(function () {
function $9a1684911372ec89$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4c70eeab04b218c5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4c70eeab04b218c5$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4c70eeab04b218c5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4c70eeab04b218c5$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $3facda9e207b3c1f$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $84de056ed7b7040b$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $3facda9e207b3c1f$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}




var $a7c5fbb10bbfe083$export$402e76927ebf6a24 = [];


var $8192207d1bf31104$export$63c81bd924f89474 = function hasActiveObservations() {
    return (0, $a7c5fbb10bbfe083$export$402e76927ebf6a24).some(function(ro) {
        return ro.activeTargets.length > 0;
    });
};



var $73c91169adb30354$export$8ca35300535e324d = function hasSkippedObservations() {
    return (0, $a7c5fbb10bbfe083$export$402e76927ebf6a24).some(function(ro) {
        return ro.skippedTargets.length > 0;
    });
};


var $104f3a2f1eff8fef$var$msg = 'ResizeObserver loop completed with undelivered notifications.';
var $104f3a2f1eff8fef$export$888cb69481582149 = function deliverResizeLoopError() {
    var event;
    if (typeof ErrorEvent === 'function') event = new ErrorEvent('error', {
        message: $104f3a2f1eff8fef$var$msg
    });
    else {
        event = document.createEvent('Event');
        event.initEvent('error', false, false);
        event.message = $104f3a2f1eff8fef$var$msg;
    }
    window.dispatchEvent(event);
};



var $53f75bbdcbc8267b$export$416d111b83cd1483;
(function(ResizeObserverBoxOptions) {
    ResizeObserverBoxOptions["BORDER_BOX"] = "border-box";
    ResizeObserverBoxOptions["CONTENT_BOX"] = "content-box";
    ResizeObserverBoxOptions["DEVICE_PIXEL_CONTENT_BOX"] = "device-pixel-content-box";
})($53f75bbdcbc8267b$export$416d111b83cd1483 || ($53f75bbdcbc8267b$export$416d111b83cd1483 = {}));


var $ffc9f4469e20cf88$export$792f3d81ea979f55 = function freeze(obj) {
    return Object.freeze(obj);
};


var $f091b62d8be5b0c3$export$c9ad8cdf6bbd331c = function() {
    function ResizeObserverSize(inlineSize, blockSize) {
        this.inlineSize = inlineSize;
        this.blockSize = blockSize;
        (0, $ffc9f4469e20cf88$export$792f3d81ea979f55)(this);
    }
    return ResizeObserverSize;
}();



var $2720057d124a8362$export$51d7a67026f4e0b7 = function() {
    function DOMRectReadOnly(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.top = this.y;
        this.left = this.x;
        this.bottom = this.top + this.height;
        this.right = this.left + this.width;
        return (0, $ffc9f4469e20cf88$export$792f3d81ea979f55)(this);
    }
    DOMRectReadOnly.prototype.toJSON = function() {
        var _a = this, x = _a.x, y = _a.y, top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left, width = _a.width, height = _a.height;
        return {
            x: x,
            y: y,
            top: top,
            right: right,
            bottom: bottom,
            left: left,
            width: width,
            height: height
        };
    };
    DOMRectReadOnly.fromRect = function(rectangle) {
        return new DOMRectReadOnly(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
    };
    return DOMRectReadOnly;
}();


var $f20f46dda2de7be9$export$165b39ed277223c2 = function isSVG(target) {
    return target instanceof SVGElement && 'getBBox' in target;
};
var $f20f46dda2de7be9$export$ee695c13482bb5dd = function isHidden(target) {
    if ($f20f46dda2de7be9$export$165b39ed277223c2(target)) {
        var _a = target.getBBox(), width = _a.width, height = _a.height;
        return !width && !height;
    }
    var _b = target, offsetWidth = _b.offsetWidth, offsetHeight = _b.offsetHeight;
    return !(offsetWidth || offsetHeight || target.getClientRects().length);
};
var $f20f46dda2de7be9$export$45a5e7f76e0caa8d = function isElement(obj) {
    var _a;
    if (obj instanceof Element) return true;
    var scope = (_a = obj === null || obj === void 0 ? void 0 : obj.ownerDocument) === null || _a === void 0 ? void 0 : _a.defaultView;
    return !!(scope && obj instanceof scope.Element);
};
var $f20f46dda2de7be9$export$a6eb60f7e7c182ba = function isReplacedElement(target) {
    switch(target.tagName){
        case 'INPUT':
            if (target.type !== 'image') break;
        case 'VIDEO':
        case 'AUDIO':
        case 'EMBED':
        case 'OBJECT':
        case 'CANVAS':
        case 'IFRAME':
        case 'IMG':
            return true;
    }
    return false;
};



var $4929fb675a7c4e35$export$90b4d2ff6acb88af = typeof window !== 'undefined' ? window : {};


var $f731325922ee7dc3$var$cache = new WeakMap();
var $f731325922ee7dc3$var$scrollRegexp = /auto|scroll/;
var $f731325922ee7dc3$var$verticalRegexp = /^tb|vertical/;
var $f731325922ee7dc3$var$IE = /msie|trident/i.test((0, $4929fb675a7c4e35$export$90b4d2ff6acb88af).navigator && (0, $4929fb675a7c4e35$export$90b4d2ff6acb88af).navigator.userAgent);
var $f731325922ee7dc3$var$parseDimension = function parseDimension(pixel) {
    return parseFloat(pixel || '0');
};
var $f731325922ee7dc3$var$size = function size(inlineSize, blockSize, switchSizes) {
    if (inlineSize === void 0) inlineSize = 0;
    if (blockSize === void 0) blockSize = 0;
    if (switchSizes === void 0) switchSizes = false;
    return new (0, $f091b62d8be5b0c3$export$c9ad8cdf6bbd331c)((switchSizes ? blockSize : inlineSize) || 0, (switchSizes ? inlineSize : blockSize) || 0);
};
var $f731325922ee7dc3$var$zeroBoxes = (0, $ffc9f4469e20cf88$export$792f3d81ea979f55)({
    devicePixelContentBoxSize: $f731325922ee7dc3$var$size(),
    borderBoxSize: $f731325922ee7dc3$var$size(),
    contentBoxSize: $f731325922ee7dc3$var$size(),
    contentRect: new (0, $2720057d124a8362$export$51d7a67026f4e0b7)(0, 0, 0, 0)
});
var $f731325922ee7dc3$export$504d039a9c501c94 = function calculateBoxSizes(target, forceRecalculation) {
    if (forceRecalculation === void 0) forceRecalculation = false;
    if ($f731325922ee7dc3$var$cache.has(target) && !forceRecalculation) return $f731325922ee7dc3$var$cache.get(target);
    if ((0, $f20f46dda2de7be9$export$ee695c13482bb5dd)(target)) {
        $f731325922ee7dc3$var$cache.set(target, $f731325922ee7dc3$var$zeroBoxes);
        return $f731325922ee7dc3$var$zeroBoxes;
    }
    var cs = getComputedStyle(target);
    var svg = (0, $f20f46dda2de7be9$export$165b39ed277223c2)(target) && target.ownerSVGElement && target.getBBox();
    var removePadding = !$f731325922ee7dc3$var$IE && cs.boxSizing === 'border-box';
    var switchSizes = $f731325922ee7dc3$var$verticalRegexp.test(cs.writingMode || '');
    var canScrollVertically = !svg && $f731325922ee7dc3$var$scrollRegexp.test(cs.overflowY || '');
    var canScrollHorizontally = !svg && $f731325922ee7dc3$var$scrollRegexp.test(cs.overflowX || '');
    var paddingTop = svg ? 0 : $f731325922ee7dc3$var$parseDimension(cs.paddingTop);
    var paddingRight = svg ? 0 : $f731325922ee7dc3$var$parseDimension(cs.paddingRight);
    var paddingBottom = svg ? 0 : $f731325922ee7dc3$var$parseDimension(cs.paddingBottom);
    var paddingLeft = svg ? 0 : $f731325922ee7dc3$var$parseDimension(cs.paddingLeft);
    var borderTop = svg ? 0 : $f731325922ee7dc3$var$parseDimension(cs.borderTopWidth);
    var borderRight = svg ? 0 : $f731325922ee7dc3$var$parseDimension(cs.borderRightWidth);
    var borderBottom = svg ? 0 : $f731325922ee7dc3$var$parseDimension(cs.borderBottomWidth);
    var borderLeft = svg ? 0 : $f731325922ee7dc3$var$parseDimension(cs.borderLeftWidth);
    var horizontalPadding = paddingLeft + paddingRight;
    var verticalPadding = paddingTop + paddingBottom;
    var horizontalBorderArea = borderLeft + borderRight;
    var verticalBorderArea = borderTop + borderBottom;
    var horizontalScrollbarThickness = !canScrollHorizontally ? 0 : target.offsetHeight - verticalBorderArea - target.clientHeight;
    var verticalScrollbarThickness = !canScrollVertically ? 0 : target.offsetWidth - horizontalBorderArea - target.clientWidth;
    var widthReduction = removePadding ? horizontalPadding + horizontalBorderArea : 0;
    var heightReduction = removePadding ? verticalPadding + verticalBorderArea : 0;
    var contentWidth = svg ? svg.width : $f731325922ee7dc3$var$parseDimension(cs.width) - widthReduction - verticalScrollbarThickness;
    var contentHeight = svg ? svg.height : $f731325922ee7dc3$var$parseDimension(cs.height) - heightReduction - horizontalScrollbarThickness;
    var borderBoxWidth = contentWidth + horizontalPadding + verticalScrollbarThickness + horizontalBorderArea;
    var borderBoxHeight = contentHeight + verticalPadding + horizontalScrollbarThickness + verticalBorderArea;
    var boxes = (0, $ffc9f4469e20cf88$export$792f3d81ea979f55)({
        devicePixelContentBoxSize: $f731325922ee7dc3$var$size(Math.round(contentWidth * devicePixelRatio), Math.round(contentHeight * devicePixelRatio), switchSizes),
        borderBoxSize: $f731325922ee7dc3$var$size(borderBoxWidth, borderBoxHeight, switchSizes),
        contentBoxSize: $f731325922ee7dc3$var$size(contentWidth, contentHeight, switchSizes),
        contentRect: new (0, $2720057d124a8362$export$51d7a67026f4e0b7)(paddingLeft, paddingTop, contentWidth, contentHeight)
    });
    $f731325922ee7dc3$var$cache.set(target, boxes);
    return boxes;
};
var $f731325922ee7dc3$export$1a78030b04106bdb = function calculateBoxSize(target, observedBox, forceRecalculation) {
    var _a = $f731325922ee7dc3$export$504d039a9c501c94(target, forceRecalculation), borderBoxSize = _a.borderBoxSize, contentBoxSize = _a.contentBoxSize, devicePixelContentBoxSize = _a.devicePixelContentBoxSize;
    switch(observedBox){
        case (0, $53f75bbdcbc8267b$export$416d111b83cd1483).DEVICE_PIXEL_CONTENT_BOX:
            return devicePixelContentBoxSize;
        case (0, $53f75bbdcbc8267b$export$416d111b83cd1483).BORDER_BOX:
            return borderBoxSize;
        default:
            return contentBoxSize;
    }
};



var $4ba50665a75d6ca7$export$226159b441fc89f8 = function() {
    function ResizeObserverEntry(target) {
        var boxes = (0, $f731325922ee7dc3$export$504d039a9c501c94)(target);
        this.target = target;
        this.contentRect = boxes.contentRect;
        this.borderBoxSize = (0, $ffc9f4469e20cf88$export$792f3d81ea979f55)([
            boxes.borderBoxSize
        ]);
        this.contentBoxSize = (0, $ffc9f4469e20cf88$export$792f3d81ea979f55)([
            boxes.contentBoxSize
        ]);
        this.devicePixelContentBoxSize = (0, $ffc9f4469e20cf88$export$792f3d81ea979f55)([
            boxes.devicePixelContentBoxSize
        ]);
    }
    return ResizeObserverEntry;
}();



var $1623126dcddd91e5$export$f8c8e3b5da1f41d2 = function calculateDepthForNode(node) {
    if ((0, $f20f46dda2de7be9$export$ee695c13482bb5dd)(node)) return Infinity;
    var depth = 0;
    var parent = node.parentNode;
    while(parent){
        depth += 1;
        parent = parent.parentNode;
    }
    return depth;
};



var $c147da3570b4c754$export$9cac928141e5443b = function broadcastActiveObservations() {
    var shallowestDepth = Infinity;
    var callbacks = [];
    (0, $a7c5fbb10bbfe083$export$402e76927ebf6a24).forEach(function processObserver(ro) {
        if (ro.activeTargets.length === 0) return;
        var entries = [];
        ro.activeTargets.forEach(function processTarget(ot) {
            var entry = new (0, $4ba50665a75d6ca7$export$226159b441fc89f8)(ot.target);
            var targetDepth = (0, $1623126dcddd91e5$export$f8c8e3b5da1f41d2)(ot.target);
            entries.push(entry);
            ot.lastReportedSize = (0, $f731325922ee7dc3$export$1a78030b04106bdb)(ot.target, ot.observedBox);
            if (targetDepth < shallowestDepth) shallowestDepth = targetDepth;
        });
        callbacks.push(function resizeObserverCallback() {
            ro.callback.call(ro.observer, entries, ro.observer);
        });
        ro.activeTargets.splice(0, ro.activeTargets.length);
    });
    for(var _i = 0, callbacks_1 = callbacks; _i < callbacks_1.length; _i++){
        var callback = callbacks_1[_i];
        callback();
    }
    return shallowestDepth;
};




var $ef83835901a8ccc3$export$9c17b8913a2a3572 = function gatherActiveObservationsAtDepth(depth) {
    (0, $a7c5fbb10bbfe083$export$402e76927ebf6a24).forEach(function processObserver(ro) {
        ro.activeTargets.splice(0, ro.activeTargets.length);
        ro.skippedTargets.splice(0, ro.skippedTargets.length);
        ro.observationTargets.forEach(function processTarget(ot) {
            if (ot.isActive()) {
                if ((0, $1623126dcddd91e5$export$f8c8e3b5da1f41d2)(ot.target) > depth) ro.activeTargets.push(ot);
                else ro.skippedTargets.push(ot);
            }
        });
    });
};


var $bacc60b8b649211b$export$e54fe5b0f43758f7 = function process() {
    var depth = 0;
    (0, $ef83835901a8ccc3$export$9c17b8913a2a3572)(depth);
    while((0, $8192207d1bf31104$export$63c81bd924f89474)()){
        depth = (0, $c147da3570b4c754$export$9cac928141e5443b)();
        (0, $ef83835901a8ccc3$export$9c17b8913a2a3572)(depth);
    }
    if ((0, $73c91169adb30354$export$8ca35300535e324d)()) (0, $104f3a2f1eff8fef$export$888cb69481582149)();
    return depth > 0;
};



var $6c8fdac4f6e28da7$var$trigger;
var $6c8fdac4f6e28da7$var$callbacks = [];
var $6c8fdac4f6e28da7$var$notify = function notify() {
    return $6c8fdac4f6e28da7$var$callbacks.splice(0).forEach(function(cb) {
        return cb();
    });
};
var $6c8fdac4f6e28da7$export$4c995d4933c4abb = function queueMicroTask(callback) {
    if (!$6c8fdac4f6e28da7$var$trigger) {
        var toggle_1 = 0;
        var el_1 = document.createTextNode('');
        var config = {
            characterData: true
        };
        new MutationObserver(function() {
            return $6c8fdac4f6e28da7$var$notify();
        }).observe(el_1, config);
        $6c8fdac4f6e28da7$var$trigger = function trigger() {
            el_1.textContent = "".concat(toggle_1 ? toggle_1-- : toggle_1++);
        };
    }
    $6c8fdac4f6e28da7$var$callbacks.push(callback);
    $6c8fdac4f6e28da7$var$trigger();
};


var $994f6ab4b3578d13$export$5755c7b572e34c6 = function queueResizeObserver(cb) {
    (0, $6c8fdac4f6e28da7$export$4c995d4933c4abb)(function ResizeObserver() {
        requestAnimationFrame(cb);
    });
};


var $981f5c978b626896$var$watching = 0;
var $981f5c978b626896$var$isWatching = function isWatching() {
    return !!$981f5c978b626896$var$watching;
};
var $981f5c978b626896$var$CATCH_PERIOD = 250;
var $981f5c978b626896$var$observerConfig = {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true
};
var $981f5c978b626896$var$events = [
    'resize',
    'load',
    'transitionend',
    'animationend',
    'animationstart',
    'animationiteration',
    'keyup',
    'keydown',
    'mouseup',
    'mousedown',
    'mouseover',
    'mouseout',
    'blur',
    'focus'
];
var $981f5c978b626896$var$time = function time(timeout) {
    if (timeout === void 0) timeout = 0;
    return Date.now() + timeout;
};
var $981f5c978b626896$var$scheduled = false;
var $981f5c978b626896$var$Scheduler = function() {
    function Scheduler() {
        var _this = this;
        this.stopped = true;
        this.listener = function() {
            return _this.schedule();
        };
    }
    Scheduler.prototype.run = function(timeout) {
        var _this = this;
        if (timeout === void 0) timeout = $981f5c978b626896$var$CATCH_PERIOD;
        if ($981f5c978b626896$var$scheduled) return;
        $981f5c978b626896$var$scheduled = true;
        var until = $981f5c978b626896$var$time(timeout);
        (0, $994f6ab4b3578d13$export$5755c7b572e34c6)(function() {
            var elementsHaveResized = false;
            try {
                elementsHaveResized = (0, $bacc60b8b649211b$export$e54fe5b0f43758f7)();
            } finally{
                $981f5c978b626896$var$scheduled = false;
                timeout = until - $981f5c978b626896$var$time();
                if (!$981f5c978b626896$var$isWatching()) return;
                if (elementsHaveResized) _this.run(1000);
                else if (timeout > 0) _this.run(timeout);
                else _this.start();
            }
        });
    };
    Scheduler.prototype.schedule = function() {
        this.stop();
        this.run();
    };
    Scheduler.prototype.observe = function() {
        var _this = this;
        var cb = function cb() {
            return _this.observer && _this.observer.observe(document.body, $981f5c978b626896$var$observerConfig);
        };
        document.body ? cb() : (0, $4929fb675a7c4e35$export$90b4d2ff6acb88af).addEventListener('DOMContentLoaded', cb);
    };
    Scheduler.prototype.start = function() {
        var _this = this;
        if (this.stopped) {
            this.stopped = false;
            this.observer = new MutationObserver(this.listener);
            this.observe();
            $981f5c978b626896$var$events.forEach(function(name) {
                return (0, $4929fb675a7c4e35$export$90b4d2ff6acb88af).addEventListener(name, _this.listener, true);
            });
        }
    };
    Scheduler.prototype.stop = function() {
        var _this = this;
        if (!this.stopped) {
            this.observer && this.observer.disconnect();
            $981f5c978b626896$var$events.forEach(function(name) {
                return (0, $4929fb675a7c4e35$export$90b4d2ff6acb88af).removeEventListener(name, _this.listener, true);
            });
            this.stopped = true;
        }
    };
    return Scheduler;
}();
var $981f5c978b626896$export$d30788f2c20241cd = new $981f5c978b626896$var$Scheduler();
var $981f5c978b626896$export$1f18a74d42722835 = function updateCount(n) {
    !$981f5c978b626896$var$watching && n > 0 && $981f5c978b626896$export$d30788f2c20241cd.start();
    $981f5c978b626896$var$watching += n;
    !$981f5c978b626896$var$watching && $981f5c978b626896$export$d30788f2c20241cd.stop();
};





var $038644a4858040f5$var$skipNotifyOnElement = function skipNotifyOnElement(target) {
    return !(0, $f20f46dda2de7be9$export$165b39ed277223c2)(target) && !(0, $f20f46dda2de7be9$export$a6eb60f7e7c182ba)(target) && getComputedStyle(target).display === 'inline';
};
var $038644a4858040f5$export$fea412043713122 = function() {
    function ResizeObservation(target, observedBox) {
        this.target = target;
        this.observedBox = observedBox || (0, $53f75bbdcbc8267b$export$416d111b83cd1483).CONTENT_BOX;
        this.lastReportedSize = {
            inlineSize: 0,
            blockSize: 0
        };
    }
    ResizeObservation.prototype.isActive = function() {
        var size = (0, $f731325922ee7dc3$export$1a78030b04106bdb)(this.target, this.observedBox, true);
        if ($038644a4858040f5$var$skipNotifyOnElement(this.target)) this.lastReportedSize = size;
        if (this.lastReportedSize.inlineSize !== size.inlineSize || this.lastReportedSize.blockSize !== size.blockSize) return true;
        return false;
    };
    return ResizeObservation;
}();


var $b752ac3512a82d0a$export$d86966e6e4bc97e1 = function() {
    function ResizeObserverDetail(resizeObserver, callback) {
        this.activeTargets = [];
        this.skippedTargets = [];
        this.observationTargets = [];
        this.observer = resizeObserver;
        this.callback = callback;
    }
    return ResizeObserverDetail;
}();



var $86e8b39e272a7812$var$observerMap = new WeakMap();
var $86e8b39e272a7812$var$getObservationIndex = function getObservationIndex(observationTargets, target) {
    for(var i = 0; i < observationTargets.length; i += 1){
        if (observationTargets[i].target === target) return i;
    }
    return -1;
};
var $86e8b39e272a7812$export$ed99c5bafbaf8300 = function() {
    function ResizeObserverController() {}
    ResizeObserverController.connect = function(resizeObserver, callback) {
        var detail = new (0, $b752ac3512a82d0a$export$d86966e6e4bc97e1)(resizeObserver, callback);
        $86e8b39e272a7812$var$observerMap.set(resizeObserver, detail);
    };
    ResizeObserverController.observe = function(resizeObserver, target, options) {
        var detail = $86e8b39e272a7812$var$observerMap.get(resizeObserver);
        var firstObservation = detail.observationTargets.length === 0;
        if ($86e8b39e272a7812$var$getObservationIndex(detail.observationTargets, target) < 0) {
            firstObservation && (0, $a7c5fbb10bbfe083$export$402e76927ebf6a24).push(detail);
            detail.observationTargets.push(new (0, $038644a4858040f5$export$fea412043713122)(target, options && options.box));
            (0, $981f5c978b626896$export$1f18a74d42722835)(1);
            (0, $981f5c978b626896$export$d30788f2c20241cd).schedule();
        }
    };
    ResizeObserverController.unobserve = function(resizeObserver, target) {
        var detail = $86e8b39e272a7812$var$observerMap.get(resizeObserver);
        var index = $86e8b39e272a7812$var$getObservationIndex(detail.observationTargets, target);
        var lastObservation = detail.observationTargets.length === 1;
        if (index >= 0) {
            lastObservation && (0, $a7c5fbb10bbfe083$export$402e76927ebf6a24).splice((0, $a7c5fbb10bbfe083$export$402e76927ebf6a24).indexOf(detail), 1);
            detail.observationTargets.splice(index, 1);
            (0, $981f5c978b626896$export$1f18a74d42722835)(-1);
        }
    };
    ResizeObserverController.disconnect = function(resizeObserver) {
        var _this = this;
        var detail = $86e8b39e272a7812$var$observerMap.get(resizeObserver);
        detail.observationTargets.slice().forEach(function(ot) {
            return _this.unobserve(resizeObserver, ot.target);
        });
        detail.activeTargets.splice(0, detail.activeTargets.length);
    };
    return ResizeObserverController;
}();



var $84826c5bdf349b6b$export$9caf76241ca21a11 = function() {
    function ResizeObserver(callback) {
        if (arguments.length === 0) throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
        if (typeof callback !== 'function') throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
        (0, $86e8b39e272a7812$export$ed99c5bafbaf8300).connect(this, callback);
    }
    ResizeObserver.prototype.observe = function(target, options) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, $f20f46dda2de7be9$export$45a5e7f76e0caa8d)(target)) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, $86e8b39e272a7812$export$ed99c5bafbaf8300).observe(this, target, options);
    };
    ResizeObserver.prototype.unobserve = function(target) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, $f20f46dda2de7be9$export$45a5e7f76e0caa8d)(target)) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, $86e8b39e272a7812$export$ed99c5bafbaf8300).unobserve(this, target);
    };
    ResizeObserver.prototype.disconnect = function() {
        (0, $86e8b39e272a7812$export$ed99c5bafbaf8300).disconnect(this);
    };
    ResizeObserver.toString = function() {
        return 'function ResizeObserver () { [polyfill code] }';
    };
    return ResizeObserver;
}();






function $5941428b630ec017$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $5941428b630ec017$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $5941428b630ec017$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $5941428b630ec017$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ function $86d22bcb52172ef7$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}


var $353b713f9392bb93$var$extendStatics = function extendStatics1(d, b) {
    $353b713f9392bb93$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $353b713f9392bb93$var$extendStatics(d, b);
};
function $353b713f9392bb93$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $353b713f9392bb93$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $353b713f9392bb93$export$18ce0697a983be9b = function __assign1() {
    $353b713f9392bb93$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $353b713f9392bb93$export$18ce0697a983be9b.apply(this, arguments);
};
function $353b713f9392bb93$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $353b713f9392bb93$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $86d22bcb52172ef7$export$71511d61b312f219)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $353b713f9392bb93$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $353b713f9392bb93$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $86d22bcb52172ef7$export$71511d61b312f219)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $353b713f9392bb93$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $353b713f9392bb93$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $86d22bcb52172ef7$export$71511d61b312f219)(x)) === "symbol" ? x : "".concat(x);
}
function $353b713f9392bb93$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $86d22bcb52172ef7$export$71511d61b312f219)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $353b713f9392bb93$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $86d22bcb52172ef7$export$71511d61b312f219)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $353b713f9392bb93$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $353b713f9392bb93$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $353b713f9392bb93$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $353b713f9392bb93$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $353b713f9392bb93$export$45d3717a4c69092e(o, m, p);
}
function $353b713f9392bb93$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $353b713f9392bb93$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $353b713f9392bb93$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($353b713f9392bb93$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $353b713f9392bb93$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $353b713f9392bb93$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $353b713f9392bb93$export$10c90e4f7922046c(v) {
    return this instanceof $353b713f9392bb93$export$10c90e4f7922046c ? (this.v = v, this) : new $353b713f9392bb93$export$10c90e4f7922046c(v);
}
function $353b713f9392bb93$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $353b713f9392bb93$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $353b713f9392bb93$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $353b713f9392bb93$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $353b713f9392bb93$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $353b713f9392bb93$export$19a8beecd37a4c45 === "function" ? $353b713f9392bb93$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $353b713f9392bb93$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $353b713f9392bb93$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $353b713f9392bb93$var$ownKeys = function ownKeys1(o) {
    $353b713f9392bb93$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $353b713f9392bb93$var$ownKeys(o);
};
function $353b713f9392bb93$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $353b713f9392bb93$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $353b713f9392bb93$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $353b713f9392bb93$var$__setModuleDefault(result, mod);
    return result;
}
function $353b713f9392bb93$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $353b713f9392bb93$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $353b713f9392bb93$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $353b713f9392bb93$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $86d22bcb52172ef7$export$71511d61b312f219)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $353b713f9392bb93$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $86d22bcb52172ef7$export$71511d61b312f219)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $353b713f9392bb93$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $353b713f9392bb93$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $353b713f9392bb93$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $353b713f9392bb93$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $353b713f9392bb93$export$2e2bcd8739ae039 = {
    __extends: $353b713f9392bb93$export$a8ba968b8961cb8a,
    __assign: $353b713f9392bb93$export$18ce0697a983be9b,
    __rest: $353b713f9392bb93$export$3c9a16f847548506,
    __decorate: $353b713f9392bb93$export$29e00dfd3077644b,
    __param: $353b713f9392bb93$export$d5ad3fd78186038f,
    __esDecorate: $353b713f9392bb93$export$3a84e1ae4e97e9b0,
    __runInitializers: $353b713f9392bb93$export$d831c04e792af3d,
    __propKey: $353b713f9392bb93$export$6a2a36740a146cb8,
    __setFunctionName: $353b713f9392bb93$export$d1a06452d3489bc7,
    __metadata: $353b713f9392bb93$export$f1db080c865becb9,
    __awaiter: $353b713f9392bb93$export$1050f835b63b671e,
    __generator: $353b713f9392bb93$export$67ebef60e6f28a6,
    __createBinding: $353b713f9392bb93$export$45d3717a4c69092e,
    __exportStar: $353b713f9392bb93$export$f33643c0debef087,
    __values: $353b713f9392bb93$export$19a8beecd37a4c45,
    __read: $353b713f9392bb93$export$8d051b38c9118094,
    __spread: $353b713f9392bb93$export$afc72e2116322959,
    __spreadArrays: $353b713f9392bb93$export$6388937ca91ccae8,
    __spreadArray: $353b713f9392bb93$export$1216008129fb82ed,
    __await: $353b713f9392bb93$export$10c90e4f7922046c,
    __asyncGenerator: $353b713f9392bb93$export$e427f37a30a4de9b,
    __asyncDelegator: $353b713f9392bb93$export$bbd80228419bb833,
    __asyncValues: $353b713f9392bb93$export$e3b29a3d6162315f,
    __makeTemplateObject: $353b713f9392bb93$export$4fb47efe1390b86f,
    __importStar: $353b713f9392bb93$export$c21735bcef00d192,
    __importDefault: $353b713f9392bb93$export$da59b14a69baef04,
    __classPrivateFieldGet: $353b713f9392bb93$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $353b713f9392bb93$export$d40a35129aaff81f,
    __classPrivateFieldIn: $353b713f9392bb93$export$81fdc39f203e4e04,
    __addDisposableResource: $353b713f9392bb93$export$88ac25d8e944e405,
    __disposeResources: $353b713f9392bb93$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $353b713f9392bb93$export$889dfb5d17574b0b
};


/**
 * Clamp value
 * @param {number} value - value to clamp
 * @param {number} min - minimum value
 * @param {number} max - maximum value
 * @returns {number} clamped value
 */ function $4aa967d09edd827c$export$7d15b64cf5a3a4c4(value, min, max) {
    return Math.min(Math.max(value, min), max);
}
/**
 * Linear interpolation between to values
 * @param {number} value1 - range start
 * @param {number} value2 - range end
 * @param {number} lerp factor - amount 0...1
 * @returns {number} Interpolated value
 */ function $4aa967d09edd827c$export$3a89f8d6f6bf6c9f(value1, value2, factor) {
    factor = $4aa967d09edd827c$export$7d15b64cf5a3a4c4(factor, 0, 1);
    return factor === 0 ? value1 : factor === 1 ? value2 : value1 + (value2 - value1) * factor;
}
/**
 * Map value from one range to another
 * @param {number} value - value to map
 * @param {number[]} input - array of min and max value to map from
 * @param {number} input[0] - minimum value of input range
 * @param {number} input[1] - maximum value of input range
 * @param {number[]} output - array of min and max value to map to
 * @param {number} output[0] - minimum value of output range
 * @param {number} output[1] - maximum value of output range
 * @returns {number} Mapped value
 */ function $4aa967d09edd827c$export$871de8747c9eaa88() {
    var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, input = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [
        0,
        0
    ], output = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [
        0,
        0
    ];
    return (value - input[0]) * (output[1] - output[0]) / (input[1] - input[0]) + output[0];
}
/**
 * Wrap number, also works when n < 0
 *
 * @param {number} n
 * @param {number} m
 * @returns {number} wrapped number
 */ function $4aa967d09edd827c$export$4997ffc0176396a6(n, m) {
    return (n % m + m) % m;
}
/**
 * Easing functions
 *
 * Replace with d3-ease
 */ var $4aa967d09edd827c$export$24c5ac7c37452e7d = {
    linear: function(t) {
        return t;
    },
    easeInSine: function(t) {
        return 1 - Math.cos(t * Math.PI / 2);
    },
    easeOutSine: function(t) {
        return Math.sin(t * Math.PI / 2);
    },
    easeInOutSine: function(t) {
        return -(Math.cos(Math.PI * t) - 1) / 2;
    },
    easeInQuad: function(t) {
        return t * t;
    },
    easeOutQuad: function(t) {
        return t * (2 - t);
    },
    easeInOutQuad: function(t) {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    },
    easeInCubic: function(t) {
        return t * t * t;
    },
    easeOutCubic: function(t) {
        return --t * t * t + 1;
    },
    easeInOutCubic: function(t) {
        return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    },
    easeInQuart: function(t) {
        return t * t * t * t;
    },
    easeOutQuart: function(t) {
        return 1 - --t * t * t * t;
    },
    easeInOutQuart: function(t) {
        return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
    },
    easeInQuint: function(t) {
        return t * t * t * t * t;
    },
    easeOutQuint: function(t) {
        return 1 + --t * t * t * t * t;
    },
    easeInOutQuint: function(t) {
        return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
    }
};


/**
 * Get DOM node from template string
 * @param {string} string - string containing HTML
 * @returns {Node} DOM node
 */ function $9092f69cc070f61f$export$b8ebfb1f57bebf50(string) {
    var element = document.createElement("div");
    element.innerHTML = string.trim();
    return element.firstChild;
}
function $9092f69cc070f61f$export$472761e5909fca2d(element) {
    if (!element) return;
    element.offsetHeight;
}


var $1192dba981fab481$export$68d2d147c928d1dd = function() {
    return new Promise(requestAnimationFrame);
};
var $1192dba981fab481$export$1391212d75b2ee65 = function(duration) {
    return new Promise(function(resolve) {
        setTimeout(function() {
            resolve();
        }, duration);
    });
};


function $0129f79d4dbd5bf5$export$6a506b36fdea397d(string, totalChars) {
    var prepend = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "...";
    return string.length <= totalChars ? string : "".concat(string.slice(0, totalChars)).concat(prepend);
}


/**
 * Remove trailing slash from string
 * @param {string} string
 * @returns {string} string
 */ function $ee37a417455d2878$export$f13b93a29d1e39d0(string) {
    return string.replace(/\/$/, "");
}
/**
 * add trailing slash from string
 * @param {string} string
 * @returns {string} string
 */ function $ee37a417455d2878$export$937e84b90bad3e1d(string) {
    return $ee37a417455d2878$export$f13b93a29d1e39d0(string) + "/";
}
/**
 * Remove leading slash from string
 * @param {string} string
 * @returns {string} string
 */ function $ee37a417455d2878$export$86e592f5d1dc02b9(string) {
    return string.replace(/^\//, "");
}
/**
 * Add leading slash from string
 * @param {string} string
 * @returns {string} string
 */ function $ee37a417455d2878$export$fd88becfb1f64d6d(string) {
    return "/" + $ee37a417455d2878$export$86e592f5d1dc02b9(string);
}


/**
 * Tween
 *
 * ## Usage:
 *
 * const animation = new Tween({
 *   duration: 2000,
 *   onUpdate: (value, delta, progress ) => {
 *     console.log( `current value: ${value}`, `animation progress: ${}` );
 *   }
 * });
 *
 * animation.start( 0, 100 );
 */ 

var $60f171e2dbcdea5b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function Tween(options) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Tween);
        this.defaults = {
            duration: 1000,
            easing: function(t) {
                return t;
            },
            onUpdate: function() {},
            onCompleted: function() {}
        };
        this.options = Object.assign({}, this.defaults, options);
        this.isRunning = false;
        this.value = null;
        this.startValue = null;
        this.previousValue = null;
        this.targetValue = null;
        this.startTime = null;
        this.progress = 0;
        this.delta = 0;
        this.frame = null;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Tween, [
        {
            /**
   * Start animation
   * @param {number} startValue - start value
   * @param {number} targetValue - target value
   */ key: "start",
            value: function start(startValue, targetValue) {
                var _this = this;
                this.value = startValue;
                this.startValue = startValue;
                this.previousValue = startValue;
                this.targetValue = targetValue;
                this.delta = 0;
                this.progress = 0;
                this.isRunning = true;
                this.frame = requestAnimationFrame(function(time) {
                    _this.startTime = time;
                    _this.onFrame(time);
                });
            }
        },
        {
            /**
   * Stop the animation
   * @param {boolean} finish - Whether the value should be set to the target value
   */ key: "stop",
            value: function stop() {
                var finish = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                this.isRunning = false;
                cancelAnimationFrame(this.frame);
                if (finish) {
                    this.value = this.targetValue;
                    this.options.onUpdate(this.value);
                }
                this.options.onCompleted(this.value);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.stop();
            }
        },
        {
            /**
   * Frame loop while the animation is running
   * @param {number} time - Current time useually passed from requestAnimationFrame
   */ key: "onFrame",
            value: function onFrame() {
                var _this = this;
                var time = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                if (!this.isRunning) return;
                var progress = this.options.easing((time - this.startTime) / this.options.duration);
                this.previousValue = this.value;
                this.value = this.startValue + (this.targetValue - this.startValue) * progress;
                this.delta = this.value - this.previousValue;
                this.options.onUpdate(this.value, this.delta, this.progress);
                if (time - this.startTime >= this.options.duration || Math.abs(this.value - this.targetValue) <= 0) {
                    this.stop();
                    return;
                }
                cancelAnimationFrame(this.frame);
                this.frame = requestAnimationFrame(function(time) {
                    _this.onFrame(time);
                });
            }
        },
        {
            /**
   * Return if the the animation is running
   * @returns {boolean} animation is running
   */ key: "getIsRunning",
            value: function getIsRunning() {
                return this.isRunning;
            }
        },
        {
            /**
   * Return current value
   * @returns {number} current value
   */ key: "getValue",
            value: function getValue() {
                return this.value;
            }
        },
        {
            /**
   * Return current progess
   * @returns {number} current progess
   */ key: "getProgress",
            value: function getProgress() {
                return this.progress;
            }
        },
        {
            /**
   * Return current delta
   * @returns {number} current delta
   */ key: "getDelta",
            value: function getDelta() {
                return this.delta;
            }
        }
    ]);
    return Tween;
}();





var $eb3c3ad0b6bb1f42$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function Inertia() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Inertia);
        this.defaults = {
            lerpFactor: 0.035,
            precision: 0.1
        };
        this.options = Object.assign({}, this.defaults, options);
        this.isActive = false;
        this.value = null;
        this.frame = null;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Inertia, [
        {
            /**
   * Activate the instance
   */ key: "activate",
            value: function activate() {
                var _this = this;
                if (Math.abs(this.value) < this.options.precision) return;
                this.isActive = true;
                cancelAnimationFrame(this.frame);
                this.frame = requestAnimationFrame(function() {
                    _this.onFrame();
                });
            }
        },
        {
            /**
   * Deactivate the instance
   */ key: "deactivate",
            value: function deactivate() {
                this.isActive = false;
                this.value = 0;
                cancelAnimationFrame(this.frame);
            }
        },
        {
            /**
   * Set the value
   * @param {number} value - target value
   */ key: "setValue",
            value: function setValue(value) {
                this.value = value;
            }
        },
        {
            /**
   * Destroy the instance
   */ key: "destroy",
            value: function destroy() {
                this.deactivate();
            }
        },
        {
            /**
   * Frame loop while the instance is active
   */ key: "onFrame",
            value: function onFrame() {
                var _this = this;
                if (!this.isActive) return;
                this.value = (0, $4aa967d09edd827c$export$3a89f8d6f6bf6c9f)(this.value, 0, this.options.lerpFactor);
                if (Math.abs(this.value) < this.options.precision) this.deactivate();
                cancelAnimationFrame(this.frame);
                this.frame = requestAnimationFrame(function() {
                    _this.onFrame();
                });
            }
        },
        {
            /**
   * Return whether the instance is active
   * @returns {boolean} whether the instance is active
   */ key: "getIsActive",
            value: function getIsActive() {
                return this.isActive;
            }
        },
        {
            /**
   * Get current value
   * @returns {number} current value
   */ key: "getValue",
            value: function getValue() {
                return this.value;
            }
        }
    ]);
    return Inertia;
}();


/**
 * Unified animation loop
 *
 * In some circumstances performance of multiple independent requestAnimationFrame loops
 * is worse than batching all tasks in one loop
 *
 * How to use:
 *
 * // ----------------------
 * // Init globally
 * // ----------------------
 * const loop = AnimationLoop({
 *   debug: false, // log loop infos to console
 *   start: true // automatically start on first subscription
 * });
 *
 * // loop.start();
 * // loop.stop();
 * // loop.destroy();
 *
 *
 * // ----------------------
 * // in your components:
 * // ----------------------
 *
 * function onFrame() {
 *   // your animation...
 * }
 *
 * loop.subscribe(onFrame);
 * loop.unsubscribe(onFrame);
 *
 */ 



var $a3e4e7b13921a7b1$export$e35117588a48af9 = /*#__PURE__*/ function() {
    "use strict";
    function AnimationLoop() {
        var _this = this;
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, AnimationLoop);
        console.log("new AnimationLoop()");
        this.defaults = {
            debug: false,
            start: true
        };
        this.options = (0, $84de056ed7b7040b$export$71511d61b312f219)({}, this.defaults, options);
        this.callbacks = [];
        this.frame = null;
        this.frameTime = undefined;
        this.isRunning = false;
        if (this.options.debug) this.debugTimer = setInterval(function() {
            console.log("[AnimationLoop]", "".concat(_this.callbacks.length, " subscriptions."), "loop is ".concat(_this.isRunning ? "" : "NOT ", "running."));
        }, 2000);
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(AnimationLoop, [
        {
            /**
   * Subscribe to the loop
   * @param {function} callback - function to call on every frame
   */ key: "subscribe",
            value: function subscribe(callback) {
                if (!callback || typeof callback !== "function") return;
                this.callbacks.push(callback);
                if (this.options.start && this.callbacks.length === 1 && !this.isRunning) this.start();
            }
        },
        {
            /**
   * Unsubscribe from the loop
   * @param {function} callback - function to not call on every frame anymore
   */ key: "unsubscribe",
            value: function unsubscribe(callback) {
                if (!callback || typeof callback !== "function") return;
                this.callbacks = this.callbacks.filter(function(c) {
                    return c !== callback;
                });
                if (this.options.start && !this.callbacks.length) this.stop();
            }
        },
        {
            /**
   * Start the loop
   */ key: "start",
            value: function start() {
                var _this = this;
                this.isRunning = true;
                cancelAnimationFrame(this.frame);
                this.frame = requestAnimationFrame(function(t) {
                    _this.onFrame(t);
                });
            }
        },
        {
            /**
   * Stop the loop
   */ key: "stop",
            value: function stop() {
                this.isRunning = false;
                cancelAnimationFrame(this.frame);
            }
        },
        {
            /**
   * Destroy the instance
   */ key: "destroy",
            value: function destroy() {
                this.stop();
                this.callbacks = [];
                clearTimeout(this.debugTimer);
            }
        },
        {
            /**
   * Function called on every frame
   *
   * @param {number} time - Current time useually passed from requestAnimationFrame
   */ key: "onFrame",
            value: function onFrame(time) {
                var _this = this;
                if (!this.isRunning) return;
                var delta = this.frameTime ? time - this.frameTime : 0;
                if (this.callbacks && (0, $86d22bcb52172ef7$export$71511d61b312f219)(this.callbacks) === "object") this.callbacks.forEach(function(c) {
                    return c(time, delta);
                });
                this.frameTime = time;
                cancelAnimationFrame(this.frame);
                this.frame = requestAnimationFrame(function(t) {
                    _this.onFrame(t);
                });
            }
        }
    ]);
    return AnimationLoop;
}();





/**
 * Damper
 */ var $8b8f5f3839ae383e$export$9f18885e3ffbeeac = /*#__PURE__*/ function() {
    "use strict";
    function Damper() {
        var initialValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Damper);
        this.defaults = {
            smoothTime: 1,
            maxSpeed: Infinity,
            easing: function(t) {
                return 1 / (1 + t + 0.48 * t * t + 0.235 * t * t * t);
            },
            precision: 0.001
        };
        this.options = Object.assign({}, this.defaults, options);
        this.value = initialValue;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Damper, [
        {
            /**
   * Update the value
   *
   * @param {number} targetValue - target value
   * @param {number} deltaTime - time since last update
   * @returns {number} current value
   */ key: "update",
            value: function update(targetValue, deltaTime) {
                if (Math.abs(this.value - targetValue) <= this.options.precision) {
                    this.value = targetValue;
                    return this.value;
                }
                var originalTargetValue = targetValue;
                var omega = 2 / this.options.smoothTime;
                var t = this.options.easing(omega * deltaTime);
                var maxChange = this.options.maxSpeed * this.options.smoothTime;
                var change = (0, $4aa967d09edd827c$export$7d15b64cf5a3a4c4)(this.value - targetValue, -maxChange, maxChange);
                var temp = (this.options.velocity + omega * change) * deltaTime;
                this.options.velocity = (this.options.velocity - omega * temp) * t;
                var newValue = this.value - change + (change + temp) * t;
                if (originalTargetValue - this.value > 0.0 === newValue > originalTargetValue) {
                    newValue = originalTargetValue;
                    this.options.velocity = (newValue - originalTargetValue) / deltaTime;
                }
                this.value = newValue;
                return this.value;
            }
        },
        {
            /**
   * Get the current value
   * @returns {number} current value
   */ key: "get",
            value: function get() {
                return this.value;
            }
        }
    ]);
    return Damper;
}();


/**
 * Timer
 */ 

var $65831a4ecaf67031$export$c57e9b2d8b9e4de = /*#__PURE__*/ function() {
    "use strict";
    function Timer() {
        var delay = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, interval = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100, iterations = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 10, callback = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : function() {}, callbackStart = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : function() {}, callbackFinish = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : function() {}, start = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : true, immediate = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : true;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Timer);
        this.settings = {
            delay: delay,
            interval: interval,
            iterations: iterations,
            start: start,
            immediate: immediate
        };
        this.currentIteration = 0;
        this.callback = callback;
        this.callbackStart = callbackStart;
        this.callbackFinish = callbackFinish;
        this.timer = {
            delay: null,
            interval: null
        };
        this.is = {
            running: false
        };
        if (this.settings.start) this.start();
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Timer, [
        {
            /**
   * Start timer
   */ key: "start",
            value: function start() {
                var _this = this;
                if (this.is.running) this.stop();
                this.is.running = true;
                this.timer.delay = setTimeout(function() {
                    _this.callbackStart();
                    _this.currentIteration = 0;
                    if (_this.settings.immediate) {
                        _this.callback(_this.currentIteration);
                        _this.currentIteration++;
                    }
                    _this.timer.interval = setInterval(function() {
                        _this.callback(_this.currentIteration);
                        _this.currentIteration++;
                        if (_this.currentIteration >= _this.settings.iterations) _this.stop();
                    }, _this.settings.interval);
                }, this.settings.delay);
            }
        },
        {
            /**
   * Stop timer
   */ key: "stop",
            value: function stop() {
                clearInterval(this.timer.interval);
                clearTimeout(this.timer.delay);
                this.is.running = false;
                this.callbackFinish();
            }
        },
        {
            /**
   * Destroy timer instance
   */ key: "destroy",
            value: function destroy() {
                this.stop();
            }
        }
    ]);
    return Timer;
}();




/**
 * @license
 * Copyright 2010-2025 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ 
function $c142f060853b922a$export$71511d61b312f219(o) {
    $c142f060853b922a$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c142f060853b922a$export$71511d61b312f219(o);
}


function $6a1081910c20de42$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($6a1081910c20de42$export$71511d61b312f219 = function() {
        return !!result;
    })();
}


function $87670a7ac3119be9$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}



function $1d00ab1b7cc910f0$export$71511d61b312f219(self, call) {
    if (call && ((0, $86d22bcb52172ef7$export$71511d61b312f219)(call) === "object" || typeof call === "function")) return call;
    return (0, $87670a7ac3119be9$export$71511d61b312f219)(self);
}


function $c2e4ebfd0f0e7a33$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $c142f060853b922a$export$71511d61b312f219)(derived);
    return (0, $1d00ab1b7cc910f0$export$71511d61b312f219)(_this, (0, $6a1081910c20de42$export$71511d61b312f219)() ? Reflect.construct(derived, args || [], (0, $c142f060853b922a$export$71511d61b312f219)(_this).constructor) : derived.apply(_this, args));
}






function $ddf040dc80d2a03c$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $c142f060853b922a$export$71511d61b312f219)(object);
        if (object === null) break;
    }
    return object;
}


function $d78318602248389b$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $d78318602248389b$export$71511d61b312f219 = Reflect.get;
    else $d78318602248389b$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $ddf040dc80d2a03c$export$71511d61b312f219)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $d78318602248389b$export$71511d61b312f219(target, property, receiver || target);
}



function $d8e4bd9cca4def2c$export$71511d61b312f219(o, p) {
    $d8e4bd9cca4def2c$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d8e4bd9cca4def2c$export$71511d61b312f219(o, p);
}


function $bd4a3c8f482b35a0$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $d8e4bd9cca4def2c$export$71511d61b312f219)(subClass, superClass);
}



function $0baa13f7165429e0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0baa13f7165429e0$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $0baa13f7165429e0$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}


function $9ff2de0d601a7206$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $c2d866abaf6b8a52$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $98d5eefc758b26ba$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $5c72cc2eb11e0f7a$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $722151e624e13a7e$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $5c72cc2eb11e0f7a$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $5c72cc2eb11e0f7a$export$71511d61b312f219)(o, minLen);
}


function $cccf0333cb9f9910$export$71511d61b312f219(arr, i) {
    return (0, $9ff2de0d601a7206$export$71511d61b312f219)(arr) || (0, $c2d866abaf6b8a52$export$71511d61b312f219)(arr, i) || (0, $722151e624e13a7e$export$71511d61b312f219)(arr, i) || (0, $98d5eefc758b26ba$export$71511d61b312f219)();
}



function $fc7a4208a7fc2f3d$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $5c72cc2eb11e0f7a$export$71511d61b312f219)(arr);
}


function $70340e69db985d6c$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $61f9249555b159bc$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $4fcd3d80e9e33ca7$export$71511d61b312f219(arr) {
    return (0, $fc7a4208a7fc2f3d$export$71511d61b312f219)(arr) || (0, $70340e69db985d6c$export$71511d61b312f219)(arr) || (0, $722151e624e13a7e$export$71511d61b312f219)(arr) || (0, $61f9249555b159bc$export$71511d61b312f219)();
}




function $21dc3cc07aba2591$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $6a1081910c20de42$export$71511d61b312f219)()) $21dc3cc07aba2591$export$71511d61b312f219 = Reflect.construct;
    else $21dc3cc07aba2591$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $d8e4bd9cca4def2c$export$71511d61b312f219)(instance, Class.prototype);
        return instance;
    };
    return $21dc3cc07aba2591$export$71511d61b312f219.apply(null, arguments);
}



function $e4fddf15a9b25502$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}



function $60c1ca164192b5e0$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $60c1ca164192b5e0$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $e4fddf15a9b25502$export$71511d61b312f219)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $21dc3cc07aba2591$export$71511d61b312f219)(Class, arguments, (0, $c142f060853b922a$export$71511d61b312f219)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $d8e4bd9cca4def2c$export$71511d61b312f219)(Wrapper, Class);
    };
    return $60c1ca164192b5e0$export$71511d61b312f219(Class);
}



var $1a55656020b89c3a$export$3545e07a80636437 = '173';
var $1a55656020b89c3a$export$7177b3e430c2d7ca = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2
};
var $1a55656020b89c3a$export$d46bd3ead7cc759b = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
};
var $1a55656020b89c3a$export$3237e1f2c1ea1f44 = 0;
var $1a55656020b89c3a$export$b9a7b4fc5cb15f9b = 1;
var $1a55656020b89c3a$export$b8058bcc7037d3f3 = 2;
var $1a55656020b89c3a$export$f24be24dcddeac0d = 3;
var $1a55656020b89c3a$export$346307dbae2b7447 = 0;
var $1a55656020b89c3a$export$5813f879eee7cd88 = 1;
var $1a55656020b89c3a$export$a47c4b43a1be34f0 = 2;
var $1a55656020b89c3a$export$896ae1ade6c829c4 = 3;
var $1a55656020b89c3a$export$2ede184fc2998901 = 0;
var $1a55656020b89c3a$export$d9f0486e75b5ace = 1;
var $1a55656020b89c3a$export$3b296b6f144d5b03 = 2;
var $1a55656020b89c3a$export$63b8d6b580fc65ba = 0;
var $1a55656020b89c3a$export$5b29a26d96ee6af0 = 1;
var $1a55656020b89c3a$export$777d8f9551c2216b = 2;
var $1a55656020b89c3a$export$cdfa06f868e2e467 = 3;
var $1a55656020b89c3a$export$4138e1c684b46a20 = 4;
var $1a55656020b89c3a$export$eda4864c68df1fa2 = 5;
var $1a55656020b89c3a$export$20183a0484ce21a0 = 100;
var $1a55656020b89c3a$export$73e0df5177988548 = 101;
var $1a55656020b89c3a$export$28e582859cbec660 = 102;
var $1a55656020b89c3a$export$c8c1508da8d0600c = 103;
var $1a55656020b89c3a$export$99948c02fb51055f = 104;
var $1a55656020b89c3a$export$2110f05edf778d3d = 200;
var $1a55656020b89c3a$export$8805bad65e24940e = 201;
var $1a55656020b89c3a$export$7fbe15b28d28cf52 = 202;
var $1a55656020b89c3a$export$947829af9f2c17f6 = 203;
var $1a55656020b89c3a$export$d5773124e86cf28c = 204;
var $1a55656020b89c3a$export$11d468cc7f19e971 = 205;
var $1a55656020b89c3a$export$a78aed1ca2a87192 = 206;
var $1a55656020b89c3a$export$5d0fe17fd8773bac = 207;
var $1a55656020b89c3a$export$ef5f2dd8ffac5574 = 208;
var $1a55656020b89c3a$export$56b85b2686ab16 = 209;
var $1a55656020b89c3a$export$c05e2a1fc8609506 = 210;
var $1a55656020b89c3a$export$7dd8f434fd59075 = 211;
var $1a55656020b89c3a$export$99c8d898a9afbcee = 212;
var $1a55656020b89c3a$export$310cd2be38d13b56 = 213;
var $1a55656020b89c3a$export$db77b8fbcf45dbf4 = 214;
var $1a55656020b89c3a$export$69025ce147cee220 = 0;
var $1a55656020b89c3a$export$7182eb52ea3b3f04 = 1;
var $1a55656020b89c3a$export$eedccec66ab7ebe = 2;
var $1a55656020b89c3a$export$296f78a0b892f81a = 3;
var $1a55656020b89c3a$export$a60d398fc7b7590e = 4;
var $1a55656020b89c3a$export$7d7234c1240a1fc4 = 5;
var $1a55656020b89c3a$export$c5e2c52991f30937 = 6;
var $1a55656020b89c3a$export$2f843afa843d8916 = 7;
var $1a55656020b89c3a$export$e50ac29801f1774d = 0;
var $1a55656020b89c3a$export$9f9d94f963c85479 = 1;
var $1a55656020b89c3a$export$e641dc52bc3494aa = 2;
var $1a55656020b89c3a$export$9fcb6b4294603b2 = 0;
var $1a55656020b89c3a$export$98f52c2a46c598ca = 1;
var $1a55656020b89c3a$export$74b25e54b3bcd548 = 2;
var $1a55656020b89c3a$export$932b3dd283d4a366 = 3;
var $1a55656020b89c3a$export$a0d98fe6d7e4af64 = 4;
var $1a55656020b89c3a$export$2c7b09c1e9abfb5e = 5;
var $1a55656020b89c3a$export$212d53a513a325b2 = 6;
var $1a55656020b89c3a$export$f2863e1668a8e317 = 7;
var $1a55656020b89c3a$export$2595a3798997538 = 'attached';
var $1a55656020b89c3a$export$d7e7dc2e114517a0 = 'detached';
var $1a55656020b89c3a$export$1beec6768cbb3d2d = 300;
var $1a55656020b89c3a$export$8759762a6477f2c4 = 301;
var $1a55656020b89c3a$export$dc59f8aed047f61d = 302;
var $1a55656020b89c3a$export$d64030b316d3b087 = 303;
var $1a55656020b89c3a$export$ee99d97d46898098 = 304;
var $1a55656020b89c3a$export$dbf3e70ff37af79 = 306;
var $1a55656020b89c3a$export$533346c8e8dac0f5 = 1000;
var $1a55656020b89c3a$export$9d9334239a5a5e06 = 1001;
var $1a55656020b89c3a$export$c7e7c00b14f51a4f = 1002;
var $1a55656020b89c3a$export$727aa5ec3fe39bf0 = 1003;
var $1a55656020b89c3a$export$d129e38cf6feaa8c = 1004;
var $1a55656020b89c3a$export$14a4936464a36496 = 1004;
var $1a55656020b89c3a$export$d2327c1afe5bfdf2 = 1005;
var $1a55656020b89c3a$export$cbc5b7f5647595d8 = 1005;
var $1a55656020b89c3a$export$8a72f490b25c56c8 = 1006;
var $1a55656020b89c3a$export$19a719f377145a13 = 1007;
var $1a55656020b89c3a$export$dbe96bee3fe9dbf0 = 1007;
var $1a55656020b89c3a$export$5d8599b6a933fb1b = 1008;
var $1a55656020b89c3a$export$90d80f1e3506775f = 1008;
var $1a55656020b89c3a$export$2e8ce08d3f6f5e10 = 1009;
var $1a55656020b89c3a$export$545fce0311a9796a = 1010;
var $1a55656020b89c3a$export$88572337f312435f = 1011;
var $1a55656020b89c3a$export$c63dc51868b06a9d = 1012;
var $1a55656020b89c3a$export$5c612977753abe2 = 1013;
var $1a55656020b89c3a$export$c3c7fc4518ebba96 = 1014;
var $1a55656020b89c3a$export$f6d331659b644596 = 1015;
var $1a55656020b89c3a$export$2697304443f382bc = 1016;
var $1a55656020b89c3a$export$b3969b01faf587f2 = 1017;
var $1a55656020b89c3a$export$18886f8ae33e90de = 1018;
var $1a55656020b89c3a$export$6c8ea339bfab1301 = 1020;
var $1a55656020b89c3a$export$5a4c329b7e2092d3 = 35902;
var $1a55656020b89c3a$export$988473390501ed4b = 1021;
var $1a55656020b89c3a$export$7c67423a5ee6f5eb = 1022;
var $1a55656020b89c3a$export$3f8bb04b555a363c = 1023;
var $1a55656020b89c3a$export$cc09ccbf6d1ed449 = 1024;
var $1a55656020b89c3a$export$9053a81c4a69c289 = 1025;
var $1a55656020b89c3a$export$c1b6b5136be58045 = 1026;
var $1a55656020b89c3a$export$1e113ac2d0905829 = 1027;
var $1a55656020b89c3a$export$4e041a7967d15c4b = 1028;
var $1a55656020b89c3a$export$aa92e870a709d190 = 1029;
var $1a55656020b89c3a$export$6cdf0b461c7ce8a0 = 1030;
var $1a55656020b89c3a$export$1ba1c45f9f77d4d7 = 1031;
var $1a55656020b89c3a$export$d1fd40c11bfa798e = 1032;
var $1a55656020b89c3a$export$c200e7d26f592f21 = 1033;
var $1a55656020b89c3a$export$21d1799c6d552fc0 = 33776;
var $1a55656020b89c3a$export$afa304c3e981b668 = 33777;
var $1a55656020b89c3a$export$d2a1a68024a3e56c = 33778;
var $1a55656020b89c3a$export$9a79c424327dacf9 = 33779;
var $1a55656020b89c3a$export$19ada9bbb1af3573 = 35840;
var $1a55656020b89c3a$export$d0f0355bb3d948e4 = 35841;
var $1a55656020b89c3a$export$b82296714358084c = 35842;
var $1a55656020b89c3a$export$b71692456c47b6c3 = 35843;
var $1a55656020b89c3a$export$6ab91af2d757aee7 = 36196;
var $1a55656020b89c3a$export$7800993ef8106a6a = 37492;
var $1a55656020b89c3a$export$23ed8300a860e7d8 = 37496;
var $1a55656020b89c3a$export$dc5570b4a2b92d48 = 37808;
var $1a55656020b89c3a$export$68880cd325f8b2fb = 37809;
var $1a55656020b89c3a$export$7d2c0be323373d95 = 37810;
var $1a55656020b89c3a$export$22b52da301fc3a3e = 37811;
var $1a55656020b89c3a$export$c009e2cb4a66485e = 37812;
var $1a55656020b89c3a$export$118fff5afa255b63 = 37813;
var $1a55656020b89c3a$export$120713c829ae0667 = 37814;
var $1a55656020b89c3a$export$c79eeabbf53313e9 = 37815;
var $1a55656020b89c3a$export$443cf6567cdd6424 = 37816;
var $1a55656020b89c3a$export$6573984fc9840780 = 37817;
var $1a55656020b89c3a$export$e7aee563f30091de = 37818;
var $1a55656020b89c3a$export$2eb8634622ddeab7 = 37819;
var $1a55656020b89c3a$export$202b1ce7b5d25742 = 37820;
var $1a55656020b89c3a$export$18ab77abd087e467 = 37821;
var $1a55656020b89c3a$export$ce40b115e188bc81 = 36492;
var $1a55656020b89c3a$export$d279c5c4bac5121e = 36494;
var $1a55656020b89c3a$export$cde52d17225fdbd3 = 36495;
var $1a55656020b89c3a$export$b1688df4c4c21670 = 36283;
var $1a55656020b89c3a$export$fc15e5d8261eed58 = 36284;
var $1a55656020b89c3a$export$d220f6ade8463a0f = 36285;
var $1a55656020b89c3a$export$768646d09dc1b6ef = 36286;
var $1a55656020b89c3a$export$d62fdc9d1b1cccad = 2200;
var $1a55656020b89c3a$export$dfaf4422ce096e29 = 2201;
var $1a55656020b89c3a$export$f8f6f2041b78e210 = 2202;
var $1a55656020b89c3a$export$995b32462a65e855 = 2300;
var $1a55656020b89c3a$export$30fac1aace31cf4d = 2301;
var $1a55656020b89c3a$export$198b11ff4c72bb30 = 2302;
var $1a55656020b89c3a$export$7f795934b84ab523 = 2400;
var $1a55656020b89c3a$export$24a4ccb5099273b5 = 2401;
var $1a55656020b89c3a$export$8e8c3ecdcd8e1fee = 2402;
var $1a55656020b89c3a$export$bcfbbdcf8de7f8cd = 2500;
var $1a55656020b89c3a$export$d875e029ef558d3 = 2501;
var $1a55656020b89c3a$export$4c28c87c2dc84758 = 0;
var $1a55656020b89c3a$export$b23a071aa286eb29 = 1;
var $1a55656020b89c3a$export$f0d8293634f88842 = 2;
var $1a55656020b89c3a$export$deeb383078690b50 = 3200;
var $1a55656020b89c3a$export$8f910f4c4f73df11 = 3201;
var $1a55656020b89c3a$export$be2e2ddbc3983173 = 3202;
var $1a55656020b89c3a$export$1a54198784742f80 = 3203;
var $1a55656020b89c3a$export$2852a58ebdac27b8 = 0;
var $1a55656020b89c3a$export$9990ad26f9db5b2c = 1;
// Color space string identifiers, matching CSS Color Module Level 4 and WebGPU names where available.
var $1a55656020b89c3a$export$bfcb490c2dd3db51 = '';
var $1a55656020b89c3a$export$561f394b24edfcaa = 'srgb';
var $1a55656020b89c3a$export$42429b3acfb233a4 = 'srgb-linear';
var $1a55656020b89c3a$export$f197347d588c1b4a = 'linear';
var $1a55656020b89c3a$export$8d0a61916cc26abb = 'srgb';
var $1a55656020b89c3a$export$69433f11f42d5527 = 0;
var $1a55656020b89c3a$export$9f542ae4b5baca34 = 7680;
var $1a55656020b89c3a$export$8a4f28336ef203d3 = 7681;
var $1a55656020b89c3a$export$2928c0231297c036 = 7682;
var $1a55656020b89c3a$export$c0e9611c8a15f9a8 = 7683;
var $1a55656020b89c3a$export$9c2c08927385dcc4 = 34055;
var $1a55656020b89c3a$export$7c74ea00fa1315e6 = 34056;
var $1a55656020b89c3a$export$22e2e5726612443 = 5386;
var $1a55656020b89c3a$export$1343870698229224 = 512;
var $1a55656020b89c3a$export$8e1d8ed281997fa6 = 513;
var $1a55656020b89c3a$export$55648a1cde8329a7 = 514;
var $1a55656020b89c3a$export$2dff107857e6aca2 = 515;
var $1a55656020b89c3a$export$6f93765ab2f451a2 = 516;
var $1a55656020b89c3a$export$6f3fb2d2440f2b76 = 517;
var $1a55656020b89c3a$export$4119cf7b4c98fd5a = 518;
var $1a55656020b89c3a$export$14cf96713ddd97a8 = 519;
var $1a55656020b89c3a$export$d9e2d19a747baaab = 512;
var $1a55656020b89c3a$export$36bcf49c713b3eb7 = 513;
var $1a55656020b89c3a$export$66f28d946fc6a0d5 = 514;
var $1a55656020b89c3a$export$64eea11eb407ddf1 = 515;
var $1a55656020b89c3a$export$155af022118f3a38 = 516;
var $1a55656020b89c3a$export$67ab95dde6bed156 = 517;
var $1a55656020b89c3a$export$1cdcb70d53d65f61 = 518;
var $1a55656020b89c3a$export$187b73a3e352c145 = 519;
var $1a55656020b89c3a$export$763e8360f4d7f77d = 35044;
var $1a55656020b89c3a$export$8505d14ac8546ca = 35048;
var $1a55656020b89c3a$export$721e63549e51d81e = 35040;
var $1a55656020b89c3a$export$415731dc4f48e299 = 35045;
var $1a55656020b89c3a$export$9e809946455f13bc = 35049;
var $1a55656020b89c3a$export$2ed9499a35b5f832 = 35041;
var $1a55656020b89c3a$export$32ab2503ea19469a = 35046;
var $1a55656020b89c3a$export$ab4022c2c3f86315 = 35050;
var $1a55656020b89c3a$export$ba7f1db36a76a970 = 35042;
var $1a55656020b89c3a$export$43600cc67fabd9f = '100';
var $1a55656020b89c3a$export$f63012db5506e7dd = '300 es';
var $1a55656020b89c3a$export$5a0e9190d10875d3 = 2000;
var $1a55656020b89c3a$export$cc83beedcb9be9ac = 2001;
var $1a55656020b89c3a$export$f97db56e2b647801 = {
    COMPUTE: 'compute',
    RENDER: 'render'
};
/**
 * https://github.com/mrdoob/eventdispatcher.js/
 */ var $1a55656020b89c3a$export$ec8b666c5fe2c75a = /*#__PURE__*/ function() {
    "use strict";
    function EventDispatcher() {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, EventDispatcher);
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(EventDispatcher, [
        {
            key: "addEventListener",
            value: function addEventListener(type, listener) {
                if (this._listeners === undefined) this._listeners = {};
                var listeners = this._listeners;
                if (listeners[type] === undefined) listeners[type] = [];
                if (listeners[type].indexOf(listener) === -1) listeners[type].push(listener);
            }
        },
        {
            key: "hasEventListener",
            value: function hasEventListener(type, listener) {
                var listeners = this._listeners;
                if (listeners === undefined) return false;
                return listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1;
            }
        },
        {
            key: "removeEventListener",
            value: function removeEventListener(type, listener) {
                var listeners = this._listeners;
                if (listeners === undefined) return;
                var listenerArray = listeners[type];
                if (listenerArray !== undefined) {
                    var index = listenerArray.indexOf(listener);
                    if (index !== -1) listenerArray.splice(index, 1);
                }
            }
        },
        {
            key: "dispatchEvent",
            value: function dispatchEvent(event) {
                var listeners = this._listeners;
                if (listeners === undefined) return;
                var listenerArray = listeners[event.type];
                if (listenerArray !== undefined) {
                    event.target = this;
                    // Make a copy, in case listeners are removed while iterating.
                    var array = listenerArray.slice(0);
                    for(var i = 0, l = array.length; i < l; i++)array[i].call(this, event);
                    event.target = null;
                }
            }
        }
    ]);
    return EventDispatcher;
}();
var $1a55656020b89c3a$var$_lut = [
    '00',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '0a',
    '0b',
    '0c',
    '0d',
    '0e',
    '0f',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '1a',
    '1b',
    '1c',
    '1d',
    '1e',
    '1f',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
    '29',
    '2a',
    '2b',
    '2c',
    '2d',
    '2e',
    '2f',
    '30',
    '31',
    '32',
    '33',
    '34',
    '35',
    '36',
    '37',
    '38',
    '39',
    '3a',
    '3b',
    '3c',
    '3d',
    '3e',
    '3f',
    '40',
    '41',
    '42',
    '43',
    '44',
    '45',
    '46',
    '47',
    '48',
    '49',
    '4a',
    '4b',
    '4c',
    '4d',
    '4e',
    '4f',
    '50',
    '51',
    '52',
    '53',
    '54',
    '55',
    '56',
    '57',
    '58',
    '59',
    '5a',
    '5b',
    '5c',
    '5d',
    '5e',
    '5f',
    '60',
    '61',
    '62',
    '63',
    '64',
    '65',
    '66',
    '67',
    '68',
    '69',
    '6a',
    '6b',
    '6c',
    '6d',
    '6e',
    '6f',
    '70',
    '71',
    '72',
    '73',
    '74',
    '75',
    '76',
    '77',
    '78',
    '79',
    '7a',
    '7b',
    '7c',
    '7d',
    '7e',
    '7f',
    '80',
    '81',
    '82',
    '83',
    '84',
    '85',
    '86',
    '87',
    '88',
    '89',
    '8a',
    '8b',
    '8c',
    '8d',
    '8e',
    '8f',
    '90',
    '91',
    '92',
    '93',
    '94',
    '95',
    '96',
    '97',
    '98',
    '99',
    '9a',
    '9b',
    '9c',
    '9d',
    '9e',
    '9f',
    'a0',
    'a1',
    'a2',
    'a3',
    'a4',
    'a5',
    'a6',
    'a7',
    'a8',
    'a9',
    'aa',
    'ab',
    'ac',
    'ad',
    'ae',
    'af',
    'b0',
    'b1',
    'b2',
    'b3',
    'b4',
    'b5',
    'b6',
    'b7',
    'b8',
    'b9',
    'ba',
    'bb',
    'bc',
    'bd',
    'be',
    'bf',
    'c0',
    'c1',
    'c2',
    'c3',
    'c4',
    'c5',
    'c6',
    'c7',
    'c8',
    'c9',
    'ca',
    'cb',
    'cc',
    'cd',
    'ce',
    'cf',
    'd0',
    'd1',
    'd2',
    'd3',
    'd4',
    'd5',
    'd6',
    'd7',
    'd8',
    'd9',
    'da',
    'db',
    'dc',
    'dd',
    'de',
    'df',
    'e0',
    'e1',
    'e2',
    'e3',
    'e4',
    'e5',
    'e6',
    'e7',
    'e8',
    'e9',
    'ea',
    'eb',
    'ec',
    'ed',
    'ee',
    'ef',
    'f0',
    'f1',
    'f2',
    'f3',
    'f4',
    'f5',
    'f6',
    'f7',
    'f8',
    'f9',
    'fa',
    'fb',
    'fc',
    'fd',
    'fe',
    'ff'
];
var $1a55656020b89c3a$var$_seed = 1234567;
var $1a55656020b89c3a$var$DEG2RAD = Math.PI / 180;
var $1a55656020b89c3a$export$914076c8150813e5 = 180 / Math.PI;
// http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
function $1a55656020b89c3a$var$generateUUID() {
    var d0 = Math.random() * 0xffffffff | 0;
    var d1 = Math.random() * 0xffffffff | 0;
    var d2 = Math.random() * 0xffffffff | 0;
    var d3 = Math.random() * 0xffffffff | 0;
    var uuid = $1a55656020b89c3a$var$_lut[d0 & 0xff] + $1a55656020b89c3a$var$_lut[d0 >> 8 & 0xff] + $1a55656020b89c3a$var$_lut[d0 >> 16 & 0xff] + $1a55656020b89c3a$var$_lut[d0 >> 24 & 0xff] + '-' + $1a55656020b89c3a$var$_lut[d1 & 0xff] + $1a55656020b89c3a$var$_lut[d1 >> 8 & 0xff] + '-' + $1a55656020b89c3a$var$_lut[d1 >> 16 & 0x0f | 0x40] + $1a55656020b89c3a$var$_lut[d1 >> 24 & 0xff] + '-' + $1a55656020b89c3a$var$_lut[d2 & 0x3f | 0x80] + $1a55656020b89c3a$var$_lut[d2 >> 8 & 0xff] + '-' + $1a55656020b89c3a$var$_lut[d2 >> 16 & 0xff] + $1a55656020b89c3a$var$_lut[d2 >> 24 & 0xff] + $1a55656020b89c3a$var$_lut[d3 & 0xff] + $1a55656020b89c3a$var$_lut[d3 >> 8 & 0xff] + $1a55656020b89c3a$var$_lut[d3 >> 16 & 0xff] + $1a55656020b89c3a$var$_lut[d3 >> 24 & 0xff];
    // .toLowerCase() here flattens concatenated strings to save heap memory space.
    return uuid.toLowerCase();
}
function $1a55656020b89c3a$var$clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
// compute euclidean modulo of m % n
// https://en.wikipedia.org/wiki/Modulo_operation
function $1a55656020b89c3a$var$euclideanModulo(n, m) {
    return (n % m + m) % m;
}
// Linear mapping from range <a1, a2> to range <b1, b2>
function $1a55656020b89c3a$var$mapLinear(x, a1, a2, b1, b2) {
    return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
}
// https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/
function $1a55656020b89c3a$var$inverseLerp(x, y, value) {
    if (x !== y) return (value - x) / (y - x);
    else return 0;
}
// https://en.wikipedia.org/wiki/Linear_interpolation
function $1a55656020b89c3a$var$lerp(x, y, t) {
    return (1 - t) * x + t * y;
}
// http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/
function $1a55656020b89c3a$var$damp(x, y, lambda, dt) {
    return $1a55656020b89c3a$var$lerp(x, y, 1 - Math.exp(-lambda * dt));
}
// https://www.desmos.com/calculator/vcsjnyz7x4
function $1a55656020b89c3a$var$pingpong(x) {
    var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    return length - Math.abs($1a55656020b89c3a$var$euclideanModulo(x, length * 2) - length);
}
// http://en.wikipedia.org/wiki/Smoothstep
function $1a55656020b89c3a$var$smoothstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * (3 - 2 * x);
}
function $1a55656020b89c3a$var$smootherstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * x * (x * (x * 6 - 15) + 10);
}
// Random integer from <low, high> interval
function $1a55656020b89c3a$var$randInt(low, high) {
    return low + Math.floor(Math.random() * (high - low + 1));
}
// Random float from <low, high> interval
function $1a55656020b89c3a$var$randFloat(low, high) {
    return low + Math.random() * (high - low);
}
// Random float from <-range/2, range/2> interval
function $1a55656020b89c3a$var$randFloatSpread(range) {
    return range * (0.5 - Math.random());
}
// Deterministic pseudo-random float in the interval [ 0, 1 ]
function $1a55656020b89c3a$var$seededRandom(s) {
    if (s !== undefined) $1a55656020b89c3a$var$_seed = s;
    // Mulberry32 generator
    var t = $1a55656020b89c3a$var$_seed += 0x6D2B79F5;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
}
function $1a55656020b89c3a$var$degToRad(degrees) {
    return degrees * $1a55656020b89c3a$var$DEG2RAD;
}
function $1a55656020b89c3a$var$radToDeg(radians) {
    return radians * $1a55656020b89c3a$export$914076c8150813e5;
}
function $1a55656020b89c3a$var$isPowerOfTwo(value) {
    return (value & value - 1) === 0 && value !== 0;
}
function $1a55656020b89c3a$var$ceilPowerOfTwo(value) {
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
function $1a55656020b89c3a$var$floorPowerOfTwo(value) {
    return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
function $1a55656020b89c3a$var$setQuaternionFromProperEuler(q, a, b, c, order) {
    // Intrinsic Proper Euler Angles - see https://en.wikipedia.org/wiki/Euler_angles
    // rotations are applied to the axes in the order specified by 'order'
    // rotation by angle 'a' is applied first, then by angle 'b', then by angle 'c'
    // angles are in radians
    var cos = Math.cos;
    var sin = Math.sin;
    var c2 = cos(b / 2);
    var s2 = sin(b / 2);
    var c13 = cos((a + c) / 2);
    var s13 = sin((a + c) / 2);
    var c1_3 = cos((a - c) / 2);
    var s1_3 = sin((a - c) / 2);
    var c3_1 = cos((c - a) / 2);
    var s3_1 = sin((c - a) / 2);
    switch(order){
        case 'XYX':
            q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
            break;
        case 'YZY':
            q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
            break;
        case 'ZXZ':
            q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
            break;
        case 'XZX':
            q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
            break;
        case 'YXY':
            q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
            break;
        case 'ZYZ':
            q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
            break;
        default:
            console.warn('THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: ' + order);
    }
}
function $1a55656020b89c3a$var$denormalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return value / 4294967295.0;
        case Uint16Array:
            return value / 65535.0;
        case Uint8Array:
            return value / 255.0;
        case Int32Array:
            return Math.max(value / 2147483647.0, -1);
        case Int16Array:
            return Math.max(value / 32767.0, -1);
        case Int8Array:
            return Math.max(value / 127.0, -1);
        default:
            throw new Error('Invalid component type.');
    }
}
function $1a55656020b89c3a$var$normalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return Math.round(value * 4294967295.0);
        case Uint16Array:
            return Math.round(value * 65535.0);
        case Uint8Array:
            return Math.round(value * 255.0);
        case Int32Array:
            return Math.round(value * 2147483647.0);
        case Int16Array:
            return Math.round(value * 32767.0);
        case Int8Array:
            return Math.round(value * 127.0);
        default:
            throw new Error('Invalid component type.');
    }
}
var $1a55656020b89c3a$export$6a7ef315a0d1ef07 = {
    DEG2RAD: $1a55656020b89c3a$var$DEG2RAD,
    RAD2DEG: $1a55656020b89c3a$export$914076c8150813e5,
    generateUUID: $1a55656020b89c3a$var$generateUUID,
    clamp: $1a55656020b89c3a$var$clamp,
    euclideanModulo: $1a55656020b89c3a$var$euclideanModulo,
    mapLinear: $1a55656020b89c3a$var$mapLinear,
    inverseLerp: $1a55656020b89c3a$var$inverseLerp,
    lerp: $1a55656020b89c3a$var$lerp,
    damp: $1a55656020b89c3a$var$damp,
    pingpong: $1a55656020b89c3a$var$pingpong,
    smoothstep: $1a55656020b89c3a$var$smoothstep,
    smootherstep: $1a55656020b89c3a$var$smootherstep,
    randInt: $1a55656020b89c3a$var$randInt,
    randFloat: $1a55656020b89c3a$var$randFloat,
    randFloatSpread: $1a55656020b89c3a$var$randFloatSpread,
    seededRandom: $1a55656020b89c3a$var$seededRandom,
    degToRad: $1a55656020b89c3a$var$degToRad,
    radToDeg: $1a55656020b89c3a$var$radToDeg,
    isPowerOfTwo: $1a55656020b89c3a$var$isPowerOfTwo,
    ceilPowerOfTwo: $1a55656020b89c3a$var$ceilPowerOfTwo,
    floorPowerOfTwo: $1a55656020b89c3a$var$floorPowerOfTwo,
    setQuaternionFromProperEuler: $1a55656020b89c3a$var$setQuaternionFromProperEuler,
    normalize: $1a55656020b89c3a$var$normalize,
    denormalize: $1a55656020b89c3a$var$denormalize
};
var $1a55656020b89c3a$export$c977b3e384af9ae1 = /*#__PURE__*/ function() {
    "use strict";
    function Vector2() {
        var x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Vector2);
        Vector2.prototype.isVector2 = true;
        this.x = x;
        this.y = y;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Vector2, [
        {
            key: "width",
            get: function get() {
                return this.x;
            },
            set: function set(value) {
                this.x = value;
            }
        },
        {
            key: "height",
            get: function get() {
                return this.y;
            },
            set: function set(value) {
                this.y = value;
            }
        },
        {
            key: "set",
            value: function set(x, y) {
                this.x = x;
                this.y = y;
                return this;
            }
        },
        {
            key: "setScalar",
            value: function setScalar(scalar) {
                this.x = scalar;
                this.y = scalar;
                return this;
            }
        },
        {
            key: "setX",
            value: function setX(x) {
                this.x = x;
                return this;
            }
        },
        {
            key: "setY",
            value: function setY(y) {
                this.y = y;
                return this;
            }
        },
        {
            key: "setComponent",
            value: function setComponent(index, value) {
                switch(index){
                    case 0:
                        this.x = value;
                        break;
                    case 1:
                        this.y = value;
                        break;
                    default:
                        throw new Error('index is out of range: ' + index);
                }
                return this;
            }
        },
        {
            key: "getComponent",
            value: function getComponent(index) {
                switch(index){
                    case 0:
                        return this.x;
                    case 1:
                        return this.y;
                    default:
                        throw new Error('index is out of range: ' + index);
                }
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor(this.x, this.y);
            }
        },
        {
            key: "copy",
            value: function copy(v) {
                this.x = v.x;
                this.y = v.y;
                return this;
            }
        },
        {
            key: "add",
            value: function add(v) {
                this.x += v.x;
                this.y += v.y;
                return this;
            }
        },
        {
            key: "addScalar",
            value: function addScalar(s) {
                this.x += s;
                this.y += s;
                return this;
            }
        },
        {
            key: "addVectors",
            value: function addVectors(a, b) {
                this.x = a.x + b.x;
                this.y = a.y + b.y;
                return this;
            }
        },
        {
            key: "addScaledVector",
            value: function addScaledVector(v, s) {
                this.x += v.x * s;
                this.y += v.y * s;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(v) {
                this.x -= v.x;
                this.y -= v.y;
                return this;
            }
        },
        {
            key: "subScalar",
            value: function subScalar(s) {
                this.x -= s;
                this.y -= s;
                return this;
            }
        },
        {
            key: "subVectors",
            value: function subVectors(a, b) {
                this.x = a.x - b.x;
                this.y = a.y - b.y;
                return this;
            }
        },
        {
            key: "multiply",
            value: function multiply(v) {
                this.x *= v.x;
                this.y *= v.y;
                return this;
            }
        },
        {
            key: "multiplyScalar",
            value: function multiplyScalar(scalar) {
                this.x *= scalar;
                this.y *= scalar;
                return this;
            }
        },
        {
            key: "divide",
            value: function divide(v) {
                this.x /= v.x;
                this.y /= v.y;
                return this;
            }
        },
        {
            key: "divideScalar",
            value: function divideScalar(scalar) {
                return this.multiplyScalar(1 / scalar);
            }
        },
        {
            key: "applyMatrix3",
            value: function applyMatrix3(m) {
                var x = this.x, y = this.y;
                var e = m.elements;
                this.x = e[0] * x + e[3] * y + e[6];
                this.y = e[1] * x + e[4] * y + e[7];
                return this;
            }
        },
        {
            key: "min",
            value: function min(v) {
                this.x = Math.min(this.x, v.x);
                this.y = Math.min(this.y, v.y);
                return this;
            }
        },
        {
            key: "max",
            value: function max(v) {
                this.x = Math.max(this.x, v.x);
                this.y = Math.max(this.y, v.y);
                return this;
            }
        },
        {
            key: "clamp",
            value: function clamp1(min, max) {
                // assumes min < max, componentwise
                this.x = $1a55656020b89c3a$var$clamp(this.x, min.x, max.x);
                this.y = $1a55656020b89c3a$var$clamp(this.y, min.y, max.y);
                return this;
            }
        },
        {
            key: "clampScalar",
            value: function clampScalar(minVal, maxVal) {
                this.x = $1a55656020b89c3a$var$clamp(this.x, minVal, maxVal);
                this.y = $1a55656020b89c3a$var$clamp(this.y, minVal, maxVal);
                return this;
            }
        },
        {
            key: "clampLength",
            value: function clampLength(min, max) {
                var length = this.length();
                return this.divideScalar(length || 1).multiplyScalar($1a55656020b89c3a$var$clamp(length, min, max));
            }
        },
        {
            key: "floor",
            value: function floor() {
                this.x = Math.floor(this.x);
                this.y = Math.floor(this.y);
                return this;
            }
        },
        {
            key: "ceil",
            value: function ceil() {
                this.x = Math.ceil(this.x);
                this.y = Math.ceil(this.y);
                return this;
            }
        },
        {
            key: "round",
            value: function round() {
                this.x = Math.round(this.x);
                this.y = Math.round(this.y);
                return this;
            }
        },
        {
            key: "roundToZero",
            value: function roundToZero() {
                this.x = Math.trunc(this.x);
                this.y = Math.trunc(this.y);
                return this;
            }
        },
        {
            key: "negate",
            value: function negate() {
                this.x = -this.x;
                this.y = -this.y;
                return this;
            }
        },
        {
            key: "dot",
            value: function dot(v) {
                return this.x * v.x + this.y * v.y;
            }
        },
        {
            key: "cross",
            value: function cross(v) {
                return this.x * v.y - this.y * v.x;
            }
        },
        {
            key: "lengthSq",
            value: function lengthSq() {
                return this.x * this.x + this.y * this.y;
            }
        },
        {
            key: "length",
            value: function length() {
                return Math.sqrt(this.x * this.x + this.y * this.y);
            }
        },
        {
            key: "manhattanLength",
            value: function manhattanLength() {
                return Math.abs(this.x) + Math.abs(this.y);
            }
        },
        {
            key: "normalize",
            value: function normalize() {
                return this.divideScalar(this.length() || 1);
            }
        },
        {
            key: "angle",
            value: function angle() {
                // computes the angle in radians with respect to the positive x-axis
                var angle = Math.atan2(-this.y, -this.x) + Math.PI;
                return angle;
            }
        },
        {
            key: "angleTo",
            value: function angleTo(v) {
                var denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
                if (denominator === 0) return Math.PI / 2;
                var theta = this.dot(v) / denominator;
                // clamp, to handle numerical problems
                return Math.acos($1a55656020b89c3a$var$clamp(theta, -1, 1));
            }
        },
        {
            key: "distanceTo",
            value: function distanceTo(v) {
                return Math.sqrt(this.distanceToSquared(v));
            }
        },
        {
            key: "distanceToSquared",
            value: function distanceToSquared(v) {
                var dx = this.x - v.x, dy = this.y - v.y;
                return dx * dx + dy * dy;
            }
        },
        {
            key: "manhattanDistanceTo",
            value: function manhattanDistanceTo(v) {
                return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
            }
        },
        {
            key: "setLength",
            value: function setLength(length) {
                return this.normalize().multiplyScalar(length);
            }
        },
        {
            key: "lerp",
            value: function lerp(v, alpha) {
                this.x += (v.x - this.x) * alpha;
                this.y += (v.y - this.y) * alpha;
                return this;
            }
        },
        {
            key: "lerpVectors",
            value: function lerpVectors(v1, v2, alpha) {
                this.x = v1.x + (v2.x - v1.x) * alpha;
                this.y = v1.y + (v2.y - v1.y) * alpha;
                return this;
            }
        },
        {
            key: "equals",
            value: function equals(v) {
                return v.x === this.x && v.y === this.y;
            }
        },
        {
            key: "fromArray",
            value: function fromArray(array) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                this.x = array[offset];
                this.y = array[offset + 1];
                return this;
            }
        },
        {
            key: "toArray",
            value: function toArray() {
                var array = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                array[offset] = this.x;
                array[offset + 1] = this.y;
                return array;
            }
        },
        {
            key: "fromBufferAttribute",
            value: function fromBufferAttribute(attribute, index) {
                this.x = attribute.getX(index);
                this.y = attribute.getY(index);
                return this;
            }
        },
        {
            key: "rotateAround",
            value: function rotateAround(center, angle) {
                var c = Math.cos(angle), s = Math.sin(angle);
                var x = this.x - center.x;
                var y = this.y - center.y;
                this.x = x * c - y * s + center.x;
                this.y = x * s + y * c + center.y;
                return this;
            }
        },
        {
            key: "random",
            value: function random() {
                this.x = Math.random();
                this.y = Math.random();
                return this;
            }
        },
        {
            key: Symbol.iterator,
            value: function value() {
                return (0, $353b713f9392bb93$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                this.x
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                this.y
                            ];
                        case 2:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }
        }
    ]);
    return Vector2;
}();
var $1a55656020b89c3a$export$8ff26dafa08918 = /*#__PURE__*/ function() {
    "use strict";
    function Matrix3(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Matrix3);
        Matrix3.prototype.isMatrix3 = true;
        this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n21, n22, n23, n31, n32, n33);
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Matrix3, [
        {
            key: "set",
            value: function set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
                var te = this.elements;
                te[0] = n11;
                te[1] = n21;
                te[2] = n31;
                te[3] = n12;
                te[4] = n22;
                te[5] = n32;
                te[6] = n13;
                te[7] = n23;
                te[8] = n33;
                return this;
            }
        },
        {
            key: "identity",
            value: function identity() {
                this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);
                return this;
            }
        },
        {
            key: "copy",
            value: function copy(m) {
                var te = this.elements;
                var me = m.elements;
                te[0] = me[0];
                te[1] = me[1];
                te[2] = me[2];
                te[3] = me[3];
                te[4] = me[4];
                te[5] = me[5];
                te[6] = me[6];
                te[7] = me[7];
                te[8] = me[8];
                return this;
            }
        },
        {
            key: "extractBasis",
            value: function extractBasis(xAxis, yAxis, zAxis) {
                xAxis.setFromMatrix3Column(this, 0);
                yAxis.setFromMatrix3Column(this, 1);
                zAxis.setFromMatrix3Column(this, 2);
                return this;
            }
        },
        {
            key: "setFromMatrix4",
            value: function setFromMatrix4(m) {
                var me = m.elements;
                this.set(me[0], me[4], me[8], me[1], me[5], me[9], me[2], me[6], me[10]);
                return this;
            }
        },
        {
            key: "multiply",
            value: function multiply(m) {
                return this.multiplyMatrices(this, m);
            }
        },
        {
            key: "premultiply",
            value: function premultiply(m) {
                return this.multiplyMatrices(m, this);
            }
        },
        {
            key: "multiplyMatrices",
            value: function multiplyMatrices(a, b) {
                var ae = a.elements;
                var be = b.elements;
                var te = this.elements;
                var a11 = ae[0], a12 = ae[3], a13 = ae[6];
                var a21 = ae[1], a22 = ae[4], a23 = ae[7];
                var a31 = ae[2], a32 = ae[5], a33 = ae[8];
                var b11 = be[0], b12 = be[3], b13 = be[6];
                var b21 = be[1], b22 = be[4], b23 = be[7];
                var b31 = be[2], b32 = be[5], b33 = be[8];
                te[0] = a11 * b11 + a12 * b21 + a13 * b31;
                te[3] = a11 * b12 + a12 * b22 + a13 * b32;
                te[6] = a11 * b13 + a12 * b23 + a13 * b33;
                te[1] = a21 * b11 + a22 * b21 + a23 * b31;
                te[4] = a21 * b12 + a22 * b22 + a23 * b32;
                te[7] = a21 * b13 + a22 * b23 + a23 * b33;
                te[2] = a31 * b11 + a32 * b21 + a33 * b31;
                te[5] = a31 * b12 + a32 * b22 + a33 * b32;
                te[8] = a31 * b13 + a32 * b23 + a33 * b33;
                return this;
            }
        },
        {
            key: "multiplyScalar",
            value: function multiplyScalar(s) {
                var te = this.elements;
                te[0] *= s;
                te[3] *= s;
                te[6] *= s;
                te[1] *= s;
                te[4] *= s;
                te[7] *= s;
                te[2] *= s;
                te[5] *= s;
                te[8] *= s;
                return this;
            }
        },
        {
            key: "determinant",
            value: function determinant() {
                var te = this.elements;
                var a = te[0], b = te[1], c = te[2], d = te[3], e = te[4], f = te[5], g = te[6], h = te[7], i = te[8];
                return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
            }
        },
        {
            key: "invert",
            value: function invert() {
                var te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n12 = te[3], n22 = te[4], n32 = te[5], n13 = te[6], n23 = te[7], n33 = te[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
                if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
                var detInv = 1 / det;
                te[0] = t11 * detInv;
                te[1] = (n31 * n23 - n33 * n21) * detInv;
                te[2] = (n32 * n21 - n31 * n22) * detInv;
                te[3] = t12 * detInv;
                te[4] = (n33 * n11 - n31 * n13) * detInv;
                te[5] = (n31 * n12 - n32 * n11) * detInv;
                te[6] = t13 * detInv;
                te[7] = (n21 * n13 - n23 * n11) * detInv;
                te[8] = (n22 * n11 - n21 * n12) * detInv;
                return this;
            }
        },
        {
            key: "transpose",
            value: function transpose() {
                var tmp;
                var m = this.elements;
                tmp = m[1];
                m[1] = m[3];
                m[3] = tmp;
                tmp = m[2];
                m[2] = m[6];
                m[6] = tmp;
                tmp = m[5];
                m[5] = m[7];
                m[7] = tmp;
                return this;
            }
        },
        {
            key: "getNormalMatrix",
            value: function getNormalMatrix(matrix4) {
                return this.setFromMatrix4(matrix4).invert().transpose();
            }
        },
        {
            key: "transposeIntoArray",
            value: function transposeIntoArray(r) {
                var m = this.elements;
                r[0] = m[0];
                r[1] = m[3];
                r[2] = m[6];
                r[3] = m[1];
                r[4] = m[4];
                r[5] = m[7];
                r[6] = m[2];
                r[7] = m[5];
                r[8] = m[8];
                return this;
            }
        },
        {
            key: "setUvTransform",
            value: function setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
                var c = Math.cos(rotation);
                var s = Math.sin(rotation);
                this.set(sx * c, sx * s, -sx * (c * cx + s * cy) + cx + tx, -sy * s, sy * c, -sy * (-s * cx + c * cy) + cy + ty, 0, 0, 1);
                return this;
            }
        },
        {
            //
            key: "scale",
            value: function scale(sx, sy) {
                this.premultiply($1a55656020b89c3a$var$_m3.makeScale(sx, sy));
                return this;
            }
        },
        {
            key: "rotate",
            value: function rotate(theta) {
                this.premultiply($1a55656020b89c3a$var$_m3.makeRotation(-theta));
                return this;
            }
        },
        {
            key: "translate",
            value: function translate(tx, ty) {
                this.premultiply($1a55656020b89c3a$var$_m3.makeTranslation(tx, ty));
                return this;
            }
        },
        {
            // for 2D Transforms
            key: "makeTranslation",
            value: function makeTranslation(x, y) {
                if (x.isVector2) this.set(1, 0, x.x, 0, 1, x.y, 0, 0, 1);
                else this.set(1, 0, x, 0, 1, y, 0, 0, 1);
                return this;
            }
        },
        {
            key: "makeRotation",
            value: function makeRotation(theta) {
                // counterclockwise
                var c = Math.cos(theta);
                var s = Math.sin(theta);
                this.set(c, -s, 0, s, c, 0, 0, 0, 1);
                return this;
            }
        },
        {
            key: "makeScale",
            value: function makeScale(x, y) {
                this.set(x, 0, 0, 0, y, 0, 0, 0, 1);
                return this;
            }
        },
        {
            //
            key: "equals",
            value: function equals(matrix) {
                var te = this.elements;
                var me = matrix.elements;
                for(var i = 0; i < 9; i++){
                    if (te[i] !== me[i]) return false;
                }
                return true;
            }
        },
        {
            key: "fromArray",
            value: function fromArray(array) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                for(var i = 0; i < 9; i++)this.elements[i] = array[i + offset];
                return this;
            }
        },
        {
            key: "toArray",
            value: function toArray() {
                var array = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var te = this.elements;
                array[offset] = te[0];
                array[offset + 1] = te[1];
                array[offset + 2] = te[2];
                array[offset + 3] = te[3];
                array[offset + 4] = te[4];
                array[offset + 5] = te[5];
                array[offset + 6] = te[6];
                array[offset + 7] = te[7];
                array[offset + 8] = te[8];
                return array;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().fromArray(this.elements);
            }
        }
    ]);
    return Matrix3;
}();
var $1a55656020b89c3a$var$_m3 = /*@__PURE__*/ new $1a55656020b89c3a$export$8ff26dafa08918();
function $1a55656020b89c3a$export$bc6f937da07eae17(array) {
    // assumes larger values usually on last
    for(var i = array.length - 1; i >= 0; --i){
        if (array[i] >= 65535) return true; // account for PRIMITIVE_RESTART_FIXED_INDEX, #24565
    }
    return false;
}
var $1a55656020b89c3a$var$TYPED_ARRAYS = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    Uint8ClampedArray: Uint8ClampedArray,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
function $1a55656020b89c3a$var$getTypedArray(type, buffer) {
    return new $1a55656020b89c3a$var$TYPED_ARRAYS[type](buffer);
}
function $1a55656020b89c3a$export$7094a064528c7fee(name) {
    return document.createElementNS('http://www.w3.org/1999/xhtml', name);
}
function $1a55656020b89c3a$export$1033a2df66368859() {
    var canvas = $1a55656020b89c3a$export$7094a064528c7fee('canvas');
    canvas.style.display = 'block';
    return canvas;
}
var $1a55656020b89c3a$var$_cache = {};
function $1a55656020b89c3a$export$5b28268982f175ba(message) {
    if (message in $1a55656020b89c3a$var$_cache) return;
    $1a55656020b89c3a$var$_cache[message] = true;
    console.warn(message);
}
function $1a55656020b89c3a$export$d43f91ebeafb2c7(gl, sync, interval) {
    return new Promise(function(resolve, reject) {
        function probe() {
            switch(gl.clientWaitSync(sync, gl.SYNC_FLUSH_COMMANDS_BIT, 0)){
                case gl.WAIT_FAILED:
                    reject();
                    break;
                case gl.TIMEOUT_EXPIRED:
                    setTimeout(probe, interval);
                    break;
                default:
                    resolve();
            }
        }
        setTimeout(probe, interval);
    });
}
function $1a55656020b89c3a$export$5238391f68c729b(projectionMatrix) {
    var m = projectionMatrix.elements;
    // Convert [-1, 1] to [0, 1] projection matrix
    m[2] = 0.5 * m[2] + 0.5 * m[3];
    m[6] = 0.5 * m[6] + 0.5 * m[7];
    m[10] = 0.5 * m[10] + 0.5 * m[11];
    m[14] = 0.5 * m[14] + 0.5 * m[15];
}
function $1a55656020b89c3a$export$f8cf97d08da9bc86(projectionMatrix) {
    var m = projectionMatrix.elements;
    var isPerspectiveMatrix = m[11] === -1;
    // Reverse [0, 1] projection matrix
    if (isPerspectiveMatrix) {
        m[10] = -m[10] - 1;
        m[14] = -m[14];
    } else {
        m[10] = -m[10];
        m[14] = -m[14] + 1;
    }
}
var $1a55656020b89c3a$var$LINEAR_REC709_TO_XYZ = /*@__PURE__*/ new $1a55656020b89c3a$export$8ff26dafa08918().set(0.4123908, 0.3575843, 0.1804808, 0.2126390, 0.7151687, 0.0721923, 0.0193308, 0.1191948, 0.9505322);
var $1a55656020b89c3a$var$XYZ_TO_LINEAR_REC709 = /*@__PURE__*/ new $1a55656020b89c3a$export$8ff26dafa08918().set(3.2409699, -1.5373832, -0.4986108, -0.9692436, 1.8759675, 0.0415551, 0.0556301, -0.203977, 1.0569715);
function $1a55656020b89c3a$var$createColorManagement() {
    var ColorManagement = {
        enabled: true,
        workingColorSpace: $1a55656020b89c3a$export$42429b3acfb233a4,
        /**
		 * Implementations of supported color spaces.
		 *
		 * Required:
		 *	- primaries: chromaticity coordinates [ rx ry gx gy bx by ]
		 *	- whitePoint: reference white [ x y ]
		 *	- transfer: transfer function (pre-defined)
		 *	- toXYZ: Matrix3 RGB to XYZ transform
		 *	- fromXYZ: Matrix3 XYZ to RGB transform
		 *	- luminanceCoefficients: RGB luminance coefficients
		 *
		 * Optional:
		 *  - outputColorSpaceConfig: { drawingBufferColorSpace: ColorSpace }
		 *  - workingColorSpaceConfig: { unpackColorSpace: ColorSpace }
		 *
		 * Reference:
		 * - https://www.russellcottrell.com/photo/matrixCalculator.htm
		 */ spaces: {},
        convert: function convert(color, sourceColorSpace, targetColorSpace) {
            if (this.enabled === false || sourceColorSpace === targetColorSpace || !sourceColorSpace || !targetColorSpace) return color;
            if (this.spaces[sourceColorSpace].transfer === $1a55656020b89c3a$export$8d0a61916cc26abb) {
                color.r = $1a55656020b89c3a$var$SRGBToLinear(color.r);
                color.g = $1a55656020b89c3a$var$SRGBToLinear(color.g);
                color.b = $1a55656020b89c3a$var$SRGBToLinear(color.b);
            }
            if (this.spaces[sourceColorSpace].primaries !== this.spaces[targetColorSpace].primaries) {
                color.applyMatrix3(this.spaces[sourceColorSpace].toXYZ);
                color.applyMatrix3(this.spaces[targetColorSpace].fromXYZ);
            }
            if (this.spaces[targetColorSpace].transfer === $1a55656020b89c3a$export$8d0a61916cc26abb) {
                color.r = $1a55656020b89c3a$var$LinearToSRGB(color.r);
                color.g = $1a55656020b89c3a$var$LinearToSRGB(color.g);
                color.b = $1a55656020b89c3a$var$LinearToSRGB(color.b);
            }
            return color;
        },
        fromWorkingColorSpace: function fromWorkingColorSpace(color, targetColorSpace) {
            return this.convert(color, this.workingColorSpace, targetColorSpace);
        },
        toWorkingColorSpace: function toWorkingColorSpace(color, sourceColorSpace) {
            return this.convert(color, sourceColorSpace, this.workingColorSpace);
        },
        getPrimaries: function getPrimaries(colorSpace) {
            return this.spaces[colorSpace].primaries;
        },
        getTransfer: function getTransfer(colorSpace) {
            if (colorSpace === $1a55656020b89c3a$export$bfcb490c2dd3db51) return $1a55656020b89c3a$export$f197347d588c1b4a;
            return this.spaces[colorSpace].transfer;
        },
        getLuminanceCoefficients: function getLuminanceCoefficients(target) {
            var colorSpace = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.workingColorSpace;
            return target.fromArray(this.spaces[colorSpace].luminanceCoefficients);
        },
        define: function define(colorSpaces) {
            Object.assign(this.spaces, colorSpaces);
        },
        // Internal APIs
        _getMatrix: function _getMatrix(targetMatrix, sourceColorSpace, targetColorSpace) {
            return targetMatrix.copy(this.spaces[sourceColorSpace].toXYZ).multiply(this.spaces[targetColorSpace].fromXYZ);
        },
        _getDrawingBufferColorSpace: function _getDrawingBufferColorSpace(colorSpace) {
            return this.spaces[colorSpace].outputColorSpaceConfig.drawingBufferColorSpace;
        },
        _getUnpackColorSpace: function _getUnpackColorSpace() {
            var colorSpace = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.workingColorSpace;
            return this.spaces[colorSpace].workingColorSpaceConfig.unpackColorSpace;
        }
    };
    /******************************************************************************
	 * sRGB definitions
	 */ var REC709_PRIMARIES = [
        0.640,
        0.330,
        0.300,
        0.600,
        0.150,
        0.060
    ];
    var REC709_LUMINANCE_COEFFICIENTS = [
        0.2126,
        0.7152,
        0.0722
    ];
    var D65 = [
        0.3127,
        0.3290
    ];
    var _obj;
    ColorManagement.define((_obj = {}, (0, $3facda9e207b3c1f$export$71511d61b312f219)(_obj, $1a55656020b89c3a$export$42429b3acfb233a4, {
        primaries: REC709_PRIMARIES,
        whitePoint: D65,
        transfer: $1a55656020b89c3a$export$f197347d588c1b4a,
        toXYZ: $1a55656020b89c3a$var$LINEAR_REC709_TO_XYZ,
        fromXYZ: $1a55656020b89c3a$var$XYZ_TO_LINEAR_REC709,
        luminanceCoefficients: REC709_LUMINANCE_COEFFICIENTS,
        workingColorSpaceConfig: {
            unpackColorSpace: $1a55656020b89c3a$export$561f394b24edfcaa
        },
        outputColorSpaceConfig: {
            drawingBufferColorSpace: $1a55656020b89c3a$export$561f394b24edfcaa
        }
    }), (0, $3facda9e207b3c1f$export$71511d61b312f219)(_obj, $1a55656020b89c3a$export$561f394b24edfcaa, {
        primaries: REC709_PRIMARIES,
        whitePoint: D65,
        transfer: $1a55656020b89c3a$export$8d0a61916cc26abb,
        toXYZ: $1a55656020b89c3a$var$LINEAR_REC709_TO_XYZ,
        fromXYZ: $1a55656020b89c3a$var$XYZ_TO_LINEAR_REC709,
        luminanceCoefficients: REC709_LUMINANCE_COEFFICIENTS,
        outputColorSpaceConfig: {
            drawingBufferColorSpace: $1a55656020b89c3a$export$561f394b24edfcaa
        }
    }), _obj));
    return ColorManagement;
}
var $1a55656020b89c3a$export$5e6fd513f44698c = /*@__PURE__*/ $1a55656020b89c3a$var$createColorManagement();
function $1a55656020b89c3a$var$SRGBToLinear(c) {
    return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}
function $1a55656020b89c3a$var$LinearToSRGB(c) {
    return c < 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
}
var $1a55656020b89c3a$var$_canvas;
var $1a55656020b89c3a$export$698882cf06df44aa = /*#__PURE__*/ function() {
    "use strict";
    function ImageUtils() {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, ImageUtils);
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(ImageUtils, null, [
        {
            key: "getDataURL",
            value: function getDataURL(image) {
                if (/^data:/i.test(image.src)) return image.src;
                if (typeof HTMLCanvasElement === 'undefined') return image.src;
                var canvas;
                if (image instanceof HTMLCanvasElement) canvas = image;
                else {
                    if ($1a55656020b89c3a$var$_canvas === undefined) $1a55656020b89c3a$var$_canvas = $1a55656020b89c3a$export$7094a064528c7fee('canvas');
                    $1a55656020b89c3a$var$_canvas.width = image.width;
                    $1a55656020b89c3a$var$_canvas.height = image.height;
                    var context = $1a55656020b89c3a$var$_canvas.getContext('2d');
                    if (image instanceof ImageData) context.putImageData(image, 0, 0);
                    else context.drawImage(image, 0, 0, image.width, image.height);
                    canvas = $1a55656020b89c3a$var$_canvas;
                }
                return canvas.toDataURL('image/png');
            }
        },
        {
            key: "sRGBToLinear",
            value: function sRGBToLinear(image) {
                if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) {
                    var canvas = $1a55656020b89c3a$export$7094a064528c7fee('canvas');
                    canvas.width = image.width;
                    canvas.height = image.height;
                    var context = canvas.getContext('2d');
                    context.drawImage(image, 0, 0, image.width, image.height);
                    var imageData = context.getImageData(0, 0, image.width, image.height);
                    var data = imageData.data;
                    for(var i = 0; i < data.length; i++)data[i] = $1a55656020b89c3a$var$SRGBToLinear(data[i] / 255) * 255;
                    context.putImageData(imageData, 0, 0);
                    return canvas;
                } else if (image.data) {
                    var data1 = image.data.slice(0);
                    for(var i1 = 0; i1 < data1.length; i1++)if (data1 instanceof Uint8Array || data1 instanceof Uint8ClampedArray) data1[i1] = Math.floor($1a55656020b89c3a$var$SRGBToLinear(data1[i1] / 255) * 255);
                    else // assuming float
                    data1[i1] = $1a55656020b89c3a$var$SRGBToLinear(data1[i1]);
                    return {
                        data: data1,
                        width: image.width,
                        height: image.height
                    };
                } else {
                    console.warn('THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.');
                    return image;
                }
            }
        }
    ]);
    return ImageUtils;
}();
var $1a55656020b89c3a$var$_sourceId = 0;
var $1a55656020b89c3a$export$1d2df86270c81ecb = /*#__PURE__*/ function() {
    "use strict";
    function Source() {
        var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Source);
        this.isSource = true;
        Object.defineProperty(this, 'id', {
            value: $1a55656020b89c3a$var$_sourceId++
        });
        this.uuid = $1a55656020b89c3a$var$generateUUID();
        this.data = data;
        this.dataReady = true;
        this.version = 0;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Source, [
        {
            key: "needsUpdate",
            set: function set(value) {
                if (value === true) this.version++;
            }
        },
        {
            key: "toJSON",
            value: function toJSON(meta) {
                var isRootObject = meta === undefined || typeof meta === 'string';
                if (!isRootObject && meta.images[this.uuid] !== undefined) return meta.images[this.uuid];
                var output = {
                    uuid: this.uuid,
                    url: ''
                };
                var data = this.data;
                if (data !== null) {
                    var url;
                    if (Array.isArray(data)) {
                        // cube texture
                        url = [];
                        for(var i = 0, l = data.length; i < l; i++)if (data[i].isDataTexture) url.push($1a55656020b89c3a$var$serializeImage(data[i].image));
                        else url.push($1a55656020b89c3a$var$serializeImage(data[i]));
                    } else // texture
                    url = $1a55656020b89c3a$var$serializeImage(data);
                    output.url = url;
                }
                if (!isRootObject) meta.images[this.uuid] = output;
                return output;
            }
        }
    ]);
    return Source;
}();
function $1a55656020b89c3a$var$serializeImage(image) {
    if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) // default images
    return $1a55656020b89c3a$export$698882cf06df44aa.getDataURL(image);
    else {
        if (image.data) // images of DataTexture
        return {
            data: Array.from(image.data),
            width: image.width,
            height: image.height,
            type: image.data.constructor.name
        };
        else {
            console.warn('THREE.Texture: Unable to serialize Texture.');
            return {};
        }
    }
}
var $1a55656020b89c3a$var$_textureId = 0;
var $1a55656020b89c3a$export$5431306cf43de24a = /*#__PURE__*/ function(EventDispatcher) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(Texture, EventDispatcher);
    function Texture() {
        var image = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Texture.DEFAULT_IMAGE, mapping = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Texture.DEFAULT_MAPPING, wrapS = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $1a55656020b89c3a$export$9d9334239a5a5e06, wrapT = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $1a55656020b89c3a$export$9d9334239a5a5e06, magFilter = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : $1a55656020b89c3a$export$8a72f490b25c56c8, minFilter = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : $1a55656020b89c3a$export$5d8599b6a933fb1b, format = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : $1a55656020b89c3a$export$3f8bb04b555a363c, type = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : $1a55656020b89c3a$export$2e8ce08d3f6f5e10, anisotropy = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : Texture.DEFAULT_ANISOTROPY, colorSpace = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : $1a55656020b89c3a$export$bfcb490c2dd3db51;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Texture);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, Texture);
        _this.isTexture = true;
        Object.defineProperty(_this, 'id', {
            value: $1a55656020b89c3a$var$_textureId++
        });
        _this.uuid = $1a55656020b89c3a$var$generateUUID();
        _this.name = '';
        _this.source = new $1a55656020b89c3a$export$1d2df86270c81ecb(image);
        _this.mipmaps = [];
        _this.mapping = mapping;
        _this.channel = 0;
        _this.wrapS = wrapS;
        _this.wrapT = wrapT;
        _this.magFilter = magFilter;
        _this.minFilter = minFilter;
        _this.anisotropy = anisotropy;
        _this.format = format;
        _this.internalFormat = null;
        _this.type = type;
        _this.offset = new $1a55656020b89c3a$export$c977b3e384af9ae1(0, 0);
        _this.repeat = new $1a55656020b89c3a$export$c977b3e384af9ae1(1, 1);
        _this.center = new $1a55656020b89c3a$export$c977b3e384af9ae1(0, 0);
        _this.rotation = 0;
        _this.matrixAutoUpdate = true;
        _this.matrix = new $1a55656020b89c3a$export$8ff26dafa08918();
        _this.generateMipmaps = true;
        _this.premultiplyAlpha = false;
        _this.flipY = true;
        _this.unpackAlignment = 4; // valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)
        _this.colorSpace = colorSpace;
        _this.userData = {};
        _this.version = 0;
        _this.onUpdate = null;
        _this.renderTarget = null; // assign texture to a render target
        _this.isRenderTargetTexture = false; // indicates whether a texture belongs to a render target or not
        _this.pmremVersion = 0; // indicates whether this texture should be processed by PMREMGenerator or not (only relevant for render target textures)
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Texture, [
        {
            key: "image",
            get: function get() {
                return this.source.data;
            },
            set: function set() {
                var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                this.source.data = value;
            }
        },
        {
            key: "updateMatrix",
            value: function updateMatrix() {
                this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                this.name = source.name;
                this.source = source.source;
                this.mipmaps = source.mipmaps.slice(0);
                this.mapping = source.mapping;
                this.channel = source.channel;
                this.wrapS = source.wrapS;
                this.wrapT = source.wrapT;
                this.magFilter = source.magFilter;
                this.minFilter = source.minFilter;
                this.anisotropy = source.anisotropy;
                this.format = source.format;
                this.internalFormat = source.internalFormat;
                this.type = source.type;
                this.offset.copy(source.offset);
                this.repeat.copy(source.repeat);
                this.center.copy(source.center);
                this.rotation = source.rotation;
                this.matrixAutoUpdate = source.matrixAutoUpdate;
                this.matrix.copy(source.matrix);
                this.generateMipmaps = source.generateMipmaps;
                this.premultiplyAlpha = source.premultiplyAlpha;
                this.flipY = source.flipY;
                this.unpackAlignment = source.unpackAlignment;
                this.colorSpace = source.colorSpace;
                this.renderTarget = source.renderTarget;
                this.isRenderTargetTexture = source.isRenderTargetTexture;
                this.userData = JSON.parse(JSON.stringify(source.userData));
                this.needsUpdate = true;
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON(meta) {
                var isRootObject = meta === undefined || typeof meta === 'string';
                if (!isRootObject && meta.textures[this.uuid] !== undefined) return meta.textures[this.uuid];
                var output = {
                    metadata: {
                        version: 4.6,
                        type: 'Texture',
                        generator: 'Texture.toJSON'
                    },
                    uuid: this.uuid,
                    name: this.name,
                    image: this.source.toJSON(meta).uuid,
                    mapping: this.mapping,
                    channel: this.channel,
                    repeat: [
                        this.repeat.x,
                        this.repeat.y
                    ],
                    offset: [
                        this.offset.x,
                        this.offset.y
                    ],
                    center: [
                        this.center.x,
                        this.center.y
                    ],
                    rotation: this.rotation,
                    wrap: [
                        this.wrapS,
                        this.wrapT
                    ],
                    format: this.format,
                    internalFormat: this.internalFormat,
                    type: this.type,
                    colorSpace: this.colorSpace,
                    minFilter: this.minFilter,
                    magFilter: this.magFilter,
                    anisotropy: this.anisotropy,
                    flipY: this.flipY,
                    generateMipmaps: this.generateMipmaps,
                    premultiplyAlpha: this.premultiplyAlpha,
                    unpackAlignment: this.unpackAlignment
                };
                if (Object.keys(this.userData).length > 0) output.userData = this.userData;
                if (!isRootObject) meta.textures[this.uuid] = output;
                return output;
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this.dispatchEvent({
                    type: 'dispose'
                });
            }
        },
        {
            key: "transformUv",
            value: function transformUv(uv) {
                if (this.mapping !== $1a55656020b89c3a$export$1beec6768cbb3d2d) return uv;
                uv.applyMatrix3(this.matrix);
                if (uv.x < 0 || uv.x > 1) switch(this.wrapS){
                    case $1a55656020b89c3a$export$533346c8e8dac0f5:
                        uv.x = uv.x - Math.floor(uv.x);
                        break;
                    case $1a55656020b89c3a$export$9d9334239a5a5e06:
                        uv.x = uv.x < 0 ? 0 : 1;
                        break;
                    case $1a55656020b89c3a$export$c7e7c00b14f51a4f:
                        if (Math.abs(Math.floor(uv.x) % 2) === 1) uv.x = Math.ceil(uv.x) - uv.x;
                        else uv.x = uv.x - Math.floor(uv.x);
                        break;
                }
                if (uv.y < 0 || uv.y > 1) switch(this.wrapT){
                    case $1a55656020b89c3a$export$533346c8e8dac0f5:
                        uv.y = uv.y - Math.floor(uv.y);
                        break;
                    case $1a55656020b89c3a$export$9d9334239a5a5e06:
                        uv.y = uv.y < 0 ? 0 : 1;
                        break;
                    case $1a55656020b89c3a$export$c7e7c00b14f51a4f:
                        if (Math.abs(Math.floor(uv.y) % 2) === 1) uv.y = Math.ceil(uv.y) - uv.y;
                        else uv.y = uv.y - Math.floor(uv.y);
                        break;
                }
                if (this.flipY) uv.y = 1 - uv.y;
                return uv;
            }
        },
        {
            key: "needsUpdate",
            set: function set(value) {
                if (value === true) {
                    this.version++;
                    this.source.needsUpdate = true;
                }
            }
        },
        {
            key: "needsPMREMUpdate",
            set: function set(value) {
                if (value === true) this.pmremVersion++;
            }
        }
    ]);
    return Texture;
}($1a55656020b89c3a$export$ec8b666c5fe2c75a);
$1a55656020b89c3a$export$5431306cf43de24a.DEFAULT_IMAGE = null;
$1a55656020b89c3a$export$5431306cf43de24a.DEFAULT_MAPPING = $1a55656020b89c3a$export$1beec6768cbb3d2d;
$1a55656020b89c3a$export$5431306cf43de24a.DEFAULT_ANISOTROPY = 1;
var $1a55656020b89c3a$export$fa7daccca11cdbe3 = /*#__PURE__*/ function() {
    "use strict";
    function Vector4() {
        var x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, z = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, w = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Vector4);
        Vector4.prototype.isVector4 = true;
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Vector4, [
        {
            key: "width",
            get: function get() {
                return this.z;
            },
            set: function set(value) {
                this.z = value;
            }
        },
        {
            key: "height",
            get: function get() {
                return this.w;
            },
            set: function set(value) {
                this.w = value;
            }
        },
        {
            key: "set",
            value: function set(x, y, z, w) {
                this.x = x;
                this.y = y;
                this.z = z;
                this.w = w;
                return this;
            }
        },
        {
            key: "setScalar",
            value: function setScalar(scalar) {
                this.x = scalar;
                this.y = scalar;
                this.z = scalar;
                this.w = scalar;
                return this;
            }
        },
        {
            key: "setX",
            value: function setX(x) {
                this.x = x;
                return this;
            }
        },
        {
            key: "setY",
            value: function setY(y) {
                this.y = y;
                return this;
            }
        },
        {
            key: "setZ",
            value: function setZ(z) {
                this.z = z;
                return this;
            }
        },
        {
            key: "setW",
            value: function setW(w) {
                this.w = w;
                return this;
            }
        },
        {
            key: "setComponent",
            value: function setComponent(index, value) {
                switch(index){
                    case 0:
                        this.x = value;
                        break;
                    case 1:
                        this.y = value;
                        break;
                    case 2:
                        this.z = value;
                        break;
                    case 3:
                        this.w = value;
                        break;
                    default:
                        throw new Error('index is out of range: ' + index);
                }
                return this;
            }
        },
        {
            key: "getComponent",
            value: function getComponent(index) {
                switch(index){
                    case 0:
                        return this.x;
                    case 1:
                        return this.y;
                    case 2:
                        return this.z;
                    case 3:
                        return this.w;
                    default:
                        throw new Error('index is out of range: ' + index);
                }
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor(this.x, this.y, this.z, this.w);
            }
        },
        {
            key: "copy",
            value: function copy(v) {
                this.x = v.x;
                this.y = v.y;
                this.z = v.z;
                this.w = v.w !== undefined ? v.w : 1;
                return this;
            }
        },
        {
            key: "add",
            value: function add(v) {
                this.x += v.x;
                this.y += v.y;
                this.z += v.z;
                this.w += v.w;
                return this;
            }
        },
        {
            key: "addScalar",
            value: function addScalar(s) {
                this.x += s;
                this.y += s;
                this.z += s;
                this.w += s;
                return this;
            }
        },
        {
            key: "addVectors",
            value: function addVectors(a, b) {
                this.x = a.x + b.x;
                this.y = a.y + b.y;
                this.z = a.z + b.z;
                this.w = a.w + b.w;
                return this;
            }
        },
        {
            key: "addScaledVector",
            value: function addScaledVector(v, s) {
                this.x += v.x * s;
                this.y += v.y * s;
                this.z += v.z * s;
                this.w += v.w * s;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(v) {
                this.x -= v.x;
                this.y -= v.y;
                this.z -= v.z;
                this.w -= v.w;
                return this;
            }
        },
        {
            key: "subScalar",
            value: function subScalar(s) {
                this.x -= s;
                this.y -= s;
                this.z -= s;
                this.w -= s;
                return this;
            }
        },
        {
            key: "subVectors",
            value: function subVectors(a, b) {
                this.x = a.x - b.x;
                this.y = a.y - b.y;
                this.z = a.z - b.z;
                this.w = a.w - b.w;
                return this;
            }
        },
        {
            key: "multiply",
            value: function multiply(v) {
                this.x *= v.x;
                this.y *= v.y;
                this.z *= v.z;
                this.w *= v.w;
                return this;
            }
        },
        {
            key: "multiplyScalar",
            value: function multiplyScalar(scalar) {
                this.x *= scalar;
                this.y *= scalar;
                this.z *= scalar;
                this.w *= scalar;
                return this;
            }
        },
        {
            key: "applyMatrix4",
            value: function applyMatrix4(m) {
                var x = this.x, y = this.y, z = this.z, w = this.w;
                var e = m.elements;
                this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
                this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
                this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
                this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;
                return this;
            }
        },
        {
            key: "divide",
            value: function divide(v) {
                this.x /= v.x;
                this.y /= v.y;
                this.z /= v.z;
                this.w /= v.w;
                return this;
            }
        },
        {
            key: "divideScalar",
            value: function divideScalar(scalar) {
                return this.multiplyScalar(1 / scalar);
            }
        },
        {
            key: "setAxisAngleFromQuaternion",
            value: function setAxisAngleFromQuaternion(q) {
                // http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm
                // q is assumed to be normalized
                this.w = 2 * Math.acos(q.w);
                var s = Math.sqrt(1 - q.w * q.w);
                if (s < 0.0001) {
                    this.x = 1;
                    this.y = 0;
                    this.z = 0;
                } else {
                    this.x = q.x / s;
                    this.y = q.y / s;
                    this.z = q.z / s;
                }
                return this;
            }
        },
        {
            key: "setAxisAngleFromRotationMatrix",
            value: function setAxisAngleFromRotationMatrix(m) {
                // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm
                // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
                var angle, x, y, z; // variables for result
                var epsilon = 0.01, epsilon2 = 0.1, te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10];
                if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
                    // singularity found
                    // first check for identity matrix which must have +1 for all terms
                    // in leading diagonal and zero in other terms
                    if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
                        // this singularity is identity matrix so angle = 0
                        this.set(1, 0, 0, 0);
                        return this; // zero angle, arbitrary axis
                    }
                    // otherwise this singularity is angle = 180
                    angle = Math.PI;
                    var xx = (m11 + 1) / 2;
                    var yy = (m22 + 1) / 2;
                    var zz = (m33 + 1) / 2;
                    var xy = (m12 + m21) / 4;
                    var xz = (m13 + m31) / 4;
                    var yz = (m23 + m32) / 4;
                    if (xx > yy && xx > zz) {
                        // m11 is the largest diagonal term
                        if (xx < epsilon) {
                            x = 0;
                            y = 0.707106781;
                            z = 0.707106781;
                        } else {
                            x = Math.sqrt(xx);
                            y = xy / x;
                            z = xz / x;
                        }
                    } else if (yy > zz) {
                        // m22 is the largest diagonal term
                        if (yy < epsilon) {
                            x = 0.707106781;
                            y = 0;
                            z = 0.707106781;
                        } else {
                            y = Math.sqrt(yy);
                            x = xy / y;
                            z = yz / y;
                        }
                    } else // m33 is the largest diagonal term so base result on this
                    if (zz < epsilon) {
                        x = 0.707106781;
                        y = 0.707106781;
                        z = 0;
                    } else {
                        z = Math.sqrt(zz);
                        x = xz / z;
                        y = yz / z;
                    }
                    this.set(x, y, z, angle);
                    return this; // return 180 deg rotation
                }
                // as we have reached here there are no singularities so we can handle normally
                var s = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12)); // used to normalize
                if (Math.abs(s) < 0.001) s = 1;
                // prevent divide by zero, should not happen if matrix is orthogonal and should be
                // caught by singularity test above, but I've left it in just in case
                this.x = (m32 - m23) / s;
                this.y = (m13 - m31) / s;
                this.z = (m21 - m12) / s;
                this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
                return this;
            }
        },
        {
            key: "setFromMatrixPosition",
            value: function setFromMatrixPosition(m) {
                var e = m.elements;
                this.x = e[12];
                this.y = e[13];
                this.z = e[14];
                this.w = e[15];
                return this;
            }
        },
        {
            key: "min",
            value: function min(v) {
                this.x = Math.min(this.x, v.x);
                this.y = Math.min(this.y, v.y);
                this.z = Math.min(this.z, v.z);
                this.w = Math.min(this.w, v.w);
                return this;
            }
        },
        {
            key: "max",
            value: function max(v) {
                this.x = Math.max(this.x, v.x);
                this.y = Math.max(this.y, v.y);
                this.z = Math.max(this.z, v.z);
                this.w = Math.max(this.w, v.w);
                return this;
            }
        },
        {
            key: "clamp",
            value: function clamp1(min, max) {
                // assumes min < max, componentwise
                this.x = $1a55656020b89c3a$var$clamp(this.x, min.x, max.x);
                this.y = $1a55656020b89c3a$var$clamp(this.y, min.y, max.y);
                this.z = $1a55656020b89c3a$var$clamp(this.z, min.z, max.z);
                this.w = $1a55656020b89c3a$var$clamp(this.w, min.w, max.w);
                return this;
            }
        },
        {
            key: "clampScalar",
            value: function clampScalar(minVal, maxVal) {
                this.x = $1a55656020b89c3a$var$clamp(this.x, minVal, maxVal);
                this.y = $1a55656020b89c3a$var$clamp(this.y, minVal, maxVal);
                this.z = $1a55656020b89c3a$var$clamp(this.z, minVal, maxVal);
                this.w = $1a55656020b89c3a$var$clamp(this.w, minVal, maxVal);
                return this;
            }
        },
        {
            key: "clampLength",
            value: function clampLength(min, max) {
                var length = this.length();
                return this.divideScalar(length || 1).multiplyScalar($1a55656020b89c3a$var$clamp(length, min, max));
            }
        },
        {
            key: "floor",
            value: function floor() {
                this.x = Math.floor(this.x);
                this.y = Math.floor(this.y);
                this.z = Math.floor(this.z);
                this.w = Math.floor(this.w);
                return this;
            }
        },
        {
            key: "ceil",
            value: function ceil() {
                this.x = Math.ceil(this.x);
                this.y = Math.ceil(this.y);
                this.z = Math.ceil(this.z);
                this.w = Math.ceil(this.w);
                return this;
            }
        },
        {
            key: "round",
            value: function round() {
                this.x = Math.round(this.x);
                this.y = Math.round(this.y);
                this.z = Math.round(this.z);
                this.w = Math.round(this.w);
                return this;
            }
        },
        {
            key: "roundToZero",
            value: function roundToZero() {
                this.x = Math.trunc(this.x);
                this.y = Math.trunc(this.y);
                this.z = Math.trunc(this.z);
                this.w = Math.trunc(this.w);
                return this;
            }
        },
        {
            key: "negate",
            value: function negate() {
                this.x = -this.x;
                this.y = -this.y;
                this.z = -this.z;
                this.w = -this.w;
                return this;
            }
        },
        {
            key: "dot",
            value: function dot(v) {
                return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
            }
        },
        {
            key: "lengthSq",
            value: function lengthSq() {
                return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
            }
        },
        {
            key: "length",
            value: function length() {
                return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
            }
        },
        {
            key: "manhattanLength",
            value: function manhattanLength() {
                return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
            }
        },
        {
            key: "normalize",
            value: function normalize() {
                return this.divideScalar(this.length() || 1);
            }
        },
        {
            key: "setLength",
            value: function setLength(length) {
                return this.normalize().multiplyScalar(length);
            }
        },
        {
            key: "lerp",
            value: function lerp(v, alpha) {
                this.x += (v.x - this.x) * alpha;
                this.y += (v.y - this.y) * alpha;
                this.z += (v.z - this.z) * alpha;
                this.w += (v.w - this.w) * alpha;
                return this;
            }
        },
        {
            key: "lerpVectors",
            value: function lerpVectors(v1, v2, alpha) {
                this.x = v1.x + (v2.x - v1.x) * alpha;
                this.y = v1.y + (v2.y - v1.y) * alpha;
                this.z = v1.z + (v2.z - v1.z) * alpha;
                this.w = v1.w + (v2.w - v1.w) * alpha;
                return this;
            }
        },
        {
            key: "equals",
            value: function equals(v) {
                return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
            }
        },
        {
            key: "fromArray",
            value: function fromArray(array) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                this.x = array[offset];
                this.y = array[offset + 1];
                this.z = array[offset + 2];
                this.w = array[offset + 3];
                return this;
            }
        },
        {
            key: "toArray",
            value: function toArray() {
                var array = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                array[offset] = this.x;
                array[offset + 1] = this.y;
                array[offset + 2] = this.z;
                array[offset + 3] = this.w;
                return array;
            }
        },
        {
            key: "fromBufferAttribute",
            value: function fromBufferAttribute(attribute, index) {
                this.x = attribute.getX(index);
                this.y = attribute.getY(index);
                this.z = attribute.getZ(index);
                this.w = attribute.getW(index);
                return this;
            }
        },
        {
            key: "random",
            value: function random() {
                this.x = Math.random();
                this.y = Math.random();
                this.z = Math.random();
                this.w = Math.random();
                return this;
            }
        },
        {
            key: Symbol.iterator,
            value: function value() {
                return (0, $353b713f9392bb93$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                this.x
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                this.y
                            ];
                        case 2:
                            _state.sent();
                            return [
                                4,
                                this.z
                            ];
                        case 3:
                            _state.sent();
                            return [
                                4,
                                this.w
                            ];
                        case 4:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }
        }
    ]);
    return Vector4;
}();
/*
 In options, we can specify:
 * Texture parameters for an auto-generated target texture
 * depthBuffer/stencilBuffer: Booleans to indicate if we should generate these buffers
*/ var $1a55656020b89c3a$export$efcb1f8bf367cbfb = /*#__PURE__*/ function(EventDispatcher) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(RenderTarget, EventDispatcher);
    function RenderTarget() {
        var width = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, height = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, RenderTarget);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, RenderTarget);
        _this.isRenderTarget = true;
        _this.width = width;
        _this.height = height;
        _this.depth = 1;
        _this.scissor = new $1a55656020b89c3a$export$fa7daccca11cdbe3(0, 0, width, height);
        _this.scissorTest = false;
        _this.viewport = new $1a55656020b89c3a$export$fa7daccca11cdbe3(0, 0, width, height);
        var image = {
            width: width,
            height: height,
            depth: 1
        };
        options = Object.assign({
            generateMipmaps: false,
            internalFormat: null,
            minFilter: $1a55656020b89c3a$export$8a72f490b25c56c8,
            depthBuffer: true,
            stencilBuffer: false,
            resolveDepthBuffer: true,
            resolveStencilBuffer: true,
            depthTexture: null,
            samples: 0,
            count: 1
        }, options);
        var texture = new $1a55656020b89c3a$export$5431306cf43de24a(image, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace);
        texture.flipY = false;
        texture.generateMipmaps = options.generateMipmaps;
        texture.internalFormat = options.internalFormat;
        _this.textures = [];
        var count = options.count;
        for(var i = 0; i < count; i++){
            _this.textures[i] = texture.clone();
            _this.textures[i].isRenderTargetTexture = true;
            _this.textures[i].renderTarget = _this;
        }
        _this.depthBuffer = options.depthBuffer;
        _this.stencilBuffer = options.stencilBuffer;
        _this.resolveDepthBuffer = options.resolveDepthBuffer;
        _this.resolveStencilBuffer = options.resolveStencilBuffer;
        _this._depthTexture = null;
        _this.depthTexture = options.depthTexture;
        _this.samples = options.samples;
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(RenderTarget, [
        {
            key: "texture",
            get: function get() {
                return this.textures[0];
            },
            set: function set(value) {
                this.textures[0] = value;
            }
        },
        {
            key: "depthTexture",
            get: function get() {
                return this._depthTexture;
            },
            set: function set(current) {
                if (this._depthTexture !== null) this._depthTexture.renderTarget = null;
                if (current !== null) current.renderTarget = this;
                this._depthTexture = current;
            }
        },
        {
            key: "setSize",
            value: function setSize(width, height) {
                var depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
                if (this.width !== width || this.height !== height || this.depth !== depth) {
                    this.width = width;
                    this.height = height;
                    this.depth = depth;
                    for(var i = 0, il = this.textures.length; i < il; i++){
                        this.textures[i].image.width = width;
                        this.textures[i].image.height = height;
                        this.textures[i].image.depth = depth;
                    }
                    this.dispose();
                }
                this.viewport.set(0, 0, width, height);
                this.scissor.set(0, 0, width, height);
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                this.width = source.width;
                this.height = source.height;
                this.depth = source.depth;
                this.scissor.copy(source.scissor);
                this.scissorTest = source.scissorTest;
                this.viewport.copy(source.viewport);
                this.textures.length = 0;
                for(var i = 0, il = source.textures.length; i < il; i++){
                    this.textures[i] = source.textures[i].clone();
                    this.textures[i].isRenderTargetTexture = true;
                    this.textures[i].renderTarget = this;
                }
                // ensure image object is not shared, see #20328
                var image = Object.assign({}, source.texture.image);
                this.texture.source = new $1a55656020b89c3a$export$1d2df86270c81ecb(image);
                this.depthBuffer = source.depthBuffer;
                this.stencilBuffer = source.stencilBuffer;
                this.resolveDepthBuffer = source.resolveDepthBuffer;
                this.resolveStencilBuffer = source.resolveStencilBuffer;
                if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
                this.samples = source.samples;
                return this;
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this.dispatchEvent({
                    type: 'dispose'
                });
            }
        }
    ]);
    return RenderTarget;
}($1a55656020b89c3a$export$ec8b666c5fe2c75a);
var $1a55656020b89c3a$export$3c052beb2e51e23f = /*#__PURE__*/ function(RenderTarget) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(WebGLRenderTarget, RenderTarget);
    function WebGLRenderTarget() {
        var width = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, height = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, WebGLRenderTarget);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, WebGLRenderTarget, [
            width,
            height,
            options
        ]);
        _this.isWebGLRenderTarget = true;
        return _this;
    }
    return WebGLRenderTarget;
}($1a55656020b89c3a$export$efcb1f8bf367cbfb);
var $1a55656020b89c3a$export$dfac6c8e811406a3 = /*#__PURE__*/ function(Texture) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(DataArrayTexture, Texture);
    function DataArrayTexture() {
        var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, width = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, height = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, depth = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, DataArrayTexture);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, DataArrayTexture, [
            null
        ]);
        _this.isDataArrayTexture = true;
        _this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        _this.magFilter = $1a55656020b89c3a$export$727aa5ec3fe39bf0;
        _this.minFilter = $1a55656020b89c3a$export$727aa5ec3fe39bf0;
        _this.wrapR = $1a55656020b89c3a$export$9d9334239a5a5e06;
        _this.generateMipmaps = false;
        _this.flipY = false;
        _this.unpackAlignment = 1;
        _this.layerUpdates = new Set();
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(DataArrayTexture, [
        {
            key: "addLayerUpdate",
            value: function addLayerUpdate(layerIndex) {
                this.layerUpdates.add(layerIndex);
            }
        },
        {
            key: "clearLayerUpdates",
            value: function clearLayerUpdates() {
                this.layerUpdates.clear();
            }
        }
    ]);
    return DataArrayTexture;
}($1a55656020b89c3a$export$5431306cf43de24a);
var $1a55656020b89c3a$export$c77a02c11ed180c7 = /*#__PURE__*/ function(WebGLRenderTarget) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(WebGLArrayRenderTarget, WebGLRenderTarget);
    function WebGLArrayRenderTarget() {
        var width = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, height = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, WebGLArrayRenderTarget);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, WebGLArrayRenderTarget, [
            width,
            height,
            options
        ]);
        _this.isWebGLArrayRenderTarget = true;
        _this.depth = depth;
        _this.texture = new $1a55656020b89c3a$export$dfac6c8e811406a3(null, width, height, depth);
        _this.texture.isRenderTargetTexture = true;
        return _this;
    }
    return WebGLArrayRenderTarget;
}($1a55656020b89c3a$export$3c052beb2e51e23f);
var $1a55656020b89c3a$export$d7a3086320f856db = /*#__PURE__*/ function(Texture) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(Data3DTexture, Texture);
    function Data3DTexture() {
        var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, width = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, height = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, depth = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Data3DTexture);
        var _this;
        // We're going to add .setXXX() methods for setting properties later.
        // Users can still set in Data3DTexture directly.
        //
        //	const texture = new THREE.Data3DTexture( data, width, height, depth );
        // 	texture.anisotropy = 16;
        //
        // See #14839
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, Data3DTexture, [
            null
        ]);
        _this.isData3DTexture = true;
        _this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        _this.magFilter = $1a55656020b89c3a$export$727aa5ec3fe39bf0;
        _this.minFilter = $1a55656020b89c3a$export$727aa5ec3fe39bf0;
        _this.wrapR = $1a55656020b89c3a$export$9d9334239a5a5e06;
        _this.generateMipmaps = false;
        _this.flipY = false;
        _this.unpackAlignment = 1;
        return _this;
    }
    return Data3DTexture;
}($1a55656020b89c3a$export$5431306cf43de24a);
var $1a55656020b89c3a$export$7ee06591009639df = /*#__PURE__*/ function(WebGLRenderTarget) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(WebGL3DRenderTarget, WebGLRenderTarget);
    function WebGL3DRenderTarget() {
        var width = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, height = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, WebGL3DRenderTarget);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, WebGL3DRenderTarget, [
            width,
            height,
            options
        ]);
        _this.isWebGL3DRenderTarget = true;
        _this.depth = depth;
        _this.texture = new $1a55656020b89c3a$export$d7a3086320f856db(null, width, height, depth);
        _this.texture.isRenderTargetTexture = true;
        return _this;
    }
    return WebGL3DRenderTarget;
}($1a55656020b89c3a$export$3c052beb2e51e23f);
var $1a55656020b89c3a$export$23d6a54f0bbc85a3 = /*#__PURE__*/ function() {
    "use strict";
    function Quaternion() {
        var x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, z = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, w = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Quaternion);
        this.isQuaternion = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Quaternion, [
        {
            key: "x",
            get: function get() {
                return this._x;
            },
            set: function set(value) {
                this._x = value;
                this._onChangeCallback();
            }
        },
        {
            key: "y",
            get: function get() {
                return this._y;
            },
            set: function set(value) {
                this._y = value;
                this._onChangeCallback();
            }
        },
        {
            key: "z",
            get: function get() {
                return this._z;
            },
            set: function set(value) {
                this._z = value;
                this._onChangeCallback();
            }
        },
        {
            key: "w",
            get: function get() {
                return this._w;
            },
            set: function set(value) {
                this._w = value;
                this._onChangeCallback();
            }
        },
        {
            key: "set",
            value: function set(x, y, z, w) {
                this._x = x;
                this._y = y;
                this._z = z;
                this._w = w;
                this._onChangeCallback();
                return this;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor(this._x, this._y, this._z, this._w);
            }
        },
        {
            key: "copy",
            value: function copy(quaternion) {
                this._x = quaternion.x;
                this._y = quaternion.y;
                this._z = quaternion.z;
                this._w = quaternion.w;
                this._onChangeCallback();
                return this;
            }
        },
        {
            key: "setFromEuler",
            value: function setFromEuler(euler) {
                var update = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                var x = euler._x, y = euler._y, z = euler._z, order = euler._order;
                // http://www.mathworks.com/matlabcentral/fileexchange/
                // 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
                //	content/SpinCalc.m
                var cos = Math.cos;
                var sin = Math.sin;
                var c1 = cos(x / 2);
                var c2 = cos(y / 2);
                var c3 = cos(z / 2);
                var s1 = sin(x / 2);
                var s2 = sin(y / 2);
                var s3 = sin(z / 2);
                switch(order){
                    case 'XYZ':
                        this._x = s1 * c2 * c3 + c1 * s2 * s3;
                        this._y = c1 * s2 * c3 - s1 * c2 * s3;
                        this._z = c1 * c2 * s3 + s1 * s2 * c3;
                        this._w = c1 * c2 * c3 - s1 * s2 * s3;
                        break;
                    case 'YXZ':
                        this._x = s1 * c2 * c3 + c1 * s2 * s3;
                        this._y = c1 * s2 * c3 - s1 * c2 * s3;
                        this._z = c1 * c2 * s3 - s1 * s2 * c3;
                        this._w = c1 * c2 * c3 + s1 * s2 * s3;
                        break;
                    case 'ZXY':
                        this._x = s1 * c2 * c3 - c1 * s2 * s3;
                        this._y = c1 * s2 * c3 + s1 * c2 * s3;
                        this._z = c1 * c2 * s3 + s1 * s2 * c3;
                        this._w = c1 * c2 * c3 - s1 * s2 * s3;
                        break;
                    case 'ZYX':
                        this._x = s1 * c2 * c3 - c1 * s2 * s3;
                        this._y = c1 * s2 * c3 + s1 * c2 * s3;
                        this._z = c1 * c2 * s3 - s1 * s2 * c3;
                        this._w = c1 * c2 * c3 + s1 * s2 * s3;
                        break;
                    case 'YZX':
                        this._x = s1 * c2 * c3 + c1 * s2 * s3;
                        this._y = c1 * s2 * c3 + s1 * c2 * s3;
                        this._z = c1 * c2 * s3 - s1 * s2 * c3;
                        this._w = c1 * c2 * c3 - s1 * s2 * s3;
                        break;
                    case 'XZY':
                        this._x = s1 * c2 * c3 - c1 * s2 * s3;
                        this._y = c1 * s2 * c3 - s1 * c2 * s3;
                        this._z = c1 * c2 * s3 + s1 * s2 * c3;
                        this._w = c1 * c2 * c3 + s1 * s2 * s3;
                        break;
                    default:
                        console.warn('THREE.Quaternion: .setFromEuler() encountered an unknown order: ' + order);
                }
                if (update === true) this._onChangeCallback();
                return this;
            }
        },
        {
            key: "setFromAxisAngle",
            value: function setFromAxisAngle(axis, angle) {
                // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
                // assumes axis is normalized
                var halfAngle = angle / 2, s = Math.sin(halfAngle);
                this._x = axis.x * s;
                this._y = axis.y * s;
                this._z = axis.z * s;
                this._w = Math.cos(halfAngle);
                this._onChangeCallback();
                return this;
            }
        },
        {
            key: "setFromRotationMatrix",
            value: function setFromRotationMatrix(m) {
                // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
                // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
                var te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33;
                if (trace > 0) {
                    var s = 0.5 / Math.sqrt(trace + 1.0);
                    this._w = 0.25 / s;
                    this._x = (m32 - m23) * s;
                    this._y = (m13 - m31) * s;
                    this._z = (m21 - m12) * s;
                } else if (m11 > m22 && m11 > m33) {
                    var s1 = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
                    this._w = (m32 - m23) / s1;
                    this._x = 0.25 * s1;
                    this._y = (m12 + m21) / s1;
                    this._z = (m13 + m31) / s1;
                } else if (m22 > m33) {
                    var s2 = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
                    this._w = (m13 - m31) / s2;
                    this._x = (m12 + m21) / s2;
                    this._y = 0.25 * s2;
                    this._z = (m23 + m32) / s2;
                } else {
                    var s3 = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
                    this._w = (m21 - m12) / s3;
                    this._x = (m13 + m31) / s3;
                    this._y = (m23 + m32) / s3;
                    this._z = 0.25 * s3;
                }
                this._onChangeCallback();
                return this;
            }
        },
        {
            key: "setFromUnitVectors",
            value: function setFromUnitVectors(vFrom, vTo) {
                // assumes direction vectors vFrom and vTo are normalized
                var r = vFrom.dot(vTo) + 1;
                if (r < Number.EPSILON) {
                    // vFrom and vTo point in opposite directions
                    r = 0;
                    if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
                        this._x = -vFrom.y;
                        this._y = vFrom.x;
                        this._z = 0;
                        this._w = r;
                    } else {
                        this._x = 0;
                        this._y = -vFrom.z;
                        this._z = vFrom.y;
                        this._w = r;
                    }
                } else {
                    // crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3
                    this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
                    this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
                    this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
                    this._w = r;
                }
                return this.normalize();
            }
        },
        {
            key: "angleTo",
            value: function angleTo(q) {
                return 2 * Math.acos(Math.abs($1a55656020b89c3a$var$clamp(this.dot(q), -1, 1)));
            }
        },
        {
            key: "rotateTowards",
            value: function rotateTowards(q, step) {
                var angle = this.angleTo(q);
                if (angle === 0) return this;
                var t = Math.min(1, step / angle);
                this.slerp(q, t);
                return this;
            }
        },
        {
            key: "identity",
            value: function identity() {
                return this.set(0, 0, 0, 1);
            }
        },
        {
            key: "invert",
            value: function invert() {
                // quaternion is assumed to have unit length
                return this.conjugate();
            }
        },
        {
            key: "conjugate",
            value: function conjugate() {
                this._x *= -1;
                this._y *= -1;
                this._z *= -1;
                this._onChangeCallback();
                return this;
            }
        },
        {
            key: "dot",
            value: function dot(v) {
                return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
            }
        },
        {
            key: "lengthSq",
            value: function lengthSq() {
                return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
            }
        },
        {
            key: "length",
            value: function length() {
                return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
            }
        },
        {
            key: "normalize",
            value: function normalize() {
                var l = this.length();
                if (l === 0) {
                    this._x = 0;
                    this._y = 0;
                    this._z = 0;
                    this._w = 1;
                } else {
                    l = 1 / l;
                    this._x = this._x * l;
                    this._y = this._y * l;
                    this._z = this._z * l;
                    this._w = this._w * l;
                }
                this._onChangeCallback();
                return this;
            }
        },
        {
            key: "multiply",
            value: function multiply(q) {
                return this.multiplyQuaternions(this, q);
            }
        },
        {
            key: "premultiply",
            value: function premultiply(q) {
                return this.multiplyQuaternions(q, this);
            }
        },
        {
            key: "multiplyQuaternions",
            value: function multiplyQuaternions(a, b) {
                // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
                var qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
                var qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
                this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
                this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
                this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
                this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
                this._onChangeCallback();
                return this;
            }
        },
        {
            key: "slerp",
            value: function slerp(qb, t) {
                if (t === 0) return this;
                if (t === 1) return this.copy(qb);
                var x = this._x, y = this._y, z = this._z, w = this._w;
                // http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/
                var cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;
                if (cosHalfTheta < 0) {
                    this._w = -qb._w;
                    this._x = -qb._x;
                    this._y = -qb._y;
                    this._z = -qb._z;
                    cosHalfTheta = -cosHalfTheta;
                } else this.copy(qb);
                if (cosHalfTheta >= 1.0) {
                    this._w = w;
                    this._x = x;
                    this._y = y;
                    this._z = z;
                    return this;
                }
                var sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;
                if (sqrSinHalfTheta <= Number.EPSILON) {
                    var s = 1 - t;
                    this._w = s * w + t * this._w;
                    this._x = s * x + t * this._x;
                    this._y = s * y + t * this._y;
                    this._z = s * z + t * this._z;
                    this.normalize(); // normalize calls _onChangeCallback()
                    return this;
                }
                var sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
                var halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
                var ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta, ratioB = Math.sin(t * halfTheta) / sinHalfTheta;
                this._w = w * ratioA + this._w * ratioB;
                this._x = x * ratioA + this._x * ratioB;
                this._y = y * ratioA + this._y * ratioB;
                this._z = z * ratioA + this._z * ratioB;
                this._onChangeCallback();
                return this;
            }
        },
        {
            key: "slerpQuaternions",
            value: function slerpQuaternions(qa, qb, t) {
                return this.copy(qa).slerp(qb, t);
            }
        },
        {
            key: "random",
            value: function random() {
                // sets this quaternion to a uniform random unit quaternnion
                // Ken Shoemake
                // Uniform random rotations
                // D. Kirk, editor, Graphics Gems III, pages 124-132. Academic Press, New York, 1992.
                var theta1 = 2 * Math.PI * Math.random();
                var theta2 = 2 * Math.PI * Math.random();
                var x0 = Math.random();
                var r1 = Math.sqrt(1 - x0);
                var r2 = Math.sqrt(x0);
                return this.set(r1 * Math.sin(theta1), r1 * Math.cos(theta1), r2 * Math.sin(theta2), r2 * Math.cos(theta2));
            }
        },
        {
            key: "equals",
            value: function equals(quaternion) {
                return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
            }
        },
        {
            key: "fromArray",
            value: function fromArray(array) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                this._x = array[offset];
                this._y = array[offset + 1];
                this._z = array[offset + 2];
                this._w = array[offset + 3];
                this._onChangeCallback();
                return this;
            }
        },
        {
            key: "toArray",
            value: function toArray() {
                var array = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                array[offset] = this._x;
                array[offset + 1] = this._y;
                array[offset + 2] = this._z;
                array[offset + 3] = this._w;
                return array;
            }
        },
        {
            key: "fromBufferAttribute",
            value: function fromBufferAttribute(attribute, index) {
                this._x = attribute.getX(index);
                this._y = attribute.getY(index);
                this._z = attribute.getZ(index);
                this._w = attribute.getW(index);
                this._onChangeCallback();
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.toArray();
            }
        },
        {
            key: "_onChange",
            value: function _onChange(callback) {
                this._onChangeCallback = callback;
                return this;
            }
        },
        {
            key: "_onChangeCallback",
            value: function _onChangeCallback() {}
        },
        {
            key: Symbol.iterator,
            value: function value() {
                return (0, $353b713f9392bb93$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                this._x
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                this._y
                            ];
                        case 2:
                            _state.sent();
                            return [
                                4,
                                this._z
                            ];
                        case 3:
                            _state.sent();
                            return [
                                4,
                                this._w
                            ];
                        case 4:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }
        }
    ], [
        {
            key: "slerpFlat",
            value: function slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
                // fuzz-free, array-based Quaternion SLERP operation
                var x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
                var x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
                if (t === 0) {
                    dst[dstOffset + 0] = x0;
                    dst[dstOffset + 1] = y0;
                    dst[dstOffset + 2] = z0;
                    dst[dstOffset + 3] = w0;
                    return;
                }
                if (t === 1) {
                    dst[dstOffset + 0] = x1;
                    dst[dstOffset + 1] = y1;
                    dst[dstOffset + 2] = z1;
                    dst[dstOffset + 3] = w1;
                    return;
                }
                if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
                    var s = 1 - t;
                    var cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1, dir = cos >= 0 ? 1 : -1, sqrSin = 1 - cos * cos;
                    // Skip the Slerp for tiny steps to avoid numeric problems:
                    if (sqrSin > Number.EPSILON) {
                        var sin = Math.sqrt(sqrSin), len = Math.atan2(sin, cos * dir);
                        s = Math.sin(s * len) / sin;
                        t = Math.sin(t * len) / sin;
                    }
                    var tDir = t * dir;
                    x0 = x0 * s + x1 * tDir;
                    y0 = y0 * s + y1 * tDir;
                    z0 = z0 * s + z1 * tDir;
                    w0 = w0 * s + w1 * tDir;
                    // Normalize in case we just did a lerp:
                    if (s === 1 - t) {
                        var f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
                        x0 *= f;
                        y0 *= f;
                        z0 *= f;
                        w0 *= f;
                    }
                }
                dst[dstOffset] = x0;
                dst[dstOffset + 1] = y0;
                dst[dstOffset + 2] = z0;
                dst[dstOffset + 3] = w0;
            }
        },
        {
            key: "multiplyQuaternionsFlat",
            value: function multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
                var x0 = src0[srcOffset0];
                var y0 = src0[srcOffset0 + 1];
                var z0 = src0[srcOffset0 + 2];
                var w0 = src0[srcOffset0 + 3];
                var x1 = src1[srcOffset1];
                var y1 = src1[srcOffset1 + 1];
                var z1 = src1[srcOffset1 + 2];
                var w1 = src1[srcOffset1 + 3];
                dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
                dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
                dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
                dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
                return dst;
            }
        }
    ]);
    return Quaternion;
}();
var $1a55656020b89c3a$export$64b5c384219d3699 = /*#__PURE__*/ function() {
    "use strict";
    function Vector3() {
        var x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, z = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Vector3);
        Vector3.prototype.isVector3 = true;
        this.x = x;
        this.y = y;
        this.z = z;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Vector3, [
        {
            key: "set",
            value: function set(x, y, z) {
                if (z === undefined) z = this.z; // sprite.scale.set(x,y)
                this.x = x;
                this.y = y;
                this.z = z;
                return this;
            }
        },
        {
            key: "setScalar",
            value: function setScalar(scalar) {
                this.x = scalar;
                this.y = scalar;
                this.z = scalar;
                return this;
            }
        },
        {
            key: "setX",
            value: function setX(x) {
                this.x = x;
                return this;
            }
        },
        {
            key: "setY",
            value: function setY(y) {
                this.y = y;
                return this;
            }
        },
        {
            key: "setZ",
            value: function setZ(z) {
                this.z = z;
                return this;
            }
        },
        {
            key: "setComponent",
            value: function setComponent(index, value) {
                switch(index){
                    case 0:
                        this.x = value;
                        break;
                    case 1:
                        this.y = value;
                        break;
                    case 2:
                        this.z = value;
                        break;
                    default:
                        throw new Error('index is out of range: ' + index);
                }
                return this;
            }
        },
        {
            key: "getComponent",
            value: function getComponent(index) {
                switch(index){
                    case 0:
                        return this.x;
                    case 1:
                        return this.y;
                    case 2:
                        return this.z;
                    default:
                        throw new Error('index is out of range: ' + index);
                }
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor(this.x, this.y, this.z);
            }
        },
        {
            key: "copy",
            value: function copy(v) {
                this.x = v.x;
                this.y = v.y;
                this.z = v.z;
                return this;
            }
        },
        {
            key: "add",
            value: function add(v) {
                this.x += v.x;
                this.y += v.y;
                this.z += v.z;
                return this;
            }
        },
        {
            key: "addScalar",
            value: function addScalar(s) {
                this.x += s;
                this.y += s;
                this.z += s;
                return this;
            }
        },
        {
            key: "addVectors",
            value: function addVectors(a, b) {
                this.x = a.x + b.x;
                this.y = a.y + b.y;
                this.z = a.z + b.z;
                return this;
            }
        },
        {
            key: "addScaledVector",
            value: function addScaledVector(v, s) {
                this.x += v.x * s;
                this.y += v.y * s;
                this.z += v.z * s;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(v) {
                this.x -= v.x;
                this.y -= v.y;
                this.z -= v.z;
                return this;
            }
        },
        {
            key: "subScalar",
            value: function subScalar(s) {
                this.x -= s;
                this.y -= s;
                this.z -= s;
                return this;
            }
        },
        {
            key: "subVectors",
            value: function subVectors(a, b) {
                this.x = a.x - b.x;
                this.y = a.y - b.y;
                this.z = a.z - b.z;
                return this;
            }
        },
        {
            key: "multiply",
            value: function multiply(v) {
                this.x *= v.x;
                this.y *= v.y;
                this.z *= v.z;
                return this;
            }
        },
        {
            key: "multiplyScalar",
            value: function multiplyScalar(scalar) {
                this.x *= scalar;
                this.y *= scalar;
                this.z *= scalar;
                return this;
            }
        },
        {
            key: "multiplyVectors",
            value: function multiplyVectors(a, b) {
                this.x = a.x * b.x;
                this.y = a.y * b.y;
                this.z = a.z * b.z;
                return this;
            }
        },
        {
            key: "applyEuler",
            value: function applyEuler(euler) {
                return this.applyQuaternion($1a55656020b89c3a$var$_quaternion$4.setFromEuler(euler));
            }
        },
        {
            key: "applyAxisAngle",
            value: function applyAxisAngle(axis, angle) {
                return this.applyQuaternion($1a55656020b89c3a$var$_quaternion$4.setFromAxisAngle(axis, angle));
            }
        },
        {
            key: "applyMatrix3",
            value: function applyMatrix3(m) {
                var x = this.x, y = this.y, z = this.z;
                var e = m.elements;
                this.x = e[0] * x + e[3] * y + e[6] * z;
                this.y = e[1] * x + e[4] * y + e[7] * z;
                this.z = e[2] * x + e[5] * y + e[8] * z;
                return this;
            }
        },
        {
            key: "applyNormalMatrix",
            value: function applyNormalMatrix(m) {
                return this.applyMatrix3(m).normalize();
            }
        },
        {
            key: "applyMatrix4",
            value: function applyMatrix4(m) {
                var x = this.x, y = this.y, z = this.z;
                var e = m.elements;
                var w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
                this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
                this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
                this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
                return this;
            }
        },
        {
            key: "applyQuaternion",
            value: function applyQuaternion(q) {
                // quaternion q is assumed to have unit length
                var vx = this.x, vy = this.y, vz = this.z;
                var qx = q.x, qy = q.y, qz = q.z, qw = q.w;
                // t = 2 * cross( q.xyz, v );
                var tx = 2 * (qy * vz - qz * vy);
                var ty = 2 * (qz * vx - qx * vz);
                var tz = 2 * (qx * vy - qy * vx);
                // v + q.w * t + cross( q.xyz, t );
                this.x = vx + qw * tx + qy * tz - qz * ty;
                this.y = vy + qw * ty + qz * tx - qx * tz;
                this.z = vz + qw * tz + qx * ty - qy * tx;
                return this;
            }
        },
        {
            key: "project",
            value: function project(camera) {
                return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
            }
        },
        {
            key: "unproject",
            value: function unproject(camera) {
                return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
            }
        },
        {
            key: "transformDirection",
            value: function transformDirection(m) {
                // input: THREE.Matrix4 affine matrix
                // vector interpreted as a direction
                var x = this.x, y = this.y, z = this.z;
                var e = m.elements;
                this.x = e[0] * x + e[4] * y + e[8] * z;
                this.y = e[1] * x + e[5] * y + e[9] * z;
                this.z = e[2] * x + e[6] * y + e[10] * z;
                return this.normalize();
            }
        },
        {
            key: "divide",
            value: function divide(v) {
                this.x /= v.x;
                this.y /= v.y;
                this.z /= v.z;
                return this;
            }
        },
        {
            key: "divideScalar",
            value: function divideScalar(scalar) {
                return this.multiplyScalar(1 / scalar);
            }
        },
        {
            key: "min",
            value: function min(v) {
                this.x = Math.min(this.x, v.x);
                this.y = Math.min(this.y, v.y);
                this.z = Math.min(this.z, v.z);
                return this;
            }
        },
        {
            key: "max",
            value: function max(v) {
                this.x = Math.max(this.x, v.x);
                this.y = Math.max(this.y, v.y);
                this.z = Math.max(this.z, v.z);
                return this;
            }
        },
        {
            key: "clamp",
            value: function clamp1(min, max) {
                // assumes min < max, componentwise
                this.x = $1a55656020b89c3a$var$clamp(this.x, min.x, max.x);
                this.y = $1a55656020b89c3a$var$clamp(this.y, min.y, max.y);
                this.z = $1a55656020b89c3a$var$clamp(this.z, min.z, max.z);
                return this;
            }
        },
        {
            key: "clampScalar",
            value: function clampScalar(minVal, maxVal) {
                this.x = $1a55656020b89c3a$var$clamp(this.x, minVal, maxVal);
                this.y = $1a55656020b89c3a$var$clamp(this.y, minVal, maxVal);
                this.z = $1a55656020b89c3a$var$clamp(this.z, minVal, maxVal);
                return this;
            }
        },
        {
            key: "clampLength",
            value: function clampLength(min, max) {
                var length = this.length();
                return this.divideScalar(length || 1).multiplyScalar($1a55656020b89c3a$var$clamp(length, min, max));
            }
        },
        {
            key: "floor",
            value: function floor() {
                this.x = Math.floor(this.x);
                this.y = Math.floor(this.y);
                this.z = Math.floor(this.z);
                return this;
            }
        },
        {
            key: "ceil",
            value: function ceil() {
                this.x = Math.ceil(this.x);
                this.y = Math.ceil(this.y);
                this.z = Math.ceil(this.z);
                return this;
            }
        },
        {
            key: "round",
            value: function round() {
                this.x = Math.round(this.x);
                this.y = Math.round(this.y);
                this.z = Math.round(this.z);
                return this;
            }
        },
        {
            key: "roundToZero",
            value: function roundToZero() {
                this.x = Math.trunc(this.x);
                this.y = Math.trunc(this.y);
                this.z = Math.trunc(this.z);
                return this;
            }
        },
        {
            key: "negate",
            value: function negate() {
                this.x = -this.x;
                this.y = -this.y;
                this.z = -this.z;
                return this;
            }
        },
        {
            key: "dot",
            value: function dot(v) {
                return this.x * v.x + this.y * v.y + this.z * v.z;
            }
        },
        {
            // TODO lengthSquared?
            key: "lengthSq",
            value: function lengthSq() {
                return this.x * this.x + this.y * this.y + this.z * this.z;
            }
        },
        {
            key: "length",
            value: function length() {
                return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
            }
        },
        {
            key: "manhattanLength",
            value: function manhattanLength() {
                return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
            }
        },
        {
            key: "normalize",
            value: function normalize() {
                return this.divideScalar(this.length() || 1);
            }
        },
        {
            key: "setLength",
            value: function setLength(length) {
                return this.normalize().multiplyScalar(length);
            }
        },
        {
            key: "lerp",
            value: function lerp(v, alpha) {
                this.x += (v.x - this.x) * alpha;
                this.y += (v.y - this.y) * alpha;
                this.z += (v.z - this.z) * alpha;
                return this;
            }
        },
        {
            key: "lerpVectors",
            value: function lerpVectors(v1, v2, alpha) {
                this.x = v1.x + (v2.x - v1.x) * alpha;
                this.y = v1.y + (v2.y - v1.y) * alpha;
                this.z = v1.z + (v2.z - v1.z) * alpha;
                return this;
            }
        },
        {
            key: "cross",
            value: function cross(v) {
                return this.crossVectors(this, v);
            }
        },
        {
            key: "crossVectors",
            value: function crossVectors(a, b) {
                var ax = a.x, ay = a.y, az = a.z;
                var bx = b.x, by = b.y, bz = b.z;
                this.x = ay * bz - az * by;
                this.y = az * bx - ax * bz;
                this.z = ax * by - ay * bx;
                return this;
            }
        },
        {
            key: "projectOnVector",
            value: function projectOnVector(v) {
                var denominator = v.lengthSq();
                if (denominator === 0) return this.set(0, 0, 0);
                var scalar = v.dot(this) / denominator;
                return this.copy(v).multiplyScalar(scalar);
            }
        },
        {
            key: "projectOnPlane",
            value: function projectOnPlane(planeNormal) {
                $1a55656020b89c3a$var$_vector$c.copy(this).projectOnVector(planeNormal);
                return this.sub($1a55656020b89c3a$var$_vector$c);
            }
        },
        {
            key: "reflect",
            value: function reflect(normal) {
                // reflect incident vector off plane orthogonal to normal
                // normal is assumed to have unit length
                return this.sub($1a55656020b89c3a$var$_vector$c.copy(normal).multiplyScalar(2 * this.dot(normal)));
            }
        },
        {
            key: "angleTo",
            value: function angleTo(v) {
                var denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
                if (denominator === 0) return Math.PI / 2;
                var theta = this.dot(v) / denominator;
                // clamp, to handle numerical problems
                return Math.acos($1a55656020b89c3a$var$clamp(theta, -1, 1));
            }
        },
        {
            key: "distanceTo",
            value: function distanceTo(v) {
                return Math.sqrt(this.distanceToSquared(v));
            }
        },
        {
            key: "distanceToSquared",
            value: function distanceToSquared(v) {
                var dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
                return dx * dx + dy * dy + dz * dz;
            }
        },
        {
            key: "manhattanDistanceTo",
            value: function manhattanDistanceTo(v) {
                return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
            }
        },
        {
            key: "setFromSpherical",
            value: function setFromSpherical(s) {
                return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
            }
        },
        {
            key: "setFromSphericalCoords",
            value: function setFromSphericalCoords(radius, phi, theta) {
                var sinPhiRadius = Math.sin(phi) * radius;
                this.x = sinPhiRadius * Math.sin(theta);
                this.y = Math.cos(phi) * radius;
                this.z = sinPhiRadius * Math.cos(theta);
                return this;
            }
        },
        {
            key: "setFromCylindrical",
            value: function setFromCylindrical(c) {
                return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
            }
        },
        {
            key: "setFromCylindricalCoords",
            value: function setFromCylindricalCoords(radius, theta, y) {
                this.x = radius * Math.sin(theta);
                this.y = y;
                this.z = radius * Math.cos(theta);
                return this;
            }
        },
        {
            key: "setFromMatrixPosition",
            value: function setFromMatrixPosition(m) {
                var e = m.elements;
                this.x = e[12];
                this.y = e[13];
                this.z = e[14];
                return this;
            }
        },
        {
            key: "setFromMatrixScale",
            value: function setFromMatrixScale(m) {
                var sx = this.setFromMatrixColumn(m, 0).length();
                var sy = this.setFromMatrixColumn(m, 1).length();
                var sz = this.setFromMatrixColumn(m, 2).length();
                this.x = sx;
                this.y = sy;
                this.z = sz;
                return this;
            }
        },
        {
            key: "setFromMatrixColumn",
            value: function setFromMatrixColumn(m, index) {
                return this.fromArray(m.elements, index * 4);
            }
        },
        {
            key: "setFromMatrix3Column",
            value: function setFromMatrix3Column(m, index) {
                return this.fromArray(m.elements, index * 3);
            }
        },
        {
            key: "setFromEuler",
            value: function setFromEuler(e) {
                this.x = e._x;
                this.y = e._y;
                this.z = e._z;
                return this;
            }
        },
        {
            key: "setFromColor",
            value: function setFromColor(c) {
                this.x = c.r;
                this.y = c.g;
                this.z = c.b;
                return this;
            }
        },
        {
            key: "equals",
            value: function equals(v) {
                return v.x === this.x && v.y === this.y && v.z === this.z;
            }
        },
        {
            key: "fromArray",
            value: function fromArray(array) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                this.x = array[offset];
                this.y = array[offset + 1];
                this.z = array[offset + 2];
                return this;
            }
        },
        {
            key: "toArray",
            value: function toArray() {
                var array = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                array[offset] = this.x;
                array[offset + 1] = this.y;
                array[offset + 2] = this.z;
                return array;
            }
        },
        {
            key: "fromBufferAttribute",
            value: function fromBufferAttribute(attribute, index) {
                this.x = attribute.getX(index);
                this.y = attribute.getY(index);
                this.z = attribute.getZ(index);
                return this;
            }
        },
        {
            key: "random",
            value: function random() {
                this.x = Math.random();
                this.y = Math.random();
                this.z = Math.random();
                return this;
            }
        },
        {
            key: "randomDirection",
            value: function randomDirection() {
                // https://mathworld.wolfram.com/SpherePointPicking.html
                var theta = Math.random() * Math.PI * 2;
                var u = Math.random() * 2 - 1;
                var c = Math.sqrt(1 - u * u);
                this.x = c * Math.cos(theta);
                this.y = u;
                this.z = c * Math.sin(theta);
                return this;
            }
        },
        {
            key: Symbol.iterator,
            value: function value() {
                return (0, $353b713f9392bb93$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                this.x
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                this.y
                            ];
                        case 2:
                            _state.sent();
                            return [
                                4,
                                this.z
                            ];
                        case 3:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }
        }
    ]);
    return Vector3;
}();
var $1a55656020b89c3a$var$_vector$c = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_quaternion$4 = /*@__PURE__*/ new $1a55656020b89c3a$export$23d6a54f0bbc85a3();
var $1a55656020b89c3a$export$6f7d5a9418ab2aa3 = /*#__PURE__*/ function() {
    "use strict";
    function Box3() {
        var min = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $1a55656020b89c3a$export$64b5c384219d3699(Infinity, Infinity, Infinity), max = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $1a55656020b89c3a$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity);
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Box3);
        this.isBox3 = true;
        this.min = min;
        this.max = max;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Box3, [
        {
            key: "set",
            value: function set(min, max) {
                this.min.copy(min);
                this.max.copy(max);
                return this;
            }
        },
        {
            key: "setFromArray",
            value: function setFromArray(array) {
                this.makeEmpty();
                for(var i = 0, il = array.length; i < il; i += 3)this.expandByPoint($1a55656020b89c3a$var$_vector$b.fromArray(array, i));
                return this;
            }
        },
        {
            key: "setFromBufferAttribute",
            value: function setFromBufferAttribute(attribute) {
                this.makeEmpty();
                for(var i = 0, il = attribute.count; i < il; i++)this.expandByPoint($1a55656020b89c3a$var$_vector$b.fromBufferAttribute(attribute, i));
                return this;
            }
        },
        {
            key: "setFromPoints",
            value: function setFromPoints(points) {
                this.makeEmpty();
                for(var i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
                return this;
            }
        },
        {
            key: "setFromCenterAndSize",
            value: function setFromCenterAndSize(center, size) {
                var halfSize = $1a55656020b89c3a$var$_vector$b.copy(size).multiplyScalar(0.5);
                this.min.copy(center).sub(halfSize);
                this.max.copy(center).add(halfSize);
                return this;
            }
        },
        {
            key: "setFromObject",
            value: function setFromObject(object) {
                var precise = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                this.makeEmpty();
                return this.expandByObject(object, precise);
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        },
        {
            key: "copy",
            value: function copy(box) {
                this.min.copy(box.min);
                this.max.copy(box.max);
                return this;
            }
        },
        {
            key: "makeEmpty",
            value: function makeEmpty() {
                this.min.x = this.min.y = this.min.z = Infinity;
                this.max.x = this.max.y = this.max.z = -Infinity;
                return this;
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
                return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
            }
        },
        {
            key: "getCenter",
            value: function getCenter(target) {
                return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
            }
        },
        {
            key: "getSize",
            value: function getSize(target) {
                return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
            }
        },
        {
            key: "expandByPoint",
            value: function expandByPoint(point) {
                this.min.min(point);
                this.max.max(point);
                return this;
            }
        },
        {
            key: "expandByVector",
            value: function expandByVector(vector) {
                this.min.sub(vector);
                this.max.add(vector);
                return this;
            }
        },
        {
            key: "expandByScalar",
            value: function expandByScalar(scalar) {
                this.min.addScalar(-scalar);
                this.max.addScalar(scalar);
                return this;
            }
        },
        {
            key: "expandByObject",
            value: function expandByObject(object) {
                var precise = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                // Computes the world-axis-aligned bounding box of an object (including its children),
                // accounting for both the object's, and children's, world transforms
                object.updateWorldMatrix(false, false);
                var geometry = object.geometry;
                if (geometry !== undefined) {
                    var positionAttribute = geometry.getAttribute('position');
                    // precise AABB computation based on vertex data requires at least a position attribute.
                    // instancing isn't supported so far and uses the normal (conservative) code path.
                    if (precise === true && positionAttribute !== undefined && object.isInstancedMesh !== true) for(var i = 0, l = positionAttribute.count; i < l; i++){
                        if (object.isMesh === true) object.getVertexPosition(i, $1a55656020b89c3a$var$_vector$b);
                        else $1a55656020b89c3a$var$_vector$b.fromBufferAttribute(positionAttribute, i);
                        $1a55656020b89c3a$var$_vector$b.applyMatrix4(object.matrixWorld);
                        this.expandByPoint($1a55656020b89c3a$var$_vector$b);
                    }
                    else {
                        if (object.boundingBox !== undefined) {
                            // object-level bounding box
                            if (object.boundingBox === null) object.computeBoundingBox();
                            $1a55656020b89c3a$var$_box$4.copy(object.boundingBox);
                        } else {
                            // geometry-level bounding box
                            if (geometry.boundingBox === null) geometry.computeBoundingBox();
                            $1a55656020b89c3a$var$_box$4.copy(geometry.boundingBox);
                        }
                        $1a55656020b89c3a$var$_box$4.applyMatrix4(object.matrixWorld);
                        this.union($1a55656020b89c3a$var$_box$4);
                    }
                }
                var children = object.children;
                for(var i1 = 0, l1 = children.length; i1 < l1; i1++)this.expandByObject(children[i1], precise);
                return this;
            }
        },
        {
            key: "containsPoint",
            value: function containsPoint(point) {
                return point.x >= this.min.x && point.x <= this.max.x && point.y >= this.min.y && point.y <= this.max.y && point.z >= this.min.z && point.z <= this.max.z;
            }
        },
        {
            key: "containsBox",
            value: function containsBox(box) {
                return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
            }
        },
        {
            key: "getParameter",
            value: function getParameter(point, target) {
                // This can potentially have a divide by zero if the box
                // has a size dimension of 0.
                return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y), (point.z - this.min.z) / (this.max.z - this.min.z));
            }
        },
        {
            key: "intersectsBox",
            value: function intersectsBox(box) {
                // using 6 splitting planes to rule out intersections.
                return box.max.x >= this.min.x && box.min.x <= this.max.x && box.max.y >= this.min.y && box.min.y <= this.max.y && box.max.z >= this.min.z && box.min.z <= this.max.z;
            }
        },
        {
            key: "intersectsSphere",
            value: function intersectsSphere(sphere) {
                // Find the point on the AABB closest to the sphere center.
                this.clampPoint(sphere.center, $1a55656020b89c3a$var$_vector$b);
                // If that point is inside the sphere, the AABB and sphere intersect.
                return $1a55656020b89c3a$var$_vector$b.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
            }
        },
        {
            key: "intersectsPlane",
            value: function intersectsPlane(plane) {
                // We compute the minimum and maximum dot product values. If those values
                // are on the same side (back or front) of the plane, then there is no intersection.
                var min, max;
                if (plane.normal.x > 0) {
                    min = plane.normal.x * this.min.x;
                    max = plane.normal.x * this.max.x;
                } else {
                    min = plane.normal.x * this.max.x;
                    max = plane.normal.x * this.min.x;
                }
                if (plane.normal.y > 0) {
                    min += plane.normal.y * this.min.y;
                    max += plane.normal.y * this.max.y;
                } else {
                    min += plane.normal.y * this.max.y;
                    max += plane.normal.y * this.min.y;
                }
                if (plane.normal.z > 0) {
                    min += plane.normal.z * this.min.z;
                    max += plane.normal.z * this.max.z;
                } else {
                    min += plane.normal.z * this.max.z;
                    max += plane.normal.z * this.min.z;
                }
                return min <= -plane.constant && max >= -plane.constant;
            }
        },
        {
            key: "intersectsTriangle",
            value: function intersectsTriangle(triangle) {
                if (this.isEmpty()) return false;
                // compute box center and extents
                this.getCenter($1a55656020b89c3a$var$_center);
                $1a55656020b89c3a$var$_extents.subVectors(this.max, $1a55656020b89c3a$var$_center);
                // translate triangle to aabb origin
                $1a55656020b89c3a$var$_v0$2.subVectors(triangle.a, $1a55656020b89c3a$var$_center);
                $1a55656020b89c3a$var$_v1$7.subVectors(triangle.b, $1a55656020b89c3a$var$_center);
                $1a55656020b89c3a$var$_v2$4.subVectors(triangle.c, $1a55656020b89c3a$var$_center);
                // compute edge vectors for triangle
                $1a55656020b89c3a$var$_f0.subVectors($1a55656020b89c3a$var$_v1$7, $1a55656020b89c3a$var$_v0$2);
                $1a55656020b89c3a$var$_f1.subVectors($1a55656020b89c3a$var$_v2$4, $1a55656020b89c3a$var$_v1$7);
                $1a55656020b89c3a$var$_f2.subVectors($1a55656020b89c3a$var$_v0$2, $1a55656020b89c3a$var$_v2$4);
                // test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
                // make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
                // axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
                var axes = [
                    0,
                    -$1a55656020b89c3a$var$_f0.z,
                    $1a55656020b89c3a$var$_f0.y,
                    0,
                    -$1a55656020b89c3a$var$_f1.z,
                    $1a55656020b89c3a$var$_f1.y,
                    0,
                    -$1a55656020b89c3a$var$_f2.z,
                    $1a55656020b89c3a$var$_f2.y,
                    $1a55656020b89c3a$var$_f0.z,
                    0,
                    -$1a55656020b89c3a$var$_f0.x,
                    $1a55656020b89c3a$var$_f1.z,
                    0,
                    -$1a55656020b89c3a$var$_f1.x,
                    $1a55656020b89c3a$var$_f2.z,
                    0,
                    -$1a55656020b89c3a$var$_f2.x,
                    -$1a55656020b89c3a$var$_f0.y,
                    $1a55656020b89c3a$var$_f0.x,
                    0,
                    -$1a55656020b89c3a$var$_f1.y,
                    $1a55656020b89c3a$var$_f1.x,
                    0,
                    -$1a55656020b89c3a$var$_f2.y,
                    $1a55656020b89c3a$var$_f2.x,
                    0
                ];
                if (!$1a55656020b89c3a$var$satForAxes(axes, $1a55656020b89c3a$var$_v0$2, $1a55656020b89c3a$var$_v1$7, $1a55656020b89c3a$var$_v2$4, $1a55656020b89c3a$var$_extents)) return false;
                // test 3 face normals from the aabb
                axes = [
                    1,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    1
                ];
                if (!$1a55656020b89c3a$var$satForAxes(axes, $1a55656020b89c3a$var$_v0$2, $1a55656020b89c3a$var$_v1$7, $1a55656020b89c3a$var$_v2$4, $1a55656020b89c3a$var$_extents)) return false;
                // finally testing the face normal of the triangle
                // use already existing triangle edge vectors here
                $1a55656020b89c3a$var$_triangleNormal.crossVectors($1a55656020b89c3a$var$_f0, $1a55656020b89c3a$var$_f1);
                axes = [
                    $1a55656020b89c3a$var$_triangleNormal.x,
                    $1a55656020b89c3a$var$_triangleNormal.y,
                    $1a55656020b89c3a$var$_triangleNormal.z
                ];
                return $1a55656020b89c3a$var$satForAxes(axes, $1a55656020b89c3a$var$_v0$2, $1a55656020b89c3a$var$_v1$7, $1a55656020b89c3a$var$_v2$4, $1a55656020b89c3a$var$_extents);
            }
        },
        {
            key: "clampPoint",
            value: function clampPoint(point, target) {
                return target.copy(point).clamp(this.min, this.max);
            }
        },
        {
            key: "distanceToPoint",
            value: function distanceToPoint(point) {
                return this.clampPoint(point, $1a55656020b89c3a$var$_vector$b).distanceTo(point);
            }
        },
        {
            key: "getBoundingSphere",
            value: function getBoundingSphere(target) {
                if (this.isEmpty()) target.makeEmpty();
                else {
                    this.getCenter(target.center);
                    target.radius = this.getSize($1a55656020b89c3a$var$_vector$b).length() * 0.5;
                }
                return target;
            }
        },
        {
            key: "intersect",
            value: function intersect(box) {
                this.min.max(box.min);
                this.max.min(box.max);
                // ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
                if (this.isEmpty()) this.makeEmpty();
                return this;
            }
        },
        {
            key: "union",
            value: function union(box) {
                this.min.min(box.min);
                this.max.max(box.max);
                return this;
            }
        },
        {
            key: "applyMatrix4",
            value: function applyMatrix4(matrix) {
                // transform of empty box is an empty box.
                if (this.isEmpty()) return this;
                // NOTE: I am using a binary pattern to specify all 2^3 combinations below
                $1a55656020b89c3a$var$_points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix); // 000
                $1a55656020b89c3a$var$_points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix); // 001
                $1a55656020b89c3a$var$_points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix); // 010
                $1a55656020b89c3a$var$_points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix); // 011
                $1a55656020b89c3a$var$_points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix); // 100
                $1a55656020b89c3a$var$_points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix); // 101
                $1a55656020b89c3a$var$_points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix); // 110
                $1a55656020b89c3a$var$_points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix); // 111
                this.setFromPoints($1a55656020b89c3a$var$_points);
                return this;
            }
        },
        {
            key: "translate",
            value: function translate(offset) {
                this.min.add(offset);
                this.max.add(offset);
                return this;
            }
        },
        {
            key: "equals",
            value: function equals(box) {
                return box.min.equals(this.min) && box.max.equals(this.max);
            }
        }
    ]);
    return Box3;
}();
var $1a55656020b89c3a$var$_points = [
    /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699(),
    /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699(),
    /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699(),
    /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699(),
    /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699(),
    /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699(),
    /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699(),
    /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699()
];
var $1a55656020b89c3a$var$_vector$b = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_box$4 = /*@__PURE__*/ new $1a55656020b89c3a$export$6f7d5a9418ab2aa3();
// triangle centered vertices
var $1a55656020b89c3a$var$_v0$2 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_v1$7 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_v2$4 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
// triangle edge vectors
var $1a55656020b89c3a$var$_f0 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_f1 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_f2 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_center = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_extents = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_triangleNormal = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_testAxis = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
function $1a55656020b89c3a$var$satForAxes(axes, v0, v1, v2, extents) {
    for(var i = 0, j = axes.length - 3; i <= j; i += 3){
        $1a55656020b89c3a$var$_testAxis.fromArray(axes, i);
        // project the aabb onto the separating axis
        var r = extents.x * Math.abs($1a55656020b89c3a$var$_testAxis.x) + extents.y * Math.abs($1a55656020b89c3a$var$_testAxis.y) + extents.z * Math.abs($1a55656020b89c3a$var$_testAxis.z);
        // project all 3 vertices of the triangle onto the separating axis
        var p0 = v0.dot($1a55656020b89c3a$var$_testAxis);
        var p1 = v1.dot($1a55656020b89c3a$var$_testAxis);
        var p2 = v2.dot($1a55656020b89c3a$var$_testAxis);
        // actual test, basically see if either of the most extreme of the triangle points intersects r
        if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) // points of the projected triangle are outside the projected half-length of the aabb
        // the axis is separating and we can exit
        return false;
    }
    return true;
}
var $1a55656020b89c3a$var$_box$3 = /*@__PURE__*/ new $1a55656020b89c3a$export$6f7d5a9418ab2aa3();
var $1a55656020b89c3a$var$_v1$6 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_v2$3 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$export$805e8b72413ccaba = /*#__PURE__*/ function() {
    "use strict";
    function Sphere() {
        var center = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $1a55656020b89c3a$export$64b5c384219d3699(), radius = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Sphere);
        this.isSphere = true;
        this.center = center;
        this.radius = radius;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Sphere, [
        {
            key: "set",
            value: function set(center, radius) {
                this.center.copy(center);
                this.radius = radius;
                return this;
            }
        },
        {
            key: "setFromPoints",
            value: function setFromPoints(points, optionalCenter) {
                var center = this.center;
                if (optionalCenter !== undefined) center.copy(optionalCenter);
                else $1a55656020b89c3a$var$_box$3.setFromPoints(points).getCenter(center);
                var maxRadiusSq = 0;
                for(var i = 0, il = points.length; i < il; i++)maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i]));
                this.radius = Math.sqrt(maxRadiusSq);
                return this;
            }
        },
        {
            key: "copy",
            value: function copy(sphere) {
                this.center.copy(sphere.center);
                this.radius = sphere.radius;
                return this;
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return this.radius < 0;
            }
        },
        {
            key: "makeEmpty",
            value: function makeEmpty() {
                this.center.set(0, 0, 0);
                this.radius = -1;
                return this;
            }
        },
        {
            key: "containsPoint",
            value: function containsPoint(point) {
                return point.distanceToSquared(this.center) <= this.radius * this.radius;
            }
        },
        {
            key: "distanceToPoint",
            value: function distanceToPoint(point) {
                return point.distanceTo(this.center) - this.radius;
            }
        },
        {
            key: "intersectsSphere",
            value: function intersectsSphere(sphere) {
                var radiusSum = this.radius + sphere.radius;
                return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
            }
        },
        {
            key: "intersectsBox",
            value: function intersectsBox(box) {
                return box.intersectsSphere(this);
            }
        },
        {
            key: "intersectsPlane",
            value: function intersectsPlane(plane) {
                return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
            }
        },
        {
            key: "clampPoint",
            value: function clampPoint(point, target) {
                var deltaLengthSq = this.center.distanceToSquared(point);
                target.copy(point);
                if (deltaLengthSq > this.radius * this.radius) {
                    target.sub(this.center).normalize();
                    target.multiplyScalar(this.radius).add(this.center);
                }
                return target;
            }
        },
        {
            key: "getBoundingBox",
            value: function getBoundingBox(target) {
                if (this.isEmpty()) {
                    // Empty sphere produces empty bounding box
                    target.makeEmpty();
                    return target;
                }
                target.set(this.center, this.center);
                target.expandByScalar(this.radius);
                return target;
            }
        },
        {
            key: "applyMatrix4",
            value: function applyMatrix4(matrix) {
                this.center.applyMatrix4(matrix);
                this.radius = this.radius * matrix.getMaxScaleOnAxis();
                return this;
            }
        },
        {
            key: "translate",
            value: function translate(offset) {
                this.center.add(offset);
                return this;
            }
        },
        {
            key: "expandByPoint",
            value: function expandByPoint(point) {
                if (this.isEmpty()) {
                    this.center.copy(point);
                    this.radius = 0;
                    return this;
                }
                $1a55656020b89c3a$var$_v1$6.subVectors(point, this.center);
                var lengthSq = $1a55656020b89c3a$var$_v1$6.lengthSq();
                if (lengthSq > this.radius * this.radius) {
                    // calculate the minimal sphere
                    var length = Math.sqrt(lengthSq);
                    var delta = (length - this.radius) * 0.5;
                    this.center.addScaledVector($1a55656020b89c3a$var$_v1$6, delta / length);
                    this.radius += delta;
                }
                return this;
            }
        },
        {
            key: "union",
            value: function union(sphere) {
                if (sphere.isEmpty()) return this;
                if (this.isEmpty()) {
                    this.copy(sphere);
                    return this;
                }
                if (this.center.equals(sphere.center) === true) this.radius = Math.max(this.radius, sphere.radius);
                else {
                    $1a55656020b89c3a$var$_v2$3.subVectors(sphere.center, this.center).setLength(sphere.radius);
                    this.expandByPoint($1a55656020b89c3a$var$_v1$6.copy(sphere.center).add($1a55656020b89c3a$var$_v2$3));
                    this.expandByPoint($1a55656020b89c3a$var$_v1$6.copy(sphere.center).sub($1a55656020b89c3a$var$_v2$3));
                }
                return this;
            }
        },
        {
            key: "equals",
            value: function equals(sphere) {
                return sphere.center.equals(this.center) && sphere.radius === this.radius;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        }
    ]);
    return Sphere;
}();
var $1a55656020b89c3a$var$_vector$a = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_segCenter = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_segDir = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_diff = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_edge1 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_edge2 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_normal$1 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$export$a186db52eed6d40e = /*#__PURE__*/ function() {
    "use strict";
    function Ray() {
        var origin = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $1a55656020b89c3a$export$64b5c384219d3699(), direction = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $1a55656020b89c3a$export$64b5c384219d3699(0, 0, -1);
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Ray);
        this.origin = origin;
        this.direction = direction;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Ray, [
        {
            key: "set",
            value: function set(origin, direction) {
                this.origin.copy(origin);
                this.direction.copy(direction);
                return this;
            }
        },
        {
            key: "copy",
            value: function copy(ray) {
                this.origin.copy(ray.origin);
                this.direction.copy(ray.direction);
                return this;
            }
        },
        {
            key: "at",
            value: function at(t, target) {
                return target.copy(this.origin).addScaledVector(this.direction, t);
            }
        },
        {
            key: "lookAt",
            value: function lookAt(v) {
                this.direction.copy(v).sub(this.origin).normalize();
                return this;
            }
        },
        {
            key: "recast",
            value: function recast(t) {
                this.origin.copy(this.at(t, $1a55656020b89c3a$var$_vector$a));
                return this;
            }
        },
        {
            key: "closestPointToPoint",
            value: function closestPointToPoint(point, target) {
                target.subVectors(point, this.origin);
                var directionDistance = target.dot(this.direction);
                if (directionDistance < 0) return target.copy(this.origin);
                return target.copy(this.origin).addScaledVector(this.direction, directionDistance);
            }
        },
        {
            key: "distanceToPoint",
            value: function distanceToPoint(point) {
                return Math.sqrt(this.distanceSqToPoint(point));
            }
        },
        {
            key: "distanceSqToPoint",
            value: function distanceSqToPoint(point) {
                var directionDistance = $1a55656020b89c3a$var$_vector$a.subVectors(point, this.origin).dot(this.direction);
                // point behind the ray
                if (directionDistance < 0) return this.origin.distanceToSquared(point);
                $1a55656020b89c3a$var$_vector$a.copy(this.origin).addScaledVector(this.direction, directionDistance);
                return $1a55656020b89c3a$var$_vector$a.distanceToSquared(point);
            }
        },
        {
            key: "distanceSqToSegment",
            value: function distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
                // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteDistRaySegment.h
                // It returns the min distance between the ray and the segment
                // defined by v0 and v1
                // It can also set two optional targets :
                // - The closest point on the ray
                // - The closest point on the segment
                $1a55656020b89c3a$var$_segCenter.copy(v0).add(v1).multiplyScalar(0.5);
                $1a55656020b89c3a$var$_segDir.copy(v1).sub(v0).normalize();
                $1a55656020b89c3a$var$_diff.copy(this.origin).sub($1a55656020b89c3a$var$_segCenter);
                var segExtent = v0.distanceTo(v1) * 0.5;
                var a01 = -this.direction.dot($1a55656020b89c3a$var$_segDir);
                var b0 = $1a55656020b89c3a$var$_diff.dot(this.direction);
                var b1 = -$1a55656020b89c3a$var$_diff.dot($1a55656020b89c3a$var$_segDir);
                var c = $1a55656020b89c3a$var$_diff.lengthSq();
                var det = Math.abs(1 - a01 * a01);
                var s0, s1, sqrDist, extDet;
                if (det > 0) {
                    // The ray and segment are not parallel.
                    s0 = a01 * b1 - b0;
                    s1 = a01 * b0 - b1;
                    extDet = segExtent * det;
                    if (s0 >= 0) {
                        if (s1 >= -extDet) {
                            if (s1 <= extDet) {
                                // region 0
                                // Minimum at interior points of ray and segment.
                                var invDet = 1 / det;
                                s0 *= invDet;
                                s1 *= invDet;
                                sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
                            } else {
                                // region 1
                                s1 = segExtent;
                                s0 = Math.max(0, -(a01 * s1 + b0));
                                sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                            }
                        } else {
                            // region 5
                            s1 = -segExtent;
                            s0 = Math.max(0, -(a01 * s1 + b0));
                            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                        }
                    } else {
                        if (s1 <= -extDet) {
                            // region 4
                            s0 = Math.max(0, -(-a01 * segExtent + b0));
                            s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                        } else if (s1 <= extDet) {
                            // region 3
                            s0 = 0;
                            s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
                            sqrDist = s1 * (s1 + 2 * b1) + c;
                        } else {
                            // region 2
                            s0 = Math.max(0, -(a01 * segExtent + b0));
                            s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                        }
                    }
                } else {
                    // Ray and segment are parallel.
                    s1 = a01 > 0 ? -segExtent : segExtent;
                    s0 = Math.max(0, -(a01 * s1 + b0));
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
                if (optionalPointOnRay) optionalPointOnRay.copy(this.origin).addScaledVector(this.direction, s0);
                if (optionalPointOnSegment) optionalPointOnSegment.copy($1a55656020b89c3a$var$_segCenter).addScaledVector($1a55656020b89c3a$var$_segDir, s1);
                return sqrDist;
            }
        },
        {
            key: "intersectSphere",
            value: function intersectSphere(sphere, target) {
                $1a55656020b89c3a$var$_vector$a.subVectors(sphere.center, this.origin);
                var tca = $1a55656020b89c3a$var$_vector$a.dot(this.direction);
                var d2 = $1a55656020b89c3a$var$_vector$a.dot($1a55656020b89c3a$var$_vector$a) - tca * tca;
                var radius2 = sphere.radius * sphere.radius;
                if (d2 > radius2) return null;
                var thc = Math.sqrt(radius2 - d2);
                // t0 = first intersect point - entrance on front of sphere
                var t0 = tca - thc;
                // t1 = second intersect point - exit point on back of sphere
                var t1 = tca + thc;
                // test to see if t1 is behind the ray - if so, return null
                if (t1 < 0) return null;
                // test to see if t0 is behind the ray:
                // if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
                // in order to always return an intersect point that is in front of the ray.
                if (t0 < 0) return this.at(t1, target);
                // else t0 is in front of the ray, so return the first collision point scaled by t0
                return this.at(t0, target);
            }
        },
        {
            key: "intersectsSphere",
            value: function intersectsSphere(sphere) {
                return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
            }
        },
        {
            key: "distanceToPlane",
            value: function distanceToPlane(plane) {
                var denominator = plane.normal.dot(this.direction);
                if (denominator === 0) {
                    // line is coplanar, return origin
                    if (plane.distanceToPoint(this.origin) === 0) return 0;
                    // Null is preferable to undefined since undefined means.... it is undefined
                    return null;
                }
                var t = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
                // Return if the ray never intersects the plane
                return t >= 0 ? t : null;
            }
        },
        {
            key: "intersectPlane",
            value: function intersectPlane(plane, target) {
                var t = this.distanceToPlane(plane);
                if (t === null) return null;
                return this.at(t, target);
            }
        },
        {
            key: "intersectsPlane",
            value: function intersectsPlane(plane) {
                // check if the ray lies on the plane first
                var distToPoint = plane.distanceToPoint(this.origin);
                if (distToPoint === 0) return true;
                var denominator = plane.normal.dot(this.direction);
                if (denominator * distToPoint < 0) return true;
                // ray origin is behind the plane (and is pointing behind it)
                return false;
            }
        },
        {
            key: "intersectBox",
            value: function intersectBox(box, target) {
                var tmin, tmax, tymin, tymax, tzmin, tzmax;
                var invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
                var origin = this.origin;
                if (invdirx >= 0) {
                    tmin = (box.min.x - origin.x) * invdirx;
                    tmax = (box.max.x - origin.x) * invdirx;
                } else {
                    tmin = (box.max.x - origin.x) * invdirx;
                    tmax = (box.min.x - origin.x) * invdirx;
                }
                if (invdiry >= 0) {
                    tymin = (box.min.y - origin.y) * invdiry;
                    tymax = (box.max.y - origin.y) * invdiry;
                } else {
                    tymin = (box.max.y - origin.y) * invdiry;
                    tymax = (box.min.y - origin.y) * invdiry;
                }
                if (tmin > tymax || tymin > tmax) return null;
                if (tymin > tmin || isNaN(tmin)) tmin = tymin;
                if (tymax < tmax || isNaN(tmax)) tmax = tymax;
                if (invdirz >= 0) {
                    tzmin = (box.min.z - origin.z) * invdirz;
                    tzmax = (box.max.z - origin.z) * invdirz;
                } else {
                    tzmin = (box.max.z - origin.z) * invdirz;
                    tzmax = (box.min.z - origin.z) * invdirz;
                }
                if (tmin > tzmax || tzmin > tmax) return null;
                if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
                if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
                //return point closest to the ray (positive side)
                if (tmax < 0) return null;
                return this.at(tmin >= 0 ? tmin : tmax, target);
            }
        },
        {
            key: "intersectsBox",
            value: function intersectsBox(box) {
                return this.intersectBox(box, $1a55656020b89c3a$var$_vector$a) !== null;
            }
        },
        {
            key: "intersectTriangle",
            value: function intersectTriangle(a, b, c, backfaceCulling, target) {
                // Compute the offset origin, edges, and normal.
                // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
                $1a55656020b89c3a$var$_edge1.subVectors(b, a);
                $1a55656020b89c3a$var$_edge2.subVectors(c, a);
                $1a55656020b89c3a$var$_normal$1.crossVectors($1a55656020b89c3a$var$_edge1, $1a55656020b89c3a$var$_edge2);
                // Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
                // E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
                //   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
                //   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
                //   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
                var DdN = this.direction.dot($1a55656020b89c3a$var$_normal$1);
                var sign;
                if (DdN > 0) {
                    if (backfaceCulling) return null;
                    sign = 1;
                } else if (DdN < 0) {
                    sign = -1;
                    DdN = -DdN;
                } else return null;
                $1a55656020b89c3a$var$_diff.subVectors(this.origin, a);
                var DdQxE2 = sign * this.direction.dot($1a55656020b89c3a$var$_edge2.crossVectors($1a55656020b89c3a$var$_diff, $1a55656020b89c3a$var$_edge2));
                // b1 < 0, no intersection
                if (DdQxE2 < 0) return null;
                var DdE1xQ = sign * this.direction.dot($1a55656020b89c3a$var$_edge1.cross($1a55656020b89c3a$var$_diff));
                // b2 < 0, no intersection
                if (DdE1xQ < 0) return null;
                // b1+b2 > 1, no intersection
                if (DdQxE2 + DdE1xQ > DdN) return null;
                // Line intersects triangle, check if ray does.
                var QdN = -sign * $1a55656020b89c3a$var$_diff.dot($1a55656020b89c3a$var$_normal$1);
                // t < 0, no intersection
                if (QdN < 0) return null;
                // Ray intersects triangle.
                return this.at(QdN / DdN, target);
            }
        },
        {
            key: "applyMatrix4",
            value: function applyMatrix4(matrix4) {
                this.origin.applyMatrix4(matrix4);
                this.direction.transformDirection(matrix4);
                return this;
            }
        },
        {
            key: "equals",
            value: function equals(ray) {
                return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        }
    ]);
    return Ray;
}();
var $1a55656020b89c3a$export$2ae72fc923e5eb5 = /*#__PURE__*/ function() {
    "use strict";
    function Matrix4(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Matrix4);
        Matrix4.prototype.isMatrix4 = true;
        this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44);
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Matrix4, [
        {
            key: "set",
            value: function set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
                var te = this.elements;
                te[0] = n11;
                te[4] = n12;
                te[8] = n13;
                te[12] = n14;
                te[1] = n21;
                te[5] = n22;
                te[9] = n23;
                te[13] = n24;
                te[2] = n31;
                te[6] = n32;
                te[10] = n33;
                te[14] = n34;
                te[3] = n41;
                te[7] = n42;
                te[11] = n43;
                te[15] = n44;
                return this;
            }
        },
        {
            key: "identity",
            value: function identity() {
                this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
                return this;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new Matrix4().fromArray(this.elements);
            }
        },
        {
            key: "copy",
            value: function copy(m) {
                var te = this.elements;
                var me = m.elements;
                te[0] = me[0];
                te[1] = me[1];
                te[2] = me[2];
                te[3] = me[3];
                te[4] = me[4];
                te[5] = me[5];
                te[6] = me[6];
                te[7] = me[7];
                te[8] = me[8];
                te[9] = me[9];
                te[10] = me[10];
                te[11] = me[11];
                te[12] = me[12];
                te[13] = me[13];
                te[14] = me[14];
                te[15] = me[15];
                return this;
            }
        },
        {
            key: "copyPosition",
            value: function copyPosition(m) {
                var te = this.elements, me = m.elements;
                te[12] = me[12];
                te[13] = me[13];
                te[14] = me[14];
                return this;
            }
        },
        {
            key: "setFromMatrix3",
            value: function setFromMatrix3(m) {
                var me = m.elements;
                this.set(me[0], me[3], me[6], 0, me[1], me[4], me[7], 0, me[2], me[5], me[8], 0, 0, 0, 0, 1);
                return this;
            }
        },
        {
            key: "extractBasis",
            value: function extractBasis(xAxis, yAxis, zAxis) {
                xAxis.setFromMatrixColumn(this, 0);
                yAxis.setFromMatrixColumn(this, 1);
                zAxis.setFromMatrixColumn(this, 2);
                return this;
            }
        },
        {
            key: "makeBasis",
            value: function makeBasis(xAxis, yAxis, zAxis) {
                this.set(xAxis.x, yAxis.x, zAxis.x, 0, xAxis.y, yAxis.y, zAxis.y, 0, xAxis.z, yAxis.z, zAxis.z, 0, 0, 0, 0, 1);
                return this;
            }
        },
        {
            key: "extractRotation",
            value: function extractRotation(m) {
                // this method does not support reflection matrices
                var te = this.elements;
                var me = m.elements;
                var scaleX = 1 / $1a55656020b89c3a$var$_v1$5.setFromMatrixColumn(m, 0).length();
                var scaleY = 1 / $1a55656020b89c3a$var$_v1$5.setFromMatrixColumn(m, 1).length();
                var scaleZ = 1 / $1a55656020b89c3a$var$_v1$5.setFromMatrixColumn(m, 2).length();
                te[0] = me[0] * scaleX;
                te[1] = me[1] * scaleX;
                te[2] = me[2] * scaleX;
                te[3] = 0;
                te[4] = me[4] * scaleY;
                te[5] = me[5] * scaleY;
                te[6] = me[6] * scaleY;
                te[7] = 0;
                te[8] = me[8] * scaleZ;
                te[9] = me[9] * scaleZ;
                te[10] = me[10] * scaleZ;
                te[11] = 0;
                te[12] = 0;
                te[13] = 0;
                te[14] = 0;
                te[15] = 1;
                return this;
            }
        },
        {
            key: "makeRotationFromEuler",
            value: function makeRotationFromEuler(euler) {
                var te = this.elements;
                var x = euler.x, y = euler.y, z = euler.z;
                var a = Math.cos(x), b = Math.sin(x);
                var c = Math.cos(y), d = Math.sin(y);
                var e = Math.cos(z), f = Math.sin(z);
                if (euler.order === 'XYZ') {
                    var ae = a * e, af = a * f, be = b * e, bf = b * f;
                    te[0] = c * e;
                    te[4] = -c * f;
                    te[8] = d;
                    te[1] = af + be * d;
                    te[5] = ae - bf * d;
                    te[9] = -b * c;
                    te[2] = bf - ae * d;
                    te[6] = be + af * d;
                    te[10] = a * c;
                } else if (euler.order === 'YXZ') {
                    var ce = c * e, cf = c * f, de = d * e, df = d * f;
                    te[0] = ce + df * b;
                    te[4] = de * b - cf;
                    te[8] = a * d;
                    te[1] = a * f;
                    te[5] = a * e;
                    te[9] = -b;
                    te[2] = cf * b - de;
                    te[6] = df + ce * b;
                    te[10] = a * c;
                } else if (euler.order === 'ZXY') {
                    var ce1 = c * e, cf1 = c * f, de1 = d * e, df1 = d * f;
                    te[0] = ce1 - df1 * b;
                    te[4] = -a * f;
                    te[8] = de1 + cf1 * b;
                    te[1] = cf1 + de1 * b;
                    te[5] = a * e;
                    te[9] = df1 - ce1 * b;
                    te[2] = -a * d;
                    te[6] = b;
                    te[10] = a * c;
                } else if (euler.order === 'ZYX') {
                    var ae1 = a * e, af1 = a * f, be1 = b * e, bf1 = b * f;
                    te[0] = c * e;
                    te[4] = be1 * d - af1;
                    te[8] = ae1 * d + bf1;
                    te[1] = c * f;
                    te[5] = bf1 * d + ae1;
                    te[9] = af1 * d - be1;
                    te[2] = -d;
                    te[6] = b * c;
                    te[10] = a * c;
                } else if (euler.order === 'YZX') {
                    var ac = a * c, ad = a * d, bc = b * c, bd = b * d;
                    te[0] = c * e;
                    te[4] = bd - ac * f;
                    te[8] = bc * f + ad;
                    te[1] = f;
                    te[5] = a * e;
                    te[9] = -b * e;
                    te[2] = -d * e;
                    te[6] = ad * f + bc;
                    te[10] = ac - bd * f;
                } else if (euler.order === 'XZY') {
                    var ac1 = a * c, ad1 = a * d, bc1 = b * c, bd1 = b * d;
                    te[0] = c * e;
                    te[4] = -f;
                    te[8] = d * e;
                    te[1] = ac1 * f + bd1;
                    te[5] = a * e;
                    te[9] = ad1 * f - bc1;
                    te[2] = bc1 * f - ad1;
                    te[6] = b * e;
                    te[10] = bd1 * f + ac1;
                }
                // bottom row
                te[3] = 0;
                te[7] = 0;
                te[11] = 0;
                // last column
                te[12] = 0;
                te[13] = 0;
                te[14] = 0;
                te[15] = 1;
                return this;
            }
        },
        {
            key: "makeRotationFromQuaternion",
            value: function makeRotationFromQuaternion(q) {
                return this.compose($1a55656020b89c3a$var$_zero, q, $1a55656020b89c3a$var$_one);
            }
        },
        {
            key: "lookAt",
            value: function lookAt(eye, target, up) {
                var te = this.elements;
                $1a55656020b89c3a$var$_z.subVectors(eye, target);
                if ($1a55656020b89c3a$var$_z.lengthSq() === 0) // eye and target are in the same position
                $1a55656020b89c3a$var$_z.z = 1;
                $1a55656020b89c3a$var$_z.normalize();
                $1a55656020b89c3a$var$_x.crossVectors(up, $1a55656020b89c3a$var$_z);
                if ($1a55656020b89c3a$var$_x.lengthSq() === 0) {
                    // up and z are parallel
                    if (Math.abs(up.z) === 1) $1a55656020b89c3a$var$_z.x += 0.0001;
                    else $1a55656020b89c3a$var$_z.z += 0.0001;
                    $1a55656020b89c3a$var$_z.normalize();
                    $1a55656020b89c3a$var$_x.crossVectors(up, $1a55656020b89c3a$var$_z);
                }
                $1a55656020b89c3a$var$_x.normalize();
                $1a55656020b89c3a$var$_y.crossVectors($1a55656020b89c3a$var$_z, $1a55656020b89c3a$var$_x);
                te[0] = $1a55656020b89c3a$var$_x.x;
                te[4] = $1a55656020b89c3a$var$_y.x;
                te[8] = $1a55656020b89c3a$var$_z.x;
                te[1] = $1a55656020b89c3a$var$_x.y;
                te[5] = $1a55656020b89c3a$var$_y.y;
                te[9] = $1a55656020b89c3a$var$_z.y;
                te[2] = $1a55656020b89c3a$var$_x.z;
                te[6] = $1a55656020b89c3a$var$_y.z;
                te[10] = $1a55656020b89c3a$var$_z.z;
                return this;
            }
        },
        {
            key: "multiply",
            value: function multiply(m) {
                return this.multiplyMatrices(this, m);
            }
        },
        {
            key: "premultiply",
            value: function premultiply(m) {
                return this.multiplyMatrices(m, this);
            }
        },
        {
            key: "multiplyMatrices",
            value: function multiplyMatrices(a, b) {
                var ae = a.elements;
                var be = b.elements;
                var te = this.elements;
                var a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
                var a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
                var a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
                var a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
                var b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
                var b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
                var b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
                var b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
                te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
                te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
                te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
                te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
                te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
                te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
                te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
                te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
                te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
                te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
                te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
                te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
                te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
                te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
                te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
                te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
                return this;
            }
        },
        {
            key: "multiplyScalar",
            value: function multiplyScalar(s) {
                var te = this.elements;
                te[0] *= s;
                te[4] *= s;
                te[8] *= s;
                te[12] *= s;
                te[1] *= s;
                te[5] *= s;
                te[9] *= s;
                te[13] *= s;
                te[2] *= s;
                te[6] *= s;
                te[10] *= s;
                te[14] *= s;
                te[3] *= s;
                te[7] *= s;
                te[11] *= s;
                te[15] *= s;
                return this;
            }
        },
        {
            key: "determinant",
            value: function determinant() {
                var te = this.elements;
                var n11 = te[0], n12 = te[4], n13 = te[8], n14 = te[12];
                var n21 = te[1], n22 = te[5], n23 = te[9], n24 = te[13];
                var n31 = te[2], n32 = te[6], n33 = te[10], n34 = te[14];
                var n41 = te[3], n42 = te[7], n43 = te[11], n44 = te[15];
                //TODO: make this more efficient
                //( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )
                return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
            }
        },
        {
            key: "transpose",
            value: function transpose() {
                var te = this.elements;
                var tmp;
                tmp = te[1];
                te[1] = te[4];
                te[4] = tmp;
                tmp = te[2];
                te[2] = te[8];
                te[8] = tmp;
                tmp = te[6];
                te[6] = te[9];
                te[9] = tmp;
                tmp = te[3];
                te[3] = te[12];
                te[12] = tmp;
                tmp = te[7];
                te[7] = te[13];
                te[13] = tmp;
                tmp = te[11];
                te[11] = te[14];
                te[14] = tmp;
                return this;
            }
        },
        {
            key: "setPosition",
            value: function setPosition(x, y, z) {
                var te = this.elements;
                if (x.isVector3) {
                    te[12] = x.x;
                    te[13] = x.y;
                    te[14] = x.z;
                } else {
                    te[12] = x;
                    te[13] = y;
                    te[14] = z;
                }
                return this;
            }
        },
        {
            key: "invert",
            value: function invert() {
                // based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
                var te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n41 = te[3], n12 = te[4], n22 = te[5], n32 = te[6], n42 = te[7], n13 = te[8], n23 = te[9], n33 = te[10], n43 = te[11], n14 = te[12], n24 = te[13], n34 = te[14], n44 = te[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
                var det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
                if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
                var detInv = 1 / det;
                te[0] = t11 * detInv;
                te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
                te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
                te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
                te[4] = t12 * detInv;
                te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
                te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
                te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
                te[8] = t13 * detInv;
                te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
                te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
                te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
                te[12] = t14 * detInv;
                te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
                te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
                te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
                return this;
            }
        },
        {
            key: "scale",
            value: function scale(v) {
                var te = this.elements;
                var x = v.x, y = v.y, z = v.z;
                te[0] *= x;
                te[4] *= y;
                te[8] *= z;
                te[1] *= x;
                te[5] *= y;
                te[9] *= z;
                te[2] *= x;
                te[6] *= y;
                te[10] *= z;
                te[3] *= x;
                te[7] *= y;
                te[11] *= z;
                return this;
            }
        },
        {
            key: "getMaxScaleOnAxis",
            value: function getMaxScaleOnAxis() {
                var te = this.elements;
                var scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
                var scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
                var scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
                return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
            }
        },
        {
            key: "makeTranslation",
            value: function makeTranslation(x, y, z) {
                if (x.isVector3) this.set(1, 0, 0, x.x, 0, 1, 0, x.y, 0, 0, 1, x.z, 0, 0, 0, 1);
                else this.set(1, 0, 0, x, 0, 1, 0, y, 0, 0, 1, z, 0, 0, 0, 1);
                return this;
            }
        },
        {
            key: "makeRotationX",
            value: function makeRotationX(theta) {
                var c = Math.cos(theta), s = Math.sin(theta);
                this.set(1, 0, 0, 0, 0, c, -s, 0, 0, s, c, 0, 0, 0, 0, 1);
                return this;
            }
        },
        {
            key: "makeRotationY",
            value: function makeRotationY(theta) {
                var c = Math.cos(theta), s = Math.sin(theta);
                this.set(c, 0, s, 0, 0, 1, 0, 0, -s, 0, c, 0, 0, 0, 0, 1);
                return this;
            }
        },
        {
            key: "makeRotationZ",
            value: function makeRotationZ(theta) {
                var c = Math.cos(theta), s = Math.sin(theta);
                this.set(c, -s, 0, 0, s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
                return this;
            }
        },
        {
            key: "makeRotationAxis",
            value: function makeRotationAxis(axis, angle) {
                // Based on http://www.gamedev.net/reference/articles/article1199.asp
                var c = Math.cos(angle);
                var s = Math.sin(angle);
                var t = 1 - c;
                var x = axis.x, y = axis.y, z = axis.z;
                var tx = t * x, ty = t * y;
                this.set(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
                return this;
            }
        },
        {
            key: "makeScale",
            value: function makeScale(x, y, z) {
                this.set(x, 0, 0, 0, 0, y, 0, 0, 0, 0, z, 0, 0, 0, 0, 1);
                return this;
            }
        },
        {
            key: "makeShear",
            value: function makeShear(xy, xz, yx, yz, zx, zy) {
                this.set(1, yx, zx, 0, xy, 1, zy, 0, xz, yz, 1, 0, 0, 0, 0, 1);
                return this;
            }
        },
        {
            key: "compose",
            value: function compose(position, quaternion, scale) {
                var te = this.elements;
                var x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
                var x2 = x + x, y2 = y + y, z2 = z + z;
                var xx = x * x2, xy = x * y2, xz = x * z2;
                var yy = y * y2, yz = y * z2, zz = z * z2;
                var wx = w * x2, wy = w * y2, wz = w * z2;
                var sx = scale.x, sy = scale.y, sz = scale.z;
                te[0] = (1 - (yy + zz)) * sx;
                te[1] = (xy + wz) * sx;
                te[2] = (xz - wy) * sx;
                te[3] = 0;
                te[4] = (xy - wz) * sy;
                te[5] = (1 - (xx + zz)) * sy;
                te[6] = (yz + wx) * sy;
                te[7] = 0;
                te[8] = (xz + wy) * sz;
                te[9] = (yz - wx) * sz;
                te[10] = (1 - (xx + yy)) * sz;
                te[11] = 0;
                te[12] = position.x;
                te[13] = position.y;
                te[14] = position.z;
                te[15] = 1;
                return this;
            }
        },
        {
            key: "decompose",
            value: function decompose(position, quaternion, scale) {
                var te = this.elements;
                var sx = $1a55656020b89c3a$var$_v1$5.set(te[0], te[1], te[2]).length();
                var sy = $1a55656020b89c3a$var$_v1$5.set(te[4], te[5], te[6]).length();
                var sz = $1a55656020b89c3a$var$_v1$5.set(te[8], te[9], te[10]).length();
                // if determine is negative, we need to invert one scale
                var det = this.determinant();
                if (det < 0) sx = -sx;
                position.x = te[12];
                position.y = te[13];
                position.z = te[14];
                // scale the rotation part
                $1a55656020b89c3a$var$_m1$2.copy(this);
                var invSX = 1 / sx;
                var invSY = 1 / sy;
                var invSZ = 1 / sz;
                $1a55656020b89c3a$var$_m1$2.elements[0] *= invSX;
                $1a55656020b89c3a$var$_m1$2.elements[1] *= invSX;
                $1a55656020b89c3a$var$_m1$2.elements[2] *= invSX;
                $1a55656020b89c3a$var$_m1$2.elements[4] *= invSY;
                $1a55656020b89c3a$var$_m1$2.elements[5] *= invSY;
                $1a55656020b89c3a$var$_m1$2.elements[6] *= invSY;
                $1a55656020b89c3a$var$_m1$2.elements[8] *= invSZ;
                $1a55656020b89c3a$var$_m1$2.elements[9] *= invSZ;
                $1a55656020b89c3a$var$_m1$2.elements[10] *= invSZ;
                quaternion.setFromRotationMatrix($1a55656020b89c3a$var$_m1$2);
                scale.x = sx;
                scale.y = sy;
                scale.z = sz;
                return this;
            }
        },
        {
            key: "makePerspective",
            value: function makePerspective(left, right, top, bottom, near, far) {
                var coordinateSystem = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : $1a55656020b89c3a$export$5a0e9190d10875d3;
                var te = this.elements;
                var x = 2 * near / (right - left);
                var y = 2 * near / (top - bottom);
                var a = (right + left) / (right - left);
                var b = (top + bottom) / (top - bottom);
                var c, d;
                if (coordinateSystem === $1a55656020b89c3a$export$5a0e9190d10875d3) {
                    c = -(far + near) / (far - near);
                    d = -2 * far * near / (far - near);
                } else if (coordinateSystem === $1a55656020b89c3a$export$cc83beedcb9be9ac) {
                    c = -far / (far - near);
                    d = -far * near / (far - near);
                } else throw new Error('THREE.Matrix4.makePerspective(): Invalid coordinate system: ' + coordinateSystem);
                te[0] = x;
                te[4] = 0;
                te[8] = a;
                te[12] = 0;
                te[1] = 0;
                te[5] = y;
                te[9] = b;
                te[13] = 0;
                te[2] = 0;
                te[6] = 0;
                te[10] = c;
                te[14] = d;
                te[3] = 0;
                te[7] = 0;
                te[11] = -1;
                te[15] = 0;
                return this;
            }
        },
        {
            key: "makeOrthographic",
            value: function makeOrthographic(left, right, top, bottom, near, far) {
                var coordinateSystem = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : $1a55656020b89c3a$export$5a0e9190d10875d3;
                var te = this.elements;
                var w = 1.0 / (right - left);
                var h = 1.0 / (top - bottom);
                var p = 1.0 / (far - near);
                var x = (right + left) * w;
                var y = (top + bottom) * h;
                var z, zInv;
                if (coordinateSystem === $1a55656020b89c3a$export$5a0e9190d10875d3) {
                    z = (far + near) * p;
                    zInv = -2 * p;
                } else if (coordinateSystem === $1a55656020b89c3a$export$cc83beedcb9be9ac) {
                    z = near * p;
                    zInv = -1 * p;
                } else throw new Error('THREE.Matrix4.makeOrthographic(): Invalid coordinate system: ' + coordinateSystem);
                te[0] = 2 * w;
                te[4] = 0;
                te[8] = 0;
                te[12] = -x;
                te[1] = 0;
                te[5] = 2 * h;
                te[9] = 0;
                te[13] = -y;
                te[2] = 0;
                te[6] = 0;
                te[10] = zInv;
                te[14] = -z;
                te[3] = 0;
                te[7] = 0;
                te[11] = 0;
                te[15] = 1;
                return this;
            }
        },
        {
            key: "equals",
            value: function equals(matrix) {
                var te = this.elements;
                var me = matrix.elements;
                for(var i = 0; i < 16; i++){
                    if (te[i] !== me[i]) return false;
                }
                return true;
            }
        },
        {
            key: "fromArray",
            value: function fromArray(array) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                for(var i = 0; i < 16; i++)this.elements[i] = array[i + offset];
                return this;
            }
        },
        {
            key: "toArray",
            value: function toArray() {
                var array = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var te = this.elements;
                array[offset] = te[0];
                array[offset + 1] = te[1];
                array[offset + 2] = te[2];
                array[offset + 3] = te[3];
                array[offset + 4] = te[4];
                array[offset + 5] = te[5];
                array[offset + 6] = te[6];
                array[offset + 7] = te[7];
                array[offset + 8] = te[8];
                array[offset + 9] = te[9];
                array[offset + 10] = te[10];
                array[offset + 11] = te[11];
                array[offset + 12] = te[12];
                array[offset + 13] = te[13];
                array[offset + 14] = te[14];
                array[offset + 15] = te[15];
                return array;
            }
        }
    ]);
    return Matrix4;
}();
var $1a55656020b89c3a$var$_v1$5 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_m1$2 = /*@__PURE__*/ new $1a55656020b89c3a$export$2ae72fc923e5eb5();
var $1a55656020b89c3a$var$_zero = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699(0, 0, 0);
var $1a55656020b89c3a$var$_one = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699(1, 1, 1);
var $1a55656020b89c3a$var$_x = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_y = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_z = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_matrix$2 = /*@__PURE__*/ new $1a55656020b89c3a$export$2ae72fc923e5eb5();
var $1a55656020b89c3a$var$_quaternion$3 = /*@__PURE__*/ new $1a55656020b89c3a$export$23d6a54f0bbc85a3();
var $1a55656020b89c3a$export$d93cc409a0768c5f = /*#__PURE__*/ function() {
    "use strict";
    function Euler() {
        var x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, z = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, order = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Euler.DEFAULT_ORDER;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Euler);
        this.isEuler = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Euler, [
        {
            key: "x",
            get: function get() {
                return this._x;
            },
            set: function set(value) {
                this._x = value;
                this._onChangeCallback();
            }
        },
        {
            key: "y",
            get: function get() {
                return this._y;
            },
            set: function set(value) {
                this._y = value;
                this._onChangeCallback();
            }
        },
        {
            key: "z",
            get: function get() {
                return this._z;
            },
            set: function set(value) {
                this._z = value;
                this._onChangeCallback();
            }
        },
        {
            key: "order",
            get: function get() {
                return this._order;
            },
            set: function set(value) {
                this._order = value;
                this._onChangeCallback();
            }
        },
        {
            key: "set",
            value: function set(x, y, z) {
                var order = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : this._order;
                this._x = x;
                this._y = y;
                this._z = z;
                this._order = order;
                this._onChangeCallback();
                return this;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor(this._x, this._y, this._z, this._order);
            }
        },
        {
            key: "copy",
            value: function copy(euler) {
                this._x = euler._x;
                this._y = euler._y;
                this._z = euler._z;
                this._order = euler._order;
                this._onChangeCallback();
                return this;
            }
        },
        {
            key: "setFromRotationMatrix",
            value: function setFromRotationMatrix(m) {
                var order = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._order, update = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
                var te = m.elements;
                var m11 = te[0], m12 = te[4], m13 = te[8];
                var m21 = te[1], m22 = te[5], m23 = te[9];
                var m31 = te[2], m32 = te[6], m33 = te[10];
                switch(order){
                    case 'XYZ':
                        this._y = Math.asin($1a55656020b89c3a$var$clamp(m13, -1, 1));
                        if (Math.abs(m13) < 0.9999999) {
                            this._x = Math.atan2(-m23, m33);
                            this._z = Math.atan2(-m12, m11);
                        } else {
                            this._x = Math.atan2(m32, m22);
                            this._z = 0;
                        }
                        break;
                    case 'YXZ':
                        this._x = Math.asin(-$1a55656020b89c3a$var$clamp(m23, -1, 1));
                        if (Math.abs(m23) < 0.9999999) {
                            this._y = Math.atan2(m13, m33);
                            this._z = Math.atan2(m21, m22);
                        } else {
                            this._y = Math.atan2(-m31, m11);
                            this._z = 0;
                        }
                        break;
                    case 'ZXY':
                        this._x = Math.asin($1a55656020b89c3a$var$clamp(m32, -1, 1));
                        if (Math.abs(m32) < 0.9999999) {
                            this._y = Math.atan2(-m31, m33);
                            this._z = Math.atan2(-m12, m22);
                        } else {
                            this._y = 0;
                            this._z = Math.atan2(m21, m11);
                        }
                        break;
                    case 'ZYX':
                        this._y = Math.asin(-$1a55656020b89c3a$var$clamp(m31, -1, 1));
                        if (Math.abs(m31) < 0.9999999) {
                            this._x = Math.atan2(m32, m33);
                            this._z = Math.atan2(m21, m11);
                        } else {
                            this._x = 0;
                            this._z = Math.atan2(-m12, m22);
                        }
                        break;
                    case 'YZX':
                        this._z = Math.asin($1a55656020b89c3a$var$clamp(m21, -1, 1));
                        if (Math.abs(m21) < 0.9999999) {
                            this._x = Math.atan2(-m23, m22);
                            this._y = Math.atan2(-m31, m11);
                        } else {
                            this._x = 0;
                            this._y = Math.atan2(m13, m33);
                        }
                        break;
                    case 'XZY':
                        this._z = Math.asin(-$1a55656020b89c3a$var$clamp(m12, -1, 1));
                        if (Math.abs(m12) < 0.9999999) {
                            this._x = Math.atan2(m32, m22);
                            this._y = Math.atan2(m13, m11);
                        } else {
                            this._x = Math.atan2(-m23, m33);
                            this._y = 0;
                        }
                        break;
                    default:
                        console.warn('THREE.Euler: .setFromRotationMatrix() encountered an unknown order: ' + order);
                }
                this._order = order;
                if (update === true) this._onChangeCallback();
                return this;
            }
        },
        {
            key: "setFromQuaternion",
            value: function setFromQuaternion(q, order, update) {
                $1a55656020b89c3a$var$_matrix$2.makeRotationFromQuaternion(q);
                return this.setFromRotationMatrix($1a55656020b89c3a$var$_matrix$2, order, update);
            }
        },
        {
            key: "setFromVector3",
            value: function setFromVector3(v) {
                var order = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._order;
                return this.set(v.x, v.y, v.z, order);
            }
        },
        {
            key: "reorder",
            value: function reorder(newOrder) {
                // WARNING: this discards revolution information -bhouston
                $1a55656020b89c3a$var$_quaternion$3.setFromEuler(this);
                return this.setFromQuaternion($1a55656020b89c3a$var$_quaternion$3, newOrder);
            }
        },
        {
            key: "equals",
            value: function equals(euler) {
                return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
            }
        },
        {
            key: "fromArray",
            value: function fromArray(array) {
                this._x = array[0];
                this._y = array[1];
                this._z = array[2];
                if (array[3] !== undefined) this._order = array[3];
                this._onChangeCallback();
                return this;
            }
        },
        {
            key: "toArray",
            value: function toArray() {
                var array = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                array[offset] = this._x;
                array[offset + 1] = this._y;
                array[offset + 2] = this._z;
                array[offset + 3] = this._order;
                return array;
            }
        },
        {
            key: "_onChange",
            value: function _onChange(callback) {
                this._onChangeCallback = callback;
                return this;
            }
        },
        {
            key: "_onChangeCallback",
            value: function _onChangeCallback() {}
        },
        {
            key: Symbol.iterator,
            value: function value() {
                return (0, $353b713f9392bb93$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                this._x
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                this._y
                            ];
                        case 2:
                            _state.sent();
                            return [
                                4,
                                this._z
                            ];
                        case 3:
                            _state.sent();
                            return [
                                4,
                                this._order
                            ];
                        case 4:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }
        }
    ]);
    return Euler;
}();
$1a55656020b89c3a$export$d93cc409a0768c5f.DEFAULT_ORDER = 'XYZ';
var $1a55656020b89c3a$export$89312ce47c0ca777 = /*#__PURE__*/ function() {
    "use strict";
    function Layers() {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Layers);
        this.mask = 1;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Layers, [
        {
            key: "set",
            value: function set(channel) {
                this.mask = (1 << channel | 0) >>> 0;
            }
        },
        {
            key: "enable",
            value: function enable(channel) {
                this.mask |= 1 << channel | 0;
            }
        },
        {
            key: "enableAll",
            value: function enableAll() {
                this.mask = -1;
            }
        },
        {
            key: "toggle",
            value: function toggle(channel) {
                this.mask ^= 1 << channel | 0;
            }
        },
        {
            key: "disable",
            value: function disable(channel) {
                this.mask &= ~(1 << channel | 0);
            }
        },
        {
            key: "disableAll",
            value: function disableAll() {
                this.mask = 0;
            }
        },
        {
            key: "test",
            value: function test(layers) {
                return (this.mask & layers.mask) !== 0;
            }
        },
        {
            key: "isEnabled",
            value: function isEnabled(channel) {
                return (this.mask & (1 << channel | 0)) !== 0;
            }
        }
    ]);
    return Layers;
}();
var $1a55656020b89c3a$var$_object3DId = 0;
var $1a55656020b89c3a$var$_v1$4 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_q1 = /*@__PURE__*/ new $1a55656020b89c3a$export$23d6a54f0bbc85a3();
var $1a55656020b89c3a$var$_m1$1 = /*@__PURE__*/ new $1a55656020b89c3a$export$2ae72fc923e5eb5();
var $1a55656020b89c3a$var$_target = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_position$3 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_scale$2 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_quaternion$2 = /*@__PURE__*/ new $1a55656020b89c3a$export$23d6a54f0bbc85a3();
var $1a55656020b89c3a$var$_xAxis = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699(1, 0, 0);
var $1a55656020b89c3a$var$_yAxis = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699(0, 1, 0);
var $1a55656020b89c3a$var$_zAxis = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699(0, 0, 1);
var $1a55656020b89c3a$var$_addedEvent = {
    type: 'added'
};
var $1a55656020b89c3a$var$_removedEvent = {
    type: 'removed'
};
var $1a55656020b89c3a$var$_childaddedEvent = {
    type: 'childadded',
    child: null
};
var $1a55656020b89c3a$var$_childremovedEvent = {
    type: 'childremoved',
    child: null
};
var $1a55656020b89c3a$export$e4dd07dff30cc924 = /*#__PURE__*/ function(EventDispatcher) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(Object3D, EventDispatcher);
    function Object3D() {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Object3D);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, Object3D);
        _this.isObject3D = true;
        Object.defineProperty(_this, 'id', {
            value: $1a55656020b89c3a$var$_object3DId++
        });
        _this.uuid = $1a55656020b89c3a$var$generateUUID();
        _this.name = '';
        _this.type = 'Object3D';
        _this.parent = null;
        _this.children = [];
        _this.up = Object3D.DEFAULT_UP.clone();
        var position = new $1a55656020b89c3a$export$64b5c384219d3699();
        var rotation = new $1a55656020b89c3a$export$d93cc409a0768c5f();
        var quaternion = new $1a55656020b89c3a$export$23d6a54f0bbc85a3();
        var scale = new $1a55656020b89c3a$export$64b5c384219d3699(1, 1, 1);
        function onRotationChange() {
            quaternion.setFromEuler(rotation, false);
        }
        function onQuaternionChange() {
            rotation.setFromQuaternion(quaternion, undefined, false);
        }
        rotation._onChange(onRotationChange);
        quaternion._onChange(onQuaternionChange);
        Object.defineProperties(_this, {
            position: {
                configurable: true,
                enumerable: true,
                value: position
            },
            rotation: {
                configurable: true,
                enumerable: true,
                value: rotation
            },
            quaternion: {
                configurable: true,
                enumerable: true,
                value: quaternion
            },
            scale: {
                configurable: true,
                enumerable: true,
                value: scale
            },
            modelViewMatrix: {
                value: new $1a55656020b89c3a$export$2ae72fc923e5eb5()
            },
            normalMatrix: {
                value: new $1a55656020b89c3a$export$8ff26dafa08918()
            }
        });
        _this.matrix = new $1a55656020b89c3a$export$2ae72fc923e5eb5();
        _this.matrixWorld = new $1a55656020b89c3a$export$2ae72fc923e5eb5();
        _this.matrixAutoUpdate = Object3D.DEFAULT_MATRIX_AUTO_UPDATE;
        _this.matrixWorldAutoUpdate = Object3D.DEFAULT_MATRIX_WORLD_AUTO_UPDATE; // checked by the renderer
        _this.matrixWorldNeedsUpdate = false;
        _this.layers = new $1a55656020b89c3a$export$89312ce47c0ca777();
        _this.visible = true;
        _this.castShadow = false;
        _this.receiveShadow = false;
        _this.frustumCulled = true;
        _this.renderOrder = 0;
        _this.animations = [];
        _this.userData = {};
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Object3D, [
        {
            key: "onBeforeShadow",
            value: function onBeforeShadow() {}
        },
        {
            key: "onAfterShadow",
            value: function onAfterShadow() {}
        },
        {
            key: "onBeforeRender",
            value: function onBeforeRender() {}
        },
        {
            key: "onAfterRender",
            value: function onAfterRender() {}
        },
        {
            key: "applyMatrix4",
            value: function applyMatrix4(matrix) {
                if (this.matrixAutoUpdate) this.updateMatrix();
                this.matrix.premultiply(matrix);
                this.matrix.decompose(this.position, this.quaternion, this.scale);
            }
        },
        {
            key: "applyQuaternion",
            value: function applyQuaternion(q) {
                this.quaternion.premultiply(q);
                return this;
            }
        },
        {
            key: "setRotationFromAxisAngle",
            value: function setRotationFromAxisAngle(axis, angle) {
                // assumes axis is normalized
                this.quaternion.setFromAxisAngle(axis, angle);
            }
        },
        {
            key: "setRotationFromEuler",
            value: function setRotationFromEuler(euler) {
                this.quaternion.setFromEuler(euler, true);
            }
        },
        {
            key: "setRotationFromMatrix",
            value: function setRotationFromMatrix(m) {
                // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
                this.quaternion.setFromRotationMatrix(m);
            }
        },
        {
            key: "setRotationFromQuaternion",
            value: function setRotationFromQuaternion(q) {
                // assumes q is normalized
                this.quaternion.copy(q);
            }
        },
        {
            key: "rotateOnAxis",
            value: function rotateOnAxis(axis, angle) {
                // rotate object on axis in object space
                // axis is assumed to be normalized
                $1a55656020b89c3a$var$_q1.setFromAxisAngle(axis, angle);
                this.quaternion.multiply($1a55656020b89c3a$var$_q1);
                return this;
            }
        },
        {
            key: "rotateOnWorldAxis",
            value: function rotateOnWorldAxis(axis, angle) {
                // rotate object on axis in world space
                // axis is assumed to be normalized
                // method assumes no rotated parent
                $1a55656020b89c3a$var$_q1.setFromAxisAngle(axis, angle);
                this.quaternion.premultiply($1a55656020b89c3a$var$_q1);
                return this;
            }
        },
        {
            key: "rotateX",
            value: function rotateX(angle) {
                return this.rotateOnAxis($1a55656020b89c3a$var$_xAxis, angle);
            }
        },
        {
            key: "rotateY",
            value: function rotateY(angle) {
                return this.rotateOnAxis($1a55656020b89c3a$var$_yAxis, angle);
            }
        },
        {
            key: "rotateZ",
            value: function rotateZ(angle) {
                return this.rotateOnAxis($1a55656020b89c3a$var$_zAxis, angle);
            }
        },
        {
            key: "translateOnAxis",
            value: function translateOnAxis(axis, distance) {
                // translate object by distance along axis in object space
                // axis is assumed to be normalized
                $1a55656020b89c3a$var$_v1$4.copy(axis).applyQuaternion(this.quaternion);
                this.position.add($1a55656020b89c3a$var$_v1$4.multiplyScalar(distance));
                return this;
            }
        },
        {
            key: "translateX",
            value: function translateX(distance) {
                return this.translateOnAxis($1a55656020b89c3a$var$_xAxis, distance);
            }
        },
        {
            key: "translateY",
            value: function translateY(distance) {
                return this.translateOnAxis($1a55656020b89c3a$var$_yAxis, distance);
            }
        },
        {
            key: "translateZ",
            value: function translateZ(distance) {
                return this.translateOnAxis($1a55656020b89c3a$var$_zAxis, distance);
            }
        },
        {
            key: "localToWorld",
            value: function localToWorld(vector) {
                this.updateWorldMatrix(true, false);
                return vector.applyMatrix4(this.matrixWorld);
            }
        },
        {
            key: "worldToLocal",
            value: function worldToLocal(vector) {
                this.updateWorldMatrix(true, false);
                return vector.applyMatrix4($1a55656020b89c3a$var$_m1$1.copy(this.matrixWorld).invert());
            }
        },
        {
            key: "lookAt",
            value: function lookAt(x, y, z) {
                // This method does not support objects having non-uniformly-scaled parent(s)
                if (x.isVector3) $1a55656020b89c3a$var$_target.copy(x);
                else $1a55656020b89c3a$var$_target.set(x, y, z);
                var parent = this.parent;
                this.updateWorldMatrix(true, false);
                $1a55656020b89c3a$var$_position$3.setFromMatrixPosition(this.matrixWorld);
                if (this.isCamera || this.isLight) $1a55656020b89c3a$var$_m1$1.lookAt($1a55656020b89c3a$var$_position$3, $1a55656020b89c3a$var$_target, this.up);
                else $1a55656020b89c3a$var$_m1$1.lookAt($1a55656020b89c3a$var$_target, $1a55656020b89c3a$var$_position$3, this.up);
                this.quaternion.setFromRotationMatrix($1a55656020b89c3a$var$_m1$1);
                if (parent) {
                    $1a55656020b89c3a$var$_m1$1.extractRotation(parent.matrixWorld);
                    $1a55656020b89c3a$var$_q1.setFromRotationMatrix($1a55656020b89c3a$var$_m1$1);
                    this.quaternion.premultiply($1a55656020b89c3a$var$_q1.invert());
                }
            }
        },
        {
            key: "add",
            value: function add(object) {
                if (arguments.length > 1) {
                    for(var i = 0; i < arguments.length; i++)this.add(arguments[i]);
                    return this;
                }
                if (object === this) {
                    console.error('THREE.Object3D.add: object can\'t be added as a child of itself.', object);
                    return this;
                }
                if (object && object.isObject3D) {
                    object.removeFromParent();
                    object.parent = this;
                    this.children.push(object);
                    object.dispatchEvent($1a55656020b89c3a$var$_addedEvent);
                    $1a55656020b89c3a$var$_childaddedEvent.child = object;
                    this.dispatchEvent($1a55656020b89c3a$var$_childaddedEvent);
                    $1a55656020b89c3a$var$_childaddedEvent.child = null;
                } else console.error('THREE.Object3D.add: object not an instance of THREE.Object3D.', object);
                return this;
            }
        },
        {
            key: "remove",
            value: function remove(object) {
                if (arguments.length > 1) {
                    for(var i = 0; i < arguments.length; i++)this.remove(arguments[i]);
                    return this;
                }
                var index = this.children.indexOf(object);
                if (index !== -1) {
                    object.parent = null;
                    this.children.splice(index, 1);
                    object.dispatchEvent($1a55656020b89c3a$var$_removedEvent);
                    $1a55656020b89c3a$var$_childremovedEvent.child = object;
                    this.dispatchEvent($1a55656020b89c3a$var$_childremovedEvent);
                    $1a55656020b89c3a$var$_childremovedEvent.child = null;
                }
                return this;
            }
        },
        {
            key: "removeFromParent",
            value: function removeFromParent() {
                var parent = this.parent;
                if (parent !== null) parent.remove(this);
                return this;
            }
        },
        {
            key: "clear",
            value: function clear() {
                return this.remove.apply(this, (0, $4fcd3d80e9e33ca7$export$71511d61b312f219)(this.children));
            }
        },
        {
            key: "attach",
            value: function attach(object) {
                // adds object as a child of this, while maintaining the object's world transform
                // Note: This method does not support scene graphs having non-uniformly-scaled nodes(s)
                this.updateWorldMatrix(true, false);
                $1a55656020b89c3a$var$_m1$1.copy(this.matrixWorld).invert();
                if (object.parent !== null) {
                    object.parent.updateWorldMatrix(true, false);
                    $1a55656020b89c3a$var$_m1$1.multiply(object.parent.matrixWorld);
                }
                object.applyMatrix4($1a55656020b89c3a$var$_m1$1);
                object.removeFromParent();
                object.parent = this;
                this.children.push(object);
                object.updateWorldMatrix(false, true);
                object.dispatchEvent($1a55656020b89c3a$var$_addedEvent);
                $1a55656020b89c3a$var$_childaddedEvent.child = object;
                this.dispatchEvent($1a55656020b89c3a$var$_childaddedEvent);
                $1a55656020b89c3a$var$_childaddedEvent.child = null;
                return this;
            }
        },
        {
            key: "getObjectById",
            value: function getObjectById(id) {
                return this.getObjectByProperty('id', id);
            }
        },
        {
            key: "getObjectByName",
            value: function getObjectByName(name) {
                return this.getObjectByProperty('name', name);
            }
        },
        {
            key: "getObjectByProperty",
            value: function getObjectByProperty(name, value) {
                if (this[name] === value) return this;
                for(var i = 0, l = this.children.length; i < l; i++){
                    var child = this.children[i];
                    var object = child.getObjectByProperty(name, value);
                    if (object !== undefined) return object;
                }
                return undefined;
            }
        },
        {
            key: "getObjectsByProperty",
            value: function getObjectsByProperty(name, value) {
                var result = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
                if (this[name] === value) result.push(this);
                var children = this.children;
                for(var i = 0, l = children.length; i < l; i++)children[i].getObjectsByProperty(name, value, result);
                return result;
            }
        },
        {
            key: "getWorldPosition",
            value: function getWorldPosition(target) {
                this.updateWorldMatrix(true, false);
                return target.setFromMatrixPosition(this.matrixWorld);
            }
        },
        {
            key: "getWorldQuaternion",
            value: function getWorldQuaternion(target) {
                this.updateWorldMatrix(true, false);
                this.matrixWorld.decompose($1a55656020b89c3a$var$_position$3, target, $1a55656020b89c3a$var$_scale$2);
                return target;
            }
        },
        {
            key: "getWorldScale",
            value: function getWorldScale(target) {
                this.updateWorldMatrix(true, false);
                this.matrixWorld.decompose($1a55656020b89c3a$var$_position$3, $1a55656020b89c3a$var$_quaternion$2, target);
                return target;
            }
        },
        {
            key: "getWorldDirection",
            value: function getWorldDirection(target) {
                this.updateWorldMatrix(true, false);
                var e = this.matrixWorld.elements;
                return target.set(e[8], e[9], e[10]).normalize();
            }
        },
        {
            key: "raycast",
            value: function raycast() {}
        },
        {
            key: "traverse",
            value: function traverse(callback) {
                callback(this);
                var children = this.children;
                for(var i = 0, l = children.length; i < l; i++)children[i].traverse(callback);
            }
        },
        {
            key: "traverseVisible",
            value: function traverseVisible(callback) {
                if (this.visible === false) return;
                callback(this);
                var children = this.children;
                for(var i = 0, l = children.length; i < l; i++)children[i].traverseVisible(callback);
            }
        },
        {
            key: "traverseAncestors",
            value: function traverseAncestors(callback) {
                var parent = this.parent;
                if (parent !== null) {
                    callback(parent);
                    parent.traverseAncestors(callback);
                }
            }
        },
        {
            key: "updateMatrix",
            value: function updateMatrix() {
                this.matrix.compose(this.position, this.quaternion, this.scale);
                this.matrixWorldNeedsUpdate = true;
            }
        },
        {
            key: "updateMatrixWorld",
            value: function updateMatrixWorld(force) {
                if (this.matrixAutoUpdate) this.updateMatrix();
                if (this.matrixWorldNeedsUpdate || force) {
                    if (this.matrixWorldAutoUpdate === true) {
                        if (this.parent === null) this.matrixWorld.copy(this.matrix);
                        else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
                    }
                    this.matrixWorldNeedsUpdate = false;
                    force = true;
                }
                // make sure descendants are updated if required
                var children = this.children;
                for(var i = 0, l = children.length; i < l; i++){
                    var child = children[i];
                    child.updateMatrixWorld(force);
                }
            }
        },
        {
            key: "updateWorldMatrix",
            value: function updateWorldMatrix(updateParents, updateChildren) {
                var parent = this.parent;
                if (updateParents === true && parent !== null) parent.updateWorldMatrix(true, false);
                if (this.matrixAutoUpdate) this.updateMatrix();
                if (this.matrixWorldAutoUpdate === true) {
                    if (this.parent === null) this.matrixWorld.copy(this.matrix);
                    else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
                }
                // make sure descendants are updated
                if (updateChildren === true) {
                    var children = this.children;
                    for(var i = 0, l = children.length; i < l; i++){
                        var child = children[i];
                        child.updateWorldMatrix(false, true);
                    }
                }
            }
        },
        {
            key: "toJSON",
            value: function toJSON(meta) {
                // meta is a string when called from JSON.stringify
                var isRootObject = meta === undefined || typeof meta === 'string';
                var output = {};
                // meta is a hash used to collect geometries, materials.
                // not providing it implies that this is the root object
                // being serialized.
                if (isRootObject) {
                    // initialize meta obj
                    meta = {
                        geometries: {},
                        materials: {},
                        textures: {},
                        images: {},
                        shapes: {},
                        skeletons: {},
                        animations: {},
                        nodes: {}
                    };
                    output.metadata = {
                        version: 4.6,
                        type: 'Object',
                        generator: 'Object3D.toJSON'
                    };
                }
                // standard Object3D serialization
                var object = {};
                object.uuid = this.uuid;
                object.type = this.type;
                if (this.name !== '') object.name = this.name;
                if (this.castShadow === true) object.castShadow = true;
                if (this.receiveShadow === true) object.receiveShadow = true;
                if (this.visible === false) object.visible = false;
                if (this.frustumCulled === false) object.frustumCulled = false;
                if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
                if (Object.keys(this.userData).length > 0) object.userData = this.userData;
                object.layers = this.layers.mask;
                object.matrix = this.matrix.toArray();
                object.up = this.up.toArray();
                if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false;
                // object specific properties
                if (this.isInstancedMesh) {
                    object.type = 'InstancedMesh';
                    object.count = this.count;
                    object.instanceMatrix = this.instanceMatrix.toJSON();
                    if (this.instanceColor !== null) object.instanceColor = this.instanceColor.toJSON();
                }
                if (this.isBatchedMesh) {
                    object.type = 'BatchedMesh';
                    object.perObjectFrustumCulled = this.perObjectFrustumCulled;
                    object.sortObjects = this.sortObjects;
                    object.drawRanges = this._drawRanges;
                    object.reservedRanges = this._reservedRanges;
                    object.visibility = this._visibility;
                    object.active = this._active;
                    object.bounds = this._bounds.map(function(bound) {
                        return {
                            boxInitialized: bound.boxInitialized,
                            boxMin: bound.box.min.toArray(),
                            boxMax: bound.box.max.toArray(),
                            sphereInitialized: bound.sphereInitialized,
                            sphereRadius: bound.sphere.radius,
                            sphereCenter: bound.sphere.center.toArray()
                        };
                    });
                    object.maxInstanceCount = this._maxInstanceCount;
                    object.maxVertexCount = this._maxVertexCount;
                    object.maxIndexCount = this._maxIndexCount;
                    object.geometryInitialized = this._geometryInitialized;
                    object.geometryCount = this._geometryCount;
                    object.matricesTexture = this._matricesTexture.toJSON(meta);
                    if (this._colorsTexture !== null) object.colorsTexture = this._colorsTexture.toJSON(meta);
                    if (this.boundingSphere !== null) object.boundingSphere = {
                        center: object.boundingSphere.center.toArray(),
                        radius: object.boundingSphere.radius
                    };
                    if (this.boundingBox !== null) object.boundingBox = {
                        min: object.boundingBox.min.toArray(),
                        max: object.boundingBox.max.toArray()
                    };
                }
                //
                function serialize(library, element) {
                    if (library[element.uuid] === undefined) library[element.uuid] = element.toJSON(meta);
                    return element.uuid;
                }
                if (this.isScene) {
                    if (this.background) {
                        if (this.background.isColor) object.background = this.background.toJSON();
                        else if (this.background.isTexture) object.background = this.background.toJSON(meta).uuid;
                    }
                    if (this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== true) object.environment = this.environment.toJSON(meta).uuid;
                } else if (this.isMesh || this.isLine || this.isPoints) {
                    object.geometry = serialize(meta.geometries, this.geometry);
                    var parameters = this.geometry.parameters;
                    if (parameters !== undefined && parameters.shapes !== undefined) {
                        var shapes = parameters.shapes;
                        if (Array.isArray(shapes)) for(var i = 0, l = shapes.length; i < l; i++){
                            var shape = shapes[i];
                            serialize(meta.shapes, shape);
                        }
                        else serialize(meta.shapes, shapes);
                    }
                }
                if (this.isSkinnedMesh) {
                    object.bindMode = this.bindMode;
                    object.bindMatrix = this.bindMatrix.toArray();
                    if (this.skeleton !== undefined) {
                        serialize(meta.skeletons, this.skeleton);
                        object.skeleton = this.skeleton.uuid;
                    }
                }
                if (this.material !== undefined) {
                    if (Array.isArray(this.material)) {
                        var uuids = [];
                        for(var i1 = 0, l1 = this.material.length; i1 < l1; i1++)uuids.push(serialize(meta.materials, this.material[i1]));
                        object.material = uuids;
                    } else object.material = serialize(meta.materials, this.material);
                }
                //
                if (this.children.length > 0) {
                    object.children = [];
                    for(var i2 = 0; i2 < this.children.length; i2++)object.children.push(this.children[i2].toJSON(meta).object);
                }
                //
                if (this.animations.length > 0) {
                    object.animations = [];
                    for(var i3 = 0; i3 < this.animations.length; i3++){
                        var animation = this.animations[i3];
                        object.animations.push(serialize(meta.animations, animation));
                    }
                }
                if (isRootObject) {
                    var geometries = extractFromCache(meta.geometries);
                    var materials = extractFromCache(meta.materials);
                    var textures = extractFromCache(meta.textures);
                    var images = extractFromCache(meta.images);
                    var shapes1 = extractFromCache(meta.shapes);
                    var skeletons = extractFromCache(meta.skeletons);
                    var animations = extractFromCache(meta.animations);
                    var nodes = extractFromCache(meta.nodes);
                    if (geometries.length > 0) output.geometries = geometries;
                    if (materials.length > 0) output.materials = materials;
                    if (textures.length > 0) output.textures = textures;
                    if (images.length > 0) output.images = images;
                    if (shapes1.length > 0) output.shapes = shapes1;
                    if (skeletons.length > 0) output.skeletons = skeletons;
                    if (animations.length > 0) output.animations = animations;
                    if (nodes.length > 0) output.nodes = nodes;
                }
                output.object = object;
                return output;
                // extract data from the cache hash
                // remove metadata on each item
                // and return as array
                function extractFromCache(cache) {
                    var values = [];
                    for(var key in cache){
                        var data = cache[key];
                        delete data.metadata;
                        values.push(data);
                    }
                    return values;
                }
            }
        },
        {
            key: "clone",
            value: function clone(recursive) {
                return new this.constructor().copy(this, recursive);
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                var recursive = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                this.name = source.name;
                this.up.copy(source.up);
                this.position.copy(source.position);
                this.rotation.order = source.rotation.order;
                this.quaternion.copy(source.quaternion);
                this.scale.copy(source.scale);
                this.matrix.copy(source.matrix);
                this.matrixWorld.copy(source.matrixWorld);
                this.matrixAutoUpdate = source.matrixAutoUpdate;
                this.matrixWorldAutoUpdate = source.matrixWorldAutoUpdate;
                this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
                this.layers.mask = source.layers.mask;
                this.visible = source.visible;
                this.castShadow = source.castShadow;
                this.receiveShadow = source.receiveShadow;
                this.frustumCulled = source.frustumCulled;
                this.renderOrder = source.renderOrder;
                this.animations = source.animations.slice();
                this.userData = JSON.parse(JSON.stringify(source.userData));
                if (recursive === true) for(var i = 0; i < source.children.length; i++){
                    var child = source.children[i];
                    this.add(child.clone());
                }
                return this;
            }
        }
    ]);
    return Object3D;
}($1a55656020b89c3a$export$ec8b666c5fe2c75a);
$1a55656020b89c3a$export$e4dd07dff30cc924.DEFAULT_UP = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699(0, 1, 0);
$1a55656020b89c3a$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE = true;
$1a55656020b89c3a$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = true;
var $1a55656020b89c3a$var$_v0$1 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_v1$3 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_v2$2 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_v3$2 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_vab = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_vac = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_vbc = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_vap = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_vbp = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_vcp = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_v40 = /*@__PURE__*/ new $1a55656020b89c3a$export$fa7daccca11cdbe3();
var $1a55656020b89c3a$var$_v41 = /*@__PURE__*/ new $1a55656020b89c3a$export$fa7daccca11cdbe3();
var $1a55656020b89c3a$var$_v42 = /*@__PURE__*/ new $1a55656020b89c3a$export$fa7daccca11cdbe3();
var $1a55656020b89c3a$export$5a465592bfe74b48 = /*#__PURE__*/ function() {
    "use strict";
    function Triangle() {
        var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $1a55656020b89c3a$export$64b5c384219d3699(), b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $1a55656020b89c3a$export$64b5c384219d3699(), c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new $1a55656020b89c3a$export$64b5c384219d3699();
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Triangle);
        this.a = a;
        this.b = b;
        this.c = c;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Triangle, [
        {
            key: "set",
            value: function set(a, b, c) {
                this.a.copy(a);
                this.b.copy(b);
                this.c.copy(c);
                return this;
            }
        },
        {
            key: "setFromPointsAndIndices",
            value: function setFromPointsAndIndices(points, i0, i1, i2) {
                this.a.copy(points[i0]);
                this.b.copy(points[i1]);
                this.c.copy(points[i2]);
                return this;
            }
        },
        {
            key: "setFromAttributeAndIndices",
            value: function setFromAttributeAndIndices(attribute, i0, i1, i2) {
                this.a.fromBufferAttribute(attribute, i0);
                this.b.fromBufferAttribute(attribute, i1);
                this.c.fromBufferAttribute(attribute, i2);
                return this;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        },
        {
            key: "copy",
            value: function copy(triangle) {
                this.a.copy(triangle.a);
                this.b.copy(triangle.b);
                this.c.copy(triangle.c);
                return this;
            }
        },
        {
            key: "getArea",
            value: function getArea() {
                $1a55656020b89c3a$var$_v0$1.subVectors(this.c, this.b);
                $1a55656020b89c3a$var$_v1$3.subVectors(this.a, this.b);
                return $1a55656020b89c3a$var$_v0$1.cross($1a55656020b89c3a$var$_v1$3).length() * 0.5;
            }
        },
        {
            key: "getMidpoint",
            value: function getMidpoint(target) {
                return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
            }
        },
        {
            key: "getNormal",
            value: function getNormal(target) {
                return Triangle.getNormal(this.a, this.b, this.c, target);
            }
        },
        {
            key: "getPlane",
            value: function getPlane(target) {
                return target.setFromCoplanarPoints(this.a, this.b, this.c);
            }
        },
        {
            key: "getBarycoord",
            value: function getBarycoord(point, target) {
                return Triangle.getBarycoord(point, this.a, this.b, this.c, target);
            }
        },
        {
            key: "getInterpolation",
            value: function getInterpolation(point, v1, v2, v3, target) {
                return Triangle.getInterpolation(point, this.a, this.b, this.c, v1, v2, v3, target);
            }
        },
        {
            key: "containsPoint",
            value: function containsPoint(point) {
                return Triangle.containsPoint(point, this.a, this.b, this.c);
            }
        },
        {
            key: "isFrontFacing",
            value: function isFrontFacing(direction) {
                return Triangle.isFrontFacing(this.a, this.b, this.c, direction);
            }
        },
        {
            key: "intersectsBox",
            value: function intersectsBox(box) {
                return box.intersectsTriangle(this);
            }
        },
        {
            key: "closestPointToPoint",
            value: function closestPointToPoint(p, target) {
                var a = this.a, b = this.b, c = this.c;
                var v, w;
                // algorithm thanks to Real-Time Collision Detection by Christer Ericson,
                // published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
                // under the accompanying license; see chapter 5.1.5 for detailed explanation.
                // basically, we're distinguishing which of the voronoi regions of the triangle
                // the point lies in with the minimum amount of redundant computation.
                $1a55656020b89c3a$var$_vab.subVectors(b, a);
                $1a55656020b89c3a$var$_vac.subVectors(c, a);
                $1a55656020b89c3a$var$_vap.subVectors(p, a);
                var d1 = $1a55656020b89c3a$var$_vab.dot($1a55656020b89c3a$var$_vap);
                var d2 = $1a55656020b89c3a$var$_vac.dot($1a55656020b89c3a$var$_vap);
                if (d1 <= 0 && d2 <= 0) // vertex region of A; barycentric coords (1, 0, 0)
                return target.copy(a);
                $1a55656020b89c3a$var$_vbp.subVectors(p, b);
                var d3 = $1a55656020b89c3a$var$_vab.dot($1a55656020b89c3a$var$_vbp);
                var d4 = $1a55656020b89c3a$var$_vac.dot($1a55656020b89c3a$var$_vbp);
                if (d3 >= 0 && d4 <= d3) // vertex region of B; barycentric coords (0, 1, 0)
                return target.copy(b);
                var vc = d1 * d4 - d3 * d2;
                if (vc <= 0 && d1 >= 0 && d3 <= 0) {
                    v = d1 / (d1 - d3);
                    // edge region of AB; barycentric coords (1-v, v, 0)
                    return target.copy(a).addScaledVector($1a55656020b89c3a$var$_vab, v);
                }
                $1a55656020b89c3a$var$_vcp.subVectors(p, c);
                var d5 = $1a55656020b89c3a$var$_vab.dot($1a55656020b89c3a$var$_vcp);
                var d6 = $1a55656020b89c3a$var$_vac.dot($1a55656020b89c3a$var$_vcp);
                if (d6 >= 0 && d5 <= d6) // vertex region of C; barycentric coords (0, 0, 1)
                return target.copy(c);
                var vb = d5 * d2 - d1 * d6;
                if (vb <= 0 && d2 >= 0 && d6 <= 0) {
                    w = d2 / (d2 - d6);
                    // edge region of AC; barycentric coords (1-w, 0, w)
                    return target.copy(a).addScaledVector($1a55656020b89c3a$var$_vac, w);
                }
                var va = d3 * d6 - d5 * d4;
                if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
                    $1a55656020b89c3a$var$_vbc.subVectors(c, b);
                    w = (d4 - d3) / (d4 - d3 + (d5 - d6));
                    // edge region of BC; barycentric coords (0, 1-w, w)
                    return target.copy(b).addScaledVector($1a55656020b89c3a$var$_vbc, w); // edge region of BC
                }
                // face region
                var denom = 1 / (va + vb + vc);
                // u = va * denom
                v = vb * denom;
                w = vc * denom;
                return target.copy(a).addScaledVector($1a55656020b89c3a$var$_vab, v).addScaledVector($1a55656020b89c3a$var$_vac, w);
            }
        },
        {
            key: "equals",
            value: function equals(triangle) {
                return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
            }
        }
    ], [
        {
            key: "getNormal",
            value: function getNormal(a, b, c, target) {
                target.subVectors(c, b);
                $1a55656020b89c3a$var$_v0$1.subVectors(a, b);
                target.cross($1a55656020b89c3a$var$_v0$1);
                var targetLengthSq = target.lengthSq();
                if (targetLengthSq > 0) return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
                return target.set(0, 0, 0);
            }
        },
        {
            key: "getBarycoord",
            value: // static/instance method to calculate barycentric coordinates
            // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
            function getBarycoord(point, a, b, c, target) {
                $1a55656020b89c3a$var$_v0$1.subVectors(c, a);
                $1a55656020b89c3a$var$_v1$3.subVectors(b, a);
                $1a55656020b89c3a$var$_v2$2.subVectors(point, a);
                var dot00 = $1a55656020b89c3a$var$_v0$1.dot($1a55656020b89c3a$var$_v0$1);
                var dot01 = $1a55656020b89c3a$var$_v0$1.dot($1a55656020b89c3a$var$_v1$3);
                var dot02 = $1a55656020b89c3a$var$_v0$1.dot($1a55656020b89c3a$var$_v2$2);
                var dot11 = $1a55656020b89c3a$var$_v1$3.dot($1a55656020b89c3a$var$_v1$3);
                var dot12 = $1a55656020b89c3a$var$_v1$3.dot($1a55656020b89c3a$var$_v2$2);
                var denom = dot00 * dot11 - dot01 * dot01;
                // collinear or singular triangle
                if (denom === 0) {
                    target.set(0, 0, 0);
                    return null;
                }
                var invDenom = 1 / denom;
                var u = (dot11 * dot02 - dot01 * dot12) * invDenom;
                var v = (dot00 * dot12 - dot01 * dot02) * invDenom;
                // barycentric coordinates must always sum to 1
                return target.set(1 - u - v, v, u);
            }
        },
        {
            key: "containsPoint",
            value: function containsPoint(point, a, b, c) {
                // if the triangle is degenerate then we can't contain a point
                if (this.getBarycoord(point, a, b, c, $1a55656020b89c3a$var$_v3$2) === null) return false;
                return $1a55656020b89c3a$var$_v3$2.x >= 0 && $1a55656020b89c3a$var$_v3$2.y >= 0 && $1a55656020b89c3a$var$_v3$2.x + $1a55656020b89c3a$var$_v3$2.y <= 1;
            }
        },
        {
            key: "getInterpolation",
            value: function getInterpolation(point, p1, p2, p3, v1, v2, v3, target) {
                if (this.getBarycoord(point, p1, p2, p3, $1a55656020b89c3a$var$_v3$2) === null) {
                    target.x = 0;
                    target.y = 0;
                    if ('z' in target) target.z = 0;
                    if ('w' in target) target.w = 0;
                    return null;
                }
                target.setScalar(0);
                target.addScaledVector(v1, $1a55656020b89c3a$var$_v3$2.x);
                target.addScaledVector(v2, $1a55656020b89c3a$var$_v3$2.y);
                target.addScaledVector(v3, $1a55656020b89c3a$var$_v3$2.z);
                return target;
            }
        },
        {
            key: "getInterpolatedAttribute",
            value: function getInterpolatedAttribute(attr, i1, i2, i3, barycoord, target) {
                $1a55656020b89c3a$var$_v40.setScalar(0);
                $1a55656020b89c3a$var$_v41.setScalar(0);
                $1a55656020b89c3a$var$_v42.setScalar(0);
                $1a55656020b89c3a$var$_v40.fromBufferAttribute(attr, i1);
                $1a55656020b89c3a$var$_v41.fromBufferAttribute(attr, i2);
                $1a55656020b89c3a$var$_v42.fromBufferAttribute(attr, i3);
                target.setScalar(0);
                target.addScaledVector($1a55656020b89c3a$var$_v40, barycoord.x);
                target.addScaledVector($1a55656020b89c3a$var$_v41, barycoord.y);
                target.addScaledVector($1a55656020b89c3a$var$_v42, barycoord.z);
                return target;
            }
        },
        {
            key: "isFrontFacing",
            value: function isFrontFacing(a, b, c, direction) {
                $1a55656020b89c3a$var$_v0$1.subVectors(c, b);
                $1a55656020b89c3a$var$_v1$3.subVectors(a, b);
                // strictly front facing
                return $1a55656020b89c3a$var$_v0$1.cross($1a55656020b89c3a$var$_v1$3).dot(direction) < 0 ? true : false;
            }
        }
    ]);
    return Triangle;
}();
var $1a55656020b89c3a$var$_colorKeywords = {
    'aliceblue': 0xF0F8FF,
    'antiquewhite': 0xFAEBD7,
    'aqua': 0x00FFFF,
    'aquamarine': 0x7FFFD4,
    'azure': 0xF0FFFF,
    'beige': 0xF5F5DC,
    'bisque': 0xFFE4C4,
    'black': 0x000000,
    'blanchedalmond': 0xFFEBCD,
    'blue': 0x0000FF,
    'blueviolet': 0x8A2BE2,
    'brown': 0xA52A2A,
    'burlywood': 0xDEB887,
    'cadetblue': 0x5F9EA0,
    'chartreuse': 0x7FFF00,
    'chocolate': 0xD2691E,
    'coral': 0xFF7F50,
    'cornflowerblue': 0x6495ED,
    'cornsilk': 0xFFF8DC,
    'crimson': 0xDC143C,
    'cyan': 0x00FFFF,
    'darkblue': 0x00008B,
    'darkcyan': 0x008B8B,
    'darkgoldenrod': 0xB8860B,
    'darkgray': 0xA9A9A9,
    'darkgreen': 0x006400,
    'darkgrey': 0xA9A9A9,
    'darkkhaki': 0xBDB76B,
    'darkmagenta': 0x8B008B,
    'darkolivegreen': 0x556B2F,
    'darkorange': 0xFF8C00,
    'darkorchid': 0x9932CC,
    'darkred': 0x8B0000,
    'darksalmon': 0xE9967A,
    'darkseagreen': 0x8FBC8F,
    'darkslateblue': 0x483D8B,
    'darkslategray': 0x2F4F4F,
    'darkslategrey': 0x2F4F4F,
    'darkturquoise': 0x00CED1,
    'darkviolet': 0x9400D3,
    'deeppink': 0xFF1493,
    'deepskyblue': 0x00BFFF,
    'dimgray': 0x696969,
    'dimgrey': 0x696969,
    'dodgerblue': 0x1E90FF,
    'firebrick': 0xB22222,
    'floralwhite': 0xFFFAF0,
    'forestgreen': 0x228B22,
    'fuchsia': 0xFF00FF,
    'gainsboro': 0xDCDCDC,
    'ghostwhite': 0xF8F8FF,
    'gold': 0xFFD700,
    'goldenrod': 0xDAA520,
    'gray': 0x808080,
    'green': 0x008000,
    'greenyellow': 0xADFF2F,
    'grey': 0x808080,
    'honeydew': 0xF0FFF0,
    'hotpink': 0xFF69B4,
    'indianred': 0xCD5C5C,
    'indigo': 0x4B0082,
    'ivory': 0xFFFFF0,
    'khaki': 0xF0E68C,
    'lavender': 0xE6E6FA,
    'lavenderblush': 0xFFF0F5,
    'lawngreen': 0x7CFC00,
    'lemonchiffon': 0xFFFACD,
    'lightblue': 0xADD8E6,
    'lightcoral': 0xF08080,
    'lightcyan': 0xE0FFFF,
    'lightgoldenrodyellow': 0xFAFAD2,
    'lightgray': 0xD3D3D3,
    'lightgreen': 0x90EE90,
    'lightgrey': 0xD3D3D3,
    'lightpink': 0xFFB6C1,
    'lightsalmon': 0xFFA07A,
    'lightseagreen': 0x20B2AA,
    'lightskyblue': 0x87CEFA,
    'lightslategray': 0x778899,
    'lightslategrey': 0x778899,
    'lightsteelblue': 0xB0C4DE,
    'lightyellow': 0xFFFFE0,
    'lime': 0x00FF00,
    'limegreen': 0x32CD32,
    'linen': 0xFAF0E6,
    'magenta': 0xFF00FF,
    'maroon': 0x800000,
    'mediumaquamarine': 0x66CDAA,
    'mediumblue': 0x0000CD,
    'mediumorchid': 0xBA55D3,
    'mediumpurple': 0x9370DB,
    'mediumseagreen': 0x3CB371,
    'mediumslateblue': 0x7B68EE,
    'mediumspringgreen': 0x00FA9A,
    'mediumturquoise': 0x48D1CC,
    'mediumvioletred': 0xC71585,
    'midnightblue': 0x191970,
    'mintcream': 0xF5FFFA,
    'mistyrose': 0xFFE4E1,
    'moccasin': 0xFFE4B5,
    'navajowhite': 0xFFDEAD,
    'navy': 0x000080,
    'oldlace': 0xFDF5E6,
    'olive': 0x808000,
    'olivedrab': 0x6B8E23,
    'orange': 0xFFA500,
    'orangered': 0xFF4500,
    'orchid': 0xDA70D6,
    'palegoldenrod': 0xEEE8AA,
    'palegreen': 0x98FB98,
    'paleturquoise': 0xAFEEEE,
    'palevioletred': 0xDB7093,
    'papayawhip': 0xFFEFD5,
    'peachpuff': 0xFFDAB9,
    'peru': 0xCD853F,
    'pink': 0xFFC0CB,
    'plum': 0xDDA0DD,
    'powderblue': 0xB0E0E6,
    'purple': 0x800080,
    'rebeccapurple': 0x663399,
    'red': 0xFF0000,
    'rosybrown': 0xBC8F8F,
    'royalblue': 0x4169E1,
    'saddlebrown': 0x8B4513,
    'salmon': 0xFA8072,
    'sandybrown': 0xF4A460,
    'seagreen': 0x2E8B57,
    'seashell': 0xFFF5EE,
    'sienna': 0xA0522D,
    'silver': 0xC0C0C0,
    'skyblue': 0x87CEEB,
    'slateblue': 0x6A5ACD,
    'slategray': 0x708090,
    'slategrey': 0x708090,
    'snow': 0xFFFAFA,
    'springgreen': 0x00FF7F,
    'steelblue': 0x4682B4,
    'tan': 0xD2B48C,
    'teal': 0x008080,
    'thistle': 0xD8BFD8,
    'tomato': 0xFF6347,
    'turquoise': 0x40E0D0,
    'violet': 0xEE82EE,
    'wheat': 0xF5DEB3,
    'white': 0xFFFFFF,
    'whitesmoke': 0xF5F5F5,
    'yellow': 0xFFFF00,
    'yellowgreen': 0x9ACD32
};
var $1a55656020b89c3a$var$_hslA = {
    h: 0,
    s: 0,
    l: 0
};
var $1a55656020b89c3a$var$_hslB = {
    h: 0,
    s: 0,
    l: 0
};
function $1a55656020b89c3a$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
    return p;
}
var $1a55656020b89c3a$export$892596cec99bc70e = /*#__PURE__*/ function() {
    "use strict";
    function Color(r, g, b) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Color);
        this.isColor = true;
        this.r = 1;
        this.g = 1;
        this.b = 1;
        return this.set(r, g, b);
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Color, [
        {
            key: "set",
            value: function set(r, g, b) {
                if (g === undefined && b === undefined) {
                    // r is THREE.Color, hex or string
                    var value = r;
                    if (value && value.isColor) this.copy(value);
                    else if (typeof value === 'number') this.setHex(value);
                    else if (typeof value === 'string') this.setStyle(value);
                } else this.setRGB(r, g, b);
                return this;
            }
        },
        {
            key: "setScalar",
            value: function setScalar(scalar) {
                this.r = scalar;
                this.g = scalar;
                this.b = scalar;
                return this;
            }
        },
        {
            key: "setHex",
            value: function setHex(hex) {
                var colorSpace = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1a55656020b89c3a$export$561f394b24edfcaa;
                hex = Math.floor(hex);
                this.r = (hex >> 16 & 255) / 255;
                this.g = (hex >> 8 & 255) / 255;
                this.b = (hex & 255) / 255;
                $1a55656020b89c3a$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace);
                return this;
            }
        },
        {
            key: "setRGB",
            value: function setRGB(r, g, b) {
                var colorSpace = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $1a55656020b89c3a$export$5e6fd513f44698c.workingColorSpace;
                this.r = r;
                this.g = g;
                this.b = b;
                $1a55656020b89c3a$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace);
                return this;
            }
        },
        {
            key: "setHSL",
            value: function setHSL(h, s, l) {
                var colorSpace = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $1a55656020b89c3a$export$5e6fd513f44698c.workingColorSpace;
                // h,s,l ranges are in 0.0 - 1.0
                h = $1a55656020b89c3a$var$euclideanModulo(h, 1);
                s = $1a55656020b89c3a$var$clamp(s, 0, 1);
                l = $1a55656020b89c3a$var$clamp(l, 0, 1);
                if (s === 0) this.r = this.g = this.b = l;
                else {
                    var p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
                    var q = 2 * l - p;
                    this.r = $1a55656020b89c3a$var$hue2rgb(q, p, h + 1 / 3);
                    this.g = $1a55656020b89c3a$var$hue2rgb(q, p, h);
                    this.b = $1a55656020b89c3a$var$hue2rgb(q, p, h - 1 / 3);
                }
                $1a55656020b89c3a$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace);
                return this;
            }
        },
        {
            key: "setStyle",
            value: function setStyle(style) {
                var colorSpace = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1a55656020b89c3a$export$561f394b24edfcaa;
                function handleAlpha(string) {
                    if (string === undefined) return;
                    if (parseFloat(string) < 1) console.warn('THREE.Color: Alpha component of ' + style + ' will be ignored.');
                }
                var m;
                if (m = /^(\w+)\(([^\)]*)\)/.exec(style)) {
                    // rgb / hsl
                    var color;
                    var name = m[1];
                    var components = m[2];
                    switch(name){
                        case 'rgb':
                        case 'rgba':
                            if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                                // rgb(255,0,0) rgba(255,0,0,0.5)
                                handleAlpha(color[4]);
                                return this.setRGB(Math.min(255, parseInt(color[1], 10)) / 255, Math.min(255, parseInt(color[2], 10)) / 255, Math.min(255, parseInt(color[3], 10)) / 255, colorSpace);
                            }
                            if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                                // rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
                                handleAlpha(color[4]);
                                return this.setRGB(Math.min(100, parseInt(color[1], 10)) / 100, Math.min(100, parseInt(color[2], 10)) / 100, Math.min(100, parseInt(color[3], 10)) / 100, colorSpace);
                            }
                            break;
                        case 'hsl':
                        case 'hsla':
                            if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                                // hsl(120,50%,50%) hsla(120,50%,50%,0.5)
                                handleAlpha(color[4]);
                                return this.setHSL(parseFloat(color[1]) / 360, parseFloat(color[2]) / 100, parseFloat(color[3]) / 100, colorSpace);
                            }
                            break;
                        default:
                            console.warn('THREE.Color: Unknown color model ' + style);
                    }
                } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
                    // hex color
                    var hex = m[1];
                    var size = hex.length;
                    if (size === 3) // #ff0
                    return this.setRGB(parseInt(hex.charAt(0), 16) / 15, parseInt(hex.charAt(1), 16) / 15, parseInt(hex.charAt(2), 16) / 15, colorSpace);
                    else if (size === 6) // #ff0000
                    return this.setHex(parseInt(hex, 16), colorSpace);
                    else console.warn('THREE.Color: Invalid hex color ' + style);
                } else if (style && style.length > 0) return this.setColorName(style, colorSpace);
                return this;
            }
        },
        {
            key: "setColorName",
            value: function setColorName(style) {
                var colorSpace = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1a55656020b89c3a$export$561f394b24edfcaa;
                // color keywords
                var hex = $1a55656020b89c3a$var$_colorKeywords[style.toLowerCase()];
                if (hex !== undefined) // red
                this.setHex(hex, colorSpace);
                else // unknown color
                console.warn('THREE.Color: Unknown color ' + style);
                return this;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor(this.r, this.g, this.b);
            }
        },
        {
            key: "copy",
            value: function copy(color) {
                this.r = color.r;
                this.g = color.g;
                this.b = color.b;
                return this;
            }
        },
        {
            key: "copySRGBToLinear",
            value: function copySRGBToLinear(color) {
                this.r = $1a55656020b89c3a$var$SRGBToLinear(color.r);
                this.g = $1a55656020b89c3a$var$SRGBToLinear(color.g);
                this.b = $1a55656020b89c3a$var$SRGBToLinear(color.b);
                return this;
            }
        },
        {
            key: "copyLinearToSRGB",
            value: function copyLinearToSRGB(color) {
                this.r = $1a55656020b89c3a$var$LinearToSRGB(color.r);
                this.g = $1a55656020b89c3a$var$LinearToSRGB(color.g);
                this.b = $1a55656020b89c3a$var$LinearToSRGB(color.b);
                return this;
            }
        },
        {
            key: "convertSRGBToLinear",
            value: function convertSRGBToLinear() {
                this.copySRGBToLinear(this);
                return this;
            }
        },
        {
            key: "convertLinearToSRGB",
            value: function convertLinearToSRGB() {
                this.copyLinearToSRGB(this);
                return this;
            }
        },
        {
            key: "getHex",
            value: function getHex() {
                var colorSpace = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $1a55656020b89c3a$export$561f394b24edfcaa;
                $1a55656020b89c3a$export$5e6fd513f44698c.fromWorkingColorSpace($1a55656020b89c3a$var$_color.copy(this), colorSpace);
                return Math.round($1a55656020b89c3a$var$clamp($1a55656020b89c3a$var$_color.r * 255, 0, 255)) * 65536 + Math.round($1a55656020b89c3a$var$clamp($1a55656020b89c3a$var$_color.g * 255, 0, 255)) * 256 + Math.round($1a55656020b89c3a$var$clamp($1a55656020b89c3a$var$_color.b * 255, 0, 255));
            }
        },
        {
            key: "getHexString",
            value: function getHexString() {
                var colorSpace = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $1a55656020b89c3a$export$561f394b24edfcaa;
                return ('000000' + this.getHex(colorSpace).toString(16)).slice(-6);
            }
        },
        {
            key: "getHSL",
            value: function getHSL(target) {
                var colorSpace = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1a55656020b89c3a$export$5e6fd513f44698c.workingColorSpace;
                // h,s,l ranges are in 0.0 - 1.0
                $1a55656020b89c3a$export$5e6fd513f44698c.fromWorkingColorSpace($1a55656020b89c3a$var$_color.copy(this), colorSpace);
                var r = $1a55656020b89c3a$var$_color.r, g = $1a55656020b89c3a$var$_color.g, b = $1a55656020b89c3a$var$_color.b;
                var max = Math.max(r, g, b);
                var min = Math.min(r, g, b);
                var hue, saturation;
                var lightness = (min + max) / 2.0;
                if (min === max) {
                    hue = 0;
                    saturation = 0;
                } else {
                    var delta = max - min;
                    saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);
                    switch(max){
                        case r:
                            hue = (g - b) / delta + (g < b ? 6 : 0);
                            break;
                        case g:
                            hue = (b - r) / delta + 2;
                            break;
                        case b:
                            hue = (r - g) / delta + 4;
                            break;
                    }
                    hue /= 6;
                }
                target.h = hue;
                target.s = saturation;
                target.l = lightness;
                return target;
            }
        },
        {
            key: "getRGB",
            value: function getRGB(target) {
                var colorSpace = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1a55656020b89c3a$export$5e6fd513f44698c.workingColorSpace;
                $1a55656020b89c3a$export$5e6fd513f44698c.fromWorkingColorSpace($1a55656020b89c3a$var$_color.copy(this), colorSpace);
                target.r = $1a55656020b89c3a$var$_color.r;
                target.g = $1a55656020b89c3a$var$_color.g;
                target.b = $1a55656020b89c3a$var$_color.b;
                return target;
            }
        },
        {
            key: "getStyle",
            value: function getStyle() {
                var colorSpace = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $1a55656020b89c3a$export$561f394b24edfcaa;
                $1a55656020b89c3a$export$5e6fd513f44698c.fromWorkingColorSpace($1a55656020b89c3a$var$_color.copy(this), colorSpace);
                var r = $1a55656020b89c3a$var$_color.r, g = $1a55656020b89c3a$var$_color.g, b = $1a55656020b89c3a$var$_color.b;
                if (colorSpace !== $1a55656020b89c3a$export$561f394b24edfcaa) // Requires CSS Color Module Level 4 (https://www.w3.org/TR/css-color-4/).
                return "color(".concat(colorSpace, " ").concat(r.toFixed(3), " ").concat(g.toFixed(3), " ").concat(b.toFixed(3), ")");
                return "rgb(".concat(Math.round(r * 255), ",").concat(Math.round(g * 255), ",").concat(Math.round(b * 255), ")");
            }
        },
        {
            key: "offsetHSL",
            value: function offsetHSL(h, s, l) {
                this.getHSL($1a55656020b89c3a$var$_hslA);
                return this.setHSL($1a55656020b89c3a$var$_hslA.h + h, $1a55656020b89c3a$var$_hslA.s + s, $1a55656020b89c3a$var$_hslA.l + l);
            }
        },
        {
            key: "add",
            value: function add(color) {
                this.r += color.r;
                this.g += color.g;
                this.b += color.b;
                return this;
            }
        },
        {
            key: "addColors",
            value: function addColors(color1, color2) {
                this.r = color1.r + color2.r;
                this.g = color1.g + color2.g;
                this.b = color1.b + color2.b;
                return this;
            }
        },
        {
            key: "addScalar",
            value: function addScalar(s) {
                this.r += s;
                this.g += s;
                this.b += s;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(color) {
                this.r = Math.max(0, this.r - color.r);
                this.g = Math.max(0, this.g - color.g);
                this.b = Math.max(0, this.b - color.b);
                return this;
            }
        },
        {
            key: "multiply",
            value: function multiply(color) {
                this.r *= color.r;
                this.g *= color.g;
                this.b *= color.b;
                return this;
            }
        },
        {
            key: "multiplyScalar",
            value: function multiplyScalar(s) {
                this.r *= s;
                this.g *= s;
                this.b *= s;
                return this;
            }
        },
        {
            key: "lerp",
            value: function lerp(color, alpha) {
                this.r += (color.r - this.r) * alpha;
                this.g += (color.g - this.g) * alpha;
                this.b += (color.b - this.b) * alpha;
                return this;
            }
        },
        {
            key: "lerpColors",
            value: function lerpColors(color1, color2, alpha) {
                this.r = color1.r + (color2.r - color1.r) * alpha;
                this.g = color1.g + (color2.g - color1.g) * alpha;
                this.b = color1.b + (color2.b - color1.b) * alpha;
                return this;
            }
        },
        {
            key: "lerpHSL",
            value: function lerpHSL(color, alpha) {
                this.getHSL($1a55656020b89c3a$var$_hslA);
                color.getHSL($1a55656020b89c3a$var$_hslB);
                var h = $1a55656020b89c3a$var$lerp($1a55656020b89c3a$var$_hslA.h, $1a55656020b89c3a$var$_hslB.h, alpha);
                var s = $1a55656020b89c3a$var$lerp($1a55656020b89c3a$var$_hslA.s, $1a55656020b89c3a$var$_hslB.s, alpha);
                var l = $1a55656020b89c3a$var$lerp($1a55656020b89c3a$var$_hslA.l, $1a55656020b89c3a$var$_hslB.l, alpha);
                this.setHSL(h, s, l);
                return this;
            }
        },
        {
            key: "setFromVector3",
            value: function setFromVector3(v) {
                this.r = v.x;
                this.g = v.y;
                this.b = v.z;
                return this;
            }
        },
        {
            key: "applyMatrix3",
            value: function applyMatrix3(m) {
                var r = this.r, g = this.g, b = this.b;
                var e = m.elements;
                this.r = e[0] * r + e[3] * g + e[6] * b;
                this.g = e[1] * r + e[4] * g + e[7] * b;
                this.b = e[2] * r + e[5] * g + e[8] * b;
                return this;
            }
        },
        {
            key: "equals",
            value: function equals(c) {
                return c.r === this.r && c.g === this.g && c.b === this.b;
            }
        },
        {
            key: "fromArray",
            value: function fromArray(array) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                this.r = array[offset];
                this.g = array[offset + 1];
                this.b = array[offset + 2];
                return this;
            }
        },
        {
            key: "toArray",
            value: function toArray() {
                var array = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                array[offset] = this.r;
                array[offset + 1] = this.g;
                array[offset + 2] = this.b;
                return array;
            }
        },
        {
            key: "fromBufferAttribute",
            value: function fromBufferAttribute(attribute, index) {
                this.r = attribute.getX(index);
                this.g = attribute.getY(index);
                this.b = attribute.getZ(index);
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.getHex();
            }
        },
        {
            key: Symbol.iterator,
            value: function value() {
                return (0, $353b713f9392bb93$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                this.r
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                this.g
                            ];
                        case 2:
                            _state.sent();
                            return [
                                4,
                                this.b
                            ];
                        case 3:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }
        }
    ]);
    return Color;
}();
var $1a55656020b89c3a$var$_color = /*@__PURE__*/ new $1a55656020b89c3a$export$892596cec99bc70e();
$1a55656020b89c3a$export$892596cec99bc70e.NAMES = $1a55656020b89c3a$var$_colorKeywords;
var $1a55656020b89c3a$var$_materialId = 0;
var $1a55656020b89c3a$export$a2d8b23205c25948 = /*#__PURE__*/ function(EventDispatcher) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(Material, EventDispatcher);
    function Material() {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Material);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, Material);
        _this.isMaterial = true;
        Object.defineProperty(_this, 'id', {
            value: $1a55656020b89c3a$var$_materialId++
        });
        _this.uuid = $1a55656020b89c3a$var$generateUUID();
        _this.name = '';
        _this.type = 'Material';
        _this.blending = $1a55656020b89c3a$export$5b29a26d96ee6af0;
        _this.side = $1a55656020b89c3a$export$2ede184fc2998901;
        _this.vertexColors = false;
        _this.opacity = 1;
        _this.transparent = false;
        _this.alphaHash = false;
        _this.blendSrc = $1a55656020b89c3a$export$d5773124e86cf28c;
        _this.blendDst = $1a55656020b89c3a$export$11d468cc7f19e971;
        _this.blendEquation = $1a55656020b89c3a$export$20183a0484ce21a0;
        _this.blendSrcAlpha = null;
        _this.blendDstAlpha = null;
        _this.blendEquationAlpha = null;
        _this.blendColor = new $1a55656020b89c3a$export$892596cec99bc70e(0, 0, 0);
        _this.blendAlpha = 0;
        _this.depthFunc = $1a55656020b89c3a$export$296f78a0b892f81a;
        _this.depthTest = true;
        _this.depthWrite = true;
        _this.stencilWriteMask = 0xff;
        _this.stencilFunc = $1a55656020b89c3a$export$14cf96713ddd97a8;
        _this.stencilRef = 0;
        _this.stencilFuncMask = 0xff;
        _this.stencilFail = $1a55656020b89c3a$export$9f542ae4b5baca34;
        _this.stencilZFail = $1a55656020b89c3a$export$9f542ae4b5baca34;
        _this.stencilZPass = $1a55656020b89c3a$export$9f542ae4b5baca34;
        _this.stencilWrite = false;
        _this.clippingPlanes = null;
        _this.clipIntersection = false;
        _this.clipShadows = false;
        _this.shadowSide = null;
        _this.colorWrite = true;
        _this.precision = null; // override the renderer's default precision for this material
        _this.polygonOffset = false;
        _this.polygonOffsetFactor = 0;
        _this.polygonOffsetUnits = 0;
        _this.dithering = false;
        _this.alphaToCoverage = false;
        _this.premultipliedAlpha = false;
        _this.forceSinglePass = false;
        _this.visible = true;
        _this.toneMapped = true;
        _this.userData = {};
        _this.version = 0;
        _this._alphaTest = 0;
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Material, [
        {
            key: "alphaTest",
            get: function get() {
                return this._alphaTest;
            },
            set: function set(value) {
                if (this._alphaTest > 0 !== value > 0) this.version++;
                this._alphaTest = value;
            }
        },
        {
            // onBeforeRender and onBeforeCompile only supported in WebGLRenderer
            key: "onBeforeRender",
            value: function onBeforeRender() {}
        },
        {
            key: "onBeforeCompile",
            value: function onBeforeCompile() {}
        },
        {
            key: "customProgramCacheKey",
            value: function customProgramCacheKey() {
                return this.onBeforeCompile.toString();
            }
        },
        {
            key: "setValues",
            value: function setValues(values) {
                if (values === undefined) return;
                for(var key in values){
                    var newValue = values[key];
                    if (newValue === undefined) {
                        console.warn("THREE.Material: parameter '".concat(key, "' has value of undefined."));
                        continue;
                    }
                    var currentValue = this[key];
                    if (currentValue === undefined) {
                        console.warn("THREE.Material: '".concat(key, "' is not a property of THREE.").concat(this.type, "."));
                        continue;
                    }
                    if (currentValue && currentValue.isColor) currentValue.set(newValue);
                    else if (currentValue && currentValue.isVector3 && newValue && newValue.isVector3) currentValue.copy(newValue);
                    else this[key] = newValue;
                }
            }
        },
        {
            key: "toJSON",
            value: function toJSON(meta) {
                var isRootObject = meta === undefined || typeof meta === 'string';
                if (isRootObject) meta = {
                    textures: {},
                    images: {}
                };
                var data = {
                    metadata: {
                        version: 4.6,
                        type: 'Material',
                        generator: 'Material.toJSON'
                    }
                };
                // standard Material serialization
                data.uuid = this.uuid;
                data.type = this.type;
                if (this.name !== '') data.name = this.name;
                if (this.color && this.color.isColor) data.color = this.color.getHex();
                if (this.roughness !== undefined) data.roughness = this.roughness;
                if (this.metalness !== undefined) data.metalness = this.metalness;
                if (this.sheen !== undefined) data.sheen = this.sheen;
                if (this.sheenColor && this.sheenColor.isColor) data.sheenColor = this.sheenColor.getHex();
                if (this.sheenRoughness !== undefined) data.sheenRoughness = this.sheenRoughness;
                if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
                if (this.emissiveIntensity !== undefined && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
                if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
                if (this.specularIntensity !== undefined) data.specularIntensity = this.specularIntensity;
                if (this.specularColor && this.specularColor.isColor) data.specularColor = this.specularColor.getHex();
                if (this.shininess !== undefined) data.shininess = this.shininess;
                if (this.clearcoat !== undefined) data.clearcoat = this.clearcoat;
                if (this.clearcoatRoughness !== undefined) data.clearcoatRoughness = this.clearcoatRoughness;
                if (this.clearcoatMap && this.clearcoatMap.isTexture) data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
                if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
                if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
                    data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
                    data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
                }
                if (this.dispersion !== undefined) data.dispersion = this.dispersion;
                if (this.iridescence !== undefined) data.iridescence = this.iridescence;
                if (this.iridescenceIOR !== undefined) data.iridescenceIOR = this.iridescenceIOR;
                if (this.iridescenceThicknessRange !== undefined) data.iridescenceThicknessRange = this.iridescenceThicknessRange;
                if (this.iridescenceMap && this.iridescenceMap.isTexture) data.iridescenceMap = this.iridescenceMap.toJSON(meta).uuid;
                if (this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture) data.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(meta).uuid;
                if (this.anisotropy !== undefined) data.anisotropy = this.anisotropy;
                if (this.anisotropyRotation !== undefined) data.anisotropyRotation = this.anisotropyRotation;
                if (this.anisotropyMap && this.anisotropyMap.isTexture) data.anisotropyMap = this.anisotropyMap.toJSON(meta).uuid;
                if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
                if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
                if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;
                if (this.lightMap && this.lightMap.isTexture) {
                    data.lightMap = this.lightMap.toJSON(meta).uuid;
                    data.lightMapIntensity = this.lightMapIntensity;
                }
                if (this.aoMap && this.aoMap.isTexture) {
                    data.aoMap = this.aoMap.toJSON(meta).uuid;
                    data.aoMapIntensity = this.aoMapIntensity;
                }
                if (this.bumpMap && this.bumpMap.isTexture) {
                    data.bumpMap = this.bumpMap.toJSON(meta).uuid;
                    data.bumpScale = this.bumpScale;
                }
                if (this.normalMap && this.normalMap.isTexture) {
                    data.normalMap = this.normalMap.toJSON(meta).uuid;
                    data.normalMapType = this.normalMapType;
                    data.normalScale = this.normalScale.toArray();
                }
                if (this.displacementMap && this.displacementMap.isTexture) {
                    data.displacementMap = this.displacementMap.toJSON(meta).uuid;
                    data.displacementScale = this.displacementScale;
                    data.displacementBias = this.displacementBias;
                }
                if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
                if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
                if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
                if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
                if (this.specularIntensityMap && this.specularIntensityMap.isTexture) data.specularIntensityMap = this.specularIntensityMap.toJSON(meta).uuid;
                if (this.specularColorMap && this.specularColorMap.isTexture) data.specularColorMap = this.specularColorMap.toJSON(meta).uuid;
                if (this.envMap && this.envMap.isTexture) {
                    data.envMap = this.envMap.toJSON(meta).uuid;
                    if (this.combine !== undefined) data.combine = this.combine;
                }
                if (this.envMapRotation !== undefined) data.envMapRotation = this.envMapRotation.toArray();
                if (this.envMapIntensity !== undefined) data.envMapIntensity = this.envMapIntensity;
                if (this.reflectivity !== undefined) data.reflectivity = this.reflectivity;
                if (this.refractionRatio !== undefined) data.refractionRatio = this.refractionRatio;
                if (this.gradientMap && this.gradientMap.isTexture) data.gradientMap = this.gradientMap.toJSON(meta).uuid;
                if (this.transmission !== undefined) data.transmission = this.transmission;
                if (this.transmissionMap && this.transmissionMap.isTexture) data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
                if (this.thickness !== undefined) data.thickness = this.thickness;
                if (this.thicknessMap && this.thicknessMap.isTexture) data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
                if (this.attenuationDistance !== undefined && this.attenuationDistance !== Infinity) data.attenuationDistance = this.attenuationDistance;
                if (this.attenuationColor !== undefined) data.attenuationColor = this.attenuationColor.getHex();
                if (this.size !== undefined) data.size = this.size;
                if (this.shadowSide !== null) data.shadowSide = this.shadowSide;
                if (this.sizeAttenuation !== undefined) data.sizeAttenuation = this.sizeAttenuation;
                if (this.blending !== $1a55656020b89c3a$export$5b29a26d96ee6af0) data.blending = this.blending;
                if (this.side !== $1a55656020b89c3a$export$2ede184fc2998901) data.side = this.side;
                if (this.vertexColors === true) data.vertexColors = true;
                if (this.opacity < 1) data.opacity = this.opacity;
                if (this.transparent === true) data.transparent = true;
                if (this.blendSrc !== $1a55656020b89c3a$export$d5773124e86cf28c) data.blendSrc = this.blendSrc;
                if (this.blendDst !== $1a55656020b89c3a$export$11d468cc7f19e971) data.blendDst = this.blendDst;
                if (this.blendEquation !== $1a55656020b89c3a$export$20183a0484ce21a0) data.blendEquation = this.blendEquation;
                if (this.blendSrcAlpha !== null) data.blendSrcAlpha = this.blendSrcAlpha;
                if (this.blendDstAlpha !== null) data.blendDstAlpha = this.blendDstAlpha;
                if (this.blendEquationAlpha !== null) data.blendEquationAlpha = this.blendEquationAlpha;
                if (this.blendColor && this.blendColor.isColor) data.blendColor = this.blendColor.getHex();
                if (this.blendAlpha !== 0) data.blendAlpha = this.blendAlpha;
                if (this.depthFunc !== $1a55656020b89c3a$export$296f78a0b892f81a) data.depthFunc = this.depthFunc;
                if (this.depthTest === false) data.depthTest = this.depthTest;
                if (this.depthWrite === false) data.depthWrite = this.depthWrite;
                if (this.colorWrite === false) data.colorWrite = this.colorWrite;
                if (this.stencilWriteMask !== 0xff) data.stencilWriteMask = this.stencilWriteMask;
                if (this.stencilFunc !== $1a55656020b89c3a$export$14cf96713ddd97a8) data.stencilFunc = this.stencilFunc;
                if (this.stencilRef !== 0) data.stencilRef = this.stencilRef;
                if (this.stencilFuncMask !== 0xff) data.stencilFuncMask = this.stencilFuncMask;
                if (this.stencilFail !== $1a55656020b89c3a$export$9f542ae4b5baca34) data.stencilFail = this.stencilFail;
                if (this.stencilZFail !== $1a55656020b89c3a$export$9f542ae4b5baca34) data.stencilZFail = this.stencilZFail;
                if (this.stencilZPass !== $1a55656020b89c3a$export$9f542ae4b5baca34) data.stencilZPass = this.stencilZPass;
                if (this.stencilWrite === true) data.stencilWrite = this.stencilWrite;
                // rotation (SpriteMaterial)
                if (this.rotation !== undefined && this.rotation !== 0) data.rotation = this.rotation;
                if (this.polygonOffset === true) data.polygonOffset = true;
                if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
                if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
                if (this.linewidth !== undefined && this.linewidth !== 1) data.linewidth = this.linewidth;
                if (this.dashSize !== undefined) data.dashSize = this.dashSize;
                if (this.gapSize !== undefined) data.gapSize = this.gapSize;
                if (this.scale !== undefined) data.scale = this.scale;
                if (this.dithering === true) data.dithering = true;
                if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
                if (this.alphaHash === true) data.alphaHash = true;
                if (this.alphaToCoverage === true) data.alphaToCoverage = true;
                if (this.premultipliedAlpha === true) data.premultipliedAlpha = true;
                if (this.forceSinglePass === true) data.forceSinglePass = true;
                if (this.wireframe === true) data.wireframe = true;
                if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
                if (this.wireframeLinecap !== 'round') data.wireframeLinecap = this.wireframeLinecap;
                if (this.wireframeLinejoin !== 'round') data.wireframeLinejoin = this.wireframeLinejoin;
                if (this.flatShading === true) data.flatShading = true;
                if (this.visible === false) data.visible = false;
                if (this.toneMapped === false) data.toneMapped = false;
                if (this.fog === false) data.fog = false;
                if (Object.keys(this.userData).length > 0) data.userData = this.userData;
                // TODO: Copied from Object3D.toJSON
                function extractFromCache(cache) {
                    var values = [];
                    for(var key in cache){
                        var data = cache[key];
                        delete data.metadata;
                        values.push(data);
                    }
                    return values;
                }
                if (isRootObject) {
                    var textures = extractFromCache(meta.textures);
                    var images = extractFromCache(meta.images);
                    if (textures.length > 0) data.textures = textures;
                    if (images.length > 0) data.images = images;
                }
                return data;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                this.name = source.name;
                this.blending = source.blending;
                this.side = source.side;
                this.vertexColors = source.vertexColors;
                this.opacity = source.opacity;
                this.transparent = source.transparent;
                this.blendSrc = source.blendSrc;
                this.blendDst = source.blendDst;
                this.blendEquation = source.blendEquation;
                this.blendSrcAlpha = source.blendSrcAlpha;
                this.blendDstAlpha = source.blendDstAlpha;
                this.blendEquationAlpha = source.blendEquationAlpha;
                this.blendColor.copy(source.blendColor);
                this.blendAlpha = source.blendAlpha;
                this.depthFunc = source.depthFunc;
                this.depthTest = source.depthTest;
                this.depthWrite = source.depthWrite;
                this.stencilWriteMask = source.stencilWriteMask;
                this.stencilFunc = source.stencilFunc;
                this.stencilRef = source.stencilRef;
                this.stencilFuncMask = source.stencilFuncMask;
                this.stencilFail = source.stencilFail;
                this.stencilZFail = source.stencilZFail;
                this.stencilZPass = source.stencilZPass;
                this.stencilWrite = source.stencilWrite;
                var srcPlanes = source.clippingPlanes;
                var dstPlanes = null;
                if (srcPlanes !== null) {
                    var n = srcPlanes.length;
                    dstPlanes = new Array(n);
                    for(var i = 0; i !== n; ++i)dstPlanes[i] = srcPlanes[i].clone();
                }
                this.clippingPlanes = dstPlanes;
                this.clipIntersection = source.clipIntersection;
                this.clipShadows = source.clipShadows;
                this.shadowSide = source.shadowSide;
                this.colorWrite = source.colorWrite;
                this.precision = source.precision;
                this.polygonOffset = source.polygonOffset;
                this.polygonOffsetFactor = source.polygonOffsetFactor;
                this.polygonOffsetUnits = source.polygonOffsetUnits;
                this.dithering = source.dithering;
                this.alphaTest = source.alphaTest;
                this.alphaHash = source.alphaHash;
                this.alphaToCoverage = source.alphaToCoverage;
                this.premultipliedAlpha = source.premultipliedAlpha;
                this.forceSinglePass = source.forceSinglePass;
                this.visible = source.visible;
                this.toneMapped = source.toneMapped;
                this.userData = JSON.parse(JSON.stringify(source.userData));
                return this;
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this.dispatchEvent({
                    type: 'dispose'
                });
            }
        },
        {
            key: "needsUpdate",
            set: function set(value) {
                if (value === true) this.version++;
            }
        },
        {
            key: "onBuild",
            value: function onBuild() {
                console.warn('Material: onBuild() has been removed.'); // @deprecated, r166
            }
        }
    ]);
    return Material;
}($1a55656020b89c3a$export$ec8b666c5fe2c75a);
var $1a55656020b89c3a$export$55cbcc9b622fe1f5 = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(MeshBasicMaterial, Material);
    function MeshBasicMaterial(parameters) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, MeshBasicMaterial);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, MeshBasicMaterial);
        _this.isMeshBasicMaterial = true;
        _this.type = 'MeshBasicMaterial';
        _this.color = new $1a55656020b89c3a$export$892596cec99bc70e(0xffffff); // emissive
        _this.map = null;
        _this.lightMap = null;
        _this.lightMapIntensity = 1.0;
        _this.aoMap = null;
        _this.aoMapIntensity = 1.0;
        _this.specularMap = null;
        _this.alphaMap = null;
        _this.envMap = null;
        _this.envMapRotation = new $1a55656020b89c3a$export$d93cc409a0768c5f();
        _this.combine = $1a55656020b89c3a$export$e50ac29801f1774d;
        _this.reflectivity = 1;
        _this.refractionRatio = 0.98;
        _this.wireframe = false;
        _this.wireframeLinewidth = 1;
        _this.wireframeLinecap = 'round';
        _this.wireframeLinejoin = 'round';
        _this.fog = true;
        _this.setValues(parameters);
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(MeshBasicMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(MeshBasicMaterial.prototype), "copy", this).call(this, source);
                this.color.copy(source.color);
                this.map = source.map;
                this.lightMap = source.lightMap;
                this.lightMapIntensity = source.lightMapIntensity;
                this.aoMap = source.aoMap;
                this.aoMapIntensity = source.aoMapIntensity;
                this.specularMap = source.specularMap;
                this.alphaMap = source.alphaMap;
                this.envMap = source.envMap;
                this.envMapRotation.copy(source.envMapRotation);
                this.combine = source.combine;
                this.reflectivity = source.reflectivity;
                this.refractionRatio = source.refractionRatio;
                this.wireframe = source.wireframe;
                this.wireframeLinewidth = source.wireframeLinewidth;
                this.wireframeLinecap = source.wireframeLinecap;
                this.wireframeLinejoin = source.wireframeLinejoin;
                this.fog = source.fog;
                return this;
            }
        }
    ]);
    return MeshBasicMaterial;
}($1a55656020b89c3a$export$a2d8b23205c25948);
// Fast Half Float Conversions, http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
var $1a55656020b89c3a$var$_tables = /*@__PURE__*/ $1a55656020b89c3a$var$_generateTables();
function $1a55656020b89c3a$var$_generateTables() {
    // float32 to float16 helpers
    var buffer = new ArrayBuffer(4);
    var floatView = new Float32Array(buffer);
    var uint32View = new Uint32Array(buffer);
    var baseTable = new Uint32Array(512);
    var shiftTable = new Uint32Array(512);
    for(var i = 0; i < 256; ++i){
        var e = i - 127;
        // very small number (0, -0)
        if (e < -27) {
            baseTable[i] = 0x0000;
            baseTable[i | 0x100] = 0x8000;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // small number (denorm)
        } else if (e < -14) {
            baseTable[i] = 0x0400 >> -e - 14;
            baseTable[i | 0x100] = 0x0400 >> -e - 14 | 0x8000;
            shiftTable[i] = -e - 1;
            shiftTable[i | 0x100] = -e - 1;
        // normal number
        } else if (e <= 15) {
            baseTable[i] = e + 15 << 10;
            baseTable[i | 0x100] = e + 15 << 10 | 0x8000;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        // large number (Infinity, -Infinity)
        } else if (e < 128) {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // stay (NaN, Infinity, -Infinity)
        } else {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        }
    }
    // float16 to float32 helpers
    var mantissaTable = new Uint32Array(2048);
    var exponentTable = new Uint32Array(64);
    var offsetTable = new Uint32Array(64);
    for(var i1 = 1; i1 < 1024; ++i1){
        var m = i1 << 13; // zero pad mantissa bits
        var e1 = 0; // zero exponent
        // normalized
        while((m & 0x00800000) === 0){
            m <<= 1;
            e1 -= 0x00800000; // decrement exponent
        }
        m &= -8388609; // clear leading 1 bit
        e1 += 0x38800000; // adjust bias
        mantissaTable[i1] = m | e1;
    }
    for(var i2 = 1024; i2 < 2048; ++i2)mantissaTable[i2] = 0x38000000 + (i2 - 1024 << 13);
    for(var i3 = 1; i3 < 31; ++i3)exponentTable[i3] = i3 << 23;
    exponentTable[31] = 0x47800000;
    exponentTable[32] = 0x80000000;
    for(var i4 = 33; i4 < 63; ++i4)exponentTable[i4] = 0x80000000 + (i4 - 32 << 23);
    exponentTable[63] = 0xc7800000;
    for(var i5 = 1; i5 < 64; ++i5)if (i5 !== 32) offsetTable[i5] = 1024;
    return {
        floatView: floatView,
        uint32View: uint32View,
        baseTable: baseTable,
        shiftTable: shiftTable,
        mantissaTable: mantissaTable,
        exponentTable: exponentTable,
        offsetTable: offsetTable
    };
}
// float32 to float16
function $1a55656020b89c3a$var$toHalfFloat(val) {
    if (Math.abs(val) > 65504) console.warn('THREE.DataUtils.toHalfFloat(): Value out of range.');
    val = $1a55656020b89c3a$var$clamp(val, -65504, 65504);
    $1a55656020b89c3a$var$_tables.floatView[0] = val;
    var f = $1a55656020b89c3a$var$_tables.uint32View[0];
    var e = f >> 23 & 0x1ff;
    return $1a55656020b89c3a$var$_tables.baseTable[e] + ((f & 0x007fffff) >> $1a55656020b89c3a$var$_tables.shiftTable[e]);
}
// float16 to float32
function $1a55656020b89c3a$var$fromHalfFloat(val) {
    var m = val >> 10;
    $1a55656020b89c3a$var$_tables.uint32View[0] = $1a55656020b89c3a$var$_tables.mantissaTable[$1a55656020b89c3a$var$_tables.offsetTable[m] + (val & 0x3ff)] + $1a55656020b89c3a$var$_tables.exponentTable[m];
    return $1a55656020b89c3a$var$_tables.floatView[0];
}
var $1a55656020b89c3a$export$11ce8b759162cc80 = {
    toHalfFloat: $1a55656020b89c3a$var$toHalfFloat,
    fromHalfFloat: $1a55656020b89c3a$var$fromHalfFloat
};
var $1a55656020b89c3a$var$_vector$9 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_vector2$1 = /*@__PURE__*/ new $1a55656020b89c3a$export$c977b3e384af9ae1();
var $1a55656020b89c3a$var$_id$2 = 0;
var $1a55656020b89c3a$export$8dea267bd6bde117 = /*#__PURE__*/ function() {
    "use strict";
    function BufferAttribute(array, itemSize) {
        var normalized = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, BufferAttribute);
        if (Array.isArray(array)) throw new TypeError('THREE.BufferAttribute: array should be a Typed Array.');
        this.isBufferAttribute = true;
        Object.defineProperty(this, 'id', {
            value: $1a55656020b89c3a$var$_id$2++
        });
        this.name = '';
        this.array = array;
        this.itemSize = itemSize;
        this.count = array !== undefined ? array.length / itemSize : 0;
        this.normalized = normalized;
        this.usage = $1a55656020b89c3a$export$763e8360f4d7f77d;
        this.updateRanges = [];
        this.gpuType = $1a55656020b89c3a$export$f6d331659b644596;
        this.version = 0;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(BufferAttribute, [
        {
            key: "onUploadCallback",
            value: function onUploadCallback() {}
        },
        {
            key: "needsUpdate",
            set: function set(value) {
                if (value === true) this.version++;
            }
        },
        {
            key: "setUsage",
            value: function setUsage(value) {
                this.usage = value;
                return this;
            }
        },
        {
            key: "addUpdateRange",
            value: function addUpdateRange(start, count) {
                this.updateRanges.push({
                    start: start,
                    count: count
                });
            }
        },
        {
            key: "clearUpdateRanges",
            value: function clearUpdateRanges() {
                this.updateRanges.length = 0;
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                this.name = source.name;
                this.array = new source.array.constructor(source.array);
                this.itemSize = source.itemSize;
                this.count = source.count;
                this.normalized = source.normalized;
                this.usage = source.usage;
                this.gpuType = source.gpuType;
                return this;
            }
        },
        {
            key: "copyAt",
            value: function copyAt(index1, attribute, index2) {
                index1 *= this.itemSize;
                index2 *= attribute.itemSize;
                for(var i = 0, l = this.itemSize; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
                return this;
            }
        },
        {
            key: "copyArray",
            value: function copyArray(array) {
                this.array.set(array);
                return this;
            }
        },
        {
            key: "applyMatrix3",
            value: function applyMatrix3(m) {
                if (this.itemSize === 2) for(var i = 0, l = this.count; i < l; i++){
                    $1a55656020b89c3a$var$_vector2$1.fromBufferAttribute(this, i);
                    $1a55656020b89c3a$var$_vector2$1.applyMatrix3(m);
                    this.setXY(i, $1a55656020b89c3a$var$_vector2$1.x, $1a55656020b89c3a$var$_vector2$1.y);
                }
                else if (this.itemSize === 3) for(var i1 = 0, l1 = this.count; i1 < l1; i1++){
                    $1a55656020b89c3a$var$_vector$9.fromBufferAttribute(this, i1);
                    $1a55656020b89c3a$var$_vector$9.applyMatrix3(m);
                    this.setXYZ(i1, $1a55656020b89c3a$var$_vector$9.x, $1a55656020b89c3a$var$_vector$9.y, $1a55656020b89c3a$var$_vector$9.z);
                }
                return this;
            }
        },
        {
            key: "applyMatrix4",
            value: function applyMatrix4(m) {
                for(var i = 0, l = this.count; i < l; i++){
                    $1a55656020b89c3a$var$_vector$9.fromBufferAttribute(this, i);
                    $1a55656020b89c3a$var$_vector$9.applyMatrix4(m);
                    this.setXYZ(i, $1a55656020b89c3a$var$_vector$9.x, $1a55656020b89c3a$var$_vector$9.y, $1a55656020b89c3a$var$_vector$9.z);
                }
                return this;
            }
        },
        {
            key: "applyNormalMatrix",
            value: function applyNormalMatrix(m) {
                for(var i = 0, l = this.count; i < l; i++){
                    $1a55656020b89c3a$var$_vector$9.fromBufferAttribute(this, i);
                    $1a55656020b89c3a$var$_vector$9.applyNormalMatrix(m);
                    this.setXYZ(i, $1a55656020b89c3a$var$_vector$9.x, $1a55656020b89c3a$var$_vector$9.y, $1a55656020b89c3a$var$_vector$9.z);
                }
                return this;
            }
        },
        {
            key: "transformDirection",
            value: function transformDirection(m) {
                for(var i = 0, l = this.count; i < l; i++){
                    $1a55656020b89c3a$var$_vector$9.fromBufferAttribute(this, i);
                    $1a55656020b89c3a$var$_vector$9.transformDirection(m);
                    this.setXYZ(i, $1a55656020b89c3a$var$_vector$9.x, $1a55656020b89c3a$var$_vector$9.y, $1a55656020b89c3a$var$_vector$9.z);
                }
                return this;
            }
        },
        {
            key: "set",
            value: function set(value) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                // Matching BufferAttribute constructor, do not normalize the array.
                this.array.set(value, offset);
                return this;
            }
        },
        {
            key: "getComponent",
            value: function getComponent(index, component) {
                var value = this.array[index * this.itemSize + component];
                if (this.normalized) value = $1a55656020b89c3a$var$denormalize(value, this.array);
                return value;
            }
        },
        {
            key: "setComponent",
            value: function setComponent(index, component, value) {
                if (this.normalized) value = $1a55656020b89c3a$var$normalize(value, this.array);
                this.array[index * this.itemSize + component] = value;
                return this;
            }
        },
        {
            key: "getX",
            value: function getX(index) {
                var x = this.array[index * this.itemSize];
                if (this.normalized) x = $1a55656020b89c3a$var$denormalize(x, this.array);
                return x;
            }
        },
        {
            key: "setX",
            value: function setX(index, x) {
                if (this.normalized) x = $1a55656020b89c3a$var$normalize(x, this.array);
                this.array[index * this.itemSize] = x;
                return this;
            }
        },
        {
            key: "getY",
            value: function getY(index) {
                var y = this.array[index * this.itemSize + 1];
                if (this.normalized) y = $1a55656020b89c3a$var$denormalize(y, this.array);
                return y;
            }
        },
        {
            key: "setY",
            value: function setY(index, y) {
                if (this.normalized) y = $1a55656020b89c3a$var$normalize(y, this.array);
                this.array[index * this.itemSize + 1] = y;
                return this;
            }
        },
        {
            key: "getZ",
            value: function getZ(index) {
                var z = this.array[index * this.itemSize + 2];
                if (this.normalized) z = $1a55656020b89c3a$var$denormalize(z, this.array);
                return z;
            }
        },
        {
            key: "setZ",
            value: function setZ(index, z) {
                if (this.normalized) z = $1a55656020b89c3a$var$normalize(z, this.array);
                this.array[index * this.itemSize + 2] = z;
                return this;
            }
        },
        {
            key: "getW",
            value: function getW(index) {
                var w = this.array[index * this.itemSize + 3];
                if (this.normalized) w = $1a55656020b89c3a$var$denormalize(w, this.array);
                return w;
            }
        },
        {
            key: "setW",
            value: function setW(index, w) {
                if (this.normalized) w = $1a55656020b89c3a$var$normalize(w, this.array);
                this.array[index * this.itemSize + 3] = w;
                return this;
            }
        },
        {
            key: "setXY",
            value: function setXY(index, x, y) {
                index *= this.itemSize;
                if (this.normalized) {
                    x = $1a55656020b89c3a$var$normalize(x, this.array);
                    y = $1a55656020b89c3a$var$normalize(y, this.array);
                }
                this.array[index + 0] = x;
                this.array[index + 1] = y;
                return this;
            }
        },
        {
            key: "setXYZ",
            value: function setXYZ(index, x, y, z) {
                index *= this.itemSize;
                if (this.normalized) {
                    x = $1a55656020b89c3a$var$normalize(x, this.array);
                    y = $1a55656020b89c3a$var$normalize(y, this.array);
                    z = $1a55656020b89c3a$var$normalize(z, this.array);
                }
                this.array[index + 0] = x;
                this.array[index + 1] = y;
                this.array[index + 2] = z;
                return this;
            }
        },
        {
            key: "setXYZW",
            value: function setXYZW(index, x, y, z, w) {
                index *= this.itemSize;
                if (this.normalized) {
                    x = $1a55656020b89c3a$var$normalize(x, this.array);
                    y = $1a55656020b89c3a$var$normalize(y, this.array);
                    z = $1a55656020b89c3a$var$normalize(z, this.array);
                    w = $1a55656020b89c3a$var$normalize(w, this.array);
                }
                this.array[index + 0] = x;
                this.array[index + 1] = y;
                this.array[index + 2] = z;
                this.array[index + 3] = w;
                return this;
            }
        },
        {
            key: "onUpload",
            value: function onUpload(callback) {
                this.onUploadCallback = callback;
                return this;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor(this.array, this.itemSize).copy(this);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = {
                    itemSize: this.itemSize,
                    type: this.array.constructor.name,
                    array: Array.from(this.array),
                    normalized: this.normalized
                };
                if (this.name !== '') data.name = this.name;
                if (this.usage !== $1a55656020b89c3a$export$763e8360f4d7f77d) data.usage = this.usage;
                return data;
            }
        }
    ]);
    return BufferAttribute;
}();
//
var $1a55656020b89c3a$export$f9ff2d6a20248cbf = /*#__PURE__*/ function(BufferAttribute) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(Int8BufferAttribute, BufferAttribute);
    function Int8BufferAttribute(array, itemSize, normalized) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Int8BufferAttribute);
        return (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, Int8BufferAttribute, [
            new Int8Array(array),
            itemSize,
            normalized
        ]);
    }
    return Int8BufferAttribute;
}($1a55656020b89c3a$export$8dea267bd6bde117);
var $1a55656020b89c3a$export$cacc90cf35d11cdd = /*#__PURE__*/ function(BufferAttribute) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(Uint8BufferAttribute, BufferAttribute);
    function Uint8BufferAttribute(array, itemSize, normalized) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Uint8BufferAttribute);
        return (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, Uint8BufferAttribute, [
            new Uint8Array(array),
            itemSize,
            normalized
        ]);
    }
    return Uint8BufferAttribute;
}($1a55656020b89c3a$export$8dea267bd6bde117);
var $1a55656020b89c3a$export$baaa85a1a812c157 = /*#__PURE__*/ function(BufferAttribute) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(Uint8ClampedBufferAttribute, BufferAttribute);
    function Uint8ClampedBufferAttribute(array, itemSize, normalized) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Uint8ClampedBufferAttribute);
        return (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, Uint8ClampedBufferAttribute, [
            new Uint8ClampedArray(array),
            itemSize,
            normalized
        ]);
    }
    return Uint8ClampedBufferAttribute;
}($1a55656020b89c3a$export$8dea267bd6bde117);
var $1a55656020b89c3a$export$2b755a102ccdcefe = /*#__PURE__*/ function(BufferAttribute) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(Int16BufferAttribute, BufferAttribute);
    function Int16BufferAttribute(array, itemSize, normalized) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Int16BufferAttribute);
        return (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, Int16BufferAttribute, [
            new Int16Array(array),
            itemSize,
            normalized
        ]);
    }
    return Int16BufferAttribute;
}($1a55656020b89c3a$export$8dea267bd6bde117);
var $1a55656020b89c3a$export$640a853f68025f2e = /*#__PURE__*/ function(BufferAttribute) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(Uint16BufferAttribute, BufferAttribute);
    function Uint16BufferAttribute(array, itemSize, normalized) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Uint16BufferAttribute);
        return (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, Uint16BufferAttribute, [
            new Uint16Array(array),
            itemSize,
            normalized
        ]);
    }
    return Uint16BufferAttribute;
}($1a55656020b89c3a$export$8dea267bd6bde117);
var $1a55656020b89c3a$export$46b369aed2968a0a = /*#__PURE__*/ function(BufferAttribute) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(Int32BufferAttribute, BufferAttribute);
    function Int32BufferAttribute(array, itemSize, normalized) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Int32BufferAttribute);
        return (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, Int32BufferAttribute, [
            new Int32Array(array),
            itemSize,
            normalized
        ]);
    }
    return Int32BufferAttribute;
}($1a55656020b89c3a$export$8dea267bd6bde117);
var $1a55656020b89c3a$export$7eb8c9fa25cd5bd6 = /*#__PURE__*/ function(BufferAttribute) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(Uint32BufferAttribute, BufferAttribute);
    function Uint32BufferAttribute(array, itemSize, normalized) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Uint32BufferAttribute);
        return (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, Uint32BufferAttribute, [
            new Uint32Array(array),
            itemSize,
            normalized
        ]);
    }
    return Uint32BufferAttribute;
}($1a55656020b89c3a$export$8dea267bd6bde117);
var $1a55656020b89c3a$export$dbd3698c64958d69 = /*#__PURE__*/ function(BufferAttribute) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(Float16BufferAttribute, BufferAttribute);
    function Float16BufferAttribute(array, itemSize, normalized) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Float16BufferAttribute);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, Float16BufferAttribute, [
            new Uint16Array(array),
            itemSize,
            normalized
        ]);
        _this.isFloat16BufferAttribute = true;
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Float16BufferAttribute, [
        {
            key: "getX",
            value: function getX(index) {
                var x = $1a55656020b89c3a$var$fromHalfFloat(this.array[index * this.itemSize]);
                if (this.normalized) x = $1a55656020b89c3a$var$denormalize(x, this.array);
                return x;
            }
        },
        {
            key: "setX",
            value: function setX(index, x) {
                if (this.normalized) x = $1a55656020b89c3a$var$normalize(x, this.array);
                this.array[index * this.itemSize] = $1a55656020b89c3a$var$toHalfFloat(x);
                return this;
            }
        },
        {
            key: "getY",
            value: function getY(index) {
                var y = $1a55656020b89c3a$var$fromHalfFloat(this.array[index * this.itemSize + 1]);
                if (this.normalized) y = $1a55656020b89c3a$var$denormalize(y, this.array);
                return y;
            }
        },
        {
            key: "setY",
            value: function setY(index, y) {
                if (this.normalized) y = $1a55656020b89c3a$var$normalize(y, this.array);
                this.array[index * this.itemSize + 1] = $1a55656020b89c3a$var$toHalfFloat(y);
                return this;
            }
        },
        {
            key: "getZ",
            value: function getZ(index) {
                var z = $1a55656020b89c3a$var$fromHalfFloat(this.array[index * this.itemSize + 2]);
                if (this.normalized) z = $1a55656020b89c3a$var$denormalize(z, this.array);
                return z;
            }
        },
        {
            key: "setZ",
            value: function setZ(index, z) {
                if (this.normalized) z = $1a55656020b89c3a$var$normalize(z, this.array);
                this.array[index * this.itemSize + 2] = $1a55656020b89c3a$var$toHalfFloat(z);
                return this;
            }
        },
        {
            key: "getW",
            value: function getW(index) {
                var w = $1a55656020b89c3a$var$fromHalfFloat(this.array[index * this.itemSize + 3]);
                if (this.normalized) w = $1a55656020b89c3a$var$denormalize(w, this.array);
                return w;
            }
        },
        {
            key: "setW",
            value: function setW(index, w) {
                if (this.normalized) w = $1a55656020b89c3a$var$normalize(w, this.array);
                this.array[index * this.itemSize + 3] = $1a55656020b89c3a$var$toHalfFloat(w);
                return this;
            }
        },
        {
            key: "setXY",
            value: function setXY(index, x, y) {
                index *= this.itemSize;
                if (this.normalized) {
                    x = $1a55656020b89c3a$var$normalize(x, this.array);
                    y = $1a55656020b89c3a$var$normalize(y, this.array);
                }
                this.array[index + 0] = $1a55656020b89c3a$var$toHalfFloat(x);
                this.array[index + 1] = $1a55656020b89c3a$var$toHalfFloat(y);
                return this;
            }
        },
        {
            key: "setXYZ",
            value: function setXYZ(index, x, y, z) {
                index *= this.itemSize;
                if (this.normalized) {
                    x = $1a55656020b89c3a$var$normalize(x, this.array);
                    y = $1a55656020b89c3a$var$normalize(y, this.array);
                    z = $1a55656020b89c3a$var$normalize(z, this.array);
                }
                this.array[index + 0] = $1a55656020b89c3a$var$toHalfFloat(x);
                this.array[index + 1] = $1a55656020b89c3a$var$toHalfFloat(y);
                this.array[index + 2] = $1a55656020b89c3a$var$toHalfFloat(z);
                return this;
            }
        },
        {
            key: "setXYZW",
            value: function setXYZW(index, x, y, z, w) {
                index *= this.itemSize;
                if (this.normalized) {
                    x = $1a55656020b89c3a$var$normalize(x, this.array);
                    y = $1a55656020b89c3a$var$normalize(y, this.array);
                    z = $1a55656020b89c3a$var$normalize(z, this.array);
                    w = $1a55656020b89c3a$var$normalize(w, this.array);
                }
                this.array[index + 0] = $1a55656020b89c3a$var$toHalfFloat(x);
                this.array[index + 1] = $1a55656020b89c3a$var$toHalfFloat(y);
                this.array[index + 2] = $1a55656020b89c3a$var$toHalfFloat(z);
                this.array[index + 3] = $1a55656020b89c3a$var$toHalfFloat(w);
                return this;
            }
        }
    ]);
    return Float16BufferAttribute;
}($1a55656020b89c3a$export$8dea267bd6bde117);
var $1a55656020b89c3a$export$cbe7a62641830ebd = /*#__PURE__*/ function(BufferAttribute) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(Float32BufferAttribute, BufferAttribute);
    function Float32BufferAttribute(array, itemSize, normalized) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Float32BufferAttribute);
        return (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, Float32BufferAttribute, [
            new Float32Array(array),
            itemSize,
            normalized
        ]);
    }
    return Float32BufferAttribute;
}($1a55656020b89c3a$export$8dea267bd6bde117);
var $1a55656020b89c3a$var$_id$1 = 0;
var $1a55656020b89c3a$var$_m1 = /*@__PURE__*/ new $1a55656020b89c3a$export$2ae72fc923e5eb5();
var $1a55656020b89c3a$var$_obj = /*@__PURE__*/ new $1a55656020b89c3a$export$e4dd07dff30cc924();
var $1a55656020b89c3a$var$_offset = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_box$2 = /*@__PURE__*/ new $1a55656020b89c3a$export$6f7d5a9418ab2aa3();
var $1a55656020b89c3a$var$_boxMorphTargets = /*@__PURE__*/ new $1a55656020b89c3a$export$6f7d5a9418ab2aa3();
var $1a55656020b89c3a$var$_vector$8 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$export$b7be63a67df8959 = /*#__PURE__*/ function(EventDispatcher) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(BufferGeometry, EventDispatcher);
    function BufferGeometry() {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, BufferGeometry);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, BufferGeometry);
        _this.isBufferGeometry = true;
        Object.defineProperty(_this, 'id', {
            value: $1a55656020b89c3a$var$_id$1++
        });
        _this.uuid = $1a55656020b89c3a$var$generateUUID();
        _this.name = '';
        _this.type = 'BufferGeometry';
        _this.index = null;
        _this.indirect = null;
        _this.attributes = {};
        _this.morphAttributes = {};
        _this.morphTargetsRelative = false;
        _this.groups = [];
        _this.boundingBox = null;
        _this.boundingSphere = null;
        _this.drawRange = {
            start: 0,
            count: Infinity
        };
        _this.userData = {};
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(BufferGeometry, [
        {
            key: "getIndex",
            value: function getIndex() {
                return this.index;
            }
        },
        {
            key: "setIndex",
            value: function setIndex(index) {
                if (Array.isArray(index)) this.index = new ($1a55656020b89c3a$export$bc6f937da07eae17(index) ? $1a55656020b89c3a$export$7eb8c9fa25cd5bd6 : $1a55656020b89c3a$export$640a853f68025f2e)(index, 1);
                else this.index = index;
                return this;
            }
        },
        {
            key: "setIndirect",
            value: function setIndirect(indirect) {
                this.indirect = indirect;
                return this;
            }
        },
        {
            key: "getIndirect",
            value: function getIndirect() {
                return this.indirect;
            }
        },
        {
            key: "getAttribute",
            value: function getAttribute(name) {
                return this.attributes[name];
            }
        },
        {
            key: "setAttribute",
            value: function setAttribute(name, attribute) {
                this.attributes[name] = attribute;
                return this;
            }
        },
        {
            key: "deleteAttribute",
            value: function deleteAttribute(name) {
                delete this.attributes[name];
                return this;
            }
        },
        {
            key: "hasAttribute",
            value: function hasAttribute(name) {
                return this.attributes[name] !== undefined;
            }
        },
        {
            key: "addGroup",
            value: function addGroup(start, count) {
                var materialIndex = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                this.groups.push({
                    start: start,
                    count: count,
                    materialIndex: materialIndex
                });
            }
        },
        {
            key: "clearGroups",
            value: function clearGroups() {
                this.groups = [];
            }
        },
        {
            key: "setDrawRange",
            value: function setDrawRange(start, count) {
                this.drawRange.start = start;
                this.drawRange.count = count;
            }
        },
        {
            key: "applyMatrix4",
            value: function applyMatrix4(matrix) {
                var position = this.attributes.position;
                if (position !== undefined) {
                    position.applyMatrix4(matrix);
                    position.needsUpdate = true;
                }
                var normal = this.attributes.normal;
                if (normal !== undefined) {
                    var normalMatrix = new $1a55656020b89c3a$export$8ff26dafa08918().getNormalMatrix(matrix);
                    normal.applyNormalMatrix(normalMatrix);
                    normal.needsUpdate = true;
                }
                var tangent = this.attributes.tangent;
                if (tangent !== undefined) {
                    tangent.transformDirection(matrix);
                    tangent.needsUpdate = true;
                }
                if (this.boundingBox !== null) this.computeBoundingBox();
                if (this.boundingSphere !== null) this.computeBoundingSphere();
                return this;
            }
        },
        {
            key: "applyQuaternion",
            value: function applyQuaternion(q) {
                $1a55656020b89c3a$var$_m1.makeRotationFromQuaternion(q);
                this.applyMatrix4($1a55656020b89c3a$var$_m1);
                return this;
            }
        },
        {
            key: "rotateX",
            value: function rotateX(angle) {
                // rotate geometry around world x-axis
                $1a55656020b89c3a$var$_m1.makeRotationX(angle);
                this.applyMatrix4($1a55656020b89c3a$var$_m1);
                return this;
            }
        },
        {
            key: "rotateY",
            value: function rotateY(angle) {
                // rotate geometry around world y-axis
                $1a55656020b89c3a$var$_m1.makeRotationY(angle);
                this.applyMatrix4($1a55656020b89c3a$var$_m1);
                return this;
            }
        },
        {
            key: "rotateZ",
            value: function rotateZ(angle) {
                // rotate geometry around world z-axis
                $1a55656020b89c3a$var$_m1.makeRotationZ(angle);
                this.applyMatrix4($1a55656020b89c3a$var$_m1);
                return this;
            }
        },
        {
            key: "translate",
            value: function translate(x, y, z) {
                // translate geometry
                $1a55656020b89c3a$var$_m1.makeTranslation(x, y, z);
                this.applyMatrix4($1a55656020b89c3a$var$_m1);
                return this;
            }
        },
        {
            key: "scale",
            value: function scale(x, y, z) {
                // scale geometry
                $1a55656020b89c3a$var$_m1.makeScale(x, y, z);
                this.applyMatrix4($1a55656020b89c3a$var$_m1);
                return this;
            }
        },
        {
            key: "lookAt",
            value: function lookAt(vector) {
                $1a55656020b89c3a$var$_obj.lookAt(vector);
                $1a55656020b89c3a$var$_obj.updateMatrix();
                this.applyMatrix4($1a55656020b89c3a$var$_obj.matrix);
                return this;
            }
        },
        {
            key: "center",
            value: function center() {
                this.computeBoundingBox();
                this.boundingBox.getCenter($1a55656020b89c3a$var$_offset).negate();
                this.translate($1a55656020b89c3a$var$_offset.x, $1a55656020b89c3a$var$_offset.y, $1a55656020b89c3a$var$_offset.z);
                return this;
            }
        },
        {
            key: "setFromPoints",
            value: function setFromPoints(points) {
                var positionAttribute = this.getAttribute('position');
                if (positionAttribute === undefined) {
                    var position = [];
                    for(var i = 0, l = points.length; i < l; i++){
                        var point = points[i];
                        position.push(point.x, point.y, point.z || 0);
                    }
                    this.setAttribute('position', new $1a55656020b89c3a$export$cbe7a62641830ebd(position, 3));
                } else {
                    var l1 = Math.min(points.length, positionAttribute.count); // make sure data do not exceed buffer size
                    for(var i1 = 0; i1 < l1; i1++){
                        var point1 = points[i1];
                        positionAttribute.setXYZ(i1, point1.x, point1.y, point1.z || 0);
                    }
                    if (points.length > positionAttribute.count) console.warn('THREE.BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry.');
                    positionAttribute.needsUpdate = true;
                }
                return this;
            }
        },
        {
            key: "computeBoundingBox",
            value: function computeBoundingBox() {
                if (this.boundingBox === null) this.boundingBox = new $1a55656020b89c3a$export$6f7d5a9418ab2aa3();
                var position = this.attributes.position;
                var morphAttributesPosition = this.morphAttributes.position;
                if (position && position.isGLBufferAttribute) {
                    console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.', this);
                    this.boundingBox.set(new $1a55656020b89c3a$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity), new $1a55656020b89c3a$export$64b5c384219d3699(Infinity, Infinity, Infinity));
                    return;
                }
                if (position !== undefined) {
                    this.boundingBox.setFromBufferAttribute(position);
                    // process morph attributes if present
                    if (morphAttributesPosition) for(var i = 0, il = morphAttributesPosition.length; i < il; i++){
                        var morphAttribute = morphAttributesPosition[i];
                        $1a55656020b89c3a$var$_box$2.setFromBufferAttribute(morphAttribute);
                        if (this.morphTargetsRelative) {
                            $1a55656020b89c3a$var$_vector$8.addVectors(this.boundingBox.min, $1a55656020b89c3a$var$_box$2.min);
                            this.boundingBox.expandByPoint($1a55656020b89c3a$var$_vector$8);
                            $1a55656020b89c3a$var$_vector$8.addVectors(this.boundingBox.max, $1a55656020b89c3a$var$_box$2.max);
                            this.boundingBox.expandByPoint($1a55656020b89c3a$var$_vector$8);
                        } else {
                            this.boundingBox.expandByPoint($1a55656020b89c3a$var$_box$2.min);
                            this.boundingBox.expandByPoint($1a55656020b89c3a$var$_box$2.max);
                        }
                    }
                } else this.boundingBox.makeEmpty();
                if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
            }
        },
        {
            key: "computeBoundingSphere",
            value: function computeBoundingSphere() {
                if (this.boundingSphere === null) this.boundingSphere = new $1a55656020b89c3a$export$805e8b72413ccaba();
                var position = this.attributes.position;
                var morphAttributesPosition = this.morphAttributes.position;
                if (position && position.isGLBufferAttribute) {
                    console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.', this);
                    this.boundingSphere.set(new $1a55656020b89c3a$export$64b5c384219d3699(), Infinity);
                    return;
                }
                if (position) {
                    // first, find the center of the bounding sphere
                    var center = this.boundingSphere.center;
                    $1a55656020b89c3a$var$_box$2.setFromBufferAttribute(position);
                    // process morph attributes if present
                    if (morphAttributesPosition) for(var i = 0, il = morphAttributesPosition.length; i < il; i++){
                        var morphAttribute = morphAttributesPosition[i];
                        $1a55656020b89c3a$var$_boxMorphTargets.setFromBufferAttribute(morphAttribute);
                        if (this.morphTargetsRelative) {
                            $1a55656020b89c3a$var$_vector$8.addVectors($1a55656020b89c3a$var$_box$2.min, $1a55656020b89c3a$var$_boxMorphTargets.min);
                            $1a55656020b89c3a$var$_box$2.expandByPoint($1a55656020b89c3a$var$_vector$8);
                            $1a55656020b89c3a$var$_vector$8.addVectors($1a55656020b89c3a$var$_box$2.max, $1a55656020b89c3a$var$_boxMorphTargets.max);
                            $1a55656020b89c3a$var$_box$2.expandByPoint($1a55656020b89c3a$var$_vector$8);
                        } else {
                            $1a55656020b89c3a$var$_box$2.expandByPoint($1a55656020b89c3a$var$_boxMorphTargets.min);
                            $1a55656020b89c3a$var$_box$2.expandByPoint($1a55656020b89c3a$var$_boxMorphTargets.max);
                        }
                    }
                    $1a55656020b89c3a$var$_box$2.getCenter(center);
                    // second, try to find a boundingSphere with a radius smaller than the
                    // boundingSphere of the boundingBox: sqrt(3) smaller in the best case
                    var maxRadiusSq = 0;
                    for(var i1 = 0, il1 = position.count; i1 < il1; i1++){
                        $1a55656020b89c3a$var$_vector$8.fromBufferAttribute(position, i1);
                        maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($1a55656020b89c3a$var$_vector$8));
                    }
                    // process morph attributes if present
                    if (morphAttributesPosition) for(var i2 = 0, il2 = morphAttributesPosition.length; i2 < il2; i2++){
                        var morphAttribute1 = morphAttributesPosition[i2];
                        var morphTargetsRelative = this.morphTargetsRelative;
                        for(var j = 0, jl = morphAttribute1.count; j < jl; j++){
                            $1a55656020b89c3a$var$_vector$8.fromBufferAttribute(morphAttribute1, j);
                            if (morphTargetsRelative) {
                                $1a55656020b89c3a$var$_offset.fromBufferAttribute(position, j);
                                $1a55656020b89c3a$var$_vector$8.add($1a55656020b89c3a$var$_offset);
                            }
                            maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($1a55656020b89c3a$var$_vector$8));
                        }
                    }
                    this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
                    if (isNaN(this.boundingSphere.radius)) console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
                }
            }
        },
        {
            key: "computeTangents",
            value: function computeTangents() {
                var index = this.index;
                var attributes = this.attributes;
                // based on http://www.terathon.com/code/tangent.html
                // (per vertex tangents)
                if (index === null || attributes.position === undefined || attributes.normal === undefined || attributes.uv === undefined) {
                    console.error('THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)');
                    return;
                }
                var positionAttribute = attributes.position;
                var normalAttribute = attributes.normal;
                var uvAttribute = attributes.uv;
                if (this.hasAttribute('tangent') === false) this.setAttribute('tangent', new $1a55656020b89c3a$export$8dea267bd6bde117(new Float32Array(4 * positionAttribute.count), 4));
                var tangentAttribute = this.getAttribute('tangent');
                var tan1 = [], tan2 = [];
                for(var i = 0; i < positionAttribute.count; i++){
                    tan1[i] = new $1a55656020b89c3a$export$64b5c384219d3699();
                    tan2[i] = new $1a55656020b89c3a$export$64b5c384219d3699();
                }
                var vA = new $1a55656020b89c3a$export$64b5c384219d3699(), vB = new $1a55656020b89c3a$export$64b5c384219d3699(), vC = new $1a55656020b89c3a$export$64b5c384219d3699(), uvA = new $1a55656020b89c3a$export$c977b3e384af9ae1(), uvB = new $1a55656020b89c3a$export$c977b3e384af9ae1(), uvC = new $1a55656020b89c3a$export$c977b3e384af9ae1(), sdir = new $1a55656020b89c3a$export$64b5c384219d3699(), tdir = new $1a55656020b89c3a$export$64b5c384219d3699();
                function handleTriangle(a, b, c) {
                    vA.fromBufferAttribute(positionAttribute, a);
                    vB.fromBufferAttribute(positionAttribute, b);
                    vC.fromBufferAttribute(positionAttribute, c);
                    uvA.fromBufferAttribute(uvAttribute, a);
                    uvB.fromBufferAttribute(uvAttribute, b);
                    uvC.fromBufferAttribute(uvAttribute, c);
                    vB.sub(vA);
                    vC.sub(vA);
                    uvB.sub(uvA);
                    uvC.sub(uvA);
                    var r = 1.0 / (uvB.x * uvC.y - uvC.x * uvB.y);
                    // silently ignore degenerate uv triangles having coincident or colinear vertices
                    if (!isFinite(r)) return;
                    sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r);
                    tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r);
                    tan1[a].add(sdir);
                    tan1[b].add(sdir);
                    tan1[c].add(sdir);
                    tan2[a].add(tdir);
                    tan2[b].add(tdir);
                    tan2[c].add(tdir);
                }
                var groups = this.groups;
                if (groups.length === 0) groups = [
                    {
                        start: 0,
                        count: index.count
                    }
                ];
                for(var i1 = 0, il = groups.length; i1 < il; ++i1){
                    var group = groups[i1];
                    var start = group.start;
                    var count = group.count;
                    for(var j = start, jl = start + count; j < jl; j += 3)handleTriangle(index.getX(j + 0), index.getX(j + 1), index.getX(j + 2));
                }
                var tmp = new $1a55656020b89c3a$export$64b5c384219d3699(), tmp2 = new $1a55656020b89c3a$export$64b5c384219d3699();
                var n = new $1a55656020b89c3a$export$64b5c384219d3699(), n2 = new $1a55656020b89c3a$export$64b5c384219d3699();
                function handleVertex(v) {
                    n.fromBufferAttribute(normalAttribute, v);
                    n2.copy(n);
                    var t = tan1[v];
                    // Gram-Schmidt orthogonalize
                    tmp.copy(t);
                    tmp.sub(n.multiplyScalar(n.dot(t))).normalize();
                    // Calculate handedness
                    tmp2.crossVectors(n2, t);
                    var test = tmp2.dot(tan2[v]);
                    var w = test < 0.0 ? -1 : 1.0;
                    tangentAttribute.setXYZW(v, tmp.x, tmp.y, tmp.z, w);
                }
                for(var i2 = 0, il1 = groups.length; i2 < il1; ++i2){
                    var group1 = groups[i2];
                    var start1 = group1.start;
                    var count1 = group1.count;
                    for(var j1 = start1, jl1 = start1 + count1; j1 < jl1; j1 += 3){
                        handleVertex(index.getX(j1 + 0));
                        handleVertex(index.getX(j1 + 1));
                        handleVertex(index.getX(j1 + 2));
                    }
                }
            }
        },
        {
            key: "computeVertexNormals",
            value: function computeVertexNormals() {
                var index = this.index;
                var positionAttribute = this.getAttribute('position');
                if (positionAttribute !== undefined) {
                    var normalAttribute = this.getAttribute('normal');
                    if (normalAttribute === undefined) {
                        normalAttribute = new $1a55656020b89c3a$export$8dea267bd6bde117(new Float32Array(positionAttribute.count * 3), 3);
                        this.setAttribute('normal', normalAttribute);
                    } else // reset existing normals to zero
                    for(var i = 0, il = normalAttribute.count; i < il; i++)normalAttribute.setXYZ(i, 0, 0, 0);
                    var pA = new $1a55656020b89c3a$export$64b5c384219d3699(), pB = new $1a55656020b89c3a$export$64b5c384219d3699(), pC = new $1a55656020b89c3a$export$64b5c384219d3699();
                    var nA = new $1a55656020b89c3a$export$64b5c384219d3699(), nB = new $1a55656020b89c3a$export$64b5c384219d3699(), nC = new $1a55656020b89c3a$export$64b5c384219d3699();
                    var cb = new $1a55656020b89c3a$export$64b5c384219d3699(), ab = new $1a55656020b89c3a$export$64b5c384219d3699();
                    // indexed elements
                    if (index) for(var i1 = 0, il1 = index.count; i1 < il1; i1 += 3){
                        var vA = index.getX(i1 + 0);
                        var vB = index.getX(i1 + 1);
                        var vC = index.getX(i1 + 2);
                        pA.fromBufferAttribute(positionAttribute, vA);
                        pB.fromBufferAttribute(positionAttribute, vB);
                        pC.fromBufferAttribute(positionAttribute, vC);
                        cb.subVectors(pC, pB);
                        ab.subVectors(pA, pB);
                        cb.cross(ab);
                        nA.fromBufferAttribute(normalAttribute, vA);
                        nB.fromBufferAttribute(normalAttribute, vB);
                        nC.fromBufferAttribute(normalAttribute, vC);
                        nA.add(cb);
                        nB.add(cb);
                        nC.add(cb);
                        normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
                        normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
                        normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
                    }
                    else // non-indexed elements (unconnected triangle soup)
                    for(var i2 = 0, il2 = positionAttribute.count; i2 < il2; i2 += 3){
                        pA.fromBufferAttribute(positionAttribute, i2 + 0);
                        pB.fromBufferAttribute(positionAttribute, i2 + 1);
                        pC.fromBufferAttribute(positionAttribute, i2 + 2);
                        cb.subVectors(pC, pB);
                        ab.subVectors(pA, pB);
                        cb.cross(ab);
                        normalAttribute.setXYZ(i2 + 0, cb.x, cb.y, cb.z);
                        normalAttribute.setXYZ(i2 + 1, cb.x, cb.y, cb.z);
                        normalAttribute.setXYZ(i2 + 2, cb.x, cb.y, cb.z);
                    }
                    this.normalizeNormals();
                    normalAttribute.needsUpdate = true;
                }
            }
        },
        {
            key: "normalizeNormals",
            value: function normalizeNormals() {
                var normals = this.attributes.normal;
                for(var i = 0, il = normals.count; i < il; i++){
                    $1a55656020b89c3a$var$_vector$8.fromBufferAttribute(normals, i);
                    $1a55656020b89c3a$var$_vector$8.normalize();
                    normals.setXYZ(i, $1a55656020b89c3a$var$_vector$8.x, $1a55656020b89c3a$var$_vector$8.y, $1a55656020b89c3a$var$_vector$8.z);
                }
            }
        },
        {
            key: "toNonIndexed",
            value: function toNonIndexed() {
                function convertBufferAttribute(attribute, indices) {
                    var array = attribute.array;
                    var itemSize = attribute.itemSize;
                    var normalized = attribute.normalized;
                    var array2 = new array.constructor(indices.length * itemSize);
                    var index = 0, index2 = 0;
                    for(var i = 0, l = indices.length; i < l; i++){
                        if (attribute.isInterleavedBufferAttribute) index = indices[i] * attribute.data.stride + attribute.offset;
                        else index = indices[i] * itemSize;
                        for(var j = 0; j < itemSize; j++)array2[index2++] = array[index++];
                    }
                    return new $1a55656020b89c3a$export$8dea267bd6bde117(array2, itemSize, normalized);
                }
                //
                if (this.index === null) {
                    console.warn('THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.');
                    return this;
                }
                var geometry2 = new BufferGeometry();
                var indices = this.index.array;
                var attributes = this.attributes;
                // attributes
                for(var name in attributes){
                    var attribute = attributes[name];
                    var newAttribute = convertBufferAttribute(attribute, indices);
                    geometry2.setAttribute(name, newAttribute);
                }
                // morph attributes
                var morphAttributes = this.morphAttributes;
                for(var name1 in morphAttributes){
                    var morphArray = [];
                    var morphAttribute = morphAttributes[name1]; // morphAttribute: array of Float32BufferAttributes
                    for(var i = 0, il = morphAttribute.length; i < il; i++){
                        var attribute1 = morphAttribute[i];
                        var newAttribute1 = convertBufferAttribute(attribute1, indices);
                        morphArray.push(newAttribute1);
                    }
                    geometry2.morphAttributes[name1] = morphArray;
                }
                geometry2.morphTargetsRelative = this.morphTargetsRelative;
                // groups
                var groups = this.groups;
                for(var i1 = 0, l = groups.length; i1 < l; i1++){
                    var group = groups[i1];
                    geometry2.addGroup(group.start, group.count, group.materialIndex);
                }
                return geometry2;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = {
                    metadata: {
                        version: 4.6,
                        type: 'BufferGeometry',
                        generator: 'BufferGeometry.toJSON'
                    }
                };
                // standard BufferGeometry serialization
                data.uuid = this.uuid;
                data.type = this.type;
                if (this.name !== '') data.name = this.name;
                if (Object.keys(this.userData).length > 0) data.userData = this.userData;
                if (this.parameters !== undefined) {
                    var parameters = this.parameters;
                    for(var key in parameters)if (parameters[key] !== undefined) data[key] = parameters[key];
                    return data;
                }
                // for simplicity the code assumes attributes are not shared across geometries, see #15811
                data.data = {
                    attributes: {}
                };
                var index = this.index;
                if (index !== null) data.data.index = {
                    type: index.array.constructor.name,
                    array: Array.prototype.slice.call(index.array)
                };
                var attributes = this.attributes;
                for(var key1 in attributes){
                    var attribute = attributes[key1];
                    data.data.attributes[key1] = attribute.toJSON(data.data);
                }
                var morphAttributes = {};
                var hasMorphAttributes = false;
                for(var key2 in this.morphAttributes){
                    var attributeArray = this.morphAttributes[key2];
                    var array = [];
                    for(var i = 0, il = attributeArray.length; i < il; i++){
                        var attribute1 = attributeArray[i];
                        array.push(attribute1.toJSON(data.data));
                    }
                    if (array.length > 0) {
                        morphAttributes[key2] = array;
                        hasMorphAttributes = true;
                    }
                }
                if (hasMorphAttributes) {
                    data.data.morphAttributes = morphAttributes;
                    data.data.morphTargetsRelative = this.morphTargetsRelative;
                }
                var groups = this.groups;
                if (groups.length > 0) data.data.groups = JSON.parse(JSON.stringify(groups));
                var boundingSphere = this.boundingSphere;
                if (boundingSphere !== null) data.data.boundingSphere = {
                    center: boundingSphere.center.toArray(),
                    radius: boundingSphere.radius
                };
                return data;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                // reset
                this.index = null;
                this.attributes = {};
                this.morphAttributes = {};
                this.groups = [];
                this.boundingBox = null;
                this.boundingSphere = null;
                // used for storing cloned, shared data
                var data = {};
                // name
                this.name = source.name;
                // index
                var index = source.index;
                if (index !== null) this.setIndex(index.clone(data));
                // attributes
                var attributes = source.attributes;
                for(var name in attributes){
                    var attribute = attributes[name];
                    this.setAttribute(name, attribute.clone(data));
                }
                // morph attributes
                var morphAttributes = source.morphAttributes;
                for(var name1 in morphAttributes){
                    var array = [];
                    var morphAttribute = morphAttributes[name1]; // morphAttribute: array of Float32BufferAttributes
                    for(var i = 0, l = morphAttribute.length; i < l; i++)array.push(morphAttribute[i].clone(data));
                    this.morphAttributes[name1] = array;
                }
                this.morphTargetsRelative = source.morphTargetsRelative;
                // groups
                var groups = source.groups;
                for(var i1 = 0, l1 = groups.length; i1 < l1; i1++){
                    var group = groups[i1];
                    this.addGroup(group.start, group.count, group.materialIndex);
                }
                // bounding box
                var boundingBox = source.boundingBox;
                if (boundingBox !== null) this.boundingBox = boundingBox.clone();
                // bounding sphere
                var boundingSphere = source.boundingSphere;
                if (boundingSphere !== null) this.boundingSphere = boundingSphere.clone();
                // draw range
                this.drawRange.start = source.drawRange.start;
                this.drawRange.count = source.drawRange.count;
                // user data
                this.userData = source.userData;
                return this;
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this.dispatchEvent({
                    type: 'dispose'
                });
            }
        }
    ]);
    return BufferGeometry;
}($1a55656020b89c3a$export$ec8b666c5fe2c75a);
var $1a55656020b89c3a$var$_inverseMatrix$3 = /*@__PURE__*/ new $1a55656020b89c3a$export$2ae72fc923e5eb5();
var $1a55656020b89c3a$var$_ray$3 = /*@__PURE__*/ new $1a55656020b89c3a$export$a186db52eed6d40e();
var $1a55656020b89c3a$var$_sphere$6 = /*@__PURE__*/ new $1a55656020b89c3a$export$805e8b72413ccaba();
var $1a55656020b89c3a$var$_sphereHitAt = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_vA$1 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_vB$1 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_vC$1 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_tempA = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_morphA = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_intersectionPoint = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_intersectionPointWorld = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$export$e176487c05830cc5 = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(Mesh, Object3D);
    function Mesh() {
        var geometry = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $1a55656020b89c3a$export$b7be63a67df8959(), material = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $1a55656020b89c3a$export$55cbcc9b622fe1f5();
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Mesh);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, Mesh);
        _this.isMesh = true;
        _this.type = 'Mesh';
        _this.geometry = geometry;
        _this.material = material;
        _this.updateMorphTargets();
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Mesh, [
        {
            key: "copy",
            value: function copy(source, recursive) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(Mesh.prototype), "copy", this).call(this, source, recursive);
                if (source.morphTargetInfluences !== undefined) this.morphTargetInfluences = source.morphTargetInfluences.slice();
                if (source.morphTargetDictionary !== undefined) this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
                this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
                this.geometry = source.geometry;
                return this;
            }
        },
        {
            key: "updateMorphTargets",
            value: function updateMorphTargets() {
                var geometry = this.geometry;
                var morphAttributes = geometry.morphAttributes;
                var keys = Object.keys(morphAttributes);
                if (keys.length > 0) {
                    var morphAttribute = morphAttributes[keys[0]];
                    if (morphAttribute !== undefined) {
                        this.morphTargetInfluences = [];
                        this.morphTargetDictionary = {};
                        for(var m = 0, ml = morphAttribute.length; m < ml; m++){
                            var name = morphAttribute[m].name || String(m);
                            this.morphTargetInfluences.push(0);
                            this.morphTargetDictionary[name] = m;
                        }
                    }
                }
            }
        },
        {
            key: "getVertexPosition",
            value: function getVertexPosition(index, target) {
                var geometry = this.geometry;
                var position = geometry.attributes.position;
                var morphPosition = geometry.morphAttributes.position;
                var morphTargetsRelative = geometry.morphTargetsRelative;
                target.fromBufferAttribute(position, index);
                var morphInfluences = this.morphTargetInfluences;
                if (morphPosition && morphInfluences) {
                    $1a55656020b89c3a$var$_morphA.set(0, 0, 0);
                    for(var i = 0, il = morphPosition.length; i < il; i++){
                        var influence = morphInfluences[i];
                        var morphAttribute = morphPosition[i];
                        if (influence === 0) continue;
                        $1a55656020b89c3a$var$_tempA.fromBufferAttribute(morphAttribute, index);
                        if (morphTargetsRelative) $1a55656020b89c3a$var$_morphA.addScaledVector($1a55656020b89c3a$var$_tempA, influence);
                        else $1a55656020b89c3a$var$_morphA.addScaledVector($1a55656020b89c3a$var$_tempA.sub(target), influence);
                    }
                    target.add($1a55656020b89c3a$var$_morphA);
                }
                return target;
            }
        },
        {
            key: "raycast",
            value: function raycast(raycaster, intersects) {
                var geometry = this.geometry;
                var material = this.material;
                var matrixWorld = this.matrixWorld;
                if (material === undefined) return;
                // test with bounding sphere in world space
                if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                $1a55656020b89c3a$var$_sphere$6.copy(geometry.boundingSphere);
                $1a55656020b89c3a$var$_sphere$6.applyMatrix4(matrixWorld);
                // check distance from ray origin to bounding sphere
                $1a55656020b89c3a$var$_ray$3.copy(raycaster.ray).recast(raycaster.near);
                if ($1a55656020b89c3a$var$_sphere$6.containsPoint($1a55656020b89c3a$var$_ray$3.origin) === false) {
                    if ($1a55656020b89c3a$var$_ray$3.intersectSphere($1a55656020b89c3a$var$_sphere$6, $1a55656020b89c3a$var$_sphereHitAt) === null) return;
                    if ($1a55656020b89c3a$var$_ray$3.origin.distanceToSquared($1a55656020b89c3a$var$_sphereHitAt) > Math.pow(raycaster.far - raycaster.near, 2)) return;
                }
                // convert ray to local space of mesh
                $1a55656020b89c3a$var$_inverseMatrix$3.copy(matrixWorld).invert();
                $1a55656020b89c3a$var$_ray$3.copy(raycaster.ray).applyMatrix4($1a55656020b89c3a$var$_inverseMatrix$3);
                // test with bounding box in local space
                if (geometry.boundingBox !== null) {
                    if ($1a55656020b89c3a$var$_ray$3.intersectsBox(geometry.boundingBox) === false) return;
                }
                // test for intersections with geometry
                this._computeIntersections(raycaster, intersects, $1a55656020b89c3a$var$_ray$3);
            }
        },
        {
            key: "_computeIntersections",
            value: function _computeIntersections(raycaster, intersects, rayLocalSpace) {
                var intersection;
                var geometry = this.geometry;
                var material = this.material;
                var index = geometry.index;
                var position = geometry.attributes.position;
                var uv = geometry.attributes.uv;
                var uv1 = geometry.attributes.uv1;
                var normal = geometry.attributes.normal;
                var groups = geometry.groups;
                var drawRange = geometry.drawRange;
                if (index !== null) {
                    // indexed buffer geometry
                    if (Array.isArray(material)) for(var i = 0, il = groups.length; i < il; i++){
                        var group = groups[i];
                        var groupMaterial = material[group.materialIndex];
                        var start = Math.max(group.start, drawRange.start);
                        var end = Math.min(index.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                        for(var j = start, jl = end; j < jl; j += 3){
                            var a = index.getX(j);
                            var b = index.getX(j + 1);
                            var c = index.getX(j + 2);
                            intersection = $1a55656020b89c3a$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                            if (intersection) {
                                intersection.faceIndex = Math.floor(j / 3); // triangle number in indexed buffer semantics
                                intersection.face.materialIndex = group.materialIndex;
                                intersects.push(intersection);
                            }
                        }
                    }
                    else {
                        var start1 = Math.max(0, drawRange.start);
                        var end1 = Math.min(index.count, drawRange.start + drawRange.count);
                        for(var i1 = start1, il1 = end1; i1 < il1; i1 += 3){
                            var a1 = index.getX(i1);
                            var b1 = index.getX(i1 + 1);
                            var c1 = index.getX(i1 + 2);
                            intersection = $1a55656020b89c3a$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a1, b1, c1);
                            if (intersection) {
                                intersection.faceIndex = Math.floor(i1 / 3); // triangle number in indexed buffer semantics
                                intersects.push(intersection);
                            }
                        }
                    }
                } else if (position !== undefined) {
                    // non-indexed buffer geometry
                    if (Array.isArray(material)) for(var i2 = 0, il2 = groups.length; i2 < il2; i2++){
                        var group1 = groups[i2];
                        var groupMaterial1 = material[group1.materialIndex];
                        var start2 = Math.max(group1.start, drawRange.start);
                        var end2 = Math.min(position.count, Math.min(group1.start + group1.count, drawRange.start + drawRange.count));
                        for(var j1 = start2, jl1 = end2; j1 < jl1; j1 += 3){
                            var a2 = j1;
                            var b2 = j1 + 1;
                            var c2 = j1 + 2;
                            intersection = $1a55656020b89c3a$var$checkGeometryIntersection(this, groupMaterial1, raycaster, rayLocalSpace, uv, uv1, normal, a2, b2, c2);
                            if (intersection) {
                                intersection.faceIndex = Math.floor(j1 / 3); // triangle number in non-indexed buffer semantics
                                intersection.face.materialIndex = group1.materialIndex;
                                intersects.push(intersection);
                            }
                        }
                    }
                    else {
                        var start3 = Math.max(0, drawRange.start);
                        var end3 = Math.min(position.count, drawRange.start + drawRange.count);
                        for(var i3 = start3, il3 = end3; i3 < il3; i3 += 3){
                            var a3 = i3;
                            var b3 = i3 + 1;
                            var c3 = i3 + 2;
                            intersection = $1a55656020b89c3a$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a3, b3, c3);
                            if (intersection) {
                                intersection.faceIndex = Math.floor(i3 / 3); // triangle number in non-indexed buffer semantics
                                intersects.push(intersection);
                            }
                        }
                    }
                }
            }
        }
    ]);
    return Mesh;
}($1a55656020b89c3a$export$e4dd07dff30cc924);
function $1a55656020b89c3a$var$checkIntersection$1(object, material, raycaster, ray, pA, pB, pC, point) {
    var intersect;
    if (material.side === $1a55656020b89c3a$export$d9f0486e75b5ace) intersect = ray.intersectTriangle(pC, pB, pA, true, point);
    else intersect = ray.intersectTriangle(pA, pB, pC, material.side === $1a55656020b89c3a$export$2ede184fc2998901, point);
    if (intersect === null) return null;
    $1a55656020b89c3a$var$_intersectionPointWorld.copy(point);
    $1a55656020b89c3a$var$_intersectionPointWorld.applyMatrix4(object.matrixWorld);
    var distance = raycaster.ray.origin.distanceTo($1a55656020b89c3a$var$_intersectionPointWorld);
    if (distance < raycaster.near || distance > raycaster.far) return null;
    return {
        distance: distance,
        point: $1a55656020b89c3a$var$_intersectionPointWorld.clone(),
        object: object
    };
}
function $1a55656020b89c3a$var$checkGeometryIntersection(object, material, raycaster, ray, uv, uv1, normal, a, b, c) {
    object.getVertexPosition(a, $1a55656020b89c3a$var$_vA$1);
    object.getVertexPosition(b, $1a55656020b89c3a$var$_vB$1);
    object.getVertexPosition(c, $1a55656020b89c3a$var$_vC$1);
    var intersection = $1a55656020b89c3a$var$checkIntersection$1(object, material, raycaster, ray, $1a55656020b89c3a$var$_vA$1, $1a55656020b89c3a$var$_vB$1, $1a55656020b89c3a$var$_vC$1, $1a55656020b89c3a$var$_intersectionPoint);
    if (intersection) {
        var barycoord = new $1a55656020b89c3a$export$64b5c384219d3699();
        $1a55656020b89c3a$export$5a465592bfe74b48.getBarycoord($1a55656020b89c3a$var$_intersectionPoint, $1a55656020b89c3a$var$_vA$1, $1a55656020b89c3a$var$_vB$1, $1a55656020b89c3a$var$_vC$1, barycoord);
        if (uv) intersection.uv = $1a55656020b89c3a$export$5a465592bfe74b48.getInterpolatedAttribute(uv, a, b, c, barycoord, new $1a55656020b89c3a$export$c977b3e384af9ae1());
        if (uv1) intersection.uv1 = $1a55656020b89c3a$export$5a465592bfe74b48.getInterpolatedAttribute(uv1, a, b, c, barycoord, new $1a55656020b89c3a$export$c977b3e384af9ae1());
        if (normal) {
            intersection.normal = $1a55656020b89c3a$export$5a465592bfe74b48.getInterpolatedAttribute(normal, a, b, c, barycoord, new $1a55656020b89c3a$export$64b5c384219d3699());
            if (intersection.normal.dot(ray.direction) > 0) intersection.normal.multiplyScalar(-1);
        }
        var face = {
            a: a,
            b: b,
            c: c,
            normal: new $1a55656020b89c3a$export$64b5c384219d3699(),
            materialIndex: 0
        };
        $1a55656020b89c3a$export$5a465592bfe74b48.getNormal($1a55656020b89c3a$var$_vA$1, $1a55656020b89c3a$var$_vB$1, $1a55656020b89c3a$var$_vC$1, face.normal);
        intersection.face = face;
        intersection.barycoord = barycoord;
    }
    return intersection;
}
var $1a55656020b89c3a$export$33e43285f7406bd5 = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(BoxGeometry, BufferGeometry);
    function BoxGeometry() {
        var width = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, height = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, widthSegments = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1, heightSegments = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 1, depthSegments = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 1;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, BoxGeometry);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, BoxGeometry);
        _this.type = 'BoxGeometry';
        _this.parameters = {
            width: width,
            height: height,
            depth: depth,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            depthSegments: depthSegments
        };
        var scope = _this;
        // segments
        widthSegments = Math.floor(widthSegments);
        heightSegments = Math.floor(heightSegments);
        depthSegments = Math.floor(depthSegments);
        // buffers
        var indices = [];
        var vertices = [];
        var normals = [];
        var uvs = [];
        // helper variables
        var numberOfVertices = 0;
        var groupStart = 0;
        // build each side of the box geometry
        buildPlane('z', 'y', 'x', -1, -1, depth, height, width, depthSegments, heightSegments, 0); // px
        buildPlane('z', 'y', 'x', 1, -1, depth, height, -width, depthSegments, heightSegments, 1); // nx
        buildPlane('x', 'z', 'y', 1, 1, width, depth, height, widthSegments, depthSegments, 2); // py
        buildPlane('x', 'z', 'y', 1, -1, width, depth, -height, widthSegments, depthSegments, 3); // ny
        buildPlane('x', 'y', 'z', 1, -1, width, height, depth, widthSegments, heightSegments, 4); // pz
        buildPlane('x', 'y', 'z', -1, -1, width, height, -depth, widthSegments, heightSegments, 5); // nz
        // build geometry
        _this.setIndex(indices);
        _this.setAttribute('position', new $1a55656020b89c3a$export$cbe7a62641830ebd(vertices, 3));
        _this.setAttribute('normal', new $1a55656020b89c3a$export$cbe7a62641830ebd(normals, 3));
        _this.setAttribute('uv', new $1a55656020b89c3a$export$cbe7a62641830ebd(uvs, 2));
        function buildPlane(u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex) {
            var segmentWidth = width / gridX;
            var segmentHeight = height / gridY;
            var widthHalf = width / 2;
            var heightHalf = height / 2;
            var depthHalf = depth / 2;
            var gridX1 = gridX + 1;
            var gridY1 = gridY + 1;
            var vertexCounter = 0;
            var groupCount = 0;
            var vector = new $1a55656020b89c3a$export$64b5c384219d3699();
            // generate vertices, normals and uvs
            for(var iy = 0; iy < gridY1; iy++){
                var y = iy * segmentHeight - heightHalf;
                for(var ix = 0; ix < gridX1; ix++){
                    var x = ix * segmentWidth - widthHalf;
                    // set values to correct vector component
                    vector[u] = x * udir;
                    vector[v] = y * vdir;
                    vector[w] = depthHalf;
                    // now apply vector to vertex buffer
                    vertices.push(vector.x, vector.y, vector.z);
                    // set values to correct vector component
                    vector[u] = 0;
                    vector[v] = 0;
                    vector[w] = depth > 0 ? 1 : -1;
                    // now apply vector to normal buffer
                    normals.push(vector.x, vector.y, vector.z);
                    // uvs
                    uvs.push(ix / gridX);
                    uvs.push(1 - iy / gridY);
                    // counters
                    vertexCounter += 1;
                }
            }
            // indices
            // 1. you need three indices to draw a single face
            // 2. a single segment consists of two faces
            // 3. so we need to generate six (2*3) indices per segment
            for(var iy1 = 0; iy1 < gridY; iy1++)for(var ix1 = 0; ix1 < gridX; ix1++){
                var a = numberOfVertices + ix1 + gridX1 * iy1;
                var b = numberOfVertices + ix1 + gridX1 * (iy1 + 1);
                var c = numberOfVertices + (ix1 + 1) + gridX1 * (iy1 + 1);
                var d = numberOfVertices + (ix1 + 1) + gridX1 * iy1;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // increase counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, materialIndex);
            // calculate new start value for groups
            groupStart += groupCount;
            // update total number of vertices
            numberOfVertices += vertexCounter;
        }
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(BoxGeometry, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(BoxGeometry.prototype), "copy", this).call(this, source);
                this.parameters = Object.assign({}, source.parameters);
                return this;
            }
        }
    ], [
        {
            key: "fromJSON",
            value: function fromJSON(data) {
                return new BoxGeometry(data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
            }
        }
    ]);
    return BoxGeometry;
}($1a55656020b89c3a$export$b7be63a67df8959);
/**
 * Uniform Utilities
 */ function $1a55656020b89c3a$export$acda854380553452(src) {
    var dst = {};
    for(var u in src){
        dst[u] = {};
        for(var p in src[u]){
            var property = src[u][p];
            if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) {
                if (property.isRenderTargetTexture) {
                    console.warn('UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms().');
                    dst[u][p] = null;
                } else dst[u][p] = property.clone();
            } else if (Array.isArray(property)) dst[u][p] = property.slice();
            else dst[u][p] = property;
        }
    }
    return dst;
}
function $1a55656020b89c3a$export$8916ce6879271f43(uniforms) {
    var merged = {};
    for(var u = 0; u < uniforms.length; u++){
        var tmp = $1a55656020b89c3a$export$acda854380553452(uniforms[u]);
        for(var p in tmp)merged[p] = tmp[p];
    }
    return merged;
}
function $1a55656020b89c3a$var$cloneUniformsGroups(src) {
    var dst = [];
    for(var u = 0; u < src.length; u++)dst.push(src[u].clone());
    return dst;
}
function $1a55656020b89c3a$export$a630742c640528c1(renderer) {
    var currentRenderTarget = renderer.getRenderTarget();
    if (currentRenderTarget === null) // https://github.com/mrdoob/three.js/pull/23937#issuecomment-1111067398
    return renderer.outputColorSpace;
    // https://github.com/mrdoob/three.js/issues/27868
    if (currentRenderTarget.isXRRenderTarget === true) return currentRenderTarget.texture.colorSpace;
    return $1a55656020b89c3a$export$5e6fd513f44698c.workingColorSpace;
}
// Legacy
var $1a55656020b89c3a$export$d8ecdf8615bfea69 = {
    clone: $1a55656020b89c3a$export$acda854380553452,
    merge: $1a55656020b89c3a$export$8916ce6879271f43
};
var $1a55656020b89c3a$var$default_vertex = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
var $1a55656020b89c3a$var$default_fragment = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
var $1a55656020b89c3a$export$83c7d75d550a8b0d = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(ShaderMaterial, Material);
    function ShaderMaterial(parameters) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, ShaderMaterial);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, ShaderMaterial);
        _this.isShaderMaterial = true;
        _this.type = 'ShaderMaterial';
        _this.defines = {};
        _this.uniforms = {};
        _this.uniformsGroups = [];
        _this.vertexShader = $1a55656020b89c3a$var$default_vertex;
        _this.fragmentShader = $1a55656020b89c3a$var$default_fragment;
        _this.linewidth = 1;
        _this.wireframe = false;
        _this.wireframeLinewidth = 1;
        _this.fog = false; // set to use scene fog
        _this.lights = false; // set to use scene lights
        _this.clipping = false; // set to use user-defined clipping planes
        _this.forceSinglePass = true;
        _this.extensions = {
            clipCullDistance: false,
            multiDraw: false // set to use vertex shader multi_draw / enable gl_DrawID
        };
        // When rendered geometry doesn't include these attributes but the material does,
        // use these default values in WebGL. This avoids errors when buffer data is missing.
        _this.defaultAttributeValues = {
            'color': [
                1,
                1,
                1
            ],
            'uv': [
                0,
                0
            ],
            'uv1': [
                0,
                0
            ]
        };
        _this.index0AttributeName = undefined;
        _this.uniformsNeedUpdate = false;
        _this.glslVersion = null;
        if (parameters !== undefined) _this.setValues(parameters);
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(ShaderMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(ShaderMaterial.prototype), "copy", this).call(this, source);
                this.fragmentShader = source.fragmentShader;
                this.vertexShader = source.vertexShader;
                this.uniforms = $1a55656020b89c3a$export$acda854380553452(source.uniforms);
                this.uniformsGroups = $1a55656020b89c3a$var$cloneUniformsGroups(source.uniformsGroups);
                this.defines = Object.assign({}, source.defines);
                this.wireframe = source.wireframe;
                this.wireframeLinewidth = source.wireframeLinewidth;
                this.fog = source.fog;
                this.lights = source.lights;
                this.clipping = source.clipping;
                this.extensions = Object.assign({}, source.extensions);
                this.glslVersion = source.glslVersion;
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON(meta) {
                var data = (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(ShaderMaterial.prototype), "toJSON", this).call(this, meta);
                data.glslVersion = this.glslVersion;
                data.uniforms = {};
                for(var name in this.uniforms){
                    var uniform = this.uniforms[name];
                    var value = uniform.value;
                    if (value && value.isTexture) data.uniforms[name] = {
                        type: 't',
                        value: value.toJSON(meta).uuid
                    };
                    else if (value && value.isColor) data.uniforms[name] = {
                        type: 'c',
                        value: value.getHex()
                    };
                    else if (value && value.isVector2) data.uniforms[name] = {
                        type: 'v2',
                        value: value.toArray()
                    };
                    else if (value && value.isVector3) data.uniforms[name] = {
                        type: 'v3',
                        value: value.toArray()
                    };
                    else if (value && value.isVector4) data.uniforms[name] = {
                        type: 'v4',
                        value: value.toArray()
                    };
                    else if (value && value.isMatrix3) data.uniforms[name] = {
                        type: 'm3',
                        value: value.toArray()
                    };
                    else if (value && value.isMatrix4) data.uniforms[name] = {
                        type: 'm4',
                        value: value.toArray()
                    };
                    else data.uniforms[name] = {
                        value: value
                    };
                }
                if (Object.keys(this.defines).length > 0) data.defines = this.defines;
                data.vertexShader = this.vertexShader;
                data.fragmentShader = this.fragmentShader;
                data.lights = this.lights;
                data.clipping = this.clipping;
                var extensions = {};
                for(var key in this.extensions)if (this.extensions[key] === true) extensions[key] = true;
                if (Object.keys(extensions).length > 0) data.extensions = extensions;
                return data;
            }
        }
    ]);
    return ShaderMaterial;
}($1a55656020b89c3a$export$a2d8b23205c25948);
var $1a55656020b89c3a$export$79f141de891a5fed = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(Camera, Object3D);
    function Camera() {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Camera);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, Camera);
        _this.isCamera = true;
        _this.type = 'Camera';
        _this.matrixWorldInverse = new $1a55656020b89c3a$export$2ae72fc923e5eb5();
        _this.projectionMatrix = new $1a55656020b89c3a$export$2ae72fc923e5eb5();
        _this.projectionMatrixInverse = new $1a55656020b89c3a$export$2ae72fc923e5eb5();
        _this.coordinateSystem = $1a55656020b89c3a$export$5a0e9190d10875d3;
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Camera, [
        {
            key: "copy",
            value: function copy(source, recursive) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(Camera.prototype), "copy", this).call(this, source, recursive);
                this.matrixWorldInverse.copy(source.matrixWorldInverse);
                this.projectionMatrix.copy(source.projectionMatrix);
                this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
                this.coordinateSystem = source.coordinateSystem;
                return this;
            }
        },
        {
            key: "getWorldDirection",
            value: function getWorldDirection(target) {
                return (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(Camera.prototype), "getWorldDirection", this).call(this, target).negate();
            }
        },
        {
            key: "updateMatrixWorld",
            value: function updateMatrixWorld(force) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(Camera.prototype), "updateMatrixWorld", this).call(this, force);
                this.matrixWorldInverse.copy(this.matrixWorld).invert();
            }
        },
        {
            key: "updateWorldMatrix",
            value: function updateWorldMatrix(updateParents, updateChildren) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(Camera.prototype), "updateWorldMatrix", this).call(this, updateParents, updateChildren);
                this.matrixWorldInverse.copy(this.matrixWorld).invert();
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        }
    ]);
    return Camera;
}($1a55656020b89c3a$export$e4dd07dff30cc924);
var $1a55656020b89c3a$var$_v3$1 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_minTarget = /*@__PURE__*/ new $1a55656020b89c3a$export$c977b3e384af9ae1();
var $1a55656020b89c3a$var$_maxTarget = /*@__PURE__*/ new $1a55656020b89c3a$export$c977b3e384af9ae1();
var $1a55656020b89c3a$export$74e4ae24825f68d7 = /*#__PURE__*/ function(Camera) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(PerspectiveCamera, Camera);
    function PerspectiveCamera() {
        var fov = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 50, aspect = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, near = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0.1, far = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 2000;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, PerspectiveCamera);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, PerspectiveCamera);
        _this.isPerspectiveCamera = true;
        _this.type = 'PerspectiveCamera';
        _this.fov = fov;
        _this.zoom = 1;
        _this.near = near;
        _this.far = far;
        _this.focus = 10;
        _this.aspect = aspect;
        _this.view = null;
        _this.filmGauge = 35; // width of the film (default in millimeters)
        _this.filmOffset = 0; // horizontal film offset (same unit as gauge)
        _this.updateProjectionMatrix();
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(PerspectiveCamera, [
        {
            key: "copy",
            value: function copy(source, recursive) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(PerspectiveCamera.prototype), "copy", this).call(this, source, recursive);
                this.fov = source.fov;
                this.zoom = source.zoom;
                this.near = source.near;
                this.far = source.far;
                this.focus = source.focus;
                this.aspect = source.aspect;
                this.view = source.view === null ? null : Object.assign({}, source.view);
                this.filmGauge = source.filmGauge;
                this.filmOffset = source.filmOffset;
                return this;
            }
        },
        {
            /**
	 * Sets the FOV by focal length in respect to the current .filmGauge.
	 *
	 * The default film gauge is 35, so that the focal length can be specified for
	 * a 35mm (full frame) camera.
	 *
	 * @param {number} focalLength - Values for focal length and film gauge must have the same unit.
	 */ key: "setFocalLength",
            value: function setFocalLength(focalLength) {
                /** see {@link http://www.bobatkins.com/photography/technical/field_of_view.html} */ var vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
                this.fov = $1a55656020b89c3a$export$914076c8150813e5 * 2 * Math.atan(vExtentSlope);
                this.updateProjectionMatrix();
            }
        },
        {
            /**
	 * Calculates the focal length from the current .fov and .filmGauge.
	 *
	 * @returns {number}
	 */ key: "getFocalLength",
            value: function getFocalLength() {
                var vExtentSlope = Math.tan($1a55656020b89c3a$var$DEG2RAD * 0.5 * this.fov);
                return 0.5 * this.getFilmHeight() / vExtentSlope;
            }
        },
        {
            key: "getEffectiveFOV",
            value: function getEffectiveFOV() {
                return $1a55656020b89c3a$export$914076c8150813e5 * 2 * Math.atan(Math.tan($1a55656020b89c3a$var$DEG2RAD * 0.5 * this.fov) / this.zoom);
            }
        },
        {
            key: "getFilmWidth",
            value: function getFilmWidth() {
                // film not completely covered in portrait format (aspect < 1)
                return this.filmGauge * Math.min(this.aspect, 1);
            }
        },
        {
            key: "getFilmHeight",
            value: function getFilmHeight() {
                // film not completely covered in landscape format (aspect > 1)
                return this.filmGauge / Math.max(this.aspect, 1);
            }
        },
        {
            /**
	 * Computes the 2D bounds of the camera's viewable rectangle at a given distance along the viewing direction.
	 * Sets minTarget and maxTarget to the coordinates of the lower-left and upper-right corners of the view rectangle.
	 *
	 * @param {number} distance
	 * @param {Vector2} minTarget
	 * @param {Vector2} maxTarget
	 */ key: "getViewBounds",
            value: function getViewBounds(distance, minTarget, maxTarget) {
                $1a55656020b89c3a$var$_v3$1.set(-1, -1, 0.5).applyMatrix4(this.projectionMatrixInverse);
                minTarget.set($1a55656020b89c3a$var$_v3$1.x, $1a55656020b89c3a$var$_v3$1.y).multiplyScalar(-distance / $1a55656020b89c3a$var$_v3$1.z);
                $1a55656020b89c3a$var$_v3$1.set(1, 1, 0.5).applyMatrix4(this.projectionMatrixInverse);
                maxTarget.set($1a55656020b89c3a$var$_v3$1.x, $1a55656020b89c3a$var$_v3$1.y).multiplyScalar(-distance / $1a55656020b89c3a$var$_v3$1.z);
            }
        },
        {
            /**
	 * Computes the width and height of the camera's viewable rectangle at a given distance along the viewing direction.
	 *
	 * @param {number} distance
	 * @param {Vector2} target - Vector2 target used to store result where x is width and y is height.
	 * @returns {Vector2}
	 */ key: "getViewSize",
            value: function getViewSize(distance, target) {
                this.getViewBounds(distance, $1a55656020b89c3a$var$_minTarget, $1a55656020b89c3a$var$_maxTarget);
                return target.subVectors($1a55656020b89c3a$var$_maxTarget, $1a55656020b89c3a$var$_minTarget);
            }
        },
        {
            /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
	 * the monitors are in grid like this
	 *
	 *   +---+---+---+
	 *   | A | B | C |
	 *   +---+---+---+
	 *   | D | E | F |
	 *   +---+---+---+
	 *
	 * then for each monitor you would call it like this
	 *
	 *   const w = 1920;
	 *   const h = 1080;
	 *   const fullWidth = w * 3;
	 *   const fullHeight = h * 2;
	 *
	 *   --A--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
	 *   --B--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
	 *   --C--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
	 *   --D--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
	 *   --E--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
	 *   --F--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
	 *
	 *   Note there is no reason monitors have to be the same size or in a grid.
	 *
	 * @param {number} fullWidth
	 * @param {number} fullHeight
	 * @param {number} x
	 * @param {number} y
	 * @param {number} width
	 * @param {number} height
	 */ key: "setViewOffset",
            value: function setViewOffset(fullWidth, fullHeight, x, y, width, height) {
                this.aspect = fullWidth / fullHeight;
                if (this.view === null) this.view = {
                    enabled: true,
                    fullWidth: 1,
                    fullHeight: 1,
                    offsetX: 0,
                    offsetY: 0,
                    width: 1,
                    height: 1
                };
                this.view.enabled = true;
                this.view.fullWidth = fullWidth;
                this.view.fullHeight = fullHeight;
                this.view.offsetX = x;
                this.view.offsetY = y;
                this.view.width = width;
                this.view.height = height;
                this.updateProjectionMatrix();
            }
        },
        {
            key: "clearViewOffset",
            value: function clearViewOffset() {
                if (this.view !== null) this.view.enabled = false;
                this.updateProjectionMatrix();
            }
        },
        {
            key: "updateProjectionMatrix",
            value: function updateProjectionMatrix() {
                var near = this.near;
                var top = near * Math.tan($1a55656020b89c3a$var$DEG2RAD * 0.5 * this.fov) / this.zoom;
                var height = 2 * top;
                var width = this.aspect * height;
                var left = -0.5 * width;
                var view = this.view;
                if (this.view !== null && this.view.enabled) {
                    var fullWidth = view.fullWidth, fullHeight = view.fullHeight;
                    left += view.offsetX * width / fullWidth;
                    top -= view.offsetY * height / fullHeight;
                    width *= view.width / fullWidth;
                    height *= view.height / fullHeight;
                }
                var skew = this.filmOffset;
                if (skew !== 0) left += near * skew / this.getFilmWidth();
                this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far, this.coordinateSystem);
                this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
            }
        },
        {
            key: "toJSON",
            value: function toJSON(meta) {
                var data = (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(PerspectiveCamera.prototype), "toJSON", this).call(this, meta);
                data.object.fov = this.fov;
                data.object.zoom = this.zoom;
                data.object.near = this.near;
                data.object.far = this.far;
                data.object.focus = this.focus;
                data.object.aspect = this.aspect;
                if (this.view !== null) data.object.view = Object.assign({}, this.view);
                data.object.filmGauge = this.filmGauge;
                data.object.filmOffset = this.filmOffset;
                return data;
            }
        }
    ]);
    return PerspectiveCamera;
}($1a55656020b89c3a$export$79f141de891a5fed);
var $1a55656020b89c3a$var$fov = -90; // negative fov is not an error
var $1a55656020b89c3a$var$aspect = 1;
var $1a55656020b89c3a$export$d0cdd0bd804995de = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(CubeCamera, Object3D);
    function CubeCamera(near, far, renderTarget) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, CubeCamera);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, CubeCamera);
        _this.type = 'CubeCamera';
        _this.renderTarget = renderTarget;
        _this.coordinateSystem = null;
        _this.activeMipmapLevel = 0;
        var cameraPX = new $1a55656020b89c3a$export$74e4ae24825f68d7($1a55656020b89c3a$var$fov, $1a55656020b89c3a$var$aspect, near, far);
        cameraPX.layers = _this.layers;
        _this.add(cameraPX);
        var cameraNX = new $1a55656020b89c3a$export$74e4ae24825f68d7($1a55656020b89c3a$var$fov, $1a55656020b89c3a$var$aspect, near, far);
        cameraNX.layers = _this.layers;
        _this.add(cameraNX);
        var cameraPY = new $1a55656020b89c3a$export$74e4ae24825f68d7($1a55656020b89c3a$var$fov, $1a55656020b89c3a$var$aspect, near, far);
        cameraPY.layers = _this.layers;
        _this.add(cameraPY);
        var cameraNY = new $1a55656020b89c3a$export$74e4ae24825f68d7($1a55656020b89c3a$var$fov, $1a55656020b89c3a$var$aspect, near, far);
        cameraNY.layers = _this.layers;
        _this.add(cameraNY);
        var cameraPZ = new $1a55656020b89c3a$export$74e4ae24825f68d7($1a55656020b89c3a$var$fov, $1a55656020b89c3a$var$aspect, near, far);
        cameraPZ.layers = _this.layers;
        _this.add(cameraPZ);
        var cameraNZ = new $1a55656020b89c3a$export$74e4ae24825f68d7($1a55656020b89c3a$var$fov, $1a55656020b89c3a$var$aspect, near, far);
        cameraNZ.layers = _this.layers;
        _this.add(cameraNZ);
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(CubeCamera, [
        {
            key: "updateCoordinateSystem",
            value: function updateCoordinateSystem() {
                var coordinateSystem = this.coordinateSystem;
                var cameras = this.children.concat();
                var _cameras = (0, $cccf0333cb9f9910$export$71511d61b312f219)(cameras, 6), cameraPX = _cameras[0], cameraNX = _cameras[1], cameraPY = _cameras[2], cameraNY = _cameras[3], cameraPZ = _cameras[4], cameraNZ = _cameras[5];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = cameras[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var camera = _step.value;
                        this.remove(camera);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (coordinateSystem === $1a55656020b89c3a$export$5a0e9190d10875d3) {
                    cameraPX.up.set(0, 1, 0);
                    cameraPX.lookAt(1, 0, 0);
                    cameraNX.up.set(0, 1, 0);
                    cameraNX.lookAt(-1, 0, 0);
                    cameraPY.up.set(0, 0, -1);
                    cameraPY.lookAt(0, 1, 0);
                    cameraNY.up.set(0, 0, 1);
                    cameraNY.lookAt(0, -1, 0);
                    cameraPZ.up.set(0, 1, 0);
                    cameraPZ.lookAt(0, 0, 1);
                    cameraNZ.up.set(0, 1, 0);
                    cameraNZ.lookAt(0, 0, -1);
                } else if (coordinateSystem === $1a55656020b89c3a$export$cc83beedcb9be9ac) {
                    cameraPX.up.set(0, -1, 0);
                    cameraPX.lookAt(-1, 0, 0);
                    cameraNX.up.set(0, -1, 0);
                    cameraNX.lookAt(1, 0, 0);
                    cameraPY.up.set(0, 0, 1);
                    cameraPY.lookAt(0, 1, 0);
                    cameraNY.up.set(0, 0, -1);
                    cameraNY.lookAt(0, -1, 0);
                    cameraPZ.up.set(0, -1, 0);
                    cameraPZ.lookAt(0, 0, 1);
                    cameraNZ.up.set(0, -1, 0);
                    cameraNZ.lookAt(0, 0, -1);
                } else throw new Error('THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: ' + coordinateSystem);
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = cameras[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var camera1 = _step1.value;
                        this.add(camera1);
                        camera1.updateMatrixWorld();
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        },
        {
            key: "update",
            value: function update(renderer, scene) {
                if (this.parent === null) this.updateMatrixWorld();
                var _this = this, renderTarget = _this.renderTarget, activeMipmapLevel = _this.activeMipmapLevel;
                if (this.coordinateSystem !== renderer.coordinateSystem) {
                    this.coordinateSystem = renderer.coordinateSystem;
                    this.updateCoordinateSystem();
                }
                var _this_children = (0, $cccf0333cb9f9910$export$71511d61b312f219)(this.children, 6), cameraPX = _this_children[0], cameraNX = _this_children[1], cameraPY = _this_children[2], cameraNY = _this_children[3], cameraPZ = _this_children[4], cameraNZ = _this_children[5];
                var currentRenderTarget = renderer.getRenderTarget();
                var currentActiveCubeFace = renderer.getActiveCubeFace();
                var currentActiveMipmapLevel = renderer.getActiveMipmapLevel();
                var currentXrEnabled = renderer.xr.enabled;
                renderer.xr.enabled = false;
                var generateMipmaps = renderTarget.texture.generateMipmaps;
                renderTarget.texture.generateMipmaps = false;
                renderer.setRenderTarget(renderTarget, 0, activeMipmapLevel);
                renderer.render(scene, cameraPX);
                renderer.setRenderTarget(renderTarget, 1, activeMipmapLevel);
                renderer.render(scene, cameraNX);
                renderer.setRenderTarget(renderTarget, 2, activeMipmapLevel);
                renderer.render(scene, cameraPY);
                renderer.setRenderTarget(renderTarget, 3, activeMipmapLevel);
                renderer.render(scene, cameraNY);
                renderer.setRenderTarget(renderTarget, 4, activeMipmapLevel);
                renderer.render(scene, cameraPZ);
                // mipmaps are generated during the last call of render()
                // at this point, all sides of the cube render target are defined
                renderTarget.texture.generateMipmaps = generateMipmaps;
                renderer.setRenderTarget(renderTarget, 5, activeMipmapLevel);
                renderer.render(scene, cameraNZ);
                renderer.setRenderTarget(currentRenderTarget, currentActiveCubeFace, currentActiveMipmapLevel);
                renderer.xr.enabled = currentXrEnabled;
                renderTarget.texture.needsPMREMUpdate = true;
            }
        }
    ]);
    return CubeCamera;
}($1a55656020b89c3a$export$e4dd07dff30cc924);
var $1a55656020b89c3a$export$ee2e5a18258a4049 = /*#__PURE__*/ function(Texture) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(CubeTexture, Texture);
    function CubeTexture(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, CubeTexture);
        var _this;
        images = images !== undefined ? images : [];
        mapping = mapping !== undefined ? mapping : $1a55656020b89c3a$export$8759762a6477f2c4;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, CubeTexture, [
            images,
            mapping,
            wrapS,
            wrapT,
            magFilter,
            minFilter,
            format,
            type,
            anisotropy,
            colorSpace
        ]);
        _this.isCubeTexture = true;
        _this.flipY = false;
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(CubeTexture, [
        {
            key: "images",
            get: function get() {
                return this.image;
            },
            set: function set(value) {
                this.image = value;
            }
        }
    ]);
    return CubeTexture;
}($1a55656020b89c3a$export$5431306cf43de24a);
var $1a55656020b89c3a$export$ac386671d651941e = /*#__PURE__*/ function(WebGLRenderTarget) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(WebGLCubeRenderTarget, WebGLRenderTarget);
    function WebGLCubeRenderTarget() {
        var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, WebGLCubeRenderTarget);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, WebGLCubeRenderTarget, [
            size,
            size,
            options
        ]);
        _this.isWebGLCubeRenderTarget = true;
        var image = {
            width: size,
            height: size,
            depth: 1
        };
        var images = [
            image,
            image,
            image,
            image,
            image,
            image
        ];
        _this.texture = new $1a55656020b89c3a$export$ee2e5a18258a4049(images, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace);
        // By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
        // in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
        // in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.
        // three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
        // and the flag isRenderTargetTexture controls this conversion. The flip is not required when using WebGLCubeRenderTarget.texture
        // as a cube texture (this is detected when isRenderTargetTexture is set to true for cube textures).
        _this.texture.isRenderTargetTexture = true;
        _this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        _this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : $1a55656020b89c3a$export$8a72f490b25c56c8;
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(WebGLCubeRenderTarget, [
        {
            key: "fromEquirectangularTexture",
            value: function fromEquirectangularTexture(renderer, texture) {
                this.texture.type = texture.type;
                this.texture.colorSpace = texture.colorSpace;
                this.texture.generateMipmaps = texture.generateMipmaps;
                this.texture.minFilter = texture.minFilter;
                this.texture.magFilter = texture.magFilter;
                var shader = {
                    uniforms: {
                        tEquirect: {
                            value: null
                        }
                    },
                    vertexShader: "\n\n				varying vec3 vWorldDirection;\n\n				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\n					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n\n				}\n\n				void main() {\n\n					vWorldDirection = transformDirection( position, modelMatrix );\n\n					#include <begin_vertex>\n					#include <project_vertex>\n\n				}\n			",
                    fragmentShader: "\n\n				uniform sampler2D tEquirect;\n\n				varying vec3 vWorldDirection;\n\n				#include <common>\n\n				void main() {\n\n					vec3 direction = normalize( vWorldDirection );\n\n					vec2 sampleUV = equirectUv( direction );\n\n					gl_FragColor = texture2D( tEquirect, sampleUV );\n\n				}\n			"
                };
                var geometry = new $1a55656020b89c3a$export$33e43285f7406bd5(5, 5, 5);
                var material = new $1a55656020b89c3a$export$83c7d75d550a8b0d({
                    name: 'CubemapFromEquirect',
                    uniforms: $1a55656020b89c3a$export$acda854380553452(shader.uniforms),
                    vertexShader: shader.vertexShader,
                    fragmentShader: shader.fragmentShader,
                    side: $1a55656020b89c3a$export$d9f0486e75b5ace,
                    blending: $1a55656020b89c3a$export$63b8d6b580fc65ba
                });
                material.uniforms.tEquirect.value = texture;
                var mesh = new $1a55656020b89c3a$export$e176487c05830cc5(geometry, material);
                var currentMinFilter = texture.minFilter;
                // Avoid blurred poles
                if (texture.minFilter === $1a55656020b89c3a$export$5d8599b6a933fb1b) texture.minFilter = $1a55656020b89c3a$export$8a72f490b25c56c8;
                var camera = new $1a55656020b89c3a$export$d0cdd0bd804995de(1, 10, this);
                camera.update(renderer, mesh);
                texture.minFilter = currentMinFilter;
                mesh.geometry.dispose();
                mesh.material.dispose();
                return this;
            }
        },
        {
            key: "clear",
            value: function clear(renderer, color, depth, stencil) {
                var currentRenderTarget = renderer.getRenderTarget();
                for(var i = 0; i < 6; i++){
                    renderer.setRenderTarget(this, i);
                    renderer.clear(color, depth, stencil);
                }
                renderer.setRenderTarget(currentRenderTarget);
            }
        }
    ]);
    return WebGLCubeRenderTarget;
}($1a55656020b89c3a$export$3c052beb2e51e23f);
var $1a55656020b89c3a$export$eb2fcfdbd7ba97d4 = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(Group, Object3D);
    function Group() {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Group);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, Group);
        _this.isGroup = true;
        _this.type = 'Group';
        return _this;
    }
    return Group;
}($1a55656020b89c3a$export$e4dd07dff30cc924);
var $1a55656020b89c3a$var$_moveEvent = {
    type: 'move'
};
var $1a55656020b89c3a$export$cb626c57dcc48b9f = /*#__PURE__*/ function() {
    "use strict";
    function WebXRController() {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, WebXRController);
        this._targetRay = null;
        this._grip = null;
        this._hand = null;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(WebXRController, [
        {
            key: "getHandSpace",
            value: function getHandSpace() {
                if (this._hand === null) {
                    this._hand = new $1a55656020b89c3a$export$eb2fcfdbd7ba97d4();
                    this._hand.matrixAutoUpdate = false;
                    this._hand.visible = false;
                    this._hand.joints = {};
                    this._hand.inputState = {
                        pinching: false
                    };
                }
                return this._hand;
            }
        },
        {
            key: "getTargetRaySpace",
            value: function getTargetRaySpace() {
                if (this._targetRay === null) {
                    this._targetRay = new $1a55656020b89c3a$export$eb2fcfdbd7ba97d4();
                    this._targetRay.matrixAutoUpdate = false;
                    this._targetRay.visible = false;
                    this._targetRay.hasLinearVelocity = false;
                    this._targetRay.linearVelocity = new $1a55656020b89c3a$export$64b5c384219d3699();
                    this._targetRay.hasAngularVelocity = false;
                    this._targetRay.angularVelocity = new $1a55656020b89c3a$export$64b5c384219d3699();
                }
                return this._targetRay;
            }
        },
        {
            key: "getGripSpace",
            value: function getGripSpace() {
                if (this._grip === null) {
                    this._grip = new $1a55656020b89c3a$export$eb2fcfdbd7ba97d4();
                    this._grip.matrixAutoUpdate = false;
                    this._grip.visible = false;
                    this._grip.hasLinearVelocity = false;
                    this._grip.linearVelocity = new $1a55656020b89c3a$export$64b5c384219d3699();
                    this._grip.hasAngularVelocity = false;
                    this._grip.angularVelocity = new $1a55656020b89c3a$export$64b5c384219d3699();
                }
                return this._grip;
            }
        },
        {
            key: "dispatchEvent",
            value: function dispatchEvent(event) {
                if (this._targetRay !== null) this._targetRay.dispatchEvent(event);
                if (this._grip !== null) this._grip.dispatchEvent(event);
                if (this._hand !== null) this._hand.dispatchEvent(event);
                return this;
            }
        },
        {
            key: "connect",
            value: function connect(inputSource) {
                if (inputSource && inputSource.hand) {
                    var hand = this._hand;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    if (hand) try {
                        for(var _iterator = inputSource.hand.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var inputjoint = _step.value;
                            // Initialize hand with joints when connected
                            this._getHandJoint(hand, inputjoint);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                this.dispatchEvent({
                    type: 'connected',
                    data: inputSource
                });
                return this;
            }
        },
        {
            key: "disconnect",
            value: function disconnect(inputSource) {
                this.dispatchEvent({
                    type: 'disconnected',
                    data: inputSource
                });
                if (this._targetRay !== null) this._targetRay.visible = false;
                if (this._grip !== null) this._grip.visible = false;
                if (this._hand !== null) this._hand.visible = false;
                return this;
            }
        },
        {
            key: "update",
            value: function update(inputSource, frame, referenceSpace) {
                var inputPose = null;
                var gripPose = null;
                var handPose = null;
                var targetRay = this._targetRay;
                var grip = this._grip;
                var hand = this._hand;
                if (inputSource && frame.session.visibilityState !== 'visible-blurred') {
                    if (hand && inputSource.hand) {
                        handPose = true;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = inputSource.hand.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var inputjoint = _step.value;
                                // Update the joints groups with the XRJoint poses
                                var jointPose = frame.getJointPose(inputjoint, referenceSpace);
                                // The transform of this joint will be updated with the joint pose on each frame
                                var joint = this._getHandJoint(hand, inputjoint);
                                if (jointPose !== null) {
                                    joint.matrix.fromArray(jointPose.transform.matrix);
                                    joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
                                    joint.matrixWorldNeedsUpdate = true;
                                    joint.jointRadius = jointPose.radius;
                                }
                                joint.visible = jointPose !== null;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        // Custom events
                        // Check pinchz
                        var indexTip = hand.joints['index-finger-tip'];
                        var thumbTip = hand.joints['thumb-tip'];
                        var distance = indexTip.position.distanceTo(thumbTip.position);
                        var distanceToPinch = 0.02;
                        var threshold = 0.005;
                        if (hand.inputState.pinching && distance > distanceToPinch + threshold) {
                            hand.inputState.pinching = false;
                            this.dispatchEvent({
                                type: 'pinchend',
                                handedness: inputSource.handedness,
                                target: this
                            });
                        } else if (!hand.inputState.pinching && distance <= distanceToPinch - threshold) {
                            hand.inputState.pinching = true;
                            this.dispatchEvent({
                                type: 'pinchstart',
                                handedness: inputSource.handedness,
                                target: this
                            });
                        }
                    } else if (grip !== null && inputSource.gripSpace) {
                        gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
                        if (gripPose !== null) {
                            grip.matrix.fromArray(gripPose.transform.matrix);
                            grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
                            grip.matrixWorldNeedsUpdate = true;
                            if (gripPose.linearVelocity) {
                                grip.hasLinearVelocity = true;
                                grip.linearVelocity.copy(gripPose.linearVelocity);
                            } else grip.hasLinearVelocity = false;
                            if (gripPose.angularVelocity) {
                                grip.hasAngularVelocity = true;
                                grip.angularVelocity.copy(gripPose.angularVelocity);
                            } else grip.hasAngularVelocity = false;
                        }
                    }
                    if (targetRay !== null) {
                        inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
                        // Some runtimes (namely Vive Cosmos with Vive OpenXR Runtime) have only grip space and ray space is equal to it
                        if (inputPose === null && gripPose !== null) inputPose = gripPose;
                        if (inputPose !== null) {
                            targetRay.matrix.fromArray(inputPose.transform.matrix);
                            targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
                            targetRay.matrixWorldNeedsUpdate = true;
                            if (inputPose.linearVelocity) {
                                targetRay.hasLinearVelocity = true;
                                targetRay.linearVelocity.copy(inputPose.linearVelocity);
                            } else targetRay.hasLinearVelocity = false;
                            if (inputPose.angularVelocity) {
                                targetRay.hasAngularVelocity = true;
                                targetRay.angularVelocity.copy(inputPose.angularVelocity);
                            } else targetRay.hasAngularVelocity = false;
                            this.dispatchEvent($1a55656020b89c3a$var$_moveEvent);
                        }
                    }
                }
                if (targetRay !== null) targetRay.visible = inputPose !== null;
                if (grip !== null) grip.visible = gripPose !== null;
                if (hand !== null) hand.visible = handPose !== null;
                return this;
            }
        },
        {
            // private method
            key: "_getHandJoint",
            value: function _getHandJoint(hand, inputjoint) {
                if (hand.joints[inputjoint.jointName] === undefined) {
                    var joint = new $1a55656020b89c3a$export$eb2fcfdbd7ba97d4();
                    joint.matrixAutoUpdate = false;
                    joint.visible = false;
                    hand.joints[inputjoint.jointName] = joint;
                    hand.add(joint);
                }
                return hand.joints[inputjoint.jointName];
            }
        }
    ]);
    return WebXRController;
}();
var $1a55656020b89c3a$export$6f1519f023b8d0f6 = /*#__PURE__*/ function() {
    "use strict";
    function FogExp2(color) {
        var density = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0.00025;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, FogExp2);
        this.isFogExp2 = true;
        this.name = '';
        this.color = new $1a55656020b89c3a$export$892596cec99bc70e(color);
        this.density = density;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(FogExp2, [
        {
            key: "clone",
            value: function clone() {
                return new FogExp2(this.color, this.density);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    type: 'FogExp2',
                    name: this.name,
                    color: this.color.getHex(),
                    density: this.density
                };
            }
        }
    ]);
    return FogExp2;
}();
var $1a55656020b89c3a$export$3c890837b09508d4 = /*#__PURE__*/ function() {
    "use strict";
    function Fog(color) {
        var near = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, far = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1000;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Fog);
        this.isFog = true;
        this.name = '';
        this.color = new $1a55656020b89c3a$export$892596cec99bc70e(color);
        this.near = near;
        this.far = far;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Fog, [
        {
            key: "clone",
            value: function clone() {
                return new Fog(this.color, this.near, this.far);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    type: 'Fog',
                    name: this.name,
                    color: this.color.getHex(),
                    near: this.near,
                    far: this.far
                };
            }
        }
    ]);
    return Fog;
}();
var $1a55656020b89c3a$export$38af1803e3442a7f = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(Scene, Object3D);
    function Scene() {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Scene);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, Scene);
        _this.isScene = true;
        _this.type = 'Scene';
        _this.background = null;
        _this.environment = null;
        _this.fog = null;
        _this.backgroundBlurriness = 0;
        _this.backgroundIntensity = 1;
        _this.backgroundRotation = new $1a55656020b89c3a$export$d93cc409a0768c5f();
        _this.environmentIntensity = 1;
        _this.environmentRotation = new $1a55656020b89c3a$export$d93cc409a0768c5f();
        _this.overrideMaterial = null;
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: _this
        }));
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Scene, [
        {
            key: "copy",
            value: function copy(source, recursive) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(Scene.prototype), "copy", this).call(this, source, recursive);
                if (source.background !== null) this.background = source.background.clone();
                if (source.environment !== null) this.environment = source.environment.clone();
                if (source.fog !== null) this.fog = source.fog.clone();
                this.backgroundBlurriness = source.backgroundBlurriness;
                this.backgroundIntensity = source.backgroundIntensity;
                this.backgroundRotation.copy(source.backgroundRotation);
                this.environmentIntensity = source.environmentIntensity;
                this.environmentRotation.copy(source.environmentRotation);
                if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
                this.matrixAutoUpdate = source.matrixAutoUpdate;
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON(meta) {
                var data = (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(Scene.prototype), "toJSON", this).call(this, meta);
                if (this.fog !== null) data.object.fog = this.fog.toJSON();
                if (this.backgroundBlurriness > 0) data.object.backgroundBlurriness = this.backgroundBlurriness;
                if (this.backgroundIntensity !== 1) data.object.backgroundIntensity = this.backgroundIntensity;
                data.object.backgroundRotation = this.backgroundRotation.toArray();
                if (this.environmentIntensity !== 1) data.object.environmentIntensity = this.environmentIntensity;
                data.object.environmentRotation = this.environmentRotation.toArray();
                return data;
            }
        }
    ]);
    return Scene;
}($1a55656020b89c3a$export$e4dd07dff30cc924);
var $1a55656020b89c3a$export$3d5cd879f108f53f = /*#__PURE__*/ function() {
    "use strict";
    function InterleavedBuffer(array, stride) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, InterleavedBuffer);
        this.isInterleavedBuffer = true;
        this.array = array;
        this.stride = stride;
        this.count = array !== undefined ? array.length / stride : 0;
        this.usage = $1a55656020b89c3a$export$763e8360f4d7f77d;
        this.updateRanges = [];
        this.version = 0;
        this.uuid = $1a55656020b89c3a$var$generateUUID();
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(InterleavedBuffer, [
        {
            key: "onUploadCallback",
            value: function onUploadCallback() {}
        },
        {
            key: "needsUpdate",
            set: function set(value) {
                if (value === true) this.version++;
            }
        },
        {
            key: "setUsage",
            value: function setUsage(value) {
                this.usage = value;
                return this;
            }
        },
        {
            key: "addUpdateRange",
            value: function addUpdateRange(start, count) {
                this.updateRanges.push({
                    start: start,
                    count: count
                });
            }
        },
        {
            key: "clearUpdateRanges",
            value: function clearUpdateRanges() {
                this.updateRanges.length = 0;
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                this.array = new source.array.constructor(source.array);
                this.count = source.count;
                this.stride = source.stride;
                this.usage = source.usage;
                return this;
            }
        },
        {
            key: "copyAt",
            value: function copyAt(index1, attribute, index2) {
                index1 *= this.stride;
                index2 *= attribute.stride;
                for(var i = 0, l = this.stride; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
                return this;
            }
        },
        {
            key: "set",
            value: function set(value) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                this.array.set(value, offset);
                return this;
            }
        },
        {
            key: "clone",
            value: function clone(data) {
                if (data.arrayBuffers === undefined) data.arrayBuffers = {};
                if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $1a55656020b89c3a$var$generateUUID();
                if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
                var array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
                var ib = new this.constructor(array, this.stride);
                ib.setUsage(this.usage);
                return ib;
            }
        },
        {
            key: "onUpload",
            value: function onUpload(callback) {
                this.onUploadCallback = callback;
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON(data) {
                if (data.arrayBuffers === undefined) data.arrayBuffers = {};
                // generate UUID for array buffer if necessary
                if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $1a55656020b89c3a$var$generateUUID();
                if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer));
                //
                return {
                    uuid: this.uuid,
                    buffer: this.array.buffer._uuid,
                    type: this.array.constructor.name,
                    stride: this.stride
                };
            }
        }
    ]);
    return InterleavedBuffer;
}();
var $1a55656020b89c3a$var$_vector$7 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$export$920b6d07334599c7 = /*#__PURE__*/ function() {
    "use strict";
    function InterleavedBufferAttribute(interleavedBuffer, itemSize, offset) {
        var normalized = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, InterleavedBufferAttribute);
        this.isInterleavedBufferAttribute = true;
        this.name = '';
        this.data = interleavedBuffer;
        this.itemSize = itemSize;
        this.offset = offset;
        this.normalized = normalized;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(InterleavedBufferAttribute, [
        {
            key: "count",
            get: function get() {
                return this.data.count;
            }
        },
        {
            key: "array",
            get: function get() {
                return this.data.array;
            }
        },
        {
            key: "needsUpdate",
            set: function set(value) {
                this.data.needsUpdate = value;
            }
        },
        {
            key: "applyMatrix4",
            value: function applyMatrix4(m) {
                for(var i = 0, l = this.data.count; i < l; i++){
                    $1a55656020b89c3a$var$_vector$7.fromBufferAttribute(this, i);
                    $1a55656020b89c3a$var$_vector$7.applyMatrix4(m);
                    this.setXYZ(i, $1a55656020b89c3a$var$_vector$7.x, $1a55656020b89c3a$var$_vector$7.y, $1a55656020b89c3a$var$_vector$7.z);
                }
                return this;
            }
        },
        {
            key: "applyNormalMatrix",
            value: function applyNormalMatrix(m) {
                for(var i = 0, l = this.count; i < l; i++){
                    $1a55656020b89c3a$var$_vector$7.fromBufferAttribute(this, i);
                    $1a55656020b89c3a$var$_vector$7.applyNormalMatrix(m);
                    this.setXYZ(i, $1a55656020b89c3a$var$_vector$7.x, $1a55656020b89c3a$var$_vector$7.y, $1a55656020b89c3a$var$_vector$7.z);
                }
                return this;
            }
        },
        {
            key: "transformDirection",
            value: function transformDirection(m) {
                for(var i = 0, l = this.count; i < l; i++){
                    $1a55656020b89c3a$var$_vector$7.fromBufferAttribute(this, i);
                    $1a55656020b89c3a$var$_vector$7.transformDirection(m);
                    this.setXYZ(i, $1a55656020b89c3a$var$_vector$7.x, $1a55656020b89c3a$var$_vector$7.y, $1a55656020b89c3a$var$_vector$7.z);
                }
                return this;
            }
        },
        {
            key: "getComponent",
            value: function getComponent(index, component) {
                var value = this.array[index * this.data.stride + this.offset + component];
                if (this.normalized) value = $1a55656020b89c3a$var$denormalize(value, this.array);
                return value;
            }
        },
        {
            key: "setComponent",
            value: function setComponent(index, component, value) {
                if (this.normalized) value = $1a55656020b89c3a$var$normalize(value, this.array);
                this.data.array[index * this.data.stride + this.offset + component] = value;
                return this;
            }
        },
        {
            key: "setX",
            value: function setX(index, x) {
                if (this.normalized) x = $1a55656020b89c3a$var$normalize(x, this.array);
                this.data.array[index * this.data.stride + this.offset] = x;
                return this;
            }
        },
        {
            key: "setY",
            value: function setY(index, y) {
                if (this.normalized) y = $1a55656020b89c3a$var$normalize(y, this.array);
                this.data.array[index * this.data.stride + this.offset + 1] = y;
                return this;
            }
        },
        {
            key: "setZ",
            value: function setZ(index, z) {
                if (this.normalized) z = $1a55656020b89c3a$var$normalize(z, this.array);
                this.data.array[index * this.data.stride + this.offset + 2] = z;
                return this;
            }
        },
        {
            key: "setW",
            value: function setW(index, w) {
                if (this.normalized) w = $1a55656020b89c3a$var$normalize(w, this.array);
                this.data.array[index * this.data.stride + this.offset + 3] = w;
                return this;
            }
        },
        {
            key: "getX",
            value: function getX(index) {
                var x = this.data.array[index * this.data.stride + this.offset];
                if (this.normalized) x = $1a55656020b89c3a$var$denormalize(x, this.array);
                return x;
            }
        },
        {
            key: "getY",
            value: function getY(index) {
                var y = this.data.array[index * this.data.stride + this.offset + 1];
                if (this.normalized) y = $1a55656020b89c3a$var$denormalize(y, this.array);
                return y;
            }
        },
        {
            key: "getZ",
            value: function getZ(index) {
                var z = this.data.array[index * this.data.stride + this.offset + 2];
                if (this.normalized) z = $1a55656020b89c3a$var$denormalize(z, this.array);
                return z;
            }
        },
        {
            key: "getW",
            value: function getW(index) {
                var w = this.data.array[index * this.data.stride + this.offset + 3];
                if (this.normalized) w = $1a55656020b89c3a$var$denormalize(w, this.array);
                return w;
            }
        },
        {
            key: "setXY",
            value: function setXY(index, x, y) {
                index = index * this.data.stride + this.offset;
                if (this.normalized) {
                    x = $1a55656020b89c3a$var$normalize(x, this.array);
                    y = $1a55656020b89c3a$var$normalize(y, this.array);
                }
                this.data.array[index + 0] = x;
                this.data.array[index + 1] = y;
                return this;
            }
        },
        {
            key: "setXYZ",
            value: function setXYZ(index, x, y, z) {
                index = index * this.data.stride + this.offset;
                if (this.normalized) {
                    x = $1a55656020b89c3a$var$normalize(x, this.array);
                    y = $1a55656020b89c3a$var$normalize(y, this.array);
                    z = $1a55656020b89c3a$var$normalize(z, this.array);
                }
                this.data.array[index + 0] = x;
                this.data.array[index + 1] = y;
                this.data.array[index + 2] = z;
                return this;
            }
        },
        {
            key: "setXYZW",
            value: function setXYZW(index, x, y, z, w) {
                index = index * this.data.stride + this.offset;
                if (this.normalized) {
                    x = $1a55656020b89c3a$var$normalize(x, this.array);
                    y = $1a55656020b89c3a$var$normalize(y, this.array);
                    z = $1a55656020b89c3a$var$normalize(z, this.array);
                    w = $1a55656020b89c3a$var$normalize(w, this.array);
                }
                this.data.array[index + 0] = x;
                this.data.array[index + 1] = y;
                this.data.array[index + 2] = z;
                this.data.array[index + 3] = w;
                return this;
            }
        },
        {
            key: "clone",
            value: function clone(data) {
                if (data === undefined) {
                    console.log('THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.');
                    var array = [];
                    for(var i = 0; i < this.count; i++){
                        var index = i * this.data.stride + this.offset;
                        for(var j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
                    }
                    return new $1a55656020b89c3a$export$8dea267bd6bde117(new this.array.constructor(array), this.itemSize, this.normalized);
                } else {
                    if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
                    if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
                    return new InterleavedBufferAttribute(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
                }
            }
        },
        {
            key: "toJSON",
            value: function toJSON(data) {
                if (data === undefined) {
                    console.log('THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.');
                    var array = [];
                    for(var i = 0; i < this.count; i++){
                        var index = i * this.data.stride + this.offset;
                        for(var j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
                    }
                    // de-interleave data and save it as an ordinary buffer attribute for now
                    return {
                        itemSize: this.itemSize,
                        type: this.array.constructor.name,
                        array: array,
                        normalized: this.normalized
                    };
                } else {
                    // save as true interleaved attribute
                    if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
                    if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
                    return {
                        isInterleavedBufferAttribute: true,
                        itemSize: this.itemSize,
                        data: this.data.uuid,
                        offset: this.offset,
                        normalized: this.normalized
                    };
                }
            }
        }
    ]);
    return InterleavedBufferAttribute;
}();
var $1a55656020b89c3a$export$5ec7dd1c6994bf8e = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(SpriteMaterial, Material);
    function SpriteMaterial(parameters) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, SpriteMaterial);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, SpriteMaterial);
        _this.isSpriteMaterial = true;
        _this.type = 'SpriteMaterial';
        _this.color = new $1a55656020b89c3a$export$892596cec99bc70e(0xffffff);
        _this.map = null;
        _this.alphaMap = null;
        _this.rotation = 0;
        _this.sizeAttenuation = true;
        _this.transparent = true;
        _this.fog = true;
        _this.setValues(parameters);
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(SpriteMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(SpriteMaterial.prototype), "copy", this).call(this, source);
                this.color.copy(source.color);
                this.map = source.map;
                this.alphaMap = source.alphaMap;
                this.rotation = source.rotation;
                this.sizeAttenuation = source.sizeAttenuation;
                this.fog = source.fog;
                return this;
            }
        }
    ]);
    return SpriteMaterial;
}($1a55656020b89c3a$export$a2d8b23205c25948);
var $1a55656020b89c3a$var$_geometry;
var $1a55656020b89c3a$var$_intersectPoint = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_worldScale = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_mvPosition = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_alignedPosition = /*@__PURE__*/ new $1a55656020b89c3a$export$c977b3e384af9ae1();
var $1a55656020b89c3a$var$_rotatedPosition = /*@__PURE__*/ new $1a55656020b89c3a$export$c977b3e384af9ae1();
var $1a55656020b89c3a$var$_viewWorldMatrix = /*@__PURE__*/ new $1a55656020b89c3a$export$2ae72fc923e5eb5();
var $1a55656020b89c3a$var$_vA = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_vB = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_vC = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_uvA = /*@__PURE__*/ new $1a55656020b89c3a$export$c977b3e384af9ae1();
var $1a55656020b89c3a$var$_uvB = /*@__PURE__*/ new $1a55656020b89c3a$export$c977b3e384af9ae1();
var $1a55656020b89c3a$var$_uvC = /*@__PURE__*/ new $1a55656020b89c3a$export$c977b3e384af9ae1();
var $1a55656020b89c3a$export$3075603db8e6204c = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(Sprite, Object3D);
    function Sprite() {
        var material = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $1a55656020b89c3a$export$5ec7dd1c6994bf8e();
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Sprite);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, Sprite);
        _this.isSprite = true;
        _this.type = 'Sprite';
        if ($1a55656020b89c3a$var$_geometry === undefined) {
            $1a55656020b89c3a$var$_geometry = new $1a55656020b89c3a$export$b7be63a67df8959();
            var float32Array = new Float32Array([
                -0.5,
                -0.5,
                0,
                0,
                0,
                0.5,
                -0.5,
                0,
                1,
                0,
                0.5,
                0.5,
                0,
                1,
                1,
                -0.5,
                0.5,
                0,
                0,
                1
            ]);
            var interleavedBuffer = new $1a55656020b89c3a$export$3d5cd879f108f53f(float32Array, 5);
            $1a55656020b89c3a$var$_geometry.setIndex([
                0,
                1,
                2,
                0,
                2,
                3
            ]);
            $1a55656020b89c3a$var$_geometry.setAttribute('position', new $1a55656020b89c3a$export$920b6d07334599c7(interleavedBuffer, 3, 0, false));
            $1a55656020b89c3a$var$_geometry.setAttribute('uv', new $1a55656020b89c3a$export$920b6d07334599c7(interleavedBuffer, 2, 3, false));
        }
        _this.geometry = $1a55656020b89c3a$var$_geometry;
        _this.material = material;
        _this.center = new $1a55656020b89c3a$export$c977b3e384af9ae1(0.5, 0.5);
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Sprite, [
        {
            key: "raycast",
            value: function raycast(raycaster, intersects) {
                if (raycaster.camera === null) console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
                $1a55656020b89c3a$var$_worldScale.setFromMatrixScale(this.matrixWorld);
                $1a55656020b89c3a$var$_viewWorldMatrix.copy(raycaster.camera.matrixWorld);
                this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);
                $1a55656020b89c3a$var$_mvPosition.setFromMatrixPosition(this.modelViewMatrix);
                if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) $1a55656020b89c3a$var$_worldScale.multiplyScalar(-$1a55656020b89c3a$var$_mvPosition.z);
                var rotation = this.material.rotation;
                var sin, cos;
                if (rotation !== 0) {
                    cos = Math.cos(rotation);
                    sin = Math.sin(rotation);
                }
                var center = this.center;
                $1a55656020b89c3a$var$transformVertex($1a55656020b89c3a$var$_vA.set(-0.5, -0.5, 0), $1a55656020b89c3a$var$_mvPosition, center, $1a55656020b89c3a$var$_worldScale, sin, cos);
                $1a55656020b89c3a$var$transformVertex($1a55656020b89c3a$var$_vB.set(0.5, -0.5, 0), $1a55656020b89c3a$var$_mvPosition, center, $1a55656020b89c3a$var$_worldScale, sin, cos);
                $1a55656020b89c3a$var$transformVertex($1a55656020b89c3a$var$_vC.set(0.5, 0.5, 0), $1a55656020b89c3a$var$_mvPosition, center, $1a55656020b89c3a$var$_worldScale, sin, cos);
                $1a55656020b89c3a$var$_uvA.set(0, 0);
                $1a55656020b89c3a$var$_uvB.set(1, 0);
                $1a55656020b89c3a$var$_uvC.set(1, 1);
                // check first triangle
                var intersect = raycaster.ray.intersectTriangle($1a55656020b89c3a$var$_vA, $1a55656020b89c3a$var$_vB, $1a55656020b89c3a$var$_vC, false, $1a55656020b89c3a$var$_intersectPoint);
                if (intersect === null) {
                    // check second triangle
                    $1a55656020b89c3a$var$transformVertex($1a55656020b89c3a$var$_vB.set(-0.5, 0.5, 0), $1a55656020b89c3a$var$_mvPosition, center, $1a55656020b89c3a$var$_worldScale, sin, cos);
                    $1a55656020b89c3a$var$_uvB.set(0, 1);
                    intersect = raycaster.ray.intersectTriangle($1a55656020b89c3a$var$_vA, $1a55656020b89c3a$var$_vC, $1a55656020b89c3a$var$_vB, false, $1a55656020b89c3a$var$_intersectPoint);
                    if (intersect === null) return;
                }
                var distance = raycaster.ray.origin.distanceTo($1a55656020b89c3a$var$_intersectPoint);
                if (distance < raycaster.near || distance > raycaster.far) return;
                intersects.push({
                    distance: distance,
                    point: $1a55656020b89c3a$var$_intersectPoint.clone(),
                    uv: $1a55656020b89c3a$export$5a465592bfe74b48.getInterpolation($1a55656020b89c3a$var$_intersectPoint, $1a55656020b89c3a$var$_vA, $1a55656020b89c3a$var$_vB, $1a55656020b89c3a$var$_vC, $1a55656020b89c3a$var$_uvA, $1a55656020b89c3a$var$_uvB, $1a55656020b89c3a$var$_uvC, new $1a55656020b89c3a$export$c977b3e384af9ae1()),
                    face: null,
                    object: this
                });
            }
        },
        {
            key: "copy",
            value: function copy(source, recursive) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(Sprite.prototype), "copy", this).call(this, source, recursive);
                if (source.center !== undefined) this.center.copy(source.center);
                this.material = source.material;
                return this;
            }
        }
    ]);
    return Sprite;
}($1a55656020b89c3a$export$e4dd07dff30cc924);
function $1a55656020b89c3a$var$transformVertex(vertexPosition, mvPosition, center, scale, sin, cos) {
    // compute position in camera space
    $1a55656020b89c3a$var$_alignedPosition.subVectors(vertexPosition, center).addScalar(0.5).multiply(scale);
    // to check if rotation is not zero
    if (sin !== undefined) {
        $1a55656020b89c3a$var$_rotatedPosition.x = cos * $1a55656020b89c3a$var$_alignedPosition.x - sin * $1a55656020b89c3a$var$_alignedPosition.y;
        $1a55656020b89c3a$var$_rotatedPosition.y = sin * $1a55656020b89c3a$var$_alignedPosition.x + cos * $1a55656020b89c3a$var$_alignedPosition.y;
    } else $1a55656020b89c3a$var$_rotatedPosition.copy($1a55656020b89c3a$var$_alignedPosition);
    vertexPosition.copy(mvPosition);
    vertexPosition.x += $1a55656020b89c3a$var$_rotatedPosition.x;
    vertexPosition.y += $1a55656020b89c3a$var$_rotatedPosition.y;
    // transform to world space
    vertexPosition.applyMatrix4($1a55656020b89c3a$var$_viewWorldMatrix);
}
var $1a55656020b89c3a$var$_v1$2 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_v2$1 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$export$112e7237be0c5f30 = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(LOD, Object3D);
    function LOD() {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, LOD);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, LOD);
        _this._currentLevel = 0;
        _this.type = 'LOD';
        Object.defineProperties(_this, {
            levels: {
                enumerable: true,
                value: []
            },
            isLOD: {
                value: true
            }
        });
        _this.autoUpdate = true;
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(LOD, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(LOD.prototype), "copy", this).call(this, source, false);
                var levels = source.levels;
                for(var i = 0, l = levels.length; i < l; i++){
                    var level = levels[i];
                    this.addLevel(level.object.clone(), level.distance, level.hysteresis);
                }
                this.autoUpdate = source.autoUpdate;
                return this;
            }
        },
        {
            key: "addLevel",
            value: function addLevel(object) {
                var distance = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, hysteresis = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                distance = Math.abs(distance);
                var levels = this.levels;
                var l;
                for(l = 0; l < levels.length; l++){
                    if (distance < levels[l].distance) break;
                }
                levels.splice(l, 0, {
                    distance: distance,
                    hysteresis: hysteresis,
                    object: object
                });
                this.add(object);
                return this;
            }
        },
        {
            key: "removeLevel",
            value: function removeLevel(distance) {
                var levels = this.levels;
                for(var i = 0; i < levels.length; i++)if (levels[i].distance === distance) {
                    var removedElements = levels.splice(i, 1);
                    this.remove(removedElements[0].object);
                    return true;
                }
                return false;
            }
        },
        {
            key: "getCurrentLevel",
            value: function getCurrentLevel() {
                return this._currentLevel;
            }
        },
        {
            key: "getObjectForDistance",
            value: function getObjectForDistance(distance) {
                var levels = this.levels;
                if (levels.length > 0) {
                    var i, l;
                    for(i = 1, l = levels.length; i < l; i++){
                        var levelDistance = levels[i].distance;
                        if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                        if (distance < levelDistance) break;
                    }
                    return levels[i - 1].object;
                }
                return null;
            }
        },
        {
            key: "raycast",
            value: function raycast(raycaster, intersects) {
                var levels = this.levels;
                if (levels.length > 0) {
                    $1a55656020b89c3a$var$_v1$2.setFromMatrixPosition(this.matrixWorld);
                    var distance = raycaster.ray.origin.distanceTo($1a55656020b89c3a$var$_v1$2);
                    this.getObjectForDistance(distance).raycast(raycaster, intersects);
                }
            }
        },
        {
            key: "update",
            value: function update(camera) {
                var levels = this.levels;
                if (levels.length > 1) {
                    $1a55656020b89c3a$var$_v1$2.setFromMatrixPosition(camera.matrixWorld);
                    $1a55656020b89c3a$var$_v2$1.setFromMatrixPosition(this.matrixWorld);
                    var distance = $1a55656020b89c3a$var$_v1$2.distanceTo($1a55656020b89c3a$var$_v2$1) / camera.zoom;
                    levels[0].object.visible = true;
                    var i, l;
                    for(i = 1, l = levels.length; i < l; i++){
                        var levelDistance = levels[i].distance;
                        if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                        if (distance >= levelDistance) {
                            levels[i - 1].object.visible = false;
                            levels[i].object.visible = true;
                        } else break;
                    }
                    this._currentLevel = i - 1;
                    for(; i < l; i++)levels[i].object.visible = false;
                }
            }
        },
        {
            key: "toJSON",
            value: function toJSON(meta) {
                var data = (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(LOD.prototype), "toJSON", this).call(this, meta);
                if (this.autoUpdate === false) data.object.autoUpdate = false;
                data.object.levels = [];
                var levels = this.levels;
                for(var i = 0, l = levels.length; i < l; i++){
                    var level = levels[i];
                    data.object.levels.push({
                        object: level.object.uuid,
                        distance: level.distance,
                        hysteresis: level.hysteresis
                    });
                }
                return data;
            }
        }
    ]);
    return LOD;
}($1a55656020b89c3a$export$e4dd07dff30cc924);
var $1a55656020b89c3a$var$_basePosition = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_skinIndex = /*@__PURE__*/ new $1a55656020b89c3a$export$fa7daccca11cdbe3();
var $1a55656020b89c3a$var$_skinWeight = /*@__PURE__*/ new $1a55656020b89c3a$export$fa7daccca11cdbe3();
var $1a55656020b89c3a$var$_vector3 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_matrix4 = /*@__PURE__*/ new $1a55656020b89c3a$export$2ae72fc923e5eb5();
var $1a55656020b89c3a$var$_vertex = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_sphere$5 = /*@__PURE__*/ new $1a55656020b89c3a$export$805e8b72413ccaba();
var $1a55656020b89c3a$var$_inverseMatrix$2 = /*@__PURE__*/ new $1a55656020b89c3a$export$2ae72fc923e5eb5();
var $1a55656020b89c3a$var$_ray$2 = /*@__PURE__*/ new $1a55656020b89c3a$export$a186db52eed6d40e();
var $1a55656020b89c3a$export$b303577035157ecf = /*#__PURE__*/ function(Mesh) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(SkinnedMesh, Mesh);
    function SkinnedMesh(geometry, material) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, SkinnedMesh);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, SkinnedMesh, [
            geometry,
            material
        ]);
        _this.isSkinnedMesh = true;
        _this.type = 'SkinnedMesh';
        _this.bindMode = $1a55656020b89c3a$export$2595a3798997538;
        _this.bindMatrix = new $1a55656020b89c3a$export$2ae72fc923e5eb5();
        _this.bindMatrixInverse = new $1a55656020b89c3a$export$2ae72fc923e5eb5();
        _this.boundingBox = null;
        _this.boundingSphere = null;
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(SkinnedMesh, [
        {
            key: "computeBoundingBox",
            value: function computeBoundingBox() {
                var geometry = this.geometry;
                if (this.boundingBox === null) this.boundingBox = new $1a55656020b89c3a$export$6f7d5a9418ab2aa3();
                this.boundingBox.makeEmpty();
                var positionAttribute = geometry.getAttribute('position');
                for(var i = 0; i < positionAttribute.count; i++){
                    this.getVertexPosition(i, $1a55656020b89c3a$var$_vertex);
                    this.boundingBox.expandByPoint($1a55656020b89c3a$var$_vertex);
                }
            }
        },
        {
            key: "computeBoundingSphere",
            value: function computeBoundingSphere() {
                var geometry = this.geometry;
                if (this.boundingSphere === null) this.boundingSphere = new $1a55656020b89c3a$export$805e8b72413ccaba();
                this.boundingSphere.makeEmpty();
                var positionAttribute = geometry.getAttribute('position');
                for(var i = 0; i < positionAttribute.count; i++){
                    this.getVertexPosition(i, $1a55656020b89c3a$var$_vertex);
                    this.boundingSphere.expandByPoint($1a55656020b89c3a$var$_vertex);
                }
            }
        },
        {
            key: "copy",
            value: function copy(source, recursive) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(SkinnedMesh.prototype), "copy", this).call(this, source, recursive);
                this.bindMode = source.bindMode;
                this.bindMatrix.copy(source.bindMatrix);
                this.bindMatrixInverse.copy(source.bindMatrixInverse);
                this.skeleton = source.skeleton;
                if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
                if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
                return this;
            }
        },
        {
            key: "raycast",
            value: function raycast(raycaster, intersects) {
                var material = this.material;
                var matrixWorld = this.matrixWorld;
                if (material === undefined) return;
                // test with bounding sphere in world space
                if (this.boundingSphere === null) this.computeBoundingSphere();
                $1a55656020b89c3a$var$_sphere$5.copy(this.boundingSphere);
                $1a55656020b89c3a$var$_sphere$5.applyMatrix4(matrixWorld);
                if (raycaster.ray.intersectsSphere($1a55656020b89c3a$var$_sphere$5) === false) return;
                // convert ray to local space of skinned mesh
                $1a55656020b89c3a$var$_inverseMatrix$2.copy(matrixWorld).invert();
                $1a55656020b89c3a$var$_ray$2.copy(raycaster.ray).applyMatrix4($1a55656020b89c3a$var$_inverseMatrix$2);
                // test with bounding box in local space
                if (this.boundingBox !== null) {
                    if ($1a55656020b89c3a$var$_ray$2.intersectsBox(this.boundingBox) === false) return;
                }
                // test for intersections with geometry
                this._computeIntersections(raycaster, intersects, $1a55656020b89c3a$var$_ray$2);
            }
        },
        {
            key: "getVertexPosition",
            value: function getVertexPosition(index, target) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(SkinnedMesh.prototype), "getVertexPosition", this).call(this, index, target);
                this.applyBoneTransform(index, target);
                return target;
            }
        },
        {
            key: "bind",
            value: function bind(skeleton, bindMatrix) {
                this.skeleton = skeleton;
                if (bindMatrix === undefined) {
                    this.updateMatrixWorld(true);
                    this.skeleton.calculateInverses();
                    bindMatrix = this.matrixWorld;
                }
                this.bindMatrix.copy(bindMatrix);
                this.bindMatrixInverse.copy(bindMatrix).invert();
            }
        },
        {
            key: "pose",
            value: function pose() {
                this.skeleton.pose();
            }
        },
        {
            key: "normalizeSkinWeights",
            value: function normalizeSkinWeights() {
                var vector = new $1a55656020b89c3a$export$fa7daccca11cdbe3();
                var skinWeight = this.geometry.attributes.skinWeight;
                for(var i = 0, l = skinWeight.count; i < l; i++){
                    vector.fromBufferAttribute(skinWeight, i);
                    var scale = 1.0 / vector.manhattanLength();
                    if (scale !== Infinity) vector.multiplyScalar(scale);
                    else vector.set(1, 0, 0, 0); // do something reasonable
                    skinWeight.setXYZW(i, vector.x, vector.y, vector.z, vector.w);
                }
            }
        },
        {
            key: "updateMatrixWorld",
            value: function updateMatrixWorld(force) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(SkinnedMesh.prototype), "updateMatrixWorld", this).call(this, force);
                if (this.bindMode === $1a55656020b89c3a$export$2595a3798997538) this.bindMatrixInverse.copy(this.matrixWorld).invert();
                else if (this.bindMode === $1a55656020b89c3a$export$d7e7dc2e114517a0) this.bindMatrixInverse.copy(this.bindMatrix).invert();
                else console.warn('THREE.SkinnedMesh: Unrecognized bindMode: ' + this.bindMode);
            }
        },
        {
            key: "applyBoneTransform",
            value: function applyBoneTransform(index, vector) {
                var skeleton = this.skeleton;
                var geometry = this.geometry;
                $1a55656020b89c3a$var$_skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index);
                $1a55656020b89c3a$var$_skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index);
                $1a55656020b89c3a$var$_basePosition.copy(vector).applyMatrix4(this.bindMatrix);
                vector.set(0, 0, 0);
                for(var i = 0; i < 4; i++){
                    var weight = $1a55656020b89c3a$var$_skinWeight.getComponent(i);
                    if (weight !== 0) {
                        var boneIndex = $1a55656020b89c3a$var$_skinIndex.getComponent(i);
                        $1a55656020b89c3a$var$_matrix4.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
                        vector.addScaledVector($1a55656020b89c3a$var$_vector3.copy($1a55656020b89c3a$var$_basePosition).applyMatrix4($1a55656020b89c3a$var$_matrix4), weight);
                    }
                }
                return vector.applyMatrix4(this.bindMatrixInverse);
            }
        }
    ]);
    return SkinnedMesh;
}($1a55656020b89c3a$export$e176487c05830cc5);
var $1a55656020b89c3a$export$b127726e56765aa4 = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(Bone, Object3D);
    function Bone() {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Bone);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, Bone);
        _this.isBone = true;
        _this.type = 'Bone';
        return _this;
    }
    return Bone;
}($1a55656020b89c3a$export$e4dd07dff30cc924);
var $1a55656020b89c3a$export$b691f601014eabe1 = /*#__PURE__*/ function(Texture) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(DataTexture, Texture);
    function DataTexture() {
        var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, width = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, height = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, format = arguments.length > 3 ? arguments[3] : void 0, type = arguments.length > 4 ? arguments[4] : void 0, mapping = arguments.length > 5 ? arguments[5] : void 0, wrapS = arguments.length > 6 ? arguments[6] : void 0, wrapT = arguments.length > 7 ? arguments[7] : void 0, magFilter = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : $1a55656020b89c3a$export$727aa5ec3fe39bf0, minFilter = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : $1a55656020b89c3a$export$727aa5ec3fe39bf0, anisotropy = arguments.length > 10 ? arguments[10] : void 0, colorSpace = arguments.length > 11 ? arguments[11] : void 0;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, DataTexture);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, DataTexture, [
            null,
            mapping,
            wrapS,
            wrapT,
            magFilter,
            minFilter,
            format,
            type,
            anisotropy,
            colorSpace
        ]);
        _this.isDataTexture = true;
        _this.image = {
            data: data,
            width: width,
            height: height
        };
        _this.generateMipmaps = false;
        _this.flipY = false;
        _this.unpackAlignment = 1;
        return _this;
    }
    return DataTexture;
}($1a55656020b89c3a$export$5431306cf43de24a);
var $1a55656020b89c3a$var$_offsetMatrix = /*@__PURE__*/ new $1a55656020b89c3a$export$2ae72fc923e5eb5();
var $1a55656020b89c3a$var$_identityMatrix = /*@__PURE__*/ new $1a55656020b89c3a$export$2ae72fc923e5eb5();
var $1a55656020b89c3a$export$8f31e4c4a37b8e9c = /*#__PURE__*/ function() {
    "use strict";
    function Skeleton() {
        var bones = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], boneInverses = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Skeleton);
        this.uuid = $1a55656020b89c3a$var$generateUUID();
        this.bones = bones.slice(0);
        this.boneInverses = boneInverses;
        this.boneMatrices = null;
        this.boneTexture = null;
        this.init();
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Skeleton, [
        {
            key: "init",
            value: function init() {
                var bones = this.bones;
                var boneInverses = this.boneInverses;
                this.boneMatrices = new Float32Array(bones.length * 16);
                // calculate inverse bone matrices if necessary
                if (boneInverses.length === 0) this.calculateInverses();
                else // handle special case
                if (bones.length !== boneInverses.length) {
                    console.warn('THREE.Skeleton: Number of inverse bone matrices does not match amount of bones.');
                    this.boneInverses = [];
                    for(var i = 0, il = this.bones.length; i < il; i++)this.boneInverses.push(new $1a55656020b89c3a$export$2ae72fc923e5eb5());
                }
            }
        },
        {
            key: "calculateInverses",
            value: function calculateInverses() {
                this.boneInverses.length = 0;
                for(var i = 0, il = this.bones.length; i < il; i++){
                    var inverse = new $1a55656020b89c3a$export$2ae72fc923e5eb5();
                    if (this.bones[i]) inverse.copy(this.bones[i].matrixWorld).invert();
                    this.boneInverses.push(inverse);
                }
            }
        },
        {
            key: "pose",
            value: function pose() {
                // recover the bind-time world matrices
                for(var i = 0, il = this.bones.length; i < il; i++){
                    var bone = this.bones[i];
                    if (bone) bone.matrixWorld.copy(this.boneInverses[i]).invert();
                }
                // compute the local matrices, positions, rotations and scales
                for(var i1 = 0, il1 = this.bones.length; i1 < il1; i1++){
                    var bone1 = this.bones[i1];
                    if (bone1) {
                        if (bone1.parent && bone1.parent.isBone) {
                            bone1.matrix.copy(bone1.parent.matrixWorld).invert();
                            bone1.matrix.multiply(bone1.matrixWorld);
                        } else bone1.matrix.copy(bone1.matrixWorld);
                        bone1.matrix.decompose(bone1.position, bone1.quaternion, bone1.scale);
                    }
                }
            }
        },
        {
            key: "update",
            value: function update() {
                var bones = this.bones;
                var boneInverses = this.boneInverses;
                var boneMatrices = this.boneMatrices;
                var boneTexture = this.boneTexture;
                // flatten bone matrices to array
                for(var i = 0, il = bones.length; i < il; i++){
                    // compute the offset between the current and the original transform
                    var matrix = bones[i] ? bones[i].matrixWorld : $1a55656020b89c3a$var$_identityMatrix;
                    $1a55656020b89c3a$var$_offsetMatrix.multiplyMatrices(matrix, boneInverses[i]);
                    $1a55656020b89c3a$var$_offsetMatrix.toArray(boneMatrices, i * 16);
                }
                if (boneTexture !== null) boneTexture.needsUpdate = true;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new Skeleton(this.bones, this.boneInverses);
            }
        },
        {
            key: "computeBoneTexture",
            value: function computeBoneTexture() {
                // layout (1 matrix = 4 pixels)
                //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
                //  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
                //       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
                //       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
                //       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)
                var size = Math.sqrt(this.bones.length * 4); // 4 pixels needed for 1 matrix
                size = Math.ceil(size / 4) * 4;
                size = Math.max(size, 4);
                var boneMatrices = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
                boneMatrices.set(this.boneMatrices); // copy current values
                var boneTexture = new $1a55656020b89c3a$export$b691f601014eabe1(boneMatrices, size, size, $1a55656020b89c3a$export$3f8bb04b555a363c, $1a55656020b89c3a$export$f6d331659b644596);
                boneTexture.needsUpdate = true;
                this.boneMatrices = boneMatrices;
                this.boneTexture = boneTexture;
                return this;
            }
        },
        {
            key: "getBoneByName",
            value: function getBoneByName(name) {
                for(var i = 0, il = this.bones.length; i < il; i++){
                    var bone = this.bones[i];
                    if (bone.name === name) return bone;
                }
                return undefined;
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                if (this.boneTexture !== null) {
                    this.boneTexture.dispose();
                    this.boneTexture = null;
                }
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json, bones) {
                this.uuid = json.uuid;
                for(var i = 0, l = json.bones.length; i < l; i++){
                    var uuid = json.bones[i];
                    var bone = bones[uuid];
                    if (bone === undefined) {
                        console.warn('THREE.Skeleton: No bone found with UUID:', uuid);
                        bone = new $1a55656020b89c3a$export$b127726e56765aa4();
                    }
                    this.bones.push(bone);
                    this.boneInverses.push(new $1a55656020b89c3a$export$2ae72fc923e5eb5().fromArray(json.boneInverses[i]));
                }
                this.init();
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = {
                    metadata: {
                        version: 4.6,
                        type: 'Skeleton',
                        generator: 'Skeleton.toJSON'
                    },
                    bones: [],
                    boneInverses: []
                };
                data.uuid = this.uuid;
                var bones = this.bones;
                var boneInverses = this.boneInverses;
                for(var i = 0, l = bones.length; i < l; i++){
                    var bone = bones[i];
                    data.bones.push(bone.uuid);
                    var boneInverse = boneInverses[i];
                    data.boneInverses.push(boneInverse.toArray());
                }
                return data;
            }
        }
    ]);
    return Skeleton;
}();
var $1a55656020b89c3a$export$32ea87a8b54d744a = /*#__PURE__*/ function(BufferAttribute) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(InstancedBufferAttribute, BufferAttribute);
    function InstancedBufferAttribute(array, itemSize, normalized) {
        var meshPerAttribute = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, InstancedBufferAttribute);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, InstancedBufferAttribute, [
            array,
            itemSize,
            normalized
        ]);
        _this.isInstancedBufferAttribute = true;
        _this.meshPerAttribute = meshPerAttribute;
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(InstancedBufferAttribute, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(InstancedBufferAttribute.prototype), "copy", this).call(this, source);
                this.meshPerAttribute = source.meshPerAttribute;
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(InstancedBufferAttribute.prototype), "toJSON", this).call(this);
                data.meshPerAttribute = this.meshPerAttribute;
                data.isInstancedBufferAttribute = true;
                return data;
            }
        }
    ]);
    return InstancedBufferAttribute;
}($1a55656020b89c3a$export$8dea267bd6bde117);
var $1a55656020b89c3a$var$_instanceLocalMatrix = /*@__PURE__*/ new $1a55656020b89c3a$export$2ae72fc923e5eb5();
var $1a55656020b89c3a$var$_instanceWorldMatrix = /*@__PURE__*/ new $1a55656020b89c3a$export$2ae72fc923e5eb5();
var $1a55656020b89c3a$var$_instanceIntersects = [];
var $1a55656020b89c3a$var$_box3 = /*@__PURE__*/ new $1a55656020b89c3a$export$6f7d5a9418ab2aa3();
var $1a55656020b89c3a$var$_identity = /*@__PURE__*/ new $1a55656020b89c3a$export$2ae72fc923e5eb5();
var $1a55656020b89c3a$var$_mesh$1 = /*@__PURE__*/ new $1a55656020b89c3a$export$e176487c05830cc5();
var $1a55656020b89c3a$var$_sphere$4 = /*@__PURE__*/ new $1a55656020b89c3a$export$805e8b72413ccaba();
var $1a55656020b89c3a$export$f3c979c331175ad7 = /*#__PURE__*/ function(Mesh) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(InstancedMesh, Mesh);
    function InstancedMesh(geometry, material, count) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, InstancedMesh);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, InstancedMesh, [
            geometry,
            material
        ]);
        _this.isInstancedMesh = true;
        _this.instanceMatrix = new $1a55656020b89c3a$export$32ea87a8b54d744a(new Float32Array(count * 16), 16);
        _this.instanceColor = null;
        _this.morphTexture = null;
        _this.count = count;
        _this.boundingBox = null;
        _this.boundingSphere = null;
        for(var i = 0; i < count; i++)_this.setMatrixAt(i, $1a55656020b89c3a$var$_identity);
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(InstancedMesh, [
        {
            key: "computeBoundingBox",
            value: function computeBoundingBox() {
                var geometry = this.geometry;
                var count = this.count;
                if (this.boundingBox === null) this.boundingBox = new $1a55656020b89c3a$export$6f7d5a9418ab2aa3();
                if (geometry.boundingBox === null) geometry.computeBoundingBox();
                this.boundingBox.makeEmpty();
                for(var i = 0; i < count; i++){
                    this.getMatrixAt(i, $1a55656020b89c3a$var$_instanceLocalMatrix);
                    $1a55656020b89c3a$var$_box3.copy(geometry.boundingBox).applyMatrix4($1a55656020b89c3a$var$_instanceLocalMatrix);
                    this.boundingBox.union($1a55656020b89c3a$var$_box3);
                }
            }
        },
        {
            key: "computeBoundingSphere",
            value: function computeBoundingSphere() {
                var geometry = this.geometry;
                var count = this.count;
                if (this.boundingSphere === null) this.boundingSphere = new $1a55656020b89c3a$export$805e8b72413ccaba();
                if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                this.boundingSphere.makeEmpty();
                for(var i = 0; i < count; i++){
                    this.getMatrixAt(i, $1a55656020b89c3a$var$_instanceLocalMatrix);
                    $1a55656020b89c3a$var$_sphere$4.copy(geometry.boundingSphere).applyMatrix4($1a55656020b89c3a$var$_instanceLocalMatrix);
                    this.boundingSphere.union($1a55656020b89c3a$var$_sphere$4);
                }
            }
        },
        {
            key: "copy",
            value: function copy(source, recursive) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(InstancedMesh.prototype), "copy", this).call(this, source, recursive);
                this.instanceMatrix.copy(source.instanceMatrix);
                if (source.morphTexture !== null) this.morphTexture = source.morphTexture.clone();
                if (source.instanceColor !== null) this.instanceColor = source.instanceColor.clone();
                this.count = source.count;
                if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
                if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
                return this;
            }
        },
        {
            key: "getColorAt",
            value: function getColorAt(index, color) {
                color.fromArray(this.instanceColor.array, index * 3);
            }
        },
        {
            key: "getMatrixAt",
            value: function getMatrixAt(index, matrix) {
                matrix.fromArray(this.instanceMatrix.array, index * 16);
            }
        },
        {
            key: "getMorphAt",
            value: function getMorphAt(index, object) {
                var objectInfluences = object.morphTargetInfluences;
                var array = this.morphTexture.source.data.data;
                var len = objectInfluences.length + 1; // All influences + the baseInfluenceSum
                var dataIndex = index * len + 1; // Skip the baseInfluenceSum at the beginning
                for(var i = 0; i < objectInfluences.length; i++)objectInfluences[i] = array[dataIndex + i];
            }
        },
        {
            key: "raycast",
            value: function raycast(raycaster, intersects) {
                var matrixWorld = this.matrixWorld;
                var raycastTimes = this.count;
                $1a55656020b89c3a$var$_mesh$1.geometry = this.geometry;
                $1a55656020b89c3a$var$_mesh$1.material = this.material;
                if ($1a55656020b89c3a$var$_mesh$1.material === undefined) return;
                // test with bounding sphere first
                if (this.boundingSphere === null) this.computeBoundingSphere();
                $1a55656020b89c3a$var$_sphere$4.copy(this.boundingSphere);
                $1a55656020b89c3a$var$_sphere$4.applyMatrix4(matrixWorld);
                if (raycaster.ray.intersectsSphere($1a55656020b89c3a$var$_sphere$4) === false) return;
                // now test each instance
                for(var instanceId = 0; instanceId < raycastTimes; instanceId++){
                    // calculate the world matrix for each instance
                    this.getMatrixAt(instanceId, $1a55656020b89c3a$var$_instanceLocalMatrix);
                    $1a55656020b89c3a$var$_instanceWorldMatrix.multiplyMatrices(matrixWorld, $1a55656020b89c3a$var$_instanceLocalMatrix);
                    // the mesh represents this single instance
                    $1a55656020b89c3a$var$_mesh$1.matrixWorld = $1a55656020b89c3a$var$_instanceWorldMatrix;
                    $1a55656020b89c3a$var$_mesh$1.raycast(raycaster, $1a55656020b89c3a$var$_instanceIntersects);
                    // process the result of raycast
                    for(var i = 0, l = $1a55656020b89c3a$var$_instanceIntersects.length; i < l; i++){
                        var intersect = $1a55656020b89c3a$var$_instanceIntersects[i];
                        intersect.instanceId = instanceId;
                        intersect.object = this;
                        intersects.push(intersect);
                    }
                    $1a55656020b89c3a$var$_instanceIntersects.length = 0;
                }
            }
        },
        {
            key: "setColorAt",
            value: function setColorAt(index, color) {
                if (this.instanceColor === null) this.instanceColor = new $1a55656020b89c3a$export$32ea87a8b54d744a(new Float32Array(this.instanceMatrix.count * 3).fill(1), 3);
                color.toArray(this.instanceColor.array, index * 3);
            }
        },
        {
            key: "setMatrixAt",
            value: function setMatrixAt(index, matrix) {
                matrix.toArray(this.instanceMatrix.array, index * 16);
            }
        },
        {
            key: "setMorphAt",
            value: function setMorphAt(index, object) {
                var objectInfluences = object.morphTargetInfluences;
                var len = objectInfluences.length + 1; // morphBaseInfluence + all influences
                if (this.morphTexture === null) this.morphTexture = new $1a55656020b89c3a$export$b691f601014eabe1(new Float32Array(len * this.count), len, this.count, $1a55656020b89c3a$export$4e041a7967d15c4b, $1a55656020b89c3a$export$f6d331659b644596);
                var array = this.morphTexture.source.data.data;
                var morphInfluencesSum = 0;
                for(var i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
                var morphBaseInfluence = this.geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
                var dataIndex = len * index;
                array[dataIndex] = morphBaseInfluence;
                array.set(objectInfluences, dataIndex + 1);
            }
        },
        {
            key: "updateMorphTargets",
            value: function updateMorphTargets() {}
        },
        {
            key: "dispose",
            value: function dispose() {
                this.dispatchEvent({
                    type: 'dispose'
                });
                if (this.morphTexture !== null) {
                    this.morphTexture.dispose();
                    this.morphTexture = null;
                }
                return this;
            }
        }
    ]);
    return InstancedMesh;
}($1a55656020b89c3a$export$e176487c05830cc5);
var $1a55656020b89c3a$var$_vector1 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_vector2 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_normalMatrix = /*@__PURE__*/ new $1a55656020b89c3a$export$8ff26dafa08918();
var $1a55656020b89c3a$export$7ff5ac152ef991b0 = /*#__PURE__*/ function() {
    "use strict";
    function Plane() {
        var normal = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $1a55656020b89c3a$export$64b5c384219d3699(1, 0, 0), constant = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Plane);
        this.isPlane = true;
        // normal is assumed to be normalized
        this.normal = normal;
        this.constant = constant;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Plane, [
        {
            key: "set",
            value: function set(normal, constant) {
                this.normal.copy(normal);
                this.constant = constant;
                return this;
            }
        },
        {
            key: "setComponents",
            value: function setComponents(x, y, z, w) {
                this.normal.set(x, y, z);
                this.constant = w;
                return this;
            }
        },
        {
            key: "setFromNormalAndCoplanarPoint",
            value: function setFromNormalAndCoplanarPoint(normal, point) {
                this.normal.copy(normal);
                this.constant = -point.dot(this.normal);
                return this;
            }
        },
        {
            key: "setFromCoplanarPoints",
            value: function setFromCoplanarPoints(a, b, c) {
                var normal = $1a55656020b89c3a$var$_vector1.subVectors(c, b).cross($1a55656020b89c3a$var$_vector2.subVectors(a, b)).normalize();
                // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
                this.setFromNormalAndCoplanarPoint(normal, a);
                return this;
            }
        },
        {
            key: "copy",
            value: function copy(plane) {
                this.normal.copy(plane.normal);
                this.constant = plane.constant;
                return this;
            }
        },
        {
            key: "normalize",
            value: function normalize() {
                // Note: will lead to a divide by zero if the plane is invalid.
                var inverseNormalLength = 1.0 / this.normal.length();
                this.normal.multiplyScalar(inverseNormalLength);
                this.constant *= inverseNormalLength;
                return this;
            }
        },
        {
            key: "negate",
            value: function negate() {
                this.constant *= -1;
                this.normal.negate();
                return this;
            }
        },
        {
            key: "distanceToPoint",
            value: function distanceToPoint(point) {
                return this.normal.dot(point) + this.constant;
            }
        },
        {
            key: "distanceToSphere",
            value: function distanceToSphere(sphere) {
                return this.distanceToPoint(sphere.center) - sphere.radius;
            }
        },
        {
            key: "projectPoint",
            value: function projectPoint(point, target) {
                return target.copy(point).addScaledVector(this.normal, -this.distanceToPoint(point));
            }
        },
        {
            key: "intersectLine",
            value: function intersectLine(line, target) {
                var direction = line.delta($1a55656020b89c3a$var$_vector1);
                var denominator = this.normal.dot(direction);
                if (denominator === 0) {
                    // line is coplanar, return origin
                    if (this.distanceToPoint(line.start) === 0) return target.copy(line.start);
                    // Unsure if this is the correct method to handle this case.
                    return null;
                }
                var t = -(line.start.dot(this.normal) + this.constant) / denominator;
                if (t < 0 || t > 1) return null;
                return target.copy(line.start).addScaledVector(direction, t);
            }
        },
        {
            key: "intersectsLine",
            value: function intersectsLine(line) {
                // Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.
                var startSign = this.distanceToPoint(line.start);
                var endSign = this.distanceToPoint(line.end);
                return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
            }
        },
        {
            key: "intersectsBox",
            value: function intersectsBox(box) {
                return box.intersectsPlane(this);
            }
        },
        {
            key: "intersectsSphere",
            value: function intersectsSphere(sphere) {
                return sphere.intersectsPlane(this);
            }
        },
        {
            key: "coplanarPoint",
            value: function coplanarPoint(target) {
                return target.copy(this.normal).multiplyScalar(-this.constant);
            }
        },
        {
            key: "applyMatrix4",
            value: function applyMatrix4(matrix, optionalNormalMatrix) {
                var normalMatrix = optionalNormalMatrix || $1a55656020b89c3a$var$_normalMatrix.getNormalMatrix(matrix);
                var referencePoint = this.coplanarPoint($1a55656020b89c3a$var$_vector1).applyMatrix4(matrix);
                var normal = this.normal.applyMatrix3(normalMatrix).normalize();
                this.constant = -referencePoint.dot(normal);
                return this;
            }
        },
        {
            key: "translate",
            value: function translate(offset) {
                this.constant -= offset.dot(this.normal);
                return this;
            }
        },
        {
            key: "equals",
            value: function equals(plane) {
                return plane.normal.equals(this.normal) && plane.constant === this.constant;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        }
    ]);
    return Plane;
}();
var $1a55656020b89c3a$var$_sphere$3 = /*@__PURE__*/ new $1a55656020b89c3a$export$805e8b72413ccaba();
var $1a55656020b89c3a$var$_vector$6 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$export$35efe6f4c85463d2 = /*#__PURE__*/ function() {
    "use strict";
    function Frustum() {
        var p0 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $1a55656020b89c3a$export$7ff5ac152ef991b0(), p1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $1a55656020b89c3a$export$7ff5ac152ef991b0(), p2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new $1a55656020b89c3a$export$7ff5ac152ef991b0(), p3 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : new $1a55656020b89c3a$export$7ff5ac152ef991b0(), p4 = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : new $1a55656020b89c3a$export$7ff5ac152ef991b0(), p5 = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : new $1a55656020b89c3a$export$7ff5ac152ef991b0();
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Frustum);
        this.planes = [
            p0,
            p1,
            p2,
            p3,
            p4,
            p5
        ];
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Frustum, [
        {
            key: "set",
            value: function set(p0, p1, p2, p3, p4, p5) {
                var planes = this.planes;
                planes[0].copy(p0);
                planes[1].copy(p1);
                planes[2].copy(p2);
                planes[3].copy(p3);
                planes[4].copy(p4);
                planes[5].copy(p5);
                return this;
            }
        },
        {
            key: "copy",
            value: function copy(frustum) {
                var planes = this.planes;
                for(var i = 0; i < 6; i++)planes[i].copy(frustum.planes[i]);
                return this;
            }
        },
        {
            key: "setFromProjectionMatrix",
            value: function setFromProjectionMatrix(m) {
                var coordinateSystem = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $1a55656020b89c3a$export$5a0e9190d10875d3;
                var planes = this.planes;
                var me = m.elements;
                var me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
                var me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
                var me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
                var me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
                planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
                planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
                planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
                planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
                planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize();
                if (coordinateSystem === $1a55656020b89c3a$export$5a0e9190d10875d3) planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize();
                else if (coordinateSystem === $1a55656020b89c3a$export$cc83beedcb9be9ac) planes[5].setComponents(me2, me6, me10, me14).normalize();
                else throw new Error('THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: ' + coordinateSystem);
                return this;
            }
        },
        {
            key: "intersectsObject",
            value: function intersectsObject(object) {
                if (object.boundingSphere !== undefined) {
                    if (object.boundingSphere === null) object.computeBoundingSphere();
                    $1a55656020b89c3a$var$_sphere$3.copy(object.boundingSphere).applyMatrix4(object.matrixWorld);
                } else {
                    var geometry = object.geometry;
                    if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                    $1a55656020b89c3a$var$_sphere$3.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
                }
                return this.intersectsSphere($1a55656020b89c3a$var$_sphere$3);
            }
        },
        {
            key: "intersectsSprite",
            value: function intersectsSprite(sprite) {
                $1a55656020b89c3a$var$_sphere$3.center.set(0, 0, 0);
                $1a55656020b89c3a$var$_sphere$3.radius = 0.7071067811865476;
                $1a55656020b89c3a$var$_sphere$3.applyMatrix4(sprite.matrixWorld);
                return this.intersectsSphere($1a55656020b89c3a$var$_sphere$3);
            }
        },
        {
            key: "intersectsSphere",
            value: function intersectsSphere(sphere) {
                var planes = this.planes;
                var center = sphere.center;
                var negRadius = -sphere.radius;
                for(var i = 0; i < 6; i++){
                    var distance = planes[i].distanceToPoint(center);
                    if (distance < negRadius) return false;
                }
                return true;
            }
        },
        {
            key: "intersectsBox",
            value: function intersectsBox(box) {
                var planes = this.planes;
                for(var i = 0; i < 6; i++){
                    var plane = planes[i];
                    // corner at max distance
                    $1a55656020b89c3a$var$_vector$6.x = plane.normal.x > 0 ? box.max.x : box.min.x;
                    $1a55656020b89c3a$var$_vector$6.y = plane.normal.y > 0 ? box.max.y : box.min.y;
                    $1a55656020b89c3a$var$_vector$6.z = plane.normal.z > 0 ? box.max.z : box.min.z;
                    if (plane.distanceToPoint($1a55656020b89c3a$var$_vector$6) < 0) return false;
                }
                return true;
            }
        },
        {
            key: "containsPoint",
            value: function containsPoint(point) {
                var planes = this.planes;
                for(var i = 0; i < 6; i++){
                    if (planes[i].distanceToPoint(point) < 0) return false;
                }
                return true;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        }
    ]);
    return Frustum;
}();
function $1a55656020b89c3a$var$ascIdSort(a, b) {
    return a - b;
}
function $1a55656020b89c3a$var$sortOpaque(a, b) {
    return a.z - b.z;
}
function $1a55656020b89c3a$var$sortTransparent(a, b) {
    return b.z - a.z;
}
var $1a55656020b89c3a$var$MultiDrawRenderList = /*#__PURE__*/ function() {
    "use strict";
    function MultiDrawRenderList() {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, MultiDrawRenderList);
        this.index = 0;
        this.pool = [];
        this.list = [];
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(MultiDrawRenderList, [
        {
            key: "push",
            value: function push(start, count, z, index) {
                var pool = this.pool;
                var list = this.list;
                if (this.index >= pool.length) pool.push({
                    start: -1,
                    count: -1,
                    z: -1,
                    index: -1
                });
                var item = pool[this.index];
                list.push(item);
                this.index++;
                item.start = start;
                item.count = count;
                item.z = z;
                item.index = index;
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.list.length = 0;
                this.index = 0;
            }
        }
    ]);
    return MultiDrawRenderList;
}();
var $1a55656020b89c3a$var$_matrix$1 = /*@__PURE__*/ new $1a55656020b89c3a$export$2ae72fc923e5eb5();
var $1a55656020b89c3a$var$_whiteColor = /*@__PURE__*/ new $1a55656020b89c3a$export$892596cec99bc70e(1, 1, 1);
var $1a55656020b89c3a$var$_frustum = /*@__PURE__*/ new $1a55656020b89c3a$export$35efe6f4c85463d2();
var $1a55656020b89c3a$var$_box$1 = /*@__PURE__*/ new $1a55656020b89c3a$export$6f7d5a9418ab2aa3();
var $1a55656020b89c3a$var$_sphere$2 = /*@__PURE__*/ new $1a55656020b89c3a$export$805e8b72413ccaba();
var $1a55656020b89c3a$var$_vector$5 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_forward = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_temp = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_renderList = /*@__PURE__*/ new $1a55656020b89c3a$var$MultiDrawRenderList();
var $1a55656020b89c3a$var$_mesh = /*@__PURE__*/ new $1a55656020b89c3a$export$e176487c05830cc5();
var $1a55656020b89c3a$var$_batchIntersects = [];
// copies data from attribute "src" into "target" starting at "targetOffset"
function $1a55656020b89c3a$var$copyAttributeData(src, target) {
    var targetOffset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    var itemSize = target.itemSize;
    if (src.isInterleavedBufferAttribute || src.array.constructor !== target.array.constructor) {
        // use the component getters and setters if the array data cannot
        // be copied directly
        var vertexCount = src.count;
        for(var i = 0; i < vertexCount; i++)for(var c = 0; c < itemSize; c++)target.setComponent(i + targetOffset, c, src.getComponent(i, c));
    } else // faster copy approach using typed array set function
    target.array.set(src.array, targetOffset * itemSize);
    target.needsUpdate = true;
}
// safely copies array contents to a potentially smaller array
function $1a55656020b89c3a$var$copyArrayContents(src, target) {
    if (src.constructor !== target.constructor) {
        // if arrays are of a different type (eg due to index size increasing) then data must be per-element copied
        var len = Math.min(src.length, target.length);
        for(var i = 0; i < len; i++)target[i] = src[i];
    } else {
        // if the arrays use the same data layout we can use a fast block copy
        var len1 = Math.min(src.length, target.length);
        target.set(new src.constructor(src.buffer, 0, len1));
    }
}
var $1a55656020b89c3a$export$6e01c5ee52ed8f7b = /*#__PURE__*/ function(Mesh) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(BatchedMesh, Mesh);
    function BatchedMesh(maxInstanceCount, maxVertexCount) {
        var maxIndexCount = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : maxVertexCount * 2, material = arguments.length > 3 ? arguments[3] : void 0;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, BatchedMesh);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, BatchedMesh, [
            new $1a55656020b89c3a$export$b7be63a67df8959(),
            material
        ]);
        _this.isBatchedMesh = true;
        _this.perObjectFrustumCulled = true;
        _this.sortObjects = true;
        _this.boundingBox = null;
        _this.boundingSphere = null;
        _this.customSort = null;
        // stores visible, active, and geometry id per instance and reserved buffer ranges for geometries
        _this._instanceInfo = [];
        _this._geometryInfo = [];
        // instance, geometry ids that have been set as inactive, and are available to be overwritten
        _this._availableInstanceIds = [];
        _this._availableGeometryIds = [];
        // used to track where the next point is that geometry should be inserted
        _this._nextIndexStart = 0;
        _this._nextVertexStart = 0;
        _this._geometryCount = 0;
        // flags
        _this._visibilityChanged = true;
        _this._geometryInitialized = false;
        // cached user options
        _this._maxInstanceCount = maxInstanceCount;
        _this._maxVertexCount = maxVertexCount;
        _this._maxIndexCount = maxIndexCount;
        // buffers for multi draw
        _this._multiDrawCounts = new Int32Array(maxInstanceCount);
        _this._multiDrawStarts = new Int32Array(maxInstanceCount);
        _this._multiDrawCount = 0;
        _this._multiDrawInstances = null;
        // Local matrix per geometry by using data texture
        _this._matricesTexture = null;
        _this._indirectTexture = null;
        _this._colorsTexture = null;
        _this._initMatricesTexture();
        _this._initIndirectTexture();
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(BatchedMesh, [
        {
            key: "maxInstanceCount",
            get: function get() {
                return this._maxInstanceCount;
            }
        },
        {
            key: "instanceCount",
            get: function get() {
                return this._instanceInfo.length - this._availableInstanceIds.length;
            }
        },
        {
            key: "unusedVertexCount",
            get: function get() {
                return this._maxVertexCount - this._nextVertexStart;
            }
        },
        {
            key: "unusedIndexCount",
            get: function get() {
                return this._maxIndexCount - this._nextIndexStart;
            }
        },
        {
            key: "_initMatricesTexture",
            value: function _initMatricesTexture() {
                // layout (1 matrix = 4 pixels)
                //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
                //  with  8x8  pixel texture max   16 matrices * 4 pixels =  (8 * 8)
                //       16x16 pixel texture max   64 matrices * 4 pixels = (16 * 16)
                //       32x32 pixel texture max  256 matrices * 4 pixels = (32 * 32)
                //       64x64 pixel texture max 1024 matrices * 4 pixels = (64 * 64)
                var size = Math.sqrt(this._maxInstanceCount * 4); // 4 pixels needed for 1 matrix
                size = Math.ceil(size / 4) * 4;
                size = Math.max(size, 4);
                var matricesArray = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
                var matricesTexture = new $1a55656020b89c3a$export$b691f601014eabe1(matricesArray, size, size, $1a55656020b89c3a$export$3f8bb04b555a363c, $1a55656020b89c3a$export$f6d331659b644596);
                this._matricesTexture = matricesTexture;
            }
        },
        {
            key: "_initIndirectTexture",
            value: function _initIndirectTexture() {
                var size = Math.sqrt(this._maxInstanceCount);
                size = Math.ceil(size);
                var indirectArray = new Uint32Array(size * size);
                var indirectTexture = new $1a55656020b89c3a$export$b691f601014eabe1(indirectArray, size, size, $1a55656020b89c3a$export$aa92e870a709d190, $1a55656020b89c3a$export$c3c7fc4518ebba96);
                this._indirectTexture = indirectTexture;
            }
        },
        {
            key: "_initColorsTexture",
            value: function _initColorsTexture() {
                var size = Math.sqrt(this._maxInstanceCount);
                size = Math.ceil(size);
                // 4 floats per RGBA pixel initialized to white
                var colorsArray = new Float32Array(size * size * 4).fill(1);
                var colorsTexture = new $1a55656020b89c3a$export$b691f601014eabe1(colorsArray, size, size, $1a55656020b89c3a$export$3f8bb04b555a363c, $1a55656020b89c3a$export$f6d331659b644596);
                colorsTexture.colorSpace = $1a55656020b89c3a$export$5e6fd513f44698c.workingColorSpace;
                this._colorsTexture = colorsTexture;
            }
        },
        {
            key: "_initializeGeometry",
            value: function _initializeGeometry(reference) {
                var geometry = this.geometry;
                var maxVertexCount = this._maxVertexCount;
                var maxIndexCount = this._maxIndexCount;
                if (this._geometryInitialized === false) {
                    for(var attributeName in reference.attributes){
                        var srcAttribute = reference.getAttribute(attributeName);
                        var array = srcAttribute.array, itemSize = srcAttribute.itemSize, normalized = srcAttribute.normalized;
                        var dstArray = new array.constructor(maxVertexCount * itemSize);
                        var dstAttribute = new $1a55656020b89c3a$export$8dea267bd6bde117(dstArray, itemSize, normalized);
                        geometry.setAttribute(attributeName, dstAttribute);
                    }
                    if (reference.getIndex() !== null) {
                        // Reserve last u16 index for primitive restart.
                        var indexArray = maxVertexCount > 65535 ? new Uint32Array(maxIndexCount) : new Uint16Array(maxIndexCount);
                        geometry.setIndex(new $1a55656020b89c3a$export$8dea267bd6bde117(indexArray, 1));
                    }
                    this._geometryInitialized = true;
                }
            }
        },
        {
            // Make sure the geometry is compatible with the existing combined geometry attributes
            key: "_validateGeometry",
            value: function _validateGeometry(geometry) {
                // check to ensure the geometries are using consistent attributes and indices
                var batchGeometry = this.geometry;
                if (Boolean(geometry.getIndex()) !== Boolean(batchGeometry.getIndex())) throw new Error('THREE.BatchedMesh: All geometries must consistently have "index".');
                for(var attributeName in batchGeometry.attributes){
                    if (!geometry.hasAttribute(attributeName)) throw new Error('THREE.BatchedMesh: Added geometry missing "'.concat(attributeName, '". All geometries must have consistent attributes.'));
                    var srcAttribute = geometry.getAttribute(attributeName);
                    var dstAttribute = batchGeometry.getAttribute(attributeName);
                    if (srcAttribute.itemSize !== dstAttribute.itemSize || srcAttribute.normalized !== dstAttribute.normalized) throw new Error('THREE.BatchedMesh: All attributes must have a consistent itemSize and normalized value.');
                }
            }
        },
        {
            key: "validateInstanceId",
            value: function validateInstanceId(instanceId) {
                var instanceInfo = this._instanceInfo;
                if (instanceId < 0 || instanceId >= instanceInfo.length || instanceInfo[instanceId].active === false) throw new Error("THREE.BatchedMesh: Invalid instanceId ".concat(instanceId, ". Instance is either out of range or has been deleted."));
            }
        },
        {
            key: "validateGeometryId",
            value: function validateGeometryId(geometryId) {
                var geometryInfoList = this._geometryInfo;
                if (geometryId < 0 || geometryId >= geometryInfoList.length || geometryInfoList[geometryId].active === false) throw new Error("THREE.BatchedMesh: Invalid geometryId ".concat(geometryId, ". Geometry is either out of range or has been deleted."));
            }
        },
        {
            key: "setCustomSort",
            value: function setCustomSort(func) {
                this.customSort = func;
                return this;
            }
        },
        {
            key: "computeBoundingBox",
            value: function computeBoundingBox() {
                if (this.boundingBox === null) this.boundingBox = new $1a55656020b89c3a$export$6f7d5a9418ab2aa3();
                var boundingBox = this.boundingBox;
                var instanceInfo = this._instanceInfo;
                boundingBox.makeEmpty();
                for(var i = 0, l = instanceInfo.length; i < l; i++){
                    if (instanceInfo[i].active === false) continue;
                    var geometryId = instanceInfo[i].geometryIndex;
                    this.getMatrixAt(i, $1a55656020b89c3a$var$_matrix$1);
                    this.getBoundingBoxAt(geometryId, $1a55656020b89c3a$var$_box$1).applyMatrix4($1a55656020b89c3a$var$_matrix$1);
                    boundingBox.union($1a55656020b89c3a$var$_box$1);
                }
            }
        },
        {
            key: "computeBoundingSphere",
            value: function computeBoundingSphere() {
                if (this.boundingSphere === null) this.boundingSphere = new $1a55656020b89c3a$export$805e8b72413ccaba();
                var boundingSphere = this.boundingSphere;
                var instanceInfo = this._instanceInfo;
                boundingSphere.makeEmpty();
                for(var i = 0, l = instanceInfo.length; i < l; i++){
                    if (instanceInfo[i].active === false) continue;
                    var geometryId = instanceInfo[i].geometryIndex;
                    this.getMatrixAt(i, $1a55656020b89c3a$var$_matrix$1);
                    this.getBoundingSphereAt(geometryId, $1a55656020b89c3a$var$_sphere$2).applyMatrix4($1a55656020b89c3a$var$_matrix$1);
                    boundingSphere.union($1a55656020b89c3a$var$_sphere$2);
                }
            }
        },
        {
            key: "addInstance",
            value: function addInstance(geometryId) {
                var atCapacity = this._instanceInfo.length >= this.maxInstanceCount;
                // ensure we're not over geometry
                if (atCapacity && this._availableInstanceIds.length === 0) throw new Error('THREE.BatchedMesh: Maximum item count reached.');
                var instanceInfo = {
                    visible: true,
                    active: true,
                    geometryIndex: geometryId
                };
                var drawId = null;
                // Prioritize using previously freed instance ids
                if (this._availableInstanceIds.length > 0) {
                    this._availableInstanceIds.sort($1a55656020b89c3a$var$ascIdSort);
                    drawId = this._availableInstanceIds.shift();
                    this._instanceInfo[drawId] = instanceInfo;
                } else {
                    drawId = this._instanceInfo.length;
                    this._instanceInfo.push(instanceInfo);
                }
                var matricesTexture = this._matricesTexture;
                $1a55656020b89c3a$var$_matrix$1.identity().toArray(matricesTexture.image.data, drawId * 16);
                matricesTexture.needsUpdate = true;
                var colorsTexture = this._colorsTexture;
                if (colorsTexture) {
                    $1a55656020b89c3a$var$_whiteColor.toArray(colorsTexture.image.data, drawId * 4);
                    colorsTexture.needsUpdate = true;
                }
                this._visibilityChanged = true;
                return drawId;
            }
        },
        {
            key: "addGeometry",
            value: function addGeometry(geometry) {
                var reservedVertexCount = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1, reservedIndexCount = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -1;
                this._initializeGeometry(geometry);
                this._validateGeometry(geometry);
                var geometryInfo = {
                    // geometry information
                    vertexStart: -1,
                    vertexCount: -1,
                    reservedVertexCount: -1,
                    indexStart: -1,
                    indexCount: -1,
                    reservedIndexCount: -1,
                    // draw range information
                    start: -1,
                    count: -1,
                    // state
                    boundingBox: null,
                    boundingSphere: null,
                    active: true
                };
                var geometryInfoList = this._geometryInfo;
                geometryInfo.vertexStart = this._nextVertexStart;
                geometryInfo.reservedVertexCount = reservedVertexCount === -1 ? geometry.getAttribute('position').count : reservedVertexCount;
                var index = geometry.getIndex();
                var hasIndex = index !== null;
                if (hasIndex) {
                    geometryInfo.indexStart = this._nextIndexStart;
                    geometryInfo.reservedIndexCount = reservedIndexCount === -1 ? index.count : reservedIndexCount;
                }
                if (geometryInfo.indexStart !== -1 && geometryInfo.indexStart + geometryInfo.reservedIndexCount > this._maxIndexCount || geometryInfo.vertexStart + geometryInfo.reservedVertexCount > this._maxVertexCount) throw new Error('THREE.BatchedMesh: Reserved space request exceeds the maximum buffer size.');
                // update id
                var geometryId;
                if (this._availableGeometryIds.length > 0) {
                    this._availableGeometryIds.sort($1a55656020b89c3a$var$ascIdSort);
                    geometryId = this._availableGeometryIds.shift();
                    geometryInfoList[geometryId] = geometryInfo;
                } else {
                    geometryId = this._geometryCount;
                    this._geometryCount++;
                    geometryInfoList.push(geometryInfo);
                }
                // update the geometry
                this.setGeometryAt(geometryId, geometry);
                // increment the next geometry position
                this._nextIndexStart = geometryInfo.indexStart + geometryInfo.reservedIndexCount;
                this._nextVertexStart = geometryInfo.vertexStart + geometryInfo.reservedVertexCount;
                return geometryId;
            }
        },
        {
            key: "setGeometryAt",
            value: function setGeometryAt(geometryId, geometry) {
                if (geometryId >= this._geometryCount) throw new Error('THREE.BatchedMesh: Maximum geometry count reached.');
                this._validateGeometry(geometry);
                var batchGeometry = this.geometry;
                var hasIndex = batchGeometry.getIndex() !== null;
                var dstIndex = batchGeometry.getIndex();
                var srcIndex = geometry.getIndex();
                var geometryInfo = this._geometryInfo[geometryId];
                if (hasIndex && srcIndex.count > geometryInfo.reservedIndexCount || geometry.attributes.position.count > geometryInfo.reservedVertexCount) throw new Error('THREE.BatchedMesh: Reserved space not large enough for provided geometry.');
                // copy geometry buffer data over
                var vertexStart = geometryInfo.vertexStart;
                var reservedVertexCount = geometryInfo.reservedVertexCount;
                geometryInfo.vertexCount = geometry.getAttribute('position').count;
                for(var attributeName in batchGeometry.attributes){
                    // copy attribute data
                    var srcAttribute = geometry.getAttribute(attributeName);
                    var dstAttribute = batchGeometry.getAttribute(attributeName);
                    $1a55656020b89c3a$var$copyAttributeData(srcAttribute, dstAttribute, vertexStart);
                    // fill the rest in with zeroes
                    var itemSize = srcAttribute.itemSize;
                    for(var i = srcAttribute.count, l = reservedVertexCount; i < l; i++){
                        var index = vertexStart + i;
                        for(var c = 0; c < itemSize; c++)dstAttribute.setComponent(index, c, 0);
                    }
                    dstAttribute.needsUpdate = true;
                    dstAttribute.addUpdateRange(vertexStart * itemSize, reservedVertexCount * itemSize);
                }
                // copy index
                if (hasIndex) {
                    var indexStart = geometryInfo.indexStart;
                    var reservedIndexCount = geometryInfo.reservedIndexCount;
                    geometryInfo.indexCount = geometry.getIndex().count;
                    // copy index data over
                    for(var i1 = 0; i1 < srcIndex.count; i1++)dstIndex.setX(indexStart + i1, vertexStart + srcIndex.getX(i1));
                    // fill the rest in with zeroes
                    for(var i2 = srcIndex.count, l1 = reservedIndexCount; i2 < l1; i2++)dstIndex.setX(indexStart + i2, vertexStart);
                    dstIndex.needsUpdate = true;
                    dstIndex.addUpdateRange(indexStart, geometryInfo.reservedIndexCount);
                }
                // update the draw range
                geometryInfo.start = hasIndex ? geometryInfo.indexStart : geometryInfo.vertexStart;
                geometryInfo.count = hasIndex ? geometryInfo.indexCount : geometryInfo.vertexCount;
                // store the bounding boxes
                geometryInfo.boundingBox = null;
                if (geometry.boundingBox !== null) geometryInfo.boundingBox = geometry.boundingBox.clone();
                geometryInfo.boundingSphere = null;
                if (geometry.boundingSphere !== null) geometryInfo.boundingSphere = geometry.boundingSphere.clone();
                this._visibilityChanged = true;
                return geometryId;
            }
        },
        {
            key: "deleteGeometry",
            value: function deleteGeometry(geometryId) {
                var geometryInfoList = this._geometryInfo;
                if (geometryId >= geometryInfoList.length || geometryInfoList[geometryId].active === false) return this;
                // delete any instances associated with this geometry
                var instanceInfo = this._instanceInfo;
                for(var i = 0, l = instanceInfo.length; i < l; i++)if (instanceInfo[i].active && instanceInfo[i].geometryIndex === geometryId) this.deleteInstance(i);
                geometryInfoList[geometryId].active = false;
                this._availableGeometryIds.push(geometryId);
                this._visibilityChanged = true;
                return this;
            }
        },
        {
            key: "deleteInstance",
            value: function deleteInstance(instanceId) {
                this.validateInstanceId(instanceId);
                this._instanceInfo[instanceId].active = false;
                this._availableInstanceIds.push(instanceId);
                this._visibilityChanged = true;
                return this;
            }
        },
        {
            key: "optimize",
            value: function optimize() {
                // track the next indices to copy data to
                var nextVertexStart = 0;
                var nextIndexStart = 0;
                // Iterate over all geometry ranges in order sorted from earliest in the geometry buffer to latest
                // in the geometry buffer. Because draw range objects can be reused there is no guarantee of their order.
                var geometryInfoList = this._geometryInfo;
                var indices = geometryInfoList.map(function(e, i) {
                    return i;
                }).sort(function(a, b) {
                    return geometryInfoList[a].vertexStart - geometryInfoList[b].vertexStart;
                });
                var geometry = this.geometry;
                for(var i = 0, l = geometryInfoList.length; i < l; i++){
                    // if a geometry range is inactive then don't copy anything
                    var index = indices[i];
                    var geometryInfo = geometryInfoList[index];
                    if (geometryInfo.active === false) continue;
                    // if a geometry contains an index buffer then shift it, as well
                    if (geometry.index !== null) {
                        if (geometryInfo.indexStart !== nextIndexStart) {
                            var indexStart = geometryInfo.indexStart, vertexStart = geometryInfo.vertexStart, reservedIndexCount = geometryInfo.reservedIndexCount;
                            var index1 = geometry.index;
                            var array = index1.array;
                            // shift the index pointers based on how the vertex data will shift
                            // adjusting the index must happen first so the original vertex start value is available
                            var elementDelta = nextVertexStart - vertexStart;
                            for(var j = indexStart; j < indexStart + reservedIndexCount; j++)array[j] = array[j] + elementDelta;
                            index1.array.copyWithin(nextIndexStart, indexStart, indexStart + reservedIndexCount);
                            index1.addUpdateRange(nextIndexStart, reservedIndexCount);
                            geometryInfo.indexStart = nextIndexStart;
                        }
                        nextIndexStart += geometryInfo.reservedIndexCount;
                    }
                    // if a geometry needs to be moved then copy attribute data to overwrite unused space
                    if (geometryInfo.vertexStart !== nextVertexStart) {
                        var vertexStart1 = geometryInfo.vertexStart, reservedVertexCount = geometryInfo.reservedVertexCount;
                        var attributes = geometry.attributes;
                        for(var key in attributes){
                            var attribute = attributes[key];
                            var array1 = attribute.array, itemSize = attribute.itemSize;
                            array1.copyWithin(nextVertexStart * itemSize, vertexStart1 * itemSize, (vertexStart1 + reservedVertexCount) * itemSize);
                            attribute.addUpdateRange(nextVertexStart * itemSize, reservedVertexCount * itemSize);
                        }
                        geometryInfo.vertexStart = nextVertexStart;
                    }
                    nextVertexStart += geometryInfo.reservedVertexCount;
                    geometryInfo.start = geometry.index ? geometryInfo.indexStart : geometryInfo.vertexStart;
                    // step the next geometry points to the shifted position
                    this._nextIndexStart = geometry.index ? geometryInfo.indexStart + geometryInfo.reservedIndexCount : 0;
                    this._nextVertexStart = geometryInfo.vertexStart + geometryInfo.reservedVertexCount;
                }
                return this;
            }
        },
        {
            // get bounding box and compute it if it doesn't exist
            key: "getBoundingBoxAt",
            value: function getBoundingBoxAt(geometryId, target) {
                if (geometryId >= this._geometryCount) return null;
                // compute bounding box
                var geometry = this.geometry;
                var geometryInfo = this._geometryInfo[geometryId];
                if (geometryInfo.boundingBox === null) {
                    var box = new $1a55656020b89c3a$export$6f7d5a9418ab2aa3();
                    var index = geometry.index;
                    var position = geometry.attributes.position;
                    for(var i = geometryInfo.start, l = geometryInfo.start + geometryInfo.count; i < l; i++){
                        var iv = i;
                        if (index) iv = index.getX(iv);
                        box.expandByPoint($1a55656020b89c3a$var$_vector$5.fromBufferAttribute(position, iv));
                    }
                    geometryInfo.boundingBox = box;
                }
                target.copy(geometryInfo.boundingBox);
                return target;
            }
        },
        {
            // get bounding sphere and compute it if it doesn't exist
            key: "getBoundingSphereAt",
            value: function getBoundingSphereAt(geometryId, target) {
                if (geometryId >= this._geometryCount) return null;
                // compute bounding sphere
                var geometry = this.geometry;
                var geometryInfo = this._geometryInfo[geometryId];
                if (geometryInfo.boundingSphere === null) {
                    var sphere = new $1a55656020b89c3a$export$805e8b72413ccaba();
                    this.getBoundingBoxAt(geometryId, $1a55656020b89c3a$var$_box$1);
                    $1a55656020b89c3a$var$_box$1.getCenter(sphere.center);
                    var index = geometry.index;
                    var position = geometry.attributes.position;
                    var maxRadiusSq = 0;
                    for(var i = geometryInfo.start, l = geometryInfo.start + geometryInfo.count; i < l; i++){
                        var iv = i;
                        if (index) iv = index.getX(iv);
                        $1a55656020b89c3a$var$_vector$5.fromBufferAttribute(position, iv);
                        maxRadiusSq = Math.max(maxRadiusSq, sphere.center.distanceToSquared($1a55656020b89c3a$var$_vector$5));
                    }
                    sphere.radius = Math.sqrt(maxRadiusSq);
                    geometryInfo.boundingSphere = sphere;
                }
                target.copy(geometryInfo.boundingSphere);
                return target;
            }
        },
        {
            key: "setMatrixAt",
            value: function setMatrixAt(instanceId, matrix) {
                this.validateInstanceId(instanceId);
                var matricesTexture = this._matricesTexture;
                var matricesArray = this._matricesTexture.image.data;
                matrix.toArray(matricesArray, instanceId * 16);
                matricesTexture.needsUpdate = true;
                return this;
            }
        },
        {
            key: "getMatrixAt",
            value: function getMatrixAt(instanceId, matrix) {
                this.validateInstanceId(instanceId);
                return matrix.fromArray(this._matricesTexture.image.data, instanceId * 16);
            }
        },
        {
            key: "setColorAt",
            value: function setColorAt(instanceId, color) {
                this.validateInstanceId(instanceId);
                if (this._colorsTexture === null) this._initColorsTexture();
                color.toArray(this._colorsTexture.image.data, instanceId * 4);
                this._colorsTexture.needsUpdate = true;
                return this;
            }
        },
        {
            key: "getColorAt",
            value: function getColorAt(instanceId, color) {
                this.validateInstanceId(instanceId);
                return color.fromArray(this._colorsTexture.image.data, instanceId * 4);
            }
        },
        {
            key: "setVisibleAt",
            value: function setVisibleAt(instanceId, value) {
                this.validateInstanceId(instanceId);
                if (this._instanceInfo[instanceId].visible === value) return this;
                this._instanceInfo[instanceId].visible = value;
                this._visibilityChanged = true;
                return this;
            }
        },
        {
            key: "getVisibleAt",
            value: function getVisibleAt(instanceId) {
                this.validateInstanceId(instanceId);
                return this._instanceInfo[instanceId].visible;
            }
        },
        {
            key: "setGeometryIdAt",
            value: function setGeometryIdAt(instanceId, geometryId) {
                this.validateInstanceId(instanceId);
                this.validateGeometryId(geometryId);
                this._instanceInfo[instanceId].geometryIndex = geometryId;
                return this;
            }
        },
        {
            key: "getGeometryIdAt",
            value: function getGeometryIdAt(instanceId) {
                this.validateInstanceId(instanceId);
                return this._instanceInfo[instanceId].geometryIndex;
            }
        },
        {
            key: "getGeometryRangeAt",
            value: function getGeometryRangeAt(geometryId) {
                var target = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                this.validateGeometryId(geometryId);
                var geometryInfo = this._geometryInfo[geometryId];
                target.vertexStart = geometryInfo.vertexStart;
                target.vertexCount = geometryInfo.vertexCount;
                target.reservedVertexCount = geometryInfo.reservedVertexCount;
                target.indexStart = geometryInfo.indexStart;
                target.indexCount = geometryInfo.indexCount;
                target.reservedIndexCount = geometryInfo.reservedIndexCount;
                target.start = geometryInfo.start;
                target.count = geometryInfo.count;
                return target;
            }
        },
        {
            key: "setInstanceCount",
            value: function setInstanceCount(maxInstanceCount) {
                // shrink the available instances as much as possible
                var availableInstanceIds = this._availableInstanceIds;
                var instanceInfo = this._instanceInfo;
                availableInstanceIds.sort($1a55656020b89c3a$var$ascIdSort);
                while(availableInstanceIds[availableInstanceIds.length - 1] === instanceInfo.length){
                    instanceInfo.pop();
                    availableInstanceIds.pop();
                }
                // throw an error if it can't be shrunk to the desired size
                if (maxInstanceCount < instanceInfo.length) throw new Error("BatchedMesh: Instance ids outside the range ".concat(maxInstanceCount, " are being used. Cannot shrink instance count."));
                // copy the multi draw counts
                var multiDrawCounts = new Int32Array(maxInstanceCount);
                var multiDrawStarts = new Int32Array(maxInstanceCount);
                $1a55656020b89c3a$var$copyArrayContents(this._multiDrawCounts, multiDrawCounts);
                $1a55656020b89c3a$var$copyArrayContents(this._multiDrawStarts, multiDrawStarts);
                this._multiDrawCounts = multiDrawCounts;
                this._multiDrawStarts = multiDrawStarts;
                this._maxInstanceCount = maxInstanceCount;
                // update texture data for instance sampling
                var indirectTexture = this._indirectTexture;
                var matricesTexture = this._matricesTexture;
                var colorsTexture = this._colorsTexture;
                indirectTexture.dispose();
                this._initIndirectTexture();
                $1a55656020b89c3a$var$copyArrayContents(indirectTexture.image.data, this._indirectTexture.image.data);
                matricesTexture.dispose();
                this._initMatricesTexture();
                $1a55656020b89c3a$var$copyArrayContents(matricesTexture.image.data, this._matricesTexture.image.data);
                if (colorsTexture) {
                    colorsTexture.dispose();
                    this._initColorsTexture();
                    $1a55656020b89c3a$var$copyArrayContents(colorsTexture.image.data, this._colorsTexture.image.data);
                }
            }
        },
        {
            key: "setGeometrySize",
            value: function setGeometrySize(maxVertexCount, maxIndexCount) {
                var _Math;
                // Check if we can shrink to the requested vertex attribute size
                var validRanges = (0, $4fcd3d80e9e33ca7$export$71511d61b312f219)(this._geometryInfo).filter(function(info) {
                    return info.active;
                });
                var requiredVertexLength = (_Math = Math).max.apply(_Math, (0, $4fcd3d80e9e33ca7$export$71511d61b312f219)(validRanges.map(function(range) {
                    return range.vertexStart + range.reservedVertexCount;
                })));
                if (requiredVertexLength > maxVertexCount) throw new Error("BatchedMesh: Geometry vertex values are being used outside the range ".concat(maxIndexCount, ". Cannot shrink further."));
                // Check if we can shrink to the requested index attribute size
                if (this.geometry.index) {
                    var _Math1;
                    var requiredIndexLength = (_Math1 = Math).max.apply(_Math1, (0, $4fcd3d80e9e33ca7$export$71511d61b312f219)(validRanges.map(function(range) {
                        return range.indexStart + range.reservedIndexCount;
                    })));
                    if (requiredIndexLength > maxIndexCount) throw new Error("BatchedMesh: Geometry index values are being used outside the range ".concat(maxIndexCount, ". Cannot shrink further."));
                }
                //
                // dispose of the previous geometry
                var oldGeometry = this.geometry;
                oldGeometry.dispose();
                // recreate the geometry needed based on the previous variant
                this._maxVertexCount = maxVertexCount;
                this._maxIndexCount = maxIndexCount;
                if (this._geometryInitialized) {
                    this._geometryInitialized = false;
                    this.geometry = new $1a55656020b89c3a$export$b7be63a67df8959();
                    this._initializeGeometry(oldGeometry);
                }
                // copy data from the previous geometry
                var geometry = this.geometry;
                if (oldGeometry.index) $1a55656020b89c3a$var$copyArrayContents(oldGeometry.index.array, geometry.index.array);
                for(var key in oldGeometry.attributes)$1a55656020b89c3a$var$copyArrayContents(oldGeometry.attributes[key].array, geometry.attributes[key].array);
            }
        },
        {
            key: "raycast",
            value: function raycast(raycaster, intersects) {
                var instanceInfo = this._instanceInfo;
                var geometryInfoList = this._geometryInfo;
                var matrixWorld = this.matrixWorld;
                var batchGeometry = this.geometry;
                // iterate over each geometry
                $1a55656020b89c3a$var$_mesh.material = this.material;
                $1a55656020b89c3a$var$_mesh.geometry.index = batchGeometry.index;
                $1a55656020b89c3a$var$_mesh.geometry.attributes = batchGeometry.attributes;
                if ($1a55656020b89c3a$var$_mesh.geometry.boundingBox === null) $1a55656020b89c3a$var$_mesh.geometry.boundingBox = new $1a55656020b89c3a$export$6f7d5a9418ab2aa3();
                if ($1a55656020b89c3a$var$_mesh.geometry.boundingSphere === null) $1a55656020b89c3a$var$_mesh.geometry.boundingSphere = new $1a55656020b89c3a$export$805e8b72413ccaba();
                for(var i = 0, l = instanceInfo.length; i < l; i++){
                    if (!instanceInfo[i].visible || !instanceInfo[i].active) continue;
                    var geometryId = instanceInfo[i].geometryIndex;
                    var geometryInfo = geometryInfoList[geometryId];
                    $1a55656020b89c3a$var$_mesh.geometry.setDrawRange(geometryInfo.start, geometryInfo.count);
                    // get the intersects
                    this.getMatrixAt(i, $1a55656020b89c3a$var$_mesh.matrixWorld).premultiply(matrixWorld);
                    this.getBoundingBoxAt(geometryId, $1a55656020b89c3a$var$_mesh.geometry.boundingBox);
                    this.getBoundingSphereAt(geometryId, $1a55656020b89c3a$var$_mesh.geometry.boundingSphere);
                    $1a55656020b89c3a$var$_mesh.raycast(raycaster, $1a55656020b89c3a$var$_batchIntersects);
                    // add batch id to the intersects
                    for(var j = 0, l1 = $1a55656020b89c3a$var$_batchIntersects.length; j < l1; j++){
                        var intersect = $1a55656020b89c3a$var$_batchIntersects[j];
                        intersect.object = this;
                        intersect.batchId = i;
                        intersects.push(intersect);
                    }
                    $1a55656020b89c3a$var$_batchIntersects.length = 0;
                }
                $1a55656020b89c3a$var$_mesh.material = null;
                $1a55656020b89c3a$var$_mesh.geometry.index = null;
                $1a55656020b89c3a$var$_mesh.geometry.attributes = {};
                $1a55656020b89c3a$var$_mesh.geometry.setDrawRange(0, Infinity);
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(BatchedMesh.prototype), "copy", this).call(this, source);
                this.geometry = source.geometry.clone();
                this.perObjectFrustumCulled = source.perObjectFrustumCulled;
                this.sortObjects = source.sortObjects;
                this.boundingBox = source.boundingBox !== null ? source.boundingBox.clone() : null;
                this.boundingSphere = source.boundingSphere !== null ? source.boundingSphere.clone() : null;
                this._geometryInfo = source._geometryInfo.map(function(info) {
                    return (0, $0baa13f7165429e0$export$71511d61b312f219)((0, $84de056ed7b7040b$export$71511d61b312f219)({}, info), {
                        boundingBox: info.boundingBox !== null ? info.boundingBox.clone() : null,
                        boundingSphere: info.boundingSphere !== null ? info.boundingSphere.clone() : null
                    });
                });
                this._instanceInfo = source._instanceInfo.map(function(info) {
                    return (0, $84de056ed7b7040b$export$71511d61b312f219)({}, info);
                });
                this._maxInstanceCount = source._maxInstanceCount;
                this._maxVertexCount = source._maxVertexCount;
                this._maxIndexCount = source._maxIndexCount;
                this._geometryInitialized = source._geometryInitialized;
                this._geometryCount = source._geometryCount;
                this._multiDrawCounts = source._multiDrawCounts.slice();
                this._multiDrawStarts = source._multiDrawStarts.slice();
                this._matricesTexture = source._matricesTexture.clone();
                this._matricesTexture.image.data = this._matricesTexture.image.data.slice();
                if (this._colorsTexture !== null) {
                    this._colorsTexture = source._colorsTexture.clone();
                    this._colorsTexture.image.data = this._colorsTexture.image.data.slice();
                }
                return this;
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                // Assuming the geometry is not shared with other meshes
                this.geometry.dispose();
                this._matricesTexture.dispose();
                this._matricesTexture = null;
                this._indirectTexture.dispose();
                this._indirectTexture = null;
                if (this._colorsTexture !== null) {
                    this._colorsTexture.dispose();
                    this._colorsTexture = null;
                }
                return this;
            }
        },
        {
            key: "onBeforeRender",
            value: function onBeforeRender(renderer, scene, camera, geometry, material /*, _group*/ ) {
                // if visibility has not changed and frustum culling and object sorting is not required
                // then skip iterating over all items
                if (!this._visibilityChanged && !this.perObjectFrustumCulled && !this.sortObjects) return;
                // the indexed version of the multi draw function requires specifying the start
                // offset in bytes.
                var index = geometry.getIndex();
                var bytesPerElement = index === null ? 1 : index.array.BYTES_PER_ELEMENT;
                var instanceInfo = this._instanceInfo;
                var multiDrawStarts = this._multiDrawStarts;
                var multiDrawCounts = this._multiDrawCounts;
                var geometryInfoList = this._geometryInfo;
                var perObjectFrustumCulled = this.perObjectFrustumCulled;
                var indirectTexture = this._indirectTexture;
                var indirectArray = indirectTexture.image.data;
                // prepare the frustum in the local frame
                if (perObjectFrustumCulled) {
                    $1a55656020b89c3a$var$_matrix$1.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse).multiply(this.matrixWorld);
                    $1a55656020b89c3a$var$_frustum.setFromProjectionMatrix($1a55656020b89c3a$var$_matrix$1, renderer.coordinateSystem);
                }
                var multiDrawCount = 0;
                if (this.sortObjects) {
                    // get the camera position in the local frame
                    $1a55656020b89c3a$var$_matrix$1.copy(this.matrixWorld).invert();
                    $1a55656020b89c3a$var$_vector$5.setFromMatrixPosition(camera.matrixWorld).applyMatrix4($1a55656020b89c3a$var$_matrix$1);
                    $1a55656020b89c3a$var$_forward.set(0, 0, -1).transformDirection(camera.matrixWorld).transformDirection($1a55656020b89c3a$var$_matrix$1);
                    for(var i = 0, l = instanceInfo.length; i < l; i++)if (instanceInfo[i].visible && instanceInfo[i].active) {
                        var geometryId = instanceInfo[i].geometryIndex;
                        // get the bounds in world space
                        this.getMatrixAt(i, $1a55656020b89c3a$var$_matrix$1);
                        this.getBoundingSphereAt(geometryId, $1a55656020b89c3a$var$_sphere$2).applyMatrix4($1a55656020b89c3a$var$_matrix$1);
                        // determine whether the batched geometry is within the frustum
                        var culled = false;
                        if (perObjectFrustumCulled) culled = !$1a55656020b89c3a$var$_frustum.intersectsSphere($1a55656020b89c3a$var$_sphere$2);
                        if (!culled) {
                            // get the distance from camera used for sorting
                            var geometryInfo = geometryInfoList[geometryId];
                            var z = $1a55656020b89c3a$var$_temp.subVectors($1a55656020b89c3a$var$_sphere$2.center, $1a55656020b89c3a$var$_vector$5).dot($1a55656020b89c3a$var$_forward);
                            $1a55656020b89c3a$var$_renderList.push(geometryInfo.start, geometryInfo.count, z, i);
                        }
                    }
                    // Sort the draw ranges and prep for rendering
                    var list = $1a55656020b89c3a$var$_renderList.list;
                    var customSort = this.customSort;
                    if (customSort === null) list.sort(material.transparent ? $1a55656020b89c3a$var$sortTransparent : $1a55656020b89c3a$var$sortOpaque);
                    else customSort.call(this, list, camera);
                    for(var i1 = 0, l1 = list.length; i1 < l1; i1++){
                        var item = list[i1];
                        multiDrawStarts[multiDrawCount] = item.start * bytesPerElement;
                        multiDrawCounts[multiDrawCount] = item.count;
                        indirectArray[multiDrawCount] = item.index;
                        multiDrawCount++;
                    }
                    $1a55656020b89c3a$var$_renderList.reset();
                } else {
                    for(var i2 = 0, l2 = instanceInfo.length; i2 < l2; i2++)if (instanceInfo[i2].visible && instanceInfo[i2].active) {
                        var geometryId1 = instanceInfo[i2].geometryIndex;
                        // determine whether the batched geometry is within the frustum
                        var culled1 = false;
                        if (perObjectFrustumCulled) {
                            // get the bounds in world space
                            this.getMatrixAt(i2, $1a55656020b89c3a$var$_matrix$1);
                            this.getBoundingSphereAt(geometryId1, $1a55656020b89c3a$var$_sphere$2).applyMatrix4($1a55656020b89c3a$var$_matrix$1);
                            culled1 = !$1a55656020b89c3a$var$_frustum.intersectsSphere($1a55656020b89c3a$var$_sphere$2);
                        }
                        if (!culled1) {
                            var geometryInfo1 = geometryInfoList[geometryId1];
                            multiDrawStarts[multiDrawCount] = geometryInfo1.start * bytesPerElement;
                            multiDrawCounts[multiDrawCount] = geometryInfo1.count;
                            indirectArray[multiDrawCount] = i2;
                            multiDrawCount++;
                        }
                    }
                }
                indirectTexture.needsUpdate = true;
                this._multiDrawCount = multiDrawCount;
                this._visibilityChanged = false;
            }
        },
        {
            key: "onBeforeShadow",
            value: function onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial /* , group */ ) {
                this.onBeforeRender(renderer, null, shadowCamera, geometry, depthMaterial);
            }
        }
    ]);
    return BatchedMesh;
}($1a55656020b89c3a$export$e176487c05830cc5);
var $1a55656020b89c3a$export$fbaaa33907730a0c = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(LineBasicMaterial, Material);
    function LineBasicMaterial(parameters) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, LineBasicMaterial);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, LineBasicMaterial);
        _this.isLineBasicMaterial = true;
        _this.type = 'LineBasicMaterial';
        _this.color = new $1a55656020b89c3a$export$892596cec99bc70e(0xffffff);
        _this.map = null;
        _this.linewidth = 1;
        _this.linecap = 'round';
        _this.linejoin = 'round';
        _this.fog = true;
        _this.setValues(parameters);
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(LineBasicMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(LineBasicMaterial.prototype), "copy", this).call(this, source);
                this.color.copy(source.color);
                this.map = source.map;
                this.linewidth = source.linewidth;
                this.linecap = source.linecap;
                this.linejoin = source.linejoin;
                this.fog = source.fog;
                return this;
            }
        }
    ]);
    return LineBasicMaterial;
}($1a55656020b89c3a$export$a2d8b23205c25948);
var $1a55656020b89c3a$var$_vStart = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_vEnd = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_inverseMatrix$1 = /*@__PURE__*/ new $1a55656020b89c3a$export$2ae72fc923e5eb5();
var $1a55656020b89c3a$var$_ray$1 = /*@__PURE__*/ new $1a55656020b89c3a$export$a186db52eed6d40e();
var $1a55656020b89c3a$var$_sphere$1 = /*@__PURE__*/ new $1a55656020b89c3a$export$805e8b72413ccaba();
var $1a55656020b89c3a$var$_intersectPointOnRay = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_intersectPointOnSegment = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$export$17d680238e50603e = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(Line, Object3D);
    function Line() {
        var geometry = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $1a55656020b89c3a$export$b7be63a67df8959(), material = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $1a55656020b89c3a$export$fbaaa33907730a0c();
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Line);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, Line);
        _this.isLine = true;
        _this.type = 'Line';
        _this.geometry = geometry;
        _this.material = material;
        _this.updateMorphTargets();
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Line, [
        {
            key: "copy",
            value: function copy(source, recursive) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(Line.prototype), "copy", this).call(this, source, recursive);
                this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
                this.geometry = source.geometry;
                return this;
            }
        },
        {
            key: "computeLineDistances",
            value: function computeLineDistances() {
                var geometry = this.geometry;
                // we assume non-indexed geometry
                if (geometry.index === null) {
                    var positionAttribute = geometry.attributes.position;
                    var lineDistances = [
                        0
                    ];
                    for(var i = 1, l = positionAttribute.count; i < l; i++){
                        $1a55656020b89c3a$var$_vStart.fromBufferAttribute(positionAttribute, i - 1);
                        $1a55656020b89c3a$var$_vEnd.fromBufferAttribute(positionAttribute, i);
                        lineDistances[i] = lineDistances[i - 1];
                        lineDistances[i] += $1a55656020b89c3a$var$_vStart.distanceTo($1a55656020b89c3a$var$_vEnd);
                    }
                    geometry.setAttribute('lineDistance', new $1a55656020b89c3a$export$cbe7a62641830ebd(lineDistances, 1));
                } else console.warn('THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
                return this;
            }
        },
        {
            key: "raycast",
            value: function raycast(raycaster, intersects) {
                var geometry = this.geometry;
                var matrixWorld = this.matrixWorld;
                var threshold = raycaster.params.Line.threshold;
                var drawRange = geometry.drawRange;
                // Checking boundingSphere distance to ray
                if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                $1a55656020b89c3a$var$_sphere$1.copy(geometry.boundingSphere);
                $1a55656020b89c3a$var$_sphere$1.applyMatrix4(matrixWorld);
                $1a55656020b89c3a$var$_sphere$1.radius += threshold;
                if (raycaster.ray.intersectsSphere($1a55656020b89c3a$var$_sphere$1) === false) return;
                //
                $1a55656020b89c3a$var$_inverseMatrix$1.copy(matrixWorld).invert();
                $1a55656020b89c3a$var$_ray$1.copy(raycaster.ray).applyMatrix4($1a55656020b89c3a$var$_inverseMatrix$1);
                var localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
                var localThresholdSq = localThreshold * localThreshold;
                var step = this.isLineSegments ? 2 : 1;
                var index = geometry.index;
                var attributes = geometry.attributes;
                var positionAttribute = attributes.position;
                if (index !== null) {
                    var start = Math.max(0, drawRange.start);
                    var end = Math.min(index.count, drawRange.start + drawRange.count);
                    for(var i = start, l = end - 1; i < l; i += step){
                        var a = index.getX(i);
                        var b = index.getX(i + 1);
                        var intersect = $1a55656020b89c3a$var$checkIntersection(this, raycaster, $1a55656020b89c3a$var$_ray$1, localThresholdSq, a, b, i);
                        if (intersect) intersects.push(intersect);
                    }
                    if (this.isLineLoop) {
                        var a1 = index.getX(end - 1);
                        var b1 = index.getX(start);
                        var intersect1 = $1a55656020b89c3a$var$checkIntersection(this, raycaster, $1a55656020b89c3a$var$_ray$1, localThresholdSq, a1, b1, end - 1);
                        if (intersect1) intersects.push(intersect1);
                    }
                } else {
                    var start1 = Math.max(0, drawRange.start);
                    var end1 = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
                    for(var i1 = start1, l1 = end1 - 1; i1 < l1; i1 += step){
                        var intersect2 = $1a55656020b89c3a$var$checkIntersection(this, raycaster, $1a55656020b89c3a$var$_ray$1, localThresholdSq, i1, i1 + 1, i1);
                        if (intersect2) intersects.push(intersect2);
                    }
                    if (this.isLineLoop) {
                        var intersect3 = $1a55656020b89c3a$var$checkIntersection(this, raycaster, $1a55656020b89c3a$var$_ray$1, localThresholdSq, end1 - 1, start1, end1 - 1);
                        if (intersect3) intersects.push(intersect3);
                    }
                }
            }
        },
        {
            key: "updateMorphTargets",
            value: function updateMorphTargets() {
                var geometry = this.geometry;
                var morphAttributes = geometry.morphAttributes;
                var keys = Object.keys(morphAttributes);
                if (keys.length > 0) {
                    var morphAttribute = morphAttributes[keys[0]];
                    if (morphAttribute !== undefined) {
                        this.morphTargetInfluences = [];
                        this.morphTargetDictionary = {};
                        for(var m = 0, ml = morphAttribute.length; m < ml; m++){
                            var name = morphAttribute[m].name || String(m);
                            this.morphTargetInfluences.push(0);
                            this.morphTargetDictionary[name] = m;
                        }
                    }
                }
            }
        }
    ]);
    return Line;
}($1a55656020b89c3a$export$e4dd07dff30cc924);
function $1a55656020b89c3a$var$checkIntersection(object, raycaster, ray, thresholdSq, a, b, i) {
    var positionAttribute = object.geometry.attributes.position;
    $1a55656020b89c3a$var$_vStart.fromBufferAttribute(positionAttribute, a);
    $1a55656020b89c3a$var$_vEnd.fromBufferAttribute(positionAttribute, b);
    var distSq = ray.distanceSqToSegment($1a55656020b89c3a$var$_vStart, $1a55656020b89c3a$var$_vEnd, $1a55656020b89c3a$var$_intersectPointOnRay, $1a55656020b89c3a$var$_intersectPointOnSegment);
    if (distSq > thresholdSq) return;
    $1a55656020b89c3a$var$_intersectPointOnRay.applyMatrix4(object.matrixWorld); // Move back to world space for distance calculation
    var distance = raycaster.ray.origin.distanceTo($1a55656020b89c3a$var$_intersectPointOnRay);
    if (distance < raycaster.near || distance > raycaster.far) return;
    return {
        distance: distance,
        // What do we want? intersection point on the ray or on the segment??
        // point: raycaster.ray.at( distance ),
        point: $1a55656020b89c3a$var$_intersectPointOnSegment.clone().applyMatrix4(object.matrixWorld),
        index: i,
        face: null,
        faceIndex: null,
        barycoord: null,
        object: object
    };
}
var $1a55656020b89c3a$var$_start = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_end = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$export$ff1ed10fedfdd604 = /*#__PURE__*/ function(Line) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(LineSegments, Line);
    function LineSegments(geometry, material) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, LineSegments);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, LineSegments, [
            geometry,
            material
        ]);
        _this.isLineSegments = true;
        _this.type = 'LineSegments';
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(LineSegments, [
        {
            key: "computeLineDistances",
            value: function computeLineDistances() {
                var geometry = this.geometry;
                // we assume non-indexed geometry
                if (geometry.index === null) {
                    var positionAttribute = geometry.attributes.position;
                    var lineDistances = [];
                    for(var i = 0, l = positionAttribute.count; i < l; i += 2){
                        $1a55656020b89c3a$var$_start.fromBufferAttribute(positionAttribute, i);
                        $1a55656020b89c3a$var$_end.fromBufferAttribute(positionAttribute, i + 1);
                        lineDistances[i] = i === 0 ? 0 : lineDistances[i - 1];
                        lineDistances[i + 1] = lineDistances[i] + $1a55656020b89c3a$var$_start.distanceTo($1a55656020b89c3a$var$_end);
                    }
                    geometry.setAttribute('lineDistance', new $1a55656020b89c3a$export$cbe7a62641830ebd(lineDistances, 1));
                } else console.warn('THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
                return this;
            }
        }
    ]);
    return LineSegments;
}($1a55656020b89c3a$export$17d680238e50603e);
var $1a55656020b89c3a$export$f85a24d745e4f17d = /*#__PURE__*/ function(Line) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(LineLoop, Line);
    function LineLoop(geometry, material) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, LineLoop);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, LineLoop, [
            geometry,
            material
        ]);
        _this.isLineLoop = true;
        _this.type = 'LineLoop';
        return _this;
    }
    return LineLoop;
}($1a55656020b89c3a$export$17d680238e50603e);
var $1a55656020b89c3a$export$a178c45366ce5d6b = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(PointsMaterial, Material);
    function PointsMaterial(parameters) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, PointsMaterial);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, PointsMaterial);
        _this.isPointsMaterial = true;
        _this.type = 'PointsMaterial';
        _this.color = new $1a55656020b89c3a$export$892596cec99bc70e(0xffffff);
        _this.map = null;
        _this.alphaMap = null;
        _this.size = 1;
        _this.sizeAttenuation = true;
        _this.fog = true;
        _this.setValues(parameters);
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(PointsMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(PointsMaterial.prototype), "copy", this).call(this, source);
                this.color.copy(source.color);
                this.map = source.map;
                this.alphaMap = source.alphaMap;
                this.size = source.size;
                this.sizeAttenuation = source.sizeAttenuation;
                this.fog = source.fog;
                return this;
            }
        }
    ]);
    return PointsMaterial;
}($1a55656020b89c3a$export$a2d8b23205c25948);
var $1a55656020b89c3a$var$_inverseMatrix = /*@__PURE__*/ new $1a55656020b89c3a$export$2ae72fc923e5eb5();
var $1a55656020b89c3a$var$_ray = /*@__PURE__*/ new $1a55656020b89c3a$export$a186db52eed6d40e();
var $1a55656020b89c3a$var$_sphere = /*@__PURE__*/ new $1a55656020b89c3a$export$805e8b72413ccaba();
var $1a55656020b89c3a$var$_position$2 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$export$1c787534cb11aa3e = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(Points, Object3D);
    function Points() {
        var geometry = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $1a55656020b89c3a$export$b7be63a67df8959(), material = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $1a55656020b89c3a$export$a178c45366ce5d6b();
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Points);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, Points);
        _this.isPoints = true;
        _this.type = 'Points';
        _this.geometry = geometry;
        _this.material = material;
        _this.updateMorphTargets();
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Points, [
        {
            key: "copy",
            value: function copy(source, recursive) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(Points.prototype), "copy", this).call(this, source, recursive);
                this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
                this.geometry = source.geometry;
                return this;
            }
        },
        {
            key: "raycast",
            value: function raycast(raycaster, intersects) {
                var geometry = this.geometry;
                var matrixWorld = this.matrixWorld;
                var threshold = raycaster.params.Points.threshold;
                var drawRange = geometry.drawRange;
                // Checking boundingSphere distance to ray
                if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                $1a55656020b89c3a$var$_sphere.copy(geometry.boundingSphere);
                $1a55656020b89c3a$var$_sphere.applyMatrix4(matrixWorld);
                $1a55656020b89c3a$var$_sphere.radius += threshold;
                if (raycaster.ray.intersectsSphere($1a55656020b89c3a$var$_sphere) === false) return;
                //
                $1a55656020b89c3a$var$_inverseMatrix.copy(matrixWorld).invert();
                $1a55656020b89c3a$var$_ray.copy(raycaster.ray).applyMatrix4($1a55656020b89c3a$var$_inverseMatrix);
                var localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
                var localThresholdSq = localThreshold * localThreshold;
                var index = geometry.index;
                var attributes = geometry.attributes;
                var positionAttribute = attributes.position;
                if (index !== null) {
                    var start = Math.max(0, drawRange.start);
                    var end = Math.min(index.count, drawRange.start + drawRange.count);
                    for(var i = start, il = end; i < il; i++){
                        var a = index.getX(i);
                        $1a55656020b89c3a$var$_position$2.fromBufferAttribute(positionAttribute, a);
                        $1a55656020b89c3a$var$testPoint($1a55656020b89c3a$var$_position$2, a, localThresholdSq, matrixWorld, raycaster, intersects, this);
                    }
                } else {
                    var start1 = Math.max(0, drawRange.start);
                    var end1 = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
                    for(var i1 = start1, l = end1; i1 < l; i1++){
                        $1a55656020b89c3a$var$_position$2.fromBufferAttribute(positionAttribute, i1);
                        $1a55656020b89c3a$var$testPoint($1a55656020b89c3a$var$_position$2, i1, localThresholdSq, matrixWorld, raycaster, intersects, this);
                    }
                }
            }
        },
        {
            key: "updateMorphTargets",
            value: function updateMorphTargets() {
                var geometry = this.geometry;
                var morphAttributes = geometry.morphAttributes;
                var keys = Object.keys(morphAttributes);
                if (keys.length > 0) {
                    var morphAttribute = morphAttributes[keys[0]];
                    if (morphAttribute !== undefined) {
                        this.morphTargetInfluences = [];
                        this.morphTargetDictionary = {};
                        for(var m = 0, ml = morphAttribute.length; m < ml; m++){
                            var name = morphAttribute[m].name || String(m);
                            this.morphTargetInfluences.push(0);
                            this.morphTargetDictionary[name] = m;
                        }
                    }
                }
            }
        }
    ]);
    return Points;
}($1a55656020b89c3a$export$e4dd07dff30cc924);
function $1a55656020b89c3a$var$testPoint(point, index, localThresholdSq, matrixWorld, raycaster, intersects, object) {
    var rayPointDistanceSq = $1a55656020b89c3a$var$_ray.distanceSqToPoint(point);
    if (rayPointDistanceSq < localThresholdSq) {
        var intersectPoint = new $1a55656020b89c3a$export$64b5c384219d3699();
        $1a55656020b89c3a$var$_ray.closestPointToPoint(point, intersectPoint);
        intersectPoint.applyMatrix4(matrixWorld);
        var distance = raycaster.ray.origin.distanceTo(intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            distanceToRay: Math.sqrt(rayPointDistanceSq),
            point: intersectPoint,
            index: index,
            face: null,
            faceIndex: null,
            barycoord: null,
            object: object
        });
    }
}
var $1a55656020b89c3a$export$6e09d1edf8d5a25c = /*#__PURE__*/ function(Texture) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(VideoTexture, Texture);
    function VideoTexture(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, VideoTexture);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, VideoTexture, [
            video,
            mapping,
            wrapS,
            wrapT,
            magFilter,
            minFilter,
            format,
            type,
            anisotropy
        ]);
        _this.isVideoTexture = true;
        _this.minFilter = minFilter !== undefined ? minFilter : $1a55656020b89c3a$export$8a72f490b25c56c8;
        _this.magFilter = magFilter !== undefined ? magFilter : $1a55656020b89c3a$export$8a72f490b25c56c8;
        _this.generateMipmaps = false;
        var scope = _this;
        function updateVideo() {
            scope.needsUpdate = true;
            video.requestVideoFrameCallback(updateVideo);
        }
        if ('requestVideoFrameCallback' in video) video.requestVideoFrameCallback(updateVideo);
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(VideoTexture, [
        {
            key: "clone",
            value: function clone() {
                return new this.constructor(this.image).copy(this);
            }
        },
        {
            key: "update",
            value: function update() {
                var video = this.image;
                var hasVideoFrameCallback = 'requestVideoFrameCallback' in video;
                if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) this.needsUpdate = true;
            }
        }
    ]);
    return VideoTexture;
}($1a55656020b89c3a$export$5431306cf43de24a);
var $1a55656020b89c3a$export$68498d200b825382 = /*#__PURE__*/ function(VideoTexture) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(VideoFrameTexture, VideoTexture);
    function VideoFrameTexture(mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, VideoFrameTexture);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, VideoFrameTexture, [
            {},
            mapping,
            wrapS,
            wrapT,
            magFilter,
            minFilter,
            format,
            type,
            anisotropy
        ]);
        _this.isVideoFrameTexture = true;
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(VideoFrameTexture, [
        {
            key: "update",
            value: function update() {
            // overwrites `VideoTexture.update()` with an empty method since
            // this type of texture is updated via `setFrame()`.
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().copy(this); // restoring Texture.clone()
            }
        },
        {
            key: "setFrame",
            value: function setFrame(frame) {
                this.image = frame;
                this.needsUpdate = true;
            }
        }
    ]);
    return VideoFrameTexture;
}($1a55656020b89c3a$export$6e09d1edf8d5a25c);
var $1a55656020b89c3a$export$9270d786f73ce6fe = /*#__PURE__*/ function(Texture) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(FramebufferTexture, Texture);
    function FramebufferTexture(width, height) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, FramebufferTexture);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, FramebufferTexture, [
            {
                width: width,
                height: height
            }
        ]);
        _this.isFramebufferTexture = true;
        _this.magFilter = $1a55656020b89c3a$export$727aa5ec3fe39bf0;
        _this.minFilter = $1a55656020b89c3a$export$727aa5ec3fe39bf0;
        _this.generateMipmaps = false;
        _this.needsUpdate = true;
        return _this;
    }
    return FramebufferTexture;
}($1a55656020b89c3a$export$5431306cf43de24a);
var $1a55656020b89c3a$export$3466bac9141a5cc4 = /*#__PURE__*/ function(Texture) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(CompressedTexture, Texture);
    function CompressedTexture(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, colorSpace) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, CompressedTexture);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, CompressedTexture, [
            null,
            mapping,
            wrapS,
            wrapT,
            magFilter,
            minFilter,
            format,
            type,
            anisotropy,
            colorSpace
        ]);
        _this.isCompressedTexture = true;
        _this.image = {
            width: width,
            height: height
        };
        _this.mipmaps = mipmaps;
        // no flipping for cube textures
        // (also flipping doesn't work for compressed textures )
        _this.flipY = false;
        // can't generate mipmaps for compressed textures
        // mips must be embedded in DDS files
        _this.generateMipmaps = false;
        return _this;
    }
    return CompressedTexture;
}($1a55656020b89c3a$export$5431306cf43de24a);
var $1a55656020b89c3a$export$5fe6b8e34b274fcb = /*#__PURE__*/ function(CompressedTexture) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(CompressedArrayTexture, CompressedTexture);
    function CompressedArrayTexture(mipmaps, width, height, depth, format, type) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, CompressedArrayTexture);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, CompressedArrayTexture, [
            mipmaps,
            width,
            height,
            format,
            type
        ]);
        _this.isCompressedArrayTexture = true;
        _this.image.depth = depth;
        _this.wrapR = $1a55656020b89c3a$export$9d9334239a5a5e06;
        _this.layerUpdates = new Set();
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(CompressedArrayTexture, [
        {
            key: "addLayerUpdate",
            value: function addLayerUpdate(layerIndex) {
                this.layerUpdates.add(layerIndex);
            }
        },
        {
            key: "clearLayerUpdates",
            value: function clearLayerUpdates() {
                this.layerUpdates.clear();
            }
        }
    ]);
    return CompressedArrayTexture;
}($1a55656020b89c3a$export$3466bac9141a5cc4);
var $1a55656020b89c3a$export$d80173634de65bff = /*#__PURE__*/ function(CompressedTexture) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(CompressedCubeTexture, CompressedTexture);
    function CompressedCubeTexture(images, format, type) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, CompressedCubeTexture);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, CompressedCubeTexture, [
            undefined,
            images[0].width,
            images[0].height,
            format,
            type,
            $1a55656020b89c3a$export$8759762a6477f2c4
        ]);
        _this.isCompressedCubeTexture = true;
        _this.isCubeTexture = true;
        _this.image = images;
        return _this;
    }
    return CompressedCubeTexture;
}($1a55656020b89c3a$export$3466bac9141a5cc4);
var $1a55656020b89c3a$export$f7189e49152d1c13 = /*#__PURE__*/ function(Texture) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(CanvasTexture, Texture);
    function CanvasTexture(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, CanvasTexture);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, CanvasTexture, [
            canvas,
            mapping,
            wrapS,
            wrapT,
            magFilter,
            minFilter,
            format,
            type,
            anisotropy
        ]);
        _this.isCanvasTexture = true;
        _this.needsUpdate = true;
        return _this;
    }
    return CanvasTexture;
}($1a55656020b89c3a$export$5431306cf43de24a);
var $1a55656020b89c3a$export$fc830aa069cc8c2f = /*#__PURE__*/ function(Texture) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(DepthTexture, Texture);
    function DepthTexture(width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy) {
        var format = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : $1a55656020b89c3a$export$c1b6b5136be58045;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, DepthTexture);
        var _this;
        if (format !== $1a55656020b89c3a$export$c1b6b5136be58045 && format !== $1a55656020b89c3a$export$1e113ac2d0905829) throw new Error('DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat');
        if (type === undefined && format === $1a55656020b89c3a$export$c1b6b5136be58045) type = $1a55656020b89c3a$export$c3c7fc4518ebba96;
        if (type === undefined && format === $1a55656020b89c3a$export$1e113ac2d0905829) type = $1a55656020b89c3a$export$6c8ea339bfab1301;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, DepthTexture, [
            null,
            mapping,
            wrapS,
            wrapT,
            magFilter,
            minFilter,
            format,
            type,
            anisotropy
        ]);
        _this.isDepthTexture = true;
        _this.image = {
            width: width,
            height: height
        };
        _this.magFilter = magFilter !== undefined ? magFilter : $1a55656020b89c3a$export$727aa5ec3fe39bf0;
        _this.minFilter = minFilter !== undefined ? minFilter : $1a55656020b89c3a$export$727aa5ec3fe39bf0;
        _this.flipY = false;
        _this.generateMipmaps = false;
        _this.compareFunction = null;
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(DepthTexture, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(DepthTexture.prototype), "copy", this).call(this, source);
                this.compareFunction = source.compareFunction;
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON(meta) {
                var data = (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(DepthTexture.prototype), "toJSON", this).call(this, meta);
                if (this.compareFunction !== null) data.compareFunction = this.compareFunction;
                return data;
            }
        }
    ]);
    return DepthTexture;
}($1a55656020b89c3a$export$5431306cf43de24a);
/**
 * Extensible curve object.
 *
 * Some common of curve methods:
 * .getPoint( t, optionalTarget ), .getTangent( t, optionalTarget )
 * .getPointAt( u, optionalTarget ), .getTangentAt( u, optionalTarget )
 * .getPoints(), .getSpacedPoints()
 * .getLength()
 * .updateArcLengths()
 *
 * This following curves inherit from THREE.Curve:
 *
 * -- 2D curves --
 * THREE.ArcCurve
 * THREE.CubicBezierCurve
 * THREE.EllipseCurve
 * THREE.LineCurve
 * THREE.QuadraticBezierCurve
 * THREE.SplineCurve
 *
 * -- 3D curves --
 * THREE.CatmullRomCurve3
 * THREE.CubicBezierCurve3
 * THREE.LineCurve3
 * THREE.QuadraticBezierCurve3
 *
 * A series of curves can be represented as a THREE.CurvePath.
 *
 **/ var $1a55656020b89c3a$export$b0e83c3ef8d2db1 = /*#__PURE__*/ function() {
    "use strict";
    function Curve() {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Curve);
        this.type = 'Curve';
        this.arcLengthDivisions = 200;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Curve, [
        {
            // Virtual base class method to overwrite and implement in subclasses
            //	- t [0 .. 1]
            key: "getPoint",
            value: function getPoint() {
                console.warn('THREE.Curve: .getPoint() not implemented.');
                return null;
            }
        },
        {
            // Get point at relative position in curve according to arc length
            // - u [0 .. 1]
            key: "getPointAt",
            value: function getPointAt(u, optionalTarget) {
                var t = this.getUtoTmapping(u);
                return this.getPoint(t, optionalTarget);
            }
        },
        {
            // Get sequence of points using getPoint( t )
            key: "getPoints",
            value: function getPoints() {
                var divisions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 5;
                var points = [];
                for(var d = 0; d <= divisions; d++)points.push(this.getPoint(d / divisions));
                return points;
            }
        },
        {
            // Get sequence of points using getPointAt( u )
            key: "getSpacedPoints",
            value: function getSpacedPoints() {
                var divisions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 5;
                var points = [];
                for(var d = 0; d <= divisions; d++)points.push(this.getPointAt(d / divisions));
                return points;
            }
        },
        {
            // Get total curve arc length
            key: "getLength",
            value: function getLength() {
                var lengths = this.getLengths();
                return lengths[lengths.length - 1];
            }
        },
        {
            // Get list of cumulative segment lengths
            key: "getLengths",
            value: function getLengths() {
                var divisions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.arcLengthDivisions;
                if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) return this.cacheArcLengths;
                this.needsUpdate = false;
                var cache = [];
                var current, last = this.getPoint(0);
                var sum = 0;
                cache.push(0);
                for(var p = 1; p <= divisions; p++){
                    current = this.getPoint(p / divisions);
                    sum += current.distanceTo(last);
                    cache.push(sum);
                    last = current;
                }
                this.cacheArcLengths = cache;
                return cache; // { sums: cache, sum: sum }; Sum is in the last element.
            }
        },
        {
            key: "updateArcLengths",
            value: function updateArcLengths() {
                this.needsUpdate = true;
                this.getLengths();
            }
        },
        {
            // Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant
            key: "getUtoTmapping",
            value: function getUtoTmapping(u, distance) {
                var arcLengths = this.getLengths();
                var i = 0;
                var il = arcLengths.length;
                var targetArcLength; // The targeted u distance value to get
                if (distance) targetArcLength = distance;
                else targetArcLength = u * arcLengths[il - 1];
                // binary search for the index with largest value smaller than target u distance
                var low = 0, high = il - 1, comparison;
                while(low <= high){
                    i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
                    comparison = arcLengths[i] - targetArcLength;
                    if (comparison < 0) low = i + 1;
                    else if (comparison > 0) high = i - 1;
                    else {
                        high = i;
                        break;
                    // DONE
                    }
                }
                i = high;
                if (arcLengths[i] === targetArcLength) return i / (il - 1);
                // we could get finer grain at lengths, or use simple interpolation between two points
                var lengthBefore = arcLengths[i];
                var lengthAfter = arcLengths[i + 1];
                var segmentLength = lengthAfter - lengthBefore;
                // determine where we are between the 'before' and 'after' points
                var segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
                // add that fractional amount to t
                var t = (i + segmentFraction) / (il - 1);
                return t;
            }
        },
        {
            // Returns a unit vector tangent at t
            // In case any sub curve does not implement its tangent derivation,
            // 2 points a small delta apart will be used to find its gradient
            // which seems to give a reasonable approximation
            key: "getTangent",
            value: function getTangent(t, optionalTarget) {
                var delta = 0.0001;
                var t1 = t - delta;
                var t2 = t + delta;
                // Capping in case of danger
                if (t1 < 0) t1 = 0;
                if (t2 > 1) t2 = 1;
                var pt1 = this.getPoint(t1);
                var pt2 = this.getPoint(t2);
                var tangent = optionalTarget || (pt1.isVector2 ? new $1a55656020b89c3a$export$c977b3e384af9ae1() : new $1a55656020b89c3a$export$64b5c384219d3699());
                tangent.copy(pt2).sub(pt1).normalize();
                return tangent;
            }
        },
        {
            key: "getTangentAt",
            value: function getTangentAt(u, optionalTarget) {
                var t = this.getUtoTmapping(u);
                return this.getTangent(t, optionalTarget);
            }
        },
        {
            key: "computeFrenetFrames",
            value: function computeFrenetFrames(segments, closed) {
                // see http://www.cs.indiana.edu/pub/techreports/TR425.pdf
                var normal = new $1a55656020b89c3a$export$64b5c384219d3699();
                var tangents = [];
                var normals = [];
                var binormals = [];
                var vec = new $1a55656020b89c3a$export$64b5c384219d3699();
                var mat = new $1a55656020b89c3a$export$2ae72fc923e5eb5();
                // compute the tangent vectors for each segment on the curve
                for(var i = 0; i <= segments; i++){
                    var u = i / segments;
                    tangents[i] = this.getTangentAt(u, new $1a55656020b89c3a$export$64b5c384219d3699());
                }
                // select an initial normal vector perpendicular to the first tangent vector,
                // and in the direction of the minimum tangent xyz component
                normals[0] = new $1a55656020b89c3a$export$64b5c384219d3699();
                binormals[0] = new $1a55656020b89c3a$export$64b5c384219d3699();
                var min = Number.MAX_VALUE;
                var tx = Math.abs(tangents[0].x);
                var ty = Math.abs(tangents[0].y);
                var tz = Math.abs(tangents[0].z);
                if (tx <= min) {
                    min = tx;
                    normal.set(1, 0, 0);
                }
                if (ty <= min) {
                    min = ty;
                    normal.set(0, 1, 0);
                }
                if (tz <= min) normal.set(0, 0, 1);
                vec.crossVectors(tangents[0], normal).normalize();
                normals[0].crossVectors(tangents[0], vec);
                binormals[0].crossVectors(tangents[0], normals[0]);
                // compute the slowly-varying normal and binormal vectors for each segment on the curve
                for(var i1 = 1; i1 <= segments; i1++){
                    normals[i1] = normals[i1 - 1].clone();
                    binormals[i1] = binormals[i1 - 1].clone();
                    vec.crossVectors(tangents[i1 - 1], tangents[i1]);
                    if (vec.length() > Number.EPSILON) {
                        vec.normalize();
                        var theta = Math.acos($1a55656020b89c3a$var$clamp(tangents[i1 - 1].dot(tangents[i1]), -1, 1)); // clamp for floating pt errors
                        normals[i1].applyMatrix4(mat.makeRotationAxis(vec, theta));
                    }
                    binormals[i1].crossVectors(tangents[i1], normals[i1]);
                }
                // if the curve is closed, postprocess the vectors so the first and last normal vectors are the same
                if (closed === true) {
                    var theta1 = Math.acos($1a55656020b89c3a$var$clamp(normals[0].dot(normals[segments]), -1, 1));
                    theta1 /= segments;
                    if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) theta1 = -theta1;
                    for(var i2 = 1; i2 <= segments; i2++){
                        // twist a little...
                        normals[i2].applyMatrix4(mat.makeRotationAxis(tangents[i2], theta1 * i2));
                        binormals[i2].crossVectors(tangents[i2], normals[i2]);
                    }
                }
                return {
                    tangents: tangents,
                    normals: normals,
                    binormals: binormals
                };
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                this.arcLengthDivisions = source.arcLengthDivisions;
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = {
                    metadata: {
                        version: 4.6,
                        type: 'Curve',
                        generator: 'Curve.toJSON'
                    }
                };
                data.arcLengthDivisions = this.arcLengthDivisions;
                data.type = this.type;
                return data;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json) {
                this.arcLengthDivisions = json.arcLengthDivisions;
                return this;
            }
        }
    ]);
    return Curve;
}();
var $1a55656020b89c3a$export$3f87a931616cde04 = /*#__PURE__*/ function(Curve) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(EllipseCurve, Curve);
    function EllipseCurve() {
        var aX = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, aY = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, xRadius = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, yRadius = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1, aStartAngle = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0, aEndAngle = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : Math.PI * 2, aClockwise = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false, aRotation = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : 0;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, EllipseCurve);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, EllipseCurve);
        _this.isEllipseCurve = true;
        _this.type = 'EllipseCurve';
        _this.aX = aX;
        _this.aY = aY;
        _this.xRadius = xRadius;
        _this.yRadius = yRadius;
        _this.aStartAngle = aStartAngle;
        _this.aEndAngle = aEndAngle;
        _this.aClockwise = aClockwise;
        _this.aRotation = aRotation;
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(EllipseCurve, [
        {
            key: "getPoint",
            value: function getPoint(t) {
                var optionalTarget = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $1a55656020b89c3a$export$c977b3e384af9ae1();
                var point = optionalTarget;
                var twoPi = Math.PI * 2;
                var deltaAngle = this.aEndAngle - this.aStartAngle;
                var samePoints = Math.abs(deltaAngle) < Number.EPSILON;
                // ensures that deltaAngle is 0 .. 2 PI
                while(deltaAngle < 0)deltaAngle += twoPi;
                while(deltaAngle > twoPi)deltaAngle -= twoPi;
                if (deltaAngle < Number.EPSILON) {
                    if (samePoints) deltaAngle = 0;
                    else deltaAngle = twoPi;
                }
                if (this.aClockwise === true && !samePoints) {
                    if (deltaAngle === twoPi) deltaAngle = -twoPi;
                    else deltaAngle = deltaAngle - twoPi;
                }
                var angle = this.aStartAngle + t * deltaAngle;
                var x = this.aX + this.xRadius * Math.cos(angle);
                var y = this.aY + this.yRadius * Math.sin(angle);
                if (this.aRotation !== 0) {
                    var cos = Math.cos(this.aRotation);
                    var sin = Math.sin(this.aRotation);
                    var tx = x - this.aX;
                    var ty = y - this.aY;
                    // Rotate the point about the center of the ellipse.
                    x = tx * cos - ty * sin + this.aX;
                    y = tx * sin + ty * cos + this.aY;
                }
                return point.set(x, y);
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(EllipseCurve.prototype), "copy", this).call(this, source);
                this.aX = source.aX;
                this.aY = source.aY;
                this.xRadius = source.xRadius;
                this.yRadius = source.yRadius;
                this.aStartAngle = source.aStartAngle;
                this.aEndAngle = source.aEndAngle;
                this.aClockwise = source.aClockwise;
                this.aRotation = source.aRotation;
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(EllipseCurve.prototype), "toJSON", this).call(this);
                data.aX = this.aX;
                data.aY = this.aY;
                data.xRadius = this.xRadius;
                data.yRadius = this.yRadius;
                data.aStartAngle = this.aStartAngle;
                data.aEndAngle = this.aEndAngle;
                data.aClockwise = this.aClockwise;
                data.aRotation = this.aRotation;
                return data;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(EllipseCurve.prototype), "fromJSON", this).call(this, json);
                this.aX = json.aX;
                this.aY = json.aY;
                this.xRadius = json.xRadius;
                this.yRadius = json.yRadius;
                this.aStartAngle = json.aStartAngle;
                this.aEndAngle = json.aEndAngle;
                this.aClockwise = json.aClockwise;
                this.aRotation = json.aRotation;
                return this;
            }
        }
    ]);
    return EllipseCurve;
}($1a55656020b89c3a$export$b0e83c3ef8d2db1);
var $1a55656020b89c3a$export$b1eedc9aab6300e8 = /*#__PURE__*/ function(EllipseCurve) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(ArcCurve, EllipseCurve);
    function ArcCurve(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, ArcCurve);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, ArcCurve, [
            aX,
            aY,
            aRadius,
            aRadius,
            aStartAngle,
            aEndAngle,
            aClockwise
        ]);
        _this.isArcCurve = true;
        _this.type = 'ArcCurve';
        return _this;
    }
    return ArcCurve;
}($1a55656020b89c3a$export$3f87a931616cde04);
/**
 * Centripetal CatmullRom Curve - which is useful for avoiding
 * cusps and self-intersections in non-uniform catmull rom curves.
 * http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
 *
 * curve.type accepts centripetal(default), chordal and catmullrom
 * curve.tension is used for catmullrom which defaults to 0.5
 */ /*
Based on an optimized c++ solution in
 - http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
 - http://ideone.com/NoEbVM

This CubicPoly class could be used for reusing some variables and calculations,
but for three.js curve use, it could be possible inlined and flatten into a single function call
which can be placed in CurveUtils.
*/ function $1a55656020b89c3a$var$CubicPoly() {
    var c0 = 0, c1 = 0, c2 = 0, c3 = 0;
    /*
	 * Compute coefficients for a cubic polynomial
	 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
	 * such that
	 *   p(0) = x0, p(1) = x1
	 *  and
	 *   p'(0) = t0, p'(1) = t1.
	 */ function init(x0, x1, t0, t1) {
        c0 = x0;
        c1 = t0;
        c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
        c3 = 2 * x0 - 2 * x1 + t0 + t1;
    }
    return {
        initCatmullRom: function initCatmullRom(x0, x1, x2, x3, tension) {
            init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
        },
        initNonuniformCatmullRom: function initNonuniformCatmullRom(x0, x1, x2, x3, dt0, dt1, dt2) {
            // compute tangents when parameterized in [t1,t2]
            var t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
            var t2 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2;
            // rescale tangents for parametrization in [0,1]
            t1 *= dt1;
            t2 *= dt1;
            init(x1, x2, t1, t2);
        },
        calc: function calc(t) {
            var t2 = t * t;
            var t3 = t2 * t;
            return c0 + c1 * t + c2 * t2 + c3 * t3;
        }
    };
}
//
var $1a55656020b89c3a$var$tmp = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$px = /*@__PURE__*/ new $1a55656020b89c3a$var$CubicPoly();
var $1a55656020b89c3a$var$py = /*@__PURE__*/ new $1a55656020b89c3a$var$CubicPoly();
var $1a55656020b89c3a$var$pz = /*@__PURE__*/ new $1a55656020b89c3a$var$CubicPoly();
var $1a55656020b89c3a$export$b9146b27c24b744c = /*#__PURE__*/ function(Curve) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(CatmullRomCurve3, Curve);
    function CatmullRomCurve3() {
        var points = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], closed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, curveType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'centripetal', tension = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0.5;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, CatmullRomCurve3);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, CatmullRomCurve3);
        _this.isCatmullRomCurve3 = true;
        _this.type = 'CatmullRomCurve3';
        _this.points = points;
        _this.closed = closed;
        _this.curveType = curveType;
        _this.tension = tension;
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(CatmullRomCurve3, [
        {
            key: "getPoint",
            value: function getPoint(t) {
                var optionalTarget = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $1a55656020b89c3a$export$64b5c384219d3699();
                var point = optionalTarget;
                var points = this.points;
                var l = points.length;
                var p = (l - (this.closed ? 0 : 1)) * t;
                var intPoint = Math.floor(p);
                var weight = p - intPoint;
                if (this.closed) intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l) + 1) * l;
                else if (weight === 0 && intPoint === l - 1) {
                    intPoint = l - 2;
                    weight = 1;
                }
                var p0, p3; // 4 points (p1 & p2 defined below)
                if (this.closed || intPoint > 0) p0 = points[(intPoint - 1) % l];
                else {
                    // extrapolate first point
                    $1a55656020b89c3a$var$tmp.subVectors(points[0], points[1]).add(points[0]);
                    p0 = $1a55656020b89c3a$var$tmp;
                }
                var p1 = points[intPoint % l];
                var p2 = points[(intPoint + 1) % l];
                if (this.closed || intPoint + 2 < l) p3 = points[(intPoint + 2) % l];
                else {
                    // extrapolate last point
                    $1a55656020b89c3a$var$tmp.subVectors(points[l - 1], points[l - 2]).add(points[l - 1]);
                    p3 = $1a55656020b89c3a$var$tmp;
                }
                if (this.curveType === 'centripetal' || this.curveType === 'chordal') {
                    // init Centripetal / Chordal Catmull-Rom
                    var pow = this.curveType === 'chordal' ? 0.5 : 0.25;
                    var dt0 = Math.pow(p0.distanceToSquared(p1), pow);
                    var dt1 = Math.pow(p1.distanceToSquared(p2), pow);
                    var dt2 = Math.pow(p2.distanceToSquared(p3), pow);
                    // safety check for repeated points
                    if (dt1 < 1e-4) dt1 = 1.0;
                    if (dt0 < 1e-4) dt0 = dt1;
                    if (dt2 < 1e-4) dt2 = dt1;
                    $1a55656020b89c3a$var$px.initNonuniformCatmullRom(p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2);
                    $1a55656020b89c3a$var$py.initNonuniformCatmullRom(p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2);
                    $1a55656020b89c3a$var$pz.initNonuniformCatmullRom(p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2);
                } else if (this.curveType === 'catmullrom') {
                    $1a55656020b89c3a$var$px.initCatmullRom(p0.x, p1.x, p2.x, p3.x, this.tension);
                    $1a55656020b89c3a$var$py.initCatmullRom(p0.y, p1.y, p2.y, p3.y, this.tension);
                    $1a55656020b89c3a$var$pz.initCatmullRom(p0.z, p1.z, p2.z, p3.z, this.tension);
                }
                point.set($1a55656020b89c3a$var$px.calc(weight), $1a55656020b89c3a$var$py.calc(weight), $1a55656020b89c3a$var$pz.calc(weight));
                return point;
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(CatmullRomCurve3.prototype), "copy", this).call(this, source);
                this.points = [];
                for(var i = 0, l = source.points.length; i < l; i++){
                    var point = source.points[i];
                    this.points.push(point.clone());
                }
                this.closed = source.closed;
                this.curveType = source.curveType;
                this.tension = source.tension;
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(CatmullRomCurve3.prototype), "toJSON", this).call(this);
                data.points = [];
                for(var i = 0, l = this.points.length; i < l; i++){
                    var point = this.points[i];
                    data.points.push(point.toArray());
                }
                data.closed = this.closed;
                data.curveType = this.curveType;
                data.tension = this.tension;
                return data;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(CatmullRomCurve3.prototype), "fromJSON", this).call(this, json);
                this.points = [];
                for(var i = 0, l = json.points.length; i < l; i++){
                    var point = json.points[i];
                    this.points.push(new $1a55656020b89c3a$export$64b5c384219d3699().fromArray(point));
                }
                this.closed = json.closed;
                this.curveType = json.curveType;
                this.tension = json.tension;
                return this;
            }
        }
    ]);
    return CatmullRomCurve3;
}($1a55656020b89c3a$export$b0e83c3ef8d2db1);
/**
 * Bezier Curves formulas obtained from
 * https://en.wikipedia.org/wiki/B%C3%A9zier_curve
 */ function $1a55656020b89c3a$var$CatmullRom(t, p0, p1, p2, p3) {
    var v0 = (p2 - p0) * 0.5;
    var v1 = (p3 - p1) * 0.5;
    var t2 = t * t;
    var t3 = t * t2;
    return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
}
//
function $1a55656020b89c3a$var$QuadraticBezierP0(t, p) {
    var k = 1 - t;
    return k * k * p;
}
function $1a55656020b89c3a$var$QuadraticBezierP1(t, p) {
    return 2 * (1 - t) * t * p;
}
function $1a55656020b89c3a$var$QuadraticBezierP2(t, p) {
    return t * t * p;
}
function $1a55656020b89c3a$var$QuadraticBezier(t, p0, p1, p2) {
    return $1a55656020b89c3a$var$QuadraticBezierP0(t, p0) + $1a55656020b89c3a$var$QuadraticBezierP1(t, p1) + $1a55656020b89c3a$var$QuadraticBezierP2(t, p2);
}
//
function $1a55656020b89c3a$var$CubicBezierP0(t, p) {
    var k = 1 - t;
    return k * k * k * p;
}
function $1a55656020b89c3a$var$CubicBezierP1(t, p) {
    var k = 1 - t;
    return 3 * k * k * t * p;
}
function $1a55656020b89c3a$var$CubicBezierP2(t, p) {
    return 3 * (1 - t) * t * t * p;
}
function $1a55656020b89c3a$var$CubicBezierP3(t, p) {
    return t * t * t * p;
}
function $1a55656020b89c3a$var$CubicBezier(t, p0, p1, p2, p3) {
    return $1a55656020b89c3a$var$CubicBezierP0(t, p0) + $1a55656020b89c3a$var$CubicBezierP1(t, p1) + $1a55656020b89c3a$var$CubicBezierP2(t, p2) + $1a55656020b89c3a$var$CubicBezierP3(t, p3);
}
var $1a55656020b89c3a$export$e36650d36468bb39 = /*#__PURE__*/ function(Curve) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(CubicBezierCurve, Curve);
    function CubicBezierCurve() {
        var v0 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $1a55656020b89c3a$export$c977b3e384af9ae1(), v1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $1a55656020b89c3a$export$c977b3e384af9ae1(), v2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new $1a55656020b89c3a$export$c977b3e384af9ae1(), v3 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : new $1a55656020b89c3a$export$c977b3e384af9ae1();
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, CubicBezierCurve);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, CubicBezierCurve);
        _this.isCubicBezierCurve = true;
        _this.type = 'CubicBezierCurve';
        _this.v0 = v0;
        _this.v1 = v1;
        _this.v2 = v2;
        _this.v3 = v3;
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(CubicBezierCurve, [
        {
            key: "getPoint",
            value: function getPoint(t) {
                var optionalTarget = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $1a55656020b89c3a$export$c977b3e384af9ae1();
                var point = optionalTarget;
                var v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
                point.set($1a55656020b89c3a$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $1a55656020b89c3a$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y));
                return point;
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(CubicBezierCurve.prototype), "copy", this).call(this, source);
                this.v0.copy(source.v0);
                this.v1.copy(source.v1);
                this.v2.copy(source.v2);
                this.v3.copy(source.v3);
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(CubicBezierCurve.prototype), "toJSON", this).call(this);
                data.v0 = this.v0.toArray();
                data.v1 = this.v1.toArray();
                data.v2 = this.v2.toArray();
                data.v3 = this.v3.toArray();
                return data;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(CubicBezierCurve.prototype), "fromJSON", this).call(this, json);
                this.v0.fromArray(json.v0);
                this.v1.fromArray(json.v1);
                this.v2.fromArray(json.v2);
                this.v3.fromArray(json.v3);
                return this;
            }
        }
    ]);
    return CubicBezierCurve;
}($1a55656020b89c3a$export$b0e83c3ef8d2db1);
var $1a55656020b89c3a$export$13d5f1c9525f246c = /*#__PURE__*/ function(Curve) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(CubicBezierCurve3, Curve);
    function CubicBezierCurve3() {
        var v0 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $1a55656020b89c3a$export$64b5c384219d3699(), v1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $1a55656020b89c3a$export$64b5c384219d3699(), v2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new $1a55656020b89c3a$export$64b5c384219d3699(), v3 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : new $1a55656020b89c3a$export$64b5c384219d3699();
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, CubicBezierCurve3);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, CubicBezierCurve3);
        _this.isCubicBezierCurve3 = true;
        _this.type = 'CubicBezierCurve3';
        _this.v0 = v0;
        _this.v1 = v1;
        _this.v2 = v2;
        _this.v3 = v3;
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(CubicBezierCurve3, [
        {
            key: "getPoint",
            value: function getPoint(t) {
                var optionalTarget = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $1a55656020b89c3a$export$64b5c384219d3699();
                var point = optionalTarget;
                var v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
                point.set($1a55656020b89c3a$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $1a55656020b89c3a$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y), $1a55656020b89c3a$var$CubicBezier(t, v0.z, v1.z, v2.z, v3.z));
                return point;
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(CubicBezierCurve3.prototype), "copy", this).call(this, source);
                this.v0.copy(source.v0);
                this.v1.copy(source.v1);
                this.v2.copy(source.v2);
                this.v3.copy(source.v3);
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(CubicBezierCurve3.prototype), "toJSON", this).call(this);
                data.v0 = this.v0.toArray();
                data.v1 = this.v1.toArray();
                data.v2 = this.v2.toArray();
                data.v3 = this.v3.toArray();
                return data;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(CubicBezierCurve3.prototype), "fromJSON", this).call(this, json);
                this.v0.fromArray(json.v0);
                this.v1.fromArray(json.v1);
                this.v2.fromArray(json.v2);
                this.v3.fromArray(json.v3);
                return this;
            }
        }
    ]);
    return CubicBezierCurve3;
}($1a55656020b89c3a$export$b0e83c3ef8d2db1);
var $1a55656020b89c3a$export$ab2e07e76531a47e = /*#__PURE__*/ function(Curve) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(LineCurve, Curve);
    function LineCurve() {
        var v1 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $1a55656020b89c3a$export$c977b3e384af9ae1(), v2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $1a55656020b89c3a$export$c977b3e384af9ae1();
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, LineCurve);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, LineCurve);
        _this.isLineCurve = true;
        _this.type = 'LineCurve';
        _this.v1 = v1;
        _this.v2 = v2;
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(LineCurve, [
        {
            key: "getPoint",
            value: function getPoint(t) {
                var optionalTarget = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $1a55656020b89c3a$export$c977b3e384af9ae1();
                var point = optionalTarget;
                if (t === 1) point.copy(this.v2);
                else {
                    point.copy(this.v2).sub(this.v1);
                    point.multiplyScalar(t).add(this.v1);
                }
                return point;
            }
        },
        {
            // Line curve is linear, so we can overwrite default getPointAt
            key: "getPointAt",
            value: function getPointAt(u, optionalTarget) {
                return this.getPoint(u, optionalTarget);
            }
        },
        {
            key: "getTangent",
            value: function getTangent(t) {
                var optionalTarget = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $1a55656020b89c3a$export$c977b3e384af9ae1();
                return optionalTarget.subVectors(this.v2, this.v1).normalize();
            }
        },
        {
            key: "getTangentAt",
            value: function getTangentAt(u, optionalTarget) {
                return this.getTangent(u, optionalTarget);
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(LineCurve.prototype), "copy", this).call(this, source);
                this.v1.copy(source.v1);
                this.v2.copy(source.v2);
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(LineCurve.prototype), "toJSON", this).call(this);
                data.v1 = this.v1.toArray();
                data.v2 = this.v2.toArray();
                return data;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(LineCurve.prototype), "fromJSON", this).call(this, json);
                this.v1.fromArray(json.v1);
                this.v2.fromArray(json.v2);
                return this;
            }
        }
    ]);
    return LineCurve;
}($1a55656020b89c3a$export$b0e83c3ef8d2db1);
var $1a55656020b89c3a$export$1fdfd9d9cf487600 = /*#__PURE__*/ function(Curve) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(LineCurve3, Curve);
    function LineCurve3() {
        var v1 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $1a55656020b89c3a$export$64b5c384219d3699(), v2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $1a55656020b89c3a$export$64b5c384219d3699();
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, LineCurve3);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, LineCurve3);
        _this.isLineCurve3 = true;
        _this.type = 'LineCurve3';
        _this.v1 = v1;
        _this.v2 = v2;
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(LineCurve3, [
        {
            key: "getPoint",
            value: function getPoint(t) {
                var optionalTarget = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $1a55656020b89c3a$export$64b5c384219d3699();
                var point = optionalTarget;
                if (t === 1) point.copy(this.v2);
                else {
                    point.copy(this.v2).sub(this.v1);
                    point.multiplyScalar(t).add(this.v1);
                }
                return point;
            }
        },
        {
            // Line curve is linear, so we can overwrite default getPointAt
            key: "getPointAt",
            value: function getPointAt(u, optionalTarget) {
                return this.getPoint(u, optionalTarget);
            }
        },
        {
            key: "getTangent",
            value: function getTangent(t) {
                var optionalTarget = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $1a55656020b89c3a$export$64b5c384219d3699();
                return optionalTarget.subVectors(this.v2, this.v1).normalize();
            }
        },
        {
            key: "getTangentAt",
            value: function getTangentAt(u, optionalTarget) {
                return this.getTangent(u, optionalTarget);
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(LineCurve3.prototype), "copy", this).call(this, source);
                this.v1.copy(source.v1);
                this.v2.copy(source.v2);
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(LineCurve3.prototype), "toJSON", this).call(this);
                data.v1 = this.v1.toArray();
                data.v2 = this.v2.toArray();
                return data;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(LineCurve3.prototype), "fromJSON", this).call(this, json);
                this.v1.fromArray(json.v1);
                this.v2.fromArray(json.v2);
                return this;
            }
        }
    ]);
    return LineCurve3;
}($1a55656020b89c3a$export$b0e83c3ef8d2db1);
var $1a55656020b89c3a$export$5938c4ee491a43ad = /*#__PURE__*/ function(Curve) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(QuadraticBezierCurve, Curve);
    function QuadraticBezierCurve() {
        var v0 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $1a55656020b89c3a$export$c977b3e384af9ae1(), v1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $1a55656020b89c3a$export$c977b3e384af9ae1(), v2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new $1a55656020b89c3a$export$c977b3e384af9ae1();
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, QuadraticBezierCurve);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, QuadraticBezierCurve);
        _this.isQuadraticBezierCurve = true;
        _this.type = 'QuadraticBezierCurve';
        _this.v0 = v0;
        _this.v1 = v1;
        _this.v2 = v2;
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(QuadraticBezierCurve, [
        {
            key: "getPoint",
            value: function getPoint(t) {
                var optionalTarget = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $1a55656020b89c3a$export$c977b3e384af9ae1();
                var point = optionalTarget;
                var v0 = this.v0, v1 = this.v1, v2 = this.v2;
                point.set($1a55656020b89c3a$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $1a55656020b89c3a$var$QuadraticBezier(t, v0.y, v1.y, v2.y));
                return point;
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(QuadraticBezierCurve.prototype), "copy", this).call(this, source);
                this.v0.copy(source.v0);
                this.v1.copy(source.v1);
                this.v2.copy(source.v2);
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(QuadraticBezierCurve.prototype), "toJSON", this).call(this);
                data.v0 = this.v0.toArray();
                data.v1 = this.v1.toArray();
                data.v2 = this.v2.toArray();
                return data;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(QuadraticBezierCurve.prototype), "fromJSON", this).call(this, json);
                this.v0.fromArray(json.v0);
                this.v1.fromArray(json.v1);
                this.v2.fromArray(json.v2);
                return this;
            }
        }
    ]);
    return QuadraticBezierCurve;
}($1a55656020b89c3a$export$b0e83c3ef8d2db1);
var $1a55656020b89c3a$export$bf3f4c7e459f90fc = /*#__PURE__*/ function(Curve) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(QuadraticBezierCurve3, Curve);
    function QuadraticBezierCurve3() {
        var v0 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $1a55656020b89c3a$export$64b5c384219d3699(), v1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $1a55656020b89c3a$export$64b5c384219d3699(), v2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new $1a55656020b89c3a$export$64b5c384219d3699();
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, QuadraticBezierCurve3);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, QuadraticBezierCurve3);
        _this.isQuadraticBezierCurve3 = true;
        _this.type = 'QuadraticBezierCurve3';
        _this.v0 = v0;
        _this.v1 = v1;
        _this.v2 = v2;
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(QuadraticBezierCurve3, [
        {
            key: "getPoint",
            value: function getPoint(t) {
                var optionalTarget = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $1a55656020b89c3a$export$64b5c384219d3699();
                var point = optionalTarget;
                var v0 = this.v0, v1 = this.v1, v2 = this.v2;
                point.set($1a55656020b89c3a$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $1a55656020b89c3a$var$QuadraticBezier(t, v0.y, v1.y, v2.y), $1a55656020b89c3a$var$QuadraticBezier(t, v0.z, v1.z, v2.z));
                return point;
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(QuadraticBezierCurve3.prototype), "copy", this).call(this, source);
                this.v0.copy(source.v0);
                this.v1.copy(source.v1);
                this.v2.copy(source.v2);
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(QuadraticBezierCurve3.prototype), "toJSON", this).call(this);
                data.v0 = this.v0.toArray();
                data.v1 = this.v1.toArray();
                data.v2 = this.v2.toArray();
                return data;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(QuadraticBezierCurve3.prototype), "fromJSON", this).call(this, json);
                this.v0.fromArray(json.v0);
                this.v1.fromArray(json.v1);
                this.v2.fromArray(json.v2);
                return this;
            }
        }
    ]);
    return QuadraticBezierCurve3;
}($1a55656020b89c3a$export$b0e83c3ef8d2db1);
var $1a55656020b89c3a$export$d3bdd77da77afc1b = /*#__PURE__*/ function(Curve) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(SplineCurve, Curve);
    function SplineCurve() {
        var points = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, SplineCurve);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, SplineCurve);
        _this.isSplineCurve = true;
        _this.type = 'SplineCurve';
        _this.points = points;
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(SplineCurve, [
        {
            key: "getPoint",
            value: function getPoint(t) {
                var optionalTarget = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $1a55656020b89c3a$export$c977b3e384af9ae1();
                var point = optionalTarget;
                var points = this.points;
                var p = (points.length - 1) * t;
                var intPoint = Math.floor(p);
                var weight = p - intPoint;
                var p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
                var p1 = points[intPoint];
                var p2 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
                var p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
                point.set($1a55656020b89c3a$var$CatmullRom(weight, p0.x, p1.x, p2.x, p3.x), $1a55656020b89c3a$var$CatmullRom(weight, p0.y, p1.y, p2.y, p3.y));
                return point;
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(SplineCurve.prototype), "copy", this).call(this, source);
                this.points = [];
                for(var i = 0, l = source.points.length; i < l; i++){
                    var point = source.points[i];
                    this.points.push(point.clone());
                }
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(SplineCurve.prototype), "toJSON", this).call(this);
                data.points = [];
                for(var i = 0, l = this.points.length; i < l; i++){
                    var point = this.points[i];
                    data.points.push(point.toArray());
                }
                return data;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(SplineCurve.prototype), "fromJSON", this).call(this, json);
                this.points = [];
                for(var i = 0, l = json.points.length; i < l; i++){
                    var point = json.points[i];
                    this.points.push(new $1a55656020b89c3a$export$c977b3e384af9ae1().fromArray(point));
                }
                return this;
            }
        }
    ]);
    return SplineCurve;
}($1a55656020b89c3a$export$b0e83c3ef8d2db1);
var $1a55656020b89c3a$var$Curves = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcCurve: $1a55656020b89c3a$export$b1eedc9aab6300e8,
    CatmullRomCurve3: $1a55656020b89c3a$export$b9146b27c24b744c,
    CubicBezierCurve: $1a55656020b89c3a$export$e36650d36468bb39,
    CubicBezierCurve3: $1a55656020b89c3a$export$13d5f1c9525f246c,
    EllipseCurve: $1a55656020b89c3a$export$3f87a931616cde04,
    LineCurve: $1a55656020b89c3a$export$ab2e07e76531a47e,
    LineCurve3: $1a55656020b89c3a$export$1fdfd9d9cf487600,
    QuadraticBezierCurve: $1a55656020b89c3a$export$5938c4ee491a43ad,
    QuadraticBezierCurve3: $1a55656020b89c3a$export$bf3f4c7e459f90fc,
    SplineCurve: $1a55656020b89c3a$export$d3bdd77da77afc1b
});
/**************************************************************
 *	Curved Path - a curve path is simply a array of connected
 *  curves, but retains the api of a curve
 **************************************************************/ var $1a55656020b89c3a$export$4aaf9b66af1bbf2c = /*#__PURE__*/ function(Curve) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(CurvePath, Curve);
    function CurvePath() {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, CurvePath);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, CurvePath);
        _this.type = 'CurvePath';
        _this.curves = [];
        _this.autoClose = false; // Automatically closes the path
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(CurvePath, [
        {
            key: "add",
            value: function add(curve) {
                this.curves.push(curve);
            }
        },
        {
            key: "closePath",
            value: function closePath() {
                // Add a line curve if start and end of lines are not connected
                var startPoint = this.curves[0].getPoint(0);
                var endPoint = this.curves[this.curves.length - 1].getPoint(1);
                if (!startPoint.equals(endPoint)) {
                    var lineType = startPoint.isVector2 === true ? 'LineCurve' : 'LineCurve3';
                    this.curves.push(new $1a55656020b89c3a$var$Curves[lineType](endPoint, startPoint));
                }
                return this;
            }
        },
        {
            // To get accurate point with reference to
            // entire path distance at time t,
            // following has to be done:
            // 1. Length of each sub path have to be known
            // 2. Locate and identify type of curve
            // 3. Get t for the curve
            // 4. Return curve.getPointAt(t')
            key: "getPoint",
            value: function getPoint(t, optionalTarget) {
                var d = t * this.getLength();
                var curveLengths = this.getCurveLengths();
                var i = 0;
                // To think about boundaries points.
                while(i < curveLengths.length){
                    if (curveLengths[i] >= d) {
                        var diff = curveLengths[i] - d;
                        var curve = this.curves[i];
                        var segmentLength = curve.getLength();
                        var u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
                        return curve.getPointAt(u, optionalTarget);
                    }
                    i++;
                }
                return null;
            // loop where sum != 0, sum > d , sum+1 <d
            }
        },
        {
            // We cannot use the default THREE.Curve getPoint() with getLength() because in
            // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
            // getPoint() depends on getLength
            key: "getLength",
            value: function getLength() {
                var lens = this.getCurveLengths();
                return lens[lens.length - 1];
            }
        },
        {
            // cacheLengths must be recalculated.
            key: "updateArcLengths",
            value: function updateArcLengths() {
                this.needsUpdate = true;
                this.cacheLengths = null;
                this.getCurveLengths();
            }
        },
        {
            // Compute lengths and cache them
            // We cannot overwrite getLengths() because UtoT mapping uses it.
            key: "getCurveLengths",
            value: function getCurveLengths() {
                // We use cache values if curves and cache array are same length
                if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
                // Get length of sub-curve
                // Push sums into cached array
                var lengths = [];
                var sums = 0;
                for(var i = 0, l = this.curves.length; i < l; i++){
                    sums += this.curves[i].getLength();
                    lengths.push(sums);
                }
                this.cacheLengths = lengths;
                return lengths;
            }
        },
        {
            key: "getSpacedPoints",
            value: function getSpacedPoints() {
                var divisions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 40;
                var points = [];
                for(var i = 0; i <= divisions; i++)points.push(this.getPoint(i / divisions));
                if (this.autoClose) points.push(points[0]);
                return points;
            }
        },
        {
            key: "getPoints",
            value: function getPoints() {
                var divisions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 12;
                var points = [];
                var last;
                for(var i = 0, curves = this.curves; i < curves.length; i++){
                    var curve = curves[i];
                    var resolution = curve.isEllipseCurve ? divisions * 2 : curve.isLineCurve || curve.isLineCurve3 ? 1 : curve.isSplineCurve ? divisions * curve.points.length : divisions;
                    var pts = curve.getPoints(resolution);
                    for(var j = 0; j < pts.length; j++){
                        var point = pts[j];
                        if (last && last.equals(point)) continue; // ensures no consecutive points are duplicates
                        points.push(point);
                        last = point;
                    }
                }
                if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) points.push(points[0]);
                return points;
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(CurvePath.prototype), "copy", this).call(this, source);
                this.curves = [];
                for(var i = 0, l = source.curves.length; i < l; i++){
                    var curve = source.curves[i];
                    this.curves.push(curve.clone());
                }
                this.autoClose = source.autoClose;
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(CurvePath.prototype), "toJSON", this).call(this);
                data.autoClose = this.autoClose;
                data.curves = [];
                for(var i = 0, l = this.curves.length; i < l; i++){
                    var curve = this.curves[i];
                    data.curves.push(curve.toJSON());
                }
                return data;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(CurvePath.prototype), "fromJSON", this).call(this, json);
                this.autoClose = json.autoClose;
                this.curves = [];
                for(var i = 0, l = json.curves.length; i < l; i++){
                    var curve = json.curves[i];
                    this.curves.push(new $1a55656020b89c3a$var$Curves[curve.type]().fromJSON(curve));
                }
                return this;
            }
        }
    ]);
    return CurvePath;
}($1a55656020b89c3a$export$b0e83c3ef8d2db1);
var $1a55656020b89c3a$export$4b2950bdac9b6ee9 = /*#__PURE__*/ function(CurvePath) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(Path, CurvePath);
    function Path(points) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Path);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, Path);
        _this.type = 'Path';
        _this.currentPoint = new $1a55656020b89c3a$export$c977b3e384af9ae1();
        if (points) _this.setFromPoints(points);
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Path, [
        {
            key: "setFromPoints",
            value: function setFromPoints(points) {
                this.moveTo(points[0].x, points[0].y);
                for(var i = 1, l = points.length; i < l; i++)this.lineTo(points[i].x, points[i].y);
                return this;
            }
        },
        {
            key: "moveTo",
            value: function moveTo(x, y) {
                this.currentPoint.set(x, y); // TODO consider referencing vectors instead of copying?
                return this;
            }
        },
        {
            key: "lineTo",
            value: function lineTo(x, y) {
                var curve = new $1a55656020b89c3a$export$ab2e07e76531a47e(this.currentPoint.clone(), new $1a55656020b89c3a$export$c977b3e384af9ae1(x, y));
                this.curves.push(curve);
                this.currentPoint.set(x, y);
                return this;
            }
        },
        {
            key: "quadraticCurveTo",
            value: function quadraticCurveTo(aCPx, aCPy, aX, aY) {
                var curve = new $1a55656020b89c3a$export$5938c4ee491a43ad(this.currentPoint.clone(), new $1a55656020b89c3a$export$c977b3e384af9ae1(aCPx, aCPy), new $1a55656020b89c3a$export$c977b3e384af9ae1(aX, aY));
                this.curves.push(curve);
                this.currentPoint.set(aX, aY);
                return this;
            }
        },
        {
            key: "bezierCurveTo",
            value: function bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
                var curve = new $1a55656020b89c3a$export$e36650d36468bb39(this.currentPoint.clone(), new $1a55656020b89c3a$export$c977b3e384af9ae1(aCP1x, aCP1y), new $1a55656020b89c3a$export$c977b3e384af9ae1(aCP2x, aCP2y), new $1a55656020b89c3a$export$c977b3e384af9ae1(aX, aY));
                this.curves.push(curve);
                this.currentPoint.set(aX, aY);
                return this;
            }
        },
        {
            key: "splineThru",
            value: function splineThru(pts /*Array of Vector*/ ) {
                var npts = [
                    this.currentPoint.clone()
                ].concat(pts);
                var curve = new $1a55656020b89c3a$export$d3bdd77da77afc1b(npts);
                this.curves.push(curve);
                this.currentPoint.copy(pts[pts.length - 1]);
                return this;
            }
        },
        {
            key: "arc",
            value: function arc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
                var x0 = this.currentPoint.x;
                var y0 = this.currentPoint.y;
                this.absarc(aX + x0, aY + y0, aRadius, aStartAngle, aEndAngle, aClockwise);
                return this;
            }
        },
        {
            key: "absarc",
            value: function absarc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
                this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
                return this;
            }
        },
        {
            key: "ellipse",
            value: function ellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
                var x0 = this.currentPoint.x;
                var y0 = this.currentPoint.y;
                this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
                return this;
            }
        },
        {
            key: "absellipse",
            value: function absellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
                var curve = new $1a55656020b89c3a$export$3f87a931616cde04(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
                if (this.curves.length > 0) {
                    // if a previous curve is present, attempt to join
                    var firstPoint = curve.getPoint(0);
                    if (!firstPoint.equals(this.currentPoint)) this.lineTo(firstPoint.x, firstPoint.y);
                }
                this.curves.push(curve);
                var lastPoint = curve.getPoint(1);
                this.currentPoint.copy(lastPoint);
                return this;
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(Path.prototype), "copy", this).call(this, source);
                this.currentPoint.copy(source.currentPoint);
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(Path.prototype), "toJSON", this).call(this);
                data.currentPoint = this.currentPoint.toArray();
                return data;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(Path.prototype), "fromJSON", this).call(this, json);
                this.currentPoint.fromArray(json.currentPoint);
                return this;
            }
        }
    ]);
    return Path;
}($1a55656020b89c3a$export$4aaf9b66af1bbf2c);
var $1a55656020b89c3a$export$6d839803fcd1882c = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(LatheGeometry, BufferGeometry);
    function LatheGeometry() {
        var points = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [
            new $1a55656020b89c3a$export$c977b3e384af9ae1(0, -0.5),
            new $1a55656020b89c3a$export$c977b3e384af9ae1(0.5, 0),
            new $1a55656020b89c3a$export$c977b3e384af9ae1(0, 0.5)
        ], segments = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 12, phiStart = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, phiLength = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Math.PI * 2;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, LatheGeometry);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, LatheGeometry);
        _this.type = 'LatheGeometry';
        _this.parameters = {
            points: points,
            segments: segments,
            phiStart: phiStart,
            phiLength: phiLength
        };
        segments = Math.floor(segments);
        // clamp phiLength so it's in range of [ 0, 2PI ]
        phiLength = $1a55656020b89c3a$var$clamp(phiLength, 0, Math.PI * 2);
        // buffers
        var indices = [];
        var vertices = [];
        var uvs = [];
        var initNormals = [];
        var normals = [];
        // helper variables
        var inverseSegments = 1.0 / segments;
        var vertex = new $1a55656020b89c3a$export$64b5c384219d3699();
        var uv = new $1a55656020b89c3a$export$c977b3e384af9ae1();
        var normal = new $1a55656020b89c3a$export$64b5c384219d3699();
        var curNormal = new $1a55656020b89c3a$export$64b5c384219d3699();
        var prevNormal = new $1a55656020b89c3a$export$64b5c384219d3699();
        var dx = 0;
        var dy = 0;
        // pre-compute normals for initial "meridian"
        for(var j = 0; j <= points.length - 1; j++)switch(j){
            case 0:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                prevNormal.copy(normal);
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                break;
            case points.length - 1:
                initNormals.push(prevNormal.x, prevNormal.y, prevNormal.z);
                break;
            default:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                curNormal.copy(normal);
                normal.x += prevNormal.x;
                normal.y += prevNormal.y;
                normal.z += prevNormal.z;
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                prevNormal.copy(curNormal);
        }
        // generate vertices, uvs and normals
        for(var i = 0; i <= segments; i++){
            var phi = phiStart + i * inverseSegments * phiLength;
            var sin = Math.sin(phi);
            var cos = Math.cos(phi);
            for(var j1 = 0; j1 <= points.length - 1; j1++){
                // vertex
                vertex.x = points[j1].x * sin;
                vertex.y = points[j1].y;
                vertex.z = points[j1].x * cos;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // uv
                uv.x = i / segments;
                uv.y = j1 / (points.length - 1);
                uvs.push(uv.x, uv.y);
                // normal
                var x = initNormals[3 * j1 + 0] * sin;
                var y = initNormals[3 * j1 + 1];
                var z = initNormals[3 * j1 + 0] * cos;
                normals.push(x, y, z);
            }
        }
        // indices
        for(var i1 = 0; i1 < segments; i1++)for(var j2 = 0; j2 < points.length - 1; j2++){
            var base = j2 + i1 * points.length;
            var a = base;
            var b = base + points.length;
            var c = base + points.length + 1;
            var d = base + 1;
            // faces
            indices.push(a, b, d);
            indices.push(c, d, b);
        }
        // build geometry
        _this.setIndex(indices);
        _this.setAttribute('position', new $1a55656020b89c3a$export$cbe7a62641830ebd(vertices, 3));
        _this.setAttribute('uv', new $1a55656020b89c3a$export$cbe7a62641830ebd(uvs, 2));
        _this.setAttribute('normal', new $1a55656020b89c3a$export$cbe7a62641830ebd(normals, 3));
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(LatheGeometry, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(LatheGeometry.prototype), "copy", this).call(this, source);
                this.parameters = Object.assign({}, source.parameters);
                return this;
            }
        }
    ], [
        {
            key: "fromJSON",
            value: function fromJSON(data) {
                return new LatheGeometry(data.points, data.segments, data.phiStart, data.phiLength);
            }
        }
    ]);
    return LatheGeometry;
}($1a55656020b89c3a$export$b7be63a67df8959);
var $1a55656020b89c3a$export$41680e8551036033 = /*#__PURE__*/ function(LatheGeometry) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(CapsuleGeometry, LatheGeometry);
    function CapsuleGeometry() {
        var radius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, capSegments = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 4, radialSegments = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 8;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, CapsuleGeometry);
        var _this;
        var path = new $1a55656020b89c3a$export$4b2950bdac9b6ee9();
        path.absarc(0, -length / 2, radius, Math.PI * 1.5, 0);
        path.absarc(0, length / 2, radius, 0, Math.PI * 0.5);
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, CapsuleGeometry, [
            path.getPoints(capSegments),
            radialSegments
        ]);
        _this.type = 'CapsuleGeometry';
        _this.parameters = {
            radius: radius,
            length: length,
            capSegments: capSegments,
            radialSegments: radialSegments
        };
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(CapsuleGeometry, null, [
        {
            key: "fromJSON",
            value: function fromJSON(data) {
                return new CapsuleGeometry(data.radius, data.length, data.capSegments, data.radialSegments);
            }
        }
    ]);
    return CapsuleGeometry;
}($1a55656020b89c3a$export$6d839803fcd1882c);
var $1a55656020b89c3a$export$d5c0e8d607467193 = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(CircleGeometry, BufferGeometry);
    function CircleGeometry() {
        var radius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, segments = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 32, thetaStart = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, thetaLength = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Math.PI * 2;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, CircleGeometry);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, CircleGeometry);
        _this.type = 'CircleGeometry';
        _this.parameters = {
            radius: radius,
            segments: segments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        segments = Math.max(3, segments);
        // buffers
        var indices = [];
        var vertices = [];
        var normals = [];
        var uvs = [];
        // helper variables
        var vertex = new $1a55656020b89c3a$export$64b5c384219d3699();
        var uv = new $1a55656020b89c3a$export$c977b3e384af9ae1();
        // center point
        vertices.push(0, 0, 0);
        normals.push(0, 0, 1);
        uvs.push(0.5, 0.5);
        for(var s = 0, i = 3; s <= segments; s++, i += 3){
            var segment = thetaStart + s / segments * thetaLength;
            // vertex
            vertex.x = radius * Math.cos(segment);
            vertex.y = radius * Math.sin(segment);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            normals.push(0, 0, 1);
            // uvs
            uv.x = (vertices[i] / radius + 1) / 2;
            uv.y = (vertices[i + 1] / radius + 1) / 2;
            uvs.push(uv.x, uv.y);
        }
        // indices
        for(var i1 = 1; i1 <= segments; i1++)indices.push(i1, i1 + 1, 0);
        // build geometry
        _this.setIndex(indices);
        _this.setAttribute('position', new $1a55656020b89c3a$export$cbe7a62641830ebd(vertices, 3));
        _this.setAttribute('normal', new $1a55656020b89c3a$export$cbe7a62641830ebd(normals, 3));
        _this.setAttribute('uv', new $1a55656020b89c3a$export$cbe7a62641830ebd(uvs, 2));
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(CircleGeometry, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(CircleGeometry.prototype), "copy", this).call(this, source);
                this.parameters = Object.assign({}, source.parameters);
                return this;
            }
        }
    ], [
        {
            key: "fromJSON",
            value: function fromJSON(data) {
                return new CircleGeometry(data.radius, data.segments, data.thetaStart, data.thetaLength);
            }
        }
    ]);
    return CircleGeometry;
}($1a55656020b89c3a$export$b7be63a67df8959);
var $1a55656020b89c3a$export$68f745719dbe5198 = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(CylinderGeometry, BufferGeometry);
    function CylinderGeometry() {
        var radiusTop = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, radiusBottom = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, height = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, radialSegments = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 32, heightSegments = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 1, openEnded = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false, thetaStart = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : 0, thetaLength = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : Math.PI * 2;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, CylinderGeometry);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, CylinderGeometry);
        _this.type = 'CylinderGeometry';
        _this.parameters = {
            radiusTop: radiusTop,
            radiusBottom: radiusBottom,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        var scope = _this;
        radialSegments = Math.floor(radialSegments);
        heightSegments = Math.floor(heightSegments);
        // buffers
        var indices = [];
        var vertices = [];
        var normals = [];
        var uvs = [];
        // helper variables
        var index = 0;
        var indexArray = [];
        var halfHeight = height / 2;
        var groupStart = 0;
        // generate geometry
        generateTorso();
        if (openEnded === false) {
            if (radiusTop > 0) generateCap(true);
            if (radiusBottom > 0) generateCap(false);
        }
        // build geometry
        _this.setIndex(indices);
        _this.setAttribute('position', new $1a55656020b89c3a$export$cbe7a62641830ebd(vertices, 3));
        _this.setAttribute('normal', new $1a55656020b89c3a$export$cbe7a62641830ebd(normals, 3));
        _this.setAttribute('uv', new $1a55656020b89c3a$export$cbe7a62641830ebd(uvs, 2));
        function generateTorso() {
            var normal = new $1a55656020b89c3a$export$64b5c384219d3699();
            var vertex = new $1a55656020b89c3a$export$64b5c384219d3699();
            var groupCount = 0;
            // this will be used to calculate the normal
            var slope = (radiusBottom - radiusTop) / height;
            // generate vertices, normals and uvs
            for(var y = 0; y <= heightSegments; y++){
                var indexRow = [];
                var v = y / heightSegments;
                // calculate the radius of the current row
                var radius = v * (radiusBottom - radiusTop) + radiusTop;
                for(var x = 0; x <= radialSegments; x++){
                    var u = x / radialSegments;
                    var theta = u * thetaLength + thetaStart;
                    var sinTheta = Math.sin(theta);
                    var cosTheta = Math.cos(theta);
                    // vertex
                    vertex.x = radius * sinTheta;
                    vertex.y = -v * height + halfHeight;
                    vertex.z = radius * cosTheta;
                    vertices.push(vertex.x, vertex.y, vertex.z);
                    // normal
                    normal.set(sinTheta, slope, cosTheta).normalize();
                    normals.push(normal.x, normal.y, normal.z);
                    // uv
                    uvs.push(u, 1 - v);
                    // save index of vertex in respective row
                    indexRow.push(index++);
                }
                // now save vertices of the row in our index array
                indexArray.push(indexRow);
            }
            // generate indices
            for(var x1 = 0; x1 < radialSegments; x1++)for(var y1 = 0; y1 < heightSegments; y1++){
                // we use the index array to access the correct indices
                var a = indexArray[y1][x1];
                var b = indexArray[y1 + 1][x1];
                var c = indexArray[y1 + 1][x1 + 1];
                var d = indexArray[y1][x1 + 1];
                // faces
                if (radiusTop > 0 || y1 !== 0) {
                    indices.push(a, b, d);
                    groupCount += 3;
                }
                if (radiusBottom > 0 || y1 !== heightSegments - 1) {
                    indices.push(b, c, d);
                    groupCount += 3;
                }
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, 0);
            // calculate new start value for groups
            groupStart += groupCount;
        }
        function generateCap(top) {
            // save the index of the first center vertex
            var centerIndexStart = index;
            var uv = new $1a55656020b89c3a$export$c977b3e384af9ae1();
            var vertex = new $1a55656020b89c3a$export$64b5c384219d3699();
            var groupCount = 0;
            var radius = top === true ? radiusTop : radiusBottom;
            var sign = top === true ? 1 : -1;
            // first we generate the center vertex data of the cap.
            // because the geometry needs one set of uvs per face,
            // we must generate a center vertex per face/segment
            for(var x = 1; x <= radialSegments; x++){
                // vertex
                vertices.push(0, halfHeight * sign, 0);
                // normal
                normals.push(0, sign, 0);
                // uv
                uvs.push(0.5, 0.5);
                // increase index
                index++;
            }
            // save the index of the last center vertex
            var centerIndexEnd = index;
            // now we generate the surrounding vertices, normals and uvs
            for(var x1 = 0; x1 <= radialSegments; x1++){
                var u = x1 / radialSegments;
                var theta = u * thetaLength + thetaStart;
                var cosTheta = Math.cos(theta);
                var sinTheta = Math.sin(theta);
                // vertex
                vertex.x = radius * sinTheta;
                vertex.y = halfHeight * sign;
                vertex.z = radius * cosTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, sign, 0);
                // uv
                uv.x = cosTheta * 0.5 + 0.5;
                uv.y = sinTheta * 0.5 * sign + 0.5;
                uvs.push(uv.x, uv.y);
                // increase index
                index++;
            }
            // generate indices
            for(var x2 = 0; x2 < radialSegments; x2++){
                var c = centerIndexStart + x2;
                var i = centerIndexEnd + x2;
                if (top === true) // face top
                indices.push(i, i + 1, c);
                else // face bottom
                indices.push(i + 1, i, c);
                groupCount += 3;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, top === true ? 1 : 2);
            // calculate new start value for groups
            groupStart += groupCount;
        }
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(CylinderGeometry, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(CylinderGeometry.prototype), "copy", this).call(this, source);
                this.parameters = Object.assign({}, source.parameters);
                return this;
            }
        }
    ], [
        {
            key: "fromJSON",
            value: function fromJSON(data) {
                return new CylinderGeometry(data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
            }
        }
    ]);
    return CylinderGeometry;
}($1a55656020b89c3a$export$b7be63a67df8959);
var $1a55656020b89c3a$export$a7a48974f285c9b3 = /*#__PURE__*/ function(CylinderGeometry) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(ConeGeometry, CylinderGeometry);
    function ConeGeometry() {
        var radius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, height = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, radialSegments = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 32, heightSegments = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1, openEnded = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, thetaStart = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0, thetaLength = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : Math.PI * 2;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, ConeGeometry);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, ConeGeometry, [
            0,
            radius,
            height,
            radialSegments,
            heightSegments,
            openEnded,
            thetaStart,
            thetaLength
        ]);
        _this.type = 'ConeGeometry';
        _this.parameters = {
            radius: radius,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(ConeGeometry, null, [
        {
            key: "fromJSON",
            value: function fromJSON(data) {
                return new ConeGeometry(data.radius, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
            }
        }
    ]);
    return ConeGeometry;
}($1a55656020b89c3a$export$68f745719dbe5198);
var $1a55656020b89c3a$export$60e57a7d3f20ff65 = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(PolyhedronGeometry, BufferGeometry);
    function PolyhedronGeometry() {
        var vertices = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], indices = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], radius = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, detail = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, PolyhedronGeometry);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, PolyhedronGeometry);
        _this.type = 'PolyhedronGeometry';
        _this.parameters = {
            vertices: vertices,
            indices: indices,
            radius: radius,
            detail: detail
        };
        // default buffer data
        var vertexBuffer = [];
        var uvBuffer = [];
        // the subdivision creates the vertex buffer data
        subdivide(detail);
        // all vertices should lie on a conceptual sphere with a given radius
        applyRadius(radius);
        // finally, create the uv data
        generateUVs();
        // build non-indexed geometry
        _this.setAttribute('position', new $1a55656020b89c3a$export$cbe7a62641830ebd(vertexBuffer, 3));
        _this.setAttribute('normal', new $1a55656020b89c3a$export$cbe7a62641830ebd(vertexBuffer.slice(), 3));
        _this.setAttribute('uv', new $1a55656020b89c3a$export$cbe7a62641830ebd(uvBuffer, 2));
        if (detail === 0) _this.computeVertexNormals(); // flat normals
        else _this.normalizeNormals(); // smooth normals
        // helper functions
        function subdivide(detail) {
            var a = new $1a55656020b89c3a$export$64b5c384219d3699();
            var b = new $1a55656020b89c3a$export$64b5c384219d3699();
            var c = new $1a55656020b89c3a$export$64b5c384219d3699();
            // iterate over all faces and apply a subdivision with the given detail value
            for(var i = 0; i < indices.length; i += 3){
                // get the vertices of the face
                getVertexByIndex(indices[i + 0], a);
                getVertexByIndex(indices[i + 1], b);
                getVertexByIndex(indices[i + 2], c);
                // perform subdivision
                subdivideFace(a, b, c, detail);
            }
        }
        function subdivideFace(a, b, c, detail) {
            var cols = detail + 1;
            // we use this multidimensional array as a data structure for creating the subdivision
            var v = [];
            // construct all of the vertices for this subdivision
            for(var i = 0; i <= cols; i++){
                v[i] = [];
                var aj = a.clone().lerp(c, i / cols);
                var bj = b.clone().lerp(c, i / cols);
                var rows = cols - i;
                for(var j = 0; j <= rows; j++)if (j === 0 && i === cols) v[i][j] = aj;
                else v[i][j] = aj.clone().lerp(bj, j / rows);
            }
            // construct all of the faces
            for(var i1 = 0; i1 < cols; i1++)for(var j1 = 0; j1 < 2 * (cols - i1) - 1; j1++){
                var k = Math.floor(j1 / 2);
                if (j1 % 2 === 0) {
                    pushVertex(v[i1][k + 1]);
                    pushVertex(v[i1 + 1][k]);
                    pushVertex(v[i1][k]);
                } else {
                    pushVertex(v[i1][k + 1]);
                    pushVertex(v[i1 + 1][k + 1]);
                    pushVertex(v[i1 + 1][k]);
                }
            }
        }
        function applyRadius(radius) {
            var vertex = new $1a55656020b89c3a$export$64b5c384219d3699();
            // iterate over the entire buffer and apply the radius to each vertex
            for(var i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                vertex.normalize().multiplyScalar(radius);
                vertexBuffer[i + 0] = vertex.x;
                vertexBuffer[i + 1] = vertex.y;
                vertexBuffer[i + 2] = vertex.z;
            }
        }
        function generateUVs() {
            var vertex = new $1a55656020b89c3a$export$64b5c384219d3699();
            for(var i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                var u = azimuth(vertex) / 2 / Math.PI + 0.5;
                var v = inclination(vertex) / Math.PI + 0.5;
                uvBuffer.push(u, 1 - v);
            }
            correctUVs();
            correctSeam();
        }
        function correctSeam() {
            // handle case when face straddles the seam, see #3269
            for(var i = 0; i < uvBuffer.length; i += 6){
                // uv data of a single face
                var x0 = uvBuffer[i + 0];
                var x1 = uvBuffer[i + 2];
                var x2 = uvBuffer[i + 4];
                var max = Math.max(x0, x1, x2);
                var min = Math.min(x0, x1, x2);
                // 0.9 is somewhat arbitrary
                if (max > 0.9 && min < 0.1) {
                    if (x0 < 0.2) uvBuffer[i + 0] += 1;
                    if (x1 < 0.2) uvBuffer[i + 2] += 1;
                    if (x2 < 0.2) uvBuffer[i + 4] += 1;
                }
            }
        }
        function pushVertex(vertex) {
            vertexBuffer.push(vertex.x, vertex.y, vertex.z);
        }
        function getVertexByIndex(index, vertex) {
            var stride = index * 3;
            vertex.x = vertices[stride + 0];
            vertex.y = vertices[stride + 1];
            vertex.z = vertices[stride + 2];
        }
        function correctUVs() {
            var a = new $1a55656020b89c3a$export$64b5c384219d3699();
            var b = new $1a55656020b89c3a$export$64b5c384219d3699();
            var c = new $1a55656020b89c3a$export$64b5c384219d3699();
            var centroid = new $1a55656020b89c3a$export$64b5c384219d3699();
            var uvA = new $1a55656020b89c3a$export$c977b3e384af9ae1();
            var uvB = new $1a55656020b89c3a$export$c977b3e384af9ae1();
            var uvC = new $1a55656020b89c3a$export$c977b3e384af9ae1();
            for(var i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6){
                a.set(vertexBuffer[i + 0], vertexBuffer[i + 1], vertexBuffer[i + 2]);
                b.set(vertexBuffer[i + 3], vertexBuffer[i + 4], vertexBuffer[i + 5]);
                c.set(vertexBuffer[i + 6], vertexBuffer[i + 7], vertexBuffer[i + 8]);
                uvA.set(uvBuffer[j + 0], uvBuffer[j + 1]);
                uvB.set(uvBuffer[j + 2], uvBuffer[j + 3]);
                uvC.set(uvBuffer[j + 4], uvBuffer[j + 5]);
                centroid.copy(a).add(b).add(c).divideScalar(3);
                var azi = azimuth(centroid);
                correctUV(uvA, j + 0, a, azi);
                correctUV(uvB, j + 2, b, azi);
                correctUV(uvC, j + 4, c, azi);
            }
        }
        function correctUV(uv, stride, vector, azimuth) {
            if (azimuth < 0 && uv.x === 1) uvBuffer[stride] = uv.x - 1;
            if (vector.x === 0 && vector.z === 0) uvBuffer[stride] = azimuth / 2 / Math.PI + 0.5;
        }
        // Angle around the Y axis, counter-clockwise when looking from above.
        function azimuth(vector) {
            return Math.atan2(vector.z, -vector.x);
        }
        // Angle above the XZ plane.
        function inclination(vector) {
            return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));
        }
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(PolyhedronGeometry, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(PolyhedronGeometry.prototype), "copy", this).call(this, source);
                this.parameters = Object.assign({}, source.parameters);
                return this;
            }
        }
    ], [
        {
            key: "fromJSON",
            value: function fromJSON(data) {
                return new PolyhedronGeometry(data.vertices, data.indices, data.radius, data.details);
            }
        }
    ]);
    return PolyhedronGeometry;
}($1a55656020b89c3a$export$b7be63a67df8959);
var $1a55656020b89c3a$export$c0babfeb8708fc9c = /*#__PURE__*/ function(PolyhedronGeometry) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(DodecahedronGeometry, PolyhedronGeometry);
    function DodecahedronGeometry() {
        var radius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, detail = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, DodecahedronGeometry);
        var _this;
        var t = (1 + Math.sqrt(5)) / 2;
        var r = 1 / t;
        var vertices = [
            // (±1, ±1, ±1)
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            // (0, ±1/φ, ±φ)
            0,
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            // (±1/φ, ±φ, 0)
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            0,
            // (±φ, 0, ±1/φ)
            -t,
            0,
            -r,
            t,
            0,
            -r,
            -t,
            0,
            r,
            t,
            0,
            r
        ];
        var indices = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ];
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, DodecahedronGeometry, [
            vertices,
            indices,
            radius,
            detail
        ]);
        _this.type = 'DodecahedronGeometry';
        _this.parameters = {
            radius: radius,
            detail: detail
        };
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(DodecahedronGeometry, null, [
        {
            key: "fromJSON",
            value: function fromJSON(data) {
                return new DodecahedronGeometry(data.radius, data.detail);
            }
        }
    ]);
    return DodecahedronGeometry;
}($1a55656020b89c3a$export$60e57a7d3f20ff65);
var $1a55656020b89c3a$var$_v0 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_v1$1 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_normal = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_triangle = /*@__PURE__*/ new $1a55656020b89c3a$export$5a465592bfe74b48();
var $1a55656020b89c3a$export$4730b1542707547f = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(EdgesGeometry, BufferGeometry);
    function EdgesGeometry() {
        var geometry = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, thresholdAngle = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, EdgesGeometry);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, EdgesGeometry);
        _this.type = 'EdgesGeometry';
        _this.parameters = {
            geometry: geometry,
            thresholdAngle: thresholdAngle
        };
        if (geometry !== null) {
            var precisionPoints = 4;
            var precision = Math.pow(10, precisionPoints);
            var thresholdDot = Math.cos($1a55656020b89c3a$var$DEG2RAD * thresholdAngle);
            var indexAttr = geometry.getIndex();
            var positionAttr = geometry.getAttribute('position');
            var indexCount = indexAttr ? indexAttr.count : positionAttr.count;
            var indexArr = [
                0,
                0,
                0
            ];
            var vertKeys = [
                'a',
                'b',
                'c'
            ];
            var hashes = new Array(3);
            var edgeData = {};
            var vertices = [];
            for(var i = 0; i < indexCount; i += 3){
                if (indexAttr) {
                    indexArr[0] = indexAttr.getX(i);
                    indexArr[1] = indexAttr.getX(i + 1);
                    indexArr[2] = indexAttr.getX(i + 2);
                } else {
                    indexArr[0] = i;
                    indexArr[1] = i + 1;
                    indexArr[2] = i + 2;
                }
                var a = $1a55656020b89c3a$var$_triangle.a, b = $1a55656020b89c3a$var$_triangle.b, c = $1a55656020b89c3a$var$_triangle.c;
                a.fromBufferAttribute(positionAttr, indexArr[0]);
                b.fromBufferAttribute(positionAttr, indexArr[1]);
                c.fromBufferAttribute(positionAttr, indexArr[2]);
                $1a55656020b89c3a$var$_triangle.getNormal($1a55656020b89c3a$var$_normal);
                // create hashes for the edge from the vertices
                hashes[0] = "".concat(Math.round(a.x * precision), ",").concat(Math.round(a.y * precision), ",").concat(Math.round(a.z * precision));
                hashes[1] = "".concat(Math.round(b.x * precision), ",").concat(Math.round(b.y * precision), ",").concat(Math.round(b.z * precision));
                hashes[2] = "".concat(Math.round(c.x * precision), ",").concat(Math.round(c.y * precision), ",").concat(Math.round(c.z * precision));
                // skip degenerate triangles
                if (hashes[0] === hashes[1] || hashes[1] === hashes[2] || hashes[2] === hashes[0]) continue;
                // iterate over every edge
                for(var j = 0; j < 3; j++){
                    // get the first and next vertex making up the edge
                    var jNext = (j + 1) % 3;
                    var vecHash0 = hashes[j];
                    var vecHash1 = hashes[jNext];
                    var v0 = $1a55656020b89c3a$var$_triangle[vertKeys[j]];
                    var v1 = $1a55656020b89c3a$var$_triangle[vertKeys[jNext]];
                    var hash = "".concat(vecHash0, "_").concat(vecHash1);
                    var reverseHash = "".concat(vecHash1, "_").concat(vecHash0);
                    if (reverseHash in edgeData && edgeData[reverseHash]) {
                        // if we found a sibling edge add it into the vertex array if
                        // it meets the angle threshold and delete the edge from the map.
                        if ($1a55656020b89c3a$var$_normal.dot(edgeData[reverseHash].normal) <= thresholdDot) {
                            vertices.push(v0.x, v0.y, v0.z);
                            vertices.push(v1.x, v1.y, v1.z);
                        }
                        edgeData[reverseHash] = null;
                    } else if (!(hash in edgeData)) // if we've already got an edge here then skip adding a new one
                    edgeData[hash] = {
                        index0: indexArr[j],
                        index1: indexArr[jNext],
                        normal: $1a55656020b89c3a$var$_normal.clone()
                    };
                }
            }
            // iterate over all remaining, unmatched edges and add them to the vertex array
            for(var key in edgeData)if (edgeData[key]) {
                var _edgeData_key = edgeData[key], index0 = _edgeData_key.index0, index1 = _edgeData_key.index1;
                $1a55656020b89c3a$var$_v0.fromBufferAttribute(positionAttr, index0);
                $1a55656020b89c3a$var$_v1$1.fromBufferAttribute(positionAttr, index1);
                vertices.push($1a55656020b89c3a$var$_v0.x, $1a55656020b89c3a$var$_v0.y, $1a55656020b89c3a$var$_v0.z);
                vertices.push($1a55656020b89c3a$var$_v1$1.x, $1a55656020b89c3a$var$_v1$1.y, $1a55656020b89c3a$var$_v1$1.z);
            }
            _this.setAttribute('position', new $1a55656020b89c3a$export$cbe7a62641830ebd(vertices, 3));
        }
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(EdgesGeometry, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(EdgesGeometry.prototype), "copy", this).call(this, source);
                this.parameters = Object.assign({}, source.parameters);
                return this;
            }
        }
    ]);
    return EdgesGeometry;
}($1a55656020b89c3a$export$b7be63a67df8959);
var $1a55656020b89c3a$export$6428a7f2611ef1fa = /*#__PURE__*/ function(Path1) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(Shape, Path1);
    function Shape(points) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Shape);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, Shape, [
            points
        ]);
        _this.uuid = $1a55656020b89c3a$var$generateUUID();
        _this.type = 'Shape';
        _this.holes = [];
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Shape, [
        {
            key: "getPointsHoles",
            value: function getPointsHoles(divisions) {
                var holesPts = [];
                for(var i = 0, l = this.holes.length; i < l; i++)holesPts[i] = this.holes[i].getPoints(divisions);
                return holesPts;
            }
        },
        {
            // get points of shape and holes (keypoints based on segments parameter)
            key: "extractPoints",
            value: function extractPoints(divisions) {
                return {
                    shape: this.getPoints(divisions),
                    holes: this.getPointsHoles(divisions)
                };
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(Shape.prototype), "copy", this).call(this, source);
                this.holes = [];
                for(var i = 0, l = source.holes.length; i < l; i++){
                    var hole = source.holes[i];
                    this.holes.push(hole.clone());
                }
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(Shape.prototype), "toJSON", this).call(this);
                data.uuid = this.uuid;
                data.holes = [];
                for(var i = 0, l = this.holes.length; i < l; i++){
                    var hole = this.holes[i];
                    data.holes.push(hole.toJSON());
                }
                return data;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(Shape.prototype), "fromJSON", this).call(this, json);
                this.uuid = json.uuid;
                this.holes = [];
                for(var i = 0, l = json.holes.length; i < l; i++){
                    var hole = json.holes[i];
                    this.holes.push(new $1a55656020b89c3a$export$4b2950bdac9b6ee9().fromJSON(hole));
                }
                return this;
            }
        }
    ]);
    return Shape;
}($1a55656020b89c3a$export$4b2950bdac9b6ee9);
/**
 * Port from https://github.com/mapbox/earcut (v2.2.4)
 */ var $1a55656020b89c3a$var$Earcut = {
    triangulate: function triangulate(data, holeIndices) {
        var dim = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2;
        var hasHoles = holeIndices && holeIndices.length;
        var outerLen = hasHoles ? holeIndices[0] * dim : data.length;
        var outerNode = $1a55656020b89c3a$var$linkedList(data, 0, outerLen, dim, true);
        var triangles = [];
        if (!outerNode || outerNode.next === outerNode.prev) return triangles;
        var minX, minY, maxX, maxY, x, y, invSize;
        if (hasHoles) outerNode = $1a55656020b89c3a$var$eliminateHoles(data, holeIndices, outerNode, dim);
        // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
        if (data.length > 80 * dim) {
            minX = maxX = data[0];
            minY = maxY = data[1];
            for(var i = dim; i < outerLen; i += dim){
                x = data[i];
                y = data[i + 1];
                if (x < minX) minX = x;
                if (y < minY) minY = y;
                if (x > maxX) maxX = x;
                if (y > maxY) maxY = y;
            }
            // minX, minY and invSize are later used to transform coords into integers for z-order calculation
            invSize = Math.max(maxX - minX, maxY - minY);
            invSize = invSize !== 0 ? 32767 / invSize : 0;
        }
        $1a55656020b89c3a$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
        return triangles;
    }
};
// create a circular doubly linked list from polygon points in the specified winding order
function $1a55656020b89c3a$var$linkedList(data, start, end, dim, clockwise) {
    var i, last;
    if (clockwise === $1a55656020b89c3a$var$signedArea(data, start, end, dim) > 0) for(i = start; i < end; i += dim)last = $1a55656020b89c3a$var$insertNode(i, data[i], data[i + 1], last);
    else for(i = end - dim; i >= start; i -= dim)last = $1a55656020b89c3a$var$insertNode(i, data[i], data[i + 1], last);
    if (last && $1a55656020b89c3a$var$equals(last, last.next)) {
        $1a55656020b89c3a$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $1a55656020b89c3a$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    var p = start, again;
    do {
        again = false;
        if (!p.steiner && ($1a55656020b89c3a$var$equals(p, p.next) || $1a55656020b89c3a$var$area(p.prev, p, p.next) === 0)) {
            $1a55656020b89c3a$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $1a55656020b89c3a$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $1a55656020b89c3a$var$indexCurve(ear, minX, minY, invSize);
    var stop = ear, prev, next;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        prev = ear.prev;
        next = ear.next;
        if (invSize ? $1a55656020b89c3a$var$isEarHashed(ear, minX, minY, invSize) : $1a55656020b89c3a$var$isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim | 0);
            triangles.push(ear.i / dim | 0);
            triangles.push(next.i / dim | 0);
            $1a55656020b89c3a$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $1a55656020b89c3a$var$earcutLinked($1a55656020b89c3a$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $1a55656020b89c3a$var$cureLocalIntersections($1a55656020b89c3a$var$filterPoints(ear), triangles, dim);
                $1a55656020b89c3a$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $1a55656020b89c3a$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $1a55656020b89c3a$var$isEar(ear) {
    var a = ear.prev, b = ear, c = ear.next;
    if ($1a55656020b89c3a$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    var ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    var x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    var p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && $1a55656020b89c3a$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $1a55656020b89c3a$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $1a55656020b89c3a$var$isEarHashed(ear, minX, minY, invSize) {
    var a = ear.prev, b = ear, c = ear.next;
    if ($1a55656020b89c3a$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    var ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    var x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    // z-order range for the current triangle bbox;
    var minZ = $1a55656020b89c3a$var$zOrder(x0, y0, minX, minY, invSize), maxZ = $1a55656020b89c3a$var$zOrder(x1, y1, minX, minY, invSize);
    var p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $1a55656020b89c3a$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $1a55656020b89c3a$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $1a55656020b89c3a$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $1a55656020b89c3a$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $1a55656020b89c3a$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $1a55656020b89c3a$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $1a55656020b89c3a$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $1a55656020b89c3a$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $1a55656020b89c3a$var$cureLocalIntersections(start, triangles, dim) {
    var p = start;
    do {
        var a = p.prev, b = p.next.next;
        if (!$1a55656020b89c3a$var$equals(a, b) && $1a55656020b89c3a$var$intersects(a, p, p.next, b) && $1a55656020b89c3a$var$locallyInside(a, b) && $1a55656020b89c3a$var$locallyInside(b, a)) {
            triangles.push(a.i / dim | 0);
            triangles.push(p.i / dim | 0);
            triangles.push(b.i / dim | 0);
            // remove two nodes involved
            $1a55656020b89c3a$var$removeNode(p);
            $1a55656020b89c3a$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $1a55656020b89c3a$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $1a55656020b89c3a$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    var a = start;
    do {
        var b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $1a55656020b89c3a$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                var c = $1a55656020b89c3a$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $1a55656020b89c3a$var$filterPoints(a, a.next);
                c = $1a55656020b89c3a$var$filterPoints(c, c.next);
                // run earcut on each half
                $1a55656020b89c3a$var$earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                $1a55656020b89c3a$var$earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $1a55656020b89c3a$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    var queue = [];
    var i, len, start, end, list;
    for(i = 0, len = holeIndices.length; i < len; i++){
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = $1a55656020b89c3a$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($1a55656020b89c3a$var$getLeftmost(list));
    }
    queue.sort($1a55656020b89c3a$var$compareX);
    // process holes from left to right
    for(i = 0; i < queue.length; i++)outerNode = $1a55656020b89c3a$var$eliminateHole(queue[i], outerNode);
    return outerNode;
}
function $1a55656020b89c3a$var$compareX(a, b) {
    return a.x - b.x;
}
// find a bridge between vertices that connects hole with an outer ring and link it
function $1a55656020b89c3a$var$eliminateHole(hole, outerNode) {
    var bridge = $1a55656020b89c3a$var$findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    var bridgeReverse = $1a55656020b89c3a$var$splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    $1a55656020b89c3a$var$filterPoints(bridgeReverse, bridgeReverse.next);
    return $1a55656020b89c3a$var$filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $1a55656020b89c3a$var$findHoleBridge(hole, outerNode) {
    var p = outerNode, qx = -Infinity, m;
    var hx = hole.x, hy = hole.y;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            var x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    var stop = m, mx = m.x, my = m.y;
    var tanMin = Infinity, tan;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $1a55656020b89c3a$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($1a55656020b89c3a$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $1a55656020b89c3a$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $1a55656020b89c3a$var$sectorContainsSector(m, p) {
    return $1a55656020b89c3a$var$area(m.prev, m, p.prev) < 0 && $1a55656020b89c3a$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $1a55656020b89c3a$var$indexCurve(start, minX, minY, invSize) {
    var p = start;
    do {
        if (p.z === 0) p.z = $1a55656020b89c3a$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $1a55656020b89c3a$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $1a55656020b89c3a$var$sortLinked(list) {
    var i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            q = p;
            pSize = 0;
            for(i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $1a55656020b89c3a$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $1a55656020b89c3a$var$getLeftmost(start) {
    var p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $1a55656020b89c3a$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $1a55656020b89c3a$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$1a55656020b89c3a$var$intersectsPolygon(a, b) && // doesn't intersect other edges
    ($1a55656020b89c3a$var$locallyInside(a, b) && $1a55656020b89c3a$var$locallyInside(b, a) && $1a55656020b89c3a$var$middleInside(a, b) && // locally visible
    ($1a55656020b89c3a$var$area(a.prev, a, b.prev) || $1a55656020b89c3a$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $1a55656020b89c3a$var$equals(a, b) && $1a55656020b89c3a$var$area(a.prev, a, a.next) > 0 && $1a55656020b89c3a$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $1a55656020b89c3a$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $1a55656020b89c3a$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $1a55656020b89c3a$var$intersects(p1, q1, p2, q2) {
    var o1 = $1a55656020b89c3a$var$sign($1a55656020b89c3a$var$area(p1, q1, p2));
    var o2 = $1a55656020b89c3a$var$sign($1a55656020b89c3a$var$area(p1, q1, q2));
    var o3 = $1a55656020b89c3a$var$sign($1a55656020b89c3a$var$area(p2, q2, p1));
    var o4 = $1a55656020b89c3a$var$sign($1a55656020b89c3a$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $1a55656020b89c3a$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $1a55656020b89c3a$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $1a55656020b89c3a$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $1a55656020b89c3a$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $1a55656020b89c3a$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $1a55656020b89c3a$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $1a55656020b89c3a$var$intersectsPolygon(a, b) {
    var p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $1a55656020b89c3a$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $1a55656020b89c3a$var$locallyInside(a, b) {
    return $1a55656020b89c3a$var$area(a.prev, a, a.next) < 0 ? $1a55656020b89c3a$var$area(a, b, a.next) >= 0 && $1a55656020b89c3a$var$area(a, a.prev, b) >= 0 : $1a55656020b89c3a$var$area(a, b, a.prev) < 0 || $1a55656020b89c3a$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $1a55656020b89c3a$var$middleInside(a, b) {
    var p = a, inside = false;
    var px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $1a55656020b89c3a$var$splitPolygon(a, b) {
    var a2 = new $1a55656020b89c3a$var$Node(a.i, a.x, a.y), b2 = new $1a55656020b89c3a$var$Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $1a55656020b89c3a$var$insertNode(i, x, y, last) {
    var p = new $1a55656020b89c3a$var$Node(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $1a55656020b89c3a$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $1a55656020b89c3a$var$Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;
    // vertex coordinates
    this.x = x;
    this.y = y;
    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;
    // z-order curve value
    this.z = 0;
    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;
    // indicates whether this is a steiner point
    this.steiner = false;
}
function $1a55656020b89c3a$var$signedArea(data, start, end, dim) {
    var sum = 0;
    for(var i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
var $1a55656020b89c3a$export$96bdf6d9c66d7ba8 = /*#__PURE__*/ function() {
    "use strict";
    function ShapeUtils() {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, ShapeUtils);
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(ShapeUtils, null, [
        {
            key: "area",
            value: // calculate area of the contour polygon
            function area(contour) {
                var n = contour.length;
                var a = 0.0;
                for(var p = n - 1, q = 0; q < n; p = q++)a += contour[p].x * contour[q].y - contour[q].x * contour[p].y;
                return a * 0.5;
            }
        },
        {
            key: "isClockWise",
            value: function isClockWise(pts) {
                return ShapeUtils.area(pts) < 0;
            }
        },
        {
            key: "triangulateShape",
            value: function triangulateShape(contour, holes) {
                var vertices = []; // flat array of vertices like [ x0,y0, x1,y1, x2,y2, ... ]
                var holeIndices = []; // array of hole indices
                var faces = []; // final array of vertex indices like [ [ a,b,d ], [ b,c,d ] ]
                $1a55656020b89c3a$var$removeDupEndPts(contour);
                $1a55656020b89c3a$var$addContour(vertices, contour);
                //
                var holeIndex = contour.length;
                holes.forEach($1a55656020b89c3a$var$removeDupEndPts);
                for(var i = 0; i < holes.length; i++){
                    holeIndices.push(holeIndex);
                    holeIndex += holes[i].length;
                    $1a55656020b89c3a$var$addContour(vertices, holes[i]);
                }
                //
                var triangles = $1a55656020b89c3a$var$Earcut.triangulate(vertices, holeIndices);
                //
                for(var i1 = 0; i1 < triangles.length; i1 += 3)faces.push(triangles.slice(i1, i1 + 3));
                return faces;
            }
        }
    ]);
    return ShapeUtils;
}();
function $1a55656020b89c3a$var$removeDupEndPts(points) {
    var l = points.length;
    if (l > 2 && points[l - 1].equals(points[0])) points.pop();
}
function $1a55656020b89c3a$var$addContour(vertices, contour) {
    for(var i = 0; i < contour.length; i++){
        vertices.push(contour[i].x);
        vertices.push(contour[i].y);
    }
}
/**
 * Creates extruded geometry from a path shape.
 *
 * parameters = {
 *
 *  curveSegments: <int>, // number of points on the curves
 *  steps: <int>, // number of points for z-side extrusions / used for subdividing segments of extrude spline too
 *  depth: <float>, // Depth to extrude the shape
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into the original shape bevel goes
 *  bevelSize: <float>, // how far from shape outline (including bevelOffset) is bevel
 *  bevelOffset: <float>, // how far from shape outline does bevel start
 *  bevelSegments: <int>, // number of bevel layers
 *
 *  extrudePath: <THREE.Curve> // curve to extrude shape along
 *
 *  UVGenerator: <Object> // object that provides UV generator functions
 *
 * }
 */ var $1a55656020b89c3a$export$598697a1efa63ca7 = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(ExtrudeGeometry, BufferGeometry);
    function ExtrudeGeometry() {
        var shapes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $1a55656020b89c3a$export$6428a7f2611ef1fa([
            new $1a55656020b89c3a$export$c977b3e384af9ae1(0.5, 0.5),
            new $1a55656020b89c3a$export$c977b3e384af9ae1(-0.5, 0.5),
            new $1a55656020b89c3a$export$c977b3e384af9ae1(-0.5, -0.5),
            new $1a55656020b89c3a$export$c977b3e384af9ae1(0.5, -0.5)
        ]), options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, ExtrudeGeometry);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, ExtrudeGeometry);
        _this.type = 'ExtrudeGeometry';
        _this.parameters = {
            shapes: shapes,
            options: options
        };
        shapes = Array.isArray(shapes) ? shapes : [
            shapes
        ];
        var scope = _this;
        var verticesArray = [];
        var uvArray = [];
        for(var i = 0, l = shapes.length; i < l; i++){
            var shape = shapes[i];
            addShape(shape);
        }
        // build geometry
        _this.setAttribute('position', new $1a55656020b89c3a$export$cbe7a62641830ebd(verticesArray, 3));
        _this.setAttribute('uv', new $1a55656020b89c3a$export$cbe7a62641830ebd(uvArray, 2));
        _this.computeVertexNormals();
        // functions
        function addShape(shape) {
            var placeholder = [];
            // options
            var curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
            var steps = options.steps !== undefined ? options.steps : 1;
            var depth = options.depth !== undefined ? options.depth : 1;
            var bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true;
            var bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 0.2;
            var bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 0.1;
            var bevelOffset = options.bevelOffset !== undefined ? options.bevelOffset : 0;
            var bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;
            var extrudePath = options.extrudePath;
            var uvgen = options.UVGenerator !== undefined ? options.UVGenerator : $1a55656020b89c3a$var$WorldUVGenerator;
            //
            var extrudePts, extrudeByPath = false;
            var splineTube, binormal, normal, position2;
            if (extrudePath) {
                extrudePts = extrudePath.getSpacedPoints(steps);
                extrudeByPath = true;
                bevelEnabled = false; // bevels not supported for path extrusion
                // SETUP TNB variables
                // TODO1 - have a .isClosed in spline?
                splineTube = extrudePath.computeFrenetFrames(steps, false);
                // console.log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);
                binormal = new $1a55656020b89c3a$export$64b5c384219d3699();
                normal = new $1a55656020b89c3a$export$64b5c384219d3699();
                position2 = new $1a55656020b89c3a$export$64b5c384219d3699();
            }
            // Safeguards if bevels are not enabled
            if (!bevelEnabled) {
                bevelSegments = 0;
                bevelThickness = 0;
                bevelSize = 0;
                bevelOffset = 0;
            }
            // Variables initialization
            var shapePoints = shape.extractPoints(curveSegments);
            var vertices = shapePoints.shape;
            var holes = shapePoints.holes;
            var reverse = !$1a55656020b89c3a$export$96bdf6d9c66d7ba8.isClockWise(vertices);
            if (reverse) {
                vertices = vertices.reverse();
                // Maybe we should also check if holes are in the opposite direction, just to be safe ...
                for(var h = 0, hl = holes.length; h < hl; h++){
                    var ahole = holes[h];
                    if ($1a55656020b89c3a$export$96bdf6d9c66d7ba8.isClockWise(ahole)) holes[h] = ahole.reverse();
                }
            }
            var faces = $1a55656020b89c3a$export$96bdf6d9c66d7ba8.triangulateShape(vertices, holes);
            /* Vertices */ var contour = vertices; // vertices has all points but contour has only points of circumference
            for(var h1 = 0, hl1 = holes.length; h1 < hl1; h1++){
                var ahole1 = holes[h1];
                vertices = vertices.concat(ahole1);
            }
            function scalePt2(pt, vec, size) {
                if (!vec) console.error('THREE.ExtrudeGeometry: vec does not exist');
                return pt.clone().addScaledVector(vec, size);
            }
            var vlen = vertices.length, flen = faces.length;
            // Find directions for point movement
            function getBevelVec(inPt, inPrev, inNext) {
                // computes for inPt the corresponding point inPt' on a new contour
                //   shifted by 1 unit (length of normalized vector) to the left
                // if we walk along contour clockwise, this new contour is outside the old one
                //
                // inPt' is the intersection of the two lines parallel to the two
                //  adjacent edges of inPt at a distance of 1 unit on the left side.
                var v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt
                // good reading for geometry algorithms (here: line-line intersection)
                // http://geomalgorithms.com/a05-_intersect-1.html
                var v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
                var v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;
                var v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y;
                // check for collinear edges
                var collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;
                if (Math.abs(collinear0) > Number.EPSILON) {
                    // not collinear
                    // length of vectors for normalizing
                    var v_prev_len = Math.sqrt(v_prev_lensq);
                    var v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y);
                    // shift adjacent points by unit vectors to the left
                    var ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
                    var ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
                    var ptNextShift_x = inNext.x - v_next_y / v_next_len;
                    var ptNextShift_y = inNext.y + v_next_x / v_next_len;
                    // scaling factor for v_prev to intersection point
                    var sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x);
                    // vector from inPt to intersection point
                    v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
                    v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y;
                    // Don't normalize!, otherwise sharp corners become ugly
                    //  but prevent crazy spikes
                    var v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
                    if (v_trans_lensq <= 2) return new $1a55656020b89c3a$export$c977b3e384af9ae1(v_trans_x, v_trans_y);
                    else shrink_by = Math.sqrt(v_trans_lensq / 2);
                } else {
                    // handle special case of collinear edges
                    var direction_eq = false; // assumes: opposite
                    if (v_prev_x > Number.EPSILON) {
                        if (v_next_x > Number.EPSILON) direction_eq = true;
                    } else {
                        if (v_prev_x < -Number.EPSILON) {
                            if (v_next_x < -Number.EPSILON) direction_eq = true;
                        } else if (Math.sign(v_prev_y) === Math.sign(v_next_y)) direction_eq = true;
                    }
                    if (direction_eq) {
                        // console.log("Warning: lines are a straight sequence");
                        v_trans_x = -v_prev_y;
                        v_trans_y = v_prev_x;
                        shrink_by = Math.sqrt(v_prev_lensq);
                    } else {
                        // console.log("Warning: lines are a straight spike");
                        v_trans_x = v_prev_x;
                        v_trans_y = v_prev_y;
                        shrink_by = Math.sqrt(v_prev_lensq / 2);
                    }
                }
                return new $1a55656020b89c3a$export$c977b3e384af9ae1(v_trans_x / shrink_by, v_trans_y / shrink_by);
            }
            var contourMovements = [];
            for(var i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                if (j === il) j = 0;
                if (k === il) k = 0;
                //  (j)---(i)---(k)
                // console.log('i,j,k', i, j , k)
                contourMovements[i] = getBevelVec(contour[i], contour[j], contour[k]);
            }
            var holesMovements = [];
            var oneHoleMovements, verticesMovements = contourMovements.concat();
            for(var h2 = 0, hl2 = holes.length; h2 < hl2; h2++){
                var ahole2 = holes[h2];
                oneHoleMovements = [];
                for(var i1 = 0, il1 = ahole2.length, j1 = il1 - 1, k1 = i1 + 1; i1 < il1; i1++, j1++, k1++){
                    if (j1 === il1) j1 = 0;
                    if (k1 === il1) k1 = 0;
                    //  (j)---(i)---(k)
                    oneHoleMovements[i1] = getBevelVec(ahole2[i1], ahole2[j1], ahole2[k1]);
                }
                holesMovements.push(oneHoleMovements);
                verticesMovements = verticesMovements.concat(oneHoleMovements);
            }
            // Loop bevelSegments, 1 for the front, 1 for the back
            for(var b = 0; b < bevelSegments; b++){
                //for ( b = bevelSegments; b > 0; b -- ) {
                var t = b / bevelSegments;
                var z = bevelThickness * Math.cos(t * Math.PI / 2);
                var bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(var i2 = 0, il2 = contour.length; i2 < il2; i2++){
                    var vert = scalePt2(contour[i2], contourMovements[i2], bs);
                    v(vert.x, vert.y, -z);
                }
                // expand holes
                for(var h3 = 0, hl3 = holes.length; h3 < hl3; h3++){
                    var ahole3 = holes[h3];
                    oneHoleMovements = holesMovements[h3];
                    for(var i3 = 0, il3 = ahole3.length; i3 < il3; i3++){
                        var vert1 = scalePt2(ahole3[i3], oneHoleMovements[i3], bs);
                        v(vert1.x, vert1.y, -z);
                    }
                }
            }
            var bs1 = bevelSize + bevelOffset;
            // Back facing vertices
            for(var i4 = 0; i4 < vlen; i4++){
                var vert2 = bevelEnabled ? scalePt2(vertices[i4], verticesMovements[i4], bs1) : vertices[i4];
                if (!extrudeByPath) v(vert2.x, vert2.y, 0);
                else {
                    // v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );
                    normal.copy(splineTube.normals[0]).multiplyScalar(vert2.x);
                    binormal.copy(splineTube.binormals[0]).multiplyScalar(vert2.y);
                    position2.copy(extrudePts[0]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add stepped vertices...
            // Including front facing vertices
            for(var s = 1; s <= steps; s++)for(var i5 = 0; i5 < vlen; i5++){
                var vert3 = bevelEnabled ? scalePt2(vertices[i5], verticesMovements[i5], bs1) : vertices[i5];
                if (!extrudeByPath) v(vert3.x, vert3.y, depth / steps * s);
                else {
                    // v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );
                    normal.copy(splineTube.normals[s]).multiplyScalar(vert3.x);
                    binormal.copy(splineTube.binormals[s]).multiplyScalar(vert3.y);
                    position2.copy(extrudePts[s]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add bevel segments planes
            //for ( b = 1; b <= bevelSegments; b ++ ) {
            for(var b1 = bevelSegments - 1; b1 >= 0; b1--){
                var t1 = b1 / bevelSegments;
                var z1 = bevelThickness * Math.cos(t1 * Math.PI / 2);
                var bs2 = bevelSize * Math.sin(t1 * Math.PI / 2) + bevelOffset;
                // contract shape
                for(var i6 = 0, il4 = contour.length; i6 < il4; i6++){
                    var vert4 = scalePt2(contour[i6], contourMovements[i6], bs2);
                    v(vert4.x, vert4.y, depth + z1);
                }
                // expand holes
                for(var h4 = 0, hl4 = holes.length; h4 < hl4; h4++){
                    var ahole4 = holes[h4];
                    oneHoleMovements = holesMovements[h4];
                    for(var i7 = 0, il5 = ahole4.length; i7 < il5; i7++){
                        var vert5 = scalePt2(ahole4[i7], oneHoleMovements[i7], bs2);
                        if (!extrudeByPath) v(vert5.x, vert5.y, depth + z1);
                        else v(vert5.x, vert5.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + z1);
                    }
                }
            }
            /* Faces */ // Top and bottom faces
            buildLidFaces();
            // Sides faces
            buildSideFaces();
            /////  Internal functions
            function buildLidFaces() {
                var start = verticesArray.length / 3;
                if (bevelEnabled) {
                    var layer = 0; // steps + 1
                    var offset = vlen * layer;
                    // Bottom faces
                    for(var i = 0; i < flen; i++){
                        var face = faces[i];
                        f3(face[2] + offset, face[1] + offset, face[0] + offset);
                    }
                    layer = steps + bevelSegments * 2;
                    offset = vlen * layer;
                    // Top faces
                    for(var i1 = 0; i1 < flen; i1++){
                        var face1 = faces[i1];
                        f3(face1[0] + offset, face1[1] + offset, face1[2] + offset);
                    }
                } else {
                    // Bottom faces
                    for(var i2 = 0; i2 < flen; i2++){
                        var face2 = faces[i2];
                        f3(face2[2], face2[1], face2[0]);
                    }
                    // Top faces
                    for(var i3 = 0; i3 < flen; i3++){
                        var face3 = faces[i3];
                        f3(face3[0] + vlen * steps, face3[1] + vlen * steps, face3[2] + vlen * steps);
                    }
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 0);
            }
            // Create faces for the z-sides of the shape
            function buildSideFaces() {
                var start = verticesArray.length / 3;
                var layeroffset = 0;
                sidewalls(contour, layeroffset);
                layeroffset += contour.length;
                for(var h = 0, hl = holes.length; h < hl; h++){
                    var ahole = holes[h];
                    sidewalls(ahole, layeroffset);
                    //, true
                    layeroffset += ahole.length;
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 1);
            }
            function sidewalls(contour, layeroffset) {
                var i = contour.length;
                while(--i >= 0){
                    var j = i;
                    var k = i - 1;
                    if (k < 0) k = contour.length - 1;
                    //console.log('b', i,j, i-1, k,vertices.length);
                    for(var s = 0, sl = steps + bevelSegments * 2; s < sl; s++){
                        var slen1 = vlen * s;
                        var slen2 = vlen * (s + 1);
                        var a = layeroffset + j + slen1, b = layeroffset + k + slen1, c = layeroffset + k + slen2, d = layeroffset + j + slen2;
                        f4(a, b, c, d);
                    }
                }
            }
            function v(x, y, z) {
                placeholder.push(x);
                placeholder.push(y);
                placeholder.push(z);
            }
            function f3(a, b, c) {
                addVertex(a);
                addVertex(b);
                addVertex(c);
                var nextIndex = verticesArray.length / 3;
                var uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[2]);
            }
            function f4(a, b, c, d) {
                addVertex(a);
                addVertex(b);
                addVertex(d);
                addVertex(b);
                addVertex(c);
                addVertex(d);
                var nextIndex = verticesArray.length / 3;
                var uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[3]);
                addUV(uvs[1]);
                addUV(uvs[2]);
                addUV(uvs[3]);
            }
            function addVertex(index) {
                verticesArray.push(placeholder[index * 3 + 0]);
                verticesArray.push(placeholder[index * 3 + 1]);
                verticesArray.push(placeholder[index * 3 + 2]);
            }
            function addUV(vector2) {
                uvArray.push(vector2.x);
                uvArray.push(vector2.y);
            }
        }
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(ExtrudeGeometry, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(ExtrudeGeometry.prototype), "copy", this).call(this, source);
                this.parameters = Object.assign({}, source.parameters);
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(ExtrudeGeometry.prototype), "toJSON", this).call(this);
                var shapes = this.parameters.shapes;
                var options = this.parameters.options;
                return $1a55656020b89c3a$var$toJSON$1(shapes, options, data);
            }
        }
    ], [
        {
            key: "fromJSON",
            value: function fromJSON(data, shapes) {
                var geometryShapes = [];
                for(var j = 0, jl = data.shapes.length; j < jl; j++){
                    var shape = shapes[data.shapes[j]];
                    geometryShapes.push(shape);
                }
                var extrudePath = data.options.extrudePath;
                if (extrudePath !== undefined) data.options.extrudePath = new $1a55656020b89c3a$var$Curves[extrudePath.type]().fromJSON(extrudePath);
                return new ExtrudeGeometry(geometryShapes, data.options);
            }
        }
    ]);
    return ExtrudeGeometry;
}($1a55656020b89c3a$export$b7be63a67df8959);
var $1a55656020b89c3a$var$WorldUVGenerator = {
    generateTopUV: function generateTopUV(geometry, vertices, indexA, indexB, indexC) {
        var a_x = vertices[indexA * 3];
        var a_y = vertices[indexA * 3 + 1];
        var b_x = vertices[indexB * 3];
        var b_y = vertices[indexB * 3 + 1];
        var c_x = vertices[indexC * 3];
        var c_y = vertices[indexC * 3 + 1];
        return [
            new $1a55656020b89c3a$export$c977b3e384af9ae1(a_x, a_y),
            new $1a55656020b89c3a$export$c977b3e384af9ae1(b_x, b_y),
            new $1a55656020b89c3a$export$c977b3e384af9ae1(c_x, c_y)
        ];
    },
    generateSideWallUV: function generateSideWallUV(geometry, vertices, indexA, indexB, indexC, indexD) {
        var a_x = vertices[indexA * 3];
        var a_y = vertices[indexA * 3 + 1];
        var a_z = vertices[indexA * 3 + 2];
        var b_x = vertices[indexB * 3];
        var b_y = vertices[indexB * 3 + 1];
        var b_z = vertices[indexB * 3 + 2];
        var c_x = vertices[indexC * 3];
        var c_y = vertices[indexC * 3 + 1];
        var c_z = vertices[indexC * 3 + 2];
        var d_x = vertices[indexD * 3];
        var d_y = vertices[indexD * 3 + 1];
        var d_z = vertices[indexD * 3 + 2];
        if (Math.abs(a_y - b_y) < Math.abs(a_x - b_x)) return [
            new $1a55656020b89c3a$export$c977b3e384af9ae1(a_x, 1 - a_z),
            new $1a55656020b89c3a$export$c977b3e384af9ae1(b_x, 1 - b_z),
            new $1a55656020b89c3a$export$c977b3e384af9ae1(c_x, 1 - c_z),
            new $1a55656020b89c3a$export$c977b3e384af9ae1(d_x, 1 - d_z)
        ];
        else return [
            new $1a55656020b89c3a$export$c977b3e384af9ae1(a_y, 1 - a_z),
            new $1a55656020b89c3a$export$c977b3e384af9ae1(b_y, 1 - b_z),
            new $1a55656020b89c3a$export$c977b3e384af9ae1(c_y, 1 - c_z),
            new $1a55656020b89c3a$export$c977b3e384af9ae1(d_y, 1 - d_z)
        ];
    }
};
function $1a55656020b89c3a$var$toJSON$1(shapes, options, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(var i = 0, l = shapes.length; i < l; i++){
        var shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    data.options = Object.assign({}, options);
    if (options.extrudePath !== undefined) data.options.extrudePath = options.extrudePath.toJSON();
    return data;
}
var $1a55656020b89c3a$export$9567cc828c9535da = /*#__PURE__*/ function(PolyhedronGeometry) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(IcosahedronGeometry, PolyhedronGeometry);
    function IcosahedronGeometry() {
        var radius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, detail = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, IcosahedronGeometry);
        var _this;
        var t = (1 + Math.sqrt(5)) / 2;
        var vertices = [
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            0,
            0,
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            t,
            0,
            -1,
            t,
            0,
            1,
            -t,
            0,
            -1,
            -t,
            0,
            1
        ];
        var indices = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ];
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, IcosahedronGeometry, [
            vertices,
            indices,
            radius,
            detail
        ]);
        _this.type = 'IcosahedronGeometry';
        _this.parameters = {
            radius: radius,
            detail: detail
        };
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(IcosahedronGeometry, null, [
        {
            key: "fromJSON",
            value: function fromJSON(data) {
                return new IcosahedronGeometry(data.radius, data.detail);
            }
        }
    ]);
    return IcosahedronGeometry;
}($1a55656020b89c3a$export$60e57a7d3f20ff65);
var $1a55656020b89c3a$export$1954e2b809fe361e = /*#__PURE__*/ function(PolyhedronGeometry) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(OctahedronGeometry, PolyhedronGeometry);
    function OctahedronGeometry() {
        var radius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, detail = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, OctahedronGeometry);
        var _this;
        var vertices = [
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1
        ];
        var indices = [
            0,
            2,
            4,
            0,
            4,
            3,
            0,
            3,
            5,
            0,
            5,
            2,
            1,
            2,
            5,
            1,
            5,
            3,
            1,
            3,
            4,
            1,
            4,
            2
        ];
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, OctahedronGeometry, [
            vertices,
            indices,
            radius,
            detail
        ]);
        _this.type = 'OctahedronGeometry';
        _this.parameters = {
            radius: radius,
            detail: detail
        };
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(OctahedronGeometry, null, [
        {
            key: "fromJSON",
            value: function fromJSON(data) {
                return new OctahedronGeometry(data.radius, data.detail);
            }
        }
    ]);
    return OctahedronGeometry;
}($1a55656020b89c3a$export$60e57a7d3f20ff65);
var $1a55656020b89c3a$export$967d831af31f69ce = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(PlaneGeometry, BufferGeometry);
    function PlaneGeometry() {
        var width = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, height = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, widthSegments = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, heightSegments = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, PlaneGeometry);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, PlaneGeometry);
        _this.type = 'PlaneGeometry';
        _this.parameters = {
            width: width,
            height: height,
            widthSegments: widthSegments,
            heightSegments: heightSegments
        };
        var width_half = width / 2;
        var height_half = height / 2;
        var gridX = Math.floor(widthSegments);
        var gridY = Math.floor(heightSegments);
        var gridX1 = gridX + 1;
        var gridY1 = gridY + 1;
        var segment_width = width / gridX;
        var segment_height = height / gridY;
        //
        var indices = [];
        var vertices = [];
        var normals = [];
        var uvs = [];
        for(var iy = 0; iy < gridY1; iy++){
            var y = iy * segment_height - height_half;
            for(var ix = 0; ix < gridX1; ix++){
                var x = ix * segment_width - width_half;
                vertices.push(x, -y, 0);
                normals.push(0, 0, 1);
                uvs.push(ix / gridX);
                uvs.push(1 - iy / gridY);
            }
        }
        for(var iy1 = 0; iy1 < gridY; iy1++)for(var ix1 = 0; ix1 < gridX; ix1++){
            var a = ix1 + gridX1 * iy1;
            var b = ix1 + gridX1 * (iy1 + 1);
            var c = ix1 + 1 + gridX1 * (iy1 + 1);
            var d = ix1 + 1 + gridX1 * iy1;
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        _this.setIndex(indices);
        _this.setAttribute('position', new $1a55656020b89c3a$export$cbe7a62641830ebd(vertices, 3));
        _this.setAttribute('normal', new $1a55656020b89c3a$export$cbe7a62641830ebd(normals, 3));
        _this.setAttribute('uv', new $1a55656020b89c3a$export$cbe7a62641830ebd(uvs, 2));
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(PlaneGeometry, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(PlaneGeometry.prototype), "copy", this).call(this, source);
                this.parameters = Object.assign({}, source.parameters);
                return this;
            }
        }
    ], [
        {
            key: "fromJSON",
            value: function fromJSON(data) {
                return new PlaneGeometry(data.width, data.height, data.widthSegments, data.heightSegments);
            }
        }
    ]);
    return PlaneGeometry;
}($1a55656020b89c3a$export$b7be63a67df8959);
var $1a55656020b89c3a$export$68cb731f50f614af = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(RingGeometry, BufferGeometry);
    function RingGeometry() {
        var innerRadius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0.5, outerRadius = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, thetaSegments = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 32, phiSegments = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1, thetaStart = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0, thetaLength = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : Math.PI * 2;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, RingGeometry);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, RingGeometry);
        _this.type = 'RingGeometry';
        _this.parameters = {
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            thetaSegments: thetaSegments,
            phiSegments: phiSegments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        thetaSegments = Math.max(3, thetaSegments);
        phiSegments = Math.max(1, phiSegments);
        // buffers
        var indices = [];
        var vertices = [];
        var normals = [];
        var uvs = [];
        // some helper variables
        var radius = innerRadius;
        var radiusStep = (outerRadius - innerRadius) / phiSegments;
        var vertex = new $1a55656020b89c3a$export$64b5c384219d3699();
        var uv = new $1a55656020b89c3a$export$c977b3e384af9ae1();
        // generate vertices, normals and uvs
        for(var j = 0; j <= phiSegments; j++){
            for(var i = 0; i <= thetaSegments; i++){
                // values are generate from the inside of the ring to the outside
                var segment = thetaStart + i / thetaSegments * thetaLength;
                // vertex
                vertex.x = radius * Math.cos(segment);
                vertex.y = radius * Math.sin(segment);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, 0, 1);
                // uv
                uv.x = (vertex.x / outerRadius + 1) / 2;
                uv.y = (vertex.y / outerRadius + 1) / 2;
                uvs.push(uv.x, uv.y);
            }
            // increase the radius for next row of vertices
            radius += radiusStep;
        }
        // indices
        for(var j1 = 0; j1 < phiSegments; j1++){
            var thetaSegmentLevel = j1 * (thetaSegments + 1);
            for(var i1 = 0; i1 < thetaSegments; i1++){
                var segment1 = i1 + thetaSegmentLevel;
                var a = segment1;
                var b = segment1 + thetaSegments + 1;
                var c = segment1 + thetaSegments + 2;
                var d = segment1 + 1;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        // build geometry
        _this.setIndex(indices);
        _this.setAttribute('position', new $1a55656020b89c3a$export$cbe7a62641830ebd(vertices, 3));
        _this.setAttribute('normal', new $1a55656020b89c3a$export$cbe7a62641830ebd(normals, 3));
        _this.setAttribute('uv', new $1a55656020b89c3a$export$cbe7a62641830ebd(uvs, 2));
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(RingGeometry, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(RingGeometry.prototype), "copy", this).call(this, source);
                this.parameters = Object.assign({}, source.parameters);
                return this;
            }
        }
    ], [
        {
            key: "fromJSON",
            value: function fromJSON(data) {
                return new RingGeometry(data.innerRadius, data.outerRadius, data.thetaSegments, data.phiSegments, data.thetaStart, data.thetaLength);
            }
        }
    ]);
    return RingGeometry;
}($1a55656020b89c3a$export$b7be63a67df8959);
var $1a55656020b89c3a$export$57a29a1c803e9065 = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(ShapeGeometry, BufferGeometry);
    function ShapeGeometry() {
        var shapes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $1a55656020b89c3a$export$6428a7f2611ef1fa([
            new $1a55656020b89c3a$export$c977b3e384af9ae1(0, 0.5),
            new $1a55656020b89c3a$export$c977b3e384af9ae1(-0.5, -0.5),
            new $1a55656020b89c3a$export$c977b3e384af9ae1(0.5, -0.5)
        ]), curveSegments = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 12;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, ShapeGeometry);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, ShapeGeometry);
        _this.type = 'ShapeGeometry';
        _this.parameters = {
            shapes: shapes,
            curveSegments: curveSegments
        };
        // buffers
        var indices = [];
        var vertices = [];
        var normals = [];
        var uvs = [];
        // helper variables
        var groupStart = 0;
        var groupCount = 0;
        // allow single and array values for "shapes" parameter
        if (Array.isArray(shapes) === false) addShape(shapes);
        else for(var i = 0; i < shapes.length; i++){
            addShape(shapes[i]);
            _this.addGroup(groupStart, groupCount, i); // enables MultiMaterial support
            groupStart += groupCount;
            groupCount = 0;
        }
        // build geometry
        _this.setIndex(indices);
        _this.setAttribute('position', new $1a55656020b89c3a$export$cbe7a62641830ebd(vertices, 3));
        _this.setAttribute('normal', new $1a55656020b89c3a$export$cbe7a62641830ebd(normals, 3));
        _this.setAttribute('uv', new $1a55656020b89c3a$export$cbe7a62641830ebd(uvs, 2));
        // helper functions
        function addShape(shape) {
            var indexOffset = vertices.length / 3;
            var points = shape.extractPoints(curveSegments);
            var shapeVertices = points.shape;
            var shapeHoles = points.holes;
            // check direction of vertices
            if ($1a55656020b89c3a$export$96bdf6d9c66d7ba8.isClockWise(shapeVertices) === false) shapeVertices = shapeVertices.reverse();
            for(var i = 0, l = shapeHoles.length; i < l; i++){
                var shapeHole = shapeHoles[i];
                if ($1a55656020b89c3a$export$96bdf6d9c66d7ba8.isClockWise(shapeHole) === true) shapeHoles[i] = shapeHole.reverse();
            }
            var faces = $1a55656020b89c3a$export$96bdf6d9c66d7ba8.triangulateShape(shapeVertices, shapeHoles);
            // join vertices of inner and outer paths to a single array
            for(var i1 = 0, l1 = shapeHoles.length; i1 < l1; i1++){
                var shapeHole1 = shapeHoles[i1];
                shapeVertices = shapeVertices.concat(shapeHole1);
            }
            // vertices, normals, uvs
            for(var i2 = 0, l2 = shapeVertices.length; i2 < l2; i2++){
                var vertex = shapeVertices[i2];
                vertices.push(vertex.x, vertex.y, 0);
                normals.push(0, 0, 1);
                uvs.push(vertex.x, vertex.y); // world uvs
            }
            // indices
            for(var i3 = 0, l3 = faces.length; i3 < l3; i3++){
                var face = faces[i3];
                var a = face[0] + indexOffset;
                var b = face[1] + indexOffset;
                var c = face[2] + indexOffset;
                indices.push(a, b, c);
                groupCount += 3;
            }
        }
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(ShapeGeometry, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(ShapeGeometry.prototype), "copy", this).call(this, source);
                this.parameters = Object.assign({}, source.parameters);
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON1() {
                var data = (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(ShapeGeometry.prototype), "toJSON", this).call(this);
                var shapes = this.parameters.shapes;
                return $1a55656020b89c3a$var$toJSON(shapes, data);
            }
        }
    ], [
        {
            key: "fromJSON",
            value: function fromJSON(data, shapes) {
                var geometryShapes = [];
                for(var j = 0, jl = data.shapes.length; j < jl; j++){
                    var shape = shapes[data.shapes[j]];
                    geometryShapes.push(shape);
                }
                return new ShapeGeometry(geometryShapes, data.curveSegments);
            }
        }
    ]);
    return ShapeGeometry;
}($1a55656020b89c3a$export$b7be63a67df8959);
function $1a55656020b89c3a$var$toJSON(shapes, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(var i = 0, l = shapes.length; i < l; i++){
        var shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    return data;
}
var $1a55656020b89c3a$export$1b417fc3b307a251 = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(SphereGeometry, BufferGeometry);
    function SphereGeometry() {
        var radius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, widthSegments = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 32, heightSegments = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 16, phiStart = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, phiLength = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : Math.PI * 2, thetaStart = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0, thetaLength = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : Math.PI;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, SphereGeometry);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, SphereGeometry);
        _this.type = 'SphereGeometry';
        _this.parameters = {
            radius: radius,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            phiStart: phiStart,
            phiLength: phiLength,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        widthSegments = Math.max(3, Math.floor(widthSegments));
        heightSegments = Math.max(2, Math.floor(heightSegments));
        var thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);
        var index = 0;
        var grid = [];
        var vertex = new $1a55656020b89c3a$export$64b5c384219d3699();
        var normal = new $1a55656020b89c3a$export$64b5c384219d3699();
        // buffers
        var indices = [];
        var vertices = [];
        var normals = [];
        var uvs = [];
        // generate vertices, normals and uvs
        for(var iy = 0; iy <= heightSegments; iy++){
            var verticesRow = [];
            var v = iy / heightSegments;
            // special case for the poles
            var uOffset = 0;
            if (iy === 0 && thetaStart === 0) uOffset = 0.5 / widthSegments;
            else if (iy === heightSegments && thetaEnd === Math.PI) uOffset = -0.5 / widthSegments;
            for(var ix = 0; ix <= widthSegments; ix++){
                var u = ix / widthSegments;
                // vertex
                vertex.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertex.y = radius * Math.cos(thetaStart + v * thetaLength);
                vertex.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.copy(vertex).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, 1 - v);
                verticesRow.push(index++);
            }
            grid.push(verticesRow);
        }
        // indices
        for(var iy1 = 0; iy1 < heightSegments; iy1++)for(var ix1 = 0; ix1 < widthSegments; ix1++){
            var a = grid[iy1][ix1 + 1];
            var b = grid[iy1][ix1];
            var c = grid[iy1 + 1][ix1];
            var d = grid[iy1 + 1][ix1 + 1];
            if (iy1 !== 0 || thetaStart > 0) indices.push(a, b, d);
            if (iy1 !== heightSegments - 1 || thetaEnd < Math.PI) indices.push(b, c, d);
        }
        // build geometry
        _this.setIndex(indices);
        _this.setAttribute('position', new $1a55656020b89c3a$export$cbe7a62641830ebd(vertices, 3));
        _this.setAttribute('normal', new $1a55656020b89c3a$export$cbe7a62641830ebd(normals, 3));
        _this.setAttribute('uv', new $1a55656020b89c3a$export$cbe7a62641830ebd(uvs, 2));
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(SphereGeometry, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(SphereGeometry.prototype), "copy", this).call(this, source);
                this.parameters = Object.assign({}, source.parameters);
                return this;
            }
        }
    ], [
        {
            key: "fromJSON",
            value: function fromJSON(data) {
                return new SphereGeometry(data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength);
            }
        }
    ]);
    return SphereGeometry;
}($1a55656020b89c3a$export$b7be63a67df8959);
var $1a55656020b89c3a$export$fb3f7adc68bd6e02 = /*#__PURE__*/ function(PolyhedronGeometry) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(TetrahedronGeometry, PolyhedronGeometry);
    function TetrahedronGeometry() {
        var radius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, detail = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, TetrahedronGeometry);
        var _this;
        var vertices = [
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            1,
            -1,
            -1
        ];
        var indices = [
            2,
            1,
            0,
            0,
            3,
            2,
            1,
            3,
            0,
            2,
            3,
            1
        ];
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, TetrahedronGeometry, [
            vertices,
            indices,
            radius,
            detail
        ]);
        _this.type = 'TetrahedronGeometry';
        _this.parameters = {
            radius: radius,
            detail: detail
        };
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(TetrahedronGeometry, null, [
        {
            key: "fromJSON",
            value: function fromJSON(data) {
                return new TetrahedronGeometry(data.radius, data.detail);
            }
        }
    ]);
    return TetrahedronGeometry;
}($1a55656020b89c3a$export$60e57a7d3f20ff65);
var $1a55656020b89c3a$export$a2312a2a1fa56495 = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(TorusGeometry, BufferGeometry);
    function TorusGeometry() {
        var radius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, tube = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0.4, radialSegments = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 12, tubularSegments = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 48, arc = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : Math.PI * 2;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, TorusGeometry);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, TorusGeometry);
        _this.type = 'TorusGeometry';
        _this.parameters = {
            radius: radius,
            tube: tube,
            radialSegments: radialSegments,
            tubularSegments: tubularSegments,
            arc: arc
        };
        radialSegments = Math.floor(radialSegments);
        tubularSegments = Math.floor(tubularSegments);
        // buffers
        var indices = [];
        var vertices = [];
        var normals = [];
        var uvs = [];
        // helper variables
        var center = new $1a55656020b89c3a$export$64b5c384219d3699();
        var vertex = new $1a55656020b89c3a$export$64b5c384219d3699();
        var normal = new $1a55656020b89c3a$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(var j = 0; j <= radialSegments; j++)for(var i = 0; i <= tubularSegments; i++){
            var u = i / tubularSegments * arc;
            var v = j / radialSegments * Math.PI * 2;
            // vertex
            vertex.x = (radius + tube * Math.cos(v)) * Math.cos(u);
            vertex.y = (radius + tube * Math.cos(v)) * Math.sin(u);
            vertex.z = tube * Math.sin(v);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            center.x = radius * Math.cos(u);
            center.y = radius * Math.sin(u);
            normal.subVectors(vertex, center).normalize();
            normals.push(normal.x, normal.y, normal.z);
            // uv
            uvs.push(i / tubularSegments);
            uvs.push(j / radialSegments);
        }
        // generate indices
        for(var j1 = 1; j1 <= radialSegments; j1++)for(var i1 = 1; i1 <= tubularSegments; i1++){
            // indices
            var a = (tubularSegments + 1) * j1 + i1 - 1;
            var b = (tubularSegments + 1) * (j1 - 1) + i1 - 1;
            var c = (tubularSegments + 1) * (j1 - 1) + i1;
            var d = (tubularSegments + 1) * j1 + i1;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        _this.setIndex(indices);
        _this.setAttribute('position', new $1a55656020b89c3a$export$cbe7a62641830ebd(vertices, 3));
        _this.setAttribute('normal', new $1a55656020b89c3a$export$cbe7a62641830ebd(normals, 3));
        _this.setAttribute('uv', new $1a55656020b89c3a$export$cbe7a62641830ebd(uvs, 2));
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(TorusGeometry, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(TorusGeometry.prototype), "copy", this).call(this, source);
                this.parameters = Object.assign({}, source.parameters);
                return this;
            }
        }
    ], [
        {
            key: "fromJSON",
            value: function fromJSON(data) {
                return new TorusGeometry(data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc);
            }
        }
    ]);
    return TorusGeometry;
}($1a55656020b89c3a$export$b7be63a67df8959);
var $1a55656020b89c3a$export$77e9bfadfb9ab8c8 = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(TorusKnotGeometry, BufferGeometry);
    function TorusKnotGeometry() {
        var radius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, tube = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0.4, tubularSegments = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 64, radialSegments = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 8, p = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 2, q = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 3;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, TorusKnotGeometry);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, TorusKnotGeometry);
        _this.type = 'TorusKnotGeometry';
        _this.parameters = {
            radius: radius,
            tube: tube,
            tubularSegments: tubularSegments,
            radialSegments: radialSegments,
            p: p,
            q: q
        };
        tubularSegments = Math.floor(tubularSegments);
        radialSegments = Math.floor(radialSegments);
        // buffers
        var indices = [];
        var vertices = [];
        var normals = [];
        var uvs = [];
        // helper variables
        var vertex = new $1a55656020b89c3a$export$64b5c384219d3699();
        var normal = new $1a55656020b89c3a$export$64b5c384219d3699();
        var P1 = new $1a55656020b89c3a$export$64b5c384219d3699();
        var P2 = new $1a55656020b89c3a$export$64b5c384219d3699();
        var B = new $1a55656020b89c3a$export$64b5c384219d3699();
        var T = new $1a55656020b89c3a$export$64b5c384219d3699();
        var N = new $1a55656020b89c3a$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(var i = 0; i <= tubularSegments; ++i){
            // the radian "u" is used to calculate the position on the torus curve of the current tubular segment
            var u = i / tubularSegments * p * Math.PI * 2;
            // now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
            // these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions
            calculatePositionOnCurve(u, p, q, radius, P1);
            calculatePositionOnCurve(u + 0.01, p, q, radius, P2);
            // calculate orthonormal basis
            T.subVectors(P2, P1);
            N.addVectors(P2, P1);
            B.crossVectors(T, N);
            N.crossVectors(B, T);
            // normalize B, N. T can be ignored, we don't use it
            B.normalize();
            N.normalize();
            for(var j = 0; j <= radialSegments; ++j){
                // now calculate the vertices. they are nothing more than an extrusion of the torus curve.
                // because we extrude a shape in the xy-plane, there is no need to calculate a z-value.
                var v = j / radialSegments * Math.PI * 2;
                var cx = -tube * Math.cos(v);
                var cy = tube * Math.sin(v);
                // now calculate the final vertex position.
                // first we orient the extrusion with our basis vectors, then we add it to the current position on the curve
                vertex.x = P1.x + (cx * N.x + cy * B.x);
                vertex.y = P1.y + (cx * N.y + cy * B.y);
                vertex.z = P1.z + (cx * N.z + cy * B.z);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)
                normal.subVectors(vertex, P1).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(i / tubularSegments);
                uvs.push(j / radialSegments);
            }
        }
        // generate indices
        for(var j1 = 1; j1 <= tubularSegments; j1++)for(var i1 = 1; i1 <= radialSegments; i1++){
            // indices
            var a = (radialSegments + 1) * (j1 - 1) + (i1 - 1);
            var b = (radialSegments + 1) * j1 + (i1 - 1);
            var c = (radialSegments + 1) * j1 + i1;
            var d = (radialSegments + 1) * (j1 - 1) + i1;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        _this.setIndex(indices);
        _this.setAttribute('position', new $1a55656020b89c3a$export$cbe7a62641830ebd(vertices, 3));
        _this.setAttribute('normal', new $1a55656020b89c3a$export$cbe7a62641830ebd(normals, 3));
        _this.setAttribute('uv', new $1a55656020b89c3a$export$cbe7a62641830ebd(uvs, 2));
        // this function calculates the current position on the torus curve
        function calculatePositionOnCurve(u, p, q, radius, position) {
            var cu = Math.cos(u);
            var su = Math.sin(u);
            var quOverP = q / p * u;
            var cs = Math.cos(quOverP);
            position.x = radius * (2 + cs) * 0.5 * cu;
            position.y = radius * (2 + cs) * su * 0.5;
            position.z = radius * Math.sin(quOverP) * 0.5;
        }
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(TorusKnotGeometry, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(TorusKnotGeometry.prototype), "copy", this).call(this, source);
                this.parameters = Object.assign({}, source.parameters);
                return this;
            }
        }
    ], [
        {
            key: "fromJSON",
            value: function fromJSON(data) {
                return new TorusKnotGeometry(data.radius, data.tube, data.tubularSegments, data.radialSegments, data.p, data.q);
            }
        }
    ]);
    return TorusKnotGeometry;
}($1a55656020b89c3a$export$b7be63a67df8959);
var $1a55656020b89c3a$export$7897d9d48904490c = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(TubeGeometry, BufferGeometry);
    function TubeGeometry() {
        var path = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $1a55656020b89c3a$export$bf3f4c7e459f90fc(new $1a55656020b89c3a$export$64b5c384219d3699(-1, -1, 0), new $1a55656020b89c3a$export$64b5c384219d3699(-1, 1, 0), new $1a55656020b89c3a$export$64b5c384219d3699(1, 1, 0)), tubularSegments = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 64, radius = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, radialSegments = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 8, closed = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, TubeGeometry);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, TubeGeometry);
        _this.type = 'TubeGeometry';
        _this.parameters = {
            path: path,
            tubularSegments: tubularSegments,
            radius: radius,
            radialSegments: radialSegments,
            closed: closed
        };
        var frames = path.computeFrenetFrames(tubularSegments, closed);
        // expose internals
        _this.tangents = frames.tangents;
        _this.normals = frames.normals;
        _this.binormals = frames.binormals;
        // helper variables
        var vertex = new $1a55656020b89c3a$export$64b5c384219d3699();
        var normal = new $1a55656020b89c3a$export$64b5c384219d3699();
        var uv = new $1a55656020b89c3a$export$c977b3e384af9ae1();
        var P = new $1a55656020b89c3a$export$64b5c384219d3699();
        // buffer
        var vertices = [];
        var normals = [];
        var uvs = [];
        var indices = [];
        // create buffer data
        generateBufferData();
        // build geometry
        _this.setIndex(indices);
        _this.setAttribute('position', new $1a55656020b89c3a$export$cbe7a62641830ebd(vertices, 3));
        _this.setAttribute('normal', new $1a55656020b89c3a$export$cbe7a62641830ebd(normals, 3));
        _this.setAttribute('uv', new $1a55656020b89c3a$export$cbe7a62641830ebd(uvs, 2));
        // functions
        function generateBufferData() {
            for(var i = 0; i < tubularSegments; i++)generateSegment(i);
            // if the geometry is not closed, generate the last row of vertices and normals
            // at the regular position on the given path
            //
            // if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)
            generateSegment(closed === false ? tubularSegments : 0);
            // uvs are generated in a separate function.
            // this makes it easy compute correct values for closed geometries
            generateUVs();
            // finally create faces
            generateIndices();
        }
        function generateSegment(i) {
            // we use getPointAt to sample evenly distributed points from the given path
            P = path.getPointAt(i / tubularSegments, P);
            // retrieve corresponding normal and binormal
            var N = frames.normals[i];
            var B = frames.binormals[i];
            // generate normals and vertices for the current segment
            for(var j = 0; j <= radialSegments; j++){
                var v = j / radialSegments * Math.PI * 2;
                var sin = Math.sin(v);
                var cos = -Math.cos(v);
                // normal
                normal.x = cos * N.x + sin * B.x;
                normal.y = cos * N.y + sin * B.y;
                normal.z = cos * N.z + sin * B.z;
                normal.normalize();
                normals.push(normal.x, normal.y, normal.z);
                // vertex
                vertex.x = P.x + radius * normal.x;
                vertex.y = P.y + radius * normal.y;
                vertex.z = P.z + radius * normal.z;
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        }
        function generateIndices() {
            for(var j = 1; j <= tubularSegments; j++)for(var i = 1; i <= radialSegments; i++){
                var a = (radialSegments + 1) * (j - 1) + (i - 1);
                var b = (radialSegments + 1) * j + (i - 1);
                var c = (radialSegments + 1) * j + i;
                var d = (radialSegments + 1) * (j - 1) + i;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        function generateUVs() {
            for(var i = 0; i <= tubularSegments; i++)for(var j = 0; j <= radialSegments; j++){
                uv.x = i / tubularSegments;
                uv.y = j / radialSegments;
                uvs.push(uv.x, uv.y);
            }
        }
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(TubeGeometry, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(TubeGeometry.prototype), "copy", this).call(this, source);
                this.parameters = Object.assign({}, source.parameters);
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(TubeGeometry.prototype), "toJSON", this).call(this);
                data.path = this.parameters.path.toJSON();
                return data;
            }
        }
    ], [
        {
            key: "fromJSON",
            value: function fromJSON(data) {
                // This only works for built-in curves (e.g. CatmullRomCurve3).
                // User defined curves or instances of CurvePath will not be deserialized.
                return new TubeGeometry(new $1a55656020b89c3a$var$Curves[data.path.type]().fromJSON(data.path), data.tubularSegments, data.radius, data.radialSegments, data.closed);
            }
        }
    ]);
    return TubeGeometry;
}($1a55656020b89c3a$export$b7be63a67df8959);
var $1a55656020b89c3a$export$4b739da06d24892b = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(WireframeGeometry, BufferGeometry);
    function WireframeGeometry() {
        var geometry = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, WireframeGeometry);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, WireframeGeometry);
        _this.type = 'WireframeGeometry';
        _this.parameters = {
            geometry: geometry
        };
        if (geometry !== null) {
            // buffer
            var vertices = [];
            var edges = new Set();
            // helper variables
            var start = new $1a55656020b89c3a$export$64b5c384219d3699();
            var end = new $1a55656020b89c3a$export$64b5c384219d3699();
            if (geometry.index !== null) {
                // indexed BufferGeometry
                var position = geometry.attributes.position;
                var indices = geometry.index;
                var groups = geometry.groups;
                if (groups.length === 0) groups = [
                    {
                        start: 0,
                        count: indices.count,
                        materialIndex: 0
                    }
                ];
                // create a data structure that contains all edges without duplicates
                for(var o = 0, ol = groups.length; o < ol; ++o){
                    var group = groups[o];
                    var groupStart = group.start;
                    var groupCount = group.count;
                    for(var i = groupStart, l = groupStart + groupCount; i < l; i += 3)for(var j = 0; j < 3; j++){
                        var index1 = indices.getX(i + j);
                        var index2 = indices.getX(i + (j + 1) % 3);
                        start.fromBufferAttribute(position, index1);
                        end.fromBufferAttribute(position, index2);
                        if ($1a55656020b89c3a$var$isUniqueEdge(start, end, edges) === true) {
                            vertices.push(start.x, start.y, start.z);
                            vertices.push(end.x, end.y, end.z);
                        }
                    }
                }
            } else {
                // non-indexed BufferGeometry
                var position1 = geometry.attributes.position;
                for(var i1 = 0, l1 = position1.count / 3; i1 < l1; i1++)for(var j1 = 0; j1 < 3; j1++){
                    // three edges per triangle, an edge is represented as (index1, index2)
                    // e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)
                    var index11 = 3 * i1 + j1;
                    var index21 = 3 * i1 + (j1 + 1) % 3;
                    start.fromBufferAttribute(position1, index11);
                    end.fromBufferAttribute(position1, index21);
                    if ($1a55656020b89c3a$var$isUniqueEdge(start, end, edges) === true) {
                        vertices.push(start.x, start.y, start.z);
                        vertices.push(end.x, end.y, end.z);
                    }
                }
            }
            // build geometry
            _this.setAttribute('position', new $1a55656020b89c3a$export$cbe7a62641830ebd(vertices, 3));
        }
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(WireframeGeometry, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(WireframeGeometry.prototype), "copy", this).call(this, source);
                this.parameters = Object.assign({}, source.parameters);
                return this;
            }
        }
    ]);
    return WireframeGeometry;
}($1a55656020b89c3a$export$b7be63a67df8959);
function $1a55656020b89c3a$var$isUniqueEdge(start, end, edges) {
    var hash1 = "".concat(start.x, ",").concat(start.y, ",").concat(start.z, "-").concat(end.x, ",").concat(end.y, ",").concat(end.z);
    var hash2 = "".concat(end.x, ",").concat(end.y, ",").concat(end.z, "-").concat(start.x, ",").concat(start.y, ",").concat(start.z); // coincident edge
    if (edges.has(hash1) === true || edges.has(hash2) === true) return false;
    else {
        edges.add(hash1);
        edges.add(hash2);
        return true;
    }
}
var $1a55656020b89c3a$var$Geometries = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BoxGeometry: $1a55656020b89c3a$export$33e43285f7406bd5,
    CapsuleGeometry: $1a55656020b89c3a$export$41680e8551036033,
    CircleGeometry: $1a55656020b89c3a$export$d5c0e8d607467193,
    ConeGeometry: $1a55656020b89c3a$export$a7a48974f285c9b3,
    CylinderGeometry: $1a55656020b89c3a$export$68f745719dbe5198,
    DodecahedronGeometry: $1a55656020b89c3a$export$c0babfeb8708fc9c,
    EdgesGeometry: $1a55656020b89c3a$export$4730b1542707547f,
    ExtrudeGeometry: $1a55656020b89c3a$export$598697a1efa63ca7,
    IcosahedronGeometry: $1a55656020b89c3a$export$9567cc828c9535da,
    LatheGeometry: $1a55656020b89c3a$export$6d839803fcd1882c,
    OctahedronGeometry: $1a55656020b89c3a$export$1954e2b809fe361e,
    PlaneGeometry: $1a55656020b89c3a$export$967d831af31f69ce,
    PolyhedronGeometry: $1a55656020b89c3a$export$60e57a7d3f20ff65,
    RingGeometry: $1a55656020b89c3a$export$68cb731f50f614af,
    ShapeGeometry: $1a55656020b89c3a$export$57a29a1c803e9065,
    SphereGeometry: $1a55656020b89c3a$export$1b417fc3b307a251,
    TetrahedronGeometry: $1a55656020b89c3a$export$fb3f7adc68bd6e02,
    TorusGeometry: $1a55656020b89c3a$export$a2312a2a1fa56495,
    TorusKnotGeometry: $1a55656020b89c3a$export$77e9bfadfb9ab8c8,
    TubeGeometry: $1a55656020b89c3a$export$7897d9d48904490c,
    WireframeGeometry: $1a55656020b89c3a$export$4b739da06d24892b
});
var $1a55656020b89c3a$export$e8564da406055a3 = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(ShadowMaterial, Material);
    function ShadowMaterial(parameters) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, ShadowMaterial);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, ShadowMaterial);
        _this.isShadowMaterial = true;
        _this.type = 'ShadowMaterial';
        _this.color = new $1a55656020b89c3a$export$892596cec99bc70e(0x000000);
        _this.transparent = true;
        _this.fog = true;
        _this.setValues(parameters);
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(ShadowMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(ShadowMaterial.prototype), "copy", this).call(this, source);
                this.color.copy(source.color);
                this.fog = source.fog;
                return this;
            }
        }
    ]);
    return ShadowMaterial;
}($1a55656020b89c3a$export$a2d8b23205c25948);
var $1a55656020b89c3a$export$21c421a2e1df9d22 = /*#__PURE__*/ function(ShaderMaterial) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(RawShaderMaterial, ShaderMaterial);
    function RawShaderMaterial(parameters) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, RawShaderMaterial);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, RawShaderMaterial, [
            parameters
        ]);
        _this.isRawShaderMaterial = true;
        _this.type = 'RawShaderMaterial';
        return _this;
    }
    return RawShaderMaterial;
}($1a55656020b89c3a$export$83c7d75d550a8b0d);
var $1a55656020b89c3a$export$f2980790215acccd = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(MeshStandardMaterial, Material);
    function MeshStandardMaterial(parameters) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, MeshStandardMaterial);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, MeshStandardMaterial);
        _this.isMeshStandardMaterial = true;
        _this.type = 'MeshStandardMaterial';
        _this.defines = {
            'STANDARD': ''
        };
        _this.color = new $1a55656020b89c3a$export$892596cec99bc70e(0xffffff); // diffuse
        _this.roughness = 1.0;
        _this.metalness = 0.0;
        _this.map = null;
        _this.lightMap = null;
        _this.lightMapIntensity = 1.0;
        _this.aoMap = null;
        _this.aoMapIntensity = 1.0;
        _this.emissive = new $1a55656020b89c3a$export$892596cec99bc70e(0x000000);
        _this.emissiveIntensity = 1.0;
        _this.emissiveMap = null;
        _this.bumpMap = null;
        _this.bumpScale = 1;
        _this.normalMap = null;
        _this.normalMapType = $1a55656020b89c3a$export$2852a58ebdac27b8;
        _this.normalScale = new $1a55656020b89c3a$export$c977b3e384af9ae1(1, 1);
        _this.displacementMap = null;
        _this.displacementScale = 1;
        _this.displacementBias = 0;
        _this.roughnessMap = null;
        _this.metalnessMap = null;
        _this.alphaMap = null;
        _this.envMap = null;
        _this.envMapRotation = new $1a55656020b89c3a$export$d93cc409a0768c5f();
        _this.envMapIntensity = 1.0;
        _this.wireframe = false;
        _this.wireframeLinewidth = 1;
        _this.wireframeLinecap = 'round';
        _this.wireframeLinejoin = 'round';
        _this.flatShading = false;
        _this.fog = true;
        _this.setValues(parameters);
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(MeshStandardMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(MeshStandardMaterial.prototype), "copy", this).call(this, source);
                this.defines = {
                    'STANDARD': ''
                };
                this.color.copy(source.color);
                this.roughness = source.roughness;
                this.metalness = source.metalness;
                this.map = source.map;
                this.lightMap = source.lightMap;
                this.lightMapIntensity = source.lightMapIntensity;
                this.aoMap = source.aoMap;
                this.aoMapIntensity = source.aoMapIntensity;
                this.emissive.copy(source.emissive);
                this.emissiveMap = source.emissiveMap;
                this.emissiveIntensity = source.emissiveIntensity;
                this.bumpMap = source.bumpMap;
                this.bumpScale = source.bumpScale;
                this.normalMap = source.normalMap;
                this.normalMapType = source.normalMapType;
                this.normalScale.copy(source.normalScale);
                this.displacementMap = source.displacementMap;
                this.displacementScale = source.displacementScale;
                this.displacementBias = source.displacementBias;
                this.roughnessMap = source.roughnessMap;
                this.metalnessMap = source.metalnessMap;
                this.alphaMap = source.alphaMap;
                this.envMap = source.envMap;
                this.envMapRotation.copy(source.envMapRotation);
                this.envMapIntensity = source.envMapIntensity;
                this.wireframe = source.wireframe;
                this.wireframeLinewidth = source.wireframeLinewidth;
                this.wireframeLinecap = source.wireframeLinecap;
                this.wireframeLinejoin = source.wireframeLinejoin;
                this.flatShading = source.flatShading;
                this.fog = source.fog;
                return this;
            }
        }
    ]);
    return MeshStandardMaterial;
}($1a55656020b89c3a$export$a2d8b23205c25948);
var $1a55656020b89c3a$export$28d04986c4269c9f = /*#__PURE__*/ function(MeshStandardMaterial) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(MeshPhysicalMaterial, MeshStandardMaterial);
    function MeshPhysicalMaterial(parameters) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, MeshPhysicalMaterial);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, MeshPhysicalMaterial);
        _this.isMeshPhysicalMaterial = true;
        _this.defines = {
            'STANDARD': '',
            'PHYSICAL': ''
        };
        _this.type = 'MeshPhysicalMaterial';
        _this.anisotropyRotation = 0;
        _this.anisotropyMap = null;
        _this.clearcoatMap = null;
        _this.clearcoatRoughness = 0.0;
        _this.clearcoatRoughnessMap = null;
        _this.clearcoatNormalScale = new $1a55656020b89c3a$export$c977b3e384af9ae1(1, 1);
        _this.clearcoatNormalMap = null;
        _this.ior = 1.5;
        Object.defineProperty(_this, 'reflectivity', {
            get: function get() {
                return $1a55656020b89c3a$var$clamp(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
            },
            set: function set(reflectivity) {
                this.ior = (1 + 0.4 * reflectivity) / (1 - 0.4 * reflectivity);
            }
        });
        _this.iridescenceMap = null;
        _this.iridescenceIOR = 1.3;
        _this.iridescenceThicknessRange = [
            100,
            400
        ];
        _this.iridescenceThicknessMap = null;
        _this.sheenColor = new $1a55656020b89c3a$export$892596cec99bc70e(0x000000);
        _this.sheenColorMap = null;
        _this.sheenRoughness = 1.0;
        _this.sheenRoughnessMap = null;
        _this.transmissionMap = null;
        _this.thickness = 0;
        _this.thicknessMap = null;
        _this.attenuationDistance = Infinity;
        _this.attenuationColor = new $1a55656020b89c3a$export$892596cec99bc70e(1, 1, 1);
        _this.specularIntensity = 1.0;
        _this.specularIntensityMap = null;
        _this.specularColor = new $1a55656020b89c3a$export$892596cec99bc70e(1, 1, 1);
        _this.specularColorMap = null;
        _this._anisotropy = 0;
        _this._clearcoat = 0;
        _this._dispersion = 0;
        _this._iridescence = 0;
        _this._sheen = 0.0;
        _this._transmission = 0;
        _this.setValues(parameters);
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(MeshPhysicalMaterial, [
        {
            key: "anisotropy",
            get: function get() {
                return this._anisotropy;
            },
            set: function set(value) {
                if (this._anisotropy > 0 !== value > 0) this.version++;
                this._anisotropy = value;
            }
        },
        {
            key: "clearcoat",
            get: function get() {
                return this._clearcoat;
            },
            set: function set(value) {
                if (this._clearcoat > 0 !== value > 0) this.version++;
                this._clearcoat = value;
            }
        },
        {
            key: "iridescence",
            get: function get() {
                return this._iridescence;
            },
            set: function set(value) {
                if (this._iridescence > 0 !== value > 0) this.version++;
                this._iridescence = value;
            }
        },
        {
            key: "dispersion",
            get: function get() {
                return this._dispersion;
            },
            set: function set(value) {
                if (this._dispersion > 0 !== value > 0) this.version++;
                this._dispersion = value;
            }
        },
        {
            key: "sheen",
            get: function get() {
                return this._sheen;
            },
            set: function set(value) {
                if (this._sheen > 0 !== value > 0) this.version++;
                this._sheen = value;
            }
        },
        {
            key: "transmission",
            get: function get() {
                return this._transmission;
            },
            set: function set(value) {
                if (this._transmission > 0 !== value > 0) this.version++;
                this._transmission = value;
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(MeshPhysicalMaterial.prototype), "copy", this).call(this, source);
                this.defines = {
                    'STANDARD': '',
                    'PHYSICAL': ''
                };
                this.anisotropy = source.anisotropy;
                this.anisotropyRotation = source.anisotropyRotation;
                this.anisotropyMap = source.anisotropyMap;
                this.clearcoat = source.clearcoat;
                this.clearcoatMap = source.clearcoatMap;
                this.clearcoatRoughness = source.clearcoatRoughness;
                this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
                this.clearcoatNormalMap = source.clearcoatNormalMap;
                this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
                this.dispersion = source.dispersion;
                this.ior = source.ior;
                this.iridescence = source.iridescence;
                this.iridescenceMap = source.iridescenceMap;
                this.iridescenceIOR = source.iridescenceIOR;
                this.iridescenceThicknessRange = (0, $4fcd3d80e9e33ca7$export$71511d61b312f219)(source.iridescenceThicknessRange);
                this.iridescenceThicknessMap = source.iridescenceThicknessMap;
                this.sheen = source.sheen;
                this.sheenColor.copy(source.sheenColor);
                this.sheenColorMap = source.sheenColorMap;
                this.sheenRoughness = source.sheenRoughness;
                this.sheenRoughnessMap = source.sheenRoughnessMap;
                this.transmission = source.transmission;
                this.transmissionMap = source.transmissionMap;
                this.thickness = source.thickness;
                this.thicknessMap = source.thicknessMap;
                this.attenuationDistance = source.attenuationDistance;
                this.attenuationColor.copy(source.attenuationColor);
                this.specularIntensity = source.specularIntensity;
                this.specularIntensityMap = source.specularIntensityMap;
                this.specularColor.copy(source.specularColor);
                this.specularColorMap = source.specularColorMap;
                return this;
            }
        }
    ]);
    return MeshPhysicalMaterial;
}($1a55656020b89c3a$export$f2980790215acccd);
var $1a55656020b89c3a$export$24c72f71cbaf0678 = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(MeshPhongMaterial, Material);
    function MeshPhongMaterial(parameters) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, MeshPhongMaterial);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, MeshPhongMaterial);
        _this.isMeshPhongMaterial = true;
        _this.type = 'MeshPhongMaterial';
        _this.color = new $1a55656020b89c3a$export$892596cec99bc70e(0xffffff); // diffuse
        _this.specular = new $1a55656020b89c3a$export$892596cec99bc70e(0x111111);
        _this.shininess = 30;
        _this.map = null;
        _this.lightMap = null;
        _this.lightMapIntensity = 1.0;
        _this.aoMap = null;
        _this.aoMapIntensity = 1.0;
        _this.emissive = new $1a55656020b89c3a$export$892596cec99bc70e(0x000000);
        _this.emissiveIntensity = 1.0;
        _this.emissiveMap = null;
        _this.bumpMap = null;
        _this.bumpScale = 1;
        _this.normalMap = null;
        _this.normalMapType = $1a55656020b89c3a$export$2852a58ebdac27b8;
        _this.normalScale = new $1a55656020b89c3a$export$c977b3e384af9ae1(1, 1);
        _this.displacementMap = null;
        _this.displacementScale = 1;
        _this.displacementBias = 0;
        _this.specularMap = null;
        _this.alphaMap = null;
        _this.envMap = null;
        _this.envMapRotation = new $1a55656020b89c3a$export$d93cc409a0768c5f();
        _this.combine = $1a55656020b89c3a$export$e50ac29801f1774d;
        _this.reflectivity = 1;
        _this.refractionRatio = 0.98;
        _this.wireframe = false;
        _this.wireframeLinewidth = 1;
        _this.wireframeLinecap = 'round';
        _this.wireframeLinejoin = 'round';
        _this.flatShading = false;
        _this.fog = true;
        _this.setValues(parameters);
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(MeshPhongMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(MeshPhongMaterial.prototype), "copy", this).call(this, source);
                this.color.copy(source.color);
                this.specular.copy(source.specular);
                this.shininess = source.shininess;
                this.map = source.map;
                this.lightMap = source.lightMap;
                this.lightMapIntensity = source.lightMapIntensity;
                this.aoMap = source.aoMap;
                this.aoMapIntensity = source.aoMapIntensity;
                this.emissive.copy(source.emissive);
                this.emissiveMap = source.emissiveMap;
                this.emissiveIntensity = source.emissiveIntensity;
                this.bumpMap = source.bumpMap;
                this.bumpScale = source.bumpScale;
                this.normalMap = source.normalMap;
                this.normalMapType = source.normalMapType;
                this.normalScale.copy(source.normalScale);
                this.displacementMap = source.displacementMap;
                this.displacementScale = source.displacementScale;
                this.displacementBias = source.displacementBias;
                this.specularMap = source.specularMap;
                this.alphaMap = source.alphaMap;
                this.envMap = source.envMap;
                this.envMapRotation.copy(source.envMapRotation);
                this.combine = source.combine;
                this.reflectivity = source.reflectivity;
                this.refractionRatio = source.refractionRatio;
                this.wireframe = source.wireframe;
                this.wireframeLinewidth = source.wireframeLinewidth;
                this.wireframeLinecap = source.wireframeLinecap;
                this.wireframeLinejoin = source.wireframeLinejoin;
                this.flatShading = source.flatShading;
                this.fog = source.fog;
                return this;
            }
        }
    ]);
    return MeshPhongMaterial;
}($1a55656020b89c3a$export$a2d8b23205c25948);
var $1a55656020b89c3a$export$df893cf97e765622 = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(MeshToonMaterial, Material);
    function MeshToonMaterial(parameters) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, MeshToonMaterial);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, MeshToonMaterial);
        _this.isMeshToonMaterial = true;
        _this.defines = {
            'TOON': ''
        };
        _this.type = 'MeshToonMaterial';
        _this.color = new $1a55656020b89c3a$export$892596cec99bc70e(0xffffff);
        _this.map = null;
        _this.gradientMap = null;
        _this.lightMap = null;
        _this.lightMapIntensity = 1.0;
        _this.aoMap = null;
        _this.aoMapIntensity = 1.0;
        _this.emissive = new $1a55656020b89c3a$export$892596cec99bc70e(0x000000);
        _this.emissiveIntensity = 1.0;
        _this.emissiveMap = null;
        _this.bumpMap = null;
        _this.bumpScale = 1;
        _this.normalMap = null;
        _this.normalMapType = $1a55656020b89c3a$export$2852a58ebdac27b8;
        _this.normalScale = new $1a55656020b89c3a$export$c977b3e384af9ae1(1, 1);
        _this.displacementMap = null;
        _this.displacementScale = 1;
        _this.displacementBias = 0;
        _this.alphaMap = null;
        _this.wireframe = false;
        _this.wireframeLinewidth = 1;
        _this.wireframeLinecap = 'round';
        _this.wireframeLinejoin = 'round';
        _this.fog = true;
        _this.setValues(parameters);
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(MeshToonMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(MeshToonMaterial.prototype), "copy", this).call(this, source);
                this.color.copy(source.color);
                this.map = source.map;
                this.gradientMap = source.gradientMap;
                this.lightMap = source.lightMap;
                this.lightMapIntensity = source.lightMapIntensity;
                this.aoMap = source.aoMap;
                this.aoMapIntensity = source.aoMapIntensity;
                this.emissive.copy(source.emissive);
                this.emissiveMap = source.emissiveMap;
                this.emissiveIntensity = source.emissiveIntensity;
                this.bumpMap = source.bumpMap;
                this.bumpScale = source.bumpScale;
                this.normalMap = source.normalMap;
                this.normalMapType = source.normalMapType;
                this.normalScale.copy(source.normalScale);
                this.displacementMap = source.displacementMap;
                this.displacementScale = source.displacementScale;
                this.displacementBias = source.displacementBias;
                this.alphaMap = source.alphaMap;
                this.wireframe = source.wireframe;
                this.wireframeLinewidth = source.wireframeLinewidth;
                this.wireframeLinecap = source.wireframeLinecap;
                this.wireframeLinejoin = source.wireframeLinejoin;
                this.fog = source.fog;
                return this;
            }
        }
    ]);
    return MeshToonMaterial;
}($1a55656020b89c3a$export$a2d8b23205c25948);
var $1a55656020b89c3a$export$bfe8c0a091f41ae7 = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(MeshNormalMaterial, Material);
    function MeshNormalMaterial(parameters) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, MeshNormalMaterial);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, MeshNormalMaterial);
        _this.isMeshNormalMaterial = true;
        _this.type = 'MeshNormalMaterial';
        _this.bumpMap = null;
        _this.bumpScale = 1;
        _this.normalMap = null;
        _this.normalMapType = $1a55656020b89c3a$export$2852a58ebdac27b8;
        _this.normalScale = new $1a55656020b89c3a$export$c977b3e384af9ae1(1, 1);
        _this.displacementMap = null;
        _this.displacementScale = 1;
        _this.displacementBias = 0;
        _this.wireframe = false;
        _this.wireframeLinewidth = 1;
        _this.flatShading = false;
        _this.setValues(parameters);
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(MeshNormalMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(MeshNormalMaterial.prototype), "copy", this).call(this, source);
                this.bumpMap = source.bumpMap;
                this.bumpScale = source.bumpScale;
                this.normalMap = source.normalMap;
                this.normalMapType = source.normalMapType;
                this.normalScale.copy(source.normalScale);
                this.displacementMap = source.displacementMap;
                this.displacementScale = source.displacementScale;
                this.displacementBias = source.displacementBias;
                this.wireframe = source.wireframe;
                this.wireframeLinewidth = source.wireframeLinewidth;
                this.flatShading = source.flatShading;
                return this;
            }
        }
    ]);
    return MeshNormalMaterial;
}($1a55656020b89c3a$export$a2d8b23205c25948);
var $1a55656020b89c3a$export$5023a9a8114806b8 = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(MeshLambertMaterial, Material);
    function MeshLambertMaterial(parameters) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, MeshLambertMaterial);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, MeshLambertMaterial);
        _this.isMeshLambertMaterial = true;
        _this.type = 'MeshLambertMaterial';
        _this.color = new $1a55656020b89c3a$export$892596cec99bc70e(0xffffff); // diffuse
        _this.map = null;
        _this.lightMap = null;
        _this.lightMapIntensity = 1.0;
        _this.aoMap = null;
        _this.aoMapIntensity = 1.0;
        _this.emissive = new $1a55656020b89c3a$export$892596cec99bc70e(0x000000);
        _this.emissiveIntensity = 1.0;
        _this.emissiveMap = null;
        _this.bumpMap = null;
        _this.bumpScale = 1;
        _this.normalMap = null;
        _this.normalMapType = $1a55656020b89c3a$export$2852a58ebdac27b8;
        _this.normalScale = new $1a55656020b89c3a$export$c977b3e384af9ae1(1, 1);
        _this.displacementMap = null;
        _this.displacementScale = 1;
        _this.displacementBias = 0;
        _this.specularMap = null;
        _this.alphaMap = null;
        _this.envMap = null;
        _this.envMapRotation = new $1a55656020b89c3a$export$d93cc409a0768c5f();
        _this.combine = $1a55656020b89c3a$export$e50ac29801f1774d;
        _this.reflectivity = 1;
        _this.refractionRatio = 0.98;
        _this.wireframe = false;
        _this.wireframeLinewidth = 1;
        _this.wireframeLinecap = 'round';
        _this.wireframeLinejoin = 'round';
        _this.flatShading = false;
        _this.fog = true;
        _this.setValues(parameters);
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(MeshLambertMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(MeshLambertMaterial.prototype), "copy", this).call(this, source);
                this.color.copy(source.color);
                this.map = source.map;
                this.lightMap = source.lightMap;
                this.lightMapIntensity = source.lightMapIntensity;
                this.aoMap = source.aoMap;
                this.aoMapIntensity = source.aoMapIntensity;
                this.emissive.copy(source.emissive);
                this.emissiveMap = source.emissiveMap;
                this.emissiveIntensity = source.emissiveIntensity;
                this.bumpMap = source.bumpMap;
                this.bumpScale = source.bumpScale;
                this.normalMap = source.normalMap;
                this.normalMapType = source.normalMapType;
                this.normalScale.copy(source.normalScale);
                this.displacementMap = source.displacementMap;
                this.displacementScale = source.displacementScale;
                this.displacementBias = source.displacementBias;
                this.specularMap = source.specularMap;
                this.alphaMap = source.alphaMap;
                this.envMap = source.envMap;
                this.envMapRotation.copy(source.envMapRotation);
                this.combine = source.combine;
                this.reflectivity = source.reflectivity;
                this.refractionRatio = source.refractionRatio;
                this.wireframe = source.wireframe;
                this.wireframeLinewidth = source.wireframeLinewidth;
                this.wireframeLinecap = source.wireframeLinecap;
                this.wireframeLinejoin = source.wireframeLinejoin;
                this.flatShading = source.flatShading;
                this.fog = source.fog;
                return this;
            }
        }
    ]);
    return MeshLambertMaterial;
}($1a55656020b89c3a$export$a2d8b23205c25948);
var $1a55656020b89c3a$export$2698c22ec13825db = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(MeshDepthMaterial, Material);
    function MeshDepthMaterial(parameters) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, MeshDepthMaterial);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, MeshDepthMaterial);
        _this.isMeshDepthMaterial = true;
        _this.type = 'MeshDepthMaterial';
        _this.depthPacking = $1a55656020b89c3a$export$deeb383078690b50;
        _this.map = null;
        _this.alphaMap = null;
        _this.displacementMap = null;
        _this.displacementScale = 1;
        _this.displacementBias = 0;
        _this.wireframe = false;
        _this.wireframeLinewidth = 1;
        _this.setValues(parameters);
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(MeshDepthMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(MeshDepthMaterial.prototype), "copy", this).call(this, source);
                this.depthPacking = source.depthPacking;
                this.map = source.map;
                this.alphaMap = source.alphaMap;
                this.displacementMap = source.displacementMap;
                this.displacementScale = source.displacementScale;
                this.displacementBias = source.displacementBias;
                this.wireframe = source.wireframe;
                this.wireframeLinewidth = source.wireframeLinewidth;
                return this;
            }
        }
    ]);
    return MeshDepthMaterial;
}($1a55656020b89c3a$export$a2d8b23205c25948);
var $1a55656020b89c3a$export$33e187ed002f2a19 = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(MeshDistanceMaterial, Material);
    function MeshDistanceMaterial(parameters) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, MeshDistanceMaterial);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, MeshDistanceMaterial);
        _this.isMeshDistanceMaterial = true;
        _this.type = 'MeshDistanceMaterial';
        _this.map = null;
        _this.alphaMap = null;
        _this.displacementMap = null;
        _this.displacementScale = 1;
        _this.displacementBias = 0;
        _this.setValues(parameters);
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(MeshDistanceMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(MeshDistanceMaterial.prototype), "copy", this).call(this, source);
                this.map = source.map;
                this.alphaMap = source.alphaMap;
                this.displacementMap = source.displacementMap;
                this.displacementScale = source.displacementScale;
                this.displacementBias = source.displacementBias;
                return this;
            }
        }
    ]);
    return MeshDistanceMaterial;
}($1a55656020b89c3a$export$a2d8b23205c25948);
var $1a55656020b89c3a$export$6f5fef6235ec12ee = /*#__PURE__*/ function(Material) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(MeshMatcapMaterial, Material);
    function MeshMatcapMaterial(parameters) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, MeshMatcapMaterial);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, MeshMatcapMaterial);
        _this.isMeshMatcapMaterial = true;
        _this.defines = {
            'MATCAP': ''
        };
        _this.type = 'MeshMatcapMaterial';
        _this.color = new $1a55656020b89c3a$export$892596cec99bc70e(0xffffff); // diffuse
        _this.matcap = null;
        _this.map = null;
        _this.bumpMap = null;
        _this.bumpScale = 1;
        _this.normalMap = null;
        _this.normalMapType = $1a55656020b89c3a$export$2852a58ebdac27b8;
        _this.normalScale = new $1a55656020b89c3a$export$c977b3e384af9ae1(1, 1);
        _this.displacementMap = null;
        _this.displacementScale = 1;
        _this.displacementBias = 0;
        _this.alphaMap = null;
        _this.flatShading = false;
        _this.fog = true;
        _this.setValues(parameters);
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(MeshMatcapMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(MeshMatcapMaterial.prototype), "copy", this).call(this, source);
                this.defines = {
                    'MATCAP': ''
                };
                this.color.copy(source.color);
                this.matcap = source.matcap;
                this.map = source.map;
                this.bumpMap = source.bumpMap;
                this.bumpScale = source.bumpScale;
                this.normalMap = source.normalMap;
                this.normalMapType = source.normalMapType;
                this.normalScale.copy(source.normalScale);
                this.displacementMap = source.displacementMap;
                this.displacementScale = source.displacementScale;
                this.displacementBias = source.displacementBias;
                this.alphaMap = source.alphaMap;
                this.flatShading = source.flatShading;
                this.fog = source.fog;
                return this;
            }
        }
    ]);
    return MeshMatcapMaterial;
}($1a55656020b89c3a$export$a2d8b23205c25948);
var $1a55656020b89c3a$export$327886a3efaeaebe = /*#__PURE__*/ function(LineBasicMaterial) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(LineDashedMaterial, LineBasicMaterial);
    function LineDashedMaterial(parameters) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, LineDashedMaterial);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, LineDashedMaterial);
        _this.isLineDashedMaterial = true;
        _this.type = 'LineDashedMaterial';
        _this.scale = 1;
        _this.dashSize = 3;
        _this.gapSize = 1;
        _this.setValues(parameters);
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(LineDashedMaterial, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(LineDashedMaterial.prototype), "copy", this).call(this, source);
                this.scale = source.scale;
                this.dashSize = source.dashSize;
                this.gapSize = source.gapSize;
                return this;
            }
        }
    ]);
    return LineDashedMaterial;
}($1a55656020b89c3a$export$fbaaa33907730a0c);
// converts an array to a specific type
function $1a55656020b89c3a$var$convertArray(array, type, forceClone) {
    if (!array || // let 'undefined' and 'null' pass
    !forceClone && array.constructor === type) return array;
    if (typeof type.BYTES_PER_ELEMENT === 'number') return new type(array); // create typed array
    return Array.prototype.slice.call(array); // create Array
}
function $1a55656020b89c3a$var$isTypedArray(object) {
    return ArrayBuffer.isView(object) && !(object instanceof DataView);
}
// returns an array by which times and values can be sorted
function $1a55656020b89c3a$var$getKeyframeOrder(times) {
    function compareTime(i, j) {
        return times[i] - times[j];
    }
    var n = times.length;
    var result = new Array(n);
    for(var i = 0; i !== n; ++i)result[i] = i;
    result.sort(compareTime);
    return result;
}
// uses the array previously returned by 'getKeyframeOrder' to sort data
function $1a55656020b89c3a$var$sortedArray(values, stride, order) {
    var nValues = values.length;
    var result = new values.constructor(nValues);
    for(var i = 0, dstOffset = 0; dstOffset !== nValues; ++i){
        var srcOffset = order[i] * stride;
        for(var j = 0; j !== stride; ++j)result[dstOffset++] = values[srcOffset + j];
    }
    return result;
}
// function for parsing AOS keyframe formats
function $1a55656020b89c3a$var$flattenJSON(jsonKeys, times, values, valuePropertyName) {
    var i = 1, key = jsonKeys[0];
    while(key !== undefined && key[valuePropertyName] === undefined)key = jsonKeys[i++];
    if (key === undefined) return; // no data
    var value = key[valuePropertyName];
    if (value === undefined) return; // no data
    if (Array.isArray(value)) do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push.apply(values, value); // push all elements
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else if (value.toArray !== undefined) // ...assume THREE.Math-ish
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            value.toArray(values, values.length);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else // otherwise push as-is
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push(value);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
}
function $1a55656020b89c3a$var$subclip(sourceClip, name, startFrame, endFrame) {
    var fps = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 30;
    var clip = sourceClip.clone();
    clip.name = name;
    var tracks = [];
    for(var i = 0; i < clip.tracks.length; ++i){
        var track = clip.tracks[i];
        var valueSize = track.getValueSize();
        var times = [];
        var values = [];
        for(var j = 0; j < track.times.length; ++j){
            var frame = track.times[j] * fps;
            if (frame < startFrame || frame >= endFrame) continue;
            times.push(track.times[j]);
            for(var k = 0; k < valueSize; ++k)values.push(track.values[j * valueSize + k]);
        }
        if (times.length === 0) continue;
        track.times = $1a55656020b89c3a$var$convertArray(times, track.times.constructor);
        track.values = $1a55656020b89c3a$var$convertArray(values, track.values.constructor);
        tracks.push(track);
    }
    clip.tracks = tracks;
    // find minimum .times value across all tracks in the trimmed clip
    var minStartTime = Infinity;
    for(var i1 = 0; i1 < clip.tracks.length; ++i1)if (minStartTime > clip.tracks[i1].times[0]) minStartTime = clip.tracks[i1].times[0];
    // shift all tracks such that clip begins at t=0
    for(var i2 = 0; i2 < clip.tracks.length; ++i2)clip.tracks[i2].shift(-1 * minStartTime);
    clip.resetDuration();
    return clip;
}
function $1a55656020b89c3a$var$makeClipAdditive(targetClip) {
    var _loop = function(i) {
        var referenceTrack = referenceClip.tracks[i];
        var referenceTrackType = referenceTrack.ValueTypeName;
        // Skip this track if it's non-numeric
        if (referenceTrackType === 'bool' || referenceTrackType === 'string') return "continue";
        // Find the track in the target clip whose name and type matches the reference track
        var targetTrack = targetClip.tracks.find(function(track) {
            return track.name === referenceTrack.name && track.ValueTypeName === referenceTrackType;
        });
        if (targetTrack === undefined) return "continue";
        var referenceOffset = 0;
        var referenceValueSize = referenceTrack.getValueSize();
        if (referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) referenceOffset = referenceValueSize / 3;
        var targetOffset = 0;
        var targetValueSize = targetTrack.getValueSize();
        if (targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) targetOffset = targetValueSize / 3;
        var lastIndex = referenceTrack.times.length - 1;
        var referenceValue = void 0;
        // Find the value to subtract out of the track
        if (referenceTime <= referenceTrack.times[0]) {
            // Reference frame is earlier than the first keyframe, so just use the first keyframe
            var startIndex = referenceOffset;
            var endIndex = referenceValueSize - referenceOffset;
            referenceValue = referenceTrack.values.slice(startIndex, endIndex);
        } else if (referenceTime >= referenceTrack.times[lastIndex]) {
            // Reference frame is after the last keyframe, so just use the last keyframe
            var startIndex1 = lastIndex * referenceValueSize + referenceOffset;
            var endIndex1 = startIndex1 + referenceValueSize - referenceOffset;
            referenceValue = referenceTrack.values.slice(startIndex1, endIndex1);
        } else {
            // Interpolate to the reference value
            var interpolant = referenceTrack.createInterpolant();
            var startIndex2 = referenceOffset;
            var endIndex2 = referenceValueSize - referenceOffset;
            interpolant.evaluate(referenceTime);
            referenceValue = interpolant.resultBuffer.slice(startIndex2, endIndex2);
        }
        // Conjugate the quaternion
        if (referenceTrackType === 'quaternion') {
            var referenceQuat = new $1a55656020b89c3a$export$23d6a54f0bbc85a3().fromArray(referenceValue).normalize().conjugate();
            referenceQuat.toArray(referenceValue);
        }
        // Subtract the reference value from all of the track values
        var numTimes = targetTrack.times.length;
        for(var j = 0; j < numTimes; ++j){
            var valueStart = j * targetValueSize + targetOffset;
            if (referenceTrackType === 'quaternion') // Multiply the conjugate for quaternion track types
            $1a55656020b89c3a$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(targetTrack.values, valueStart, referenceValue, 0, targetTrack.values, valueStart);
            else {
                var valueEnd = targetValueSize - targetOffset * 2;
                // Subtract each value for all other numeric track types
                for(var k = 0; k < valueEnd; ++k)targetTrack.values[valueStart + k] -= referenceValue[k];
            }
        }
    };
    var referenceFrame = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, referenceClip = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : targetClip, fps = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 30;
    if (fps <= 0) fps = 30;
    var numTracks = referenceClip.tracks.length;
    var referenceTime = referenceFrame / fps;
    // Make each track's values relative to the values at the reference frame
    for(var i = 0; i < numTracks; ++i)_loop(i);
    targetClip.blendMode = $1a55656020b89c3a$export$d875e029ef558d3;
    return targetClip;
}
var $1a55656020b89c3a$export$7ee8caa573e71ad1 = {
    convertArray: $1a55656020b89c3a$var$convertArray,
    isTypedArray: $1a55656020b89c3a$var$isTypedArray,
    getKeyframeOrder: $1a55656020b89c3a$var$getKeyframeOrder,
    sortedArray: $1a55656020b89c3a$var$sortedArray,
    flattenJSON: $1a55656020b89c3a$var$flattenJSON,
    subclip: $1a55656020b89c3a$var$subclip,
    makeClipAdditive: $1a55656020b89c3a$var$makeClipAdditive
};
/**
 * Abstract base class of interpolants over parametric samples.
 *
 * The parameter domain is one dimensional, typically the time or a path
 * along a curve defined by the data.
 *
 * The sample values can have any dimensionality and derived classes may
 * apply special interpretations to the data.
 *
 * This class provides the interval seek in a Template Method, deferring
 * the actual interpolation to derived classes.
 *
 * Time complexity is O(1) for linear access crossing at most two points
 * and O(log N) for random access, where N is the number of positions.
 *
 * References:
 *
 * 		http://www.oodesign.com/template-method-pattern.html
 *
 */ var $1a55656020b89c3a$export$b558baee9c0f72d3 = /*#__PURE__*/ function() {
    "use strict";
    function Interpolant(parameterPositions, sampleValues, sampleSize, resultBuffer) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Interpolant);
        this.parameterPositions = parameterPositions;
        this._cachedIndex = 0;
        this.resultBuffer = resultBuffer !== undefined ? resultBuffer : new sampleValues.constructor(sampleSize);
        this.sampleValues = sampleValues;
        this.valueSize = sampleSize;
        this.settings = null;
        this.DefaultSettings_ = {};
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Interpolant, [
        {
            key: "evaluate",
            value: function evaluate(t) {
                var pp = this.parameterPositions;
                var i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
                validate_interval: {
                    seek: {
                        var right;
                        linear_scan: {
                            //- See http://jsperf.com/comparison-to-undefined/3
                            //- slower code:
                            //-
                            //- 				if ( t >= t1 || t1 === undefined ) {
                            forward_scan: if (!(t < t1)) {
                                for(var giveUpAt = i1 + 2;;){
                                    if (t1 === undefined) {
                                        if (t < t0) break forward_scan;
                                        // after end
                                        i1 = pp.length;
                                        this._cachedIndex = i1;
                                        return this.copySampleValue_(i1 - 1);
                                    }
                                    if (i1 === giveUpAt) break; // this loop
                                    t0 = t1;
                                    t1 = pp[++i1];
                                    if (t < t1) break seek;
                                }
                                // prepare binary search on the right side of the index
                                right = pp.length;
                                break linear_scan;
                            }
                            //- slower code:
                            //-					if ( t < t0 || t0 === undefined ) {
                            if (!(t >= t0)) {
                                // looping?
                                var t1global = pp[1];
                                if (t < t1global) {
                                    i1 = 2; // + 1, using the scan for the details
                                    t0 = t1global;
                                }
                                // linear reverse scan
                                for(var giveUpAt1 = i1 - 2;;){
                                    if (t0 === undefined) {
                                        // before start
                                        this._cachedIndex = 0;
                                        return this.copySampleValue_(0);
                                    }
                                    if (i1 === giveUpAt1) break; // this loop
                                    t1 = t0;
                                    t0 = pp[--i1 - 1];
                                    if (t >= t0) break seek;
                                }
                                // prepare binary search on the left side of the index
                                right = i1;
                                i1 = 0;
                                break linear_scan;
                            }
                            break validate_interval;
                        } // linear scan
                        // binary search
                        while(i1 < right){
                            var mid = i1 + right >>> 1;
                            if (t < pp[mid]) right = mid;
                            else i1 = mid + 1;
                        }
                        t1 = pp[i1];
                        t0 = pp[i1 - 1];
                        // check boundary cases, again
                        if (t0 === undefined) {
                            this._cachedIndex = 0;
                            return this.copySampleValue_(0);
                        }
                        if (t1 === undefined) {
                            i1 = pp.length;
                            this._cachedIndex = i1;
                            return this.copySampleValue_(i1 - 1);
                        }
                    } // seek
                    this._cachedIndex = i1;
                    this.intervalChanged_(i1, t0, t1);
                } // validate_interval
                return this.interpolate_(i1, t0, t, t1);
            }
        },
        {
            key: "getSettings_",
            value: function getSettings_() {
                return this.settings || this.DefaultSettings_;
            }
        },
        {
            key: "copySampleValue_",
            value: function copySampleValue_(index) {
                // copies a sample value to the result buffer
                var result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset = index * stride;
                for(var i = 0; i !== stride; ++i)result[i] = values[offset + i];
                return result;
            }
        },
        {
            // Template methods for derived classes:
            key: "interpolate_",
            value: function interpolate_() {
                throw new Error('call to abstract method');
            // implementations shall return this.resultBuffer
            }
        },
        {
            key: "intervalChanged_",
            value: function intervalChanged_() {
            // empty
            }
        }
    ]);
    return Interpolant;
}();
/**
 * Fast and simple cubic spline interpolant.
 *
 * It was derived from a Hermitian construction setting the first derivative
 * at each sample position to the linear slope between neighboring positions
 * over their parameter interval.
 */ var $1a55656020b89c3a$export$3646682e7a3959 = /*#__PURE__*/ function(Interpolant) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(CubicInterpolant, Interpolant);
    function CubicInterpolant(parameterPositions, sampleValues, sampleSize, resultBuffer) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, CubicInterpolant);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, CubicInterpolant, [
            parameterPositions,
            sampleValues,
            sampleSize,
            resultBuffer
        ]);
        _this._weightPrev = -0;
        _this._offsetPrev = -0;
        _this._weightNext = -0;
        _this._offsetNext = -0;
        _this.DefaultSettings_ = {
            endingStart: $1a55656020b89c3a$export$7f795934b84ab523,
            endingEnd: $1a55656020b89c3a$export$7f795934b84ab523
        };
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(CubicInterpolant, [
        {
            key: "intervalChanged_",
            value: function intervalChanged_(i1, t0, t1) {
                var pp = this.parameterPositions;
                var iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
                if (tPrev === undefined) switch(this.getSettings_().endingStart){
                    case $1a55656020b89c3a$export$24a4ccb5099273b5:
                        // f'(t0) = 0
                        iPrev = i1;
                        tPrev = 2 * t0 - t1;
                        break;
                    case $1a55656020b89c3a$export$8e8c3ecdcd8e1fee:
                        // use the other end of the curve
                        iPrev = pp.length - 2;
                        tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
                        break;
                    default:
                        // f''(t0) = 0 a.k.a. Natural Spline
                        iPrev = i1;
                        tPrev = t1;
                }
                if (tNext === undefined) switch(this.getSettings_().endingEnd){
                    case $1a55656020b89c3a$export$24a4ccb5099273b5:
                        // f'(tN) = 0
                        iNext = i1;
                        tNext = 2 * t1 - t0;
                        break;
                    case $1a55656020b89c3a$export$8e8c3ecdcd8e1fee:
                        // use the other end of the curve
                        iNext = 1;
                        tNext = t1 + pp[1] - pp[0];
                        break;
                    default:
                        // f''(tN) = 0, a.k.a. Natural Spline
                        iNext = i1 - 1;
                        tNext = t0;
                }
                var halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
                this._weightPrev = halfDt / (t0 - tPrev);
                this._weightNext = halfDt / (tNext - t1);
                this._offsetPrev = iPrev * stride;
                this._offsetNext = iNext * stride;
            }
        },
        {
            key: "interpolate_",
            value: function interpolate_(i1, t0, t, t1) {
                var result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p = (t - t0) / (t1 - t0), pp = p * p, ppp = pp * p;
                // evaluate polynomials
                var sP = -wP * ppp + 2 * wP * pp - wP * p;
                var s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p + 1;
                var s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p;
                var sN = wN * ppp - wN * pp;
                // combine data linearly
                for(var i = 0; i !== stride; ++i)result[i] = sP * values[oP + i] + s0 * values[o0 + i] + s1 * values[o1 + i] + sN * values[oN + i];
                return result;
            }
        }
    ]);
    return CubicInterpolant;
}($1a55656020b89c3a$export$b558baee9c0f72d3);
var $1a55656020b89c3a$export$a8e6009059f51e1a = /*#__PURE__*/ function(Interpolant) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(LinearInterpolant, Interpolant);
    function LinearInterpolant(parameterPositions, sampleValues, sampleSize, resultBuffer) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, LinearInterpolant);
        return (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, LinearInterpolant, [
            parameterPositions,
            sampleValues,
            sampleSize,
            resultBuffer
        ]);
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(LinearInterpolant, [
        {
            key: "interpolate_",
            value: function interpolate_(i1, t0, t, t1) {
                var result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t - t0) / (t1 - t0), weight0 = 1 - weight1;
                for(var i = 0; i !== stride; ++i)result[i] = values[offset0 + i] * weight0 + values[offset1 + i] * weight1;
                return result;
            }
        }
    ]);
    return LinearInterpolant;
}($1a55656020b89c3a$export$b558baee9c0f72d3);
/**
 *
 * Interpolant that evaluates to the sample value at the position preceding
 * the parameter.
 */ var $1a55656020b89c3a$export$fb9758ef7ef8d5cc = /*#__PURE__*/ function(Interpolant) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(DiscreteInterpolant, Interpolant);
    function DiscreteInterpolant(parameterPositions, sampleValues, sampleSize, resultBuffer) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, DiscreteInterpolant);
        return (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, DiscreteInterpolant, [
            parameterPositions,
            sampleValues,
            sampleSize,
            resultBuffer
        ]);
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(DiscreteInterpolant, [
        {
            key: "interpolate_",
            value: function interpolate_(i1 /*, t0, t, t1 */ ) {
                return this.copySampleValue_(i1 - 1);
            }
        }
    ]);
    return DiscreteInterpolant;
}($1a55656020b89c3a$export$b558baee9c0f72d3);
var $1a55656020b89c3a$export$b0e479f45b7006d6 = /*#__PURE__*/ function() {
    "use strict";
    function KeyframeTrack(name, times, values, interpolation) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, KeyframeTrack);
        if (name === undefined) throw new Error('THREE.KeyframeTrack: track name is undefined');
        if (times === undefined || times.length === 0) throw new Error('THREE.KeyframeTrack: no keyframes in track named ' + name);
        this.name = name;
        this.times = $1a55656020b89c3a$var$convertArray(times, this.TimeBufferType);
        this.values = $1a55656020b89c3a$var$convertArray(values, this.ValueBufferType);
        this.setInterpolation(interpolation || this.DefaultInterpolation);
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(KeyframeTrack, [
        {
            key: "InterpolantFactoryMethodDiscrete",
            value: function InterpolantFactoryMethodDiscrete(result) {
                return new $1a55656020b89c3a$export$fb9758ef7ef8d5cc(this.times, this.values, this.getValueSize(), result);
            }
        },
        {
            key: "InterpolantFactoryMethodLinear",
            value: function InterpolantFactoryMethodLinear(result) {
                return new $1a55656020b89c3a$export$a8e6009059f51e1a(this.times, this.values, this.getValueSize(), result);
            }
        },
        {
            key: "InterpolantFactoryMethodSmooth",
            value: function InterpolantFactoryMethodSmooth(result) {
                return new $1a55656020b89c3a$export$3646682e7a3959(this.times, this.values, this.getValueSize(), result);
            }
        },
        {
            key: "setInterpolation",
            value: function setInterpolation(interpolation) {
                var factoryMethod;
                switch(interpolation){
                    case $1a55656020b89c3a$export$995b32462a65e855:
                        factoryMethod = this.InterpolantFactoryMethodDiscrete;
                        break;
                    case $1a55656020b89c3a$export$30fac1aace31cf4d:
                        factoryMethod = this.InterpolantFactoryMethodLinear;
                        break;
                    case $1a55656020b89c3a$export$198b11ff4c72bb30:
                        factoryMethod = this.InterpolantFactoryMethodSmooth;
                        break;
                }
                if (factoryMethod === undefined) {
                    var message = 'unsupported interpolation for ' + this.ValueTypeName + ' keyframe track named ' + this.name;
                    if (this.createInterpolant === undefined) {
                        // fall back to default, unless the default itself is messed up
                        if (interpolation !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
                        else throw new Error(message); // fatal, in this case
                    }
                    console.warn('THREE.KeyframeTrack:', message);
                    return this;
                }
                this.createInterpolant = factoryMethod;
                return this;
            }
        },
        {
            key: "getInterpolation",
            value: function getInterpolation() {
                switch(this.createInterpolant){
                    case this.InterpolantFactoryMethodDiscrete:
                        return $1a55656020b89c3a$export$995b32462a65e855;
                    case this.InterpolantFactoryMethodLinear:
                        return $1a55656020b89c3a$export$30fac1aace31cf4d;
                    case this.InterpolantFactoryMethodSmooth:
                        return $1a55656020b89c3a$export$198b11ff4c72bb30;
                }
            }
        },
        {
            key: "getValueSize",
            value: function getValueSize() {
                return this.values.length / this.times.length;
            }
        },
        {
            // move all keyframes either forwards or backwards in time
            key: "shift",
            value: function shift(timeOffset) {
                if (timeOffset !== 0.0) {
                    var times = this.times;
                    for(var i = 0, n = times.length; i !== n; ++i)times[i] += timeOffset;
                }
                return this;
            }
        },
        {
            // scale all keyframe times by a factor (useful for frame <-> seconds conversions)
            key: "scale",
            value: function scale(timeScale) {
                if (timeScale !== 1.0) {
                    var times = this.times;
                    for(var i = 0, n = times.length; i !== n; ++i)times[i] *= timeScale;
                }
                return this;
            }
        },
        {
            // removes keyframes before and after animation without changing any values within the range [startTime, endTime].
            // IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
            key: "trim",
            value: function trim(startTime, endTime) {
                var times = this.times, nKeys = times.length;
                var from = 0, to = nKeys - 1;
                while(from !== nKeys && times[from] < startTime)++from;
                while(to !== -1 && times[to] > endTime)--to;
                ++to; // inclusive -> exclusive bound
                if (from !== 0 || to !== nKeys) {
                    // empty tracks are forbidden, so keep at least one keyframe
                    if (from >= to) {
                        to = Math.max(to, 1);
                        from = to - 1;
                    }
                    var stride = this.getValueSize();
                    this.times = times.slice(from, to);
                    this.values = this.values.slice(from * stride, to * stride);
                }
                return this;
            }
        },
        {
            // ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
            key: "validate",
            value: function validate() {
                var valid = true;
                var valueSize = this.getValueSize();
                if (valueSize - Math.floor(valueSize) !== 0) {
                    console.error('THREE.KeyframeTrack: Invalid value size in track.', this);
                    valid = false;
                }
                var times = this.times, values = this.values, nKeys = times.length;
                if (nKeys === 0) {
                    console.error('THREE.KeyframeTrack: Track is empty.', this);
                    valid = false;
                }
                var prevTime = null;
                for(var i = 0; i !== nKeys; i++){
                    var currTime = times[i];
                    if (typeof currTime === 'number' && isNaN(currTime)) {
                        console.error('THREE.KeyframeTrack: Time is not a valid number.', this, i, currTime);
                        valid = false;
                        break;
                    }
                    if (prevTime !== null && prevTime > currTime) {
                        console.error('THREE.KeyframeTrack: Out of order keys.', this, i, currTime, prevTime);
                        valid = false;
                        break;
                    }
                    prevTime = currTime;
                }
                if (values !== undefined) {
                    if ($1a55656020b89c3a$var$isTypedArray(values)) for(var i1 = 0, n = values.length; i1 !== n; ++i1){
                        var value = values[i1];
                        if (isNaN(value)) {
                            console.error('THREE.KeyframeTrack: Value is not a valid number.', this, i1, value);
                            valid = false;
                            break;
                        }
                    }
                }
                return valid;
            }
        },
        {
            // removes equivalent sequential keys as common in morph target sequences
            // (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
            key: "optimize",
            value: function optimize() {
                // times or values may be shared with other tracks, so overwriting is unsafe
                var times = this.times.slice(), values = this.values.slice(), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === $1a55656020b89c3a$export$198b11ff4c72bb30, lastIndex = times.length - 1;
                var writeIndex = 1;
                for(var i = 1; i < lastIndex; ++i){
                    var keep = false;
                    var time = times[i];
                    var timeNext = times[i + 1];
                    // remove adjacent keyframes scheduled at the same time
                    if (time !== timeNext && (i !== 1 || time !== times[0])) {
                        if (!smoothInterpolation) {
                            // remove unnecessary keyframes same as their neighbors
                            var offset = i * stride, offsetP = offset - stride, offsetN = offset + stride;
                            for(var j = 0; j !== stride; ++j){
                                var value = values[offset + j];
                                if (value !== values[offsetP + j] || value !== values[offsetN + j]) {
                                    keep = true;
                                    break;
                                }
                            }
                        } else keep = true;
                    }
                    // in-place compaction
                    if (keep) {
                        if (i !== writeIndex) {
                            times[writeIndex] = times[i];
                            var readOffset = i * stride, writeOffset = writeIndex * stride;
                            for(var j1 = 0; j1 !== stride; ++j1)values[writeOffset + j1] = values[readOffset + j1];
                        }
                        ++writeIndex;
                    }
                }
                // flush last keyframe (compaction looks ahead)
                if (lastIndex > 0) {
                    times[writeIndex] = times[lastIndex];
                    for(var readOffset1 = lastIndex * stride, writeOffset1 = writeIndex * stride, j2 = 0; j2 !== stride; ++j2)values[writeOffset1 + j2] = values[readOffset1 + j2];
                    ++writeIndex;
                }
                if (writeIndex !== times.length) {
                    this.times = times.slice(0, writeIndex);
                    this.values = values.slice(0, writeIndex * stride);
                } else {
                    this.times = times;
                    this.values = values;
                }
                return this;
            }
        },
        {
            key: "clone",
            value: function clone() {
                var times = this.times.slice();
                var values = this.values.slice();
                var TypedKeyframeTrack = this.constructor;
                var track = new TypedKeyframeTrack(this.name, times, values);
                // Interpolant argument to constructor is not saved, so copy the factory method directly.
                track.createInterpolant = this.createInterpolant;
                return track;
            }
        }
    ], [
        {
            key: "toJSON",
            value: // Serialization (in static context, because of constructor invocation
            // and automatic invocation of .toJSON):
            function toJSON(track) {
                var trackType = track.constructor;
                var json;
                // derived classes can define a static toJSON method
                if (trackType.toJSON !== this.toJSON) json = trackType.toJSON(track);
                else {
                    // by default, we assume the data can be serialized as-is
                    json = {
                        'name': track.name,
                        'times': $1a55656020b89c3a$var$convertArray(track.times, Array),
                        'values': $1a55656020b89c3a$var$convertArray(track.values, Array)
                    };
                    var interpolation = track.getInterpolation();
                    if (interpolation !== track.DefaultInterpolation) json.interpolation = interpolation;
                }
                json.type = track.ValueTypeName; // mandatory
                return json;
            }
        }
    ]);
    return KeyframeTrack;
}();
$1a55656020b89c3a$export$b0e479f45b7006d6.prototype.TimeBufferType = Float32Array;
$1a55656020b89c3a$export$b0e479f45b7006d6.prototype.ValueBufferType = Float32Array;
$1a55656020b89c3a$export$b0e479f45b7006d6.prototype.DefaultInterpolation = $1a55656020b89c3a$export$30fac1aace31cf4d;
/**
 * A Track of Boolean keyframe values.
 */ var $1a55656020b89c3a$export$d3a344b98cf0b775 = /*#__PURE__*/ function(KeyframeTrack) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(BooleanKeyframeTrack, KeyframeTrack);
    function BooleanKeyframeTrack(name, times, values) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, BooleanKeyframeTrack);
        return (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, BooleanKeyframeTrack, [
            name,
            times,
            values
        ]);
    }
    return BooleanKeyframeTrack;
}($1a55656020b89c3a$export$b0e479f45b7006d6);
$1a55656020b89c3a$export$d3a344b98cf0b775.prototype.ValueTypeName = 'bool';
$1a55656020b89c3a$export$d3a344b98cf0b775.prototype.ValueBufferType = Array;
$1a55656020b89c3a$export$d3a344b98cf0b775.prototype.DefaultInterpolation = $1a55656020b89c3a$export$995b32462a65e855;
$1a55656020b89c3a$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodLinear = undefined;
$1a55656020b89c3a$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of keyframe values that represent color.
 */ var $1a55656020b89c3a$export$83444c5d885347d8 = /*#__PURE__*/ function(KeyframeTrack) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(ColorKeyframeTrack, KeyframeTrack);
    function ColorKeyframeTrack() {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, ColorKeyframeTrack);
        return (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, ColorKeyframeTrack, arguments);
    }
    return ColorKeyframeTrack;
}($1a55656020b89c3a$export$b0e479f45b7006d6);
$1a55656020b89c3a$export$83444c5d885347d8.prototype.ValueTypeName = 'color';
/**
 * A Track of numeric keyframe values.
 */ var $1a55656020b89c3a$export$d45f0d1a4d9a9314 = /*#__PURE__*/ function(KeyframeTrack) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(NumberKeyframeTrack, KeyframeTrack);
    function NumberKeyframeTrack() {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, NumberKeyframeTrack);
        return (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, NumberKeyframeTrack, arguments);
    }
    return NumberKeyframeTrack;
}($1a55656020b89c3a$export$b0e479f45b7006d6);
$1a55656020b89c3a$export$d45f0d1a4d9a9314.prototype.ValueTypeName = 'number';
/**
 * Spherical linear unit quaternion interpolant.
 */ var $1a55656020b89c3a$export$2db1cfb7923d931e = /*#__PURE__*/ function(Interpolant) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(QuaternionLinearInterpolant, Interpolant);
    function QuaternionLinearInterpolant(parameterPositions, sampleValues, sampleSize, resultBuffer) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, QuaternionLinearInterpolant);
        return (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, QuaternionLinearInterpolant, [
            parameterPositions,
            sampleValues,
            sampleSize,
            resultBuffer
        ]);
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(QuaternionLinearInterpolant, [
        {
            key: "interpolate_",
            value: function interpolate_(i1, t0, t, t1) {
                var result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, alpha = (t - t0) / (t1 - t0);
                var offset = i1 * stride;
                for(var end = offset + stride; offset !== end; offset += 4)$1a55656020b89c3a$export$23d6a54f0bbc85a3.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
                return result;
            }
        }
    ]);
    return QuaternionLinearInterpolant;
}($1a55656020b89c3a$export$b558baee9c0f72d3);
/**
 * A Track of quaternion keyframe values.
 */ var $1a55656020b89c3a$export$b8043f12b5aafbd7 = /*#__PURE__*/ function(KeyframeTrack) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(QuaternionKeyframeTrack, KeyframeTrack);
    function QuaternionKeyframeTrack() {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, QuaternionKeyframeTrack);
        return (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, QuaternionKeyframeTrack, arguments);
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(QuaternionKeyframeTrack, [
        {
            key: "InterpolantFactoryMethodLinear",
            value: function InterpolantFactoryMethodLinear(result) {
                return new $1a55656020b89c3a$export$2db1cfb7923d931e(this.times, this.values, this.getValueSize(), result);
            }
        }
    ]);
    return QuaternionKeyframeTrack;
}($1a55656020b89c3a$export$b0e479f45b7006d6);
$1a55656020b89c3a$export$b8043f12b5aafbd7.prototype.ValueTypeName = 'quaternion';
// ValueBufferType is inherited
// DefaultInterpolation is inherited;
$1a55656020b89c3a$export$b8043f12b5aafbd7.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track that interpolates Strings
 */ var $1a55656020b89c3a$export$6ce41d4f3a8df9cd = /*#__PURE__*/ function(KeyframeTrack) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(StringKeyframeTrack, KeyframeTrack);
    function StringKeyframeTrack(name, times, values) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, StringKeyframeTrack);
        return (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, StringKeyframeTrack, [
            name,
            times,
            values
        ]);
    }
    return StringKeyframeTrack;
}($1a55656020b89c3a$export$b0e479f45b7006d6);
$1a55656020b89c3a$export$6ce41d4f3a8df9cd.prototype.ValueTypeName = 'string';
$1a55656020b89c3a$export$6ce41d4f3a8df9cd.prototype.ValueBufferType = Array;
$1a55656020b89c3a$export$6ce41d4f3a8df9cd.prototype.DefaultInterpolation = $1a55656020b89c3a$export$995b32462a65e855;
$1a55656020b89c3a$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodLinear = undefined;
$1a55656020b89c3a$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of vectored keyframe values.
 */ var $1a55656020b89c3a$export$5ce2dcb4cc9f2bff = /*#__PURE__*/ function(KeyframeTrack) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(VectorKeyframeTrack, KeyframeTrack);
    function VectorKeyframeTrack() {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, VectorKeyframeTrack);
        return (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, VectorKeyframeTrack, arguments);
    }
    return VectorKeyframeTrack;
}($1a55656020b89c3a$export$b0e479f45b7006d6);
$1a55656020b89c3a$export$5ce2dcb4cc9f2bff.prototype.ValueTypeName = 'vector';
var $1a55656020b89c3a$export$d942c706bf23829c = /*#__PURE__*/ function() {
    "use strict";
    function AnimationClip() {
        var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '', duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1, tracks = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], blendMode = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $1a55656020b89c3a$export$bcfbbdcf8de7f8cd;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, AnimationClip);
        this.name = name;
        this.tracks = tracks;
        this.duration = duration;
        this.blendMode = blendMode;
        this.uuid = $1a55656020b89c3a$var$generateUUID();
        // this means it should figure out its duration by scanning the tracks
        if (this.duration < 0) this.resetDuration();
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(AnimationClip, [
        {
            key: "resetDuration",
            value: function resetDuration() {
                var tracks = this.tracks;
                var duration = 0;
                for(var i = 0, n = tracks.length; i !== n; ++i){
                    var track = this.tracks[i];
                    duration = Math.max(duration, track.times[track.times.length - 1]);
                }
                this.duration = duration;
                return this;
            }
        },
        {
            key: "trim",
            value: function trim() {
                for(var i = 0; i < this.tracks.length; i++)this.tracks[i].trim(0, this.duration);
                return this;
            }
        },
        {
            key: "validate",
            value: function validate() {
                var valid = true;
                for(var i = 0; i < this.tracks.length; i++)valid = valid && this.tracks[i].validate();
                return valid;
            }
        },
        {
            key: "optimize",
            value: function optimize() {
                for(var i = 0; i < this.tracks.length; i++)this.tracks[i].optimize();
                return this;
            }
        },
        {
            key: "clone",
            value: function clone() {
                var tracks = [];
                for(var i = 0; i < this.tracks.length; i++)tracks.push(this.tracks[i].clone());
                return new this.constructor(this.name, this.duration, tracks, this.blendMode);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.constructor.toJSON(this);
            }
        }
    ], [
        {
            key: "parse",
            value: function parse(json) {
                var tracks = [], jsonTracks = json.tracks, frameTime = 1.0 / (json.fps || 1.0);
                for(var i = 0, n = jsonTracks.length; i !== n; ++i)tracks.push($1a55656020b89c3a$var$parseKeyframeTrack(jsonTracks[i]).scale(frameTime));
                var clip = new this(json.name, json.duration, tracks, json.blendMode);
                clip.uuid = json.uuid;
                return clip;
            }
        },
        {
            key: "toJSON",
            value: function toJSON(clip) {
                var tracks = [], clipTracks = clip.tracks;
                var json = {
                    'name': clip.name,
                    'duration': clip.duration,
                    'tracks': tracks,
                    'uuid': clip.uuid,
                    'blendMode': clip.blendMode
                };
                for(var i = 0, n = clipTracks.length; i !== n; ++i)tracks.push($1a55656020b89c3a$export$b0e479f45b7006d6.toJSON(clipTracks[i]));
                return json;
            }
        },
        {
            key: "CreateFromMorphTargetSequence",
            value: function CreateFromMorphTargetSequence(name, morphTargetSequence, fps, noLoop) {
                var numMorphTargets = morphTargetSequence.length;
                var tracks = [];
                for(var i = 0; i < numMorphTargets; i++){
                    var times = [];
                    var values = [];
                    times.push((i + numMorphTargets - 1) % numMorphTargets, i, (i + 1) % numMorphTargets);
                    values.push(0, 1, 0);
                    var order = $1a55656020b89c3a$var$getKeyframeOrder(times);
                    times = $1a55656020b89c3a$var$sortedArray(times, 1, order);
                    values = $1a55656020b89c3a$var$sortedArray(values, 1, order);
                    // if there is a key at the first frame, duplicate it as the
                    // last frame as well for perfect loop.
                    if (!noLoop && times[0] === 0) {
                        times.push(numMorphTargets);
                        values.push(values[0]);
                    }
                    tracks.push(new $1a55656020b89c3a$export$d45f0d1a4d9a9314('.morphTargetInfluences[' + morphTargetSequence[i].name + ']', times, values).scale(1.0 / fps));
                }
                return new this(name, -1, tracks);
            }
        },
        {
            key: "findByName",
            value: function findByName(objectOrClipArray, name) {
                var clipArray = objectOrClipArray;
                if (!Array.isArray(objectOrClipArray)) {
                    var o = objectOrClipArray;
                    clipArray = o.geometry && o.geometry.animations || o.animations;
                }
                for(var i = 0; i < clipArray.length; i++){
                    if (clipArray[i].name === name) return clipArray[i];
                }
                return null;
            }
        },
        {
            key: "CreateClipsFromMorphTargetSequences",
            value: function CreateClipsFromMorphTargetSequences(morphTargets, fps, noLoop) {
                var animationToMorphTargets = {};
                // tested with https://regex101.com/ on trick sequences
                // such flamingo_flyA_003, flamingo_run1_003, crdeath0059
                var pattern = /^([\w-]*?)([\d]+)$/;
                // sort morph target names into animation groups based
                // patterns like Walk_001, Walk_002, Run_001, Run_002
                for(var i = 0, il = morphTargets.length; i < il; i++){
                    var morphTarget = morphTargets[i];
                    var parts = morphTarget.name.match(pattern);
                    if (parts && parts.length > 1) {
                        var name = parts[1];
                        var animationMorphTargets = animationToMorphTargets[name];
                        if (!animationMorphTargets) animationToMorphTargets[name] = animationMorphTargets = [];
                        animationMorphTargets.push(morphTarget);
                    }
                }
                var clips = [];
                for(var name1 in animationToMorphTargets)clips.push(this.CreateFromMorphTargetSequence(name1, animationToMorphTargets[name1], fps, noLoop));
                return clips;
            }
        },
        {
            key: "parseAnimation",
            value: // parse the animation.hierarchy format
            function parseAnimation(animation, bones) {
                if (!animation) {
                    console.error('THREE.AnimationClip: No animation in JSONLoader data.');
                    return null;
                }
                var addNonemptyTrack = function addNonemptyTrack(trackType, trackName, animationKeys, propertyName, destTracks) {
                    // only return track if there are actually keys.
                    if (animationKeys.length !== 0) {
                        var times = [];
                        var values = [];
                        $1a55656020b89c3a$var$flattenJSON(animationKeys, times, values, propertyName);
                        // empty keys are filtered out, so check again
                        if (times.length !== 0) destTracks.push(new trackType(trackName, times, values));
                    }
                };
                var tracks = [];
                var clipName = animation.name || 'default';
                var fps = animation.fps || 30;
                var blendMode = animation.blendMode;
                // automatic length determination in AnimationClip.
                var duration = animation.length || -1;
                var hierarchyTracks = animation.hierarchy || [];
                for(var h = 0; h < hierarchyTracks.length; h++){
                    var animationKeys = hierarchyTracks[h].keys;
                    // skip empty tracks
                    if (!animationKeys || animationKeys.length === 0) continue;
                    // process morph targets
                    if (animationKeys[0].morphTargets) {
                        // figure out all morph targets used in this track
                        var morphTargetNames = {};
                        var k = void 0;
                        for(k = 0; k < animationKeys.length; k++){
                            if (animationKeys[k].morphTargets) for(var m = 0; m < animationKeys[k].morphTargets.length; m++)morphTargetNames[animationKeys[k].morphTargets[m]] = -1;
                        }
                        // create a track for each morph target with all zero
                        // morphTargetInfluences except for the keys in which
                        // the morphTarget is named.
                        for(var morphTargetName in morphTargetNames){
                            var times = [];
                            var values = [];
                            for(var m1 = 0; m1 !== animationKeys[k].morphTargets.length; ++m1){
                                var animationKey = animationKeys[k];
                                times.push(animationKey.time);
                                values.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
                            }
                            tracks.push(new $1a55656020b89c3a$export$d45f0d1a4d9a9314('.morphTargetInfluence[' + morphTargetName + ']', times, values));
                        }
                        duration = morphTargetNames.length * fps;
                    } else {
                        // ...assume skeletal animation
                        var boneName = '.bones[' + bones[h].name + ']';
                        addNonemptyTrack($1a55656020b89c3a$export$5ce2dcb4cc9f2bff, boneName + '.position', animationKeys, 'pos', tracks);
                        addNonemptyTrack($1a55656020b89c3a$export$b8043f12b5aafbd7, boneName + '.quaternion', animationKeys, 'rot', tracks);
                        addNonemptyTrack($1a55656020b89c3a$export$5ce2dcb4cc9f2bff, boneName + '.scale', animationKeys, 'scl', tracks);
                    }
                }
                if (tracks.length === 0) return null;
                var clip = new this(clipName, duration, tracks, blendMode);
                return clip;
            }
        }
    ]);
    return AnimationClip;
}();
function $1a55656020b89c3a$var$getTrackTypeForValueTypeName(typeName) {
    switch(typeName.toLowerCase()){
        case 'scalar':
        case 'double':
        case 'float':
        case 'number':
        case 'integer':
            return $1a55656020b89c3a$export$d45f0d1a4d9a9314;
        case 'vector':
        case 'vector2':
        case 'vector3':
        case 'vector4':
            return $1a55656020b89c3a$export$5ce2dcb4cc9f2bff;
        case 'color':
            return $1a55656020b89c3a$export$83444c5d885347d8;
        case 'quaternion':
            return $1a55656020b89c3a$export$b8043f12b5aafbd7;
        case 'bool':
        case 'boolean':
            return $1a55656020b89c3a$export$d3a344b98cf0b775;
        case 'string':
            return $1a55656020b89c3a$export$6ce41d4f3a8df9cd;
    }
    throw new Error('THREE.KeyframeTrack: Unsupported typeName: ' + typeName);
}
function $1a55656020b89c3a$var$parseKeyframeTrack(json) {
    if (json.type === undefined) throw new Error('THREE.KeyframeTrack: track type undefined, can not parse');
    var trackType = $1a55656020b89c3a$var$getTrackTypeForValueTypeName(json.type);
    if (json.times === undefined) {
        var times = [], values = [];
        $1a55656020b89c3a$var$flattenJSON(json.keys, times, values, 'value');
        json.times = times;
        json.values = values;
    }
    // derived classes can define a static parse method
    if (trackType.parse !== undefined) return trackType.parse(json);
    else // by default, we assume a constructor compatible with the base
    return new trackType(json.name, json.times, json.values, json.interpolation);
}
var $1a55656020b89c3a$export$94affb487e701bf2 = {
    enabled: false,
    files: {},
    add: function add(key, file) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Adding key:', key );
        this.files[key] = file;
    },
    get: function get(key) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Checking key:', key );
        return this.files[key];
    },
    remove: function remove(key) {
        delete this.files[key];
    },
    clear: function clear() {
        this.files = {};
    }
};
var $1a55656020b89c3a$export$99cc795e99919eed = function LoadingManager(onLoad, onProgress, onError) {
    "use strict";
    (0, $9a1684911372ec89$export$71511d61b312f219)(this, LoadingManager);
    var scope = this;
    var isLoading = false;
    var itemsLoaded = 0;
    var itemsTotal = 0;
    var urlModifier = undefined;
    var handlers = [];
    // Refer to #5689 for the reason why we don't set .onStart
    // in the constructor
    this.onStart = undefined;
    this.onLoad = onLoad;
    this.onProgress = onProgress;
    this.onError = onError;
    this.itemStart = function(url) {
        itemsTotal++;
        if (isLoading === false) {
            if (scope.onStart !== undefined) scope.onStart(url, itemsLoaded, itemsTotal);
        }
        isLoading = true;
    };
    this.itemEnd = function(url) {
        itemsLoaded++;
        if (scope.onProgress !== undefined) scope.onProgress(url, itemsLoaded, itemsTotal);
        if (itemsLoaded === itemsTotal) {
            isLoading = false;
            if (scope.onLoad !== undefined) scope.onLoad();
        }
    };
    this.itemError = function(url) {
        if (scope.onError !== undefined) scope.onError(url);
    };
    this.resolveURL = function(url) {
        if (urlModifier) return urlModifier(url);
        return url;
    };
    this.setURLModifier = function(transform) {
        urlModifier = transform;
        return this;
    };
    this.addHandler = function(regex, loader) {
        handlers.push(regex, loader);
        return this;
    };
    this.removeHandler = function(regex) {
        var index = handlers.indexOf(regex);
        if (index !== -1) handlers.splice(index, 2);
        return this;
    };
    this.getHandler = function(file) {
        for(var i = 0, l = handlers.length; i < l; i += 2){
            var regex = handlers[i];
            var loader = handlers[i + 1];
            if (regex.global) regex.lastIndex = 0; // see #17920
            if (regex.test(file)) return loader;
        }
        return null;
    };
};
var $1a55656020b89c3a$export$b033c3f9a95c6a16 = /*@__PURE__*/ new $1a55656020b89c3a$export$99cc795e99919eed();
var $1a55656020b89c3a$export$3b0d6d7590275603 = /*#__PURE__*/ function() {
    "use strict";
    function Loader(manager) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Loader);
        this.manager = manager !== undefined ? manager : $1a55656020b89c3a$export$b033c3f9a95c6a16;
        this.crossOrigin = 'anonymous';
        this.withCredentials = false;
        this.path = '';
        this.resourcePath = '';
        this.requestHeader = {};
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Loader, [
        {
            key: "load",
            value: function load() {}
        },
        {
            key: "loadAsync",
            value: function loadAsync(url, onProgress) {
                var scope = this;
                return new Promise(function(resolve, reject) {
                    scope.load(url, resolve, onProgress, reject);
                });
            }
        },
        {
            key: "parse",
            value: function parse() {}
        },
        {
            key: "setCrossOrigin",
            value: function setCrossOrigin(crossOrigin) {
                this.crossOrigin = crossOrigin;
                return this;
            }
        },
        {
            key: "setWithCredentials",
            value: function setWithCredentials(value) {
                this.withCredentials = value;
                return this;
            }
        },
        {
            key: "setPath",
            value: function setPath(path) {
                this.path = path;
                return this;
            }
        },
        {
            key: "setResourcePath",
            value: function setResourcePath(resourcePath) {
                this.resourcePath = resourcePath;
                return this;
            }
        },
        {
            key: "setRequestHeader",
            value: function setRequestHeader(requestHeader) {
                this.requestHeader = requestHeader;
                return this;
            }
        }
    ]);
    return Loader;
}();
$1a55656020b89c3a$export$3b0d6d7590275603.DEFAULT_MATERIAL_NAME = '__DEFAULT';
var $1a55656020b89c3a$var$loading = {};
var $1a55656020b89c3a$var$HttpError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(HttpError, Error1);
    function HttpError(message, response) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, HttpError);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, HttpError, [
            message
        ]);
        _this.response = response;
        return _this;
    }
    return HttpError;
}((0, $60c1ca164192b5e0$export$71511d61b312f219)(Error));
var $1a55656020b89c3a$export$98435a25b5cf7b2b = /*#__PURE__*/ function(Loader) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(FileLoader, Loader);
    function FileLoader(manager) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, FileLoader);
        return (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, FileLoader, [
            manager
        ]);
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(FileLoader, [
        {
            key: "load",
            value: function load(url, onLoad, onProgress, onError) {
                var _this = this;
                if (url === undefined) url = '';
                if (this.path !== undefined) url = this.path + url;
                url = this.manager.resolveURL(url);
                var cached = $1a55656020b89c3a$export$94affb487e701bf2.get(url);
                if (cached !== undefined) {
                    this.manager.itemStart(url);
                    setTimeout(function() {
                        if (onLoad) onLoad(cached);
                        _this.manager.itemEnd(url);
                    }, 0);
                    return cached;
                }
                // Check if request is duplicate
                if ($1a55656020b89c3a$var$loading[url] !== undefined) {
                    $1a55656020b89c3a$var$loading[url].push({
                        onLoad: onLoad,
                        onProgress: onProgress,
                        onError: onError
                    });
                    return;
                }
                // Initialise array for duplicate requests
                $1a55656020b89c3a$var$loading[url] = [];
                $1a55656020b89c3a$var$loading[url].push({
                    onLoad: onLoad,
                    onProgress: onProgress,
                    onError: onError
                });
                // create request
                var req = new Request(url, {
                    headers: new Headers(this.requestHeader),
                    credentials: this.withCredentials ? 'include' : 'same-origin'
                });
                // record states ( avoid data race )
                var mimeType = this.mimeType;
                var responseType = this.responseType;
                // start the fetch
                fetch(req).then(function(response) {
                    if (response.status === 200 || response.status === 0) {
                        // Some browsers return HTTP Status 0 when using non-http protocol
                        // e.g. 'file://' or 'data://'. Handle as success.
                        if (response.status === 0) console.warn('THREE.FileLoader: HTTP Status 0 received.');
                        // Workaround: Checking if response.body === undefined for Alipay browser #23548
                        if (typeof ReadableStream === 'undefined' || response.body === undefined || response.body.getReader === undefined) return response;
                        var callbacks = $1a55656020b89c3a$var$loading[url];
                        var reader = response.body.getReader();
                        // Nginx needs X-File-Size check
                        // https://serverfault.com/questions/482875/why-does-nginx-remove-content-length-header-for-chunked-content
                        var contentLength = response.headers.get('X-File-Size') || response.headers.get('Content-Length');
                        var total = contentLength ? parseInt(contentLength) : 0;
                        var lengthComputable = total !== 0;
                        var loaded = 0;
                        // periodically read data into the new stream tracking while download progress
                        var stream = new ReadableStream({
                            start: function(controller) {
                                readData();
                                function readData() {
                                    reader.read().then(function(param) {
                                        var done = param.done, value = param.value;
                                        if (done) controller.close();
                                        else {
                                            loaded += value.byteLength;
                                            var event = new ProgressEvent('progress', {
                                                lengthComputable: lengthComputable,
                                                loaded: loaded,
                                                total: total
                                            });
                                            for(var i = 0, il = callbacks.length; i < il; i++){
                                                var callback = callbacks[i];
                                                if (callback.onProgress) callback.onProgress(event);
                                            }
                                            controller.enqueue(value);
                                            readData();
                                        }
                                    }, function(e) {
                                        controller.error(e);
                                    });
                                }
                            }
                        });
                        return new Response(stream);
                    } else throw new $1a55656020b89c3a$var$HttpError('fetch for "'.concat(response.url, '" responded with ').concat(response.status, ": ").concat(response.statusText), response);
                }).then(function(response) {
                    switch(responseType){
                        case 'arraybuffer':
                            return response.arrayBuffer();
                        case 'blob':
                            return response.blob();
                        case 'document':
                            return response.text().then(function(text) {
                                var parser = new DOMParser();
                                return parser.parseFromString(text, mimeType);
                            });
                        case 'json':
                            return response.json();
                        default:
                            if (mimeType === undefined) return response.text();
                            else {
                                // sniff encoding
                                var re = /charset="?([^;"\s]*)"?/i;
                                var exec = re.exec(mimeType);
                                var label = exec && exec[1] ? exec[1].toLowerCase() : undefined;
                                var decoder = new TextDecoder(label);
                                return response.arrayBuffer().then(function(ab) {
                                    return decoder.decode(ab);
                                });
                            }
                    }
                }).then(function(data) {
                    // Add to cache only on HTTP success, so that we do not cache
                    // error response bodies as proper responses to requests.
                    $1a55656020b89c3a$export$94affb487e701bf2.add(url, data);
                    var callbacks = $1a55656020b89c3a$var$loading[url];
                    delete $1a55656020b89c3a$var$loading[url];
                    for(var i = 0, il = callbacks.length; i < il; i++){
                        var callback = callbacks[i];
                        if (callback.onLoad) callback.onLoad(data);
                    }
                }).catch(function(err) {
                    // Abort errors and other errors are handled the same
                    var callbacks = $1a55656020b89c3a$var$loading[url];
                    if (callbacks === undefined) {
                        // When onLoad was called and url was deleted in `loading`
                        _this.manager.itemError(url);
                        throw err;
                    }
                    delete $1a55656020b89c3a$var$loading[url];
                    for(var i = 0, il = callbacks.length; i < il; i++){
                        var callback = callbacks[i];
                        if (callback.onError) callback.onError(err);
                    }
                    _this.manager.itemError(url);
                }).finally(function() {
                    _this.manager.itemEnd(url);
                });
                this.manager.itemStart(url);
            }
        },
        {
            key: "setResponseType",
            value: function setResponseType(value) {
                this.responseType = value;
                return this;
            }
        },
        {
            key: "setMimeType",
            value: function setMimeType(value) {
                this.mimeType = value;
                return this;
            }
        }
    ]);
    return FileLoader;
}($1a55656020b89c3a$export$3b0d6d7590275603);
var $1a55656020b89c3a$export$29711c7e14f61db = /*#__PURE__*/ function(Loader) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(AnimationLoader, Loader);
    function AnimationLoader(manager) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, AnimationLoader);
        return (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, AnimationLoader, [
            manager
        ]);
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(AnimationLoader, [
        {
            key: "load",
            value: function load(url, onLoad, onProgress, onError) {
                var scope = this;
                var loader = new $1a55656020b89c3a$export$98435a25b5cf7b2b(this.manager);
                loader.setPath(this.path);
                loader.setRequestHeader(this.requestHeader);
                loader.setWithCredentials(this.withCredentials);
                loader.load(url, function(text) {
                    try {
                        onLoad(scope.parse(JSON.parse(text)));
                    } catch (e) {
                        if (onError) onError(e);
                        else console.error(e);
                        scope.manager.itemError(url);
                    }
                }, onProgress, onError);
            }
        },
        {
            key: "parse",
            value: function parse(json) {
                var animations = [];
                for(var i = 0; i < json.length; i++){
                    var clip = $1a55656020b89c3a$export$d942c706bf23829c.parse(json[i]);
                    animations.push(clip);
                }
                return animations;
            }
        }
    ]);
    return AnimationLoader;
}($1a55656020b89c3a$export$3b0d6d7590275603);
/**
 * Abstract Base class to block based textures loader (dds, pvr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ var $1a55656020b89c3a$export$bd73ce947a280350 = /*#__PURE__*/ function(Loader) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(CompressedTextureLoader, Loader);
    function CompressedTextureLoader(manager) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, CompressedTextureLoader);
        return (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, CompressedTextureLoader, [
            manager
        ]);
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(CompressedTextureLoader, [
        {
            key: "load",
            value: function load(url, onLoad, onProgress, onError) {
                var scope = this;
                var images = [];
                var texture = new $1a55656020b89c3a$export$3466bac9141a5cc4();
                var loader = new $1a55656020b89c3a$export$98435a25b5cf7b2b(this.manager);
                loader.setPath(this.path);
                loader.setResponseType('arraybuffer');
                loader.setRequestHeader(this.requestHeader);
                loader.setWithCredentials(scope.withCredentials);
                var loaded = 0;
                function loadTexture(i) {
                    loader.load(url[i], function(buffer) {
                        var texDatas = scope.parse(buffer, true);
                        images[i] = {
                            width: texDatas.width,
                            height: texDatas.height,
                            format: texDatas.format,
                            mipmaps: texDatas.mipmaps
                        };
                        loaded += 1;
                        if (loaded === 6) {
                            if (texDatas.mipmapCount === 1) texture.minFilter = $1a55656020b89c3a$export$8a72f490b25c56c8;
                            texture.image = images;
                            texture.format = texDatas.format;
                            texture.needsUpdate = true;
                            if (onLoad) onLoad(texture);
                        }
                    }, onProgress, onError);
                }
                if (Array.isArray(url)) for(var i = 0, il = url.length; i < il; ++i)loadTexture(i);
                else // compressed cubemap texture stored in a single DDS file
                loader.load(url, function(buffer) {
                    var texDatas = scope.parse(buffer, true);
                    if (texDatas.isCubemap) {
                        var faces = texDatas.mipmaps.length / texDatas.mipmapCount;
                        for(var f = 0; f < faces; f++){
                            images[f] = {
                                mipmaps: []
                            };
                            for(var i = 0; i < texDatas.mipmapCount; i++){
                                images[f].mipmaps.push(texDatas.mipmaps[f * texDatas.mipmapCount + i]);
                                images[f].format = texDatas.format;
                                images[f].width = texDatas.width;
                                images[f].height = texDatas.height;
                            }
                        }
                        texture.image = images;
                    } else {
                        texture.image.width = texDatas.width;
                        texture.image.height = texDatas.height;
                        texture.mipmaps = texDatas.mipmaps;
                    }
                    if (texDatas.mipmapCount === 1) texture.minFilter = $1a55656020b89c3a$export$8a72f490b25c56c8;
                    texture.format = texDatas.format;
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }, onProgress, onError);
                return texture;
            }
        }
    ]);
    return CompressedTextureLoader;
}($1a55656020b89c3a$export$3b0d6d7590275603);
var $1a55656020b89c3a$export$8905ce1c7a2464a1 = /*#__PURE__*/ function(Loader) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(ImageLoader, Loader);
    function ImageLoader(manager) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, ImageLoader);
        return (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, ImageLoader, [
            manager
        ]);
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(ImageLoader, [
        {
            key: "load",
            value: function load(url, onLoad, onProgress, onError) {
                if (this.path !== undefined) url = this.path + url;
                url = this.manager.resolveURL(url);
                var scope = this;
                var cached = $1a55656020b89c3a$export$94affb487e701bf2.get(url);
                if (cached !== undefined) {
                    scope.manager.itemStart(url);
                    setTimeout(function() {
                        if (onLoad) onLoad(cached);
                        scope.manager.itemEnd(url);
                    }, 0);
                    return cached;
                }
                var image = $1a55656020b89c3a$export$7094a064528c7fee('img');
                function onImageLoad() {
                    removeEventListeners();
                    $1a55656020b89c3a$export$94affb487e701bf2.add(url, this);
                    if (onLoad) onLoad(this);
                    scope.manager.itemEnd(url);
                }
                function onImageError(event) {
                    removeEventListeners();
                    if (onError) onError(event);
                    scope.manager.itemError(url);
                    scope.manager.itemEnd(url);
                }
                function removeEventListeners() {
                    image.removeEventListener('load', onImageLoad, false);
                    image.removeEventListener('error', onImageError, false);
                }
                image.addEventListener('load', onImageLoad, false);
                image.addEventListener('error', onImageError, false);
                if (url.slice(0, 5) !== 'data:') {
                    if (this.crossOrigin !== undefined) image.crossOrigin = this.crossOrigin;
                }
                scope.manager.itemStart(url);
                image.src = url;
                return image;
            }
        }
    ]);
    return ImageLoader;
}($1a55656020b89c3a$export$3b0d6d7590275603);
var $1a55656020b89c3a$export$2ec114afc2cf6308 = /*#__PURE__*/ function(Loader) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(CubeTextureLoader, Loader);
    function CubeTextureLoader(manager) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, CubeTextureLoader);
        return (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, CubeTextureLoader, [
            manager
        ]);
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(CubeTextureLoader, [
        {
            key: "load",
            value: function load(urls, onLoad, onProgress, onError) {
                var texture = new $1a55656020b89c3a$export$ee2e5a18258a4049();
                texture.colorSpace = $1a55656020b89c3a$export$561f394b24edfcaa;
                var loader = new $1a55656020b89c3a$export$8905ce1c7a2464a1(this.manager);
                loader.setCrossOrigin(this.crossOrigin);
                loader.setPath(this.path);
                var loaded = 0;
                function loadTexture(i) {
                    loader.load(urls[i], function(image) {
                        texture.images[i] = image;
                        loaded++;
                        if (loaded === 6) {
                            texture.needsUpdate = true;
                            if (onLoad) onLoad(texture);
                        }
                    }, undefined, onError);
                }
                for(var i = 0; i < urls.length; ++i)loadTexture(i);
                return texture;
            }
        }
    ]);
    return CubeTextureLoader;
}($1a55656020b89c3a$export$3b0d6d7590275603);
/**
 * Abstract Base class to load generic binary textures formats (rgbe, hdr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ var $1a55656020b89c3a$export$792d8a18f2c55855 = /*#__PURE__*/ function(Loader) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(DataTextureLoader, Loader);
    function DataTextureLoader(manager) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, DataTextureLoader);
        return (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, DataTextureLoader, [
            manager
        ]);
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(DataTextureLoader, [
        {
            key: "load",
            value: function load(url, onLoad, onProgress, onError) {
                var scope = this;
                var texture = new $1a55656020b89c3a$export$b691f601014eabe1();
                var loader = new $1a55656020b89c3a$export$98435a25b5cf7b2b(this.manager);
                loader.setResponseType('arraybuffer');
                loader.setRequestHeader(this.requestHeader);
                loader.setPath(this.path);
                loader.setWithCredentials(scope.withCredentials);
                loader.load(url, function(buffer) {
                    var texData;
                    try {
                        texData = scope.parse(buffer);
                    } catch (error) {
                        if (onError !== undefined) onError(error);
                        else {
                            console.error(error);
                            return;
                        }
                    }
                    if (texData.image !== undefined) texture.image = texData.image;
                    else if (texData.data !== undefined) {
                        texture.image.width = texData.width;
                        texture.image.height = texData.height;
                        texture.image.data = texData.data;
                    }
                    texture.wrapS = texData.wrapS !== undefined ? texData.wrapS : $1a55656020b89c3a$export$9d9334239a5a5e06;
                    texture.wrapT = texData.wrapT !== undefined ? texData.wrapT : $1a55656020b89c3a$export$9d9334239a5a5e06;
                    texture.magFilter = texData.magFilter !== undefined ? texData.magFilter : $1a55656020b89c3a$export$8a72f490b25c56c8;
                    texture.minFilter = texData.minFilter !== undefined ? texData.minFilter : $1a55656020b89c3a$export$8a72f490b25c56c8;
                    texture.anisotropy = texData.anisotropy !== undefined ? texData.anisotropy : 1;
                    if (texData.colorSpace !== undefined) texture.colorSpace = texData.colorSpace;
                    if (texData.flipY !== undefined) texture.flipY = texData.flipY;
                    if (texData.format !== undefined) texture.format = texData.format;
                    if (texData.type !== undefined) texture.type = texData.type;
                    if (texData.mipmaps !== undefined) {
                        texture.mipmaps = texData.mipmaps;
                        texture.minFilter = $1a55656020b89c3a$export$5d8599b6a933fb1b; // presumably...
                    }
                    if (texData.mipmapCount === 1) texture.minFilter = $1a55656020b89c3a$export$8a72f490b25c56c8;
                    if (texData.generateMipmaps !== undefined) texture.generateMipmaps = texData.generateMipmaps;
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture, texData);
                }, onProgress, onError);
                return texture;
            }
        }
    ]);
    return DataTextureLoader;
}($1a55656020b89c3a$export$3b0d6d7590275603);
var $1a55656020b89c3a$export$fd1bfc71f64c538c = /*#__PURE__*/ function(Loader) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(TextureLoader, Loader);
    function TextureLoader(manager) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, TextureLoader);
        return (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, TextureLoader, [
            manager
        ]);
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(TextureLoader, [
        {
            key: "load",
            value: function load(url, onLoad, onProgress, onError) {
                var texture = new $1a55656020b89c3a$export$5431306cf43de24a();
                var loader = new $1a55656020b89c3a$export$8905ce1c7a2464a1(this.manager);
                loader.setCrossOrigin(this.crossOrigin);
                loader.setPath(this.path);
                loader.load(url, function(image) {
                    texture.image = image;
                    texture.needsUpdate = true;
                    if (onLoad !== undefined) onLoad(texture);
                }, onProgress, onError);
                return texture;
            }
        }
    ]);
    return TextureLoader;
}($1a55656020b89c3a$export$3b0d6d7590275603);
var $1a55656020b89c3a$export$6ecadb6ed240d696 = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(Light, Object3D);
    function Light(color) {
        var intensity = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Light);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, Light);
        _this.isLight = true;
        _this.type = 'Light';
        _this.color = new $1a55656020b89c3a$export$892596cec99bc70e(color);
        _this.intensity = intensity;
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Light, [
        {
            key: "dispose",
            value: function dispose() {
            // Empty here in base class; some subclasses override.
            }
        },
        {
            key: "copy",
            value: function copy(source, recursive) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(Light.prototype), "copy", this).call(this, source, recursive);
                this.color.copy(source.color);
                this.intensity = source.intensity;
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON(meta) {
                var data = (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(Light.prototype), "toJSON", this).call(this, meta);
                data.object.color = this.color.getHex();
                data.object.intensity = this.intensity;
                if (this.groundColor !== undefined) data.object.groundColor = this.groundColor.getHex();
                if (this.distance !== undefined) data.object.distance = this.distance;
                if (this.angle !== undefined) data.object.angle = this.angle;
                if (this.decay !== undefined) data.object.decay = this.decay;
                if (this.penumbra !== undefined) data.object.penumbra = this.penumbra;
                if (this.shadow !== undefined) data.object.shadow = this.shadow.toJSON();
                if (this.target !== undefined) data.object.target = this.target.uuid;
                return data;
            }
        }
    ]);
    return Light;
}($1a55656020b89c3a$export$e4dd07dff30cc924);
var $1a55656020b89c3a$export$8d474f55edbb9624 = /*#__PURE__*/ function(Light) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(HemisphereLight, Light);
    function HemisphereLight(skyColor, groundColor, intensity) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, HemisphereLight);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, HemisphereLight, [
            skyColor,
            intensity
        ]);
        _this.isHemisphereLight = true;
        _this.type = 'HemisphereLight';
        _this.position.copy($1a55656020b89c3a$export$e4dd07dff30cc924.DEFAULT_UP);
        _this.updateMatrix();
        _this.groundColor = new $1a55656020b89c3a$export$892596cec99bc70e(groundColor);
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(HemisphereLight, [
        {
            key: "copy",
            value: function copy(source, recursive) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(HemisphereLight.prototype), "copy", this).call(this, source, recursive);
                this.groundColor.copy(source.groundColor);
                return this;
            }
        }
    ]);
    return HemisphereLight;
}($1a55656020b89c3a$export$6ecadb6ed240d696);
var $1a55656020b89c3a$var$_projScreenMatrix$1 = /*@__PURE__*/ new $1a55656020b89c3a$export$2ae72fc923e5eb5();
var $1a55656020b89c3a$var$_lightPositionWorld$1 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_lookTarget$1 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$LightShadow = /*#__PURE__*/ function() {
    "use strict";
    function LightShadow(camera) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, LightShadow);
        this.camera = camera;
        this.intensity = 1;
        this.bias = 0;
        this.normalBias = 0;
        this.radius = 1;
        this.blurSamples = 8;
        this.mapSize = new $1a55656020b89c3a$export$c977b3e384af9ae1(512, 512);
        this.map = null;
        this.mapPass = null;
        this.matrix = new $1a55656020b89c3a$export$2ae72fc923e5eb5();
        this.autoUpdate = true;
        this.needsUpdate = false;
        this._frustum = new $1a55656020b89c3a$export$35efe6f4c85463d2();
        this._frameExtents = new $1a55656020b89c3a$export$c977b3e384af9ae1(1, 1);
        this._viewportCount = 1;
        this._viewports = [
            new $1a55656020b89c3a$export$fa7daccca11cdbe3(0, 0, 1, 1)
        ];
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(LightShadow, [
        {
            key: "getViewportCount",
            value: function getViewportCount() {
                return this._viewportCount;
            }
        },
        {
            key: "getFrustum",
            value: function getFrustum() {
                return this._frustum;
            }
        },
        {
            key: "updateMatrices",
            value: function updateMatrices(light) {
                var shadowCamera = this.camera;
                var shadowMatrix = this.matrix;
                $1a55656020b89c3a$var$_lightPositionWorld$1.setFromMatrixPosition(light.matrixWorld);
                shadowCamera.position.copy($1a55656020b89c3a$var$_lightPositionWorld$1);
                $1a55656020b89c3a$var$_lookTarget$1.setFromMatrixPosition(light.target.matrixWorld);
                shadowCamera.lookAt($1a55656020b89c3a$var$_lookTarget$1);
                shadowCamera.updateMatrixWorld();
                $1a55656020b89c3a$var$_projScreenMatrix$1.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
                this._frustum.setFromProjectionMatrix($1a55656020b89c3a$var$_projScreenMatrix$1);
                shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0);
                shadowMatrix.multiply($1a55656020b89c3a$var$_projScreenMatrix$1);
            }
        },
        {
            key: "getViewport",
            value: function getViewport(viewportIndex) {
                return this._viewports[viewportIndex];
            }
        },
        {
            key: "getFrameExtents",
            value: function getFrameExtents() {
                return this._frameExtents;
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                if (this.map) this.map.dispose();
                if (this.mapPass) this.mapPass.dispose();
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                this.camera = source.camera.clone();
                this.intensity = source.intensity;
                this.bias = source.bias;
                this.radius = source.radius;
                this.mapSize.copy(source.mapSize);
                return this;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var object = {};
                if (this.intensity !== 1) object.intensity = this.intensity;
                if (this.bias !== 0) object.bias = this.bias;
                if (this.normalBias !== 0) object.normalBias = this.normalBias;
                if (this.radius !== 1) object.radius = this.radius;
                if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
                object.camera = this.camera.toJSON(false).object;
                delete object.camera.matrix;
                return object;
            }
        }
    ]);
    return LightShadow;
}();
var $1a55656020b89c3a$var$SpotLightShadow = /*#__PURE__*/ function(LightShadow) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(SpotLightShadow, LightShadow);
    function SpotLightShadow() {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, SpotLightShadow);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, SpotLightShadow, [
            new $1a55656020b89c3a$export$74e4ae24825f68d7(50, 1, 0.5, 500)
        ]);
        _this.isSpotLightShadow = true;
        _this.focus = 1;
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(SpotLightShadow, [
        {
            key: "updateMatrices",
            value: function updateMatrices(light) {
                var camera = this.camera;
                var fov = $1a55656020b89c3a$export$914076c8150813e5 * 2 * light.angle * this.focus;
                var aspect = this.mapSize.width / this.mapSize.height;
                var far = light.distance || camera.far;
                if (fov !== camera.fov || aspect !== camera.aspect || far !== camera.far) {
                    camera.fov = fov;
                    camera.aspect = aspect;
                    camera.far = far;
                    camera.updateProjectionMatrix();
                }
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(SpotLightShadow.prototype), "updateMatrices", this).call(this, light);
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(SpotLightShadow.prototype), "copy", this).call(this, source);
                this.focus = source.focus;
                return this;
            }
        }
    ]);
    return SpotLightShadow;
}($1a55656020b89c3a$var$LightShadow);
var $1a55656020b89c3a$export$81495cbb73897362 = /*#__PURE__*/ function(Light) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(SpotLight, Light);
    function SpotLight(color, intensity) {
        var distance = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, angle = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Math.PI / 3, penumbra = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0, decay = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 2;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, SpotLight);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, SpotLight, [
            color,
            intensity
        ]);
        _this.isSpotLight = true;
        _this.type = 'SpotLight';
        _this.position.copy($1a55656020b89c3a$export$e4dd07dff30cc924.DEFAULT_UP);
        _this.updateMatrix();
        _this.target = new $1a55656020b89c3a$export$e4dd07dff30cc924();
        _this.distance = distance;
        _this.angle = angle;
        _this.penumbra = penumbra;
        _this.decay = decay;
        _this.map = null;
        _this.shadow = new $1a55656020b89c3a$var$SpotLightShadow();
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(SpotLight, [
        {
            key: "power",
            get: function get() {
                // compute the light's luminous power (in lumens) from its intensity (in candela)
                // by convention for a spotlight, luminous power (lm) = π * luminous intensity (cd)
                return this.intensity * Math.PI;
            },
            set: function set(power) {
                // set the light's intensity (in candela) from the desired luminous power (in lumens)
                this.intensity = power / Math.PI;
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this.shadow.dispose();
            }
        },
        {
            key: "copy",
            value: function copy(source, recursive) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(SpotLight.prototype), "copy", this).call(this, source, recursive);
                this.distance = source.distance;
                this.angle = source.angle;
                this.penumbra = source.penumbra;
                this.decay = source.decay;
                this.target = source.target.clone();
                this.shadow = source.shadow.clone();
                return this;
            }
        }
    ]);
    return SpotLight;
}($1a55656020b89c3a$export$6ecadb6ed240d696);
var $1a55656020b89c3a$var$_projScreenMatrix = /*@__PURE__*/ new $1a55656020b89c3a$export$2ae72fc923e5eb5();
var $1a55656020b89c3a$var$_lightPositionWorld = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_lookTarget = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$PointLightShadow = /*#__PURE__*/ function(LightShadow) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(PointLightShadow, LightShadow);
    function PointLightShadow() {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, PointLightShadow);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, PointLightShadow, [
            new $1a55656020b89c3a$export$74e4ae24825f68d7(90, 1, 0.5, 500)
        ]);
        _this.isPointLightShadow = true;
        _this._frameExtents = new $1a55656020b89c3a$export$c977b3e384af9ae1(4, 2);
        _this._viewportCount = 6;
        _this._viewports = [
            // These viewports map a cube-map onto a 2D texture with the
            // following orientation:
            //
            //  xzXZ
            //   y Y
            //
            // X - Positive x direction
            // x - Negative x direction
            // Y - Positive y direction
            // y - Negative y direction
            // Z - Positive z direction
            // z - Negative z direction
            // positive X
            new $1a55656020b89c3a$export$fa7daccca11cdbe3(2, 1, 1, 1),
            // negative X
            new $1a55656020b89c3a$export$fa7daccca11cdbe3(0, 1, 1, 1),
            // positive Z
            new $1a55656020b89c3a$export$fa7daccca11cdbe3(3, 1, 1, 1),
            // negative Z
            new $1a55656020b89c3a$export$fa7daccca11cdbe3(1, 1, 1, 1),
            // positive Y
            new $1a55656020b89c3a$export$fa7daccca11cdbe3(3, 0, 1, 1),
            // negative Y
            new $1a55656020b89c3a$export$fa7daccca11cdbe3(1, 0, 1, 1)
        ];
        _this._cubeDirections = [
            new $1a55656020b89c3a$export$64b5c384219d3699(1, 0, 0),
            new $1a55656020b89c3a$export$64b5c384219d3699(-1, 0, 0),
            new $1a55656020b89c3a$export$64b5c384219d3699(0, 0, 1),
            new $1a55656020b89c3a$export$64b5c384219d3699(0, 0, -1),
            new $1a55656020b89c3a$export$64b5c384219d3699(0, 1, 0),
            new $1a55656020b89c3a$export$64b5c384219d3699(0, -1, 0)
        ];
        _this._cubeUps = [
            new $1a55656020b89c3a$export$64b5c384219d3699(0, 1, 0),
            new $1a55656020b89c3a$export$64b5c384219d3699(0, 1, 0),
            new $1a55656020b89c3a$export$64b5c384219d3699(0, 1, 0),
            new $1a55656020b89c3a$export$64b5c384219d3699(0, 1, 0),
            new $1a55656020b89c3a$export$64b5c384219d3699(0, 0, 1),
            new $1a55656020b89c3a$export$64b5c384219d3699(0, 0, -1)
        ];
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(PointLightShadow, [
        {
            key: "updateMatrices",
            value: function updateMatrices(light) {
                var viewportIndex = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var camera = this.camera;
                var shadowMatrix = this.matrix;
                var far = light.distance || camera.far;
                if (far !== camera.far) {
                    camera.far = far;
                    camera.updateProjectionMatrix();
                }
                $1a55656020b89c3a$var$_lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
                camera.position.copy($1a55656020b89c3a$var$_lightPositionWorld);
                $1a55656020b89c3a$var$_lookTarget.copy(camera.position);
                $1a55656020b89c3a$var$_lookTarget.add(this._cubeDirections[viewportIndex]);
                camera.up.copy(this._cubeUps[viewportIndex]);
                camera.lookAt($1a55656020b89c3a$var$_lookTarget);
                camera.updateMatrixWorld();
                shadowMatrix.makeTranslation(-$1a55656020b89c3a$var$_lightPositionWorld.x, -$1a55656020b89c3a$var$_lightPositionWorld.y, -$1a55656020b89c3a$var$_lightPositionWorld.z);
                $1a55656020b89c3a$var$_projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
                this._frustum.setFromProjectionMatrix($1a55656020b89c3a$var$_projScreenMatrix);
            }
        }
    ]);
    return PointLightShadow;
}($1a55656020b89c3a$var$LightShadow);
var $1a55656020b89c3a$export$4c9c1cb3f0b6f455 = /*#__PURE__*/ function(Light) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(PointLight, Light);
    function PointLight(color, intensity) {
        var distance = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, decay = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 2;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, PointLight);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, PointLight, [
            color,
            intensity
        ]);
        _this.isPointLight = true;
        _this.type = 'PointLight';
        _this.distance = distance;
        _this.decay = decay;
        _this.shadow = new $1a55656020b89c3a$var$PointLightShadow();
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(PointLight, [
        {
            key: "power",
            get: function get() {
                // compute the light's luminous power (in lumens) from its intensity (in candela)
                // for an isotropic light source, luminous power (lm) = 4 π luminous intensity (cd)
                return this.intensity * 4 * Math.PI;
            },
            set: function set(power) {
                // set the light's intensity (in candela) from the desired luminous power (in lumens)
                this.intensity = power / (4 * Math.PI);
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this.shadow.dispose();
            }
        },
        {
            key: "copy",
            value: function copy(source, recursive) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(PointLight.prototype), "copy", this).call(this, source, recursive);
                this.distance = source.distance;
                this.decay = source.decay;
                this.shadow = source.shadow.clone();
                return this;
            }
        }
    ]);
    return PointLight;
}($1a55656020b89c3a$export$6ecadb6ed240d696);
var $1a55656020b89c3a$export$9ebf355ee4ed261b = /*#__PURE__*/ function(Camera) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(OrthographicCamera, Camera);
    function OrthographicCamera() {
        var left = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : -1, right = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, top = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, bottom = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : -1, near = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0.1, far = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 2000;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, OrthographicCamera);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, OrthographicCamera);
        _this.isOrthographicCamera = true;
        _this.type = 'OrthographicCamera';
        _this.zoom = 1;
        _this.view = null;
        _this.left = left;
        _this.right = right;
        _this.top = top;
        _this.bottom = bottom;
        _this.near = near;
        _this.far = far;
        _this.updateProjectionMatrix();
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(OrthographicCamera, [
        {
            key: "copy",
            value: function copy(source, recursive) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(OrthographicCamera.prototype), "copy", this).call(this, source, recursive);
                this.left = source.left;
                this.right = source.right;
                this.top = source.top;
                this.bottom = source.bottom;
                this.near = source.near;
                this.far = source.far;
                this.zoom = source.zoom;
                this.view = source.view === null ? null : Object.assign({}, source.view);
                return this;
            }
        },
        {
            key: "setViewOffset",
            value: function setViewOffset(fullWidth, fullHeight, x, y, width, height) {
                if (this.view === null) this.view = {
                    enabled: true,
                    fullWidth: 1,
                    fullHeight: 1,
                    offsetX: 0,
                    offsetY: 0,
                    width: 1,
                    height: 1
                };
                this.view.enabled = true;
                this.view.fullWidth = fullWidth;
                this.view.fullHeight = fullHeight;
                this.view.offsetX = x;
                this.view.offsetY = y;
                this.view.width = width;
                this.view.height = height;
                this.updateProjectionMatrix();
            }
        },
        {
            key: "clearViewOffset",
            value: function clearViewOffset() {
                if (this.view !== null) this.view.enabled = false;
                this.updateProjectionMatrix();
            }
        },
        {
            key: "updateProjectionMatrix",
            value: function updateProjectionMatrix() {
                var dx = (this.right - this.left) / (2 * this.zoom);
                var dy = (this.top - this.bottom) / (2 * this.zoom);
                var cx = (this.right + this.left) / 2;
                var cy = (this.top + this.bottom) / 2;
                var left = cx - dx;
                var right = cx + dx;
                var top = cy + dy;
                var bottom = cy - dy;
                if (this.view !== null && this.view.enabled) {
                    var scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
                    var scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
                    left += scaleW * this.view.offsetX;
                    right = left + scaleW * this.view.width;
                    top -= scaleH * this.view.offsetY;
                    bottom = top - scaleH * this.view.height;
                }
                this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far, this.coordinateSystem);
                this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
            }
        },
        {
            key: "toJSON",
            value: function toJSON(meta) {
                var data = (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(OrthographicCamera.prototype), "toJSON", this).call(this, meta);
                data.object.zoom = this.zoom;
                data.object.left = this.left;
                data.object.right = this.right;
                data.object.top = this.top;
                data.object.bottom = this.bottom;
                data.object.near = this.near;
                data.object.far = this.far;
                if (this.view !== null) data.object.view = Object.assign({}, this.view);
                return data;
            }
        }
    ]);
    return OrthographicCamera;
}($1a55656020b89c3a$export$79f141de891a5fed);
var $1a55656020b89c3a$var$DirectionalLightShadow = /*#__PURE__*/ function(LightShadow) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(DirectionalLightShadow, LightShadow);
    function DirectionalLightShadow() {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, DirectionalLightShadow);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, DirectionalLightShadow, [
            new $1a55656020b89c3a$export$9ebf355ee4ed261b(-5, 5, 5, -5, 0.5, 500)
        ]);
        _this.isDirectionalLightShadow = true;
        return _this;
    }
    return DirectionalLightShadow;
}($1a55656020b89c3a$var$LightShadow);
var $1a55656020b89c3a$export$3fea33cc9972c868 = /*#__PURE__*/ function(Light) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(DirectionalLight, Light);
    function DirectionalLight(color, intensity) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, DirectionalLight);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, DirectionalLight, [
            color,
            intensity
        ]);
        _this.isDirectionalLight = true;
        _this.type = 'DirectionalLight';
        _this.position.copy($1a55656020b89c3a$export$e4dd07dff30cc924.DEFAULT_UP);
        _this.updateMatrix();
        _this.target = new $1a55656020b89c3a$export$e4dd07dff30cc924();
        _this.shadow = new $1a55656020b89c3a$var$DirectionalLightShadow();
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(DirectionalLight, [
        {
            key: "dispose",
            value: function dispose() {
                this.shadow.dispose();
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(DirectionalLight.prototype), "copy", this).call(this, source);
                this.target = source.target.clone();
                this.shadow = source.shadow.clone();
                return this;
            }
        }
    ]);
    return DirectionalLight;
}($1a55656020b89c3a$export$6ecadb6ed240d696);
var $1a55656020b89c3a$export$af279bfef9ec2c96 = /*#__PURE__*/ function(Light) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(AmbientLight, Light);
    function AmbientLight(color, intensity) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, AmbientLight);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, AmbientLight, [
            color,
            intensity
        ]);
        _this.isAmbientLight = true;
        _this.type = 'AmbientLight';
        return _this;
    }
    return AmbientLight;
}($1a55656020b89c3a$export$6ecadb6ed240d696);
var $1a55656020b89c3a$export$61db2d908bbd2429 = /*#__PURE__*/ function(Light) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(RectAreaLight, Light);
    function RectAreaLight(color, intensity) {
        var width = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 10, height = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 10;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, RectAreaLight);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, RectAreaLight, [
            color,
            intensity
        ]);
        _this.isRectAreaLight = true;
        _this.type = 'RectAreaLight';
        _this.width = width;
        _this.height = height;
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(RectAreaLight, [
        {
            key: "power",
            get: function get() {
                // compute the light's luminous power (in lumens) from its intensity (in nits)
                return this.intensity * this.width * this.height * Math.PI;
            },
            set: function set(power) {
                // set the light's intensity (in nits) from the desired luminous power (in lumens)
                this.intensity = power / (this.width * this.height * Math.PI);
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(RectAreaLight.prototype), "copy", this).call(this, source);
                this.width = source.width;
                this.height = source.height;
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON(meta) {
                var data = (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(RectAreaLight.prototype), "toJSON", this).call(this, meta);
                data.object.width = this.width;
                data.object.height = this.height;
                return data;
            }
        }
    ]);
    return RectAreaLight;
}($1a55656020b89c3a$export$6ecadb6ed240d696);
/**
 * Primary reference:
 *   https://graphics.stanford.edu/papers/envmap/envmap.pdf
 *
 * Secondary reference:
 *   https://www.ppsloan.org/publications/StupidSH36.pdf
 */ // 3-band SH defined by 9 coefficients
var $1a55656020b89c3a$export$ba61ce607e1f405a = /*#__PURE__*/ function() {
    "use strict";
    function SphericalHarmonics3() {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, SphericalHarmonics3);
        this.isSphericalHarmonics3 = true;
        this.coefficients = [];
        for(var i = 0; i < 9; i++)this.coefficients.push(new $1a55656020b89c3a$export$64b5c384219d3699());
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(SphericalHarmonics3, [
        {
            key: "set",
            value: function set(coefficients) {
                for(var i = 0; i < 9; i++)this.coefficients[i].copy(coefficients[i]);
                return this;
            }
        },
        {
            key: "zero",
            value: function zero() {
                for(var i = 0; i < 9; i++)this.coefficients[i].set(0, 0, 0);
                return this;
            }
        },
        {
            // get the radiance in the direction of the normal
            // target is a Vector3
            key: "getAt",
            value: function getAt(normal, target) {
                // normal is assumed to be unit length
                var x = normal.x, y = normal.y, z = normal.z;
                var coeff = this.coefficients;
                // band 0
                target.copy(coeff[0]).multiplyScalar(0.282095);
                // band 1
                target.addScaledVector(coeff[1], 0.488603 * y);
                target.addScaledVector(coeff[2], 0.488603 * z);
                target.addScaledVector(coeff[3], 0.488603 * x);
                // band 2
                target.addScaledVector(coeff[4], 1.092548 * (x * y));
                target.addScaledVector(coeff[5], 1.092548 * (y * z));
                target.addScaledVector(coeff[6], 0.315392 * (3.0 * z * z - 1.0));
                target.addScaledVector(coeff[7], 1.092548 * (x * z));
                target.addScaledVector(coeff[8], 0.546274 * (x * x - y * y));
                return target;
            }
        },
        {
            // get the irradiance (radiance convolved with cosine lobe) in the direction of the normal
            // target is a Vector3
            // https://graphics.stanford.edu/papers/envmap/envmap.pdf
            key: "getIrradianceAt",
            value: function getIrradianceAt(normal, target) {
                // normal is assumed to be unit length
                var x = normal.x, y = normal.y, z = normal.z;
                var coeff = this.coefficients;
                // band 0
                target.copy(coeff[0]).multiplyScalar(0.886227); // π * 0.282095
                // band 1
                target.addScaledVector(coeff[1], 1.023328 * y); // ( 2 * π / 3 ) * 0.488603
                target.addScaledVector(coeff[2], 1.023328 * z);
                target.addScaledVector(coeff[3], 1.023328 * x);
                // band 2
                target.addScaledVector(coeff[4], 0.858086 * x * y); // ( π / 4 ) * 1.092548
                target.addScaledVector(coeff[5], 0.858086 * y * z);
                target.addScaledVector(coeff[6], 0.743125 * z * z - 0.247708); // ( π / 4 ) * 0.315392 * 3
                target.addScaledVector(coeff[7], 0.858086 * x * z);
                target.addScaledVector(coeff[8], 0.429043 * (x * x - y * y)); // ( π / 4 ) * 0.546274
                return target;
            }
        },
        {
            key: "add",
            value: function add(sh) {
                for(var i = 0; i < 9; i++)this.coefficients[i].add(sh.coefficients[i]);
                return this;
            }
        },
        {
            key: "addScaledSH",
            value: function addScaledSH(sh, s) {
                for(var i = 0; i < 9; i++)this.coefficients[i].addScaledVector(sh.coefficients[i], s);
                return this;
            }
        },
        {
            key: "scale",
            value: function scale(s) {
                for(var i = 0; i < 9; i++)this.coefficients[i].multiplyScalar(s);
                return this;
            }
        },
        {
            key: "lerp",
            value: function lerp(sh, alpha) {
                for(var i = 0; i < 9; i++)this.coefficients[i].lerp(sh.coefficients[i], alpha);
                return this;
            }
        },
        {
            key: "equals",
            value: function equals(sh) {
                for(var i = 0; i < 9; i++){
                    if (!this.coefficients[i].equals(sh.coefficients[i])) return false;
                }
                return true;
            }
        },
        {
            key: "copy",
            value: function copy(sh) {
                return this.set(sh.coefficients);
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        },
        {
            key: "fromArray",
            value: function fromArray(array) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var coefficients = this.coefficients;
                for(var i = 0; i < 9; i++)coefficients[i].fromArray(array, offset + i * 3);
                return this;
            }
        },
        {
            key: "toArray",
            value: function toArray() {
                var array = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var coefficients = this.coefficients;
                for(var i = 0; i < 9; i++)coefficients[i].toArray(array, offset + i * 3);
                return array;
            }
        }
    ], [
        {
            key: "getBasisAt",
            value: // evaluate the basis functions
            // shBasis is an Array[ 9 ]
            function getBasisAt(normal, shBasis) {
                // normal is assumed to be unit length
                var x = normal.x, y = normal.y, z = normal.z;
                // band 0
                shBasis[0] = 0.282095;
                // band 1
                shBasis[1] = 0.488603 * y;
                shBasis[2] = 0.488603 * z;
                shBasis[3] = 0.488603 * x;
                // band 2
                shBasis[4] = 1.092548 * x * y;
                shBasis[5] = 1.092548 * y * z;
                shBasis[6] = 0.315392 * (3 * z * z - 1);
                shBasis[7] = 1.092548 * x * z;
                shBasis[8] = 0.546274 * (x * x - y * y);
            }
        }
    ]);
    return SphericalHarmonics3;
}();
var $1a55656020b89c3a$export$e7ef036e309b38d2 = /*#__PURE__*/ function(Light) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(LightProbe, Light);
    function LightProbe() {
        var sh = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $1a55656020b89c3a$export$ba61ce607e1f405a(), intensity = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, LightProbe);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, LightProbe, [
            undefined,
            intensity
        ]);
        _this.isLightProbe = true;
        _this.sh = sh;
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(LightProbe, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(LightProbe.prototype), "copy", this).call(this, source);
                this.sh.copy(source.sh);
                return this;
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(json) {
                this.intensity = json.intensity; // TODO: Move this bit to Light.fromJSON();
                this.sh.fromArray(json.sh);
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON(meta) {
                var data = (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(LightProbe.prototype), "toJSON", this).call(this, meta);
                data.object.sh = this.sh.toArray();
                return data;
            }
        }
    ]);
    return LightProbe;
}($1a55656020b89c3a$export$6ecadb6ed240d696);
var $1a55656020b89c3a$export$3bd6d323353dcf96 = /*#__PURE__*/ function(Loader) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(MaterialLoader, Loader);
    function MaterialLoader(manager) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, MaterialLoader);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, MaterialLoader, [
            manager
        ]);
        _this.textures = {};
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(MaterialLoader, [
        {
            key: "load",
            value: function load(url, onLoad, onProgress, onError) {
                var scope = this;
                var loader = new $1a55656020b89c3a$export$98435a25b5cf7b2b(scope.manager);
                loader.setPath(scope.path);
                loader.setRequestHeader(scope.requestHeader);
                loader.setWithCredentials(scope.withCredentials);
                loader.load(url, function(text) {
                    try {
                        onLoad(scope.parse(JSON.parse(text)));
                    } catch (e) {
                        if (onError) onError(e);
                        else console.error(e);
                        scope.manager.itemError(url);
                    }
                }, onProgress, onError);
            }
        },
        {
            key: "parse",
            value: function parse(json) {
                var textures = this.textures;
                function getTexture(name) {
                    if (textures[name] === undefined) console.warn('THREE.MaterialLoader: Undefined texture', name);
                    return textures[name];
                }
                var material = this.createMaterialFromType(json.type);
                if (json.uuid !== undefined) material.uuid = json.uuid;
                if (json.name !== undefined) material.name = json.name;
                if (json.color !== undefined && material.color !== undefined) material.color.setHex(json.color);
                if (json.roughness !== undefined) material.roughness = json.roughness;
                if (json.metalness !== undefined) material.metalness = json.metalness;
                if (json.sheen !== undefined) material.sheen = json.sheen;
                if (json.sheenColor !== undefined) material.sheenColor = new $1a55656020b89c3a$export$892596cec99bc70e().setHex(json.sheenColor);
                if (json.sheenRoughness !== undefined) material.sheenRoughness = json.sheenRoughness;
                if (json.emissive !== undefined && material.emissive !== undefined) material.emissive.setHex(json.emissive);
                if (json.specular !== undefined && material.specular !== undefined) material.specular.setHex(json.specular);
                if (json.specularIntensity !== undefined) material.specularIntensity = json.specularIntensity;
                if (json.specularColor !== undefined && material.specularColor !== undefined) material.specularColor.setHex(json.specularColor);
                if (json.shininess !== undefined) material.shininess = json.shininess;
                if (json.clearcoat !== undefined) material.clearcoat = json.clearcoat;
                if (json.clearcoatRoughness !== undefined) material.clearcoatRoughness = json.clearcoatRoughness;
                if (json.dispersion !== undefined) material.dispersion = json.dispersion;
                if (json.iridescence !== undefined) material.iridescence = json.iridescence;
                if (json.iridescenceIOR !== undefined) material.iridescenceIOR = json.iridescenceIOR;
                if (json.iridescenceThicknessRange !== undefined) material.iridescenceThicknessRange = json.iridescenceThicknessRange;
                if (json.transmission !== undefined) material.transmission = json.transmission;
                if (json.thickness !== undefined) material.thickness = json.thickness;
                if (json.attenuationDistance !== undefined) material.attenuationDistance = json.attenuationDistance;
                if (json.attenuationColor !== undefined && material.attenuationColor !== undefined) material.attenuationColor.setHex(json.attenuationColor);
                if (json.anisotropy !== undefined) material.anisotropy = json.anisotropy;
                if (json.anisotropyRotation !== undefined) material.anisotropyRotation = json.anisotropyRotation;
                if (json.fog !== undefined) material.fog = json.fog;
                if (json.flatShading !== undefined) material.flatShading = json.flatShading;
                if (json.blending !== undefined) material.blending = json.blending;
                if (json.combine !== undefined) material.combine = json.combine;
                if (json.side !== undefined) material.side = json.side;
                if (json.shadowSide !== undefined) material.shadowSide = json.shadowSide;
                if (json.opacity !== undefined) material.opacity = json.opacity;
                if (json.transparent !== undefined) material.transparent = json.transparent;
                if (json.alphaTest !== undefined) material.alphaTest = json.alphaTest;
                if (json.alphaHash !== undefined) material.alphaHash = json.alphaHash;
                if (json.depthFunc !== undefined) material.depthFunc = json.depthFunc;
                if (json.depthTest !== undefined) material.depthTest = json.depthTest;
                if (json.depthWrite !== undefined) material.depthWrite = json.depthWrite;
                if (json.colorWrite !== undefined) material.colorWrite = json.colorWrite;
                if (json.blendSrc !== undefined) material.blendSrc = json.blendSrc;
                if (json.blendDst !== undefined) material.blendDst = json.blendDst;
                if (json.blendEquation !== undefined) material.blendEquation = json.blendEquation;
                if (json.blendSrcAlpha !== undefined) material.blendSrcAlpha = json.blendSrcAlpha;
                if (json.blendDstAlpha !== undefined) material.blendDstAlpha = json.blendDstAlpha;
                if (json.blendEquationAlpha !== undefined) material.blendEquationAlpha = json.blendEquationAlpha;
                if (json.blendColor !== undefined && material.blendColor !== undefined) material.blendColor.setHex(json.blendColor);
                if (json.blendAlpha !== undefined) material.blendAlpha = json.blendAlpha;
                if (json.stencilWriteMask !== undefined) material.stencilWriteMask = json.stencilWriteMask;
                if (json.stencilFunc !== undefined) material.stencilFunc = json.stencilFunc;
                if (json.stencilRef !== undefined) material.stencilRef = json.stencilRef;
                if (json.stencilFuncMask !== undefined) material.stencilFuncMask = json.stencilFuncMask;
                if (json.stencilFail !== undefined) material.stencilFail = json.stencilFail;
                if (json.stencilZFail !== undefined) material.stencilZFail = json.stencilZFail;
                if (json.stencilZPass !== undefined) material.stencilZPass = json.stencilZPass;
                if (json.stencilWrite !== undefined) material.stencilWrite = json.stencilWrite;
                if (json.wireframe !== undefined) material.wireframe = json.wireframe;
                if (json.wireframeLinewidth !== undefined) material.wireframeLinewidth = json.wireframeLinewidth;
                if (json.wireframeLinecap !== undefined) material.wireframeLinecap = json.wireframeLinecap;
                if (json.wireframeLinejoin !== undefined) material.wireframeLinejoin = json.wireframeLinejoin;
                if (json.rotation !== undefined) material.rotation = json.rotation;
                if (json.linewidth !== undefined) material.linewidth = json.linewidth;
                if (json.dashSize !== undefined) material.dashSize = json.dashSize;
                if (json.gapSize !== undefined) material.gapSize = json.gapSize;
                if (json.scale !== undefined) material.scale = json.scale;
                if (json.polygonOffset !== undefined) material.polygonOffset = json.polygonOffset;
                if (json.polygonOffsetFactor !== undefined) material.polygonOffsetFactor = json.polygonOffsetFactor;
                if (json.polygonOffsetUnits !== undefined) material.polygonOffsetUnits = json.polygonOffsetUnits;
                if (json.dithering !== undefined) material.dithering = json.dithering;
                if (json.alphaToCoverage !== undefined) material.alphaToCoverage = json.alphaToCoverage;
                if (json.premultipliedAlpha !== undefined) material.premultipliedAlpha = json.premultipliedAlpha;
                if (json.forceSinglePass !== undefined) material.forceSinglePass = json.forceSinglePass;
                if (json.visible !== undefined) material.visible = json.visible;
                if (json.toneMapped !== undefined) material.toneMapped = json.toneMapped;
                if (json.userData !== undefined) material.userData = json.userData;
                if (json.vertexColors !== undefined) {
                    if (typeof json.vertexColors === 'number') material.vertexColors = json.vertexColors > 0 ? true : false;
                    else material.vertexColors = json.vertexColors;
                }
                // Shader Material
                if (json.uniforms !== undefined) for(var name in json.uniforms){
                    var uniform = json.uniforms[name];
                    material.uniforms[name] = {};
                    switch(uniform.type){
                        case 't':
                            material.uniforms[name].value = getTexture(uniform.value);
                            break;
                        case 'c':
                            material.uniforms[name].value = new $1a55656020b89c3a$export$892596cec99bc70e().setHex(uniform.value);
                            break;
                        case 'v2':
                            material.uniforms[name].value = new $1a55656020b89c3a$export$c977b3e384af9ae1().fromArray(uniform.value);
                            break;
                        case 'v3':
                            material.uniforms[name].value = new $1a55656020b89c3a$export$64b5c384219d3699().fromArray(uniform.value);
                            break;
                        case 'v4':
                            material.uniforms[name].value = new $1a55656020b89c3a$export$fa7daccca11cdbe3().fromArray(uniform.value);
                            break;
                        case 'm3':
                            material.uniforms[name].value = new $1a55656020b89c3a$export$8ff26dafa08918().fromArray(uniform.value);
                            break;
                        case 'm4':
                            material.uniforms[name].value = new $1a55656020b89c3a$export$2ae72fc923e5eb5().fromArray(uniform.value);
                            break;
                        default:
                            material.uniforms[name].value = uniform.value;
                    }
                }
                if (json.defines !== undefined) material.defines = json.defines;
                if (json.vertexShader !== undefined) material.vertexShader = json.vertexShader;
                if (json.fragmentShader !== undefined) material.fragmentShader = json.fragmentShader;
                if (json.glslVersion !== undefined) material.glslVersion = json.glslVersion;
                if (json.extensions !== undefined) for(var key in json.extensions)material.extensions[key] = json.extensions[key];
                if (json.lights !== undefined) material.lights = json.lights;
                if (json.clipping !== undefined) material.clipping = json.clipping;
                // for PointsMaterial
                if (json.size !== undefined) material.size = json.size;
                if (json.sizeAttenuation !== undefined) material.sizeAttenuation = json.sizeAttenuation;
                // maps
                if (json.map !== undefined) material.map = getTexture(json.map);
                if (json.matcap !== undefined) material.matcap = getTexture(json.matcap);
                if (json.alphaMap !== undefined) material.alphaMap = getTexture(json.alphaMap);
                if (json.bumpMap !== undefined) material.bumpMap = getTexture(json.bumpMap);
                if (json.bumpScale !== undefined) material.bumpScale = json.bumpScale;
                if (json.normalMap !== undefined) material.normalMap = getTexture(json.normalMap);
                if (json.normalMapType !== undefined) material.normalMapType = json.normalMapType;
                if (json.normalScale !== undefined) {
                    var normalScale = json.normalScale;
                    if (Array.isArray(normalScale) === false) // Blender exporter used to export a scalar. See #7459
                    normalScale = [
                        normalScale,
                        normalScale
                    ];
                    material.normalScale = new $1a55656020b89c3a$export$c977b3e384af9ae1().fromArray(normalScale);
                }
                if (json.displacementMap !== undefined) material.displacementMap = getTexture(json.displacementMap);
                if (json.displacementScale !== undefined) material.displacementScale = json.displacementScale;
                if (json.displacementBias !== undefined) material.displacementBias = json.displacementBias;
                if (json.roughnessMap !== undefined) material.roughnessMap = getTexture(json.roughnessMap);
                if (json.metalnessMap !== undefined) material.metalnessMap = getTexture(json.metalnessMap);
                if (json.emissiveMap !== undefined) material.emissiveMap = getTexture(json.emissiveMap);
                if (json.emissiveIntensity !== undefined) material.emissiveIntensity = json.emissiveIntensity;
                if (json.specularMap !== undefined) material.specularMap = getTexture(json.specularMap);
                if (json.specularIntensityMap !== undefined) material.specularIntensityMap = getTexture(json.specularIntensityMap);
                if (json.specularColorMap !== undefined) material.specularColorMap = getTexture(json.specularColorMap);
                if (json.envMap !== undefined) material.envMap = getTexture(json.envMap);
                if (json.envMapRotation !== undefined) material.envMapRotation.fromArray(json.envMapRotation);
                if (json.envMapIntensity !== undefined) material.envMapIntensity = json.envMapIntensity;
                if (json.reflectivity !== undefined) material.reflectivity = json.reflectivity;
                if (json.refractionRatio !== undefined) material.refractionRatio = json.refractionRatio;
                if (json.lightMap !== undefined) material.lightMap = getTexture(json.lightMap);
                if (json.lightMapIntensity !== undefined) material.lightMapIntensity = json.lightMapIntensity;
                if (json.aoMap !== undefined) material.aoMap = getTexture(json.aoMap);
                if (json.aoMapIntensity !== undefined) material.aoMapIntensity = json.aoMapIntensity;
                if (json.gradientMap !== undefined) material.gradientMap = getTexture(json.gradientMap);
                if (json.clearcoatMap !== undefined) material.clearcoatMap = getTexture(json.clearcoatMap);
                if (json.clearcoatRoughnessMap !== undefined) material.clearcoatRoughnessMap = getTexture(json.clearcoatRoughnessMap);
                if (json.clearcoatNormalMap !== undefined) material.clearcoatNormalMap = getTexture(json.clearcoatNormalMap);
                if (json.clearcoatNormalScale !== undefined) material.clearcoatNormalScale = new $1a55656020b89c3a$export$c977b3e384af9ae1().fromArray(json.clearcoatNormalScale);
                if (json.iridescenceMap !== undefined) material.iridescenceMap = getTexture(json.iridescenceMap);
                if (json.iridescenceThicknessMap !== undefined) material.iridescenceThicknessMap = getTexture(json.iridescenceThicknessMap);
                if (json.transmissionMap !== undefined) material.transmissionMap = getTexture(json.transmissionMap);
                if (json.thicknessMap !== undefined) material.thicknessMap = getTexture(json.thicknessMap);
                if (json.anisotropyMap !== undefined) material.anisotropyMap = getTexture(json.anisotropyMap);
                if (json.sheenColorMap !== undefined) material.sheenColorMap = getTexture(json.sheenColorMap);
                if (json.sheenRoughnessMap !== undefined) material.sheenRoughnessMap = getTexture(json.sheenRoughnessMap);
                return material;
            }
        },
        {
            key: "setTextures",
            value: function setTextures(value) {
                this.textures = value;
                return this;
            }
        },
        {
            key: "createMaterialFromType",
            value: function createMaterialFromType(type) {
                return MaterialLoader.createMaterialFromType(type);
            }
        }
    ], [
        {
            key: "createMaterialFromType",
            value: function createMaterialFromType(type) {
                var materialLib = {
                    ShadowMaterial: $1a55656020b89c3a$export$e8564da406055a3,
                    SpriteMaterial: $1a55656020b89c3a$export$5ec7dd1c6994bf8e,
                    RawShaderMaterial: $1a55656020b89c3a$export$21c421a2e1df9d22,
                    ShaderMaterial: $1a55656020b89c3a$export$83c7d75d550a8b0d,
                    PointsMaterial: $1a55656020b89c3a$export$a178c45366ce5d6b,
                    MeshPhysicalMaterial: $1a55656020b89c3a$export$28d04986c4269c9f,
                    MeshStandardMaterial: $1a55656020b89c3a$export$f2980790215acccd,
                    MeshPhongMaterial: $1a55656020b89c3a$export$24c72f71cbaf0678,
                    MeshToonMaterial: $1a55656020b89c3a$export$df893cf97e765622,
                    MeshNormalMaterial: $1a55656020b89c3a$export$bfe8c0a091f41ae7,
                    MeshLambertMaterial: $1a55656020b89c3a$export$5023a9a8114806b8,
                    MeshDepthMaterial: $1a55656020b89c3a$export$2698c22ec13825db,
                    MeshDistanceMaterial: $1a55656020b89c3a$export$33e187ed002f2a19,
                    MeshBasicMaterial: $1a55656020b89c3a$export$55cbcc9b622fe1f5,
                    MeshMatcapMaterial: $1a55656020b89c3a$export$6f5fef6235ec12ee,
                    LineDashedMaterial: $1a55656020b89c3a$export$327886a3efaeaebe,
                    LineBasicMaterial: $1a55656020b89c3a$export$fbaaa33907730a0c,
                    Material: $1a55656020b89c3a$export$a2d8b23205c25948
                };
                return new materialLib[type]();
            }
        }
    ]);
    return MaterialLoader;
}($1a55656020b89c3a$export$3b0d6d7590275603);
var $1a55656020b89c3a$export$b5d2dc08d867e41a = /*#__PURE__*/ function() {
    "use strict";
    function LoaderUtils() {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, LoaderUtils);
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(LoaderUtils, null, [
        {
            key: "decodeText",
            value: function decodeText(array) {
                console.warn('THREE.LoaderUtils: decodeText() has been deprecated with r165 and will be removed with r175. Use TextDecoder instead.');
                if (typeof TextDecoder !== 'undefined') return new TextDecoder().decode(array);
                // Avoid the String.fromCharCode.apply(null, array) shortcut, which
                // throws a "maximum call stack size exceeded" error for large arrays.
                var s = '';
                for(var i = 0, il = array.length; i < il; i++)// Implicitly assumes little-endian.
                s += String.fromCharCode(array[i]);
                try {
                    // merges multi-byte utf-8 characters.
                    return decodeURIComponent(escape(s));
                } catch (e) {
                    return s;
                }
            }
        },
        {
            key: "extractUrlBase",
            value: function extractUrlBase(url) {
                var index = url.lastIndexOf('/');
                if (index === -1) return './';
                return url.slice(0, index + 1);
            }
        },
        {
            key: "resolveURL",
            value: function resolveURL(url, path) {
                // Invalid URL
                if (typeof url !== 'string' || url === '') return '';
                // Host Relative URL
                if (/^https?:\/\//i.test(path) && /^\//.test(url)) path = path.replace(/(^https?:\/\/[^\/]+).*/i, '$1');
                // Absolute URL http://,https://,//
                if (/^(https?:)?\/\//i.test(url)) return url;
                // Data URI
                if (/^data:.*,.*$/i.test(url)) return url;
                // Blob URL
                if (/^blob:.*$/i.test(url)) return url;
                // Relative URL
                return path + url;
            }
        }
    ]);
    return LoaderUtils;
}();
var $1a55656020b89c3a$export$231f009cbe414146 = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(InstancedBufferGeometry, BufferGeometry);
    function InstancedBufferGeometry() {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, InstancedBufferGeometry);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, InstancedBufferGeometry);
        _this.isInstancedBufferGeometry = true;
        _this.type = 'InstancedBufferGeometry';
        _this.instanceCount = Infinity;
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(InstancedBufferGeometry, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(InstancedBufferGeometry.prototype), "copy", this).call(this, source);
                this.instanceCount = source.instanceCount;
                return this;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var data = (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(InstancedBufferGeometry.prototype), "toJSON", this).call(this);
                data.instanceCount = this.instanceCount;
                data.isInstancedBufferGeometry = true;
                return data;
            }
        }
    ]);
    return InstancedBufferGeometry;
}($1a55656020b89c3a$export$b7be63a67df8959);
var $1a55656020b89c3a$export$dc275bb96327833a = /*#__PURE__*/ function(Loader) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(BufferGeometryLoader, Loader);
    function BufferGeometryLoader(manager) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, BufferGeometryLoader);
        return (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, BufferGeometryLoader, [
            manager
        ]);
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(BufferGeometryLoader, [
        {
            key: "load",
            value: function load(url, onLoad, onProgress, onError) {
                var scope = this;
                var loader = new $1a55656020b89c3a$export$98435a25b5cf7b2b(scope.manager);
                loader.setPath(scope.path);
                loader.setRequestHeader(scope.requestHeader);
                loader.setWithCredentials(scope.withCredentials);
                loader.load(url, function(text) {
                    try {
                        onLoad(scope.parse(JSON.parse(text)));
                    } catch (e) {
                        if (onError) onError(e);
                        else console.error(e);
                        scope.manager.itemError(url);
                    }
                }, onProgress, onError);
            }
        },
        {
            key: "parse",
            value: function parse(json) {
                var interleavedBufferMap = {};
                var arrayBufferMap = {};
                function getInterleavedBuffer(json, uuid) {
                    if (interleavedBufferMap[uuid] !== undefined) return interleavedBufferMap[uuid];
                    var interleavedBuffers = json.interleavedBuffers;
                    var interleavedBuffer = interleavedBuffers[uuid];
                    var buffer = getArrayBuffer(json, interleavedBuffer.buffer);
                    var array = $1a55656020b89c3a$var$getTypedArray(interleavedBuffer.type, buffer);
                    var ib = new $1a55656020b89c3a$export$3d5cd879f108f53f(array, interleavedBuffer.stride);
                    ib.uuid = interleavedBuffer.uuid;
                    interleavedBufferMap[uuid] = ib;
                    return ib;
                }
                function getArrayBuffer(json, uuid) {
                    if (arrayBufferMap[uuid] !== undefined) return arrayBufferMap[uuid];
                    var arrayBuffers = json.arrayBuffers;
                    var arrayBuffer = arrayBuffers[uuid];
                    var ab = new Uint32Array(arrayBuffer).buffer;
                    arrayBufferMap[uuid] = ab;
                    return ab;
                }
                var geometry = json.isInstancedBufferGeometry ? new $1a55656020b89c3a$export$231f009cbe414146() : new $1a55656020b89c3a$export$b7be63a67df8959();
                var index = json.data.index;
                if (index !== undefined) {
                    var typedArray = $1a55656020b89c3a$var$getTypedArray(index.type, index.array);
                    geometry.setIndex(new $1a55656020b89c3a$export$8dea267bd6bde117(typedArray, 1));
                }
                var attributes = json.data.attributes;
                for(var key in attributes){
                    var attribute = attributes[key];
                    var bufferAttribute = void 0;
                    if (attribute.isInterleavedBufferAttribute) {
                        var interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                        bufferAttribute = new $1a55656020b89c3a$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
                    } else {
                        var typedArray1 = $1a55656020b89c3a$var$getTypedArray(attribute.type, attribute.array);
                        var bufferAttributeConstr = attribute.isInstancedBufferAttribute ? $1a55656020b89c3a$export$32ea87a8b54d744a : $1a55656020b89c3a$export$8dea267bd6bde117;
                        bufferAttribute = new bufferAttributeConstr(typedArray1, attribute.itemSize, attribute.normalized);
                    }
                    if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
                    if (attribute.usage !== undefined) bufferAttribute.setUsage(attribute.usage);
                    geometry.setAttribute(key, bufferAttribute);
                }
                var morphAttributes = json.data.morphAttributes;
                if (morphAttributes) for(var key1 in morphAttributes){
                    var attributeArray = morphAttributes[key1];
                    var array = [];
                    for(var i = 0, il = attributeArray.length; i < il; i++){
                        var attribute1 = attributeArray[i];
                        var bufferAttribute1 = void 0;
                        if (attribute1.isInterleavedBufferAttribute) {
                            var interleavedBuffer1 = getInterleavedBuffer(json.data, attribute1.data);
                            bufferAttribute1 = new $1a55656020b89c3a$export$920b6d07334599c7(interleavedBuffer1, attribute1.itemSize, attribute1.offset, attribute1.normalized);
                        } else {
                            var typedArray2 = $1a55656020b89c3a$var$getTypedArray(attribute1.type, attribute1.array);
                            bufferAttribute1 = new $1a55656020b89c3a$export$8dea267bd6bde117(typedArray2, attribute1.itemSize, attribute1.normalized);
                        }
                        if (attribute1.name !== undefined) bufferAttribute1.name = attribute1.name;
                        array.push(bufferAttribute1);
                    }
                    geometry.morphAttributes[key1] = array;
                }
                var morphTargetsRelative = json.data.morphTargetsRelative;
                if (morphTargetsRelative) geometry.morphTargetsRelative = true;
                var groups = json.data.groups || json.data.drawcalls || json.data.offsets;
                if (groups !== undefined) for(var i1 = 0, n = groups.length; i1 !== n; ++i1){
                    var group = groups[i1];
                    geometry.addGroup(group.start, group.count, group.materialIndex);
                }
                var boundingSphere = json.data.boundingSphere;
                if (boundingSphere !== undefined) {
                    var center = new $1a55656020b89c3a$export$64b5c384219d3699();
                    if (boundingSphere.center !== undefined) center.fromArray(boundingSphere.center);
                    geometry.boundingSphere = new $1a55656020b89c3a$export$805e8b72413ccaba(center, boundingSphere.radius);
                }
                if (json.name) geometry.name = json.name;
                if (json.userData) geometry.userData = json.userData;
                return geometry;
            }
        }
    ]);
    return BufferGeometryLoader;
}($1a55656020b89c3a$export$3b0d6d7590275603);
var $1a55656020b89c3a$export$40110c8505c5ad19 = /*#__PURE__*/ function(Loader) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(ObjectLoader, Loader);
    function ObjectLoader(manager) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, ObjectLoader);
        return (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, ObjectLoader, [
            manager
        ]);
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(ObjectLoader, [
        {
            key: "load",
            value: function load(url, onLoad, onProgress, onError) {
                var scope = this;
                var path = this.path === '' ? $1a55656020b89c3a$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
                this.resourcePath = this.resourcePath || path;
                var loader = new $1a55656020b89c3a$export$98435a25b5cf7b2b(this.manager);
                loader.setPath(this.path);
                loader.setRequestHeader(this.requestHeader);
                loader.setWithCredentials(this.withCredentials);
                loader.load(url, function(text) {
                    var json = null;
                    try {
                        json = JSON.parse(text);
                    } catch (error) {
                        if (onError !== undefined) onError(error);
                        console.error('THREE:ObjectLoader: Can\'t parse ' + url + '.', error.message);
                        return;
                    }
                    var metadata = json.metadata;
                    if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') {
                        if (onError !== undefined) onError(new Error('THREE.ObjectLoader: Can\'t load ' + url));
                        console.error('THREE.ObjectLoader: Can\'t load ' + url);
                        return;
                    }
                    scope.parse(json, onLoad);
                }, onProgress, onError);
            }
        },
        {
            key: "loadAsync",
            value: function loadAsync(url, onProgress) {
                var _this = this;
                return (0, $5941428b630ec017$export$71511d61b312f219)(function() {
                    var scope, path, loader, text, json, metadata;
                    return (0, $353b713f9392bb93$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                scope = _this;
                                path = _this.path === '' ? $1a55656020b89c3a$export$b5d2dc08d867e41a.extractUrlBase(url) : _this.path;
                                _this.resourcePath = _this.resourcePath || path;
                                loader = new $1a55656020b89c3a$export$98435a25b5cf7b2b(_this.manager);
                                loader.setPath(_this.path);
                                loader.setRequestHeader(_this.requestHeader);
                                loader.setWithCredentials(_this.withCredentials);
                                return [
                                    4,
                                    loader.loadAsync(url, onProgress)
                                ];
                            case 1:
                                text = _state.sent();
                                json = JSON.parse(text);
                                metadata = json.metadata;
                                if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') throw new Error('THREE.ObjectLoader: Can\'t load ' + url);
                                return [
                                    4,
                                    scope.parseAsync(json)
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "parse",
            value: function parse(json, onLoad) {
                var animations = this.parseAnimations(json.animations);
                var shapes = this.parseShapes(json.shapes);
                var geometries = this.parseGeometries(json.geometries, shapes);
                var images = this.parseImages(json.images, function() {
                    if (onLoad !== undefined) onLoad(object);
                });
                var textures = this.parseTextures(json.textures, images);
                var materials = this.parseMaterials(json.materials, textures);
                var object = this.parseObject(json.object, geometries, materials, textures, animations);
                var skeletons = this.parseSkeletons(json.skeletons, object);
                this.bindSkeletons(object, skeletons);
                this.bindLightTargets(object);
                //
                if (onLoad !== undefined) {
                    var hasImages = false;
                    for(var uuid in images)if (images[uuid].data instanceof HTMLImageElement) {
                        hasImages = true;
                        break;
                    }
                    if (hasImages === false) onLoad(object);
                }
                return object;
            }
        },
        {
            key: "parseAsync",
            value: function parseAsync(json) {
                var _this = this;
                return (0, $5941428b630ec017$export$71511d61b312f219)(function() {
                    var animations, shapes, geometries, images, textures, materials, object, skeletons;
                    return (0, $353b713f9392bb93$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                animations = _this.parseAnimations(json.animations);
                                shapes = _this.parseShapes(json.shapes);
                                geometries = _this.parseGeometries(json.geometries, shapes);
                                return [
                                    4,
                                    _this.parseImagesAsync(json.images)
                                ];
                            case 1:
                                images = _state.sent();
                                textures = _this.parseTextures(json.textures, images);
                                materials = _this.parseMaterials(json.materials, textures);
                                object = _this.parseObject(json.object, geometries, materials, textures, animations);
                                skeletons = _this.parseSkeletons(json.skeletons, object);
                                _this.bindSkeletons(object, skeletons);
                                _this.bindLightTargets(object);
                                return [
                                    2,
                                    object
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "parseShapes",
            value: function parseShapes(json) {
                var shapes = {};
                if (json !== undefined) for(var i = 0, l = json.length; i < l; i++){
                    var shape = new $1a55656020b89c3a$export$6428a7f2611ef1fa().fromJSON(json[i]);
                    shapes[shape.uuid] = shape;
                }
                return shapes;
            }
        },
        {
            key: "parseSkeletons",
            value: function parseSkeletons(json, object) {
                var skeletons = {};
                var bones = {};
                // generate bone lookup table
                object.traverse(function(child) {
                    if (child.isBone) bones[child.uuid] = child;
                });
                // create skeletons
                if (json !== undefined) for(var i = 0, l = json.length; i < l; i++){
                    var skeleton = new $1a55656020b89c3a$export$8f31e4c4a37b8e9c().fromJSON(json[i], bones);
                    skeletons[skeleton.uuid] = skeleton;
                }
                return skeletons;
            }
        },
        {
            key: "parseGeometries",
            value: function parseGeometries(json, shapes) {
                var geometries = {};
                if (json !== undefined) {
                    var bufferGeometryLoader = new $1a55656020b89c3a$export$dc275bb96327833a();
                    for(var i = 0, l = json.length; i < l; i++){
                        var geometry = void 0;
                        var data = json[i];
                        switch(data.type){
                            case 'BufferGeometry':
                            case 'InstancedBufferGeometry':
                                geometry = bufferGeometryLoader.parse(data);
                                break;
                            default:
                                if (data.type in $1a55656020b89c3a$var$Geometries) geometry = $1a55656020b89c3a$var$Geometries[data.type].fromJSON(data, shapes);
                                else console.warn('THREE.ObjectLoader: Unsupported geometry type "'.concat(data.type, '"'));
                        }
                        geometry.uuid = data.uuid;
                        if (data.name !== undefined) geometry.name = data.name;
                        if (data.userData !== undefined) geometry.userData = data.userData;
                        geometries[data.uuid] = geometry;
                    }
                }
                return geometries;
            }
        },
        {
            key: "parseMaterials",
            value: function parseMaterials(json, textures) {
                var cache = {}; // MultiMaterial
                var materials = {};
                if (json !== undefined) {
                    var loader = new $1a55656020b89c3a$export$3bd6d323353dcf96();
                    loader.setTextures(textures);
                    for(var i = 0, l = json.length; i < l; i++){
                        var data = json[i];
                        if (cache[data.uuid] === undefined) cache[data.uuid] = loader.parse(data);
                        materials[data.uuid] = cache[data.uuid];
                    }
                }
                return materials;
            }
        },
        {
            key: "parseAnimations",
            value: function parseAnimations(json) {
                var animations = {};
                if (json !== undefined) for(var i = 0; i < json.length; i++){
                    var data = json[i];
                    var clip = $1a55656020b89c3a$export$d942c706bf23829c.parse(data);
                    animations[clip.uuid] = clip;
                }
                return animations;
            }
        },
        {
            key: "parseImages",
            value: function parseImages(json, onLoad) {
                var scope = this;
                var images = {};
                var loader;
                function loadImage(url) {
                    scope.manager.itemStart(url);
                    return loader.load(url, function() {
                        scope.manager.itemEnd(url);
                    }, undefined, function() {
                        scope.manager.itemError(url);
                        scope.manager.itemEnd(url);
                    });
                }
                function deserializeImage(image) {
                    if (typeof image === 'string') {
                        var url = image;
                        var path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                        return loadImage(path);
                    } else {
                        if (image.data) return {
                            data: $1a55656020b89c3a$var$getTypedArray(image.type, image.data),
                            width: image.width,
                            height: image.height
                        };
                        else return null;
                    }
                }
                if (json !== undefined && json.length > 0) {
                    var manager = new $1a55656020b89c3a$export$99cc795e99919eed(onLoad);
                    loader = new $1a55656020b89c3a$export$8905ce1c7a2464a1(manager);
                    loader.setCrossOrigin(this.crossOrigin);
                    for(var i = 0, il = json.length; i < il; i++){
                        var image = json[i];
                        var url = image.url;
                        if (Array.isArray(url)) {
                            // load array of images e.g CubeTexture
                            var imageArray = [];
                            for(var j = 0, jl = url.length; j < jl; j++){
                                var currentUrl = url[j];
                                var deserializedImage = deserializeImage(currentUrl);
                                if (deserializedImage !== null) {
                                    if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                                    else // special case: handle array of data textures for cube textures
                                    imageArray.push(new $1a55656020b89c3a$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                                }
                            }
                            images[image.uuid] = new $1a55656020b89c3a$export$1d2df86270c81ecb(imageArray);
                        } else {
                            // load single image
                            var deserializedImage1 = deserializeImage(image.url);
                            images[image.uuid] = new $1a55656020b89c3a$export$1d2df86270c81ecb(deserializedImage1);
                        }
                    }
                }
                return images;
            }
        },
        {
            key: "parseImagesAsync",
            value: function parseImagesAsync(json) {
                var _this = this;
                return (0, $5941428b630ec017$export$71511d61b312f219)(function() {
                    var scope, images, loader, i, il, image, url, imageArray, j, jl, currentUrl, deserializedImage, deserializedImage1;
                    function deserializeImage(image) {
                        return _deserializeImage.apply(this, arguments);
                    }
                    function _deserializeImage() {
                        _deserializeImage = (0, $5941428b630ec017$export$71511d61b312f219)(function(image) {
                            var url, path;
                            return (0, $353b713f9392bb93$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (!(typeof image === 'string')) return [
                                            3,
                                            2
                                        ];
                                        url = image;
                                        path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                                        return [
                                            4,
                                            loader.loadAsync(path)
                                        ];
                                    case 1:
                                        return [
                                            2,
                                            _state.sent()
                                        ];
                                    case 2:
                                        if (image.data) return [
                                            2,
                                            {
                                                data: $1a55656020b89c3a$var$getTypedArray(image.type, image.data),
                                                width: image.width,
                                                height: image.height
                                            }
                                        ];
                                        else return [
                                            2,
                                            null
                                        ];
                                        _state.label = 3;
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return _deserializeImage.apply(this, arguments);
                    }
                    return (0, $353b713f9392bb93$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                scope = _this;
                                images = {};
                                if (!(json !== undefined && json.length > 0)) return [
                                    3,
                                    9
                                ];
                                loader = new $1a55656020b89c3a$export$8905ce1c7a2464a1(_this.manager);
                                loader.setCrossOrigin(_this.crossOrigin);
                                i = 0, il = json.length;
                                _state.label = 1;
                            case 1:
                                if (!(i < il)) return [
                                    3,
                                    9
                                ];
                                image = json[i];
                                url = image.url;
                                if (!Array.isArray(url)) return [
                                    3,
                                    6
                                ];
                                // load array of images e.g CubeTexture
                                imageArray = [];
                                j = 0, jl = url.length;
                                _state.label = 2;
                            case 2:
                                if (!(j < jl)) return [
                                    3,
                                    5
                                ];
                                currentUrl = url[j];
                                return [
                                    4,
                                    deserializeImage(currentUrl)
                                ];
                            case 3:
                                deserializedImage = _state.sent();
                                if (deserializedImage !== null) {
                                    if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                                    else // special case: handle array of data textures for cube textures
                                    imageArray.push(new $1a55656020b89c3a$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                                }
                                _state.label = 4;
                            case 4:
                                j++;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                images[image.uuid] = new $1a55656020b89c3a$export$1d2df86270c81ecb(imageArray);
                                return [
                                    3,
                                    8
                                ];
                            case 6:
                                return [
                                    4,
                                    deserializeImage(image.url)
                                ];
                            case 7:
                                deserializedImage1 = _state.sent();
                                images[image.uuid] = new $1a55656020b89c3a$export$1d2df86270c81ecb(deserializedImage1);
                                _state.label = 8;
                            case 8:
                                i++;
                                return [
                                    3,
                                    1
                                ];
                            case 9:
                                return [
                                    2,
                                    images
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "parseTextures",
            value: function parseTextures(json, images) {
                function parseConstant(value, type) {
                    if (typeof value === 'number') return value;
                    console.warn('THREE.ObjectLoader.parseTexture: Constant should be in numeric form.', value);
                    return type[value];
                }
                var textures = {};
                if (json !== undefined) for(var i = 0, l = json.length; i < l; i++){
                    var data = json[i];
                    if (data.image === undefined) console.warn('THREE.ObjectLoader: No "image" specified for', data.uuid);
                    if (images[data.image] === undefined) console.warn('THREE.ObjectLoader: Undefined image', data.image);
                    var source = images[data.image];
                    var image = source.data;
                    var texture = void 0;
                    if (Array.isArray(image)) {
                        texture = new $1a55656020b89c3a$export$ee2e5a18258a4049();
                        if (image.length === 6) texture.needsUpdate = true;
                    } else {
                        if (image && image.data) texture = new $1a55656020b89c3a$export$b691f601014eabe1();
                        else texture = new $1a55656020b89c3a$export$5431306cf43de24a();
                        if (image) texture.needsUpdate = true; // textures can have undefined image data
                    }
                    texture.source = source;
                    texture.uuid = data.uuid;
                    if (data.name !== undefined) texture.name = data.name;
                    if (data.mapping !== undefined) texture.mapping = parseConstant(data.mapping, $1a55656020b89c3a$var$TEXTURE_MAPPING);
                    if (data.channel !== undefined) texture.channel = data.channel;
                    if (data.offset !== undefined) texture.offset.fromArray(data.offset);
                    if (data.repeat !== undefined) texture.repeat.fromArray(data.repeat);
                    if (data.center !== undefined) texture.center.fromArray(data.center);
                    if (data.rotation !== undefined) texture.rotation = data.rotation;
                    if (data.wrap !== undefined) {
                        texture.wrapS = parseConstant(data.wrap[0], $1a55656020b89c3a$var$TEXTURE_WRAPPING);
                        texture.wrapT = parseConstant(data.wrap[1], $1a55656020b89c3a$var$TEXTURE_WRAPPING);
                    }
                    if (data.format !== undefined) texture.format = data.format;
                    if (data.internalFormat !== undefined) texture.internalFormat = data.internalFormat;
                    if (data.type !== undefined) texture.type = data.type;
                    if (data.colorSpace !== undefined) texture.colorSpace = data.colorSpace;
                    if (data.minFilter !== undefined) texture.minFilter = parseConstant(data.minFilter, $1a55656020b89c3a$var$TEXTURE_FILTER);
                    if (data.magFilter !== undefined) texture.magFilter = parseConstant(data.magFilter, $1a55656020b89c3a$var$TEXTURE_FILTER);
                    if (data.anisotropy !== undefined) texture.anisotropy = data.anisotropy;
                    if (data.flipY !== undefined) texture.flipY = data.flipY;
                    if (data.generateMipmaps !== undefined) texture.generateMipmaps = data.generateMipmaps;
                    if (data.premultiplyAlpha !== undefined) texture.premultiplyAlpha = data.premultiplyAlpha;
                    if (data.unpackAlignment !== undefined) texture.unpackAlignment = data.unpackAlignment;
                    if (data.compareFunction !== undefined) texture.compareFunction = data.compareFunction;
                    if (data.userData !== undefined) texture.userData = data.userData;
                    textures[data.uuid] = texture;
                }
                return textures;
            }
        },
        {
            key: "parseObject",
            value: function parseObject(data, geometries, materials, textures, animations) {
                var object;
                function getGeometry(name) {
                    if (geometries[name] === undefined) console.warn('THREE.ObjectLoader: Undefined geometry', name);
                    return geometries[name];
                }
                function getMaterial(name) {
                    if (name === undefined) return undefined;
                    if (Array.isArray(name)) {
                        var array = [];
                        for(var i = 0, l = name.length; i < l; i++){
                            var uuid = name[i];
                            if (materials[uuid] === undefined) console.warn('THREE.ObjectLoader: Undefined material', uuid);
                            array.push(materials[uuid]);
                        }
                        return array;
                    }
                    if (materials[name] === undefined) console.warn('THREE.ObjectLoader: Undefined material', name);
                    return materials[name];
                }
                function getTexture(uuid) {
                    if (textures[uuid] === undefined) console.warn('THREE.ObjectLoader: Undefined texture', uuid);
                    return textures[uuid];
                }
                var geometry, material;
                switch(data.type){
                    case 'Scene':
                        object = new $1a55656020b89c3a$export$38af1803e3442a7f();
                        if (data.background !== undefined) {
                            if (Number.isInteger(data.background)) object.background = new $1a55656020b89c3a$export$892596cec99bc70e(data.background);
                            else object.background = getTexture(data.background);
                        }
                        if (data.environment !== undefined) object.environment = getTexture(data.environment);
                        if (data.fog !== undefined) {
                            if (data.fog.type === 'Fog') object.fog = new $1a55656020b89c3a$export$3c890837b09508d4(data.fog.color, data.fog.near, data.fog.far);
                            else if (data.fog.type === 'FogExp2') object.fog = new $1a55656020b89c3a$export$6f1519f023b8d0f6(data.fog.color, data.fog.density);
                            if (data.fog.name !== '') object.fog.name = data.fog.name;
                        }
                        if (data.backgroundBlurriness !== undefined) object.backgroundBlurriness = data.backgroundBlurriness;
                        if (data.backgroundIntensity !== undefined) object.backgroundIntensity = data.backgroundIntensity;
                        if (data.backgroundRotation !== undefined) object.backgroundRotation.fromArray(data.backgroundRotation);
                        if (data.environmentIntensity !== undefined) object.environmentIntensity = data.environmentIntensity;
                        if (data.environmentRotation !== undefined) object.environmentRotation.fromArray(data.environmentRotation);
                        break;
                    case 'PerspectiveCamera':
                        object = new $1a55656020b89c3a$export$74e4ae24825f68d7(data.fov, data.aspect, data.near, data.far);
                        if (data.focus !== undefined) object.focus = data.focus;
                        if (data.zoom !== undefined) object.zoom = data.zoom;
                        if (data.filmGauge !== undefined) object.filmGauge = data.filmGauge;
                        if (data.filmOffset !== undefined) object.filmOffset = data.filmOffset;
                        if (data.view !== undefined) object.view = Object.assign({}, data.view);
                        break;
                    case 'OrthographicCamera':
                        object = new $1a55656020b89c3a$export$9ebf355ee4ed261b(data.left, data.right, data.top, data.bottom, data.near, data.far);
                        if (data.zoom !== undefined) object.zoom = data.zoom;
                        if (data.view !== undefined) object.view = Object.assign({}, data.view);
                        break;
                    case 'AmbientLight':
                        object = new $1a55656020b89c3a$export$af279bfef9ec2c96(data.color, data.intensity);
                        break;
                    case 'DirectionalLight':
                        object = new $1a55656020b89c3a$export$3fea33cc9972c868(data.color, data.intensity);
                        object.target = data.target || '';
                        break;
                    case 'PointLight':
                        object = new $1a55656020b89c3a$export$4c9c1cb3f0b6f455(data.color, data.intensity, data.distance, data.decay);
                        break;
                    case 'RectAreaLight':
                        object = new $1a55656020b89c3a$export$61db2d908bbd2429(data.color, data.intensity, data.width, data.height);
                        break;
                    case 'SpotLight':
                        object = new $1a55656020b89c3a$export$81495cbb73897362(data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay);
                        object.target = data.target || '';
                        break;
                    case 'HemisphereLight':
                        object = new $1a55656020b89c3a$export$8d474f55edbb9624(data.color, data.groundColor, data.intensity);
                        break;
                    case 'LightProbe':
                        object = new $1a55656020b89c3a$export$e7ef036e309b38d2().fromJSON(data);
                        break;
                    case 'SkinnedMesh':
                        geometry = getGeometry(data.geometry);
                        material = getMaterial(data.material);
                        object = new $1a55656020b89c3a$export$b303577035157ecf(geometry, material);
                        if (data.bindMode !== undefined) object.bindMode = data.bindMode;
                        if (data.bindMatrix !== undefined) object.bindMatrix.fromArray(data.bindMatrix);
                        if (data.skeleton !== undefined) object.skeleton = data.skeleton;
                        break;
                    case 'Mesh':
                        geometry = getGeometry(data.geometry);
                        material = getMaterial(data.material);
                        object = new $1a55656020b89c3a$export$e176487c05830cc5(geometry, material);
                        break;
                    case 'InstancedMesh':
                        geometry = getGeometry(data.geometry);
                        material = getMaterial(data.material);
                        var count = data.count;
                        var instanceMatrix = data.instanceMatrix;
                        var instanceColor = data.instanceColor;
                        object = new $1a55656020b89c3a$export$f3c979c331175ad7(geometry, material, count);
                        object.instanceMatrix = new $1a55656020b89c3a$export$32ea87a8b54d744a(new Float32Array(instanceMatrix.array), 16);
                        if (instanceColor !== undefined) object.instanceColor = new $1a55656020b89c3a$export$32ea87a8b54d744a(new Float32Array(instanceColor.array), instanceColor.itemSize);
                        break;
                    case 'BatchedMesh':
                        geometry = getGeometry(data.geometry);
                        material = getMaterial(data.material);
                        object = new $1a55656020b89c3a$export$6e01c5ee52ed8f7b(data.maxInstanceCount, data.maxVertexCount, data.maxIndexCount, material);
                        object.geometry = geometry;
                        object.perObjectFrustumCulled = data.perObjectFrustumCulled;
                        object.sortObjects = data.sortObjects;
                        object._drawRanges = data.drawRanges;
                        object._reservedRanges = data.reservedRanges;
                        object._visibility = data.visibility;
                        object._active = data.active;
                        object._bounds = data.bounds.map(function(bound) {
                            var box = new $1a55656020b89c3a$export$6f7d5a9418ab2aa3();
                            box.min.fromArray(bound.boxMin);
                            box.max.fromArray(bound.boxMax);
                            var sphere = new $1a55656020b89c3a$export$805e8b72413ccaba();
                            sphere.radius = bound.sphereRadius;
                            sphere.center.fromArray(bound.sphereCenter);
                            return {
                                boxInitialized: bound.boxInitialized,
                                box: box,
                                sphereInitialized: bound.sphereInitialized,
                                sphere: sphere
                            };
                        });
                        object._maxInstanceCount = data.maxInstanceCount;
                        object._maxVertexCount = data.maxVertexCount;
                        object._maxIndexCount = data.maxIndexCount;
                        object._geometryInitialized = data.geometryInitialized;
                        object._geometryCount = data.geometryCount;
                        object._matricesTexture = getTexture(data.matricesTexture.uuid);
                        if (data.colorsTexture !== undefined) object._colorsTexture = getTexture(data.colorsTexture.uuid);
                        break;
                    case 'LOD':
                        object = new $1a55656020b89c3a$export$112e7237be0c5f30();
                        break;
                    case 'Line':
                        object = new $1a55656020b89c3a$export$17d680238e50603e(getGeometry(data.geometry), getMaterial(data.material));
                        break;
                    case 'LineLoop':
                        object = new $1a55656020b89c3a$export$f85a24d745e4f17d(getGeometry(data.geometry), getMaterial(data.material));
                        break;
                    case 'LineSegments':
                        object = new $1a55656020b89c3a$export$ff1ed10fedfdd604(getGeometry(data.geometry), getMaterial(data.material));
                        break;
                    case 'PointCloud':
                    case 'Points':
                        object = new $1a55656020b89c3a$export$1c787534cb11aa3e(getGeometry(data.geometry), getMaterial(data.material));
                        break;
                    case 'Sprite':
                        object = new $1a55656020b89c3a$export$3075603db8e6204c(getMaterial(data.material));
                        break;
                    case 'Group':
                        object = new $1a55656020b89c3a$export$eb2fcfdbd7ba97d4();
                        break;
                    case 'Bone':
                        object = new $1a55656020b89c3a$export$b127726e56765aa4();
                        break;
                    default:
                        object = new $1a55656020b89c3a$export$e4dd07dff30cc924();
                }
                object.uuid = data.uuid;
                if (data.name !== undefined) object.name = data.name;
                if (data.matrix !== undefined) {
                    object.matrix.fromArray(data.matrix);
                    if (data.matrixAutoUpdate !== undefined) object.matrixAutoUpdate = data.matrixAutoUpdate;
                    if (object.matrixAutoUpdate) object.matrix.decompose(object.position, object.quaternion, object.scale);
                } else {
                    if (data.position !== undefined) object.position.fromArray(data.position);
                    if (data.rotation !== undefined) object.rotation.fromArray(data.rotation);
                    if (data.quaternion !== undefined) object.quaternion.fromArray(data.quaternion);
                    if (data.scale !== undefined) object.scale.fromArray(data.scale);
                }
                if (data.up !== undefined) object.up.fromArray(data.up);
                if (data.castShadow !== undefined) object.castShadow = data.castShadow;
                if (data.receiveShadow !== undefined) object.receiveShadow = data.receiveShadow;
                if (data.shadow) {
                    if (data.shadow.intensity !== undefined) object.shadow.intensity = data.shadow.intensity;
                    if (data.shadow.bias !== undefined) object.shadow.bias = data.shadow.bias;
                    if (data.shadow.normalBias !== undefined) object.shadow.normalBias = data.shadow.normalBias;
                    if (data.shadow.radius !== undefined) object.shadow.radius = data.shadow.radius;
                    if (data.shadow.mapSize !== undefined) object.shadow.mapSize.fromArray(data.shadow.mapSize);
                    if (data.shadow.camera !== undefined) object.shadow.camera = this.parseObject(data.shadow.camera);
                }
                if (data.visible !== undefined) object.visible = data.visible;
                if (data.frustumCulled !== undefined) object.frustumCulled = data.frustumCulled;
                if (data.renderOrder !== undefined) object.renderOrder = data.renderOrder;
                if (data.userData !== undefined) object.userData = data.userData;
                if (data.layers !== undefined) object.layers.mask = data.layers;
                if (data.children !== undefined) {
                    var children = data.children;
                    for(var i = 0; i < children.length; i++)object.add(this.parseObject(children[i], geometries, materials, textures, animations));
                }
                if (data.animations !== undefined) {
                    var objectAnimations = data.animations;
                    for(var i1 = 0; i1 < objectAnimations.length; i1++){
                        var uuid = objectAnimations[i1];
                        object.animations.push(animations[uuid]);
                    }
                }
                if (data.type === 'LOD') {
                    if (data.autoUpdate !== undefined) object.autoUpdate = data.autoUpdate;
                    var levels = data.levels;
                    for(var l = 0; l < levels.length; l++){
                        var level = levels[l];
                        var child = object.getObjectByProperty('uuid', level.object);
                        if (child !== undefined) object.addLevel(child, level.distance, level.hysteresis);
                    }
                }
                return object;
            }
        },
        {
            key: "bindSkeletons",
            value: function bindSkeletons(object, skeletons) {
                if (Object.keys(skeletons).length === 0) return;
                object.traverse(function(child) {
                    if (child.isSkinnedMesh === true && child.skeleton !== undefined) {
                        var skeleton = skeletons[child.skeleton];
                        if (skeleton === undefined) console.warn('THREE.ObjectLoader: No skeleton found with UUID:', child.skeleton);
                        else child.bind(skeleton, child.bindMatrix);
                    }
                });
            }
        },
        {
            key: "bindLightTargets",
            value: function bindLightTargets(object) {
                object.traverse(function(child) {
                    if (child.isDirectionalLight || child.isSpotLight) {
                        var uuid = child.target;
                        var target = object.getObjectByProperty('uuid', uuid);
                        if (target !== undefined) child.target = target;
                        else child.target = new $1a55656020b89c3a$export$e4dd07dff30cc924();
                    }
                });
            }
        }
    ]);
    return ObjectLoader;
}($1a55656020b89c3a$export$3b0d6d7590275603);
var $1a55656020b89c3a$var$TEXTURE_MAPPING = {
    UVMapping: $1a55656020b89c3a$export$1beec6768cbb3d2d,
    CubeReflectionMapping: $1a55656020b89c3a$export$8759762a6477f2c4,
    CubeRefractionMapping: $1a55656020b89c3a$export$dc59f8aed047f61d,
    EquirectangularReflectionMapping: $1a55656020b89c3a$export$d64030b316d3b087,
    EquirectangularRefractionMapping: $1a55656020b89c3a$export$ee99d97d46898098,
    CubeUVReflectionMapping: $1a55656020b89c3a$export$dbf3e70ff37af79
};
var $1a55656020b89c3a$var$TEXTURE_WRAPPING = {
    RepeatWrapping: $1a55656020b89c3a$export$533346c8e8dac0f5,
    ClampToEdgeWrapping: $1a55656020b89c3a$export$9d9334239a5a5e06,
    MirroredRepeatWrapping: $1a55656020b89c3a$export$c7e7c00b14f51a4f
};
var $1a55656020b89c3a$var$TEXTURE_FILTER = {
    NearestFilter: $1a55656020b89c3a$export$727aa5ec3fe39bf0,
    NearestMipmapNearestFilter: $1a55656020b89c3a$export$d129e38cf6feaa8c,
    NearestMipmapLinearFilter: $1a55656020b89c3a$export$d2327c1afe5bfdf2,
    LinearFilter: $1a55656020b89c3a$export$8a72f490b25c56c8,
    LinearMipmapNearestFilter: $1a55656020b89c3a$export$19a719f377145a13,
    LinearMipmapLinearFilter: $1a55656020b89c3a$export$5d8599b6a933fb1b
};
var $1a55656020b89c3a$export$52286b55c4a9b51f = /*#__PURE__*/ function(Loader) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(ImageBitmapLoader, Loader);
    function ImageBitmapLoader(manager) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, ImageBitmapLoader);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, ImageBitmapLoader, [
            manager
        ]);
        _this.isImageBitmapLoader = true;
        if (typeof createImageBitmap === 'undefined') console.warn('THREE.ImageBitmapLoader: createImageBitmap() not supported.');
        if (typeof fetch === 'undefined') console.warn('THREE.ImageBitmapLoader: fetch() not supported.');
        _this.options = {
            premultiplyAlpha: 'none'
        };
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(ImageBitmapLoader, [
        {
            key: "setOptions",
            value: function setOptions(options) {
                this.options = options;
                return this;
            }
        },
        {
            key: "load",
            value: function load(url, onLoad, onProgress, onError) {
                if (url === undefined) url = '';
                if (this.path !== undefined) url = this.path + url;
                url = this.manager.resolveURL(url);
                var scope = this;
                var cached = $1a55656020b89c3a$export$94affb487e701bf2.get(url);
                if (cached !== undefined) {
                    scope.manager.itemStart(url);
                    // If cached is a promise, wait for it to resolve
                    if (cached.then) {
                        cached.then(function(imageBitmap) {
                            if (onLoad) onLoad(imageBitmap);
                            scope.manager.itemEnd(url);
                        }).catch(function(e) {
                            if (onError) onError(e);
                        });
                        return;
                    }
                    // If cached is not a promise (i.e., it's already an imageBitmap)
                    setTimeout(function() {
                        if (onLoad) onLoad(cached);
                        scope.manager.itemEnd(url);
                    }, 0);
                    return cached;
                }
                var fetchOptions = {};
                fetchOptions.credentials = this.crossOrigin === 'anonymous' ? 'same-origin' : 'include';
                fetchOptions.headers = this.requestHeader;
                var promise = fetch(url, fetchOptions).then(function(res) {
                    return res.blob();
                }).then(function(blob) {
                    return createImageBitmap(blob, Object.assign(scope.options, {
                        colorSpaceConversion: 'none'
                    }));
                }).then(function(imageBitmap) {
                    $1a55656020b89c3a$export$94affb487e701bf2.add(url, imageBitmap);
                    if (onLoad) onLoad(imageBitmap);
                    scope.manager.itemEnd(url);
                    return imageBitmap;
                }).catch(function(e) {
                    if (onError) onError(e);
                    $1a55656020b89c3a$export$94affb487e701bf2.remove(url);
                    scope.manager.itemError(url);
                    scope.manager.itemEnd(url);
                });
                $1a55656020b89c3a$export$94affb487e701bf2.add(url, promise);
                scope.manager.itemStart(url);
            }
        }
    ]);
    return ImageBitmapLoader;
}($1a55656020b89c3a$export$3b0d6d7590275603);
var $1a55656020b89c3a$var$_context;
var $1a55656020b89c3a$export$fcbc63750ec2a81f = /*#__PURE__*/ function() {
    "use strict";
    function AudioContext() {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, AudioContext);
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(AudioContext, null, [
        {
            key: "getContext",
            value: function getContext() {
                if ($1a55656020b89c3a$var$_context === undefined) $1a55656020b89c3a$var$_context = new (window.AudioContext || window.webkitAudioContext)();
                return $1a55656020b89c3a$var$_context;
            }
        },
        {
            key: "setContext",
            value: function setContext(value) {
                $1a55656020b89c3a$var$_context = value;
            }
        }
    ]);
    return AudioContext;
}();
var $1a55656020b89c3a$export$d8d5fccfbf47714e = /*#__PURE__*/ function(Loader) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(AudioLoader, Loader);
    function AudioLoader(manager) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, AudioLoader);
        return (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, AudioLoader, [
            manager
        ]);
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(AudioLoader, [
        {
            key: "load",
            value: function load(url, onLoad, onProgress, onError) {
                var scope = this;
                var loader = new $1a55656020b89c3a$export$98435a25b5cf7b2b(this.manager);
                loader.setResponseType('arraybuffer');
                loader.setPath(this.path);
                loader.setRequestHeader(this.requestHeader);
                loader.setWithCredentials(this.withCredentials);
                loader.load(url, function(buffer) {
                    try {
                        // Create a copy of the buffer. The `decodeAudioData` method
                        // detaches the buffer when complete, preventing reuse.
                        var bufferCopy = buffer.slice(0);
                        var context = $1a55656020b89c3a$export$fcbc63750ec2a81f.getContext();
                        context.decodeAudioData(bufferCopy, function(audioBuffer) {
                            onLoad(audioBuffer);
                        }).catch(handleError);
                    } catch (e) {
                        handleError(e);
                    }
                }, onProgress, onError);
                function handleError(e) {
                    if (onError) onError(e);
                    else console.error(e);
                    scope.manager.itemError(url);
                }
            }
        }
    ]);
    return AudioLoader;
}($1a55656020b89c3a$export$3b0d6d7590275603);
var $1a55656020b89c3a$var$_eyeRight = /*@__PURE__*/ new $1a55656020b89c3a$export$2ae72fc923e5eb5();
var $1a55656020b89c3a$var$_eyeLeft = /*@__PURE__*/ new $1a55656020b89c3a$export$2ae72fc923e5eb5();
var $1a55656020b89c3a$var$_projectionMatrix = /*@__PURE__*/ new $1a55656020b89c3a$export$2ae72fc923e5eb5();
var $1a55656020b89c3a$export$bc7f73a1065bee0c = /*#__PURE__*/ function() {
    "use strict";
    function StereoCamera() {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, StereoCamera);
        this.type = 'StereoCamera';
        this.aspect = 1;
        this.eyeSep = 0.064;
        this.cameraL = new $1a55656020b89c3a$export$74e4ae24825f68d7();
        this.cameraL.layers.enable(1);
        this.cameraL.matrixAutoUpdate = false;
        this.cameraR = new $1a55656020b89c3a$export$74e4ae24825f68d7();
        this.cameraR.layers.enable(2);
        this.cameraR.matrixAutoUpdate = false;
        this._cache = {
            focus: null,
            fov: null,
            aspect: null,
            near: null,
            far: null,
            zoom: null,
            eyeSep: null
        };
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(StereoCamera, [
        {
            key: "update",
            value: function update(camera) {
                var cache = this._cache;
                var needsUpdate = cache.focus !== camera.focus || cache.fov !== camera.fov || cache.aspect !== camera.aspect * this.aspect || cache.near !== camera.near || cache.far !== camera.far || cache.zoom !== camera.zoom || cache.eyeSep !== this.eyeSep;
                if (needsUpdate) {
                    cache.focus = camera.focus;
                    cache.fov = camera.fov;
                    cache.aspect = camera.aspect * this.aspect;
                    cache.near = camera.near;
                    cache.far = camera.far;
                    cache.zoom = camera.zoom;
                    cache.eyeSep = this.eyeSep;
                    // Off-axis stereoscopic effect based on
                    // http://paulbourke.net/stereographics/stereorender/
                    $1a55656020b89c3a$var$_projectionMatrix.copy(camera.projectionMatrix);
                    var eyeSepHalf = cache.eyeSep / 2;
                    var eyeSepOnProjection = eyeSepHalf * cache.near / cache.focus;
                    var ymax = cache.near * Math.tan($1a55656020b89c3a$var$DEG2RAD * cache.fov * 0.5) / cache.zoom;
                    var xmin, xmax;
                    // translate xOffset
                    $1a55656020b89c3a$var$_eyeLeft.elements[12] = -eyeSepHalf;
                    $1a55656020b89c3a$var$_eyeRight.elements[12] = eyeSepHalf;
                    // for left eye
                    xmin = -ymax * cache.aspect + eyeSepOnProjection;
                    xmax = ymax * cache.aspect + eyeSepOnProjection;
                    $1a55656020b89c3a$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
                    $1a55656020b89c3a$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
                    this.cameraL.projectionMatrix.copy($1a55656020b89c3a$var$_projectionMatrix);
                    // for right eye
                    xmin = -ymax * cache.aspect - eyeSepOnProjection;
                    xmax = ymax * cache.aspect - eyeSepOnProjection;
                    $1a55656020b89c3a$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
                    $1a55656020b89c3a$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
                    this.cameraR.projectionMatrix.copy($1a55656020b89c3a$var$_projectionMatrix);
                }
                this.cameraL.matrixWorld.copy(camera.matrixWorld).multiply($1a55656020b89c3a$var$_eyeLeft);
                this.cameraR.matrixWorld.copy(camera.matrixWorld).multiply($1a55656020b89c3a$var$_eyeRight);
            }
        }
    ]);
    return StereoCamera;
}();
var $1a55656020b89c3a$export$56b937d9e5581166 = /*#__PURE__*/ function(PerspectiveCamera) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(ArrayCamera, PerspectiveCamera);
    function ArrayCamera() {
        var array = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, ArrayCamera);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, ArrayCamera);
        _this.isArrayCamera = true;
        _this.cameras = array;
        _this.index = 0;
        return _this;
    }
    return ArrayCamera;
}($1a55656020b89c3a$export$74e4ae24825f68d7);
var $1a55656020b89c3a$export$9735c82c4bae3302 = /*#__PURE__*/ function() {
    "use strict";
    function Clock() {
        var autoStart = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Clock);
        this.autoStart = autoStart;
        this.startTime = 0;
        this.oldTime = 0;
        this.elapsedTime = 0;
        this.running = false;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Clock, [
        {
            key: "start",
            value: function start() {
                this.startTime = $1a55656020b89c3a$var$now();
                this.oldTime = this.startTime;
                this.elapsedTime = 0;
                this.running = true;
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.getElapsedTime();
                this.running = false;
                this.autoStart = false;
            }
        },
        {
            key: "getElapsedTime",
            value: function getElapsedTime() {
                this.getDelta();
                return this.elapsedTime;
            }
        },
        {
            key: "getDelta",
            value: function getDelta() {
                var diff = 0;
                if (this.autoStart && !this.running) {
                    this.start();
                    return 0;
                }
                if (this.running) {
                    var newTime = $1a55656020b89c3a$var$now();
                    diff = (newTime - this.oldTime) / 1000;
                    this.oldTime = newTime;
                    this.elapsedTime += diff;
                }
                return diff;
            }
        }
    ]);
    return Clock;
}();
function $1a55656020b89c3a$var$now() {
    return performance.now();
}
var $1a55656020b89c3a$var$_position$1 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_quaternion$1 = /*@__PURE__*/ new $1a55656020b89c3a$export$23d6a54f0bbc85a3();
var $1a55656020b89c3a$var$_scale$1 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_orientation$1 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$export$8a1b810c6fde8951 = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(AudioListener, Object3D);
    function AudioListener() {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, AudioListener);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, AudioListener);
        _this.type = 'AudioListener';
        _this.context = $1a55656020b89c3a$export$fcbc63750ec2a81f.getContext();
        _this.gain = _this.context.createGain();
        _this.gain.connect(_this.context.destination);
        _this.filter = null;
        _this.timeDelta = 0;
        // private
        _this._clock = new $1a55656020b89c3a$export$9735c82c4bae3302();
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(AudioListener, [
        {
            key: "getInput",
            value: function getInput() {
                return this.gain;
            }
        },
        {
            key: "removeFilter",
            value: function removeFilter() {
                if (this.filter !== null) {
                    this.gain.disconnect(this.filter);
                    this.filter.disconnect(this.context.destination);
                    this.gain.connect(this.context.destination);
                    this.filter = null;
                }
                return this;
            }
        },
        {
            key: "getFilter",
            value: function getFilter() {
                return this.filter;
            }
        },
        {
            key: "setFilter",
            value: function setFilter(value) {
                if (this.filter !== null) {
                    this.gain.disconnect(this.filter);
                    this.filter.disconnect(this.context.destination);
                } else this.gain.disconnect(this.context.destination);
                this.filter = value;
                this.gain.connect(this.filter);
                this.filter.connect(this.context.destination);
                return this;
            }
        },
        {
            key: "getMasterVolume",
            value: function getMasterVolume() {
                return this.gain.gain.value;
            }
        },
        {
            key: "setMasterVolume",
            value: function setMasterVolume(value) {
                this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
                return this;
            }
        },
        {
            key: "updateMatrixWorld",
            value: function updateMatrixWorld(force) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(AudioListener.prototype), "updateMatrixWorld", this).call(this, force);
                var listener = this.context.listener;
                var up = this.up;
                this.timeDelta = this._clock.getDelta();
                this.matrixWorld.decompose($1a55656020b89c3a$var$_position$1, $1a55656020b89c3a$var$_quaternion$1, $1a55656020b89c3a$var$_scale$1);
                $1a55656020b89c3a$var$_orientation$1.set(0, 0, -1).applyQuaternion($1a55656020b89c3a$var$_quaternion$1);
                if (listener.positionX) {
                    // code path for Chrome (see #14393)
                    var endTime = this.context.currentTime + this.timeDelta;
                    listener.positionX.linearRampToValueAtTime($1a55656020b89c3a$var$_position$1.x, endTime);
                    listener.positionY.linearRampToValueAtTime($1a55656020b89c3a$var$_position$1.y, endTime);
                    listener.positionZ.linearRampToValueAtTime($1a55656020b89c3a$var$_position$1.z, endTime);
                    listener.forwardX.linearRampToValueAtTime($1a55656020b89c3a$var$_orientation$1.x, endTime);
                    listener.forwardY.linearRampToValueAtTime($1a55656020b89c3a$var$_orientation$1.y, endTime);
                    listener.forwardZ.linearRampToValueAtTime($1a55656020b89c3a$var$_orientation$1.z, endTime);
                    listener.upX.linearRampToValueAtTime(up.x, endTime);
                    listener.upY.linearRampToValueAtTime(up.y, endTime);
                    listener.upZ.linearRampToValueAtTime(up.z, endTime);
                } else {
                    listener.setPosition($1a55656020b89c3a$var$_position$1.x, $1a55656020b89c3a$var$_position$1.y, $1a55656020b89c3a$var$_position$1.z);
                    listener.setOrientation($1a55656020b89c3a$var$_orientation$1.x, $1a55656020b89c3a$var$_orientation$1.y, $1a55656020b89c3a$var$_orientation$1.z, up.x, up.y, up.z);
                }
            }
        }
    ]);
    return AudioListener;
}($1a55656020b89c3a$export$e4dd07dff30cc924);
var $1a55656020b89c3a$export$153755f98d9861de = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(Audio, Object3D);
    function Audio(listener) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Audio);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, Audio);
        _this.type = 'Audio';
        _this.listener = listener;
        _this.context = listener.context;
        _this.gain = _this.context.createGain();
        _this.gain.connect(listener.getInput());
        _this.autoplay = false;
        _this.buffer = null;
        _this.detune = 0;
        _this.loop = false;
        _this.loopStart = 0;
        _this.loopEnd = 0;
        _this.offset = 0;
        _this.duration = undefined;
        _this.playbackRate = 1;
        _this.isPlaying = false;
        _this.hasPlaybackControl = true;
        _this.source = null;
        _this.sourceType = 'empty';
        _this._startedAt = 0;
        _this._progress = 0;
        _this._connected = false;
        _this.filters = [];
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Audio, [
        {
            key: "getOutput",
            value: function getOutput() {
                return this.gain;
            }
        },
        {
            key: "setNodeSource",
            value: function setNodeSource(audioNode) {
                this.hasPlaybackControl = false;
                this.sourceType = 'audioNode';
                this.source = audioNode;
                this.connect();
                return this;
            }
        },
        {
            key: "setMediaElementSource",
            value: function setMediaElementSource(mediaElement) {
                this.hasPlaybackControl = false;
                this.sourceType = 'mediaNode';
                this.source = this.context.createMediaElementSource(mediaElement);
                this.connect();
                return this;
            }
        },
        {
            key: "setMediaStreamSource",
            value: function setMediaStreamSource(mediaStream) {
                this.hasPlaybackControl = false;
                this.sourceType = 'mediaStreamNode';
                this.source = this.context.createMediaStreamSource(mediaStream);
                this.connect();
                return this;
            }
        },
        {
            key: "setBuffer",
            value: function setBuffer(audioBuffer) {
                this.buffer = audioBuffer;
                this.sourceType = 'buffer';
                if (this.autoplay) this.play();
                return this;
            }
        },
        {
            key: "play",
            value: function play() {
                var delay = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                if (this.isPlaying === true) {
                    console.warn('THREE.Audio: Audio is already playing.');
                    return;
                }
                if (this.hasPlaybackControl === false) {
                    console.warn('THREE.Audio: this Audio has no playback control.');
                    return;
                }
                this._startedAt = this.context.currentTime + delay;
                var source = this.context.createBufferSource();
                source.buffer = this.buffer;
                source.loop = this.loop;
                source.loopStart = this.loopStart;
                source.loopEnd = this.loopEnd;
                source.onended = this.onEnded.bind(this);
                source.start(this._startedAt, this._progress + this.offset, this.duration);
                this.isPlaying = true;
                this.source = source;
                this.setDetune(this.detune);
                this.setPlaybackRate(this.playbackRate);
                return this.connect();
            }
        },
        {
            key: "pause",
            value: function pause() {
                if (this.hasPlaybackControl === false) {
                    console.warn('THREE.Audio: this Audio has no playback control.');
                    return;
                }
                if (this.isPlaying === true) {
                    // update current progress
                    this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate;
                    if (this.loop === true) // ensure _progress does not exceed duration with looped audios
                    this._progress = this._progress % (this.duration || this.buffer.duration);
                    this.source.stop();
                    this.source.onended = null;
                    this.isPlaying = false;
                }
                return this;
            }
        },
        {
            key: "stop",
            value: function stop() {
                var delay = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                if (this.hasPlaybackControl === false) {
                    console.warn('THREE.Audio: this Audio has no playback control.');
                    return;
                }
                this._progress = 0;
                if (this.source !== null) {
                    this.source.stop(this.context.currentTime + delay);
                    this.source.onended = null;
                }
                this.isPlaying = false;
                return this;
            }
        },
        {
            key: "connect",
            value: function connect() {
                if (this.filters.length > 0) {
                    this.source.connect(this.filters[0]);
                    for(var i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].connect(this.filters[i]);
                    this.filters[this.filters.length - 1].connect(this.getOutput());
                } else this.source.connect(this.getOutput());
                this._connected = true;
                return this;
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this._connected === false) return;
                if (this.filters.length > 0) {
                    this.source.disconnect(this.filters[0]);
                    for(var i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].disconnect(this.filters[i]);
                    this.filters[this.filters.length - 1].disconnect(this.getOutput());
                } else this.source.disconnect(this.getOutput());
                this._connected = false;
                return this;
            }
        },
        {
            key: "getFilters",
            value: function getFilters() {
                return this.filters;
            }
        },
        {
            key: "setFilters",
            value: function setFilters(value) {
                if (!value) value = [];
                if (this._connected === true) {
                    this.disconnect();
                    this.filters = value.slice();
                    this.connect();
                } else this.filters = value.slice();
                return this;
            }
        },
        {
            key: "setDetune",
            value: function setDetune(value) {
                this.detune = value;
                if (this.isPlaying === true && this.source.detune !== undefined) this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01);
                return this;
            }
        },
        {
            key: "getDetune",
            value: function getDetune() {
                return this.detune;
            }
        },
        {
            key: "getFilter",
            value: function getFilter() {
                return this.getFilters()[0];
            }
        },
        {
            key: "setFilter",
            value: function setFilter(filter) {
                return this.setFilters(filter ? [
                    filter
                ] : []);
            }
        },
        {
            key: "setPlaybackRate",
            value: function setPlaybackRate(value) {
                if (this.hasPlaybackControl === false) {
                    console.warn('THREE.Audio: this Audio has no playback control.');
                    return;
                }
                this.playbackRate = value;
                if (this.isPlaying === true) this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01);
                return this;
            }
        },
        {
            key: "getPlaybackRate",
            value: function getPlaybackRate() {
                return this.playbackRate;
            }
        },
        {
            key: "onEnded",
            value: function onEnded() {
                this.isPlaying = false;
                this._progress = 0;
            }
        },
        {
            key: "getLoop",
            value: function getLoop() {
                if (this.hasPlaybackControl === false) {
                    console.warn('THREE.Audio: this Audio has no playback control.');
                    return false;
                }
                return this.loop;
            }
        },
        {
            key: "setLoop",
            value: function setLoop(value) {
                if (this.hasPlaybackControl === false) {
                    console.warn('THREE.Audio: this Audio has no playback control.');
                    return;
                }
                this.loop = value;
                if (this.isPlaying === true) this.source.loop = this.loop;
                return this;
            }
        },
        {
            key: "setLoopStart",
            value: function setLoopStart(value) {
                this.loopStart = value;
                return this;
            }
        },
        {
            key: "setLoopEnd",
            value: function setLoopEnd(value) {
                this.loopEnd = value;
                return this;
            }
        },
        {
            key: "getVolume",
            value: function getVolume() {
                return this.gain.gain.value;
            }
        },
        {
            key: "setVolume",
            value: function setVolume(value) {
                this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
                return this;
            }
        },
        {
            key: "copy",
            value: function copy(source, recursive) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(Audio.prototype), "copy", this).call(this, source, recursive);
                if (source.sourceType !== 'buffer') {
                    console.warn('THREE.Audio: Audio source type cannot be copied.');
                    return this;
                }
                this.autoplay = source.autoplay;
                this.buffer = source.buffer;
                this.detune = source.detune;
                this.loop = source.loop;
                this.loopStart = source.loopStart;
                this.loopEnd = source.loopEnd;
                this.offset = source.offset;
                this.duration = source.duration;
                this.playbackRate = source.playbackRate;
                this.hasPlaybackControl = source.hasPlaybackControl;
                this.sourceType = source.sourceType;
                this.filters = source.filters.slice();
                return this;
            }
        },
        {
            key: "clone",
            value: function clone(recursive) {
                return new this.constructor(this.listener).copy(this, recursive);
            }
        }
    ]);
    return Audio;
}($1a55656020b89c3a$export$e4dd07dff30cc924);
var $1a55656020b89c3a$var$_position = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_quaternion = /*@__PURE__*/ new $1a55656020b89c3a$export$23d6a54f0bbc85a3();
var $1a55656020b89c3a$var$_scale = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_orientation = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$export$4b3e397ef1832507 = /*#__PURE__*/ function(Audio) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(PositionalAudio, Audio);
    function PositionalAudio(listener) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, PositionalAudio);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, PositionalAudio, [
            listener
        ]);
        _this.panner = _this.context.createPanner();
        _this.panner.panningModel = 'HRTF';
        _this.panner.connect(_this.gain);
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(PositionalAudio, [
        {
            key: "connect",
            value: function connect() {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(PositionalAudio.prototype), "connect", this).call(this);
                this.panner.connect(this.gain);
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(PositionalAudio.prototype), "disconnect", this).call(this);
                this.panner.disconnect(this.gain);
            }
        },
        {
            key: "getOutput",
            value: function getOutput() {
                return this.panner;
            }
        },
        {
            key: "getRefDistance",
            value: function getRefDistance() {
                return this.panner.refDistance;
            }
        },
        {
            key: "setRefDistance",
            value: function setRefDistance(value) {
                this.panner.refDistance = value;
                return this;
            }
        },
        {
            key: "getRolloffFactor",
            value: function getRolloffFactor() {
                return this.panner.rolloffFactor;
            }
        },
        {
            key: "setRolloffFactor",
            value: function setRolloffFactor(value) {
                this.panner.rolloffFactor = value;
                return this;
            }
        },
        {
            key: "getDistanceModel",
            value: function getDistanceModel() {
                return this.panner.distanceModel;
            }
        },
        {
            key: "setDistanceModel",
            value: function setDistanceModel(value) {
                this.panner.distanceModel = value;
                return this;
            }
        },
        {
            key: "getMaxDistance",
            value: function getMaxDistance() {
                return this.panner.maxDistance;
            }
        },
        {
            key: "setMaxDistance",
            value: function setMaxDistance(value) {
                this.panner.maxDistance = value;
                return this;
            }
        },
        {
            key: "setDirectionalCone",
            value: function setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain) {
                this.panner.coneInnerAngle = coneInnerAngle;
                this.panner.coneOuterAngle = coneOuterAngle;
                this.panner.coneOuterGain = coneOuterGain;
                return this;
            }
        },
        {
            key: "updateMatrixWorld",
            value: function updateMatrixWorld(force) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(PositionalAudio.prototype), "updateMatrixWorld", this).call(this, force);
                if (this.hasPlaybackControl === true && this.isPlaying === false) return;
                this.matrixWorld.decompose($1a55656020b89c3a$var$_position, $1a55656020b89c3a$var$_quaternion, $1a55656020b89c3a$var$_scale);
                $1a55656020b89c3a$var$_orientation.set(0, 0, 1).applyQuaternion($1a55656020b89c3a$var$_quaternion);
                var panner = this.panner;
                if (panner.positionX) {
                    // code path for Chrome and Firefox (see #14393)
                    var endTime = this.context.currentTime + this.listener.timeDelta;
                    panner.positionX.linearRampToValueAtTime($1a55656020b89c3a$var$_position.x, endTime);
                    panner.positionY.linearRampToValueAtTime($1a55656020b89c3a$var$_position.y, endTime);
                    panner.positionZ.linearRampToValueAtTime($1a55656020b89c3a$var$_position.z, endTime);
                    panner.orientationX.linearRampToValueAtTime($1a55656020b89c3a$var$_orientation.x, endTime);
                    panner.orientationY.linearRampToValueAtTime($1a55656020b89c3a$var$_orientation.y, endTime);
                    panner.orientationZ.linearRampToValueAtTime($1a55656020b89c3a$var$_orientation.z, endTime);
                } else {
                    panner.setPosition($1a55656020b89c3a$var$_position.x, $1a55656020b89c3a$var$_position.y, $1a55656020b89c3a$var$_position.z);
                    panner.setOrientation($1a55656020b89c3a$var$_orientation.x, $1a55656020b89c3a$var$_orientation.y, $1a55656020b89c3a$var$_orientation.z);
                }
            }
        }
    ]);
    return PositionalAudio;
}((0, $60c1ca164192b5e0$export$71511d61b312f219)($1a55656020b89c3a$export$153755f98d9861de));
var $1a55656020b89c3a$export$d47da1ef3d382827 = /*#__PURE__*/ function() {
    "use strict";
    function AudioAnalyser(audio) {
        var fftSize = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2048;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, AudioAnalyser);
        this.analyser = audio.context.createAnalyser();
        this.analyser.fftSize = fftSize;
        this.data = new Uint8Array(this.analyser.frequencyBinCount);
        audio.getOutput().connect(this.analyser);
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(AudioAnalyser, [
        {
            key: "getFrequencyData",
            value: function getFrequencyData() {
                this.analyser.getByteFrequencyData(this.data);
                return this.data;
            }
        },
        {
            key: "getAverageFrequency",
            value: function getAverageFrequency() {
                var value = 0;
                var data = this.getFrequencyData();
                for(var i = 0; i < data.length; i++)value += data[i];
                return value / data.length;
            }
        }
    ]);
    return AudioAnalyser;
}();
var $1a55656020b89c3a$export$dfe0af1ca1acb78a = /*#__PURE__*/ function() {
    "use strict";
    function PropertyMixer(binding, typeName, valueSize) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, PropertyMixer);
        this.binding = binding;
        this.valueSize = valueSize;
        var mixFunction, mixFunctionAdditive, setIdentity;
        // buffer layout: [ incoming | accu0 | accu1 | orig | addAccu | (optional work) ]
        //
        // interpolators can use .buffer as their .result
        // the data then goes to 'incoming'
        //
        // 'accu0' and 'accu1' are used frame-interleaved for
        // the cumulative result and are compared to detect
        // changes
        //
        // 'orig' stores the original state of the property
        //
        // 'add' is used for additive cumulative results
        //
        // 'work' is optional and is only present for quaternion types. It is used
        // to store intermediate quaternion multiplication results
        switch(typeName){
            case 'quaternion':
                mixFunction = this._slerp;
                mixFunctionAdditive = this._slerpAdditive;
                setIdentity = this._setAdditiveIdentityQuaternion;
                this.buffer = new Float64Array(valueSize * 6);
                this._workIndex = 5;
                break;
            case 'string':
            case 'bool':
                mixFunction = this._select;
                // Use the regular mix function and for additive on these types,
                // additive is not relevant for non-numeric types
                mixFunctionAdditive = this._select;
                setIdentity = this._setAdditiveIdentityOther;
                this.buffer = new Array(valueSize * 5);
                break;
            default:
                mixFunction = this._lerp;
                mixFunctionAdditive = this._lerpAdditive;
                setIdentity = this._setAdditiveIdentityNumeric;
                this.buffer = new Float64Array(valueSize * 5);
        }
        this._mixBufferRegion = mixFunction;
        this._mixBufferRegionAdditive = mixFunctionAdditive;
        this._setIdentity = setIdentity;
        this._origIndex = 3;
        this._addIndex = 4;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        this.useCount = 0;
        this.referenceCount = 0;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(PropertyMixer, [
        {
            // accumulate data in the 'incoming' region into 'accu<i>'
            key: "accumulate",
            value: function accumulate(accuIndex, weight) {
                // note: happily accumulating nothing when weight = 0, the caller knows
                // the weight and shouldn't have made the call in the first place
                var buffer = this.buffer, stride = this.valueSize, offset = accuIndex * stride + stride;
                var currentWeight = this.cumulativeWeight;
                if (currentWeight === 0) {
                    // accuN := incoming * weight
                    for(var i = 0; i !== stride; ++i)buffer[offset + i] = buffer[i];
                    currentWeight = weight;
                } else {
                    // accuN := accuN + incoming * weight
                    currentWeight += weight;
                    var mix = weight / currentWeight;
                    this._mixBufferRegion(buffer, offset, 0, mix, stride);
                }
                this.cumulativeWeight = currentWeight;
            }
        },
        {
            // accumulate data in the 'incoming' region into 'add'
            key: "accumulateAdditive",
            value: function accumulateAdditive(weight) {
                var buffer = this.buffer, stride = this.valueSize, offset = stride * this._addIndex;
                if (this.cumulativeWeightAdditive === 0) // add = identity
                this._setIdentity();
                // add := add + incoming * weight
                this._mixBufferRegionAdditive(buffer, offset, 0, weight, stride);
                this.cumulativeWeightAdditive += weight;
            }
        },
        {
            // apply the state of 'accu<i>' to the binding when accus differ
            key: "apply",
            value: function apply(accuIndex) {
                var stride = this.valueSize, buffer = this.buffer, offset = accuIndex * stride + stride, weight = this.cumulativeWeight, weightAdditive = this.cumulativeWeightAdditive, binding = this.binding;
                this.cumulativeWeight = 0;
                this.cumulativeWeightAdditive = 0;
                if (weight < 1) {
                    // accuN := accuN + original * ( 1 - cumulativeWeight )
                    var originalValueOffset = stride * this._origIndex;
                    this._mixBufferRegion(buffer, offset, originalValueOffset, 1 - weight, stride);
                }
                if (weightAdditive > 0) // accuN := accuN + additive accuN
                this._mixBufferRegionAdditive(buffer, offset, this._addIndex * stride, 1, stride);
                for(var i = stride, e = stride + stride; i !== e; ++i)if (buffer[i] !== buffer[i + stride]) {
                    // value has changed -> update scene graph
                    binding.setValue(buffer, offset);
                    break;
                }
            }
        },
        {
            // remember the state of the bound property and copy it to both accus
            key: "saveOriginalState",
            value: function saveOriginalState() {
                var binding = this.binding;
                var buffer = this.buffer, stride = this.valueSize, originalValueOffset = stride * this._origIndex;
                binding.getValue(buffer, originalValueOffset);
                // accu[0..1] := orig -- initially detect changes against the original
                for(var i = stride, e = originalValueOffset; i !== e; ++i)buffer[i] = buffer[originalValueOffset + i % stride];
                // Add to identity for additive
                this._setIdentity();
                this.cumulativeWeight = 0;
                this.cumulativeWeightAdditive = 0;
            }
        },
        {
            // apply the state previously taken via 'saveOriginalState' to the binding
            key: "restoreOriginalState",
            value: function restoreOriginalState() {
                var originalValueOffset = this.valueSize * 3;
                this.binding.setValue(this.buffer, originalValueOffset);
            }
        },
        {
            key: "_setAdditiveIdentityNumeric",
            value: function _setAdditiveIdentityNumeric() {
                var startIndex = this._addIndex * this.valueSize;
                var endIndex = startIndex + this.valueSize;
                for(var i = startIndex; i < endIndex; i++)this.buffer[i] = 0;
            }
        },
        {
            key: "_setAdditiveIdentityQuaternion",
            value: function _setAdditiveIdentityQuaternion() {
                this._setAdditiveIdentityNumeric();
                this.buffer[this._addIndex * this.valueSize + 3] = 1;
            }
        },
        {
            key: "_setAdditiveIdentityOther",
            value: function _setAdditiveIdentityOther() {
                var startIndex = this._origIndex * this.valueSize;
                var targetIndex = this._addIndex * this.valueSize;
                for(var i = 0; i < this.valueSize; i++)this.buffer[targetIndex + i] = this.buffer[startIndex + i];
            }
        },
        {
            // mix functions
            key: "_select",
            value: function _select(buffer, dstOffset, srcOffset, t, stride) {
                if (t >= 0.5) for(var i = 0; i !== stride; ++i)buffer[dstOffset + i] = buffer[srcOffset + i];
            }
        },
        {
            key: "_slerp",
            value: function _slerp(buffer, dstOffset, srcOffset, t) {
                $1a55656020b89c3a$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t);
            }
        },
        {
            key: "_slerpAdditive",
            value: function _slerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
                var workOffset = this._workIndex * stride;
                // Store result in intermediate buffer offset
                $1a55656020b89c3a$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(buffer, workOffset, buffer, dstOffset, buffer, srcOffset);
                // Slerp to the intermediate result
                $1a55656020b89c3a$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t);
            }
        },
        {
            key: "_lerp",
            value: function _lerp(buffer, dstOffset, srcOffset, t, stride) {
                var s = 1 - t;
                for(var i = 0; i !== stride; ++i){
                    var j = dstOffset + i;
                    buffer[j] = buffer[j] * s + buffer[srcOffset + i] * t;
                }
            }
        },
        {
            key: "_lerpAdditive",
            value: function _lerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
                for(var i = 0; i !== stride; ++i){
                    var j = dstOffset + i;
                    buffer[j] = buffer[j] + buffer[srcOffset + i] * t;
                }
            }
        }
    ]);
    return PropertyMixer;
}();
// Characters [].:/ are reserved for track binding syntax.
var $1a55656020b89c3a$var$_RESERVED_CHARS_RE = '\\[\\]\\.:\\/';
var $1a55656020b89c3a$var$_reservedRe = new RegExp('[' + $1a55656020b89c3a$var$_RESERVED_CHARS_RE + ']', 'g');
// Attempts to allow node names from any language. ES5's `\w` regexp matches
// only latin characters, and the unicode \p{L} is not yet supported. So
// instead, we exclude reserved characters and match everything else.
var $1a55656020b89c3a$var$_wordChar = '[^' + $1a55656020b89c3a$var$_RESERVED_CHARS_RE + ']';
var $1a55656020b89c3a$var$_wordCharOrDot = '[^' + $1a55656020b89c3a$var$_RESERVED_CHARS_RE.replace('\\.', '') + ']';
// Parent directories, delimited by '/' or ':'. Currently unused, but must
// be matched to parse the rest of the track name.
var $1a55656020b89c3a$var$_directoryRe = /*@__PURE__*/ /((?:WC+[\/:])*)/.source.replace('WC', $1a55656020b89c3a$var$_wordChar);
// Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
var $1a55656020b89c3a$var$_nodeRe = /*@__PURE__*/ /(WCOD+)?/.source.replace('WCOD', $1a55656020b89c3a$var$_wordCharOrDot);
// Object on target node, and accessor. May not contain reserved
// characters. Accessor may contain any character except closing bracket.
var $1a55656020b89c3a$var$_objectRe = /*@__PURE__*/ /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace('WC', $1a55656020b89c3a$var$_wordChar);
// Property and accessor. May not contain reserved characters. Accessor may
// contain any non-bracket characters.
var $1a55656020b89c3a$var$_propertyRe = /*@__PURE__*/ /\.(WC+)(?:\[(.+)\])?/.source.replace('WC', $1a55656020b89c3a$var$_wordChar);
var $1a55656020b89c3a$var$_trackRe = new RegExp("^" + $1a55656020b89c3a$var$_directoryRe + $1a55656020b89c3a$var$_nodeRe + $1a55656020b89c3a$var$_objectRe + $1a55656020b89c3a$var$_propertyRe + '$');
var $1a55656020b89c3a$var$_supportedObjectNames = [
    'material',
    'materials',
    'bones',
    'map'
];
var $1a55656020b89c3a$var$Composite = /*#__PURE__*/ function() {
    "use strict";
    function Composite(targetGroup, path, optionalParsedPath) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Composite);
        var parsedPath = optionalParsedPath || $1a55656020b89c3a$export$7bf70fcf9f891893.parseTrackName(path);
        this._targetGroup = targetGroup;
        this._bindings = targetGroup.subscribe_(path, parsedPath);
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Composite, [
        {
            key: "getValue",
            value: function getValue(array, offset) {
                this.bind(); // bind all binding
                var firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
                // and only call .getValue on the first
                if (binding !== undefined) binding.getValue(array, offset);
            }
        },
        {
            key: "setValue",
            value: function setValue(array, offset) {
                var bindings = this._bindings;
                for(var i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].setValue(array, offset);
            }
        },
        {
            key: "bind",
            value: function bind() {
                var bindings = this._bindings;
                for(var i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].bind();
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                var bindings = this._bindings;
                for(var i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].unbind();
            }
        }
    ]);
    return Composite;
}();
// Note: This class uses a State pattern on a per-method basis:
// 'bind' sets 'this.getValue' / 'setValue' and shadows the
// prototype version of these methods with one that represents
// the bound state. When the property is not found, the methods
// become no-ops.
var $1a55656020b89c3a$export$7bf70fcf9f891893 = /*#__PURE__*/ function() {
    "use strict";
    function PropertyBinding(rootNode, path, parsedPath) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, PropertyBinding);
        this.path = path;
        this.parsedPath = parsedPath || PropertyBinding.parseTrackName(path);
        this.node = PropertyBinding.findNode(rootNode, this.parsedPath.nodeName);
        this.rootNode = rootNode;
        // initial state of these methods that calls 'bind'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(PropertyBinding, [
        {
            // these are used to "bind" a nonexistent property
            key: "_getValue_unavailable",
            value: function _getValue_unavailable() {}
        },
        {
            key: "_setValue_unavailable",
            value: function _setValue_unavailable() {}
        },
        {
            // Getters
            key: "_getValue_direct",
            value: function _getValue_direct(buffer, offset) {
                buffer[offset] = this.targetObject[this.propertyName];
            }
        },
        {
            key: "_getValue_array",
            value: function _getValue_array(buffer, offset) {
                var source = this.resolvedProperty;
                for(var i = 0, n = source.length; i !== n; ++i)buffer[offset++] = source[i];
            }
        },
        {
            key: "_getValue_arrayElement",
            value: function _getValue_arrayElement(buffer, offset) {
                buffer[offset] = this.resolvedProperty[this.propertyIndex];
            }
        },
        {
            key: "_getValue_toArray",
            value: function _getValue_toArray(buffer, offset) {
                this.resolvedProperty.toArray(buffer, offset);
            }
        },
        {
            // Direct
            key: "_setValue_direct",
            value: function _setValue_direct(buffer, offset) {
                this.targetObject[this.propertyName] = buffer[offset];
            }
        },
        {
            key: "_setValue_direct_setNeedsUpdate",
            value: function _setValue_direct_setNeedsUpdate(buffer, offset) {
                this.targetObject[this.propertyName] = buffer[offset];
                this.targetObject.needsUpdate = true;
            }
        },
        {
            key: "_setValue_direct_setMatrixWorldNeedsUpdate",
            value: function _setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {
                this.targetObject[this.propertyName] = buffer[offset];
                this.targetObject.matrixWorldNeedsUpdate = true;
            }
        },
        {
            // EntireArray
            key: "_setValue_array",
            value: function _setValue_array(buffer, offset) {
                var dest = this.resolvedProperty;
                for(var i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
            }
        },
        {
            key: "_setValue_array_setNeedsUpdate",
            value: function _setValue_array_setNeedsUpdate(buffer, offset) {
                var dest = this.resolvedProperty;
                for(var i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
                this.targetObject.needsUpdate = true;
            }
        },
        {
            key: "_setValue_array_setMatrixWorldNeedsUpdate",
            value: function _setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {
                var dest = this.resolvedProperty;
                for(var i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
                this.targetObject.matrixWorldNeedsUpdate = true;
            }
        },
        {
            // ArrayElement
            key: "_setValue_arrayElement",
            value: function _setValue_arrayElement(buffer, offset) {
                this.resolvedProperty[this.propertyIndex] = buffer[offset];
            }
        },
        {
            key: "_setValue_arrayElement_setNeedsUpdate",
            value: function _setValue_arrayElement_setNeedsUpdate(buffer, offset) {
                this.resolvedProperty[this.propertyIndex] = buffer[offset];
                this.targetObject.needsUpdate = true;
            }
        },
        {
            key: "_setValue_arrayElement_setMatrixWorldNeedsUpdate",
            value: function _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {
                this.resolvedProperty[this.propertyIndex] = buffer[offset];
                this.targetObject.matrixWorldNeedsUpdate = true;
            }
        },
        {
            // HasToFromArray
            key: "_setValue_fromArray",
            value: function _setValue_fromArray(buffer, offset) {
                this.resolvedProperty.fromArray(buffer, offset);
            }
        },
        {
            key: "_setValue_fromArray_setNeedsUpdate",
            value: function _setValue_fromArray_setNeedsUpdate(buffer, offset) {
                this.resolvedProperty.fromArray(buffer, offset);
                this.targetObject.needsUpdate = true;
            }
        },
        {
            key: "_setValue_fromArray_setMatrixWorldNeedsUpdate",
            value: function _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {
                this.resolvedProperty.fromArray(buffer, offset);
                this.targetObject.matrixWorldNeedsUpdate = true;
            }
        },
        {
            key: "_getValue_unbound",
            value: function _getValue_unbound(targetArray, offset) {
                this.bind();
                this.getValue(targetArray, offset);
            }
        },
        {
            key: "_setValue_unbound",
            value: function _setValue_unbound(sourceArray, offset) {
                this.bind();
                this.setValue(sourceArray, offset);
            }
        },
        {
            // create getter / setter pair for a property in the scene graph
            key: "bind",
            value: function bind() {
                var targetObject = this.node;
                var parsedPath = this.parsedPath;
                var objectName = parsedPath.objectName;
                var propertyName = parsedPath.propertyName;
                var propertyIndex = parsedPath.propertyIndex;
                if (!targetObject) {
                    targetObject = PropertyBinding.findNode(this.rootNode, parsedPath.nodeName);
                    this.node = targetObject;
                }
                // set fail state so we can just 'return' on error
                this.getValue = this._getValue_unavailable;
                this.setValue = this._setValue_unavailable;
                // ensure there is a value node
                if (!targetObject) {
                    console.warn('THREE.PropertyBinding: No target node found for track: ' + this.path + '.');
                    return;
                }
                if (objectName) {
                    var objectIndex = parsedPath.objectIndex;
                    // special cases were we need to reach deeper into the hierarchy to get the face materials....
                    switch(objectName){
                        case 'materials':
                            if (!targetObject.material) {
                                console.error('THREE.PropertyBinding: Can not bind to material as node does not have a material.', this);
                                return;
                            }
                            if (!targetObject.material.materials) {
                                console.error('THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.', this);
                                return;
                            }
                            targetObject = targetObject.material.materials;
                            break;
                        case 'bones':
                            if (!targetObject.skeleton) {
                                console.error('THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.', this);
                                return;
                            }
                            // potential future optimization: skip this if propertyIndex is already an integer
                            // and convert the integer string to a true integer.
                            targetObject = targetObject.skeleton.bones;
                            // support resolving morphTarget names into indices.
                            for(var i = 0; i < targetObject.length; i++)if (targetObject[i].name === objectIndex) {
                                objectIndex = i;
                                break;
                            }
                            break;
                        case 'map':
                            if ('map' in targetObject) {
                                targetObject = targetObject.map;
                                break;
                            }
                            if (!targetObject.material) {
                                console.error('THREE.PropertyBinding: Can not bind to material as node does not have a material.', this);
                                return;
                            }
                            if (!targetObject.material.map) {
                                console.error('THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.', this);
                                return;
                            }
                            targetObject = targetObject.material.map;
                            break;
                        default:
                            if (targetObject[objectName] === undefined) {
                                console.error('THREE.PropertyBinding: Can not bind to objectName of node undefined.', this);
                                return;
                            }
                            targetObject = targetObject[objectName];
                    }
                    if (objectIndex !== undefined) {
                        if (targetObject[objectIndex] === undefined) {
                            console.error('THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.', this, targetObject);
                            return;
                        }
                        targetObject = targetObject[objectIndex];
                    }
                }
                // resolve property
                var nodeProperty = targetObject[propertyName];
                if (nodeProperty === undefined) {
                    var nodeName = parsedPath.nodeName;
                    console.error('THREE.PropertyBinding: Trying to update property for track: ' + nodeName + '.' + propertyName + ' but it wasn\'t found.', targetObject);
                    return;
                }
                // determine versioning scheme
                var versioning = this.Versioning.None;
                this.targetObject = targetObject;
                if (targetObject.isMaterial === true) versioning = this.Versioning.NeedsUpdate;
                else if (targetObject.isObject3D === true) versioning = this.Versioning.MatrixWorldNeedsUpdate;
                // determine how the property gets bound
                var bindingType = this.BindingType.Direct;
                if (propertyIndex !== undefined) {
                    // access a sub element of the property array (only primitives are supported right now)
                    if (propertyName === 'morphTargetInfluences') {
                        // potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.
                        // support resolving morphTarget names into indices.
                        if (!targetObject.geometry) {
                            console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.', this);
                            return;
                        }
                        if (!targetObject.geometry.morphAttributes) {
                            console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.', this);
                            return;
                        }
                        if (targetObject.morphTargetDictionary[propertyIndex] !== undefined) propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
                    }
                    bindingType = this.BindingType.ArrayElement;
                    this.resolvedProperty = nodeProperty;
                    this.propertyIndex = propertyIndex;
                } else if (nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined) {
                    // must use copy for Object3D.Euler/Quaternion
                    bindingType = this.BindingType.HasFromToArray;
                    this.resolvedProperty = nodeProperty;
                } else if (Array.isArray(nodeProperty)) {
                    bindingType = this.BindingType.EntireArray;
                    this.resolvedProperty = nodeProperty;
                } else this.propertyName = propertyName;
                // select getter / setter
                this.getValue = this.GetterByBindingType[bindingType];
                this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                this.node = null;
                // back to the prototype version of getValue / setValue
                // note: avoiding to mutate the shape of 'this' via 'delete'
                this.getValue = this._getValue_unbound;
                this.setValue = this._setValue_unbound;
            }
        }
    ], [
        {
            key: "create",
            value: function create(root, path, parsedPath) {
                if (!(root && root.isAnimationObjectGroup)) return new PropertyBinding(root, path, parsedPath);
                else return new PropertyBinding.Composite(root, path, parsedPath);
            }
        },
        {
            key: "sanitizeNodeName",
            value: /**
	 * Replaces spaces with underscores and removes unsupported characters from
	 * node names, to ensure compatibility with parseTrackName().
	 *
	 * @param {string} name Node name to be sanitized.
	 * @return {string}
	 */ function sanitizeNodeName(name) {
                return name.replace(/\s/g, '_').replace($1a55656020b89c3a$var$_reservedRe, '');
            }
        },
        {
            key: "parseTrackName",
            value: function parseTrackName(trackName) {
                var matches = $1a55656020b89c3a$var$_trackRe.exec(trackName);
                if (matches === null) throw new Error('PropertyBinding: Cannot parse trackName: ' + trackName);
                var results = {
                    // directoryName: matches[ 1 ], // (tschw) currently unused
                    nodeName: matches[2],
                    objectName: matches[3],
                    objectIndex: matches[4],
                    propertyName: matches[5],
                    propertyIndex: matches[6]
                };
                var lastDot = results.nodeName && results.nodeName.lastIndexOf('.');
                if (lastDot !== undefined && lastDot !== -1) {
                    var objectName = results.nodeName.substring(lastDot + 1);
                    // Object names must be checked against an allowlist. Otherwise, there
                    // is no way to parse 'foo.bar.baz': 'baz' must be a property, but
                    // 'bar' could be the objectName, or part of a nodeName (which can
                    // include '.' characters).
                    if ($1a55656020b89c3a$var$_supportedObjectNames.indexOf(objectName) !== -1) {
                        results.nodeName = results.nodeName.substring(0, lastDot);
                        results.objectName = objectName;
                    }
                }
                if (results.propertyName === null || results.propertyName.length === 0) throw new Error('PropertyBinding: can not parse propertyName from trackName: ' + trackName);
                return results;
            }
        },
        {
            key: "findNode",
            value: function findNode(root, nodeName) {
                if (nodeName === undefined || nodeName === '' || nodeName === '.' || nodeName === -1 || nodeName === root.name || nodeName === root.uuid) return root;
                // search into skeleton bones.
                if (root.skeleton) {
                    var bone = root.skeleton.getBoneByName(nodeName);
                    if (bone !== undefined) return bone;
                }
                // search into node subtree.
                if (root.children) {
                    var searchNodeSubtree = function searchNodeSubtree1(children) {
                        for(var i = 0; i < children.length; i++){
                            var childNode = children[i];
                            if (childNode.name === nodeName || childNode.uuid === nodeName) return childNode;
                            var result = searchNodeSubtree(childNode.children);
                            if (result) return result;
                        }
                        return null;
                    };
                    var subTreeNode = searchNodeSubtree(root.children);
                    if (subTreeNode) return subTreeNode;
                }
                return null;
            }
        }
    ]);
    return PropertyBinding;
}();
$1a55656020b89c3a$export$7bf70fcf9f891893.Composite = $1a55656020b89c3a$var$Composite;
$1a55656020b89c3a$export$7bf70fcf9f891893.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3
};
$1a55656020b89c3a$export$7bf70fcf9f891893.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2
};
$1a55656020b89c3a$export$7bf70fcf9f891893.prototype.GetterByBindingType = [
    $1a55656020b89c3a$export$7bf70fcf9f891893.prototype._getValue_direct,
    $1a55656020b89c3a$export$7bf70fcf9f891893.prototype._getValue_array,
    $1a55656020b89c3a$export$7bf70fcf9f891893.prototype._getValue_arrayElement,
    $1a55656020b89c3a$export$7bf70fcf9f891893.prototype._getValue_toArray
];
$1a55656020b89c3a$export$7bf70fcf9f891893.prototype.SetterByBindingTypeAndVersioning = [
    [
        // Direct
        $1a55656020b89c3a$export$7bf70fcf9f891893.prototype._setValue_direct,
        $1a55656020b89c3a$export$7bf70fcf9f891893.prototype._setValue_direct_setNeedsUpdate,
        $1a55656020b89c3a$export$7bf70fcf9f891893.prototype._setValue_direct_setMatrixWorldNeedsUpdate
    ],
    [
        // EntireArray
        $1a55656020b89c3a$export$7bf70fcf9f891893.prototype._setValue_array,
        $1a55656020b89c3a$export$7bf70fcf9f891893.prototype._setValue_array_setNeedsUpdate,
        $1a55656020b89c3a$export$7bf70fcf9f891893.prototype._setValue_array_setMatrixWorldNeedsUpdate
    ],
    [
        // ArrayElement
        $1a55656020b89c3a$export$7bf70fcf9f891893.prototype._setValue_arrayElement,
        $1a55656020b89c3a$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setNeedsUpdate,
        $1a55656020b89c3a$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
    ],
    [
        // HasToFromArray
        $1a55656020b89c3a$export$7bf70fcf9f891893.prototype._setValue_fromArray,
        $1a55656020b89c3a$export$7bf70fcf9f891893.prototype._setValue_fromArray_setNeedsUpdate,
        $1a55656020b89c3a$export$7bf70fcf9f891893.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
    ]
];
/**
 *
 * A group of objects that receives a shared animation state.
 *
 * Usage:
 *
 *  - Add objects you would otherwise pass as 'root' to the
 *    constructor or the .clipAction method of AnimationMixer.
 *
 *  - Instead pass this object as 'root'.
 *
 *  - You can also add and remove objects later when the mixer
 *    is running.
 *
 * Note:
 *
 *    Objects of this class appear as one object to the mixer,
 *    so cache control of the individual objects must be done
 *    on the group.
 *
 * Limitation:
 *
 *  - The animated properties must be compatible among the
 *    all objects in the group.
 *
 *  - A single property can either be controlled through a
 *    target group or directly, but not both.
 */ var $1a55656020b89c3a$export$30619c2afd3f34db = /*#__PURE__*/ function() {
    "use strict";
    function AnimationObjectGroup() {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, AnimationObjectGroup);
        this.isAnimationObjectGroup = true;
        this.uuid = $1a55656020b89c3a$var$generateUUID();
        // cached objects followed by the active ones
        this._objects = Array.prototype.slice.call(arguments);
        this.nCachedObjects_ = 0; // threshold
        // note: read by PropertyBinding.Composite
        var indices = {};
        this._indicesByUUID = indices; // for bookkeeping
        for(var i = 0, n = arguments.length; i !== n; ++i)indices[arguments[i].uuid] = i;
        this._paths = []; // inside: string
        this._parsedPaths = []; // inside: { we don't care, here }
        this._bindings = []; // inside: Array< PropertyBinding >
        this._bindingsIndicesByPath = {}; // inside: indices in these arrays
        var scope = this;
        this.stats = {
            objects: {
                get total () {
                    return scope._objects.length;
                },
                get inUse () {
                    return this.total - scope.nCachedObjects_;
                }
            },
            get bindingsPerObject () {
                return scope._bindings.length;
            }
        };
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(AnimationObjectGroup, [
        {
            key: "add",
            value: function add() {
                var objects = this._objects, indicesByUUID = this._indicesByUUID, paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, nBindings = bindings.length;
                var knownObject = undefined, nObjects = objects.length, nCachedObjects = this.nCachedObjects_;
                for(var i = 0, n = arguments.length; i !== n; ++i){
                    var object = arguments[i], uuid = object.uuid;
                    var index = indicesByUUID[uuid];
                    if (index === undefined) {
                        // unknown object -> add it to the ACTIVE region
                        index = nObjects++;
                        indicesByUUID[uuid] = index;
                        objects.push(object);
                        // accounting is done, now do the same for all bindings
                        for(var j = 0, m = nBindings; j !== m; ++j)bindings[j].push(new $1a55656020b89c3a$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]));
                    } else if (index < nCachedObjects) {
                        knownObject = objects[index];
                        // move existing object to the ACTIVE region
                        var firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex];
                        indicesByUUID[lastCachedObject.uuid] = index;
                        objects[index] = lastCachedObject;
                        indicesByUUID[uuid] = firstActiveIndex;
                        objects[firstActiveIndex] = object;
                        // accounting is done, now do the same for all bindings
                        for(var j1 = 0, m1 = nBindings; j1 !== m1; ++j1){
                            var bindingsForPath = bindings[j1], lastCached = bindingsForPath[firstActiveIndex];
                            var binding = bindingsForPath[index];
                            bindingsForPath[index] = lastCached;
                            if (binding === undefined) // since we do not bother to create new bindings
                            // for objects that are cached, the binding may
                            // or may not exist
                            binding = new $1a55656020b89c3a$export$7bf70fcf9f891893(object, paths[j1], parsedPaths[j1]);
                            bindingsForPath[firstActiveIndex] = binding;
                        }
                    } else if (objects[index] !== knownObject) console.error("THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
                     // else the object is already where we want it to be
                } // for arguments
                this.nCachedObjects_ = nCachedObjects;
            }
        },
        {
            key: "remove",
            value: function remove() {
                var objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
                var nCachedObjects = this.nCachedObjects_;
                for(var i = 0, n = arguments.length; i !== n; ++i){
                    var object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
                    if (index !== undefined && index >= nCachedObjects) {
                        // move existing object into the CACHED region
                        var lastCachedIndex = nCachedObjects++, firstActiveObject = objects[lastCachedIndex];
                        indicesByUUID[firstActiveObject.uuid] = index;
                        objects[index] = firstActiveObject;
                        indicesByUUID[uuid] = lastCachedIndex;
                        objects[lastCachedIndex] = object;
                        // accounting is done, now do the same for all bindings
                        for(var j = 0, m = nBindings; j !== m; ++j){
                            var bindingsForPath = bindings[j], firstActive = bindingsForPath[lastCachedIndex], binding = bindingsForPath[index];
                            bindingsForPath[index] = firstActive;
                            bindingsForPath[lastCachedIndex] = binding;
                        }
                    }
                } // for arguments
                this.nCachedObjects_ = nCachedObjects;
            }
        },
        {
            // remove & forget
            key: "uncache",
            value: function uncache() {
                var objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
                var nCachedObjects = this.nCachedObjects_, nObjects = objects.length;
                for(var i = 0, n = arguments.length; i !== n; ++i){
                    var object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
                    if (index !== undefined) {
                        delete indicesByUUID[uuid];
                        if (index < nCachedObjects) {
                            // object is cached, shrink the CACHED region
                            var firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex], lastIndex = --nObjects, lastObject = objects[lastIndex];
                            // last cached object takes this object's place
                            indicesByUUID[lastCachedObject.uuid] = index;
                            objects[index] = lastCachedObject;
                            // last object goes to the activated slot and pop
                            indicesByUUID[lastObject.uuid] = firstActiveIndex;
                            objects[firstActiveIndex] = lastObject;
                            objects.pop();
                            // accounting is done, now do the same for all bindings
                            for(var j = 0, m = nBindings; j !== m; ++j){
                                var bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex], last = bindingsForPath[lastIndex];
                                bindingsForPath[index] = lastCached;
                                bindingsForPath[firstActiveIndex] = last;
                                bindingsForPath.pop();
                            }
                        } else {
                            // object is active, just swap with the last and pop
                            var lastIndex1 = --nObjects, lastObject1 = objects[lastIndex1];
                            if (lastIndex1 > 0) indicesByUUID[lastObject1.uuid] = index;
                            objects[index] = lastObject1;
                            objects.pop();
                            // accounting is done, now do the same for all bindings
                            for(var j1 = 0, m1 = nBindings; j1 !== m1; ++j1){
                                var bindingsForPath1 = bindings[j1];
                                bindingsForPath1[index] = bindingsForPath1[lastIndex1];
                                bindingsForPath1.pop();
                            }
                        } // cached or active
                    } // if object is known
                } // for arguments
                this.nCachedObjects_ = nCachedObjects;
            }
        },
        {
            // Internal interface used by befriended PropertyBinding.Composite:
            key: "subscribe_",
            value: function subscribe_(path, parsedPath) {
                // returns an array of bindings for the given path that is changed
                // according to the contained objects in the group
                var indicesByPath = this._bindingsIndicesByPath;
                var index = indicesByPath[path];
                var bindings = this._bindings;
                if (index !== undefined) return bindings[index];
                var paths = this._paths, parsedPaths = this._parsedPaths, objects = this._objects, nObjects = objects.length, nCachedObjects = this.nCachedObjects_, bindingsForPath = new Array(nObjects);
                index = bindings.length;
                indicesByPath[path] = index;
                paths.push(path);
                parsedPaths.push(parsedPath);
                bindings.push(bindingsForPath);
                for(var i = nCachedObjects, n = objects.length; i !== n; ++i){
                    var object = objects[i];
                    bindingsForPath[i] = new $1a55656020b89c3a$export$7bf70fcf9f891893(object, path, parsedPath);
                }
                return bindingsForPath;
            }
        },
        {
            key: "unsubscribe_",
            value: function unsubscribe_(path) {
                // tells the group to forget about a property path and no longer
                // update the array previously obtained with 'subscribe_'
                var indicesByPath = this._bindingsIndicesByPath, index = indicesByPath[path];
                if (index !== undefined) {
                    var paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, lastBindingsIndex = bindings.length - 1, lastBindings = bindings[lastBindingsIndex], lastBindingsPath = path[lastBindingsIndex];
                    indicesByPath[lastBindingsPath] = index;
                    bindings[index] = lastBindings;
                    bindings.pop();
                    parsedPaths[index] = parsedPaths[lastBindingsIndex];
                    parsedPaths.pop();
                    paths[index] = paths[lastBindingsIndex];
                    paths.pop();
                }
            }
        }
    ]);
    return AnimationObjectGroup;
}();
var $1a55656020b89c3a$export$6946940a69e799e = /*#__PURE__*/ function() {
    "use strict";
    function AnimationAction(mixer, clip) {
        var localRoot = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, blendMode = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : clip.blendMode;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, AnimationAction);
        this._mixer = mixer;
        this._clip = clip;
        this._localRoot = localRoot;
        this.blendMode = blendMode;
        var tracks = clip.tracks, nTracks = tracks.length, interpolants = new Array(nTracks);
        var interpolantSettings = {
            endingStart: $1a55656020b89c3a$export$7f795934b84ab523,
            endingEnd: $1a55656020b89c3a$export$7f795934b84ab523
        };
        for(var i = 0; i !== nTracks; ++i){
            var interpolant = tracks[i].createInterpolant(null);
            interpolants[i] = interpolant;
            interpolant.settings = interpolantSettings;
        }
        this._interpolantSettings = interpolantSettings;
        this._interpolants = interpolants; // bound by the mixer
        // inside: PropertyMixer (managed by the mixer)
        this._propertyBindings = new Array(nTracks);
        this._cacheIndex = null; // for the memory manager
        this._byClipCacheIndex = null; // for the memory manager
        this._timeScaleInterpolant = null;
        this._weightInterpolant = null;
        this.loop = $1a55656020b89c3a$export$dfaf4422ce096e29;
        this._loopCount = -1;
        // global mixer time when the action is to be started
        // it's set back to 'null' upon start of the action
        this._startTime = null;
        // scaled local time of the action
        // gets clamped or wrapped to 0..clip.duration according to loop
        this.time = 0;
        this.timeScale = 1;
        this._effectiveTimeScale = 1;
        this.weight = 1;
        this._effectiveWeight = 1;
        this.repetitions = Infinity; // no. of repetitions when looping
        this.paused = false; // true -> zero effective time scale
        this.enabled = true; // false -> zero effective weight
        this.clampWhenFinished = false; // keep feeding the last frame?
        this.zeroSlopeAtStart = true; // for smooth interpolation w/o separate
        this.zeroSlopeAtEnd = true; // clips for start, loop and end
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(AnimationAction, [
        {
            // State & Scheduling
            key: "play",
            value: function play() {
                this._mixer._activateAction(this);
                return this;
            }
        },
        {
            key: "stop",
            value: function stop() {
                this._mixer._deactivateAction(this);
                return this.reset();
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.paused = false;
                this.enabled = true;
                this.time = 0; // restart clip
                this._loopCount = -1; // forget previous loops
                this._startTime = null; // forget scheduling
                return this.stopFading().stopWarping();
            }
        },
        {
            key: "isRunning",
            value: function isRunning() {
                return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
            }
        },
        {
            // return true when play has been called
            key: "isScheduled",
            value: function isScheduled() {
                return this._mixer._isActiveAction(this);
            }
        },
        {
            key: "startAt",
            value: function startAt(time) {
                this._startTime = time;
                return this;
            }
        },
        {
            key: "setLoop",
            value: function setLoop(mode, repetitions) {
                this.loop = mode;
                this.repetitions = repetitions;
                return this;
            }
        },
        {
            // Weight
            // set the weight stopping any scheduled fading
            // although .enabled = false yields an effective weight of zero, this
            // method does *not* change .enabled, because it would be confusing
            key: "setEffectiveWeight",
            value: function setEffectiveWeight(weight) {
                this.weight = weight;
                // note: same logic as when updated at runtime
                this._effectiveWeight = this.enabled ? weight : 0;
                return this.stopFading();
            }
        },
        {
            // return the weight considering fading and .enabled
            key: "getEffectiveWeight",
            value: function getEffectiveWeight() {
                return this._effectiveWeight;
            }
        },
        {
            key: "fadeIn",
            value: function fadeIn(duration) {
                return this._scheduleFading(duration, 0, 1);
            }
        },
        {
            key: "fadeOut",
            value: function fadeOut(duration) {
                return this._scheduleFading(duration, 1, 0);
            }
        },
        {
            key: "crossFadeFrom",
            value: function crossFadeFrom(fadeOutAction, duration, warp) {
                fadeOutAction.fadeOut(duration);
                this.fadeIn(duration);
                if (warp) {
                    var fadeInDuration = this._clip.duration, fadeOutDuration = fadeOutAction._clip.duration, startEndRatio = fadeOutDuration / fadeInDuration, endStartRatio = fadeInDuration / fadeOutDuration;
                    fadeOutAction.warp(1.0, startEndRatio, duration);
                    this.warp(endStartRatio, 1.0, duration);
                }
                return this;
            }
        },
        {
            key: "crossFadeTo",
            value: function crossFadeTo(fadeInAction, duration, warp) {
                return fadeInAction.crossFadeFrom(this, duration, warp);
            }
        },
        {
            key: "stopFading",
            value: function stopFading() {
                var weightInterpolant = this._weightInterpolant;
                if (weightInterpolant !== null) {
                    this._weightInterpolant = null;
                    this._mixer._takeBackControlInterpolant(weightInterpolant);
                }
                return this;
            }
        },
        {
            // Time Scale Control
            // set the time scale stopping any scheduled warping
            // although .paused = true yields an effective time scale of zero, this
            // method does *not* change .paused, because it would be confusing
            key: "setEffectiveTimeScale",
            value: function setEffectiveTimeScale(timeScale) {
                this.timeScale = timeScale;
                this._effectiveTimeScale = this.paused ? 0 : timeScale;
                return this.stopWarping();
            }
        },
        {
            // return the time scale considering warping and .paused
            key: "getEffectiveTimeScale",
            value: function getEffectiveTimeScale() {
                return this._effectiveTimeScale;
            }
        },
        {
            key: "setDuration",
            value: function setDuration(duration) {
                this.timeScale = this._clip.duration / duration;
                return this.stopWarping();
            }
        },
        {
            key: "syncWith",
            value: function syncWith(action) {
                this.time = action.time;
                this.timeScale = action.timeScale;
                return this.stopWarping();
            }
        },
        {
            key: "halt",
            value: function halt(duration) {
                return this.warp(this._effectiveTimeScale, 0, duration);
            }
        },
        {
            key: "warp",
            value: function warp(startTimeScale, endTimeScale, duration) {
                var mixer = this._mixer, now = mixer.time, timeScale = this.timeScale;
                var interpolant = this._timeScaleInterpolant;
                if (interpolant === null) {
                    interpolant = mixer._lendControlInterpolant();
                    this._timeScaleInterpolant = interpolant;
                }
                var times = interpolant.parameterPositions, values = interpolant.sampleValues;
                times[0] = now;
                times[1] = now + duration;
                values[0] = startTimeScale / timeScale;
                values[1] = endTimeScale / timeScale;
                return this;
            }
        },
        {
            key: "stopWarping",
            value: function stopWarping() {
                var timeScaleInterpolant = this._timeScaleInterpolant;
                if (timeScaleInterpolant !== null) {
                    this._timeScaleInterpolant = null;
                    this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
                }
                return this;
            }
        },
        {
            // Object Accessors
            key: "getMixer",
            value: function getMixer() {
                return this._mixer;
            }
        },
        {
            key: "getClip",
            value: function getClip() {
                return this._clip;
            }
        },
        {
            key: "getRoot",
            value: function getRoot() {
                return this._localRoot || this._mixer._root;
            }
        },
        {
            // Interna
            key: "_update",
            value: function _update(time, deltaTime, timeDirection, accuIndex) {
                // called by the mixer
                if (!this.enabled) {
                    // call ._updateWeight() to update ._effectiveWeight
                    this._updateWeight(time);
                    return;
                }
                var startTime = this._startTime;
                if (startTime !== null) {
                    // check for scheduled start of action
                    var timeRunning = (time - startTime) * timeDirection;
                    if (timeRunning < 0 || timeDirection === 0) deltaTime = 0;
                    else {
                        this._startTime = null; // unschedule
                        deltaTime = timeDirection * timeRunning;
                    }
                }
                // apply time scale and advance time
                deltaTime *= this._updateTimeScale(time);
                var clipTime = this._updateTime(deltaTime);
                // note: _updateTime may disable the action resulting in
                // an effective weight of 0
                var weight = this._updateWeight(time);
                if (weight > 0) {
                    var interpolants = this._interpolants;
                    var propertyMixers = this._propertyBindings;
                    switch(this.blendMode){
                        case $1a55656020b89c3a$export$d875e029ef558d3:
                            for(var j = 0, m = interpolants.length; j !== m; ++j){
                                interpolants[j].evaluate(clipTime);
                                propertyMixers[j].accumulateAdditive(weight);
                            }
                            break;
                        case $1a55656020b89c3a$export$bcfbbdcf8de7f8cd:
                        default:
                            for(var j1 = 0, m1 = interpolants.length; j1 !== m1; ++j1){
                                interpolants[j1].evaluate(clipTime);
                                propertyMixers[j1].accumulate(accuIndex, weight);
                            }
                    }
                }
            }
        },
        {
            key: "_updateWeight",
            value: function _updateWeight(time) {
                var weight = 0;
                if (this.enabled) {
                    weight = this.weight;
                    var interpolant = this._weightInterpolant;
                    if (interpolant !== null) {
                        var interpolantValue = interpolant.evaluate(time)[0];
                        weight *= interpolantValue;
                        if (time > interpolant.parameterPositions[1]) {
                            this.stopFading();
                            if (interpolantValue === 0) // faded out, disable
                            this.enabled = false;
                        }
                    }
                }
                this._effectiveWeight = weight;
                return weight;
            }
        },
        {
            key: "_updateTimeScale",
            value: function _updateTimeScale(time) {
                var timeScale = 0;
                if (!this.paused) {
                    timeScale = this.timeScale;
                    var interpolant = this._timeScaleInterpolant;
                    if (interpolant !== null) {
                        var interpolantValue = interpolant.evaluate(time)[0];
                        timeScale *= interpolantValue;
                        if (time > interpolant.parameterPositions[1]) {
                            this.stopWarping();
                            if (timeScale === 0) // motion has halted, pause
                            this.paused = true;
                            else // warp done - apply final time scale
                            this.timeScale = timeScale;
                        }
                    }
                }
                this._effectiveTimeScale = timeScale;
                return timeScale;
            }
        },
        {
            key: "_updateTime",
            value: function _updateTime(deltaTime) {
                var duration = this._clip.duration;
                var loop = this.loop;
                var time = this.time + deltaTime;
                var loopCount = this._loopCount;
                var pingPong = loop === $1a55656020b89c3a$export$f8f6f2041b78e210;
                if (deltaTime === 0) {
                    if (loopCount === -1) return time;
                    return pingPong && (loopCount & 1) === 1 ? duration - time : time;
                }
                if (loop === $1a55656020b89c3a$export$d62fdc9d1b1cccad) {
                    if (loopCount === -1) {
                        // just started
                        this._loopCount = 0;
                        this._setEndings(true, true, false);
                    }
                    handle_stop: {
                        if (time >= duration) time = duration;
                        else if (time < 0) time = 0;
                        else {
                            this.time = time;
                            break handle_stop;
                        }
                        if (this.clampWhenFinished) this.paused = true;
                        else this.enabled = false;
                        this.time = time;
                        this._mixer.dispatchEvent({
                            type: 'finished',
                            action: this,
                            direction: deltaTime < 0 ? -1 : 1
                        });
                    }
                } else {
                    if (loopCount === -1) {
                        // just started
                        if (deltaTime >= 0) {
                            loopCount = 0;
                            this._setEndings(true, this.repetitions === 0, pingPong);
                        } else // when looping in reverse direction, the initial
                        // transition through zero counts as a repetition,
                        // so leave loopCount at -1
                        this._setEndings(this.repetitions === 0, true, pingPong);
                    }
                    if (time >= duration || time < 0) {
                        // wrap around
                        var loopDelta = Math.floor(time / duration); // signed
                        time -= duration * loopDelta;
                        loopCount += Math.abs(loopDelta);
                        var pending = this.repetitions - loopCount;
                        if (pending <= 0) {
                            // have to stop (switch state, clamp time, fire event)
                            if (this.clampWhenFinished) this.paused = true;
                            else this.enabled = false;
                            time = deltaTime > 0 ? duration : 0;
                            this.time = time;
                            this._mixer.dispatchEvent({
                                type: 'finished',
                                action: this,
                                direction: deltaTime > 0 ? 1 : -1
                            });
                        } else {
                            // keep running
                            if (pending === 1) {
                                // entering the last round
                                var atStart = deltaTime < 0;
                                this._setEndings(atStart, !atStart, pingPong);
                            } else this._setEndings(false, false, pingPong);
                            this._loopCount = loopCount;
                            this.time = time;
                            this._mixer.dispatchEvent({
                                type: 'loop',
                                action: this,
                                loopDelta: loopDelta
                            });
                        }
                    } else this.time = time;
                    if (pingPong && (loopCount & 1) === 1) // invert time for the "pong round"
                    return duration - time;
                }
                return time;
            }
        },
        {
            key: "_setEndings",
            value: function _setEndings(atStart, atEnd, pingPong) {
                var settings = this._interpolantSettings;
                if (pingPong) {
                    settings.endingStart = $1a55656020b89c3a$export$24a4ccb5099273b5;
                    settings.endingEnd = $1a55656020b89c3a$export$24a4ccb5099273b5;
                } else {
                    // assuming for LoopOnce atStart == atEnd == true
                    if (atStart) settings.endingStart = this.zeroSlopeAtStart ? $1a55656020b89c3a$export$24a4ccb5099273b5 : $1a55656020b89c3a$export$7f795934b84ab523;
                    else settings.endingStart = $1a55656020b89c3a$export$8e8c3ecdcd8e1fee;
                    if (atEnd) settings.endingEnd = this.zeroSlopeAtEnd ? $1a55656020b89c3a$export$24a4ccb5099273b5 : $1a55656020b89c3a$export$7f795934b84ab523;
                    else settings.endingEnd = $1a55656020b89c3a$export$8e8c3ecdcd8e1fee;
                }
            }
        },
        {
            key: "_scheduleFading",
            value: function _scheduleFading(duration, weightNow, weightThen) {
                var mixer = this._mixer, now = mixer.time;
                var interpolant = this._weightInterpolant;
                if (interpolant === null) {
                    interpolant = mixer._lendControlInterpolant();
                    this._weightInterpolant = interpolant;
                }
                var times = interpolant.parameterPositions, values = interpolant.sampleValues;
                times[0] = now;
                values[0] = weightNow;
                times[1] = now + duration;
                values[1] = weightThen;
                return this;
            }
        }
    ]);
    return AnimationAction;
}();
var $1a55656020b89c3a$var$_controlInterpolantsResultBuffer = new Float32Array(1);
var $1a55656020b89c3a$export$fbd77e5aefaa0102 = /*#__PURE__*/ function(EventDispatcher) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(AnimationMixer, EventDispatcher);
    function AnimationMixer(root) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, AnimationMixer);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, AnimationMixer);
        _this._root = root;
        _this._initMemoryManager();
        _this._accuIndex = 0;
        _this.time = 0;
        _this.timeScale = 1.0;
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(AnimationMixer, [
        {
            key: "_bindAction",
            value: function _bindAction(action, prototypeAction) {
                var root = action._localRoot || this._root, tracks = action._clip.tracks, nTracks = tracks.length, bindings = action._propertyBindings, interpolants = action._interpolants, rootUuid = root.uuid, bindingsByRoot = this._bindingsByRootAndName;
                var bindingsByName = bindingsByRoot[rootUuid];
                if (bindingsByName === undefined) {
                    bindingsByName = {};
                    bindingsByRoot[rootUuid] = bindingsByName;
                }
                for(var i = 0; i !== nTracks; ++i){
                    var track = tracks[i], trackName = track.name;
                    var binding = bindingsByName[trackName];
                    if (binding !== undefined) {
                        ++binding.referenceCount;
                        bindings[i] = binding;
                    } else {
                        binding = bindings[i];
                        if (binding !== undefined) {
                            // existing binding, make sure the cache knows
                            if (binding._cacheIndex === null) {
                                ++binding.referenceCount;
                                this._addInactiveBinding(binding, rootUuid, trackName);
                            }
                            continue;
                        }
                        var path = prototypeAction && prototypeAction._propertyBindings[i].binding.parsedPath;
                        binding = new $1a55656020b89c3a$export$dfe0af1ca1acb78a($1a55656020b89c3a$export$7bf70fcf9f891893.create(root, trackName, path), track.ValueTypeName, track.getValueSize());
                        ++binding.referenceCount;
                        this._addInactiveBinding(binding, rootUuid, trackName);
                        bindings[i] = binding;
                    }
                    interpolants[i].resultBuffer = binding.buffer;
                }
            }
        },
        {
            key: "_activateAction",
            value: function _activateAction(action) {
                if (!this._isActiveAction(action)) {
                    if (action._cacheIndex === null) {
                        // this action has been forgotten by the cache, but the user
                        // appears to be still using it -> rebind
                        var rootUuid = (action._localRoot || this._root).uuid, clipUuid = action._clip.uuid, actionsForClip = this._actionsByClip[clipUuid];
                        this._bindAction(action, actionsForClip && actionsForClip.knownActions[0]);
                        this._addInactiveAction(action, clipUuid, rootUuid);
                    }
                    var bindings = action._propertyBindings;
                    // increment reference counts / sort out state
                    for(var i = 0, n = bindings.length; i !== n; ++i){
                        var binding = bindings[i];
                        if (binding.useCount++ === 0) {
                            this._lendBinding(binding);
                            binding.saveOriginalState();
                        }
                    }
                    this._lendAction(action);
                }
            }
        },
        {
            key: "_deactivateAction",
            value: function _deactivateAction(action) {
                if (this._isActiveAction(action)) {
                    var bindings = action._propertyBindings;
                    // decrement reference counts / sort out state
                    for(var i = 0, n = bindings.length; i !== n; ++i){
                        var binding = bindings[i];
                        if (--binding.useCount === 0) {
                            binding.restoreOriginalState();
                            this._takeBackBinding(binding);
                        }
                    }
                    this._takeBackAction(action);
                }
            }
        },
        {
            // Memory manager
            key: "_initMemoryManager",
            value: function _initMemoryManager() {
                this._actions = []; // 'nActiveActions' followed by inactive ones
                this._nActiveActions = 0;
                this._actionsByClip = {};
                // inside:
                // {
                // 	knownActions: Array< AnimationAction > - used as prototypes
                // 	actionByRoot: AnimationAction - lookup
                // }
                this._bindings = []; // 'nActiveBindings' followed by inactive ones
                this._nActiveBindings = 0;
                this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >
                this._controlInterpolants = []; // same game as above
                this._nActiveControlInterpolants = 0;
                var scope = this;
                this.stats = {
                    actions: {
                        get total () {
                            return scope._actions.length;
                        },
                        get inUse () {
                            return scope._nActiveActions;
                        }
                    },
                    bindings: {
                        get total () {
                            return scope._bindings.length;
                        },
                        get inUse () {
                            return scope._nActiveBindings;
                        }
                    },
                    controlInterpolants: {
                        get total () {
                            return scope._controlInterpolants.length;
                        },
                        get inUse () {
                            return scope._nActiveControlInterpolants;
                        }
                    }
                };
            }
        },
        {
            // Memory management for AnimationAction objects
            key: "_isActiveAction",
            value: function _isActiveAction(action) {
                var index = action._cacheIndex;
                return index !== null && index < this._nActiveActions;
            }
        },
        {
            key: "_addInactiveAction",
            value: function _addInactiveAction(action, clipUuid, rootUuid) {
                var actions = this._actions, actionsByClip = this._actionsByClip;
                var actionsForClip = actionsByClip[clipUuid];
                if (actionsForClip === undefined) {
                    actionsForClip = {
                        knownActions: [
                            action
                        ],
                        actionByRoot: {}
                    };
                    action._byClipCacheIndex = 0;
                    actionsByClip[clipUuid] = actionsForClip;
                } else {
                    var knownActions = actionsForClip.knownActions;
                    action._byClipCacheIndex = knownActions.length;
                    knownActions.push(action);
                }
                action._cacheIndex = actions.length;
                actions.push(action);
                actionsForClip.actionByRoot[rootUuid] = action;
            }
        },
        {
            key: "_removeInactiveAction",
            value: function _removeInactiveAction(action) {
                var actions = this._actions, lastInactiveAction = actions[actions.length - 1], cacheIndex = action._cacheIndex;
                lastInactiveAction._cacheIndex = cacheIndex;
                actions[cacheIndex] = lastInactiveAction;
                actions.pop();
                action._cacheIndex = null;
                var clipUuid = action._clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid], knownActionsForClip = actionsForClip.knownActions, lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1], byClipCacheIndex = action._byClipCacheIndex;
                lastKnownAction._byClipCacheIndex = byClipCacheIndex;
                knownActionsForClip[byClipCacheIndex] = lastKnownAction;
                knownActionsForClip.pop();
                action._byClipCacheIndex = null;
                var actionByRoot = actionsForClip.actionByRoot, rootUuid = (action._localRoot || this._root).uuid;
                delete actionByRoot[rootUuid];
                if (knownActionsForClip.length === 0) delete actionsByClip[clipUuid];
                this._removeInactiveBindingsForAction(action);
            }
        },
        {
            key: "_removeInactiveBindingsForAction",
            value: function _removeInactiveBindingsForAction(action) {
                var bindings = action._propertyBindings;
                for(var i = 0, n = bindings.length; i !== n; ++i){
                    var binding = bindings[i];
                    if (--binding.referenceCount === 0) this._removeInactiveBinding(binding);
                }
            }
        },
        {
            key: "_lendAction",
            value: function _lendAction(action) {
                // [ active actions |  inactive actions  ]
                // [  active actions >| inactive actions ]
                //                 s        a
                //                  <-swap->
                //                 a        s
                var actions = this._actions, prevIndex = action._cacheIndex, lastActiveIndex = this._nActiveActions++, firstInactiveAction = actions[lastActiveIndex];
                action._cacheIndex = lastActiveIndex;
                actions[lastActiveIndex] = action;
                firstInactiveAction._cacheIndex = prevIndex;
                actions[prevIndex] = firstInactiveAction;
            }
        },
        {
            key: "_takeBackAction",
            value: function _takeBackAction(action) {
                // [  active actions  | inactive actions ]
                // [ active actions |< inactive actions  ]
                //        a        s
                //         <-swap->
                //        s        a
                var actions = this._actions, prevIndex = action._cacheIndex, firstInactiveIndex = --this._nActiveActions, lastActiveAction = actions[firstInactiveIndex];
                action._cacheIndex = firstInactiveIndex;
                actions[firstInactiveIndex] = action;
                lastActiveAction._cacheIndex = prevIndex;
                actions[prevIndex] = lastActiveAction;
            }
        },
        {
            // Memory management for PropertyMixer objects
            key: "_addInactiveBinding",
            value: function _addInactiveBinding(binding, rootUuid, trackName) {
                var bindingsByRoot = this._bindingsByRootAndName, bindings = this._bindings;
                var bindingByName = bindingsByRoot[rootUuid];
                if (bindingByName === undefined) {
                    bindingByName = {};
                    bindingsByRoot[rootUuid] = bindingByName;
                }
                bindingByName[trackName] = binding;
                binding._cacheIndex = bindings.length;
                bindings.push(binding);
            }
        },
        {
            key: "_removeInactiveBinding",
            value: function _removeInactiveBinding(binding) {
                var bindings = this._bindings, propBinding = binding.binding, rootUuid = propBinding.rootNode.uuid, trackName = propBinding.path, bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid], lastInactiveBinding = bindings[bindings.length - 1], cacheIndex = binding._cacheIndex;
                lastInactiveBinding._cacheIndex = cacheIndex;
                bindings[cacheIndex] = lastInactiveBinding;
                bindings.pop();
                delete bindingByName[trackName];
                if (Object.keys(bindingByName).length === 0) delete bindingsByRoot[rootUuid];
            }
        },
        {
            key: "_lendBinding",
            value: function _lendBinding(binding) {
                var bindings = this._bindings, prevIndex = binding._cacheIndex, lastActiveIndex = this._nActiveBindings++, firstInactiveBinding = bindings[lastActiveIndex];
                binding._cacheIndex = lastActiveIndex;
                bindings[lastActiveIndex] = binding;
                firstInactiveBinding._cacheIndex = prevIndex;
                bindings[prevIndex] = firstInactiveBinding;
            }
        },
        {
            key: "_takeBackBinding",
            value: function _takeBackBinding(binding) {
                var bindings = this._bindings, prevIndex = binding._cacheIndex, firstInactiveIndex = --this._nActiveBindings, lastActiveBinding = bindings[firstInactiveIndex];
                binding._cacheIndex = firstInactiveIndex;
                bindings[firstInactiveIndex] = binding;
                lastActiveBinding._cacheIndex = prevIndex;
                bindings[prevIndex] = lastActiveBinding;
            }
        },
        {
            // Memory management of Interpolants for weight and time scale
            key: "_lendControlInterpolant",
            value: function _lendControlInterpolant() {
                var interpolants = this._controlInterpolants, lastActiveIndex = this._nActiveControlInterpolants++;
                var interpolant = interpolants[lastActiveIndex];
                if (interpolant === undefined) {
                    interpolant = new $1a55656020b89c3a$export$a8e6009059f51e1a(new Float32Array(2), new Float32Array(2), 1, $1a55656020b89c3a$var$_controlInterpolantsResultBuffer);
                    interpolant.__cacheIndex = lastActiveIndex;
                    interpolants[lastActiveIndex] = interpolant;
                }
                return interpolant;
            }
        },
        {
            key: "_takeBackControlInterpolant",
            value: function _takeBackControlInterpolant(interpolant) {
                var interpolants = this._controlInterpolants, prevIndex = interpolant.__cacheIndex, firstInactiveIndex = --this._nActiveControlInterpolants, lastActiveInterpolant = interpolants[firstInactiveIndex];
                interpolant.__cacheIndex = firstInactiveIndex;
                interpolants[firstInactiveIndex] = interpolant;
                lastActiveInterpolant.__cacheIndex = prevIndex;
                interpolants[prevIndex] = lastActiveInterpolant;
            }
        },
        {
            // return an action for a clip optionally using a custom root target
            // object (this method allocates a lot of dynamic memory in case a
            // previously unknown clip/root combination is specified)
            key: "clipAction",
            value: function clipAction(clip, optionalRoot, blendMode) {
                var root = optionalRoot || this._root, rootUuid = root.uuid;
                var clipObject = typeof clip === 'string' ? $1a55656020b89c3a$export$d942c706bf23829c.findByName(root, clip) : clip;
                var clipUuid = clipObject !== null ? clipObject.uuid : clip;
                var actionsForClip = this._actionsByClip[clipUuid];
                var prototypeAction = null;
                if (blendMode === undefined) {
                    if (clipObject !== null) blendMode = clipObject.blendMode;
                    else blendMode = $1a55656020b89c3a$export$bcfbbdcf8de7f8cd;
                }
                if (actionsForClip !== undefined) {
                    var existingAction = actionsForClip.actionByRoot[rootUuid];
                    if (existingAction !== undefined && existingAction.blendMode === blendMode) return existingAction;
                    // we know the clip, so we don't have to parse all
                    // the bindings again but can just copy
                    prototypeAction = actionsForClip.knownActions[0];
                    // also, take the clip from the prototype action
                    if (clipObject === null) clipObject = prototypeAction._clip;
                }
                // clip must be known when specified via string
                if (clipObject === null) return null;
                // allocate all resources required to run it
                var newAction = new $1a55656020b89c3a$export$6946940a69e799e(this, clipObject, optionalRoot, blendMode);
                this._bindAction(newAction, prototypeAction);
                // and make the action known to the memory manager
                this._addInactiveAction(newAction, clipUuid, rootUuid);
                return newAction;
            }
        },
        {
            // get an existing action
            key: "existingAction",
            value: function existingAction(clip, optionalRoot) {
                var root = optionalRoot || this._root, rootUuid = root.uuid, clipObject = typeof clip === 'string' ? $1a55656020b89c3a$export$d942c706bf23829c.findByName(root, clip) : clip, clipUuid = clipObject ? clipObject.uuid : clip, actionsForClip = this._actionsByClip[clipUuid];
                if (actionsForClip !== undefined) return actionsForClip.actionByRoot[rootUuid] || null;
                return null;
            }
        },
        {
            // deactivates all previously scheduled actions
            key: "stopAllAction",
            value: function stopAllAction() {
                var actions = this._actions, nActions = this._nActiveActions;
                for(var i = nActions - 1; i >= 0; --i)actions[i].stop();
                return this;
            }
        },
        {
            // advance the time and update apply the animation
            key: "update",
            value: function update(deltaTime) {
                deltaTime *= this.timeScale;
                var actions = this._actions, nActions = this._nActiveActions, time = this.time += deltaTime, timeDirection = Math.sign(deltaTime), accuIndex = this._accuIndex ^= 1;
                // run active actions
                for(var i = 0; i !== nActions; ++i){
                    var action = actions[i];
                    action._update(time, deltaTime, timeDirection, accuIndex);
                }
                // update scene graph
                var bindings = this._bindings, nBindings = this._nActiveBindings;
                for(var i1 = 0; i1 !== nBindings; ++i1)bindings[i1].apply(accuIndex);
                return this;
            }
        },
        {
            // Allows you to seek to a specific time in an animation.
            key: "setTime",
            value: function setTime(timeInSeconds) {
                this.time = 0; // Zero out time attribute for AnimationMixer object;
                for(var i = 0; i < this._actions.length; i++)this._actions[i].time = 0; // Zero out time attribute for all associated AnimationAction objects.
                return this.update(timeInSeconds); // Update used to set exact time. Returns "this" AnimationMixer object.
            }
        },
        {
            // return this mixer's root target object
            key: "getRoot",
            value: function getRoot() {
                return this._root;
            }
        },
        {
            // free all resources specific to a particular clip
            key: "uncacheClip",
            value: function uncacheClip(clip) {
                var actions = this._actions, clipUuid = clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid];
                if (actionsForClip !== undefined) {
                    // note: just calling _removeInactiveAction would mess up the
                    // iteration state and also require updating the state we can
                    // just throw away
                    var actionsToRemove = actionsForClip.knownActions;
                    for(var i = 0, n = actionsToRemove.length; i !== n; ++i){
                        var action = actionsToRemove[i];
                        this._deactivateAction(action);
                        var cacheIndex = action._cacheIndex, lastInactiveAction = actions[actions.length - 1];
                        action._cacheIndex = null;
                        action._byClipCacheIndex = null;
                        lastInactiveAction._cacheIndex = cacheIndex;
                        actions[cacheIndex] = lastInactiveAction;
                        actions.pop();
                        this._removeInactiveBindingsForAction(action);
                    }
                    delete actionsByClip[clipUuid];
                }
            }
        },
        {
            // free all resources specific to a particular root target object
            key: "uncacheRoot",
            value: function uncacheRoot(root) {
                var rootUuid = root.uuid, actionsByClip = this._actionsByClip;
                for(var clipUuid in actionsByClip){
                    var actionByRoot = actionsByClip[clipUuid].actionByRoot, action = actionByRoot[rootUuid];
                    if (action !== undefined) {
                        this._deactivateAction(action);
                        this._removeInactiveAction(action);
                    }
                }
                var bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid];
                if (bindingByName !== undefined) for(var trackName in bindingByName){
                    var binding = bindingByName[trackName];
                    binding.restoreOriginalState();
                    this._removeInactiveBinding(binding);
                }
            }
        },
        {
            // remove a targeted clip from the cache
            key: "uncacheAction",
            value: function uncacheAction(clip, optionalRoot) {
                var action = this.existingAction(clip, optionalRoot);
                if (action !== null) {
                    this._deactivateAction(action);
                    this._removeInactiveAction(action);
                }
            }
        }
    ]);
    return AnimationMixer;
}($1a55656020b89c3a$export$ec8b666c5fe2c75a);
var $1a55656020b89c3a$export$6b116d2fdfef087c = /*#__PURE__*/ function(RenderTarget) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(RenderTarget3D, RenderTarget);
    function RenderTarget3D() {
        var width = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, height = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, RenderTarget3D);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, RenderTarget3D, [
            width,
            height,
            options
        ]);
        _this.isRenderTarget3D = true;
        _this.depth = depth;
        _this.texture = new $1a55656020b89c3a$export$d7a3086320f856db(null, width, height, depth);
        _this.texture.isRenderTargetTexture = true;
        return _this;
    }
    return RenderTarget3D;
}($1a55656020b89c3a$export$efcb1f8bf367cbfb);
var $1a55656020b89c3a$export$eb4d196341728d65 = /*#__PURE__*/ function(RenderTarget) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(RenderTargetArray, RenderTarget);
    function RenderTargetArray() {
        var width = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, height = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, RenderTargetArray);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, RenderTargetArray, [
            width,
            height,
            options
        ]);
        _this.isRenderTargetArray = true;
        _this.depth = depth;
        _this.texture = new $1a55656020b89c3a$export$dfac6c8e811406a3(null, width, height, depth);
        _this.texture.isRenderTargetTexture = true;
        return _this;
    }
    return RenderTargetArray;
}($1a55656020b89c3a$export$efcb1f8bf367cbfb);
var $1a55656020b89c3a$export$2947cebfe91c02f8 = /*#__PURE__*/ function() {
    "use strict";
    function Uniform(value) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Uniform);
        this.value = value;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Uniform, [
        {
            key: "clone",
            value: function clone() {
                return new Uniform(this.value.clone === undefined ? this.value : this.value.clone());
            }
        }
    ]);
    return Uniform;
}();
var $1a55656020b89c3a$var$_id = 0;
var $1a55656020b89c3a$export$c412d5ffe1f79209 = /*#__PURE__*/ function(EventDispatcher) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(UniformsGroup, EventDispatcher);
    function UniformsGroup() {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, UniformsGroup);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, UniformsGroup);
        _this.isUniformsGroup = true;
        Object.defineProperty(_this, 'id', {
            value: $1a55656020b89c3a$var$_id++
        });
        _this.name = '';
        _this.usage = $1a55656020b89c3a$export$763e8360f4d7f77d;
        _this.uniforms = [];
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(UniformsGroup, [
        {
            key: "add",
            value: function add(uniform) {
                this.uniforms.push(uniform);
                return this;
            }
        },
        {
            key: "remove",
            value: function remove(uniform) {
                var index = this.uniforms.indexOf(uniform);
                if (index !== -1) this.uniforms.splice(index, 1);
                return this;
            }
        },
        {
            key: "setName",
            value: function setName(name) {
                this.name = name;
                return this;
            }
        },
        {
            key: "setUsage",
            value: function setUsage(value) {
                this.usage = value;
                return this;
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this.dispatchEvent({
                    type: 'dispose'
                });
                return this;
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                this.name = source.name;
                this.usage = source.usage;
                var uniformsSource = source.uniforms;
                this.uniforms.length = 0;
                for(var i = 0, l = uniformsSource.length; i < l; i++){
                    var uniforms = Array.isArray(uniformsSource[i]) ? uniformsSource[i] : [
                        uniformsSource[i]
                    ];
                    for(var j = 0; j < uniforms.length; j++)this.uniforms.push(uniforms[j].clone());
                }
                return this;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        }
    ]);
    return UniformsGroup;
}($1a55656020b89c3a$export$ec8b666c5fe2c75a);
var $1a55656020b89c3a$export$25ec0e1af1389358 = /*#__PURE__*/ function(InterleavedBuffer) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(InstancedInterleavedBuffer, InterleavedBuffer);
    function InstancedInterleavedBuffer(array, stride) {
        var meshPerAttribute = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, InstancedInterleavedBuffer);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, InstancedInterleavedBuffer, [
            array,
            stride
        ]);
        _this.isInstancedInterleavedBuffer = true;
        _this.meshPerAttribute = meshPerAttribute;
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(InstancedInterleavedBuffer, [
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(InstancedInterleavedBuffer.prototype), "copy", this).call(this, source);
                this.meshPerAttribute = source.meshPerAttribute;
                return this;
            }
        },
        {
            key: "clone",
            value: function clone(data) {
                var ib = (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(InstancedInterleavedBuffer.prototype), "clone", this).call(this, data);
                ib.meshPerAttribute = this.meshPerAttribute;
                return ib;
            }
        },
        {
            key: "toJSON",
            value: function toJSON(data) {
                var json = (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(InstancedInterleavedBuffer.prototype), "toJSON", this).call(this, data);
                json.isInstancedInterleavedBuffer = true;
                json.meshPerAttribute = this.meshPerAttribute;
                return json;
            }
        }
    ]);
    return InstancedInterleavedBuffer;
}($1a55656020b89c3a$export$3d5cd879f108f53f);
var $1a55656020b89c3a$export$6b7339ae8dbddf73 = /*#__PURE__*/ function() {
    "use strict";
    function GLBufferAttribute(buffer, type, itemSize, elementSize, count) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, GLBufferAttribute);
        this.isGLBufferAttribute = true;
        this.name = '';
        this.buffer = buffer;
        this.type = type;
        this.itemSize = itemSize;
        this.elementSize = elementSize;
        this.count = count;
        this.version = 0;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(GLBufferAttribute, [
        {
            key: "needsUpdate",
            set: function set(value) {
                if (value === true) this.version++;
            }
        },
        {
            key: "setBuffer",
            value: function setBuffer(buffer) {
                this.buffer = buffer;
                return this;
            }
        },
        {
            key: "setType",
            value: function setType(type, elementSize) {
                this.type = type;
                this.elementSize = elementSize;
                return this;
            }
        },
        {
            key: "setItemSize",
            value: function setItemSize(itemSize) {
                this.itemSize = itemSize;
                return this;
            }
        },
        {
            key: "setCount",
            value: function setCount(count) {
                this.count = count;
                return this;
            }
        }
    ]);
    return GLBufferAttribute;
}();
var $1a55656020b89c3a$var$_matrix = /*@__PURE__*/ new $1a55656020b89c3a$export$2ae72fc923e5eb5();
var $1a55656020b89c3a$export$8b7aaceff00bd2f = /*#__PURE__*/ function() {
    "use strict";
    function Raycaster(origin, direction) {
        var near = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, far = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Infinity;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Raycaster);
        this.ray = new $1a55656020b89c3a$export$a186db52eed6d40e(origin, direction);
        // direction is assumed to be normalized (for accurate distance calculations)
        this.near = near;
        this.far = far;
        this.camera = null;
        this.layers = new $1a55656020b89c3a$export$89312ce47c0ca777();
        this.params = {
            Mesh: {},
            Line: {
                threshold: 1
            },
            LOD: {},
            Points: {
                threshold: 1
            },
            Sprite: {}
        };
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Raycaster, [
        {
            key: "set",
            value: function set(origin, direction) {
                // direction is assumed to be normalized (for accurate distance calculations)
                this.ray.set(origin, direction);
            }
        },
        {
            key: "setFromCamera",
            value: function setFromCamera(coords, camera) {
                if (camera.isPerspectiveCamera) {
                    this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
                    this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
                    this.camera = camera;
                } else if (camera.isOrthographicCamera) {
                    this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera); // set origin in plane of camera
                    this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
                    this.camera = camera;
                } else console.error('THREE.Raycaster: Unsupported camera type: ' + camera.type);
            }
        },
        {
            key: "setFromXRController",
            value: function setFromXRController(controller) {
                $1a55656020b89c3a$var$_matrix.identity().extractRotation(controller.matrixWorld);
                this.ray.origin.setFromMatrixPosition(controller.matrixWorld);
                this.ray.direction.set(0, 0, -1).applyMatrix4($1a55656020b89c3a$var$_matrix);
                return this;
            }
        },
        {
            key: "intersectObject",
            value: function intersectObject(object) {
                var recursive = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, intersects = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
                $1a55656020b89c3a$var$intersect(object, this, intersects, recursive);
                intersects.sort($1a55656020b89c3a$var$ascSort);
                return intersects;
            }
        },
        {
            key: "intersectObjects",
            value: function intersectObjects(objects) {
                var recursive = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, intersects = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
                for(var i = 0, l = objects.length; i < l; i++)$1a55656020b89c3a$var$intersect(objects[i], this, intersects, recursive);
                intersects.sort($1a55656020b89c3a$var$ascSort);
                return intersects;
            }
        }
    ]);
    return Raycaster;
}();
function $1a55656020b89c3a$var$ascSort(a, b) {
    return a.distance - b.distance;
}
function $1a55656020b89c3a$var$intersect(object, raycaster, intersects, recursive) {
    var propagate = true;
    if (object.layers.test(raycaster.layers)) {
        var result = object.raycast(raycaster, intersects);
        if (result === false) propagate = false;
    }
    if (propagate === true && recursive === true) {
        var children = object.children;
        for(var i = 0, l = children.length; i < l; i++)$1a55656020b89c3a$var$intersect(children[i], raycaster, intersects, true);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Spherical_coordinate_system
 *
 * phi (the polar angle) is measured from the positive y-axis. The positive y-axis is up.
 * theta (the azimuthal angle) is measured from the positive z-axis.
 */ var $1a55656020b89c3a$export$d712cd887b4a00f7 = /*#__PURE__*/ function() {
    "use strict";
    function Spherical() {
        var radius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, phi = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, theta = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Spherical);
        this.radius = radius;
        this.phi = phi; // polar angle
        this.theta = theta; // azimuthal angle
        return this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Spherical, [
        {
            key: "set",
            value: function set(radius, phi, theta) {
                this.radius = radius;
                this.phi = phi;
                this.theta = theta;
                return this;
            }
        },
        {
            key: "copy",
            value: function copy(other) {
                this.radius = other.radius;
                this.phi = other.phi;
                this.theta = other.theta;
                return this;
            }
        },
        {
            // restrict phi to be between EPS and PI-EPS
            key: "makeSafe",
            value: function makeSafe() {
                var EPS = 0.000001;
                this.phi = $1a55656020b89c3a$var$clamp(this.phi, EPS, Math.PI - EPS);
                return this;
            }
        },
        {
            key: "setFromVector3",
            value: function setFromVector3(v) {
                return this.setFromCartesianCoords(v.x, v.y, v.z);
            }
        },
        {
            key: "setFromCartesianCoords",
            value: function setFromCartesianCoords(x, y, z) {
                this.radius = Math.sqrt(x * x + y * y + z * z);
                if (this.radius === 0) {
                    this.theta = 0;
                    this.phi = 0;
                } else {
                    this.theta = Math.atan2(x, z);
                    this.phi = Math.acos($1a55656020b89c3a$var$clamp(y / this.radius, -1, 1));
                }
                return this;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        }
    ]);
    return Spherical;
}();
/**
 * Ref: https://en.wikipedia.org/wiki/Cylindrical_coordinate_system
 */ var $1a55656020b89c3a$export$287165bb2177f4fd = /*#__PURE__*/ function() {
    "use strict";
    function Cylindrical() {
        var radius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, theta = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, y = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Cylindrical);
        this.radius = radius; // distance from the origin to a point in the x-z plane
        this.theta = theta; // counterclockwise angle in the x-z plane measured in radians from the positive z-axis
        this.y = y; // height above the x-z plane
        return this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Cylindrical, [
        {
            key: "set",
            value: function set(radius, theta, y) {
                this.radius = radius;
                this.theta = theta;
                this.y = y;
                return this;
            }
        },
        {
            key: "copy",
            value: function copy(other) {
                this.radius = other.radius;
                this.theta = other.theta;
                this.y = other.y;
                return this;
            }
        },
        {
            key: "setFromVector3",
            value: function setFromVector3(v) {
                return this.setFromCartesianCoords(v.x, v.y, v.z);
            }
        },
        {
            key: "setFromCartesianCoords",
            value: function setFromCartesianCoords(x, y, z) {
                this.radius = Math.sqrt(x * x + z * z);
                this.theta = Math.atan2(x, z);
                this.y = y;
                return this;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        }
    ]);
    return Cylindrical;
}();
var $1a55656020b89c3a$export$cbcc6560bf79fb38 = /*#__PURE__*/ function() {
    "use strict";
    function Matrix2(n11, n12, n21, n22) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Matrix2);
        Matrix2.prototype.isMatrix2 = true;
        this.elements = [
            1,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n21, n22);
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Matrix2, [
        {
            key: "identity",
            value: function identity() {
                this.set(1, 0, 0, 1);
                return this;
            }
        },
        {
            key: "fromArray",
            value: function fromArray(array) {
                var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                for(var i = 0; i < 4; i++)this.elements[i] = array[i + offset];
                return this;
            }
        },
        {
            key: "set",
            value: function set(n11, n12, n21, n22) {
                var te = this.elements;
                te[0] = n11;
                te[2] = n12;
                te[1] = n21;
                te[3] = n22;
                return this;
            }
        }
    ]);
    return Matrix2;
}();
var $1a55656020b89c3a$var$_vector$4 = /*@__PURE__*/ new $1a55656020b89c3a$export$c977b3e384af9ae1();
var $1a55656020b89c3a$export$60f553fa130f08b0 = /*#__PURE__*/ function() {
    "use strict";
    function Box2() {
        var min = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $1a55656020b89c3a$export$c977b3e384af9ae1(Infinity, Infinity), max = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $1a55656020b89c3a$export$c977b3e384af9ae1(-Infinity, -Infinity);
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Box2);
        this.isBox2 = true;
        this.min = min;
        this.max = max;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Box2, [
        {
            key: "set",
            value: function set(min, max) {
                this.min.copy(min);
                this.max.copy(max);
                return this;
            }
        },
        {
            key: "setFromPoints",
            value: function setFromPoints(points) {
                this.makeEmpty();
                for(var i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
                return this;
            }
        },
        {
            key: "setFromCenterAndSize",
            value: function setFromCenterAndSize(center, size) {
                var halfSize = $1a55656020b89c3a$var$_vector$4.copy(size).multiplyScalar(0.5);
                this.min.copy(center).sub(halfSize);
                this.max.copy(center).add(halfSize);
                return this;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        },
        {
            key: "copy",
            value: function copy(box) {
                this.min.copy(box.min);
                this.max.copy(box.max);
                return this;
            }
        },
        {
            key: "makeEmpty",
            value: function makeEmpty() {
                this.min.x = this.min.y = Infinity;
                this.max.x = this.max.y = -Infinity;
                return this;
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
                return this.max.x < this.min.x || this.max.y < this.min.y;
            }
        },
        {
            key: "getCenter",
            value: function getCenter(target) {
                return this.isEmpty() ? target.set(0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
            }
        },
        {
            key: "getSize",
            value: function getSize(target) {
                return this.isEmpty() ? target.set(0, 0) : target.subVectors(this.max, this.min);
            }
        },
        {
            key: "expandByPoint",
            value: function expandByPoint(point) {
                this.min.min(point);
                this.max.max(point);
                return this;
            }
        },
        {
            key: "expandByVector",
            value: function expandByVector(vector) {
                this.min.sub(vector);
                this.max.add(vector);
                return this;
            }
        },
        {
            key: "expandByScalar",
            value: function expandByScalar(scalar) {
                this.min.addScalar(-scalar);
                this.max.addScalar(scalar);
                return this;
            }
        },
        {
            key: "containsPoint",
            value: function containsPoint(point) {
                return point.x >= this.min.x && point.x <= this.max.x && point.y >= this.min.y && point.y <= this.max.y;
            }
        },
        {
            key: "containsBox",
            value: function containsBox(box) {
                return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y;
            }
        },
        {
            key: "getParameter",
            value: function getParameter(point, target) {
                // This can potentially have a divide by zero if the box
                // has a size dimension of 0.
                return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y));
            }
        },
        {
            key: "intersectsBox",
            value: function intersectsBox(box) {
                // using 4 splitting planes to rule out intersections
                return box.max.x >= this.min.x && box.min.x <= this.max.x && box.max.y >= this.min.y && box.min.y <= this.max.y;
            }
        },
        {
            key: "clampPoint",
            value: function clampPoint(point, target) {
                return target.copy(point).clamp(this.min, this.max);
            }
        },
        {
            key: "distanceToPoint",
            value: function distanceToPoint(point) {
                return this.clampPoint(point, $1a55656020b89c3a$var$_vector$4).distanceTo(point);
            }
        },
        {
            key: "intersect",
            value: function intersect(box) {
                this.min.max(box.min);
                this.max.min(box.max);
                if (this.isEmpty()) this.makeEmpty();
                return this;
            }
        },
        {
            key: "union",
            value: function union(box) {
                this.min.min(box.min);
                this.max.max(box.max);
                return this;
            }
        },
        {
            key: "translate",
            value: function translate(offset) {
                this.min.add(offset);
                this.max.add(offset);
                return this;
            }
        },
        {
            key: "equals",
            value: function equals(box) {
                return box.min.equals(this.min) && box.max.equals(this.max);
            }
        }
    ]);
    return Box2;
}();
var $1a55656020b89c3a$var$_startP = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_startEnd = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$export$e0ba6359f1954fd3 = /*#__PURE__*/ function() {
    "use strict";
    function Line3() {
        var start = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $1a55656020b89c3a$export$64b5c384219d3699(), end = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $1a55656020b89c3a$export$64b5c384219d3699();
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Line3);
        this.start = start;
        this.end = end;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Line3, [
        {
            key: "set",
            value: function set(start, end) {
                this.start.copy(start);
                this.end.copy(end);
                return this;
            }
        },
        {
            key: "copy",
            value: function copy(line) {
                this.start.copy(line.start);
                this.end.copy(line.end);
                return this;
            }
        },
        {
            key: "getCenter",
            value: function getCenter(target) {
                return target.addVectors(this.start, this.end).multiplyScalar(0.5);
            }
        },
        {
            key: "delta",
            value: function delta(target) {
                return target.subVectors(this.end, this.start);
            }
        },
        {
            key: "distanceSq",
            value: function distanceSq() {
                return this.start.distanceToSquared(this.end);
            }
        },
        {
            key: "distance",
            value: function distance() {
                return this.start.distanceTo(this.end);
            }
        },
        {
            key: "at",
            value: function at(t, target) {
                return this.delta(target).multiplyScalar(t).add(this.start);
            }
        },
        {
            key: "closestPointToPointParameter",
            value: function closestPointToPointParameter(point, clampToLine) {
                $1a55656020b89c3a$var$_startP.subVectors(point, this.start);
                $1a55656020b89c3a$var$_startEnd.subVectors(this.end, this.start);
                var startEnd2 = $1a55656020b89c3a$var$_startEnd.dot($1a55656020b89c3a$var$_startEnd);
                var startEnd_startP = $1a55656020b89c3a$var$_startEnd.dot($1a55656020b89c3a$var$_startP);
                var t = startEnd_startP / startEnd2;
                if (clampToLine) t = $1a55656020b89c3a$var$clamp(t, 0, 1);
                return t;
            }
        },
        {
            key: "closestPointToPoint",
            value: function closestPointToPoint(point, clampToLine, target) {
                var t = this.closestPointToPointParameter(point, clampToLine);
                return this.delta(target).multiplyScalar(t).add(this.start);
            }
        },
        {
            key: "applyMatrix4",
            value: function applyMatrix4(matrix) {
                this.start.applyMatrix4(matrix);
                this.end.applyMatrix4(matrix);
                return this;
            }
        },
        {
            key: "equals",
            value: function equals(line) {
                return line.start.equals(this.start) && line.end.equals(this.end);
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        }
    ]);
    return Line3;
}();
var $1a55656020b89c3a$var$_vector$3 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$export$4b14638ffdd81e68 = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(SpotLightHelper, Object3D);
    function SpotLightHelper(light, color) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, SpotLightHelper);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, SpotLightHelper);
        _this.light = light;
        _this.matrixAutoUpdate = false;
        _this.color = color;
        _this.type = 'SpotLightHelper';
        var geometry = new $1a55656020b89c3a$export$b7be63a67df8959();
        var positions = [
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            -1,
            1
        ];
        for(var i = 0, j = 1, l = 32; i < l; i++, j++){
            var p1 = i / l * Math.PI * 2;
            var p2 = j / l * Math.PI * 2;
            positions.push(Math.cos(p1), Math.sin(p1), 1, Math.cos(p2), Math.sin(p2), 1);
        }
        geometry.setAttribute('position', new $1a55656020b89c3a$export$cbe7a62641830ebd(positions, 3));
        var material = new $1a55656020b89c3a$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        _this.cone = new $1a55656020b89c3a$export$ff1ed10fedfdd604(geometry, material);
        _this.add(_this.cone);
        _this.update();
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(SpotLightHelper, [
        {
            key: "dispose",
            value: function dispose() {
                this.cone.geometry.dispose();
                this.cone.material.dispose();
            }
        },
        {
            key: "update",
            value: function update() {
                this.light.updateWorldMatrix(true, false);
                this.light.target.updateWorldMatrix(true, false);
                // update the local matrix based on the parent and light target transforms
                if (this.parent) {
                    this.parent.updateWorldMatrix(true);
                    this.matrix.copy(this.parent.matrixWorld).invert().multiply(this.light.matrixWorld);
                } else this.matrix.copy(this.light.matrixWorld);
                this.matrixWorld.copy(this.light.matrixWorld);
                var coneLength = this.light.distance ? this.light.distance : 1000;
                var coneWidth = coneLength * Math.tan(this.light.angle);
                this.cone.scale.set(coneWidth, coneWidth, coneLength);
                $1a55656020b89c3a$var$_vector$3.setFromMatrixPosition(this.light.target.matrixWorld);
                this.cone.lookAt($1a55656020b89c3a$var$_vector$3);
                if (this.color !== undefined) this.cone.material.color.set(this.color);
                else this.cone.material.color.copy(this.light.color);
            }
        }
    ]);
    return SpotLightHelper;
}($1a55656020b89c3a$export$e4dd07dff30cc924);
var $1a55656020b89c3a$var$_vector$2 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_boneMatrix = /*@__PURE__*/ new $1a55656020b89c3a$export$2ae72fc923e5eb5();
var $1a55656020b89c3a$var$_matrixWorldInv = /*@__PURE__*/ new $1a55656020b89c3a$export$2ae72fc923e5eb5();
var $1a55656020b89c3a$export$5277df3c9e732259 = /*#__PURE__*/ function(LineSegments) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(SkeletonHelper, LineSegments);
    function SkeletonHelper(object) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, SkeletonHelper);
        var _this;
        var bones = $1a55656020b89c3a$var$getBoneList(object);
        var geometry = new $1a55656020b89c3a$export$b7be63a67df8959();
        var vertices = [];
        var colors = [];
        var color1 = new $1a55656020b89c3a$export$892596cec99bc70e(0, 0, 1);
        var color2 = new $1a55656020b89c3a$export$892596cec99bc70e(0, 1, 0);
        for(var i = 0; i < bones.length; i++){
            var bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                vertices.push(0, 0, 0);
                vertices.push(0, 0, 0);
                colors.push(color1.r, color1.g, color1.b);
                colors.push(color2.r, color2.g, color2.b);
            }
        }
        geometry.setAttribute('position', new $1a55656020b89c3a$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $1a55656020b89c3a$export$cbe7a62641830ebd(colors, 3));
        var material = new $1a55656020b89c3a$export$fbaaa33907730a0c({
            vertexColors: true,
            depthTest: false,
            depthWrite: false,
            toneMapped: false,
            transparent: true
        });
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, SkeletonHelper, [
            geometry,
            material
        ]);
        _this.isSkeletonHelper = true;
        _this.type = 'SkeletonHelper';
        _this.root = object;
        _this.bones = bones;
        _this.matrix = object.matrixWorld;
        _this.matrixAutoUpdate = false;
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(SkeletonHelper, [
        {
            key: "updateMatrixWorld",
            value: function updateMatrixWorld(force) {
                var bones = this.bones;
                var geometry = this.geometry;
                var position = geometry.getAttribute('position');
                $1a55656020b89c3a$var$_matrixWorldInv.copy(this.root.matrixWorld).invert();
                for(var i = 0, j = 0; i < bones.length; i++){
                    var bone = bones[i];
                    if (bone.parent && bone.parent.isBone) {
                        $1a55656020b89c3a$var$_boneMatrix.multiplyMatrices($1a55656020b89c3a$var$_matrixWorldInv, bone.matrixWorld);
                        $1a55656020b89c3a$var$_vector$2.setFromMatrixPosition($1a55656020b89c3a$var$_boneMatrix);
                        position.setXYZ(j, $1a55656020b89c3a$var$_vector$2.x, $1a55656020b89c3a$var$_vector$2.y, $1a55656020b89c3a$var$_vector$2.z);
                        $1a55656020b89c3a$var$_boneMatrix.multiplyMatrices($1a55656020b89c3a$var$_matrixWorldInv, bone.parent.matrixWorld);
                        $1a55656020b89c3a$var$_vector$2.setFromMatrixPosition($1a55656020b89c3a$var$_boneMatrix);
                        position.setXYZ(j + 1, $1a55656020b89c3a$var$_vector$2.x, $1a55656020b89c3a$var$_vector$2.y, $1a55656020b89c3a$var$_vector$2.z);
                        j += 2;
                    }
                }
                geometry.getAttribute('position').needsUpdate = true;
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(SkeletonHelper.prototype), "updateMatrixWorld", this).call(this, force);
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this.geometry.dispose();
                this.material.dispose();
            }
        }
    ]);
    return SkeletonHelper;
}($1a55656020b89c3a$export$ff1ed10fedfdd604);
function $1a55656020b89c3a$var$getBoneList(object) {
    var boneList = [];
    if (object.isBone === true) boneList.push(object);
    for(var i = 0; i < object.children.length; i++)boneList.push.apply(boneList, $1a55656020b89c3a$var$getBoneList(object.children[i]));
    return boneList;
}
var $1a55656020b89c3a$export$9a9291685b9e4023 = /*#__PURE__*/ function(Mesh) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(PointLightHelper, Mesh);
    function PointLightHelper(light, sphereSize, color) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, PointLightHelper);
        var _this;
        var geometry = new $1a55656020b89c3a$export$1b417fc3b307a251(sphereSize, 4, 2);
        var material = new $1a55656020b89c3a$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, PointLightHelper, [
            geometry,
            material
        ]);
        _this.light = light;
        _this.color = color;
        _this.type = 'PointLightHelper';
        _this.matrix = _this.light.matrixWorld;
        _this.matrixAutoUpdate = false;
        _this.update();
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(PointLightHelper, [
        {
            key: "dispose",
            value: function dispose() {
                this.geometry.dispose();
                this.material.dispose();
            }
        },
        {
            key: "update",
            value: function update() {
                this.light.updateWorldMatrix(true, false);
                if (this.color !== undefined) this.material.color.set(this.color);
                else this.material.color.copy(this.light.color);
            /*
		const d = this.light.distance;

		if ( d === 0.0 ) {

			this.lightDistance.visible = false;

		} else {

			this.lightDistance.visible = true;
			this.lightDistance.scale.set( d, d, d );

		}
		*/ }
        }
    ]);
    return PointLightHelper;
}($1a55656020b89c3a$export$e176487c05830cc5);
var $1a55656020b89c3a$var$_vector$1 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_color1 = /*@__PURE__*/ new $1a55656020b89c3a$export$892596cec99bc70e();
var $1a55656020b89c3a$var$_color2 = /*@__PURE__*/ new $1a55656020b89c3a$export$892596cec99bc70e();
var $1a55656020b89c3a$export$8dca15f13f4f8172 = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(HemisphereLightHelper, Object3D);
    function HemisphereLightHelper(light, size, color) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, HemisphereLightHelper);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, HemisphereLightHelper);
        _this.light = light;
        _this.matrix = light.matrixWorld;
        _this.matrixAutoUpdate = false;
        _this.color = color;
        _this.type = 'HemisphereLightHelper';
        var geometry = new $1a55656020b89c3a$export$1954e2b809fe361e(size);
        geometry.rotateY(Math.PI * 0.5);
        _this.material = new $1a55656020b89c3a$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        if (_this.color === undefined) _this.material.vertexColors = true;
        var position = geometry.getAttribute('position');
        var colors = new Float32Array(position.count * 3);
        geometry.setAttribute('color', new $1a55656020b89c3a$export$8dea267bd6bde117(colors, 3));
        _this.add(new $1a55656020b89c3a$export$e176487c05830cc5(geometry, _this.material));
        _this.update();
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(HemisphereLightHelper, [
        {
            key: "dispose",
            value: function dispose() {
                this.children[0].geometry.dispose();
                this.children[0].material.dispose();
            }
        },
        {
            key: "update",
            value: function update() {
                var mesh = this.children[0];
                if (this.color !== undefined) this.material.color.set(this.color);
                else {
                    var colors = mesh.geometry.getAttribute('color');
                    $1a55656020b89c3a$var$_color1.copy(this.light.color);
                    $1a55656020b89c3a$var$_color2.copy(this.light.groundColor);
                    for(var i = 0, l = colors.count; i < l; i++){
                        var color = i < l / 2 ? $1a55656020b89c3a$var$_color1 : $1a55656020b89c3a$var$_color2;
                        colors.setXYZ(i, color.r, color.g, color.b);
                    }
                    colors.needsUpdate = true;
                }
                this.light.updateWorldMatrix(true, false);
                mesh.lookAt($1a55656020b89c3a$var$_vector$1.setFromMatrixPosition(this.light.matrixWorld).negate());
            }
        }
    ]);
    return HemisphereLightHelper;
}($1a55656020b89c3a$export$e4dd07dff30cc924);
var $1a55656020b89c3a$export$3875d39926561055 = /*#__PURE__*/ function(LineSegments) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(GridHelper, LineSegments);
    function GridHelper() {
        var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10, divisions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10, color1 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0x444444, color2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0x888888;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, GridHelper);
        var _this;
        color1 = new $1a55656020b89c3a$export$892596cec99bc70e(color1);
        color2 = new $1a55656020b89c3a$export$892596cec99bc70e(color2);
        var center = divisions / 2;
        var step = size / divisions;
        var halfSize = size / 2;
        var vertices = [], colors = [];
        for(var i = 0, j = 0, k = -halfSize; i <= divisions; i++, k += step){
            vertices.push(-halfSize, 0, k, halfSize, 0, k);
            vertices.push(k, 0, -halfSize, k, 0, halfSize);
            var color = i === center ? color1 : color2;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
        }
        var geometry = new $1a55656020b89c3a$export$b7be63a67df8959();
        geometry.setAttribute('position', new $1a55656020b89c3a$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $1a55656020b89c3a$export$cbe7a62641830ebd(colors, 3));
        var material = new $1a55656020b89c3a$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, GridHelper, [
            geometry,
            material
        ]);
        _this.type = 'GridHelper';
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(GridHelper, [
        {
            key: "dispose",
            value: function dispose() {
                this.geometry.dispose();
                this.material.dispose();
            }
        }
    ]);
    return GridHelper;
}($1a55656020b89c3a$export$ff1ed10fedfdd604);
var $1a55656020b89c3a$export$361430a10f533cd3 = /*#__PURE__*/ function(LineSegments) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(PolarGridHelper, LineSegments);
    function PolarGridHelper() {
        var radius = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10, sectors = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 16, rings = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 8, divisions = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 64, color1 = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0x444444, color2 = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0x888888;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, PolarGridHelper);
        var _this;
        color1 = new $1a55656020b89c3a$export$892596cec99bc70e(color1);
        color2 = new $1a55656020b89c3a$export$892596cec99bc70e(color2);
        var vertices = [];
        var colors = [];
        // create the sectors
        if (sectors > 1) for(var i = 0; i < sectors; i++){
            var v = i / sectors * (Math.PI * 2);
            var x = Math.sin(v) * radius;
            var z = Math.cos(v) * radius;
            vertices.push(0, 0, 0);
            vertices.push(x, 0, z);
            var color = i & 1 ? color1 : color2;
            colors.push(color.r, color.g, color.b);
            colors.push(color.r, color.g, color.b);
        }
        // create the rings
        for(var i1 = 0; i1 < rings; i1++){
            var color3 = i1 & 1 ? color1 : color2;
            var r = radius - radius / rings * i1;
            for(var j = 0; j < divisions; j++){
                // first vertex
                var v1 = j / divisions * (Math.PI * 2);
                var x1 = Math.sin(v1) * r;
                var z1 = Math.cos(v1) * r;
                vertices.push(x1, 0, z1);
                colors.push(color3.r, color3.g, color3.b);
                // second vertex
                v1 = (j + 1) / divisions * (Math.PI * 2);
                x1 = Math.sin(v1) * r;
                z1 = Math.cos(v1) * r;
                vertices.push(x1, 0, z1);
                colors.push(color3.r, color3.g, color3.b);
            }
        }
        var geometry = new $1a55656020b89c3a$export$b7be63a67df8959();
        geometry.setAttribute('position', new $1a55656020b89c3a$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $1a55656020b89c3a$export$cbe7a62641830ebd(colors, 3));
        var material = new $1a55656020b89c3a$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, PolarGridHelper, [
            geometry,
            material
        ]);
        _this.type = 'PolarGridHelper';
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(PolarGridHelper, [
        {
            key: "dispose",
            value: function dispose() {
                this.geometry.dispose();
                this.material.dispose();
            }
        }
    ]);
    return PolarGridHelper;
}($1a55656020b89c3a$export$ff1ed10fedfdd604);
var $1a55656020b89c3a$var$_v1 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_v2 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_v3 = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$export$f8e434dc14203e7d = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(DirectionalLightHelper, Object3D);
    function DirectionalLightHelper(light, size, color) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, DirectionalLightHelper);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, DirectionalLightHelper);
        _this.light = light;
        _this.matrix = light.matrixWorld;
        _this.matrixAutoUpdate = false;
        _this.color = color;
        _this.type = 'DirectionalLightHelper';
        if (size === undefined) size = 1;
        var geometry = new $1a55656020b89c3a$export$b7be63a67df8959();
        geometry.setAttribute('position', new $1a55656020b89c3a$export$cbe7a62641830ebd([
            -size,
            size,
            0,
            size,
            size,
            0,
            size,
            -size,
            0,
            -size,
            -size,
            0,
            -size,
            size,
            0
        ], 3));
        var material = new $1a55656020b89c3a$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        _this.lightPlane = new $1a55656020b89c3a$export$17d680238e50603e(geometry, material);
        _this.add(_this.lightPlane);
        geometry = new $1a55656020b89c3a$export$b7be63a67df8959();
        geometry.setAttribute('position', new $1a55656020b89c3a$export$cbe7a62641830ebd([
            0,
            0,
            0,
            0,
            0,
            1
        ], 3));
        _this.targetLine = new $1a55656020b89c3a$export$17d680238e50603e(geometry, material);
        _this.add(_this.targetLine);
        _this.update();
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(DirectionalLightHelper, [
        {
            key: "dispose",
            value: function dispose() {
                this.lightPlane.geometry.dispose();
                this.lightPlane.material.dispose();
                this.targetLine.geometry.dispose();
                this.targetLine.material.dispose();
            }
        },
        {
            key: "update",
            value: function update() {
                this.light.updateWorldMatrix(true, false);
                this.light.target.updateWorldMatrix(true, false);
                $1a55656020b89c3a$var$_v1.setFromMatrixPosition(this.light.matrixWorld);
                $1a55656020b89c3a$var$_v2.setFromMatrixPosition(this.light.target.matrixWorld);
                $1a55656020b89c3a$var$_v3.subVectors($1a55656020b89c3a$var$_v2, $1a55656020b89c3a$var$_v1);
                this.lightPlane.lookAt($1a55656020b89c3a$var$_v2);
                if (this.color !== undefined) {
                    this.lightPlane.material.color.set(this.color);
                    this.targetLine.material.color.set(this.color);
                } else {
                    this.lightPlane.material.color.copy(this.light.color);
                    this.targetLine.material.color.copy(this.light.color);
                }
                this.targetLine.lookAt($1a55656020b89c3a$var$_v2);
                this.targetLine.scale.z = $1a55656020b89c3a$var$_v3.length();
            }
        }
    ]);
    return DirectionalLightHelper;
}($1a55656020b89c3a$export$e4dd07dff30cc924);
var $1a55656020b89c3a$var$_vector = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_camera = /*@__PURE__*/ new $1a55656020b89c3a$export$79f141de891a5fed();
/**
 *	- shows frustum, line of sight and up of the camera
 *	- suitable for fast updates
 * 	- based on frustum visualization in lightgl.js shadowmap example
 *		https://github.com/evanw/lightgl.js/blob/master/tests/shadowmap.html
 */ var $1a55656020b89c3a$export$ed8e93f853cd795 = /*#__PURE__*/ function(LineSegments) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(CameraHelper, LineSegments);
    function CameraHelper(camera) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, CameraHelper);
        var _this;
        var geometry = new $1a55656020b89c3a$export$b7be63a67df8959();
        var material = new $1a55656020b89c3a$export$fbaaa33907730a0c({
            color: 0xffffff,
            vertexColors: true,
            toneMapped: false
        });
        var vertices = [];
        var colors = [];
        var pointMap = {};
        // near
        addLine('n1', 'n2');
        addLine('n2', 'n4');
        addLine('n4', 'n3');
        addLine('n3', 'n1');
        // far
        addLine('f1', 'f2');
        addLine('f2', 'f4');
        addLine('f4', 'f3');
        addLine('f3', 'f1');
        // sides
        addLine('n1', 'f1');
        addLine('n2', 'f2');
        addLine('n3', 'f3');
        addLine('n4', 'f4');
        // cone
        addLine('p', 'n1');
        addLine('p', 'n2');
        addLine('p', 'n3');
        addLine('p', 'n4');
        // up
        addLine('u1', 'u2');
        addLine('u2', 'u3');
        addLine('u3', 'u1');
        // target
        addLine('c', 't');
        addLine('p', 'c');
        // cross
        addLine('cn1', 'cn2');
        addLine('cn3', 'cn4');
        addLine('cf1', 'cf2');
        addLine('cf3', 'cf4');
        function addLine(a, b) {
            addPoint(a);
            addPoint(b);
        }
        function addPoint(id) {
            vertices.push(0, 0, 0);
            colors.push(0, 0, 0);
            if (pointMap[id] === undefined) pointMap[id] = [];
            pointMap[id].push(vertices.length / 3 - 1);
        }
        geometry.setAttribute('position', new $1a55656020b89c3a$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $1a55656020b89c3a$export$cbe7a62641830ebd(colors, 3));
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, CameraHelper, [
            geometry,
            material
        ]);
        _this.type = 'CameraHelper';
        _this.camera = camera;
        if (_this.camera.updateProjectionMatrix) _this.camera.updateProjectionMatrix();
        _this.matrix = camera.matrixWorld;
        _this.matrixAutoUpdate = false;
        _this.pointMap = pointMap;
        _this.update();
        // colors
        var colorFrustum = new $1a55656020b89c3a$export$892596cec99bc70e(0xffaa00);
        var colorCone = new $1a55656020b89c3a$export$892596cec99bc70e(0xff0000);
        var colorUp = new $1a55656020b89c3a$export$892596cec99bc70e(0x00aaff);
        var colorTarget = new $1a55656020b89c3a$export$892596cec99bc70e(0xffffff);
        var colorCross = new $1a55656020b89c3a$export$892596cec99bc70e(0x333333);
        _this.setColors(colorFrustum, colorCone, colorUp, colorTarget, colorCross);
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(CameraHelper, [
        {
            key: "setColors",
            value: function setColors(frustum, cone, up, target, cross) {
                var geometry = this.geometry;
                var colorAttribute = geometry.getAttribute('color');
                // near
                colorAttribute.setXYZ(0, frustum.r, frustum.g, frustum.b);
                colorAttribute.setXYZ(1, frustum.r, frustum.g, frustum.b); // n1, n2
                colorAttribute.setXYZ(2, frustum.r, frustum.g, frustum.b);
                colorAttribute.setXYZ(3, frustum.r, frustum.g, frustum.b); // n2, n4
                colorAttribute.setXYZ(4, frustum.r, frustum.g, frustum.b);
                colorAttribute.setXYZ(5, frustum.r, frustum.g, frustum.b); // n4, n3
                colorAttribute.setXYZ(6, frustum.r, frustum.g, frustum.b);
                colorAttribute.setXYZ(7, frustum.r, frustum.g, frustum.b); // n3, n1
                // far
                colorAttribute.setXYZ(8, frustum.r, frustum.g, frustum.b);
                colorAttribute.setXYZ(9, frustum.r, frustum.g, frustum.b); // f1, f2
                colorAttribute.setXYZ(10, frustum.r, frustum.g, frustum.b);
                colorAttribute.setXYZ(11, frustum.r, frustum.g, frustum.b); // f2, f4
                colorAttribute.setXYZ(12, frustum.r, frustum.g, frustum.b);
                colorAttribute.setXYZ(13, frustum.r, frustum.g, frustum.b); // f4, f3
                colorAttribute.setXYZ(14, frustum.r, frustum.g, frustum.b);
                colorAttribute.setXYZ(15, frustum.r, frustum.g, frustum.b); // f3, f1
                // sides
                colorAttribute.setXYZ(16, frustum.r, frustum.g, frustum.b);
                colorAttribute.setXYZ(17, frustum.r, frustum.g, frustum.b); // n1, f1
                colorAttribute.setXYZ(18, frustum.r, frustum.g, frustum.b);
                colorAttribute.setXYZ(19, frustum.r, frustum.g, frustum.b); // n2, f2
                colorAttribute.setXYZ(20, frustum.r, frustum.g, frustum.b);
                colorAttribute.setXYZ(21, frustum.r, frustum.g, frustum.b); // n3, f3
                colorAttribute.setXYZ(22, frustum.r, frustum.g, frustum.b);
                colorAttribute.setXYZ(23, frustum.r, frustum.g, frustum.b); // n4, f4
                // cone
                colorAttribute.setXYZ(24, cone.r, cone.g, cone.b);
                colorAttribute.setXYZ(25, cone.r, cone.g, cone.b); // p, n1
                colorAttribute.setXYZ(26, cone.r, cone.g, cone.b);
                colorAttribute.setXYZ(27, cone.r, cone.g, cone.b); // p, n2
                colorAttribute.setXYZ(28, cone.r, cone.g, cone.b);
                colorAttribute.setXYZ(29, cone.r, cone.g, cone.b); // p, n3
                colorAttribute.setXYZ(30, cone.r, cone.g, cone.b);
                colorAttribute.setXYZ(31, cone.r, cone.g, cone.b); // p, n4
                // up
                colorAttribute.setXYZ(32, up.r, up.g, up.b);
                colorAttribute.setXYZ(33, up.r, up.g, up.b); // u1, u2
                colorAttribute.setXYZ(34, up.r, up.g, up.b);
                colorAttribute.setXYZ(35, up.r, up.g, up.b); // u2, u3
                colorAttribute.setXYZ(36, up.r, up.g, up.b);
                colorAttribute.setXYZ(37, up.r, up.g, up.b); // u3, u1
                // target
                colorAttribute.setXYZ(38, target.r, target.g, target.b);
                colorAttribute.setXYZ(39, target.r, target.g, target.b); // c, t
                colorAttribute.setXYZ(40, cross.r, cross.g, cross.b);
                colorAttribute.setXYZ(41, cross.r, cross.g, cross.b); // p, c
                // cross
                colorAttribute.setXYZ(42, cross.r, cross.g, cross.b);
                colorAttribute.setXYZ(43, cross.r, cross.g, cross.b); // cn1, cn2
                colorAttribute.setXYZ(44, cross.r, cross.g, cross.b);
                colorAttribute.setXYZ(45, cross.r, cross.g, cross.b); // cn3, cn4
                colorAttribute.setXYZ(46, cross.r, cross.g, cross.b);
                colorAttribute.setXYZ(47, cross.r, cross.g, cross.b); // cf1, cf2
                colorAttribute.setXYZ(48, cross.r, cross.g, cross.b);
                colorAttribute.setXYZ(49, cross.r, cross.g, cross.b); // cf3, cf4
                colorAttribute.needsUpdate = true;
            }
        },
        {
            key: "update",
            value: function update() {
                var geometry = this.geometry;
                var pointMap = this.pointMap;
                var w = 1, h = 1;
                // we need just camera projection matrix inverse
                // world matrix must be identity
                $1a55656020b89c3a$var$_camera.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse);
                // Adjust z values based on coordinate system
                var nearZ = this.camera.coordinateSystem === $1a55656020b89c3a$export$5a0e9190d10875d3 ? -1 : 0;
                // center / target
                $1a55656020b89c3a$var$setPoint('c', pointMap, geometry, $1a55656020b89c3a$var$_camera, 0, 0, nearZ);
                $1a55656020b89c3a$var$setPoint('t', pointMap, geometry, $1a55656020b89c3a$var$_camera, 0, 0, 1);
                // near
                $1a55656020b89c3a$var$setPoint('n1', pointMap, geometry, $1a55656020b89c3a$var$_camera, -w, -h, nearZ);
                $1a55656020b89c3a$var$setPoint('n2', pointMap, geometry, $1a55656020b89c3a$var$_camera, w, -h, nearZ);
                $1a55656020b89c3a$var$setPoint('n3', pointMap, geometry, $1a55656020b89c3a$var$_camera, -w, h, nearZ);
                $1a55656020b89c3a$var$setPoint('n4', pointMap, geometry, $1a55656020b89c3a$var$_camera, w, h, nearZ);
                // far
                $1a55656020b89c3a$var$setPoint('f1', pointMap, geometry, $1a55656020b89c3a$var$_camera, -w, -h, 1);
                $1a55656020b89c3a$var$setPoint('f2', pointMap, geometry, $1a55656020b89c3a$var$_camera, w, -h, 1);
                $1a55656020b89c3a$var$setPoint('f3', pointMap, geometry, $1a55656020b89c3a$var$_camera, -w, h, 1);
                $1a55656020b89c3a$var$setPoint('f4', pointMap, geometry, $1a55656020b89c3a$var$_camera, w, h, 1);
                // up
                $1a55656020b89c3a$var$setPoint('u1', pointMap, geometry, $1a55656020b89c3a$var$_camera, w * 0.7, h * 1.1, nearZ);
                $1a55656020b89c3a$var$setPoint('u2', pointMap, geometry, $1a55656020b89c3a$var$_camera, -w * 0.7, h * 1.1, nearZ);
                $1a55656020b89c3a$var$setPoint('u3', pointMap, geometry, $1a55656020b89c3a$var$_camera, 0, h * 2, nearZ);
                // cross
                $1a55656020b89c3a$var$setPoint('cf1', pointMap, geometry, $1a55656020b89c3a$var$_camera, -w, 0, 1);
                $1a55656020b89c3a$var$setPoint('cf2', pointMap, geometry, $1a55656020b89c3a$var$_camera, w, 0, 1);
                $1a55656020b89c3a$var$setPoint('cf3', pointMap, geometry, $1a55656020b89c3a$var$_camera, 0, -h, 1);
                $1a55656020b89c3a$var$setPoint('cf4', pointMap, geometry, $1a55656020b89c3a$var$_camera, 0, h, 1);
                $1a55656020b89c3a$var$setPoint('cn1', pointMap, geometry, $1a55656020b89c3a$var$_camera, -w, 0, nearZ);
                $1a55656020b89c3a$var$setPoint('cn2', pointMap, geometry, $1a55656020b89c3a$var$_camera, w, 0, nearZ);
                $1a55656020b89c3a$var$setPoint('cn3', pointMap, geometry, $1a55656020b89c3a$var$_camera, 0, -h, nearZ);
                $1a55656020b89c3a$var$setPoint('cn4', pointMap, geometry, $1a55656020b89c3a$var$_camera, 0, h, nearZ);
                geometry.getAttribute('position').needsUpdate = true;
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this.geometry.dispose();
                this.material.dispose();
            }
        }
    ]);
    return CameraHelper;
}($1a55656020b89c3a$export$ff1ed10fedfdd604);
function $1a55656020b89c3a$var$setPoint(point, pointMap, geometry, camera, x, y, z) {
    $1a55656020b89c3a$var$_vector.set(x, y, z).unproject(camera);
    var points = pointMap[point];
    if (points !== undefined) {
        var position = geometry.getAttribute('position');
        for(var i = 0, l = points.length; i < l; i++)position.setXYZ(points[i], $1a55656020b89c3a$var$_vector.x, $1a55656020b89c3a$var$_vector.y, $1a55656020b89c3a$var$_vector.z);
    }
}
var $1a55656020b89c3a$var$_box = /*@__PURE__*/ new $1a55656020b89c3a$export$6f7d5a9418ab2aa3();
var $1a55656020b89c3a$export$38a664cc862a6a9d = /*#__PURE__*/ function(LineSegments) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(BoxHelper, LineSegments);
    function BoxHelper(object) {
        var color = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0xffff00;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, BoxHelper);
        var _this;
        var indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        var positions = new Float32Array(24);
        var geometry = new $1a55656020b89c3a$export$b7be63a67df8959();
        geometry.setIndex(new $1a55656020b89c3a$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute('position', new $1a55656020b89c3a$export$8dea267bd6bde117(positions, 3));
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, BoxHelper, [
            geometry,
            new $1a55656020b89c3a$export$fbaaa33907730a0c({
                color: color,
                toneMapped: false
            })
        ]);
        _this.object = object;
        _this.type = 'BoxHelper';
        _this.matrixAutoUpdate = false;
        _this.update();
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(BoxHelper, [
        {
            key: "update",
            value: function update(object) {
                if (object !== undefined) console.warn('THREE.BoxHelper: .update() has no longer arguments.');
                if (this.object !== undefined) $1a55656020b89c3a$var$_box.setFromObject(this.object);
                if ($1a55656020b89c3a$var$_box.isEmpty()) return;
                var min = $1a55656020b89c3a$var$_box.min;
                var max = $1a55656020b89c3a$var$_box.max;
                /*
			5____4
		1/___0/|
		| 6__|_7
		2/___3/

		0: max.x, max.y, max.z
		1: min.x, max.y, max.z
		2: min.x, min.y, max.z
		3: max.x, min.y, max.z
		4: max.x, max.y, min.z
		5: min.x, max.y, min.z
		6: min.x, min.y, min.z
		7: max.x, min.y, min.z
		*/ var position = this.geometry.attributes.position;
                var array = position.array;
                array[0] = max.x;
                array[1] = max.y;
                array[2] = max.z;
                array[3] = min.x;
                array[4] = max.y;
                array[5] = max.z;
                array[6] = min.x;
                array[7] = min.y;
                array[8] = max.z;
                array[9] = max.x;
                array[10] = min.y;
                array[11] = max.z;
                array[12] = max.x;
                array[13] = max.y;
                array[14] = min.z;
                array[15] = min.x;
                array[16] = max.y;
                array[17] = min.z;
                array[18] = min.x;
                array[19] = min.y;
                array[20] = min.z;
                array[21] = max.x;
                array[22] = min.y;
                array[23] = min.z;
                position.needsUpdate = true;
                this.geometry.computeBoundingSphere();
            }
        },
        {
            key: "setFromObject",
            value: function setFromObject(object) {
                this.object = object;
                this.update();
                return this;
            }
        },
        {
            key: "copy",
            value: function copy(source, recursive) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(BoxHelper.prototype), "copy", this).call(this, source, recursive);
                this.object = source.object;
                return this;
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this.geometry.dispose();
                this.material.dispose();
            }
        }
    ]);
    return BoxHelper;
}($1a55656020b89c3a$export$ff1ed10fedfdd604);
var $1a55656020b89c3a$export$ce39f4bb96c9a290 = /*#__PURE__*/ function(LineSegments) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(Box3Helper, LineSegments);
    function Box3Helper(box) {
        var color = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0xffff00;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Box3Helper);
        var _this;
        var indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        var positions = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1
        ];
        var geometry = new $1a55656020b89c3a$export$b7be63a67df8959();
        geometry.setIndex(new $1a55656020b89c3a$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute('position', new $1a55656020b89c3a$export$cbe7a62641830ebd(positions, 3));
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, Box3Helper, [
            geometry,
            new $1a55656020b89c3a$export$fbaaa33907730a0c({
                color: color,
                toneMapped: false
            })
        ]);
        _this.box = box;
        _this.type = 'Box3Helper';
        _this.geometry.computeBoundingSphere();
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Box3Helper, [
        {
            key: "updateMatrixWorld",
            value: function updateMatrixWorld(force) {
                var box = this.box;
                if (box.isEmpty()) return;
                box.getCenter(this.position);
                box.getSize(this.scale);
                this.scale.multiplyScalar(0.5);
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(Box3Helper.prototype), "updateMatrixWorld", this).call(this, force);
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this.geometry.dispose();
                this.material.dispose();
            }
        }
    ]);
    return Box3Helper;
}($1a55656020b89c3a$export$ff1ed10fedfdd604);
var $1a55656020b89c3a$export$a34fe8156c66e5d7 = /*#__PURE__*/ function(Line) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(PlaneHelper, Line);
    function PlaneHelper(plane) {
        var size = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, hex = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0xffff00;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, PlaneHelper);
        var _this;
        var color = hex;
        var positions = [
            1,
            -1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0,
            1,
            1,
            0
        ];
        var geometry = new $1a55656020b89c3a$export$b7be63a67df8959();
        geometry.setAttribute('position', new $1a55656020b89c3a$export$cbe7a62641830ebd(positions, 3));
        geometry.computeBoundingSphere();
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, PlaneHelper, [
            geometry,
            new $1a55656020b89c3a$export$fbaaa33907730a0c({
                color: color,
                toneMapped: false
            })
        ]);
        _this.type = 'PlaneHelper';
        _this.plane = plane;
        _this.size = size;
        var positions2 = [
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0
        ];
        var geometry2 = new $1a55656020b89c3a$export$b7be63a67df8959();
        geometry2.setAttribute('position', new $1a55656020b89c3a$export$cbe7a62641830ebd(positions2, 3));
        geometry2.computeBoundingSphere();
        _this.add(new $1a55656020b89c3a$export$e176487c05830cc5(geometry2, new $1a55656020b89c3a$export$55cbcc9b622fe1f5({
            color: color,
            opacity: 0.2,
            transparent: true,
            depthWrite: false,
            toneMapped: false
        })));
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(PlaneHelper, [
        {
            key: "updateMatrixWorld",
            value: function updateMatrixWorld(force) {
                this.position.set(0, 0, 0);
                this.scale.set(0.5 * this.size, 0.5 * this.size, 1);
                this.lookAt(this.plane.normal);
                this.translateZ(-this.plane.constant);
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(PlaneHelper.prototype), "updateMatrixWorld", this).call(this, force);
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this.geometry.dispose();
                this.material.dispose();
                this.children[0].geometry.dispose();
                this.children[0].material.dispose();
            }
        }
    ]);
    return PlaneHelper;
}($1a55656020b89c3a$export$17d680238e50603e);
var $1a55656020b89c3a$var$_axis = /*@__PURE__*/ new $1a55656020b89c3a$export$64b5c384219d3699();
var $1a55656020b89c3a$var$_lineGeometry, $1a55656020b89c3a$var$_coneGeometry;
var $1a55656020b89c3a$export$a3008e7bd8d2cbe7 = /*#__PURE__*/ function(Object3D) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(ArrowHelper, Object3D);
    function ArrowHelper() {
        var dir = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new $1a55656020b89c3a$export$64b5c384219d3699(0, 0, 1), origin = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new $1a55656020b89c3a$export$64b5c384219d3699(0, 0, 0), length = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, color = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0xffff00, headLength = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : length * 0.2, headWidth = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : headLength * 0.2;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, ArrowHelper);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, ArrowHelper);
        _this.type = 'ArrowHelper';
        if ($1a55656020b89c3a$var$_lineGeometry === undefined) {
            $1a55656020b89c3a$var$_lineGeometry = new $1a55656020b89c3a$export$b7be63a67df8959();
            $1a55656020b89c3a$var$_lineGeometry.setAttribute('position', new $1a55656020b89c3a$export$cbe7a62641830ebd([
                0,
                0,
                0,
                0,
                1,
                0
            ], 3));
            $1a55656020b89c3a$var$_coneGeometry = new $1a55656020b89c3a$export$68f745719dbe5198(0, 0.5, 1, 5, 1);
            $1a55656020b89c3a$var$_coneGeometry.translate(0, -0.5, 0);
        }
        _this.position.copy(origin);
        _this.line = new $1a55656020b89c3a$export$17d680238e50603e($1a55656020b89c3a$var$_lineGeometry, new $1a55656020b89c3a$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        _this.line.matrixAutoUpdate = false;
        _this.add(_this.line);
        _this.cone = new $1a55656020b89c3a$export$e176487c05830cc5($1a55656020b89c3a$var$_coneGeometry, new $1a55656020b89c3a$export$55cbcc9b622fe1f5({
            color: color,
            toneMapped: false
        }));
        _this.cone.matrixAutoUpdate = false;
        _this.add(_this.cone);
        _this.setDirection(dir);
        _this.setLength(length, headLength, headWidth);
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(ArrowHelper, [
        {
            key: "setDirection",
            value: function setDirection(dir) {
                // dir is assumed to be normalized
                if (dir.y > 0.99999) this.quaternion.set(0, 0, 0, 1);
                else if (dir.y < -0.99999) this.quaternion.set(1, 0, 0, 0);
                else {
                    $1a55656020b89c3a$var$_axis.set(dir.z, 0, -dir.x).normalize();
                    var radians = Math.acos(dir.y);
                    this.quaternion.setFromAxisAngle($1a55656020b89c3a$var$_axis, radians);
                }
            }
        },
        {
            key: "setLength",
            value: function setLength(length) {
                var headLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : length * 0.2, headWidth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : headLength * 0.2;
                this.line.scale.set(1, Math.max(0.0001, length - headLength), 1); // see #17458
                this.line.updateMatrix();
                this.cone.scale.set(headWidth, headLength, headWidth);
                this.cone.position.y = length;
                this.cone.updateMatrix();
            }
        },
        {
            key: "setColor",
            value: function setColor(color) {
                this.line.material.color.set(color);
                this.cone.material.color.set(color);
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(ArrowHelper.prototype), "copy", this).call(this, source, false);
                this.line.copy(source.line);
                this.cone.copy(source.cone);
                return this;
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this.line.geometry.dispose();
                this.line.material.dispose();
                this.cone.geometry.dispose();
                this.cone.material.dispose();
            }
        }
    ]);
    return ArrowHelper;
}($1a55656020b89c3a$export$e4dd07dff30cc924);
var $1a55656020b89c3a$export$6c8303f35b8578fd = /*#__PURE__*/ function(LineSegments) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(AxesHelper, LineSegments);
    function AxesHelper() {
        var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, AxesHelper);
        var _this;
        var vertices = [
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size
        ];
        var colors = [
            1,
            0,
            0,
            1,
            0.6,
            0,
            0,
            1,
            0,
            0.6,
            1,
            0,
            0,
            0,
            1,
            0,
            0.6,
            1
        ];
        var geometry = new $1a55656020b89c3a$export$b7be63a67df8959();
        geometry.setAttribute('position', new $1a55656020b89c3a$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $1a55656020b89c3a$export$cbe7a62641830ebd(colors, 3));
        var material = new $1a55656020b89c3a$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, AxesHelper, [
            geometry,
            material
        ]);
        _this.type = 'AxesHelper';
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(AxesHelper, [
        {
            key: "setColors",
            value: function setColors(xAxisColor, yAxisColor, zAxisColor) {
                var color = new $1a55656020b89c3a$export$892596cec99bc70e();
                var array = this.geometry.attributes.color.array;
                color.set(xAxisColor);
                color.toArray(array, 0);
                color.toArray(array, 3);
                color.set(yAxisColor);
                color.toArray(array, 6);
                color.toArray(array, 9);
                color.set(zAxisColor);
                color.toArray(array, 12);
                color.toArray(array, 15);
                this.geometry.attributes.color.needsUpdate = true;
                return this;
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this.geometry.dispose();
                this.material.dispose();
            }
        }
    ]);
    return AxesHelper;
}($1a55656020b89c3a$export$ff1ed10fedfdd604);
var $1a55656020b89c3a$export$148534a3c727230b = /*#__PURE__*/ function() {
    "use strict";
    function ShapePath() {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, ShapePath);
        this.type = 'ShapePath';
        this.color = new $1a55656020b89c3a$export$892596cec99bc70e();
        this.subPaths = [];
        this.currentPath = null;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(ShapePath, [
        {
            key: "moveTo",
            value: function moveTo(x, y) {
                this.currentPath = new $1a55656020b89c3a$export$4b2950bdac9b6ee9();
                this.subPaths.push(this.currentPath);
                this.currentPath.moveTo(x, y);
                return this;
            }
        },
        {
            key: "lineTo",
            value: function lineTo(x, y) {
                this.currentPath.lineTo(x, y);
                return this;
            }
        },
        {
            key: "quadraticCurveTo",
            value: function quadraticCurveTo(aCPx, aCPy, aX, aY) {
                this.currentPath.quadraticCurveTo(aCPx, aCPy, aX, aY);
                return this;
            }
        },
        {
            key: "bezierCurveTo",
            value: function bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
                this.currentPath.bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY);
                return this;
            }
        },
        {
            key: "splineThru",
            value: function splineThru(pts) {
                this.currentPath.splineThru(pts);
                return this;
            }
        },
        {
            key: "toShapes",
            value: function toShapes(isCCW) {
                function toShapesNoHoles(inSubpaths) {
                    var shapes = [];
                    for(var i = 0, l = inSubpaths.length; i < l; i++){
                        var tmpPath = inSubpaths[i];
                        var tmpShape = new $1a55656020b89c3a$export$6428a7f2611ef1fa();
                        tmpShape.curves = tmpPath.curves;
                        shapes.push(tmpShape);
                    }
                    return shapes;
                }
                function isPointInsidePolygon(inPt, inPolygon) {
                    var polyLen = inPolygon.length;
                    // inPt on polygon contour => immediate success    or
                    // toggling of inside/outside at every single! intersection point of an edge
                    //  with the horizontal line through inPt, left of inPt
                    //  not counting lowerY endpoints of edges and whole edges on that line
                    var inside = false;
                    for(var p = polyLen - 1, q = 0; q < polyLen; p = q++){
                        var edgeLowPt = inPolygon[p];
                        var edgeHighPt = inPolygon[q];
                        var edgeDx = edgeHighPt.x - edgeLowPt.x;
                        var edgeDy = edgeHighPt.y - edgeLowPt.y;
                        if (Math.abs(edgeDy) > Number.EPSILON) {
                            // not parallel
                            if (edgeDy < 0) {
                                edgeLowPt = inPolygon[q];
                                edgeDx = -edgeDx;
                                edgeHighPt = inPolygon[p];
                                edgeDy = -edgeDy;
                            }
                            if (inPt.y < edgeLowPt.y || inPt.y > edgeHighPt.y) continue;
                            if (inPt.y === edgeLowPt.y) {
                                if (inPt.x === edgeLowPt.x) return true; // inPt is on contour ?
                            // continue;				// no intersection or edgeLowPt => doesn't count !!!
                            } else {
                                var perpEdge = edgeDy * (inPt.x - edgeLowPt.x) - edgeDx * (inPt.y - edgeLowPt.y);
                                if (perpEdge === 0) return true; // inPt is on contour ?
                                if (perpEdge < 0) continue;
                                inside = !inside; // true intersection left of inPt
                            }
                        } else {
                            // parallel or collinear
                            if (inPt.y !== edgeLowPt.y) continue; // parallel
                            // edge lies on the same horizontal line as inPt
                            if (edgeHighPt.x <= inPt.x && inPt.x <= edgeLowPt.x || edgeLowPt.x <= inPt.x && inPt.x <= edgeHighPt.x) return true; // inPt: Point on contour !
                        // continue;
                        }
                    }
                    return inside;
                }
                var isClockWise = $1a55656020b89c3a$export$96bdf6d9c66d7ba8.isClockWise;
                var subPaths = this.subPaths;
                if (subPaths.length === 0) return [];
                var solid, tmpPath, tmpShape;
                var shapes = [];
                if (subPaths.length === 1) {
                    tmpPath = subPaths[0];
                    tmpShape = new $1a55656020b89c3a$export$6428a7f2611ef1fa();
                    tmpShape.curves = tmpPath.curves;
                    shapes.push(tmpShape);
                    return shapes;
                }
                var holesFirst = !isClockWise(subPaths[0].getPoints());
                holesFirst = isCCW ? !holesFirst : holesFirst;
                // console.log("Holes first", holesFirst);
                var betterShapeHoles = [];
                var newShapes = [];
                var newShapeHoles = [];
                var mainIdx = 0;
                var tmpPoints;
                newShapes[mainIdx] = undefined;
                newShapeHoles[mainIdx] = [];
                for(var i = 0, l = subPaths.length; i < l; i++){
                    tmpPath = subPaths[i];
                    tmpPoints = tmpPath.getPoints();
                    solid = isClockWise(tmpPoints);
                    solid = isCCW ? !solid : solid;
                    if (solid) {
                        if (!holesFirst && newShapes[mainIdx]) mainIdx++;
                        newShapes[mainIdx] = {
                            s: new $1a55656020b89c3a$export$6428a7f2611ef1fa(),
                            p: tmpPoints
                        };
                        newShapes[mainIdx].s.curves = tmpPath.curves;
                        if (holesFirst) mainIdx++;
                        newShapeHoles[mainIdx] = [];
                    //console.log('cw', i);
                    } else newShapeHoles[mainIdx].push({
                        h: tmpPath,
                        p: tmpPoints[0]
                    });
                }
                // only Holes? -> probably all Shapes with wrong orientation
                if (!newShapes[0]) return toShapesNoHoles(subPaths);
                if (newShapes.length > 1) {
                    var ambiguous = false;
                    var toChange = 0;
                    for(var sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++)betterShapeHoles[sIdx] = [];
                    for(var sIdx1 = 0, sLen1 = newShapes.length; sIdx1 < sLen1; sIdx1++){
                        var sho = newShapeHoles[sIdx1];
                        for(var hIdx = 0; hIdx < sho.length; hIdx++){
                            var ho = sho[hIdx];
                            var hole_unassigned = true;
                            for(var s2Idx = 0; s2Idx < newShapes.length; s2Idx++)if (isPointInsidePolygon(ho.p, newShapes[s2Idx].p)) {
                                if (sIdx1 !== s2Idx) toChange++;
                                if (hole_unassigned) {
                                    hole_unassigned = false;
                                    betterShapeHoles[s2Idx].push(ho);
                                } else ambiguous = true;
                            }
                            if (hole_unassigned) betterShapeHoles[sIdx1].push(ho);
                        }
                    }
                    if (toChange > 0 && ambiguous === false) newShapeHoles = betterShapeHoles;
                }
                var tmpHoles;
                for(var i1 = 0, il = newShapes.length; i1 < il; i1++){
                    tmpShape = newShapes[i1].s;
                    shapes.push(tmpShape);
                    tmpHoles = newShapeHoles[i1];
                    for(var j = 0, jl = tmpHoles.length; j < jl; j++)tmpShape.holes.push(tmpHoles[j].h);
                }
                //console.log("shape", shapes);
                return shapes;
            }
        }
    ]);
    return ShapePath;
}();
var $1a55656020b89c3a$export$c7c44baae9d9f25f = /*#__PURE__*/ function(EventDispatcher) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(Controls, EventDispatcher);
    function Controls(object) {
        var domElement = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Controls);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, Controls);
        _this.object = object;
        _this.domElement = domElement;
        _this.enabled = true;
        _this.state = -1;
        _this.keys = {};
        _this.mouseButtons = {
            LEFT: null,
            MIDDLE: null,
            RIGHT: null
        };
        _this.touches = {
            ONE: null,
            TWO: null
        };
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Controls, [
        {
            key: "connect",
            value: function connect() {}
        },
        {
            key: "disconnect",
            value: function disconnect() {}
        },
        {
            key: "dispose",
            value: function dispose() {}
        },
        {
            key: "update",
            value: function update() {}
        }
    ]);
    return Controls;
}($1a55656020b89c3a$export$ec8b666c5fe2c75a);
function $1a55656020b89c3a$var$contain(texture, aspect) {
    var imageAspect = texture.image && texture.image.width ? texture.image.width / texture.image.height : 1;
    if (imageAspect > aspect) {
        texture.repeat.x = 1;
        texture.repeat.y = imageAspect / aspect;
        texture.offset.x = 0;
        texture.offset.y = (1 - texture.repeat.y) / 2;
    } else {
        texture.repeat.x = aspect / imageAspect;
        texture.repeat.y = 1;
        texture.offset.x = (1 - texture.repeat.x) / 2;
        texture.offset.y = 0;
    }
    return texture;
}
function $1a55656020b89c3a$var$cover(texture, aspect) {
    var imageAspect = texture.image && texture.image.width ? texture.image.width / texture.image.height : 1;
    if (imageAspect > aspect) {
        texture.repeat.x = aspect / imageAspect;
        texture.repeat.y = 1;
        texture.offset.x = (1 - texture.repeat.x) / 2;
        texture.offset.y = 0;
    } else {
        texture.repeat.x = 1;
        texture.repeat.y = imageAspect / aspect;
        texture.offset.x = 0;
        texture.offset.y = (1 - texture.repeat.y) / 2;
    }
    return texture;
}
function $1a55656020b89c3a$var$fill(texture) {
    texture.repeat.x = 1;
    texture.repeat.y = 1;
    texture.offset.x = 0;
    texture.offset.y = 0;
    return texture;
}
/**
 * Given the width, height, format, and type of a texture. Determines how many
 * bytes must be used to represent the texture.
 *
 * @param {Number} width
 * @param {Number} height
 * @param {Number} format
 * @param {Number} type
 * @return {Number} The number of bytes required to represent the texture.
 */ function $1a55656020b89c3a$export$cc8c3b705bb8e6e2(width, height, format, type) {
    var typeByteLength = $1a55656020b89c3a$var$getTextureTypeByteLength(type);
    switch(format){
        // https://registry.khronos.org/OpenGL-Refpages/es3.0/html/glTexImage2D.xhtml
        case $1a55656020b89c3a$export$988473390501ed4b:
            return width * height;
        case $1a55656020b89c3a$export$cc09ccbf6d1ed449:
            return width * height;
        case $1a55656020b89c3a$export$9053a81c4a69c289:
            return width * height * 2;
        case $1a55656020b89c3a$export$4e041a7967d15c4b:
            return width * height / typeByteLength.components * typeByteLength.byteLength;
        case $1a55656020b89c3a$export$aa92e870a709d190:
            return width * height / typeByteLength.components * typeByteLength.byteLength;
        case $1a55656020b89c3a$export$6cdf0b461c7ce8a0:
            return width * height * 2 / typeByteLength.components * typeByteLength.byteLength;
        case $1a55656020b89c3a$export$1ba1c45f9f77d4d7:
            return width * height * 2 / typeByteLength.components * typeByteLength.byteLength;
        case $1a55656020b89c3a$export$7c67423a5ee6f5eb:
            return width * height * 3 / typeByteLength.components * typeByteLength.byteLength;
        case $1a55656020b89c3a$export$3f8bb04b555a363c:
            return width * height * 4 / typeByteLength.components * typeByteLength.byteLength;
        case $1a55656020b89c3a$export$c200e7d26f592f21:
            return width * height * 4 / typeByteLength.components * typeByteLength.byteLength;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_s3tc_srgb/
        case $1a55656020b89c3a$export$21d1799c6d552fc0:
        case $1a55656020b89c3a$export$afa304c3e981b668:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 8;
        case $1a55656020b89c3a$export$d2a1a68024a3e56c:
        case $1a55656020b89c3a$export$9a79c424327dacf9:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_pvrtc/
        case $1a55656020b89c3a$export$d0f0355bb3d948e4:
        case $1a55656020b89c3a$export$b71692456c47b6c3:
            return Math.max(width, 16) * Math.max(height, 8) / 4;
        case $1a55656020b89c3a$export$19ada9bbb1af3573:
        case $1a55656020b89c3a$export$b82296714358084c:
            return Math.max(width, 8) * Math.max(height, 8) / 2;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_etc/
        case $1a55656020b89c3a$export$6ab91af2d757aee7:
        case $1a55656020b89c3a$export$7800993ef8106a6a:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 8;
        case $1a55656020b89c3a$export$23ed8300a860e7d8:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_astc/
        case $1a55656020b89c3a$export$dc5570b4a2b92d48:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        case $1a55656020b89c3a$export$68880cd325f8b2fb:
            return Math.floor((width + 4) / 5) * Math.floor((height + 3) / 4) * 16;
        case $1a55656020b89c3a$export$7d2c0be323373d95:
            return Math.floor((width + 4) / 5) * Math.floor((height + 4) / 5) * 16;
        case $1a55656020b89c3a$export$22b52da301fc3a3e:
            return Math.floor((width + 5) / 6) * Math.floor((height + 4) / 5) * 16;
        case $1a55656020b89c3a$export$c009e2cb4a66485e:
            return Math.floor((width + 5) / 6) * Math.floor((height + 5) / 6) * 16;
        case $1a55656020b89c3a$export$118fff5afa255b63:
            return Math.floor((width + 7) / 8) * Math.floor((height + 4) / 5) * 16;
        case $1a55656020b89c3a$export$120713c829ae0667:
            return Math.floor((width + 7) / 8) * Math.floor((height + 5) / 6) * 16;
        case $1a55656020b89c3a$export$c79eeabbf53313e9:
            return Math.floor((width + 7) / 8) * Math.floor((height + 7) / 8) * 16;
        case $1a55656020b89c3a$export$443cf6567cdd6424:
            return Math.floor((width + 9) / 10) * Math.floor((height + 4) / 5) * 16;
        case $1a55656020b89c3a$export$6573984fc9840780:
            return Math.floor((width + 9) / 10) * Math.floor((height + 5) / 6) * 16;
        case $1a55656020b89c3a$export$e7aee563f30091de:
            return Math.floor((width + 9) / 10) * Math.floor((height + 7) / 8) * 16;
        case $1a55656020b89c3a$export$2eb8634622ddeab7:
            return Math.floor((width + 9) / 10) * Math.floor((height + 9) / 10) * 16;
        case $1a55656020b89c3a$export$202b1ce7b5d25742:
            return Math.floor((width + 11) / 12) * Math.floor((height + 9) / 10) * 16;
        case $1a55656020b89c3a$export$18ab77abd087e467:
            return Math.floor((width + 11) / 12) * Math.floor((height + 11) / 12) * 16;
        // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_bptc/
        case $1a55656020b89c3a$export$ce40b115e188bc81:
        case $1a55656020b89c3a$export$d279c5c4bac5121e:
        case $1a55656020b89c3a$export$cde52d17225fdbd3:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_rgtc/
        case $1a55656020b89c3a$export$b1688df4c4c21670:
        case $1a55656020b89c3a$export$fc15e5d8261eed58:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 8;
        case $1a55656020b89c3a$export$d220f6ade8463a0f:
        case $1a55656020b89c3a$export$768646d09dc1b6ef:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 16;
    }
    throw new Error("Unable to determine texture byte length for ".concat(format, " format."));
}
function $1a55656020b89c3a$var$getTextureTypeByteLength(type) {
    switch(type){
        case $1a55656020b89c3a$export$2e8ce08d3f6f5e10:
        case $1a55656020b89c3a$export$545fce0311a9796a:
            return {
                byteLength: 1,
                components: 1
            };
        case $1a55656020b89c3a$export$c63dc51868b06a9d:
        case $1a55656020b89c3a$export$88572337f312435f:
        case $1a55656020b89c3a$export$2697304443f382bc:
            return {
                byteLength: 2,
                components: 1
            };
        case $1a55656020b89c3a$export$b3969b01faf587f2:
        case $1a55656020b89c3a$export$18886f8ae33e90de:
            return {
                byteLength: 2,
                components: 4
            };
        case $1a55656020b89c3a$export$c3c7fc4518ebba96:
        case $1a55656020b89c3a$export$5c612977753abe2:
        case $1a55656020b89c3a$export$f6d331659b644596:
            return {
                byteLength: 4,
                components: 1
            };
        case $1a55656020b89c3a$export$5a4c329b7e2092d3:
            return {
                byteLength: 4,
                components: 3
            };
    }
    throw new Error("Unknown texture type ".concat(type, "."));
}
var $1a55656020b89c3a$export$ec276d39f33d4b7 = {
    contain: $1a55656020b89c3a$var$contain,
    cover: $1a55656020b89c3a$var$cover,
    fill: $1a55656020b89c3a$var$fill,
    getByteLength: $1a55656020b89c3a$export$cc8c3b705bb8e6e2
};
if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('register', {
    detail: {
        revision: $1a55656020b89c3a$export$3545e07a80636437
    }
}));
if (typeof window !== 'undefined') {
    if (window.__THREE__) console.warn('WARNING: Multiple instances of Three.js being imported.');
    else window.__THREE__ = $1a55656020b89c3a$export$3545e07a80636437;
}

/**
 * @license
 * Copyright 2010-2025 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ 







function $079becb54c0579a9$var$WebGLAnimation() {
    var context = null;
    var isAnimating = false;
    var animationLoop = null;
    var requestId = null;
    function onAnimationFrame(time, frame) {
        animationLoop(time, frame);
        requestId = context.requestAnimationFrame(onAnimationFrame);
    }
    return {
        start: function start() {
            if (isAnimating === true) return;
            if (animationLoop === null) return;
            requestId = context.requestAnimationFrame(onAnimationFrame);
            isAnimating = true;
        },
        stop: function stop() {
            context.cancelAnimationFrame(requestId);
            isAnimating = false;
        },
        setAnimationLoop: function setAnimationLoop(callback) {
            animationLoop = callback;
        },
        setContext: function setContext(value) {
            context = value;
        }
    };
}
function $079becb54c0579a9$var$WebGLAttributes(gl) {
    var buffers = new WeakMap();
    function createBuffer(attribute, bufferType) {
        var array = attribute.array;
        var usage = attribute.usage;
        var size = array.byteLength;
        var buffer = gl.createBuffer();
        gl.bindBuffer(bufferType, buffer);
        gl.bufferData(bufferType, array, usage);
        attribute.onUploadCallback();
        var type;
        if (array instanceof Float32Array) type = gl.FLOAT;
        else if (array instanceof Uint16Array) {
            if (attribute.isFloat16BufferAttribute) type = gl.HALF_FLOAT;
            else type = gl.UNSIGNED_SHORT;
        } else if (array instanceof Int16Array) type = gl.SHORT;
        else if (array instanceof Uint32Array) type = gl.UNSIGNED_INT;
        else if (array instanceof Int32Array) type = gl.INT;
        else if (array instanceof Int8Array) type = gl.BYTE;
        else if (array instanceof Uint8Array) type = gl.UNSIGNED_BYTE;
        else if (array instanceof Uint8ClampedArray) type = gl.UNSIGNED_BYTE;
        else throw new Error('THREE.WebGLAttributes: Unsupported buffer data format: ' + array);
        return {
            buffer: buffer,
            type: type,
            bytesPerElement: array.BYTES_PER_ELEMENT,
            version: attribute.version,
            size: size
        };
    }
    function updateBuffer(buffer, attribute, bufferType) {
        var array = attribute.array;
        var updateRanges = attribute.updateRanges;
        gl.bindBuffer(bufferType, buffer);
        if (updateRanges.length === 0) // Not using update ranges
        gl.bufferSubData(bufferType, 0, array);
        else {
            // Before applying update ranges, we merge any adjacent / overlapping
            // ranges to reduce load on `gl.bufferSubData`. Empirically, this has led
            // to performance improvements for applications which make heavy use of
            // update ranges. Likely due to GPU command overhead.
            //
            // Note that to reduce garbage collection between frames, we merge the
            // update ranges in-place. This is safe because this method will clear the
            // update ranges once updated.
            updateRanges.sort(function(a, b) {
                return a.start - b.start;
            });
            // To merge the update ranges in-place, we work from left to right in the
            // existing updateRanges array, merging ranges. This may result in a final
            // array which is smaller than the original. This index tracks the last
            // index representing a merged range, any data after this index can be
            // trimmed once the merge algorithm is completed.
            var mergeIndex = 0;
            for(var i = 1; i < updateRanges.length; i++){
                var previousRange = updateRanges[mergeIndex];
                var range = updateRanges[i];
                // We add one here to merge adjacent ranges. This is safe because ranges
                // operate over positive integers.
                if (range.start <= previousRange.start + previousRange.count + 1) previousRange.count = Math.max(previousRange.count, range.start + range.count - previousRange.start);
                else {
                    ++mergeIndex;
                    updateRanges[mergeIndex] = range;
                }
            }
            // Trim the array to only contain the merged ranges.
            updateRanges.length = mergeIndex + 1;
            for(var i1 = 0, l = updateRanges.length; i1 < l; i1++){
                var range1 = updateRanges[i1];
                gl.bufferSubData(bufferType, range1.start * array.BYTES_PER_ELEMENT, array, range1.start, range1.count);
            }
            attribute.clearUpdateRanges();
        }
        attribute.onUploadCallback();
    }
    //
    function get(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        return buffers.get(attribute);
    }
    function remove(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        var data = buffers.get(attribute);
        if (data) {
            gl.deleteBuffer(data.buffer);
            buffers.delete(attribute);
        }
    }
    function update(attribute, bufferType) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        if (attribute.isGLBufferAttribute) {
            var cached = buffers.get(attribute);
            if (!cached || cached.version < attribute.version) buffers.set(attribute, {
                buffer: attribute.buffer,
                type: attribute.type,
                bytesPerElement: attribute.elementSize,
                version: attribute.version
            });
            return;
        }
        var data = buffers.get(attribute);
        if (data === undefined) buffers.set(attribute, createBuffer(attribute, bufferType));
        else if (data.version < attribute.version) {
            if (data.size !== attribute.array.byteLength) throw new Error('THREE.WebGLAttributes: The size of the buffer attribute\'s array buffer does not match the original size. Resizing buffer attributes is not supported.');
            updateBuffer(data.buffer, attribute, bufferType);
            data.version = attribute.version;
        }
    }
    return {
        get: get,
        remove: remove,
        update: update
    };
}
var $079becb54c0579a9$var$alphahash_fragment = "#ifdef USE_ALPHAHASH\n\tif ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;\n#endif";
var $079becb54c0579a9$var$alphahash_pars_fragment = "#ifdef USE_ALPHAHASH\n\tconst float ALPHA_HASH_SCALE = 0.05;\n\tfloat hash2D( vec2 value ) {\n\t\treturn fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );\n\t}\n\tfloat hash3D( vec3 value ) {\n\t\treturn hash2D( vec2( hash2D( value.xy ), value.z ) );\n\t}\n\tfloat getAlphaHashThreshold( vec3 position ) {\n\t\tfloat maxDeriv = max(\n\t\t\tlength( dFdx( position.xyz ) ),\n\t\t\tlength( dFdy( position.xyz ) )\n\t\t);\n\t\tfloat pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );\n\t\tvec2 pixScales = vec2(\n\t\t\texp2( floor( log2( pixScale ) ) ),\n\t\t\texp2( ceil( log2( pixScale ) ) )\n\t\t);\n\t\tvec2 alpha = vec2(\n\t\t\thash3D( floor( pixScales.x * position.xyz ) ),\n\t\t\thash3D( floor( pixScales.y * position.xyz ) )\n\t\t);\n\t\tfloat lerpFactor = fract( log2( pixScale ) );\n\t\tfloat x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;\n\t\tfloat a = min( lerpFactor, 1.0 - lerpFactor );\n\t\tvec3 cases = vec3(\n\t\t\tx * x / ( 2.0 * a * ( 1.0 - a ) ),\n\t\t\t( x - 0.5 * a ) / ( 1.0 - a ),\n\t\t\t1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )\n\t\t);\n\t\tfloat threshold = ( x < ( 1.0 - a ) )\n\t\t\t? ( ( x < a ) ? cases.x : cases.y )\n\t\t\t: cases.z;\n\t\treturn clamp( threshold , 1.0e-6, 1.0 );\n\t}\n#endif";
var $079becb54c0579a9$var$alphamap_fragment = "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif";
var $079becb54c0579a9$var$alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var $079becb54c0579a9$var$alphatest_fragment = "#ifdef USE_ALPHATEST\n\t#ifdef ALPHA_TO_COVERAGE\n\tdiffuseColor.a = smoothstep( alphaTest, alphaTest + fwidth( diffuseColor.a ), diffuseColor.a );\n\tif ( diffuseColor.a == 0.0 ) discard;\n\t#else\n\tif ( diffuseColor.a < alphaTest ) discard;\n\t#endif\n#endif";
var $079becb54c0579a9$var$alphatest_pars_fragment = "#ifdef USE_ALPHATEST\n\tuniform float alphaTest;\n#endif";
var $079becb54c0579a9$var$aomap_fragment = "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_CLEARCOAT ) \n\t\tclearcoatSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_SHEEN ) \n\t\tsheenSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD )\n\t\tfloat dotNV = saturate( dot( geometryNormal, geometryViewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n\t#endif\n#endif";
var $079becb54c0579a9$var$aomap_pars_fragment = "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif";
var $079becb54c0579a9$var$batching_pars_vertex = "#ifdef USE_BATCHING\n\t#if ! defined( GL_ANGLE_multi_draw )\n\t#define gl_DrawID _gl_DrawID\n\tuniform int _gl_DrawID;\n\t#endif\n\tuniform highp sampler2D batchingTexture;\n\tuniform highp usampler2D batchingIdTexture;\n\tmat4 getBatchingMatrix( const in float i ) {\n\t\tint size = textureSize( batchingTexture, 0 ).x;\n\t\tint j = int( i ) * 4;\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\tvec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );\n\t\tvec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );\n\t\tvec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );\n\t\tvec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );\n\t\treturn mat4( v1, v2, v3, v4 );\n\t}\n\tfloat getIndirectIndex( const in int i ) {\n\t\tint size = textureSize( batchingIdTexture, 0 ).x;\n\t\tint x = i % size;\n\t\tint y = i / size;\n\t\treturn float( texelFetch( batchingIdTexture, ivec2( x, y ), 0 ).r );\n\t}\n#endif\n#ifdef USE_BATCHING_COLOR\n\tuniform sampler2D batchingColorTexture;\n\tvec3 getBatchingColor( const in float i ) {\n\t\tint size = textureSize( batchingColorTexture, 0 ).x;\n\t\tint j = int( i );\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\treturn texelFetch( batchingColorTexture, ivec2( x, y ), 0 ).rgb;\n\t}\n#endif";
var $079becb54c0579a9$var$batching_vertex = "#ifdef USE_BATCHING\n\tmat4 batchingMatrix = getBatchingMatrix( getIndirectIndex( gl_DrawID ) );\n#endif";
var $079becb54c0579a9$var$begin_vertex = "vec3 transformed = vec3( position );\n#ifdef USE_ALPHAHASH\n\tvPosition = vec3( position );\n#endif";
var $079becb54c0579a9$var$beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n\tvec3 objectTangent = vec3( tangent.xyz );\n#endif";
var $079becb54c0579a9$var$bsdfs = "float G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, 1.0, dotVH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n} // validated";
var $079becb54c0579a9$var$iridescence_fragment = "#ifdef USE_IRIDESCENCE\n\tconst mat3 XYZ_TO_REC709 = mat3(\n\t\t 3.2404542, -0.9692660,  0.0556434,\n\t\t-1.5371385,  1.8760108, -0.2040259,\n\t\t-0.4985314,  0.0415560,  1.0572252\n\t);\n\tvec3 Fresnel0ToIor( vec3 fresnel0 ) {\n\t\tvec3 sqrtF0 = sqrt( fresnel0 );\n\t\treturn ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n\t}\n\tvec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n\t}\n\tfloat IorToFresnel0( float transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n\t}\n\tvec3 evalSensitivity( float OPD, vec3 shift ) {\n\t\tfloat phase = 2.0 * PI * OPD * 1.0e-9;\n\t\tvec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n\t\tvec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n\t\tvec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n\t\tvec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n\t\txyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n\t\txyz /= 1.0685e-7;\n\t\tvec3 rgb = XYZ_TO_REC709 * xyz;\n\t\treturn rgb;\n\t}\n\tvec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n\t\tvec3 I;\n\t\tfloat iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n\t\tfloat sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n\t\tfloat cosTheta2Sq = 1.0 - sinTheta2Sq;\n\t\tif ( cosTheta2Sq < 0.0 ) {\n\t\t\treturn vec3( 1.0 );\n\t\t}\n\t\tfloat cosTheta2 = sqrt( cosTheta2Sq );\n\t\tfloat R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n\t\tfloat R12 = F_Schlick( R0, 1.0, cosTheta1 );\n\t\tfloat T121 = 1.0 - R12;\n\t\tfloat phi12 = 0.0;\n\t\tif ( iridescenceIOR < outsideIOR ) phi12 = PI;\n\t\tfloat phi21 = PI - phi12;\n\t\tvec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );\t\tvec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n\t\tvec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n\t\tvec3 phi23 = vec3( 0.0 );\n\t\tif ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n\t\tif ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n\t\tif ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n\t\tfloat OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n\t\tvec3 phi = vec3( phi21 ) + phi23;\n\t\tvec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n\t\tvec3 r123 = sqrt( R123 );\n\t\tvec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n\t\tvec3 C0 = R12 + Rs;\n\t\tI = C0;\n\t\tvec3 Cm = Rs - T121;\n\t\tfor ( int m = 1; m <= 2; ++ m ) {\n\t\t\tCm *= r123;\n\t\t\tvec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n\t\t\tI += Cm * Sm;\n\t\t}\n\t\treturn max( I, vec3( 0.0 ) );\n\t}\n#endif";
var $079becb54c0579a9$var$bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vBumpMapUv );\n\t\tvec2 dSTdy = dFdy( vBumpMapUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n\t\tvec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );\n\t\tvec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 ) * faceDirection;\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif";
var $079becb54c0579a9$var$clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#ifdef ALPHA_TO_COVERAGE\n\t\tfloat distanceToPlane, distanceGradient;\n\t\tfloat clipOpacity = 1.0;\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tdistanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n\t\t\tdistanceGradient = fwidth( distanceToPlane ) / 2.0;\n\t\t\tclipOpacity *= smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n\t\t\tif ( clipOpacity == 0.0 ) discard;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\t\tfloat unionClipOpacity = 1.0;\n\t\t\t#pragma unroll_loop_start\n\t\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\t\tplane = clippingPlanes[ i ];\n\t\t\t\tdistanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n\t\t\t\tdistanceGradient = fwidth( distanceToPlane ) / 2.0;\n\t\t\t\tunionClipOpacity *= 1.0 - smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n\t\t\t}\n\t\t\t#pragma unroll_loop_end\n\t\t\tclipOpacity *= 1.0 - unionClipOpacity;\n\t\t#endif\n\t\tdiffuseColor.a *= clipOpacity;\n\t\tif ( diffuseColor.a == 0.0 ) discard;\n\t#else\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\t\tbool clipped = true;\n\t\t\t#pragma unroll_loop_start\n\t\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\t\tplane = clippingPlanes[ i ];\n\t\t\t\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t\t}\n\t\t\t#pragma unroll_loop_end\n\t\t\tif ( clipped ) discard;\n\t\t#endif\n\t#endif\n#endif";
var $079becb54c0579a9$var$clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
var $079becb54c0579a9$var$clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n#endif";
var $079becb54c0579a9$var$clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvClipPosition = - mvPosition.xyz;\n#endif";
var $079becb54c0579a9$var$color_fragment = "#if defined( USE_COLOR_ALPHA )\n\tdiffuseColor *= vColor;\n#elif defined( USE_COLOR )\n\tdiffuseColor.rgb *= vColor;\n#endif";
var $079becb54c0579a9$var$color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR )\n\tvarying vec3 vColor;\n#endif";
var $079becb54c0579a9$var$color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n\tvarying vec3 vColor;\n#endif";
var $079becb54c0579a9$var$color_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n\tvColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n\tvColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n\tvColor.xyz *= instanceColor.xyz;\n#endif\n#ifdef USE_BATCHING_COLOR\n\tvec3 batchingColor = getBatchingColor( getIndirectIndex( gl_DrawID ) );\n\tvColor.xyz *= batchingColor.xyz;\n#endif";
var $079becb54c0579a9$var$common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n\tfloat precisionSafeLength( vec3 v ) {\n\t\tfloat maxComponent = max3( abs( v ) );\n\t\treturn length( v / maxComponent ) * maxComponent;\n\t}\n#endif\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\n#ifdef USE_ALPHAHASH\n\tvarying vec3 vPosition;\n#endif\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n\tmat3 tmp;\n\ttmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n\ttmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n\ttmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n\treturn tmp;\n}\nbool isPerspectiveMatrix( mat4 m ) {\n\treturn m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\treturn vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated";
var $079becb54c0579a9$var$cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n\t#define cubeUV_minMipLevel 4.0\n\t#define cubeUV_minTileSize 16.0\n\tfloat getFace( vec3 direction ) {\n\t\tvec3 absDirection = abs( direction );\n\t\tfloat face = - 1.0;\n\t\tif ( absDirection.x > absDirection.z ) {\n\t\t\tif ( absDirection.x > absDirection.y )\n\t\t\t\tface = direction.x > 0.0 ? 0.0 : 3.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t} else {\n\t\t\tif ( absDirection.z > absDirection.y )\n\t\t\t\tface = direction.z > 0.0 ? 2.0 : 5.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t}\n\t\treturn face;\n\t}\n\tvec2 getUV( vec3 direction, float face ) {\n\t\tvec2 uv;\n\t\tif ( face == 0.0 ) {\n\t\t\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 1.0 ) {\n\t\t\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n\t\t} else if ( face == 2.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\n\t\t} else if ( face == 3.0 ) {\n\t\t\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 4.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\n\t\t} else {\n\t\t\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\n\t\t}\n\t\treturn 0.5 * ( uv + 1.0 );\n\t}\n\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n\t\tfloat face = getFace( direction );\n\t\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n\t\tmipInt = max( mipInt, cubeUV_minMipLevel );\n\t\tfloat faceSize = exp2( mipInt );\n\t\thighp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n\t\tif ( face > 2.0 ) {\n\t\t\tuv.y += faceSize;\n\t\t\tface -= 3.0;\n\t\t}\n\t\tuv.x += face * faceSize;\n\t\tuv.x += filterInt * 3.0 * cubeUV_minTileSize;\n\t\tuv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n\t\tuv.x *= CUBEUV_TEXEL_WIDTH;\n\t\tuv.y *= CUBEUV_TEXEL_HEIGHT;\n\t\t#ifdef texture2DGradEXT\n\t\t\treturn texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n\t\t#else\n\t\t\treturn texture2D( envMap, uv ).rgb;\n\t\t#endif\n\t}\n\t#define cubeUV_r0 1.0\n\t#define cubeUV_m0 - 2.0\n\t#define cubeUV_r1 0.8\n\t#define cubeUV_m1 - 1.0\n\t#define cubeUV_r4 0.4\n\t#define cubeUV_m4 2.0\n\t#define cubeUV_r5 0.305\n\t#define cubeUV_m5 3.0\n\t#define cubeUV_r6 0.21\n\t#define cubeUV_m6 4.0\n\tfloat roughnessToMip( float roughness ) {\n\t\tfloat mip = 0.0;\n\t\tif ( roughness >= cubeUV_r1 ) {\n\t\t\tmip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n\t\t} else if ( roughness >= cubeUV_r4 ) {\n\t\t\tmip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n\t\t} else if ( roughness >= cubeUV_r5 ) {\n\t\t\tmip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n\t\t} else if ( roughness >= cubeUV_r6 ) {\n\t\t\tmip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n\t\t} else {\n\t\t\tmip = - 2.0 * log2( 1.16 * roughness );\t\t}\n\t\treturn mip;\n\t}\n\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n\t\tfloat mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n\t\tfloat mipF = fract( mip );\n\t\tfloat mipInt = floor( mip );\n\t\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n\t\tif ( mipF == 0.0 ) {\n\t\t\treturn vec4( color0, 1.0 );\n\t\t} else {\n\t\t\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n\t\t\treturn vec4( mix( color0, color1, mipF ), 1.0 );\n\t\t}\n\t}\n#endif";
var $079becb54c0579a9$var$defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_TANGENT\n\tvec3 transformedTangent = objectTangent;\n#endif\n#ifdef USE_BATCHING\n\tmat3 bm = mat3( batchingMatrix );\n\ttransformedNormal /= vec3( dot( bm[ 0 ], bm[ 0 ] ), dot( bm[ 1 ], bm[ 1 ] ), dot( bm[ 2 ], bm[ 2 ] ) );\n\ttransformedNormal = bm * transformedNormal;\n\t#ifdef USE_TANGENT\n\t\ttransformedTangent = bm * transformedTangent;\n\t#endif\n#endif\n#ifdef USE_INSTANCING\n\tmat3 im = mat3( instanceMatrix );\n\ttransformedNormal /= vec3( dot( im[ 0 ], im[ 0 ] ), dot( im[ 1 ], im[ 1 ] ), dot( im[ 2 ], im[ 2 ] ) );\n\ttransformedNormal = im * transformedNormal;\n\t#ifdef USE_TANGENT\n\t\ttransformedTangent = im * transformedTangent;\n\t#endif\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n\ttransformedTangent = ( modelViewMatrix * vec4( transformedTangent, 0.0 ) ).xyz;\n\t#ifdef FLIP_SIDED\n\t\ttransformedTangent = - transformedTangent;\n\t#endif\n#endif";
var $079becb54c0579a9$var$displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif";
var $079becb54c0579a9$var$displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif";
var $079becb54c0579a9$var$emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n\t#ifdef DECODE_VIDEO_TEXTURE_EMISSIVE\n\t\temissiveColor = sRGBTransferEOTF( emissiveColor );\n\t#endif\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
var $079becb54c0579a9$var$emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif";
var $079becb54c0579a9$var$colorspace_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
var $079becb54c0579a9$var$colorspace_pars_fragment = "vec4 LinearTransferOETF( in vec4 value ) {\n\treturn value;\n}\nvec4 sRGBTransferEOTF( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );\n}\nvec4 sRGBTransferOETF( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}";
var $079becb54c0579a9$var$envmap_fragment = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvec3 cameraToFrag;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, envMapRotation * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif";
var $079becb54c0579a9$var$envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float envMapIntensity;\n\tuniform float flipEnvMap;\n\tuniform mat3 envMapRotation;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\t\n#endif";
var $079becb54c0579a9$var$envmap_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float reflectivity;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\tvarying vec3 vWorldPosition;\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif";
var $079becb54c0579a9$var$envmap_pars_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\t\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif";
var $079becb54c0579a9$var$envmap_vertex = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif";
var $079becb54c0579a9$var$fog_vertex = "#ifdef USE_FOG\n\tvFogDepth = - mvPosition.z;\n#endif";
var $079becb54c0579a9$var$fog_pars_vertex = "#ifdef USE_FOG\n\tvarying float vFogDepth;\n#endif";
var $079becb54c0579a9$var$fog_fragment = "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
var $079becb54c0579a9$var$fog_pars_fragment = "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float vFogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif";
var $079becb54c0579a9$var$gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n\tuniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\tfloat dotNL = dot( normal, lightDirection );\n\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t#ifdef USE_GRADIENTMAP\n\t\treturn vec3( texture2D( gradientMap, coord ).r );\n\t#else\n\t\tvec2 fw = fwidth( coord ) * 0.5;\n\t\treturn mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n\t#endif\n}";
var $079becb54c0579a9$var$lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif";
var $079becb54c0579a9$var$lights_lambert_fragment = "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;";
var $079becb54c0579a9$var$lights_lambert_pars_fragment = "varying vec3 vViewPosition;\nstruct LambertMaterial {\n\tvec3 diffuseColor;\n\tfloat specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Lambert\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Lambert";
var $079becb54c0579a9$var$lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\n#if defined( USE_LIGHT_PROBES )\n\tuniform vec3 lightProbe[ 9 ];\n#endif\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n\tfloat x = normal.x, y = normal.y, z = normal.z;\n\tvec3 result = shCoefficients[ 0 ] * 0.886227;\n\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n\treturn result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n\treturn irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\treturn irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\tif ( cutoffDistance > 0.0 ) {\n\t\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t}\n\treturn distanceFalloff;\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n\treturn smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {\n\t\tlight.color = directionalLight.color;\n\t\tlight.direction = directionalLight.direction;\n\t\tlight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = pointLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tlight.color = pointLight.color;\n\t\tlight.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = spotLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat angleCos = dot( light.direction, spotLight.direction );\n\t\tfloat spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\tif ( spotAttenuation > 0.0 ) {\n\t\t\tfloat lightDistance = length( lVector );\n\t\t\tlight.color = spotLight.color * spotAttenuation;\n\t\t\tlight.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t\t} else {\n\t\t\tlight.color = vec3( 0.0 );\n\t\t\tlight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n\t\tfloat dotNL = dot( normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\treturn irradiance;\n\t}\n#endif";
var $079becb54c0579a9$var$envmap_physical_pars_fragment = "#ifdef USE_ENVMAP\n\tvec3 getIBLIrradiance( const in vec3 normal ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, envMapRotation * worldNormal, 1.0 );\n\t\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\tvec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 reflectVec = reflect( - viewDir, normal );\n\t\t\treflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n\t\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, envMapRotation * reflectVec, roughness );\n\t\t\treturn envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\t#ifdef USE_ANISOTROPY\n\t\tvec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n\t\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\t\tvec3 bentNormal = cross( bitangent, viewDir );\n\t\t\t\tbentNormal = normalize( cross( bentNormal, bitangent ) );\n\t\t\t\tbentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n\t\t\t\treturn getIBLRadiance( viewDir, bentNormal, roughness );\n\t\t\t#else\n\t\t\t\treturn vec3( 0.0 );\n\t\t\t#endif\n\t\t}\n\t#endif\n#endif";
var $079becb54c0579a9$var$lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
var $079becb54c0579a9$var$lights_toon_pars_fragment = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n\tvec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Toon\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Toon";
var $079becb54c0579a9$var$lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
var $079becb54c0579a9$var$lights_phong_pars_fragment = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n\tvec3 diffuseColor;\n\tvec3 specularColor;\n\tfloat specularShininess;\n\tfloat specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong";
var $079becb54c0579a9$var$lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n\tmaterial.ior = ior;\n\t#ifdef USE_SPECULAR\n\t\tfloat specularIntensityFactor = specularIntensity;\n\t\tvec3 specularColorFactor = specularColor;\n\t\t#ifdef USE_SPECULAR_COLORMAP\n\t\t\tspecularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n\t\t#endif\n\t\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\t\tspecularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n\t\t#endif\n\t\tmaterial.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n\t#else\n\t\tfloat specularIntensityFactor = 1.0;\n\t\tvec3 specularColorFactor = vec3( 1.0 );\n\t\tmaterial.specularF90 = 1.0;\n\t#endif\n\tmaterial.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n\tmaterial.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n\tmaterial.clearcoat = clearcoat;\n\tmaterial.clearcoatRoughness = clearcoatRoughness;\n\tmaterial.clearcoatF0 = vec3( 0.04 );\n\tmaterial.clearcoatF90 = 1.0;\n\t#ifdef USE_CLEARCOATMAP\n\t\tmaterial.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n\t#endif\n\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\t\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n\t#endif\n\tmaterial.clearcoat = saturate( material.clearcoat );\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n\tmaterial.clearcoatRoughness += geometryRoughness;\n\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_DISPERSION\n\tmaterial.dispersion = dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n\tmaterial.iridescence = iridescence;\n\tmaterial.iridescenceIOR = iridescenceIOR;\n\t#ifdef USE_IRIDESCENCEMAP\n\t\tmaterial.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n\t#endif\n\t#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\t\tmaterial.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n\t#else\n\t\tmaterial.iridescenceThickness = iridescenceThicknessMaximum;\n\t#endif\n#endif\n#ifdef USE_SHEEN\n\tmaterial.sheenColor = sheenColor;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tmaterial.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n\t#endif\n\tmaterial.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tmaterial.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\t#ifdef USE_ANISOTROPYMAP\n\t\tmat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n\t\tvec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n\t\tvec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n\t#else\n\t\tvec2 anisotropyV = anisotropyVector;\n\t#endif\n\tmaterial.anisotropy = length( anisotropyV );\n\tif( material.anisotropy == 0.0 ) {\n\t\tanisotropyV = vec2( 1.0, 0.0 );\n\t} else {\n\t\tanisotropyV /= material.anisotropy;\n\t\tmaterial.anisotropy = saturate( material.anisotropy );\n\t}\n\tmaterial.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n\tmaterial.anisotropyT = tbn[ 0 ] * anisotropyV.x + tbn[ 1 ] * anisotropyV.y;\n\tmaterial.anisotropyB = tbn[ 1 ] * anisotropyV.x - tbn[ 0 ] * anisotropyV.y;\n#endif";
var $079becb54c0579a9$var$lights_physical_pars_fragment = "struct PhysicalMaterial {\n\tvec3 diffuseColor;\n\tfloat roughness;\n\tvec3 specularColor;\n\tfloat specularF90;\n\tfloat dispersion;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat clearcoat;\n\t\tfloat clearcoatRoughness;\n\t\tvec3 clearcoatF0;\n\t\tfloat clearcoatF90;\n\t#endif\n\t#ifdef USE_IRIDESCENCE\n\t\tfloat iridescence;\n\t\tfloat iridescenceIOR;\n\t\tfloat iridescenceThickness;\n\t\tvec3 iridescenceFresnel;\n\t\tvec3 iridescenceF0;\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tvec3 sheenColor;\n\t\tfloat sheenRoughness;\n\t#endif\n\t#ifdef IOR\n\t\tfloat ior;\n\t#endif\n\t#ifdef USE_TRANSMISSION\n\t\tfloat transmission;\n\t\tfloat transmissionAlpha;\n\t\tfloat thickness;\n\t\tfloat attenuationDistance;\n\t\tvec3 attenuationColor;\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat anisotropy;\n\t\tfloat alphaT;\n\t\tvec3 anisotropyT;\n\t\tvec3 anisotropyB;\n\t#endif\n};\nvec3 clearcoatSpecularDirect = vec3( 0.0 );\nvec3 clearcoatSpecularIndirect = vec3( 0.0 );\nvec3 sheenSpecularDirect = vec3( 0.0 );\nvec3 sheenSpecularIndirect = vec3(0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n\tfloat V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n\t\tfloat gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n\t\tfloat gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n\t\tfloat v = 0.5 / ( gv + gl );\n\t\treturn saturate(v);\n\t}\n\tfloat D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n\t\tfloat a2 = alphaT * alphaB;\n\t\thighp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n\t\thighp float v2 = dot( v, v );\n\t\tfloat w2 = a2 / v2;\n\t\treturn RECIPROCAL_PI * a2 * pow2 ( w2 );\n\t}\n#endif\n#ifdef USE_CLEARCOAT\n\tvec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n\t\tvec3 f0 = material.clearcoatF0;\n\t\tfloat f90 = material.clearcoatF90;\n\t\tfloat roughness = material.clearcoatRoughness;\n\t\tfloat alpha = pow2( roughness );\n\t\tvec3 halfDir = normalize( lightDir + viewDir );\n\t\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\t\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\t\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\t\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\t\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t\treturn F * ( V * D );\n\t}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n\tvec3 f0 = material.specularColor;\n\tfloat f90 = material.specularF90;\n\tfloat roughness = material.roughness;\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t#ifdef USE_IRIDESCENCE\n\t\tF = mix( F, material.iridescenceFresnel, material.iridescence );\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat dotTL = dot( material.anisotropyT, lightDir );\n\t\tfloat dotTV = dot( material.anisotropyT, viewDir );\n\t\tfloat dotTH = dot( material.anisotropyT, halfDir );\n\t\tfloat dotBL = dot( material.anisotropyB, lightDir );\n\t\tfloat dotBV = dot( material.anisotropyB, viewDir );\n\t\tfloat dotBH = dot( material.anisotropyB, halfDir );\n\t\tfloat V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n\t\tfloat D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n\t#else\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t#endif\n\treturn F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n\tfloat alpha = pow2( roughness );\n\tfloat invAlpha = 1.0 / alpha;\n\tfloat cos2h = dotNH * dotNH;\n\tfloat sin2h = max( 1.0 - cos2h, 0.0078125 );\n\treturn ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n\treturn saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat D = D_Charlie( sheenRoughness, dotNH );\n\tfloat V = V_Neubelt( dotNV, dotNL );\n\treturn sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat r2 = roughness * roughness;\n\tfloat a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n\tfloat b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n\tfloat DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n\treturn saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\tvec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n\treturn fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\treturn specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\t#ifdef USE_IRIDESCENCE\n\t\tvec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n\t#else\n\t\tvec3 Fr = specularColor;\n\t#endif\n\tvec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n\tfloat Ess = fab.x + fab.y;\n\tfloat Ems = 1.0 - Ess;\n\tvec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n\tsingleScatter += FssEss;\n\tmultiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometryNormal;\n\t\tvec3 viewDir = geometryViewDir;\n\t\tvec3 position = geometryPosition;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.roughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );\n\t\tvec3 ccIrradiance = dotNLcc * directLight.color;\n\t\tclearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );\n\t#endif\n\treflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometryViewDir, geometryNormal, material );\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n\t#endif\n\tvec3 singleScattering = vec3( 0.0 );\n\tvec3 multiScattering = vec3( 0.0 );\n\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n\t#ifdef USE_IRIDESCENCE\n\t\tcomputeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n\t#else\n\t\tcomputeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n\t#endif\n\tvec3 totalScattering = singleScattering + multiScattering;\n\tvec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n\treflectedLight.indirectSpecular += radiance * singleScattering;\n\treflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n\treflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
var $079becb54c0579a9$var$lights_fragment_begin = "\nvec3 geometryPosition = - vViewPosition;\nvec3 geometryNormal = normal;\nvec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\nvec3 geometryClearcoatNormal = vec3( 0.0 );\n#ifdef USE_CLEARCOAT\n\tgeometryClearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n\tfloat dotNVi = saturate( dot( normal, geometryViewDir ) );\n\tif ( material.iridescenceThickness == 0.0 ) {\n\t\tmaterial.iridescence = 0.0;\n\t} else {\n\t\tmaterial.iridescence = saturate( material.iridescence );\n\t}\n\tif ( material.iridescence > 0.0 ) {\n\t\tmaterial.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n\t\tmaterial.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n\t}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointLightInfo( pointLight, geometryPosition, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n\t\tpointLightShadow = pointLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowIntensity, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\tvec4 spotColor;\n\tvec3 spotLightCoord;\n\tbool inSpotLightMap;\n\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotLightInfo( spotLight, geometryPosition, directLight );\n\t\t#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n\t\t#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n\t\t#else\n\t\t#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#endif\n\t\t#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n\t\t\tspotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n\t\t\tinSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n\t\t\tspotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n\t\t\tdirectLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n\t\t#endif\n\t\t#undef SPOT_LIGHT_MAP_INDEX\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\tspotLightShadow = spotLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowIntensity, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalLightInfo( directionalLight, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n\t\tdirectionalLightShadow = directionalLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowIntensity, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 iblIrradiance = vec3( 0.0 );\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\t#if defined( USE_LIGHT_PROBES )\n\t\tirradiance += getLightProbeIrradiance( lightProbe, geometryNormal );\n\t#endif\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
var $079becb54c0579a9$var$lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tiblIrradiance += getIBLIrradiance( geometryNormal );\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\t#ifdef USE_ANISOTROPY\n\t\tradiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );\n\t#else\n\t\tradiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );\n\t#endif\n#endif";
var $079becb54c0579a9$var$lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n\tRE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif";
var $079becb54c0579a9$var$logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF )\n\tgl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
var $079becb54c0579a9$var$logdepthbuf_pars_fragment = "#if defined( USE_LOGDEPTHBUF )\n\tuniform float logDepthBufFC;\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";
var $079becb54c0579a9$var$logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";
var $079becb54c0579a9$var$logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n\tvFragDepth = 1.0 + gl_Position.w;\n\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n#endif";
var $079becb54c0579a9$var$map_fragment = "#ifdef USE_MAP\n\tvec4 sampledDiffuseColor = texture2D( map, vMapUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\tsampledDiffuseColor = sRGBTransferEOTF( sampledDiffuseColor );\n\t#endif\n\tdiffuseColor *= sampledDiffuseColor;\n#endif";
var $079becb54c0579a9$var$map_pars_fragment = "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif";
var $079becb54c0579a9$var$map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t#if defined( USE_POINTS_UV )\n\t\tvec2 uv = vUv;\n\t#else\n\t\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tdiffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
var $079becb54c0579a9$var$map_particle_pars_fragment = "#if defined( USE_POINTS_UV )\n\tvarying vec2 vUv;\n#else\n\t#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t\tuniform mat3 uvTransform;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var $079becb54c0579a9$var$metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif";
var $079becb54c0579a9$var$metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif";
var $079becb54c0579a9$var$morphinstance_vertex = "#ifdef USE_INSTANCING_MORPH\n\tfloat morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\tfloat morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tmorphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;\n\t}\n#endif";
var $079becb54c0579a9$var$morphcolor_vertex = "#if defined( USE_MORPHCOLORS )\n\tvColor *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t#if defined( USE_COLOR_ALPHA )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n\t\t#elif defined( USE_COLOR )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n\t\t#endif\n\t}\n#endif";
var $079becb54c0579a9$var$morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n\tobjectNormal *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tif ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n\t}\n#endif";
var $079becb54c0579a9$var$morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n\t#ifndef USE_INSTANCING_MORPH\n\t\tuniform float morphTargetBaseInfluence;\n\t\tuniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\t#endif\n\tuniform sampler2DArray morphTargetsTexture;\n\tuniform ivec2 morphTargetsTextureSize;\n\tvec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n\t\tint texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n\t\tint y = texelIndex / morphTargetsTextureSize.x;\n\t\tint x = texelIndex - y * morphTargetsTextureSize.x;\n\t\tivec3 morphUV = ivec3( x, y, morphTargetIndex );\n\t\treturn texelFetch( morphTargetsTexture, morphUV, 0 );\n\t}\n#endif";
var $079becb54c0579a9$var$morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n\ttransformed *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tif ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n\t}\n#endif";
var $079becb54c0579a9$var$normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n\tvec3 fdx = dFdx( vViewPosition );\n\tvec3 fdy = dFdy( vViewPosition );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal *= faceDirection;\n\t#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn = getTangentFrame( - vViewPosition, normal,\n\t\t#if defined( USE_NORMALMAP )\n\t\t\tvNormalMapUv\n\t\t#elif defined( USE_CLEARCOAT_NORMALMAP )\n\t\t\tvClearcoatNormalMapUv\n\t\t#else\n\t\t\tvUv\n\t\t#endif\n\t\t);\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn[0] *= faceDirection;\n\t\ttbn[1] *= faceDirection;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn2[0] *= faceDirection;\n\t\ttbn2[1] *= faceDirection;\n\t#endif\n#endif\nvec3 nonPerturbedNormal = normal;";
var $079becb54c0579a9$var$normal_fragment_maps = "#ifdef USE_NORMALMAP_OBJECTSPACE\n\tnormal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\t#ifdef FLIP_SIDED\n\t\tnormal = - normal;\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\tnormal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n\tvec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\tmapN.xy *= normalScale;\n\tnormal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
var $079becb54c0579a9$var$normal_pars_fragment = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
var $079becb54c0579a9$var$normal_pars_vertex = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
var $079becb54c0579a9$var$normal_vertex = "#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif";
var $079becb54c0579a9$var$normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n\tuniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n\tmat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n\t\tvec3 q0 = dFdx( eye_pos.xyz );\n\t\tvec3 q1 = dFdy( eye_pos.xyz );\n\t\tvec2 st0 = dFdx( uv.st );\n\t\tvec2 st1 = dFdy( uv.st );\n\t\tvec3 N = surf_norm;\n\t\tvec3 q1perp = cross( q1, N );\n\t\tvec3 q0perp = cross( N, q0 );\n\t\tvec3 T = q1perp * st0.x + q0perp * st1.x;\n\t\tvec3 B = q1perp * st0.y + q0perp * st1.y;\n\t\tfloat det = max( dot( T, T ), dot( B, B ) );\n\t\tfloat scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n\t\treturn mat3( T * scale, B * scale, N );\n\t}\n#endif";
var $079becb54c0579a9$var$clearcoat_normal_fragment_begin = "#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal = nonPerturbedNormal;\n#endif";
var $079becb54c0579a9$var$clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n\tclearcoatMapN.xy *= clearcoatNormalScale;\n\tclearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif";
var $079becb54c0579a9$var$clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n\tuniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform sampler2D clearcoatNormalMap;\n\tuniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform sampler2D clearcoatRoughnessMap;\n#endif";
var $079becb54c0579a9$var$iridescence_pars_fragment = "#ifdef USE_IRIDESCENCEMAP\n\tuniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform sampler2D iridescenceThicknessMap;\n#endif";
var $079becb54c0579a9$var$opaque_fragment = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";
var $079becb54c0579a9$var$packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;const float ShiftRight8 = 1. / 256.;\nconst float Inv255 = 1. / 255.;\nconst vec4 PackFactors = vec4( 1.0, 256.0, 256.0 * 256.0, 256.0 * 256.0 * 256.0 );\nconst vec2 UnpackFactors2 = vec2( UnpackDownscale, 1.0 / PackFactors.g );\nconst vec3 UnpackFactors3 = vec3( UnpackDownscale / PackFactors.rg, 1.0 / PackFactors.b );\nconst vec4 UnpackFactors4 = vec4( UnpackDownscale / PackFactors.rgb, 1.0 / PackFactors.a );\nvec4 packDepthToRGBA( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec4( 0., 0., 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec4( 1., 1., 1., 1. );\n\tfloat vuf;\n\tfloat af = modf( v * PackFactors.a, vuf );\n\tfloat bf = modf( vuf * ShiftRight8, vuf );\n\tfloat gf = modf( vuf * ShiftRight8, vuf );\n\treturn vec4( vuf * Inv255, gf * PackUpscale, bf * PackUpscale, af );\n}\nvec3 packDepthToRGB( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec3( 0., 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec3( 1., 1., 1. );\n\tfloat vuf;\n\tfloat bf = modf( v * PackFactors.b, vuf );\n\tfloat gf = modf( vuf * ShiftRight8, vuf );\n\treturn vec3( vuf * Inv255, gf * PackUpscale, bf );\n}\nvec2 packDepthToRG( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec2( 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec2( 1., 1. );\n\tfloat vuf;\n\tfloat gf = modf( v * 256., vuf );\n\treturn vec2( vuf * Inv255, gf );\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors4 );\n}\nfloat unpackRGBToDepth( const in vec3 v ) {\n\treturn dot( v, UnpackFactors3 );\n}\nfloat unpackRGToDepth( const in vec2 v ) {\n\treturn v.r * UnpackFactors2.r + v.g * UnpackFactors2.g;\n}\nvec4 pack2HalfToRGBA( const in vec2 v ) {\n\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( const in vec4 v ) {\n\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn depth * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * depth - far );\n}";
var $079becb54c0579a9$var$premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif";
var $079becb54c0579a9$var$project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_BATCHING\n\tmvPosition = batchingMatrix * mvPosition;\n#endif\n#ifdef USE_INSTANCING\n\tmvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
var $079becb54c0579a9$var$dithering_fragment = "#ifdef DITHERING\n\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
var $079becb54c0579a9$var$dithering_pars_fragment = "#ifdef DITHERING\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif";
var $079becb54c0579a9$var$roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n\troughnessFactor *= texelRoughness.g;\n#endif";
var $079becb54c0579a9$var$roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif";
var $079becb54c0579a9$var$shadowmap_pars_fragment = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n\tuniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tvec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n\t\treturn unpackRGBATo2Half( texture2D( shadow, uv ) );\n\t}\n\tfloat VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n\t\tfloat occlusion = 1.0;\n\t\tvec2 distribution = texture2DDistribution( shadow, uv );\n\t\tfloat hard_shadow = step( compare , distribution.x );\n\t\tif (hard_shadow != 1.0 ) {\n\t\t\tfloat distance = compare - distribution.x ;\n\t\t\tfloat variance = max( 0.00000, distribution.y * distribution.y );\n\t\t\tfloat softness_probability = variance / (variance + distance * distance );\t\t\tsoftness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );\t\t\tocclusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n\t\t}\n\t\treturn occlusion;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tfloat shadow = 1.0;\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n\t\tbool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tfloat dx2 = dx0 / 2.0;\n\t\t\tfloat dy2 = dy0 / 2.0;\n\t\t\tfloat dx3 = dx1 / 2.0;\n\t\t\tfloat dy3 = dy1 / 2.0;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 17.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx = texelSize.x;\n\t\t\tfloat dy = texelSize.y;\n\t\t\tvec2 uv = shadowCoord.xy;\n\t\t\tvec2 f = fract( uv * shadowMapSize + 0.5 );\n\t\t\tuv -= f * texelSize;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, uv, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t f.y )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_VSM )\n\t\t\tshadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#else\n\t\t\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tfloat shadow = 1.0;\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\t\n\t\tfloat lightToPositionLength = length( lightToPosition );\n\t\tif ( lightToPositionLength - shadowCameraFar <= 0.0 && lightToPositionLength - shadowCameraNear >= 0.0 ) {\n\t\t\tfloat dp = ( lightToPositionLength - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\t\t\tdp += shadowBias;\n\t\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n\t\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\t\tshadow = (\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t\t) * ( 1.0 / 9.0 );\n\t\t\t#else\n\t\t\t\tshadow = texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t\t#endif\n\t\t}\n\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t}\n#endif";
var $079becb54c0579a9$var$shadowmap_pars_vertex = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tuniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n#endif";
var $079becb54c0579a9$var$shadowmap_vertex = "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n\tvec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\tvec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition;\n\t\t#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t\tshadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n\t\t#endif\n\t\tvSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n#endif";
var $079becb54c0579a9$var$shadowmask_pars_fragment = "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tdirectionalLight = directionalLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowIntensity, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tspotLight = spotLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowIntensity, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tpointLight = pointLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowIntensity, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#endif\n\treturn shadow;\n}";
var $079becb54c0579a9$var$skinbase_vertex = "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
var $079becb54c0579a9$var$skinning_pars_vertex = "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\tuniform highp sampler2D boneTexture;\n\tmat4 getBoneMatrix( const in float i ) {\n\t\tint size = textureSize( boneTexture, 0 ).x;\n\t\tint j = int( i ) * 4;\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\tvec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );\n\t\tvec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );\n\t\tvec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );\n\t\tvec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );\n\t\treturn mat4( v1, v2, v3, v4 );\n\t}\n#endif";
var $079becb54c0579a9$var$skinning_vertex = "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
var $079becb54c0579a9$var$skinnormal_vertex = "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\t#ifdef USE_TANGENT\n\t\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#endif\n#endif";
var $079becb54c0579a9$var$specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif";
var $079becb54c0579a9$var$specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif";
var $079becb54c0579a9$var$tonemapping_fragment = "#if defined( TONE_MAPPING )\n\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
var $079becb54c0579a9$var$tonemapping_pars_fragment = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 CineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n\treturn a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n\tconst mat3 ACESInputMat = mat3(\n\t\tvec3( 0.59719, 0.07600, 0.02840 ),\t\tvec3( 0.35458, 0.90834, 0.13383 ),\n\t\tvec3( 0.04823, 0.01566, 0.83777 )\n\t);\n\tconst mat3 ACESOutputMat = mat3(\n\t\tvec3(  1.60475, -0.10208, -0.00327 ),\t\tvec3( -0.53108,  1.10813, -0.07276 ),\n\t\tvec3( -0.07367, -0.00605,  1.07602 )\n\t);\n\tcolor *= toneMappingExposure / 0.6;\n\tcolor = ACESInputMat * color;\n\tcolor = RRTAndODTFit( color );\n\tcolor = ACESOutputMat * color;\n\treturn saturate( color );\n}\nconst mat3 LINEAR_REC2020_TO_LINEAR_SRGB = mat3(\n\tvec3( 1.6605, - 0.1246, - 0.0182 ),\n\tvec3( - 0.5876, 1.1329, - 0.1006 ),\n\tvec3( - 0.0728, - 0.0083, 1.1187 )\n);\nconst mat3 LINEAR_SRGB_TO_LINEAR_REC2020 = mat3(\n\tvec3( 0.6274, 0.0691, 0.0164 ),\n\tvec3( 0.3293, 0.9195, 0.0880 ),\n\tvec3( 0.0433, 0.0113, 0.8956 )\n);\nvec3 agxDefaultContrastApprox( vec3 x ) {\n\tvec3 x2 = x * x;\n\tvec3 x4 = x2 * x2;\n\treturn + 15.5 * x4 * x2\n\t\t- 40.14 * x4 * x\n\t\t+ 31.96 * x4\n\t\t- 6.868 * x2 * x\n\t\t+ 0.4298 * x2\n\t\t+ 0.1191 * x\n\t\t- 0.00232;\n}\nvec3 AgXToneMapping( vec3 color ) {\n\tconst mat3 AgXInsetMatrix = mat3(\n\t\tvec3( 0.856627153315983, 0.137318972929847, 0.11189821299995 ),\n\t\tvec3( 0.0951212405381588, 0.761241990602591, 0.0767994186031903 ),\n\t\tvec3( 0.0482516061458583, 0.101439036467562, 0.811302368396859 )\n\t);\n\tconst mat3 AgXOutsetMatrix = mat3(\n\t\tvec3( 1.1271005818144368, - 0.1413297634984383, - 0.14132976349843826 ),\n\t\tvec3( - 0.11060664309660323, 1.157823702216272, - 0.11060664309660294 ),\n\t\tvec3( - 0.016493938717834573, - 0.016493938717834257, 1.2519364065950405 )\n\t);\n\tconst float AgxMinEv = - 12.47393;\tconst float AgxMaxEv = 4.026069;\n\tcolor *= toneMappingExposure;\n\tcolor = LINEAR_SRGB_TO_LINEAR_REC2020 * color;\n\tcolor = AgXInsetMatrix * color;\n\tcolor = max( color, 1e-10 );\tcolor = log2( color );\n\tcolor = ( color - AgxMinEv ) / ( AgxMaxEv - AgxMinEv );\n\tcolor = clamp( color, 0.0, 1.0 );\n\tcolor = agxDefaultContrastApprox( color );\n\tcolor = AgXOutsetMatrix * color;\n\tcolor = pow( max( vec3( 0.0 ), color ), vec3( 2.2 ) );\n\tcolor = LINEAR_REC2020_TO_LINEAR_SRGB * color;\n\tcolor = clamp( color, 0.0, 1.0 );\n\treturn color;\n}\nvec3 NeutralToneMapping( vec3 color ) {\n\tconst float StartCompression = 0.8 - 0.04;\n\tconst float Desaturation = 0.15;\n\tcolor *= toneMappingExposure;\n\tfloat x = min( color.r, min( color.g, color.b ) );\n\tfloat offset = x < 0.08 ? x - 6.25 * x * x : 0.04;\n\tcolor -= offset;\n\tfloat peak = max( color.r, max( color.g, color.b ) );\n\tif ( peak < StartCompression ) return color;\n\tfloat d = 1. - StartCompression;\n\tfloat newPeak = 1. - d * d / ( peak + d - StartCompression );\n\tcolor *= newPeak / peak;\n\tfloat g = 1. - 1. / ( Desaturation * ( peak - newPeak ) + 1. );\n\treturn mix( color, vec3( newPeak ), g );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
var $079becb54c0579a9$var$transmission_fragment = "#ifdef USE_TRANSMISSION\n\tmaterial.transmission = transmission;\n\tmaterial.transmissionAlpha = 1.0;\n\tmaterial.thickness = thickness;\n\tmaterial.attenuationDistance = attenuationDistance;\n\tmaterial.attenuationColor = attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tmaterial.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tmaterial.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n\t#endif\n\tvec3 pos = vWorldPosition;\n\tvec3 v = normalize( cameraPosition - pos );\n\tvec3 n = inverseTransformDirection( normal, viewMatrix );\n\tvec4 transmitted = getIBLVolumeRefraction(\n\t\tn, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\n\t\tpos, modelMatrix, viewMatrix, projectionMatrix, material.dispersion, material.ior, material.thickness,\n\t\tmaterial.attenuationColor, material.attenuationDistance );\n\tmaterial.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n\ttotalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif";
var $079becb54c0579a9$var$transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n\tuniform float transmission;\n\tuniform float thickness;\n\tuniform float attenuationDistance;\n\tuniform vec3 attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tuniform sampler2D transmissionMap;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tuniform sampler2D thicknessMap;\n\t#endif\n\tuniform vec2 transmissionSamplerSize;\n\tuniform sampler2D transmissionSamplerMap;\n\tuniform mat4 modelMatrix;\n\tuniform mat4 projectionMatrix;\n\tvarying vec3 vWorldPosition;\n\tfloat w0( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n\t}\n\tfloat w1( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n\t}\n\tfloat w2( float a ){\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n\t}\n\tfloat w3( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * a * a );\n\t}\n\tfloat g0( float a ) {\n\t\treturn w0( a ) + w1( a );\n\t}\n\tfloat g1( float a ) {\n\t\treturn w2( a ) + w3( a );\n\t}\n\tfloat h0( float a ) {\n\t\treturn - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n\t}\n\tfloat h1( float a ) {\n\t\treturn 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n\t}\n\tvec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n\t\tuv = uv * texelSize.zw + 0.5;\n\t\tvec2 iuv = floor( uv );\n\t\tvec2 fuv = fract( uv );\n\t\tfloat g0x = g0( fuv.x );\n\t\tfloat g1x = g1( fuv.x );\n\t\tfloat h0x = h0( fuv.x );\n\t\tfloat h1x = h1( fuv.x );\n\t\tfloat h0y = h0( fuv.y );\n\t\tfloat h1y = h1( fuv.y );\n\t\tvec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\treturn g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n\t\t\tg1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n\t}\n\tvec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n\t\tvec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n\t\tvec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n\t\tvec2 fLodSizeInv = 1.0 / fLodSize;\n\t\tvec2 cLodSizeInv = 1.0 / cLodSize;\n\t\tvec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n\t\tvec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n\t\treturn mix( fSample, cSample, fract( lod ) );\n\t}\n\tvec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n\t\tvec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n\t\tvec3 modelScale;\n\t\tmodelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n\t\tmodelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n\t\tmodelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n\t\treturn normalize( refractionVector ) * thickness * modelScale;\n\t}\n\tfloat applyIorToRoughness( const in float roughness, const in float ior ) {\n\t\treturn roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n\t}\n\tvec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n\t\tfloat lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n\t\treturn textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n\t}\n\tvec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tif ( isinf( attenuationDistance ) ) {\n\t\t\treturn vec3( 1.0 );\n\t\t} else {\n\t\t\tvec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n\t\t\tvec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );\t\t\treturn transmittance;\n\t\t}\n\t}\n\tvec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n\t\tconst in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n\t\tconst in mat4 viewMatrix, const in mat4 projMatrix, const in float dispersion, const in float ior, const in float thickness,\n\t\tconst in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tvec4 transmittedLight;\n\t\tvec3 transmittance;\n\t\t#ifdef USE_DISPERSION\n\t\t\tfloat halfSpread = ( ior - 1.0 ) * 0.025 * dispersion;\n\t\t\tvec3 iors = vec3( ior - halfSpread, ior, ior + halfSpread );\n\t\t\tfor ( int i = 0; i < 3; i ++ ) {\n\t\t\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, iors[ i ], modelMatrix );\n\t\t\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\t\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\t\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\t\t\trefractionCoords += 1.0;\n\t\t\t\trefractionCoords /= 2.0;\n\t\t\t\tvec4 transmissionSample = getTransmissionSample( refractionCoords, roughness, iors[ i ] );\n\t\t\t\ttransmittedLight[ i ] = transmissionSample[ i ];\n\t\t\t\ttransmittedLight.a += transmissionSample.a;\n\t\t\t\ttransmittance[ i ] = diffuseColor[ i ] * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance )[ i ];\n\t\t\t}\n\t\t\ttransmittedLight.a /= 3.0;\n\t\t#else\n\t\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n\t\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\t\trefractionCoords += 1.0;\n\t\t\trefractionCoords /= 2.0;\n\t\t\ttransmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n\t\t\ttransmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n\t\t#endif\n\t\tvec3 attenuatedColor = transmittance * transmittedLight.rgb;\n\t\tvec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n\t\tfloat transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n\t\treturn vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n\t}\n#endif";
var $079becb54c0579a9$var$uv_pars_fragment = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";
var $079becb54c0579a9$var$uv_pars_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tuniform mat3 mapTransform;\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform mat3 alphaMapTransform;\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tuniform mat3 lightMapTransform;\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tuniform mat3 aoMapTransform;\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tuniform mat3 bumpMapTransform;\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tuniform mat3 normalMapTransform;\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tuniform mat3 displacementMapTransform;\n\tvarying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tuniform mat3 emissiveMapTransform;\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tuniform mat3 metalnessMapTransform;\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tuniform mat3 roughnessMapTransform;\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tuniform mat3 anisotropyMapTransform;\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tuniform mat3 clearcoatMapTransform;\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform mat3 clearcoatNormalMapTransform;\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform mat3 clearcoatRoughnessMapTransform;\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tuniform mat3 sheenColorMapTransform;\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tuniform mat3 sheenRoughnessMapTransform;\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tuniform mat3 iridescenceMapTransform;\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform mat3 iridescenceThicknessMapTransform;\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tuniform mat3 specularMapTransform;\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tuniform mat3 specularColorMapTransform;\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tuniform mat3 specularIntensityMapTransform;\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";
var $079becb54c0579a9$var$uv_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n\tvMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n\tvAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n\tvLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n\tvAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n\tvBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n\tvNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tvDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n\tvMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n\tvSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tvTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n\tvThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif";
var $079becb54c0579a9$var$worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n\tvec4 worldPosition = vec4( transformed, 1.0 );\n\t#ifdef USE_BATCHING\n\t\tworldPosition = batchingMatrix * worldPosition;\n\t#endif\n\t#ifdef USE_INSTANCING\n\t\tworldPosition = instanceMatrix * worldPosition;\n\t#endif\n\tworldPosition = modelMatrix * worldPosition;\n#endif";
var $079becb54c0579a9$var$vertex$h = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
var $079becb54c0579a9$var$fragment$h = "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n\tvec4 texColor = texture2D( t2D, vUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\ttexColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
var $079becb54c0579a9$var$vertex$g = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
var $079becb54c0579a9$var$fragment$g = "#ifdef ENVMAP_TYPE_CUBE\n\tuniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n\tuniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nuniform mat3 backgroundRotation;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 texColor = textureCube( envMap, backgroundRotation * vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\tvec4 texColor = textureCubeUV( envMap, backgroundRotation * vWorldDirection, backgroundBlurriness );\n\t#else\n\t\tvec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
var $079becb54c0579a9$var$vertex$f = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
var $079becb54c0579a9$var$fragment$f = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n\tvec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n\tgl_FragColor = texColor;\n\tgl_FragColor.a *= opacity;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
var $079becb54c0579a9$var$vertex$e = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <skinbase_vertex>\n\t#include <morphinstance_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvHighPrecisionZW = gl_Position.zw;\n}";
var $079becb54c0579a9$var$fragment$e = "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <clipping_planes_fragment>\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <logdepthbuf_fragment>\n\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( fragCoordZ );\n\t#elif DEPTH_PACKING == 3202\n\t\tgl_FragColor = vec4( packDepthToRGB( fragCoordZ ), 1.0 );\n\t#elif DEPTH_PACKING == 3203\n\t\tgl_FragColor = vec4( packDepthToRG( fragCoordZ ), 0.0, 1.0 );\n\t#endif\n}";
var $079becb54c0579a9$var$vertex$d = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <skinbase_vertex>\n\t#include <morphinstance_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}";
var $079becb54c0579a9$var$fragment$d = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <clipping_planes_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = packDepthToRGBA( dist );\n}";
var $079becb54c0579a9$var$vertex$c = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}";
var $079becb54c0579a9$var$fragment$c = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldDirection );\n\tvec2 sampleUV = equirectUv( direction );\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
var $079becb54c0579a9$var$vertex$b = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvLineDistance = scale * lineDistance;\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
var $079becb54c0579a9$var$fragment$b = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
var $079becb54c0579a9$var$vertex$a = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinbase_vertex>\n\t\t#include <skinnormal_vertex>\n\t\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}";
var $079becb54c0579a9$var$fragment$a = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\treflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var $079becb54c0579a9$var$vertex$9 = "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
var $079becb54c0579a9$var$fragment$9 = "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_lambert_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var $079becb54c0579a9$var$vertex$8 = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n\tvViewPosition = - mvPosition.xyz;\n}";
var $079becb54c0579a9$var$fragment$8 = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tvec3 viewDir = normalize( vViewPosition );\n\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n\tvec3 y = cross( viewDir, x );\n\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n\t#ifdef USE_MATCAP\n\t\tvec4 matcapColor = texture2D( matcap, uv );\n\t#else\n\t\tvec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n\t#endif\n\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var $079becb54c0579a9$var$vertex$7 = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}";
var $079becb54c0579a9$var$fragment$7 = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( 0.0, 0.0, 0.0, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), diffuseColor.a );\n\t#ifdef OPAQUE\n\t\tgl_FragColor.a = 1.0;\n\t#endif\n}";
var $079becb54c0579a9$var$vertex$6 = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
var $079becb54c0579a9$var$fragment$6 = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var $079becb54c0579a9$var$vertex$5 = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n\tvarying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n\tvWorldPosition = worldPosition.xyz;\n#endif\n}";
var $079becb54c0579a9$var$fragment$5 = "#define STANDARD\n#ifdef PHYSICAL\n\t#define IOR\n\t#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n\tuniform float ior;\n#endif\n#ifdef USE_SPECULAR\n\tuniform float specularIntensity;\n\tuniform vec3 specularColor;\n\t#ifdef USE_SPECULAR_COLORMAP\n\t\tuniform sampler2D specularColorMap;\n\t#endif\n\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\tuniform sampler2D specularIntensityMap;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_DISPERSION\n\tuniform float dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n\tuniform float iridescence;\n\tuniform float iridescenceIOR;\n\tuniform float iridescenceThicknessMinimum;\n\tuniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheenColor;\n\tuniform float sheenRoughness;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tuniform sampler2D sheenColorMap;\n\t#endif\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tuniform sampler2D sheenRoughnessMap;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\tuniform vec2 anisotropyVector;\n\t#ifdef USE_ANISOTROPYMAP\n\t\tuniform sampler2D anisotropyMap;\n\t#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n\tvec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n\t#include <transmission_fragment>\n\tvec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n\t#ifdef USE_SHEEN\n\t\tfloat sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n\t\toutgoingLight = outgoingLight * sheenEnergyComp + sheenSpecularDirect + sheenSpecularIndirect;\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );\n\t\tvec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n\t\toutgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;\n\t#endif\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var $079becb54c0579a9$var$vertex$4 = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
var $079becb54c0579a9$var$fragment$4 = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_toon_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var $079becb54c0579a9$var$vertex$3 = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n\tvarying vec2 vUv;\n\tuniform mat3 uvTransform;\n#endif\nvoid main() {\n\t#ifdef USE_POINTS_UV\n\t\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\t#endif\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\tgl_PointSize = size;\n\t#ifdef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}";
var $079becb54c0579a9$var$fragment$3 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
var $079becb54c0579a9$var$vertex$2 = "#include <common>\n#include <batching_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
var $079becb54c0579a9$var$fragment$2 = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\t#include <logdepthbuf_fragment>\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}";
var $079becb54c0579a9$var$vertex$1 = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec4 mvPosition = modelViewMatrix[ 3 ];\n\tvec2 scale = vec2( length( modelMatrix[ 0 ].xyz ), length( modelMatrix[ 1 ].xyz ) );\n\t#ifndef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) scale *= - mvPosition.z;\n\t#endif\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
var $079becb54c0579a9$var$fragment$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}";
var $079becb54c0579a9$export$955f9f2e84c43c8b = {
    alphahash_fragment: $079becb54c0579a9$var$alphahash_fragment,
    alphahash_pars_fragment: $079becb54c0579a9$var$alphahash_pars_fragment,
    alphamap_fragment: $079becb54c0579a9$var$alphamap_fragment,
    alphamap_pars_fragment: $079becb54c0579a9$var$alphamap_pars_fragment,
    alphatest_fragment: $079becb54c0579a9$var$alphatest_fragment,
    alphatest_pars_fragment: $079becb54c0579a9$var$alphatest_pars_fragment,
    aomap_fragment: $079becb54c0579a9$var$aomap_fragment,
    aomap_pars_fragment: $079becb54c0579a9$var$aomap_pars_fragment,
    batching_pars_vertex: $079becb54c0579a9$var$batching_pars_vertex,
    batching_vertex: $079becb54c0579a9$var$batching_vertex,
    begin_vertex: $079becb54c0579a9$var$begin_vertex,
    beginnormal_vertex: $079becb54c0579a9$var$beginnormal_vertex,
    bsdfs: $079becb54c0579a9$var$bsdfs,
    iridescence_fragment: $079becb54c0579a9$var$iridescence_fragment,
    bumpmap_pars_fragment: $079becb54c0579a9$var$bumpmap_pars_fragment,
    clipping_planes_fragment: $079becb54c0579a9$var$clipping_planes_fragment,
    clipping_planes_pars_fragment: $079becb54c0579a9$var$clipping_planes_pars_fragment,
    clipping_planes_pars_vertex: $079becb54c0579a9$var$clipping_planes_pars_vertex,
    clipping_planes_vertex: $079becb54c0579a9$var$clipping_planes_vertex,
    color_fragment: $079becb54c0579a9$var$color_fragment,
    color_pars_fragment: $079becb54c0579a9$var$color_pars_fragment,
    color_pars_vertex: $079becb54c0579a9$var$color_pars_vertex,
    color_vertex: $079becb54c0579a9$var$color_vertex,
    common: $079becb54c0579a9$var$common,
    cube_uv_reflection_fragment: $079becb54c0579a9$var$cube_uv_reflection_fragment,
    defaultnormal_vertex: $079becb54c0579a9$var$defaultnormal_vertex,
    displacementmap_pars_vertex: $079becb54c0579a9$var$displacementmap_pars_vertex,
    displacementmap_vertex: $079becb54c0579a9$var$displacementmap_vertex,
    emissivemap_fragment: $079becb54c0579a9$var$emissivemap_fragment,
    emissivemap_pars_fragment: $079becb54c0579a9$var$emissivemap_pars_fragment,
    colorspace_fragment: $079becb54c0579a9$var$colorspace_fragment,
    colorspace_pars_fragment: $079becb54c0579a9$var$colorspace_pars_fragment,
    envmap_fragment: $079becb54c0579a9$var$envmap_fragment,
    envmap_common_pars_fragment: $079becb54c0579a9$var$envmap_common_pars_fragment,
    envmap_pars_fragment: $079becb54c0579a9$var$envmap_pars_fragment,
    envmap_pars_vertex: $079becb54c0579a9$var$envmap_pars_vertex,
    envmap_physical_pars_fragment: $079becb54c0579a9$var$envmap_physical_pars_fragment,
    envmap_vertex: $079becb54c0579a9$var$envmap_vertex,
    fog_vertex: $079becb54c0579a9$var$fog_vertex,
    fog_pars_vertex: $079becb54c0579a9$var$fog_pars_vertex,
    fog_fragment: $079becb54c0579a9$var$fog_fragment,
    fog_pars_fragment: $079becb54c0579a9$var$fog_pars_fragment,
    gradientmap_pars_fragment: $079becb54c0579a9$var$gradientmap_pars_fragment,
    lightmap_pars_fragment: $079becb54c0579a9$var$lightmap_pars_fragment,
    lights_lambert_fragment: $079becb54c0579a9$var$lights_lambert_fragment,
    lights_lambert_pars_fragment: $079becb54c0579a9$var$lights_lambert_pars_fragment,
    lights_pars_begin: $079becb54c0579a9$var$lights_pars_begin,
    lights_toon_fragment: $079becb54c0579a9$var$lights_toon_fragment,
    lights_toon_pars_fragment: $079becb54c0579a9$var$lights_toon_pars_fragment,
    lights_phong_fragment: $079becb54c0579a9$var$lights_phong_fragment,
    lights_phong_pars_fragment: $079becb54c0579a9$var$lights_phong_pars_fragment,
    lights_physical_fragment: $079becb54c0579a9$var$lights_physical_fragment,
    lights_physical_pars_fragment: $079becb54c0579a9$var$lights_physical_pars_fragment,
    lights_fragment_begin: $079becb54c0579a9$var$lights_fragment_begin,
    lights_fragment_maps: $079becb54c0579a9$var$lights_fragment_maps,
    lights_fragment_end: $079becb54c0579a9$var$lights_fragment_end,
    logdepthbuf_fragment: $079becb54c0579a9$var$logdepthbuf_fragment,
    logdepthbuf_pars_fragment: $079becb54c0579a9$var$logdepthbuf_pars_fragment,
    logdepthbuf_pars_vertex: $079becb54c0579a9$var$logdepthbuf_pars_vertex,
    logdepthbuf_vertex: $079becb54c0579a9$var$logdepthbuf_vertex,
    map_fragment: $079becb54c0579a9$var$map_fragment,
    map_pars_fragment: $079becb54c0579a9$var$map_pars_fragment,
    map_particle_fragment: $079becb54c0579a9$var$map_particle_fragment,
    map_particle_pars_fragment: $079becb54c0579a9$var$map_particle_pars_fragment,
    metalnessmap_fragment: $079becb54c0579a9$var$metalnessmap_fragment,
    metalnessmap_pars_fragment: $079becb54c0579a9$var$metalnessmap_pars_fragment,
    morphinstance_vertex: $079becb54c0579a9$var$morphinstance_vertex,
    morphcolor_vertex: $079becb54c0579a9$var$morphcolor_vertex,
    morphnormal_vertex: $079becb54c0579a9$var$morphnormal_vertex,
    morphtarget_pars_vertex: $079becb54c0579a9$var$morphtarget_pars_vertex,
    morphtarget_vertex: $079becb54c0579a9$var$morphtarget_vertex,
    normal_fragment_begin: $079becb54c0579a9$var$normal_fragment_begin,
    normal_fragment_maps: $079becb54c0579a9$var$normal_fragment_maps,
    normal_pars_fragment: $079becb54c0579a9$var$normal_pars_fragment,
    normal_pars_vertex: $079becb54c0579a9$var$normal_pars_vertex,
    normal_vertex: $079becb54c0579a9$var$normal_vertex,
    normalmap_pars_fragment: $079becb54c0579a9$var$normalmap_pars_fragment,
    clearcoat_normal_fragment_begin: $079becb54c0579a9$var$clearcoat_normal_fragment_begin,
    clearcoat_normal_fragment_maps: $079becb54c0579a9$var$clearcoat_normal_fragment_maps,
    clearcoat_pars_fragment: $079becb54c0579a9$var$clearcoat_pars_fragment,
    iridescence_pars_fragment: $079becb54c0579a9$var$iridescence_pars_fragment,
    opaque_fragment: $079becb54c0579a9$var$opaque_fragment,
    packing: $079becb54c0579a9$var$packing,
    premultiplied_alpha_fragment: $079becb54c0579a9$var$premultiplied_alpha_fragment,
    project_vertex: $079becb54c0579a9$var$project_vertex,
    dithering_fragment: $079becb54c0579a9$var$dithering_fragment,
    dithering_pars_fragment: $079becb54c0579a9$var$dithering_pars_fragment,
    roughnessmap_fragment: $079becb54c0579a9$var$roughnessmap_fragment,
    roughnessmap_pars_fragment: $079becb54c0579a9$var$roughnessmap_pars_fragment,
    shadowmap_pars_fragment: $079becb54c0579a9$var$shadowmap_pars_fragment,
    shadowmap_pars_vertex: $079becb54c0579a9$var$shadowmap_pars_vertex,
    shadowmap_vertex: $079becb54c0579a9$var$shadowmap_vertex,
    shadowmask_pars_fragment: $079becb54c0579a9$var$shadowmask_pars_fragment,
    skinbase_vertex: $079becb54c0579a9$var$skinbase_vertex,
    skinning_pars_vertex: $079becb54c0579a9$var$skinning_pars_vertex,
    skinning_vertex: $079becb54c0579a9$var$skinning_vertex,
    skinnormal_vertex: $079becb54c0579a9$var$skinnormal_vertex,
    specularmap_fragment: $079becb54c0579a9$var$specularmap_fragment,
    specularmap_pars_fragment: $079becb54c0579a9$var$specularmap_pars_fragment,
    tonemapping_fragment: $079becb54c0579a9$var$tonemapping_fragment,
    tonemapping_pars_fragment: $079becb54c0579a9$var$tonemapping_pars_fragment,
    transmission_fragment: $079becb54c0579a9$var$transmission_fragment,
    transmission_pars_fragment: $079becb54c0579a9$var$transmission_pars_fragment,
    uv_pars_fragment: $079becb54c0579a9$var$uv_pars_fragment,
    uv_pars_vertex: $079becb54c0579a9$var$uv_pars_vertex,
    uv_vertex: $079becb54c0579a9$var$uv_vertex,
    worldpos_vertex: $079becb54c0579a9$var$worldpos_vertex,
    background_vert: $079becb54c0579a9$var$vertex$h,
    background_frag: $079becb54c0579a9$var$fragment$h,
    backgroundCube_vert: $079becb54c0579a9$var$vertex$g,
    backgroundCube_frag: $079becb54c0579a9$var$fragment$g,
    cube_vert: $079becb54c0579a9$var$vertex$f,
    cube_frag: $079becb54c0579a9$var$fragment$f,
    depth_vert: $079becb54c0579a9$var$vertex$e,
    depth_frag: $079becb54c0579a9$var$fragment$e,
    distanceRGBA_vert: $079becb54c0579a9$var$vertex$d,
    distanceRGBA_frag: $079becb54c0579a9$var$fragment$d,
    equirect_vert: $079becb54c0579a9$var$vertex$c,
    equirect_frag: $079becb54c0579a9$var$fragment$c,
    linedashed_vert: $079becb54c0579a9$var$vertex$b,
    linedashed_frag: $079becb54c0579a9$var$fragment$b,
    meshbasic_vert: $079becb54c0579a9$var$vertex$a,
    meshbasic_frag: $079becb54c0579a9$var$fragment$a,
    meshlambert_vert: $079becb54c0579a9$var$vertex$9,
    meshlambert_frag: $079becb54c0579a9$var$fragment$9,
    meshmatcap_vert: $079becb54c0579a9$var$vertex$8,
    meshmatcap_frag: $079becb54c0579a9$var$fragment$8,
    meshnormal_vert: $079becb54c0579a9$var$vertex$7,
    meshnormal_frag: $079becb54c0579a9$var$fragment$7,
    meshphong_vert: $079becb54c0579a9$var$vertex$6,
    meshphong_frag: $079becb54c0579a9$var$fragment$6,
    meshphysical_vert: $079becb54c0579a9$var$vertex$5,
    meshphysical_frag: $079becb54c0579a9$var$fragment$5,
    meshtoon_vert: $079becb54c0579a9$var$vertex$4,
    meshtoon_frag: $079becb54c0579a9$var$fragment$4,
    points_vert: $079becb54c0579a9$var$vertex$3,
    points_frag: $079becb54c0579a9$var$fragment$3,
    shadow_vert: $079becb54c0579a9$var$vertex$2,
    shadow_frag: $079becb54c0579a9$var$fragment$2,
    sprite_vert: $079becb54c0579a9$var$vertex$1,
    sprite_frag: $079becb54c0579a9$var$fragment$1
};
/**
 * Uniforms library for shared webgl shaders
 */ var $079becb54c0579a9$export$6643083551874bf5 = {
    common: {
        diffuse: {
            value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$892596cec99bc70e)(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$8ff26dafa08918)()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$8ff26dafa08918)()
        },
        alphaTest: {
            value: 0
        }
    },
    specularmap: {
        specularMap: {
            value: null
        },
        specularMapTransform: {
            value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$8ff26dafa08918)()
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        envMapRotation: {
            value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$8ff26dafa08918)()
        },
        flipEnvMap: {
            value: -1
        },
        reflectivity: {
            value: 1.0
        },
        ior: {
            value: 1.5
        },
        refractionRatio: {
            value: 0.98
        }
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        },
        aoMapTransform: {
            value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$8ff26dafa08918)()
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        },
        lightMapTransform: {
            value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$8ff26dafa08918)()
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpMapTransform: {
            value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$8ff26dafa08918)()
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalMapTransform: {
            value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$8ff26dafa08918)()
        },
        normalScale: {
            value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$c977b3e384af9ae1)(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementMapTransform: {
            value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$8ff26dafa08918)()
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        },
        emissiveMapTransform: {
            value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$8ff26dafa08918)()
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        },
        metalnessMapTransform: {
            value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$8ff26dafa08918)()
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        },
        roughnessMapTransform: {
            value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$8ff26dafa08918)()
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 0.00025
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2000
        },
        fogColor: {
            value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$892596cec99bc70e)(0xffffff)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMap: {
            value: []
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotLightMap: {
            value: []
        },
        spotShadowMap: {
            value: []
        },
        spotLightMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMap: {
            value: []
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        }
    },
    points: {
        diffuse: {
            value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$892596cec99bc70e)(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        size: {
            value: 1.0
        },
        scale: {
            value: 1.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$8ff26dafa08918)()
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$8ff26dafa08918)()
        }
    },
    sprite: {
        diffuse: {
            value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$892596cec99bc70e)(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        center: {
            value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$c977b3e384af9ae1)(0.5, 0.5)
        },
        rotation: {
            value: 0.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$8ff26dafa08918)()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$8ff26dafa08918)()
        },
        alphaTest: {
            value: 0
        }
    }
};
var $079becb54c0579a9$export$bee4a7d47f8f5014 = {
    basic: {
        uniforms: /*@__PURE__*/ (0, $1a55656020b89c3a$export$8916ce6879271f43)([
            $079becb54c0579a9$export$6643083551874bf5.common,
            $079becb54c0579a9$export$6643083551874bf5.specularmap,
            $079becb54c0579a9$export$6643083551874bf5.envmap,
            $079becb54c0579a9$export$6643083551874bf5.aomap,
            $079becb54c0579a9$export$6643083551874bf5.lightmap,
            $079becb54c0579a9$export$6643083551874bf5.fog
        ]),
        vertexShader: $079becb54c0579a9$export$955f9f2e84c43c8b.meshbasic_vert,
        fragmentShader: $079becb54c0579a9$export$955f9f2e84c43c8b.meshbasic_frag
    },
    lambert: {
        uniforms: /*@__PURE__*/ (0, $1a55656020b89c3a$export$8916ce6879271f43)([
            $079becb54c0579a9$export$6643083551874bf5.common,
            $079becb54c0579a9$export$6643083551874bf5.specularmap,
            $079becb54c0579a9$export$6643083551874bf5.envmap,
            $079becb54c0579a9$export$6643083551874bf5.aomap,
            $079becb54c0579a9$export$6643083551874bf5.lightmap,
            $079becb54c0579a9$export$6643083551874bf5.emissivemap,
            $079becb54c0579a9$export$6643083551874bf5.bumpmap,
            $079becb54c0579a9$export$6643083551874bf5.normalmap,
            $079becb54c0579a9$export$6643083551874bf5.displacementmap,
            $079becb54c0579a9$export$6643083551874bf5.fog,
            $079becb54c0579a9$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$892596cec99bc70e)(0x000000)
                }
            }
        ]),
        vertexShader: $079becb54c0579a9$export$955f9f2e84c43c8b.meshlambert_vert,
        fragmentShader: $079becb54c0579a9$export$955f9f2e84c43c8b.meshlambert_frag
    },
    phong: {
        uniforms: /*@__PURE__*/ (0, $1a55656020b89c3a$export$8916ce6879271f43)([
            $079becb54c0579a9$export$6643083551874bf5.common,
            $079becb54c0579a9$export$6643083551874bf5.specularmap,
            $079becb54c0579a9$export$6643083551874bf5.envmap,
            $079becb54c0579a9$export$6643083551874bf5.aomap,
            $079becb54c0579a9$export$6643083551874bf5.lightmap,
            $079becb54c0579a9$export$6643083551874bf5.emissivemap,
            $079becb54c0579a9$export$6643083551874bf5.bumpmap,
            $079becb54c0579a9$export$6643083551874bf5.normalmap,
            $079becb54c0579a9$export$6643083551874bf5.displacementmap,
            $079becb54c0579a9$export$6643083551874bf5.fog,
            $079becb54c0579a9$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$892596cec99bc70e)(0x000000)
                },
                specular: {
                    value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$892596cec99bc70e)(0x111111)
                },
                shininess: {
                    value: 30
                }
            }
        ]),
        vertexShader: $079becb54c0579a9$export$955f9f2e84c43c8b.meshphong_vert,
        fragmentShader: $079becb54c0579a9$export$955f9f2e84c43c8b.meshphong_frag
    },
    standard: {
        uniforms: /*@__PURE__*/ (0, $1a55656020b89c3a$export$8916ce6879271f43)([
            $079becb54c0579a9$export$6643083551874bf5.common,
            $079becb54c0579a9$export$6643083551874bf5.envmap,
            $079becb54c0579a9$export$6643083551874bf5.aomap,
            $079becb54c0579a9$export$6643083551874bf5.lightmap,
            $079becb54c0579a9$export$6643083551874bf5.emissivemap,
            $079becb54c0579a9$export$6643083551874bf5.bumpmap,
            $079becb54c0579a9$export$6643083551874bf5.normalmap,
            $079becb54c0579a9$export$6643083551874bf5.displacementmap,
            $079becb54c0579a9$export$6643083551874bf5.roughnessmap,
            $079becb54c0579a9$export$6643083551874bf5.metalnessmap,
            $079becb54c0579a9$export$6643083551874bf5.fog,
            $079becb54c0579a9$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$892596cec99bc70e)(0x000000)
                },
                roughness: {
                    value: 1.0
                },
                metalness: {
                    value: 0.0
                },
                envMapIntensity: {
                    value: 1
                }
            }
        ]),
        vertexShader: $079becb54c0579a9$export$955f9f2e84c43c8b.meshphysical_vert,
        fragmentShader: $079becb54c0579a9$export$955f9f2e84c43c8b.meshphysical_frag
    },
    toon: {
        uniforms: /*@__PURE__*/ (0, $1a55656020b89c3a$export$8916ce6879271f43)([
            $079becb54c0579a9$export$6643083551874bf5.common,
            $079becb54c0579a9$export$6643083551874bf5.aomap,
            $079becb54c0579a9$export$6643083551874bf5.lightmap,
            $079becb54c0579a9$export$6643083551874bf5.emissivemap,
            $079becb54c0579a9$export$6643083551874bf5.bumpmap,
            $079becb54c0579a9$export$6643083551874bf5.normalmap,
            $079becb54c0579a9$export$6643083551874bf5.displacementmap,
            $079becb54c0579a9$export$6643083551874bf5.gradientmap,
            $079becb54c0579a9$export$6643083551874bf5.fog,
            $079becb54c0579a9$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$892596cec99bc70e)(0x000000)
                }
            }
        ]),
        vertexShader: $079becb54c0579a9$export$955f9f2e84c43c8b.meshtoon_vert,
        fragmentShader: $079becb54c0579a9$export$955f9f2e84c43c8b.meshtoon_frag
    },
    matcap: {
        uniforms: /*@__PURE__*/ (0, $1a55656020b89c3a$export$8916ce6879271f43)([
            $079becb54c0579a9$export$6643083551874bf5.common,
            $079becb54c0579a9$export$6643083551874bf5.bumpmap,
            $079becb54c0579a9$export$6643083551874bf5.normalmap,
            $079becb54c0579a9$export$6643083551874bf5.displacementmap,
            $079becb54c0579a9$export$6643083551874bf5.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: $079becb54c0579a9$export$955f9f2e84c43c8b.meshmatcap_vert,
        fragmentShader: $079becb54c0579a9$export$955f9f2e84c43c8b.meshmatcap_frag
    },
    points: {
        uniforms: /*@__PURE__*/ (0, $1a55656020b89c3a$export$8916ce6879271f43)([
            $079becb54c0579a9$export$6643083551874bf5.points,
            $079becb54c0579a9$export$6643083551874bf5.fog
        ]),
        vertexShader: $079becb54c0579a9$export$955f9f2e84c43c8b.points_vert,
        fragmentShader: $079becb54c0579a9$export$955f9f2e84c43c8b.points_frag
    },
    dashed: {
        uniforms: /*@__PURE__*/ (0, $1a55656020b89c3a$export$8916ce6879271f43)([
            $079becb54c0579a9$export$6643083551874bf5.common,
            $079becb54c0579a9$export$6643083551874bf5.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: $079becb54c0579a9$export$955f9f2e84c43c8b.linedashed_vert,
        fragmentShader: $079becb54c0579a9$export$955f9f2e84c43c8b.linedashed_frag
    },
    depth: {
        uniforms: /*@__PURE__*/ (0, $1a55656020b89c3a$export$8916ce6879271f43)([
            $079becb54c0579a9$export$6643083551874bf5.common,
            $079becb54c0579a9$export$6643083551874bf5.displacementmap
        ]),
        vertexShader: $079becb54c0579a9$export$955f9f2e84c43c8b.depth_vert,
        fragmentShader: $079becb54c0579a9$export$955f9f2e84c43c8b.depth_frag
    },
    normal: {
        uniforms: /*@__PURE__*/ (0, $1a55656020b89c3a$export$8916ce6879271f43)([
            $079becb54c0579a9$export$6643083551874bf5.common,
            $079becb54c0579a9$export$6643083551874bf5.bumpmap,
            $079becb54c0579a9$export$6643083551874bf5.normalmap,
            $079becb54c0579a9$export$6643083551874bf5.displacementmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $079becb54c0579a9$export$955f9f2e84c43c8b.meshnormal_vert,
        fragmentShader: $079becb54c0579a9$export$955f9f2e84c43c8b.meshnormal_frag
    },
    sprite: {
        uniforms: /*@__PURE__*/ (0, $1a55656020b89c3a$export$8916ce6879271f43)([
            $079becb54c0579a9$export$6643083551874bf5.sprite,
            $079becb54c0579a9$export$6643083551874bf5.fog
        ]),
        vertexShader: $079becb54c0579a9$export$955f9f2e84c43c8b.sprite_vert,
        fragmentShader: $079becb54c0579a9$export$955f9f2e84c43c8b.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$8ff26dafa08918)()
            },
            t2D: {
                value: null
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: $079becb54c0579a9$export$955f9f2e84c43c8b.background_vert,
        fragmentShader: $079becb54c0579a9$export$955f9f2e84c43c8b.background_frag
    },
    backgroundCube: {
        uniforms: {
            envMap: {
                value: null
            },
            flipEnvMap: {
                value: -1
            },
            backgroundBlurriness: {
                value: 0
            },
            backgroundIntensity: {
                value: 1
            },
            backgroundRotation: {
                value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$8ff26dafa08918)()
            }
        },
        vertexShader: $079becb54c0579a9$export$955f9f2e84c43c8b.backgroundCube_vert,
        fragmentShader: $079becb54c0579a9$export$955f9f2e84c43c8b.backgroundCube_frag
    },
    cube: {
        uniforms: {
            tCube: {
                value: null
            },
            tFlip: {
                value: -1
            },
            opacity: {
                value: 1.0
            }
        },
        vertexShader: $079becb54c0579a9$export$955f9f2e84c43c8b.cube_vert,
        fragmentShader: $079becb54c0579a9$export$955f9f2e84c43c8b.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: $079becb54c0579a9$export$955f9f2e84c43c8b.equirect_vert,
        fragmentShader: $079becb54c0579a9$export$955f9f2e84c43c8b.equirect_frag
    },
    distanceRGBA: {
        uniforms: /*@__PURE__*/ (0, $1a55656020b89c3a$export$8916ce6879271f43)([
            $079becb54c0579a9$export$6643083551874bf5.common,
            $079becb54c0579a9$export$6643083551874bf5.displacementmap,
            {
                referencePosition: {
                    value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$64b5c384219d3699)()
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1000
                }
            }
        ]),
        vertexShader: $079becb54c0579a9$export$955f9f2e84c43c8b.distanceRGBA_vert,
        fragmentShader: $079becb54c0579a9$export$955f9f2e84c43c8b.distanceRGBA_frag
    },
    shadow: {
        uniforms: /*@__PURE__*/ (0, $1a55656020b89c3a$export$8916ce6879271f43)([
            $079becb54c0579a9$export$6643083551874bf5.lights,
            $079becb54c0579a9$export$6643083551874bf5.fog,
            {
                color: {
                    value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$892596cec99bc70e)(0x00000)
                },
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $079becb54c0579a9$export$955f9f2e84c43c8b.shadow_vert,
        fragmentShader: $079becb54c0579a9$export$955f9f2e84c43c8b.shadow_frag
    }
};
$079becb54c0579a9$export$bee4a7d47f8f5014.physical = {
    uniforms: /*@__PURE__*/ (0, $1a55656020b89c3a$export$8916ce6879271f43)([
        $079becb54c0579a9$export$bee4a7d47f8f5014.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatMapTransform: {
                value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$8ff26dafa08918)()
            },
            clearcoatNormalMap: {
                value: null
            },
            clearcoatNormalMapTransform: {
                value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$8ff26dafa08918)()
            },
            clearcoatNormalScale: {
                value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$c977b3e384af9ae1)(1, 1)
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatRoughnessMapTransform: {
                value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$8ff26dafa08918)()
            },
            dispersion: {
                value: 0
            },
            iridescence: {
                value: 0
            },
            iridescenceMap: {
                value: null
            },
            iridescenceMapTransform: {
                value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$8ff26dafa08918)()
            },
            iridescenceIOR: {
                value: 1.3
            },
            iridescenceThicknessMinimum: {
                value: 100
            },
            iridescenceThicknessMaximum: {
                value: 400
            },
            iridescenceThicknessMap: {
                value: null
            },
            iridescenceThicknessMapTransform: {
                value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$8ff26dafa08918)()
            },
            sheen: {
                value: 0
            },
            sheenColor: {
                value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$892596cec99bc70e)(0x000000)
            },
            sheenColorMap: {
                value: null
            },
            sheenColorMapTransform: {
                value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$8ff26dafa08918)()
            },
            sheenRoughness: {
                value: 1
            },
            sheenRoughnessMap: {
                value: null
            },
            sheenRoughnessMapTransform: {
                value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$8ff26dafa08918)()
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            },
            transmissionMapTransform: {
                value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$8ff26dafa08918)()
            },
            transmissionSamplerSize: {
                value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$c977b3e384af9ae1)()
            },
            transmissionSamplerMap: {
                value: null
            },
            thickness: {
                value: 0
            },
            thicknessMap: {
                value: null
            },
            thicknessMapTransform: {
                value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$8ff26dafa08918)()
            },
            attenuationDistance: {
                value: 0
            },
            attenuationColor: {
                value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$892596cec99bc70e)(0x000000)
            },
            specularColor: {
                value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$892596cec99bc70e)(1, 1, 1)
            },
            specularColorMap: {
                value: null
            },
            specularColorMapTransform: {
                value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$8ff26dafa08918)()
            },
            specularIntensity: {
                value: 1
            },
            specularIntensityMap: {
                value: null
            },
            specularIntensityMapTransform: {
                value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$8ff26dafa08918)()
            },
            anisotropyVector: {
                value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$c977b3e384af9ae1)()
            },
            anisotropyMap: {
                value: null
            },
            anisotropyMapTransform: {
                value: /*@__PURE__*/ new (0, $1a55656020b89c3a$export$8ff26dafa08918)()
            }
        }
    ]),
    vertexShader: $079becb54c0579a9$export$955f9f2e84c43c8b.meshphysical_vert,
    fragmentShader: $079becb54c0579a9$export$955f9f2e84c43c8b.meshphysical_frag
};
var $079becb54c0579a9$var$_rgb = {
    r: 0,
    b: 0,
    g: 0
};
var $079becb54c0579a9$var$_e1$1 = /*@__PURE__*/ new (0, $1a55656020b89c3a$export$d93cc409a0768c5f)();
var $079becb54c0579a9$var$_m1$1 = /*@__PURE__*/ new (0, $1a55656020b89c3a$export$2ae72fc923e5eb5)();
function $079becb54c0579a9$var$WebGLBackground(renderer, cubemaps, cubeuvmaps, state, objects, alpha, premultipliedAlpha) {
    var clearColor = new (0, $1a55656020b89c3a$export$892596cec99bc70e)(0x000000);
    var clearAlpha = alpha === true ? 0 : 1;
    var planeMesh;
    var boxMesh;
    var currentBackground = null;
    var currentBackgroundVersion = 0;
    var currentTonemapping = null;
    function getBackground(scene) {
        var background = scene.isScene === true ? scene.background : null;
        if (background && background.isTexture) {
            var usePMREM = scene.backgroundBlurriness > 0; // use PMREM if the user wants to blur the background
            background = (usePMREM ? cubeuvmaps : cubemaps).get(background);
        }
        return background;
    }
    function render(scene) {
        var forceClear = false;
        var background = getBackground(scene);
        if (background === null) setClear(clearColor, clearAlpha);
        else if (background && background.isColor) {
            setClear(background, 1);
            forceClear = true;
        }
        var environmentBlendMode = renderer.xr.getEnvironmentBlendMode();
        if (environmentBlendMode === 'additive') state.buffers.color.setClear(0, 0, 0, 1, premultipliedAlpha);
        else if (environmentBlendMode === 'alpha-blend') state.buffers.color.setClear(0, 0, 0, 0, premultipliedAlpha);
        if (renderer.autoClear || forceClear) {
            // buffers might not be writable which is required to ensure a correct clear
            state.buffers.depth.setTest(true);
            state.buffers.depth.setMask(true);
            state.buffers.color.setMask(true);
            renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
        }
    }
    function addToRenderList(renderList, scene) {
        var background = getBackground(scene);
        if (background && (background.isCubeTexture || background.mapping === (0, $1a55656020b89c3a$export$dbf3e70ff37af79))) {
            if (boxMesh === undefined) {
                boxMesh = new (0, $1a55656020b89c3a$export$e176487c05830cc5)(new (0, $1a55656020b89c3a$export$33e43285f7406bd5)(1, 1, 1), new (0, $1a55656020b89c3a$export$83c7d75d550a8b0d)({
                    name: 'BackgroundCubeMaterial',
                    uniforms: (0, $1a55656020b89c3a$export$acda854380553452)($079becb54c0579a9$export$bee4a7d47f8f5014.backgroundCube.uniforms),
                    vertexShader: $079becb54c0579a9$export$bee4a7d47f8f5014.backgroundCube.vertexShader,
                    fragmentShader: $079becb54c0579a9$export$bee4a7d47f8f5014.backgroundCube.fragmentShader,
                    side: (0, $1a55656020b89c3a$export$d9f0486e75b5ace),
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                boxMesh.geometry.deleteAttribute('normal');
                boxMesh.geometry.deleteAttribute('uv');
                boxMesh.onBeforeRender = function(renderer, scene, camera) {
                    this.matrixWorld.copyPosition(camera.matrixWorld);
                };
                // add "envMap" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(boxMesh.material, 'envMap', {
                    get: function get() {
                        return this.uniforms.envMap.value;
                    }
                });
                objects.update(boxMesh);
            }
            $079becb54c0579a9$var$_e1$1.copy(scene.backgroundRotation);
            // accommodate left-handed frame
            $079becb54c0579a9$var$_e1$1.x *= -1;
            $079becb54c0579a9$var$_e1$1.y *= -1;
            $079becb54c0579a9$var$_e1$1.z *= -1;
            if (background.isCubeTexture && background.isRenderTargetTexture === false) {
                // environment maps which are not cube render targets or PMREMs follow a different convention
                $079becb54c0579a9$var$_e1$1.y *= -1;
                $079becb54c0579a9$var$_e1$1.z *= -1;
            }
            boxMesh.material.uniforms.envMap.value = background;
            boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background.isRenderTargetTexture === false ? -1 : 1;
            boxMesh.material.uniforms.backgroundBlurriness.value = scene.backgroundBlurriness;
            boxMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            boxMesh.material.uniforms.backgroundRotation.value.setFromMatrix4($079becb54c0579a9$var$_m1$1.makeRotationFromEuler($079becb54c0579a9$var$_e1$1));
            boxMesh.material.toneMapped = (0, $1a55656020b89c3a$export$5e6fd513f44698c).getTransfer(background.colorSpace) !== (0, $1a55656020b89c3a$export$8d0a61916cc26abb);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                boxMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            boxMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
        } else if (background && background.isTexture) {
            if (planeMesh === undefined) {
                planeMesh = new (0, $1a55656020b89c3a$export$e176487c05830cc5)(new (0, $1a55656020b89c3a$export$967d831af31f69ce)(2, 2), new (0, $1a55656020b89c3a$export$83c7d75d550a8b0d)({
                    name: 'BackgroundMaterial',
                    uniforms: (0, $1a55656020b89c3a$export$acda854380553452)($079becb54c0579a9$export$bee4a7d47f8f5014.background.uniforms),
                    vertexShader: $079becb54c0579a9$export$bee4a7d47f8f5014.background.vertexShader,
                    fragmentShader: $079becb54c0579a9$export$bee4a7d47f8f5014.background.fragmentShader,
                    side: (0, $1a55656020b89c3a$export$2ede184fc2998901),
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                planeMesh.geometry.deleteAttribute('normal');
                // add "map" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(planeMesh.material, 'map', {
                    get: function get() {
                        return this.uniforms.t2D.value;
                    }
                });
                objects.update(planeMesh);
            }
            planeMesh.material.uniforms.t2D.value = background;
            planeMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            planeMesh.material.toneMapped = (0, $1a55656020b89c3a$export$5e6fd513f44698c).getTransfer(background.colorSpace) !== (0, $1a55656020b89c3a$export$8d0a61916cc26abb);
            if (background.matrixAutoUpdate === true) background.updateMatrix();
            planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                planeMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            planeMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
        }
    }
    function setClear(color, alpha) {
        color.getRGB($079becb54c0579a9$var$_rgb, (0, $1a55656020b89c3a$export$a630742c640528c1)(renderer));
        state.buffers.color.setClear($079becb54c0579a9$var$_rgb.r, $079becb54c0579a9$var$_rgb.g, $079becb54c0579a9$var$_rgb.b, alpha, premultipliedAlpha);
    }
    function dispose() {
        if (boxMesh !== undefined) {
            boxMesh.geometry.dispose();
            boxMesh.material.dispose();
            boxMesh = undefined;
        }
        if (planeMesh !== undefined) {
            planeMesh.geometry.dispose();
            planeMesh.material.dispose();
            planeMesh = undefined;
        }
    }
    return {
        getClearColor: function getClearColor() {
            return clearColor;
        },
        setClearColor: function setClearColor(color) {
            var _$alpha = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
            clearColor.set(color);
            clearAlpha = _$alpha;
            setClear(clearColor, clearAlpha);
        },
        getClearAlpha: function getClearAlpha() {
            return clearAlpha;
        },
        setClearAlpha: function setClearAlpha(alpha) {
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        render: render,
        addToRenderList: addToRenderList,
        dispose: dispose
    };
}
function $079becb54c0579a9$var$WebGLBindingStates(gl, attributes) {
    var maxVertexAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    var bindingStates = {};
    var defaultState = createBindingState(null);
    var currentState = defaultState;
    var forceUpdate = false;
    function setup(object, material, program, geometry, index) {
        var updateBuffers = false;
        var state = getBindingState(geometry, program, material);
        if (currentState !== state) {
            currentState = state;
            bindVertexArrayObject(currentState.object);
        }
        updateBuffers = needsUpdate(object, geometry, program, index);
        if (updateBuffers) saveCache(object, geometry, program, index);
        if (index !== null) attributes.update(index, gl.ELEMENT_ARRAY_BUFFER);
        if (updateBuffers || forceUpdate) {
            forceUpdate = false;
            setupVertexAttributes(object, material, program, geometry);
            if (index !== null) gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, attributes.get(index).buffer);
        }
    }
    function createVertexArrayObject() {
        return gl.createVertexArray();
    }
    function bindVertexArrayObject(vao) {
        return gl.bindVertexArray(vao);
    }
    function deleteVertexArrayObject(vao) {
        return gl.deleteVertexArray(vao);
    }
    function getBindingState(geometry, program, material) {
        var wireframe = material.wireframe === true;
        var programMap = bindingStates[geometry.id];
        if (programMap === undefined) {
            programMap = {};
            bindingStates[geometry.id] = programMap;
        }
        var stateMap = programMap[program.id];
        if (stateMap === undefined) {
            stateMap = {};
            programMap[program.id] = stateMap;
        }
        var state = stateMap[wireframe];
        if (state === undefined) {
            state = createBindingState(createVertexArrayObject());
            stateMap[wireframe] = state;
        }
        return state;
    }
    function createBindingState(vao) {
        var newAttributes = [];
        var enabledAttributes = [];
        var attributeDivisors = [];
        for(var i = 0; i < maxVertexAttributes; i++){
            newAttributes[i] = 0;
            enabledAttributes[i] = 0;
            attributeDivisors[i] = 0;
        }
        return {
            // for backward compatibility on non-VAO support browser
            geometry: null,
            program: null,
            wireframe: false,
            newAttributes: newAttributes,
            enabledAttributes: enabledAttributes,
            attributeDivisors: attributeDivisors,
            object: vao,
            attributes: {},
            index: null
        };
    }
    function needsUpdate(object, geometry, program, index) {
        var cachedAttributes = currentState.attributes;
        var geometryAttributes = geometry.attributes;
        var attributesNum = 0;
        var programAttributes = program.getAttributes();
        for(var name in programAttributes){
            var programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                var cachedAttribute = cachedAttributes[name];
                var geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (cachedAttribute === undefined) return true;
                if (cachedAttribute.attribute !== geometryAttribute) return true;
                if (geometryAttribute && cachedAttribute.data !== geometryAttribute.data) return true;
                attributesNum++;
            }
        }
        if (currentState.attributesNum !== attributesNum) return true;
        if (currentState.index !== index) return true;
        return false;
    }
    function saveCache(object, geometry, program, index) {
        var cache = {};
        var attributes = geometry.attributes;
        var attributesNum = 0;
        var programAttributes = program.getAttributes();
        for(var name in programAttributes){
            var programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                var attribute = attributes[name];
                if (attribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) attribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) attribute = object.instanceColor;
                }
                var data = {};
                data.attribute = attribute;
                if (attribute && attribute.data) data.data = attribute.data;
                cache[name] = data;
                attributesNum++;
            }
        }
        currentState.attributes = cache;
        currentState.attributesNum = attributesNum;
        currentState.index = index;
    }
    function initAttributes() {
        var newAttributes = currentState.newAttributes;
        for(var i = 0, il = newAttributes.length; i < il; i++)newAttributes[i] = 0;
    }
    function enableAttribute(attribute) {
        enableAttributeAndDivisor(attribute, 0);
    }
    function enableAttributeAndDivisor(attribute, meshPerAttribute) {
        var newAttributes = currentState.newAttributes;
        var enabledAttributes = currentState.enabledAttributes;
        var attributeDivisors = currentState.attributeDivisors;
        newAttributes[attribute] = 1;
        if (enabledAttributes[attribute] === 0) {
            gl.enableVertexAttribArray(attribute);
            enabledAttributes[attribute] = 1;
        }
        if (attributeDivisors[attribute] !== meshPerAttribute) {
            gl.vertexAttribDivisor(attribute, meshPerAttribute);
            attributeDivisors[attribute] = meshPerAttribute;
        }
    }
    function disableUnusedAttributes() {
        var newAttributes = currentState.newAttributes;
        var enabledAttributes = currentState.enabledAttributes;
        for(var i = 0, il = enabledAttributes.length; i < il; i++)if (enabledAttributes[i] !== newAttributes[i]) {
            gl.disableVertexAttribArray(i);
            enabledAttributes[i] = 0;
        }
    }
    function vertexAttribPointer(index, size, type, normalized, stride, offset, integer) {
        if (integer === true) gl.vertexAttribIPointer(index, size, type, stride, offset);
        else gl.vertexAttribPointer(index, size, type, normalized, stride, offset);
    }
    function setupVertexAttributes(object, material, program, geometry) {
        initAttributes();
        var geometryAttributes = geometry.attributes;
        var programAttributes = program.getAttributes();
        var materialDefaultAttributeValues = material.defaultAttributeValues;
        for(var name in programAttributes){
            var programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                var geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (geometryAttribute !== undefined) {
                    var normalized = geometryAttribute.normalized;
                    var size = geometryAttribute.itemSize;
                    var attribute = attributes.get(geometryAttribute);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    var buffer = attribute.buffer;
                    var type = attribute.type;
                    var bytesPerElement = attribute.bytesPerElement;
                    // check for integer attributes
                    var integer = type === gl.INT || type === gl.UNSIGNED_INT || geometryAttribute.gpuType === (0, $1a55656020b89c3a$export$5c612977753abe2);
                    if (geometryAttribute.isInterleavedBufferAttribute) {
                        var data = geometryAttribute.data;
                        var stride = data.stride;
                        var offset = geometryAttribute.offset;
                        if (data.isInstancedInterleavedBuffer) {
                            for(var i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, data.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = data.meshPerAttribute * data.count;
                        } else for(var i1 = 0; i1 < programAttribute.locationSize; i1++)enableAttribute(programAttribute.location + i1);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(var i2 = 0; i2 < programAttribute.locationSize; i2++)vertexAttribPointer(programAttribute.location + i2, size / programAttribute.locationSize, type, normalized, stride * bytesPerElement, (offset + size / programAttribute.locationSize * i2) * bytesPerElement, integer);
                    } else {
                        if (geometryAttribute.isInstancedBufferAttribute) {
                            for(var i3 = 0; i3 < programAttribute.locationSize; i3++)enableAttributeAndDivisor(programAttribute.location + i3, geometryAttribute.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
                        } else for(var i4 = 0; i4 < programAttribute.locationSize; i4++)enableAttribute(programAttribute.location + i4);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(var i5 = 0; i5 < programAttribute.locationSize; i5++)vertexAttribPointer(programAttribute.location + i5, size / programAttribute.locationSize, type, normalized, size * bytesPerElement, size / programAttribute.locationSize * i5 * bytesPerElement, integer);
                    }
                } else if (materialDefaultAttributeValues !== undefined) {
                    var value = materialDefaultAttributeValues[name];
                    if (value !== undefined) switch(value.length){
                        case 2:
                            gl.vertexAttrib2fv(programAttribute.location, value);
                            break;
                        case 3:
                            gl.vertexAttrib3fv(programAttribute.location, value);
                            break;
                        case 4:
                            gl.vertexAttrib4fv(programAttribute.location, value);
                            break;
                        default:
                            gl.vertexAttrib1fv(programAttribute.location, value);
                    }
                }
            }
        }
        disableUnusedAttributes();
    }
    function dispose() {
        reset();
        for(var geometryId in bindingStates){
            var programMap = bindingStates[geometryId];
            for(var programId in programMap){
                var stateMap = programMap[programId];
                for(var wireframe in stateMap){
                    deleteVertexArrayObject(stateMap[wireframe].object);
                    delete stateMap[wireframe];
                }
                delete programMap[programId];
            }
            delete bindingStates[geometryId];
        }
    }
    function releaseStatesOfGeometry(geometry) {
        if (bindingStates[geometry.id] === undefined) return;
        var programMap = bindingStates[geometry.id];
        for(var programId in programMap){
            var stateMap = programMap[programId];
            for(var wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[programId];
        }
        delete bindingStates[geometry.id];
    }
    function releaseStatesOfProgram(program) {
        for(var geometryId in bindingStates){
            var programMap = bindingStates[geometryId];
            if (programMap[program.id] === undefined) continue;
            var stateMap = programMap[program.id];
            for(var wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[program.id];
        }
    }
    function reset() {
        resetDefaultState();
        forceUpdate = true;
        if (currentState === defaultState) return;
        currentState = defaultState;
        bindVertexArrayObject(currentState.object);
    }
    // for backward-compatibility
    function resetDefaultState() {
        defaultState.geometry = null;
        defaultState.program = null;
        defaultState.wireframe = false;
    }
    return {
        setup: setup,
        reset: reset,
        resetDefaultState: resetDefaultState,
        dispose: dispose,
        releaseStatesOfGeometry: releaseStatesOfGeometry,
        releaseStatesOfProgram: releaseStatesOfProgram,
        initAttributes: initAttributes,
        enableAttribute: enableAttribute,
        disableUnusedAttributes: disableUnusedAttributes
    };
}
function $079becb54c0579a9$var$WebGLBufferRenderer(gl, extensions, info) {
    var mode;
    function setMode(value) {
        mode = value;
    }
    function render(start, count) {
        gl.drawArrays(mode, start, count);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        gl.drawArraysInstanced(mode, start, count, primcount);
        info.update(count, mode, primcount);
    }
    function renderMultiDraw(starts, counts, drawCount) {
        if (drawCount === 0) return;
        var extension = extensions.get('WEBGL_multi_draw');
        extension.multiDrawArraysWEBGL(mode, starts, 0, counts, 0, drawCount);
        var elementCount = 0;
        for(var i = 0; i < drawCount; i++)elementCount += counts[i];
        info.update(elementCount, mode, 1);
    }
    function renderMultiDrawInstances(starts, counts, drawCount, primcount) {
        if (drawCount === 0) return;
        var extension = extensions.get('WEBGL_multi_draw');
        if (extension === null) for(var i = 0; i < starts.length; i++)renderInstances(starts[i], counts[i], primcount[i]);
        else {
            extension.multiDrawArraysInstancedWEBGL(mode, starts, 0, counts, 0, primcount, 0, drawCount);
            var elementCount = 0;
            for(var i1 = 0; i1 < drawCount; i1++)elementCount += counts[i1] * primcount[i1];
            info.update(elementCount, mode, 1);
        }
    }
    //
    this.setMode = setMode;
    this.render = render;
    this.renderInstances = renderInstances;
    this.renderMultiDraw = renderMultiDraw;
    this.renderMultiDrawInstances = renderMultiDrawInstances;
}
function $079becb54c0579a9$var$WebGLCapabilities(gl, extensions, parameters, utils) {
    var maxAnisotropy;
    function getMaxAnisotropy() {
        if (maxAnisotropy !== undefined) return maxAnisotropy;
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            var extension = extensions.get('EXT_texture_filter_anisotropic');
            maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else maxAnisotropy = 0;
        return maxAnisotropy;
    }
    function textureFormatReadable(textureFormat) {
        if (textureFormat !== (0, $1a55656020b89c3a$export$3f8bb04b555a363c) && utils.convert(textureFormat) !== gl.getParameter(gl.IMPLEMENTATION_COLOR_READ_FORMAT)) return false;
        return true;
    }
    function textureTypeReadable(textureType) {
        var halfFloatSupportedByExt = textureType === (0, $1a55656020b89c3a$export$2697304443f382bc) && (extensions.has('EXT_color_buffer_half_float') || extensions.has('EXT_color_buffer_float'));
        if (textureType !== (0, $1a55656020b89c3a$export$2e8ce08d3f6f5e10) && utils.convert(textureType) !== gl.getParameter(gl.IMPLEMENTATION_COLOR_READ_TYPE) && // Edge and Chrome Mac < 52 (#9513)
        textureType !== (0, $1a55656020b89c3a$export$f6d331659b644596) && !halfFloatSupportedByExt) return false;
        return true;
    }
    function getMaxPrecision(precision) {
        if (precision === 'highp') {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT).precision > 0) return 'highp';
            precision = 'mediump';
        }
        if (precision === 'mediump') {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT).precision > 0) return 'mediump';
        }
        return 'lowp';
    }
    var precision = parameters.precision !== undefined ? parameters.precision : 'highp';
    var maxPrecision = getMaxPrecision(precision);
    if (maxPrecision !== precision) {
        console.warn('THREE.WebGLRenderer:', precision, 'not supported, using', maxPrecision, 'instead.');
        precision = maxPrecision;
    }
    var logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
    var reverseDepthBuffer = parameters.reverseDepthBuffer === true && extensions.has('EXT_clip_control');
    var maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
    var maxVertexTextures = gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS);
    var maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
    var maxCubemapSize = gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE);
    var maxAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    var maxVertexUniforms = gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS);
    var maxVaryings = gl.getParameter(gl.MAX_VARYING_VECTORS);
    var maxFragmentUniforms = gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS);
    var vertexTextures = maxVertexTextures > 0;
    var maxSamples = gl.getParameter(gl.MAX_SAMPLES);
    return {
        isWebGL2: true,
        getMaxAnisotropy: getMaxAnisotropy,
        getMaxPrecision: getMaxPrecision,
        textureFormatReadable: textureFormatReadable,
        textureTypeReadable: textureTypeReadable,
        precision: precision,
        logarithmicDepthBuffer: logarithmicDepthBuffer,
        reverseDepthBuffer: reverseDepthBuffer,
        maxTextures: maxTextures,
        maxVertexTextures: maxVertexTextures,
        maxTextureSize: maxTextureSize,
        maxCubemapSize: maxCubemapSize,
        maxAttributes: maxAttributes,
        maxVertexUniforms: maxVertexUniforms,
        maxVaryings: maxVaryings,
        maxFragmentUniforms: maxFragmentUniforms,
        vertexTextures: vertexTextures,
        maxSamples: maxSamples
    };
}
function $079becb54c0579a9$var$WebGLClipping(properties) {
    var scope = this;
    var globalState = null, numGlobalPlanes = 0, localClippingEnabled = false, renderingShadows = false;
    var plane = new (0, $1a55656020b89c3a$export$7ff5ac152ef991b0)(), viewNormalMatrix = new (0, $1a55656020b89c3a$export$8ff26dafa08918)(), uniform = {
        value: null,
        needsUpdate: false
    };
    this.uniform = uniform;
    this.numPlanes = 0;
    this.numIntersection = 0;
    this.init = function(planes, enableLocalClipping) {
        var enabled = planes.length !== 0 || enableLocalClipping || // enable state of previous frame - the clipping code has to
        // run another frame in order to reset the state:
        numGlobalPlanes !== 0 || localClippingEnabled;
        localClippingEnabled = enableLocalClipping;
        numGlobalPlanes = planes.length;
        return enabled;
    };
    this.beginShadows = function() {
        renderingShadows = true;
        projectPlanes(null);
    };
    this.endShadows = function() {
        renderingShadows = false;
    };
    this.setGlobalState = function(planes, camera) {
        globalState = projectPlanes(planes, camera, 0);
    };
    this.setState = function(material, camera, useCache) {
        var planes = material.clippingPlanes, clipIntersection = material.clipIntersection, clipShadows = material.clipShadows;
        var materialProperties = properties.get(material);
        if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
            // there's no local clipping
            if (renderingShadows) // there's no global clipping
            projectPlanes(null);
            else resetGlobalState();
        } else {
            var nGlobal = renderingShadows ? 0 : numGlobalPlanes, lGlobal = nGlobal * 4;
            var dstArray = materialProperties.clippingState || null;
            uniform.value = dstArray; // ensure unique state
            dstArray = projectPlanes(planes, camera, lGlobal, useCache);
            for(var i = 0; i !== lGlobal; ++i)dstArray[i] = globalState[i];
            materialProperties.clippingState = dstArray;
            this.numIntersection = clipIntersection ? this.numPlanes : 0;
            this.numPlanes += nGlobal;
        }
    };
    function resetGlobalState() {
        if (uniform.value !== globalState) {
            uniform.value = globalState;
            uniform.needsUpdate = numGlobalPlanes > 0;
        }
        scope.numPlanes = numGlobalPlanes;
        scope.numIntersection = 0;
    }
    function projectPlanes(planes, camera, dstOffset, skipTransform) {
        var nPlanes = planes !== null ? planes.length : 0;
        var dstArray = null;
        if (nPlanes !== 0) {
            dstArray = uniform.value;
            if (skipTransform !== true || dstArray === null) {
                var flatSize = dstOffset + nPlanes * 4, viewMatrix = camera.matrixWorldInverse;
                viewNormalMatrix.getNormalMatrix(viewMatrix);
                if (dstArray === null || dstArray.length < flatSize) dstArray = new Float32Array(flatSize);
                for(var i = 0, i4 = dstOffset; i !== nPlanes; ++i, i4 += 4){
                    plane.copy(planes[i]).applyMatrix4(viewMatrix, viewNormalMatrix);
                    plane.normal.toArray(dstArray, i4);
                    dstArray[i4 + 3] = plane.constant;
                }
            }
            uniform.value = dstArray;
            uniform.needsUpdate = true;
        }
        scope.numPlanes = nPlanes;
        scope.numIntersection = 0;
        return dstArray;
    }
}
function $079becb54c0579a9$var$WebGLCubeMaps(renderer) {
    var cubemaps = new WeakMap();
    function mapTextureMapping(texture, mapping) {
        if (mapping === (0, $1a55656020b89c3a$export$d64030b316d3b087)) texture.mapping = (0, $1a55656020b89c3a$export$8759762a6477f2c4);
        else if (mapping === (0, $1a55656020b89c3a$export$ee99d97d46898098)) texture.mapping = (0, $1a55656020b89c3a$export$dc59f8aed047f61d);
        return texture;
    }
    function get(texture) {
        if (texture && texture.isTexture) {
            var mapping = texture.mapping;
            if (mapping === (0, $1a55656020b89c3a$export$d64030b316d3b087) || mapping === (0, $1a55656020b89c3a$export$ee99d97d46898098)) {
                if (cubemaps.has(texture)) {
                    var cubemap = cubemaps.get(texture).texture;
                    return mapTextureMapping(cubemap, texture.mapping);
                } else {
                    var image = texture.image;
                    if (image && image.height > 0) {
                        var renderTarget = new (0, $1a55656020b89c3a$export$ac386671d651941e)(image.height);
                        renderTarget.fromEquirectangularTexture(renderer, texture);
                        cubemaps.set(texture, renderTarget);
                        texture.addEventListener('dispose', onTextureDispose);
                        return mapTextureMapping(renderTarget.texture, texture.mapping);
                    } else // image not yet ready. try the conversion next frame
                    return null;
                }
            }
        }
        return texture;
    }
    function onTextureDispose(event) {
        var texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        var cubemap = cubemaps.get(texture);
        if (cubemap !== undefined) {
            cubemaps.delete(texture);
            cubemap.dispose();
        }
    }
    function dispose() {
        cubemaps = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
var $079becb54c0579a9$var$LOD_MIN = 4;
// The standard deviations (radians) associated with the extra mips. These are
// chosen to approximate a Trowbridge-Reitz distribution function times the
// geometric shadowing function. These sigma values squared must match the
// variance #defines in cube_uv_reflection_fragment.glsl.js.
var $079becb54c0579a9$var$EXTRA_LOD_SIGMA = [
    0.125,
    0.215,
    0.35,
    0.446,
    0.526,
    0.582
];
// The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.
var $079becb54c0579a9$var$MAX_SAMPLES = 20;
var $079becb54c0579a9$var$_flatCamera = /*@__PURE__*/ new (0, $1a55656020b89c3a$export$9ebf355ee4ed261b)();
var $079becb54c0579a9$var$_clearColor = /*@__PURE__*/ new (0, $1a55656020b89c3a$export$892596cec99bc70e)();
var $079becb54c0579a9$var$_oldTarget = null;
var $079becb54c0579a9$var$_oldActiveCubeFace = 0;
var $079becb54c0579a9$var$_oldActiveMipmapLevel = 0;
var $079becb54c0579a9$var$_oldXrEnabled = false;
// Golden Ratio
var $079becb54c0579a9$var$PHI = (1 + Math.sqrt(5)) / 2;
var $079becb54c0579a9$var$INV_PHI = 1 / $079becb54c0579a9$var$PHI;
// Vertices of a dodecahedron (except the opposites, which represent the
// same axis), used as axis directions evenly spread on a sphere.
var $079becb54c0579a9$var$_axisDirections = [
    /*@__PURE__*/ new (0, $1a55656020b89c3a$export$64b5c384219d3699)(-$079becb54c0579a9$var$PHI, $079becb54c0579a9$var$INV_PHI, 0),
    /*@__PURE__*/ new (0, $1a55656020b89c3a$export$64b5c384219d3699)($079becb54c0579a9$var$PHI, $079becb54c0579a9$var$INV_PHI, 0),
    /*@__PURE__*/ new (0, $1a55656020b89c3a$export$64b5c384219d3699)(-$079becb54c0579a9$var$INV_PHI, 0, $079becb54c0579a9$var$PHI),
    /*@__PURE__*/ new (0, $1a55656020b89c3a$export$64b5c384219d3699)($079becb54c0579a9$var$INV_PHI, 0, $079becb54c0579a9$var$PHI),
    /*@__PURE__*/ new (0, $1a55656020b89c3a$export$64b5c384219d3699)(0, $079becb54c0579a9$var$PHI, -$079becb54c0579a9$var$INV_PHI),
    /*@__PURE__*/ new (0, $1a55656020b89c3a$export$64b5c384219d3699)(0, $079becb54c0579a9$var$PHI, $079becb54c0579a9$var$INV_PHI),
    /*@__PURE__*/ new (0, $1a55656020b89c3a$export$64b5c384219d3699)(-1, 1, -1),
    /*@__PURE__*/ new (0, $1a55656020b89c3a$export$64b5c384219d3699)(1, 1, -1),
    /*@__PURE__*/ new (0, $1a55656020b89c3a$export$64b5c384219d3699)(-1, 1, 1),
    /*@__PURE__*/ new (0, $1a55656020b89c3a$export$64b5c384219d3699)(1, 1, 1)
];
/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 *
 * Paper: Fast, Accurate Image-Based Lighting
 * https://drive.google.com/file/d/15y8r_UpKlU9SvV4ILb0C3qCPecS8pvLz/view
*/ var $079becb54c0579a9$export$6add42717753e221 = /*#__PURE__*/ function() {
    "use strict";
    function PMREMGenerator(renderer) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, PMREMGenerator);
        this._renderer = renderer;
        this._pingPongRenderTarget = null;
        this._lodMax = 0;
        this._cubeSize = 0;
        this._lodPlanes = [];
        this._sizeLods = [];
        this._sigmas = [];
        this._blurMaterial = null;
        this._cubemapMaterial = null;
        this._equirectMaterial = null;
        this._compileMaterial(this._blurMaterial);
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(PMREMGenerator, [
        {
            /**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety (the cubeCamera
	 * is placed at the origin).
	 *
	 * @param {Scene} scene
	 * @param {number} sigma
	 * @param {number} near
	 * @param {number} far
	 * @return {WebGLRenderTarget}
	 */ key: "fromScene",
            value: function fromScene(scene) {
                var sigma = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, near = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0.1, far = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 100;
                $079becb54c0579a9$var$_oldTarget = this._renderer.getRenderTarget();
                $079becb54c0579a9$var$_oldActiveCubeFace = this._renderer.getActiveCubeFace();
                $079becb54c0579a9$var$_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
                $079becb54c0579a9$var$_oldXrEnabled = this._renderer.xr.enabled;
                this._renderer.xr.enabled = false;
                this._setSize(256);
                var cubeUVRenderTarget = this._allocateTargets();
                cubeUVRenderTarget.depthBuffer = true;
                this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget);
                if (sigma > 0) this._blur(cubeUVRenderTarget, 0, 0, sigma);
                this._applyPMREM(cubeUVRenderTarget);
                this._cleanup(cubeUVRenderTarget);
                return cubeUVRenderTarget;
            }
        },
        {
            /**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * or HDR. The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 * The smallest supported equirectangular image size is 64 x 32.
	 *
	 * @param {Texture} equirectangular
	 * @param {WebGLRenderTarget} [renderTarget=null] - Optional render target.
	 * @return {WebGLRenderTarget}
	 */ key: "fromEquirectangular",
            value: function fromEquirectangular(equirectangular) {
                var renderTarget = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                return this._fromTexture(equirectangular, renderTarget);
            }
        },
        {
            /**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * or HDR. The ideal input cube size is 256 x 256,
	 * as this matches best with the 256 x 256 cubemap output.
	 * The smallest supported cube size is 16 x 16.
	 *
	 * @param {Texture} cubemap
	 * @param {null} [renderTarget=null] - Optional render target.
	 * @return {WebGLRenderTarget}
	 */ key: "fromCubemap",
            value: function fromCubemap(cubemap) {
                var renderTarget = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                return this._fromTexture(cubemap, renderTarget);
            }
        },
        {
            /**
	 * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ key: "compileCubemapShader",
            value: function compileCubemapShader() {
                if (this._cubemapMaterial === null) {
                    this._cubemapMaterial = $079becb54c0579a9$var$_getCubemapMaterial();
                    this._compileMaterial(this._cubemapMaterial);
                }
            }
        },
        {
            /**
	 * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ key: "compileEquirectangularShader",
            value: function compileEquirectangularShader() {
                if (this._equirectMaterial === null) {
                    this._equirectMaterial = $079becb54c0579a9$var$_getEquirectMaterial();
                    this._compileMaterial(this._equirectMaterial);
                }
            }
        },
        {
            /**
	 * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
	 * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
	 * one of them will cause any others to also become unusable.
	 */ key: "dispose",
            value: function dispose() {
                this._dispose();
                if (this._cubemapMaterial !== null) this._cubemapMaterial.dispose();
                if (this._equirectMaterial !== null) this._equirectMaterial.dispose();
            }
        },
        {
            // private interface
            key: "_setSize",
            value: function _setSize(cubeSize) {
                this._lodMax = Math.floor(Math.log2(cubeSize));
                this._cubeSize = Math.pow(2, this._lodMax);
            }
        },
        {
            key: "_dispose",
            value: function _dispose() {
                if (this._blurMaterial !== null) this._blurMaterial.dispose();
                if (this._pingPongRenderTarget !== null) this._pingPongRenderTarget.dispose();
                for(var i = 0; i < this._lodPlanes.length; i++)this._lodPlanes[i].dispose();
            }
        },
        {
            key: "_cleanup",
            value: function _cleanup(outputTarget) {
                this._renderer.setRenderTarget($079becb54c0579a9$var$_oldTarget, $079becb54c0579a9$var$_oldActiveCubeFace, $079becb54c0579a9$var$_oldActiveMipmapLevel);
                this._renderer.xr.enabled = $079becb54c0579a9$var$_oldXrEnabled;
                outputTarget.scissorTest = false;
                $079becb54c0579a9$var$_setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
            }
        },
        {
            key: "_fromTexture",
            value: function _fromTexture(texture, renderTarget) {
                if (texture.mapping === (0, $1a55656020b89c3a$export$8759762a6477f2c4) || texture.mapping === (0, $1a55656020b89c3a$export$dc59f8aed047f61d)) this._setSize(texture.image.length === 0 ? 16 : texture.image[0].width || texture.image[0].image.width);
                else this._setSize(texture.image.width / 4);
                $079becb54c0579a9$var$_oldTarget = this._renderer.getRenderTarget();
                $079becb54c0579a9$var$_oldActiveCubeFace = this._renderer.getActiveCubeFace();
                $079becb54c0579a9$var$_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
                $079becb54c0579a9$var$_oldXrEnabled = this._renderer.xr.enabled;
                this._renderer.xr.enabled = false;
                var cubeUVRenderTarget = renderTarget || this._allocateTargets();
                this._textureToCubeUV(texture, cubeUVRenderTarget);
                this._applyPMREM(cubeUVRenderTarget);
                this._cleanup(cubeUVRenderTarget);
                return cubeUVRenderTarget;
            }
        },
        {
            key: "_allocateTargets",
            value: function _allocateTargets() {
                var width = 3 * Math.max(this._cubeSize, 112);
                var height = 4 * this._cubeSize;
                var params = {
                    magFilter: (0, $1a55656020b89c3a$export$8a72f490b25c56c8),
                    minFilter: (0, $1a55656020b89c3a$export$8a72f490b25c56c8),
                    generateMipmaps: false,
                    type: (0, $1a55656020b89c3a$export$2697304443f382bc),
                    format: (0, $1a55656020b89c3a$export$3f8bb04b555a363c),
                    colorSpace: (0, $1a55656020b89c3a$export$42429b3acfb233a4),
                    depthBuffer: false
                };
                var cubeUVRenderTarget = $079becb54c0579a9$var$_createRenderTarget(width, height, params);
                if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== width || this._pingPongRenderTarget.height !== height) {
                    if (this._pingPongRenderTarget !== null) this._dispose();
                    this._pingPongRenderTarget = $079becb54c0579a9$var$_createRenderTarget(width, height, params);
                    var _lodMax = this._lodMax;
                    var ref;
                    ref = $079becb54c0579a9$var$_createPlanes(_lodMax), this._sizeLods = ref.sizeLods, this._lodPlanes = ref.lodPlanes, this._sigmas = ref.sigmas, ref;
                    this._blurMaterial = $079becb54c0579a9$var$_getBlurShader(_lodMax, width, height);
                }
                return cubeUVRenderTarget;
            }
        },
        {
            key: "_compileMaterial",
            value: function _compileMaterial(material) {
                var tmpMesh = new (0, $1a55656020b89c3a$export$e176487c05830cc5)(this._lodPlanes[0], material);
                this._renderer.compile(tmpMesh, $079becb54c0579a9$var$_flatCamera);
            }
        },
        {
            key: "_sceneToCubeUV",
            value: function _sceneToCubeUV(scene, near, far, cubeUVRenderTarget) {
                var fov = 90;
                var aspect = 1;
                var cubeCamera = new (0, $1a55656020b89c3a$export$74e4ae24825f68d7)(fov, aspect, near, far);
                var upSign = [
                    1,
                    -1,
                    1,
                    1,
                    1,
                    1
                ];
                var forwardSign = [
                    1,
                    1,
                    1,
                    -1,
                    -1,
                    -1
                ];
                var renderer = this._renderer;
                var originalAutoClear = renderer.autoClear;
                var toneMapping = renderer.toneMapping;
                renderer.getClearColor($079becb54c0579a9$var$_clearColor);
                renderer.toneMapping = (0, $1a55656020b89c3a$export$9fcb6b4294603b2);
                renderer.autoClear = false;
                var backgroundMaterial = new (0, $1a55656020b89c3a$export$55cbcc9b622fe1f5)({
                    name: 'PMREM.Background',
                    side: (0, $1a55656020b89c3a$export$d9f0486e75b5ace),
                    depthWrite: false,
                    depthTest: false
                });
                var backgroundBox = new (0, $1a55656020b89c3a$export$e176487c05830cc5)(new (0, $1a55656020b89c3a$export$33e43285f7406bd5)(), backgroundMaterial);
                var useSolidColor = false;
                var background = scene.background;
                if (background) {
                    if (background.isColor) {
                        backgroundMaterial.color.copy(background);
                        scene.background = null;
                        useSolidColor = true;
                    }
                } else {
                    backgroundMaterial.color.copy($079becb54c0579a9$var$_clearColor);
                    useSolidColor = true;
                }
                for(var i = 0; i < 6; i++){
                    var col = i % 3;
                    if (col === 0) {
                        cubeCamera.up.set(0, upSign[i], 0);
                        cubeCamera.lookAt(forwardSign[i], 0, 0);
                    } else if (col === 1) {
                        cubeCamera.up.set(0, 0, upSign[i]);
                        cubeCamera.lookAt(0, forwardSign[i], 0);
                    } else {
                        cubeCamera.up.set(0, upSign[i], 0);
                        cubeCamera.lookAt(0, 0, forwardSign[i]);
                    }
                    var size = this._cubeSize;
                    $079becb54c0579a9$var$_setViewport(cubeUVRenderTarget, col * size, i > 2 ? size : 0, size, size);
                    renderer.setRenderTarget(cubeUVRenderTarget);
                    if (useSolidColor) renderer.render(backgroundBox, cubeCamera);
                    renderer.render(scene, cubeCamera);
                }
                backgroundBox.geometry.dispose();
                backgroundBox.material.dispose();
                renderer.toneMapping = toneMapping;
                renderer.autoClear = originalAutoClear;
                scene.background = background;
            }
        },
        {
            key: "_textureToCubeUV",
            value: function _textureToCubeUV(texture, cubeUVRenderTarget) {
                var renderer = this._renderer;
                var isCubeTexture = texture.mapping === (0, $1a55656020b89c3a$export$8759762a6477f2c4) || texture.mapping === (0, $1a55656020b89c3a$export$dc59f8aed047f61d);
                if (isCubeTexture) {
                    if (this._cubemapMaterial === null) this._cubemapMaterial = $079becb54c0579a9$var$_getCubemapMaterial();
                    this._cubemapMaterial.uniforms.flipEnvMap.value = texture.isRenderTargetTexture === false ? -1 : 1;
                } else if (this._equirectMaterial === null) this._equirectMaterial = $079becb54c0579a9$var$_getEquirectMaterial();
                var material = isCubeTexture ? this._cubemapMaterial : this._equirectMaterial;
                var mesh = new (0, $1a55656020b89c3a$export$e176487c05830cc5)(this._lodPlanes[0], material);
                var uniforms = material.uniforms;
                uniforms['envMap'].value = texture;
                var size = this._cubeSize;
                $079becb54c0579a9$var$_setViewport(cubeUVRenderTarget, 0, 0, 3 * size, 2 * size);
                renderer.setRenderTarget(cubeUVRenderTarget);
                renderer.render(mesh, $079becb54c0579a9$var$_flatCamera);
            }
        },
        {
            key: "_applyPMREM",
            value: function _applyPMREM(cubeUVRenderTarget) {
                var renderer = this._renderer;
                var autoClear = renderer.autoClear;
                renderer.autoClear = false;
                var n = this._lodPlanes.length;
                for(var i = 1; i < n; i++){
                    var sigma = Math.sqrt(this._sigmas[i] * this._sigmas[i] - this._sigmas[i - 1] * this._sigmas[i - 1]);
                    var poleAxis = $079becb54c0579a9$var$_axisDirections[(n - i - 1) % $079becb54c0579a9$var$_axisDirections.length];
                    this._blur(cubeUVRenderTarget, i - 1, i, sigma, poleAxis);
                }
                renderer.autoClear = autoClear;
            }
        },
        {
            /**
	 * This is a two-pass Gaussian blur for a cubemap. Normally this is done
	 * vertically and horizontally, but this breaks down on a cube. Here we apply
	 * the blur latitudinally (around the poles), and then longitudinally (towards
	 * the poles) to approximate the orthogonally-separable blur. It is least
	 * accurate at the poles, but still does a decent job.
	 *
	 * @param {WebGLRenderTarget} cubeUVRenderTarget
	 * @param {number} lodIn
	 * @param {number} lodOut
	 * @param {number} sigma
	 * @param {Vector3} [poleAxis]
	 */ key: "_blur",
            value: function _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
                var pingPongRenderTarget = this._pingPongRenderTarget;
                this._halfBlur(cubeUVRenderTarget, pingPongRenderTarget, lodIn, lodOut, sigma, 'latitudinal', poleAxis);
                this._halfBlur(pingPongRenderTarget, cubeUVRenderTarget, lodOut, lodOut, sigma, 'longitudinal', poleAxis);
            }
        },
        {
            key: "_halfBlur",
            value: function _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
                var renderer = this._renderer;
                var blurMaterial = this._blurMaterial;
                if (direction !== 'latitudinal' && direction !== 'longitudinal') console.error('blur direction must be either latitudinal or longitudinal!');
                // Number of standard deviations at which to cut off the discrete approximation.
                var STANDARD_DEVIATIONS = 3;
                var blurMesh = new (0, $1a55656020b89c3a$export$e176487c05830cc5)(this._lodPlanes[lodOut], blurMaterial);
                var blurUniforms = blurMaterial.uniforms;
                var pixels = this._sizeLods[lodIn] - 1;
                var radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * $079becb54c0579a9$var$MAX_SAMPLES - 1);
                var sigmaPixels = sigmaRadians / radiansPerPixel;
                var samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : $079becb54c0579a9$var$MAX_SAMPLES;
                if (samples > $079becb54c0579a9$var$MAX_SAMPLES) console.warn("sigmaRadians, ".concat(sigmaRadians, ", is too large and will clip, as it requested ").concat(samples, " samples when the maximum is set to ").concat($079becb54c0579a9$var$MAX_SAMPLES));
                var weights = [];
                var sum = 0;
                for(var i = 0; i < $079becb54c0579a9$var$MAX_SAMPLES; ++i){
                    var x = i / sigmaPixels;
                    var weight = Math.exp(-x * x / 2);
                    weights.push(weight);
                    if (i === 0) sum += weight;
                    else if (i < samples) sum += 2 * weight;
                }
                for(var i1 = 0; i1 < weights.length; i1++)weights[i1] = weights[i1] / sum;
                blurUniforms['envMap'].value = targetIn.texture;
                blurUniforms['samples'].value = samples;
                blurUniforms['weights'].value = weights;
                blurUniforms['latitudinal'].value = direction === 'latitudinal';
                if (poleAxis) blurUniforms['poleAxis'].value = poleAxis;
                var _lodMax = this._lodMax;
                blurUniforms['dTheta'].value = radiansPerPixel;
                blurUniforms['mipInt'].value = _lodMax - lodIn;
                var outputSize = this._sizeLods[lodOut];
                var x1 = 3 * outputSize * (lodOut > _lodMax - $079becb54c0579a9$var$LOD_MIN ? lodOut - _lodMax + $079becb54c0579a9$var$LOD_MIN : 0);
                var y = 4 * (this._cubeSize - outputSize);
                $079becb54c0579a9$var$_setViewport(targetOut, x1, y, 3 * outputSize, 2 * outputSize);
                renderer.setRenderTarget(targetOut);
                renderer.render(blurMesh, $079becb54c0579a9$var$_flatCamera);
            }
        }
    ]);
    return PMREMGenerator;
}();
function $079becb54c0579a9$var$_createPlanes(lodMax) {
    var lodPlanes = [];
    var sizeLods = [];
    var sigmas = [];
    var lod = lodMax;
    var totalLods = lodMax - $079becb54c0579a9$var$LOD_MIN + 1 + $079becb54c0579a9$var$EXTRA_LOD_SIGMA.length;
    for(var i = 0; i < totalLods; i++){
        var sizeLod = Math.pow(2, lod);
        sizeLods.push(sizeLod);
        var sigma = 1.0 / sizeLod;
        if (i > lodMax - $079becb54c0579a9$var$LOD_MIN) sigma = $079becb54c0579a9$var$EXTRA_LOD_SIGMA[i - lodMax + $079becb54c0579a9$var$LOD_MIN - 1];
        else if (i === 0) sigma = 0;
        sigmas.push(sigma);
        var texelSize = 1.0 / (sizeLod - 2);
        var min = -texelSize;
        var max = 1 + texelSize;
        var uv1 = [
            min,
            min,
            max,
            min,
            max,
            max,
            min,
            min,
            max,
            max,
            min,
            max
        ];
        var cubeFaces = 6;
        var vertices = 6;
        var positionSize = 3;
        var uvSize = 2;
        var faceIndexSize = 1;
        var position = new Float32Array(positionSize * vertices * cubeFaces);
        var uv = new Float32Array(uvSize * vertices * cubeFaces);
        var faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
        for(var face = 0; face < cubeFaces; face++){
            var x = face % 3 * 2 / 3 - 1;
            var y = face > 2 ? 0 : -1;
            var coordinates = [
                x,
                y,
                0,
                x + 2 / 3,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y + 1,
                0
            ];
            position.set(coordinates, positionSize * vertices * face);
            uv.set(uv1, uvSize * vertices * face);
            var fill = [
                face,
                face,
                face,
                face,
                face,
                face
            ];
            faceIndex.set(fill, faceIndexSize * vertices * face);
        }
        var planes = new (0, $1a55656020b89c3a$export$b7be63a67df8959)();
        planes.setAttribute('position', new (0, $1a55656020b89c3a$export$8dea267bd6bde117)(position, positionSize));
        planes.setAttribute('uv', new (0, $1a55656020b89c3a$export$8dea267bd6bde117)(uv, uvSize));
        planes.setAttribute('faceIndex', new (0, $1a55656020b89c3a$export$8dea267bd6bde117)(faceIndex, faceIndexSize));
        lodPlanes.push(planes);
        if (lod > $079becb54c0579a9$var$LOD_MIN) lod--;
    }
    return {
        lodPlanes: lodPlanes,
        sizeLods: sizeLods,
        sigmas: sigmas
    };
}
function $079becb54c0579a9$var$_createRenderTarget(width, height, params) {
    var cubeUVRenderTarget = new (0, $1a55656020b89c3a$export$3c052beb2e51e23f)(width, height, params);
    cubeUVRenderTarget.texture.mapping = (0, $1a55656020b89c3a$export$dbf3e70ff37af79);
    cubeUVRenderTarget.texture.name = 'PMREM.cubeUv';
    cubeUVRenderTarget.scissorTest = true;
    return cubeUVRenderTarget;
}
function $079becb54c0579a9$var$_setViewport(target, x, y, width, height) {
    target.viewport.set(x, y, width, height);
    target.scissor.set(x, y, width, height);
}
function $079becb54c0579a9$var$_getBlurShader(lodMax, width, height) {
    var weights = new Float32Array($079becb54c0579a9$var$MAX_SAMPLES);
    var poleAxis = new (0, $1a55656020b89c3a$export$64b5c384219d3699)(0, 1, 0);
    var shaderMaterial = new (0, $1a55656020b89c3a$export$83c7d75d550a8b0d)({
        name: 'SphericalGaussianBlur',
        defines: {
            'n': $079becb54c0579a9$var$MAX_SAMPLES,
            'CUBEUV_TEXEL_WIDTH': 1.0 / width,
            'CUBEUV_TEXEL_HEIGHT': 1.0 / height,
            'CUBEUV_MAX_MIP': "".concat(lodMax, ".0")
        },
        uniforms: {
            'envMap': {
                value: null
            },
            'samples': {
                value: 1
            },
            'weights': {
                value: weights
            },
            'latitudinal': {
                value: false
            },
            'dTheta': {
                value: 0
            },
            'mipInt': {
                value: 0
            },
            'poleAxis': {
                value: poleAxis
            }
        },
        vertexShader: $079becb54c0579a9$var$_getCommonVertexShader(),
        fragmentShader: "\n\n			precision mediump float;\n			precision mediump int;\n\n			varying vec3 vOutputDirection;\n\n			uniform sampler2D envMap;\n			uniform int samples;\n			uniform float weights[ n ];\n			uniform bool latitudinal;\n			uniform float dTheta;\n			uniform float mipInt;\n			uniform vec3 poleAxis;\n\n			#define ENVMAP_TYPE_CUBE_UV\n			#include <cube_uv_reflection_fragment>\n\n			vec3 getSample( float theta, vec3 axis ) {\n\n				float cosTheta = cos( theta );\n				// Rodrigues' axis-angle rotation\n				vec3 sampleDirection = vOutputDirection * cosTheta\n					+ cross( axis, vOutputDirection ) * sin( theta )\n					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );\n\n				return bilinearCubeUV( envMap, sampleDirection, mipInt );\n\n			}\n\n			void main() {\n\n				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );\n\n				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {\n\n					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );\n\n				}\n\n				axis = normalize( axis );\n\n				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );\n\n				for ( int i = 1; i < n; i++ ) {\n\n					if ( i >= samples ) {\n\n						break;\n\n					}\n\n					float theta = dTheta * float( i );\n					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );\n					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );\n\n				}\n\n			}\n		",
        blending: (0, $1a55656020b89c3a$export$63b8d6b580fc65ba),
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $079becb54c0579a9$var$_getEquirectMaterial() {
    return new (0, $1a55656020b89c3a$export$83c7d75d550a8b0d)({
        name: 'EquirectangularToCubeUV',
        uniforms: {
            'envMap': {
                value: null
            }
        },
        vertexShader: $079becb54c0579a9$var$_getCommonVertexShader(),
        fragmentShader: "\n\n			precision mediump float;\n			precision mediump int;\n\n			varying vec3 vOutputDirection;\n\n			uniform sampler2D envMap;\n\n			#include <common>\n\n			void main() {\n\n				vec3 outputDirection = normalize( vOutputDirection );\n				vec2 uv = equirectUv( outputDirection );\n\n				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );\n\n			}\n		",
        blending: (0, $1a55656020b89c3a$export$63b8d6b580fc65ba),
        depthTest: false,
        depthWrite: false
    });
}
function $079becb54c0579a9$var$_getCubemapMaterial() {
    return new (0, $1a55656020b89c3a$export$83c7d75d550a8b0d)({
        name: 'CubemapToCubeUV',
        uniforms: {
            'envMap': {
                value: null
            },
            'flipEnvMap': {
                value: -1
            }
        },
        vertexShader: $079becb54c0579a9$var$_getCommonVertexShader(),
        fragmentShader: "\n\n			precision mediump float;\n			precision mediump int;\n\n			uniform float flipEnvMap;\n\n			varying vec3 vOutputDirection;\n\n			uniform samplerCube envMap;\n\n			void main() {\n\n				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );\n\n			}\n		",
        blending: (0, $1a55656020b89c3a$export$63b8d6b580fc65ba),
        depthTest: false,
        depthWrite: false
    });
}
function $079becb54c0579a9$var$_getCommonVertexShader() {
    return "\n\n		precision mediump float;\n		precision mediump int;\n\n		attribute float faceIndex;\n\n		varying vec3 vOutputDirection;\n\n		// RH coordinate system; PMREM face-indexing convention\n		vec3 getDirection( vec2 uv, float face ) {\n\n			uv = 2.0 * uv - 1.0;\n\n			vec3 direction = vec3( uv, 1.0 );\n\n			if ( face == 0.0 ) {\n\n				direction = direction.zyx; // ( 1, v, u ) pos x\n\n			} else if ( face == 1.0 ) {\n\n				direction = direction.xzy;\n				direction.xz *= -1.0; // ( -u, 1, -v ) pos y\n\n			} else if ( face == 2.0 ) {\n\n				direction.x *= -1.0; // ( -u, v, 1 ) pos z\n\n			} else if ( face == 3.0 ) {\n\n				direction = direction.zyx;\n				direction.xz *= -1.0; // ( -1, v, -u ) neg x\n\n			} else if ( face == 4.0 ) {\n\n				direction = direction.xzy;\n				direction.xy *= -1.0; // ( -u, -1, v ) neg y\n\n			} else if ( face == 5.0 ) {\n\n				direction.z *= -1.0; // ( u, v, -1 ) neg z\n\n			}\n\n			return direction;\n\n		}\n\n		void main() {\n\n			vOutputDirection = getDirection( uv, faceIndex );\n			gl_Position = vec4( position, 1.0 );\n\n		}\n	";
}
function $079becb54c0579a9$var$WebGLCubeUVMaps(renderer) {
    var cubeUVmaps = new WeakMap();
    var pmremGenerator = null;
    function get(texture) {
        if (texture && texture.isTexture) {
            var mapping = texture.mapping;
            var isEquirectMap = mapping === (0, $1a55656020b89c3a$export$d64030b316d3b087) || mapping === (0, $1a55656020b89c3a$export$ee99d97d46898098);
            var isCubeMap = mapping === (0, $1a55656020b89c3a$export$8759762a6477f2c4) || mapping === (0, $1a55656020b89c3a$export$dc59f8aed047f61d);
            // equirect/cube map to cubeUV conversion
            if (isEquirectMap || isCubeMap) {
                var renderTarget = cubeUVmaps.get(texture);
                var currentPMREMVersion = renderTarget !== undefined ? renderTarget.texture.pmremVersion : 0;
                if (texture.isRenderTargetTexture && texture.pmremVersion !== currentPMREMVersion) {
                    if (pmremGenerator === null) pmremGenerator = new $079becb54c0579a9$export$6add42717753e221(renderer);
                    renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture, renderTarget) : pmremGenerator.fromCubemap(texture, renderTarget);
                    renderTarget.texture.pmremVersion = texture.pmremVersion;
                    cubeUVmaps.set(texture, renderTarget);
                    return renderTarget.texture;
                } else {
                    if (renderTarget !== undefined) return renderTarget.texture;
                    else {
                        var image = texture.image;
                        if (isEquirectMap && image && image.height > 0 || isCubeMap && image && isCubeTextureComplete(image)) {
                            if (pmremGenerator === null) pmremGenerator = new $079becb54c0579a9$export$6add42717753e221(renderer);
                            renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture) : pmremGenerator.fromCubemap(texture);
                            renderTarget.texture.pmremVersion = texture.pmremVersion;
                            cubeUVmaps.set(texture, renderTarget);
                            texture.addEventListener('dispose', onTextureDispose);
                            return renderTarget.texture;
                        } else // image not yet ready. try the conversion next frame
                        return null;
                    }
                }
            }
        }
        return texture;
    }
    function isCubeTextureComplete(image) {
        var count = 0;
        var length = 6;
        for(var i = 0; i < length; i++)if (image[i] !== undefined) count++;
        return count === length;
    }
    function onTextureDispose(event) {
        var texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        var cubemapUV = cubeUVmaps.get(texture);
        if (cubemapUV !== undefined) {
            cubeUVmaps.delete(texture);
            cubemapUV.dispose();
        }
    }
    function dispose() {
        cubeUVmaps = new WeakMap();
        if (pmremGenerator !== null) {
            pmremGenerator.dispose();
            pmremGenerator = null;
        }
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $079becb54c0579a9$var$WebGLExtensions(gl) {
    var extensions = {};
    function getExtension(name) {
        if (extensions[name] !== undefined) return extensions[name];
        var extension;
        switch(name){
            case 'WEBGL_depth_texture':
                extension = gl.getExtension('WEBGL_depth_texture') || gl.getExtension('MOZ_WEBGL_depth_texture') || gl.getExtension('WEBKIT_WEBGL_depth_texture');
                break;
            case 'EXT_texture_filter_anisotropic':
                extension = gl.getExtension('EXT_texture_filter_anisotropic') || gl.getExtension('MOZ_EXT_texture_filter_anisotropic') || gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic');
                break;
            case 'WEBGL_compressed_texture_s3tc':
                extension = gl.getExtension('WEBGL_compressed_texture_s3tc') || gl.getExtension('MOZ_WEBGL_compressed_texture_s3tc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_s3tc');
                break;
            case 'WEBGL_compressed_texture_pvrtc':
                extension = gl.getExtension('WEBGL_compressed_texture_pvrtc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_pvrtc');
                break;
            default:
                extension = gl.getExtension(name);
        }
        extensions[name] = extension;
        return extension;
    }
    return {
        has: function has(name) {
            return getExtension(name) !== null;
        },
        init: function init() {
            getExtension('EXT_color_buffer_float');
            getExtension('WEBGL_clip_cull_distance');
            getExtension('OES_texture_float_linear');
            getExtension('EXT_color_buffer_half_float');
            getExtension('WEBGL_multisampled_render_to_texture');
            getExtension('WEBGL_render_shared_exponent');
        },
        get: function get(name) {
            var extension = getExtension(name);
            if (extension === null) (0, $1a55656020b89c3a$export$5b28268982f175ba)('THREE.WebGLRenderer: ' + name + ' extension not supported.');
            return extension;
        }
    };
}
function $079becb54c0579a9$var$WebGLGeometries(gl, attributes, info, bindingStates) {
    var geometries = {};
    var wireframeAttributes = new WeakMap();
    function onGeometryDispose(event) {
        var geometry = event.target;
        if (geometry.index !== null) attributes.remove(geometry.index);
        for(var name in geometry.attributes)attributes.remove(geometry.attributes[name]);
        geometry.removeEventListener('dispose', onGeometryDispose);
        delete geometries[geometry.id];
        var attribute = wireframeAttributes.get(geometry);
        if (attribute) {
            attributes.remove(attribute);
            wireframeAttributes.delete(geometry);
        }
        bindingStates.releaseStatesOfGeometry(geometry);
        if (geometry.isInstancedBufferGeometry === true) delete geometry._maxInstanceCount;
        //
        info.memory.geometries--;
    }
    function get(object, geometry) {
        if (geometries[geometry.id] === true) return geometry;
        geometry.addEventListener('dispose', onGeometryDispose);
        geometries[geometry.id] = true;
        info.memory.geometries++;
        return geometry;
    }
    function update(geometry) {
        var geometryAttributes = geometry.attributes;
        // Updating index buffer in VAO now. See WebGLBindingStates.
        for(var name in geometryAttributes)attributes.update(geometryAttributes[name], gl.ARRAY_BUFFER);
    }
    function updateWireframeAttribute(geometry) {
        var indices = [];
        var geometryIndex = geometry.index;
        var geometryPosition = geometry.attributes.position;
        var version = 0;
        if (geometryIndex !== null) {
            var array = geometryIndex.array;
            version = geometryIndex.version;
            for(var i = 0, l = array.length; i < l; i += 3){
                var a = array[i + 0];
                var b = array[i + 1];
                var c = array[i + 2];
                indices.push(a, b, b, c, c, a);
            }
        } else if (geometryPosition !== undefined) {
            var array1 = geometryPosition.array;
            version = geometryPosition.version;
            for(var i1 = 0, l1 = array1.length / 3 - 1; i1 < l1; i1 += 3){
                var a1 = i1 + 0;
                var b1 = i1 + 1;
                var c1 = i1 + 2;
                indices.push(a1, b1, b1, c1, c1, a1);
            }
        } else return;
        var attribute = new ((0, $1a55656020b89c3a$export$bc6f937da07eae17)(indices) ? (0, $1a55656020b89c3a$export$7eb8c9fa25cd5bd6) : (0, $1a55656020b89c3a$export$640a853f68025f2e))(indices, 1);
        attribute.version = version;
        // Updating index buffer in VAO now. See WebGLBindingStates
        //
        var previousAttribute = wireframeAttributes.get(geometry);
        if (previousAttribute) attributes.remove(previousAttribute);
        //
        wireframeAttributes.set(geometry, attribute);
    }
    function getWireframeAttribute(geometry) {
        var currentAttribute = wireframeAttributes.get(geometry);
        if (currentAttribute) {
            var geometryIndex = geometry.index;
            if (geometryIndex !== null) // if the attribute is obsolete, create a new one
            {
                if (currentAttribute.version < geometryIndex.version) updateWireframeAttribute(geometry);
            }
        } else updateWireframeAttribute(geometry);
        return wireframeAttributes.get(geometry);
    }
    return {
        get: get,
        update: update,
        getWireframeAttribute: getWireframeAttribute
    };
}
function $079becb54c0579a9$var$WebGLIndexedBufferRenderer(gl, extensions, info) {
    var mode;
    function setMode(value) {
        mode = value;
    }
    var type, bytesPerElement;
    function setIndex(value) {
        type = value.type;
        bytesPerElement = value.bytesPerElement;
    }
    function render(start, count) {
        gl.drawElements(mode, count, type, start * bytesPerElement);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        gl.drawElementsInstanced(mode, count, type, start * bytesPerElement, primcount);
        info.update(count, mode, primcount);
    }
    function renderMultiDraw(starts, counts, drawCount) {
        if (drawCount === 0) return;
        var extension = extensions.get('WEBGL_multi_draw');
        extension.multiDrawElementsWEBGL(mode, counts, 0, type, starts, 0, drawCount);
        var elementCount = 0;
        for(var i = 0; i < drawCount; i++)elementCount += counts[i];
        info.update(elementCount, mode, 1);
    }
    function renderMultiDrawInstances(starts, counts, drawCount, primcount) {
        if (drawCount === 0) return;
        var extension = extensions.get('WEBGL_multi_draw');
        if (extension === null) for(var i = 0; i < starts.length; i++)renderInstances(starts[i] / bytesPerElement, counts[i], primcount[i]);
        else {
            extension.multiDrawElementsInstancedWEBGL(mode, counts, 0, type, starts, 0, primcount, 0, drawCount);
            var elementCount = 0;
            for(var i1 = 0; i1 < drawCount; i1++)elementCount += counts[i1] * primcount[i1];
            info.update(elementCount, mode, 1);
        }
    }
    //
    this.setMode = setMode;
    this.setIndex = setIndex;
    this.render = render;
    this.renderInstances = renderInstances;
    this.renderMultiDraw = renderMultiDraw;
    this.renderMultiDrawInstances = renderMultiDrawInstances;
}
function $079becb54c0579a9$var$WebGLInfo(gl) {
    var memory = {
        geometries: 0,
        textures: 0
    };
    var render = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    function update(count, mode, instanceCount) {
        render.calls++;
        switch(mode){
            case gl.TRIANGLES:
                render.triangles += instanceCount * (count / 3);
                break;
            case gl.LINES:
                render.lines += instanceCount * (count / 2);
                break;
            case gl.LINE_STRIP:
                render.lines += instanceCount * (count - 1);
                break;
            case gl.LINE_LOOP:
                render.lines += instanceCount * count;
                break;
            case gl.POINTS:
                render.points += instanceCount * count;
                break;
            default:
                console.error('THREE.WebGLInfo: Unknown draw mode:', mode);
                break;
        }
    }
    function reset() {
        render.calls = 0;
        render.triangles = 0;
        render.points = 0;
        render.lines = 0;
    }
    return {
        memory: memory,
        render: render,
        programs: null,
        autoReset: true,
        reset: reset,
        update: update
    };
}
function $079becb54c0579a9$var$WebGLMorphtargets(gl, capabilities, textures) {
    var morphTextures = new WeakMap();
    var morph = new (0, $1a55656020b89c3a$export$fa7daccca11cdbe3)();
    function update(object, geometry, program) {
        var objectInfluences = object.morphTargetInfluences;
        // the following encodes morph targets into an array of data textures. Each layer represents a single morph target.
        var morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        var morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        var entry = morphTextures.get(geometry);
        if (entry === undefined || entry.count !== morphTargetsCount) {
            if (entry !== undefined) entry.texture.dispose();
            var hasMorphPosition = geometry.morphAttributes.position !== undefined;
            var hasMorphNormals = geometry.morphAttributes.normal !== undefined;
            var hasMorphColors = geometry.morphAttributes.color !== undefined;
            var morphTargets = geometry.morphAttributes.position || [];
            var morphNormals = geometry.morphAttributes.normal || [];
            var morphColors = geometry.morphAttributes.color || [];
            var vertexDataCount = 0;
            if (hasMorphPosition === true) vertexDataCount = 1;
            if (hasMorphNormals === true) vertexDataCount = 2;
            if (hasMorphColors === true) vertexDataCount = 3;
            var width = geometry.attributes.position.count * vertexDataCount;
            var height = 1;
            if (width > capabilities.maxTextureSize) {
                height = Math.ceil(width / capabilities.maxTextureSize);
                width = capabilities.maxTextureSize;
            }
            var buffer = new Float32Array(width * height * 4 * morphTargetsCount);
            var texture = new (0, $1a55656020b89c3a$export$dfac6c8e811406a3)(buffer, width, height, morphTargetsCount);
            texture.type = (0, $1a55656020b89c3a$export$f6d331659b644596);
            texture.needsUpdate = true;
            // fill buffer
            var vertexDataStride = vertexDataCount * 4;
            for(var i = 0; i < morphTargetsCount; i++){
                var morphTarget = morphTargets[i];
                var morphNormal = morphNormals[i];
                var morphColor = morphColors[i];
                var offset = width * height * 4 * i;
                for(var j = 0; j < morphTarget.count; j++){
                    var stride = j * vertexDataStride;
                    if (hasMorphPosition === true) {
                        morph.fromBufferAttribute(morphTarget, j);
                        buffer[offset + stride + 0] = morph.x;
                        buffer[offset + stride + 1] = morph.y;
                        buffer[offset + stride + 2] = morph.z;
                        buffer[offset + stride + 3] = 0;
                    }
                    if (hasMorphNormals === true) {
                        morph.fromBufferAttribute(morphNormal, j);
                        buffer[offset + stride + 4] = morph.x;
                        buffer[offset + stride + 5] = morph.y;
                        buffer[offset + stride + 6] = morph.z;
                        buffer[offset + stride + 7] = 0;
                    }
                    if (hasMorphColors === true) {
                        morph.fromBufferAttribute(morphColor, j);
                        buffer[offset + stride + 8] = morph.x;
                        buffer[offset + stride + 9] = morph.y;
                        buffer[offset + stride + 10] = morph.z;
                        buffer[offset + stride + 11] = morphColor.itemSize === 4 ? morph.w : 1;
                    }
                }
            }
            entry = {
                count: morphTargetsCount,
                texture: texture,
                size: new (0, $1a55656020b89c3a$export$c977b3e384af9ae1)(width, height)
            };
            morphTextures.set(geometry, entry);
            function disposeTexture() {
                texture.dispose();
                morphTextures.delete(geometry);
                geometry.removeEventListener('dispose', disposeTexture);
            }
            geometry.addEventListener('dispose', disposeTexture);
        }
        //
        if (object.isInstancedMesh === true && object.morphTexture !== null) program.getUniforms().setValue(gl, 'morphTexture', object.morphTexture, textures);
        else {
            var morphInfluencesSum = 0;
            for(var i1 = 0; i1 < objectInfluences.length; i1++)morphInfluencesSum += objectInfluences[i1];
            var morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, 'morphTargetBaseInfluence', morphBaseInfluence);
            program.getUniforms().setValue(gl, 'morphTargetInfluences', objectInfluences);
        }
        program.getUniforms().setValue(gl, 'morphTargetsTexture', entry.texture, textures);
        program.getUniforms().setValue(gl, 'morphTargetsTextureSize', entry.size);
    }
    return {
        update: update
    };
}
function $079becb54c0579a9$var$WebGLObjects(gl, geometries, attributes, info) {
    var updateMap = new WeakMap();
    function update(object) {
        var frame = info.render.frame;
        var geometry = object.geometry;
        var buffergeometry = geometries.get(object, geometry);
        // Update once per frame
        if (updateMap.get(buffergeometry) !== frame) {
            geometries.update(buffergeometry);
            updateMap.set(buffergeometry, frame);
        }
        if (object.isInstancedMesh) {
            if (object.hasEventListener('dispose', onInstancedMeshDispose) === false) object.addEventListener('dispose', onInstancedMeshDispose);
            if (updateMap.get(object) !== frame) {
                attributes.update(object.instanceMatrix, gl.ARRAY_BUFFER);
                if (object.instanceColor !== null) attributes.update(object.instanceColor, gl.ARRAY_BUFFER);
                updateMap.set(object, frame);
            }
        }
        if (object.isSkinnedMesh) {
            var skeleton = object.skeleton;
            if (updateMap.get(skeleton) !== frame) {
                skeleton.update();
                updateMap.set(skeleton, frame);
            }
        }
        return buffergeometry;
    }
    function dispose() {
        updateMap = new WeakMap();
    }
    function onInstancedMeshDispose(event) {
        var instancedMesh = event.target;
        instancedMesh.removeEventListener('dispose', onInstancedMeshDispose);
        attributes.remove(instancedMesh.instanceMatrix);
        if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
    }
    return {
        update: update,
        dispose: dispose
    };
}
/**
 * Uniforms of a program.
 * Those form a tree structure with a special top-level container for the root,
 * which you get by calling 'new WebGLUniforms( gl, program )'.
 *
 *
 * Properties of inner nodes including the top-level container:
 *
 * .seq - array of nested uniforms
 * .map - nested uniforms by name
 *
 *
 * Methods of all nodes except the top-level container:
 *
 * .setValue( gl, value, [textures] )
 *
 * 		uploads a uniform value(s)
 *  	the 'textures' parameter is needed for sampler uniforms
 *
 *
 * Static methods of the top-level container (textures factorizations):
 *
 * .upload( gl, seq, values, textures )
 *
 * 		sets uniforms in 'seq' to 'values[id].value'
 *
 * .seqWithValue( seq, values ) : filteredSeq
 *
 * 		filters 'seq' entries with corresponding entry in values
 *
 *
 * Methods of the top-level container (textures factorizations):
 *
 * .setValue( gl, name, value, textures )
 *
 * 		sets uniform with  name 'name' to 'value'
 *
 * .setOptional( gl, obj, prop )
 *
 * 		like .set for an optional property of the object
 *
 */ var $079becb54c0579a9$var$emptyTexture = /*@__PURE__*/ new (0, $1a55656020b89c3a$export$5431306cf43de24a)();
var $079becb54c0579a9$var$emptyShadowTexture = /*@__PURE__*/ new (0, $1a55656020b89c3a$export$fc830aa069cc8c2f)(1, 1);
var $079becb54c0579a9$var$emptyArrayTexture = /*@__PURE__*/ new (0, $1a55656020b89c3a$export$dfac6c8e811406a3)();
var $079becb54c0579a9$var$empty3dTexture = /*@__PURE__*/ new (0, $1a55656020b89c3a$export$d7a3086320f856db)();
var $079becb54c0579a9$var$emptyCubeTexture = /*@__PURE__*/ new (0, $1a55656020b89c3a$export$ee2e5a18258a4049)();
// --- Utilities ---
// Array Caches (provide typed arrays for temporary by size)
var $079becb54c0579a9$var$arrayCacheF32 = [];
var $079becb54c0579a9$var$arrayCacheI32 = [];
// Float32Array caches used for uploading Matrix uniforms
var $079becb54c0579a9$var$mat4array = new Float32Array(16);
var $079becb54c0579a9$var$mat3array = new Float32Array(9);
var $079becb54c0579a9$var$mat2array = new Float32Array(4);
// Flattening for arrays of vectors and matrices
function $079becb54c0579a9$var$flatten(array, nBlocks, blockSize) {
    var firstElem = array[0];
    if (firstElem <= 0 || firstElem > 0) return array;
    // unoptimized: ! isNaN( firstElem )
    // see http://jacksondunstan.com/articles/983
    var n = nBlocks * blockSize;
    var r = $079becb54c0579a9$var$arrayCacheF32[n];
    if (r === undefined) {
        r = new Float32Array(n);
        $079becb54c0579a9$var$arrayCacheF32[n] = r;
    }
    if (nBlocks !== 0) {
        firstElem.toArray(r, 0);
        for(var i = 1, offset = 0; i !== nBlocks; ++i){
            offset += blockSize;
            array[i].toArray(r, offset);
        }
    }
    return r;
}
function $079becb54c0579a9$var$arraysEqual(a, b) {
    if (a.length !== b.length) return false;
    for(var i = 0, l = a.length; i < l; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $079becb54c0579a9$var$copyArray(a, b) {
    for(var i = 0, l = b.length; i < l; i++)a[i] = b[i];
}
// Texture unit allocation
function $079becb54c0579a9$var$allocTexUnits(textures, n) {
    var r = $079becb54c0579a9$var$arrayCacheI32[n];
    if (r === undefined) {
        r = new Int32Array(n);
        $079becb54c0579a9$var$arrayCacheI32[n] = r;
    }
    for(var i = 0; i !== n; ++i)r[i] = textures.allocateTextureUnit();
    return r;
}
// --- Setters ---
// Note: Defining these methods externally, because they come in a bunch
// and this way their names minify.
// Single scalar
function $079becb54c0579a9$var$setValueV1f(gl, v) {
    var cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1f(this.addr, v);
    cache[0] = v;
}
// Single float vector (from flat array or THREE.VectorN)
function $079becb54c0579a9$var$setValueV2f(gl, v) {
    var cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2f(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($079becb54c0579a9$var$arraysEqual(cache, v)) return;
        gl.uniform2fv(this.addr, v);
        $079becb54c0579a9$var$copyArray(cache, v);
    }
}
function $079becb54c0579a9$var$setValueV3f(gl, v) {
    var cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3f(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else if (v.r !== undefined) {
        if (cache[0] !== v.r || cache[1] !== v.g || cache[2] !== v.b) {
            gl.uniform3f(this.addr, v.r, v.g, v.b);
            cache[0] = v.r;
            cache[1] = v.g;
            cache[2] = v.b;
        }
    } else {
        if ($079becb54c0579a9$var$arraysEqual(cache, v)) return;
        gl.uniform3fv(this.addr, v);
        $079becb54c0579a9$var$copyArray(cache, v);
    }
}
function $079becb54c0579a9$var$setValueV4f(gl, v) {
    var cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4f(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($079becb54c0579a9$var$arraysEqual(cache, v)) return;
        gl.uniform4fv(this.addr, v);
        $079becb54c0579a9$var$copyArray(cache, v);
    }
}
// Single matrix (from flat array or THREE.MatrixN)
function $079becb54c0579a9$var$setValueM2(gl, v) {
    var cache = this.cache;
    var elements = v.elements;
    if (elements === undefined) {
        if ($079becb54c0579a9$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix2fv(this.addr, false, v);
        $079becb54c0579a9$var$copyArray(cache, v);
    } else {
        if ($079becb54c0579a9$var$arraysEqual(cache, elements)) return;
        $079becb54c0579a9$var$mat2array.set(elements);
        gl.uniformMatrix2fv(this.addr, false, $079becb54c0579a9$var$mat2array);
        $079becb54c0579a9$var$copyArray(cache, elements);
    }
}
function $079becb54c0579a9$var$setValueM3(gl, v) {
    var cache = this.cache;
    var elements = v.elements;
    if (elements === undefined) {
        if ($079becb54c0579a9$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix3fv(this.addr, false, v);
        $079becb54c0579a9$var$copyArray(cache, v);
    } else {
        if ($079becb54c0579a9$var$arraysEqual(cache, elements)) return;
        $079becb54c0579a9$var$mat3array.set(elements);
        gl.uniformMatrix3fv(this.addr, false, $079becb54c0579a9$var$mat3array);
        $079becb54c0579a9$var$copyArray(cache, elements);
    }
}
function $079becb54c0579a9$var$setValueM4(gl, v) {
    var cache = this.cache;
    var elements = v.elements;
    if (elements === undefined) {
        if ($079becb54c0579a9$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix4fv(this.addr, false, v);
        $079becb54c0579a9$var$copyArray(cache, v);
    } else {
        if ($079becb54c0579a9$var$arraysEqual(cache, elements)) return;
        $079becb54c0579a9$var$mat4array.set(elements);
        gl.uniformMatrix4fv(this.addr, false, $079becb54c0579a9$var$mat4array);
        $079becb54c0579a9$var$copyArray(cache, elements);
    }
}
// Single integer / boolean
function $079becb54c0579a9$var$setValueV1i(gl, v) {
    var cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1i(this.addr, v);
    cache[0] = v;
}
// Single integer / boolean vector (from flat array or THREE.VectorN)
function $079becb54c0579a9$var$setValueV2i(gl, v) {
    var cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2i(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($079becb54c0579a9$var$arraysEqual(cache, v)) return;
        gl.uniform2iv(this.addr, v);
        $079becb54c0579a9$var$copyArray(cache, v);
    }
}
function $079becb54c0579a9$var$setValueV3i(gl, v) {
    var cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3i(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($079becb54c0579a9$var$arraysEqual(cache, v)) return;
        gl.uniform3iv(this.addr, v);
        $079becb54c0579a9$var$copyArray(cache, v);
    }
}
function $079becb54c0579a9$var$setValueV4i(gl, v) {
    var cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4i(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($079becb54c0579a9$var$arraysEqual(cache, v)) return;
        gl.uniform4iv(this.addr, v);
        $079becb54c0579a9$var$copyArray(cache, v);
    }
}
// Single unsigned integer
function $079becb54c0579a9$var$setValueV1ui(gl, v) {
    var cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1ui(this.addr, v);
    cache[0] = v;
}
// Single unsigned integer vector (from flat array or THREE.VectorN)
function $079becb54c0579a9$var$setValueV2ui(gl, v) {
    var cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2ui(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($079becb54c0579a9$var$arraysEqual(cache, v)) return;
        gl.uniform2uiv(this.addr, v);
        $079becb54c0579a9$var$copyArray(cache, v);
    }
}
function $079becb54c0579a9$var$setValueV3ui(gl, v) {
    var cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3ui(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($079becb54c0579a9$var$arraysEqual(cache, v)) return;
        gl.uniform3uiv(this.addr, v);
        $079becb54c0579a9$var$copyArray(cache, v);
    }
}
function $079becb54c0579a9$var$setValueV4ui(gl, v) {
    var cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4ui(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($079becb54c0579a9$var$arraysEqual(cache, v)) return;
        gl.uniform4uiv(this.addr, v);
        $079becb54c0579a9$var$copyArray(cache, v);
    }
}
// Single texture (2D / Cube)
function $079becb54c0579a9$var$setValueT1(gl, v, textures) {
    var cache = this.cache;
    var unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    var emptyTexture2D;
    if (this.type === gl.SAMPLER_2D_SHADOW) {
        $079becb54c0579a9$var$emptyShadowTexture.compareFunction = (0, $1a55656020b89c3a$export$64eea11eb407ddf1); // #28670
        emptyTexture2D = $079becb54c0579a9$var$emptyShadowTexture;
    } else emptyTexture2D = $079becb54c0579a9$var$emptyTexture;
    textures.setTexture2D(v || emptyTexture2D, unit);
}
function $079becb54c0579a9$var$setValueT3D1(gl, v, textures) {
    var cache = this.cache;
    var unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture3D(v || $079becb54c0579a9$var$empty3dTexture, unit);
}
function $079becb54c0579a9$var$setValueT6(gl, v, textures) {
    var cache = this.cache;
    var unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTextureCube(v || $079becb54c0579a9$var$emptyCubeTexture, unit);
}
function $079becb54c0579a9$var$setValueT2DArray1(gl, v, textures) {
    var cache = this.cache;
    var unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2DArray(v || $079becb54c0579a9$var$emptyArrayTexture, unit);
}
// Helper to pick the right setter for the singular case
function $079becb54c0579a9$var$getSingularSetter(type) {
    switch(type){
        case 0x1406:
            return $079becb54c0579a9$var$setValueV1f; // FLOAT
        case 0x8b50:
            return $079becb54c0579a9$var$setValueV2f; // _VEC2
        case 0x8b51:
            return $079becb54c0579a9$var$setValueV3f; // _VEC3
        case 0x8b52:
            return $079becb54c0579a9$var$setValueV4f; // _VEC4
        case 0x8b5a:
            return $079becb54c0579a9$var$setValueM2; // _MAT2
        case 0x8b5b:
            return $079becb54c0579a9$var$setValueM3; // _MAT3
        case 0x8b5c:
            return $079becb54c0579a9$var$setValueM4; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $079becb54c0579a9$var$setValueV1i; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $079becb54c0579a9$var$setValueV2i; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $079becb54c0579a9$var$setValueV3i; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $079becb54c0579a9$var$setValueV4i; // _VEC4
        case 0x1405:
            return $079becb54c0579a9$var$setValueV1ui; // UINT
        case 0x8dc6:
            return $079becb54c0579a9$var$setValueV2ui; // _VEC2
        case 0x8dc7:
            return $079becb54c0579a9$var$setValueV3ui; // _VEC3
        case 0x8dc8:
            return $079becb54c0579a9$var$setValueV4ui; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $079becb54c0579a9$var$setValueT1;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $079becb54c0579a9$var$setValueT3D1;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $079becb54c0579a9$var$setValueT6;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $079becb54c0579a9$var$setValueT2DArray1;
    }
}
// Array of scalars
function $079becb54c0579a9$var$setValueV1fArray(gl, v) {
    gl.uniform1fv(this.addr, v);
}
// Array of vectors (from flat array or array of THREE.VectorN)
function $079becb54c0579a9$var$setValueV2fArray(gl, v) {
    var data = $079becb54c0579a9$var$flatten(v, this.size, 2);
    gl.uniform2fv(this.addr, data);
}
function $079becb54c0579a9$var$setValueV3fArray(gl, v) {
    var data = $079becb54c0579a9$var$flatten(v, this.size, 3);
    gl.uniform3fv(this.addr, data);
}
function $079becb54c0579a9$var$setValueV4fArray(gl, v) {
    var data = $079becb54c0579a9$var$flatten(v, this.size, 4);
    gl.uniform4fv(this.addr, data);
}
// Array of matrices (from flat array or array of THREE.MatrixN)
function $079becb54c0579a9$var$setValueM2Array(gl, v) {
    var data = $079becb54c0579a9$var$flatten(v, this.size, 4);
    gl.uniformMatrix2fv(this.addr, false, data);
}
function $079becb54c0579a9$var$setValueM3Array(gl, v) {
    var data = $079becb54c0579a9$var$flatten(v, this.size, 9);
    gl.uniformMatrix3fv(this.addr, false, data);
}
function $079becb54c0579a9$var$setValueM4Array(gl, v) {
    var data = $079becb54c0579a9$var$flatten(v, this.size, 16);
    gl.uniformMatrix4fv(this.addr, false, data);
}
// Array of integer / boolean
function $079becb54c0579a9$var$setValueV1iArray(gl, v) {
    gl.uniform1iv(this.addr, v);
}
// Array of integer / boolean vectors (from flat array)
function $079becb54c0579a9$var$setValueV2iArray(gl, v) {
    gl.uniform2iv(this.addr, v);
}
function $079becb54c0579a9$var$setValueV3iArray(gl, v) {
    gl.uniform3iv(this.addr, v);
}
function $079becb54c0579a9$var$setValueV4iArray(gl, v) {
    gl.uniform4iv(this.addr, v);
}
// Array of unsigned integer
function $079becb54c0579a9$var$setValueV1uiArray(gl, v) {
    gl.uniform1uiv(this.addr, v);
}
// Array of unsigned integer vectors (from flat array)
function $079becb54c0579a9$var$setValueV2uiArray(gl, v) {
    gl.uniform2uiv(this.addr, v);
}
function $079becb54c0579a9$var$setValueV3uiArray(gl, v) {
    gl.uniform3uiv(this.addr, v);
}
function $079becb54c0579a9$var$setValueV4uiArray(gl, v) {
    gl.uniform4uiv(this.addr, v);
}
// Array of textures (2D / 3D / Cube / 2DArray)
function $079becb54c0579a9$var$setValueT1Array(gl, v, textures) {
    var cache = this.cache;
    var n = v.length;
    var units = $079becb54c0579a9$var$allocTexUnits(textures, n);
    if (!$079becb54c0579a9$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $079becb54c0579a9$var$copyArray(cache, units);
    }
    for(var i = 0; i !== n; ++i)textures.setTexture2D(v[i] || $079becb54c0579a9$var$emptyTexture, units[i]);
}
function $079becb54c0579a9$var$setValueT3DArray(gl, v, textures) {
    var cache = this.cache;
    var n = v.length;
    var units = $079becb54c0579a9$var$allocTexUnits(textures, n);
    if (!$079becb54c0579a9$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $079becb54c0579a9$var$copyArray(cache, units);
    }
    for(var i = 0; i !== n; ++i)textures.setTexture3D(v[i] || $079becb54c0579a9$var$empty3dTexture, units[i]);
}
function $079becb54c0579a9$var$setValueT6Array(gl, v, textures) {
    var cache = this.cache;
    var n = v.length;
    var units = $079becb54c0579a9$var$allocTexUnits(textures, n);
    if (!$079becb54c0579a9$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $079becb54c0579a9$var$copyArray(cache, units);
    }
    for(var i = 0; i !== n; ++i)textures.setTextureCube(v[i] || $079becb54c0579a9$var$emptyCubeTexture, units[i]);
}
function $079becb54c0579a9$var$setValueT2DArrayArray(gl, v, textures) {
    var cache = this.cache;
    var n = v.length;
    var units = $079becb54c0579a9$var$allocTexUnits(textures, n);
    if (!$079becb54c0579a9$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $079becb54c0579a9$var$copyArray(cache, units);
    }
    for(var i = 0; i !== n; ++i)textures.setTexture2DArray(v[i] || $079becb54c0579a9$var$emptyArrayTexture, units[i]);
}
// Helper to pick the right setter for a pure (bottom-level) array
function $079becb54c0579a9$var$getPureArraySetter(type) {
    switch(type){
        case 0x1406:
            return $079becb54c0579a9$var$setValueV1fArray; // FLOAT
        case 0x8b50:
            return $079becb54c0579a9$var$setValueV2fArray; // _VEC2
        case 0x8b51:
            return $079becb54c0579a9$var$setValueV3fArray; // _VEC3
        case 0x8b52:
            return $079becb54c0579a9$var$setValueV4fArray; // _VEC4
        case 0x8b5a:
            return $079becb54c0579a9$var$setValueM2Array; // _MAT2
        case 0x8b5b:
            return $079becb54c0579a9$var$setValueM3Array; // _MAT3
        case 0x8b5c:
            return $079becb54c0579a9$var$setValueM4Array; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $079becb54c0579a9$var$setValueV1iArray; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $079becb54c0579a9$var$setValueV2iArray; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $079becb54c0579a9$var$setValueV3iArray; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $079becb54c0579a9$var$setValueV4iArray; // _VEC4
        case 0x1405:
            return $079becb54c0579a9$var$setValueV1uiArray; // UINT
        case 0x8dc6:
            return $079becb54c0579a9$var$setValueV2uiArray; // _VEC2
        case 0x8dc7:
            return $079becb54c0579a9$var$setValueV3uiArray; // _VEC3
        case 0x8dc8:
            return $079becb54c0579a9$var$setValueV4uiArray; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $079becb54c0579a9$var$setValueT1Array;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $079becb54c0579a9$var$setValueT3DArray;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $079becb54c0579a9$var$setValueT6Array;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $079becb54c0579a9$var$setValueT2DArrayArray;
    }
}
// --- Uniform Classes ---
var $079becb54c0579a9$var$SingleUniform = function SingleUniform(id, activeInfo, addr) {
    "use strict";
    (0, $9a1684911372ec89$export$71511d61b312f219)(this, SingleUniform);
    this.id = id;
    this.addr = addr;
    this.cache = [];
    this.type = activeInfo.type;
    this.setValue = $079becb54c0579a9$var$getSingularSetter(activeInfo.type);
};
var $079becb54c0579a9$var$PureArrayUniform = function PureArrayUniform(id, activeInfo, addr) {
    "use strict";
    (0, $9a1684911372ec89$export$71511d61b312f219)(this, PureArrayUniform);
    this.id = id;
    this.addr = addr;
    this.cache = [];
    this.type = activeInfo.type;
    this.size = activeInfo.size;
    this.setValue = $079becb54c0579a9$var$getPureArraySetter(activeInfo.type);
};
var $079becb54c0579a9$var$StructuredUniform = /*#__PURE__*/ function() {
    "use strict";
    function StructuredUniform(id) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, StructuredUniform);
        this.id = id;
        this.seq = [];
        this.map = {};
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(StructuredUniform, [
        {
            key: "setValue",
            value: function setValue(gl, value, textures) {
                var seq = this.seq;
                for(var i = 0, n = seq.length; i !== n; ++i){
                    var u = seq[i];
                    u.setValue(gl, value[u.id], textures);
                }
            }
        }
    ]);
    return StructuredUniform;
}();
// --- Top-level ---
// Parser - builds up the property tree from the path strings
var $079becb54c0579a9$var$RePathPart = /(\w+)(\])?(\[|\.)?/g;
// extracts
// 	- the identifier (member name or array index)
//  - followed by an optional right bracket (found when array index)
//  - followed by an optional left bracket or dot (type of subscript)
//
// Note: These portions can be read in a non-overlapping fashion and
// allow straightforward parsing of the hierarchy that WebGL encodes
// in the uniform names.
function $079becb54c0579a9$var$addUniform(container, uniformObject) {
    container.seq.push(uniformObject);
    container.map[uniformObject.id] = uniformObject;
}
function $079becb54c0579a9$var$parseUniform(activeInfo, addr, container) {
    var path = activeInfo.name, pathLength = path.length;
    // reset RegExp object, because of the early exit of a previous run
    $079becb54c0579a9$var$RePathPart.lastIndex = 0;
    while(true){
        var match = $079becb54c0579a9$var$RePathPart.exec(path), matchEnd = $079becb54c0579a9$var$RePathPart.lastIndex;
        var id = match[1];
        var idIsIndex = match[2] === ']', subscript = match[3];
        if (idIsIndex) id = id | 0; // convert to integer
        if (subscript === undefined || subscript === '[' && matchEnd + 2 === pathLength) {
            // bare name or "pure" bottom-level array "[0]" suffix
            $079becb54c0579a9$var$addUniform(container, subscript === undefined ? new $079becb54c0579a9$var$SingleUniform(id, activeInfo, addr) : new $079becb54c0579a9$var$PureArrayUniform(id, activeInfo, addr));
            break;
        } else {
            // step into inner node / create it in case it doesn't exist
            var map = container.map;
            var next = map[id];
            if (next === undefined) {
                next = new $079becb54c0579a9$var$StructuredUniform(id);
                $079becb54c0579a9$var$addUniform(container, next);
            }
            container = next;
        }
    }
}
// Root Container
var $079becb54c0579a9$var$WebGLUniforms = /*#__PURE__*/ function() {
    "use strict";
    function WebGLUniforms(gl, program) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, WebGLUniforms);
        this.seq = [];
        this.map = {};
        var n = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
        for(var i = 0; i < n; ++i){
            var info = gl.getActiveUniform(program, i), addr = gl.getUniformLocation(program, info.name);
            $079becb54c0579a9$var$parseUniform(info, addr, this);
        }
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(WebGLUniforms, [
        {
            key: "setValue",
            value: function setValue(gl, name, value, textures) {
                var u = this.map[name];
                if (u !== undefined) u.setValue(gl, value, textures);
            }
        },
        {
            key: "setOptional",
            value: function setOptional(gl, object, name) {
                var v = object[name];
                if (v !== undefined) this.setValue(gl, name, v);
            }
        }
    ], [
        {
            key: "upload",
            value: function upload(gl, seq, values, textures) {
                for(var i = 0, n = seq.length; i !== n; ++i){
                    var u = seq[i], v = values[u.id];
                    if (v.needsUpdate !== false) // note: always updating when .needsUpdate is undefined
                    u.setValue(gl, v.value, textures);
                }
            }
        },
        {
            key: "seqWithValue",
            value: function seqWithValue(seq, values) {
                var r = [];
                for(var i = 0, n = seq.length; i !== n; ++i){
                    var u = seq[i];
                    if (u.id in values) r.push(u);
                }
                return r;
            }
        }
    ]);
    return WebGLUniforms;
}();
function $079becb54c0579a9$var$WebGLShader(gl, type, string) {
    var shader = gl.createShader(type);
    gl.shaderSource(shader, string);
    gl.compileShader(shader);
    return shader;
}
// From https://www.khronos.org/registry/webgl/extensions/KHR_parallel_shader_compile/
var $079becb54c0579a9$var$COMPLETION_STATUS_KHR = 0x91B1;
var $079becb54c0579a9$var$programIdCount = 0;
function $079becb54c0579a9$var$handleSource(string, errorLine) {
    var lines = string.split('\n');
    var lines2 = [];
    var from = Math.max(errorLine - 6, 0);
    var to = Math.min(errorLine + 6, lines.length);
    for(var i = from; i < to; i++){
        var line = i + 1;
        lines2.push("".concat(line === errorLine ? '>' : ' ', " ").concat(line, ": ").concat(lines[i]));
    }
    return lines2.join('\n');
}
var $079becb54c0579a9$var$_m0 = /*@__PURE__*/ new (0, $1a55656020b89c3a$export$8ff26dafa08918)();
function $079becb54c0579a9$var$getEncodingComponents(colorSpace) {
    (0, $1a55656020b89c3a$export$5e6fd513f44698c)._getMatrix($079becb54c0579a9$var$_m0, (0, $1a55656020b89c3a$export$5e6fd513f44698c).workingColorSpace, colorSpace);
    var encodingMatrix = "mat3( ".concat($079becb54c0579a9$var$_m0.elements.map(function(v) {
        return v.toFixed(4);
    }), " )");
    switch((0, $1a55656020b89c3a$export$5e6fd513f44698c).getTransfer(colorSpace)){
        case 0, $1a55656020b89c3a$export$f197347d588c1b4a:
            return [
                encodingMatrix,
                'LinearTransferOETF'
            ];
        case 0, $1a55656020b89c3a$export$8d0a61916cc26abb:
            return [
                encodingMatrix,
                'sRGBTransferOETF'
            ];
        default:
            console.warn('THREE.WebGLProgram: Unsupported color space: ', colorSpace);
            return [
                encodingMatrix,
                'LinearTransferOETF'
            ];
    }
}
function $079becb54c0579a9$var$getShaderErrors(gl, shader, type) {
    var status = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
    var errors = gl.getShaderInfoLog(shader).trim();
    if (status && errors === '') return '';
    var errorMatches = /ERROR: 0:(\d+)/.exec(errors);
    if (errorMatches) {
        // --enable-privileged-webgl-extension
        // console.log( '**' + type + '**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );
        var errorLine = parseInt(errorMatches[1]);
        return type.toUpperCase() + '\n\n' + errors + '\n\n' + $079becb54c0579a9$var$handleSource(gl.getShaderSource(shader), errorLine);
    } else return errors;
}
function $079becb54c0579a9$var$getTexelEncodingFunction(functionName, colorSpace) {
    var components = $079becb54c0579a9$var$getEncodingComponents(colorSpace);
    return [
        "vec4 ".concat(functionName, "( vec4 value ) {"),
        "	return ".concat(components[1], "( vec4( value.rgb * ").concat(components[0], ", value.a ) );"),
        '}'
    ].join('\n');
}
function $079becb54c0579a9$var$getToneMappingFunction(functionName, toneMapping) {
    var toneMappingName;
    switch(toneMapping){
        case 0, $1a55656020b89c3a$export$98f52c2a46c598ca:
            toneMappingName = 'Linear';
            break;
        case 0, $1a55656020b89c3a$export$74b25e54b3bcd548:
            toneMappingName = 'Reinhard';
            break;
        case 0, $1a55656020b89c3a$export$932b3dd283d4a366:
            toneMappingName = 'Cineon';
            break;
        case 0, $1a55656020b89c3a$export$a0d98fe6d7e4af64:
            toneMappingName = 'ACESFilmic';
            break;
        case 0, $1a55656020b89c3a$export$212d53a513a325b2:
            toneMappingName = 'AgX';
            break;
        case 0, $1a55656020b89c3a$export$f2863e1668a8e317:
            toneMappingName = 'Neutral';
            break;
        case 0, $1a55656020b89c3a$export$2c7b09c1e9abfb5e:
            toneMappingName = 'Custom';
            break;
        default:
            console.warn('THREE.WebGLProgram: Unsupported toneMapping:', toneMapping);
            toneMappingName = 'Linear';
    }
    return 'vec3 ' + functionName + '( vec3 color ) { return ' + toneMappingName + 'ToneMapping( color ); }';
}
var $079becb54c0579a9$var$_v0 = /*@__PURE__*/ new (0, $1a55656020b89c3a$export$64b5c384219d3699)();
function $079becb54c0579a9$var$getLuminanceFunction() {
    (0, $1a55656020b89c3a$export$5e6fd513f44698c).getLuminanceCoefficients($079becb54c0579a9$var$_v0);
    var r = $079becb54c0579a9$var$_v0.x.toFixed(4);
    var g = $079becb54c0579a9$var$_v0.y.toFixed(4);
    var b = $079becb54c0579a9$var$_v0.z.toFixed(4);
    return [
        'float luminance( const in vec3 rgb ) {',
        "	const vec3 weights = vec3( ".concat(r, ", ").concat(g, ", ").concat(b, " );"),
        '	return dot( weights, rgb );',
        '}'
    ].join('\n');
}
function $079becb54c0579a9$var$generateVertexExtensions(parameters) {
    var chunks = [
        parameters.extensionClipCullDistance ? '#extension GL_ANGLE_clip_cull_distance : require' : '',
        parameters.extensionMultiDraw ? '#extension GL_ANGLE_multi_draw : require' : ''
    ];
    return chunks.filter($079becb54c0579a9$var$filterEmptyLine).join('\n');
}
function $079becb54c0579a9$var$generateDefines(defines) {
    var chunks = [];
    for(var name in defines){
        var value = defines[name];
        if (value === false) continue;
        chunks.push('#define ' + name + ' ' + value);
    }
    return chunks.join('\n');
}
function $079becb54c0579a9$var$fetchAttributeLocations(gl, program) {
    var attributes = {};
    var n = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
    for(var i = 0; i < n; i++){
        var info = gl.getActiveAttrib(program, i);
        var name = info.name;
        var locationSize = 1;
        if (info.type === gl.FLOAT_MAT2) locationSize = 2;
        if (info.type === gl.FLOAT_MAT3) locationSize = 3;
        if (info.type === gl.FLOAT_MAT4) locationSize = 4;
        // console.log( 'THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );
        attributes[name] = {
            type: info.type,
            location: gl.getAttribLocation(program, name),
            locationSize: locationSize
        };
    }
    return attributes;
}
function $079becb54c0579a9$var$filterEmptyLine(string) {
    return string !== '';
}
function $079becb54c0579a9$var$replaceLightNums(string, parameters) {
    var numSpotLightCoords = parameters.numSpotLightShadows + parameters.numSpotLightMaps - parameters.numSpotLightShadowsWithMaps;
    return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, parameters.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, numSpotLightCoords).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, parameters.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}
function $079becb54c0579a9$var$replaceClippingPlaneNums(string, parameters) {
    return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
}
// Resolve Includes
var $079becb54c0579a9$var$includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
function $079becb54c0579a9$var$resolveIncludes(string) {
    return string.replace($079becb54c0579a9$var$includePattern, $079becb54c0579a9$var$includeReplacer);
}
var $079becb54c0579a9$var$shaderChunkMap = new Map();
function $079becb54c0579a9$var$includeReplacer(match, include) {
    var string = $079becb54c0579a9$export$955f9f2e84c43c8b[include];
    if (string === undefined) {
        var newInclude = $079becb54c0579a9$var$shaderChunkMap.get(include);
        if (newInclude !== undefined) {
            string = $079becb54c0579a9$export$955f9f2e84c43c8b[newInclude];
            console.warn('THREE.WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', include, newInclude);
        } else throw new Error('Can not resolve #include <' + include + '>');
    }
    return $079becb54c0579a9$var$resolveIncludes(string);
}
// Unroll Loops
var $079becb54c0579a9$var$unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function $079becb54c0579a9$var$unrollLoops(string) {
    return string.replace($079becb54c0579a9$var$unrollLoopPattern, $079becb54c0579a9$var$loopReplacer);
}
function $079becb54c0579a9$var$loopReplacer(match, start, end, snippet) {
    var string = '';
    for(var i = parseInt(start); i < parseInt(end); i++)string += snippet.replace(/\[\s*i\s*\]/g, '[ ' + i + ' ]').replace(/UNROLLED_LOOP_INDEX/g, i);
    return string;
}
//
function $079becb54c0579a9$var$generatePrecision(parameters) {
    var precisionstring = "precision ".concat(parameters.precision, " float;\n	precision ").concat(parameters.precision, " int;\n	precision ").concat(parameters.precision, " sampler2D;\n	precision ").concat(parameters.precision, " samplerCube;\n	precision ").concat(parameters.precision, " sampler3D;\n	precision ").concat(parameters.precision, " sampler2DArray;\n	precision ").concat(parameters.precision, " sampler2DShadow;\n	precision ").concat(parameters.precision, " samplerCubeShadow;\n	precision ").concat(parameters.precision, " sampler2DArrayShadow;\n	precision ").concat(parameters.precision, " isampler2D;\n	precision ").concat(parameters.precision, " isampler3D;\n	precision ").concat(parameters.precision, " isamplerCube;\n	precision ").concat(parameters.precision, " isampler2DArray;\n	precision ").concat(parameters.precision, " usampler2D;\n	precision ").concat(parameters.precision, " usampler3D;\n	precision ").concat(parameters.precision, " usamplerCube;\n	precision ").concat(parameters.precision, " usampler2DArray;\n	");
    if (parameters.precision === 'highp') precisionstring += '\n#define HIGH_PRECISION';
    else if (parameters.precision === 'mediump') precisionstring += '\n#define MEDIUM_PRECISION';
    else if (parameters.precision === 'lowp') precisionstring += '\n#define LOW_PRECISION';
    return precisionstring;
}
function $079becb54c0579a9$var$generateShadowMapTypeDefine(parameters) {
    var shadowMapTypeDefine = 'SHADOWMAP_TYPE_BASIC';
    if (parameters.shadowMapType === (0, $1a55656020b89c3a$export$5813f879eee7cd88)) shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF';
    else if (parameters.shadowMapType === (0, $1a55656020b89c3a$export$a47c4b43a1be34f0)) shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF_SOFT';
    else if (parameters.shadowMapType === (0, $1a55656020b89c3a$export$896ae1ade6c829c4)) shadowMapTypeDefine = 'SHADOWMAP_TYPE_VSM';
    return shadowMapTypeDefine;
}
function $079becb54c0579a9$var$generateEnvMapTypeDefine(parameters) {
    var envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
    if (parameters.envMap) switch(parameters.envMapMode){
        case 0, $1a55656020b89c3a$export$8759762a6477f2c4:
        case 0, $1a55656020b89c3a$export$dc59f8aed047f61d:
            envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
            break;
        case 0, $1a55656020b89c3a$export$dbf3e70ff37af79:
            envMapTypeDefine = 'ENVMAP_TYPE_CUBE_UV';
            break;
    }
    return envMapTypeDefine;
}
function $079becb54c0579a9$var$generateEnvMapModeDefine(parameters) {
    var envMapModeDefine = 'ENVMAP_MODE_REFLECTION';
    if (parameters.envMap) switch(parameters.envMapMode){
        case 0, $1a55656020b89c3a$export$dc59f8aed047f61d:
            envMapModeDefine = 'ENVMAP_MODE_REFRACTION';
            break;
    }
    return envMapModeDefine;
}
function $079becb54c0579a9$var$generateEnvMapBlendingDefine(parameters) {
    var envMapBlendingDefine = 'ENVMAP_BLENDING_NONE';
    if (parameters.envMap) switch(parameters.combine){
        case 0, $1a55656020b89c3a$export$e50ac29801f1774d:
            envMapBlendingDefine = 'ENVMAP_BLENDING_MULTIPLY';
            break;
        case 0, $1a55656020b89c3a$export$9f9d94f963c85479:
            envMapBlendingDefine = 'ENVMAP_BLENDING_MIX';
            break;
        case 0, $1a55656020b89c3a$export$e641dc52bc3494aa:
            envMapBlendingDefine = 'ENVMAP_BLENDING_ADD';
            break;
    }
    return envMapBlendingDefine;
}
function $079becb54c0579a9$var$generateCubeUVSize(parameters) {
    var imageHeight = parameters.envMapCubeUVHeight;
    if (imageHeight === null) return null;
    var maxMip = Math.log2(imageHeight) - 2;
    var texelHeight = 1.0 / imageHeight;
    var texelWidth = 1.0 / (3 * Math.max(Math.pow(2, maxMip), 112));
    return {
        texelWidth: texelWidth,
        texelHeight: texelHeight,
        maxMip: maxMip
    };
}
function $079becb54c0579a9$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates) {
    // TODO Send this event to Three.js DevTools
    // console.log( 'WebGLProgram', cacheKey );
    var gl = renderer.getContext();
    var defines = parameters.defines;
    var vertexShader = parameters.vertexShader;
    var fragmentShader = parameters.fragmentShader;
    var shadowMapTypeDefine = $079becb54c0579a9$var$generateShadowMapTypeDefine(parameters);
    var envMapTypeDefine = $079becb54c0579a9$var$generateEnvMapTypeDefine(parameters);
    var envMapModeDefine = $079becb54c0579a9$var$generateEnvMapModeDefine(parameters);
    var envMapBlendingDefine = $079becb54c0579a9$var$generateEnvMapBlendingDefine(parameters);
    var envMapCubeUVSize = $079becb54c0579a9$var$generateCubeUVSize(parameters);
    var customVertexExtensions = $079becb54c0579a9$var$generateVertexExtensions(parameters);
    var customDefines = $079becb54c0579a9$var$generateDefines(defines);
    var program = gl.createProgram();
    var prefixVertex, prefixFragment;
    var versionString = parameters.glslVersion ? '#version ' + parameters.glslVersion + '\n' : '';
    if (parameters.isRawShaderMaterial) {
        prefixVertex = [
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines
        ].filter($079becb54c0579a9$var$filterEmptyLine).join('\n');
        if (prefixVertex.length > 0) prefixVertex += '\n';
        prefixFragment = [
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines
        ].filter($079becb54c0579a9$var$filterEmptyLine).join('\n');
        if (prefixFragment.length > 0) prefixFragment += '\n';
    } else {
        prefixVertex = [
            $079becb54c0579a9$var$generatePrecision(parameters),
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.extensionClipCullDistance ? '#define USE_CLIP_DISTANCE' : '',
            parameters.batching ? '#define USE_BATCHING' : '',
            parameters.batchingColor ? '#define USE_BATCHING_COLOR' : '',
            parameters.instancing ? '#define USE_INSTANCING' : '',
            parameters.instancingColor ? '#define USE_INSTANCING_COLOR' : '',
            parameters.instancingMorph ? '#define USE_INSTANCING_MORPH' : '',
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '',
            parameters.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '',
            parameters.displacementMap ? '#define USE_DISPLACEMENTMAP' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.anisotropy ? '#define USE_ANISOTROPY' : '',
            parameters.anisotropyMap ? '#define USE_ANISOTROPYMAP' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
            parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '',
            parameters.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.alphaHash ? '#define USE_ALPHAHASH' : '',
            parameters.transmission ? '#define USE_TRANSMISSION' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            parameters.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '',
            parameters.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '',
            //
            parameters.mapUv ? '#define MAP_UV ' + parameters.mapUv : '',
            parameters.alphaMapUv ? '#define ALPHAMAP_UV ' + parameters.alphaMapUv : '',
            parameters.lightMapUv ? '#define LIGHTMAP_UV ' + parameters.lightMapUv : '',
            parameters.aoMapUv ? '#define AOMAP_UV ' + parameters.aoMapUv : '',
            parameters.emissiveMapUv ? '#define EMISSIVEMAP_UV ' + parameters.emissiveMapUv : '',
            parameters.bumpMapUv ? '#define BUMPMAP_UV ' + parameters.bumpMapUv : '',
            parameters.normalMapUv ? '#define NORMALMAP_UV ' + parameters.normalMapUv : '',
            parameters.displacementMapUv ? '#define DISPLACEMENTMAP_UV ' + parameters.displacementMapUv : '',
            parameters.metalnessMapUv ? '#define METALNESSMAP_UV ' + parameters.metalnessMapUv : '',
            parameters.roughnessMapUv ? '#define ROUGHNESSMAP_UV ' + parameters.roughnessMapUv : '',
            parameters.anisotropyMapUv ? '#define ANISOTROPYMAP_UV ' + parameters.anisotropyMapUv : '',
            parameters.clearcoatMapUv ? '#define CLEARCOATMAP_UV ' + parameters.clearcoatMapUv : '',
            parameters.clearcoatNormalMapUv ? '#define CLEARCOAT_NORMALMAP_UV ' + parameters.clearcoatNormalMapUv : '',
            parameters.clearcoatRoughnessMapUv ? '#define CLEARCOAT_ROUGHNESSMAP_UV ' + parameters.clearcoatRoughnessMapUv : '',
            parameters.iridescenceMapUv ? '#define IRIDESCENCEMAP_UV ' + parameters.iridescenceMapUv : '',
            parameters.iridescenceThicknessMapUv ? '#define IRIDESCENCE_THICKNESSMAP_UV ' + parameters.iridescenceThicknessMapUv : '',
            parameters.sheenColorMapUv ? '#define SHEEN_COLORMAP_UV ' + parameters.sheenColorMapUv : '',
            parameters.sheenRoughnessMapUv ? '#define SHEEN_ROUGHNESSMAP_UV ' + parameters.sheenRoughnessMapUv : '',
            parameters.specularMapUv ? '#define SPECULARMAP_UV ' + parameters.specularMapUv : '',
            parameters.specularColorMapUv ? '#define SPECULAR_COLORMAP_UV ' + parameters.specularColorMapUv : '',
            parameters.specularIntensityMapUv ? '#define SPECULAR_INTENSITYMAP_UV ' + parameters.specularIntensityMapUv : '',
            parameters.transmissionMapUv ? '#define TRANSMISSIONMAP_UV ' + parameters.transmissionMapUv : '',
            parameters.thicknessMapUv ? '#define THICKNESSMAP_UV ' + parameters.thicknessMapUv : '',
            //
            parameters.vertexTangents && parameters.flatShading === false ? '#define USE_TANGENT' : '',
            parameters.vertexColors ? '#define USE_COLOR' : '',
            parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
            parameters.vertexUv1s ? '#define USE_UV1' : '',
            parameters.vertexUv2s ? '#define USE_UV2' : '',
            parameters.vertexUv3s ? '#define USE_UV3' : '',
            parameters.pointsUvs ? '#define USE_POINTS_UV' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.skinning ? '#define USE_SKINNING' : '',
            parameters.morphTargets ? '#define USE_MORPHTARGETS' : '',
            parameters.morphNormals && parameters.flatShading === false ? '#define USE_MORPHNORMALS' : '',
            parameters.morphColors ? '#define USE_MORPHCOLORS' : '',
            parameters.morphTargetsCount > 0 ? '#define MORPHTARGETS_TEXTURE_STRIDE ' + parameters.morphTextureStride : '',
            parameters.morphTargetsCount > 0 ? '#define MORPHTARGETS_COUNT ' + parameters.morphTargetsCount : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.sizeAttenuation ? '#define USE_SIZEATTENUATION' : '',
            parameters.numLightProbes > 0 ? '#define USE_LIGHT_PROBES' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
            parameters.reverseDepthBuffer ? '#define USE_REVERSEDEPTHBUF' : '',
            'uniform mat4 modelMatrix;',
            'uniform mat4 modelViewMatrix;',
            'uniform mat4 projectionMatrix;',
            'uniform mat4 viewMatrix;',
            'uniform mat3 normalMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            '#ifdef USE_INSTANCING',
            '	attribute mat4 instanceMatrix;',
            '#endif',
            '#ifdef USE_INSTANCING_COLOR',
            '	attribute vec3 instanceColor;',
            '#endif',
            '#ifdef USE_INSTANCING_MORPH',
            '	uniform sampler2D morphTexture;',
            '#endif',
            'attribute vec3 position;',
            'attribute vec3 normal;',
            'attribute vec2 uv;',
            '#ifdef USE_UV1',
            '	attribute vec2 uv1;',
            '#endif',
            '#ifdef USE_UV2',
            '	attribute vec2 uv2;',
            '#endif',
            '#ifdef USE_UV3',
            '	attribute vec2 uv3;',
            '#endif',
            '#ifdef USE_TANGENT',
            '	attribute vec4 tangent;',
            '#endif',
            '#if defined( USE_COLOR_ALPHA )',
            '	attribute vec4 color;',
            '#elif defined( USE_COLOR )',
            '	attribute vec3 color;',
            '#endif',
            '#ifdef USE_SKINNING',
            '	attribute vec4 skinIndex;',
            '	attribute vec4 skinWeight;',
            '#endif',
            '\n'
        ].filter($079becb54c0579a9$var$filterEmptyLine).join('\n');
        prefixFragment = [
            $079becb54c0579a9$var$generatePrecision(parameters),
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.alphaToCoverage ? '#define ALPHA_TO_COVERAGE' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.matcap ? '#define USE_MATCAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapTypeDefine : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.envMap ? '#define ' + envMapBlendingDefine : '',
            envMapCubeUVSize ? '#define CUBEUV_TEXEL_WIDTH ' + envMapCubeUVSize.texelWidth : '',
            envMapCubeUVSize ? '#define CUBEUV_TEXEL_HEIGHT ' + envMapCubeUVSize.texelHeight : '',
            envMapCubeUVSize ? '#define CUBEUV_MAX_MIP ' + envMapCubeUVSize.maxMip + '.0' : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '',
            parameters.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.anisotropy ? '#define USE_ANISOTROPY' : '',
            parameters.anisotropyMap ? '#define USE_ANISOTROPYMAP' : '',
            parameters.clearcoat ? '#define USE_CLEARCOAT' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.dispersion ? '#define USE_DISPERSION' : '',
            parameters.iridescence ? '#define USE_IRIDESCENCE' : '',
            parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
            parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '',
            parameters.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.alphaTest ? '#define USE_ALPHATEST' : '',
            parameters.alphaHash ? '#define USE_ALPHAHASH' : '',
            parameters.sheen ? '#define USE_SHEEN' : '',
            parameters.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '',
            parameters.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '',
            parameters.transmission ? '#define USE_TRANSMISSION' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            parameters.vertexTangents && parameters.flatShading === false ? '#define USE_TANGENT' : '',
            parameters.vertexColors || parameters.instancingColor || parameters.batchingColor ? '#define USE_COLOR' : '',
            parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
            parameters.vertexUv1s ? '#define USE_UV1' : '',
            parameters.vertexUv2s ? '#define USE_UV2' : '',
            parameters.vertexUv3s ? '#define USE_UV3' : '',
            parameters.pointsUvs ? '#define USE_POINTS_UV' : '',
            parameters.gradientMap ? '#define USE_GRADIENTMAP' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.premultipliedAlpha ? '#define PREMULTIPLIED_ALPHA' : '',
            parameters.numLightProbes > 0 ? '#define USE_LIGHT_PROBES' : '',
            parameters.decodeVideoTexture ? '#define DECODE_VIDEO_TEXTURE' : '',
            parameters.decodeVideoTextureEmissive ? '#define DECODE_VIDEO_TEXTURE_EMISSIVE' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
            parameters.reverseDepthBuffer ? '#define USE_REVERSEDEPTHBUF' : '',
            'uniform mat4 viewMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            parameters.toneMapping !== (0, $1a55656020b89c3a$export$9fcb6b4294603b2) ? '#define TONE_MAPPING' : '',
            parameters.toneMapping !== (0, $1a55656020b89c3a$export$9fcb6b4294603b2) ? $079becb54c0579a9$export$955f9f2e84c43c8b['tonemapping_pars_fragment'] : '',
            parameters.toneMapping !== (0, $1a55656020b89c3a$export$9fcb6b4294603b2) ? $079becb54c0579a9$var$getToneMappingFunction('toneMapping', parameters.toneMapping) : '',
            parameters.dithering ? '#define DITHERING' : '',
            parameters.opaque ? '#define OPAQUE' : '',
            $079becb54c0579a9$export$955f9f2e84c43c8b['colorspace_pars_fragment'],
            $079becb54c0579a9$var$getTexelEncodingFunction('linearToOutputTexel', parameters.outputColorSpace),
            $079becb54c0579a9$var$getLuminanceFunction(),
            parameters.useDepthPacking ? '#define DEPTH_PACKING ' + parameters.depthPacking : '',
            '\n'
        ].filter($079becb54c0579a9$var$filterEmptyLine).join('\n');
    }
    vertexShader = $079becb54c0579a9$var$resolveIncludes(vertexShader);
    vertexShader = $079becb54c0579a9$var$replaceLightNums(vertexShader, parameters);
    vertexShader = $079becb54c0579a9$var$replaceClippingPlaneNums(vertexShader, parameters);
    fragmentShader = $079becb54c0579a9$var$resolveIncludes(fragmentShader);
    fragmentShader = $079becb54c0579a9$var$replaceLightNums(fragmentShader, parameters);
    fragmentShader = $079becb54c0579a9$var$replaceClippingPlaneNums(fragmentShader, parameters);
    vertexShader = $079becb54c0579a9$var$unrollLoops(vertexShader);
    fragmentShader = $079becb54c0579a9$var$unrollLoops(fragmentShader);
    if (parameters.isRawShaderMaterial !== true) {
        // GLSL 3.0 conversion for built-in materials and ShaderMaterial
        versionString = '#version 300 es\n';
        prefixVertex = [
            customVertexExtensions,
            '#define attribute in',
            '#define varying out',
            '#define texture2D texture'
        ].join('\n') + '\n' + prefixVertex;
        prefixFragment = [
            '#define varying in',
            parameters.glslVersion === (0, $1a55656020b89c3a$export$f63012db5506e7dd) ? '' : 'layout(location = 0) out highp vec4 pc_fragColor;',
            parameters.glslVersion === (0, $1a55656020b89c3a$export$f63012db5506e7dd) ? '' : '#define gl_FragColor pc_fragColor',
            '#define gl_FragDepthEXT gl_FragDepth',
            '#define texture2D texture',
            '#define textureCube texture',
            '#define texture2DProj textureProj',
            '#define texture2DLodEXT textureLod',
            '#define texture2DProjLodEXT textureProjLod',
            '#define textureCubeLodEXT textureLod',
            '#define texture2DGradEXT textureGrad',
            '#define texture2DProjGradEXT textureProjGrad',
            '#define textureCubeGradEXT textureGrad'
        ].join('\n') + '\n' + prefixFragment;
    }
    var vertexGlsl = versionString + prefixVertex + vertexShader;
    var fragmentGlsl = versionString + prefixFragment + fragmentShader;
    // console.log( '*VERTEX*', vertexGlsl );
    // console.log( '*FRAGMENT*', fragmentGlsl );
    var glVertexShader = $079becb54c0579a9$var$WebGLShader(gl, gl.VERTEX_SHADER, vertexGlsl);
    var glFragmentShader = $079becb54c0579a9$var$WebGLShader(gl, gl.FRAGMENT_SHADER, fragmentGlsl);
    gl.attachShader(program, glVertexShader);
    gl.attachShader(program, glFragmentShader);
    // Force a particular attribute to index 0.
    if (parameters.index0AttributeName !== undefined) gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
    else if (parameters.morphTargets === true) // programs with morphTargets displace position out of attribute 0
    gl.bindAttribLocation(program, 0, 'position');
    gl.linkProgram(program);
    function onFirstUse(self1) {
        // check for link errors
        if (renderer.debug.checkShaderErrors) {
            var programLog = gl.getProgramInfoLog(program).trim();
            var vertexLog = gl.getShaderInfoLog(glVertexShader).trim();
            var fragmentLog = gl.getShaderInfoLog(glFragmentShader).trim();
            var runnable = true;
            var haveDiagnostics = true;
            if (gl.getProgramParameter(program, gl.LINK_STATUS) === false) {
                runnable = false;
                if (typeof renderer.debug.onShaderError === 'function') renderer.debug.onShaderError(gl, program, glVertexShader, glFragmentShader);
                else {
                    // default error reporting
                    var vertexErrors = $079becb54c0579a9$var$getShaderErrors(gl, glVertexShader, 'vertex');
                    var fragmentErrors = $079becb54c0579a9$var$getShaderErrors(gl, glFragmentShader, 'fragment');
                    console.error('THREE.WebGLProgram: Shader Error ' + gl.getError() + ' - ' + 'VALIDATE_STATUS ' + gl.getProgramParameter(program, gl.VALIDATE_STATUS) + '\n\n' + 'Material Name: ' + self1.name + '\n' + 'Material Type: ' + self1.type + '\n\n' + 'Program Info Log: ' + programLog + '\n' + vertexErrors + '\n' + fragmentErrors);
                }
            } else if (programLog !== '') console.warn('THREE.WebGLProgram: Program Info Log:', programLog);
            else if (vertexLog === '' || fragmentLog === '') haveDiagnostics = false;
            if (haveDiagnostics) self1.diagnostics = {
                runnable: runnable,
                programLog: programLog,
                vertexShader: {
                    log: vertexLog,
                    prefix: prefixVertex
                },
                fragmentShader: {
                    log: fragmentLog,
                    prefix: prefixFragment
                }
            };
        }
        // Clean up
        // Crashes in iOS9 and iOS10. #18402
        // gl.detachShader( program, glVertexShader );
        // gl.detachShader( program, glFragmentShader );
        gl.deleteShader(glVertexShader);
        gl.deleteShader(glFragmentShader);
        cachedUniforms = new $079becb54c0579a9$var$WebGLUniforms(gl, program);
        cachedAttributes = $079becb54c0579a9$var$fetchAttributeLocations(gl, program);
    }
    // set up caching for uniform locations
    var cachedUniforms;
    this.getUniforms = function() {
        if (cachedUniforms === undefined) // Populates cachedUniforms and cachedAttributes
        onFirstUse(this);
        return cachedUniforms;
    };
    // set up caching for attribute locations
    var cachedAttributes;
    this.getAttributes = function() {
        if (cachedAttributes === undefined) // Populates cachedAttributes and cachedUniforms
        onFirstUse(this);
        return cachedAttributes;
    };
    // indicate when the program is ready to be used. if the KHR_parallel_shader_compile extension isn't supported,
    // flag the program as ready immediately. It may cause a stall when it's first used.
    var programReady = parameters.rendererExtensionParallelShaderCompile === false;
    this.isReady = function() {
        if (programReady === false) programReady = gl.getProgramParameter(program, $079becb54c0579a9$var$COMPLETION_STATUS_KHR);
        return programReady;
    };
    // free resource
    this.destroy = function() {
        bindingStates.releaseStatesOfProgram(this);
        gl.deleteProgram(program);
        this.program = undefined;
    };
    //
    this.type = parameters.shaderType;
    this.name = parameters.shaderName;
    this.id = $079becb54c0579a9$var$programIdCount++;
    this.cacheKey = cacheKey;
    this.usedTimes = 1;
    this.program = program;
    this.vertexShader = glVertexShader;
    this.fragmentShader = glFragmentShader;
    return this;
}
var $079becb54c0579a9$var$_id = 0;
var $079becb54c0579a9$var$WebGLShaderCache = /*#__PURE__*/ function() {
    "use strict";
    function WebGLShaderCache() {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, WebGLShaderCache);
        this.shaderCache = new Map();
        this.materialCache = new Map();
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(WebGLShaderCache, [
        {
            key: "update",
            value: function update(material) {
                var vertexShader = material.vertexShader;
                var fragmentShader = material.fragmentShader;
                var vertexShaderStage = this._getShaderStage(vertexShader);
                var fragmentShaderStage = this._getShaderStage(fragmentShader);
                var materialShaders = this._getShaderCacheForMaterial(material);
                if (materialShaders.has(vertexShaderStage) === false) {
                    materialShaders.add(vertexShaderStage);
                    vertexShaderStage.usedTimes++;
                }
                if (materialShaders.has(fragmentShaderStage) === false) {
                    materialShaders.add(fragmentShaderStage);
                    fragmentShaderStage.usedTimes++;
                }
                return this;
            }
        },
        {
            key: "remove",
            value: function remove(material) {
                var materialShaders = this.materialCache.get(material);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = materialShaders[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var shaderStage = _step.value;
                        shaderStage.usedTimes--;
                        if (shaderStage.usedTimes === 0) this.shaderCache.delete(shaderStage.code);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.materialCache.delete(material);
                return this;
            }
        },
        {
            key: "getVertexShaderID",
            value: function getVertexShaderID(material) {
                return this._getShaderStage(material.vertexShader).id;
            }
        },
        {
            key: "getFragmentShaderID",
            value: function getFragmentShaderID(material) {
                return this._getShaderStage(material.fragmentShader).id;
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this.shaderCache.clear();
                this.materialCache.clear();
            }
        },
        {
            key: "_getShaderCacheForMaterial",
            value: function _getShaderCacheForMaterial(material) {
                var cache = this.materialCache;
                var set = cache.get(material);
                if (set === undefined) {
                    set = new Set();
                    cache.set(material, set);
                }
                return set;
            }
        },
        {
            key: "_getShaderStage",
            value: function _getShaderStage(code) {
                var cache = this.shaderCache;
                var stage = cache.get(code);
                if (stage === undefined) {
                    stage = new $079becb54c0579a9$var$WebGLShaderStage(code);
                    cache.set(code, stage);
                }
                return stage;
            }
        }
    ]);
    return WebGLShaderCache;
}();
var $079becb54c0579a9$var$WebGLShaderStage = function WebGLShaderStage(code) {
    "use strict";
    (0, $9a1684911372ec89$export$71511d61b312f219)(this, WebGLShaderStage);
    this.id = $079becb54c0579a9$var$_id++;
    this.code = code;
    this.usedTimes = 0;
};
function $079becb54c0579a9$var$WebGLPrograms(renderer, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping) {
    var _programLayers = new (0, $1a55656020b89c3a$export$89312ce47c0ca777)();
    var _customShaders = new $079becb54c0579a9$var$WebGLShaderCache();
    var _activeChannels = new Set();
    var programs = [];
    var logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
    var SUPPORTS_VERTEX_TEXTURES = capabilities.vertexTextures;
    var precision = capabilities.precision;
    var shaderIDs = {
        MeshDepthMaterial: 'depth',
        MeshDistanceMaterial: 'distanceRGBA',
        MeshNormalMaterial: 'normal',
        MeshBasicMaterial: 'basic',
        MeshLambertMaterial: 'lambert',
        MeshPhongMaterial: 'phong',
        MeshToonMaterial: 'toon',
        MeshStandardMaterial: 'physical',
        MeshPhysicalMaterial: 'physical',
        MeshMatcapMaterial: 'matcap',
        LineBasicMaterial: 'basic',
        LineDashedMaterial: 'dashed',
        PointsMaterial: 'points',
        ShadowMaterial: 'shadow',
        SpriteMaterial: 'sprite'
    };
    function getChannel(value) {
        _activeChannels.add(value);
        if (value === 0) return 'uv';
        return "uv".concat(value);
    }
    function getParameters(material, lights, shadows, scene, object) {
        var fog = scene.fog;
        var geometry = object.geometry;
        var environment = material.isMeshStandardMaterial ? scene.environment : null;
        var envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
        var envMapCubeUVHeight = !!envMap && envMap.mapping === (0, $1a55656020b89c3a$export$dbf3e70ff37af79) ? envMap.image.height : null;
        var shaderID = shaderIDs[material.type];
        // heuristics to create shader parameters according to lights in the scene
        // (not to blow over maxLights budget)
        if (material.precision !== null) {
            precision = capabilities.getMaxPrecision(material.precision);
            if (precision !== material.precision) console.warn('THREE.WebGLProgram.getParameters:', material.precision, 'not supported, using', precision, 'instead.');
        }
        //
        var morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        var morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        var morphTextureStride = 0;
        if (geometry.morphAttributes.position !== undefined) morphTextureStride = 1;
        if (geometry.morphAttributes.normal !== undefined) morphTextureStride = 2;
        if (geometry.morphAttributes.color !== undefined) morphTextureStride = 3;
        //
        var vertexShader, fragmentShader;
        var customVertexShaderID, customFragmentShaderID;
        if (shaderID) {
            var shader = $079becb54c0579a9$export$bee4a7d47f8f5014[shaderID];
            vertexShader = shader.vertexShader;
            fragmentShader = shader.fragmentShader;
        } else {
            vertexShader = material.vertexShader;
            fragmentShader = material.fragmentShader;
            _customShaders.update(material);
            customVertexShaderID = _customShaders.getVertexShaderID(material);
            customFragmentShaderID = _customShaders.getFragmentShaderID(material);
        }
        var currentRenderTarget = renderer.getRenderTarget();
        var reverseDepthBuffer = renderer.state.buffers.depth.getReversed();
        var IS_INSTANCEDMESH = object.isInstancedMesh === true;
        var IS_BATCHEDMESH = object.isBatchedMesh === true;
        var HAS_MAP = !!material.map;
        var HAS_MATCAP = !!material.matcap;
        var HAS_ENVMAP = !!envMap;
        var HAS_AOMAP = !!material.aoMap;
        var HAS_LIGHTMAP = !!material.lightMap;
        var HAS_BUMPMAP = !!material.bumpMap;
        var HAS_NORMALMAP = !!material.normalMap;
        var HAS_DISPLACEMENTMAP = !!material.displacementMap;
        var HAS_EMISSIVEMAP = !!material.emissiveMap;
        var HAS_METALNESSMAP = !!material.metalnessMap;
        var HAS_ROUGHNESSMAP = !!material.roughnessMap;
        var HAS_ANISOTROPY = material.anisotropy > 0;
        var HAS_CLEARCOAT = material.clearcoat > 0;
        var HAS_DISPERSION = material.dispersion > 0;
        var HAS_IRIDESCENCE = material.iridescence > 0;
        var HAS_SHEEN = material.sheen > 0;
        var HAS_TRANSMISSION = material.transmission > 0;
        var HAS_ANISOTROPYMAP = HAS_ANISOTROPY && !!material.anisotropyMap;
        var HAS_CLEARCOATMAP = HAS_CLEARCOAT && !!material.clearcoatMap;
        var HAS_CLEARCOAT_NORMALMAP = HAS_CLEARCOAT && !!material.clearcoatNormalMap;
        var HAS_CLEARCOAT_ROUGHNESSMAP = HAS_CLEARCOAT && !!material.clearcoatRoughnessMap;
        var HAS_IRIDESCENCEMAP = HAS_IRIDESCENCE && !!material.iridescenceMap;
        var HAS_IRIDESCENCE_THICKNESSMAP = HAS_IRIDESCENCE && !!material.iridescenceThicknessMap;
        var HAS_SHEEN_COLORMAP = HAS_SHEEN && !!material.sheenColorMap;
        var HAS_SHEEN_ROUGHNESSMAP = HAS_SHEEN && !!material.sheenRoughnessMap;
        var HAS_SPECULARMAP = !!material.specularMap;
        var HAS_SPECULAR_COLORMAP = !!material.specularColorMap;
        var HAS_SPECULAR_INTENSITYMAP = !!material.specularIntensityMap;
        var HAS_TRANSMISSIONMAP = HAS_TRANSMISSION && !!material.transmissionMap;
        var HAS_THICKNESSMAP = HAS_TRANSMISSION && !!material.thicknessMap;
        var HAS_GRADIENTMAP = !!material.gradientMap;
        var HAS_ALPHAMAP = !!material.alphaMap;
        var HAS_ALPHATEST = material.alphaTest > 0;
        var HAS_ALPHAHASH = !!material.alphaHash;
        var HAS_EXTENSIONS = !!material.extensions;
        var toneMapping = (0, $1a55656020b89c3a$export$9fcb6b4294603b2);
        if (material.toneMapped) {
            if (currentRenderTarget === null || currentRenderTarget.isXRRenderTarget === true) toneMapping = renderer.toneMapping;
        }
        var parameters = {
            shaderID: shaderID,
            shaderType: material.type,
            shaderName: material.name,
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            defines: material.defines,
            customVertexShaderID: customVertexShaderID,
            customFragmentShaderID: customFragmentShaderID,
            isRawShaderMaterial: material.isRawShaderMaterial === true,
            glslVersion: material.glslVersion,
            precision: precision,
            batching: IS_BATCHEDMESH,
            batchingColor: IS_BATCHEDMESH && object._colorsTexture !== null,
            instancing: IS_INSTANCEDMESH,
            instancingColor: IS_INSTANCEDMESH && object.instanceColor !== null,
            instancingMorph: IS_INSTANCEDMESH && object.morphTexture !== null,
            supportsVertexTextures: SUPPORTS_VERTEX_TEXTURES,
            outputColorSpace: currentRenderTarget === null ? renderer.outputColorSpace : currentRenderTarget.isXRRenderTarget === true ? currentRenderTarget.texture.colorSpace : (0, $1a55656020b89c3a$export$42429b3acfb233a4),
            alphaToCoverage: !!material.alphaToCoverage,
            map: HAS_MAP,
            matcap: HAS_MATCAP,
            envMap: HAS_ENVMAP,
            envMapMode: HAS_ENVMAP && envMap.mapping,
            envMapCubeUVHeight: envMapCubeUVHeight,
            aoMap: HAS_AOMAP,
            lightMap: HAS_LIGHTMAP,
            bumpMap: HAS_BUMPMAP,
            normalMap: HAS_NORMALMAP,
            displacementMap: SUPPORTS_VERTEX_TEXTURES && HAS_DISPLACEMENTMAP,
            emissiveMap: HAS_EMISSIVEMAP,
            normalMapObjectSpace: HAS_NORMALMAP && material.normalMapType === (0, $1a55656020b89c3a$export$9990ad26f9db5b2c),
            normalMapTangentSpace: HAS_NORMALMAP && material.normalMapType === (0, $1a55656020b89c3a$export$2852a58ebdac27b8),
            metalnessMap: HAS_METALNESSMAP,
            roughnessMap: HAS_ROUGHNESSMAP,
            anisotropy: HAS_ANISOTROPY,
            anisotropyMap: HAS_ANISOTROPYMAP,
            clearcoat: HAS_CLEARCOAT,
            clearcoatMap: HAS_CLEARCOATMAP,
            clearcoatNormalMap: HAS_CLEARCOAT_NORMALMAP,
            clearcoatRoughnessMap: HAS_CLEARCOAT_ROUGHNESSMAP,
            dispersion: HAS_DISPERSION,
            iridescence: HAS_IRIDESCENCE,
            iridescenceMap: HAS_IRIDESCENCEMAP,
            iridescenceThicknessMap: HAS_IRIDESCENCE_THICKNESSMAP,
            sheen: HAS_SHEEN,
            sheenColorMap: HAS_SHEEN_COLORMAP,
            sheenRoughnessMap: HAS_SHEEN_ROUGHNESSMAP,
            specularMap: HAS_SPECULARMAP,
            specularColorMap: HAS_SPECULAR_COLORMAP,
            specularIntensityMap: HAS_SPECULAR_INTENSITYMAP,
            transmission: HAS_TRANSMISSION,
            transmissionMap: HAS_TRANSMISSIONMAP,
            thicknessMap: HAS_THICKNESSMAP,
            gradientMap: HAS_GRADIENTMAP,
            opaque: material.transparent === false && material.blending === (0, $1a55656020b89c3a$export$5b29a26d96ee6af0) && material.alphaToCoverage === false,
            alphaMap: HAS_ALPHAMAP,
            alphaTest: HAS_ALPHATEST,
            alphaHash: HAS_ALPHAHASH,
            combine: material.combine,
            //
            mapUv: HAS_MAP && getChannel(material.map.channel),
            aoMapUv: HAS_AOMAP && getChannel(material.aoMap.channel),
            lightMapUv: HAS_LIGHTMAP && getChannel(material.lightMap.channel),
            bumpMapUv: HAS_BUMPMAP && getChannel(material.bumpMap.channel),
            normalMapUv: HAS_NORMALMAP && getChannel(material.normalMap.channel),
            displacementMapUv: HAS_DISPLACEMENTMAP && getChannel(material.displacementMap.channel),
            emissiveMapUv: HAS_EMISSIVEMAP && getChannel(material.emissiveMap.channel),
            metalnessMapUv: HAS_METALNESSMAP && getChannel(material.metalnessMap.channel),
            roughnessMapUv: HAS_ROUGHNESSMAP && getChannel(material.roughnessMap.channel),
            anisotropyMapUv: HAS_ANISOTROPYMAP && getChannel(material.anisotropyMap.channel),
            clearcoatMapUv: HAS_CLEARCOATMAP && getChannel(material.clearcoatMap.channel),
            clearcoatNormalMapUv: HAS_CLEARCOAT_NORMALMAP && getChannel(material.clearcoatNormalMap.channel),
            clearcoatRoughnessMapUv: HAS_CLEARCOAT_ROUGHNESSMAP && getChannel(material.clearcoatRoughnessMap.channel),
            iridescenceMapUv: HAS_IRIDESCENCEMAP && getChannel(material.iridescenceMap.channel),
            iridescenceThicknessMapUv: HAS_IRIDESCENCE_THICKNESSMAP && getChannel(material.iridescenceThicknessMap.channel),
            sheenColorMapUv: HAS_SHEEN_COLORMAP && getChannel(material.sheenColorMap.channel),
            sheenRoughnessMapUv: HAS_SHEEN_ROUGHNESSMAP && getChannel(material.sheenRoughnessMap.channel),
            specularMapUv: HAS_SPECULARMAP && getChannel(material.specularMap.channel),
            specularColorMapUv: HAS_SPECULAR_COLORMAP && getChannel(material.specularColorMap.channel),
            specularIntensityMapUv: HAS_SPECULAR_INTENSITYMAP && getChannel(material.specularIntensityMap.channel),
            transmissionMapUv: HAS_TRANSMISSIONMAP && getChannel(material.transmissionMap.channel),
            thicknessMapUv: HAS_THICKNESSMAP && getChannel(material.thicknessMap.channel),
            alphaMapUv: HAS_ALPHAMAP && getChannel(material.alphaMap.channel),
            //
            vertexTangents: !!geometry.attributes.tangent && (HAS_NORMALMAP || HAS_ANISOTROPY),
            vertexColors: material.vertexColors,
            vertexAlphas: material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4,
            pointsUvs: object.isPoints === true && !!geometry.attributes.uv && (HAS_MAP || HAS_ALPHAMAP),
            fog: !!fog,
            useFog: material.fog === true,
            fogExp2: !!fog && fog.isFogExp2,
            flatShading: material.flatShading === true,
            sizeAttenuation: material.sizeAttenuation === true,
            logarithmicDepthBuffer: logarithmicDepthBuffer,
            reverseDepthBuffer: reverseDepthBuffer,
            skinning: object.isSkinnedMesh === true,
            morphTargets: geometry.morphAttributes.position !== undefined,
            morphNormals: geometry.morphAttributes.normal !== undefined,
            morphColors: geometry.morphAttributes.color !== undefined,
            morphTargetsCount: morphTargetsCount,
            morphTextureStride: morphTextureStride,
            numDirLights: lights.directional.length,
            numPointLights: lights.point.length,
            numSpotLights: lights.spot.length,
            numSpotLightMaps: lights.spotLightMap.length,
            numRectAreaLights: lights.rectArea.length,
            numHemiLights: lights.hemi.length,
            numDirLightShadows: lights.directionalShadowMap.length,
            numPointLightShadows: lights.pointShadowMap.length,
            numSpotLightShadows: lights.spotShadowMap.length,
            numSpotLightShadowsWithMaps: lights.numSpotLightShadowsWithMaps,
            numLightProbes: lights.numLightProbes,
            numClippingPlanes: clipping.numPlanes,
            numClipIntersection: clipping.numIntersection,
            dithering: material.dithering,
            shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
            shadowMapType: renderer.shadowMap.type,
            toneMapping: toneMapping,
            decodeVideoTexture: HAS_MAP && material.map.isVideoTexture === true && (0, $1a55656020b89c3a$export$5e6fd513f44698c).getTransfer(material.map.colorSpace) === (0, $1a55656020b89c3a$export$8d0a61916cc26abb),
            decodeVideoTextureEmissive: HAS_EMISSIVEMAP && material.emissiveMap.isVideoTexture === true && (0, $1a55656020b89c3a$export$5e6fd513f44698c).getTransfer(material.emissiveMap.colorSpace) === (0, $1a55656020b89c3a$export$8d0a61916cc26abb),
            premultipliedAlpha: material.premultipliedAlpha,
            doubleSided: material.side === (0, $1a55656020b89c3a$export$3b296b6f144d5b03),
            flipSided: material.side === (0, $1a55656020b89c3a$export$d9f0486e75b5ace),
            useDepthPacking: material.depthPacking >= 0,
            depthPacking: material.depthPacking || 0,
            index0AttributeName: material.index0AttributeName,
            extensionClipCullDistance: HAS_EXTENSIONS && material.extensions.clipCullDistance === true && extensions.has('WEBGL_clip_cull_distance'),
            extensionMultiDraw: (HAS_EXTENSIONS && material.extensions.multiDraw === true || IS_BATCHEDMESH) && extensions.has('WEBGL_multi_draw'),
            rendererExtensionParallelShaderCompile: extensions.has('KHR_parallel_shader_compile'),
            customProgramCacheKey: material.customProgramCacheKey()
        };
        // the usage of getChannel() determines the active texture channels for this shader
        parameters.vertexUv1s = _activeChannels.has(1);
        parameters.vertexUv2s = _activeChannels.has(2);
        parameters.vertexUv3s = _activeChannels.has(3);
        _activeChannels.clear();
        return parameters;
    }
    function getProgramCacheKey(parameters) {
        var array = [];
        if (parameters.shaderID) array.push(parameters.shaderID);
        else {
            array.push(parameters.customVertexShaderID);
            array.push(parameters.customFragmentShaderID);
        }
        if (parameters.defines !== undefined) for(var name in parameters.defines){
            array.push(name);
            array.push(parameters.defines[name]);
        }
        if (parameters.isRawShaderMaterial === false) {
            getProgramCacheKeyParameters(array, parameters);
            getProgramCacheKeyBooleans(array, parameters);
            array.push(renderer.outputColorSpace);
        }
        array.push(parameters.customProgramCacheKey);
        return array.join();
    }
    function getProgramCacheKeyParameters(array, parameters) {
        array.push(parameters.precision);
        array.push(parameters.outputColorSpace);
        array.push(parameters.envMapMode);
        array.push(parameters.envMapCubeUVHeight);
        array.push(parameters.mapUv);
        array.push(parameters.alphaMapUv);
        array.push(parameters.lightMapUv);
        array.push(parameters.aoMapUv);
        array.push(parameters.bumpMapUv);
        array.push(parameters.normalMapUv);
        array.push(parameters.displacementMapUv);
        array.push(parameters.emissiveMapUv);
        array.push(parameters.metalnessMapUv);
        array.push(parameters.roughnessMapUv);
        array.push(parameters.anisotropyMapUv);
        array.push(parameters.clearcoatMapUv);
        array.push(parameters.clearcoatNormalMapUv);
        array.push(parameters.clearcoatRoughnessMapUv);
        array.push(parameters.iridescenceMapUv);
        array.push(parameters.iridescenceThicknessMapUv);
        array.push(parameters.sheenColorMapUv);
        array.push(parameters.sheenRoughnessMapUv);
        array.push(parameters.specularMapUv);
        array.push(parameters.specularColorMapUv);
        array.push(parameters.specularIntensityMapUv);
        array.push(parameters.transmissionMapUv);
        array.push(parameters.thicknessMapUv);
        array.push(parameters.combine);
        array.push(parameters.fogExp2);
        array.push(parameters.sizeAttenuation);
        array.push(parameters.morphTargetsCount);
        array.push(parameters.morphAttributeCount);
        array.push(parameters.numDirLights);
        array.push(parameters.numPointLights);
        array.push(parameters.numSpotLights);
        array.push(parameters.numSpotLightMaps);
        array.push(parameters.numHemiLights);
        array.push(parameters.numRectAreaLights);
        array.push(parameters.numDirLightShadows);
        array.push(parameters.numPointLightShadows);
        array.push(parameters.numSpotLightShadows);
        array.push(parameters.numSpotLightShadowsWithMaps);
        array.push(parameters.numLightProbes);
        array.push(parameters.shadowMapType);
        array.push(parameters.toneMapping);
        array.push(parameters.numClippingPlanes);
        array.push(parameters.numClipIntersection);
        array.push(parameters.depthPacking);
    }
    function getProgramCacheKeyBooleans(array, parameters) {
        _programLayers.disableAll();
        if (parameters.supportsVertexTextures) _programLayers.enable(0);
        if (parameters.instancing) _programLayers.enable(1);
        if (parameters.instancingColor) _programLayers.enable(2);
        if (parameters.instancingMorph) _programLayers.enable(3);
        if (parameters.matcap) _programLayers.enable(4);
        if (parameters.envMap) _programLayers.enable(5);
        if (parameters.normalMapObjectSpace) _programLayers.enable(6);
        if (parameters.normalMapTangentSpace) _programLayers.enable(7);
        if (parameters.clearcoat) _programLayers.enable(8);
        if (parameters.iridescence) _programLayers.enable(9);
        if (parameters.alphaTest) _programLayers.enable(10);
        if (parameters.vertexColors) _programLayers.enable(11);
        if (parameters.vertexAlphas) _programLayers.enable(12);
        if (parameters.vertexUv1s) _programLayers.enable(13);
        if (parameters.vertexUv2s) _programLayers.enable(14);
        if (parameters.vertexUv3s) _programLayers.enable(15);
        if (parameters.vertexTangents) _programLayers.enable(16);
        if (parameters.anisotropy) _programLayers.enable(17);
        if (parameters.alphaHash) _programLayers.enable(18);
        if (parameters.batching) _programLayers.enable(19);
        if (parameters.dispersion) _programLayers.enable(20);
        if (parameters.batchingColor) _programLayers.enable(21);
        array.push(_programLayers.mask);
        _programLayers.disableAll();
        if (parameters.fog) _programLayers.enable(0);
        if (parameters.useFog) _programLayers.enable(1);
        if (parameters.flatShading) _programLayers.enable(2);
        if (parameters.logarithmicDepthBuffer) _programLayers.enable(3);
        if (parameters.reverseDepthBuffer) _programLayers.enable(4);
        if (parameters.skinning) _programLayers.enable(5);
        if (parameters.morphTargets) _programLayers.enable(6);
        if (parameters.morphNormals) _programLayers.enable(7);
        if (parameters.morphColors) _programLayers.enable(8);
        if (parameters.premultipliedAlpha) _programLayers.enable(9);
        if (parameters.shadowMapEnabled) _programLayers.enable(10);
        if (parameters.doubleSided) _programLayers.enable(11);
        if (parameters.flipSided) _programLayers.enable(12);
        if (parameters.useDepthPacking) _programLayers.enable(13);
        if (parameters.dithering) _programLayers.enable(14);
        if (parameters.transmission) _programLayers.enable(15);
        if (parameters.sheen) _programLayers.enable(16);
        if (parameters.opaque) _programLayers.enable(17);
        if (parameters.pointsUvs) _programLayers.enable(18);
        if (parameters.decodeVideoTexture) _programLayers.enable(19);
        if (parameters.decodeVideoTextureEmissive) _programLayers.enable(20);
        if (parameters.alphaToCoverage) _programLayers.enable(21);
        array.push(_programLayers.mask);
    }
    function getUniforms(material) {
        var shaderID = shaderIDs[material.type];
        var uniforms;
        if (shaderID) {
            var shader = $079becb54c0579a9$export$bee4a7d47f8f5014[shaderID];
            uniforms = (0, $1a55656020b89c3a$export$d8ecdf8615bfea69).clone(shader.uniforms);
        } else uniforms = material.uniforms;
        return uniforms;
    }
    function acquireProgram(parameters, cacheKey) {
        var program;
        // Check if code has been already compiled
        for(var p = 0, pl = programs.length; p < pl; p++){
            var preexistingProgram = programs[p];
            if (preexistingProgram.cacheKey === cacheKey) {
                program = preexistingProgram;
                ++program.usedTimes;
                break;
            }
        }
        if (program === undefined) {
            program = new $079becb54c0579a9$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates);
            programs.push(program);
        }
        return program;
    }
    function releaseProgram(program) {
        if (--program.usedTimes === 0) {
            // Remove from unordered set
            var i = programs.indexOf(program);
            programs[i] = programs[programs.length - 1];
            programs.pop();
            // Free WebGL resources
            program.destroy();
        }
    }
    function releaseShaderCache(material) {
        _customShaders.remove(material);
    }
    function dispose() {
        _customShaders.dispose();
    }
    return {
        getParameters: getParameters,
        getProgramCacheKey: getProgramCacheKey,
        getUniforms: getUniforms,
        acquireProgram: acquireProgram,
        releaseProgram: releaseProgram,
        releaseShaderCache: releaseShaderCache,
        // Exposed for resource monitoring & error feedback via renderer.info:
        programs: programs,
        dispose: dispose
    };
}
function $079becb54c0579a9$var$WebGLProperties() {
    var properties = new WeakMap();
    function has(object) {
        return properties.has(object);
    }
    function get(object) {
        var map = properties.get(object);
        if (map === undefined) {
            map = {};
            properties.set(object, map);
        }
        return map;
    }
    function remove(object) {
        properties.delete(object);
    }
    function update(object, key, value) {
        properties.get(object)[key] = value;
    }
    function dispose() {
        properties = new WeakMap();
    }
    return {
        has: has,
        get: get,
        remove: remove,
        update: update,
        dispose: dispose
    };
}
function $079becb54c0579a9$var$painterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.material.id !== b.material.id) return a.material.id - b.material.id;
    else if (a.z !== b.z) return a.z - b.z;
    else return a.id - b.id;
}
function $079becb54c0579a9$var$reversePainterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.z !== b.z) return b.z - a.z;
    else return a.id - b.id;
}
function $079becb54c0579a9$var$WebGLRenderList() {
    var renderItems = [];
    var renderItemsIndex = 0;
    var opaque = [];
    var transmissive = [];
    var transparent = [];
    function init() {
        renderItemsIndex = 0;
        opaque.length = 0;
        transmissive.length = 0;
        transparent.length = 0;
    }
    function getNextRenderItem(object, geometry, material, groupOrder, z, group) {
        var renderItem = renderItems[renderItemsIndex];
        if (renderItem === undefined) {
            renderItem = {
                id: object.id,
                object: object,
                geometry: geometry,
                material: material,
                groupOrder: groupOrder,
                renderOrder: object.renderOrder,
                z: z,
                group: group
            };
            renderItems[renderItemsIndex] = renderItem;
        } else {
            renderItem.id = object.id;
            renderItem.object = object;
            renderItem.geometry = geometry;
            renderItem.material = material;
            renderItem.groupOrder = groupOrder;
            renderItem.renderOrder = object.renderOrder;
            renderItem.z = z;
            renderItem.group = group;
        }
        renderItemsIndex++;
        return renderItem;
    }
    function push(object, geometry, material, groupOrder, z, group) {
        var renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.push(renderItem);
        else if (material.transparent === true) transparent.push(renderItem);
        else opaque.push(renderItem);
    }
    function unshift(object, geometry, material, groupOrder, z, group) {
        var renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.unshift(renderItem);
        else if (material.transparent === true) transparent.unshift(renderItem);
        else opaque.unshift(renderItem);
    }
    function sort(customOpaqueSort, customTransparentSort) {
        if (opaque.length > 1) opaque.sort(customOpaqueSort || $079becb54c0579a9$var$painterSortStable);
        if (transmissive.length > 1) transmissive.sort(customTransparentSort || $079becb54c0579a9$var$reversePainterSortStable);
        if (transparent.length > 1) transparent.sort(customTransparentSort || $079becb54c0579a9$var$reversePainterSortStable);
    }
    function finish() {
        // Clear references from inactive renderItems in the list
        for(var i = renderItemsIndex, il = renderItems.length; i < il; i++){
            var renderItem = renderItems[i];
            if (renderItem.id === null) break;
            renderItem.id = null;
            renderItem.object = null;
            renderItem.geometry = null;
            renderItem.material = null;
            renderItem.group = null;
        }
    }
    return {
        opaque: opaque,
        transmissive: transmissive,
        transparent: transparent,
        init: init,
        push: push,
        unshift: unshift,
        finish: finish,
        sort: sort
    };
}
function $079becb54c0579a9$var$WebGLRenderLists() {
    var lists = new WeakMap();
    function get(scene, renderCallDepth) {
        var listArray = lists.get(scene);
        var list;
        if (listArray === undefined) {
            list = new $079becb54c0579a9$var$WebGLRenderList();
            lists.set(scene, [
                list
            ]);
        } else if (renderCallDepth >= listArray.length) {
            list = new $079becb54c0579a9$var$WebGLRenderList();
            listArray.push(list);
        } else list = listArray[renderCallDepth];
        return list;
    }
    function dispose() {
        lists = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $079becb54c0579a9$var$UniformsCache() {
    var lights = {};
    return {
        get: function get(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            var uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        direction: new (0, $1a55656020b89c3a$export$64b5c384219d3699)(),
                        color: new (0, $1a55656020b89c3a$export$892596cec99bc70e)()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        position: new (0, $1a55656020b89c3a$export$64b5c384219d3699)(),
                        direction: new (0, $1a55656020b89c3a$export$64b5c384219d3699)(),
                        color: new (0, $1a55656020b89c3a$export$892596cec99bc70e)(),
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        position: new (0, $1a55656020b89c3a$export$64b5c384219d3699)(),
                        color: new (0, $1a55656020b89c3a$export$892596cec99bc70e)(),
                        distance: 0,
                        decay: 0
                    };
                    break;
                case 'HemisphereLight':
                    uniforms = {
                        direction: new (0, $1a55656020b89c3a$export$64b5c384219d3699)(),
                        skyColor: new (0, $1a55656020b89c3a$export$892596cec99bc70e)(),
                        groundColor: new (0, $1a55656020b89c3a$export$892596cec99bc70e)()
                    };
                    break;
                case 'RectAreaLight':
                    uniforms = {
                        color: new (0, $1a55656020b89c3a$export$892596cec99bc70e)(),
                        position: new (0, $1a55656020b89c3a$export$64b5c384219d3699)(),
                        halfWidth: new (0, $1a55656020b89c3a$export$64b5c384219d3699)(),
                        halfHeight: new (0, $1a55656020b89c3a$export$64b5c384219d3699)()
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
function $079becb54c0579a9$var$ShadowUniformsCache() {
    var lights = {};
    return {
        get: function get(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            var uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new (0, $1a55656020b89c3a$export$c977b3e384af9ae1)()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new (0, $1a55656020b89c3a$export$c977b3e384af9ae1)()
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new (0, $1a55656020b89c3a$export$c977b3e384af9ae1)(),
                        shadowCameraNear: 1,
                        shadowCameraFar: 1000
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
var $079becb54c0579a9$var$nextVersion = 0;
function $079becb54c0579a9$var$shadowCastingAndTexturingLightsFirst(lightA, lightB) {
    return (lightB.castShadow ? 2 : 0) - (lightA.castShadow ? 2 : 0) + (lightB.map ? 1 : 0) - (lightA.map ? 1 : 0);
}
function $079becb54c0579a9$var$WebGLLights(extensions) {
    var cache = new $079becb54c0579a9$var$UniformsCache();
    var shadowCache = $079becb54c0579a9$var$ShadowUniformsCache();
    var state = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1,
            numSpotMaps: -1,
            numLightProbes: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotLightMap: [],
        spotShadow: [],
        spotShadowMap: [],
        spotLightMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: [],
        numSpotLightShadowsWithMaps: 0,
        numLightProbes: 0
    };
    for(var i = 0; i < 9; i++)state.probe.push(new (0, $1a55656020b89c3a$export$64b5c384219d3699)());
    var vector3 = new (0, $1a55656020b89c3a$export$64b5c384219d3699)();
    var matrix4 = new (0, $1a55656020b89c3a$export$2ae72fc923e5eb5)();
    var matrix42 = new (0, $1a55656020b89c3a$export$2ae72fc923e5eb5)();
    function setup(lights) {
        var r = 0, g = 0, b = 0;
        for(var i = 0; i < 9; i++)state.probe[i].set(0, 0, 0);
        var directionalLength = 0;
        var pointLength = 0;
        var spotLength = 0;
        var rectAreaLength = 0;
        var hemiLength = 0;
        var numDirectionalShadows = 0;
        var numPointShadows = 0;
        var numSpotShadows = 0;
        var numSpotMaps = 0;
        var numSpotShadowsWithMaps = 0;
        var numLightProbes = 0;
        // ordering : [shadow casting + map texturing, map texturing, shadow casting, none ]
        lights.sort($079becb54c0579a9$var$shadowCastingAndTexturingLightsFirst);
        for(var i1 = 0, l = lights.length; i1 < l; i1++){
            var light = lights[i1];
            var color = light.color;
            var intensity = light.intensity;
            var distance = light.distance;
            var shadowMap = light.shadow && light.shadow.map ? light.shadow.map.texture : null;
            if (light.isAmbientLight) {
                r += color.r * intensity;
                g += color.g * intensity;
                b += color.b * intensity;
            } else if (light.isLightProbe) {
                for(var j = 0; j < 9; j++)state.probe[j].addScaledVector(light.sh.coefficients[j], intensity);
                numLightProbes++;
            } else if (light.isDirectionalLight) {
                var uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity);
                if (light.castShadow) {
                    var shadow = light.shadow;
                    var shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowIntensity = shadow.intensity;
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.directionalShadow[directionalLength] = shadowUniforms;
                    state.directionalShadowMap[directionalLength] = shadowMap;
                    state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
                    numDirectionalShadows++;
                }
                state.directional[directionalLength] = uniforms;
                directionalLength++;
            } else if (light.isSpotLight) {
                var uniforms1 = cache.get(light);
                uniforms1.position.setFromMatrixPosition(light.matrixWorld);
                uniforms1.color.copy(color).multiplyScalar(intensity);
                uniforms1.distance = distance;
                uniforms1.coneCos = Math.cos(light.angle);
                uniforms1.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
                uniforms1.decay = light.decay;
                state.spot[spotLength] = uniforms1;
                var shadow1 = light.shadow;
                if (light.map) {
                    state.spotLightMap[numSpotMaps] = light.map;
                    numSpotMaps++;
                    // make sure the lightMatrix is up to date
                    // TODO : do it if required only
                    shadow1.updateMatrices(light);
                    if (light.castShadow) numSpotShadowsWithMaps++;
                }
                state.spotLightMatrix[spotLength] = shadow1.matrix;
                if (light.castShadow) {
                    var shadowUniforms1 = shadowCache.get(light);
                    shadowUniforms1.shadowIntensity = shadow1.intensity;
                    shadowUniforms1.shadowBias = shadow1.bias;
                    shadowUniforms1.shadowNormalBias = shadow1.normalBias;
                    shadowUniforms1.shadowRadius = shadow1.radius;
                    shadowUniforms1.shadowMapSize = shadow1.mapSize;
                    state.spotShadow[spotLength] = shadowUniforms1;
                    state.spotShadowMap[spotLength] = shadowMap;
                    numSpotShadows++;
                }
                spotLength++;
            } else if (light.isRectAreaLight) {
                var uniforms2 = cache.get(light);
                uniforms2.color.copy(color).multiplyScalar(intensity);
                uniforms2.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms2.halfHeight.set(0.0, light.height * 0.5, 0.0);
                state.rectArea[rectAreaLength] = uniforms2;
                rectAreaLength++;
            } else if (light.isPointLight) {
                var uniforms3 = cache.get(light);
                uniforms3.color.copy(light.color).multiplyScalar(light.intensity);
                uniforms3.distance = light.distance;
                uniforms3.decay = light.decay;
                if (light.castShadow) {
                    var shadow2 = light.shadow;
                    var shadowUniforms2 = shadowCache.get(light);
                    shadowUniforms2.shadowIntensity = shadow2.intensity;
                    shadowUniforms2.shadowBias = shadow2.bias;
                    shadowUniforms2.shadowNormalBias = shadow2.normalBias;
                    shadowUniforms2.shadowRadius = shadow2.radius;
                    shadowUniforms2.shadowMapSize = shadow2.mapSize;
                    shadowUniforms2.shadowCameraNear = shadow2.camera.near;
                    shadowUniforms2.shadowCameraFar = shadow2.camera.far;
                    state.pointShadow[pointLength] = shadowUniforms2;
                    state.pointShadowMap[pointLength] = shadowMap;
                    state.pointShadowMatrix[pointLength] = light.shadow.matrix;
                    numPointShadows++;
                }
                state.point[pointLength] = uniforms3;
                pointLength++;
            } else if (light.isHemisphereLight) {
                var uniforms4 = cache.get(light);
                uniforms4.skyColor.copy(light.color).multiplyScalar(intensity);
                uniforms4.groundColor.copy(light.groundColor).multiplyScalar(intensity);
                state.hemi[hemiLength] = uniforms4;
                hemiLength++;
            }
        }
        if (rectAreaLength > 0) {
            if (extensions.has('OES_texture_float_linear') === true) {
                state.rectAreaLTC1 = $079becb54c0579a9$export$6643083551874bf5.LTC_FLOAT_1;
                state.rectAreaLTC2 = $079becb54c0579a9$export$6643083551874bf5.LTC_FLOAT_2;
            } else {
                state.rectAreaLTC1 = $079becb54c0579a9$export$6643083551874bf5.LTC_HALF_1;
                state.rectAreaLTC2 = $079becb54c0579a9$export$6643083551874bf5.LTC_HALF_2;
            }
        }
        state.ambient[0] = r;
        state.ambient[1] = g;
        state.ambient[2] = b;
        var hash = state.hash;
        if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows || hash.numSpotMaps !== numSpotMaps || hash.numLightProbes !== numLightProbes) {
            state.directional.length = directionalLength;
            state.spot.length = spotLength;
            state.rectArea.length = rectAreaLength;
            state.point.length = pointLength;
            state.hemi.length = hemiLength;
            state.directionalShadow.length = numDirectionalShadows;
            state.directionalShadowMap.length = numDirectionalShadows;
            state.pointShadow.length = numPointShadows;
            state.pointShadowMap.length = numPointShadows;
            state.spotShadow.length = numSpotShadows;
            state.spotShadowMap.length = numSpotShadows;
            state.directionalShadowMatrix.length = numDirectionalShadows;
            state.pointShadowMatrix.length = numPointShadows;
            state.spotLightMatrix.length = numSpotShadows + numSpotMaps - numSpotShadowsWithMaps;
            state.spotLightMap.length = numSpotMaps;
            state.numSpotLightShadowsWithMaps = numSpotShadowsWithMaps;
            state.numLightProbes = numLightProbes;
            hash.directionalLength = directionalLength;
            hash.pointLength = pointLength;
            hash.spotLength = spotLength;
            hash.rectAreaLength = rectAreaLength;
            hash.hemiLength = hemiLength;
            hash.numDirectionalShadows = numDirectionalShadows;
            hash.numPointShadows = numPointShadows;
            hash.numSpotShadows = numSpotShadows;
            hash.numSpotMaps = numSpotMaps;
            hash.numLightProbes = numLightProbes;
            state.version = $079becb54c0579a9$var$nextVersion++;
        }
    }
    function setupView(lights, camera) {
        var directionalLength = 0;
        var pointLength = 0;
        var spotLength = 0;
        var rectAreaLength = 0;
        var hemiLength = 0;
        var viewMatrix = camera.matrixWorldInverse;
        for(var i = 0, l = lights.length; i < l; i++){
            var light = lights[i];
            if (light.isDirectionalLight) {
                var uniforms = state.directional[directionalLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                directionalLength++;
            } else if (light.isSpotLight) {
                var uniforms1 = state.spot[spotLength];
                uniforms1.position.setFromMatrixPosition(light.matrixWorld);
                uniforms1.position.applyMatrix4(viewMatrix);
                uniforms1.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms1.direction.sub(vector3);
                uniforms1.direction.transformDirection(viewMatrix);
                spotLength++;
            } else if (light.isRectAreaLight) {
                var uniforms2 = state.rectArea[rectAreaLength];
                uniforms2.position.setFromMatrixPosition(light.matrixWorld);
                uniforms2.position.applyMatrix4(viewMatrix);
                // extract local rotation of light to derive width/height half vectors
                matrix42.identity();
                matrix4.copy(light.matrixWorld);
                matrix4.premultiply(viewMatrix);
                matrix42.extractRotation(matrix4);
                uniforms2.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms2.halfHeight.set(0.0, light.height * 0.5, 0.0);
                uniforms2.halfWidth.applyMatrix4(matrix42);
                uniforms2.halfHeight.applyMatrix4(matrix42);
                rectAreaLength++;
            } else if (light.isPointLight) {
                var uniforms3 = state.point[pointLength];
                uniforms3.position.setFromMatrixPosition(light.matrixWorld);
                uniforms3.position.applyMatrix4(viewMatrix);
                pointLength++;
            } else if (light.isHemisphereLight) {
                var uniforms4 = state.hemi[hemiLength];
                uniforms4.direction.setFromMatrixPosition(light.matrixWorld);
                uniforms4.direction.transformDirection(viewMatrix);
                hemiLength++;
            }
        }
    }
    return {
        setup: setup,
        setupView: setupView,
        state: state
    };
}
function $079becb54c0579a9$var$WebGLRenderState(extensions) {
    var lights = new $079becb54c0579a9$var$WebGLLights(extensions);
    var lightsArray = [];
    var shadowsArray = [];
    function init(camera) {
        state.camera = camera;
        lightsArray.length = 0;
        shadowsArray.length = 0;
    }
    function pushLight(light) {
        lightsArray.push(light);
    }
    function pushShadow(shadowLight) {
        shadowsArray.push(shadowLight);
    }
    function setupLights() {
        lights.setup(lightsArray);
    }
    function setupLightsView(camera) {
        lights.setupView(lightsArray, camera);
    }
    var state = {
        lightsArray: lightsArray,
        shadowsArray: shadowsArray,
        camera: null,
        lights: lights,
        transmissionRenderTarget: {}
    };
    return {
        init: init,
        state: state,
        setupLights: setupLights,
        setupLightsView: setupLightsView,
        pushLight: pushLight,
        pushShadow: pushShadow
    };
}
function $079becb54c0579a9$var$WebGLRenderStates(extensions) {
    var renderStates = new WeakMap();
    function get(scene) {
        var renderCallDepth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        var renderStateArray = renderStates.get(scene);
        var renderState;
        if (renderStateArray === undefined) {
            renderState = new $079becb54c0579a9$var$WebGLRenderState(extensions);
            renderStates.set(scene, [
                renderState
            ]);
        } else if (renderCallDepth >= renderStateArray.length) {
            renderState = new $079becb54c0579a9$var$WebGLRenderState(extensions);
            renderStateArray.push(renderState);
        } else renderState = renderStateArray[renderCallDepth];
        return renderState;
    }
    function dispose() {
        renderStates = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
var $079becb54c0579a9$var$vertex = "void main() {\n\tgl_Position = vec4( position, 1.0 );\n}";
var $079becb54c0579a9$var$fragment = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n\tconst float samples = float( VSM_SAMPLES );\n\tfloat mean = 0.0;\n\tfloat squared_mean = 0.0;\n\tfloat uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n\tfloat uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n\tfor ( float i = 0.0; i < samples; i ++ ) {\n\t\tfloat uvOffset = uvStart + i * uvStride;\n\t\t#ifdef HORIZONTAL_PASS\n\t\t\tvec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n\t\t\tmean += distribution.x;\n\t\t\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n\t\t#else\n\t\t\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n\t\t\tmean += depth;\n\t\t\tsquared_mean += depth * depth;\n\t\t#endif\n\t}\n\tmean = mean / samples;\n\tsquared_mean = squared_mean / samples;\n\tfloat std_dev = sqrt( squared_mean - mean * mean );\n\tgl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";
function $079becb54c0579a9$var$WebGLShadowMap(renderer, objects, capabilities) {
    var _frustum = new (0, $1a55656020b89c3a$export$35efe6f4c85463d2)();
    var _shadowMapSize = new (0, $1a55656020b89c3a$export$c977b3e384af9ae1)(), _viewportSize = new (0, $1a55656020b89c3a$export$c977b3e384af9ae1)(), _viewport = new (0, $1a55656020b89c3a$export$fa7daccca11cdbe3)(), _depthMaterial = new (0, $1a55656020b89c3a$export$2698c22ec13825db)({
        depthPacking: (0, $1a55656020b89c3a$export$8f910f4c4f73df11)
    }), _distanceMaterial = new (0, $1a55656020b89c3a$export$33e187ed002f2a19)(), _materialCache = {}, _maxTextureSize = capabilities.maxTextureSize;
    var _obj;
    var shadowSide = (_obj = {}, (0, $3facda9e207b3c1f$export$71511d61b312f219)(_obj, (0, $1a55656020b89c3a$export$2ede184fc2998901), (0, $1a55656020b89c3a$export$d9f0486e75b5ace)), (0, $3facda9e207b3c1f$export$71511d61b312f219)(_obj, (0, $1a55656020b89c3a$export$d9f0486e75b5ace), (0, $1a55656020b89c3a$export$2ede184fc2998901)), (0, $3facda9e207b3c1f$export$71511d61b312f219)(_obj, (0, $1a55656020b89c3a$export$3b296b6f144d5b03), (0, $1a55656020b89c3a$export$3b296b6f144d5b03)), _obj);
    var shadowMaterialVertical = new (0, $1a55656020b89c3a$export$83c7d75d550a8b0d)({
        defines: {
            VSM_SAMPLES: 8
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new (0, $1a55656020b89c3a$export$c977b3e384af9ae1)()
            },
            radius: {
                value: 4.0
            }
        },
        vertexShader: $079becb54c0579a9$var$vertex,
        fragmentShader: $079becb54c0579a9$var$fragment
    });
    var shadowMaterialHorizontal = shadowMaterialVertical.clone();
    shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
    var fullScreenTri = new (0, $1a55656020b89c3a$export$b7be63a67df8959)();
    fullScreenTri.setAttribute('position', new (0, $1a55656020b89c3a$export$8dea267bd6bde117)(new Float32Array([
        -1,
        -1,
        0.5,
        3,
        -1,
        0.5,
        -1,
        3,
        0.5
    ]), 3));
    var fullScreenMesh = new (0, $1a55656020b89c3a$export$e176487c05830cc5)(fullScreenTri, shadowMaterialVertical);
    var scope = this;
    this.enabled = false;
    this.autoUpdate = true;
    this.needsUpdate = false;
    this.type = (0, $1a55656020b89c3a$export$5813f879eee7cd88);
    var _previousType = this.type;
    this.render = function(lights, scene, camera) {
        if (scope.enabled === false) return;
        if (scope.autoUpdate === false && scope.needsUpdate === false) return;
        if (lights.length === 0) return;
        var currentRenderTarget = renderer.getRenderTarget();
        var activeCubeFace = renderer.getActiveCubeFace();
        var activeMipmapLevel = renderer.getActiveMipmapLevel();
        var _state = renderer.state;
        // Set GL state for depth map.
        _state.setBlending((0, $1a55656020b89c3a$export$63b8d6b580fc65ba));
        _state.buffers.color.setClear(1, 1, 1, 1);
        _state.buffers.depth.setTest(true);
        _state.setScissorTest(false);
        // check for shadow map type changes
        var toVSM = _previousType !== (0, $1a55656020b89c3a$export$896ae1ade6c829c4) && this.type === (0, $1a55656020b89c3a$export$896ae1ade6c829c4);
        var fromVSM = _previousType === (0, $1a55656020b89c3a$export$896ae1ade6c829c4) && this.type !== (0, $1a55656020b89c3a$export$896ae1ade6c829c4);
        // render depth map
        for(var i = 0, il = lights.length; i < il; i++){
            var light = lights[i];
            var shadow = light.shadow;
            if (shadow === undefined) {
                console.warn('THREE.WebGLShadowMap:', light, 'has no shadow.');
                continue;
            }
            if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;
            _shadowMapSize.copy(shadow.mapSize);
            var shadowFrameExtents = shadow.getFrameExtents();
            _shadowMapSize.multiply(shadowFrameExtents);
            _viewportSize.copy(shadow.mapSize);
            if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {
                if (_shadowMapSize.x > _maxTextureSize) {
                    _viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
                    _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
                    shadow.mapSize.x = _viewportSize.x;
                }
                if (_shadowMapSize.y > _maxTextureSize) {
                    _viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
                    _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
                    shadow.mapSize.y = _viewportSize.y;
                }
            }
            if (shadow.map === null || toVSM === true || fromVSM === true) {
                var pars = this.type !== (0, $1a55656020b89c3a$export$896ae1ade6c829c4) ? {
                    minFilter: (0, $1a55656020b89c3a$export$727aa5ec3fe39bf0),
                    magFilter: (0, $1a55656020b89c3a$export$727aa5ec3fe39bf0)
                } : {};
                if (shadow.map !== null) shadow.map.dispose();
                shadow.map = new (0, $1a55656020b89c3a$export$3c052beb2e51e23f)(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.map.texture.name = light.name + '.shadowMap';
                shadow.camera.updateProjectionMatrix();
            }
            renderer.setRenderTarget(shadow.map);
            renderer.clear();
            var viewportCount = shadow.getViewportCount();
            for(var vp = 0; vp < viewportCount; vp++){
                var viewport = shadow.getViewport(vp);
                _viewport.set(_viewportSize.x * viewport.x, _viewportSize.y * viewport.y, _viewportSize.x * viewport.z, _viewportSize.y * viewport.w);
                _state.viewport(_viewport);
                shadow.updateMatrices(light, vp);
                _frustum = shadow.getFrustum();
                renderObject(scene, camera, shadow.camera, light, this.type);
            }
            // do blur pass for VSM
            if (shadow.isPointLightShadow !== true && this.type === (0, $1a55656020b89c3a$export$896ae1ade6c829c4)) VSMPass(shadow, camera);
            shadow.needsUpdate = false;
        }
        _previousType = this.type;
        scope.needsUpdate = false;
        renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
    };
    function VSMPass(shadow, camera) {
        var geometry = objects.update(fullScreenMesh);
        if (shadowMaterialVertical.defines.VSM_SAMPLES !== shadow.blurSamples) {
            shadowMaterialVertical.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialHorizontal.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialVertical.needsUpdate = true;
            shadowMaterialHorizontal.needsUpdate = true;
        }
        if (shadow.mapPass === null) shadow.mapPass = new (0, $1a55656020b89c3a$export$3c052beb2e51e23f)(_shadowMapSize.x, _shadowMapSize.y);
        // vertical pass
        shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
        shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialVertical.uniforms.radius.value = shadow.radius;
        renderer.setRenderTarget(shadow.mapPass);
        renderer.clear();
        renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null);
        // horizontal pass
        shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
        shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
        renderer.setRenderTarget(shadow.map);
        renderer.clear();
        renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
    }
    function getDepthMaterial(object, material, light, type) {
        var result = null;
        var customMaterial = light.isPointLight === true ? object.customDistanceMaterial : object.customDepthMaterial;
        if (customMaterial !== undefined) result = customMaterial;
        else {
            result = light.isPointLight === true ? _distanceMaterial : _depthMaterial;
            if (renderer.localClippingEnabled && material.clipShadows === true && Array.isArray(material.clippingPlanes) && material.clippingPlanes.length !== 0 || material.displacementMap && material.displacementScale !== 0 || material.alphaMap && material.alphaTest > 0 || material.map && material.alphaTest > 0) {
                // in this case we need a unique material instance reflecting the
                // appropriate state
                var keyA = result.uuid, keyB = material.uuid;
                var materialsForVariant = _materialCache[keyA];
                if (materialsForVariant === undefined) {
                    materialsForVariant = {};
                    _materialCache[keyA] = materialsForVariant;
                }
                var cachedMaterial = materialsForVariant[keyB];
                if (cachedMaterial === undefined) {
                    cachedMaterial = result.clone();
                    materialsForVariant[keyB] = cachedMaterial;
                    material.addEventListener('dispose', onMaterialDispose);
                }
                result = cachedMaterial;
            }
        }
        result.visible = material.visible;
        result.wireframe = material.wireframe;
        if (type === (0, $1a55656020b89c3a$export$896ae1ade6c829c4)) result.side = material.shadowSide !== null ? material.shadowSide : material.side;
        else result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
        result.alphaMap = material.alphaMap;
        result.alphaTest = material.alphaTest;
        result.map = material.map;
        result.clipShadows = material.clipShadows;
        result.clippingPlanes = material.clippingPlanes;
        result.clipIntersection = material.clipIntersection;
        result.displacementMap = material.displacementMap;
        result.displacementScale = material.displacementScale;
        result.displacementBias = material.displacementBias;
        result.wireframeLinewidth = material.wireframeLinewidth;
        result.linewidth = material.linewidth;
        if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
            var materialProperties = renderer.properties.get(result);
            materialProperties.light = light;
        }
        return result;
    }
    function renderObject(object, camera, shadowCamera, light, type) {
        if (object.visible === false) return;
        var visible = object.layers.test(camera.layers);
        if (visible && (object.isMesh || object.isLine || object.isPoints)) {
            if ((object.castShadow || object.receiveShadow && type === (0, $1a55656020b89c3a$export$896ae1ade6c829c4)) && (!object.frustumCulled || _frustum.intersectsObject(object))) {
                object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);
                var geometry = objects.update(object);
                var material = object.material;
                if (Array.isArray(material)) {
                    var groups = geometry.groups;
                    for(var k = 0, kl = groups.length; k < kl; k++){
                        var group = groups[k];
                        var groupMaterial = material[group.materialIndex];
                        if (groupMaterial && groupMaterial.visible) {
                            var depthMaterial = getDepthMaterial(object, groupMaterial, light, type);
                            object.onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, group);
                            renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
                            object.onAfterShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, group);
                        }
                    }
                } else if (material.visible) {
                    var depthMaterial1 = getDepthMaterial(object, material, light, type);
                    object.onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial1, null);
                    renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial1, object, null);
                    object.onAfterShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial1, null);
                }
            }
        }
        var children = object.children;
        for(var i = 0, l = children.length; i < l; i++)renderObject(children[i], camera, shadowCamera, light, type);
    }
    function onMaterialDispose(event) {
        var material = event.target;
        material.removeEventListener('dispose', onMaterialDispose);
        // make sure to remove the unique distance/depth materials used for shadow map rendering
        for(var id in _materialCache){
            var cache = _materialCache[id];
            var uuid = event.target.uuid;
            if (uuid in cache) {
                var shadowMaterial = cache[uuid];
                shadowMaterial.dispose();
                delete cache[uuid];
            }
        }
    }
}
var $079becb54c0579a9$var$_obj;
var $079becb54c0579a9$var$reversedFuncs = ($079becb54c0579a9$var$_obj = {}, (0, $3facda9e207b3c1f$export$71511d61b312f219)($079becb54c0579a9$var$_obj, (0, $1a55656020b89c3a$export$69025ce147cee220), (0, $1a55656020b89c3a$export$7182eb52ea3b3f04)), (0, $3facda9e207b3c1f$export$71511d61b312f219)($079becb54c0579a9$var$_obj, (0, $1a55656020b89c3a$export$eedccec66ab7ebe), (0, $1a55656020b89c3a$export$c5e2c52991f30937)), (0, $3facda9e207b3c1f$export$71511d61b312f219)($079becb54c0579a9$var$_obj, (0, $1a55656020b89c3a$export$a60d398fc7b7590e), (0, $1a55656020b89c3a$export$2f843afa843d8916)), (0, $3facda9e207b3c1f$export$71511d61b312f219)($079becb54c0579a9$var$_obj, (0, $1a55656020b89c3a$export$296f78a0b892f81a), (0, $1a55656020b89c3a$export$7d7234c1240a1fc4)), (0, $3facda9e207b3c1f$export$71511d61b312f219)($079becb54c0579a9$var$_obj, (0, $1a55656020b89c3a$export$7182eb52ea3b3f04), (0, $1a55656020b89c3a$export$69025ce147cee220)), (0, $3facda9e207b3c1f$export$71511d61b312f219)($079becb54c0579a9$var$_obj, (0, $1a55656020b89c3a$export$c5e2c52991f30937), (0, $1a55656020b89c3a$export$eedccec66ab7ebe)), (0, $3facda9e207b3c1f$export$71511d61b312f219)($079becb54c0579a9$var$_obj, (0, $1a55656020b89c3a$export$2f843afa843d8916), (0, $1a55656020b89c3a$export$a60d398fc7b7590e)), (0, $3facda9e207b3c1f$export$71511d61b312f219)($079becb54c0579a9$var$_obj, (0, $1a55656020b89c3a$export$7d7234c1240a1fc4), (0, $1a55656020b89c3a$export$296f78a0b892f81a)), $079becb54c0579a9$var$_obj);
function $079becb54c0579a9$var$WebGLState(gl, extensions) {
    function ColorBuffer() {
        var locked = false;
        var color = new (0, $1a55656020b89c3a$export$fa7daccca11cdbe3)();
        var currentColorMask = null;
        var currentColorClear = new (0, $1a55656020b89c3a$export$fa7daccca11cdbe3)(0, 0, 0, 0);
        return {
            setMask: function setMask(colorMask) {
                if (currentColorMask !== colorMask && !locked) {
                    gl.colorMask(colorMask, colorMask, colorMask, colorMask);
                    currentColorMask = colorMask;
                }
            },
            setLocked: function setLocked(lock) {
                locked = lock;
            },
            setClear: function setClear(r, g, b, a, premultipliedAlpha) {
                if (premultipliedAlpha === true) {
                    r *= a;
                    g *= a;
                    b *= a;
                }
                color.set(r, g, b, a);
                if (currentColorClear.equals(color) === false) {
                    gl.clearColor(r, g, b, a);
                    currentColorClear.copy(color);
                }
            },
            reset: function reset() {
                locked = false;
                currentColorMask = null;
                currentColorClear.set(-1, 0, 0, 0); // set to invalid state
            }
        };
    }
    function DepthBuffer() {
        var locked = false;
        var reversed = false;
        var currentDepthMask = null;
        var currentDepthFunc = null;
        var currentDepthClear = null;
        return {
            setReversed: function setReversed(value) {
                if (reversed !== value) {
                    var ext = extensions.get('EXT_clip_control');
                    if (reversed) ext.clipControlEXT(ext.LOWER_LEFT_EXT, ext.ZERO_TO_ONE_EXT);
                    else ext.clipControlEXT(ext.LOWER_LEFT_EXT, ext.NEGATIVE_ONE_TO_ONE_EXT);
                    var oldDepth = currentDepthClear;
                    currentDepthClear = null;
                    this.setClear(oldDepth);
                }
                reversed = value;
            },
            getReversed: function getReversed() {
                return reversed;
            },
            setTest: function setTest(depthTest) {
                if (depthTest) enable(gl.DEPTH_TEST);
                else disable(gl.DEPTH_TEST);
            },
            setMask: function setMask(depthMask) {
                if (currentDepthMask !== depthMask && !locked) {
                    gl.depthMask(depthMask);
                    currentDepthMask = depthMask;
                }
            },
            setFunc: function setFunc(depthFunc) {
                if (reversed) depthFunc = $079becb54c0579a9$var$reversedFuncs[depthFunc];
                if (currentDepthFunc !== depthFunc) {
                    switch(depthFunc){
                        case 0, $1a55656020b89c3a$export$69025ce147cee220:
                            gl.depthFunc(gl.NEVER);
                            break;
                        case 0, $1a55656020b89c3a$export$7182eb52ea3b3f04:
                            gl.depthFunc(gl.ALWAYS);
                            break;
                        case 0, $1a55656020b89c3a$export$eedccec66ab7ebe:
                            gl.depthFunc(gl.LESS);
                            break;
                        case 0, $1a55656020b89c3a$export$296f78a0b892f81a:
                            gl.depthFunc(gl.LEQUAL);
                            break;
                        case 0, $1a55656020b89c3a$export$a60d398fc7b7590e:
                            gl.depthFunc(gl.EQUAL);
                            break;
                        case 0, $1a55656020b89c3a$export$7d7234c1240a1fc4:
                            gl.depthFunc(gl.GEQUAL);
                            break;
                        case 0, $1a55656020b89c3a$export$c5e2c52991f30937:
                            gl.depthFunc(gl.GREATER);
                            break;
                        case 0, $1a55656020b89c3a$export$2f843afa843d8916:
                            gl.depthFunc(gl.NOTEQUAL);
                            break;
                        default:
                            gl.depthFunc(gl.LEQUAL);
                    }
                    currentDepthFunc = depthFunc;
                }
            },
            setLocked: function setLocked(lock) {
                locked = lock;
            },
            setClear: function setClear(depth) {
                if (currentDepthClear !== depth) {
                    if (reversed) depth = 1 - depth;
                    gl.clearDepth(depth);
                    currentDepthClear = depth;
                }
            },
            reset: function reset() {
                locked = false;
                currentDepthMask = null;
                currentDepthFunc = null;
                currentDepthClear = null;
                reversed = false;
            }
        };
    }
    function StencilBuffer() {
        var locked = false;
        var currentStencilMask = null;
        var currentStencilFunc = null;
        var currentStencilRef = null;
        var currentStencilFuncMask = null;
        var currentStencilFail = null;
        var currentStencilZFail = null;
        var currentStencilZPass = null;
        var currentStencilClear = null;
        return {
            setTest: function setTest(stencilTest) {
                if (!locked) {
                    if (stencilTest) enable(gl.STENCIL_TEST);
                    else disable(gl.STENCIL_TEST);
                }
            },
            setMask: function setMask(stencilMask) {
                if (currentStencilMask !== stencilMask && !locked) {
                    gl.stencilMask(stencilMask);
                    currentStencilMask = stencilMask;
                }
            },
            setFunc: function setFunc(stencilFunc, stencilRef, stencilMask) {
                if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
                    gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
                    currentStencilFunc = stencilFunc;
                    currentStencilRef = stencilRef;
                    currentStencilFuncMask = stencilMask;
                }
            },
            setOp: function setOp(stencilFail, stencilZFail, stencilZPass) {
                if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
                    gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
                    currentStencilFail = stencilFail;
                    currentStencilZFail = stencilZFail;
                    currentStencilZPass = stencilZPass;
                }
            },
            setLocked: function setLocked(lock) {
                locked = lock;
            },
            setClear: function setClear(stencil) {
                if (currentStencilClear !== stencil) {
                    gl.clearStencil(stencil);
                    currentStencilClear = stencil;
                }
            },
            reset: function reset() {
                locked = false;
                currentStencilMask = null;
                currentStencilFunc = null;
                currentStencilRef = null;
                currentStencilFuncMask = null;
                currentStencilFail = null;
                currentStencilZFail = null;
                currentStencilZPass = null;
                currentStencilClear = null;
            }
        };
    }
    //
    var colorBuffer = new ColorBuffer();
    var depthBuffer = new DepthBuffer();
    var stencilBuffer = new StencilBuffer();
    var uboBindings = new WeakMap();
    var uboProgramMap = new WeakMap();
    var enabledCapabilities = {};
    var currentBoundFramebuffers = {};
    var currentDrawbuffers = new WeakMap();
    var defaultDrawbuffers = [];
    var currentProgram = null;
    var currentBlendingEnabled = false;
    var currentBlending = null;
    var currentBlendEquation = null;
    var currentBlendSrc = null;
    var currentBlendDst = null;
    var currentBlendEquationAlpha = null;
    var currentBlendSrcAlpha = null;
    var currentBlendDstAlpha = null;
    var currentBlendColor = new (0, $1a55656020b89c3a$export$892596cec99bc70e)(0, 0, 0);
    var currentBlendAlpha = 0;
    var currentPremultipledAlpha = false;
    var currentFlipSided = null;
    var currentCullFace = null;
    var currentLineWidth = null;
    var currentPolygonOffsetFactor = null;
    var currentPolygonOffsetUnits = null;
    var maxTextures = gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
    var lineWidthAvailable = false;
    var version = 0;
    var glVersion = gl.getParameter(gl.VERSION);
    if (glVersion.indexOf('WebGL') !== -1) {
        version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 1.0;
    } else if (glVersion.indexOf('OpenGL ES') !== -1) {
        version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 2.0;
    }
    var currentTextureSlot = null;
    var currentBoundTextures = {};
    var scissorParam = gl.getParameter(gl.SCISSOR_BOX);
    var viewportParam = gl.getParameter(gl.VIEWPORT);
    var currentScissor = new (0, $1a55656020b89c3a$export$fa7daccca11cdbe3)().fromArray(scissorParam);
    var currentViewport = new (0, $1a55656020b89c3a$export$fa7daccca11cdbe3)().fromArray(viewportParam);
    function createTexture(type, target, count, dimensions) {
        var data = new Uint8Array(4); // 4 is required to match default unpack alignment of 4.
        var texture = gl.createTexture();
        gl.bindTexture(type, texture);
        gl.texParameteri(type, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(type, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        for(var i = 0; i < count; i++)if (type === gl.TEXTURE_3D || type === gl.TEXTURE_2D_ARRAY) gl.texImage3D(target, 0, gl.RGBA, 1, 1, dimensions, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        else gl.texImage2D(target + i, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        return texture;
    }
    var emptyTextures = {};
    emptyTextures[gl.TEXTURE_2D] = createTexture(gl.TEXTURE_2D, gl.TEXTURE_2D, 1);
    emptyTextures[gl.TEXTURE_CUBE_MAP] = createTexture(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_CUBE_MAP_POSITIVE_X, 6);
    emptyTextures[gl.TEXTURE_2D_ARRAY] = createTexture(gl.TEXTURE_2D_ARRAY, gl.TEXTURE_2D_ARRAY, 1, 1);
    emptyTextures[gl.TEXTURE_3D] = createTexture(gl.TEXTURE_3D, gl.TEXTURE_3D, 1, 1);
    // init
    colorBuffer.setClear(0, 0, 0, 1);
    depthBuffer.setClear(1);
    stencilBuffer.setClear(0);
    enable(gl.DEPTH_TEST);
    depthBuffer.setFunc((0, $1a55656020b89c3a$export$296f78a0b892f81a));
    setFlipSided(false);
    setCullFace((0, $1a55656020b89c3a$export$b9a7b4fc5cb15f9b));
    enable(gl.CULL_FACE);
    setBlending((0, $1a55656020b89c3a$export$63b8d6b580fc65ba));
    //
    function enable(id) {
        if (enabledCapabilities[id] !== true) {
            gl.enable(id);
            enabledCapabilities[id] = true;
        }
    }
    function disable(id) {
        if (enabledCapabilities[id] !== false) {
            gl.disable(id);
            enabledCapabilities[id] = false;
        }
    }
    function bindFramebuffer(target, framebuffer) {
        if (currentBoundFramebuffers[target] !== framebuffer) {
            gl.bindFramebuffer(target, framebuffer);
            currentBoundFramebuffers[target] = framebuffer;
            // gl.DRAW_FRAMEBUFFER is equivalent to gl.FRAMEBUFFER
            if (target === gl.DRAW_FRAMEBUFFER) currentBoundFramebuffers[gl.FRAMEBUFFER] = framebuffer;
            if (target === gl.FRAMEBUFFER) currentBoundFramebuffers[gl.DRAW_FRAMEBUFFER] = framebuffer;
            return true;
        }
        return false;
    }
    function drawBuffers(renderTarget, framebuffer) {
        var _$drawBuffers = defaultDrawbuffers;
        var needsUpdate = false;
        if (renderTarget) {
            _$drawBuffers = currentDrawbuffers.get(framebuffer);
            if (_$drawBuffers === undefined) {
                _$drawBuffers = [];
                currentDrawbuffers.set(framebuffer, _$drawBuffers);
            }
            var textures = renderTarget.textures;
            if (_$drawBuffers.length !== textures.length || _$drawBuffers[0] !== gl.COLOR_ATTACHMENT0) {
                for(var i = 0, il = textures.length; i < il; i++)_$drawBuffers[i] = gl.COLOR_ATTACHMENT0 + i;
                _$drawBuffers.length = textures.length;
                needsUpdate = true;
            }
        } else if (_$drawBuffers[0] !== gl.BACK) {
            _$drawBuffers[0] = gl.BACK;
            needsUpdate = true;
        }
        if (needsUpdate) gl.drawBuffers(_$drawBuffers);
    }
    function useProgram(program) {
        if (currentProgram !== program) {
            gl.useProgram(program);
            currentProgram = program;
            return true;
        }
        return false;
    }
    var _obj;
    var equationToGL = (_obj = {}, (0, $3facda9e207b3c1f$export$71511d61b312f219)(_obj, (0, $1a55656020b89c3a$export$20183a0484ce21a0), gl.FUNC_ADD), (0, $3facda9e207b3c1f$export$71511d61b312f219)(_obj, (0, $1a55656020b89c3a$export$73e0df5177988548), gl.FUNC_SUBTRACT), (0, $3facda9e207b3c1f$export$71511d61b312f219)(_obj, (0, $1a55656020b89c3a$export$28e582859cbec660), gl.FUNC_REVERSE_SUBTRACT), _obj);
    equationToGL[0, $1a55656020b89c3a$export$c8c1508da8d0600c] = gl.MIN;
    equationToGL[0, $1a55656020b89c3a$export$99948c02fb51055f] = gl.MAX;
    var _obj1;
    var factorToGL = (_obj1 = {}, (0, $3facda9e207b3c1f$export$71511d61b312f219)(_obj1, (0, $1a55656020b89c3a$export$2110f05edf778d3d), gl.ZERO), (0, $3facda9e207b3c1f$export$71511d61b312f219)(_obj1, (0, $1a55656020b89c3a$export$8805bad65e24940e), gl.ONE), (0, $3facda9e207b3c1f$export$71511d61b312f219)(_obj1, (0, $1a55656020b89c3a$export$7fbe15b28d28cf52), gl.SRC_COLOR), (0, $3facda9e207b3c1f$export$71511d61b312f219)(_obj1, (0, $1a55656020b89c3a$export$d5773124e86cf28c), gl.SRC_ALPHA), (0, $3facda9e207b3c1f$export$71511d61b312f219)(_obj1, (0, $1a55656020b89c3a$export$c05e2a1fc8609506), gl.SRC_ALPHA_SATURATE), (0, $3facda9e207b3c1f$export$71511d61b312f219)(_obj1, (0, $1a55656020b89c3a$export$ef5f2dd8ffac5574), gl.DST_COLOR), (0, $3facda9e207b3c1f$export$71511d61b312f219)(_obj1, (0, $1a55656020b89c3a$export$a78aed1ca2a87192), gl.DST_ALPHA), (0, $3facda9e207b3c1f$export$71511d61b312f219)(_obj1, (0, $1a55656020b89c3a$export$947829af9f2c17f6), gl.ONE_MINUS_SRC_COLOR), (0, $3facda9e207b3c1f$export$71511d61b312f219)(_obj1, (0, $1a55656020b89c3a$export$11d468cc7f19e971), gl.ONE_MINUS_SRC_ALPHA), (0, $3facda9e207b3c1f$export$71511d61b312f219)(_obj1, (0, $1a55656020b89c3a$export$56b85b2686ab16), gl.ONE_MINUS_DST_COLOR), (0, $3facda9e207b3c1f$export$71511d61b312f219)(_obj1, (0, $1a55656020b89c3a$export$5d0fe17fd8773bac), gl.ONE_MINUS_DST_ALPHA), (0, $3facda9e207b3c1f$export$71511d61b312f219)(_obj1, (0, $1a55656020b89c3a$export$7dd8f434fd59075), gl.CONSTANT_COLOR), (0, $3facda9e207b3c1f$export$71511d61b312f219)(_obj1, (0, $1a55656020b89c3a$export$99c8d898a9afbcee), gl.ONE_MINUS_CONSTANT_COLOR), (0, $3facda9e207b3c1f$export$71511d61b312f219)(_obj1, (0, $1a55656020b89c3a$export$310cd2be38d13b56), gl.CONSTANT_ALPHA), (0, $3facda9e207b3c1f$export$71511d61b312f219)(_obj1, (0, $1a55656020b89c3a$export$db77b8fbcf45dbf4), gl.ONE_MINUS_CONSTANT_ALPHA), _obj1);
    function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, blendColor, blendAlpha, premultipliedAlpha) {
        if (blending === (0, $1a55656020b89c3a$export$63b8d6b580fc65ba)) {
            if (currentBlendingEnabled === true) {
                disable(gl.BLEND);
                currentBlendingEnabled = false;
            }
            return;
        }
        if (currentBlendingEnabled === false) {
            enable(gl.BLEND);
            currentBlendingEnabled = true;
        }
        if (blending !== (0, $1a55656020b89c3a$export$eda4864c68df1fa2)) {
            if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
                if (currentBlendEquation !== (0, $1a55656020b89c3a$export$20183a0484ce21a0) || currentBlendEquationAlpha !== (0, $1a55656020b89c3a$export$20183a0484ce21a0)) {
                    gl.blendEquation(gl.FUNC_ADD);
                    currentBlendEquation = (0, $1a55656020b89c3a$export$20183a0484ce21a0);
                    currentBlendEquationAlpha = (0, $1a55656020b89c3a$export$20183a0484ce21a0);
                }
                if (premultipliedAlpha) switch(blending){
                    case 0, $1a55656020b89c3a$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case 0, $1a55656020b89c3a$export$777d8f9551c2216b:
                        gl.blendFunc(gl.ONE, gl.ONE);
                        break;
                    case 0, $1a55656020b89c3a$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case 0, $1a55656020b89c3a$export$4138e1c684b46a20:
                        gl.blendFuncSeparate(gl.ZERO, gl.SRC_COLOR, gl.ZERO, gl.SRC_ALPHA);
                        break;
                    default:
                        console.error('THREE.WebGLState: Invalid blending: ', blending);
                        break;
                }
                else switch(blending){
                    case 0, $1a55656020b89c3a$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case 0, $1a55656020b89c3a$export$777d8f9551c2216b:
                        gl.blendFunc(gl.SRC_ALPHA, gl.ONE);
                        break;
                    case 0, $1a55656020b89c3a$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case 0, $1a55656020b89c3a$export$4138e1c684b46a20:
                        gl.blendFunc(gl.ZERO, gl.SRC_COLOR);
                        break;
                    default:
                        console.error('THREE.WebGLState: Invalid blending: ', blending);
                        break;
                }
                currentBlendSrc = null;
                currentBlendDst = null;
                currentBlendSrcAlpha = null;
                currentBlendDstAlpha = null;
                currentBlendColor.set(0, 0, 0);
                currentBlendAlpha = 0;
                currentBlending = blending;
                currentPremultipledAlpha = premultipliedAlpha;
            }
            return;
        }
        // custom blending
        blendEquationAlpha = blendEquationAlpha || blendEquation;
        blendSrcAlpha = blendSrcAlpha || blendSrc;
        blendDstAlpha = blendDstAlpha || blendDst;
        if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
            gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
            currentBlendEquation = blendEquation;
            currentBlendEquationAlpha = blendEquationAlpha;
        }
        if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
            gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
            currentBlendSrc = blendSrc;
            currentBlendDst = blendDst;
            currentBlendSrcAlpha = blendSrcAlpha;
            currentBlendDstAlpha = blendDstAlpha;
        }
        if (blendColor.equals(currentBlendColor) === false || blendAlpha !== currentBlendAlpha) {
            gl.blendColor(blendColor.r, blendColor.g, blendColor.b, blendAlpha);
            currentBlendColor.copy(blendColor);
            currentBlendAlpha = blendAlpha;
        }
        currentBlending = blending;
        currentPremultipledAlpha = false;
    }
    function setMaterial(material, frontFaceCW) {
        material.side === (0, $1a55656020b89c3a$export$3b296b6f144d5b03) ? disable(gl.CULL_FACE) : enable(gl.CULL_FACE);
        var flipSided = material.side === (0, $1a55656020b89c3a$export$d9f0486e75b5ace);
        if (frontFaceCW) flipSided = !flipSided;
        setFlipSided(flipSided);
        material.blending === (0, $1a55656020b89c3a$export$5b29a26d96ee6af0) && material.transparent === false ? setBlending((0, $1a55656020b89c3a$export$63b8d6b580fc65ba)) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.blendColor, material.blendAlpha, material.premultipliedAlpha);
        depthBuffer.setFunc(material.depthFunc);
        depthBuffer.setTest(material.depthTest);
        depthBuffer.setMask(material.depthWrite);
        colorBuffer.setMask(material.colorWrite);
        var stencilWrite = material.stencilWrite;
        stencilBuffer.setTest(stencilWrite);
        if (stencilWrite) {
            stencilBuffer.setMask(material.stencilWriteMask);
            stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
            stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
        }
        setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
        material.alphaToCoverage === true ? enable(gl.SAMPLE_ALPHA_TO_COVERAGE) : disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
    }
    //
    function setFlipSided(flipSided) {
        if (currentFlipSided !== flipSided) {
            if (flipSided) gl.frontFace(gl.CW);
            else gl.frontFace(gl.CCW);
            currentFlipSided = flipSided;
        }
    }
    function setCullFace(cullFace) {
        if (cullFace !== (0, $1a55656020b89c3a$export$3237e1f2c1ea1f44)) {
            enable(gl.CULL_FACE);
            if (cullFace !== currentCullFace) {
                if (cullFace === (0, $1a55656020b89c3a$export$b9a7b4fc5cb15f9b)) gl.cullFace(gl.BACK);
                else if (cullFace === (0, $1a55656020b89c3a$export$b8058bcc7037d3f3)) gl.cullFace(gl.FRONT);
                else gl.cullFace(gl.FRONT_AND_BACK);
            }
        } else disable(gl.CULL_FACE);
        currentCullFace = cullFace;
    }
    function setLineWidth(width) {
        if (width !== currentLineWidth) {
            if (lineWidthAvailable) gl.lineWidth(width);
            currentLineWidth = width;
        }
    }
    function setPolygonOffset(polygonOffset, factor, units) {
        if (polygonOffset) {
            enable(gl.POLYGON_OFFSET_FILL);
            if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
                gl.polygonOffset(factor, units);
                currentPolygonOffsetFactor = factor;
                currentPolygonOffsetUnits = units;
            }
        } else disable(gl.POLYGON_OFFSET_FILL);
    }
    function setScissorTest(scissorTest) {
        if (scissorTest) enable(gl.SCISSOR_TEST);
        else disable(gl.SCISSOR_TEST);
    }
    // texture
    function activeTexture(webglSlot) {
        if (webglSlot === undefined) webglSlot = gl.TEXTURE0 + maxTextures - 1;
        if (currentTextureSlot !== webglSlot) {
            gl.activeTexture(webglSlot);
            currentTextureSlot = webglSlot;
        }
    }
    function bindTexture(webglType, webglTexture, webglSlot) {
        if (webglSlot === undefined) {
            if (currentTextureSlot === null) webglSlot = gl.TEXTURE0 + maxTextures - 1;
            else webglSlot = currentTextureSlot;
        }
        var boundTexture = currentBoundTextures[webglSlot];
        if (boundTexture === undefined) {
            boundTexture = {
                type: undefined,
                texture: undefined
            };
            currentBoundTextures[webglSlot] = boundTexture;
        }
        if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
            if (currentTextureSlot !== webglSlot) {
                gl.activeTexture(webglSlot);
                currentTextureSlot = webglSlot;
            }
            gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
            boundTexture.type = webglType;
            boundTexture.texture = webglTexture;
        }
    }
    function unbindTexture() {
        var boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture !== undefined && boundTexture.type !== undefined) {
            gl.bindTexture(boundTexture.type, null);
            boundTexture.type = undefined;
            boundTexture.texture = undefined;
        }
    }
    function compressedTexImage2D() {
        try {
            gl.compressedTexImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function compressedTexImage3D() {
        try {
            gl.compressedTexImage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texSubImage2D() {
        try {
            gl.texSubImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texSubImage3D() {
        try {
            gl.texSubImage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function compressedTexSubImage2D() {
        try {
            gl.compressedTexSubImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function compressedTexSubImage3D() {
        try {
            gl.compressedTexSubImage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texStorage2D() {
        try {
            gl.texStorage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texStorage3D() {
        try {
            gl.texStorage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texImage2D() {
        try {
            gl.texImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texImage3D() {
        try {
            gl.texImage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    //
    function scissor(scissor) {
        if (currentScissor.equals(scissor) === false) {
            gl.scissor(scissor.x, scissor.y, scissor.z, scissor.w);
            currentScissor.copy(scissor);
        }
    }
    function viewport(viewport) {
        if (currentViewport.equals(viewport) === false) {
            gl.viewport(viewport.x, viewport.y, viewport.z, viewport.w);
            currentViewport.copy(viewport);
        }
    }
    function updateUBOMapping(uniformsGroup, program) {
        var mapping = uboProgramMap.get(program);
        if (mapping === undefined) {
            mapping = new WeakMap();
            uboProgramMap.set(program, mapping);
        }
        var blockIndex = mapping.get(uniformsGroup);
        if (blockIndex === undefined) {
            blockIndex = gl.getUniformBlockIndex(program, uniformsGroup.name);
            mapping.set(uniformsGroup, blockIndex);
        }
    }
    function uniformBlockBinding(uniformsGroup, program) {
        var mapping = uboProgramMap.get(program);
        var blockIndex = mapping.get(uniformsGroup);
        if (uboBindings.get(program) !== blockIndex) {
            // bind shader specific block index to global block point
            gl.uniformBlockBinding(program, blockIndex, uniformsGroup.__bindingPointIndex);
            uboBindings.set(program, blockIndex);
        }
    }
    //
    function reset() {
        // reset state
        gl.disable(gl.BLEND);
        gl.disable(gl.CULL_FACE);
        gl.disable(gl.DEPTH_TEST);
        gl.disable(gl.POLYGON_OFFSET_FILL);
        gl.disable(gl.SCISSOR_TEST);
        gl.disable(gl.STENCIL_TEST);
        gl.disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
        gl.blendEquation(gl.FUNC_ADD);
        gl.blendFunc(gl.ONE, gl.ZERO);
        gl.blendFuncSeparate(gl.ONE, gl.ZERO, gl.ONE, gl.ZERO);
        gl.blendColor(0, 0, 0, 0);
        gl.colorMask(true, true, true, true);
        gl.clearColor(0, 0, 0, 0);
        gl.depthMask(true);
        gl.depthFunc(gl.LESS);
        depthBuffer.setReversed(false);
        gl.clearDepth(1);
        gl.stencilMask(0xffffffff);
        gl.stencilFunc(gl.ALWAYS, 0, 0xffffffff);
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
        gl.clearStencil(0);
        gl.cullFace(gl.BACK);
        gl.frontFace(gl.CCW);
        gl.polygonOffset(0, 0);
        gl.activeTexture(gl.TEXTURE0);
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
        gl.bindFramebuffer(gl.READ_FRAMEBUFFER, null);
        gl.useProgram(null);
        gl.lineWidth(1);
        gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
        gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
        // reset internals
        enabledCapabilities = {};
        currentTextureSlot = null;
        currentBoundTextures = {};
        currentBoundFramebuffers = {};
        currentDrawbuffers = new WeakMap();
        defaultDrawbuffers = [];
        currentProgram = null;
        currentBlendingEnabled = false;
        currentBlending = null;
        currentBlendEquation = null;
        currentBlendSrc = null;
        currentBlendDst = null;
        currentBlendEquationAlpha = null;
        currentBlendSrcAlpha = null;
        currentBlendDstAlpha = null;
        currentBlendColor = new (0, $1a55656020b89c3a$export$892596cec99bc70e)(0, 0, 0);
        currentBlendAlpha = 0;
        currentPremultipledAlpha = false;
        currentFlipSided = null;
        currentCullFace = null;
        currentLineWidth = null;
        currentPolygonOffsetFactor = null;
        currentPolygonOffsetUnits = null;
        currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
        currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);
        colorBuffer.reset();
        depthBuffer.reset();
        stencilBuffer.reset();
    }
    return {
        buffers: {
            color: colorBuffer,
            depth: depthBuffer,
            stencil: stencilBuffer
        },
        enable: enable,
        disable: disable,
        bindFramebuffer: bindFramebuffer,
        drawBuffers: drawBuffers,
        useProgram: useProgram,
        setBlending: setBlending,
        setMaterial: setMaterial,
        setFlipSided: setFlipSided,
        setCullFace: setCullFace,
        setLineWidth: setLineWidth,
        setPolygonOffset: setPolygonOffset,
        setScissorTest: setScissorTest,
        activeTexture: activeTexture,
        bindTexture: bindTexture,
        unbindTexture: unbindTexture,
        compressedTexImage2D: compressedTexImage2D,
        compressedTexImage3D: compressedTexImage3D,
        texImage2D: texImage2D,
        texImage3D: texImage3D,
        updateUBOMapping: updateUBOMapping,
        uniformBlockBinding: uniformBlockBinding,
        texStorage2D: texStorage2D,
        texStorage3D: texStorage3D,
        texSubImage2D: texSubImage2D,
        texSubImage3D: texSubImage3D,
        compressedTexSubImage2D: compressedTexSubImage2D,
        compressedTexSubImage3D: compressedTexSubImage3D,
        scissor: scissor,
        viewport: viewport,
        reset: reset
    };
}
function $079becb54c0579a9$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info) {
    var multisampledRTTExt = extensions.has('WEBGL_multisampled_render_to_texture') ? extensions.get('WEBGL_multisampled_render_to_texture') : null;
    var supportsInvalidateFramebuffer = typeof navigator === 'undefined' ? false : /OculusBrowser/g.test(navigator.userAgent);
    var _imageDimensions = new (0, $1a55656020b89c3a$export$c977b3e384af9ae1)();
    var _videoTextures = new WeakMap();
    var _canvas;
    var _sources = new WeakMap(); // maps WebglTexture objects to instances of Source
    // cordova iOS (as of 5.0) still uses UIWebView, which provides OffscreenCanvas,
    // also OffscreenCanvas.getContext("webgl"), but not OffscreenCanvas.getContext("2d")!
    // Some implementations may only implement OffscreenCanvas partially (e.g. lacking 2d).
    var useOffscreenCanvas = false;
    try {
        useOffscreenCanvas = typeof OffscreenCanvas !== 'undefined' && new OffscreenCanvas(1, 1).getContext('2d') !== null;
    } catch (err) {
    // Ignore any errors
    }
    function createCanvas(width, height) {
        // Use OffscreenCanvas when available. Specially needed in web workers
        return useOffscreenCanvas ? // eslint-disable-next-line compat/compat
        new OffscreenCanvas(width, height) : (0, $1a55656020b89c3a$export$7094a064528c7fee)('canvas');
    }
    function resizeImage(image, needsNewCanvas, maxSize) {
        var scale = 1;
        var dimensions = getDimensions(image);
        // handle case if texture exceeds max size
        if (dimensions.width > maxSize || dimensions.height > maxSize) scale = maxSize / Math.max(dimensions.width, dimensions.height);
        // only perform resize if necessary
        if (scale < 1) {
            // only perform resize for certain image types
            if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap || typeof VideoFrame !== 'undefined' && image instanceof VideoFrame) {
                var width = Math.floor(scale * dimensions.width);
                var height = Math.floor(scale * dimensions.height);
                if (_canvas === undefined) _canvas = createCanvas(width, height);
                // cube textures can't reuse the same canvas
                var canvas = needsNewCanvas ? createCanvas(width, height) : _canvas;
                canvas.width = width;
                canvas.height = height;
                var context = canvas.getContext('2d');
                context.drawImage(image, 0, 0, width, height);
                console.warn('THREE.WebGLRenderer: Texture has been resized from (' + dimensions.width + 'x' + dimensions.height + ') to (' + width + 'x' + height + ').');
                return canvas;
            } else {
                if ('data' in image) console.warn('THREE.WebGLRenderer: Image in DataTexture is too big (' + dimensions.width + 'x' + dimensions.height + ').');
                return image;
            }
        }
        return image;
    }
    function textureNeedsGenerateMipmaps(texture) {
        return texture.generateMipmaps;
    }
    function generateMipmap(target) {
        _gl.generateMipmap(target);
    }
    function getTargetType(texture) {
        if (texture.isWebGLCubeRenderTarget) return _gl.TEXTURE_CUBE_MAP;
        if (texture.isWebGL3DRenderTarget) return _gl.TEXTURE_3D;
        if (texture.isWebGLArrayRenderTarget || texture.isCompressedArrayTexture) return _gl.TEXTURE_2D_ARRAY;
        return _gl.TEXTURE_2D;
    }
    function getInternalFormat(internalFormatName, glFormat, glType, colorSpace) {
        var forceLinearTransfer = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
        if (internalFormatName !== null) {
            if (_gl[internalFormatName] !== undefined) return _gl[internalFormatName];
            console.warn('THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format \'' + internalFormatName + '\'');
        }
        var internalFormat = glFormat;
        if (glFormat === _gl.RED) {
            if (glType === _gl.FLOAT) internalFormat = _gl.R32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.R16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8;
        }
        if (glFormat === _gl.RED_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.R16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.R32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.R8I;
            if (glType === _gl.SHORT) internalFormat = _gl.R16I;
            if (glType === _gl.INT) internalFormat = _gl.R32I;
        }
        if (glFormat === _gl.RG) {
            if (glType === _gl.FLOAT) internalFormat = _gl.RG32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RG16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8;
        }
        if (glFormat === _gl.RG_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RG16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RG32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.RG8I;
            if (glType === _gl.SHORT) internalFormat = _gl.RG16I;
            if (glType === _gl.INT) internalFormat = _gl.RG32I;
        }
        if (glFormat === _gl.RGB_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RGB8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RGB16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RGB32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.RGB8I;
            if (glType === _gl.SHORT) internalFormat = _gl.RGB16I;
            if (glType === _gl.INT) internalFormat = _gl.RGB32I;
        }
        if (glFormat === _gl.RGBA_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RGBA8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RGBA16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RGBA32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.RGBA8I;
            if (glType === _gl.SHORT) internalFormat = _gl.RGBA16I;
            if (glType === _gl.INT) internalFormat = _gl.RGBA32I;
        }
        if (glFormat === _gl.RGB) {
            if (glType === _gl.UNSIGNED_INT_5_9_9_9_REV) internalFormat = _gl.RGB9_E5;
        }
        if (glFormat === _gl.RGBA) {
            var transfer = forceLinearTransfer ? (0, $1a55656020b89c3a$export$f197347d588c1b4a) : (0, $1a55656020b89c3a$export$5e6fd513f44698c).getTransfer(colorSpace);
            if (glType === _gl.FLOAT) internalFormat = _gl.RGBA32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RGBA16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = transfer === (0, $1a55656020b89c3a$export$8d0a61916cc26abb) ? _gl.SRGB8_ALPHA8 : _gl.RGBA8;
            if (glType === _gl.UNSIGNED_SHORT_4_4_4_4) internalFormat = _gl.RGBA4;
            if (glType === _gl.UNSIGNED_SHORT_5_5_5_1) internalFormat = _gl.RGB5_A1;
        }
        if (internalFormat === _gl.R16F || internalFormat === _gl.R32F || internalFormat === _gl.RG16F || internalFormat === _gl.RG32F || internalFormat === _gl.RGBA16F || internalFormat === _gl.RGBA32F) extensions.get('EXT_color_buffer_float');
        return internalFormat;
    }
    function getInternalDepthFormat(useStencil, depthType) {
        var glInternalFormat;
        if (useStencil) {
            if (depthType === null || depthType === (0, $1a55656020b89c3a$export$c3c7fc4518ebba96) || depthType === (0, $1a55656020b89c3a$export$6c8ea339bfab1301)) glInternalFormat = _gl.DEPTH24_STENCIL8;
            else if (depthType === (0, $1a55656020b89c3a$export$f6d331659b644596)) glInternalFormat = _gl.DEPTH32F_STENCIL8;
            else if (depthType === (0, $1a55656020b89c3a$export$c63dc51868b06a9d)) {
                glInternalFormat = _gl.DEPTH24_STENCIL8;
                console.warn('DepthTexture: 16 bit depth attachment is not supported with stencil. Using 24-bit attachment.');
            }
        } else {
            if (depthType === null || depthType === (0, $1a55656020b89c3a$export$c3c7fc4518ebba96) || depthType === (0, $1a55656020b89c3a$export$6c8ea339bfab1301)) glInternalFormat = _gl.DEPTH_COMPONENT24;
            else if (depthType === (0, $1a55656020b89c3a$export$f6d331659b644596)) glInternalFormat = _gl.DEPTH_COMPONENT32F;
            else if (depthType === (0, $1a55656020b89c3a$export$c63dc51868b06a9d)) glInternalFormat = _gl.DEPTH_COMPONENT16;
        }
        return glInternalFormat;
    }
    function getMipLevels(texture, image) {
        if (textureNeedsGenerateMipmaps(texture) === true || texture.isFramebufferTexture && texture.minFilter !== (0, $1a55656020b89c3a$export$727aa5ec3fe39bf0) && texture.minFilter !== (0, $1a55656020b89c3a$export$8a72f490b25c56c8)) return Math.log2(Math.max(image.width, image.height)) + 1;
        else if (texture.mipmaps !== undefined && texture.mipmaps.length > 0) // user-defined mipmaps
        return texture.mipmaps.length;
        else if (texture.isCompressedTexture && Array.isArray(texture.image)) return image.mipmaps.length;
        else // texture without mipmaps (only base level)
        return 1;
    }
    //
    function onTextureDispose(event) {
        var texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        deallocateTexture(texture);
        if (texture.isVideoTexture) _videoTextures.delete(texture);
    }
    function onRenderTargetDispose(event) {
        var renderTarget = event.target;
        renderTarget.removeEventListener('dispose', onRenderTargetDispose);
        deallocateRenderTarget(renderTarget);
    }
    //
    function deallocateTexture(texture) {
        var textureProperties = properties.get(texture);
        if (textureProperties.__webglInit === undefined) return;
        // check if it's necessary to remove the WebGLTexture object
        var source = texture.source;
        var webglTextures = _sources.get(source);
        if (webglTextures) {
            var webglTexture = webglTextures[textureProperties.__cacheKey];
            webglTexture.usedTimes--;
            // the WebGLTexture object is not used anymore, remove it
            if (webglTexture.usedTimes === 0) deleteTexture(texture);
            // remove the weak map entry if no WebGLTexture uses the source anymore
            if (Object.keys(webglTextures).length === 0) _sources.delete(source);
        }
        properties.remove(texture);
    }
    function deleteTexture(texture) {
        var textureProperties = properties.get(texture);
        _gl.deleteTexture(textureProperties.__webglTexture);
        var source = texture.source;
        var webglTextures = _sources.get(source);
        delete webglTextures[textureProperties.__cacheKey];
        info.memory.textures--;
    }
    function deallocateRenderTarget(renderTarget) {
        var renderTargetProperties = properties.get(renderTarget);
        if (renderTarget.depthTexture) {
            renderTarget.depthTexture.dispose();
            properties.remove(renderTarget.depthTexture);
        }
        if (renderTarget.isWebGLCubeRenderTarget) for(var i = 0; i < 6; i++){
            if (Array.isArray(renderTargetProperties.__webglFramebuffer[i])) for(var level = 0; level < renderTargetProperties.__webglFramebuffer[i].length; level++)_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i][level]);
            else _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i]);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i]);
        }
        else {
            if (Array.isArray(renderTargetProperties.__webglFramebuffer)) for(var level1 = 0; level1 < renderTargetProperties.__webglFramebuffer.length; level1++)_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[level1]);
            else _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
            if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
            if (renderTargetProperties.__webglColorRenderbuffer) {
                for(var i1 = 0; i1 < renderTargetProperties.__webglColorRenderbuffer.length; i1++)if (renderTargetProperties.__webglColorRenderbuffer[i1]) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer[i1]);
            }
            if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
        }
        var textures = renderTarget.textures;
        for(var i2 = 0, il = textures.length; i2 < il; i2++){
            var attachmentProperties = properties.get(textures[i2]);
            if (attachmentProperties.__webglTexture) {
                _gl.deleteTexture(attachmentProperties.__webglTexture);
                info.memory.textures--;
            }
            properties.remove(textures[i2]);
        }
        properties.remove(renderTarget);
    }
    //
    var textureUnits = 0;
    function resetTextureUnits() {
        textureUnits = 0;
    }
    function allocateTextureUnit() {
        var textureUnit = textureUnits;
        if (textureUnit >= capabilities.maxTextures) console.warn('THREE.WebGLTextures: Trying to use ' + textureUnit + ' texture units while this GPU supports only ' + capabilities.maxTextures);
        textureUnits += 1;
        return textureUnit;
    }
    function getTextureCacheKey(texture) {
        var array = [];
        array.push(texture.wrapS);
        array.push(texture.wrapT);
        array.push(texture.wrapR || 0);
        array.push(texture.magFilter);
        array.push(texture.minFilter);
        array.push(texture.anisotropy);
        array.push(texture.internalFormat);
        array.push(texture.format);
        array.push(texture.type);
        array.push(texture.generateMipmaps);
        array.push(texture.premultiplyAlpha);
        array.push(texture.flipY);
        array.push(texture.unpackAlignment);
        array.push(texture.colorSpace);
        return array.join();
    }
    //
    function setTexture2D(texture, slot) {
        var textureProperties = properties.get(texture);
        if (texture.isVideoTexture) updateVideoTexture(texture);
        if (texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version) {
            var image = texture.image;
            if (image === null) console.warn('THREE.WebGLRenderer: Texture marked for update but no image data found.');
            else if (image.complete === false) console.warn('THREE.WebGLRenderer: Texture marked for update but image is incomplete');
            else {
                uploadTexture(textureProperties, texture, slot);
                return;
            }
        }
        state.bindTexture(_gl.TEXTURE_2D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture2DArray(texture, slot) {
        var textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_2D_ARRAY, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture3D(texture, slot) {
        var textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_3D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTextureCube(texture, slot) {
        var textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadCubeTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    var _obj;
    var wrappingToGL = (_obj = {}, (0, $3facda9e207b3c1f$export$71511d61b312f219)(_obj, (0, $1a55656020b89c3a$export$533346c8e8dac0f5), _gl.REPEAT), (0, $3facda9e207b3c1f$export$71511d61b312f219)(_obj, (0, $1a55656020b89c3a$export$9d9334239a5a5e06), _gl.CLAMP_TO_EDGE), (0, $3facda9e207b3c1f$export$71511d61b312f219)(_obj, (0, $1a55656020b89c3a$export$c7e7c00b14f51a4f), _gl.MIRRORED_REPEAT), _obj);
    var _obj1;
    var filterToGL = (_obj1 = {}, (0, $3facda9e207b3c1f$export$71511d61b312f219)(_obj1, (0, $1a55656020b89c3a$export$727aa5ec3fe39bf0), _gl.NEAREST), (0, $3facda9e207b3c1f$export$71511d61b312f219)(_obj1, (0, $1a55656020b89c3a$export$d129e38cf6feaa8c), _gl.NEAREST_MIPMAP_NEAREST), (0, $3facda9e207b3c1f$export$71511d61b312f219)(_obj1, (0, $1a55656020b89c3a$export$d2327c1afe5bfdf2), _gl.NEAREST_MIPMAP_LINEAR), (0, $3facda9e207b3c1f$export$71511d61b312f219)(_obj1, (0, $1a55656020b89c3a$export$8a72f490b25c56c8), _gl.LINEAR), (0, $3facda9e207b3c1f$export$71511d61b312f219)(_obj1, (0, $1a55656020b89c3a$export$19a719f377145a13), _gl.LINEAR_MIPMAP_NEAREST), (0, $3facda9e207b3c1f$export$71511d61b312f219)(_obj1, (0, $1a55656020b89c3a$export$5d8599b6a933fb1b), _gl.LINEAR_MIPMAP_LINEAR), _obj1);
    var _obj2;
    var compareToGL = (_obj2 = {}, (0, $3facda9e207b3c1f$export$71511d61b312f219)(_obj2, (0, $1a55656020b89c3a$export$d9e2d19a747baaab), _gl.NEVER), (0, $3facda9e207b3c1f$export$71511d61b312f219)(_obj2, (0, $1a55656020b89c3a$export$187b73a3e352c145), _gl.ALWAYS), (0, $3facda9e207b3c1f$export$71511d61b312f219)(_obj2, (0, $1a55656020b89c3a$export$36bcf49c713b3eb7), _gl.LESS), (0, $3facda9e207b3c1f$export$71511d61b312f219)(_obj2, (0, $1a55656020b89c3a$export$64eea11eb407ddf1), _gl.LEQUAL), (0, $3facda9e207b3c1f$export$71511d61b312f219)(_obj2, (0, $1a55656020b89c3a$export$66f28d946fc6a0d5), _gl.EQUAL), (0, $3facda9e207b3c1f$export$71511d61b312f219)(_obj2, (0, $1a55656020b89c3a$export$1cdcb70d53d65f61), _gl.GEQUAL), (0, $3facda9e207b3c1f$export$71511d61b312f219)(_obj2, (0, $1a55656020b89c3a$export$155af022118f3a38), _gl.GREATER), (0, $3facda9e207b3c1f$export$71511d61b312f219)(_obj2, (0, $1a55656020b89c3a$export$67ab95dde6bed156), _gl.NOTEQUAL), _obj2);
    function setTextureParameters(textureType, texture) {
        if (texture.type === (0, $1a55656020b89c3a$export$f6d331659b644596) && extensions.has('OES_texture_float_linear') === false && (texture.magFilter === (0, $1a55656020b89c3a$export$8a72f490b25c56c8) || texture.magFilter === (0, $1a55656020b89c3a$export$19a719f377145a13) || texture.magFilter === (0, $1a55656020b89c3a$export$d2327c1afe5bfdf2) || texture.magFilter === (0, $1a55656020b89c3a$export$5d8599b6a933fb1b) || texture.minFilter === (0, $1a55656020b89c3a$export$8a72f490b25c56c8) || texture.minFilter === (0, $1a55656020b89c3a$export$19a719f377145a13) || texture.minFilter === (0, $1a55656020b89c3a$export$d2327c1afe5bfdf2) || texture.minFilter === (0, $1a55656020b89c3a$export$5d8599b6a933fb1b))) console.warn('THREE.WebGLRenderer: Unable to use linear filtering with floating point textures. OES_texture_float_linear not supported on this device.');
        _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_S, wrappingToGL[texture.wrapS]);
        _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_T, wrappingToGL[texture.wrapT]);
        if (textureType === _gl.TEXTURE_3D || textureType === _gl.TEXTURE_2D_ARRAY) _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_R, wrappingToGL[texture.wrapR]);
        _gl.texParameteri(textureType, _gl.TEXTURE_MAG_FILTER, filterToGL[texture.magFilter]);
        _gl.texParameteri(textureType, _gl.TEXTURE_MIN_FILTER, filterToGL[texture.minFilter]);
        if (texture.compareFunction) {
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_MODE, _gl.COMPARE_REF_TO_TEXTURE);
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_FUNC, compareToGL[texture.compareFunction]);
        }
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            if (texture.magFilter === (0, $1a55656020b89c3a$export$727aa5ec3fe39bf0)) return;
            if (texture.minFilter !== (0, $1a55656020b89c3a$export$d2327c1afe5bfdf2) && texture.minFilter !== (0, $1a55656020b89c3a$export$5d8599b6a933fb1b)) return;
            if (texture.type === (0, $1a55656020b89c3a$export$f6d331659b644596) && extensions.has('OES_texture_float_linear') === false) return; // verify extension
            if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
                var extension = extensions.get('EXT_texture_filter_anisotropic');
                _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
                properties.get(texture).__currentAnisotropy = texture.anisotropy;
            }
        }
    }
    function initTexture(textureProperties, texture) {
        var forceUpload = false;
        if (textureProperties.__webglInit === undefined) {
            textureProperties.__webglInit = true;
            texture.addEventListener('dispose', onTextureDispose);
        }
        // create Source <-> WebGLTextures mapping if necessary
        var source = texture.source;
        var webglTextures = _sources.get(source);
        if (webglTextures === undefined) {
            webglTextures = {};
            _sources.set(source, webglTextures);
        }
        // check if there is already a WebGLTexture object for the given texture parameters
        var textureCacheKey = getTextureCacheKey(texture);
        if (textureCacheKey !== textureProperties.__cacheKey) {
            // if not, create a new instance of WebGLTexture
            if (webglTextures[textureCacheKey] === undefined) {
                // create new entry
                webglTextures[textureCacheKey] = {
                    texture: _gl.createTexture(),
                    usedTimes: 0
                };
                info.memory.textures++;
                // when a new instance of WebGLTexture was created, a texture upload is required
                // even if the image contents are identical
                forceUpload = true;
            }
            webglTextures[textureCacheKey].usedTimes++;
            // every time the texture cache key changes, it's necessary to check if an instance of
            // WebGLTexture can be deleted in order to avoid a memory leak.
            var webglTexture = webglTextures[textureProperties.__cacheKey];
            if (webglTexture !== undefined) {
                webglTextures[textureProperties.__cacheKey].usedTimes--;
                if (webglTexture.usedTimes === 0) deleteTexture(texture);
            }
            // store references to cache key and WebGLTexture object
            textureProperties.__cacheKey = textureCacheKey;
            textureProperties.__webglTexture = webglTextures[textureCacheKey].texture;
        }
        return forceUpload;
    }
    function uploadTexture(textureProperties, texture, slot) {
        var textureType = _gl.TEXTURE_2D;
        if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textureType = _gl.TEXTURE_2D_ARRAY;
        if (texture.isData3DTexture) textureType = _gl.TEXTURE_3D;
        var forceUpload = initTexture(textureProperties, texture);
        var source = texture.source;
        state.bindTexture(textureType, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        var sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            var workingPrimaries = (0, $1a55656020b89c3a$export$5e6fd513f44698c).getPrimaries((0, $1a55656020b89c3a$export$5e6fd513f44698c).workingColorSpace);
            var texturePrimaries = texture.colorSpace === (0, $1a55656020b89c3a$export$bfcb490c2dd3db51) ? null : (0, $1a55656020b89c3a$export$5e6fd513f44698c).getPrimaries(texture.colorSpace);
            var unpackConversion = texture.colorSpace === (0, $1a55656020b89c3a$export$bfcb490c2dd3db51) || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
            var image = resizeImage(texture.image, false, capabilities.maxTextureSize);
            image = verifyColorSpace(texture, image);
            var glFormat = utils.convert(texture.format, texture.colorSpace);
            var glType = utils.convert(texture.type);
            var glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, texture.isVideoTexture);
            setTextureParameters(textureType, texture);
            var mipmap;
            var mipmaps = texture.mipmaps;
            var useTexStorage = texture.isVideoTexture !== true;
            var allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            var dataReady = source.dataReady;
            var levels = getMipLevels(texture, image);
            if (texture.isDepthTexture) {
                glInternalFormat = getInternalDepthFormat(texture.format === (0, $1a55656020b89c3a$export$1e113ac2d0905829), texture.type);
                //
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, 1, glInternalFormat, image.width, image.height);
                    else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
                }
            } else if (texture.isDataTexture) {
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0) {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(var i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        } else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, image.width, image.height, glFormat, glType, image.data);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
            } else if (texture.isCompressedTexture) {
                if (texture.isCompressedArrayTexture) {
                    if (useTexStorage && allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height, image.depth);
                    for(var i1 = 0, il1 = mipmaps.length; i1 < il1; i1++){
                        mipmap = mipmaps[i1];
                        if (texture.format !== (0, $1a55656020b89c3a$export$3f8bb04b555a363c)) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) {
                                        if (texture.layerUpdates.size > 0) {
                                            var layerByteLength = (0, $1a55656020b89c3a$export$cc8c3b705bb8e6e2)(mipmap.width, mipmap.height, texture.format, texture.type);
                                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                            try {
                                                for(var _iterator = texture.layerUpdates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                    var layerIndex = _step.value;
                                                    var layerData = mipmap.data.subarray(layerIndex * layerByteLength / mipmap.data.BYTES_PER_ELEMENT, (layerIndex + 1) * layerByteLength / mipmap.data.BYTES_PER_ELEMENT);
                                                    state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i1, 0, 0, layerIndex, mipmap.width, mipmap.height, 1, glFormat, layerData);
                                                }
                                            } catch (err) {
                                                _didIteratorError = true;
                                                _iteratorError = err;
                                            } finally{
                                                try {
                                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                        _iterator.return();
                                                    }
                                                } finally{
                                                    if (_didIteratorError) {
                                                        throw _iteratorError;
                                                    }
                                                }
                                            }
                                            texture.clearLayerUpdates();
                                        } else state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i1, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, mipmap.data);
                                    }
                                } else state.compressedTexImage3D(_gl.TEXTURE_2D_ARRAY, i1, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, mipmap.data, 0, 0);
                            } else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, i1, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, glType, mipmap.data);
                            } else state.texImage3D(_gl.TEXTURE_2D_ARRAY, i1, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, glFormat, glType, mipmap.data);
                        }
                    }
                } else {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(var i2 = 0, il2 = mipmaps.length; i2 < il2; i2++){
                        mipmap = mipmaps[i2];
                        if (texture.format !== (0, $1a55656020b89c3a$export$3f8bb04b555a363c)) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) state.compressedTexSubImage2D(_gl.TEXTURE_2D, i2, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                } else state.compressedTexImage2D(_gl.TEXTURE_2D, i2, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i2, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                            } else state.texImage2D(_gl.TEXTURE_2D, i2, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                        }
                    }
                }
            } else if (texture.isDataArrayTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, image.width, image.height, image.depth);
                    if (dataReady) {
                        if (texture.layerUpdates.size > 0) {
                            var layerByteLength1 = (0, $1a55656020b89c3a$export$cc8c3b705bb8e6e2)(image.width, image.height, texture.format, texture.type);
                            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                for(var _iterator1 = texture.layerUpdates[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                    var layerIndex1 = _step1.value;
                                    var layerData1 = image.data.subarray(layerIndex1 * layerByteLength1 / image.data.BYTES_PER_ELEMENT, (layerIndex1 + 1) * layerByteLength1 / image.data.BYTES_PER_ELEMENT);
                                    state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, layerIndex1, image.width, image.height, 1, glFormat, glType, layerData1);
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                            texture.clearLayerUpdates();
                        } else state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                    }
                } else state.texImage3D(_gl.TEXTURE_2D_ARRAY, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isData3DTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_3D, levels, glInternalFormat, image.width, image.height, image.depth);
                    if (dataReady) state.texSubImage3D(_gl.TEXTURE_3D, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                } else state.texImage3D(_gl.TEXTURE_3D, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isFramebufferTexture) {
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    else {
                        var width = image.width, height = image.height;
                        for(var i3 = 0; i3 < levels; i3++){
                            state.texImage2D(_gl.TEXTURE_2D, i3, glInternalFormat, width, height, 0, glFormat, glType, null);
                            width >>= 1;
                            height >>= 1;
                        }
                    }
                }
            } else {
                // regular Texture (image, video, canvas)
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0) {
                    if (useTexStorage && allocateMemory) {
                        var dimensions = getDimensions(mipmaps[0]);
                        state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height);
                    }
                    for(var i4 = 0, il3 = mipmaps.length; i4 < il3; i4++){
                        mipmap = mipmaps[i4];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i4, 0, 0, glFormat, glType, mipmap);
                        } else state.texImage2D(_gl.TEXTURE_2D, i4, glInternalFormat, glFormat, glType, mipmap);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) {
                        var dimensions1 = getDimensions(image);
                        state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, dimensions1.width, dimensions1.height);
                    }
                    if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, glFormat, glType, image);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, glFormat, glType, image);
            }
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(textureType);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    function uploadCubeTexture(textureProperties, texture, slot) {
        if (texture.image.length !== 6) return;
        var forceUpload = initTexture(textureProperties, texture);
        var source = texture.source;
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        var sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            var workingPrimaries = (0, $1a55656020b89c3a$export$5e6fd513f44698c).getPrimaries((0, $1a55656020b89c3a$export$5e6fd513f44698c).workingColorSpace);
            var texturePrimaries = texture.colorSpace === (0, $1a55656020b89c3a$export$bfcb490c2dd3db51) ? null : (0, $1a55656020b89c3a$export$5e6fd513f44698c).getPrimaries(texture.colorSpace);
            var unpackConversion = texture.colorSpace === (0, $1a55656020b89c3a$export$bfcb490c2dd3db51) || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
            var isCompressed = texture.isCompressedTexture || texture.image[0].isCompressedTexture;
            var isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
            var cubeImage = [];
            for(var i = 0; i < 6; i++){
                if (!isCompressed && !isDataTexture) cubeImage[i] = resizeImage(texture.image[i], true, capabilities.maxCubemapSize);
                else cubeImage[i] = isDataTexture ? texture.image[i].image : texture.image[i];
                cubeImage[i] = verifyColorSpace(texture, cubeImage[i]);
            }
            var image = cubeImage[0], glFormat = utils.convert(texture.format, texture.colorSpace), glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
            var useTexStorage = texture.isVideoTexture !== true;
            var allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            var dataReady = source.dataReady;
            var levels = getMipLevels(texture, image);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture);
            var mipmaps;
            if (isCompressed) {
                if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, image.width, image.height);
                for(var i1 = 0; i1 < 6; i1++){
                    mipmaps = cubeImage[i1].mipmaps;
                    for(var j = 0; j < mipmaps.length; j++){
                        var mipmap = mipmaps[j];
                        if (texture.format !== (0, $1a55656020b89c3a$export$3f8bb04b555a363c)) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) state.compressedTexSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i1, j, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                } else state.compressedTexImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i1, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()');
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i1, j, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                            } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i1, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                        }
                    }
                }
            } else {
                mipmaps = texture.mipmaps;
                if (useTexStorage && allocateMemory) {
                    // TODO: Uniformly handle mipmap definitions
                    // Normal textures and compressed cube textures define base level + mips with their mipmap array
                    // Uncompressed cube textures use their mipmap array only for mips (no base level)
                    if (mipmaps.length > 0) levels++;
                    var dimensions = getDimensions(cubeImage[0]);
                    state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, dimensions.width, dimensions.height);
                }
                for(var i2 = 0; i2 < 6; i2++)if (isDataTexture) {
                    if (useTexStorage) {
                        if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, 0, 0, 0, cubeImage[i2].width, cubeImage[i2].height, glFormat, glType, cubeImage[i2].data);
                    } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, 0, glInternalFormat, cubeImage[i2].width, cubeImage[i2].height, 0, glFormat, glType, cubeImage[i2].data);
                    for(var j1 = 0; j1 < mipmaps.length; j1++){
                        var mipmap1 = mipmaps[j1];
                        var mipmapImage = mipmap1.image[i2].image;
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, j1 + 1, 0, 0, mipmapImage.width, mipmapImage.height, glFormat, glType, mipmapImage.data);
                        } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, j1 + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
                    }
                } else {
                    if (useTexStorage) {
                        if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, 0, 0, 0, glFormat, glType, cubeImage[i2]);
                    } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, 0, glInternalFormat, glFormat, glType, cubeImage[i2]);
                    for(var j2 = 0; j2 < mipmaps.length; j2++){
                        var mipmap2 = mipmaps[j2];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, j2 + 1, 0, 0, glFormat, glType, mipmap2.image[i2]);
                        } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i2, j2 + 1, glInternalFormat, glFormat, glType, mipmap2.image[i2]);
                    }
                }
            }
            if (textureNeedsGenerateMipmaps(texture)) // We assume images for cube map have the same size.
            generateMipmap(_gl.TEXTURE_CUBE_MAP);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    // Render targets
    // Setup storage for target texture and bind it to correct framebuffer
    function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget, level) {
        var glFormat = utils.convert(texture.format, texture.colorSpace);
        var glType = utils.convert(texture.type);
        var glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
        var renderTargetProperties = properties.get(renderTarget);
        var textureProperties = properties.get(texture);
        textureProperties.__renderTarget = renderTarget;
        if (!renderTargetProperties.__hasExternalTextures) {
            var width = Math.max(1, renderTarget.width >> level);
            var height = Math.max(1, renderTarget.height >> level);
            if (textureTarget === _gl.TEXTURE_3D || textureTarget === _gl.TEXTURE_2D_ARRAY) state.texImage3D(textureTarget, level, glInternalFormat, width, height, renderTarget.depth, 0, glFormat, glType, null);
            else state.texImage2D(textureTarget, level, glInternalFormat, width, height, 0, glFormat, glType, null);
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, attachment, textureTarget, textureProperties.__webglTexture, 0, getRenderTargetSamples(renderTarget));
        else if (textureTarget === _gl.TEXTURE_2D || textureTarget >= _gl.TEXTURE_CUBE_MAP_POSITIVE_X && textureTarget <= _gl.TEXTURE_CUBE_MAP_NEGATIVE_Z) _gl.framebufferTexture2D(_gl.FRAMEBUFFER, attachment, textureTarget, textureProperties.__webglTexture, level);
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // Setup storage for internal depth/stencil buffers and bind to correct framebuffer
    function setupRenderBufferStorage(renderbuffer, renderTarget, isMultisample) {
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
        if (renderTarget.depthBuffer) {
            // retrieve the depth attachment types
            var depthTexture = renderTarget.depthTexture;
            var depthType = depthTexture && depthTexture.isDepthTexture ? depthTexture.type : null;
            var glInternalFormat = getInternalDepthFormat(renderTarget.stencilBuffer, depthType);
            var glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
            // set up the attachment
            var samples = getRenderTargetSamples(renderTarget);
            var isUseMultisampledRTT = useMultisampledRTT(renderTarget);
            if (isUseMultisampledRTT) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            else if (isMultisample) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
        } else {
            var textures = renderTarget.textures;
            for(var i = 0; i < textures.length; i++){
                var texture = textures[i];
                var glFormat = utils.convert(texture.format, texture.colorSpace);
                var glType = utils.convert(texture.type);
                var glInternalFormat1 = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
                var samples1 = getRenderTargetSamples(renderTarget);
                if (isMultisample && useMultisampledRTT(renderTarget) === false) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples1, glInternalFormat1, renderTarget.width, renderTarget.height);
                else if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples1, glInternalFormat1, renderTarget.width, renderTarget.height);
                else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat1, renderTarget.width, renderTarget.height);
            }
        }
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
    }
    // Setup resources for a Depth Texture for a FBO (needs an extension)
    function setupDepthTexture(framebuffer, renderTarget) {
        var isCube = renderTarget && renderTarget.isWebGLCubeRenderTarget;
        if (isCube) throw new Error('Depth Texture with cube render targets is not supported');
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) throw new Error('renderTarget.depthTexture must be an instance of THREE.DepthTexture');
        var textureProperties = properties.get(renderTarget.depthTexture);
        textureProperties.__renderTarget = renderTarget;
        // upload an empty depth texture with framebuffer size
        if (!textureProperties.__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
            renderTarget.depthTexture.image.width = renderTarget.width;
            renderTarget.depthTexture.image.height = renderTarget.height;
            renderTarget.depthTexture.needsUpdate = true;
        }
        setTexture2D(renderTarget.depthTexture, 0);
        var webglDepthTexture = textureProperties.__webglTexture;
        var samples = getRenderTargetSamples(renderTarget);
        if (renderTarget.depthTexture.format === (0, $1a55656020b89c3a$export$c1b6b5136be58045)) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
        } else if (renderTarget.depthTexture.format === (0, $1a55656020b89c3a$export$1e113ac2d0905829)) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
        } else throw new Error('Unknown depthTexture format');
    }
    // Setup GL resources for a non-texture depth buffer
    function setupDepthRenderbuffer(renderTarget) {
        var renderTargetProperties = properties.get(renderTarget);
        var isCube = renderTarget.isWebGLCubeRenderTarget === true;
        // if the bound depth texture has changed
        if (renderTargetProperties.__boundDepthTexture !== renderTarget.depthTexture) {
            // fire the dispose event to get rid of stored state associated with the previously bound depth buffer
            var depthTexture = renderTarget.depthTexture;
            if (renderTargetProperties.__depthDisposeCallback) renderTargetProperties.__depthDisposeCallback();
            // set up dispose listeners to track when the currently attached buffer is implicitly unbound
            if (depthTexture) {
                var disposeEvent = function() {
                    delete renderTargetProperties.__boundDepthTexture;
                    delete renderTargetProperties.__depthDisposeCallback;
                    depthTexture.removeEventListener('dispose', disposeEvent);
                };
                depthTexture.addEventListener('dispose', disposeEvent);
                renderTargetProperties.__depthDisposeCallback = disposeEvent;
            }
            renderTargetProperties.__boundDepthTexture = depthTexture;
        }
        if (renderTarget.depthTexture && !renderTargetProperties.__autoAllocateDepthBuffer) {
            if (isCube) throw new Error('target.depthTexture not supported in Cube render targets');
            setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget);
        } else if (isCube) {
            renderTargetProperties.__webglDepthbuffer = [];
            for(var i = 0; i < 6; i++){
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[i]);
                if (renderTargetProperties.__webglDepthbuffer[i] === undefined) {
                    renderTargetProperties.__webglDepthbuffer[i] = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i], renderTarget, false);
                } else {
                    // attach buffer if it's been created already
                    var glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                    var renderbuffer = renderTargetProperties.__webglDepthbuffer[i];
                    _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
                }
            }
        } else {
            state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer === undefined) {
                renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
                setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
            } else {
                // attach buffer if it's been created already
                var glAttachmentType1 = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                var renderbuffer1 = renderTargetProperties.__webglDepthbuffer;
                _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer1);
                _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType1, _gl.RENDERBUFFER, renderbuffer1);
            }
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // rebind framebuffer with external textures
    function rebindTextures(renderTarget, colorTexture, depthTexture) {
        var renderTargetProperties = properties.get(renderTarget);
        if (colorTexture !== undefined) setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, renderTarget.texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, 0);
        if (depthTexture !== undefined) setupDepthRenderbuffer(renderTarget);
    }
    // Set up GL resources for the render target
    function setupRenderTarget(renderTarget) {
        var texture = renderTarget.texture;
        var renderTargetProperties = properties.get(renderTarget);
        var textureProperties = properties.get(texture);
        renderTarget.addEventListener('dispose', onRenderTargetDispose);
        var textures = renderTarget.textures;
        var isCube = renderTarget.isWebGLCubeRenderTarget === true;
        var isMultipleRenderTargets = textures.length > 1;
        if (!isMultipleRenderTargets) {
            if (textureProperties.__webglTexture === undefined) textureProperties.__webglTexture = _gl.createTexture();
            textureProperties.__version = texture.version;
            info.memory.textures++;
        }
        // Setup framebuffer
        if (isCube) {
            renderTargetProperties.__webglFramebuffer = [];
            for(var i = 0; i < 6; i++)if (texture.mipmaps && texture.mipmaps.length > 0) {
                renderTargetProperties.__webglFramebuffer[i] = [];
                for(var level = 0; level < texture.mipmaps.length; level++)renderTargetProperties.__webglFramebuffer[i][level] = _gl.createFramebuffer();
            } else renderTargetProperties.__webglFramebuffer[i] = _gl.createFramebuffer();
        } else {
            if (texture.mipmaps && texture.mipmaps.length > 0) {
                renderTargetProperties.__webglFramebuffer = [];
                for(var level1 = 0; level1 < texture.mipmaps.length; level1++)renderTargetProperties.__webglFramebuffer[level1] = _gl.createFramebuffer();
            } else renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
            if (isMultipleRenderTargets) for(var i1 = 0, il = textures.length; i1 < il; i1++){
                var attachmentProperties = properties.get(textures[i1]);
                if (attachmentProperties.__webglTexture === undefined) {
                    attachmentProperties.__webglTexture = _gl.createTexture();
                    info.memory.textures++;
                }
            }
            if (renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
                renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
                renderTargetProperties.__webglColorRenderbuffer = [];
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                for(var i2 = 0; i2 < textures.length; i2++){
                    var texture1 = textures[i2];
                    renderTargetProperties.__webglColorRenderbuffer[i2] = _gl.createRenderbuffer();
                    _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i2]);
                    var glFormat = utils.convert(texture1.format, texture1.colorSpace);
                    var glType = utils.convert(texture1.type);
                    var glInternalFormat = getInternalFormat(texture1.internalFormat, glFormat, glType, texture1.colorSpace, renderTarget.isXRRenderTarget === true);
                    var samples = getRenderTargetSamples(renderTarget);
                    _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i2, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i2]);
                }
                _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
                if (renderTarget.depthBuffer) {
                    renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
                }
                state.bindFramebuffer(_gl.FRAMEBUFFER, null);
            }
        }
        // Setup color buffer
        if (isCube) {
            state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture);
            for(var i3 = 0; i3 < 6; i3++){
                if (texture.mipmaps && texture.mipmaps.length > 0) for(var level2 = 0; level2 < texture.mipmaps.length; level2++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i3][level2], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i3, level2);
                else setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i3], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i3, 0);
            }
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(_gl.TEXTURE_CUBE_MAP);
            state.unbindTexture();
        } else if (isMultipleRenderTargets) {
            for(var i4 = 0, il1 = textures.length; i4 < il1; i4++){
                var attachment = textures[i4];
                var attachmentProperties1 = properties.get(attachment);
                state.bindTexture(_gl.TEXTURE_2D, attachmentProperties1.__webglTexture);
                setTextureParameters(_gl.TEXTURE_2D, attachment);
                setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, _gl.COLOR_ATTACHMENT0 + i4, _gl.TEXTURE_2D, 0);
                if (textureNeedsGenerateMipmaps(attachment)) generateMipmap(_gl.TEXTURE_2D);
            }
            state.unbindTexture();
        } else {
            var glTextureType = _gl.TEXTURE_2D;
            if (renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget) glTextureType = renderTarget.isWebGL3DRenderTarget ? _gl.TEXTURE_3D : _gl.TEXTURE_2D_ARRAY;
            state.bindTexture(glTextureType, textureProperties.__webglTexture);
            setTextureParameters(glTextureType, texture);
            if (texture.mipmaps && texture.mipmaps.length > 0) for(var level3 = 0; level3 < texture.mipmaps.length; level3++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[level3], renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, level3);
            else setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, 0);
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(glTextureType);
            state.unbindTexture();
        }
        // Setup depth and stencil buffers
        if (renderTarget.depthBuffer) setupDepthRenderbuffer(renderTarget);
    }
    function updateRenderTargetMipmap(renderTarget) {
        var textures = renderTarget.textures;
        for(var i = 0, il = textures.length; i < il; i++){
            var texture = textures[i];
            if (textureNeedsGenerateMipmaps(texture)) {
                var targetType = getTargetType(renderTarget);
                var webglTexture = properties.get(texture).__webglTexture;
                state.bindTexture(targetType, webglTexture);
                generateMipmap(targetType);
                state.unbindTexture();
            }
        }
    }
    var invalidationArrayRead = [];
    var invalidationArrayDraw = [];
    function updateMultisampleRenderTarget(renderTarget) {
        if (renderTarget.samples > 0) {
            if (useMultisampledRTT(renderTarget) === false) {
                var textures = renderTarget.textures;
                var width = renderTarget.width;
                var height = renderTarget.height;
                var mask = _gl.COLOR_BUFFER_BIT;
                var depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                var renderTargetProperties = properties.get(renderTarget);
                var isMultipleRenderTargets = textures.length > 1;
                // If MRT we need to remove FBO attachments
                if (isMultipleRenderTargets) for(var i = 0; i < textures.length; i++){
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, null);
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                    _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, null, 0);
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                for(var i1 = 0; i1 < textures.length; i1++){
                    if (renderTarget.resolveDepthBuffer) {
                        if (renderTarget.depthBuffer) mask |= _gl.DEPTH_BUFFER_BIT;
                        // resolving stencil is slow with a D3D backend. disable it for all transmission render targets (see #27799)
                        if (renderTarget.stencilBuffer && renderTarget.resolveStencilBuffer) mask |= _gl.STENCIL_BUFFER_BIT;
                    }
                    if (isMultipleRenderTargets) {
                        _gl.framebufferRenderbuffer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i1]);
                        var webglTexture = properties.get(textures[i1]).__webglTexture;
                        _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, webglTexture, 0);
                    }
                    _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, _gl.NEAREST);
                    if (supportsInvalidateFramebuffer === true) {
                        invalidationArrayRead.length = 0;
                        invalidationArrayDraw.length = 0;
                        invalidationArrayRead.push(_gl.COLOR_ATTACHMENT0 + i1);
                        if (renderTarget.depthBuffer && renderTarget.resolveDepthBuffer === false) {
                            invalidationArrayRead.push(depthStyle);
                            invalidationArrayDraw.push(depthStyle);
                            _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, invalidationArrayDraw);
                        }
                        _gl.invalidateFramebuffer(_gl.READ_FRAMEBUFFER, invalidationArrayRead);
                    }
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
                // If MRT since pre-blit we removed the FBO we need to reconstruct the attachments
                if (isMultipleRenderTargets) for(var i2 = 0; i2 < textures.length; i2++){
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i2, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i2]);
                    var webglTexture1 = properties.get(textures[i2]).__webglTexture;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                    _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i2, _gl.TEXTURE_2D, webglTexture1, 0);
                }
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
            } else if (renderTarget.depthBuffer && renderTarget.resolveDepthBuffer === false && supportsInvalidateFramebuffer) {
                var depthStyle1 = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, [
                    depthStyle1
                ]);
            }
        }
    }
    function getRenderTargetSamples(renderTarget) {
        return Math.min(capabilities.maxSamples, renderTarget.samples);
    }
    function useMultisampledRTT(renderTarget) {
        var renderTargetProperties = properties.get(renderTarget);
        return renderTarget.samples > 0 && extensions.has('WEBGL_multisampled_render_to_texture') === true && renderTargetProperties.__useRenderToTexture !== false;
    }
    function updateVideoTexture(texture) {
        var frame = info.render.frame;
        // Check the last frame we updated the VideoTexture
        if (_videoTextures.get(texture) !== frame) {
            _videoTextures.set(texture, frame);
            texture.update();
        }
    }
    function verifyColorSpace(texture, image) {
        var colorSpace = texture.colorSpace;
        var format = texture.format;
        var type = texture.type;
        if (texture.isCompressedTexture === true || texture.isVideoTexture === true) return image;
        if (colorSpace !== (0, $1a55656020b89c3a$export$42429b3acfb233a4) && colorSpace !== (0, $1a55656020b89c3a$export$bfcb490c2dd3db51)) {
            // sRGB
            if ((0, $1a55656020b89c3a$export$5e6fd513f44698c).getTransfer(colorSpace) === (0, $1a55656020b89c3a$export$8d0a61916cc26abb)) // in WebGL 2 uncompressed textures can only be sRGB encoded if they have the RGBA8 format
            {
                if (format !== (0, $1a55656020b89c3a$export$3f8bb04b555a363c) || type !== (0, $1a55656020b89c3a$export$2e8ce08d3f6f5e10)) console.warn('THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.');
            } else console.error('THREE.WebGLTextures: Unsupported texture color space:', colorSpace);
        }
        return image;
    }
    function getDimensions(image) {
        if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement) {
            // if intrinsic data are not available, fallback to width/height
            _imageDimensions.width = image.naturalWidth || image.width;
            _imageDimensions.height = image.naturalHeight || image.height;
        } else if (typeof VideoFrame !== 'undefined' && image instanceof VideoFrame) {
            _imageDimensions.width = image.displayWidth;
            _imageDimensions.height = image.displayHeight;
        } else {
            _imageDimensions.width = image.width;
            _imageDimensions.height = image.height;
        }
        return _imageDimensions;
    }
    //
    this.allocateTextureUnit = allocateTextureUnit;
    this.resetTextureUnits = resetTextureUnits;
    this.setTexture2D = setTexture2D;
    this.setTexture2DArray = setTexture2DArray;
    this.setTexture3D = setTexture3D;
    this.setTextureCube = setTextureCube;
    this.rebindTextures = rebindTextures;
    this.setupRenderTarget = setupRenderTarget;
    this.updateRenderTargetMipmap = updateRenderTargetMipmap;
    this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
    this.setupDepthRenderbuffer = setupDepthRenderbuffer;
    this.setupFrameBufferTexture = setupFrameBufferTexture;
    this.useMultisampledRTT = useMultisampledRTT;
}
function $079becb54c0579a9$export$ddaebcad857649a8(gl, extensions) {
    function convert(p) {
        var colorSpace = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $1a55656020b89c3a$export$bfcb490c2dd3db51);
        var extension;
        var transfer = (0, $1a55656020b89c3a$export$5e6fd513f44698c).getTransfer(colorSpace);
        if (p === (0, $1a55656020b89c3a$export$2e8ce08d3f6f5e10)) return gl.UNSIGNED_BYTE;
        if (p === (0, $1a55656020b89c3a$export$b3969b01faf587f2)) return gl.UNSIGNED_SHORT_4_4_4_4;
        if (p === (0, $1a55656020b89c3a$export$18886f8ae33e90de)) return gl.UNSIGNED_SHORT_5_5_5_1;
        if (p === (0, $1a55656020b89c3a$export$5a4c329b7e2092d3)) return gl.UNSIGNED_INT_5_9_9_9_REV;
        if (p === (0, $1a55656020b89c3a$export$545fce0311a9796a)) return gl.BYTE;
        if (p === (0, $1a55656020b89c3a$export$88572337f312435f)) return gl.SHORT;
        if (p === (0, $1a55656020b89c3a$export$c63dc51868b06a9d)) return gl.UNSIGNED_SHORT;
        if (p === (0, $1a55656020b89c3a$export$5c612977753abe2)) return gl.INT;
        if (p === (0, $1a55656020b89c3a$export$c3c7fc4518ebba96)) return gl.UNSIGNED_INT;
        if (p === (0, $1a55656020b89c3a$export$f6d331659b644596)) return gl.FLOAT;
        if (p === (0, $1a55656020b89c3a$export$2697304443f382bc)) return gl.HALF_FLOAT;
        if (p === (0, $1a55656020b89c3a$export$988473390501ed4b)) return gl.ALPHA;
        if (p === (0, $1a55656020b89c3a$export$7c67423a5ee6f5eb)) return gl.RGB;
        if (p === (0, $1a55656020b89c3a$export$3f8bb04b555a363c)) return gl.RGBA;
        if (p === (0, $1a55656020b89c3a$export$cc09ccbf6d1ed449)) return gl.LUMINANCE;
        if (p === (0, $1a55656020b89c3a$export$9053a81c4a69c289)) return gl.LUMINANCE_ALPHA;
        if (p === (0, $1a55656020b89c3a$export$c1b6b5136be58045)) return gl.DEPTH_COMPONENT;
        if (p === (0, $1a55656020b89c3a$export$1e113ac2d0905829)) return gl.DEPTH_STENCIL;
        // WebGL2 formats.
        if (p === (0, $1a55656020b89c3a$export$4e041a7967d15c4b)) return gl.RED;
        if (p === (0, $1a55656020b89c3a$export$aa92e870a709d190)) return gl.RED_INTEGER;
        if (p === (0, $1a55656020b89c3a$export$6cdf0b461c7ce8a0)) return gl.RG;
        if (p === (0, $1a55656020b89c3a$export$1ba1c45f9f77d4d7)) return gl.RG_INTEGER;
        if (p === (0, $1a55656020b89c3a$export$c200e7d26f592f21)) return gl.RGBA_INTEGER;
        // S3TC
        if (p === (0, $1a55656020b89c3a$export$21d1799c6d552fc0) || p === (0, $1a55656020b89c3a$export$afa304c3e981b668) || p === (0, $1a55656020b89c3a$export$d2a1a68024a3e56c) || p === (0, $1a55656020b89c3a$export$9a79c424327dacf9)) {
            if (transfer === (0, $1a55656020b89c3a$export$8d0a61916cc26abb)) {
                extension = extensions.get('WEBGL_compressed_texture_s3tc_srgb');
                if (extension !== null) {
                    if (p === (0, $1a55656020b89c3a$export$21d1799c6d552fc0)) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (p === (0, $1a55656020b89c3a$export$afa304c3e981b668)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (p === (0, $1a55656020b89c3a$export$d2a1a68024a3e56c)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (p === (0, $1a55656020b89c3a$export$9a79c424327dacf9)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else return null;
            } else {
                extension = extensions.get('WEBGL_compressed_texture_s3tc');
                if (extension !== null) {
                    if (p === (0, $1a55656020b89c3a$export$21d1799c6d552fc0)) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
                    if (p === (0, $1a55656020b89c3a$export$afa304c3e981b668)) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                    if (p === (0, $1a55656020b89c3a$export$d2a1a68024a3e56c)) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                    if (p === (0, $1a55656020b89c3a$export$9a79c424327dacf9)) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                } else return null;
            }
        }
        // PVRTC
        if (p === (0, $1a55656020b89c3a$export$19ada9bbb1af3573) || p === (0, $1a55656020b89c3a$export$d0f0355bb3d948e4) || p === (0, $1a55656020b89c3a$export$b82296714358084c) || p === (0, $1a55656020b89c3a$export$b71692456c47b6c3)) {
            extension = extensions.get('WEBGL_compressed_texture_pvrtc');
            if (extension !== null) {
                if (p === (0, $1a55656020b89c3a$export$19ada9bbb1af3573)) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (p === (0, $1a55656020b89c3a$export$d0f0355bb3d948e4)) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (p === (0, $1a55656020b89c3a$export$b82296714358084c)) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (p === (0, $1a55656020b89c3a$export$b71692456c47b6c3)) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        // ETC
        if (p === (0, $1a55656020b89c3a$export$6ab91af2d757aee7) || p === (0, $1a55656020b89c3a$export$7800993ef8106a6a) || p === (0, $1a55656020b89c3a$export$23ed8300a860e7d8)) {
            extension = extensions.get('WEBGL_compressed_texture_etc');
            if (extension !== null) {
                if (p === (0, $1a55656020b89c3a$export$6ab91af2d757aee7) || p === (0, $1a55656020b89c3a$export$7800993ef8106a6a)) return transfer === (0, $1a55656020b89c3a$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
                if (p === (0, $1a55656020b89c3a$export$23ed8300a860e7d8)) return transfer === (0, $1a55656020b89c3a$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;
            } else return null;
        }
        // ASTC
        if (p === (0, $1a55656020b89c3a$export$dc5570b4a2b92d48) || p === (0, $1a55656020b89c3a$export$68880cd325f8b2fb) || p === (0, $1a55656020b89c3a$export$7d2c0be323373d95) || p === (0, $1a55656020b89c3a$export$22b52da301fc3a3e) || p === (0, $1a55656020b89c3a$export$c009e2cb4a66485e) || p === (0, $1a55656020b89c3a$export$118fff5afa255b63) || p === (0, $1a55656020b89c3a$export$120713c829ae0667) || p === (0, $1a55656020b89c3a$export$c79eeabbf53313e9) || p === (0, $1a55656020b89c3a$export$443cf6567cdd6424) || p === (0, $1a55656020b89c3a$export$6573984fc9840780) || p === (0, $1a55656020b89c3a$export$e7aee563f30091de) || p === (0, $1a55656020b89c3a$export$2eb8634622ddeab7) || p === (0, $1a55656020b89c3a$export$202b1ce7b5d25742) || p === (0, $1a55656020b89c3a$export$18ab77abd087e467)) {
            extension = extensions.get('WEBGL_compressed_texture_astc');
            if (extension !== null) {
                if (p === (0, $1a55656020b89c3a$export$dc5570b4a2b92d48)) return transfer === (0, $1a55656020b89c3a$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (p === (0, $1a55656020b89c3a$export$68880cd325f8b2fb)) return transfer === (0, $1a55656020b89c3a$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (p === (0, $1a55656020b89c3a$export$7d2c0be323373d95)) return transfer === (0, $1a55656020b89c3a$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (p === (0, $1a55656020b89c3a$export$22b52da301fc3a3e)) return transfer === (0, $1a55656020b89c3a$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (p === (0, $1a55656020b89c3a$export$c009e2cb4a66485e)) return transfer === (0, $1a55656020b89c3a$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (p === (0, $1a55656020b89c3a$export$118fff5afa255b63)) return transfer === (0, $1a55656020b89c3a$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (p === (0, $1a55656020b89c3a$export$120713c829ae0667)) return transfer === (0, $1a55656020b89c3a$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (p === (0, $1a55656020b89c3a$export$c79eeabbf53313e9)) return transfer === (0, $1a55656020b89c3a$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (p === (0, $1a55656020b89c3a$export$443cf6567cdd6424)) return transfer === (0, $1a55656020b89c3a$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (p === (0, $1a55656020b89c3a$export$6573984fc9840780)) return transfer === (0, $1a55656020b89c3a$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (p === (0, $1a55656020b89c3a$export$e7aee563f30091de)) return transfer === (0, $1a55656020b89c3a$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (p === (0, $1a55656020b89c3a$export$2eb8634622ddeab7)) return transfer === (0, $1a55656020b89c3a$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (p === (0, $1a55656020b89c3a$export$202b1ce7b5d25742)) return transfer === (0, $1a55656020b89c3a$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (p === (0, $1a55656020b89c3a$export$18ab77abd087e467)) return transfer === (0, $1a55656020b89c3a$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;
            } else return null;
        }
        // BPTC
        if (p === (0, $1a55656020b89c3a$export$ce40b115e188bc81) || p === (0, $1a55656020b89c3a$export$d279c5c4bac5121e) || p === (0, $1a55656020b89c3a$export$cde52d17225fdbd3)) {
            extension = extensions.get('EXT_texture_compression_bptc');
            if (extension !== null) {
                if (p === (0, $1a55656020b89c3a$export$ce40b115e188bc81)) return transfer === (0, $1a55656020b89c3a$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
                if (p === (0, $1a55656020b89c3a$export$d279c5c4bac5121e)) return extension.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
                if (p === (0, $1a55656020b89c3a$export$cde52d17225fdbd3)) return extension.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
            } else return null;
        }
        // RGTC
        if (p === (0, $1a55656020b89c3a$export$b1688df4c4c21670) || p === (0, $1a55656020b89c3a$export$fc15e5d8261eed58) || p === (0, $1a55656020b89c3a$export$d220f6ade8463a0f) || p === (0, $1a55656020b89c3a$export$768646d09dc1b6ef)) {
            extension = extensions.get('EXT_texture_compression_rgtc');
            if (extension !== null) {
                if (p === (0, $1a55656020b89c3a$export$ce40b115e188bc81)) return extension.COMPRESSED_RED_RGTC1_EXT;
                if (p === (0, $1a55656020b89c3a$export$fc15e5d8261eed58)) return extension.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                if (p === (0, $1a55656020b89c3a$export$d220f6ade8463a0f)) return extension.COMPRESSED_RED_GREEN_RGTC2_EXT;
                if (p === (0, $1a55656020b89c3a$export$768646d09dc1b6ef)) return extension.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
            } else return null;
        }
        //
        if (p === (0, $1a55656020b89c3a$export$6c8ea339bfab1301)) return gl.UNSIGNED_INT_24_8;
        // if "p" can't be resolved, assume the user defines a WebGL constant as a string (fallback/workaround for packed RGB formats)
        return gl[p] !== undefined ? gl[p] : null;
    }
    return {
        convert: convert
    };
}
var $079becb54c0579a9$var$_occlusion_vertex = "\nvoid main() {\n\n	gl_Position = vec4( position, 1.0 );\n\n}";
var $079becb54c0579a9$var$_occlusion_fragment = "\nuniform sampler2DArray depthColor;\nuniform float depthWidth;\nuniform float depthHeight;\n\nvoid main() {\n\n	vec2 coord = vec2( gl_FragCoord.x / depthWidth, gl_FragCoord.y / depthHeight );\n\n	if ( coord.x >= 1.0 ) {\n\n		gl_FragDepth = texture( depthColor, vec3( coord.x - 1.0, coord.y, 1 ) ).r;\n\n	} else {\n\n		gl_FragDepth = texture( depthColor, vec3( coord.x, coord.y, 0 ) ).r;\n\n	}\n\n}";
var $079becb54c0579a9$var$WebXRDepthSensing = /*#__PURE__*/ function() {
    "use strict";
    function WebXRDepthSensing() {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, WebXRDepthSensing);
        this.texture = null;
        this.mesh = null;
        this.depthNear = 0;
        this.depthFar = 0;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(WebXRDepthSensing, [
        {
            key: "init",
            value: function init(renderer, depthData, renderState) {
                if (this.texture === null) {
                    var texture = new (0, $1a55656020b89c3a$export$5431306cf43de24a)();
                    var texProps = renderer.properties.get(texture);
                    texProps.__webglTexture = depthData.texture;
                    if (depthData.depthNear !== renderState.depthNear || depthData.depthFar !== renderState.depthFar) {
                        this.depthNear = depthData.depthNear;
                        this.depthFar = depthData.depthFar;
                    }
                    this.texture = texture;
                }
            }
        },
        {
            key: "getMesh",
            value: function getMesh(cameraXR) {
                if (this.texture !== null) {
                    if (this.mesh === null) {
                        var viewport = cameraXR.cameras[0].viewport;
                        var material = new (0, $1a55656020b89c3a$export$83c7d75d550a8b0d)({
                            vertexShader: $079becb54c0579a9$var$_occlusion_vertex,
                            fragmentShader: $079becb54c0579a9$var$_occlusion_fragment,
                            uniforms: {
                                depthColor: {
                                    value: this.texture
                                },
                                depthWidth: {
                                    value: viewport.z
                                },
                                depthHeight: {
                                    value: viewport.w
                                }
                            }
                        });
                        this.mesh = new (0, $1a55656020b89c3a$export$e176487c05830cc5)(new (0, $1a55656020b89c3a$export$967d831af31f69ce)(20, 20), material);
                    }
                }
                return this.mesh;
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.texture = null;
                this.mesh = null;
            }
        },
        {
            key: "getDepthTexture",
            value: function getDepthTexture() {
                return this.texture;
            }
        }
    ]);
    return WebXRDepthSensing;
}();
var $079becb54c0579a9$var$WebXRManager = /*#__PURE__*/ function(EventDispatcher) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(WebXRManager, EventDispatcher);
    function WebXRManager(renderer, gl) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, WebXRManager);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, WebXRManager);
        var scope = _this;
        var session = null;
        var framebufferScaleFactor = 1.0;
        var referenceSpace = null;
        var referenceSpaceType = 'local-floor';
        // Set default foveation to maximum.
        var foveation = 1.0;
        var customReferenceSpace = null;
        var pose = null;
        var glBinding = null;
        var glProjLayer = null;
        var glBaseLayer = null;
        var xrFrame = null;
        var depthSensing = new $079becb54c0579a9$var$WebXRDepthSensing();
        var attributes = gl.getContextAttributes();
        var initialRenderTarget = null;
        var newRenderTarget = null;
        var controllers = [];
        var controllerInputSources = [];
        var currentSize = new (0, $1a55656020b89c3a$export$c977b3e384af9ae1)();
        var currentPixelRatio = null;
        //
        var cameraL = new (0, $1a55656020b89c3a$export$74e4ae24825f68d7)();
        cameraL.viewport = new (0, $1a55656020b89c3a$export$fa7daccca11cdbe3)();
        var cameraR = new (0, $1a55656020b89c3a$export$74e4ae24825f68d7)();
        cameraR.viewport = new (0, $1a55656020b89c3a$export$fa7daccca11cdbe3)();
        var cameras = [
            cameraL,
            cameraR
        ];
        var cameraXR = new (0, $1a55656020b89c3a$export$56b937d9e5581166)();
        var _currentDepthNear = null;
        var _currentDepthFar = null;
        //
        _this.cameraAutoUpdate = true;
        _this.enabled = false;
        _this.isPresenting = false;
        _this.getController = function(index) {
            var controller = controllers[index];
            if (controller === undefined) {
                controller = new (0, $1a55656020b89c3a$export$cb626c57dcc48b9f)();
                controllers[index] = controller;
            }
            return controller.getTargetRaySpace();
        };
        _this.getControllerGrip = function(index) {
            var controller = controllers[index];
            if (controller === undefined) {
                controller = new (0, $1a55656020b89c3a$export$cb626c57dcc48b9f)();
                controllers[index] = controller;
            }
            return controller.getGripSpace();
        };
        _this.getHand = function(index) {
            var controller = controllers[index];
            if (controller === undefined) {
                controller = new (0, $1a55656020b89c3a$export$cb626c57dcc48b9f)();
                controllers[index] = controller;
            }
            return controller.getHandSpace();
        };
        //
        function onSessionEvent(event) {
            var controllerIndex = controllerInputSources.indexOf(event.inputSource);
            if (controllerIndex === -1) return;
            var controller = controllers[controllerIndex];
            if (controller !== undefined) {
                controller.update(event.inputSource, event.frame, customReferenceSpace || referenceSpace);
                controller.dispatchEvent({
                    type: event.type,
                    data: event.inputSource
                });
            }
        }
        function onSessionEnd() {
            session.removeEventListener('select', onSessionEvent);
            session.removeEventListener('selectstart', onSessionEvent);
            session.removeEventListener('selectend', onSessionEvent);
            session.removeEventListener('squeeze', onSessionEvent);
            session.removeEventListener('squeezestart', onSessionEvent);
            session.removeEventListener('squeezeend', onSessionEvent);
            session.removeEventListener('end', onSessionEnd);
            session.removeEventListener('inputsourceschange', onInputSourcesChange);
            for(var i = 0; i < controllers.length; i++){
                var inputSource = controllerInputSources[i];
                if (inputSource === null) continue;
                controllerInputSources[i] = null;
                controllers[i].disconnect(inputSource);
            }
            _currentDepthNear = null;
            _currentDepthFar = null;
            depthSensing.reset();
            // restore framebuffer/rendering state
            renderer.setRenderTarget(initialRenderTarget);
            glBaseLayer = null;
            glProjLayer = null;
            glBinding = null;
            session = null;
            newRenderTarget = null;
            //
            animation.stop();
            scope.isPresenting = false;
            renderer.setPixelRatio(currentPixelRatio);
            renderer.setSize(currentSize.width, currentSize.height, false);
            scope.dispatchEvent({
                type: 'sessionend'
            });
        }
        _this.setFramebufferScaleFactor = function(value) {
            framebufferScaleFactor = value;
            if (scope.isPresenting === true) console.warn('THREE.WebXRManager: Cannot change framebuffer scale while presenting.');
        };
        _this.setReferenceSpaceType = function(value) {
            referenceSpaceType = value;
            if (scope.isPresenting === true) console.warn('THREE.WebXRManager: Cannot change reference space type while presenting.');
        };
        _this.getReferenceSpace = function() {
            return customReferenceSpace || referenceSpace;
        };
        _this.setReferenceSpace = function(space) {
            customReferenceSpace = space;
        };
        _this.getBaseLayer = function() {
            return glProjLayer !== null ? glProjLayer : glBaseLayer;
        };
        _this.getBinding = function() {
            return glBinding;
        };
        _this.getFrame = function() {
            return xrFrame;
        };
        _this.getSession = function() {
            return session;
        };
        _this.setSession = /*#__PURE__*/ function() {
            var _ref = (0, $5941428b630ec017$export$71511d61b312f219)(function(value) {
                var useLayers, layerInit, depthFormat, depthType, glDepthFormat, projectionlayerInit;
                return (0, $353b713f9392bb93$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            session = value;
                            if (!(session !== null)) return [
                                3,
                                4
                            ];
                            initialRenderTarget = renderer.getRenderTarget();
                            session.addEventListener('select', onSessionEvent);
                            session.addEventListener('selectstart', onSessionEvent);
                            session.addEventListener('selectend', onSessionEvent);
                            session.addEventListener('squeeze', onSessionEvent);
                            session.addEventListener('squeezestart', onSessionEvent);
                            session.addEventListener('squeezeend', onSessionEvent);
                            session.addEventListener('end', onSessionEnd);
                            session.addEventListener('inputsourceschange', onInputSourcesChange);
                            if (!(attributes.xrCompatible !== true)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                gl.makeXRCompatible()
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            currentPixelRatio = renderer.getPixelRatio();
                            renderer.getSize(currentSize);
                            // Check that the browser implements the necessary APIs to use an
                            // XRProjectionLayer rather than an XRWebGLLayer
                            useLayers = typeof XRWebGLBinding !== 'undefined' && 'createProjectionLayer' in XRWebGLBinding.prototype;
                            if (!useLayers) {
                                layerInit = {
                                    antialias: attributes.antialias,
                                    alpha: true,
                                    depth: attributes.depth,
                                    stencil: attributes.stencil,
                                    framebufferScaleFactor: framebufferScaleFactor
                                };
                                glBaseLayer = new XRWebGLLayer(session, gl, layerInit);
                                session.updateRenderState({
                                    baseLayer: glBaseLayer
                                });
                                renderer.setPixelRatio(1);
                                renderer.setSize(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, false);
                                newRenderTarget = new (0, $1a55656020b89c3a$export$3c052beb2e51e23f)(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, {
                                    format: (0, $1a55656020b89c3a$export$3f8bb04b555a363c),
                                    type: (0, $1a55656020b89c3a$export$2e8ce08d3f6f5e10),
                                    colorSpace: renderer.outputColorSpace,
                                    stencilBuffer: attributes.stencil
                                });
                            } else {
                                depthFormat = null;
                                depthType = null;
                                glDepthFormat = null;
                                if (attributes.depth) {
                                    glDepthFormat = attributes.stencil ? gl.DEPTH24_STENCIL8 : gl.DEPTH_COMPONENT24;
                                    depthFormat = attributes.stencil ? (0, $1a55656020b89c3a$export$1e113ac2d0905829) : (0, $1a55656020b89c3a$export$c1b6b5136be58045);
                                    depthType = attributes.stencil ? (0, $1a55656020b89c3a$export$6c8ea339bfab1301) : (0, $1a55656020b89c3a$export$c3c7fc4518ebba96);
                                }
                                projectionlayerInit = {
                                    colorFormat: gl.RGBA8,
                                    depthFormat: glDepthFormat,
                                    scaleFactor: framebufferScaleFactor
                                };
                                glBinding = new XRWebGLBinding(session, gl);
                                glProjLayer = glBinding.createProjectionLayer(projectionlayerInit);
                                session.updateRenderState({
                                    layers: [
                                        glProjLayer
                                    ]
                                });
                                renderer.setPixelRatio(1);
                                renderer.setSize(glProjLayer.textureWidth, glProjLayer.textureHeight, false);
                                newRenderTarget = new (0, $1a55656020b89c3a$export$3c052beb2e51e23f)(glProjLayer.textureWidth, glProjLayer.textureHeight, {
                                    format: (0, $1a55656020b89c3a$export$3f8bb04b555a363c),
                                    type: (0, $1a55656020b89c3a$export$2e8ce08d3f6f5e10),
                                    depthTexture: new (0, $1a55656020b89c3a$export$fc830aa069cc8c2f)(glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, undefined, undefined, undefined, undefined, undefined, undefined, depthFormat),
                                    stencilBuffer: attributes.stencil,
                                    colorSpace: renderer.outputColorSpace,
                                    samples: attributes.antialias ? 4 : 0,
                                    resolveDepthBuffer: glProjLayer.ignoreDepthValues === false
                                });
                            }
                            newRenderTarget.isXRRenderTarget = true; // TODO Remove this when possible, see #23278
                            this.setFoveation(foveation);
                            customReferenceSpace = null;
                            return [
                                4,
                                session.requestReferenceSpace(referenceSpaceType)
                            ];
                        case 3:
                            referenceSpace = _state.sent();
                            animation.setContext(session);
                            animation.start();
                            scope.isPresenting = true;
                            scope.dispatchEvent({
                                type: 'sessionstart'
                            });
                            _state.label = 4;
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(value) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.getEnvironmentBlendMode = function() {
            if (session !== null) return session.environmentBlendMode;
        };
        _this.getDepthTexture = function() {
            return depthSensing.getDepthTexture();
        };
        function onInputSourcesChange(event) {
            // Notify disconnected
            for(var i = 0; i < event.removed.length; i++){
                var inputSource = event.removed[i];
                var index = controllerInputSources.indexOf(inputSource);
                if (index >= 0) {
                    controllerInputSources[index] = null;
                    controllers[index].disconnect(inputSource);
                }
            }
            // Notify connected
            for(var i1 = 0; i1 < event.added.length; i1++){
                var inputSource1 = event.added[i1];
                var controllerIndex = controllerInputSources.indexOf(inputSource1);
                if (controllerIndex === -1) {
                    // Assign input source a controller that currently has no input source
                    for(var i2 = 0; i2 < controllers.length; i2++){
                        if (i2 >= controllerInputSources.length) {
                            controllerInputSources.push(inputSource1);
                            controllerIndex = i2;
                            break;
                        } else if (controllerInputSources[i2] === null) {
                            controllerInputSources[i2] = inputSource1;
                            controllerIndex = i2;
                            break;
                        }
                    }
                    // If all controllers do currently receive input we ignore new ones
                    if (controllerIndex === -1) break;
                }
                var controller = controllers[controllerIndex];
                if (controller) controller.connect(inputSource1);
            }
        }
        //
        var cameraLPos = new (0, $1a55656020b89c3a$export$64b5c384219d3699)();
        var cameraRPos = new (0, $1a55656020b89c3a$export$64b5c384219d3699)();
        /**
		 * Assumes 2 cameras that are parallel and share an X-axis, and that
		 * the cameras' projection and world matrices have already been set.
		 * And that near and far planes are identical for both cameras.
		 * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
		 *
		 * @param {ArrayCamera} camera - The camera to update.
		 * @param {PerspectiveCamera} cameraL - The left camera.
		 * @param {PerspectiveCamera} cameraR - The right camera.
		 */ function setProjectionFromUnion(camera, cameraL, cameraR) {
            cameraLPos.setFromMatrixPosition(cameraL.matrixWorld);
            cameraRPos.setFromMatrixPosition(cameraR.matrixWorld);
            var ipd = cameraLPos.distanceTo(cameraRPos);
            var projL = cameraL.projectionMatrix.elements;
            var projR = cameraR.projectionMatrix.elements;
            // VR systems will have identical far and near planes, and
            // most likely identical top and bottom frustum extents.
            // Use the left camera for these values.
            var near = projL[14] / (projL[10] - 1);
            var far = projL[14] / (projL[10] + 1);
            var topFov = (projL[9] + 1) / projL[5];
            var bottomFov = (projL[9] - 1) / projL[5];
            var leftFov = (projL[8] - 1) / projL[0];
            var rightFov = (projR[8] + 1) / projR[0];
            var left = near * leftFov;
            var right = near * rightFov;
            // Calculate the new camera's position offset from the
            // left camera. xOffset should be roughly half `ipd`.
            var zOffset = ipd / (-leftFov + rightFov);
            var xOffset = zOffset * -leftFov;
            // TODO: Better way to apply this offset?
            cameraL.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
            camera.translateX(xOffset);
            camera.translateZ(zOffset);
            camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
            // Check if the projection uses an infinite far plane.
            if (projL[10] === -1) {
                // Use the projection matrix from the left eye.
                // The camera offset is sufficient to include the view volumes
                // of both eyes (assuming symmetric projections).
                camera.projectionMatrix.copy(cameraL.projectionMatrix);
                camera.projectionMatrixInverse.copy(cameraL.projectionMatrixInverse);
            } else {
                // Find the union of the frustum values of the cameras and scale
                // the values so that the near plane's position does not change in world space,
                // although must now be relative to the new union camera.
                var near2 = near + zOffset;
                var far2 = far + zOffset;
                var left2 = left - xOffset;
                var right2 = right + (ipd - xOffset);
                var top2 = topFov * far / far2 * near2;
                var bottom2 = bottomFov * far / far2 * near2;
                camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
                camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
            }
        }
        function updateCamera(camera, parent) {
            if (parent === null) camera.matrixWorld.copy(camera.matrix);
            else camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
        }
        _this.updateCamera = function(camera) {
            if (session === null) return;
            var depthNear = camera.near;
            var depthFar = camera.far;
            if (depthSensing.texture !== null) {
                if (depthSensing.depthNear > 0) depthNear = depthSensing.depthNear;
                if (depthSensing.depthFar > 0) depthFar = depthSensing.depthFar;
            }
            cameraXR.near = cameraR.near = cameraL.near = depthNear;
            cameraXR.far = cameraR.far = cameraL.far = depthFar;
            if (_currentDepthNear !== cameraXR.near || _currentDepthFar !== cameraXR.far) {
                // Note that the new renderState won't apply until the next frame. See #18320
                session.updateRenderState({
                    depthNear: cameraXR.near,
                    depthFar: cameraXR.far
                });
                _currentDepthNear = cameraXR.near;
                _currentDepthFar = cameraXR.far;
            }
            cameraL.layers.mask = camera.layers.mask | 2;
            cameraR.layers.mask = camera.layers.mask | 4;
            cameraXR.layers.mask = cameraL.layers.mask | cameraR.layers.mask;
            var parent = camera.parent;
            var cameras = cameraXR.cameras;
            updateCamera(cameraXR, parent);
            for(var i = 0; i < cameras.length; i++)updateCamera(cameras[i], parent);
            // update projection matrix for proper view frustum culling
            if (cameras.length === 2) setProjectionFromUnion(cameraXR, cameraL, cameraR);
            else // assume single camera setup (AR)
            cameraXR.projectionMatrix.copy(cameraL.projectionMatrix);
            // update user camera and its children
            updateUserCamera(camera, cameraXR, parent);
        };
        function updateUserCamera(camera, cameraXR, parent) {
            if (parent === null) camera.matrix.copy(cameraXR.matrixWorld);
            else {
                camera.matrix.copy(parent.matrixWorld);
                camera.matrix.invert();
                camera.matrix.multiply(cameraXR.matrixWorld);
            }
            camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
            camera.updateMatrixWorld(true);
            camera.projectionMatrix.copy(cameraXR.projectionMatrix);
            camera.projectionMatrixInverse.copy(cameraXR.projectionMatrixInverse);
            if (camera.isPerspectiveCamera) {
                camera.fov = (0, $1a55656020b89c3a$export$914076c8150813e5) * 2 * Math.atan(1 / camera.projectionMatrix.elements[5]);
                camera.zoom = 1;
            }
        }
        _this.getCamera = function() {
            return cameraXR;
        };
        _this.getFoveation = function() {
            if (glProjLayer === null && glBaseLayer === null) return undefined;
            return foveation;
        };
        _this.setFoveation = function(value) {
            // 0 = no foveation = full resolution
            // 1 = maximum foveation = the edges render at lower resolution
            foveation = value;
            if (glProjLayer !== null) glProjLayer.fixedFoveation = value;
            if (glBaseLayer !== null && glBaseLayer.fixedFoveation !== undefined) glBaseLayer.fixedFoveation = value;
        };
        _this.hasDepthSensing = function() {
            return depthSensing.texture !== null;
        };
        _this.getDepthSensingMesh = function() {
            return depthSensing.getMesh(cameraXR);
        };
        // Animation Loop
        var onAnimationFrameCallback = null;
        function onAnimationFrame(time, frame) {
            pose = frame.getViewerPose(customReferenceSpace || referenceSpace);
            xrFrame = frame;
            if (pose !== null) {
                var views = pose.views;
                if (glBaseLayer !== null) {
                    renderer.setRenderTargetFramebuffer(newRenderTarget, glBaseLayer.framebuffer);
                    renderer.setRenderTarget(newRenderTarget);
                }
                var cameraXRNeedsUpdate = false;
                // check if it's necessary to rebuild cameraXR's camera list
                if (views.length !== cameraXR.cameras.length) {
                    cameraXR.cameras.length = 0;
                    cameraXRNeedsUpdate = true;
                }
                for(var i = 0; i < views.length; i++){
                    var view = views[i];
                    var viewport = null;
                    if (glBaseLayer !== null) viewport = glBaseLayer.getViewport(view);
                    else {
                        var glSubImage = glBinding.getViewSubImage(glProjLayer, view);
                        viewport = glSubImage.viewport;
                        // For side-by-side projection, we only produce a single texture for both eyes.
                        if (i === 0) {
                            renderer.setRenderTargetTextures(newRenderTarget, glSubImage.colorTexture, glProjLayer.ignoreDepthValues ? undefined : glSubImage.depthStencilTexture);
                            renderer.setRenderTarget(newRenderTarget);
                        }
                    }
                    var camera = cameras[i];
                    if (camera === undefined) {
                        camera = new (0, $1a55656020b89c3a$export$74e4ae24825f68d7)();
                        camera.layers.enable(i);
                        camera.viewport = new (0, $1a55656020b89c3a$export$fa7daccca11cdbe3)();
                        cameras[i] = camera;
                    }
                    camera.matrix.fromArray(view.transform.matrix);
                    camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
                    camera.projectionMatrix.fromArray(view.projectionMatrix);
                    camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
                    camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
                    if (i === 0) {
                        cameraXR.matrix.copy(camera.matrix);
                        cameraXR.matrix.decompose(cameraXR.position, cameraXR.quaternion, cameraXR.scale);
                    }
                    if (cameraXRNeedsUpdate === true) cameraXR.cameras.push(camera);
                }
                //
                var enabledFeatures = session.enabledFeatures;
                var gpuDepthSensingEnabled = enabledFeatures && enabledFeatures.includes('depth-sensing') && session.depthUsage == 'gpu-optimized';
                if (gpuDepthSensingEnabled && glBinding) {
                    var depthData = glBinding.getDepthInformation(views[0]);
                    if (depthData && depthData.isValid && depthData.texture) depthSensing.init(renderer, depthData, session.renderState);
                }
            }
            //
            for(var i1 = 0; i1 < controllers.length; i1++){
                var inputSource = controllerInputSources[i1];
                var controller = controllers[i1];
                if (inputSource !== null && controller !== undefined) controller.update(inputSource, frame, customReferenceSpace || referenceSpace);
            }
            if (onAnimationFrameCallback) onAnimationFrameCallback(time, frame);
            if (frame.detectedPlanes) scope.dispatchEvent({
                type: 'planesdetected',
                data: frame
            });
            xrFrame = null;
        }
        var animation = new $079becb54c0579a9$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        _this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
        };
        _this.dispose = function() {};
        return _this;
    }
    return WebXRManager;
}((0, $1a55656020b89c3a$export$ec8b666c5fe2c75a));
var $079becb54c0579a9$var$_e1 = /*@__PURE__*/ new (0, $1a55656020b89c3a$export$d93cc409a0768c5f)();
var $079becb54c0579a9$var$_m1 = /*@__PURE__*/ new (0, $1a55656020b89c3a$export$2ae72fc923e5eb5)();
function $079becb54c0579a9$var$WebGLMaterials(renderer, properties) {
    function refreshTransformUniform(map, uniform) {
        if (map.matrixAutoUpdate === true) map.updateMatrix();
        uniform.value.copy(map.matrix);
    }
    function refreshFogUniforms(uniforms, fog) {
        fog.color.getRGB(uniforms.fogColor.value, (0, $1a55656020b89c3a$export$a630742c640528c1)(renderer));
        if (fog.isFog) {
            uniforms.fogNear.value = fog.near;
            uniforms.fogFar.value = fog.far;
        } else if (fog.isFogExp2) uniforms.fogDensity.value = fog.density;
    }
    function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {
        if (material.isMeshBasicMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshLambertMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshToonMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsToon(uniforms, material);
        } else if (material.isMeshPhongMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsPhong(uniforms, material);
        } else if (material.isMeshStandardMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsStandard(uniforms, material);
            if (material.isMeshPhysicalMaterial) refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
        } else if (material.isMeshMatcapMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsMatcap(uniforms, material);
        } else if (material.isMeshDepthMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshDistanceMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsDistance(uniforms, material);
        } else if (material.isMeshNormalMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isLineBasicMaterial) {
            refreshUniformsLine(uniforms, material);
            if (material.isLineDashedMaterial) refreshUniformsDash(uniforms, material);
        } else if (material.isPointsMaterial) refreshUniformsPoints(uniforms, material, pixelRatio, height);
        else if (material.isSpriteMaterial) refreshUniformsSprites(uniforms, material);
        else if (material.isShadowMaterial) {
            uniforms.color.value.copy(material.color);
            uniforms.opacity.value = material.opacity;
        } else if (material.isShaderMaterial) material.uniformsNeedUpdate = false; // #15581
    }
    function refreshUniformsCommon(uniforms, material) {
        uniforms.opacity.value = material.opacity;
        if (material.color) uniforms.diffuse.value.copy(material.color);
        if (material.emissive) uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            refreshTransformUniform(material.bumpMap, uniforms.bumpMapTransform);
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === (0, $1a55656020b89c3a$export$d9f0486e75b5ace)) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            refreshTransformUniform(material.normalMap, uniforms.normalMapTransform);
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === (0, $1a55656020b89c3a$export$d9f0486e75b5ace)) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            refreshTransformUniform(material.displacementMap, uniforms.displacementMapTransform);
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
        if (material.emissiveMap) {
            uniforms.emissiveMap.value = material.emissiveMap;
            refreshTransformUniform(material.emissiveMap, uniforms.emissiveMapTransform);
        }
        if (material.specularMap) {
            uniforms.specularMap.value = material.specularMap;
            refreshTransformUniform(material.specularMap, uniforms.specularMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
        var materialProperties = properties.get(material);
        var envMap = materialProperties.envMap;
        var envMapRotation = materialProperties.envMapRotation;
        if (envMap) {
            uniforms.envMap.value = envMap;
            $079becb54c0579a9$var$_e1.copy(envMapRotation);
            // accommodate left-handed frame
            $079becb54c0579a9$var$_e1.x *= -1;
            $079becb54c0579a9$var$_e1.y *= -1;
            $079becb54c0579a9$var$_e1.z *= -1;
            if (envMap.isCubeTexture && envMap.isRenderTargetTexture === false) {
                // environment maps which are not cube render targets or PMREMs follow a different convention
                $079becb54c0579a9$var$_e1.y *= -1;
                $079becb54c0579a9$var$_e1.z *= -1;
            }
            uniforms.envMapRotation.value.setFromMatrix4($079becb54c0579a9$var$_m1.makeRotationFromEuler($079becb54c0579a9$var$_e1));
            uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            uniforms.reflectivity.value = material.reflectivity;
            uniforms.ior.value = material.ior;
            uniforms.refractionRatio.value = material.refractionRatio;
        }
        if (material.lightMap) {
            uniforms.lightMap.value = material.lightMap;
            uniforms.lightMapIntensity.value = material.lightMapIntensity;
            refreshTransformUniform(material.lightMap, uniforms.lightMapTransform);
        }
        if (material.aoMap) {
            uniforms.aoMap.value = material.aoMap;
            uniforms.aoMapIntensity.value = material.aoMapIntensity;
            refreshTransformUniform(material.aoMap, uniforms.aoMapTransform);
        }
    }
    function refreshUniformsLine(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
    }
    function refreshUniformsDash(uniforms, material) {
        uniforms.dashSize.value = material.dashSize;
        uniforms.totalSize.value = material.dashSize + material.gapSize;
        uniforms.scale.value = material.scale;
    }
    function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.size.value = material.size * pixelRatio;
        uniforms.scale.value = height * 0.5;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.uvTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsSprites(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.rotation.value = material.rotation;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsPhong(uniforms, material) {
        uniforms.specular.value.copy(material.specular);
        uniforms.shininess.value = Math.max(material.shininess, 1e-4); // to prevent pow( 0.0, 0.0 )
    }
    function refreshUniformsToon(uniforms, material) {
        if (material.gradientMap) uniforms.gradientMap.value = material.gradientMap;
    }
    function refreshUniformsStandard(uniforms, material) {
        uniforms.metalness.value = material.metalness;
        if (material.metalnessMap) {
            uniforms.metalnessMap.value = material.metalnessMap;
            refreshTransformUniform(material.metalnessMap, uniforms.metalnessMapTransform);
        }
        uniforms.roughness.value = material.roughness;
        if (material.roughnessMap) {
            uniforms.roughnessMap.value = material.roughnessMap;
            refreshTransformUniform(material.roughnessMap, uniforms.roughnessMapTransform);
        }
        if (material.envMap) //uniforms.envMap.value = material.envMap; // part of uniforms common
        uniforms.envMapIntensity.value = material.envMapIntensity;
    }
    function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {
        uniforms.ior.value = material.ior; // also part of uniforms common
        if (material.sheen > 0) {
            uniforms.sheenColor.value.copy(material.sheenColor).multiplyScalar(material.sheen);
            uniforms.sheenRoughness.value = material.sheenRoughness;
            if (material.sheenColorMap) {
                uniforms.sheenColorMap.value = material.sheenColorMap;
                refreshTransformUniform(material.sheenColorMap, uniforms.sheenColorMapTransform);
            }
            if (material.sheenRoughnessMap) {
                uniforms.sheenRoughnessMap.value = material.sheenRoughnessMap;
                refreshTransformUniform(material.sheenRoughnessMap, uniforms.sheenRoughnessMapTransform);
            }
        }
        if (material.clearcoat > 0) {
            uniforms.clearcoat.value = material.clearcoat;
            uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
            if (material.clearcoatMap) {
                uniforms.clearcoatMap.value = material.clearcoatMap;
                refreshTransformUniform(material.clearcoatMap, uniforms.clearcoatMapTransform);
            }
            if (material.clearcoatRoughnessMap) {
                uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
                refreshTransformUniform(material.clearcoatRoughnessMap, uniforms.clearcoatRoughnessMapTransform);
            }
            if (material.clearcoatNormalMap) {
                uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
                refreshTransformUniform(material.clearcoatNormalMap, uniforms.clearcoatNormalMapTransform);
                uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
                if (material.side === (0, $1a55656020b89c3a$export$d9f0486e75b5ace)) uniforms.clearcoatNormalScale.value.negate();
            }
        }
        if (material.dispersion > 0) uniforms.dispersion.value = material.dispersion;
        if (material.iridescence > 0) {
            uniforms.iridescence.value = material.iridescence;
            uniforms.iridescenceIOR.value = material.iridescenceIOR;
            uniforms.iridescenceThicknessMinimum.value = material.iridescenceThicknessRange[0];
            uniforms.iridescenceThicknessMaximum.value = material.iridescenceThicknessRange[1];
            if (material.iridescenceMap) {
                uniforms.iridescenceMap.value = material.iridescenceMap;
                refreshTransformUniform(material.iridescenceMap, uniforms.iridescenceMapTransform);
            }
            if (material.iridescenceThicknessMap) {
                uniforms.iridescenceThicknessMap.value = material.iridescenceThicknessMap;
                refreshTransformUniform(material.iridescenceThicknessMap, uniforms.iridescenceThicknessMapTransform);
            }
        }
        if (material.transmission > 0) {
            uniforms.transmission.value = material.transmission;
            uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
            uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);
            if (material.transmissionMap) {
                uniforms.transmissionMap.value = material.transmissionMap;
                refreshTransformUniform(material.transmissionMap, uniforms.transmissionMapTransform);
            }
            uniforms.thickness.value = material.thickness;
            if (material.thicknessMap) {
                uniforms.thicknessMap.value = material.thicknessMap;
                refreshTransformUniform(material.thicknessMap, uniforms.thicknessMapTransform);
            }
            uniforms.attenuationDistance.value = material.attenuationDistance;
            uniforms.attenuationColor.value.copy(material.attenuationColor);
        }
        if (material.anisotropy > 0) {
            uniforms.anisotropyVector.value.set(material.anisotropy * Math.cos(material.anisotropyRotation), material.anisotropy * Math.sin(material.anisotropyRotation));
            if (material.anisotropyMap) {
                uniforms.anisotropyMap.value = material.anisotropyMap;
                refreshTransformUniform(material.anisotropyMap, uniforms.anisotropyMapTransform);
            }
        }
        uniforms.specularIntensity.value = material.specularIntensity;
        uniforms.specularColor.value.copy(material.specularColor);
        if (material.specularColorMap) {
            uniforms.specularColorMap.value = material.specularColorMap;
            refreshTransformUniform(material.specularColorMap, uniforms.specularColorMapTransform);
        }
        if (material.specularIntensityMap) {
            uniforms.specularIntensityMap.value = material.specularIntensityMap;
            refreshTransformUniform(material.specularIntensityMap, uniforms.specularIntensityMapTransform);
        }
    }
    function refreshUniformsMatcap(uniforms, material) {
        if (material.matcap) uniforms.matcap.value = material.matcap;
    }
    function refreshUniformsDistance(uniforms, material) {
        var light = properties.get(material).light;
        uniforms.referencePosition.value.setFromMatrixPosition(light.matrixWorld);
        uniforms.nearDistance.value = light.shadow.camera.near;
        uniforms.farDistance.value = light.shadow.camera.far;
    }
    return {
        refreshFogUniforms: refreshFogUniforms,
        refreshMaterialUniforms: refreshMaterialUniforms
    };
}
function $079becb54c0579a9$var$WebGLUniformsGroups(gl, info, capabilities, state) {
    var buffers = {};
    var updateList = {};
    var allocatedBindingPoints = [];
    var maxBindingPoints = gl.getParameter(gl.MAX_UNIFORM_BUFFER_BINDINGS); // binding points are global whereas block indices are per shader program
    function bind(uniformsGroup, program) {
        var webglProgram = program.program;
        state.uniformBlockBinding(uniformsGroup, webglProgram);
    }
    function update(uniformsGroup, program) {
        var buffer = buffers[uniformsGroup.id];
        if (buffer === undefined) {
            prepareUniformsGroup(uniformsGroup);
            buffer = createBuffer(uniformsGroup);
            buffers[uniformsGroup.id] = buffer;
            uniformsGroup.addEventListener('dispose', onUniformsGroupsDispose);
        }
        // ensure to update the binding points/block indices mapping for this program
        var webglProgram = program.program;
        state.updateUBOMapping(uniformsGroup, webglProgram);
        // update UBO once per frame
        var frame = info.render.frame;
        if (updateList[uniformsGroup.id] !== frame) {
            updateBufferData(uniformsGroup);
            updateList[uniformsGroup.id] = frame;
        }
    }
    function createBuffer(uniformsGroup) {
        // the setup of an UBO is independent of a particular shader program but global
        var bindingPointIndex = allocateBindingPointIndex();
        uniformsGroup.__bindingPointIndex = bindingPointIndex;
        var buffer = gl.createBuffer();
        var size = uniformsGroup.__size;
        var usage = uniformsGroup.usage;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        gl.bufferData(gl.UNIFORM_BUFFER, size, usage);
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
        gl.bindBufferBase(gl.UNIFORM_BUFFER, bindingPointIndex, buffer);
        return buffer;
    }
    function allocateBindingPointIndex() {
        for(var i = 0; i < maxBindingPoints; i++)if (allocatedBindingPoints.indexOf(i) === -1) {
            allocatedBindingPoints.push(i);
            return i;
        }
        console.error('THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached.');
        return 0;
    }
    function updateBufferData(uniformsGroup) {
        var buffer = buffers[uniformsGroup.id];
        var uniforms = uniformsGroup.uniforms;
        var cache = uniformsGroup.__cache;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        for(var i = 0, il = uniforms.length; i < il; i++){
            var uniformArray = Array.isArray(uniforms[i]) ? uniforms[i] : [
                uniforms[i]
            ];
            for(var j = 0, jl = uniformArray.length; j < jl; j++){
                var uniform = uniformArray[j];
                if (hasUniformChanged(uniform, i, j, cache) === true) {
                    var offset = uniform.__offset;
                    var values = Array.isArray(uniform.value) ? uniform.value : [
                        uniform.value
                    ];
                    var arrayOffset = 0;
                    for(var k = 0; k < values.length; k++){
                        var value = values[k];
                        var info = getUniformSize(value);
                        // TODO add integer and struct support
                        if (typeof value === 'number' || typeof value === 'boolean') {
                            uniform.__data[0] = value;
                            gl.bufferSubData(gl.UNIFORM_BUFFER, offset + arrayOffset, uniform.__data);
                        } else if (value.isMatrix3) {
                            // manually converting 3x3 to 3x4
                            uniform.__data[0] = value.elements[0];
                            uniform.__data[1] = value.elements[1];
                            uniform.__data[2] = value.elements[2];
                            uniform.__data[3] = 0;
                            uniform.__data[4] = value.elements[3];
                            uniform.__data[5] = value.elements[4];
                            uniform.__data[6] = value.elements[5];
                            uniform.__data[7] = 0;
                            uniform.__data[8] = value.elements[6];
                            uniform.__data[9] = value.elements[7];
                            uniform.__data[10] = value.elements[8];
                            uniform.__data[11] = 0;
                        } else {
                            value.toArray(uniform.__data, arrayOffset);
                            arrayOffset += info.storage / Float32Array.BYTES_PER_ELEMENT;
                        }
                    }
                    gl.bufferSubData(gl.UNIFORM_BUFFER, offset, uniform.__data);
                }
            }
        }
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
    }
    function hasUniformChanged(uniform, index, indexArray, cache) {
        var value = uniform.value;
        var indexString = index + '_' + indexArray;
        if (cache[indexString] === undefined) {
            // cache entry does not exist so far
            if (typeof value === 'number' || typeof value === 'boolean') cache[indexString] = value;
            else cache[indexString] = value.clone();
            return true;
        } else {
            var cachedObject = cache[indexString];
            // compare current value with cached entry
            if (typeof value === 'number' || typeof value === 'boolean') {
                if (cachedObject !== value) {
                    cache[indexString] = value;
                    return true;
                }
            } else if (cachedObject.equals(value) === false) {
                cachedObject.copy(value);
                return true;
            }
        }
        return false;
    }
    function prepareUniformsGroup(uniformsGroup) {
        // determine total buffer size according to the STD140 layout
        // Hint: STD140 is the only supported layout in WebGL 2
        var uniforms = uniformsGroup.uniforms;
        var offset = 0; // global buffer offset in bytes
        var chunkSize = 16; // size of a chunk in bytes
        for(var i = 0, l = uniforms.length; i < l; i++){
            var uniformArray = Array.isArray(uniforms[i]) ? uniforms[i] : [
                uniforms[i]
            ];
            for(var j = 0, jl = uniformArray.length; j < jl; j++){
                var uniform = uniformArray[j];
                var values = Array.isArray(uniform.value) ? uniform.value : [
                    uniform.value
                ];
                for(var k = 0, kl = values.length; k < kl; k++){
                    var value = values[k];
                    var info = getUniformSize(value);
                    var chunkOffset = offset % chunkSize; // offset in the current chunk
                    var chunkPadding = chunkOffset % info.boundary; // required padding to match boundary
                    var chunkStart = chunkOffset + chunkPadding; // the start position in the current chunk for the data
                    offset += chunkPadding;
                    // Check for chunk overflow
                    if (chunkStart !== 0 && chunkSize - chunkStart < info.storage) // Add padding and adjust offset
                    offset += chunkSize - chunkStart;
                    // the following two properties will be used for partial buffer updates
                    uniform.__data = new Float32Array(info.storage / Float32Array.BYTES_PER_ELEMENT);
                    uniform.__offset = offset;
                    // Update the global offset
                    offset += info.storage;
                }
            }
        }
        // ensure correct final padding
        var chunkOffset1 = offset % chunkSize;
        if (chunkOffset1 > 0) offset += chunkSize - chunkOffset1;
        //
        uniformsGroup.__size = offset;
        uniformsGroup.__cache = {};
        return this;
    }
    function getUniformSize(value) {
        var info = {
            boundary: 0,
            storage: 0 // bytes
        };
        // determine sizes according to STD140
        if (typeof value === 'number' || typeof value === 'boolean') {
            // float/int/bool
            info.boundary = 4;
            info.storage = 4;
        } else if (value.isVector2) {
            // vec2
            info.boundary = 8;
            info.storage = 8;
        } else if (value.isVector3 || value.isColor) {
            // vec3
            info.boundary = 16;
            info.storage = 12; // evil: vec3 must start on a 16-byte boundary but it only consumes 12 bytes
        } else if (value.isVector4) {
            // vec4
            info.boundary = 16;
            info.storage = 16;
        } else if (value.isMatrix3) {
            // mat3 (in STD140 a 3x3 matrix is represented as 3x4)
            info.boundary = 48;
            info.storage = 48;
        } else if (value.isMatrix4) {
            // mat4
            info.boundary = 64;
            info.storage = 64;
        } else if (value.isTexture) console.warn('THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.');
        else console.warn('THREE.WebGLRenderer: Unsupported uniform value type.', value);
        return info;
    }
    function onUniformsGroupsDispose(event) {
        var uniformsGroup = event.target;
        uniformsGroup.removeEventListener('dispose', onUniformsGroupsDispose);
        var index = allocatedBindingPoints.indexOf(uniformsGroup.__bindingPointIndex);
        allocatedBindingPoints.splice(index, 1);
        gl.deleteBuffer(buffers[uniformsGroup.id]);
        delete buffers[uniformsGroup.id];
        delete updateList[uniformsGroup.id];
    }
    function dispose() {
        for(var id in buffers)gl.deleteBuffer(buffers[id]);
        allocatedBindingPoints = [];
        buffers = {};
        updateList = {};
    }
    return {
        bind: bind,
        update: update,
        dispose: dispose
    };
}
var $079becb54c0579a9$export$f6cc00ef28d7cf97 = /*#__PURE__*/ function() {
    "use strict";
    function WebGLRenderer() {
        var parameters = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, WebGLRenderer);
        var _parameters_canvas = parameters.canvas, canvas = _parameters_canvas === void 0 ? (0, $1a55656020b89c3a$export$1033a2df66368859)() : _parameters_canvas, _parameters_context = parameters.context, context = _parameters_context === void 0 ? null : _parameters_context, _parameters_depth = parameters.depth, depth = _parameters_depth === void 0 ? true : _parameters_depth, _parameters_stencil = parameters.stencil, stencil = _parameters_stencil === void 0 ? false : _parameters_stencil, _parameters_alpha = parameters.alpha, alpha = _parameters_alpha === void 0 ? false : _parameters_alpha, _parameters_antialias = parameters.antialias, antialias = _parameters_antialias === void 0 ? false : _parameters_antialias, _parameters_premultipliedAlpha = parameters.premultipliedAlpha, premultipliedAlpha = _parameters_premultipliedAlpha === void 0 ? true : _parameters_premultipliedAlpha, _parameters_preserveDrawingBuffer = parameters.preserveDrawingBuffer, preserveDrawingBuffer = _parameters_preserveDrawingBuffer === void 0 ? false : _parameters_preserveDrawingBuffer, _parameters_powerPreference = parameters.powerPreference, powerPreference = _parameters_powerPreference === void 0 ? 'default' : _parameters_powerPreference, _parameters_failIfMajorPerformanceCaveat = parameters.failIfMajorPerformanceCaveat, failIfMajorPerformanceCaveat = _parameters_failIfMajorPerformanceCaveat === void 0 ? false : _parameters_failIfMajorPerformanceCaveat, _parameters_reverseDepthBuffer = parameters.reverseDepthBuffer, reverseDepthBuffer = _parameters_reverseDepthBuffer === void 0 ? false : _parameters_reverseDepthBuffer;
        this.isWebGLRenderer = true;
        var _alpha;
        if (context !== null) {
            if (typeof WebGLRenderingContext !== 'undefined' && context instanceof WebGLRenderingContext) throw new Error('THREE.WebGLRenderer: WebGL 1 is not supported since r163.');
            _alpha = context.getContextAttributes().alpha;
        } else _alpha = alpha;
        var uintClearColor = new Uint32Array(4);
        var intClearColor = new Int32Array(4);
        var currentRenderList = null;
        var currentRenderState = null;
        // render() can be called from within a callback triggered by another render.
        // We track this so that the nested render call gets its list and state isolated from the parent render call.
        var renderListStack = [];
        var renderStateStack = [];
        // public properties
        this.domElement = canvas;
        // Debug configuration container
        this.debug = {
            /**
			 * Enables error checking and reporting when shader programs are being compiled
			 * @type {boolean}
			 */ checkShaderErrors: true,
            /**
			 * Callback for custom error reporting.
			 * @type {?Function}
			 */ onShaderError: null
        };
        // clearing
        this.autoClear = true;
        this.autoClearColor = true;
        this.autoClearDepth = true;
        this.autoClearStencil = true;
        // scene graph
        this.sortObjects = true;
        // user-defined clipping
        this.clippingPlanes = [];
        this.localClippingEnabled = false;
        // physically based shading
        this._outputColorSpace = (0, $1a55656020b89c3a$export$561f394b24edfcaa);
        // tone mapping
        this.toneMapping = (0, $1a55656020b89c3a$export$9fcb6b4294603b2);
        this.toneMappingExposure = 1.0;
        // internal properties
        var _this = this;
        var _isContextLost = false;
        // internal state cache
        var _currentActiveCubeFace = 0;
        var _currentActiveMipmapLevel = 0;
        var _currentRenderTarget = null;
        var _currentMaterialId = -1;
        var _currentCamera = null;
        var _currentViewport = new (0, $1a55656020b89c3a$export$fa7daccca11cdbe3)();
        var _currentScissor = new (0, $1a55656020b89c3a$export$fa7daccca11cdbe3)();
        var _currentScissorTest = null;
        var _currentClearColor = new (0, $1a55656020b89c3a$export$892596cec99bc70e)(0x000000);
        var _currentClearAlpha = 0;
        //
        var _width = canvas.width;
        var _height = canvas.height;
        var _pixelRatio = 1;
        var _opaqueSort = null;
        var _transparentSort = null;
        var _viewport = new (0, $1a55656020b89c3a$export$fa7daccca11cdbe3)(0, 0, _width, _height);
        var _scissor = new (0, $1a55656020b89c3a$export$fa7daccca11cdbe3)(0, 0, _width, _height);
        var _scissorTest = false;
        // frustum
        var _frustum = new (0, $1a55656020b89c3a$export$35efe6f4c85463d2)();
        // clipping
        var _clippingEnabled = false;
        var _localClippingEnabled = false;
        // transmission render target scale
        this.transmissionResolutionScale = 1.0;
        // camera matrices cache
        var _currentProjectionMatrix = new (0, $1a55656020b89c3a$export$2ae72fc923e5eb5)();
        var _projScreenMatrix = new (0, $1a55656020b89c3a$export$2ae72fc923e5eb5)();
        var _vector3 = new (0, $1a55656020b89c3a$export$64b5c384219d3699)();
        var _vector4 = new (0, $1a55656020b89c3a$export$fa7daccca11cdbe3)();
        var _emptyScene = {
            background: null,
            fog: null,
            environment: null,
            overrideMaterial: null,
            isScene: true
        };
        var _renderBackground = false;
        function getTargetPixelRatio() {
            return _currentRenderTarget === null ? _pixelRatio : 1;
        }
        // initialize
        var _gl = context;
        function getContext(contextName, contextAttributes) {
            return canvas.getContext(contextName, contextAttributes);
        }
        try {
            var contextAttributes = {
                alpha: true,
                depth: depth,
                stencil: stencil,
                antialias: antialias,
                premultipliedAlpha: premultipliedAlpha,
                preserveDrawingBuffer: preserveDrawingBuffer,
                powerPreference: powerPreference,
                failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat
            };
            // OffscreenCanvas does not have setAttribute, see #22811
            if ('setAttribute' in canvas) canvas.setAttribute('data-engine', "three.js r".concat((0, $1a55656020b89c3a$export$3545e07a80636437)));
            // event listeners must be registered before WebGL context is created, see #12753
            canvas.addEventListener('webglcontextlost', onContextLost, false);
            canvas.addEventListener('webglcontextrestored', onContextRestore, false);
            canvas.addEventListener('webglcontextcreationerror', onContextCreationError, false);
            if (_gl === null) {
                var contextName = 'webgl2';
                _gl = getContext(contextName, contextAttributes);
                if (_gl === null) {
                    if (getContext(contextName)) throw new Error('Error creating WebGL context with your selected attributes.');
                    else throw new Error('Error creating WebGL context.');
                }
            }
        } catch (error) {
            console.error('THREE.WebGLRenderer: ' + error.message);
            throw error;
        }
        var extensions, capabilities, state, info;
        var properties, textures, cubemaps, cubeuvmaps, attributes, geometries, objects;
        var programCache, materials, renderLists, renderStates, clipping, shadowMap;
        var background, morphtargets, bufferRenderer, indexedBufferRenderer;
        var utils, bindingStates, uniformsGroups;
        function initGLContext() {
            extensions = new $079becb54c0579a9$var$WebGLExtensions(_gl);
            extensions.init();
            utils = new $079becb54c0579a9$export$ddaebcad857649a8(_gl, extensions);
            capabilities = new $079becb54c0579a9$var$WebGLCapabilities(_gl, extensions, parameters, utils);
            state = new $079becb54c0579a9$var$WebGLState(_gl, extensions);
            if (capabilities.reverseDepthBuffer && reverseDepthBuffer) state.buffers.depth.setReversed(true);
            info = new $079becb54c0579a9$var$WebGLInfo(_gl);
            properties = new $079becb54c0579a9$var$WebGLProperties();
            textures = new $079becb54c0579a9$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info);
            cubemaps = new $079becb54c0579a9$var$WebGLCubeMaps(_this);
            cubeuvmaps = new $079becb54c0579a9$var$WebGLCubeUVMaps(_this);
            attributes = new $079becb54c0579a9$var$WebGLAttributes(_gl);
            bindingStates = new $079becb54c0579a9$var$WebGLBindingStates(_gl, attributes);
            geometries = new $079becb54c0579a9$var$WebGLGeometries(_gl, attributes, info, bindingStates);
            objects = new $079becb54c0579a9$var$WebGLObjects(_gl, geometries, attributes, info);
            morphtargets = new $079becb54c0579a9$var$WebGLMorphtargets(_gl, capabilities, textures);
            clipping = new $079becb54c0579a9$var$WebGLClipping(properties);
            programCache = new $079becb54c0579a9$var$WebGLPrograms(_this, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping);
            materials = new $079becb54c0579a9$var$WebGLMaterials(_this, properties);
            renderLists = new $079becb54c0579a9$var$WebGLRenderLists();
            renderStates = new $079becb54c0579a9$var$WebGLRenderStates(extensions);
            background = new $079becb54c0579a9$var$WebGLBackground(_this, cubemaps, cubeuvmaps, state, objects, _alpha, premultipliedAlpha);
            shadowMap = new $079becb54c0579a9$var$WebGLShadowMap(_this, objects, capabilities);
            uniformsGroups = new $079becb54c0579a9$var$WebGLUniformsGroups(_gl, info, capabilities, state);
            bufferRenderer = new $079becb54c0579a9$var$WebGLBufferRenderer(_gl, extensions, info);
            indexedBufferRenderer = new $079becb54c0579a9$var$WebGLIndexedBufferRenderer(_gl, extensions, info);
            info.programs = programCache.programs;
            _this.capabilities = capabilities;
            _this.extensions = extensions;
            _this.properties = properties;
            _this.renderLists = renderLists;
            _this.shadowMap = shadowMap;
            _this.state = state;
            _this.info = info;
        }
        initGLContext();
        // xr
        var xr = new $079becb54c0579a9$var$WebXRManager(_this, _gl);
        this.xr = xr;
        // API
        this.getContext = function() {
            return _gl;
        };
        this.getContextAttributes = function() {
            return _gl.getContextAttributes();
        };
        this.forceContextLoss = function() {
            var extension = extensions.get('WEBGL_lose_context');
            if (extension) extension.loseContext();
        };
        this.forceContextRestore = function() {
            var extension = extensions.get('WEBGL_lose_context');
            if (extension) extension.restoreContext();
        };
        this.getPixelRatio = function() {
            return _pixelRatio;
        };
        this.setPixelRatio = function(value) {
            if (value === undefined) return;
            _pixelRatio = value;
            this.setSize(_width, _height, false);
        };
        this.getSize = function(target) {
            return target.set(_width, _height);
        };
        this.setSize = function(width, height) {
            var updateStyle = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
            if (xr.isPresenting) {
                console.warn('THREE.WebGLRenderer: Can\'t change size while VR device is presenting.');
                return;
            }
            _width = width;
            _height = height;
            canvas.width = Math.floor(width * _pixelRatio);
            canvas.height = Math.floor(height * _pixelRatio);
            if (updateStyle === true) {
                canvas.style.width = width + 'px';
                canvas.style.height = height + 'px';
            }
            this.setViewport(0, 0, width, height);
        };
        this.getDrawingBufferSize = function(target) {
            return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
        };
        this.setDrawingBufferSize = function(width, height, pixelRatio) {
            _width = width;
            _height = height;
            _pixelRatio = pixelRatio;
            canvas.width = Math.floor(width * pixelRatio);
            canvas.height = Math.floor(height * pixelRatio);
            this.setViewport(0, 0, width, height);
        };
        this.getCurrentViewport = function(target) {
            return target.copy(_currentViewport);
        };
        this.getViewport = function(target) {
            return target.copy(_viewport);
        };
        this.setViewport = function(x, y, width, height) {
            if (x.isVector4) _viewport.set(x.x, x.y, x.z, x.w);
            else _viewport.set(x, y, width, height);
            state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).round());
        };
        this.getScissor = function(target) {
            return target.copy(_scissor);
        };
        this.setScissor = function(x, y, width, height) {
            if (x.isVector4) _scissor.set(x.x, x.y, x.z, x.w);
            else _scissor.set(x, y, width, height);
            state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).round());
        };
        this.getScissorTest = function() {
            return _scissorTest;
        };
        this.setScissorTest = function(boolean) {
            state.setScissorTest(_scissorTest = boolean);
        };
        this.setOpaqueSort = function(method) {
            _opaqueSort = method;
        };
        this.setTransparentSort = function(method) {
            _transparentSort = method;
        };
        // Clearing
        this.getClearColor = function(target) {
            return target.copy(background.getClearColor());
        };
        this.setClearColor = function() {
            background.setClearColor.apply(background, arguments);
        };
        this.getClearAlpha = function() {
            return background.getClearAlpha();
        };
        this.setClearAlpha = function() {
            background.setClearAlpha.apply(background, arguments);
        };
        this.clear = function() {
            var color = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, stencil = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
            var bits = 0;
            if (color) {
                // check if we're trying to clear an integer target
                var isIntegerFormat = false;
                if (_currentRenderTarget !== null) {
                    var targetFormat = _currentRenderTarget.texture.format;
                    isIntegerFormat = targetFormat === (0, $1a55656020b89c3a$export$c200e7d26f592f21) || targetFormat === (0, $1a55656020b89c3a$export$1ba1c45f9f77d4d7) || targetFormat === (0, $1a55656020b89c3a$export$aa92e870a709d190);
                }
                // use the appropriate clear functions to clear the target if it's a signed
                // or unsigned integer target
                if (isIntegerFormat) {
                    var targetType = _currentRenderTarget.texture.type;
                    var isUnsignedType = targetType === (0, $1a55656020b89c3a$export$2e8ce08d3f6f5e10) || targetType === (0, $1a55656020b89c3a$export$c3c7fc4518ebba96) || targetType === (0, $1a55656020b89c3a$export$c63dc51868b06a9d) || targetType === (0, $1a55656020b89c3a$export$6c8ea339bfab1301) || targetType === (0, $1a55656020b89c3a$export$b3969b01faf587f2) || targetType === (0, $1a55656020b89c3a$export$18886f8ae33e90de);
                    var clearColor = background.getClearColor();
                    var a = background.getClearAlpha();
                    var r = clearColor.r;
                    var g = clearColor.g;
                    var b = clearColor.b;
                    if (isUnsignedType) {
                        uintClearColor[0] = r;
                        uintClearColor[1] = g;
                        uintClearColor[2] = b;
                        uintClearColor[3] = a;
                        _gl.clearBufferuiv(_gl.COLOR, 0, uintClearColor);
                    } else {
                        intClearColor[0] = r;
                        intClearColor[1] = g;
                        intClearColor[2] = b;
                        intClearColor[3] = a;
                        _gl.clearBufferiv(_gl.COLOR, 0, intClearColor);
                    }
                } else bits |= _gl.COLOR_BUFFER_BIT;
            }
            if (depth) bits |= _gl.DEPTH_BUFFER_BIT;
            if (stencil) {
                bits |= _gl.STENCIL_BUFFER_BIT;
                this.state.buffers.stencil.setMask(0xffffffff);
            }
            _gl.clear(bits);
        };
        this.clearColor = function() {
            this.clear(true, false, false);
        };
        this.clearDepth = function() {
            this.clear(false, true, false);
        };
        this.clearStencil = function() {
            this.clear(false, false, true);
        };
        //
        this.dispose = function() {
            canvas.removeEventListener('webglcontextlost', onContextLost, false);
            canvas.removeEventListener('webglcontextrestored', onContextRestore, false);
            canvas.removeEventListener('webglcontextcreationerror', onContextCreationError, false);
            background.dispose();
            renderLists.dispose();
            renderStates.dispose();
            properties.dispose();
            cubemaps.dispose();
            cubeuvmaps.dispose();
            objects.dispose();
            bindingStates.dispose();
            uniformsGroups.dispose();
            programCache.dispose();
            xr.dispose();
            xr.removeEventListener('sessionstart', onXRSessionStart);
            xr.removeEventListener('sessionend', onXRSessionEnd);
            animation.stop();
        };
        // Events
        function onContextLost(event) {
            event.preventDefault();
            console.log('THREE.WebGLRenderer: Context Lost.');
            _isContextLost = true;
        }
        function onContextRestore() {
            console.log('THREE.WebGLRenderer: Context Restored.');
            _isContextLost = false;
            var infoAutoReset = info.autoReset;
            var shadowMapEnabled = shadowMap.enabled;
            var shadowMapAutoUpdate = shadowMap.autoUpdate;
            var shadowMapNeedsUpdate = shadowMap.needsUpdate;
            var shadowMapType = shadowMap.type;
            initGLContext();
            info.autoReset = infoAutoReset;
            shadowMap.enabled = shadowMapEnabled;
            shadowMap.autoUpdate = shadowMapAutoUpdate;
            shadowMap.needsUpdate = shadowMapNeedsUpdate;
            shadowMap.type = shadowMapType;
        }
        function onContextCreationError(event) {
            console.error('THREE.WebGLRenderer: A WebGL context could not be created. Reason: ', event.statusMessage);
        }
        function onMaterialDispose(event) {
            var material = event.target;
            material.removeEventListener('dispose', onMaterialDispose);
            deallocateMaterial(material);
        }
        // Buffer deallocation
        function deallocateMaterial(material) {
            releaseMaterialProgramReferences(material);
            properties.remove(material);
        }
        function releaseMaterialProgramReferences(material) {
            var programs = properties.get(material).programs;
            if (programs !== undefined) {
                programs.forEach(function(program) {
                    programCache.releaseProgram(program);
                });
                if (material.isShaderMaterial) programCache.releaseShaderCache(material);
            }
        }
        // Buffer rendering
        this.renderBufferDirect = function(camera, scene, geometry, material, object, group) {
            if (scene === null) scene = _emptyScene; // renderBufferDirect second parameter used to be fog (could be null)
            var frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
            var program = setProgram(camera, scene, geometry, material, object);
            state.setMaterial(material, frontFaceCW);
            //
            var index = geometry.index;
            var rangeFactor = 1;
            if (material.wireframe === true) {
                index = geometries.getWireframeAttribute(geometry);
                if (index === undefined) return;
                rangeFactor = 2;
            }
            //
            var drawRange = geometry.drawRange;
            var position = geometry.attributes.position;
            var drawStart = drawRange.start * rangeFactor;
            var drawEnd = (drawRange.start + drawRange.count) * rangeFactor;
            if (group !== null) {
                drawStart = Math.max(drawStart, group.start * rangeFactor);
                drawEnd = Math.min(drawEnd, (group.start + group.count) * rangeFactor);
            }
            if (index !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, index.count);
            } else if (position !== undefined && position !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, position.count);
            }
            var drawCount = drawEnd - drawStart;
            if (drawCount < 0 || drawCount === Infinity) return;
            //
            bindingStates.setup(object, material, program, geometry, index);
            var attribute;
            var renderer = bufferRenderer;
            if (index !== null) {
                attribute = attributes.get(index);
                renderer = indexedBufferRenderer;
                renderer.setIndex(attribute);
            }
            //
            if (object.isMesh) {
                if (material.wireframe === true) {
                    state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
                    renderer.setMode(_gl.LINES);
                } else renderer.setMode(_gl.TRIANGLES);
            } else if (object.isLine) {
                var lineWidth = material.linewidth;
                if (lineWidth === undefined) lineWidth = 1; // Not using Line*Material
                state.setLineWidth(lineWidth * getTargetPixelRatio());
                if (object.isLineSegments) renderer.setMode(_gl.LINES);
                else if (object.isLineLoop) renderer.setMode(_gl.LINE_LOOP);
                else renderer.setMode(_gl.LINE_STRIP);
            } else if (object.isPoints) renderer.setMode(_gl.POINTS);
            else if (object.isSprite) renderer.setMode(_gl.TRIANGLES);
            if (object.isBatchedMesh) {
                if (object._multiDrawInstances !== null) renderer.renderMultiDrawInstances(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount, object._multiDrawInstances);
                else if (!extensions.get('WEBGL_multi_draw')) {
                    var starts = object._multiDrawStarts;
                    var counts = object._multiDrawCounts;
                    var drawCount1 = object._multiDrawCount;
                    var bytesPerElement = index ? attributes.get(index).bytesPerElement : 1;
                    var uniforms = properties.get(material).currentProgram.getUniforms();
                    for(var i = 0; i < drawCount1; i++){
                        uniforms.setValue(_gl, '_gl_DrawID', i);
                        renderer.render(starts[i] / bytesPerElement, counts[i]);
                    }
                } else renderer.renderMultiDraw(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount);
            } else if (object.isInstancedMesh) renderer.renderInstances(drawStart, drawCount, object.count);
            else if (geometry.isInstancedBufferGeometry) {
                var maxInstanceCount = geometry._maxInstanceCount !== undefined ? geometry._maxInstanceCount : Infinity;
                var instanceCount = Math.min(geometry.instanceCount, maxInstanceCount);
                renderer.renderInstances(drawStart, drawCount, instanceCount);
            } else renderer.render(drawStart, drawCount);
        };
        // Compile
        function prepareMaterial(material, scene, object) {
            if (material.transparent === true && material.side === (0, $1a55656020b89c3a$export$3b296b6f144d5b03) && material.forceSinglePass === false) {
                material.side = (0, $1a55656020b89c3a$export$d9f0486e75b5ace);
                material.needsUpdate = true;
                getProgram(material, scene, object);
                material.side = (0, $1a55656020b89c3a$export$2ede184fc2998901);
                material.needsUpdate = true;
                getProgram(material, scene, object);
                material.side = (0, $1a55656020b89c3a$export$3b296b6f144d5b03);
            } else getProgram(material, scene, object);
        }
        this.compile = function(scene, camera) {
            var targetScene = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
            if (targetScene === null) targetScene = scene;
            currentRenderState = renderStates.get(targetScene);
            currentRenderState.init(camera);
            renderStateStack.push(currentRenderState);
            // gather lights from both the target scene and the new object that will be added to the scene.
            targetScene.traverseVisible(function(object) {
                if (object.isLight && object.layers.test(camera.layers)) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                }
            });
            if (scene !== targetScene) scene.traverseVisible(function(object) {
                if (object.isLight && object.layers.test(camera.layers)) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                }
            });
            currentRenderState.setupLights();
            // Only initialize materials in the new scene, not the targetScene.
            var materials = new Set();
            scene.traverse(function(object) {
                if (!(object.isMesh || object.isPoints || object.isLine || object.isSprite)) return;
                var material = object.material;
                if (material) {
                    if (Array.isArray(material)) for(var i = 0; i < material.length; i++){
                        var material2 = material[i];
                        prepareMaterial(material2, targetScene, object);
                        materials.add(material2);
                    }
                    else {
                        prepareMaterial(material, targetScene, object);
                        materials.add(material);
                    }
                }
            });
            renderStateStack.pop();
            currentRenderState = null;
            return materials;
        };
        // compileAsync
        this.compileAsync = function(scene, camera) {
            var targetScene = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
            var materials = this.compile(scene, camera, targetScene);
            // Wait for all the materials in the new object to indicate that they're
            // ready to be used before resolving the promise.
            return new Promise(function(resolve) {
                function checkMaterialsReady() {
                    materials.forEach(function(material) {
                        var materialProperties = properties.get(material);
                        var program = materialProperties.currentProgram;
                        if (program.isReady()) // remove any programs that report they're ready to use from the list
                        materials.delete(material);
                    });
                    // once the list of compiling materials is empty, call the callback
                    if (materials.size === 0) {
                        resolve(scene);
                        return;
                    }
                    // if some materials are still not ready, wait a bit and check again
                    setTimeout(checkMaterialsReady, 10);
                }
                if (extensions.get('KHR_parallel_shader_compile') !== null) // If we can check the compilation status of the materials without
                // blocking then do so right away.
                checkMaterialsReady();
                else // Otherwise start by waiting a bit to give the materials we just
                // initialized a chance to finish.
                setTimeout(checkMaterialsReady, 10);
            });
        };
        // Animation Loop
        var onAnimationFrameCallback = null;
        function onAnimationFrame(time) {
            if (onAnimationFrameCallback) onAnimationFrameCallback(time);
        }
        function onXRSessionStart() {
            animation.stop();
        }
        function onXRSessionEnd() {
            animation.start();
        }
        var animation = new $079becb54c0579a9$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        if (typeof self !== 'undefined') animation.setContext(self);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
            xr.setAnimationLoop(callback);
            callback === null ? animation.stop() : animation.start();
        };
        xr.addEventListener('sessionstart', onXRSessionStart);
        xr.addEventListener('sessionend', onXRSessionEnd);
        // Rendering
        this.render = function(scene, camera) {
            if (camera !== undefined && camera.isCamera !== true) {
                console.error('THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.');
                return;
            }
            if (_isContextLost === true) return;
            // update scene graph
            if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();
            // update camera matrices and frustum
            if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();
            if (xr.enabled === true && xr.isPresenting === true) {
                if (xr.cameraAutoUpdate === true) xr.updateCamera(camera);
                camera = xr.getCamera(); // use XR camera for rendering
            }
            //
            if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);
            currentRenderState = renderStates.get(scene, renderStateStack.length);
            currentRenderState.init(camera);
            renderStateStack.push(currentRenderState);
            _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            _frustum.setFromProjectionMatrix(_projScreenMatrix);
            _localClippingEnabled = this.localClippingEnabled;
            _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled);
            currentRenderList = renderLists.get(scene, renderListStack.length);
            currentRenderList.init();
            renderListStack.push(currentRenderList);
            if (xr.enabled === true && xr.isPresenting === true) {
                var depthSensingMesh = _this.xr.getDepthSensingMesh();
                if (depthSensingMesh !== null) projectObject(depthSensingMesh, camera, -Infinity, _this.sortObjects);
            }
            projectObject(scene, camera, 0, _this.sortObjects);
            currentRenderList.finish();
            if (_this.sortObjects === true) currentRenderList.sort(_opaqueSort, _transparentSort);
            _renderBackground = xr.enabled === false || xr.isPresenting === false || xr.hasDepthSensing() === false;
            if (_renderBackground) background.addToRenderList(currentRenderList, scene);
            //
            this.info.render.frame++;
            if (_clippingEnabled === true) clipping.beginShadows();
            var shadowsArray = currentRenderState.state.shadowsArray;
            shadowMap.render(shadowsArray, scene, camera);
            if (_clippingEnabled === true) clipping.endShadows();
            //
            if (this.info.autoReset === true) this.info.reset();
            // render scene
            var opaqueObjects = currentRenderList.opaque;
            var transmissiveObjects = currentRenderList.transmissive;
            currentRenderState.setupLights();
            if (camera.isArrayCamera) {
                var cameras = camera.cameras;
                if (transmissiveObjects.length > 0) for(var i = 0, l = cameras.length; i < l; i++){
                    var camera2 = cameras[i];
                    renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera2);
                }
                if (_renderBackground) background.render(scene);
                for(var i1 = 0, l1 = cameras.length; i1 < l1; i1++){
                    var camera21 = cameras[i1];
                    renderScene(currentRenderList, scene, camera21, camera21.viewport);
                }
            } else {
                if (transmissiveObjects.length > 0) renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera);
                if (_renderBackground) background.render(scene);
                renderScene(currentRenderList, scene, camera);
            }
            //
            if (_currentRenderTarget !== null && _currentActiveMipmapLevel === 0) {
                // resolve multisample renderbuffers to a single-sample texture if necessary
                textures.updateMultisampleRenderTarget(_currentRenderTarget);
                // Generate mipmap if we're using any kind of mipmap filtering
                textures.updateRenderTargetMipmap(_currentRenderTarget);
            }
            //
            if (scene.isScene === true) scene.onAfterRender(_this, scene, camera);
            // _gl.finish();
            bindingStates.resetDefaultState();
            _currentMaterialId = -1;
            _currentCamera = null;
            renderStateStack.pop();
            if (renderStateStack.length > 0) {
                currentRenderState = renderStateStack[renderStateStack.length - 1];
                if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, currentRenderState.state.camera);
            } else currentRenderState = null;
            renderListStack.pop();
            if (renderListStack.length > 0) currentRenderList = renderListStack[renderListStack.length - 1];
            else currentRenderList = null;
        };
        function projectObject(object, camera, groupOrder, sortObjects) {
            if (object.visible === false) return;
            var visible = object.layers.test(camera.layers);
            if (visible) {
                if (object.isGroup) groupOrder = object.renderOrder;
                else if (object.isLOD) {
                    if (object.autoUpdate === true) object.update(camera);
                } else if (object.isLight) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                } else if (object.isSprite) {
                    if (!object.frustumCulled || _frustum.intersectsSprite(object)) {
                        if (sortObjects) _vector4.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        var geometry = objects.update(object);
                        var material = object.material;
                        if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector4.z, null);
                    }
                } else if (object.isMesh || object.isLine || object.isPoints) {
                    if (!object.frustumCulled || _frustum.intersectsObject(object)) {
                        var geometry1 = objects.update(object);
                        var material1 = object.material;
                        if (sortObjects) {
                            if (object.boundingSphere !== undefined) {
                                if (object.boundingSphere === null) object.computeBoundingSphere();
                                _vector4.copy(object.boundingSphere.center);
                            } else {
                                if (geometry1.boundingSphere === null) geometry1.computeBoundingSphere();
                                _vector4.copy(geometry1.boundingSphere.center);
                            }
                            _vector4.applyMatrix4(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        }
                        if (Array.isArray(material1)) {
                            var groups = geometry1.groups;
                            for(var i = 0, l = groups.length; i < l; i++){
                                var group = groups[i];
                                var groupMaterial = material1[group.materialIndex];
                                if (groupMaterial && groupMaterial.visible) currentRenderList.push(object, geometry1, groupMaterial, groupOrder, _vector4.z, group);
                            }
                        } else if (material1.visible) currentRenderList.push(object, geometry1, material1, groupOrder, _vector4.z, null);
                    }
                }
            }
            var children = object.children;
            for(var i1 = 0, l1 = children.length; i1 < l1; i1++)projectObject(children[i1], camera, groupOrder, sortObjects);
        }
        function renderScene(currentRenderList, scene, camera, viewport) {
            var opaqueObjects = currentRenderList.opaque;
            var transmissiveObjects = currentRenderList.transmissive;
            var transparentObjects = currentRenderList.transparent;
            currentRenderState.setupLightsView(camera);
            if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
            if (viewport) state.viewport(_currentViewport.copy(viewport));
            if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
            if (transmissiveObjects.length > 0) renderObjects(transmissiveObjects, scene, camera);
            if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera);
            // Ensure depth buffer writing is enabled so it can be cleared on next render
            state.buffers.depth.setTest(true);
            state.buffers.depth.setMask(true);
            state.buffers.color.setMask(true);
            state.setPolygonOffset(false);
        }
        function renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera) {
            var overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
            if (overrideMaterial !== null) return;
            if (currentRenderState.state.transmissionRenderTarget[camera.id] === undefined) currentRenderState.state.transmissionRenderTarget[camera.id] = new (0, $1a55656020b89c3a$export$3c052beb2e51e23f)(1, 1, {
                generateMipmaps: true,
                type: extensions.has('EXT_color_buffer_half_float') || extensions.has('EXT_color_buffer_float') ? (0, $1a55656020b89c3a$export$2697304443f382bc) : (0, $1a55656020b89c3a$export$2e8ce08d3f6f5e10),
                minFilter: (0, $1a55656020b89c3a$export$5d8599b6a933fb1b),
                samples: 4,
                stencilBuffer: stencil,
                resolveDepthBuffer: false,
                resolveStencilBuffer: false,
                colorSpace: (0, $1a55656020b89c3a$export$5e6fd513f44698c).workingColorSpace
            });
            var transmissionRenderTarget = currentRenderState.state.transmissionRenderTarget[camera.id];
            var activeViewport = camera.viewport || _currentViewport;
            transmissionRenderTarget.setSize(activeViewport.z * _this.transmissionResolutionScale, activeViewport.w * _this.transmissionResolutionScale);
            //
            var currentRenderTarget = _this.getRenderTarget();
            _this.setRenderTarget(transmissionRenderTarget);
            _this.getClearColor(_currentClearColor);
            _currentClearAlpha = _this.getClearAlpha();
            if (_currentClearAlpha < 1) _this.setClearColor(0xffffff, 0.5);
            _this.clear();
            if (_renderBackground) background.render(scene);
            // Turn off the features which can affect the frag color for opaque objects pass.
            // Otherwise they are applied twice in opaque objects pass and transmission objects pass.
            var currentToneMapping = _this.toneMapping;
            _this.toneMapping = (0, $1a55656020b89c3a$export$9fcb6b4294603b2);
            // Remove viewport from camera to avoid nested render calls resetting viewport to it (e.g Reflector).
            // Transmission render pass requires viewport to match the transmissionRenderTarget.
            var currentCameraViewport = camera.viewport;
            if (camera.viewport !== undefined) camera.viewport = undefined;
            currentRenderState.setupLightsView(camera);
            if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
            renderObjects(opaqueObjects, scene, camera);
            textures.updateMultisampleRenderTarget(transmissionRenderTarget);
            textures.updateRenderTargetMipmap(transmissionRenderTarget);
            if (extensions.has('WEBGL_multisampled_render_to_texture') === false) {
                var renderTargetNeedsUpdate = false;
                for(var i = 0, l = transmissiveObjects.length; i < l; i++){
                    var renderItem = transmissiveObjects[i];
                    var object = renderItem.object;
                    var geometry = renderItem.geometry;
                    var material = renderItem.material;
                    var group = renderItem.group;
                    if (material.side === (0, $1a55656020b89c3a$export$3b296b6f144d5b03) && object.layers.test(camera.layers)) {
                        var currentSide = material.side;
                        material.side = (0, $1a55656020b89c3a$export$d9f0486e75b5ace);
                        material.needsUpdate = true;
                        renderObject(object, scene, camera, geometry, material, group);
                        material.side = currentSide;
                        material.needsUpdate = true;
                        renderTargetNeedsUpdate = true;
                    }
                }
                if (renderTargetNeedsUpdate === true) {
                    textures.updateMultisampleRenderTarget(transmissionRenderTarget);
                    textures.updateRenderTargetMipmap(transmissionRenderTarget);
                }
            }
            _this.setRenderTarget(currentRenderTarget);
            _this.setClearColor(_currentClearColor, _currentClearAlpha);
            if (currentCameraViewport !== undefined) camera.viewport = currentCameraViewport;
            _this.toneMapping = currentToneMapping;
        }
        function renderObjects(renderList, scene, camera) {
            var overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
            for(var i = 0, l = renderList.length; i < l; i++){
                var renderItem = renderList[i];
                var object = renderItem.object;
                var geometry = renderItem.geometry;
                var material = overrideMaterial === null ? renderItem.material : overrideMaterial;
                var group = renderItem.group;
                if (object.layers.test(camera.layers)) renderObject(object, scene, camera, geometry, material, group);
            }
        }
        function renderObject(object, scene, camera, geometry, material, group) {
            object.onBeforeRender(_this, scene, camera, geometry, material, group);
            object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
            object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
            material.onBeforeRender(_this, scene, camera, geometry, object, group);
            if (material.transparent === true && material.side === (0, $1a55656020b89c3a$export$3b296b6f144d5b03) && material.forceSinglePass === false) {
                material.side = (0, $1a55656020b89c3a$export$d9f0486e75b5ace);
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = (0, $1a55656020b89c3a$export$2ede184fc2998901);
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = (0, $1a55656020b89c3a$export$3b296b6f144d5b03);
            } else _this.renderBufferDirect(camera, scene, geometry, material, object, group);
            object.onAfterRender(_this, scene, camera, geometry, material, group);
        }
        function getProgram(material, scene, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            var materialProperties = properties.get(material);
            var lights = currentRenderState.state.lights;
            var shadowsArray = currentRenderState.state.shadowsArray;
            var lightsStateVersion = lights.state.version;
            var parameters = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
            var programCacheKey = programCache.getProgramCacheKey(parameters);
            var programs = materialProperties.programs;
            // always update environment and fog - changing these trigger an getProgram call, but it's possible that the program doesn't change
            materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
            materialProperties.fog = scene.fog;
            materialProperties.envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || materialProperties.environment);
            materialProperties.envMapRotation = materialProperties.environment !== null && material.envMap === null ? scene.environmentRotation : material.envMapRotation;
            if (programs === undefined) {
                // new material
                material.addEventListener('dispose', onMaterialDispose);
                programs = new Map();
                materialProperties.programs = programs;
            }
            var program = programs.get(programCacheKey);
            if (program !== undefined) // early out if program and light state is identical
            {
                if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {
                    updateCommonMaterialProperties(material, parameters);
                    return program;
                }
            } else {
                parameters.uniforms = programCache.getUniforms(material);
                material.onBeforeCompile(parameters, _this);
                program = programCache.acquireProgram(parameters, programCacheKey);
                programs.set(programCacheKey, program);
                materialProperties.uniforms = parameters.uniforms;
            }
            var uniforms = materialProperties.uniforms;
            if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) uniforms.clippingPlanes = clipping.uniform;
            updateCommonMaterialProperties(material, parameters);
            // store the light setup it was created for
            materialProperties.needsLights = materialNeedsLights(material);
            materialProperties.lightsStateVersion = lightsStateVersion;
            if (materialProperties.needsLights) {
                // wire up the material to this renderer's lighting state
                uniforms.ambientLightColor.value = lights.state.ambient;
                uniforms.lightProbe.value = lights.state.probe;
                uniforms.directionalLights.value = lights.state.directional;
                uniforms.directionalLightShadows.value = lights.state.directionalShadow;
                uniforms.spotLights.value = lights.state.spot;
                uniforms.spotLightShadows.value = lights.state.spotShadow;
                uniforms.rectAreaLights.value = lights.state.rectArea;
                uniforms.ltc_1.value = lights.state.rectAreaLTC1;
                uniforms.ltc_2.value = lights.state.rectAreaLTC2;
                uniforms.pointLights.value = lights.state.point;
                uniforms.pointLightShadows.value = lights.state.pointShadow;
                uniforms.hemisphereLights.value = lights.state.hemi;
                uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
                uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
                uniforms.spotShadowMap.value = lights.state.spotShadowMap;
                uniforms.spotLightMatrix.value = lights.state.spotLightMatrix;
                uniforms.spotLightMap.value = lights.state.spotLightMap;
                uniforms.pointShadowMap.value = lights.state.pointShadowMap;
                uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
            // TODO (abelnation): add area lights shadow info to uniforms
            }
            materialProperties.currentProgram = program;
            materialProperties.uniformsList = null;
            return program;
        }
        function getUniformList(materialProperties) {
            if (materialProperties.uniformsList === null) {
                var progUniforms = materialProperties.currentProgram.getUniforms();
                materialProperties.uniformsList = $079becb54c0579a9$var$WebGLUniforms.seqWithValue(progUniforms.seq, materialProperties.uniforms);
            }
            return materialProperties.uniformsList;
        }
        function updateCommonMaterialProperties(material, parameters) {
            var materialProperties = properties.get(material);
            materialProperties.outputColorSpace = parameters.outputColorSpace;
            materialProperties.batching = parameters.batching;
            materialProperties.batchingColor = parameters.batchingColor;
            materialProperties.instancing = parameters.instancing;
            materialProperties.instancingColor = parameters.instancingColor;
            materialProperties.instancingMorph = parameters.instancingMorph;
            materialProperties.skinning = parameters.skinning;
            materialProperties.morphTargets = parameters.morphTargets;
            materialProperties.morphNormals = parameters.morphNormals;
            materialProperties.morphColors = parameters.morphColors;
            materialProperties.morphTargetsCount = parameters.morphTargetsCount;
            materialProperties.numClippingPlanes = parameters.numClippingPlanes;
            materialProperties.numIntersection = parameters.numClipIntersection;
            materialProperties.vertexAlphas = parameters.vertexAlphas;
            materialProperties.vertexTangents = parameters.vertexTangents;
            materialProperties.toneMapping = parameters.toneMapping;
        }
        function setProgram(camera, scene, geometry, material, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            textures.resetTextureUnits();
            var fog = scene.fog;
            var environment = material.isMeshStandardMaterial ? scene.environment : null;
            var colorSpace = _currentRenderTarget === null ? _this.outputColorSpace : _currentRenderTarget.isXRRenderTarget === true ? _currentRenderTarget.texture.colorSpace : (0, $1a55656020b89c3a$export$42429b3acfb233a4);
            var envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
            var vertexAlphas = material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4;
            var vertexTangents = !!geometry.attributes.tangent && (!!material.normalMap || material.anisotropy > 0);
            var morphTargets = !!geometry.morphAttributes.position;
            var morphNormals = !!geometry.morphAttributes.normal;
            var morphColors = !!geometry.morphAttributes.color;
            var toneMapping = (0, $1a55656020b89c3a$export$9fcb6b4294603b2);
            if (material.toneMapped) {
                if (_currentRenderTarget === null || _currentRenderTarget.isXRRenderTarget === true) toneMapping = _this.toneMapping;
            }
            var morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
            var morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
            var materialProperties = properties.get(material);
            var lights = currentRenderState.state.lights;
            if (_clippingEnabled === true) {
                if (_localClippingEnabled === true || camera !== _currentCamera) {
                    var useCache = camera === _currentCamera && material.id === _currentMaterialId;
                    // we might want to call this function with some ClippingGroup
                    // object instead of the material, once it becomes feasible
                    // (#8465, #8379)
                    clipping.setState(material, camera, useCache);
                }
            }
            //
            var needsProgramChange = false;
            if (material.version === materialProperties.__version) {
                if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) needsProgramChange = true;
                else if (materialProperties.outputColorSpace !== colorSpace) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batching === false) needsProgramChange = true;
                else if (!object.isBatchedMesh && materialProperties.batching === true) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batchingColor === true && object.colorTexture === null) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batchingColor === false && object.colorTexture !== null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancing === false) needsProgramChange = true;
                else if (!object.isInstancedMesh && materialProperties.instancing === true) needsProgramChange = true;
                else if (object.isSkinnedMesh && materialProperties.skinning === false) needsProgramChange = true;
                else if (!object.isSkinnedMesh && materialProperties.skinning === true) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingColor === true && object.instanceColor === null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingColor === false && object.instanceColor !== null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingMorph === true && object.morphTexture === null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingMorph === false && object.morphTexture !== null) needsProgramChange = true;
                else if (materialProperties.envMap !== envMap) needsProgramChange = true;
                else if (material.fog === true && materialProperties.fog !== fog) needsProgramChange = true;
                else if (materialProperties.numClippingPlanes !== undefined && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) needsProgramChange = true;
                else if (materialProperties.vertexAlphas !== vertexAlphas) needsProgramChange = true;
                else if (materialProperties.vertexTangents !== vertexTangents) needsProgramChange = true;
                else if (materialProperties.morphTargets !== morphTargets) needsProgramChange = true;
                else if (materialProperties.morphNormals !== morphNormals) needsProgramChange = true;
                else if (materialProperties.morphColors !== morphColors) needsProgramChange = true;
                else if (materialProperties.toneMapping !== toneMapping) needsProgramChange = true;
                else if (materialProperties.morphTargetsCount !== morphTargetsCount) needsProgramChange = true;
            } else {
                needsProgramChange = true;
                materialProperties.__version = material.version;
            }
            //
            var program = materialProperties.currentProgram;
            if (needsProgramChange === true) program = getProgram(material, scene, object);
            var refreshProgram = false;
            var refreshMaterial = false;
            var refreshLights = false;
            var p_uniforms = program.getUniforms(), m_uniforms = materialProperties.uniforms;
            if (state.useProgram(program.program)) {
                refreshProgram = true;
                refreshMaterial = true;
                refreshLights = true;
            }
            if (material.id !== _currentMaterialId) {
                _currentMaterialId = material.id;
                refreshMaterial = true;
            }
            if (refreshProgram || _currentCamera !== camera) {
                // common camera uniforms
                var reverseDepthBuffer = state.buffers.depth.getReversed();
                if (reverseDepthBuffer) {
                    _currentProjectionMatrix.copy(camera.projectionMatrix);
                    (0, $1a55656020b89c3a$export$5238391f68c729b)(_currentProjectionMatrix);
                    (0, $1a55656020b89c3a$export$f8cf97d08da9bc86)(_currentProjectionMatrix);
                    p_uniforms.setValue(_gl, 'projectionMatrix', _currentProjectionMatrix);
                } else p_uniforms.setValue(_gl, 'projectionMatrix', camera.projectionMatrix);
                p_uniforms.setValue(_gl, 'viewMatrix', camera.matrixWorldInverse);
                var uCamPos = p_uniforms.map.cameraPosition;
                if (uCamPos !== undefined) uCamPos.setValue(_gl, _vector3.setFromMatrixPosition(camera.matrixWorld));
                if (capabilities.logarithmicDepthBuffer) p_uniforms.setValue(_gl, 'logDepthBufFC', 2.0 / (Math.log(camera.far + 1.0) / Math.LN2));
                // consider moving isOrthographic to UniformLib and WebGLMaterials, see https://github.com/mrdoob/three.js/pull/26467#issuecomment-1645185067
                if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) p_uniforms.setValue(_gl, 'isOrthographic', camera.isOrthographicCamera === true);
                if (_currentCamera !== camera) {
                    _currentCamera = camera;
                    // lighting uniforms depend on the camera so enforce an update
                    // now, in case this material supports lights - or later, when
                    // the next material that does gets activated:
                    refreshMaterial = true; // set to true on material change
                    refreshLights = true; // remains set until update done
                }
            }
            // skinning and morph target uniforms must be set even if material didn't change
            // auto-setting of texture unit for bone and morph texture must go before other textures
            // otherwise textures used for skinning and morphing can take over texture units reserved for other material textures
            if (object.isSkinnedMesh) {
                p_uniforms.setOptional(_gl, object, 'bindMatrix');
                p_uniforms.setOptional(_gl, object, 'bindMatrixInverse');
                var skeleton = object.skeleton;
                if (skeleton) {
                    if (skeleton.boneTexture === null) skeleton.computeBoneTexture();
                    p_uniforms.setValue(_gl, 'boneTexture', skeleton.boneTexture, textures);
                }
            }
            if (object.isBatchedMesh) {
                p_uniforms.setOptional(_gl, object, 'batchingTexture');
                p_uniforms.setValue(_gl, 'batchingTexture', object._matricesTexture, textures);
                p_uniforms.setOptional(_gl, object, 'batchingIdTexture');
                p_uniforms.setValue(_gl, 'batchingIdTexture', object._indirectTexture, textures);
                p_uniforms.setOptional(_gl, object, 'batchingColorTexture');
                if (object._colorsTexture !== null) p_uniforms.setValue(_gl, 'batchingColorTexture', object._colorsTexture, textures);
            }
            var morphAttributes = geometry.morphAttributes;
            if (morphAttributes.position !== undefined || morphAttributes.normal !== undefined || morphAttributes.color !== undefined) morphtargets.update(object, geometry, program);
            if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
                materialProperties.receiveShadow = object.receiveShadow;
                p_uniforms.setValue(_gl, 'receiveShadow', object.receiveShadow);
            }
            // https://github.com/mrdoob/three.js/pull/24467#issuecomment-1209031512
            if (material.isMeshGouraudMaterial && material.envMap !== null) {
                m_uniforms.envMap.value = envMap;
                m_uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            }
            if (material.isMeshStandardMaterial && material.envMap === null && scene.environment !== null) m_uniforms.envMapIntensity.value = scene.environmentIntensity;
            if (refreshMaterial) {
                p_uniforms.setValue(_gl, 'toneMappingExposure', _this.toneMappingExposure);
                if (materialProperties.needsLights) // the current material requires lighting info
                // note: all lighting uniforms are always set correctly
                // they simply reference the renderer's state for their
                // values
                //
                // use the current material's .needsUpdate flags to set
                // the GL state when required
                markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
                // refresh uniforms common to several materials
                if (fog && material.fog === true) materials.refreshFogUniforms(m_uniforms, fog);
                materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, currentRenderState.state.transmissionRenderTarget[camera.id]);
                $079becb54c0579a9$var$WebGLUniforms.upload(_gl, getUniformList(materialProperties), m_uniforms, textures);
            }
            if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
                $079becb54c0579a9$var$WebGLUniforms.upload(_gl, getUniformList(materialProperties), m_uniforms, textures);
                material.uniformsNeedUpdate = false;
            }
            if (material.isSpriteMaterial) p_uniforms.setValue(_gl, 'center', object.center);
            // common matrices
            p_uniforms.setValue(_gl, 'modelViewMatrix', object.modelViewMatrix);
            p_uniforms.setValue(_gl, 'normalMatrix', object.normalMatrix);
            p_uniforms.setValue(_gl, 'modelMatrix', object.matrixWorld);
            // UBOs
            if (material.isShaderMaterial || material.isRawShaderMaterial) {
                var groups = material.uniformsGroups;
                for(var i = 0, l = groups.length; i < l; i++){
                    var group = groups[i];
                    uniformsGroups.update(group, program);
                    uniformsGroups.bind(group, program);
                }
            }
            return program;
        }
        // If uniforms are marked as clean, they don't need to be loaded to the GPU.
        function markUniformsLightsNeedsUpdate(uniforms, value) {
            uniforms.ambientLightColor.needsUpdate = value;
            uniforms.lightProbe.needsUpdate = value;
            uniforms.directionalLights.needsUpdate = value;
            uniforms.directionalLightShadows.needsUpdate = value;
            uniforms.pointLights.needsUpdate = value;
            uniforms.pointLightShadows.needsUpdate = value;
            uniforms.spotLights.needsUpdate = value;
            uniforms.spotLightShadows.needsUpdate = value;
            uniforms.rectAreaLights.needsUpdate = value;
            uniforms.hemisphereLights.needsUpdate = value;
        }
        function materialNeedsLights(material) {
            return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
        }
        this.getActiveCubeFace = function() {
            return _currentActiveCubeFace;
        };
        this.getActiveMipmapLevel = function() {
            return _currentActiveMipmapLevel;
        };
        this.getRenderTarget = function() {
            return _currentRenderTarget;
        };
        this.setRenderTargetTextures = function(renderTarget, colorTexture, depthTexture) {
            properties.get(renderTarget.texture).__webglTexture = colorTexture;
            properties.get(renderTarget.depthTexture).__webglTexture = depthTexture;
            var renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__hasExternalTextures = true;
            renderTargetProperties.__autoAllocateDepthBuffer = depthTexture === undefined;
            if (!renderTargetProperties.__autoAllocateDepthBuffer) // The multisample_render_to_texture extension doesn't work properly if there
            // are midframe flushes and an external depth buffer. Disable use of the extension.
            {
                if (extensions.has('WEBGL_multisampled_render_to_texture') === true) {
                    console.warn('THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided');
                    renderTargetProperties.__useRenderToTexture = false;
                }
            }
        };
        this.setRenderTargetFramebuffer = function(renderTarget, defaultFramebuffer) {
            var renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__webglFramebuffer = defaultFramebuffer;
            renderTargetProperties.__useDefaultFramebuffer = defaultFramebuffer === undefined;
        };
        var _scratchFrameBuffer = _gl.createFramebuffer();
        this.setRenderTarget = function(renderTarget) {
            var activeCubeFace = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, activeMipmapLevel = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
            _currentRenderTarget = renderTarget;
            _currentActiveCubeFace = activeCubeFace;
            _currentActiveMipmapLevel = activeMipmapLevel;
            var useDefaultFramebuffer = true;
            var framebuffer = null;
            var isCube = false;
            var isRenderTarget3D = false;
            if (renderTarget) {
                var renderTargetProperties = properties.get(renderTarget);
                if (renderTargetProperties.__useDefaultFramebuffer !== undefined) {
                    // We need to make sure to rebind the framebuffer.
                    state.bindFramebuffer(_gl.FRAMEBUFFER, null);
                    useDefaultFramebuffer = false;
                } else if (renderTargetProperties.__webglFramebuffer === undefined) textures.setupRenderTarget(renderTarget);
                else if (renderTargetProperties.__hasExternalTextures) // Color and depth texture must be rebound in order for the swapchain to update.
                textures.rebindTextures(renderTarget, properties.get(renderTarget.texture).__webglTexture, properties.get(renderTarget.depthTexture).__webglTexture);
                else if (renderTarget.depthBuffer) {
                    // check if the depth texture is already bound to the frame buffer and that it's been initialized
                    var depthTexture = renderTarget.depthTexture;
                    if (renderTargetProperties.__boundDepthTexture !== depthTexture) {
                        // check if the depth texture is compatible
                        if (depthTexture !== null && properties.has(depthTexture) && (renderTarget.width !== depthTexture.image.width || renderTarget.height !== depthTexture.image.height)) throw new Error('WebGLRenderTarget: Attached DepthTexture is initialized to the incorrect size.');
                        // Swap the depth buffer to the currently attached one
                        textures.setupDepthRenderbuffer(renderTarget);
                    }
                }
                var texture = renderTarget.texture;
                if (texture.isData3DTexture || texture.isDataArrayTexture || texture.isCompressedArrayTexture) isRenderTarget3D = true;
                var __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
                if (renderTarget.isWebGLCubeRenderTarget) {
                    if (Array.isArray(__webglFramebuffer[activeCubeFace])) framebuffer = __webglFramebuffer[activeCubeFace][activeMipmapLevel];
                    else framebuffer = __webglFramebuffer[activeCubeFace];
                    isCube = true;
                } else if (renderTarget.samples > 0 && textures.useMultisampledRTT(renderTarget) === false) framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
                else if (Array.isArray(__webglFramebuffer)) framebuffer = __webglFramebuffer[activeMipmapLevel];
                else framebuffer = __webglFramebuffer;
                _currentViewport.copy(renderTarget.viewport);
                _currentScissor.copy(renderTarget.scissor);
                _currentScissorTest = renderTarget.scissorTest;
            } else {
                _currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();
                _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
                _currentScissorTest = _scissorTest;
            }
            // Use a scratch frame buffer if rendering to a mip level to avoid depth buffers
            // being bound that are different sizes.
            if (activeMipmapLevel !== 0) framebuffer = _scratchFrameBuffer;
            var framebufferBound = state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
            if (framebufferBound && useDefaultFramebuffer) state.drawBuffers(renderTarget, framebuffer);
            state.viewport(_currentViewport);
            state.scissor(_currentScissor);
            state.setScissorTest(_currentScissorTest);
            if (isCube) {
                var textureProperties = properties.get(renderTarget.texture);
                _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
            } else if (isRenderTarget3D) {
                var textureProperties1 = properties.get(renderTarget.texture);
                var layer = activeCubeFace;
                _gl.framebufferTextureLayer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, textureProperties1.__webglTexture, activeMipmapLevel, layer);
            } else if (renderTarget !== null && activeMipmapLevel !== 0) {
                // Only bind the frame buffer if we are using a scratch frame buffer to render to a mipmap.
                // If we rebind the texture when using a multi sample buffer then an error about inconsistent samples will be thrown.
                var textureProperties2 = properties.get(renderTarget.texture);
                _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, textureProperties2.__webglTexture, activeMipmapLevel);
            }
            _currentMaterialId = -1; // reset current material to ensure correct uniform bindings
        };
        this.readRenderTargetPixels = function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
            if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
                console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.');
                return;
            }
            var framebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
            if (framebuffer) {
                state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                try {
                    var texture = renderTarget.texture;
                    var textureFormat = texture.format;
                    var textureType = texture.type;
                    if (!capabilities.textureFormatReadable(textureFormat)) {
                        console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.');
                        return;
                    }
                    if (!capabilities.textureTypeReadable(textureType)) {
                        console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.');
                        return;
                    }
                    // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                    if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), buffer);
                } finally{
                    // restore framebuffer of current render target if necessary
                    var framebuffer1 = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer1);
                }
            }
        };
        this.readRenderTargetPixelsAsync = /*#__PURE__*/ function() {
            var _ref = (0, $5941428b630ec017$export$71511d61b312f219)(function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
                var framebuffer, texture, textureFormat, textureType, glBuffer, currFramebuffer, sync;
                return (0, $353b713f9392bb93$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(renderTarget && renderTarget.isWebGLRenderTarget)) throw new Error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.');
                            framebuffer = properties.get(renderTarget).__webglFramebuffer;
                            if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
                            if (!framebuffer) return [
                                3,
                                3
                            ];
                            texture = renderTarget.texture;
                            textureFormat = texture.format;
                            textureType = texture.type;
                            if (!capabilities.textureFormatReadable(textureFormat)) throw new Error('THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in RGBA or implementation defined format.');
                            if (!capabilities.textureTypeReadable(textureType)) throw new Error('THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in UnsignedByteType or implementation defined type.');
                            if (!(x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height)) return [
                                3,
                                2
                            ];
                            // set the active frame buffer to the one we want to read
                            state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                            glBuffer = _gl.createBuffer();
                            _gl.bindBuffer(_gl.PIXEL_PACK_BUFFER, glBuffer);
                            _gl.bufferData(_gl.PIXEL_PACK_BUFFER, buffer.byteLength, _gl.STREAM_READ);
                            _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), 0);
                            // reset the frame buffer to the currently set buffer before waiting
                            currFramebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                            state.bindFramebuffer(_gl.FRAMEBUFFER, currFramebuffer);
                            // check if the commands have finished every 8 ms
                            sync = _gl.fenceSync(_gl.SYNC_GPU_COMMANDS_COMPLETE, 0);
                            _gl.flush();
                            return [
                                4,
                                (0, $1a55656020b89c3a$export$d43f91ebeafb2c7)(_gl, sync, 4)
                            ];
                        case 1:
                            _state.sent();
                            // read the data and delete the buffer
                            _gl.bindBuffer(_gl.PIXEL_PACK_BUFFER, glBuffer);
                            _gl.getBufferSubData(_gl.PIXEL_PACK_BUFFER, 0, buffer);
                            _gl.deleteBuffer(glBuffer);
                            _gl.deleteSync(sync);
                            return [
                                2,
                                buffer
                            ];
                        case 2:
                            throw new Error('THREE.WebGLRenderer.readRenderTargetPixelsAsync: requested read bounds are out of range.');
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
                return _ref.apply(this, arguments);
            };
        }();
        this.copyFramebufferToTexture = function(texture) {
            var position = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, level = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
            // support previous signature with position first
            if (texture.isTexture !== true) {
                // @deprecated, r165
                (0, $1a55656020b89c3a$export$5b28268982f175ba)('WebGLRenderer: copyFramebufferToTexture function signature has changed.');
                position = arguments[0] || null;
                texture = arguments[1];
            }
            var levelScale = Math.pow(2, -level);
            var width = Math.floor(texture.image.width * levelScale);
            var height = Math.floor(texture.image.height * levelScale);
            var x = position !== null ? position.x : 0;
            var y = position !== null ? position.y : 0;
            textures.setTexture2D(texture, 0);
            _gl.copyTexSubImage2D(_gl.TEXTURE_2D, level, 0, 0, x, y, width, height);
            state.unbindTexture();
        };
        var _srcFramebuffer = _gl.createFramebuffer();
        var _dstFramebuffer = _gl.createFramebuffer();
        this.copyTextureToTexture = function(srcTexture, dstTexture) {
            var srcRegion = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, dstPosition = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, srcLevel = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0, dstLevel = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null;
            // support previous signature with dstPosition first
            if (srcTexture.isTexture !== true) {
                // @deprecated, r165
                (0, $1a55656020b89c3a$export$5b28268982f175ba)('WebGLRenderer: copyTextureToTexture function signature has changed.');
                dstPosition = arguments[0] || null;
                srcTexture = arguments[1];
                dstTexture = arguments[2];
                dstLevel = arguments[3] || 0;
                srcRegion = null;
            }
            // support the previous signature with just a single dst mipmap level
            if (dstLevel === null) {
                if (srcLevel !== 0) {
                    // @deprecated, r171
                    (0, $1a55656020b89c3a$export$5b28268982f175ba)('WebGLRenderer: copyTextureToTexture function signature has changed to support src and dst mipmap levels.');
                    dstLevel = srcLevel;
                    srcLevel = 0;
                } else dstLevel = 0;
            }
            // gather the necessary dimensions to copy
            var width, height, depth, minX, minY, minZ;
            var dstX, dstY, dstZ;
            var image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[dstLevel] : srcTexture.image;
            if (srcRegion !== null) {
                width = srcRegion.max.x - srcRegion.min.x;
                height = srcRegion.max.y - srcRegion.min.y;
                depth = srcRegion.isBox3 ? srcRegion.max.z - srcRegion.min.z : 1;
                minX = srcRegion.min.x;
                minY = srcRegion.min.y;
                minZ = srcRegion.isBox3 ? srcRegion.min.z : 0;
            } else {
                var levelScale = Math.pow(2, -srcLevel);
                width = Math.floor(image.width * levelScale);
                height = Math.floor(image.height * levelScale);
                if (srcTexture.isDataArrayTexture) depth = image.depth;
                else if (srcTexture.isData3DTexture) depth = Math.floor(image.depth * levelScale);
                else depth = 1;
                minX = 0;
                minY = 0;
                minZ = 0;
            }
            if (dstPosition !== null) {
                dstX = dstPosition.x;
                dstY = dstPosition.y;
                dstZ = dstPosition.z;
            } else {
                dstX = 0;
                dstY = 0;
                dstZ = 0;
            }
            // Set up the destination target
            var glFormat = utils.convert(dstTexture.format);
            var glType = utils.convert(dstTexture.type);
            var glTarget;
            if (dstTexture.isData3DTexture) {
                textures.setTexture3D(dstTexture, 0);
                glTarget = _gl.TEXTURE_3D;
            } else if (dstTexture.isDataArrayTexture || dstTexture.isCompressedArrayTexture) {
                textures.setTexture2DArray(dstTexture, 0);
                glTarget = _gl.TEXTURE_2D_ARRAY;
            } else {
                textures.setTexture2D(dstTexture, 0);
                glTarget = _gl.TEXTURE_2D;
            }
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
            // used for copying data from cpu
            var currentUnpackRowLen = _gl.getParameter(_gl.UNPACK_ROW_LENGTH);
            var currentUnpackImageHeight = _gl.getParameter(_gl.UNPACK_IMAGE_HEIGHT);
            var currentUnpackSkipPixels = _gl.getParameter(_gl.UNPACK_SKIP_PIXELS);
            var currentUnpackSkipRows = _gl.getParameter(_gl.UNPACK_SKIP_ROWS);
            var currentUnpackSkipImages = _gl.getParameter(_gl.UNPACK_SKIP_IMAGES);
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, image.width);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, image.height);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, minX);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, minY);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, minZ);
            // set up the src texture
            var isSrc3D = srcTexture.isDataArrayTexture || srcTexture.isData3DTexture;
            var isDst3D = dstTexture.isDataArrayTexture || dstTexture.isData3DTexture;
            if (srcTexture.isDepthTexture) {
                var srcTextureProperties = properties.get(srcTexture);
                var dstTextureProperties = properties.get(dstTexture);
                var srcRenderTargetProperties = properties.get(srcTextureProperties.__renderTarget);
                var dstRenderTargetProperties = properties.get(dstTextureProperties.__renderTarget);
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, srcRenderTargetProperties.__webglFramebuffer);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, dstRenderTargetProperties.__webglFramebuffer);
                for(var i = 0; i < depth; i++){
                    // if the source or destination are a 3d target then a layer needs to be bound
                    if (isSrc3D) {
                        _gl.framebufferTextureLayer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, properties.get(srcTexture).__webglTexture, srcLevel, minZ + i);
                        _gl.framebufferTextureLayer(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, properties.get(dstTexture).__webglTexture, dstLevel, dstZ + i);
                    }
                    _gl.blitFramebuffer(minX, minY, width, height, dstX, dstY, width, height, _gl.DEPTH_BUFFER_BIT, _gl.NEAREST);
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
            } else if (srcLevel !== 0 || srcTexture.isRenderTargetTexture || properties.has(srcTexture)) {
                // get the appropriate frame buffers
                var srcTextureProperties1 = properties.get(srcTexture);
                var dstTextureProperties1 = properties.get(dstTexture);
                // bind the frame buffer targets
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, _srcFramebuffer);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, _dstFramebuffer);
                for(var i1 = 0; i1 < depth; i1++){
                    // assign the correct layers and mip maps to the frame buffers
                    if (isSrc3D) _gl.framebufferTextureLayer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, srcTextureProperties1.__webglTexture, srcLevel, minZ + i1);
                    else _gl.framebufferTexture2D(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, srcTextureProperties1.__webglTexture, srcLevel);
                    if (isDst3D) _gl.framebufferTextureLayer(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, dstTextureProperties1.__webglTexture, dstLevel, dstZ + i1);
                    else _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, dstTextureProperties1.__webglTexture, dstLevel);
                    // copy the data using the fastest function that can achieve the copy
                    if (srcLevel !== 0) _gl.blitFramebuffer(minX, minY, width, height, dstX, dstY, width, height, _gl.COLOR_BUFFER_BIT, _gl.NEAREST);
                    else if (isDst3D) _gl.copyTexSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ + i1, minX, minY, width, height);
                    else _gl.copyTexSubImage2D(glTarget, dstLevel, dstX, dstY, minX, minY, width, height);
                }
                // unbind read, draw buffers
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
            } else if (isDst3D) {
                // copy data into the 3d texture
                if (srcTexture.isDataTexture || srcTexture.isData3DTexture) _gl.texSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth, glFormat, glType, image.data);
                else if (dstTexture.isCompressedArrayTexture) _gl.compressedTexSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth, glFormat, image.data);
                else _gl.texSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth, glFormat, glType, image);
            } else {
                // copy data into the 2d texture
                if (srcTexture.isDataTexture) _gl.texSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, width, height, glFormat, glType, image.data);
                else if (srcTexture.isCompressedTexture) _gl.compressedTexSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, image.width, image.height, glFormat, image.data);
                else _gl.texSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, width, height, glFormat, glType, image);
            }
            // reset values
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, currentUnpackRowLen);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, currentUnpackImageHeight);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, currentUnpackSkipPixels);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, currentUnpackSkipRows);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, currentUnpackSkipImages);
            // Generate mipmaps only when copying level 0
            if (dstLevel === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(glTarget);
            state.unbindTexture();
        };
        this.copyTextureToTexture3D = function(srcTexture, dstTexture) {
            var srcRegion = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, dstPosition = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, level = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
            // support previous signature with source box first
            if (srcTexture.isTexture !== true) {
                // @deprecated, r165
                (0, $1a55656020b89c3a$export$5b28268982f175ba)('WebGLRenderer: copyTextureToTexture3D function signature has changed.');
                srcRegion = arguments[0] || null;
                dstPosition = arguments[1] || null;
                srcTexture = arguments[2];
                dstTexture = arguments[3];
                level = arguments[4] || 0;
            }
            // @deprecated, r170
            (0, $1a55656020b89c3a$export$5b28268982f175ba)('WebGLRenderer: copyTextureToTexture3D function has been deprecated. Use "copyTextureToTexture" instead.');
            return this.copyTextureToTexture(srcTexture, dstTexture, srcRegion, dstPosition, level);
        };
        this.initRenderTarget = function(target) {
            if (properties.get(target).__webglFramebuffer === undefined) textures.setupRenderTarget(target);
        };
        this.initTexture = function(texture) {
            if (texture.isCubeTexture) textures.setTextureCube(texture, 0);
            else if (texture.isData3DTexture) textures.setTexture3D(texture, 0);
            else if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textures.setTexture2DArray(texture, 0);
            else textures.setTexture2D(texture, 0);
            state.unbindTexture();
        };
        this.resetState = function() {
            _currentActiveCubeFace = 0;
            _currentActiveMipmapLevel = 0;
            _currentRenderTarget = null;
            state.reset();
            bindingStates.reset();
        };
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        }));
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(WebGLRenderer, [
        {
            key: "coordinateSystem",
            get: function get() {
                return 0, $1a55656020b89c3a$export$5a0e9190d10875d3;
            }
        },
        {
            key: "outputColorSpace",
            get: function get() {
                return this._outputColorSpace;
            },
            set: function set(colorSpace) {
                this._outputColorSpace = colorSpace;
                var gl = this.getContext();
                gl.drawingBufferColorspace = (0, $1a55656020b89c3a$export$5e6fd513f44698c)._getDrawingBufferColorSpace(colorSpace);
                gl.unpackColorSpace = (0, $1a55656020b89c3a$export$5e6fd513f44698c)._getUnpackColorSpace();
            }
        }
    ]);
    return WebGLRenderer;
}();





/**
 * Full-screen textured quad shader
 */ var $29b46539d89188c9$export$57f84a24a9a6130d = {
    name: 'CopyShader',
    uniforms: {
        'tDiffuse': {
            value: null
        },
        'opacity': {
            value: 1.0
        }
    },
    vertexShader: "\n\n		varying vec2 vUv;\n\n		void main() {\n\n			vUv = uv;\n			gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n\n		}",
    fragmentShader: "\n\n		uniform float opacity;\n\n		uniform sampler2D tDiffuse;\n\n		varying vec2 vUv;\n\n		void main() {\n\n			vec4 texel = texture2D( tDiffuse, vUv );\n			gl_FragColor = opacity * texel;\n\n\n		}"
};












var $14df9def65f9e423$export$802bc10488da99c7 = /*#__PURE__*/ function() {
    "use strict";
    function Pass() {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Pass);
        this.isPass = true;
        // if set to true, the pass is processed by the composer
        this.enabled = true;
        // if set to true, the pass indicates to swap read and write buffer after rendering
        this.needsSwap = true;
        // if set to true, the pass clears its buffer before rendering
        this.clear = false;
        // if set to true, the result of the pass is rendered to screen. This is set automatically by EffectComposer.
        this.renderToScreen = false;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Pass, [
        {
            key: "setSize",
            value: function setSize() {}
        },
        {
            key: "render",
            value: function render() {
                console.error('THREE.Pass: .render() must be implemented in derived pass.');
            }
        },
        {
            key: "dispose",
            value: function dispose() {}
        }
    ]);
    return Pass;
}();
// Helper for passes that need to fill the viewport with a single quad.
var $14df9def65f9e423$var$_camera = new (0, $1a55656020b89c3a$export$9ebf355ee4ed261b)(-1, 1, 1, -1, 0, 1);
// https://github.com/mrdoob/three.js/pull/21358
var $14df9def65f9e423$var$FullscreenTriangleGeometry = /*#__PURE__*/ function(BufferGeometry) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(FullscreenTriangleGeometry, BufferGeometry);
    function FullscreenTriangleGeometry() {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, FullscreenTriangleGeometry);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, FullscreenTriangleGeometry);
        _this.setAttribute('position', new (0, $1a55656020b89c3a$export$cbe7a62641830ebd)([
            -1,
            3,
            0,
            -1,
            -1,
            0,
            3,
            -1,
            0
        ], 3));
        _this.setAttribute('uv', new (0, $1a55656020b89c3a$export$cbe7a62641830ebd)([
            0,
            2,
            0,
            0,
            2,
            0
        ], 2));
        return _this;
    }
    return FullscreenTriangleGeometry;
}((0, $1a55656020b89c3a$export$b7be63a67df8959));
var $14df9def65f9e423$var$_geometry = new $14df9def65f9e423$var$FullscreenTriangleGeometry();
var $14df9def65f9e423$export$3983474c8e6e978b = /*#__PURE__*/ function() {
    "use strict";
    function FullScreenQuad(material) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, FullScreenQuad);
        this._mesh = new (0, $1a55656020b89c3a$export$e176487c05830cc5)($14df9def65f9e423$var$_geometry, material);
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(FullScreenQuad, [
        {
            key: "dispose",
            value: function dispose() {
                this._mesh.geometry.dispose();
            }
        },
        {
            key: "render",
            value: function render(renderer) {
                renderer.render(this._mesh, $14df9def65f9e423$var$_camera);
            }
        },
        {
            key: "material",
            get: function get() {
                return this._mesh.material;
            },
            set: function set(value) {
                this._mesh.material = value;
            }
        }
    ]);
    return FullScreenQuad;
}();


var $885ddd6dd5eeb2d2$export$c55093fd4f9e42f0 = /*#__PURE__*/ function(Pass) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(ShaderPass, Pass);
    function ShaderPass(shader, textureID) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, ShaderPass);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, ShaderPass);
        _this.textureID = textureID !== undefined ? textureID : 'tDiffuse';
        if (shader instanceof (0, $1a55656020b89c3a$export$83c7d75d550a8b0d)) {
            _this.uniforms = shader.uniforms;
            _this.material = shader;
        } else if (shader) {
            _this.uniforms = (0, $1a55656020b89c3a$export$d8ecdf8615bfea69).clone(shader.uniforms);
            _this.material = new (0, $1a55656020b89c3a$export$83c7d75d550a8b0d)({
                name: shader.name !== undefined ? shader.name : 'unspecified',
                defines: Object.assign({}, shader.defines),
                uniforms: _this.uniforms,
                vertexShader: shader.vertexShader,
                fragmentShader: shader.fragmentShader
            });
        }
        _this.fsQuad = new (0, $14df9def65f9e423$export$3983474c8e6e978b)(_this.material);
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(ShaderPass, [
        {
            key: "render",
            value: function render(renderer, writeBuffer, readBuffer /*, deltaTime, maskActive */ ) {
                if (this.uniforms[this.textureID]) this.uniforms[this.textureID].value = readBuffer.texture;
                this.fsQuad.material = this.material;
                if (this.renderToScreen) {
                    renderer.setRenderTarget(null);
                    this.fsQuad.render(renderer);
                } else {
                    renderer.setRenderTarget(writeBuffer);
                    // TODO: Avoid using autoClear properties, see https://github.com/mrdoob/three.js/pull/15571#issuecomment-465669600
                    if (this.clear) renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
                    this.fsQuad.render(renderer);
                }
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this.material.dispose();
                this.fsQuad.dispose();
            }
        }
    ]);
    return ShaderPass;
}((0, $14df9def65f9e423$export$802bc10488da99c7));







var $73f965994d0af78e$export$bb424a4005d6dde0 = /*#__PURE__*/ function(Pass) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(MaskPass, Pass);
    function MaskPass(scene, camera) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, MaskPass);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, MaskPass);
        _this.scene = scene;
        _this.camera = camera;
        _this.clear = true;
        _this.needsSwap = false;
        _this.inverse = false;
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(MaskPass, [
        {
            key: "render",
            value: function render(renderer, writeBuffer, readBuffer /*, deltaTime, maskActive */ ) {
                var context = renderer.getContext();
                var state = renderer.state;
                // don't update color or depth
                state.buffers.color.setMask(false);
                state.buffers.depth.setMask(false);
                // lock buffers
                state.buffers.color.setLocked(true);
                state.buffers.depth.setLocked(true);
                // set up stencil
                var writeValue, clearValue;
                if (this.inverse) {
                    writeValue = 0;
                    clearValue = 1;
                } else {
                    writeValue = 1;
                    clearValue = 0;
                }
                state.buffers.stencil.setTest(true);
                state.buffers.stencil.setOp(context.REPLACE, context.REPLACE, context.REPLACE);
                state.buffers.stencil.setFunc(context.ALWAYS, writeValue, 0xffffffff);
                state.buffers.stencil.setClear(clearValue);
                state.buffers.stencil.setLocked(true);
                // draw into the stencil buffer
                renderer.setRenderTarget(readBuffer);
                if (this.clear) renderer.clear();
                renderer.render(this.scene, this.camera);
                renderer.setRenderTarget(writeBuffer);
                if (this.clear) renderer.clear();
                renderer.render(this.scene, this.camera);
                // unlock color and depth buffer and make them writable for subsequent rendering/clearing
                state.buffers.color.setLocked(false);
                state.buffers.depth.setLocked(false);
                state.buffers.color.setMask(true);
                state.buffers.depth.setMask(true);
                // only render where stencil is set to 1
                state.buffers.stencil.setLocked(false);
                state.buffers.stencil.setFunc(context.EQUAL, 1, 0xffffffff); // draw if == 1
                state.buffers.stencil.setOp(context.KEEP, context.KEEP, context.KEEP);
                state.buffers.stencil.setLocked(true);
            }
        }
    ]);
    return MaskPass;
}((0, $14df9def65f9e423$export$802bc10488da99c7));
var $73f965994d0af78e$export$8d8650aed29c6251 = /*#__PURE__*/ function(Pass) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(ClearMaskPass, Pass);
    function ClearMaskPass() {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, ClearMaskPass);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, ClearMaskPass);
        _this.needsSwap = false;
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(ClearMaskPass, [
        {
            key: "render",
            value: function render(renderer /*, writeBuffer, readBuffer, deltaTime, maskActive */ ) {
                renderer.state.buffers.stencil.setLocked(false);
                renderer.state.buffers.stencil.setTest(false);
            }
        }
    ]);
    return ClearMaskPass;
}((0, $14df9def65f9e423$export$802bc10488da99c7));


var $e047865f13e317c0$export$7fe01e6ab8aa748c = /*#__PURE__*/ function() {
    "use strict";
    function EffectComposer(renderer, renderTarget) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, EffectComposer);
        this.renderer = renderer;
        this._pixelRatio = renderer.getPixelRatio();
        if (renderTarget === undefined) {
            var size = renderer.getSize(new (0, $1a55656020b89c3a$export$c977b3e384af9ae1)());
            this._width = size.width;
            this._height = size.height;
            renderTarget = new (0, $1a55656020b89c3a$export$3c052beb2e51e23f)(this._width * this._pixelRatio, this._height * this._pixelRatio, {
                type: (0, $1a55656020b89c3a$export$2697304443f382bc)
            });
            renderTarget.texture.name = 'EffectComposer.rt1';
        } else {
            this._width = renderTarget.width;
            this._height = renderTarget.height;
        }
        this.renderTarget1 = renderTarget;
        this.renderTarget2 = renderTarget.clone();
        this.renderTarget2.texture.name = 'EffectComposer.rt2';
        this.writeBuffer = this.renderTarget1;
        this.readBuffer = this.renderTarget2;
        this.renderToScreen = true;
        this.passes = [];
        this.copyPass = new (0, $885ddd6dd5eeb2d2$export$c55093fd4f9e42f0)((0, $29b46539d89188c9$export$57f84a24a9a6130d));
        this.copyPass.material.blending = (0, $1a55656020b89c3a$export$63b8d6b580fc65ba);
        this.clock = new (0, $1a55656020b89c3a$export$9735c82c4bae3302)();
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(EffectComposer, [
        {
            key: "swapBuffers",
            value: function swapBuffers() {
                var tmp = this.readBuffer;
                this.readBuffer = this.writeBuffer;
                this.writeBuffer = tmp;
            }
        },
        {
            key: "addPass",
            value: function addPass(pass) {
                this.passes.push(pass);
                pass.setSize(this._width * this._pixelRatio, this._height * this._pixelRatio);
            }
        },
        {
            key: "insertPass",
            value: function insertPass(pass, index) {
                this.passes.splice(index, 0, pass);
                pass.setSize(this._width * this._pixelRatio, this._height * this._pixelRatio);
            }
        },
        {
            key: "removePass",
            value: function removePass(pass) {
                var index = this.passes.indexOf(pass);
                if (index !== -1) this.passes.splice(index, 1);
            }
        },
        {
            key: "isLastEnabledPass",
            value: function isLastEnabledPass(passIndex) {
                for(var i = passIndex + 1; i < this.passes.length; i++){
                    if (this.passes[i].enabled) return false;
                }
                return true;
            }
        },
        {
            key: "render",
            value: function render(deltaTime) {
                // deltaTime value is in seconds
                if (deltaTime === undefined) deltaTime = this.clock.getDelta();
                var currentRenderTarget = this.renderer.getRenderTarget();
                var maskActive = false;
                for(var i = 0, il = this.passes.length; i < il; i++){
                    var pass = this.passes[i];
                    if (pass.enabled === false) continue;
                    pass.renderToScreen = this.renderToScreen && this.isLastEnabledPass(i);
                    pass.render(this.renderer, this.writeBuffer, this.readBuffer, deltaTime, maskActive);
                    if (pass.needsSwap) {
                        if (maskActive) {
                            var context = this.renderer.getContext();
                            var stencil = this.renderer.state.buffers.stencil;
                            //context.stencilFunc( context.NOTEQUAL, 1, 0xffffffff );
                            stencil.setFunc(context.NOTEQUAL, 1, 0xffffffff);
                            this.copyPass.render(this.renderer, this.writeBuffer, this.readBuffer, deltaTime);
                            //context.stencilFunc( context.EQUAL, 1, 0xffffffff );
                            stencil.setFunc(context.EQUAL, 1, 0xffffffff);
                        }
                        this.swapBuffers();
                    }
                    if ((0, $73f965994d0af78e$export$bb424a4005d6dde0) !== undefined) {
                        if (pass instanceof (0, $73f965994d0af78e$export$bb424a4005d6dde0)) maskActive = true;
                        else if (pass instanceof (0, $73f965994d0af78e$export$8d8650aed29c6251)) maskActive = false;
                    }
                }
                this.renderer.setRenderTarget(currentRenderTarget);
            }
        },
        {
            key: "reset",
            value: function reset(renderTarget) {
                if (renderTarget === undefined) {
                    var size = this.renderer.getSize(new (0, $1a55656020b89c3a$export$c977b3e384af9ae1)());
                    this._pixelRatio = this.renderer.getPixelRatio();
                    this._width = size.width;
                    this._height = size.height;
                    renderTarget = this.renderTarget1.clone();
                    renderTarget.setSize(this._width * this._pixelRatio, this._height * this._pixelRatio);
                }
                this.renderTarget1.dispose();
                this.renderTarget2.dispose();
                this.renderTarget1 = renderTarget;
                this.renderTarget2 = renderTarget.clone();
                this.writeBuffer = this.renderTarget1;
                this.readBuffer = this.renderTarget2;
            }
        },
        {
            key: "setSize",
            value: function setSize(width, height) {
                this._width = width;
                this._height = height;
                var effectiveWidth = this._width * this._pixelRatio;
                var effectiveHeight = this._height * this._pixelRatio;
                this.renderTarget1.setSize(effectiveWidth, effectiveHeight);
                this.renderTarget2.setSize(effectiveWidth, effectiveHeight);
                for(var i = 0; i < this.passes.length; i++)this.passes[i].setSize(effectiveWidth, effectiveHeight);
            }
        },
        {
            key: "setPixelRatio",
            value: function setPixelRatio(pixelRatio) {
                this._pixelRatio = pixelRatio;
                this.setSize(this._width, this._height);
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this.renderTarget1.dispose();
                this.renderTarget2.dispose();
                this.copyPass.dispose();
            }
        }
    ]);
    return EffectComposer;
}();








var $824eec6761c11732$export$f63ea822f020b5b0 = /*#__PURE__*/ function(Pass) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(RenderPass, Pass);
    function RenderPass(scene, camera) {
        var overrideMaterial = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, clearColor = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, clearAlpha = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, RenderPass);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, RenderPass);
        _this.scene = scene;
        _this.camera = camera;
        _this.overrideMaterial = overrideMaterial;
        _this.clearColor = clearColor;
        _this.clearAlpha = clearAlpha;
        _this.clear = true;
        _this.clearDepth = false;
        _this.needsSwap = false;
        _this._oldClearColor = new (0, $1a55656020b89c3a$export$892596cec99bc70e)();
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(RenderPass, [
        {
            key: "render",
            value: function render(renderer, writeBuffer, readBuffer /*, deltaTime, maskActive */ ) {
                var oldAutoClear = renderer.autoClear;
                renderer.autoClear = false;
                var oldClearAlpha, oldOverrideMaterial;
                if (this.overrideMaterial !== null) {
                    oldOverrideMaterial = this.scene.overrideMaterial;
                    this.scene.overrideMaterial = this.overrideMaterial;
                }
                if (this.clearColor !== null) {
                    renderer.getClearColor(this._oldClearColor);
                    renderer.setClearColor(this.clearColor, renderer.getClearAlpha());
                }
                if (this.clearAlpha !== null) {
                    oldClearAlpha = renderer.getClearAlpha();
                    renderer.setClearAlpha(this.clearAlpha);
                }
                if (this.clearDepth == true) renderer.clearDepth();
                renderer.setRenderTarget(this.renderToScreen ? null : readBuffer);
                if (this.clear === true) // TODO: Avoid using autoClear properties, see https://github.com/mrdoob/three.js/pull/15571#issuecomment-465669600
                renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
                renderer.render(this.scene, this.camera);
                // restore
                if (this.clearColor !== null) renderer.setClearColor(this._oldClearColor);
                if (this.clearAlpha !== null) renderer.setClearAlpha(oldClearAlpha);
                if (this.overrideMaterial !== null) this.scene.overrideMaterial = oldOverrideMaterial;
                renderer.autoClear = oldAutoClear;
            }
        }
    ]);
    return RenderPass;
}((0, $14df9def65f9e423$export$802bc10488da99c7));









/**
 * Afterimage shader
 * I created this effect inspired by a demo on codepen:
 * https://codepen.io/brunoimbrizi/pen/MoRJaN?page=1&
 */ var $8f47912338c2a059$export$2bc1bdf1a2ab862b = {
    name: 'AfterimageShader',
    uniforms: {
        'damp': {
            value: 0.96
        },
        'tOld': {
            value: null
        },
        'tNew': {
            value: null
        }
    },
    vertexShader: "\n\n		varying vec2 vUv;\n\n		void main() {\n\n			vUv = uv;\n			gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n\n		}",
    fragmentShader: "\n\n		uniform float damp;\n\n		uniform sampler2D tOld;\n		uniform sampler2D tNew;\n\n		varying vec2 vUv;\n\n		vec4 when_gt( vec4 x, float y ) {\n\n			return max( sign( x - y ), 0.0 );\n\n		}\n\n		void main() {\n\n			vec4 texelOld = texture2D( tOld, vUv );\n			vec4 texelNew = texture2D( tNew, vUv );\n\n			texelOld *= damp * when_gt( texelOld, 0.1 );\n\n			gl_FragColor = max(texelNew, texelOld);\n\n		}"
};


var $68d1b828c7be5c52$export$1794c02a58210166 = /*#__PURE__*/ function(Pass) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(AfterimagePass, Pass);
    function AfterimagePass() {
        var damp = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0.96;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, AfterimagePass);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, AfterimagePass);
        _this.shader = (0, $8f47912338c2a059$export$2bc1bdf1a2ab862b);
        _this.uniforms = (0, $1a55656020b89c3a$export$d8ecdf8615bfea69).clone(_this.shader.uniforms);
        _this.uniforms['damp'].value = damp;
        _this.textureComp = new (0, $1a55656020b89c3a$export$3c052beb2e51e23f)(window.innerWidth, window.innerHeight, {
            magFilter: (0, $1a55656020b89c3a$export$727aa5ec3fe39bf0),
            type: (0, $1a55656020b89c3a$export$2697304443f382bc)
        });
        _this.textureOld = new (0, $1a55656020b89c3a$export$3c052beb2e51e23f)(window.innerWidth, window.innerHeight, {
            magFilter: (0, $1a55656020b89c3a$export$727aa5ec3fe39bf0),
            type: (0, $1a55656020b89c3a$export$2697304443f382bc)
        });
        _this.compFsMaterial = new (0, $1a55656020b89c3a$export$83c7d75d550a8b0d)({
            uniforms: _this.uniforms,
            vertexShader: _this.shader.vertexShader,
            fragmentShader: _this.shader.fragmentShader
        });
        _this.compFsQuad = new (0, $14df9def65f9e423$export$3983474c8e6e978b)(_this.compFsMaterial);
        var copyShader = (0, $29b46539d89188c9$export$57f84a24a9a6130d);
        _this.copyFsMaterial = new (0, $1a55656020b89c3a$export$83c7d75d550a8b0d)({
            uniforms: (0, $1a55656020b89c3a$export$d8ecdf8615bfea69).clone(copyShader.uniforms),
            vertexShader: copyShader.vertexShader,
            fragmentShader: copyShader.fragmentShader,
            blending: (0, $1a55656020b89c3a$export$63b8d6b580fc65ba),
            depthTest: false,
            depthWrite: false
        });
        _this.copyFsQuad = new (0, $14df9def65f9e423$export$3983474c8e6e978b)(_this.copyFsMaterial);
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(AfterimagePass, [
        {
            key: "render",
            value: function render(renderer, writeBuffer, readBuffer /*, deltaTime, maskActive*/ ) {
                this.uniforms['tOld'].value = this.textureOld.texture;
                this.uniforms['tNew'].value = readBuffer.texture;
                renderer.setRenderTarget(this.textureComp);
                this.compFsQuad.render(renderer);
                this.copyFsQuad.material.uniforms.tDiffuse.value = this.textureComp.texture;
                if (this.renderToScreen) {
                    renderer.setRenderTarget(null);
                    this.copyFsQuad.render(renderer);
                } else {
                    renderer.setRenderTarget(writeBuffer);
                    if (this.clear) renderer.clear();
                    this.copyFsQuad.render(renderer);
                }
                // Swap buffers.
                var temp = this.textureOld;
                this.textureOld = this.textureComp;
                this.textureComp = temp;
            // Now textureOld contains the latest image, ready for the next frame.
            }
        },
        {
            key: "setSize",
            value: function setSize(width, height) {
                this.textureComp.setSize(width, height);
                this.textureOld.setSize(width, height);
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this.textureComp.dispose();
                this.textureOld.dispose();
                this.compFsMaterial.dispose();
                this.copyFsMaterial.dispose();
                this.compFsQuad.dispose();
                this.copyFsQuad.dispose();
            }
        }
    ]);
    return AfterimagePass;
}((0, $14df9def65f9e423$export$802bc10488da99c7));








var $c0d7b092373e1271$export$64bec83dfaa26cbe = {
    name: 'OutputShader',
    uniforms: {
        'tDiffuse': {
            value: null
        },
        'toneMappingExposure': {
            value: 1
        }
    },
    vertexShader: "\n		precision highp float;\n\n		uniform mat4 modelViewMatrix;\n		uniform mat4 projectionMatrix;\n\n		attribute vec3 position;\n		attribute vec2 uv;\n\n		varying vec2 vUv;\n\n		void main() {\n\n			vUv = uv;\n			gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n\n		}",
    fragmentShader: "\n\n		precision highp float;\n\n		uniform sampler2D tDiffuse;\n\n		#include <tonemapping_pars_fragment>\n		#include <colorspace_pars_fragment>\n\n		varying vec2 vUv;\n\n		void main() {\n\n			gl_FragColor = texture2D( tDiffuse, vUv );\n\n			// tone mapping\n\n			#ifdef LINEAR_TONE_MAPPING\n\n				gl_FragColor.rgb = LinearToneMapping( gl_FragColor.rgb );\n\n			#elif defined( REINHARD_TONE_MAPPING )\n\n				gl_FragColor.rgb = ReinhardToneMapping( gl_FragColor.rgb );\n\n			#elif defined( CINEON_TONE_MAPPING )\n\n				gl_FragColor.rgb = CineonToneMapping( gl_FragColor.rgb );\n\n			#elif defined( ACES_FILMIC_TONE_MAPPING )\n\n				gl_FragColor.rgb = ACESFilmicToneMapping( gl_FragColor.rgb );\n\n			#elif defined( AGX_TONE_MAPPING )\n\n				gl_FragColor.rgb = AgXToneMapping( gl_FragColor.rgb );\n\n			#elif defined( NEUTRAL_TONE_MAPPING )\n\n				gl_FragColor.rgb = NeutralToneMapping( gl_FragColor.rgb );\n\n			#elif defined( CUSTOM_TONE_MAPPING )\n\n				gl_FragColor.rgb = CustomToneMapping( gl_FragColor.rgb );\n\n			#endif\n\n			// color space\n\n			#ifdef SRGB_TRANSFER\n\n				gl_FragColor = sRGBTransferOETF( gl_FragColor );\n\n			#endif\n\n		}"
};


var $36861e50dc478ff2$export$4035ba3abeff0682 = /*#__PURE__*/ function(Pass) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(OutputPass, Pass);
    function OutputPass() {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, OutputPass);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, OutputPass);
        //
        var shader = (0, $c0d7b092373e1271$export$64bec83dfaa26cbe);
        _this.uniforms = (0, $1a55656020b89c3a$export$d8ecdf8615bfea69).clone(shader.uniforms);
        _this.material = new (0, $1a55656020b89c3a$export$21c421a2e1df9d22)({
            name: shader.name,
            uniforms: _this.uniforms,
            vertexShader: shader.vertexShader,
            fragmentShader: shader.fragmentShader
        });
        _this.fsQuad = new (0, $14df9def65f9e423$export$3983474c8e6e978b)(_this.material);
        // internal cache
        _this._outputColorSpace = null;
        _this._toneMapping = null;
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(OutputPass, [
        {
            key: "render",
            value: function render(renderer, writeBuffer, readBuffer /*, deltaTime, maskActive */ ) {
                this.uniforms['tDiffuse'].value = readBuffer.texture;
                this.uniforms['toneMappingExposure'].value = renderer.toneMappingExposure;
                // rebuild defines if required
                if (this._outputColorSpace !== renderer.outputColorSpace || this._toneMapping !== renderer.toneMapping) {
                    this._outputColorSpace = renderer.outputColorSpace;
                    this._toneMapping = renderer.toneMapping;
                    this.material.defines = {};
                    if ((0, $1a55656020b89c3a$export$5e6fd513f44698c).getTransfer(this._outputColorSpace) === (0, $1a55656020b89c3a$export$8d0a61916cc26abb)) this.material.defines.SRGB_TRANSFER = '';
                    if (this._toneMapping === (0, $1a55656020b89c3a$export$98f52c2a46c598ca)) this.material.defines.LINEAR_TONE_MAPPING = '';
                    else if (this._toneMapping === (0, $1a55656020b89c3a$export$74b25e54b3bcd548)) this.material.defines.REINHARD_TONE_MAPPING = '';
                    else if (this._toneMapping === (0, $1a55656020b89c3a$export$932b3dd283d4a366)) this.material.defines.CINEON_TONE_MAPPING = '';
                    else if (this._toneMapping === (0, $1a55656020b89c3a$export$a0d98fe6d7e4af64)) this.material.defines.ACES_FILMIC_TONE_MAPPING = '';
                    else if (this._toneMapping === (0, $1a55656020b89c3a$export$212d53a513a325b2)) this.material.defines.AGX_TONE_MAPPING = '';
                    else if (this._toneMapping === (0, $1a55656020b89c3a$export$f2863e1668a8e317)) this.material.defines.NEUTRAL_TONE_MAPPING = '';
                    else if (this._toneMapping === (0, $1a55656020b89c3a$export$2c7b09c1e9abfb5e)) this.material.defines.CUSTOM_TONE_MAPPING = '';
                    this.material.needsUpdate = true;
                }
                //
                if (this.renderToScreen === true) {
                    renderer.setRenderTarget(null);
                    this.fsQuad.render(renderer);
                } else {
                    renderer.setRenderTarget(writeBuffer);
                    if (this.clear) renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
                    this.fsQuad.render(renderer);
                }
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this.material.dispose();
                this.fsQuad.dispose();
            }
        }
    ]);
    return OutputPass;
}((0, $14df9def65f9e423$export$802bc10488da99c7));




var $38038850429cf425$exports = {};











/*! Tweakpane 3.1.10 (c) 2016 cocopon, licensed under the MIT license. */ (function(global, factory) {
    factory($38038850429cf425$exports);
})(undefined, function(exports1) {
    'use strict';
    /***
     * A simple semantic versioning perser.
     */ var Semver = /*#__PURE__*/ function() {
        function Semver(text) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, Semver);
            var _text_split = (0, $cccf0333cb9f9910$export$71511d61b312f219)(text.split('-'), 2), core = _text_split[0], prerelease = _text_split[1];
            var coreComps = core.split('.');
            this.major = parseInt(coreComps[0], 10);
            this.minor = parseInt(coreComps[1], 10);
            this.patch = parseInt(coreComps[2], 10);
            this.prerelease = prerelease !== null && prerelease !== void 0 ? prerelease : null;
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(Semver, [
            {
                key: "toString",
                value: function toString() {
                    var core = [
                        this.major,
                        this.minor,
                        this.patch
                    ].join('.');
                    return this.prerelease !== null ? [
                        core,
                        this.prerelease
                    ].join('-') : core;
                }
            }
        ]);
        return Semver;
    }();
    var BladeApi = /*#__PURE__*/ function() {
        function BladeApi(controller) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, BladeApi);
            this.controller_ = controller;
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(BladeApi, [
            {
                key: "element",
                get: function get() {
                    return this.controller_.view.element;
                }
            },
            {
                key: "disabled",
                get: function get() {
                    return this.controller_.viewProps.get('disabled');
                },
                set: function set(disabled) {
                    this.controller_.viewProps.set('disabled', disabled);
                }
            },
            {
                key: "hidden",
                get: function get() {
                    return this.controller_.viewProps.get('hidden');
                },
                set: function set(hidden) {
                    this.controller_.viewProps.set('hidden', hidden);
                }
            },
            {
                key: "dispose",
                value: function dispose() {
                    this.controller_.viewProps.set('disposed', true);
                }
            }
        ]);
        return BladeApi;
    }();
    var TpEvent = function TpEvent(target) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, TpEvent);
        this.target = target;
    };
    var TpChangeEvent = /*#__PURE__*/ function(TpEvent) {
        (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(TpChangeEvent, TpEvent);
        function TpChangeEvent(target, value, presetKey, last) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, TpChangeEvent);
            var _this;
            _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, TpChangeEvent, [
                target
            ]);
            _this.value = value;
            _this.presetKey = presetKey;
            _this.last = last !== null && last !== void 0 ? last : true;
            return _this;
        }
        return TpChangeEvent;
    }(TpEvent);
    var TpUpdateEvent = /*#__PURE__*/ function(TpEvent) {
        (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(TpUpdateEvent, TpEvent);
        function TpUpdateEvent(target, value, presetKey) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, TpUpdateEvent);
            var _this;
            _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, TpUpdateEvent, [
                target
            ]);
            _this.value = value;
            _this.presetKey = presetKey;
            return _this;
        }
        return TpUpdateEvent;
    }(TpEvent);
    var TpFoldEvent = /*#__PURE__*/ function(TpEvent) {
        (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(TpFoldEvent, TpEvent);
        function TpFoldEvent(target, expanded) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, TpFoldEvent);
            var _this;
            _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, TpFoldEvent, [
                target
            ]);
            _this.expanded = expanded;
            return _this;
        }
        return TpFoldEvent;
    }(TpEvent);
    var TpTabSelectEvent = /*#__PURE__*/ function(TpEvent) {
        (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(TpTabSelectEvent, TpEvent);
        function TpTabSelectEvent(target, index) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, TpTabSelectEvent);
            var _this;
            _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, TpTabSelectEvent, [
                target
            ]);
            _this.index = index;
            return _this;
        }
        return TpTabSelectEvent;
    }(TpEvent);
    function forceCast(v) {
        return v;
    }
    function isEmpty(value) {
        return value === null || value === undefined;
    }
    function deepEqualsArray(a1, a2) {
        if (a1.length !== a2.length) return false;
        for(var i = 0; i < a1.length; i++){
            if (a1[i] !== a2[i]) return false;
        }
        return true;
    }
    function isPropertyWritable(obj, key) {
        var target = obj;
        do {
            var d = Object.getOwnPropertyDescriptor(target, key);
            if (d && (d.set !== undefined || d.writable === true)) return true;
            target = Object.getPrototypeOf(target);
        }while (target !== null);
        return false;
    }
    var CREATE_MESSAGE_MAP = {
        alreadydisposed: function() {
            return 'View has been already disposed';
        },
        invalidparams: function(context) {
            return "Invalid parameters for '".concat(context.name, "'");
        },
        nomatchingcontroller: function(context) {
            return "No matching controller for '".concat(context.key, "'");
        },
        nomatchingview: function(context) {
            return "No matching view for '".concat(JSON.stringify(context.params), "'");
        },
        notbindable: function() {
            return "Value is not bindable";
        },
        propertynotfound: function(context) {
            return "Property '".concat(context.name, "' not found");
        },
        shouldneverhappen: function() {
            return 'This error should never happen';
        }
    };
    var TpError = /*#__PURE__*/ function() {
        function TpError(config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, TpError);
            var _a;
            this.message = (_a = CREATE_MESSAGE_MAP[config.type](forceCast(config.context))) !== null && _a !== void 0 ? _a : 'Unexpected error';
            this.name = this.constructor.name;
            this.stack = new Error(this.message).stack;
            this.type = config.type;
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(TpError, null, [
            {
                key: "alreadyDisposed",
                value: function alreadyDisposed() {
                    return new TpError({
                        type: 'alreadydisposed'
                    });
                }
            },
            {
                key: "notBindable",
                value: function notBindable() {
                    return new TpError({
                        type: 'notbindable'
                    });
                }
            },
            {
                key: "propertyNotFound",
                value: function propertyNotFound(name) {
                    return new TpError({
                        type: 'propertynotfound',
                        context: {
                            name: name
                        }
                    });
                }
            },
            {
                key: "shouldNeverHappen",
                value: function shouldNeverHappen() {
                    return new TpError({
                        type: 'shouldneverhappen'
                    });
                }
            }
        ]);
        return TpError;
    }();
    var BindingTarget = /*#__PURE__*/ function() {
        function BindingTarget(obj, key, opt_id) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, BindingTarget);
            this.obj_ = obj;
            this.key_ = key;
            this.presetKey_ = opt_id !== null && opt_id !== void 0 ? opt_id : key;
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(BindingTarget, [
            {
                key: "key",
                get: function get() {
                    return this.key_;
                }
            },
            {
                key: "presetKey",
                get: function get() {
                    return this.presetKey_;
                }
            },
            {
                key: "read",
                value: function read() {
                    return this.obj_[this.key_];
                }
            },
            {
                key: "write",
                value: function write(value) {
                    this.obj_[this.key_] = value;
                }
            },
            {
                key: "writeProperty",
                value: function writeProperty(name, value) {
                    var valueObj = this.read();
                    if (!BindingTarget.isBindable(valueObj)) throw TpError.notBindable();
                    if (!(name in valueObj)) throw TpError.propertyNotFound(name);
                    valueObj[name] = value;
                }
            }
        ], [
            {
                key: "isBindable",
                value: function isBindable(obj) {
                    if (obj === null) return false;
                    if ((typeof obj === "undefined" ? "undefined" : (0, $86d22bcb52172ef7$export$71511d61b312f219)(obj)) !== 'object' && typeof obj !== 'function') return false;
                    return true;
                }
            }
        ]);
        return BindingTarget;
    }();
    var ButtonApi = /*#__PURE__*/ function(BladeApi) {
        (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(ButtonApi, BladeApi);
        function ButtonApi() {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, ButtonApi);
            return (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, ButtonApi, arguments);
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(ButtonApi, [
            {
                key: "label",
                get: function get() {
                    return this.controller_.props.get('label');
                },
                set: function set(label) {
                    this.controller_.props.set('label', label);
                }
            },
            {
                key: "title",
                get: function get() {
                    var _a;
                    return (_a = this.controller_.valueController.props.get('title')) !== null && _a !== void 0 ? _a : '';
                },
                set: function set(title) {
                    this.controller_.valueController.props.set('title', title);
                }
            },
            {
                key: "on",
                value: function on(eventName, handler) {
                    var _this = this;
                    var bh = handler.bind(this);
                    var emitter = this.controller_.valueController.emitter;
                    emitter.on(eventName, function() {
                        bh(new TpEvent(_this));
                    });
                    return this;
                }
            }
        ]);
        return ButtonApi;
    }(BladeApi);
    var Emitter = /*#__PURE__*/ function() {
        function Emitter() {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, Emitter);
            this.observers_ = {};
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(Emitter, [
            {
                key: "on",
                value: function on(eventName, handler) {
                    var observers = this.observers_[eventName];
                    if (!observers) observers = this.observers_[eventName] = [];
                    observers.push({
                        handler: handler
                    });
                    return this;
                }
            },
            {
                key: "off",
                value: function off(eventName, handler) {
                    var observers = this.observers_[eventName];
                    if (observers) this.observers_[eventName] = observers.filter(function(observer) {
                        return observer.handler !== handler;
                    });
                    return this;
                }
            },
            {
                key: "emit",
                value: function emit(eventName, event) {
                    var observers = this.observers_[eventName];
                    if (!observers) return;
                    observers.forEach(function(observer) {
                        observer.handler(event);
                    });
                }
            }
        ]);
        return Emitter;
    }();
    var PREFIX = 'tp';
    function ClassName(viewName) {
        var fn = function(opt_elementName, opt_modifier) {
            return [
                PREFIX,
                '-',
                viewName,
                'v',
                opt_elementName ? "_".concat(opt_elementName) : '',
                opt_modifier ? "-".concat(opt_modifier) : ''
            ].join('');
        };
        return fn;
    }
    function compose(h1, h2) {
        return function(input) {
            return h2(h1(input));
        };
    }
    function extractValue(ev) {
        return ev.rawValue;
    }
    function bindValue(value, applyValue) {
        value.emitter.on('change', compose(extractValue, applyValue));
        applyValue(value.rawValue);
    }
    function bindValueMap(valueMap, key, applyValue) {
        bindValue(valueMap.value(key), applyValue);
    }
    function applyClass(elem, className, active) {
        if (active) elem.classList.add(className);
        else elem.classList.remove(className);
    }
    function valueToClassName(elem, className) {
        return function(value) {
            applyClass(elem, className, value);
        };
    }
    function bindValueToTextContent(value, elem) {
        bindValue(value, function(text) {
            elem.textContent = text !== null && text !== void 0 ? text : '';
        });
    }
    var className$q = ClassName('btn');
    var ButtonView = function ButtonView(doc, config) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, ButtonView);
        this.element = doc.createElement('div');
        this.element.classList.add(className$q());
        config.viewProps.bindClassModifiers(this.element);
        var buttonElem = doc.createElement('button');
        buttonElem.classList.add(className$q('b'));
        config.viewProps.bindDisabled(buttonElem);
        this.element.appendChild(buttonElem);
        this.buttonElement = buttonElem;
        var titleElem = doc.createElement('div');
        titleElem.classList.add(className$q('t'));
        bindValueToTextContent(config.props.value('title'), titleElem);
        this.buttonElement.appendChild(titleElem);
    };
    var ButtonController = /*#__PURE__*/ function() {
        function ButtonController(doc, config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, ButtonController);
            this.emitter = new Emitter();
            this.onClick_ = this.onClick_.bind(this);
            this.props = config.props;
            this.viewProps = config.viewProps;
            this.view = new ButtonView(doc, {
                props: this.props,
                viewProps: this.viewProps
            });
            this.view.buttonElement.addEventListener('click', this.onClick_);
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(ButtonController, [
            {
                key: "onClick_",
                value: function onClick_() {
                    this.emitter.emit('click', {
                        sender: this
                    });
                }
            }
        ]);
        return ButtonController;
    }();
    var BoundValue = /*#__PURE__*/ function() {
        function BoundValue(initialValue, config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, BoundValue);
            var _a;
            this.constraint_ = config === null || config === void 0 ? void 0 : config.constraint;
            this.equals_ = (_a = config === null || config === void 0 ? void 0 : config.equals) !== null && _a !== void 0 ? _a : function(v1, v2) {
                return v1 === v2;
            };
            this.emitter = new Emitter();
            this.rawValue_ = initialValue;
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(BoundValue, [
            {
                key: "constraint",
                get: function get() {
                    return this.constraint_;
                }
            },
            {
                key: "rawValue",
                get: function get() {
                    return this.rawValue_;
                },
                set: function set(rawValue) {
                    this.setRawValue(rawValue, {
                        forceEmit: false,
                        last: true
                    });
                }
            },
            {
                key: "setRawValue",
                value: function setRawValue(rawValue, options) {
                    var opts = options !== null && options !== void 0 ? options : {
                        forceEmit: false,
                        last: true
                    };
                    var constrainedValue = this.constraint_ ? this.constraint_.constrain(rawValue) : rawValue;
                    var prevValue = this.rawValue_;
                    var changed = !this.equals_(prevValue, constrainedValue);
                    if (!changed && !opts.forceEmit) return;
                    this.emitter.emit('beforechange', {
                        sender: this
                    });
                    this.rawValue_ = constrainedValue;
                    this.emitter.emit('change', {
                        options: opts,
                        previousRawValue: prevValue,
                        rawValue: constrainedValue,
                        sender: this
                    });
                }
            }
        ]);
        return BoundValue;
    }();
    var PrimitiveValue = /*#__PURE__*/ function() {
        function PrimitiveValue(initialValue) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, PrimitiveValue);
            this.emitter = new Emitter();
            this.value_ = initialValue;
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(PrimitiveValue, [
            {
                key: "rawValue",
                get: function get() {
                    return this.value_;
                },
                set: function set(value) {
                    this.setRawValue(value, {
                        forceEmit: false,
                        last: true
                    });
                }
            },
            {
                key: "setRawValue",
                value: function setRawValue(value, options) {
                    var opts = options !== null && options !== void 0 ? options : {
                        forceEmit: false,
                        last: true
                    };
                    var prevValue = this.value_;
                    if (prevValue === value && !opts.forceEmit) return;
                    this.emitter.emit('beforechange', {
                        sender: this
                    });
                    this.value_ = value;
                    this.emitter.emit('change', {
                        options: opts,
                        previousRawValue: prevValue,
                        rawValue: this.value_,
                        sender: this
                    });
                }
            }
        ]);
        return PrimitiveValue;
    }();
    function createValue(initialValue, config) {
        var constraint = config === null || config === void 0 ? void 0 : config.constraint;
        var equals = config === null || config === void 0 ? void 0 : config.equals;
        if (!constraint && !equals) return new PrimitiveValue(initialValue);
        return new BoundValue(initialValue, config);
    }
    var ValueMap = /*#__PURE__*/ function() {
        function ValueMap(valueMap) {
            var _this, _loop = function(key) {
                var v = _this.valMap_[key];
                v.emitter.on('change', function() {
                    _this1.emitter.emit('change', {
                        key: key,
                        sender: _this1
                    });
                });
            };
            var _this1 = this;
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, ValueMap);
            this.emitter = new Emitter();
            this.valMap_ = valueMap;
            for(var key in this.valMap_)_this = this, _loop(key);
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(ValueMap, [
            {
                key: "get",
                value: function get(key) {
                    return this.valMap_[key].rawValue;
                }
            },
            {
                key: "set",
                value: function set(key, value) {
                    this.valMap_[key].rawValue = value;
                }
            },
            {
                key: "value",
                value: function value(key) {
                    return this.valMap_[key];
                }
            }
        ], [
            {
                key: "createCore",
                value: function createCore(initialValue) {
                    var keys = Object.keys(initialValue);
                    return keys.reduce(function(o, key) {
                        return Object.assign(o, (0, $3facda9e207b3c1f$export$71511d61b312f219)({}, key, createValue(initialValue[key])));
                    }, {});
                }
            },
            {
                key: "fromObject",
                value: function fromObject(initialValue) {
                    var core = this.createCore(initialValue);
                    return new ValueMap(core);
                }
            }
        ]);
        return ValueMap;
    }();
    function parseObject(value, keyToParserMap) {
        var keys = Object.keys(keyToParserMap);
        var result = keys.reduce(function(tmp, key) {
            if (tmp === undefined) return undefined;
            var parser = keyToParserMap[key];
            var result = parser(value[key]);
            return result.succeeded ? Object.assign(Object.assign({}, tmp), (0, $3facda9e207b3c1f$export$71511d61b312f219)({}, key, result.value)) : undefined;
        }, {});
        return forceCast(result);
    }
    function parseArray(value, parseItem) {
        return value.reduce(function(tmp, item) {
            if (tmp === undefined) return undefined;
            var result = parseItem(item);
            if (!result.succeeded || result.value === undefined) return undefined;
            return (0, $4fcd3d80e9e33ca7$export$71511d61b312f219)(tmp).concat([
                result.value
            ]);
        }, []);
    }
    function isObject(value) {
        if (value === null) return false;
        return (typeof value === "undefined" ? "undefined" : (0, $86d22bcb52172ef7$export$71511d61b312f219)(value)) === 'object';
    }
    function createParamsParserBuilder(parse) {
        return function(optional) {
            return function(v) {
                if (!optional && v === undefined) return {
                    succeeded: false,
                    value: undefined
                };
                if (optional && v === undefined) return {
                    succeeded: true,
                    value: undefined
                };
                var result = parse(v);
                return result !== undefined ? {
                    succeeded: true,
                    value: result
                } : {
                    succeeded: false,
                    value: undefined
                };
            };
        };
    }
    function createParamsParserBuilders(optional) {
        return {
            custom: function(parse) {
                return createParamsParserBuilder(parse)(optional);
            },
            boolean: createParamsParserBuilder(function(v) {
                return typeof v === 'boolean' ? v : undefined;
            })(optional),
            number: createParamsParserBuilder(function(v) {
                return typeof v === 'number' ? v : undefined;
            })(optional),
            string: createParamsParserBuilder(function(v) {
                return typeof v === 'string' ? v : undefined;
            })(optional),
            function: createParamsParserBuilder(function(v) {
                return typeof v === 'function' ? v : undefined;
            })(optional),
            constant: function(value) {
                return createParamsParserBuilder(function(v) {
                    return v === value ? value : undefined;
                })(optional);
            },
            raw: createParamsParserBuilder(function(v) {
                return v;
            })(optional),
            object: function(keyToParserMap) {
                return createParamsParserBuilder(function(v) {
                    if (!isObject(v)) return undefined;
                    return parseObject(v, keyToParserMap);
                })(optional);
            },
            array: function(itemParser) {
                return createParamsParserBuilder(function(v) {
                    if (!Array.isArray(v)) return undefined;
                    return parseArray(v, itemParser);
                })(optional);
            }
        };
    }
    var ParamsParsers = {
        optional: createParamsParserBuilders(true),
        required: createParamsParserBuilders(false)
    };
    function parseParams(value, keyToParserMap) {
        var result = ParamsParsers.required.object(keyToParserMap)(value);
        return result.succeeded ? result.value : undefined;
    }
    function warnMissing(info) {
        console.warn([
            "Missing '".concat(info.key, "' of ").concat(info.target, " in ").concat(info.place, "."),
            'Please rebuild plugins with the latest core package.'
        ].join(' '));
    }
    function disposeElement(elem) {
        if (elem && elem.parentElement) elem.parentElement.removeChild(elem);
        return null;
    }
    var ReadonlyValue = /*#__PURE__*/ function() {
        function ReadonlyValue(value) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, ReadonlyValue);
            this.value_ = value;
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(ReadonlyValue, [
            {
                key: "emitter",
                get: function get() {
                    return this.value_.emitter;
                }
            },
            {
                key: "rawValue",
                get: function get() {
                    return this.value_.rawValue;
                }
            }
        ], [
            {
                key: "create",
                value: function create(value) {
                    return [
                        new ReadonlyValue(value),
                        function(rawValue, options) {
                            value.setRawValue(rawValue, options);
                        }
                    ];
                }
            }
        ]);
        return ReadonlyValue;
    }();
    var className$p = ClassName('');
    function valueToModifier(elem, modifier) {
        return valueToClassName(elem, className$p(undefined, modifier));
    }
    var ViewProps = /*#__PURE__*/ function(ValueMap1) {
        (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(ViewProps, ValueMap1);
        function ViewProps(valueMap) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, ViewProps);
            var _this;
            var _a;
            _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, ViewProps, [
                valueMap
            ]);
            _this.onDisabledChange_ = _this.onDisabledChange_.bind(_this);
            _this.onParentChange_ = _this.onParentChange_.bind(_this);
            _this.onParentGlobalDisabledChange_ = _this.onParentGlobalDisabledChange_.bind(_this);
            var ref;
            ref = (0, $cccf0333cb9f9910$export$71511d61b312f219)(ReadonlyValue.create(createValue(_this.getGlobalDisabled_())), 2), _this.globalDisabled_ = ref[0], _this.setGlobalDisabled_ = ref[1], ref;
            _this.value('disabled').emitter.on('change', _this.onDisabledChange_);
            _this.value('parent').emitter.on('change', _this.onParentChange_);
            (_a = _this.get('parent')) === null || _a === void 0 || _a.globalDisabled.emitter.on('change', _this.onParentGlobalDisabledChange_);
            return _this;
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(ViewProps, [
            {
                key: "globalDisabled",
                get: function get() {
                    return this.globalDisabled_;
                }
            },
            {
                key: "bindClassModifiers",
                value: function bindClassModifiers(elem) {
                    bindValue(this.globalDisabled_, valueToModifier(elem, 'disabled'));
                    bindValueMap(this, 'hidden', valueToModifier(elem, 'hidden'));
                }
            },
            {
                key: "bindDisabled",
                value: function bindDisabled(target) {
                    bindValue(this.globalDisabled_, function(disabled) {
                        target.disabled = disabled;
                    });
                }
            },
            {
                key: "bindTabIndex",
                value: function bindTabIndex(elem) {
                    bindValue(this.globalDisabled_, function(disabled) {
                        elem.tabIndex = disabled ? -1 : 0;
                    });
                }
            },
            {
                key: "handleDispose",
                value: function handleDispose(callback) {
                    this.value('disposed').emitter.on('change', function(disposed) {
                        if (disposed) callback();
                    });
                }
            },
            {
                key: "getGlobalDisabled_",
                value: function getGlobalDisabled_() {
                    var parent = this.get('parent');
                    var parentDisabled = parent ? parent.globalDisabled.rawValue : false;
                    return parentDisabled || this.get('disabled');
                }
            },
            {
                key: "updateGlobalDisabled_",
                value: function updateGlobalDisabled_() {
                    this.setGlobalDisabled_(this.getGlobalDisabled_());
                }
            },
            {
                key: "onDisabledChange_",
                value: function onDisabledChange_() {
                    this.updateGlobalDisabled_();
                }
            },
            {
                key: "onParentGlobalDisabledChange_",
                value: function onParentGlobalDisabledChange_() {
                    this.updateGlobalDisabled_();
                }
            },
            {
                key: "onParentChange_",
                value: function onParentChange_(ev) {
                    var _a;
                    var prevParent = ev.previousRawValue;
                    prevParent === null || prevParent === void 0 || prevParent.globalDisabled.emitter.off('change', this.onParentGlobalDisabledChange_);
                    (_a = this.get('parent')) === null || _a === void 0 || _a.globalDisabled.emitter.on('change', this.onParentGlobalDisabledChange_);
                    this.updateGlobalDisabled_();
                }
            }
        ], [
            {
                key: "create",
                value: function create(opt_initialValue) {
                    var _a, _b, _c;
                    var initialValue = opt_initialValue !== null && opt_initialValue !== void 0 ? opt_initialValue : {};
                    return new ViewProps(ValueMap.createCore({
                        disabled: (_a = initialValue.disabled) !== null && _a !== void 0 ? _a : false,
                        disposed: false,
                        hidden: (_b = initialValue.hidden) !== null && _b !== void 0 ? _b : false,
                        parent: (_c = initialValue.parent) !== null && _c !== void 0 ? _c : null
                    }));
                }
            }
        ]);
        return ViewProps;
    }(ValueMap);
    function getAllBladePositions() {
        return [
            'veryfirst',
            'first',
            'last',
            'verylast'
        ];
    }
    var className$o = ClassName('');
    var POS_TO_CLASS_NAME_MAP = {
        veryfirst: 'vfst',
        first: 'fst',
        last: 'lst',
        verylast: 'vlst'
    };
    var BladeController = /*#__PURE__*/ function() {
        function BladeController(config) {
            var _this = this;
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, BladeController);
            this.parent_ = null;
            this.blade = config.blade;
            this.view = config.view;
            this.viewProps = config.viewProps;
            var elem = this.view.element;
            this.blade.value('positions').emitter.on('change', function() {
                getAllBladePositions().forEach(function(pos) {
                    elem.classList.remove(className$o(undefined, POS_TO_CLASS_NAME_MAP[pos]));
                });
                _this.blade.get('positions').forEach(function(pos) {
                    elem.classList.add(className$o(undefined, POS_TO_CLASS_NAME_MAP[pos]));
                });
            });
            this.viewProps.handleDispose(function() {
                disposeElement(elem);
            });
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(BladeController, [
            {
                key: "parent",
                get: function get() {
                    return this.parent_;
                },
                set: function set(parent) {
                    this.parent_ = parent;
                    if (!('parent' in this.viewProps.valMap_)) {
                        warnMissing({
                            key: 'parent',
                            target: ViewProps.name,
                            place: 'BladeController.parent'
                        });
                        return;
                    }
                    this.viewProps.set('parent', this.parent_ ? this.parent_.viewProps : null);
                }
            }
        ]);
        return BladeController;
    }();
    var SVG_NS = 'http://www.w3.org/2000/svg';
    function forceReflow(element) {
        element.offsetHeight;
    }
    function disableTransitionTemporarily(element, callback) {
        var t = element.style.transition;
        element.style.transition = 'none';
        callback();
        element.style.transition = t;
    }
    function supportsTouch(doc) {
        return doc.ontouchstart !== undefined;
    }
    function getGlobalObject() {
        return globalThis;
    }
    function getWindowDocument() {
        var globalObj = forceCast(getGlobalObject());
        return globalObj.document;
    }
    function getCanvasContext(canvasElement) {
        var win = canvasElement.ownerDocument.defaultView;
        if (!win) return null;
        var isBrowser = 'document' in win;
        return isBrowser ? canvasElement.getContext('2d', {
            willReadFrequently: true
        }) : null;
    }
    var ICON_ID_TO_INNER_HTML_MAP = {
        check: '<path d="M2 8l4 4l8 -8"/>',
        dropdown: '<path d="M5 7h6l-3 3 z"/>',
        p2dpad: '<path d="M8 4v8"/><path d="M4 8h8"/><circle cx="12" cy="12" r="1.2"/>'
    };
    function createSvgIconElement(document, iconId) {
        var elem = document.createElementNS(SVG_NS, 'svg');
        elem.innerHTML = ICON_ID_TO_INNER_HTML_MAP[iconId];
        return elem;
    }
    function insertElementAt(parentElement, element, index) {
        parentElement.insertBefore(element, parentElement.children[index]);
    }
    function removeElement(element) {
        if (element.parentElement) element.parentElement.removeChild(element);
    }
    function removeChildElements(element) {
        while(element.children.length > 0)element.removeChild(element.children[0]);
    }
    function removeChildNodes(element) {
        while(element.childNodes.length > 0)element.removeChild(element.childNodes[0]);
    }
    function findNextTarget(ev) {
        if (ev.relatedTarget) return forceCast(ev.relatedTarget);
        if ('explicitOriginalTarget' in ev) return ev.explicitOriginalTarget;
        return null;
    }
    var className$n = ClassName('lbl');
    function createLabelNode(doc, label) {
        var frag = doc.createDocumentFragment();
        var lineNodes = label.split('\n').map(function(line) {
            return doc.createTextNode(line);
        });
        lineNodes.forEach(function(lineNode, index) {
            if (index > 0) frag.appendChild(doc.createElement('br'));
            frag.appendChild(lineNode);
        });
        return frag;
    }
    var LabelView = function LabelView(doc, config) {
        var _this = this;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, LabelView);
        this.element = doc.createElement('div');
        this.element.classList.add(className$n());
        config.viewProps.bindClassModifiers(this.element);
        var labelElem = doc.createElement('div');
        labelElem.classList.add(className$n('l'));
        bindValueMap(config.props, 'label', function(value) {
            if (isEmpty(value)) _this.element.classList.add(className$n(undefined, 'nol'));
            else {
                _this.element.classList.remove(className$n(undefined, 'nol'));
                removeChildNodes(labelElem);
                labelElem.appendChild(createLabelNode(doc, value));
            }
        });
        this.element.appendChild(labelElem);
        this.labelElement = labelElem;
        var valueElem = doc.createElement('div');
        valueElem.classList.add(className$n('v'));
        this.element.appendChild(valueElem);
        this.valueElement = valueElem;
    };
    var LabelController = /*#__PURE__*/ function(BladeController) {
        (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(LabelController, BladeController);
        function LabelController(doc, config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, LabelController);
            var _this;
            var viewProps = config.valueController.viewProps;
            _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, LabelController, [
                Object.assign(Object.assign({}, config), {
                    view: new LabelView(doc, {
                        props: config.props,
                        viewProps: viewProps
                    }),
                    viewProps: viewProps
                })
            ]);
            _this.props = config.props;
            _this.valueController = config.valueController;
            _this.view.valueElement.appendChild(_this.valueController.view.element);
            return _this;
        }
        return LabelController;
    }(BladeController);
    var ButtonBladePlugin = {
        id: 'button',
        type: 'blade',
        accept: function(params) {
            var p = ParamsParsers;
            var result = parseParams(params, {
                title: p.required.string,
                view: p.required.constant('button'),
                label: p.optional.string
            });
            return result ? {
                params: result
            } : null;
        },
        controller: function(args) {
            return new LabelController(args.document, {
                blade: args.blade,
                props: ValueMap.fromObject({
                    label: args.params.label
                }),
                valueController: new ButtonController(args.document, {
                    props: ValueMap.fromObject({
                        title: args.params.title
                    }),
                    viewProps: args.viewProps
                })
            });
        },
        api: function(args) {
            if (!(args.controller instanceof LabelController)) return null;
            if (!(args.controller.valueController instanceof ButtonController)) return null;
            return new ButtonApi(args.controller);
        }
    };
    var ValueBladeController = /*#__PURE__*/ function(BladeController) {
        (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(ValueBladeController, BladeController);
        function ValueBladeController(config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, ValueBladeController);
            var _this;
            _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, ValueBladeController, [
                config
            ]);
            _this.value = config.value;
            return _this;
        }
        return ValueBladeController;
    }(BladeController);
    function createBlade() {
        return new ValueMap({
            positions: createValue([], {
                equals: deepEqualsArray
            })
        });
    }
    var Foldable = /*#__PURE__*/ function(ValueMap1) {
        (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(Foldable, ValueMap1);
        function Foldable(valueMap) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, Foldable);
            return (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, Foldable, [
                valueMap
            ]);
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(Foldable, [
            {
                key: "styleExpanded",
                get: function get() {
                    var _a;
                    return (_a = this.get('temporaryExpanded')) !== null && _a !== void 0 ? _a : this.get('expanded');
                }
            },
            {
                key: "styleHeight",
                get: function get() {
                    if (!this.styleExpanded) return '0';
                    var exHeight = this.get('expandedHeight');
                    if (this.get('shouldFixHeight') && !isEmpty(exHeight)) return "".concat(exHeight, "px");
                    return 'auto';
                }
            },
            {
                key: "bindExpandedClass",
                value: function bindExpandedClass(elem, expandedClassName) {
                    var _this = this;
                    var onExpand = function() {
                        var expanded = _this.styleExpanded;
                        if (expanded) elem.classList.add(expandedClassName);
                        else elem.classList.remove(expandedClassName);
                    };
                    bindValueMap(this, 'expanded', onExpand);
                    bindValueMap(this, 'temporaryExpanded', onExpand);
                }
            },
            {
                key: "cleanUpTransition",
                value: function cleanUpTransition() {
                    this.set('shouldFixHeight', false);
                    this.set('expandedHeight', null);
                    this.set('completed', true);
                }
            }
        ], [
            {
                key: "create",
                value: function create(expanded) {
                    var coreObj = {
                        completed: true,
                        expanded: expanded,
                        expandedHeight: null,
                        shouldFixHeight: false,
                        temporaryExpanded: null
                    };
                    var core = ValueMap.createCore(coreObj);
                    return new Foldable(core);
                }
            }
        ]);
        return Foldable;
    }(ValueMap);
    function computeExpandedFolderHeight(folder, containerElement) {
        var height = 0;
        disableTransitionTemporarily(containerElement, function() {
            folder.set('expandedHeight', null);
            folder.set('temporaryExpanded', true);
            forceReflow(containerElement);
            height = containerElement.clientHeight;
            folder.set('temporaryExpanded', null);
            forceReflow(containerElement);
        });
        return height;
    }
    function applyHeight(foldable, elem) {
        elem.style.height = foldable.styleHeight;
    }
    function bindFoldable(foldable, elem) {
        foldable.value('expanded').emitter.on('beforechange', function() {
            foldable.set('completed', false);
            if (isEmpty(foldable.get('expandedHeight'))) {
                var h = computeExpandedFolderHeight(foldable, elem);
                if (h > 0) foldable.set('expandedHeight', h);
            }
            foldable.set('shouldFixHeight', true);
            forceReflow(elem);
        });
        foldable.emitter.on('change', function() {
            applyHeight(foldable, elem);
        });
        applyHeight(foldable, elem);
        elem.addEventListener('transitionend', function(ev) {
            if (ev.propertyName !== 'height') return;
            foldable.cleanUpTransition();
        });
    }
    var RackLikeApi = /*#__PURE__*/ function(BladeApi) {
        (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(RackLikeApi, BladeApi);
        function RackLikeApi(controller, rackApi) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, RackLikeApi);
            var _this;
            _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, RackLikeApi, [
                controller
            ]);
            _this.rackApi_ = rackApi;
            return _this;
        }
        return RackLikeApi;
    }(BladeApi);
    function addButtonAsBlade(api, params) {
        return api.addBlade(Object.assign(Object.assign({}, params), {
            view: 'button'
        }));
    }
    function addFolderAsBlade(api, params) {
        return api.addBlade(Object.assign(Object.assign({}, params), {
            view: 'folder'
        }));
    }
    function addSeparatorAsBlade(api, opt_params) {
        var params = opt_params !== null && opt_params !== void 0 ? opt_params : {};
        return api.addBlade(Object.assign(Object.assign({}, params), {
            view: 'separator'
        }));
    }
    function addTabAsBlade(api, params) {
        return api.addBlade(Object.assign(Object.assign({}, params), {
            view: 'tab'
        }));
    }
    var NestedOrderedSet = /*#__PURE__*/ function() {
        function NestedOrderedSet(extract) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, NestedOrderedSet);
            this.emitter = new Emitter();
            this.items_ = [];
            this.cache_ = new Set();
            this.onSubListAdd_ = this.onSubListAdd_.bind(this);
            this.onSubListRemove_ = this.onSubListRemove_.bind(this);
            this.extract_ = extract;
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(NestedOrderedSet, [
            {
                key: "items",
                get: function get() {
                    return this.items_;
                }
            },
            {
                key: "allItems",
                value: function allItems() {
                    return Array.from(this.cache_);
                }
            },
            {
                key: "find",
                value: function find(callback) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = this.allItems()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var item = _step.value;
                            if (callback(item)) return item;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return null;
                }
            },
            {
                key: "includes",
                value: function includes(item) {
                    return this.cache_.has(item);
                }
            },
            {
                key: "add",
                value: function add(item, opt_index) {
                    var _this = this;
                    if (this.includes(item)) throw TpError.shouldNeverHappen();
                    var index = opt_index !== undefined ? opt_index : this.items_.length;
                    this.items_.splice(index, 0, item);
                    this.cache_.add(item);
                    var subList = this.extract_(item);
                    if (subList) {
                        subList.emitter.on('add', this.onSubListAdd_);
                        subList.emitter.on('remove', this.onSubListRemove_);
                        subList.allItems().forEach(function(item) {
                            _this.cache_.add(item);
                        });
                    }
                    this.emitter.emit('add', {
                        index: index,
                        item: item,
                        root: this,
                        target: this
                    });
                }
            },
            {
                key: "remove",
                value: function remove(item) {
                    var index = this.items_.indexOf(item);
                    if (index < 0) return;
                    this.items_.splice(index, 1);
                    this.cache_.delete(item);
                    var subList = this.extract_(item);
                    if (subList) {
                        subList.emitter.off('add', this.onSubListAdd_);
                        subList.emitter.off('remove', this.onSubListRemove_);
                    }
                    this.emitter.emit('remove', {
                        index: index,
                        item: item,
                        root: this,
                        target: this
                    });
                }
            },
            {
                key: "onSubListAdd_",
                value: function onSubListAdd_(ev) {
                    this.cache_.add(ev.item);
                    this.emitter.emit('add', {
                        index: ev.index,
                        item: ev.item,
                        root: this,
                        target: ev.target
                    });
                }
            },
            {
                key: "onSubListRemove_",
                value: function onSubListRemove_(ev) {
                    this.cache_.delete(ev.item);
                    this.emitter.emit('remove', {
                        index: ev.index,
                        item: ev.item,
                        root: this,
                        target: ev.target
                    });
                }
            }
        ]);
        return NestedOrderedSet;
    }();
    var InputBindingApi = /*#__PURE__*/ function(BladeApi) {
        (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(InputBindingApi, BladeApi);
        function InputBindingApi(controller) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, InputBindingApi);
            var _this;
            _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, InputBindingApi, [
                controller
            ]);
            _this.onBindingChange_ = _this.onBindingChange_.bind(_this);
            _this.emitter_ = new Emitter();
            _this.controller_.binding.emitter.on('change', _this.onBindingChange_);
            return _this;
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(InputBindingApi, [
            {
                key: "label",
                get: function get() {
                    return this.controller_.props.get('label');
                },
                set: function set(label) {
                    this.controller_.props.set('label', label);
                }
            },
            {
                key: "on",
                value: function on(eventName, handler) {
                    var bh = handler.bind(this);
                    this.emitter_.on(eventName, function(ev) {
                        bh(ev.event);
                    });
                    return this;
                }
            },
            {
                key: "refresh",
                value: function refresh() {
                    this.controller_.binding.read();
                }
            },
            {
                key: "onBindingChange_",
                value: function onBindingChange_(ev) {
                    var value = ev.sender.target.read();
                    this.emitter_.emit('change', {
                        event: new TpChangeEvent(this, forceCast(value), this.controller_.binding.target.presetKey, ev.options.last)
                    });
                }
            }
        ]);
        return InputBindingApi;
    }(BladeApi);
    var InputBindingController = /*#__PURE__*/ function(LabelController) {
        (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(InputBindingController, LabelController);
        function InputBindingController(doc, config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, InputBindingController);
            var _this;
            _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, InputBindingController, [
                doc,
                config
            ]);
            _this.binding = config.binding;
            return _this;
        }
        return InputBindingController;
    }(LabelController);
    var MonitorBindingApi = /*#__PURE__*/ function(BladeApi) {
        (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(MonitorBindingApi, BladeApi);
        function MonitorBindingApi(controller) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, MonitorBindingApi);
            var _this;
            _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, MonitorBindingApi, [
                controller
            ]);
            _this.onBindingUpdate_ = _this.onBindingUpdate_.bind(_this);
            _this.emitter_ = new Emitter();
            _this.controller_.binding.emitter.on('update', _this.onBindingUpdate_);
            return _this;
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(MonitorBindingApi, [
            {
                key: "label",
                get: function get() {
                    return this.controller_.props.get('label');
                },
                set: function set(label) {
                    this.controller_.props.set('label', label);
                }
            },
            {
                key: "on",
                value: function on(eventName, handler) {
                    var bh = handler.bind(this);
                    this.emitter_.on(eventName, function(ev) {
                        bh(ev.event);
                    });
                    return this;
                }
            },
            {
                key: "refresh",
                value: function refresh() {
                    this.controller_.binding.read();
                }
            },
            {
                key: "onBindingUpdate_",
                value: function onBindingUpdate_(ev) {
                    var value = ev.sender.target.read();
                    this.emitter_.emit('update', {
                        event: new TpUpdateEvent(this, forceCast(value), this.controller_.binding.target.presetKey)
                    });
                }
            }
        ]);
        return MonitorBindingApi;
    }(BladeApi);
    var MonitorBindingController = /*#__PURE__*/ function(LabelController) {
        (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(MonitorBindingController, LabelController);
        function MonitorBindingController(doc, config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, MonitorBindingController);
            var _this;
            _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, MonitorBindingController, [
                doc,
                config
            ]);
            _this.binding = config.binding;
            _this.viewProps.bindDisabled(_this.binding.ticker);
            _this.viewProps.handleDispose(function() {
                _this.binding.dispose();
            });
            return _this;
        }
        return MonitorBindingController;
    }(LabelController);
    function findSubBladeApiSet(api) {
        if (api instanceof RackApi) return api['apiSet_'];
        if (api instanceof RackLikeApi) return api['rackApi_']['apiSet_'];
        return null;
    }
    function getApiByController(apiSet, controller) {
        var api = apiSet.find(function(api) {
            return api.controller_ === controller;
        });
        if (!api) throw TpError.shouldNeverHappen();
        return api;
    }
    function createBindingTarget(obj, key, opt_id) {
        if (!BindingTarget.isBindable(obj)) throw TpError.notBindable();
        return new BindingTarget(obj, key, opt_id);
    }
    var RackApi = /*#__PURE__*/ function(BladeApi) {
        (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(RackApi, BladeApi);
        function RackApi(controller, pool) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, RackApi);
            var _this;
            _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, RackApi, [
                controller
            ]);
            _this.onRackAdd_ = _this.onRackAdd_.bind(_this);
            _this.onRackRemove_ = _this.onRackRemove_.bind(_this);
            _this.onRackInputChange_ = _this.onRackInputChange_.bind(_this);
            _this.onRackMonitorUpdate_ = _this.onRackMonitorUpdate_.bind(_this);
            _this.emitter_ = new Emitter();
            _this.apiSet_ = new NestedOrderedSet(findSubBladeApiSet);
            _this.pool_ = pool;
            var rack = _this.controller_.rack;
            rack.emitter.on('add', _this.onRackAdd_);
            rack.emitter.on('remove', _this.onRackRemove_);
            rack.emitter.on('inputchange', _this.onRackInputChange_);
            rack.emitter.on('monitorupdate', _this.onRackMonitorUpdate_);
            rack.children.forEach(function(bc) {
                _this.setUpApi_(bc);
            });
            return _this;
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(RackApi, [
            {
                key: "children",
                get: function get() {
                    var _this = this;
                    return this.controller_.rack.children.map(function(bc) {
                        return getApiByController(_this.apiSet_, bc);
                    });
                }
            },
            {
                key: "addInput",
                value: function addInput(object, key, opt_params) {
                    var params = opt_params !== null && opt_params !== void 0 ? opt_params : {};
                    var doc = this.controller_.view.element.ownerDocument;
                    var bc = this.pool_.createInput(doc, createBindingTarget(object, key, params.presetKey), params);
                    var api = new InputBindingApi(bc);
                    return this.add(api, params.index);
                }
            },
            {
                key: "addMonitor",
                value: function addMonitor(object, key, opt_params) {
                    var params = opt_params !== null && opt_params !== void 0 ? opt_params : {};
                    var doc = this.controller_.view.element.ownerDocument;
                    var bc = this.pool_.createMonitor(doc, createBindingTarget(object, key), params);
                    var api = new MonitorBindingApi(bc);
                    return forceCast(this.add(api, params.index));
                }
            },
            {
                key: "addFolder",
                value: function addFolder(params) {
                    return addFolderAsBlade(this, params);
                }
            },
            {
                key: "addButton",
                value: function addButton(params) {
                    return addButtonAsBlade(this, params);
                }
            },
            {
                key: "addSeparator",
                value: function addSeparator(opt_params) {
                    return addSeparatorAsBlade(this, opt_params);
                }
            },
            {
                key: "addTab",
                value: function addTab(params) {
                    return addTabAsBlade(this, params);
                }
            },
            {
                key: "add",
                value: function add(api, opt_index) {
                    this.controller_.rack.add(api.controller_, opt_index);
                    var gapi = this.apiSet_.find(function(a) {
                        return a.controller_ === api.controller_;
                    });
                    if (gapi) this.apiSet_.remove(gapi);
                    this.apiSet_.add(api);
                    return api;
                }
            },
            {
                key: "remove",
                value: function remove(api) {
                    this.controller_.rack.remove(api.controller_);
                }
            },
            {
                key: "addBlade",
                value: function addBlade(params) {
                    var doc = this.controller_.view.element.ownerDocument;
                    var bc = this.pool_.createBlade(doc, params);
                    var api = this.pool_.createBladeApi(bc);
                    return this.add(api, params.index);
                }
            },
            {
                key: "on",
                value: function on(eventName, handler) {
                    var bh = handler.bind(this);
                    this.emitter_.on(eventName, function(ev) {
                        bh(ev.event);
                    });
                    return this;
                }
            },
            {
                key: "setUpApi_",
                value: function setUpApi_(bc) {
                    var api = this.apiSet_.find(function(api) {
                        return api.controller_ === bc;
                    });
                    if (!api) this.apiSet_.add(this.pool_.createBladeApi(bc));
                }
            },
            {
                key: "onRackAdd_",
                value: function onRackAdd_(ev) {
                    this.setUpApi_(ev.bladeController);
                }
            },
            {
                key: "onRackRemove_",
                value: function onRackRemove_(ev) {
                    if (ev.isRoot) {
                        var api = getApiByController(this.apiSet_, ev.bladeController);
                        this.apiSet_.remove(api);
                    }
                }
            },
            {
                key: "onRackInputChange_",
                value: function onRackInputChange_(ev) {
                    var bc = ev.bladeController;
                    if (bc instanceof InputBindingController) {
                        var api = getApiByController(this.apiSet_, bc);
                        var binding = bc.binding;
                        this.emitter_.emit('change', {
                            event: new TpChangeEvent(api, forceCast(binding.target.read()), binding.target.presetKey, ev.options.last)
                        });
                    } else if (bc instanceof ValueBladeController) {
                        var api1 = getApiByController(this.apiSet_, bc);
                        this.emitter_.emit('change', {
                            event: new TpChangeEvent(api1, bc.value.rawValue, undefined, ev.options.last)
                        });
                    }
                }
            },
            {
                key: "onRackMonitorUpdate_",
                value: function onRackMonitorUpdate_(ev) {
                    if (!(ev.bladeController instanceof MonitorBindingController)) throw TpError.shouldNeverHappen();
                    var api = getApiByController(this.apiSet_, ev.bladeController);
                    var binding = ev.bladeController.binding;
                    this.emitter_.emit('update', {
                        event: new TpUpdateEvent(api, forceCast(binding.target.read()), binding.target.presetKey)
                    });
                }
            }
        ]);
        return RackApi;
    }(BladeApi);
    var FolderApi = /*#__PURE__*/ function(RackLikeApi) {
        (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(FolderApi, RackLikeApi);
        function FolderApi(controller, pool) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, FolderApi);
            var _this;
            _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, FolderApi, [
                controller,
                new RackApi(controller.rackController, pool)
            ]);
            _this.emitter_ = new Emitter();
            _this.controller_.foldable.value('expanded').emitter.on('change', function(ev) {
                _this.emitter_.emit('fold', {
                    event: new TpFoldEvent(_this, ev.sender.rawValue)
                });
            });
            _this.rackApi_.on('change', function(ev) {
                _this.emitter_.emit('change', {
                    event: ev
                });
            });
            _this.rackApi_.on('update', function(ev) {
                _this.emitter_.emit('update', {
                    event: ev
                });
            });
            return _this;
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(FolderApi, [
            {
                key: "expanded",
                get: function get() {
                    return this.controller_.foldable.get('expanded');
                },
                set: function set(expanded) {
                    this.controller_.foldable.set('expanded', expanded);
                }
            },
            {
                key: "title",
                get: function get() {
                    return this.controller_.props.get('title');
                },
                set: function set(title) {
                    this.controller_.props.set('title', title);
                }
            },
            {
                key: "children",
                get: function get() {
                    return this.rackApi_.children;
                }
            },
            {
                key: "addInput",
                value: function addInput(object, key, opt_params) {
                    return this.rackApi_.addInput(object, key, opt_params);
                }
            },
            {
                key: "addMonitor",
                value: function addMonitor(object, key, opt_params) {
                    return this.rackApi_.addMonitor(object, key, opt_params);
                }
            },
            {
                key: "addFolder",
                value: function addFolder(params) {
                    return this.rackApi_.addFolder(params);
                }
            },
            {
                key: "addButton",
                value: function addButton(params) {
                    return this.rackApi_.addButton(params);
                }
            },
            {
                key: "addSeparator",
                value: function addSeparator(opt_params) {
                    return this.rackApi_.addSeparator(opt_params);
                }
            },
            {
                key: "addTab",
                value: function addTab(params) {
                    return this.rackApi_.addTab(params);
                }
            },
            {
                key: "add",
                value: function add(api, opt_index) {
                    return this.rackApi_.add(api, opt_index);
                }
            },
            {
                key: "remove",
                value: function remove(api) {
                    this.rackApi_.remove(api);
                }
            },
            {
                key: "addBlade",
                value: function addBlade(params) {
                    return this.rackApi_.addBlade(params);
                }
            },
            {
                key: "on",
                value: function on(eventName, handler) {
                    var bh = handler.bind(this);
                    this.emitter_.on(eventName, function(ev) {
                        bh(ev.event);
                    });
                    return this;
                }
            }
        ]);
        return FolderApi;
    }(RackLikeApi);
    var RackLikeController = /*#__PURE__*/ function(BladeController) {
        (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(RackLikeController, BladeController);
        function RackLikeController(config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, RackLikeController);
            var _this;
            _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, RackLikeController, [
                {
                    blade: config.blade,
                    view: config.view,
                    viewProps: config.rackController.viewProps
                }
            ]);
            _this.rackController = config.rackController;
            return _this;
        }
        return RackLikeController;
    }(BladeController);
    var PlainView = function PlainView(doc, config) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, PlainView);
        var className = ClassName(config.viewName);
        this.element = doc.createElement('div');
        this.element.classList.add(className());
        config.viewProps.bindClassModifiers(this.element);
    };
    function findInputBindingController(bcs, b) {
        for(var i = 0; i < bcs.length; i++){
            var bc = bcs[i];
            if (bc instanceof InputBindingController && bc.binding === b) return bc;
        }
        return null;
    }
    function findMonitorBindingController(bcs, b) {
        for(var i = 0; i < bcs.length; i++){
            var bc = bcs[i];
            if (bc instanceof MonitorBindingController && bc.binding === b) return bc;
        }
        return null;
    }
    function findValueBladeController(bcs, v) {
        for(var i = 0; i < bcs.length; i++){
            var bc = bcs[i];
            if (bc instanceof ValueBladeController && bc.value === v) return bc;
        }
        return null;
    }
    function findSubRack(bc) {
        if (bc instanceof RackController) return bc.rack;
        if (bc instanceof RackLikeController) return bc.rackController.rack;
        return null;
    }
    function findSubBladeControllerSet(bc) {
        var rack = findSubRack(bc);
        return rack ? rack['bcSet_'] : null;
    }
    var BladeRack = /*#__PURE__*/ function() {
        function BladeRack(config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, BladeRack);
            var _a, _b;
            this.onBladePositionsChange_ = this.onBladePositionsChange_.bind(this);
            this.onSetAdd_ = this.onSetAdd_.bind(this);
            this.onSetRemove_ = this.onSetRemove_.bind(this);
            this.onChildDispose_ = this.onChildDispose_.bind(this);
            this.onChildPositionsChange_ = this.onChildPositionsChange_.bind(this);
            this.onChildInputChange_ = this.onChildInputChange_.bind(this);
            this.onChildMonitorUpdate_ = this.onChildMonitorUpdate_.bind(this);
            this.onChildValueChange_ = this.onChildValueChange_.bind(this);
            this.onChildViewPropsChange_ = this.onChildViewPropsChange_.bind(this);
            this.onDescendantLayout_ = this.onDescendantLayout_.bind(this);
            this.onDescendantInputChange_ = this.onDescendantInputChange_.bind(this);
            this.onDescendantMonitorUpdate_ = this.onDescendantMonitorUpdate_.bind(this);
            this.emitter = new Emitter();
            this.blade_ = (_a = config.blade) !== null && _a !== void 0 ? _a : null;
            (_b = this.blade_) === null || _b === void 0 || _b.value('positions').emitter.on('change', this.onBladePositionsChange_);
            this.viewProps = config.viewProps;
            this.bcSet_ = new NestedOrderedSet(findSubBladeControllerSet);
            this.bcSet_.emitter.on('add', this.onSetAdd_);
            this.bcSet_.emitter.on('remove', this.onSetRemove_);
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(BladeRack, [
            {
                key: "children",
                get: function get() {
                    return this.bcSet_.items;
                }
            },
            {
                key: "add",
                value: function add(bc, opt_index) {
                    var _a;
                    (_a = bc.parent) === null || _a === void 0 || _a.remove(bc);
                    if (isPropertyWritable(bc, 'parent')) bc.parent = this;
                    else {
                        bc['parent_'] = this;
                        warnMissing({
                            key: 'parent',
                            target: 'BladeController',
                            place: 'BladeRack.add'
                        });
                    }
                    this.bcSet_.add(bc, opt_index);
                }
            },
            {
                key: "remove",
                value: function remove(bc) {
                    if (isPropertyWritable(bc, 'parent')) bc.parent = null;
                    else {
                        bc['parent_'] = null;
                        warnMissing({
                            key: 'parent',
                            target: 'BladeController',
                            place: 'BladeRack.remove'
                        });
                    }
                    this.bcSet_.remove(bc);
                }
            },
            {
                key: "find",
                value: function find(controllerClass) {
                    return forceCast(this.bcSet_.allItems().filter(function(bc) {
                        return bc instanceof controllerClass;
                    }));
                }
            },
            {
                key: "onSetAdd_",
                value: function onSetAdd_(ev) {
                    this.updatePositions_();
                    var isRoot = ev.target === ev.root;
                    this.emitter.emit('add', {
                        bladeController: ev.item,
                        index: ev.index,
                        isRoot: isRoot,
                        sender: this
                    });
                    if (!isRoot) return;
                    var bc = ev.item;
                    bc.viewProps.emitter.on('change', this.onChildViewPropsChange_);
                    bc.blade.value('positions').emitter.on('change', this.onChildPositionsChange_);
                    bc.viewProps.handleDispose(this.onChildDispose_);
                    if (bc instanceof InputBindingController) bc.binding.emitter.on('change', this.onChildInputChange_);
                    else if (bc instanceof MonitorBindingController) bc.binding.emitter.on('update', this.onChildMonitorUpdate_);
                    else if (bc instanceof ValueBladeController) bc.value.emitter.on('change', this.onChildValueChange_);
                    else {
                        var rack = findSubRack(bc);
                        if (rack) {
                            var emitter = rack.emitter;
                            emitter.on('layout', this.onDescendantLayout_);
                            emitter.on('inputchange', this.onDescendantInputChange_);
                            emitter.on('monitorupdate', this.onDescendantMonitorUpdate_);
                        }
                    }
                }
            },
            {
                key: "onSetRemove_",
                value: function onSetRemove_(ev) {
                    this.updatePositions_();
                    var isRoot = ev.target === ev.root;
                    this.emitter.emit('remove', {
                        bladeController: ev.item,
                        isRoot: isRoot,
                        sender: this
                    });
                    if (!isRoot) return;
                    var bc = ev.item;
                    if (bc instanceof InputBindingController) bc.binding.emitter.off('change', this.onChildInputChange_);
                    else if (bc instanceof MonitorBindingController) bc.binding.emitter.off('update', this.onChildMonitorUpdate_);
                    else if (bc instanceof ValueBladeController) bc.value.emitter.off('change', this.onChildValueChange_);
                    else {
                        var rack = findSubRack(bc);
                        if (rack) {
                            var emitter = rack.emitter;
                            emitter.off('layout', this.onDescendantLayout_);
                            emitter.off('inputchange', this.onDescendantInputChange_);
                            emitter.off('monitorupdate', this.onDescendantMonitorUpdate_);
                        }
                    }
                }
            },
            {
                key: "updatePositions_",
                value: function updatePositions_() {
                    var _this = this;
                    var visibleItems = this.bcSet_.items.filter(function(bc) {
                        return !bc.viewProps.get('hidden');
                    });
                    var firstVisibleItem = visibleItems[0];
                    var lastVisibleItem = visibleItems[visibleItems.length - 1];
                    this.bcSet_.items.forEach(function(bc) {
                        var ps = [];
                        if (bc === firstVisibleItem) {
                            ps.push('first');
                            if (!_this.blade_ || _this.blade_.get('positions').includes('veryfirst')) ps.push('veryfirst');
                        }
                        if (bc === lastVisibleItem) {
                            ps.push('last');
                            if (!_this.blade_ || _this.blade_.get('positions').includes('verylast')) ps.push('verylast');
                        }
                        bc.blade.set('positions', ps);
                    });
                }
            },
            {
                key: "onChildPositionsChange_",
                value: function onChildPositionsChange_() {
                    this.updatePositions_();
                    this.emitter.emit('layout', {
                        sender: this
                    });
                }
            },
            {
                key: "onChildViewPropsChange_",
                value: function onChildViewPropsChange_(_ev) {
                    this.updatePositions_();
                    this.emitter.emit('layout', {
                        sender: this
                    });
                }
            },
            {
                key: "onChildDispose_",
                value: function onChildDispose_() {
                    var _this = this;
                    var disposedUcs = this.bcSet_.items.filter(function(bc) {
                        return bc.viewProps.get('disposed');
                    });
                    disposedUcs.forEach(function(bc) {
                        _this.bcSet_.remove(bc);
                    });
                }
            },
            {
                key: "onChildInputChange_",
                value: function onChildInputChange_(ev) {
                    var bc = findInputBindingController(this.find(InputBindingController), ev.sender);
                    if (!bc) throw TpError.alreadyDisposed();
                    this.emitter.emit('inputchange', {
                        bladeController: bc,
                        options: ev.options,
                        sender: this
                    });
                }
            },
            {
                key: "onChildMonitorUpdate_",
                value: function onChildMonitorUpdate_(ev) {
                    var bc = findMonitorBindingController(this.find(MonitorBindingController), ev.sender);
                    if (!bc) throw TpError.alreadyDisposed();
                    this.emitter.emit('monitorupdate', {
                        bladeController: bc,
                        sender: this
                    });
                }
            },
            {
                key: "onChildValueChange_",
                value: function onChildValueChange_(ev) {
                    var bc = findValueBladeController(this.find(ValueBladeController), ev.sender);
                    if (!bc) throw TpError.alreadyDisposed();
                    this.emitter.emit('inputchange', {
                        bladeController: bc,
                        options: ev.options,
                        sender: this
                    });
                }
            },
            {
                key: "onDescendantLayout_",
                value: function onDescendantLayout_(_) {
                    this.updatePositions_();
                    this.emitter.emit('layout', {
                        sender: this
                    });
                }
            },
            {
                key: "onDescendantInputChange_",
                value: function onDescendantInputChange_(ev) {
                    this.emitter.emit('inputchange', {
                        bladeController: ev.bladeController,
                        options: ev.options,
                        sender: this
                    });
                }
            },
            {
                key: "onDescendantMonitorUpdate_",
                value: function onDescendantMonitorUpdate_(ev) {
                    this.emitter.emit('monitorupdate', {
                        bladeController: ev.bladeController,
                        sender: this
                    });
                }
            },
            {
                key: "onBladePositionsChange_",
                value: function onBladePositionsChange_() {
                    this.updatePositions_();
                }
            }
        ]);
        return BladeRack;
    }();
    var RackController = /*#__PURE__*/ function(BladeController) {
        (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(RackController, BladeController);
        function RackController(doc, config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, RackController);
            var _this;
            _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, RackController, [
                Object.assign(Object.assign({}, config), {
                    view: new PlainView(doc, {
                        viewName: 'brk',
                        viewProps: config.viewProps
                    })
                })
            ]);
            _this.onRackAdd_ = _this.onRackAdd_.bind(_this);
            _this.onRackRemove_ = _this.onRackRemove_.bind(_this);
            var rack = new BladeRack({
                blade: config.root ? undefined : config.blade,
                viewProps: config.viewProps
            });
            rack.emitter.on('add', _this.onRackAdd_);
            rack.emitter.on('remove', _this.onRackRemove_);
            _this.rack = rack;
            _this.viewProps.handleDispose(function() {
                for(var i = _this.rack.children.length - 1; i >= 0; i--){
                    var bc = _this.rack.children[i];
                    bc.viewProps.set('disposed', true);
                }
            });
            return _this;
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(RackController, [
            {
                key: "onRackAdd_",
                value: function onRackAdd_(ev) {
                    if (!ev.isRoot) return;
                    insertElementAt(this.view.element, ev.bladeController.view.element, ev.index);
                }
            },
            {
                key: "onRackRemove_",
                value: function onRackRemove_(ev) {
                    if (!ev.isRoot) return;
                    removeElement(ev.bladeController.view.element);
                }
            }
        ]);
        return RackController;
    }(BladeController);
    var bladeContainerClassName = ClassName('cnt');
    var FolderView = function FolderView(doc, config) {
        var _this = this;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, FolderView);
        var _a;
        this.className_ = ClassName((_a = config.viewName) !== null && _a !== void 0 ? _a : 'fld');
        this.element = doc.createElement('div');
        this.element.classList.add(this.className_(), bladeContainerClassName());
        config.viewProps.bindClassModifiers(this.element);
        this.foldable_ = config.foldable;
        this.foldable_.bindExpandedClass(this.element, this.className_(undefined, 'expanded'));
        bindValueMap(this.foldable_, 'completed', valueToClassName(this.element, this.className_(undefined, 'cpl')));
        var buttonElem = doc.createElement('button');
        buttonElem.classList.add(this.className_('b'));
        bindValueMap(config.props, 'title', function(title) {
            if (isEmpty(title)) _this.element.classList.add(_this.className_(undefined, 'not'));
            else _this.element.classList.remove(_this.className_(undefined, 'not'));
        });
        config.viewProps.bindDisabled(buttonElem);
        this.element.appendChild(buttonElem);
        this.buttonElement = buttonElem;
        var indentElem = doc.createElement('div');
        indentElem.classList.add(this.className_('i'));
        this.element.appendChild(indentElem);
        var titleElem = doc.createElement('div');
        titleElem.classList.add(this.className_('t'));
        bindValueToTextContent(config.props.value('title'), titleElem);
        this.buttonElement.appendChild(titleElem);
        this.titleElement = titleElem;
        var markElem = doc.createElement('div');
        markElem.classList.add(this.className_('m'));
        this.buttonElement.appendChild(markElem);
        var containerElem = config.containerElement;
        containerElem.classList.add(this.className_('c'));
        this.element.appendChild(containerElem);
        this.containerElement = containerElem;
    };
    var FolderController = /*#__PURE__*/ function(RackLikeController) {
        (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(FolderController, RackLikeController);
        function FolderController(doc, config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, FolderController);
            var _this;
            var _a;
            var foldable = Foldable.create((_a = config.expanded) !== null && _a !== void 0 ? _a : true);
            var rc = new RackController(doc, {
                blade: config.blade,
                root: config.root,
                viewProps: config.viewProps
            });
            _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, FolderController, [
                Object.assign(Object.assign({}, config), {
                    rackController: rc,
                    view: new FolderView(doc, {
                        containerElement: rc.view.element,
                        foldable: foldable,
                        props: config.props,
                        viewName: config.root ? 'rot' : undefined,
                        viewProps: config.viewProps
                    })
                })
            ]);
            _this.onTitleClick_ = _this.onTitleClick_.bind(_this);
            _this.props = config.props;
            _this.foldable = foldable;
            bindFoldable(_this.foldable, _this.view.containerElement);
            _this.rackController.rack.emitter.on('add', function() {
                _this.foldable.cleanUpTransition();
            });
            _this.rackController.rack.emitter.on('remove', function() {
                _this.foldable.cleanUpTransition();
            });
            _this.view.buttonElement.addEventListener('click', _this.onTitleClick_);
            return _this;
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(FolderController, [
            {
                key: "document",
                get: function get() {
                    return this.view.element.ownerDocument;
                }
            },
            {
                key: "onTitleClick_",
                value: function onTitleClick_() {
                    this.foldable.set('expanded', !this.foldable.get('expanded'));
                }
            }
        ]);
        return FolderController;
    }(RackLikeController);
    var FolderBladePlugin = {
        id: 'folder',
        type: 'blade',
        accept: function(params) {
            var p = ParamsParsers;
            var result = parseParams(params, {
                title: p.required.string,
                view: p.required.constant('folder'),
                expanded: p.optional.boolean
            });
            return result ? {
                params: result
            } : null;
        },
        controller: function(args) {
            return new FolderController(args.document, {
                blade: args.blade,
                expanded: args.params.expanded,
                props: ValueMap.fromObject({
                    title: args.params.title
                }),
                viewProps: args.viewProps
            });
        },
        api: function(args) {
            if (!(args.controller instanceof FolderController)) return null;
            return new FolderApi(args.controller, args.pool);
        }
    };
    var LabeledValueController = /*#__PURE__*/ function(ValueBladeController) {
        (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(LabeledValueController, ValueBladeController);
        function LabeledValueController(doc, config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, LabeledValueController);
            var _this;
            var viewProps = config.valueController.viewProps;
            _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, LabeledValueController, [
                Object.assign(Object.assign({}, config), {
                    value: config.valueController.value,
                    view: new LabelView(doc, {
                        props: config.props,
                        viewProps: viewProps
                    }),
                    viewProps: viewProps
                })
            ]);
            _this.props = config.props;
            _this.valueController = config.valueController;
            _this.view.valueElement.appendChild(_this.valueController.view.element);
            return _this;
        }
        return LabeledValueController;
    }(ValueBladeController);
    var SeparatorApi = /*#__PURE__*/ function(BladeApi) {
        (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(SeparatorApi, BladeApi);
        function SeparatorApi() {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, SeparatorApi);
            return (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, SeparatorApi, arguments);
        }
        return SeparatorApi;
    }(BladeApi);
    var className$m = ClassName('spr');
    var SeparatorView = function SeparatorView(doc, config) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, SeparatorView);
        this.element = doc.createElement('div');
        this.element.classList.add(className$m());
        config.viewProps.bindClassModifiers(this.element);
        var hrElem = doc.createElement('hr');
        hrElem.classList.add(className$m('r'));
        this.element.appendChild(hrElem);
    };
    var SeparatorController = /*#__PURE__*/ function(BladeController) {
        (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(SeparatorController, BladeController);
        function SeparatorController(doc, config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, SeparatorController);
            return (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, SeparatorController, [
                Object.assign(Object.assign({}, config), {
                    view: new SeparatorView(doc, {
                        viewProps: config.viewProps
                    })
                })
            ]);
        }
        return SeparatorController;
    }(BladeController);
    var SeparatorBladePlugin = {
        id: 'separator',
        type: 'blade',
        accept: function(params) {
            var p = ParamsParsers;
            var result = parseParams(params, {
                view: p.required.constant('separator')
            });
            return result ? {
                params: result
            } : null;
        },
        controller: function(args) {
            return new SeparatorController(args.document, {
                blade: args.blade,
                viewProps: args.viewProps
            });
        },
        api: function(args) {
            if (!(args.controller instanceof SeparatorController)) return null;
            return new SeparatorApi(args.controller);
        }
    };
    var className$l = ClassName('tbi');
    var TabItemView = function TabItemView(doc, config) {
        var _this = this;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, TabItemView);
        this.element = doc.createElement('div');
        this.element.classList.add(className$l());
        config.viewProps.bindClassModifiers(this.element);
        bindValueMap(config.props, 'selected', function(selected) {
            if (selected) _this.element.classList.add(className$l(undefined, 'sel'));
            else _this.element.classList.remove(className$l(undefined, 'sel'));
        });
        var buttonElem = doc.createElement('button');
        buttonElem.classList.add(className$l('b'));
        config.viewProps.bindDisabled(buttonElem);
        this.element.appendChild(buttonElem);
        this.buttonElement = buttonElem;
        var titleElem = doc.createElement('div');
        titleElem.classList.add(className$l('t'));
        bindValueToTextContent(config.props.value('title'), titleElem);
        this.buttonElement.appendChild(titleElem);
        this.titleElement = titleElem;
    };
    var TabItemController = /*#__PURE__*/ function() {
        function TabItemController(doc, config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, TabItemController);
            this.emitter = new Emitter();
            this.onClick_ = this.onClick_.bind(this);
            this.props = config.props;
            this.viewProps = config.viewProps;
            this.view = new TabItemView(doc, {
                props: config.props,
                viewProps: config.viewProps
            });
            this.view.buttonElement.addEventListener('click', this.onClick_);
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(TabItemController, [
            {
                key: "onClick_",
                value: function onClick_() {
                    this.emitter.emit('click', {
                        sender: this
                    });
                }
            }
        ]);
        return TabItemController;
    }();
    var TabPageController = /*#__PURE__*/ function() {
        function TabPageController(doc, config) {
            var _this = this;
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, TabPageController);
            this.onItemClick_ = this.onItemClick_.bind(this);
            this.ic_ = new TabItemController(doc, {
                props: config.itemProps,
                viewProps: ViewProps.create()
            });
            this.ic_.emitter.on('click', this.onItemClick_);
            this.cc_ = new RackController(doc, {
                blade: createBlade(),
                viewProps: ViewProps.create()
            });
            this.props = config.props;
            bindValueMap(this.props, 'selected', function(selected) {
                _this.itemController.props.set('selected', selected);
                _this.contentController.viewProps.set('hidden', !selected);
            });
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(TabPageController, [
            {
                key: "itemController",
                get: function get() {
                    return this.ic_;
                }
            },
            {
                key: "contentController",
                get: function get() {
                    return this.cc_;
                }
            },
            {
                key: "onItemClick_",
                value: function onItemClick_() {
                    this.props.set('selected', true);
                }
            }
        ]);
        return TabPageController;
    }();
    var TabPageApi = /*#__PURE__*/ function() {
        function TabPageApi(controller, contentRackApi) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, TabPageApi);
            this.controller_ = controller;
            this.rackApi_ = contentRackApi;
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(TabPageApi, [
            {
                key: "title",
                get: function get() {
                    var _a;
                    return (_a = this.controller_.itemController.props.get('title')) !== null && _a !== void 0 ? _a : '';
                },
                set: function set(title) {
                    this.controller_.itemController.props.set('title', title);
                }
            },
            {
                key: "selected",
                get: function get() {
                    return this.controller_.props.get('selected');
                },
                set: function set(selected) {
                    this.controller_.props.set('selected', selected);
                }
            },
            {
                key: "children",
                get: function get() {
                    return this.rackApi_.children;
                }
            },
            {
                key: "addButton",
                value: function addButton(params) {
                    return this.rackApi_.addButton(params);
                }
            },
            {
                key: "addFolder",
                value: function addFolder(params) {
                    return this.rackApi_.addFolder(params);
                }
            },
            {
                key: "addSeparator",
                value: function addSeparator(opt_params) {
                    return this.rackApi_.addSeparator(opt_params);
                }
            },
            {
                key: "addTab",
                value: function addTab(params) {
                    return this.rackApi_.addTab(params);
                }
            },
            {
                key: "add",
                value: function add(api, opt_index) {
                    this.rackApi_.add(api, opt_index);
                }
            },
            {
                key: "remove",
                value: function remove(api) {
                    this.rackApi_.remove(api);
                }
            },
            {
                key: "addInput",
                value: function addInput(object, key, opt_params) {
                    return this.rackApi_.addInput(object, key, opt_params);
                }
            },
            {
                key: "addMonitor",
                value: function addMonitor(object, key, opt_params) {
                    return this.rackApi_.addMonitor(object, key, opt_params);
                }
            },
            {
                key: "addBlade",
                value: function addBlade(params) {
                    return this.rackApi_.addBlade(params);
                }
            }
        ]);
        return TabPageApi;
    }();
    var TabApi = /*#__PURE__*/ function(RackLikeApi) {
        (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(TabApi, RackLikeApi);
        function TabApi(controller, pool) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, TabApi);
            var _this;
            _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, TabApi, [
                controller,
                new RackApi(controller.rackController, pool)
            ]);
            _this.onPageAdd_ = _this.onPageAdd_.bind(_this);
            _this.onPageRemove_ = _this.onPageRemove_.bind(_this);
            _this.onSelect_ = _this.onSelect_.bind(_this);
            _this.emitter_ = new Emitter();
            _this.pageApiMap_ = new Map();
            _this.rackApi_.on('change', function(ev) {
                _this.emitter_.emit('change', {
                    event: ev
                });
            });
            _this.rackApi_.on('update', function(ev) {
                _this.emitter_.emit('update', {
                    event: ev
                });
            });
            _this.controller_.tab.selectedIndex.emitter.on('change', _this.onSelect_);
            _this.controller_.pageSet.emitter.on('add', _this.onPageAdd_);
            _this.controller_.pageSet.emitter.on('remove', _this.onPageRemove_);
            _this.controller_.pageSet.items.forEach(function(pc) {
                _this.setUpPageApi_(pc);
            });
            return _this;
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(TabApi, [
            {
                key: "pages",
                get: function get() {
                    var _this = this;
                    return this.controller_.pageSet.items.map(function(pc) {
                        var api = _this.pageApiMap_.get(pc);
                        if (!api) throw TpError.shouldNeverHappen();
                        return api;
                    });
                }
            },
            {
                key: "addPage",
                value: function addPage(params) {
                    var doc = this.controller_.view.element.ownerDocument;
                    var pc = new TabPageController(doc, {
                        itemProps: ValueMap.fromObject({
                            selected: false,
                            title: params.title
                        }),
                        props: ValueMap.fromObject({
                            selected: false
                        })
                    });
                    this.controller_.add(pc, params.index);
                    var api = this.pageApiMap_.get(pc);
                    if (!api) throw TpError.shouldNeverHappen();
                    return api;
                }
            },
            {
                key: "removePage",
                value: function removePage(index) {
                    this.controller_.remove(index);
                }
            },
            {
                key: "on",
                value: function on(eventName, handler) {
                    var bh = handler.bind(this);
                    this.emitter_.on(eventName, function(ev) {
                        bh(ev.event);
                    });
                    return this;
                }
            },
            {
                key: "setUpPageApi_",
                value: function setUpPageApi_(pc) {
                    var rackApi = this.rackApi_['apiSet_'].find(function(api) {
                        return api.controller_ === pc.contentController;
                    });
                    if (!rackApi) throw TpError.shouldNeverHappen();
                    var api = new TabPageApi(pc, rackApi);
                    this.pageApiMap_.set(pc, api);
                }
            },
            {
                key: "onPageAdd_",
                value: function onPageAdd_(ev) {
                    this.setUpPageApi_(ev.item);
                }
            },
            {
                key: "onPageRemove_",
                value: function onPageRemove_(ev) {
                    var api = this.pageApiMap_.get(ev.item);
                    if (!api) throw TpError.shouldNeverHappen();
                    this.pageApiMap_.delete(ev.item);
                }
            },
            {
                key: "onSelect_",
                value: function onSelect_(ev) {
                    this.emitter_.emit('select', {
                        event: new TpTabSelectEvent(this, ev.rawValue)
                    });
                }
            }
        ]);
        return TabApi;
    }(RackLikeApi);
    var INDEX_NOT_SELECTED = -1;
    var Tab = /*#__PURE__*/ function() {
        function Tab() {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, Tab);
            this.onItemSelectedChange_ = this.onItemSelectedChange_.bind(this);
            this.empty = createValue(true);
            this.selectedIndex = createValue(INDEX_NOT_SELECTED);
            this.items_ = [];
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(Tab, [
            {
                key: "add",
                value: function add(item, opt_index) {
                    var index = opt_index !== null && opt_index !== void 0 ? opt_index : this.items_.length;
                    this.items_.splice(index, 0, item);
                    item.emitter.on('change', this.onItemSelectedChange_);
                    this.keepSelection_();
                }
            },
            {
                key: "remove",
                value: function remove(item) {
                    var index = this.items_.indexOf(item);
                    if (index < 0) return;
                    this.items_.splice(index, 1);
                    item.emitter.off('change', this.onItemSelectedChange_);
                    this.keepSelection_();
                }
            },
            {
                key: "keepSelection_",
                value: function keepSelection_() {
                    if (this.items_.length === 0) {
                        this.selectedIndex.rawValue = INDEX_NOT_SELECTED;
                        this.empty.rawValue = true;
                        return;
                    }
                    var firstSelIndex = this.items_.findIndex(function(s) {
                        return s.rawValue;
                    });
                    if (firstSelIndex < 0) {
                        this.items_.forEach(function(s, i) {
                            s.rawValue = i === 0;
                        });
                        this.selectedIndex.rawValue = 0;
                    } else {
                        this.items_.forEach(function(s, i) {
                            s.rawValue = i === firstSelIndex;
                        });
                        this.selectedIndex.rawValue = firstSelIndex;
                    }
                    this.empty.rawValue = false;
                }
            },
            {
                key: "onItemSelectedChange_",
                value: function onItemSelectedChange_(ev) {
                    if (ev.rawValue) {
                        var index = this.items_.findIndex(function(s) {
                            return s === ev.sender;
                        });
                        this.items_.forEach(function(s, i) {
                            s.rawValue = i === index;
                        });
                        this.selectedIndex.rawValue = index;
                    } else this.keepSelection_();
                }
            }
        ]);
        return Tab;
    }();
    var className$k = ClassName('tab');
    var TabView = function TabView(doc, config) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, TabView);
        this.element = doc.createElement('div');
        this.element.classList.add(className$k(), bladeContainerClassName());
        config.viewProps.bindClassModifiers(this.element);
        bindValue(config.empty, valueToClassName(this.element, className$k(undefined, 'nop')));
        var titleElem = doc.createElement('div');
        titleElem.classList.add(className$k('t'));
        this.element.appendChild(titleElem);
        this.itemsElement = titleElem;
        var indentElem = doc.createElement('div');
        indentElem.classList.add(className$k('i'));
        this.element.appendChild(indentElem);
        var contentsElem = config.contentsElement;
        contentsElem.classList.add(className$k('c'));
        this.element.appendChild(contentsElem);
        this.contentsElement = contentsElem;
    };
    var TabController = /*#__PURE__*/ function(RackLikeController) {
        (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(TabController, RackLikeController);
        function TabController(doc, config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, TabController);
            var _this;
            var cr = new RackController(doc, {
                blade: config.blade,
                viewProps: config.viewProps
            });
            var tab = new Tab();
            _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, TabController, [
                {
                    blade: config.blade,
                    rackController: cr,
                    view: new TabView(doc, {
                        contentsElement: cr.view.element,
                        empty: tab.empty,
                        viewProps: config.viewProps
                    })
                }
            ]);
            _this.onPageAdd_ = _this.onPageAdd_.bind(_this);
            _this.onPageRemove_ = _this.onPageRemove_.bind(_this);
            _this.pageSet_ = new NestedOrderedSet(function() {
                return null;
            });
            _this.pageSet_.emitter.on('add', _this.onPageAdd_);
            _this.pageSet_.emitter.on('remove', _this.onPageRemove_);
            _this.tab = tab;
            return _this;
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(TabController, [
            {
                key: "pageSet",
                get: function get() {
                    return this.pageSet_;
                }
            },
            {
                key: "add",
                value: function add(pc, opt_index) {
                    this.pageSet_.add(pc, opt_index);
                }
            },
            {
                key: "remove",
                value: function remove(index) {
                    this.pageSet_.remove(this.pageSet_.items[index]);
                }
            },
            {
                key: "onPageAdd_",
                value: function onPageAdd_(ev) {
                    var pc = ev.item;
                    insertElementAt(this.view.itemsElement, pc.itemController.view.element, ev.index);
                    pc.itemController.viewProps.set('parent', this.viewProps);
                    this.rackController.rack.add(pc.contentController, ev.index);
                    this.tab.add(pc.props.value('selected'));
                }
            },
            {
                key: "onPageRemove_",
                value: function onPageRemove_(ev) {
                    var pc = ev.item;
                    removeElement(pc.itemController.view.element);
                    pc.itemController.viewProps.set('parent', null);
                    this.rackController.rack.remove(pc.contentController);
                    this.tab.remove(pc.props.value('selected'));
                }
            }
        ]);
        return TabController;
    }(RackLikeController);
    var TabBladePlugin = {
        id: 'tab',
        type: 'blade',
        accept: function(params) {
            var p = ParamsParsers;
            var result = parseParams(params, {
                pages: p.required.array(p.required.object({
                    title: p.required.string
                })),
                view: p.required.constant('tab')
            });
            if (!result || result.pages.length === 0) return null;
            return {
                params: result
            };
        },
        controller: function(args) {
            var c = new TabController(args.document, {
                blade: args.blade,
                viewProps: args.viewProps
            });
            args.params.pages.forEach(function(p) {
                var pc = new TabPageController(args.document, {
                    itemProps: ValueMap.fromObject({
                        selected: false,
                        title: p.title
                    }),
                    props: ValueMap.fromObject({
                        selected: false
                    })
                });
                c.add(pc);
            });
            return c;
        },
        api: function(args) {
            if (!(args.controller instanceof TabController)) return null;
            return new TabApi(args.controller, args.pool);
        }
    };
    function createBladeController(plugin, args) {
        var ac = plugin.accept(args.params);
        if (!ac) return null;
        var disabled = ParamsParsers.optional.boolean(args.params['disabled']).value;
        var hidden = ParamsParsers.optional.boolean(args.params['hidden']).value;
        return plugin.controller({
            blade: createBlade(),
            document: args.document,
            params: forceCast(Object.assign(Object.assign({}, ac.params), {
                disabled: disabled,
                hidden: hidden
            })),
            viewProps: ViewProps.create({
                disabled: disabled,
                hidden: hidden
            })
        });
    }
    var ManualTicker = /*#__PURE__*/ function() {
        function ManualTicker() {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, ManualTicker);
            this.disabled = false;
            this.emitter = new Emitter();
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(ManualTicker, [
            {
                key: "dispose",
                value: function dispose() {}
            },
            {
                key: "tick",
                value: function tick() {
                    if (this.disabled) return;
                    this.emitter.emit('tick', {
                        sender: this
                    });
                }
            }
        ]);
        return ManualTicker;
    }();
    var IntervalTicker = /*#__PURE__*/ function() {
        function IntervalTicker(doc, interval) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, IntervalTicker);
            this.disabled_ = false;
            this.timerId_ = null;
            this.onTick_ = this.onTick_.bind(this);
            this.doc_ = doc;
            this.emitter = new Emitter();
            this.interval_ = interval;
            this.setTimer_();
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(IntervalTicker, [
            {
                key: "disabled",
                get: function get() {
                    return this.disabled_;
                },
                set: function set(inactive) {
                    this.disabled_ = inactive;
                    if (this.disabled_) this.clearTimer_();
                    else this.setTimer_();
                }
            },
            {
                key: "dispose",
                value: function dispose() {
                    this.clearTimer_();
                }
            },
            {
                key: "clearTimer_",
                value: function clearTimer_() {
                    if (this.timerId_ === null) return;
                    var win = this.doc_.defaultView;
                    if (win) win.clearInterval(this.timerId_);
                    this.timerId_ = null;
                }
            },
            {
                key: "setTimer_",
                value: function setTimer_() {
                    this.clearTimer_();
                    if (this.interval_ <= 0) return;
                    var win = this.doc_.defaultView;
                    if (win) this.timerId_ = win.setInterval(this.onTick_, this.interval_);
                }
            },
            {
                key: "onTick_",
                value: function onTick_() {
                    if (this.disabled_) return;
                    this.emitter.emit('tick', {
                        sender: this
                    });
                }
            }
        ]);
        return IntervalTicker;
    }();
    var InputBinding = /*#__PURE__*/ function() {
        function InputBinding(config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, InputBinding);
            this.onValueChange_ = this.onValueChange_.bind(this);
            this.reader = config.reader;
            this.writer = config.writer;
            this.emitter = new Emitter();
            this.value = config.value;
            this.value.emitter.on('change', this.onValueChange_);
            this.target = config.target;
            this.read();
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(InputBinding, [
            {
                key: "read",
                value: function read() {
                    var targetValue = this.target.read();
                    if (targetValue !== undefined) this.value.rawValue = this.reader(targetValue);
                }
            },
            {
                key: "write_",
                value: function write_(rawValue) {
                    this.writer(this.target, rawValue);
                }
            },
            {
                key: "onValueChange_",
                value: function onValueChange_(ev) {
                    this.write_(ev.rawValue);
                    this.emitter.emit('change', {
                        options: ev.options,
                        rawValue: ev.rawValue,
                        sender: this
                    });
                }
            }
        ]);
        return InputBinding;
    }();
    function fillBuffer(buffer, bufferSize) {
        while(buffer.length < bufferSize)buffer.push(undefined);
    }
    function initializeBuffer(bufferSize) {
        var buffer = [];
        fillBuffer(buffer, bufferSize);
        return createValue(buffer);
    }
    function createTrimmedBuffer(buffer) {
        var index = buffer.indexOf(undefined);
        return forceCast(index < 0 ? buffer : buffer.slice(0, index));
    }
    function createPushedBuffer(buffer, newValue) {
        var newBuffer = (0, $4fcd3d80e9e33ca7$export$71511d61b312f219)(createTrimmedBuffer(buffer)).concat([
            newValue
        ]);
        if (newBuffer.length > buffer.length) newBuffer.splice(0, newBuffer.length - buffer.length);
        else fillBuffer(newBuffer, buffer.length);
        return newBuffer;
    }
    var MonitorBinding = /*#__PURE__*/ function() {
        function MonitorBinding(config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, MonitorBinding);
            this.onTick_ = this.onTick_.bind(this);
            this.reader_ = config.reader;
            this.target = config.target;
            this.emitter = new Emitter();
            this.value = config.value;
            this.ticker = config.ticker;
            this.ticker.emitter.on('tick', this.onTick_);
            this.read();
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(MonitorBinding, [
            {
                key: "dispose",
                value: function dispose() {
                    this.ticker.dispose();
                }
            },
            {
                key: "read",
                value: function read() {
                    var targetValue = this.target.read();
                    if (targetValue === undefined) return;
                    var buffer = this.value.rawValue;
                    var newValue = this.reader_(targetValue);
                    this.value.rawValue = createPushedBuffer(buffer, newValue);
                    this.emitter.emit('update', {
                        rawValue: newValue,
                        sender: this
                    });
                }
            },
            {
                key: "onTick_",
                value: function onTick_(_) {
                    this.read();
                }
            }
        ]);
        return MonitorBinding;
    }();
    var CompositeConstraint = /*#__PURE__*/ function() {
        function CompositeConstraint(constraints) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, CompositeConstraint);
            this.constraints = constraints;
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(CompositeConstraint, [
            {
                key: "constrain",
                value: function constrain(value) {
                    return this.constraints.reduce(function(result, c) {
                        return c.constrain(result);
                    }, value);
                }
            }
        ]);
        return CompositeConstraint;
    }();
    function findConstraint(c, constraintClass) {
        if (c instanceof constraintClass) return c;
        if (c instanceof CompositeConstraint) {
            var result = c.constraints.reduce(function(tmpResult, sc) {
                if (tmpResult) return tmpResult;
                return sc instanceof constraintClass ? sc : null;
            }, null);
            if (result) return result;
        }
        return null;
    }
    var DefiniteRangeConstraint = /*#__PURE__*/ function() {
        function DefiniteRangeConstraint(config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, DefiniteRangeConstraint);
            this.values = ValueMap.fromObject({
                max: config.max,
                min: config.min
            });
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(DefiniteRangeConstraint, [
            {
                key: "constrain",
                value: function constrain(value) {
                    var max = this.values.get('max');
                    var min = this.values.get('min');
                    return Math.min(Math.max(value, min), max);
                }
            }
        ]);
        return DefiniteRangeConstraint;
    }();
    var ListConstraint = /*#__PURE__*/ function() {
        function ListConstraint(options) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, ListConstraint);
            this.values = ValueMap.fromObject({
                options: options
            });
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(ListConstraint, [
            {
                key: "options",
                get: function get() {
                    return this.values.get('options');
                }
            },
            {
                key: "constrain",
                value: function constrain(value) {
                    var opts = this.values.get('options');
                    if (opts.length === 0) return value;
                    var matched = opts.filter(function(item) {
                        return item.value === value;
                    }).length > 0;
                    return matched ? value : opts[0].value;
                }
            }
        ]);
        return ListConstraint;
    }();
    var RangeConstraint = /*#__PURE__*/ function() {
        function RangeConstraint(config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, RangeConstraint);
            this.values = ValueMap.fromObject({
                max: config.max,
                min: config.min
            });
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(RangeConstraint, [
            {
                key: "maxValue",
                get: function get() {
                    return this.values.get('max');
                }
            },
            {
                key: "minValue",
                get: function get() {
                    return this.values.get('min');
                }
            },
            {
                key: "constrain",
                value: function constrain(value) {
                    var max = this.values.get('max');
                    var min = this.values.get('min');
                    var result = value;
                    if (!isEmpty(min)) result = Math.max(result, min);
                    if (!isEmpty(max)) result = Math.min(result, max);
                    return result;
                }
            }
        ]);
        return RangeConstraint;
    }();
    var StepConstraint = /*#__PURE__*/ function() {
        function StepConstraint(step) {
            var origin = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, StepConstraint);
            this.step = step;
            this.origin = origin;
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(StepConstraint, [
            {
                key: "constrain",
                value: function constrain(value) {
                    var o = this.origin % this.step;
                    var r = Math.round((value - o) / this.step);
                    return o + r * this.step;
                }
            }
        ]);
        return StepConstraint;
    }();
    var className$j = ClassName('lst');
    var ListView = /*#__PURE__*/ function() {
        function ListView(doc, config) {
            var _this = this;
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, ListView);
            this.onValueChange_ = this.onValueChange_.bind(this);
            this.props_ = config.props;
            this.element = doc.createElement('div');
            this.element.classList.add(className$j());
            config.viewProps.bindClassModifiers(this.element);
            var selectElem = doc.createElement('select');
            selectElem.classList.add(className$j('s'));
            config.viewProps.bindDisabled(selectElem);
            this.element.appendChild(selectElem);
            this.selectElement = selectElem;
            var markElem = doc.createElement('div');
            markElem.classList.add(className$j('m'));
            markElem.appendChild(createSvgIconElement(doc, 'dropdown'));
            this.element.appendChild(markElem);
            config.value.emitter.on('change', this.onValueChange_);
            this.value_ = config.value;
            bindValueMap(this.props_, 'options', function(opts) {
                removeChildElements(_this.selectElement);
                opts.forEach(function(item) {
                    var optionElem = doc.createElement('option');
                    optionElem.textContent = item.text;
                    _this.selectElement.appendChild(optionElem);
                });
                _this.update_();
            });
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(ListView, [
            {
                key: "update_",
                value: function update_() {
                    var values = this.props_.get('options').map(function(o) {
                        return o.value;
                    });
                    this.selectElement.selectedIndex = values.indexOf(this.value_.rawValue);
                }
            },
            {
                key: "onValueChange_",
                value: function onValueChange_() {
                    this.update_();
                }
            }
        ]);
        return ListView;
    }();
    var ListController = /*#__PURE__*/ function() {
        function ListController(doc, config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, ListController);
            this.onSelectChange_ = this.onSelectChange_.bind(this);
            this.props = config.props;
            this.value = config.value;
            this.viewProps = config.viewProps;
            this.view = new ListView(doc, {
                props: this.props,
                value: this.value,
                viewProps: this.viewProps
            });
            this.view.selectElement.addEventListener('change', this.onSelectChange_);
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(ListController, [
            {
                key: "onSelectChange_",
                value: function onSelectChange_(e) {
                    var selectElem = forceCast(e.currentTarget);
                    this.value.rawValue = this.props.get('options')[selectElem.selectedIndex].value;
                }
            }
        ]);
        return ListController;
    }();
    var className$i = ClassName('pop');
    var PopupView = function PopupView(doc, config) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, PopupView);
        this.element = doc.createElement('div');
        this.element.classList.add(className$i());
        config.viewProps.bindClassModifiers(this.element);
        bindValue(config.shows, valueToClassName(this.element, className$i(undefined, 'v')));
    };
    var PopupController = function PopupController(doc, config) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, PopupController);
        this.shows = createValue(false);
        this.viewProps = config.viewProps;
        this.view = new PopupView(doc, {
            shows: this.shows,
            viewProps: this.viewProps
        });
    };
    var className$h = ClassName('txt');
    var TextView = /*#__PURE__*/ function() {
        function TextView(doc, config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, TextView);
            this.onChange_ = this.onChange_.bind(this);
            this.element = doc.createElement('div');
            this.element.classList.add(className$h());
            config.viewProps.bindClassModifiers(this.element);
            this.props_ = config.props;
            this.props_.emitter.on('change', this.onChange_);
            var inputElem = doc.createElement('input');
            inputElem.classList.add(className$h('i'));
            inputElem.type = 'text';
            config.viewProps.bindDisabled(inputElem);
            this.element.appendChild(inputElem);
            this.inputElement = inputElem;
            config.value.emitter.on('change', this.onChange_);
            this.value_ = config.value;
            this.refresh();
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(TextView, [
            {
                key: "refresh",
                value: function refresh() {
                    var formatter = this.props_.get('formatter');
                    this.inputElement.value = formatter(this.value_.rawValue);
                }
            },
            {
                key: "onChange_",
                value: function onChange_() {
                    this.refresh();
                }
            }
        ]);
        return TextView;
    }();
    var TextController = /*#__PURE__*/ function() {
        function TextController(doc, config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, TextController);
            this.onInputChange_ = this.onInputChange_.bind(this);
            this.parser_ = config.parser;
            this.props = config.props;
            this.value = config.value;
            this.viewProps = config.viewProps;
            this.view = new TextView(doc, {
                props: config.props,
                value: this.value,
                viewProps: this.viewProps
            });
            this.view.inputElement.addEventListener('change', this.onInputChange_);
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(TextController, [
            {
                key: "onInputChange_",
                value: function onInputChange_(e) {
                    var inputElem = forceCast(e.currentTarget);
                    var value = inputElem.value;
                    var parsedValue = this.parser_(value);
                    if (!isEmpty(parsedValue)) this.value.rawValue = parsedValue;
                    this.view.refresh();
                }
            }
        ]);
        return TextController;
    }();
    function boolToString(value) {
        return String(value);
    }
    function boolFromUnknown(value) {
        if (value === 'false') return false;
        return !!value;
    }
    function BooleanFormatter(value) {
        return boolToString(value);
    }
    var NumberLiteralNode = /*#__PURE__*/ function() {
        function NumberLiteralNode(text) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, NumberLiteralNode);
            this.text = text;
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(NumberLiteralNode, [
            {
                key: "evaluate",
                value: function evaluate() {
                    return Number(this.text);
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return this.text;
                }
            }
        ]);
        return NumberLiteralNode;
    }();
    var BINARY_OPERATION_MAP = {
        '**': function(v1, v2) {
            return Math.pow(v1, v2);
        },
        '*': function(v1, v2) {
            return v1 * v2;
        },
        '/': function(v1, v2) {
            return v1 / v2;
        },
        '%': function(v1, v2) {
            return v1 % v2;
        },
        '+': function(v1, v2) {
            return v1 + v2;
        },
        '-': function(v1, v2) {
            return v1 - v2;
        },
        '<<': function(v1, v2) {
            return v1 << v2;
        },
        '>>': function(v1, v2) {
            return v1 >> v2;
        },
        '>>>': function(v1, v2) {
            return v1 >>> v2;
        },
        '&': function(v1, v2) {
            return v1 & v2;
        },
        '^': function(v1, v2) {
            return v1 ^ v2;
        },
        '|': function(v1, v2) {
            return v1 | v2;
        }
    };
    var BinaryOperationNode = /*#__PURE__*/ function() {
        function BinaryOperationNode(operator, left, right) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, BinaryOperationNode);
            this.left = left;
            this.operator = operator;
            this.right = right;
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(BinaryOperationNode, [
            {
                key: "evaluate",
                value: function evaluate() {
                    var op = BINARY_OPERATION_MAP[this.operator];
                    if (!op) throw new Error("unexpected binary operator: '".concat(this.operator));
                    return op(this.left.evaluate(), this.right.evaluate());
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return [
                        'b(',
                        this.left.toString(),
                        this.operator,
                        this.right.toString(),
                        ')'
                    ].join(' ');
                }
            }
        ]);
        return BinaryOperationNode;
    }();
    var UNARY_OPERATION_MAP = {
        '+': function(v) {
            return v;
        },
        '-': function(v) {
            return -v;
        },
        '~': function(v) {
            return ~v;
        }
    };
    var UnaryOperationNode = /*#__PURE__*/ function() {
        function UnaryOperationNode(operator, expr) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, UnaryOperationNode);
            this.operator = operator;
            this.expression = expr;
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(UnaryOperationNode, [
            {
                key: "evaluate",
                value: function evaluate() {
                    var op = UNARY_OPERATION_MAP[this.operator];
                    if (!op) throw new Error("unexpected unary operator: '".concat(this.operator));
                    return op(this.expression.evaluate());
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return [
                        'u(',
                        this.operator,
                        this.expression.toString(),
                        ')'
                    ].join(' ');
                }
            }
        ]);
        return UnaryOperationNode;
    }();
    function combineReader(parsers) {
        return function(text, cursor) {
            for(var i = 0; i < parsers.length; i++){
                var result = parsers[i](text, cursor);
                if (result !== '') return result;
            }
            return '';
        };
    }
    function readWhitespace(text, cursor) {
        var _a;
        var m = text.substr(cursor).match(/^\s+/);
        return (_a = m && m[0]) !== null && _a !== void 0 ? _a : '';
    }
    function readNonZeroDigit(text, cursor) {
        var ch = text.substr(cursor, 1);
        return ch.match(/^[1-9]$/) ? ch : '';
    }
    function readDecimalDigits(text, cursor) {
        var _a;
        var m = text.substr(cursor).match(/^[0-9]+/);
        return (_a = m && m[0]) !== null && _a !== void 0 ? _a : '';
    }
    function readSignedInteger(text, cursor) {
        var ds = readDecimalDigits(text, cursor);
        if (ds !== '') return ds;
        var sign = text.substr(cursor, 1);
        cursor += 1;
        if (sign !== '-' && sign !== '+') return '';
        var sds = readDecimalDigits(text, cursor);
        if (sds === '') return '';
        return sign + sds;
    }
    function readExponentPart(text, cursor) {
        var e = text.substr(cursor, 1);
        cursor += 1;
        if (e.toLowerCase() !== 'e') return '';
        var si = readSignedInteger(text, cursor);
        if (si === '') return '';
        return e + si;
    }
    function readDecimalIntegerLiteral(text, cursor) {
        var ch = text.substr(cursor, 1);
        if (ch === '0') return ch;
        var nzd = readNonZeroDigit(text, cursor);
        cursor += nzd.length;
        if (nzd === '') return '';
        return nzd + readDecimalDigits(text, cursor);
    }
    function readDecimalLiteral1(text, cursor) {
        var dil = readDecimalIntegerLiteral(text, cursor);
        cursor += dil.length;
        if (dil === '') return '';
        var dot = text.substr(cursor, 1);
        cursor += dot.length;
        if (dot !== '.') return '';
        var dds = readDecimalDigits(text, cursor);
        cursor += dds.length;
        return dil + dot + dds + readExponentPart(text, cursor);
    }
    function readDecimalLiteral2(text, cursor) {
        var dot = text.substr(cursor, 1);
        cursor += dot.length;
        if (dot !== '.') return '';
        var dds = readDecimalDigits(text, cursor);
        cursor += dds.length;
        if (dds === '') return '';
        return dot + dds + readExponentPart(text, cursor);
    }
    function readDecimalLiteral3(text, cursor) {
        var dil = readDecimalIntegerLiteral(text, cursor);
        cursor += dil.length;
        if (dil === '') return '';
        return dil + readExponentPart(text, cursor);
    }
    var readDecimalLiteral = combineReader([
        readDecimalLiteral1,
        readDecimalLiteral2,
        readDecimalLiteral3
    ]);
    function parseBinaryDigits(text, cursor) {
        var _a;
        var m = text.substr(cursor).match(/^[01]+/);
        return (_a = m && m[0]) !== null && _a !== void 0 ? _a : '';
    }
    function readBinaryIntegerLiteral(text, cursor) {
        var prefix = text.substr(cursor, 2);
        cursor += prefix.length;
        if (prefix.toLowerCase() !== '0b') return '';
        var bds = parseBinaryDigits(text, cursor);
        if (bds === '') return '';
        return prefix + bds;
    }
    function readOctalDigits(text, cursor) {
        var _a;
        var m = text.substr(cursor).match(/^[0-7]+/);
        return (_a = m && m[0]) !== null && _a !== void 0 ? _a : '';
    }
    function readOctalIntegerLiteral(text, cursor) {
        var prefix = text.substr(cursor, 2);
        cursor += prefix.length;
        if (prefix.toLowerCase() !== '0o') return '';
        var ods = readOctalDigits(text, cursor);
        if (ods === '') return '';
        return prefix + ods;
    }
    function readHexDigits(text, cursor) {
        var _a;
        var m = text.substr(cursor).match(/^[0-9a-f]+/i);
        return (_a = m && m[0]) !== null && _a !== void 0 ? _a : '';
    }
    function readHexIntegerLiteral(text, cursor) {
        var prefix = text.substr(cursor, 2);
        cursor += prefix.length;
        if (prefix.toLowerCase() !== '0x') return '';
        var hds = readHexDigits(text, cursor);
        if (hds === '') return '';
        return prefix + hds;
    }
    var readNonDecimalIntegerLiteral = combineReader([
        readBinaryIntegerLiteral,
        readOctalIntegerLiteral,
        readHexIntegerLiteral
    ]);
    var readNumericLiteral = combineReader([
        readNonDecimalIntegerLiteral,
        readDecimalLiteral
    ]);
    function parseLiteral(text, cursor) {
        var num = readNumericLiteral(text, cursor);
        cursor += num.length;
        if (num === '') return null;
        return {
            evaluable: new NumberLiteralNode(num),
            cursor: cursor
        };
    }
    function parseParenthesizedExpression(text, cursor) {
        var op = text.substr(cursor, 1);
        cursor += op.length;
        if (op !== '(') return null;
        var expr = parseExpression(text, cursor);
        if (!expr) return null;
        cursor = expr.cursor;
        cursor += readWhitespace(text, cursor).length;
        var cl = text.substr(cursor, 1);
        cursor += cl.length;
        if (cl !== ')') return null;
        return {
            evaluable: expr.evaluable,
            cursor: cursor
        };
    }
    function parsePrimaryExpression(text, cursor) {
        var _a;
        return (_a = parseLiteral(text, cursor)) !== null && _a !== void 0 ? _a : parseParenthesizedExpression(text, cursor);
    }
    function parseUnaryExpression(text, cursor) {
        var expr = parsePrimaryExpression(text, cursor);
        if (expr) return expr;
        var op = text.substr(cursor, 1);
        cursor += op.length;
        if (op !== '+' && op !== '-' && op !== '~') return null;
        var num = parseUnaryExpression(text, cursor);
        if (!num) return null;
        cursor = num.cursor;
        return {
            cursor: cursor,
            evaluable: new UnaryOperationNode(op, num.evaluable)
        };
    }
    function readBinaryOperator(ops, text, cursor) {
        cursor += readWhitespace(text, cursor).length;
        var op = ops.filter(function(op) {
            return text.startsWith(op, cursor);
        })[0];
        if (!op) return null;
        cursor += op.length;
        cursor += readWhitespace(text, cursor).length;
        return {
            cursor: cursor,
            operator: op
        };
    }
    function createBinaryOperationExpressionParser(exprParser, ops) {
        return function(text, cursor) {
            var firstExpr = exprParser(text, cursor);
            if (!firstExpr) return null;
            cursor = firstExpr.cursor;
            var expr = firstExpr.evaluable;
            for(;;){
                var op = readBinaryOperator(ops, text, cursor);
                if (!op) break;
                cursor = op.cursor;
                var nextExpr = exprParser(text, cursor);
                if (!nextExpr) return null;
                cursor = nextExpr.cursor;
                expr = new BinaryOperationNode(op.operator, expr, nextExpr.evaluable);
            }
            return expr ? {
                cursor: cursor,
                evaluable: expr
            } : null;
        };
    }
    var parseBinaryOperationExpression = [
        [
            '**'
        ],
        [
            '*',
            '/',
            '%'
        ],
        [
            '+',
            '-'
        ],
        [
            '<<',
            '>>>',
            '>>'
        ],
        [
            '&'
        ],
        [
            '^'
        ],
        [
            '|'
        ]
    ].reduce(function(parser, ops) {
        return createBinaryOperationExpressionParser(parser, ops);
    }, parseUnaryExpression);
    function parseExpression(text, cursor) {
        cursor += readWhitespace(text, cursor).length;
        return parseBinaryOperationExpression(text, cursor);
    }
    function parseEcmaNumberExpression(text) {
        var expr = parseExpression(text, 0);
        if (!expr) return null;
        var cursor = expr.cursor + readWhitespace(text, expr.cursor).length;
        if (cursor !== text.length) return null;
        return expr.evaluable;
    }
    function parseNumber(text) {
        var _a;
        var r = parseEcmaNumberExpression(text);
        return (_a = r === null || r === void 0 ? void 0 : r.evaluate()) !== null && _a !== void 0 ? _a : null;
    }
    function numberFromUnknown(value) {
        if (typeof value === 'number') return value;
        if (typeof value === 'string') {
            var pv = parseNumber(value);
            if (!isEmpty(pv)) return pv;
        }
        return 0;
    }
    function numberToString(value) {
        return String(value);
    }
    function createNumberFormatter(digits) {
        return function(value) {
            return value.toFixed(Math.max(Math.min(digits, 20), 0));
        };
    }
    var innerFormatter = createNumberFormatter(0);
    function formatPercentage(value) {
        return innerFormatter(value) + '%';
    }
    function stringFromUnknown(value) {
        return String(value);
    }
    function formatString(value) {
        return value;
    }
    function connectValues(param) {
        var primary = param.primary, secondary = param.secondary, forward = param.forward, backward = param.backward;
        var changing = false;
        function preventFeedback(callback) {
            if (changing) return;
            changing = true;
            callback();
            changing = false;
        }
        primary.emitter.on('change', function(ev) {
            preventFeedback(function() {
                secondary.setRawValue(forward(primary, secondary), ev.options);
            });
        });
        secondary.emitter.on('change', function(ev) {
            preventFeedback(function() {
                primary.setRawValue(backward(primary, secondary), ev.options);
            });
            preventFeedback(function() {
                secondary.setRawValue(forward(primary, secondary), ev.options);
            });
        });
        preventFeedback(function() {
            secondary.setRawValue(forward(primary, secondary), {
                forceEmit: false,
                last: true
            });
        });
    }
    function getStepForKey(baseStep, keys) {
        var step = baseStep * (keys.altKey ? 0.1 : 1) * (keys.shiftKey ? 10 : 1);
        if (keys.upKey) return +step;
        else if (keys.downKey) return -step;
        return 0;
    }
    function getVerticalStepKeys(ev) {
        return {
            altKey: ev.altKey,
            downKey: ev.key === 'ArrowDown',
            shiftKey: ev.shiftKey,
            upKey: ev.key === 'ArrowUp'
        };
    }
    function getHorizontalStepKeys(ev) {
        return {
            altKey: ev.altKey,
            downKey: ev.key === 'ArrowLeft',
            shiftKey: ev.shiftKey,
            upKey: ev.key === 'ArrowRight'
        };
    }
    function isVerticalArrowKey(key) {
        return key === 'ArrowUp' || key === 'ArrowDown';
    }
    function isArrowKey(key) {
        return isVerticalArrowKey(key) || key === 'ArrowLeft' || key === 'ArrowRight';
    }
    function computeOffset$1(ev, elem) {
        var _a, _b;
        var win = elem.ownerDocument.defaultView;
        var rect = elem.getBoundingClientRect();
        return {
            x: ev.pageX - (((_a = win && win.scrollX) !== null && _a !== void 0 ? _a : 0) + rect.left),
            y: ev.pageY - (((_b = win && win.scrollY) !== null && _b !== void 0 ? _b : 0) + rect.top)
        };
    }
    var PointerHandler = /*#__PURE__*/ function() {
        function PointerHandler(element) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, PointerHandler);
            this.lastTouch_ = null;
            this.onDocumentMouseMove_ = this.onDocumentMouseMove_.bind(this);
            this.onDocumentMouseUp_ = this.onDocumentMouseUp_.bind(this);
            this.onMouseDown_ = this.onMouseDown_.bind(this);
            this.onTouchEnd_ = this.onTouchEnd_.bind(this);
            this.onTouchMove_ = this.onTouchMove_.bind(this);
            this.onTouchStart_ = this.onTouchStart_.bind(this);
            this.elem_ = element;
            this.emitter = new Emitter();
            element.addEventListener('touchstart', this.onTouchStart_, {
                passive: false
            });
            element.addEventListener('touchmove', this.onTouchMove_, {
                passive: true
            });
            element.addEventListener('touchend', this.onTouchEnd_);
            element.addEventListener('mousedown', this.onMouseDown_);
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(PointerHandler, [
            {
                key: "computePosition_",
                value: function computePosition_(offset) {
                    var rect = this.elem_.getBoundingClientRect();
                    return {
                        bounds: {
                            width: rect.width,
                            height: rect.height
                        },
                        point: offset ? {
                            x: offset.x,
                            y: offset.y
                        } : null
                    };
                }
            },
            {
                key: "onMouseDown_",
                value: function onMouseDown_(ev) {
                    var _a;
                    ev.preventDefault();
                    (_a = ev.currentTarget) === null || _a === void 0 || _a.focus();
                    var doc = this.elem_.ownerDocument;
                    doc.addEventListener('mousemove', this.onDocumentMouseMove_);
                    doc.addEventListener('mouseup', this.onDocumentMouseUp_);
                    this.emitter.emit('down', {
                        altKey: ev.altKey,
                        data: this.computePosition_(computeOffset$1(ev, this.elem_)),
                        sender: this,
                        shiftKey: ev.shiftKey
                    });
                }
            },
            {
                key: "onDocumentMouseMove_",
                value: function onDocumentMouseMove_(ev) {
                    this.emitter.emit('move', {
                        altKey: ev.altKey,
                        data: this.computePosition_(computeOffset$1(ev, this.elem_)),
                        sender: this,
                        shiftKey: ev.shiftKey
                    });
                }
            },
            {
                key: "onDocumentMouseUp_",
                value: function onDocumentMouseUp_(ev) {
                    var doc = this.elem_.ownerDocument;
                    doc.removeEventListener('mousemove', this.onDocumentMouseMove_);
                    doc.removeEventListener('mouseup', this.onDocumentMouseUp_);
                    this.emitter.emit('up', {
                        altKey: ev.altKey,
                        data: this.computePosition_(computeOffset$1(ev, this.elem_)),
                        sender: this,
                        shiftKey: ev.shiftKey
                    });
                }
            },
            {
                key: "onTouchStart_",
                value: function onTouchStart_(ev) {
                    ev.preventDefault();
                    var touch = ev.targetTouches.item(0);
                    var rect = this.elem_.getBoundingClientRect();
                    this.emitter.emit('down', {
                        altKey: ev.altKey,
                        data: this.computePosition_(touch ? {
                            x: touch.clientX - rect.left,
                            y: touch.clientY - rect.top
                        } : undefined),
                        sender: this,
                        shiftKey: ev.shiftKey
                    });
                    this.lastTouch_ = touch;
                }
            },
            {
                key: "onTouchMove_",
                value: function onTouchMove_(ev) {
                    var touch = ev.targetTouches.item(0);
                    var rect = this.elem_.getBoundingClientRect();
                    this.emitter.emit('move', {
                        altKey: ev.altKey,
                        data: this.computePosition_(touch ? {
                            x: touch.clientX - rect.left,
                            y: touch.clientY - rect.top
                        } : undefined),
                        sender: this,
                        shiftKey: ev.shiftKey
                    });
                    this.lastTouch_ = touch;
                }
            },
            {
                key: "onTouchEnd_",
                value: function onTouchEnd_(ev) {
                    var _a;
                    var touch = (_a = ev.targetTouches.item(0)) !== null && _a !== void 0 ? _a : this.lastTouch_;
                    var rect = this.elem_.getBoundingClientRect();
                    this.emitter.emit('up', {
                        altKey: ev.altKey,
                        data: this.computePosition_(touch ? {
                            x: touch.clientX - rect.left,
                            y: touch.clientY - rect.top
                        } : undefined),
                        sender: this,
                        shiftKey: ev.shiftKey
                    });
                }
            }
        ]);
        return PointerHandler;
    }();
    function mapRange(value, start1, end1, start2, end2) {
        var p = (value - start1) / (end1 - start1);
        return start2 + p * (end2 - start2);
    }
    function getDecimalDigits(value) {
        var text = String(value.toFixed(10));
        var frac = text.split('.')[1];
        return frac.replace(/0+$/, '').length;
    }
    function constrainRange(value, min, max) {
        return Math.min(Math.max(value, min), max);
    }
    function loopRange(value, max) {
        return (value % max + max) % max;
    }
    var className$g = ClassName('txt');
    var NumberTextView = /*#__PURE__*/ function() {
        function NumberTextView(doc, config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, NumberTextView);
            this.onChange_ = this.onChange_.bind(this);
            this.props_ = config.props;
            this.props_.emitter.on('change', this.onChange_);
            this.element = doc.createElement('div');
            this.element.classList.add(className$g(), className$g(undefined, 'num'));
            if (config.arrayPosition) this.element.classList.add(className$g(undefined, config.arrayPosition));
            config.viewProps.bindClassModifiers(this.element);
            var inputElem = doc.createElement('input');
            inputElem.classList.add(className$g('i'));
            inputElem.type = 'text';
            config.viewProps.bindDisabled(inputElem);
            this.element.appendChild(inputElem);
            this.inputElement = inputElem;
            this.onDraggingChange_ = this.onDraggingChange_.bind(this);
            this.dragging_ = config.dragging;
            this.dragging_.emitter.on('change', this.onDraggingChange_);
            this.element.classList.add(className$g());
            this.inputElement.classList.add(className$g('i'));
            var knobElem = doc.createElement('div');
            knobElem.classList.add(className$g('k'));
            this.element.appendChild(knobElem);
            this.knobElement = knobElem;
            var guideElem = doc.createElementNS(SVG_NS, 'svg');
            guideElem.classList.add(className$g('g'));
            this.knobElement.appendChild(guideElem);
            var bodyElem = doc.createElementNS(SVG_NS, 'path');
            bodyElem.classList.add(className$g('gb'));
            guideElem.appendChild(bodyElem);
            this.guideBodyElem_ = bodyElem;
            var headElem = doc.createElementNS(SVG_NS, 'path');
            headElem.classList.add(className$g('gh'));
            guideElem.appendChild(headElem);
            this.guideHeadElem_ = headElem;
            var tooltipElem = doc.createElement('div');
            tooltipElem.classList.add(ClassName('tt')());
            this.knobElement.appendChild(tooltipElem);
            this.tooltipElem_ = tooltipElem;
            config.value.emitter.on('change', this.onChange_);
            this.value = config.value;
            this.refresh();
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(NumberTextView, [
            {
                key: "onDraggingChange_",
                value: function onDraggingChange_(ev) {
                    if (ev.rawValue === null) {
                        this.element.classList.remove(className$g(undefined, 'drg'));
                        return;
                    }
                    this.element.classList.add(className$g(undefined, 'drg'));
                    var x = ev.rawValue / this.props_.get('draggingScale');
                    var aox = x + (x > 0 ? -1 : x < 0 ? 1 : 0);
                    var adx = constrainRange(-aox, -4, 4);
                    this.guideHeadElem_.setAttributeNS(null, 'd', [
                        "M ".concat(aox + adx, ",0 L").concat(aox, ",4 L").concat(aox + adx, ",8"),
                        "M ".concat(x, ",-1 L").concat(x, ",9")
                    ].join(' '));
                    this.guideBodyElem_.setAttributeNS(null, 'd', "M 0,4 L".concat(x, ",4"));
                    var formatter = this.props_.get('formatter');
                    this.tooltipElem_.textContent = formatter(this.value.rawValue);
                    this.tooltipElem_.style.left = "".concat(x, "px");
                }
            },
            {
                key: "refresh",
                value: function refresh() {
                    var formatter = this.props_.get('formatter');
                    this.inputElement.value = formatter(this.value.rawValue);
                }
            },
            {
                key: "onChange_",
                value: function onChange_() {
                    this.refresh();
                }
            }
        ]);
        return NumberTextView;
    }();
    var NumberTextController = /*#__PURE__*/ function() {
        function NumberTextController(doc, config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, NumberTextController);
            var _a;
            this.originRawValue_ = 0;
            this.onInputChange_ = this.onInputChange_.bind(this);
            this.onInputKeyDown_ = this.onInputKeyDown_.bind(this);
            this.onInputKeyUp_ = this.onInputKeyUp_.bind(this);
            this.onPointerDown_ = this.onPointerDown_.bind(this);
            this.onPointerMove_ = this.onPointerMove_.bind(this);
            this.onPointerUp_ = this.onPointerUp_.bind(this);
            this.baseStep_ = config.baseStep;
            this.parser_ = config.parser;
            this.props = config.props;
            this.sliderProps_ = (_a = config.sliderProps) !== null && _a !== void 0 ? _a : null;
            this.value = config.value;
            this.viewProps = config.viewProps;
            this.dragging_ = createValue(null);
            this.view = new NumberTextView(doc, {
                arrayPosition: config.arrayPosition,
                dragging: this.dragging_,
                props: this.props,
                value: this.value,
                viewProps: this.viewProps
            });
            this.view.inputElement.addEventListener('change', this.onInputChange_);
            this.view.inputElement.addEventListener('keydown', this.onInputKeyDown_);
            this.view.inputElement.addEventListener('keyup', this.onInputKeyUp_);
            var ph = new PointerHandler(this.view.knobElement);
            ph.emitter.on('down', this.onPointerDown_);
            ph.emitter.on('move', this.onPointerMove_);
            ph.emitter.on('up', this.onPointerUp_);
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(NumberTextController, [
            {
                key: "constrainValue_",
                value: function constrainValue_(value) {
                    var _a, _b;
                    var min = (_a = this.sliderProps_) === null || _a === void 0 ? void 0 : _a.get('minValue');
                    var max = (_b = this.sliderProps_) === null || _b === void 0 ? void 0 : _b.get('maxValue');
                    var v = value;
                    if (min !== undefined) v = Math.max(v, min);
                    if (max !== undefined) v = Math.min(v, max);
                    return v;
                }
            },
            {
                key: "onInputChange_",
                value: function onInputChange_(e) {
                    var inputElem = forceCast(e.currentTarget);
                    var value = inputElem.value;
                    var parsedValue = this.parser_(value);
                    if (!isEmpty(parsedValue)) this.value.rawValue = this.constrainValue_(parsedValue);
                    this.view.refresh();
                }
            },
            {
                key: "onInputKeyDown_",
                value: function onInputKeyDown_(ev) {
                    var step = getStepForKey(this.baseStep_, getVerticalStepKeys(ev));
                    if (step === 0) return;
                    this.value.setRawValue(this.constrainValue_(this.value.rawValue + step), {
                        forceEmit: false,
                        last: false
                    });
                }
            },
            {
                key: "onInputKeyUp_",
                value: function onInputKeyUp_(ev) {
                    var step = getStepForKey(this.baseStep_, getVerticalStepKeys(ev));
                    if (step === 0) return;
                    this.value.setRawValue(this.value.rawValue, {
                        forceEmit: true,
                        last: true
                    });
                }
            },
            {
                key: "onPointerDown_",
                value: function onPointerDown_() {
                    this.originRawValue_ = this.value.rawValue;
                    this.dragging_.rawValue = 0;
                }
            },
            {
                key: "computeDraggingValue_",
                value: function computeDraggingValue_(data) {
                    if (!data.point) return null;
                    var dx = data.point.x - data.bounds.width / 2;
                    return this.constrainValue_(this.originRawValue_ + dx * this.props.get('draggingScale'));
                }
            },
            {
                key: "onPointerMove_",
                value: function onPointerMove_(ev) {
                    var v = this.computeDraggingValue_(ev.data);
                    if (v === null) return;
                    this.value.setRawValue(v, {
                        forceEmit: false,
                        last: false
                    });
                    this.dragging_.rawValue = this.value.rawValue - this.originRawValue_;
                }
            },
            {
                key: "onPointerUp_",
                value: function onPointerUp_(ev) {
                    var v = this.computeDraggingValue_(ev.data);
                    if (v === null) return;
                    this.value.setRawValue(v, {
                        forceEmit: true,
                        last: true
                    });
                    this.dragging_.rawValue = null;
                }
            }
        ]);
        return NumberTextController;
    }();
    var className$f = ClassName('sld');
    var SliderView = /*#__PURE__*/ function() {
        function SliderView(doc, config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, SliderView);
            this.onChange_ = this.onChange_.bind(this);
            this.props_ = config.props;
            this.props_.emitter.on('change', this.onChange_);
            this.element = doc.createElement('div');
            this.element.classList.add(className$f());
            config.viewProps.bindClassModifiers(this.element);
            var trackElem = doc.createElement('div');
            trackElem.classList.add(className$f('t'));
            config.viewProps.bindTabIndex(trackElem);
            this.element.appendChild(trackElem);
            this.trackElement = trackElem;
            var knobElem = doc.createElement('div');
            knobElem.classList.add(className$f('k'));
            this.trackElement.appendChild(knobElem);
            this.knobElement = knobElem;
            config.value.emitter.on('change', this.onChange_);
            this.value = config.value;
            this.update_();
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(SliderView, [
            {
                key: "update_",
                value: function update_() {
                    var p = constrainRange(mapRange(this.value.rawValue, this.props_.get('minValue'), this.props_.get('maxValue'), 0, 100), 0, 100);
                    this.knobElement.style.width = "".concat(p, "%");
                }
            },
            {
                key: "onChange_",
                value: function onChange_() {
                    this.update_();
                }
            }
        ]);
        return SliderView;
    }();
    var SliderController = /*#__PURE__*/ function() {
        function SliderController(doc, config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, SliderController);
            this.onKeyDown_ = this.onKeyDown_.bind(this);
            this.onKeyUp_ = this.onKeyUp_.bind(this);
            this.onPointerDownOrMove_ = this.onPointerDownOrMove_.bind(this);
            this.onPointerUp_ = this.onPointerUp_.bind(this);
            this.baseStep_ = config.baseStep;
            this.value = config.value;
            this.viewProps = config.viewProps;
            this.props = config.props;
            this.view = new SliderView(doc, {
                props: this.props,
                value: this.value,
                viewProps: this.viewProps
            });
            this.ptHandler_ = new PointerHandler(this.view.trackElement);
            this.ptHandler_.emitter.on('down', this.onPointerDownOrMove_);
            this.ptHandler_.emitter.on('move', this.onPointerDownOrMove_);
            this.ptHandler_.emitter.on('up', this.onPointerUp_);
            this.view.trackElement.addEventListener('keydown', this.onKeyDown_);
            this.view.trackElement.addEventListener('keyup', this.onKeyUp_);
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(SliderController, [
            {
                key: "handlePointerEvent_",
                value: function handlePointerEvent_(d, opts) {
                    if (!d.point) return;
                    this.value.setRawValue(mapRange(constrainRange(d.point.x, 0, d.bounds.width), 0, d.bounds.width, this.props.get('minValue'), this.props.get('maxValue')), opts);
                }
            },
            {
                key: "onPointerDownOrMove_",
                value: function onPointerDownOrMove_(ev) {
                    this.handlePointerEvent_(ev.data, {
                        forceEmit: false,
                        last: false
                    });
                }
            },
            {
                key: "onPointerUp_",
                value: function onPointerUp_(ev) {
                    this.handlePointerEvent_(ev.data, {
                        forceEmit: true,
                        last: true
                    });
                }
            },
            {
                key: "onKeyDown_",
                value: function onKeyDown_(ev) {
                    var step = getStepForKey(this.baseStep_, getHorizontalStepKeys(ev));
                    if (step === 0) return;
                    this.value.setRawValue(this.value.rawValue + step, {
                        forceEmit: false,
                        last: false
                    });
                }
            },
            {
                key: "onKeyUp_",
                value: function onKeyUp_(ev) {
                    var step = getStepForKey(this.baseStep_, getHorizontalStepKeys(ev));
                    if (step === 0) return;
                    this.value.setRawValue(this.value.rawValue, {
                        forceEmit: true,
                        last: true
                    });
                }
            }
        ]);
        return SliderController;
    }();
    var className$e = ClassName('sldtxt');
    var SliderTextView = function SliderTextView(doc, config) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, SliderTextView);
        this.element = doc.createElement('div');
        this.element.classList.add(className$e());
        var sliderElem = doc.createElement('div');
        sliderElem.classList.add(className$e('s'));
        this.sliderView_ = config.sliderView;
        sliderElem.appendChild(this.sliderView_.element);
        this.element.appendChild(sliderElem);
        var textElem = doc.createElement('div');
        textElem.classList.add(className$e('t'));
        this.textView_ = config.textView;
        textElem.appendChild(this.textView_.element);
        this.element.appendChild(textElem);
    };
    var SliderTextController = /*#__PURE__*/ function() {
        function SliderTextController(doc, config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, SliderTextController);
            this.value = config.value;
            this.viewProps = config.viewProps;
            this.sliderC_ = new SliderController(doc, {
                baseStep: config.baseStep,
                props: config.sliderProps,
                value: config.value,
                viewProps: this.viewProps
            });
            this.textC_ = new NumberTextController(doc, {
                baseStep: config.baseStep,
                parser: config.parser,
                props: config.textProps,
                sliderProps: config.sliderProps,
                value: config.value,
                viewProps: config.viewProps
            });
            this.view = new SliderTextView(doc, {
                sliderView: this.sliderC_.view,
                textView: this.textC_.view
            });
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(SliderTextController, [
            {
                key: "sliderController",
                get: function get() {
                    return this.sliderC_;
                }
            },
            {
                key: "textController",
                get: function get() {
                    return this.textC_;
                }
            }
        ]);
        return SliderTextController;
    }();
    function writePrimitive(target, value) {
        target.write(value);
    }
    function parseListOptions(value) {
        var p = ParamsParsers;
        if (Array.isArray(value)) return p.required.array(p.required.object({
            text: p.required.string,
            value: p.required.raw
        }))(value).value;
        if ((typeof value === "undefined" ? "undefined" : (0, $86d22bcb52172ef7$export$71511d61b312f219)(value)) === 'object') return p.required.raw(value).value;
        return undefined;
    }
    function parsePickerLayout(value) {
        if (value === 'inline' || value === 'popup') return value;
        return undefined;
    }
    function parsePointDimensionParams(value) {
        var p = ParamsParsers;
        return p.required.object({
            max: p.optional.number,
            min: p.optional.number,
            step: p.optional.number
        })(value).value;
    }
    function normalizeListOptions(options) {
        if (Array.isArray(options)) return options;
        var items = [];
        Object.keys(options).forEach(function(text) {
            items.push({
                text: text,
                value: options[text]
            });
        });
        return items;
    }
    function createListConstraint(options) {
        return !isEmpty(options) ? new ListConstraint(normalizeListOptions(forceCast(options))) : null;
    }
    function findStep(constraint) {
        var c = constraint ? findConstraint(constraint, StepConstraint) : null;
        if (!c) return null;
        return c.step;
    }
    function getSuitableDecimalDigits(constraint, rawValue) {
        var sc = constraint && findConstraint(constraint, StepConstraint);
        if (sc) return getDecimalDigits(sc.step);
        return Math.max(getDecimalDigits(rawValue), 2);
    }
    function getBaseStep(constraint) {
        var step = findStep(constraint);
        return step !== null && step !== void 0 ? step : 1;
    }
    function getSuitableDraggingScale(constraint, rawValue) {
        var _a;
        var sc = constraint && findConstraint(constraint, StepConstraint);
        var base = Math.abs((_a = sc === null || sc === void 0 ? void 0 : sc.step) !== null && _a !== void 0 ? _a : rawValue);
        return base === 0 ? 0.1 : Math.pow(10, Math.floor(Math.log10(base)) - 1);
    }
    var className$d = ClassName('ckb');
    var CheckboxView = /*#__PURE__*/ function() {
        function CheckboxView(doc, config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, CheckboxView);
            this.onValueChange_ = this.onValueChange_.bind(this);
            this.element = doc.createElement('div');
            this.element.classList.add(className$d());
            config.viewProps.bindClassModifiers(this.element);
            var labelElem = doc.createElement('label');
            labelElem.classList.add(className$d('l'));
            this.element.appendChild(labelElem);
            var inputElem = doc.createElement('input');
            inputElem.classList.add(className$d('i'));
            inputElem.type = 'checkbox';
            labelElem.appendChild(inputElem);
            this.inputElement = inputElem;
            config.viewProps.bindDisabled(this.inputElement);
            var wrapperElem = doc.createElement('div');
            wrapperElem.classList.add(className$d('w'));
            labelElem.appendChild(wrapperElem);
            var markElem = createSvgIconElement(doc, 'check');
            wrapperElem.appendChild(markElem);
            config.value.emitter.on('change', this.onValueChange_);
            this.value = config.value;
            this.update_();
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(CheckboxView, [
            {
                key: "update_",
                value: function update_() {
                    this.inputElement.checked = this.value.rawValue;
                }
            },
            {
                key: "onValueChange_",
                value: function onValueChange_() {
                    this.update_();
                }
            }
        ]);
        return CheckboxView;
    }();
    var CheckboxController = /*#__PURE__*/ function() {
        function CheckboxController(doc, config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, CheckboxController);
            this.onInputChange_ = this.onInputChange_.bind(this);
            this.value = config.value;
            this.viewProps = config.viewProps;
            this.view = new CheckboxView(doc, {
                value: this.value,
                viewProps: this.viewProps
            });
            this.view.inputElement.addEventListener('change', this.onInputChange_);
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(CheckboxController, [
            {
                key: "onInputChange_",
                value: function onInputChange_(e) {
                    var inputElem = forceCast(e.currentTarget);
                    this.value.rawValue = inputElem.checked;
                }
            }
        ]);
        return CheckboxController;
    }();
    function createConstraint$6(params) {
        var constraints = [];
        var lc = createListConstraint(params.options);
        if (lc) constraints.push(lc);
        return new CompositeConstraint(constraints);
    }
    var BooleanInputPlugin = {
        id: 'input-bool',
        type: 'input',
        accept: function(value, params) {
            if (typeof value !== 'boolean') return null;
            var p = ParamsParsers;
            var result = parseParams(params, {
                options: p.optional.custom(parseListOptions)
            });
            return result ? {
                initialValue: value,
                params: result
            } : null;
        },
        binding: {
            reader: function(_args) {
                return boolFromUnknown;
            },
            constraint: function(args) {
                return createConstraint$6(args.params);
            },
            writer: function(_args) {
                return writePrimitive;
            }
        },
        controller: function(args) {
            var doc = args.document;
            var value = args.value;
            var c = args.constraint;
            var lc = c && findConstraint(c, ListConstraint);
            if (lc) return new ListController(doc, {
                props: new ValueMap({
                    options: lc.values.value('options')
                }),
                value: value,
                viewProps: args.viewProps
            });
            return new CheckboxController(doc, {
                value: value,
                viewProps: args.viewProps
            });
        }
    };
    var className$c = ClassName('col');
    var ColorView = function ColorView(doc, config) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, ColorView);
        this.element = doc.createElement('div');
        this.element.classList.add(className$c());
        config.foldable.bindExpandedClass(this.element, className$c(undefined, 'expanded'));
        bindValueMap(config.foldable, 'completed', valueToClassName(this.element, className$c(undefined, 'cpl')));
        var headElem = doc.createElement('div');
        headElem.classList.add(className$c('h'));
        this.element.appendChild(headElem);
        var swatchElem = doc.createElement('div');
        swatchElem.classList.add(className$c('s'));
        headElem.appendChild(swatchElem);
        this.swatchElement = swatchElem;
        var textElem = doc.createElement('div');
        textElem.classList.add(className$c('t'));
        headElem.appendChild(textElem);
        this.textElement = textElem;
        if (config.pickerLayout === 'inline') {
            var pickerElem = doc.createElement('div');
            pickerElem.classList.add(className$c('p'));
            this.element.appendChild(pickerElem);
            this.pickerElement = pickerElem;
        } else this.pickerElement = null;
    };
    function rgbToHslInt(r, g, b) {
        var rp = constrainRange(r / 255, 0, 1);
        var gp = constrainRange(g / 255, 0, 1);
        var bp = constrainRange(b / 255, 0, 1);
        var cmax = Math.max(rp, gp, bp);
        var cmin = Math.min(rp, gp, bp);
        var c = cmax - cmin;
        var h = 0;
        var s = 0;
        var l = (cmin + cmax) / 2;
        if (c !== 0) {
            s = c / (1 - Math.abs(cmax + cmin - 1));
            if (rp === cmax) h = (gp - bp) / c;
            else if (gp === cmax) h = 2 + (bp - rp) / c;
            else h = 4 + (rp - gp) / c;
            h = h / 6 + (h < 0 ? 1 : 0);
        }
        return [
            h * 360,
            s * 100,
            l * 100
        ];
    }
    function hslToRgbInt(h, s, l) {
        var hp = (h % 360 + 360) % 360;
        var sp = constrainRange(s / 100, 0, 1);
        var lp = constrainRange(l / 100, 0, 1);
        var c = (1 - Math.abs(2 * lp - 1)) * sp;
        var x = c * (1 - Math.abs(hp / 60 % 2 - 1));
        var m = lp - c / 2;
        var rp, gp, bp;
        var ref, ref1, ref2, ref3, ref4, ref5;
        if (hp >= 0 && hp < 60) ref = [
            c,
            x,
            0
        ], rp = ref[0], gp = ref[1], bp = ref[2], ref;
        else if (hp >= 60 && hp < 120) ref1 = [
            x,
            c,
            0
        ], rp = ref1[0], gp = ref1[1], bp = ref1[2], ref1;
        else if (hp >= 120 && hp < 180) ref2 = [
            0,
            c,
            x
        ], rp = ref2[0], gp = ref2[1], bp = ref2[2], ref2;
        else if (hp >= 180 && hp < 240) ref3 = [
            0,
            x,
            c
        ], rp = ref3[0], gp = ref3[1], bp = ref3[2], ref3;
        else if (hp >= 240 && hp < 300) ref4 = [
            x,
            0,
            c
        ], rp = ref4[0], gp = ref4[1], bp = ref4[2], ref4;
        else ref5 = [
            c,
            0,
            x
        ], rp = ref5[0], gp = ref5[1], bp = ref5[2], ref5;
        return [
            (rp + m) * 255,
            (gp + m) * 255,
            (bp + m) * 255
        ];
    }
    function rgbToHsvInt(r, g, b) {
        var rp = constrainRange(r / 255, 0, 1);
        var gp = constrainRange(g / 255, 0, 1);
        var bp = constrainRange(b / 255, 0, 1);
        var cmax = Math.max(rp, gp, bp);
        var cmin = Math.min(rp, gp, bp);
        var d = cmax - cmin;
        var h;
        if (d === 0) h = 0;
        else if (cmax === rp) h = 60 * (((gp - bp) / d % 6 + 6) % 6);
        else if (cmax === gp) h = 60 * ((bp - rp) / d + 2);
        else h = 60 * ((rp - gp) / d + 4);
        var s = cmax === 0 ? 0 : d / cmax;
        var v = cmax;
        return [
            h,
            s * 100,
            v * 100
        ];
    }
    function hsvToRgbInt(h, s, v) {
        var hp = loopRange(h, 360);
        var sp = constrainRange(s / 100, 0, 1);
        var vp = constrainRange(v / 100, 0, 1);
        var c = vp * sp;
        var x = c * (1 - Math.abs(hp / 60 % 2 - 1));
        var m = vp - c;
        var rp, gp, bp;
        var ref, ref1, ref2, ref3, ref4, ref5;
        if (hp >= 0 && hp < 60) ref = [
            c,
            x,
            0
        ], rp = ref[0], gp = ref[1], bp = ref[2], ref;
        else if (hp >= 60 && hp < 120) ref1 = [
            x,
            c,
            0
        ], rp = ref1[0], gp = ref1[1], bp = ref1[2], ref1;
        else if (hp >= 120 && hp < 180) ref2 = [
            0,
            c,
            x
        ], rp = ref2[0], gp = ref2[1], bp = ref2[2], ref2;
        else if (hp >= 180 && hp < 240) ref3 = [
            0,
            x,
            c
        ], rp = ref3[0], gp = ref3[1], bp = ref3[2], ref3;
        else if (hp >= 240 && hp < 300) ref4 = [
            x,
            0,
            c
        ], rp = ref4[0], gp = ref4[1], bp = ref4[2], ref4;
        else ref5 = [
            c,
            0,
            x
        ], rp = ref5[0], gp = ref5[1], bp = ref5[2], ref5;
        return [
            (rp + m) * 255,
            (gp + m) * 255,
            (bp + m) * 255
        ];
    }
    function hslToHsvInt(h, s, l) {
        var sd = l + s * (100 - Math.abs(2 * l - 100)) / 200;
        return [
            h,
            sd !== 0 ? s * (100 - Math.abs(2 * l - 100)) / sd : 0,
            l + s * (100 - Math.abs(2 * l - 100)) / 200
        ];
    }
    function hsvToHslInt(h, s, v) {
        var sd = 100 - Math.abs(v * (200 - s) / 100 - 100);
        return [
            h,
            sd !== 0 ? s * v / sd : 0,
            v * (200 - s) / 200
        ];
    }
    function removeAlphaComponent(comps) {
        return [
            comps[0],
            comps[1],
            comps[2]
        ];
    }
    function appendAlphaComponent(comps, alpha) {
        return [
            comps[0],
            comps[1],
            comps[2],
            alpha
        ];
    }
    var MODE_CONVERTER_MAP = {
        hsl: {
            hsl: function(h, s, l) {
                return [
                    h,
                    s,
                    l
                ];
            },
            hsv: hslToHsvInt,
            rgb: hslToRgbInt
        },
        hsv: {
            hsl: hsvToHslInt,
            hsv: function(h, s, v) {
                return [
                    h,
                    s,
                    v
                ];
            },
            rgb: hsvToRgbInt
        },
        rgb: {
            hsl: rgbToHslInt,
            hsv: rgbToHsvInt,
            rgb: function(r, g, b) {
                return [
                    r,
                    g,
                    b
                ];
            }
        }
    };
    function getColorMaxComponents(mode, type) {
        return [
            type === 'float' ? 1 : mode === 'rgb' ? 255 : 360,
            type === 'float' ? 1 : mode === 'rgb' ? 255 : 100,
            type === 'float' ? 1 : mode === 'rgb' ? 255 : 100
        ];
    }
    function loopHueRange(hue, max) {
        return hue === max ? max : loopRange(hue, max);
    }
    function constrainColorComponents(components, mode, type) {
        var _a;
        var ms = getColorMaxComponents(mode, type);
        return [
            mode === 'rgb' ? constrainRange(components[0], 0, ms[0]) : loopHueRange(components[0], ms[0]),
            constrainRange(components[1], 0, ms[1]),
            constrainRange(components[2], 0, ms[2]),
            constrainRange((_a = components[3]) !== null && _a !== void 0 ? _a : 1, 0, 1)
        ];
    }
    function convertColorType(comps, mode, from, to) {
        var fms = getColorMaxComponents(mode, from);
        var tms = getColorMaxComponents(mode, to);
        return comps.map(function(c, index) {
            return c / fms[index] * tms[index];
        });
    }
    function convertColor(components, from, to) {
        var _MODE_CONVERTER_MAP_from_mode;
        var intComps = convertColorType(components, from.mode, from.type, 'int');
        var result = (_MODE_CONVERTER_MAP_from_mode = MODE_CONVERTER_MAP[from.mode])[to.mode].apply(_MODE_CONVERTER_MAP_from_mode, (0, $4fcd3d80e9e33ca7$export$71511d61b312f219)(intComps));
        return convertColorType(result, to.mode, 'int', to.type);
    }
    function isRgbColorComponent(obj, key) {
        if ((typeof obj === "undefined" ? "undefined" : (0, $86d22bcb52172ef7$export$71511d61b312f219)(obj)) !== 'object' || isEmpty(obj)) return false;
        return key in obj && typeof obj[key] === 'number';
    }
    var Color = /*#__PURE__*/ function() {
        function Color(comps, mode) {
            var type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'int';
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, Color);
            this.mode = mode;
            this.type = type;
            this.comps_ = constrainColorComponents(comps, mode, type);
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(Color, [
            {
                key: "getComponents",
                value: function getComponents(opt_mode) {
                    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'int';
                    return appendAlphaComponent(convertColor(removeAlphaComponent(this.comps_), {
                        mode: this.mode,
                        type: this.type
                    }, {
                        mode: opt_mode !== null && opt_mode !== void 0 ? opt_mode : this.mode,
                        type: type
                    }), this.comps_[3]);
                }
            },
            {
                key: "toRgbaObject",
                value: function toRgbaObject() {
                    var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'int';
                    var rgbComps = this.getComponents('rgb', type);
                    return {
                        r: rgbComps[0],
                        g: rgbComps[1],
                        b: rgbComps[2],
                        a: rgbComps[3]
                    };
                }
            }
        ], [
            {
                key: "black",
                value: function black() {
                    var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'int';
                    return new Color([
                        0,
                        0,
                        0
                    ], 'rgb', type);
                }
            },
            {
                key: "fromObject",
                value: function fromObject(obj) {
                    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'int';
                    var comps = 'a' in obj ? [
                        obj.r,
                        obj.g,
                        obj.b,
                        obj.a
                    ] : [
                        obj.r,
                        obj.g,
                        obj.b
                    ];
                    return new Color(comps, 'rgb', type);
                }
            },
            {
                key: "toRgbaObject",
                value: function toRgbaObject(color) {
                    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'int';
                    return color.toRgbaObject(type);
                }
            },
            {
                key: "isRgbColorObject",
                value: function isRgbColorObject(obj) {
                    return isRgbColorComponent(obj, 'r') && isRgbColorComponent(obj, 'g') && isRgbColorComponent(obj, 'b');
                }
            },
            {
                key: "isRgbaColorObject",
                value: function isRgbaColorObject(obj) {
                    return this.isRgbColorObject(obj) && isRgbColorComponent(obj, 'a');
                }
            },
            {
                key: "isColorObject",
                value: function isColorObject(obj) {
                    return this.isRgbColorObject(obj);
                }
            },
            {
                key: "equals",
                value: function equals(v1, v2) {
                    if (v1.mode !== v2.mode) return false;
                    var comps1 = v1.comps_;
                    var comps2 = v2.comps_;
                    for(var i = 0; i < comps1.length; i++){
                        if (comps1[i] !== comps2[i]) return false;
                    }
                    return true;
                }
            }
        ]);
        return Color;
    }();
    var className$b = ClassName('colp');
    var ColorPickerView = /*#__PURE__*/ function() {
        function ColorPickerView(doc, config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, ColorPickerView);
            this.alphaViews_ = null;
            this.element = doc.createElement('div');
            this.element.classList.add(className$b());
            config.viewProps.bindClassModifiers(this.element);
            var hsvElem = doc.createElement('div');
            hsvElem.classList.add(className$b('hsv'));
            var svElem = doc.createElement('div');
            svElem.classList.add(className$b('sv'));
            this.svPaletteView_ = config.svPaletteView;
            svElem.appendChild(this.svPaletteView_.element);
            hsvElem.appendChild(svElem);
            var hElem = doc.createElement('div');
            hElem.classList.add(className$b('h'));
            this.hPaletteView_ = config.hPaletteView;
            hElem.appendChild(this.hPaletteView_.element);
            hsvElem.appendChild(hElem);
            this.element.appendChild(hsvElem);
            var rgbElem = doc.createElement('div');
            rgbElem.classList.add(className$b('rgb'));
            this.textView_ = config.textView;
            rgbElem.appendChild(this.textView_.element);
            this.element.appendChild(rgbElem);
            if (config.alphaViews) {
                this.alphaViews_ = {
                    palette: config.alphaViews.palette,
                    text: config.alphaViews.text
                };
                var aElem = doc.createElement('div');
                aElem.classList.add(className$b('a'));
                var apElem = doc.createElement('div');
                apElem.classList.add(className$b('ap'));
                apElem.appendChild(this.alphaViews_.palette.element);
                aElem.appendChild(apElem);
                var atElem = doc.createElement('div');
                atElem.classList.add(className$b('at'));
                atElem.appendChild(this.alphaViews_.text.element);
                aElem.appendChild(atElem);
                this.element.appendChild(aElem);
            }
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(ColorPickerView, [
            {
                key: "allFocusableElements",
                get: function get() {
                    var elems = [
                        this.svPaletteView_.element,
                        this.hPaletteView_.element,
                        this.textView_.modeSelectElement
                    ].concat((0, $4fcd3d80e9e33ca7$export$71511d61b312f219)(this.textView_.textViews.map(function(v) {
                        return v.inputElement;
                    })));
                    if (this.alphaViews_) elems.push(this.alphaViews_.palette.element, this.alphaViews_.text.inputElement);
                    return elems;
                }
            }
        ]);
        return ColorPickerView;
    }();
    function parseColorType(value) {
        return value === 'int' ? 'int' : value === 'float' ? 'float' : undefined;
    }
    function parseColorInputParams(params) {
        var p = ParamsParsers;
        return parseParams(params, {
            alpha: p.optional.boolean,
            color: p.optional.object({
                alpha: p.optional.boolean,
                type: p.optional.custom(parseColorType)
            }),
            expanded: p.optional.boolean,
            picker: p.optional.custom(parsePickerLayout)
        });
    }
    function getBaseStepForColor(forAlpha) {
        return forAlpha ? 0.1 : 1;
    }
    function extractColorType(params) {
        var _a;
        return (_a = params.color) === null || _a === void 0 ? void 0 : _a.type;
    }
    function equalsStringColorFormat(f1, f2) {
        return f1.alpha === f2.alpha && f1.mode === f2.mode && f1.notation === f2.notation && f1.type === f2.type;
    }
    function parseCssNumberOrPercentage(text, maxValue) {
        var m = text.match(/^(.+)%$/);
        if (!m) return Math.min(parseFloat(text), maxValue);
        return Math.min(parseFloat(m[1]) * 0.01 * maxValue, maxValue);
    }
    var ANGLE_TO_DEG_MAP = {
        deg: function(angle) {
            return angle;
        },
        grad: function(angle) {
            return angle * 360 / 400;
        },
        rad: function(angle) {
            return angle * 360 / (2 * Math.PI);
        },
        turn: function(angle) {
            return angle * 360;
        }
    };
    function parseCssNumberOrAngle(text) {
        var m = text.match(/^([0-9.]+?)(deg|grad|rad|turn)$/);
        if (!m) return parseFloat(text);
        var angle = parseFloat(m[1]);
        var unit = m[2];
        return ANGLE_TO_DEG_MAP[unit](angle);
    }
    function parseFunctionalRgbColorComponents(text) {
        var m = text.match(/^rgb\(\s*([0-9A-Fa-f.]+%?)\s*,\s*([0-9A-Fa-f.]+%?)\s*,\s*([0-9A-Fa-f.]+%?)\s*\)$/);
        if (!m) return null;
        var comps = [
            parseCssNumberOrPercentage(m[1], 255),
            parseCssNumberOrPercentage(m[2], 255),
            parseCssNumberOrPercentage(m[3], 255)
        ];
        if (isNaN(comps[0]) || isNaN(comps[1]) || isNaN(comps[2])) return null;
        return comps;
    }
    function createFunctionalRgbColorParser(type) {
        return function(text) {
            var comps = parseFunctionalRgbColorComponents(text);
            return comps ? new Color(comps, 'rgb', type) : null;
        };
    }
    function parseFunctionalRgbaColorComponents(text) {
        var m = text.match(/^rgba\(\s*([0-9A-Fa-f.]+%?)\s*,\s*([0-9A-Fa-f.]+%?)\s*,\s*([0-9A-Fa-f.]+%?)\s*,\s*([0-9A-Fa-f.]+%?)\s*\)$/);
        if (!m) return null;
        var comps = [
            parseCssNumberOrPercentage(m[1], 255),
            parseCssNumberOrPercentage(m[2], 255),
            parseCssNumberOrPercentage(m[3], 255),
            parseCssNumberOrPercentage(m[4], 1)
        ];
        if (isNaN(comps[0]) || isNaN(comps[1]) || isNaN(comps[2]) || isNaN(comps[3])) return null;
        return comps;
    }
    function createFunctionalRgbaColorParser(type) {
        return function(text) {
            var comps = parseFunctionalRgbaColorComponents(text);
            return comps ? new Color(comps, 'rgb', type) : null;
        };
    }
    function parseHslColorComponents(text) {
        var m = text.match(/^hsl\(\s*([0-9A-Fa-f.]+(?:deg|grad|rad|turn)?)\s*,\s*([0-9A-Fa-f.]+%?)\s*,\s*([0-9A-Fa-f.]+%?)\s*\)$/);
        if (!m) return null;
        var comps = [
            parseCssNumberOrAngle(m[1]),
            parseCssNumberOrPercentage(m[2], 100),
            parseCssNumberOrPercentage(m[3], 100)
        ];
        if (isNaN(comps[0]) || isNaN(comps[1]) || isNaN(comps[2])) return null;
        return comps;
    }
    function createHslColorParser(type) {
        return function(text) {
            var comps = parseHslColorComponents(text);
            return comps ? new Color(comps, 'hsl', type) : null;
        };
    }
    function parseHslaColorComponents(text) {
        var m = text.match(/^hsla\(\s*([0-9A-Fa-f.]+(?:deg|grad|rad|turn)?)\s*,\s*([0-9A-Fa-f.]+%?)\s*,\s*([0-9A-Fa-f.]+%?)\s*,\s*([0-9A-Fa-f.]+%?)\s*\)$/);
        if (!m) return null;
        var comps = [
            parseCssNumberOrAngle(m[1]),
            parseCssNumberOrPercentage(m[2], 100),
            parseCssNumberOrPercentage(m[3], 100),
            parseCssNumberOrPercentage(m[4], 1)
        ];
        if (isNaN(comps[0]) || isNaN(comps[1]) || isNaN(comps[2]) || isNaN(comps[3])) return null;
        return comps;
    }
    function createHslaColorParser(type) {
        return function(text) {
            var comps = parseHslaColorComponents(text);
            return comps ? new Color(comps, 'hsl', type) : null;
        };
    }
    function parseHexRgbColorComponents(text) {
        var mRgb = text.match(/^#([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])$/);
        if (mRgb) return [
            parseInt(mRgb[1] + mRgb[1], 16),
            parseInt(mRgb[2] + mRgb[2], 16),
            parseInt(mRgb[3] + mRgb[3], 16)
        ];
        var mRrggbb = text.match(/^(?:#|0x)([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})$/);
        if (mRrggbb) return [
            parseInt(mRrggbb[1], 16),
            parseInt(mRrggbb[2], 16),
            parseInt(mRrggbb[3], 16)
        ];
        return null;
    }
    function parseHexRgbColor(text) {
        var comps = parseHexRgbColorComponents(text);
        return comps ? new Color(comps, 'rgb', 'int') : null;
    }
    function parseHexRgbaColorComponents(text) {
        var mRgb = text.match(/^#?([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])$/);
        if (mRgb) return [
            parseInt(mRgb[1] + mRgb[1], 16),
            parseInt(mRgb[2] + mRgb[2], 16),
            parseInt(mRgb[3] + mRgb[3], 16),
            mapRange(parseInt(mRgb[4] + mRgb[4], 16), 0, 255, 0, 1)
        ];
        var mRrggbb = text.match(/^(?:#|0x)?([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})$/);
        if (mRrggbb) return [
            parseInt(mRrggbb[1], 16),
            parseInt(mRrggbb[2], 16),
            parseInt(mRrggbb[3], 16),
            mapRange(parseInt(mRrggbb[4], 16), 0, 255, 0, 1)
        ];
        return null;
    }
    function parseHexRgbaColor(text) {
        var comps = parseHexRgbaColorComponents(text);
        return comps ? new Color(comps, 'rgb', 'int') : null;
    }
    function parseObjectRgbColorComponents(text) {
        var m = text.match(/^\{\s*r\s*:\s*([0-9A-Fa-f.]+%?)\s*,\s*g\s*:\s*([0-9A-Fa-f.]+%?)\s*,\s*b\s*:\s*([0-9A-Fa-f.]+%?)\s*\}$/);
        if (!m) return null;
        var comps = [
            parseFloat(m[1]),
            parseFloat(m[2]),
            parseFloat(m[3])
        ];
        if (isNaN(comps[0]) || isNaN(comps[1]) || isNaN(comps[2])) return null;
        return comps;
    }
    function createObjectRgbColorParser(type) {
        return function(text) {
            var comps = parseObjectRgbColorComponents(text);
            return comps ? new Color(comps, 'rgb', type) : null;
        };
    }
    function parseObjectRgbaColorComponents(text) {
        var m = text.match(/^\{\s*r\s*:\s*([0-9A-Fa-f.]+%?)\s*,\s*g\s*:\s*([0-9A-Fa-f.]+%?)\s*,\s*b\s*:\s*([0-9A-Fa-f.]+%?)\s*,\s*a\s*:\s*([0-9A-Fa-f.]+%?)\s*\}$/);
        if (!m) return null;
        var comps = [
            parseFloat(m[1]),
            parseFloat(m[2]),
            parseFloat(m[3]),
            parseFloat(m[4])
        ];
        if (isNaN(comps[0]) || isNaN(comps[1]) || isNaN(comps[2]) || isNaN(comps[3])) return null;
        return comps;
    }
    function createObjectRgbaColorParser(type) {
        return function(text) {
            var comps = parseObjectRgbaColorComponents(text);
            return comps ? new Color(comps, 'rgb', type) : null;
        };
    }
    var PARSER_AND_RESULT = [
        {
            parser: parseHexRgbColorComponents,
            result: {
                alpha: false,
                mode: 'rgb',
                notation: 'hex'
            }
        },
        {
            parser: parseHexRgbaColorComponents,
            result: {
                alpha: true,
                mode: 'rgb',
                notation: 'hex'
            }
        },
        {
            parser: parseFunctionalRgbColorComponents,
            result: {
                alpha: false,
                mode: 'rgb',
                notation: 'func'
            }
        },
        {
            parser: parseFunctionalRgbaColorComponents,
            result: {
                alpha: true,
                mode: 'rgb',
                notation: 'func'
            }
        },
        {
            parser: parseHslColorComponents,
            result: {
                alpha: false,
                mode: 'hsl',
                notation: 'func'
            }
        },
        {
            parser: parseHslaColorComponents,
            result: {
                alpha: true,
                mode: 'hsl',
                notation: 'func'
            }
        },
        {
            parser: parseObjectRgbColorComponents,
            result: {
                alpha: false,
                mode: 'rgb',
                notation: 'object'
            }
        },
        {
            parser: parseObjectRgbaColorComponents,
            result: {
                alpha: true,
                mode: 'rgb',
                notation: 'object'
            }
        }
    ];
    function detectStringColor(text) {
        return PARSER_AND_RESULT.reduce(function(prev, param) {
            var parser = param.parser, detection = param.result;
            if (prev) return prev;
            return parser(text) ? detection : null;
        }, null);
    }
    function detectStringColorFormat(text) {
        var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'int';
        var r = detectStringColor(text);
        if (!r) return null;
        if (r.notation === 'hex' && type !== 'float') return Object.assign(Object.assign({}, r), {
            type: 'int'
        });
        if (r.notation === 'func') return Object.assign(Object.assign({}, r), {
            type: type
        });
        return null;
    }
    var TYPE_TO_PARSERS = {
        int: [
            parseHexRgbColor,
            parseHexRgbaColor,
            createFunctionalRgbColorParser('int'),
            createFunctionalRgbaColorParser('int'),
            createHslColorParser('int'),
            createHslaColorParser('int'),
            createObjectRgbColorParser('int'),
            createObjectRgbaColorParser('int')
        ],
        float: [
            createFunctionalRgbColorParser('float'),
            createFunctionalRgbaColorParser('float'),
            createHslColorParser('float'),
            createHslaColorParser('float'),
            createObjectRgbColorParser('float'),
            createObjectRgbaColorParser('float')
        ]
    };
    function createColorStringBindingReader(type) {
        var parsers = TYPE_TO_PARSERS[type];
        return function(value) {
            if (typeof value !== 'string') return Color.black(type);
            var result = parsers.reduce(function(prev, parser) {
                if (prev) return prev;
                return parser(value);
            }, null);
            return result !== null && result !== void 0 ? result : Color.black(type);
        };
    }
    function createColorStringParser(type) {
        var parsers = TYPE_TO_PARSERS[type];
        return function(value) {
            return parsers.reduce(function(prev, parser) {
                if (prev) return prev;
                return parser(value);
            }, null);
        };
    }
    function zerofill(comp) {
        var hex = constrainRange(Math.floor(comp), 0, 255).toString(16);
        return hex.length === 1 ? "0".concat(hex) : hex;
    }
    function colorToHexRgbString(value) {
        var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '#';
        var hexes = removeAlphaComponent(value.getComponents('rgb')).map(zerofill).join('');
        return "".concat(prefix).concat(hexes);
    }
    function colorToHexRgbaString(value) {
        var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '#';
        var rgbaComps = value.getComponents('rgb');
        var hexes = [
            rgbaComps[0],
            rgbaComps[1],
            rgbaComps[2],
            rgbaComps[3] * 255
        ].map(zerofill).join('');
        return "".concat(prefix).concat(hexes);
    }
    function colorToFunctionalRgbString(value, opt_type) {
        var formatter = createNumberFormatter(opt_type === 'float' ? 2 : 0);
        var comps = removeAlphaComponent(value.getComponents('rgb', opt_type)).map(function(comp) {
            return formatter(comp);
        });
        return "rgb(".concat(comps.join(', '), ")");
    }
    function createFunctionalRgbColorFormatter(type) {
        return function(value) {
            return colorToFunctionalRgbString(value, type);
        };
    }
    function colorToFunctionalRgbaString(value, opt_type) {
        var aFormatter = createNumberFormatter(2);
        var rgbFormatter = createNumberFormatter(opt_type === 'float' ? 2 : 0);
        var comps = value.getComponents('rgb', opt_type).map(function(comp, index) {
            var formatter = index === 3 ? aFormatter : rgbFormatter;
            return formatter(comp);
        });
        return "rgba(".concat(comps.join(', '), ")");
    }
    function createFunctionalRgbaColorFormatter(type) {
        return function(value) {
            return colorToFunctionalRgbaString(value, type);
        };
    }
    function colorToFunctionalHslString(value) {
        var formatters = [
            createNumberFormatter(0),
            formatPercentage,
            formatPercentage
        ];
        var comps = removeAlphaComponent(value.getComponents('hsl')).map(function(comp, index) {
            return formatters[index](comp);
        });
        return "hsl(".concat(comps.join(', '), ")");
    }
    function colorToFunctionalHslaString(value) {
        var formatters = [
            createNumberFormatter(0),
            formatPercentage,
            formatPercentage,
            createNumberFormatter(2)
        ];
        var comps = value.getComponents('hsl').map(function(comp, index) {
            return formatters[index](comp);
        });
        return "hsla(".concat(comps.join(', '), ")");
    }
    function colorToObjectRgbString(value, type) {
        var formatter = createNumberFormatter(type === 'float' ? 2 : 0);
        var names = [
            'r',
            'g',
            'b'
        ];
        var comps = removeAlphaComponent(value.getComponents('rgb', type)).map(function(comp, index) {
            return "".concat(names[index], ": ").concat(formatter(comp));
        });
        return "{".concat(comps.join(', '), "}");
    }
    function createObjectRgbColorFormatter(type) {
        return function(value) {
            return colorToObjectRgbString(value, type);
        };
    }
    function colorToObjectRgbaString(value, type) {
        var aFormatter = createNumberFormatter(2);
        var rgbFormatter = createNumberFormatter(type === 'float' ? 2 : 0);
        var names = [
            'r',
            'g',
            'b',
            'a'
        ];
        var comps = value.getComponents('rgb', type).map(function(comp, index) {
            var formatter = index === 3 ? aFormatter : rgbFormatter;
            return "".concat(names[index], ": ").concat(formatter(comp));
        });
        return "{".concat(comps.join(', '), "}");
    }
    function createObjectRgbaColorFormatter(type) {
        return function(value) {
            return colorToObjectRgbaString(value, type);
        };
    }
    var FORMAT_AND_STRINGIFIERS = [
        {
            format: {
                alpha: false,
                mode: 'rgb',
                notation: 'hex',
                type: 'int'
            },
            stringifier: colorToHexRgbString
        },
        {
            format: {
                alpha: true,
                mode: 'rgb',
                notation: 'hex',
                type: 'int'
            },
            stringifier: colorToHexRgbaString
        },
        {
            format: {
                alpha: false,
                mode: 'hsl',
                notation: 'func',
                type: 'int'
            },
            stringifier: colorToFunctionalHslString
        },
        {
            format: {
                alpha: true,
                mode: 'hsl',
                notation: 'func',
                type: 'int'
            },
            stringifier: colorToFunctionalHslaString
        }
    ].concat((0, $4fcd3d80e9e33ca7$export$71511d61b312f219)([
        'int',
        'float'
    ].reduce(function(prev, type) {
        return (0, $4fcd3d80e9e33ca7$export$71511d61b312f219)(prev).concat([
            {
                format: {
                    alpha: false,
                    mode: 'rgb',
                    notation: 'func',
                    type: type
                },
                stringifier: createFunctionalRgbColorFormatter(type)
            },
            {
                format: {
                    alpha: true,
                    mode: 'rgb',
                    notation: 'func',
                    type: type
                },
                stringifier: createFunctionalRgbaColorFormatter(type)
            },
            {
                format: {
                    alpha: false,
                    mode: 'rgb',
                    notation: 'object',
                    type: type
                },
                stringifier: createObjectRgbColorFormatter(type)
            },
            {
                format: {
                    alpha: true,
                    mode: 'rgb',
                    notation: 'object',
                    type: type
                },
                stringifier: createObjectRgbaColorFormatter(type)
            }
        ]);
    }, [])));
    function findColorStringifier(format) {
        return FORMAT_AND_STRINGIFIERS.reduce(function(prev, fas) {
            if (prev) return prev;
            return equalsStringColorFormat(fas.format, format) ? fas.stringifier : null;
        }, null);
    }
    var className$a = ClassName('apl');
    var APaletteView = /*#__PURE__*/ function() {
        function APaletteView(doc, config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, APaletteView);
            this.onValueChange_ = this.onValueChange_.bind(this);
            this.value = config.value;
            this.value.emitter.on('change', this.onValueChange_);
            this.element = doc.createElement('div');
            this.element.classList.add(className$a());
            config.viewProps.bindClassModifiers(this.element);
            config.viewProps.bindTabIndex(this.element);
            var barElem = doc.createElement('div');
            barElem.classList.add(className$a('b'));
            this.element.appendChild(barElem);
            var colorElem = doc.createElement('div');
            colorElem.classList.add(className$a('c'));
            barElem.appendChild(colorElem);
            this.colorElem_ = colorElem;
            var markerElem = doc.createElement('div');
            markerElem.classList.add(className$a('m'));
            this.element.appendChild(markerElem);
            this.markerElem_ = markerElem;
            var previewElem = doc.createElement('div');
            previewElem.classList.add(className$a('p'));
            this.markerElem_.appendChild(previewElem);
            this.previewElem_ = previewElem;
            this.update_();
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(APaletteView, [
            {
                key: "update_",
                value: function update_() {
                    var c = this.value.rawValue;
                    var rgbaComps = c.getComponents('rgb');
                    var leftColor = new Color([
                        rgbaComps[0],
                        rgbaComps[1],
                        rgbaComps[2],
                        0
                    ], 'rgb');
                    var rightColor = new Color([
                        rgbaComps[0],
                        rgbaComps[1],
                        rgbaComps[2],
                        255
                    ], 'rgb');
                    var gradientComps = [
                        'to right',
                        colorToFunctionalRgbaString(leftColor),
                        colorToFunctionalRgbaString(rightColor)
                    ];
                    this.colorElem_.style.background = "linear-gradient(".concat(gradientComps.join(','), ")");
                    this.previewElem_.style.backgroundColor = colorToFunctionalRgbaString(c);
                    var left = mapRange(rgbaComps[3], 0, 1, 0, 100);
                    this.markerElem_.style.left = "".concat(left, "%");
                }
            },
            {
                key: "onValueChange_",
                value: function onValueChange_() {
                    this.update_();
                }
            }
        ]);
        return APaletteView;
    }();
    var APaletteController = /*#__PURE__*/ function() {
        function APaletteController(doc, config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, APaletteController);
            this.onKeyDown_ = this.onKeyDown_.bind(this);
            this.onKeyUp_ = this.onKeyUp_.bind(this);
            this.onPointerDown_ = this.onPointerDown_.bind(this);
            this.onPointerMove_ = this.onPointerMove_.bind(this);
            this.onPointerUp_ = this.onPointerUp_.bind(this);
            this.value = config.value;
            this.viewProps = config.viewProps;
            this.view = new APaletteView(doc, {
                value: this.value,
                viewProps: this.viewProps
            });
            this.ptHandler_ = new PointerHandler(this.view.element);
            this.ptHandler_.emitter.on('down', this.onPointerDown_);
            this.ptHandler_.emitter.on('move', this.onPointerMove_);
            this.ptHandler_.emitter.on('up', this.onPointerUp_);
            this.view.element.addEventListener('keydown', this.onKeyDown_);
            this.view.element.addEventListener('keyup', this.onKeyUp_);
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(APaletteController, [
            {
                key: "handlePointerEvent_",
                value: function handlePointerEvent_(d, opts) {
                    if (!d.point) return;
                    var alpha = d.point.x / d.bounds.width;
                    var c = this.value.rawValue;
                    var _c_getComponents = (0, $cccf0333cb9f9910$export$71511d61b312f219)(c.getComponents('hsv'), 3), h = _c_getComponents[0], s = _c_getComponents[1], v = _c_getComponents[2];
                    this.value.setRawValue(new Color([
                        h,
                        s,
                        v,
                        alpha
                    ], 'hsv'), opts);
                }
            },
            {
                key: "onPointerDown_",
                value: function onPointerDown_(ev) {
                    this.handlePointerEvent_(ev.data, {
                        forceEmit: false,
                        last: false
                    });
                }
            },
            {
                key: "onPointerMove_",
                value: function onPointerMove_(ev) {
                    this.handlePointerEvent_(ev.data, {
                        forceEmit: false,
                        last: false
                    });
                }
            },
            {
                key: "onPointerUp_",
                value: function onPointerUp_(ev) {
                    this.handlePointerEvent_(ev.data, {
                        forceEmit: true,
                        last: true
                    });
                }
            },
            {
                key: "onKeyDown_",
                value: function onKeyDown_(ev) {
                    var step = getStepForKey(getBaseStepForColor(true), getHorizontalStepKeys(ev));
                    if (step === 0) return;
                    var c = this.value.rawValue;
                    var _c_getComponents = (0, $cccf0333cb9f9910$export$71511d61b312f219)(c.getComponents('hsv'), 4), h = _c_getComponents[0], s = _c_getComponents[1], v = _c_getComponents[2], a = _c_getComponents[3];
                    this.value.setRawValue(new Color([
                        h,
                        s,
                        v,
                        a + step
                    ], 'hsv'), {
                        forceEmit: false,
                        last: false
                    });
                }
            },
            {
                key: "onKeyUp_",
                value: function onKeyUp_(ev) {
                    var step = getStepForKey(getBaseStepForColor(true), getHorizontalStepKeys(ev));
                    if (step === 0) return;
                    this.value.setRawValue(this.value.rawValue, {
                        forceEmit: true,
                        last: true
                    });
                }
            }
        ]);
        return APaletteController;
    }();
    var className$9 = ClassName('coltxt');
    function createModeSelectElement(doc) {
        var selectElem = doc.createElement('select');
        var items = [
            {
                text: 'RGB',
                value: 'rgb'
            },
            {
                text: 'HSL',
                value: 'hsl'
            },
            {
                text: 'HSV',
                value: 'hsv'
            }
        ];
        selectElem.appendChild(items.reduce(function(frag, item) {
            var optElem = doc.createElement('option');
            optElem.textContent = item.text;
            optElem.value = item.value;
            frag.appendChild(optElem);
            return frag;
        }, doc.createDocumentFragment()));
        return selectElem;
    }
    var ColorTextView = /*#__PURE__*/ function() {
        function ColorTextView(doc, config) {
            var _this = this;
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, ColorTextView);
            this.element = doc.createElement('div');
            this.element.classList.add(className$9());
            config.viewProps.bindClassModifiers(this.element);
            var modeElem = doc.createElement('div');
            modeElem.classList.add(className$9('m'));
            this.modeElem_ = createModeSelectElement(doc);
            this.modeElem_.classList.add(className$9('ms'));
            modeElem.appendChild(this.modeSelectElement);
            config.viewProps.bindDisabled(this.modeElem_);
            var modeMarkerElem = doc.createElement('div');
            modeMarkerElem.classList.add(className$9('mm'));
            modeMarkerElem.appendChild(createSvgIconElement(doc, 'dropdown'));
            modeElem.appendChild(modeMarkerElem);
            this.element.appendChild(modeElem);
            var textsElem = doc.createElement('div');
            textsElem.classList.add(className$9('w'));
            this.element.appendChild(textsElem);
            this.textsElem_ = textsElem;
            this.textViews_ = config.textViews;
            this.applyTextViews_();
            bindValue(config.colorMode, function(mode) {
                _this.modeElem_.value = mode;
            });
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(ColorTextView, [
            {
                key: "modeSelectElement",
                get: function get() {
                    return this.modeElem_;
                }
            },
            {
                key: "textViews",
                get: function get() {
                    return this.textViews_;
                },
                set: function set(textViews) {
                    this.textViews_ = textViews;
                    this.applyTextViews_();
                }
            },
            {
                key: "applyTextViews_",
                value: function applyTextViews_() {
                    var _this = this;
                    removeChildElements(this.textsElem_);
                    var doc = this.element.ownerDocument;
                    this.textViews_.forEach(function(v) {
                        var compElem = doc.createElement('div');
                        compElem.classList.add(className$9('c'));
                        compElem.appendChild(v.element);
                        _this.textsElem_.appendChild(compElem);
                    });
                }
            }
        ]);
        return ColorTextView;
    }();
    function createFormatter$2(type) {
        return createNumberFormatter(type === 'float' ? 2 : 0);
    }
    function createConstraint$5(mode, type, index) {
        var max = getColorMaxComponents(mode, type)[index];
        return new DefiniteRangeConstraint({
            min: 0,
            max: max
        });
    }
    function createComponentController(doc, config, index) {
        return new NumberTextController(doc, {
            arrayPosition: index === 0 ? 'fst' : index === 2 ? 'lst' : 'mid',
            baseStep: getBaseStepForColor(false),
            parser: config.parser,
            props: ValueMap.fromObject({
                draggingScale: config.colorType === 'float' ? 0.01 : 1,
                formatter: createFormatter$2(config.colorType)
            }),
            value: createValue(0, {
                constraint: createConstraint$5(config.colorMode, config.colorType, index)
            }),
            viewProps: config.viewProps
        });
    }
    var ColorTextController = /*#__PURE__*/ function() {
        function ColorTextController(doc, config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, ColorTextController);
            this.onModeSelectChange_ = this.onModeSelectChange_.bind(this);
            this.colorType_ = config.colorType;
            this.parser_ = config.parser;
            this.value = config.value;
            this.viewProps = config.viewProps;
            this.colorMode = createValue(this.value.rawValue.mode);
            this.ccs_ = this.createComponentControllers_(doc);
            this.view = new ColorTextView(doc, {
                colorMode: this.colorMode,
                textViews: [
                    this.ccs_[0].view,
                    this.ccs_[1].view,
                    this.ccs_[2].view
                ],
                viewProps: this.viewProps
            });
            this.view.modeSelectElement.addEventListener('change', this.onModeSelectChange_);
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(ColorTextController, [
            {
                key: "createComponentControllers_",
                value: function createComponentControllers_(doc) {
                    var _this = this;
                    var cc = {
                        colorMode: this.colorMode.rawValue,
                        colorType: this.colorType_,
                        parser: this.parser_,
                        viewProps: this.viewProps
                    };
                    var ccs = [
                        createComponentController(doc, cc, 0),
                        createComponentController(doc, cc, 1),
                        createComponentController(doc, cc, 2)
                    ];
                    ccs.forEach(function(cs, index) {
                        connectValues({
                            primary: _this.value,
                            secondary: cs.value,
                            forward: function(p) {
                                return p.rawValue.getComponents(_this.colorMode.rawValue, _this.colorType_)[index];
                            },
                            backward: function(p, s) {
                                var pickedMode = _this.colorMode.rawValue;
                                var comps = p.rawValue.getComponents(pickedMode, _this.colorType_);
                                comps[index] = s.rawValue;
                                return new Color(appendAlphaComponent(removeAlphaComponent(comps), comps[3]), pickedMode, _this.colorType_);
                            }
                        });
                    });
                    return ccs;
                }
            },
            {
                key: "onModeSelectChange_",
                value: function onModeSelectChange_(ev) {
                    var selectElem = ev.currentTarget;
                    this.colorMode.rawValue = selectElem.value;
                    this.ccs_ = this.createComponentControllers_(this.view.element.ownerDocument);
                    this.view.textViews = [
                        this.ccs_[0].view,
                        this.ccs_[1].view,
                        this.ccs_[2].view
                    ];
                }
            }
        ]);
        return ColorTextController;
    }();
    var className$8 = ClassName('hpl');
    var HPaletteView = /*#__PURE__*/ function() {
        function HPaletteView(doc, config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, HPaletteView);
            this.onValueChange_ = this.onValueChange_.bind(this);
            this.value = config.value;
            this.value.emitter.on('change', this.onValueChange_);
            this.element = doc.createElement('div');
            this.element.classList.add(className$8());
            config.viewProps.bindClassModifiers(this.element);
            config.viewProps.bindTabIndex(this.element);
            var colorElem = doc.createElement('div');
            colorElem.classList.add(className$8('c'));
            this.element.appendChild(colorElem);
            var markerElem = doc.createElement('div');
            markerElem.classList.add(className$8('m'));
            this.element.appendChild(markerElem);
            this.markerElem_ = markerElem;
            this.update_();
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(HPaletteView, [
            {
                key: "update_",
                value: function update_() {
                    var c = this.value.rawValue;
                    var _c_getComponents = (0, $cccf0333cb9f9910$export$71511d61b312f219)(c.getComponents('hsv'), 1), h = _c_getComponents[0];
                    this.markerElem_.style.backgroundColor = colorToFunctionalRgbString(new Color([
                        h,
                        100,
                        100
                    ], 'hsv'));
                    var left = mapRange(h, 0, 360, 0, 100);
                    this.markerElem_.style.left = "".concat(left, "%");
                }
            },
            {
                key: "onValueChange_",
                value: function onValueChange_() {
                    this.update_();
                }
            }
        ]);
        return HPaletteView;
    }();
    var HPaletteController = /*#__PURE__*/ function() {
        function HPaletteController(doc, config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, HPaletteController);
            this.onKeyDown_ = this.onKeyDown_.bind(this);
            this.onKeyUp_ = this.onKeyUp_.bind(this);
            this.onPointerDown_ = this.onPointerDown_.bind(this);
            this.onPointerMove_ = this.onPointerMove_.bind(this);
            this.onPointerUp_ = this.onPointerUp_.bind(this);
            this.value = config.value;
            this.viewProps = config.viewProps;
            this.view = new HPaletteView(doc, {
                value: this.value,
                viewProps: this.viewProps
            });
            this.ptHandler_ = new PointerHandler(this.view.element);
            this.ptHandler_.emitter.on('down', this.onPointerDown_);
            this.ptHandler_.emitter.on('move', this.onPointerMove_);
            this.ptHandler_.emitter.on('up', this.onPointerUp_);
            this.view.element.addEventListener('keydown', this.onKeyDown_);
            this.view.element.addEventListener('keyup', this.onKeyUp_);
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(HPaletteController, [
            {
                key: "handlePointerEvent_",
                value: function handlePointerEvent_(d, opts) {
                    if (!d.point) return;
                    var hue = mapRange(constrainRange(d.point.x, 0, d.bounds.width), 0, d.bounds.width, 0, 360);
                    var c = this.value.rawValue;
                    var _c_getComponents = (0, $cccf0333cb9f9910$export$71511d61b312f219)(c.getComponents('hsv'), 4), s = _c_getComponents[1], v = _c_getComponents[2], a = _c_getComponents[3];
                    this.value.setRawValue(new Color([
                        hue,
                        s,
                        v,
                        a
                    ], 'hsv'), opts);
                }
            },
            {
                key: "onPointerDown_",
                value: function onPointerDown_(ev) {
                    this.handlePointerEvent_(ev.data, {
                        forceEmit: false,
                        last: false
                    });
                }
            },
            {
                key: "onPointerMove_",
                value: function onPointerMove_(ev) {
                    this.handlePointerEvent_(ev.data, {
                        forceEmit: false,
                        last: false
                    });
                }
            },
            {
                key: "onPointerUp_",
                value: function onPointerUp_(ev) {
                    this.handlePointerEvent_(ev.data, {
                        forceEmit: true,
                        last: true
                    });
                }
            },
            {
                key: "onKeyDown_",
                value: function onKeyDown_(ev) {
                    var step = getStepForKey(getBaseStepForColor(false), getHorizontalStepKeys(ev));
                    if (step === 0) return;
                    var c = this.value.rawValue;
                    var _c_getComponents = (0, $cccf0333cb9f9910$export$71511d61b312f219)(c.getComponents('hsv'), 4), h = _c_getComponents[0], s = _c_getComponents[1], v = _c_getComponents[2], a = _c_getComponents[3];
                    this.value.setRawValue(new Color([
                        h + step,
                        s,
                        v,
                        a
                    ], 'hsv'), {
                        forceEmit: false,
                        last: false
                    });
                }
            },
            {
                key: "onKeyUp_",
                value: function onKeyUp_(ev) {
                    var step = getStepForKey(getBaseStepForColor(false), getHorizontalStepKeys(ev));
                    if (step === 0) return;
                    this.value.setRawValue(this.value.rawValue, {
                        forceEmit: true,
                        last: true
                    });
                }
            }
        ]);
        return HPaletteController;
    }();
    var className$7 = ClassName('svp');
    var CANVAS_RESOL = 64;
    var SvPaletteView = /*#__PURE__*/ function() {
        function SvPaletteView(doc, config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, SvPaletteView);
            this.onValueChange_ = this.onValueChange_.bind(this);
            this.value = config.value;
            this.value.emitter.on('change', this.onValueChange_);
            this.element = doc.createElement('div');
            this.element.classList.add(className$7());
            config.viewProps.bindClassModifiers(this.element);
            config.viewProps.bindTabIndex(this.element);
            var canvasElem = doc.createElement('canvas');
            canvasElem.height = CANVAS_RESOL;
            canvasElem.width = CANVAS_RESOL;
            canvasElem.classList.add(className$7('c'));
            this.element.appendChild(canvasElem);
            this.canvasElement = canvasElem;
            var markerElem = doc.createElement('div');
            markerElem.classList.add(className$7('m'));
            this.element.appendChild(markerElem);
            this.markerElem_ = markerElem;
            this.update_();
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(SvPaletteView, [
            {
                key: "update_",
                value: function update_() {
                    var ctx = getCanvasContext(this.canvasElement);
                    if (!ctx) return;
                    var c = this.value.rawValue;
                    var hsvComps = c.getComponents('hsv');
                    var width = this.canvasElement.width;
                    var height = this.canvasElement.height;
                    var imgData = ctx.getImageData(0, 0, width, height);
                    var data = imgData.data;
                    for(var iy = 0; iy < height; iy++)for(var ix = 0; ix < width; ix++){
                        var s = mapRange(ix, 0, width, 0, 100);
                        var v = mapRange(iy, 0, height, 100, 0);
                        var rgbComps = hsvToRgbInt(hsvComps[0], s, v);
                        var i = (iy * width + ix) * 4;
                        data[i] = rgbComps[0];
                        data[i + 1] = rgbComps[1];
                        data[i + 2] = rgbComps[2];
                        data[i + 3] = 255;
                    }
                    ctx.putImageData(imgData, 0, 0);
                    var left = mapRange(hsvComps[1], 0, 100, 0, 100);
                    this.markerElem_.style.left = "".concat(left, "%");
                    var top = mapRange(hsvComps[2], 0, 100, 100, 0);
                    this.markerElem_.style.top = "".concat(top, "%");
                }
            },
            {
                key: "onValueChange_",
                value: function onValueChange_() {
                    this.update_();
                }
            }
        ]);
        return SvPaletteView;
    }();
    var SvPaletteController = /*#__PURE__*/ function() {
        function SvPaletteController(doc, config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, SvPaletteController);
            this.onKeyDown_ = this.onKeyDown_.bind(this);
            this.onKeyUp_ = this.onKeyUp_.bind(this);
            this.onPointerDown_ = this.onPointerDown_.bind(this);
            this.onPointerMove_ = this.onPointerMove_.bind(this);
            this.onPointerUp_ = this.onPointerUp_.bind(this);
            this.value = config.value;
            this.viewProps = config.viewProps;
            this.view = new SvPaletteView(doc, {
                value: this.value,
                viewProps: this.viewProps
            });
            this.ptHandler_ = new PointerHandler(this.view.element);
            this.ptHandler_.emitter.on('down', this.onPointerDown_);
            this.ptHandler_.emitter.on('move', this.onPointerMove_);
            this.ptHandler_.emitter.on('up', this.onPointerUp_);
            this.view.element.addEventListener('keydown', this.onKeyDown_);
            this.view.element.addEventListener('keyup', this.onKeyUp_);
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(SvPaletteController, [
            {
                key: "handlePointerEvent_",
                value: function handlePointerEvent_(d, opts) {
                    if (!d.point) return;
                    var saturation = mapRange(d.point.x, 0, d.bounds.width, 0, 100);
                    var value = mapRange(d.point.y, 0, d.bounds.height, 100, 0);
                    var _this_value_rawValue_getComponents = (0, $cccf0333cb9f9910$export$71511d61b312f219)(this.value.rawValue.getComponents('hsv'), 4), h = _this_value_rawValue_getComponents[0], a = _this_value_rawValue_getComponents[3];
                    this.value.setRawValue(new Color([
                        h,
                        saturation,
                        value,
                        a
                    ], 'hsv'), opts);
                }
            },
            {
                key: "onPointerDown_",
                value: function onPointerDown_(ev) {
                    this.handlePointerEvent_(ev.data, {
                        forceEmit: false,
                        last: false
                    });
                }
            },
            {
                key: "onPointerMove_",
                value: function onPointerMove_(ev) {
                    this.handlePointerEvent_(ev.data, {
                        forceEmit: false,
                        last: false
                    });
                }
            },
            {
                key: "onPointerUp_",
                value: function onPointerUp_(ev) {
                    this.handlePointerEvent_(ev.data, {
                        forceEmit: true,
                        last: true
                    });
                }
            },
            {
                key: "onKeyDown_",
                value: function onKeyDown_(ev) {
                    if (isArrowKey(ev.key)) ev.preventDefault();
                    var _this_value_rawValue_getComponents = (0, $cccf0333cb9f9910$export$71511d61b312f219)(this.value.rawValue.getComponents('hsv'), 4), h = _this_value_rawValue_getComponents[0], s = _this_value_rawValue_getComponents[1], v = _this_value_rawValue_getComponents[2], a = _this_value_rawValue_getComponents[3];
                    var baseStep = getBaseStepForColor(false);
                    var ds = getStepForKey(baseStep, getHorizontalStepKeys(ev));
                    var dv = getStepForKey(baseStep, getVerticalStepKeys(ev));
                    if (ds === 0 && dv === 0) return;
                    this.value.setRawValue(new Color([
                        h,
                        s + ds,
                        v + dv,
                        a
                    ], 'hsv'), {
                        forceEmit: false,
                        last: false
                    });
                }
            },
            {
                key: "onKeyUp_",
                value: function onKeyUp_(ev) {
                    var baseStep = getBaseStepForColor(false);
                    var ds = getStepForKey(baseStep, getHorizontalStepKeys(ev));
                    var dv = getStepForKey(baseStep, getVerticalStepKeys(ev));
                    if (ds === 0 && dv === 0) return;
                    this.value.setRawValue(this.value.rawValue, {
                        forceEmit: true,
                        last: true
                    });
                }
            }
        ]);
        return SvPaletteController;
    }();
    var ColorPickerController = /*#__PURE__*/ function() {
        function ColorPickerController(doc, config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, ColorPickerController);
            this.value = config.value;
            this.viewProps = config.viewProps;
            this.hPaletteC_ = new HPaletteController(doc, {
                value: this.value,
                viewProps: this.viewProps
            });
            this.svPaletteC_ = new SvPaletteController(doc, {
                value: this.value,
                viewProps: this.viewProps
            });
            this.alphaIcs_ = config.supportsAlpha ? {
                palette: new APaletteController(doc, {
                    value: this.value,
                    viewProps: this.viewProps
                }),
                text: new NumberTextController(doc, {
                    parser: parseNumber,
                    baseStep: 0.1,
                    props: ValueMap.fromObject({
                        draggingScale: 0.01,
                        formatter: createNumberFormatter(2)
                    }),
                    value: createValue(0, {
                        constraint: new DefiniteRangeConstraint({
                            min: 0,
                            max: 1
                        })
                    }),
                    viewProps: this.viewProps
                })
            } : null;
            if (this.alphaIcs_) connectValues({
                primary: this.value,
                secondary: this.alphaIcs_.text.value,
                forward: function(p) {
                    return p.rawValue.getComponents()[3];
                },
                backward: function(p, s) {
                    var comps = p.rawValue.getComponents();
                    comps[3] = s.rawValue;
                    return new Color(comps, p.rawValue.mode);
                }
            });
            this.textC_ = new ColorTextController(doc, {
                colorType: config.colorType,
                parser: parseNumber,
                value: this.value,
                viewProps: this.viewProps
            });
            this.view = new ColorPickerView(doc, {
                alphaViews: this.alphaIcs_ ? {
                    palette: this.alphaIcs_.palette.view,
                    text: this.alphaIcs_.text.view
                } : null,
                hPaletteView: this.hPaletteC_.view,
                supportsAlpha: config.supportsAlpha,
                svPaletteView: this.svPaletteC_.view,
                textView: this.textC_.view,
                viewProps: this.viewProps
            });
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(ColorPickerController, [
            {
                key: "textController",
                get: function get() {
                    return this.textC_;
                }
            }
        ]);
        return ColorPickerController;
    }();
    var className$6 = ClassName('colsw');
    var ColorSwatchView = /*#__PURE__*/ function() {
        function ColorSwatchView(doc, config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, ColorSwatchView);
            this.onValueChange_ = this.onValueChange_.bind(this);
            config.value.emitter.on('change', this.onValueChange_);
            this.value = config.value;
            this.element = doc.createElement('div');
            this.element.classList.add(className$6());
            config.viewProps.bindClassModifiers(this.element);
            var swatchElem = doc.createElement('div');
            swatchElem.classList.add(className$6('sw'));
            this.element.appendChild(swatchElem);
            this.swatchElem_ = swatchElem;
            var buttonElem = doc.createElement('button');
            buttonElem.classList.add(className$6('b'));
            config.viewProps.bindDisabled(buttonElem);
            this.element.appendChild(buttonElem);
            this.buttonElement = buttonElem;
            this.update_();
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(ColorSwatchView, [
            {
                key: "update_",
                value: function update_() {
                    var value = this.value.rawValue;
                    this.swatchElem_.style.backgroundColor = colorToHexRgbaString(value);
                }
            },
            {
                key: "onValueChange_",
                value: function onValueChange_() {
                    this.update_();
                }
            }
        ]);
        return ColorSwatchView;
    }();
    var ColorSwatchController = function ColorSwatchController(doc, config) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, ColorSwatchController);
        this.value = config.value;
        this.viewProps = config.viewProps;
        this.view = new ColorSwatchView(doc, {
            value: this.value,
            viewProps: this.viewProps
        });
    };
    var ColorController = /*#__PURE__*/ function() {
        function ColorController(doc, config) {
            var _this = this;
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, ColorController);
            this.onButtonBlur_ = this.onButtonBlur_.bind(this);
            this.onButtonClick_ = this.onButtonClick_.bind(this);
            this.onPopupChildBlur_ = this.onPopupChildBlur_.bind(this);
            this.onPopupChildKeydown_ = this.onPopupChildKeydown_.bind(this);
            this.value = config.value;
            this.viewProps = config.viewProps;
            this.foldable_ = Foldable.create(config.expanded);
            this.swatchC_ = new ColorSwatchController(doc, {
                value: this.value,
                viewProps: this.viewProps
            });
            var buttonElem = this.swatchC_.view.buttonElement;
            buttonElem.addEventListener('blur', this.onButtonBlur_);
            buttonElem.addEventListener('click', this.onButtonClick_);
            this.textC_ = new TextController(doc, {
                parser: config.parser,
                props: ValueMap.fromObject({
                    formatter: config.formatter
                }),
                value: this.value,
                viewProps: this.viewProps
            });
            this.view = new ColorView(doc, {
                foldable: this.foldable_,
                pickerLayout: config.pickerLayout
            });
            this.view.swatchElement.appendChild(this.swatchC_.view.element);
            this.view.textElement.appendChild(this.textC_.view.element);
            this.popC_ = config.pickerLayout === 'popup' ? new PopupController(doc, {
                viewProps: this.viewProps
            }) : null;
            var pickerC = new ColorPickerController(doc, {
                colorType: config.colorType,
                supportsAlpha: config.supportsAlpha,
                value: this.value,
                viewProps: this.viewProps
            });
            pickerC.view.allFocusableElements.forEach(function(elem) {
                elem.addEventListener('blur', _this.onPopupChildBlur_);
                elem.addEventListener('keydown', _this.onPopupChildKeydown_);
            });
            this.pickerC_ = pickerC;
            if (this.popC_) {
                this.view.element.appendChild(this.popC_.view.element);
                this.popC_.view.element.appendChild(pickerC.view.element);
                connectValues({
                    primary: this.foldable_.value('expanded'),
                    secondary: this.popC_.shows,
                    forward: function(p) {
                        return p.rawValue;
                    },
                    backward: function(_, s) {
                        return s.rawValue;
                    }
                });
            } else if (this.view.pickerElement) {
                this.view.pickerElement.appendChild(this.pickerC_.view.element);
                bindFoldable(this.foldable_, this.view.pickerElement);
            }
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(ColorController, [
            {
                key: "textController",
                get: function get() {
                    return this.textC_;
                }
            },
            {
                key: "onButtonBlur_",
                value: function onButtonBlur_(e) {
                    if (!this.popC_) return;
                    var elem = this.view.element;
                    var nextTarget = forceCast(e.relatedTarget);
                    if (!nextTarget || !elem.contains(nextTarget)) this.popC_.shows.rawValue = false;
                }
            },
            {
                key: "onButtonClick_",
                value: function onButtonClick_() {
                    this.foldable_.set('expanded', !this.foldable_.get('expanded'));
                    if (this.foldable_.get('expanded')) this.pickerC_.view.allFocusableElements[0].focus();
                }
            },
            {
                key: "onPopupChildBlur_",
                value: function onPopupChildBlur_(ev) {
                    if (!this.popC_) return;
                    var elem = this.popC_.view.element;
                    var nextTarget = findNextTarget(ev);
                    if (nextTarget && elem.contains(nextTarget)) return;
                    if (nextTarget && nextTarget === this.swatchC_.view.buttonElement && !supportsTouch(elem.ownerDocument)) return;
                    this.popC_.shows.rawValue = false;
                }
            },
            {
                key: "onPopupChildKeydown_",
                value: function onPopupChildKeydown_(ev) {
                    if (this.popC_) {
                        if (ev.key === 'Escape') this.popC_.shows.rawValue = false;
                    } else if (this.view.pickerElement) {
                        if (ev.key === 'Escape') this.swatchC_.view.buttonElement.focus();
                    }
                }
            }
        ]);
        return ColorController;
    }();
    function colorFromObject(value, opt_type) {
        if (Color.isColorObject(value)) return Color.fromObject(value, opt_type);
        return Color.black(opt_type);
    }
    function colorToRgbNumber(value) {
        return removeAlphaComponent(value.getComponents('rgb')).reduce(function(result, comp) {
            return result << 8 | Math.floor(comp) & 0xff;
        }, 0);
    }
    function colorToRgbaNumber(value) {
        return value.getComponents('rgb').reduce(function(result, comp, index) {
            var hex = Math.floor(index === 3 ? comp * 255 : comp) & 0xff;
            return result << 8 | hex;
        }, 0) >>> 0;
    }
    function numberToRgbColor(num) {
        return new Color([
            num >> 16 & 0xff,
            num >> 8 & 0xff,
            num & 0xff
        ], 'rgb');
    }
    function numberToRgbaColor(num) {
        return new Color([
            num >> 24 & 0xff,
            num >> 16 & 0xff,
            num >> 8 & 0xff,
            mapRange(num & 0xff, 0, 255, 0, 1)
        ], 'rgb');
    }
    function colorFromRgbNumber(value) {
        if (typeof value !== 'number') return Color.black();
        return numberToRgbColor(value);
    }
    function colorFromRgbaNumber(value) {
        if (typeof value !== 'number') return Color.black();
        return numberToRgbaColor(value);
    }
    function createColorStringWriter(format) {
        var stringify = findColorStringifier(format);
        return stringify ? function(target, value) {
            writePrimitive(target, stringify(value));
        } : null;
    }
    function createColorNumberWriter(supportsAlpha) {
        var colorToNumber = supportsAlpha ? colorToRgbaNumber : colorToRgbNumber;
        return function(target, value) {
            writePrimitive(target, colorToNumber(value));
        };
    }
    function writeRgbaColorObject(target, value, opt_type) {
        var obj = value.toRgbaObject(opt_type);
        target.writeProperty('r', obj.r);
        target.writeProperty('g', obj.g);
        target.writeProperty('b', obj.b);
        target.writeProperty('a', obj.a);
    }
    function writeRgbColorObject(target, value, opt_type) {
        var obj = value.toRgbaObject(opt_type);
        target.writeProperty('r', obj.r);
        target.writeProperty('g', obj.g);
        target.writeProperty('b', obj.b);
    }
    function createColorObjectWriter(supportsAlpha, opt_type) {
        return function(target, inValue) {
            if (supportsAlpha) writeRgbaColorObject(target, inValue, opt_type);
            else writeRgbColorObject(target, inValue, opt_type);
        };
    }
    function shouldSupportAlpha$1(inputParams) {
        var _a;
        if ((inputParams === null || inputParams === void 0 ? void 0 : inputParams.alpha) || ((_a = inputParams === null || inputParams === void 0 ? void 0 : inputParams.color) === null || _a === void 0 ? void 0 : _a.alpha)) return true;
        return false;
    }
    function createFormatter$1(supportsAlpha) {
        return supportsAlpha ? function(v) {
            return colorToHexRgbaString(v, '0x');
        } : function(v) {
            return colorToHexRgbString(v, '0x');
        };
    }
    function isForColor(params) {
        if ('color' in params) return true;
        if ('view' in params && params.view === 'color') return true;
        return false;
    }
    var NumberColorInputPlugin = {
        id: 'input-color-number',
        type: 'input',
        accept: function(value, params) {
            if (typeof value !== 'number') return null;
            if (!isForColor(params)) return null;
            var result = parseColorInputParams(params);
            return result ? {
                initialValue: value,
                params: result
            } : null;
        },
        binding: {
            reader: function(args) {
                return shouldSupportAlpha$1(args.params) ? colorFromRgbaNumber : colorFromRgbNumber;
            },
            equals: Color.equals,
            writer: function(args) {
                return createColorNumberWriter(shouldSupportAlpha$1(args.params));
            }
        },
        controller: function(args) {
            var supportsAlpha = shouldSupportAlpha$1(args.params);
            var expanded = 'expanded' in args.params ? args.params.expanded : undefined;
            var picker = 'picker' in args.params ? args.params.picker : undefined;
            return new ColorController(args.document, {
                colorType: 'int',
                expanded: expanded !== null && expanded !== void 0 ? expanded : false,
                formatter: createFormatter$1(supportsAlpha),
                parser: createColorStringParser('int'),
                pickerLayout: picker !== null && picker !== void 0 ? picker : 'popup',
                supportsAlpha: supportsAlpha,
                value: args.value,
                viewProps: args.viewProps
            });
        }
    };
    function shouldSupportAlpha(initialValue) {
        return Color.isRgbaColorObject(initialValue);
    }
    function createColorObjectReader(opt_type) {
        return function(value) {
            return colorFromObject(value, opt_type);
        };
    }
    function createColorObjectFormatter(supportsAlpha, type) {
        return function(value) {
            if (supportsAlpha) return colorToObjectRgbaString(value, type);
            return colorToObjectRgbString(value, type);
        };
    }
    var ObjectColorInputPlugin = {
        id: 'input-color-object',
        type: 'input',
        accept: function(value, params) {
            if (!Color.isColorObject(value)) return null;
            var result = parseColorInputParams(params);
            return result ? {
                initialValue: value,
                params: result
            } : null;
        },
        binding: {
            reader: function(args) {
                return createColorObjectReader(extractColorType(args.params));
            },
            equals: Color.equals,
            writer: function(args) {
                return createColorObjectWriter(shouldSupportAlpha(args.initialValue), extractColorType(args.params));
            }
        },
        controller: function(args) {
            var _a;
            var supportsAlpha = Color.isRgbaColorObject(args.initialValue);
            var expanded = 'expanded' in args.params ? args.params.expanded : undefined;
            var picker = 'picker' in args.params ? args.params.picker : undefined;
            var type = (_a = extractColorType(args.params)) !== null && _a !== void 0 ? _a : 'int';
            return new ColorController(args.document, {
                colorType: type,
                expanded: expanded !== null && expanded !== void 0 ? expanded : false,
                formatter: createColorObjectFormatter(supportsAlpha, type),
                parser: createColorStringParser(type),
                pickerLayout: picker !== null && picker !== void 0 ? picker : 'popup',
                supportsAlpha: supportsAlpha,
                value: args.value,
                viewProps: args.viewProps
            });
        }
    };
    var StringColorInputPlugin = {
        id: 'input-color-string',
        type: 'input',
        accept: function(value, params) {
            if (typeof value !== 'string') return null;
            if ('view' in params && params.view === 'text') return null;
            var format = detectStringColorFormat(value, extractColorType(params));
            if (!format) return null;
            var stringifier = findColorStringifier(format);
            if (!stringifier) return null;
            var result = parseColorInputParams(params);
            return result ? {
                initialValue: value,
                params: result
            } : null;
        },
        binding: {
            reader: function(args) {
                var _a;
                return createColorStringBindingReader((_a = extractColorType(args.params)) !== null && _a !== void 0 ? _a : 'int');
            },
            equals: Color.equals,
            writer: function(args) {
                var format = detectStringColorFormat(args.initialValue, extractColorType(args.params));
                if (!format) throw TpError.shouldNeverHappen();
                var writer = createColorStringWriter(format);
                if (!writer) throw TpError.notBindable();
                return writer;
            }
        },
        controller: function(args) {
            var format = detectStringColorFormat(args.initialValue, extractColorType(args.params));
            if (!format) throw TpError.shouldNeverHappen();
            var stringifier = findColorStringifier(format);
            if (!stringifier) throw TpError.shouldNeverHappen();
            var expanded = 'expanded' in args.params ? args.params.expanded : undefined;
            var picker = 'picker' in args.params ? args.params.picker : undefined;
            return new ColorController(args.document, {
                colorType: format.type,
                expanded: expanded !== null && expanded !== void 0 ? expanded : false,
                formatter: stringifier,
                parser: createColorStringParser(format.type),
                pickerLayout: picker !== null && picker !== void 0 ? picker : 'popup',
                supportsAlpha: format.alpha,
                value: args.value,
                viewProps: args.viewProps
            });
        }
    };
    var PointNdConstraint = /*#__PURE__*/ function() {
        function PointNdConstraint(config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, PointNdConstraint);
            this.components = config.components;
            this.asm_ = config.assembly;
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(PointNdConstraint, [
            {
                key: "constrain",
                value: function constrain(value) {
                    var _this = this;
                    var comps = this.asm_.toComponents(value).map(function(comp, index) {
                        var _a, _b;
                        return (_b = (_a = _this.components[index]) === null || _a === void 0 ? void 0 : _a.constrain(comp)) !== null && _b !== void 0 ? _b : comp;
                    });
                    return this.asm_.fromComponents(comps);
                }
            }
        ]);
        return PointNdConstraint;
    }();
    var className$5 = ClassName('pndtxt');
    var PointNdTextView = function PointNdTextView(doc, config) {
        var _this = this;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, PointNdTextView);
        this.textViews = config.textViews;
        this.element = doc.createElement('div');
        this.element.classList.add(className$5());
        this.textViews.forEach(function(v) {
            var axisElem = doc.createElement('div');
            axisElem.classList.add(className$5('a'));
            axisElem.appendChild(v.element);
            _this.element.appendChild(axisElem);
        });
    };
    function createAxisController(doc, config, index) {
        return new NumberTextController(doc, {
            arrayPosition: index === 0 ? 'fst' : index === config.axes.length - 1 ? 'lst' : 'mid',
            baseStep: config.axes[index].baseStep,
            parser: config.parser,
            props: config.axes[index].textProps,
            value: createValue(0, {
                constraint: config.axes[index].constraint
            }),
            viewProps: config.viewProps
        });
    }
    var PointNdTextController = function PointNdTextController(doc, config) {
        var _this = this;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, PointNdTextController);
        this.value = config.value;
        this.viewProps = config.viewProps;
        this.acs_ = config.axes.map(function(_, index) {
            return createAxisController(doc, config, index);
        });
        this.acs_.forEach(function(c, index) {
            connectValues({
                primary: _this.value,
                secondary: c.value,
                forward: function(p) {
                    return config.assembly.toComponents(p.rawValue)[index];
                },
                backward: function(p, s) {
                    var comps = config.assembly.toComponents(p.rawValue);
                    comps[index] = s.rawValue;
                    return config.assembly.fromComponents(comps);
                }
            });
        });
        this.view = new PointNdTextView(doc, {
            textViews: this.acs_.map(function(ac) {
                return ac.view;
            })
        });
    };
    function createStepConstraint(params, initialValue) {
        if ('step' in params && !isEmpty(params.step)) return new StepConstraint(params.step, initialValue);
        return null;
    }
    function createRangeConstraint(params) {
        if (!isEmpty(params.max) && !isEmpty(params.min)) return new DefiniteRangeConstraint({
            max: params.max,
            min: params.min
        });
        if (!isEmpty(params.max) || !isEmpty(params.min)) return new RangeConstraint({
            max: params.max,
            min: params.min
        });
        return null;
    }
    function findNumberRange(c) {
        var drc = findConstraint(c, DefiniteRangeConstraint);
        if (drc) return [
            drc.values.get('min'),
            drc.values.get('max')
        ];
        var rc = findConstraint(c, RangeConstraint);
        if (rc) return [
            rc.minValue,
            rc.maxValue
        ];
        return [
            undefined,
            undefined
        ];
    }
    function createConstraint$4(params, initialValue) {
        var constraints = [];
        var sc = createStepConstraint(params, initialValue);
        if (sc) constraints.push(sc);
        var rc = createRangeConstraint(params);
        if (rc) constraints.push(rc);
        var lc = createListConstraint(params.options);
        if (lc) constraints.push(lc);
        return new CompositeConstraint(constraints);
    }
    var NumberInputPlugin = {
        id: 'input-number',
        type: 'input',
        accept: function(value, params) {
            if (typeof value !== 'number') return null;
            var p = ParamsParsers;
            var result = parseParams(params, {
                format: p.optional.function,
                max: p.optional.number,
                min: p.optional.number,
                options: p.optional.custom(parseListOptions),
                step: p.optional.number
            });
            return result ? {
                initialValue: value,
                params: result
            } : null;
        },
        binding: {
            reader: function(_args) {
                return numberFromUnknown;
            },
            constraint: function(args) {
                return createConstraint$4(args.params, args.initialValue);
            },
            writer: function(_args) {
                return writePrimitive;
            }
        },
        controller: function(args) {
            var _a;
            var value = args.value;
            var c = args.constraint;
            var lc = c && findConstraint(c, ListConstraint);
            if (lc) return new ListController(args.document, {
                props: new ValueMap({
                    options: lc.values.value('options')
                }),
                value: value,
                viewProps: args.viewProps
            });
            var formatter = (_a = 'format' in args.params ? args.params.format : undefined) !== null && _a !== void 0 ? _a : createNumberFormatter(getSuitableDecimalDigits(c, value.rawValue));
            var drc = c && findConstraint(c, DefiniteRangeConstraint);
            if (drc) return new SliderTextController(args.document, {
                baseStep: getBaseStep(c),
                parser: parseNumber,
                sliderProps: new ValueMap({
                    maxValue: drc.values.value('max'),
                    minValue: drc.values.value('min')
                }),
                textProps: ValueMap.fromObject({
                    draggingScale: getSuitableDraggingScale(c, value.rawValue),
                    formatter: formatter
                }),
                value: value,
                viewProps: args.viewProps
            });
            return new NumberTextController(args.document, {
                baseStep: getBaseStep(c),
                parser: parseNumber,
                props: ValueMap.fromObject({
                    draggingScale: getSuitableDraggingScale(c, value.rawValue),
                    formatter: formatter
                }),
                value: value,
                viewProps: args.viewProps
            });
        }
    };
    var Point2d = /*#__PURE__*/ function() {
        function Point2d() {
            var x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, Point2d);
            this.x = x;
            this.y = y;
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(Point2d, [
            {
                key: "getComponents",
                value: function getComponents() {
                    return [
                        this.x,
                        this.y
                    ];
                }
            },
            {
                key: "toObject",
                value: function toObject() {
                    return {
                        x: this.x,
                        y: this.y
                    };
                }
            }
        ], [
            {
                key: "isObject",
                value: function isObject(obj) {
                    if (isEmpty(obj)) return false;
                    var x = obj.x;
                    var y = obj.y;
                    if (typeof x !== 'number' || typeof y !== 'number') return false;
                    return true;
                }
            },
            {
                key: "equals",
                value: function equals(v1, v2) {
                    return v1.x === v2.x && v1.y === v2.y;
                }
            }
        ]);
        return Point2d;
    }();
    var Point2dAssembly = {
        toComponents: function(p) {
            return p.getComponents();
        },
        fromComponents: function(comps) {
            return (0, $21dc3cc07aba2591$export$71511d61b312f219)(Point2d, (0, $4fcd3d80e9e33ca7$export$71511d61b312f219)(comps));
        }
    };
    var className$4 = ClassName('p2d');
    var Point2dView = function Point2dView(doc, config) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Point2dView);
        this.element = doc.createElement('div');
        this.element.classList.add(className$4());
        config.viewProps.bindClassModifiers(this.element);
        bindValue(config.expanded, valueToClassName(this.element, className$4(undefined, 'expanded')));
        var headElem = doc.createElement('div');
        headElem.classList.add(className$4('h'));
        this.element.appendChild(headElem);
        var buttonElem = doc.createElement('button');
        buttonElem.classList.add(className$4('b'));
        buttonElem.appendChild(createSvgIconElement(doc, 'p2dpad'));
        config.viewProps.bindDisabled(buttonElem);
        headElem.appendChild(buttonElem);
        this.buttonElement = buttonElem;
        var textElem = doc.createElement('div');
        textElem.classList.add(className$4('t'));
        headElem.appendChild(textElem);
        this.textElement = textElem;
        if (config.pickerLayout === 'inline') {
            var pickerElem = doc.createElement('div');
            pickerElem.classList.add(className$4('p'));
            this.element.appendChild(pickerElem);
            this.pickerElement = pickerElem;
        } else this.pickerElement = null;
    };
    var className$3 = ClassName('p2dp');
    var Point2dPickerView = /*#__PURE__*/ function() {
        function Point2dPickerView(doc, config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, Point2dPickerView);
            this.onFoldableChange_ = this.onFoldableChange_.bind(this);
            this.onValueChange_ = this.onValueChange_.bind(this);
            this.invertsY_ = config.invertsY;
            this.maxValue_ = config.maxValue;
            this.element = doc.createElement('div');
            this.element.classList.add(className$3());
            if (config.layout === 'popup') this.element.classList.add(className$3(undefined, 'p'));
            config.viewProps.bindClassModifiers(this.element);
            var padElem = doc.createElement('div');
            padElem.classList.add(className$3('p'));
            config.viewProps.bindTabIndex(padElem);
            this.element.appendChild(padElem);
            this.padElement = padElem;
            var svgElem = doc.createElementNS(SVG_NS, 'svg');
            svgElem.classList.add(className$3('g'));
            this.padElement.appendChild(svgElem);
            this.svgElem_ = svgElem;
            var xAxisElem = doc.createElementNS(SVG_NS, 'line');
            xAxisElem.classList.add(className$3('ax'));
            xAxisElem.setAttributeNS(null, 'x1', '0');
            xAxisElem.setAttributeNS(null, 'y1', '50%');
            xAxisElem.setAttributeNS(null, 'x2', '100%');
            xAxisElem.setAttributeNS(null, 'y2', '50%');
            this.svgElem_.appendChild(xAxisElem);
            var yAxisElem = doc.createElementNS(SVG_NS, 'line');
            yAxisElem.classList.add(className$3('ax'));
            yAxisElem.setAttributeNS(null, 'x1', '50%');
            yAxisElem.setAttributeNS(null, 'y1', '0');
            yAxisElem.setAttributeNS(null, 'x2', '50%');
            yAxisElem.setAttributeNS(null, 'y2', '100%');
            this.svgElem_.appendChild(yAxisElem);
            var lineElem = doc.createElementNS(SVG_NS, 'line');
            lineElem.classList.add(className$3('l'));
            lineElem.setAttributeNS(null, 'x1', '50%');
            lineElem.setAttributeNS(null, 'y1', '50%');
            this.svgElem_.appendChild(lineElem);
            this.lineElem_ = lineElem;
            var markerElem = doc.createElement('div');
            markerElem.classList.add(className$3('m'));
            this.padElement.appendChild(markerElem);
            this.markerElem_ = markerElem;
            config.value.emitter.on('change', this.onValueChange_);
            this.value = config.value;
            this.update_();
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(Point2dPickerView, [
            {
                key: "allFocusableElements",
                get: function get() {
                    return [
                        this.padElement
                    ];
                }
            },
            {
                key: "update_",
                value: function update_() {
                    var _this_value_rawValue_getComponents = (0, $cccf0333cb9f9910$export$71511d61b312f219)(this.value.rawValue.getComponents(), 2), x = _this_value_rawValue_getComponents[0], y = _this_value_rawValue_getComponents[1];
                    var max = this.maxValue_;
                    var px = mapRange(x, -max, +max, 0, 100);
                    var py = mapRange(y, -max, +max, 0, 100);
                    var ipy = this.invertsY_ ? 100 - py : py;
                    this.lineElem_.setAttributeNS(null, 'x2', "".concat(px, "%"));
                    this.lineElem_.setAttributeNS(null, 'y2', "".concat(ipy, "%"));
                    this.markerElem_.style.left = "".concat(px, "%");
                    this.markerElem_.style.top = "".concat(ipy, "%");
                }
            },
            {
                key: "onValueChange_",
                value: function onValueChange_() {
                    this.update_();
                }
            },
            {
                key: "onFoldableChange_",
                value: function onFoldableChange_() {
                    this.update_();
                }
            }
        ]);
        return Point2dPickerView;
    }();
    function computeOffset(ev, baseSteps, invertsY) {
        return [
            getStepForKey(baseSteps[0], getHorizontalStepKeys(ev)),
            getStepForKey(baseSteps[1], getVerticalStepKeys(ev)) * (invertsY ? 1 : -1)
        ];
    }
    var Point2dPickerController = /*#__PURE__*/ function() {
        function Point2dPickerController(doc, config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, Point2dPickerController);
            this.onPadKeyDown_ = this.onPadKeyDown_.bind(this);
            this.onPadKeyUp_ = this.onPadKeyUp_.bind(this);
            this.onPointerDown_ = this.onPointerDown_.bind(this);
            this.onPointerMove_ = this.onPointerMove_.bind(this);
            this.onPointerUp_ = this.onPointerUp_.bind(this);
            this.value = config.value;
            this.viewProps = config.viewProps;
            this.baseSteps_ = config.baseSteps;
            this.maxValue_ = config.maxValue;
            this.invertsY_ = config.invertsY;
            this.view = new Point2dPickerView(doc, {
                invertsY: this.invertsY_,
                layout: config.layout,
                maxValue: this.maxValue_,
                value: this.value,
                viewProps: this.viewProps
            });
            this.ptHandler_ = new PointerHandler(this.view.padElement);
            this.ptHandler_.emitter.on('down', this.onPointerDown_);
            this.ptHandler_.emitter.on('move', this.onPointerMove_);
            this.ptHandler_.emitter.on('up', this.onPointerUp_);
            this.view.padElement.addEventListener('keydown', this.onPadKeyDown_);
            this.view.padElement.addEventListener('keyup', this.onPadKeyUp_);
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(Point2dPickerController, [
            {
                key: "handlePointerEvent_",
                value: function handlePointerEvent_(d, opts) {
                    if (!d.point) return;
                    var max = this.maxValue_;
                    var px = mapRange(d.point.x, 0, d.bounds.width, -max, +max);
                    var py = mapRange(this.invertsY_ ? d.bounds.height - d.point.y : d.point.y, 0, d.bounds.height, -max, +max);
                    this.value.setRawValue(new Point2d(px, py), opts);
                }
            },
            {
                key: "onPointerDown_",
                value: function onPointerDown_(ev) {
                    this.handlePointerEvent_(ev.data, {
                        forceEmit: false,
                        last: false
                    });
                }
            },
            {
                key: "onPointerMove_",
                value: function onPointerMove_(ev) {
                    this.handlePointerEvent_(ev.data, {
                        forceEmit: false,
                        last: false
                    });
                }
            },
            {
                key: "onPointerUp_",
                value: function onPointerUp_(ev) {
                    this.handlePointerEvent_(ev.data, {
                        forceEmit: true,
                        last: true
                    });
                }
            },
            {
                key: "onPadKeyDown_",
                value: function onPadKeyDown_(ev) {
                    if (isArrowKey(ev.key)) ev.preventDefault();
                    var _computeOffset = (0, $cccf0333cb9f9910$export$71511d61b312f219)(computeOffset(ev, this.baseSteps_, this.invertsY_), 2), dx = _computeOffset[0], dy = _computeOffset[1];
                    if (dx === 0 && dy === 0) return;
                    this.value.setRawValue(new Point2d(this.value.rawValue.x + dx, this.value.rawValue.y + dy), {
                        forceEmit: false,
                        last: false
                    });
                }
            },
            {
                key: "onPadKeyUp_",
                value: function onPadKeyUp_(ev) {
                    var _computeOffset = (0, $cccf0333cb9f9910$export$71511d61b312f219)(computeOffset(ev, this.baseSteps_, this.invertsY_), 2), dx = _computeOffset[0], dy = _computeOffset[1];
                    if (dx === 0 && dy === 0) return;
                    this.value.setRawValue(this.value.rawValue, {
                        forceEmit: true,
                        last: true
                    });
                }
            }
        ]);
        return Point2dPickerController;
    }();
    var Point2dController = /*#__PURE__*/ function() {
        function Point2dController(doc, config) {
            var _this = this;
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, Point2dController);
            var _a, _b;
            this.onPopupChildBlur_ = this.onPopupChildBlur_.bind(this);
            this.onPopupChildKeydown_ = this.onPopupChildKeydown_.bind(this);
            this.onPadButtonBlur_ = this.onPadButtonBlur_.bind(this);
            this.onPadButtonClick_ = this.onPadButtonClick_.bind(this);
            this.value = config.value;
            this.viewProps = config.viewProps;
            this.foldable_ = Foldable.create(config.expanded);
            this.popC_ = config.pickerLayout === 'popup' ? new PopupController(doc, {
                viewProps: this.viewProps
            }) : null;
            var padC = new Point2dPickerController(doc, {
                baseSteps: [
                    config.axes[0].baseStep,
                    config.axes[1].baseStep
                ],
                invertsY: config.invertsY,
                layout: config.pickerLayout,
                maxValue: config.maxValue,
                value: this.value,
                viewProps: this.viewProps
            });
            padC.view.allFocusableElements.forEach(function(elem) {
                elem.addEventListener('blur', _this.onPopupChildBlur_);
                elem.addEventListener('keydown', _this.onPopupChildKeydown_);
            });
            this.pickerC_ = padC;
            this.textC_ = new PointNdTextController(doc, {
                assembly: Point2dAssembly,
                axes: config.axes,
                parser: config.parser,
                value: this.value,
                viewProps: this.viewProps
            });
            this.view = new Point2dView(doc, {
                expanded: this.foldable_.value('expanded'),
                pickerLayout: config.pickerLayout,
                viewProps: this.viewProps
            });
            this.view.textElement.appendChild(this.textC_.view.element);
            (_a = this.view.buttonElement) === null || _a === void 0 || _a.addEventListener('blur', this.onPadButtonBlur_);
            (_b = this.view.buttonElement) === null || _b === void 0 || _b.addEventListener('click', this.onPadButtonClick_);
            if (this.popC_) {
                this.view.element.appendChild(this.popC_.view.element);
                this.popC_.view.element.appendChild(this.pickerC_.view.element);
                connectValues({
                    primary: this.foldable_.value('expanded'),
                    secondary: this.popC_.shows,
                    forward: function(p) {
                        return p.rawValue;
                    },
                    backward: function(_, s) {
                        return s.rawValue;
                    }
                });
            } else if (this.view.pickerElement) {
                this.view.pickerElement.appendChild(this.pickerC_.view.element);
                bindFoldable(this.foldable_, this.view.pickerElement);
            }
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(Point2dController, [
            {
                key: "onPadButtonBlur_",
                value: function onPadButtonBlur_(e) {
                    if (!this.popC_) return;
                    var elem = this.view.element;
                    var nextTarget = forceCast(e.relatedTarget);
                    if (!nextTarget || !elem.contains(nextTarget)) this.popC_.shows.rawValue = false;
                }
            },
            {
                key: "onPadButtonClick_",
                value: function onPadButtonClick_() {
                    this.foldable_.set('expanded', !this.foldable_.get('expanded'));
                    if (this.foldable_.get('expanded')) this.pickerC_.view.allFocusableElements[0].focus();
                }
            },
            {
                key: "onPopupChildBlur_",
                value: function onPopupChildBlur_(ev) {
                    if (!this.popC_) return;
                    var elem = this.popC_.view.element;
                    var nextTarget = findNextTarget(ev);
                    if (nextTarget && elem.contains(nextTarget)) return;
                    if (nextTarget && nextTarget === this.view.buttonElement && !supportsTouch(elem.ownerDocument)) return;
                    this.popC_.shows.rawValue = false;
                }
            },
            {
                key: "onPopupChildKeydown_",
                value: function onPopupChildKeydown_(ev) {
                    if (this.popC_) {
                        if (ev.key === 'Escape') this.popC_.shows.rawValue = false;
                    } else if (this.view.pickerElement) {
                        if (ev.key === 'Escape') this.view.buttonElement.focus();
                    }
                }
            }
        ]);
        return Point2dController;
    }();
    var Point3d = /*#__PURE__*/ function() {
        function Point3d() {
            var x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, z = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, Point3d);
            this.x = x;
            this.y = y;
            this.z = z;
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(Point3d, [
            {
                key: "getComponents",
                value: function getComponents() {
                    return [
                        this.x,
                        this.y,
                        this.z
                    ];
                }
            },
            {
                key: "toObject",
                value: function toObject() {
                    return {
                        x: this.x,
                        y: this.y,
                        z: this.z
                    };
                }
            }
        ], [
            {
                key: "isObject",
                value: function isObject(obj) {
                    if (isEmpty(obj)) return false;
                    var x = obj.x;
                    var y = obj.y;
                    var z = obj.z;
                    if (typeof x !== 'number' || typeof y !== 'number' || typeof z !== 'number') return false;
                    return true;
                }
            },
            {
                key: "equals",
                value: function equals(v1, v2) {
                    return v1.x === v2.x && v1.y === v2.y && v1.z === v2.z;
                }
            }
        ]);
        return Point3d;
    }();
    var Point3dAssembly = {
        toComponents: function(p) {
            return p.getComponents();
        },
        fromComponents: function(comps) {
            return (0, $21dc3cc07aba2591$export$71511d61b312f219)(Point3d, (0, $4fcd3d80e9e33ca7$export$71511d61b312f219)(comps));
        }
    };
    function point3dFromUnknown(value) {
        return Point3d.isObject(value) ? new Point3d(value.x, value.y, value.z) : new Point3d();
    }
    function writePoint3d(target, value) {
        target.writeProperty('x', value.x);
        target.writeProperty('y', value.y);
        target.writeProperty('z', value.z);
    }
    function createConstraint$3(params, initialValue) {
        return new PointNdConstraint({
            assembly: Point3dAssembly,
            components: [
                createDimensionConstraint('x' in params ? params.x : undefined, initialValue.x),
                createDimensionConstraint('y' in params ? params.y : undefined, initialValue.y),
                createDimensionConstraint('z' in params ? params.z : undefined, initialValue.z)
            ]
        });
    }
    function createAxis$2(initialValue, constraint) {
        return {
            baseStep: getBaseStep(constraint),
            constraint: constraint,
            textProps: ValueMap.fromObject({
                draggingScale: getSuitableDraggingScale(constraint, initialValue),
                formatter: createNumberFormatter(getSuitableDecimalDigits(constraint, initialValue))
            })
        };
    }
    var Point3dInputPlugin = {
        id: 'input-point3d',
        type: 'input',
        accept: function(value, params) {
            if (!Point3d.isObject(value)) return null;
            var p = ParamsParsers;
            var result = parseParams(params, {
                x: p.optional.custom(parsePointDimensionParams),
                y: p.optional.custom(parsePointDimensionParams),
                z: p.optional.custom(parsePointDimensionParams)
            });
            return result ? {
                initialValue: value,
                params: result
            } : null;
        },
        binding: {
            reader: function(_args) {
                return point3dFromUnknown;
            },
            constraint: function(args) {
                return createConstraint$3(args.params, args.initialValue);
            },
            equals: Point3d.equals,
            writer: function(_args) {
                return writePoint3d;
            }
        },
        controller: function(args) {
            var value = args.value;
            var c = args.constraint;
            if (!(c instanceof PointNdConstraint)) throw TpError.shouldNeverHappen();
            return new PointNdTextController(args.document, {
                assembly: Point3dAssembly,
                axes: [
                    createAxis$2(value.rawValue.x, c.components[0]),
                    createAxis$2(value.rawValue.y, c.components[1]),
                    createAxis$2(value.rawValue.z, c.components[2])
                ],
                parser: parseNumber,
                value: value,
                viewProps: args.viewProps
            });
        }
    };
    var Point4d = /*#__PURE__*/ function() {
        function Point4d() {
            var x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, z = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, w = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, Point4d);
            this.x = x;
            this.y = y;
            this.z = z;
            this.w = w;
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(Point4d, [
            {
                key: "getComponents",
                value: function getComponents() {
                    return [
                        this.x,
                        this.y,
                        this.z,
                        this.w
                    ];
                }
            },
            {
                key: "toObject",
                value: function toObject() {
                    return {
                        x: this.x,
                        y: this.y,
                        z: this.z,
                        w: this.w
                    };
                }
            }
        ], [
            {
                key: "isObject",
                value: function isObject(obj) {
                    if (isEmpty(obj)) return false;
                    var x = obj.x;
                    var y = obj.y;
                    var z = obj.z;
                    var w = obj.w;
                    if (typeof x !== 'number' || typeof y !== 'number' || typeof z !== 'number' || typeof w !== 'number') return false;
                    return true;
                }
            },
            {
                key: "equals",
                value: function equals(v1, v2) {
                    return v1.x === v2.x && v1.y === v2.y && v1.z === v2.z && v1.w === v2.w;
                }
            }
        ]);
        return Point4d;
    }();
    var Point4dAssembly = {
        toComponents: function(p) {
            return p.getComponents();
        },
        fromComponents: function(comps) {
            return (0, $21dc3cc07aba2591$export$71511d61b312f219)(Point4d, (0, $4fcd3d80e9e33ca7$export$71511d61b312f219)(comps));
        }
    };
    function point4dFromUnknown(value) {
        return Point4d.isObject(value) ? new Point4d(value.x, value.y, value.z, value.w) : new Point4d();
    }
    function writePoint4d(target, value) {
        target.writeProperty('x', value.x);
        target.writeProperty('y', value.y);
        target.writeProperty('z', value.z);
        target.writeProperty('w', value.w);
    }
    function createConstraint$2(params, initialValue) {
        return new PointNdConstraint({
            assembly: Point4dAssembly,
            components: [
                createDimensionConstraint('x' in params ? params.x : undefined, initialValue.x),
                createDimensionConstraint('y' in params ? params.y : undefined, initialValue.y),
                createDimensionConstraint('z' in params ? params.z : undefined, initialValue.z),
                createDimensionConstraint('w' in params ? params.w : undefined, initialValue.w)
            ]
        });
    }
    function createAxis$1(initialValue, constraint) {
        return {
            baseStep: getBaseStep(constraint),
            constraint: constraint,
            textProps: ValueMap.fromObject({
                draggingScale: getSuitableDraggingScale(constraint, initialValue),
                formatter: createNumberFormatter(getSuitableDecimalDigits(constraint, initialValue))
            })
        };
    }
    var Point4dInputPlugin = {
        id: 'input-point4d',
        type: 'input',
        accept: function(value, params) {
            if (!Point4d.isObject(value)) return null;
            var p = ParamsParsers;
            var result = parseParams(params, {
                x: p.optional.custom(parsePointDimensionParams),
                y: p.optional.custom(parsePointDimensionParams),
                z: p.optional.custom(parsePointDimensionParams),
                w: p.optional.custom(parsePointDimensionParams)
            });
            return result ? {
                initialValue: value,
                params: result
            } : null;
        },
        binding: {
            reader: function(_args) {
                return point4dFromUnknown;
            },
            constraint: function(args) {
                return createConstraint$2(args.params, args.initialValue);
            },
            equals: Point4d.equals,
            writer: function(_args) {
                return writePoint4d;
            }
        },
        controller: function(args) {
            var value = args.value;
            var c = args.constraint;
            if (!(c instanceof PointNdConstraint)) throw TpError.shouldNeverHappen();
            return new PointNdTextController(args.document, {
                assembly: Point4dAssembly,
                axes: value.rawValue.getComponents().map(function(comp, index) {
                    return createAxis$1(comp, c.components[index]);
                }),
                parser: parseNumber,
                value: value,
                viewProps: args.viewProps
            });
        }
    };
    function createConstraint$1(params) {
        var constraints = [];
        var lc = createListConstraint(params.options);
        if (lc) constraints.push(lc);
        return new CompositeConstraint(constraints);
    }
    var StringInputPlugin = {
        id: 'input-string',
        type: 'input',
        accept: function(value, params) {
            if (typeof value !== 'string') return null;
            var p = ParamsParsers;
            var result = parseParams(params, {
                options: p.optional.custom(parseListOptions)
            });
            return result ? {
                initialValue: value,
                params: result
            } : null;
        },
        binding: {
            reader: function(_args) {
                return stringFromUnknown;
            },
            constraint: function(args) {
                return createConstraint$1(args.params);
            },
            writer: function(_args) {
                return writePrimitive;
            }
        },
        controller: function(args) {
            var doc = args.document;
            var value = args.value;
            var c = args.constraint;
            var lc = c && findConstraint(c, ListConstraint);
            if (lc) return new ListController(doc, {
                props: new ValueMap({
                    options: lc.values.value('options')
                }),
                value: value,
                viewProps: args.viewProps
            });
            return new TextController(doc, {
                parser: function(v) {
                    return v;
                },
                props: ValueMap.fromObject({
                    formatter: formatString
                }),
                value: value,
                viewProps: args.viewProps
            });
        }
    };
    var Constants = {
        monitor: {
            defaultInterval: 200,
            defaultLineCount: 3
        }
    };
    var className$2 = ClassName('mll');
    var MultiLogView = /*#__PURE__*/ function() {
        function MultiLogView(doc, config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, MultiLogView);
            this.onValueUpdate_ = this.onValueUpdate_.bind(this);
            this.formatter_ = config.formatter;
            this.element = doc.createElement('div');
            this.element.classList.add(className$2());
            config.viewProps.bindClassModifiers(this.element);
            var textareaElem = doc.createElement('textarea');
            textareaElem.classList.add(className$2('i'));
            textareaElem.style.height = "calc(var(--bld-us) * ".concat(config.lineCount, ")");
            textareaElem.readOnly = true;
            config.viewProps.bindDisabled(textareaElem);
            this.element.appendChild(textareaElem);
            this.textareaElem_ = textareaElem;
            config.value.emitter.on('change', this.onValueUpdate_);
            this.value = config.value;
            this.update_();
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(MultiLogView, [
            {
                key: "update_",
                value: function update_() {
                    var _this = this;
                    var elem = this.textareaElem_;
                    var shouldScroll = elem.scrollTop === elem.scrollHeight - elem.clientHeight;
                    var lines = [];
                    this.value.rawValue.forEach(function(value) {
                        if (value !== undefined) lines.push(_this.formatter_(value));
                    });
                    elem.textContent = lines.join('\n');
                    if (shouldScroll) elem.scrollTop = elem.scrollHeight;
                }
            },
            {
                key: "onValueUpdate_",
                value: function onValueUpdate_() {
                    this.update_();
                }
            }
        ]);
        return MultiLogView;
    }();
    var MultiLogController = function MultiLogController(doc, config) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, MultiLogController);
        this.value = config.value;
        this.viewProps = config.viewProps;
        this.view = new MultiLogView(doc, {
            formatter: config.formatter,
            lineCount: config.lineCount,
            value: this.value,
            viewProps: this.viewProps
        });
    };
    var className$1 = ClassName('sgl');
    var SingleLogView = /*#__PURE__*/ function() {
        function SingleLogView(doc, config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, SingleLogView);
            this.onValueUpdate_ = this.onValueUpdate_.bind(this);
            this.formatter_ = config.formatter;
            this.element = doc.createElement('div');
            this.element.classList.add(className$1());
            config.viewProps.bindClassModifiers(this.element);
            var inputElem = doc.createElement('input');
            inputElem.classList.add(className$1('i'));
            inputElem.readOnly = true;
            inputElem.type = 'text';
            config.viewProps.bindDisabled(inputElem);
            this.element.appendChild(inputElem);
            this.inputElement = inputElem;
            config.value.emitter.on('change', this.onValueUpdate_);
            this.value = config.value;
            this.update_();
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(SingleLogView, [
            {
                key: "update_",
                value: function update_() {
                    var values = this.value.rawValue;
                    var lastValue = values[values.length - 1];
                    this.inputElement.value = lastValue !== undefined ? this.formatter_(lastValue) : '';
                }
            },
            {
                key: "onValueUpdate_",
                value: function onValueUpdate_() {
                    this.update_();
                }
            }
        ]);
        return SingleLogView;
    }();
    var SingleLogController = function SingleLogController(doc, config) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, SingleLogController);
        this.value = config.value;
        this.viewProps = config.viewProps;
        this.view = new SingleLogView(doc, {
            formatter: config.formatter,
            value: this.value,
            viewProps: this.viewProps
        });
    };
    var BooleanMonitorPlugin = {
        id: 'monitor-bool',
        type: 'monitor',
        accept: function(value, params) {
            if (typeof value !== 'boolean') return null;
            var p = ParamsParsers;
            var result = parseParams(params, {
                lineCount: p.optional.number
            });
            return result ? {
                initialValue: value,
                params: result
            } : null;
        },
        binding: {
            reader: function(_args) {
                return boolFromUnknown;
            }
        },
        controller: function(args) {
            var _a;
            if (args.value.rawValue.length === 1) return new SingleLogController(args.document, {
                formatter: BooleanFormatter,
                value: args.value,
                viewProps: args.viewProps
            });
            return new MultiLogController(args.document, {
                formatter: BooleanFormatter,
                lineCount: (_a = args.params.lineCount) !== null && _a !== void 0 ? _a : Constants.monitor.defaultLineCount,
                value: args.value,
                viewProps: args.viewProps
            });
        }
    };
    var className = ClassName('grl');
    var GraphLogView = /*#__PURE__*/ function() {
        function GraphLogView(doc, config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, GraphLogView);
            this.onCursorChange_ = this.onCursorChange_.bind(this);
            this.onValueUpdate_ = this.onValueUpdate_.bind(this);
            this.element = doc.createElement('div');
            this.element.classList.add(className());
            config.viewProps.bindClassModifiers(this.element);
            this.formatter_ = config.formatter;
            this.props_ = config.props;
            this.cursor_ = config.cursor;
            this.cursor_.emitter.on('change', this.onCursorChange_);
            var svgElem = doc.createElementNS(SVG_NS, 'svg');
            svgElem.classList.add(className('g'));
            svgElem.style.height = "calc(var(--bld-us) * ".concat(config.lineCount, ")");
            this.element.appendChild(svgElem);
            this.svgElem_ = svgElem;
            var lineElem = doc.createElementNS(SVG_NS, 'polyline');
            this.svgElem_.appendChild(lineElem);
            this.lineElem_ = lineElem;
            var tooltipElem = doc.createElement('div');
            tooltipElem.classList.add(className('t'), ClassName('tt')());
            this.element.appendChild(tooltipElem);
            this.tooltipElem_ = tooltipElem;
            config.value.emitter.on('change', this.onValueUpdate_);
            this.value = config.value;
            this.update_();
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(GraphLogView, [
            {
                key: "graphElement",
                get: function get() {
                    return this.svgElem_;
                }
            },
            {
                key: "update_",
                value: function update_() {
                    var bounds = this.svgElem_.getBoundingClientRect();
                    var maxIndex = this.value.rawValue.length - 1;
                    var min = this.props_.get('minValue');
                    var max = this.props_.get('maxValue');
                    var points = [];
                    this.value.rawValue.forEach(function(v, index) {
                        if (v === undefined) return;
                        var x = mapRange(index, 0, maxIndex, 0, bounds.width);
                        var y = mapRange(v, min, max, bounds.height, 0);
                        points.push([
                            x,
                            y
                        ].join(','));
                    });
                    this.lineElem_.setAttributeNS(null, 'points', points.join(' '));
                    var tooltipElem = this.tooltipElem_;
                    var value = this.value.rawValue[this.cursor_.rawValue];
                    if (value === undefined) {
                        tooltipElem.classList.remove(className('t', 'a'));
                        return;
                    }
                    var tx = mapRange(this.cursor_.rawValue, 0, maxIndex, 0, bounds.width);
                    var ty = mapRange(value, min, max, bounds.height, 0);
                    tooltipElem.style.left = "".concat(tx, "px");
                    tooltipElem.style.top = "".concat(ty, "px");
                    tooltipElem.textContent = "".concat(this.formatter_(value));
                    if (!tooltipElem.classList.contains(className('t', 'a'))) {
                        tooltipElem.classList.add(className('t', 'a'), className('t', 'in'));
                        forceReflow(tooltipElem);
                        tooltipElem.classList.remove(className('t', 'in'));
                    }
                }
            },
            {
                key: "onValueUpdate_",
                value: function onValueUpdate_() {
                    this.update_();
                }
            },
            {
                key: "onCursorChange_",
                value: function onCursorChange_() {
                    this.update_();
                }
            }
        ]);
        return GraphLogView;
    }();
    var GraphLogController = /*#__PURE__*/ function() {
        function GraphLogController(doc, config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, GraphLogController);
            this.onGraphMouseMove_ = this.onGraphMouseMove_.bind(this);
            this.onGraphMouseLeave_ = this.onGraphMouseLeave_.bind(this);
            this.onGraphPointerDown_ = this.onGraphPointerDown_.bind(this);
            this.onGraphPointerMove_ = this.onGraphPointerMove_.bind(this);
            this.onGraphPointerUp_ = this.onGraphPointerUp_.bind(this);
            this.props_ = config.props;
            this.value = config.value;
            this.viewProps = config.viewProps;
            this.cursor_ = createValue(-1);
            this.view = new GraphLogView(doc, {
                cursor: this.cursor_,
                formatter: config.formatter,
                lineCount: config.lineCount,
                props: this.props_,
                value: this.value,
                viewProps: this.viewProps
            });
            if (!supportsTouch(doc)) {
                this.view.element.addEventListener('mousemove', this.onGraphMouseMove_);
                this.view.element.addEventListener('mouseleave', this.onGraphMouseLeave_);
            } else {
                var ph = new PointerHandler(this.view.element);
                ph.emitter.on('down', this.onGraphPointerDown_);
                ph.emitter.on('move', this.onGraphPointerMove_);
                ph.emitter.on('up', this.onGraphPointerUp_);
            }
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(GraphLogController, [
            {
                key: "onGraphMouseLeave_",
                value: function onGraphMouseLeave_() {
                    this.cursor_.rawValue = -1;
                }
            },
            {
                key: "onGraphMouseMove_",
                value: function onGraphMouseMove_(ev) {
                    var bounds = this.view.element.getBoundingClientRect();
                    this.cursor_.rawValue = Math.floor(mapRange(ev.offsetX, 0, bounds.width, 0, this.value.rawValue.length));
                }
            },
            {
                key: "onGraphPointerDown_",
                value: function onGraphPointerDown_(ev) {
                    this.onGraphPointerMove_(ev);
                }
            },
            {
                key: "onGraphPointerMove_",
                value: function onGraphPointerMove_(ev) {
                    if (!ev.data.point) {
                        this.cursor_.rawValue = -1;
                        return;
                    }
                    this.cursor_.rawValue = Math.floor(mapRange(ev.data.point.x, 0, ev.data.bounds.width, 0, this.value.rawValue.length));
                }
            },
            {
                key: "onGraphPointerUp_",
                value: function onGraphPointerUp_() {
                    this.cursor_.rawValue = -1;
                }
            }
        ]);
        return GraphLogController;
    }();
    function createFormatter(params) {
        return 'format' in params && !isEmpty(params.format) ? params.format : createNumberFormatter(2);
    }
    function createTextMonitor(args) {
        var _a;
        if (args.value.rawValue.length === 1) return new SingleLogController(args.document, {
            formatter: createFormatter(args.params),
            value: args.value,
            viewProps: args.viewProps
        });
        return new MultiLogController(args.document, {
            formatter: createFormatter(args.params),
            lineCount: (_a = args.params.lineCount) !== null && _a !== void 0 ? _a : Constants.monitor.defaultLineCount,
            value: args.value,
            viewProps: args.viewProps
        });
    }
    function createGraphMonitor(args) {
        var _a, _b, _c;
        return new GraphLogController(args.document, {
            formatter: createFormatter(args.params),
            lineCount: (_a = args.params.lineCount) !== null && _a !== void 0 ? _a : Constants.monitor.defaultLineCount,
            props: ValueMap.fromObject({
                maxValue: (_b = 'max' in args.params ? args.params.max : null) !== null && _b !== void 0 ? _b : 100,
                minValue: (_c = 'min' in args.params ? args.params.min : null) !== null && _c !== void 0 ? _c : 0
            }),
            value: args.value,
            viewProps: args.viewProps
        });
    }
    function shouldShowGraph(params) {
        return 'view' in params && params.view === 'graph';
    }
    var NumberMonitorPlugin = {
        id: 'monitor-number',
        type: 'monitor',
        accept: function(value, params) {
            if (typeof value !== 'number') return null;
            var p = ParamsParsers;
            var result = parseParams(params, {
                format: p.optional.function,
                lineCount: p.optional.number,
                max: p.optional.number,
                min: p.optional.number,
                view: p.optional.string
            });
            return result ? {
                initialValue: value,
                params: result
            } : null;
        },
        binding: {
            defaultBufferSize: function(params) {
                return shouldShowGraph(params) ? 64 : 1;
            },
            reader: function(_args) {
                return numberFromUnknown;
            }
        },
        controller: function(args) {
            if (shouldShowGraph(args.params)) return createGraphMonitor(args);
            return createTextMonitor(args);
        }
    };
    var StringMonitorPlugin = {
        id: 'monitor-string',
        type: 'monitor',
        accept: function(value, params) {
            if (typeof value !== 'string') return null;
            var p = ParamsParsers;
            var result = parseParams(params, {
                lineCount: p.optional.number,
                multiline: p.optional.boolean
            });
            return result ? {
                initialValue: value,
                params: result
            } : null;
        },
        binding: {
            reader: function(_args) {
                return stringFromUnknown;
            }
        },
        controller: function(args) {
            var _a;
            var value = args.value;
            var multiline = value.rawValue.length > 1 || 'multiline' in args.params && args.params.multiline;
            if (multiline) return new MultiLogController(args.document, {
                formatter: formatString,
                lineCount: (_a = args.params.lineCount) !== null && _a !== void 0 ? _a : Constants.monitor.defaultLineCount,
                value: value,
                viewProps: args.viewProps
            });
            return new SingleLogController(args.document, {
                formatter: formatString,
                value: value,
                viewProps: args.viewProps
            });
        }
    };
    function createInputBindingController(plugin, args) {
        var _a;
        var result = plugin.accept(args.target.read(), args.params);
        if (isEmpty(result)) return null;
        var p = ParamsParsers;
        var valueArgs = {
            target: args.target,
            initialValue: result.initialValue,
            params: result.params
        };
        var reader = plugin.binding.reader(valueArgs);
        var constraint = plugin.binding.constraint ? plugin.binding.constraint(valueArgs) : undefined;
        var value = createValue(reader(result.initialValue), {
            constraint: constraint,
            equals: plugin.binding.equals
        });
        var binding = new InputBinding({
            reader: reader,
            target: args.target,
            value: value,
            writer: plugin.binding.writer(valueArgs)
        });
        var disabled = p.optional.boolean(args.params.disabled).value;
        var hidden = p.optional.boolean(args.params.hidden).value;
        var controller = plugin.controller({
            constraint: constraint,
            document: args.document,
            initialValue: result.initialValue,
            params: result.params,
            value: binding.value,
            viewProps: ViewProps.create({
                disabled: disabled,
                hidden: hidden
            })
        });
        return new InputBindingController(args.document, {
            binding: binding,
            blade: createBlade(),
            props: ValueMap.fromObject({
                label: 'label' in args.params ? (_a = p.optional.string(args.params.label).value) !== null && _a !== void 0 ? _a : null : args.target.key
            }),
            valueController: controller
        });
    }
    function createTicker(document, interval) {
        return interval === 0 ? new ManualTicker() : new IntervalTicker(document, interval !== null && interval !== void 0 ? interval : Constants.monitor.defaultInterval);
    }
    function createMonitorBindingController(plugin, args) {
        var _a, _b, _c;
        var p = ParamsParsers;
        var result = plugin.accept(args.target.read(), args.params);
        if (isEmpty(result)) return null;
        var bindingArgs = {
            target: args.target,
            initialValue: result.initialValue,
            params: result.params
        };
        var reader = plugin.binding.reader(bindingArgs);
        var bufferSize = (_b = (_a = p.optional.number(args.params.bufferSize).value) !== null && _a !== void 0 ? _a : plugin.binding.defaultBufferSize && plugin.binding.defaultBufferSize(result.params)) !== null && _b !== void 0 ? _b : 1;
        var interval = p.optional.number(args.params.interval).value;
        var binding = new MonitorBinding({
            reader: reader,
            target: args.target,
            ticker: createTicker(args.document, interval),
            value: initializeBuffer(bufferSize)
        });
        var disabled = p.optional.boolean(args.params.disabled).value;
        var hidden = p.optional.boolean(args.params.hidden).value;
        var controller = plugin.controller({
            document: args.document,
            params: result.params,
            value: binding.value,
            viewProps: ViewProps.create({
                disabled: disabled,
                hidden: hidden
            })
        });
        return new MonitorBindingController(args.document, {
            binding: binding,
            blade: createBlade(),
            props: ValueMap.fromObject({
                label: 'label' in args.params ? (_c = p.optional.string(args.params.label).value) !== null && _c !== void 0 ? _c : null : args.target.key
            }),
            valueController: controller
        });
    }
    var PluginPool = /*#__PURE__*/ function() {
        function PluginPool() {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, PluginPool);
            this.pluginsMap_ = {
                blades: [],
                inputs: [],
                monitors: []
            };
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(PluginPool, [
            {
                key: "getAll",
                value: function getAll() {
                    return (0, $4fcd3d80e9e33ca7$export$71511d61b312f219)(this.pluginsMap_.blades).concat((0, $4fcd3d80e9e33ca7$export$71511d61b312f219)(this.pluginsMap_.inputs), (0, $4fcd3d80e9e33ca7$export$71511d61b312f219)(this.pluginsMap_.monitors));
                }
            },
            {
                key: "register",
                value: function register(r) {
                    if (r.type === 'blade') this.pluginsMap_.blades.unshift(r);
                    else if (r.type === 'input') this.pluginsMap_.inputs.unshift(r);
                    else if (r.type === 'monitor') this.pluginsMap_.monitors.unshift(r);
                }
            },
            {
                key: "createInput",
                value: function createInput(document, target, params) {
                    var initialValue = target.read();
                    if (isEmpty(initialValue)) throw new TpError({
                        context: {
                            key: target.key
                        },
                        type: 'nomatchingcontroller'
                    });
                    var bc = this.pluginsMap_.inputs.reduce(function(result, plugin) {
                        return result !== null && result !== void 0 ? result : createInputBindingController(plugin, {
                            document: document,
                            target: target,
                            params: params
                        });
                    }, null);
                    if (bc) return bc;
                    throw new TpError({
                        context: {
                            key: target.key
                        },
                        type: 'nomatchingcontroller'
                    });
                }
            },
            {
                key: "createMonitor",
                value: function createMonitor(document, target, params) {
                    var bc = this.pluginsMap_.monitors.reduce(function(result, plugin) {
                        return result !== null && result !== void 0 ? result : createMonitorBindingController(plugin, {
                            document: document,
                            params: params,
                            target: target
                        });
                    }, null);
                    if (bc) return bc;
                    throw new TpError({
                        context: {
                            key: target.key
                        },
                        type: 'nomatchingcontroller'
                    });
                }
            },
            {
                key: "createBlade",
                value: function createBlade(document, params) {
                    var bc = this.pluginsMap_.blades.reduce(function(result, plugin) {
                        return result !== null && result !== void 0 ? result : createBladeController(plugin, {
                            document: document,
                            params: params
                        });
                    }, null);
                    if (!bc) throw new TpError({
                        type: 'nomatchingview',
                        context: {
                            params: params
                        }
                    });
                    return bc;
                }
            },
            {
                key: "createBladeApi",
                value: function createBladeApi(bc) {
                    var _this = this;
                    if (bc instanceof InputBindingController) return new InputBindingApi(bc);
                    if (bc instanceof MonitorBindingController) return new MonitorBindingApi(bc);
                    if (bc instanceof RackController) return new RackApi(bc, this);
                    var api = this.pluginsMap_.blades.reduce(function(result, plugin) {
                        return result !== null && result !== void 0 ? result : plugin.api({
                            controller: bc,
                            pool: _this
                        });
                    }, null);
                    if (!api) throw TpError.shouldNeverHappen();
                    return api;
                }
            }
        ]);
        return PluginPool;
    }();
    function createDefaultPluginPool() {
        var pool = new PluginPool();
        [
            Point2dInputPlugin,
            Point3dInputPlugin,
            Point4dInputPlugin,
            StringInputPlugin,
            NumberInputPlugin,
            StringColorInputPlugin,
            ObjectColorInputPlugin,
            NumberColorInputPlugin,
            BooleanInputPlugin,
            BooleanMonitorPlugin,
            StringMonitorPlugin,
            NumberMonitorPlugin,
            ButtonBladePlugin,
            FolderBladePlugin,
            SeparatorBladePlugin,
            TabBladePlugin
        ].forEach(function(p) {
            pool.register(p);
        });
        return pool;
    }
    function point2dFromUnknown(value) {
        return Point2d.isObject(value) ? new Point2d(value.x, value.y) : new Point2d();
    }
    function writePoint2d(target, value) {
        target.writeProperty('x', value.x);
        target.writeProperty('y', value.y);
    }
    function createDimensionConstraint(params, initialValue) {
        if (!params) return undefined;
        var constraints = [];
        var cs = createStepConstraint(params, initialValue);
        if (cs) constraints.push(cs);
        var rs = createRangeConstraint(params);
        if (rs) constraints.push(rs);
        return new CompositeConstraint(constraints);
    }
    function createConstraint(params, initialValue) {
        return new PointNdConstraint({
            assembly: Point2dAssembly,
            components: [
                createDimensionConstraint('x' in params ? params.x : undefined, initialValue.x),
                createDimensionConstraint('y' in params ? params.y : undefined, initialValue.y)
            ]
        });
    }
    function getSuitableMaxDimensionValue(constraint, rawValue) {
        var _ref = (0, $cccf0333cb9f9910$export$71511d61b312f219)(constraint ? findNumberRange(constraint) : [], 2), min = _ref[0], max = _ref[1];
        if (!isEmpty(min) || !isEmpty(max)) return Math.max(Math.abs(min !== null && min !== void 0 ? min : 0), Math.abs(max !== null && max !== void 0 ? max : 0));
        var step = getBaseStep(constraint);
        return Math.max(Math.abs(step) * 10, Math.abs(rawValue) * 10);
    }
    function getSuitableMaxValue(initialValue, constraint) {
        var xc = constraint instanceof PointNdConstraint ? constraint.components[0] : undefined;
        var yc = constraint instanceof PointNdConstraint ? constraint.components[1] : undefined;
        var xr = getSuitableMaxDimensionValue(xc, initialValue.x);
        var yr = getSuitableMaxDimensionValue(yc, initialValue.y);
        return Math.max(xr, yr);
    }
    function createAxis(initialValue, constraint) {
        return {
            baseStep: getBaseStep(constraint),
            constraint: constraint,
            textProps: ValueMap.fromObject({
                draggingScale: getSuitableDraggingScale(constraint, initialValue),
                formatter: createNumberFormatter(getSuitableDecimalDigits(constraint, initialValue))
            })
        };
    }
    function shouldInvertY(params) {
        if (!('y' in params)) return false;
        var yParams = params.y;
        if (!yParams) return false;
        return 'inverted' in yParams ? !!yParams.inverted : false;
    }
    var Point2dInputPlugin = {
        id: 'input-point2d',
        type: 'input',
        accept: function(value, params) {
            if (!Point2d.isObject(value)) return null;
            var p = ParamsParsers;
            var result = parseParams(params, {
                expanded: p.optional.boolean,
                picker: p.optional.custom(parsePickerLayout),
                x: p.optional.custom(parsePointDimensionParams),
                y: p.optional.object({
                    inverted: p.optional.boolean,
                    max: p.optional.number,
                    min: p.optional.number,
                    step: p.optional.number
                })
            });
            return result ? {
                initialValue: value,
                params: result
            } : null;
        },
        binding: {
            reader: function(_args) {
                return point2dFromUnknown;
            },
            constraint: function(args) {
                return createConstraint(args.params, args.initialValue);
            },
            equals: Point2d.equals,
            writer: function(_args) {
                return writePoint2d;
            }
        },
        controller: function(args) {
            var doc = args.document;
            var value = args.value;
            var c = args.constraint;
            if (!(c instanceof PointNdConstraint)) throw TpError.shouldNeverHappen();
            var expanded = 'expanded' in args.params ? args.params.expanded : undefined;
            var picker = 'picker' in args.params ? args.params.picker : undefined;
            return new Point2dController(doc, {
                axes: [
                    createAxis(value.rawValue.x, c.components[0]),
                    createAxis(value.rawValue.y, c.components[1])
                ],
                expanded: expanded !== null && expanded !== void 0 ? expanded : false,
                invertsY: shouldInvertY(args.params),
                maxValue: getSuitableMaxValue(value.rawValue, c),
                parser: parseNumber,
                pickerLayout: picker !== null && picker !== void 0 ? picker : 'popup',
                value: value,
                viewProps: args.viewProps
            });
        }
    };
    var ListApi = /*#__PURE__*/ function(BladeApi) {
        (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(ListApi, BladeApi);
        function ListApi(controller) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, ListApi);
            var _this;
            _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, ListApi, [
                controller
            ]);
            _this.emitter_ = new Emitter();
            _this.controller_.valueController.value.emitter.on('change', function(ev) {
                _this.emitter_.emit('change', {
                    event: new TpChangeEvent(_this, ev.rawValue)
                });
            });
            return _this;
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(ListApi, [
            {
                key: "label",
                get: function get() {
                    return this.controller_.props.get('label');
                },
                set: function set(label) {
                    this.controller_.props.set('label', label);
                }
            },
            {
                key: "options",
                get: function get() {
                    return this.controller_.valueController.props.get('options');
                },
                set: function set(options) {
                    this.controller_.valueController.props.set('options', options);
                }
            },
            {
                key: "value",
                get: function get() {
                    return this.controller_.valueController.value.rawValue;
                },
                set: function set(value) {
                    this.controller_.valueController.value.rawValue = value;
                }
            },
            {
                key: "on",
                value: function on(eventName, handler) {
                    var bh = handler.bind(this);
                    this.emitter_.on(eventName, function(ev) {
                        bh(ev.event);
                    });
                    return this;
                }
            }
        ]);
        return ListApi;
    }(BladeApi);
    var SliderApi = /*#__PURE__*/ function(BladeApi) {
        (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(SliderApi, BladeApi);
        function SliderApi(controller) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, SliderApi);
            var _this;
            _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, SliderApi, [
                controller
            ]);
            _this.emitter_ = new Emitter();
            _this.controller_.valueController.value.emitter.on('change', function(ev) {
                _this.emitter_.emit('change', {
                    event: new TpChangeEvent(_this, ev.rawValue)
                });
            });
            return _this;
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(SliderApi, [
            {
                key: "label",
                get: function get() {
                    return this.controller_.props.get('label');
                },
                set: function set(label) {
                    this.controller_.props.set('label', label);
                }
            },
            {
                key: "maxValue",
                get: function get() {
                    return this.controller_.valueController.sliderController.props.get('maxValue');
                },
                set: function set(maxValue) {
                    this.controller_.valueController.sliderController.props.set('maxValue', maxValue);
                }
            },
            {
                key: "minValue",
                get: function get() {
                    return this.controller_.valueController.sliderController.props.get('minValue');
                },
                set: function set(minValue) {
                    this.controller_.valueController.sliderController.props.set('minValue', minValue);
                }
            },
            {
                key: "value",
                get: function get() {
                    return this.controller_.valueController.value.rawValue;
                },
                set: function set(value) {
                    this.controller_.valueController.value.rawValue = value;
                }
            },
            {
                key: "on",
                value: function on(eventName, handler) {
                    var bh = handler.bind(this);
                    this.emitter_.on(eventName, function(ev) {
                        bh(ev.event);
                    });
                    return this;
                }
            }
        ]);
        return SliderApi;
    }(BladeApi);
    var TextApi = /*#__PURE__*/ function(BladeApi) {
        (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(TextApi, BladeApi);
        function TextApi(controller) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, TextApi);
            var _this;
            _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, TextApi, [
                controller
            ]);
            _this.emitter_ = new Emitter();
            _this.controller_.valueController.value.emitter.on('change', function(ev) {
                _this.emitter_.emit('change', {
                    event: new TpChangeEvent(_this, ev.rawValue)
                });
            });
            return _this;
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(TextApi, [
            {
                key: "label",
                get: function get() {
                    return this.controller_.props.get('label');
                },
                set: function set(label) {
                    this.controller_.props.set('label', label);
                }
            },
            {
                key: "formatter",
                get: function get() {
                    return this.controller_.valueController.props.get('formatter');
                },
                set: function set(formatter) {
                    this.controller_.valueController.props.set('formatter', formatter);
                }
            },
            {
                key: "value",
                get: function get() {
                    return this.controller_.valueController.value.rawValue;
                },
                set: function set(value) {
                    this.controller_.valueController.value.rawValue = value;
                }
            },
            {
                key: "on",
                value: function on(eventName, handler) {
                    var bh = handler.bind(this);
                    this.emitter_.on(eventName, function(ev) {
                        bh(ev.event);
                    });
                    return this;
                }
            }
        ]);
        return TextApi;
    }(BladeApi);
    var ListBladePlugin = function() {
        return {
            id: 'list',
            type: 'blade',
            accept: function(params) {
                var p = ParamsParsers;
                var result = parseParams(params, {
                    options: p.required.custom(parseListOptions),
                    value: p.required.raw,
                    view: p.required.constant('list'),
                    label: p.optional.string
                });
                return result ? {
                    params: result
                } : null;
            },
            controller: function(args) {
                var lc = new ListConstraint(normalizeListOptions(args.params.options));
                var value = createValue(args.params.value, {
                    constraint: lc
                });
                var ic = new ListController(args.document, {
                    props: new ValueMap({
                        options: lc.values.value('options')
                    }),
                    value: value,
                    viewProps: args.viewProps
                });
                return new LabeledValueController(args.document, {
                    blade: args.blade,
                    props: ValueMap.fromObject({
                        label: args.params.label
                    }),
                    valueController: ic
                });
            },
            api: function(args) {
                if (!(args.controller instanceof LabeledValueController)) return null;
                if (!(args.controller.valueController instanceof ListController)) return null;
                return new ListApi(args.controller);
            }
        };
    }();
    /**
     * @hidden
     */ function exportPresetJson(targets) {
        return targets.reduce(function(result, target) {
            return Object.assign(result, (0, $3facda9e207b3c1f$export$71511d61b312f219)({}, target.presetKey, target.read()));
        }, {});
    }
    /**
     * @hidden
     */ function importPresetJson(bindings, preset) {
        bindings.forEach(function(binding) {
            var value = preset[binding.target.presetKey];
            if (value !== undefined) binding.writer(binding.target, binding.reader(value));
        });
    }
    var RootApi = /*#__PURE__*/ function(FolderApi) {
        (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(RootApi, FolderApi);
        function RootApi(controller, pool) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, RootApi);
            return (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, RootApi, [
                controller,
                pool
            ]);
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(RootApi, [
            {
                key: "element",
                get: function get() {
                    return this.controller_.view.element;
                }
            },
            {
                /**
         * Imports a preset of all inputs.
         * @param preset The preset object to import.
         */ key: "importPreset",
                value: function importPreset(preset) {
                    var bindings = this.controller_.rackController.rack.find(InputBindingController).map(function(ibc) {
                        return ibc.binding;
                    });
                    importPresetJson(bindings, preset);
                    this.refresh();
                }
            },
            {
                /**
         * Exports a preset of all inputs.
         * @return An exported preset object.
         */ key: "exportPreset",
                value: function exportPreset() {
                    var targets = this.controller_.rackController.rack.find(InputBindingController).map(function(ibc) {
                        return ibc.binding.target;
                    });
                    return exportPresetJson(targets);
                }
            },
            {
                /**
         * Refreshes all bindings of the pane.
         */ key: "refresh",
                value: function refresh() {
                    // Force-read all input bindings
                    this.controller_.rackController.rack.find(InputBindingController).forEach(function(ibc) {
                        ibc.binding.read();
                    });
                    // Force-read all monitor bindings
                    this.controller_.rackController.rack.find(MonitorBindingController).forEach(function(mbc) {
                        mbc.binding.read();
                    });
                }
            }
        ]);
        return RootApi;
    }(FolderApi);
    var RootController = /*#__PURE__*/ function(FolderController) {
        (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(RootController, FolderController);
        function RootController(doc, config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, RootController);
            return (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, RootController, [
                doc,
                {
                    expanded: config.expanded,
                    blade: config.blade,
                    props: config.props,
                    root: true,
                    viewProps: config.viewProps
                }
            ]);
        }
        return RootController;
    }(FolderController);
    var SliderBladePlugin = {
        id: 'slider',
        type: 'blade',
        accept: function(params) {
            var p = ParamsParsers;
            var result = parseParams(params, {
                max: p.required.number,
                min: p.required.number,
                view: p.required.constant('slider'),
                format: p.optional.function,
                label: p.optional.string,
                value: p.optional.number
            });
            return result ? {
                params: result
            } : null;
        },
        controller: function(args) {
            var _a, _b;
            var initialValue = (_a = args.params.value) !== null && _a !== void 0 ? _a : 0;
            var drc = new DefiniteRangeConstraint({
                max: args.params.max,
                min: args.params.min
            });
            var vc = new SliderTextController(args.document, {
                baseStep: 1,
                parser: parseNumber,
                sliderProps: new ValueMap({
                    maxValue: drc.values.value('max'),
                    minValue: drc.values.value('min')
                }),
                textProps: ValueMap.fromObject({
                    draggingScale: getSuitableDraggingScale(undefined, initialValue),
                    formatter: (_b = args.params.format) !== null && _b !== void 0 ? _b : numberToString
                }),
                value: createValue(initialValue, {
                    constraint: drc
                }),
                viewProps: args.viewProps
            });
            return new LabeledValueController(args.document, {
                blade: args.blade,
                props: ValueMap.fromObject({
                    label: args.params.label
                }),
                valueController: vc
            });
        },
        api: function(args) {
            if (!(args.controller instanceof LabeledValueController)) return null;
            if (!(args.controller.valueController instanceof SliderTextController)) return null;
            return new SliderApi(args.controller);
        }
    };
    var TextBladePlugin = function() {
        return {
            id: 'text',
            type: 'blade',
            accept: function(params) {
                var p = ParamsParsers;
                var result = parseParams(params, {
                    parse: p.required.function,
                    value: p.required.raw,
                    view: p.required.constant('text'),
                    format: p.optional.function,
                    label: p.optional.string
                });
                return result ? {
                    params: result
                } : null;
            },
            controller: function(args) {
                var _a;
                var ic = new TextController(args.document, {
                    parser: args.params.parse,
                    props: ValueMap.fromObject({
                        formatter: (_a = args.params.format) !== null && _a !== void 0 ? _a : function(v) {
                            return String(v);
                        }
                    }),
                    value: createValue(args.params.value),
                    viewProps: args.viewProps
                });
                return new LabeledValueController(args.document, {
                    blade: args.blade,
                    props: ValueMap.fromObject({
                        label: args.params.label
                    }),
                    valueController: ic
                });
            },
            api: function(args) {
                if (!(args.controller instanceof LabeledValueController)) return null;
                if (!(args.controller.valueController instanceof TextController)) return null;
                return new TextApi(args.controller);
            }
        };
    }();
    function createDefaultWrapperElement(doc) {
        var elem = doc.createElement('div');
        elem.classList.add(ClassName('dfw')());
        if (doc.body) doc.body.appendChild(elem);
        return elem;
    }
    function embedStyle(doc, id, css) {
        if (doc.querySelector("style[data-tp-style=".concat(id, "]"))) return;
        var styleElem = doc.createElement('style');
        styleElem.dataset.tpStyle = id;
        styleElem.textContent = css;
        doc.head.appendChild(styleElem);
    }
    /**
     * The root pane of Tweakpane.
     */ var Pane = /*#__PURE__*/ function(RootApi) {
        (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(Pane, RootApi);
        function Pane(opt_config) {
            (0, $9a1684911372ec89$export$71511d61b312f219)(this, Pane);
            var _this;
            var _a, _b;
            var config = opt_config !== null && opt_config !== void 0 ? opt_config : {};
            var doc = (_a = config.document) !== null && _a !== void 0 ? _a : getWindowDocument();
            var pool = createDefaultPluginPool();
            var rootController = new RootController(doc, {
                expanded: config.expanded,
                blade: createBlade(),
                props: ValueMap.fromObject({
                    title: config.title
                }),
                viewProps: ViewProps.create()
            });
            _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, Pane, [
                rootController,
                pool
            ]);
            _this.pool_ = pool;
            _this.containerElem_ = (_b = config.container) !== null && _b !== void 0 ? _b : createDefaultWrapperElement(doc);
            _this.containerElem_.appendChild(_this.element);
            _this.doc_ = doc;
            _this.usesDefaultWrapper_ = !config.container;
            _this.setUpDefaultPlugins_();
            return _this;
        }
        (0, $4c70eeab04b218c5$export$71511d61b312f219)(Pane, [
            {
                key: "document",
                get: function get() {
                    if (!this.doc_) throw TpError.alreadyDisposed();
                    return this.doc_;
                }
            },
            {
                key: "dispose",
                value: function dispose() {
                    var containerElem = this.containerElem_;
                    if (!containerElem) throw TpError.alreadyDisposed();
                    if (this.usesDefaultWrapper_) {
                        var parentElem = containerElem.parentElement;
                        if (parentElem) parentElem.removeChild(containerElem);
                    }
                    this.containerElem_ = null;
                    this.doc_ = null;
                    (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(Pane.prototype), "dispose", this).call(this);
                }
            },
            {
                key: "registerPlugin",
                value: function registerPlugin(bundle) {
                    var _this = this;
                    var plugins = 'plugin' in bundle ? [
                        bundle.plugin
                    ] : 'plugins' in bundle ? bundle.plugins : [];
                    plugins.forEach(function(p) {
                        _this.pool_.register(p);
                        _this.embedPluginStyle_(p);
                    });
                }
            },
            {
                key: "embedPluginStyle_",
                value: function embedPluginStyle_(plugin) {
                    if (plugin.css) embedStyle(this.document, "plugin-".concat(plugin.id), plugin.css);
                }
            },
            {
                key: "setUpDefaultPlugins_",
                value: function setUpDefaultPlugins_() {
                    var _this = this;
                    // NOTE: This string literal will be replaced with the default CSS by Rollup at the compilation time
                    embedStyle(this.document, 'default', '.tp-tbiv_b,.tp-coltxtv_ms,.tp-ckbv_i,.tp-rotv_b,.tp-fldv_b,.tp-mllv_i,.tp-sglv_i,.tp-grlv_g,.tp-txtv_i,.tp-p2dpv_p,.tp-colswv_sw,.tp-p2dv_b,.tp-btnv_b,.tp-lstv_s{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:rgba(0,0,0,0);border-width:0;font-family:inherit;font-size:inherit;font-weight:inherit;margin:0;outline:none;padding:0}.tp-p2dv_b,.tp-btnv_b,.tp-lstv_s{background-color:var(--btn-bg);border-radius:var(--elm-br);color:var(--btn-fg);cursor:pointer;display:block;font-weight:bold;height:var(--bld-us);line-height:var(--bld-us);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.tp-p2dv_b:hover,.tp-btnv_b:hover,.tp-lstv_s:hover{background-color:var(--btn-bg-h)}.tp-p2dv_b:focus,.tp-btnv_b:focus,.tp-lstv_s:focus{background-color:var(--btn-bg-f)}.tp-p2dv_b:active,.tp-btnv_b:active,.tp-lstv_s:active{background-color:var(--btn-bg-a)}.tp-p2dv_b:disabled,.tp-btnv_b:disabled,.tp-lstv_s:disabled{opacity:.5}.tp-txtv_i,.tp-p2dpv_p,.tp-colswv_sw{background-color:var(--in-bg);border-radius:var(--elm-br);box-sizing:border-box;color:var(--in-fg);font-family:inherit;height:var(--bld-us);line-height:var(--bld-us);min-width:0;width:100%}.tp-txtv_i:hover,.tp-p2dpv_p:hover,.tp-colswv_sw:hover{background-color:var(--in-bg-h)}.tp-txtv_i:focus,.tp-p2dpv_p:focus,.tp-colswv_sw:focus{background-color:var(--in-bg-f)}.tp-txtv_i:active,.tp-p2dpv_p:active,.tp-colswv_sw:active{background-color:var(--in-bg-a)}.tp-txtv_i:disabled,.tp-p2dpv_p:disabled,.tp-colswv_sw:disabled{opacity:.5}.tp-mllv_i,.tp-sglv_i,.tp-grlv_g{background-color:var(--mo-bg);border-radius:var(--elm-br);box-sizing:border-box;color:var(--mo-fg);height:var(--bld-us);scrollbar-color:currentColor rgba(0,0,0,0);scrollbar-width:thin;width:100%}.tp-mllv_i::-webkit-scrollbar,.tp-sglv_i::-webkit-scrollbar,.tp-grlv_g::-webkit-scrollbar{height:8px;width:8px}.tp-mllv_i::-webkit-scrollbar-corner,.tp-sglv_i::-webkit-scrollbar-corner,.tp-grlv_g::-webkit-scrollbar-corner{background-color:rgba(0,0,0,0)}.tp-mllv_i::-webkit-scrollbar-thumb,.tp-sglv_i::-webkit-scrollbar-thumb,.tp-grlv_g::-webkit-scrollbar-thumb{background-clip:padding-box;background-color:currentColor;border:rgba(0,0,0,0) solid 2px;border-radius:4px}.tp-rotv{--font-family: var(--tp-font-family, Roboto Mono, Source Code Pro, Menlo, Courier, monospace);--bs-br: var(--tp-base-border-radius, 6px);--cnt-h-p: var(--tp-container-horizontal-padding, 4px);--cnt-v-p: var(--tp-container-vertical-padding, 4px);--elm-br: var(--tp-element-border-radius, 2px);--bld-s: var(--tp-blade-spacing, 4px);--bld-us: var(--tp-blade-unit-size, 20px);--bs-bg: var(--tp-base-background-color, hsl(230, 7%, 17%));--bs-sh: var(--tp-base-shadow-color, rgba(0, 0, 0, 0.2));--btn-bg: var(--tp-button-background-color, hsl(230, 7%, 70%));--btn-bg-a: var(--tp-button-background-color-active, #d6d7db);--btn-bg-f: var(--tp-button-background-color-focus, #c8cad0);--btn-bg-h: var(--tp-button-background-color-hover, #bbbcc4);--btn-fg: var(--tp-button-foreground-color, hsl(230, 7%, 17%));--cnt-bg: var(--tp-container-background-color, rgba(187, 188, 196, 0.1));--cnt-bg-a: var(--tp-container-background-color-active, rgba(187, 188, 196, 0.25));--cnt-bg-f: var(--tp-container-background-color-focus, rgba(187, 188, 196, 0.2));--cnt-bg-h: var(--tp-container-background-color-hover, rgba(187, 188, 196, 0.15));--cnt-fg: var(--tp-container-foreground-color, hsl(230, 7%, 75%));--in-bg: var(--tp-input-background-color, rgba(187, 188, 196, 0.1));--in-bg-a: var(--tp-input-background-color-active, rgba(187, 188, 196, 0.25));--in-bg-f: var(--tp-input-background-color-focus, rgba(187, 188, 196, 0.2));--in-bg-h: var(--tp-input-background-color-hover, rgba(187, 188, 196, 0.15));--in-fg: var(--tp-input-foreground-color, hsl(230, 7%, 75%));--lbl-fg: var(--tp-label-foreground-color, rgba(187, 188, 196, 0.7));--mo-bg: var(--tp-monitor-background-color, rgba(0, 0, 0, 0.2));--mo-fg: var(--tp-monitor-foreground-color, rgba(187, 188, 196, 0.7));--grv-fg: var(--tp-groove-foreground-color, rgba(187, 188, 196, 0.1))}.tp-rotv_c>.tp-cntv.tp-v-lst,.tp-tabv_c .tp-brkv>.tp-cntv.tp-v-lst,.tp-fldv_c>.tp-cntv.tp-v-lst{margin-bottom:calc(-1*var(--cnt-v-p))}.tp-rotv_c>.tp-fldv.tp-v-lst .tp-fldv_c,.tp-tabv_c .tp-brkv>.tp-fldv.tp-v-lst .tp-fldv_c,.tp-fldv_c>.tp-fldv.tp-v-lst .tp-fldv_c{border-bottom-left-radius:0}.tp-rotv_c>.tp-fldv.tp-v-lst .tp-fldv_b,.tp-tabv_c .tp-brkv>.tp-fldv.tp-v-lst .tp-fldv_b,.tp-fldv_c>.tp-fldv.tp-v-lst .tp-fldv_b{border-bottom-left-radius:0}.tp-rotv_c>*:not(.tp-v-fst),.tp-tabv_c .tp-brkv>*:not(.tp-v-fst),.tp-fldv_c>*:not(.tp-v-fst){margin-top:var(--bld-s)}.tp-rotv_c>.tp-sprv:not(.tp-v-fst),.tp-tabv_c .tp-brkv>.tp-sprv:not(.tp-v-fst),.tp-fldv_c>.tp-sprv:not(.tp-v-fst),.tp-rotv_c>.tp-cntv:not(.tp-v-fst),.tp-tabv_c .tp-brkv>.tp-cntv:not(.tp-v-fst),.tp-fldv_c>.tp-cntv:not(.tp-v-fst){margin-top:var(--cnt-v-p)}.tp-rotv_c>.tp-sprv+*:not(.tp-v-hidden),.tp-tabv_c .tp-brkv>.tp-sprv+*:not(.tp-v-hidden),.tp-fldv_c>.tp-sprv+*:not(.tp-v-hidden),.tp-rotv_c>.tp-cntv+*:not(.tp-v-hidden),.tp-tabv_c .tp-brkv>.tp-cntv+*:not(.tp-v-hidden),.tp-fldv_c>.tp-cntv+*:not(.tp-v-hidden){margin-top:var(--cnt-v-p)}.tp-rotv_c>.tp-sprv:not(.tp-v-hidden)+.tp-sprv,.tp-tabv_c .tp-brkv>.tp-sprv:not(.tp-v-hidden)+.tp-sprv,.tp-fldv_c>.tp-sprv:not(.tp-v-hidden)+.tp-sprv,.tp-rotv_c>.tp-cntv:not(.tp-v-hidden)+.tp-cntv,.tp-tabv_c .tp-brkv>.tp-cntv:not(.tp-v-hidden)+.tp-cntv,.tp-fldv_c>.tp-cntv:not(.tp-v-hidden)+.tp-cntv{margin-top:0}.tp-tabv_c .tp-brkv>.tp-cntv,.tp-fldv_c>.tp-cntv{margin-left:4px}.tp-tabv_c .tp-brkv>.tp-fldv>.tp-fldv_b,.tp-fldv_c>.tp-fldv>.tp-fldv_b{border-top-left-radius:var(--elm-br);border-bottom-left-radius:var(--elm-br)}.tp-tabv_c .tp-brkv>.tp-fldv.tp-fldv-expanded>.tp-fldv_b,.tp-fldv_c>.tp-fldv.tp-fldv-expanded>.tp-fldv_b{border-bottom-left-radius:0}.tp-tabv_c .tp-brkv .tp-fldv>.tp-fldv_c,.tp-fldv_c .tp-fldv>.tp-fldv_c{border-bottom-left-radius:var(--elm-br)}.tp-tabv_c .tp-brkv>.tp-cntv+.tp-fldv>.tp-fldv_b,.tp-fldv_c>.tp-cntv+.tp-fldv>.tp-fldv_b{border-top-left-radius:0}.tp-tabv_c .tp-brkv>.tp-cntv+.tp-tabv>.tp-tabv_t,.tp-fldv_c>.tp-cntv+.tp-tabv>.tp-tabv_t{border-top-left-radius:0}.tp-tabv_c .tp-brkv>.tp-tabv>.tp-tabv_t,.tp-fldv_c>.tp-tabv>.tp-tabv_t{border-top-left-radius:var(--elm-br)}.tp-tabv_c .tp-brkv .tp-tabv>.tp-tabv_c,.tp-fldv_c .tp-tabv>.tp-tabv_c{border-bottom-left-radius:var(--elm-br)}.tp-rotv_b,.tp-fldv_b{background-color:var(--cnt-bg);color:var(--cnt-fg);cursor:pointer;display:block;height:calc(var(--bld-us) + 4px);line-height:calc(var(--bld-us) + 4px);overflow:hidden;padding-left:var(--cnt-h-p);padding-right:calc(4px + var(--bld-us) + var(--cnt-h-p));position:relative;text-align:left;text-overflow:ellipsis;white-space:nowrap;width:100%;transition:border-radius .2s ease-in-out .2s}.tp-rotv_b:hover,.tp-fldv_b:hover{background-color:var(--cnt-bg-h)}.tp-rotv_b:focus,.tp-fldv_b:focus{background-color:var(--cnt-bg-f)}.tp-rotv_b:active,.tp-fldv_b:active{background-color:var(--cnt-bg-a)}.tp-rotv_b:disabled,.tp-fldv_b:disabled{opacity:.5}.tp-rotv_m,.tp-fldv_m{background:linear-gradient(to left, var(--cnt-fg), var(--cnt-fg) 2px, transparent 2px, transparent 4px, var(--cnt-fg) 4px);border-radius:2px;bottom:0;content:"";display:block;height:6px;right:calc(var(--cnt-h-p) + (var(--bld-us) + 4px - 6px)/2 - 2px);margin:auto;opacity:.5;position:absolute;top:0;transform:rotate(90deg);transition:transform .2s ease-in-out;width:6px}.tp-rotv.tp-rotv-expanded .tp-rotv_m,.tp-fldv.tp-fldv-expanded>.tp-fldv_b>.tp-fldv_m{transform:none}.tp-rotv_c,.tp-fldv_c{box-sizing:border-box;height:0;opacity:0;overflow:hidden;padding-bottom:0;padding-top:0;position:relative;transition:height .2s ease-in-out,opacity .2s linear,padding .2s ease-in-out}.tp-rotv.tp-rotv-cpl:not(.tp-rotv-expanded) .tp-rotv_c,.tp-fldv.tp-fldv-cpl:not(.tp-fldv-expanded)>.tp-fldv_c{display:none}.tp-rotv.tp-rotv-expanded .tp-rotv_c,.tp-fldv.tp-fldv-expanded>.tp-fldv_c{opacity:1;padding-bottom:var(--cnt-v-p);padding-top:var(--cnt-v-p);transform:none;overflow:visible;transition:height .2s ease-in-out,opacity .2s linear .2s,padding .2s ease-in-out}.tp-lstv,.tp-coltxtv_m{position:relative}.tp-lstv_s{padding:0 20px 0 4px;width:100%}.tp-lstv_m,.tp-coltxtv_mm{bottom:0;margin:auto;pointer-events:none;position:absolute;right:2px;top:0}.tp-lstv_m svg,.tp-coltxtv_mm svg{bottom:0;height:16px;margin:auto;position:absolute;right:0;top:0;width:16px}.tp-lstv_m svg path,.tp-coltxtv_mm svg path{fill:currentColor}.tp-pndtxtv,.tp-coltxtv_w{display:flex}.tp-pndtxtv_a,.tp-coltxtv_c{width:100%}.tp-pndtxtv_a+.tp-pndtxtv_a,.tp-coltxtv_c+.tp-pndtxtv_a,.tp-pndtxtv_a+.tp-coltxtv_c,.tp-coltxtv_c+.tp-coltxtv_c{margin-left:2px}.tp-btnv_b{width:100%}.tp-btnv_t{text-align:center}.tp-ckbv_l{display:block;position:relative}.tp-ckbv_i{left:0;opacity:0;position:absolute;top:0}.tp-ckbv_w{background-color:var(--in-bg);border-radius:var(--elm-br);cursor:pointer;display:block;height:var(--bld-us);position:relative;width:var(--bld-us)}.tp-ckbv_w svg{bottom:0;display:block;height:16px;left:0;margin:auto;opacity:0;position:absolute;right:0;top:0;width:16px}.tp-ckbv_w svg path{fill:none;stroke:var(--in-fg);stroke-width:2}.tp-ckbv_i:hover+.tp-ckbv_w{background-color:var(--in-bg-h)}.tp-ckbv_i:focus+.tp-ckbv_w{background-color:var(--in-bg-f)}.tp-ckbv_i:active+.tp-ckbv_w{background-color:var(--in-bg-a)}.tp-ckbv_i:checked+.tp-ckbv_w svg{opacity:1}.tp-ckbv.tp-v-disabled .tp-ckbv_w{opacity:.5}.tp-colv{position:relative}.tp-colv_h{display:flex}.tp-colv_s{flex-grow:0;flex-shrink:0;width:var(--bld-us)}.tp-colv_t{flex:1;margin-left:4px}.tp-colv_p{height:0;margin-top:0;opacity:0;overflow:hidden;transition:height .2s ease-in-out,opacity .2s linear,margin .2s ease-in-out}.tp-colv.tp-colv-expanded.tp-colv-cpl .tp-colv_p{overflow:visible}.tp-colv.tp-colv-expanded .tp-colv_p{margin-top:var(--bld-s);opacity:1}.tp-colv .tp-popv{left:calc(-1*var(--cnt-h-p));right:calc(-1*var(--cnt-h-p));top:var(--bld-us)}.tp-colpv_h,.tp-colpv_ap{margin-left:6px;margin-right:6px}.tp-colpv_h{margin-top:var(--bld-s)}.tp-colpv_rgb{display:flex;margin-top:var(--bld-s);width:100%}.tp-colpv_a{display:flex;margin-top:var(--cnt-v-p);padding-top:calc(var(--cnt-v-p) + 2px);position:relative}.tp-colpv_a::before{background-color:var(--grv-fg);content:"";height:2px;left:calc(-1*var(--cnt-h-p));position:absolute;right:calc(-1*var(--cnt-h-p));top:0}.tp-colpv.tp-v-disabled .tp-colpv_a::before{opacity:.5}.tp-colpv_ap{align-items:center;display:flex;flex:3}.tp-colpv_at{flex:1;margin-left:4px}.tp-svpv{border-radius:var(--elm-br);outline:none;overflow:hidden;position:relative}.tp-svpv.tp-v-disabled{opacity:.5}.tp-svpv_c{cursor:crosshair;display:block;height:calc(var(--bld-us)*4);width:100%}.tp-svpv_m{border-radius:100%;border:rgba(255,255,255,.75) solid 2px;box-sizing:border-box;filter:drop-shadow(0 0 1px rgba(0, 0, 0, 0.3));height:12px;margin-left:-6px;margin-top:-6px;pointer-events:none;position:absolute;width:12px}.tp-svpv:focus .tp-svpv_m{border-color:#fff}.tp-hplv{cursor:pointer;height:var(--bld-us);outline:none;position:relative}.tp-hplv.tp-v-disabled{opacity:.5}.tp-hplv_c{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAABCAYAAABubagXAAAAQ0lEQVQoU2P8z8Dwn0GCgQEDi2OK/RBgYHjBgIpfovFh8j8YBIgzFGQxuqEgPhaDOT5gOhPkdCxOZeBg+IDFZZiGAgCaSSMYtcRHLgAAAABJRU5ErkJggg==);background-position:left top;background-repeat:no-repeat;background-size:100% 100%;border-radius:2px;display:block;height:4px;left:0;margin-top:-2px;position:absolute;top:50%;width:100%}.tp-hplv_m{border-radius:var(--elm-br);border:rgba(255,255,255,.75) solid 2px;box-shadow:0 0 2px rgba(0,0,0,.1);box-sizing:border-box;height:12px;left:50%;margin-left:-6px;margin-top:-6px;pointer-events:none;position:absolute;top:50%;width:12px}.tp-hplv:focus .tp-hplv_m{border-color:#fff}.tp-aplv{cursor:pointer;height:var(--bld-us);outline:none;position:relative;width:100%}.tp-aplv.tp-v-disabled{opacity:.5}.tp-aplv_b{background-color:#fff;background-image:linear-gradient(to top right, #ddd 25%, transparent 25%, transparent 75%, #ddd 75%),linear-gradient(to top right, #ddd 25%, transparent 25%, transparent 75%, #ddd 75%);background-size:4px 4px;background-position:0 0,2px 2px;border-radius:2px;display:block;height:4px;left:0;margin-top:-2px;overflow:hidden;position:absolute;top:50%;width:100%}.tp-aplv_c{bottom:0;left:0;position:absolute;right:0;top:0}.tp-aplv_m{background-color:#fff;background-image:linear-gradient(to top right, #ddd 25%, transparent 25%, transparent 75%, #ddd 75%),linear-gradient(to top right, #ddd 25%, transparent 25%, transparent 75%, #ddd 75%);background-size:12px 12px;background-position:0 0,6px 6px;border-radius:var(--elm-br);box-shadow:0 0 2px rgba(0,0,0,.1);height:12px;left:50%;margin-left:-6px;margin-top:-6px;overflow:hidden;pointer-events:none;position:absolute;top:50%;width:12px}.tp-aplv_p{border-radius:var(--elm-br);border:rgba(255,255,255,.75) solid 2px;box-sizing:border-box;bottom:0;left:0;position:absolute;right:0;top:0}.tp-aplv:focus .tp-aplv_p{border-color:#fff}.tp-colswv{background-color:#fff;background-image:linear-gradient(to top right, #ddd 25%, transparent 25%, transparent 75%, #ddd 75%),linear-gradient(to top right, #ddd 25%, transparent 25%, transparent 75%, #ddd 75%);background-size:10px 10px;background-position:0 0,5px 5px;border-radius:var(--elm-br);overflow:hidden}.tp-colswv.tp-v-disabled{opacity:.5}.tp-colswv_sw{border-radius:0}.tp-colswv_b{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:rgba(0,0,0,0);border-width:0;cursor:pointer;display:block;height:var(--bld-us);left:0;margin:0;outline:none;padding:0;position:absolute;top:0;width:var(--bld-us)}.tp-colswv_b:focus::after{border:rgba(255,255,255,.75) solid 2px;border-radius:var(--elm-br);bottom:0;content:"";display:block;left:0;position:absolute;right:0;top:0}.tp-coltxtv{display:flex;width:100%}.tp-coltxtv_m{margin-right:4px}.tp-coltxtv_ms{border-radius:var(--elm-br);color:var(--lbl-fg);cursor:pointer;height:var(--bld-us);line-height:var(--bld-us);padding:0 18px 0 4px}.tp-coltxtv_ms:hover{background-color:var(--in-bg-h)}.tp-coltxtv_ms:focus{background-color:var(--in-bg-f)}.tp-coltxtv_ms:active{background-color:var(--in-bg-a)}.tp-coltxtv_mm{color:var(--lbl-fg)}.tp-coltxtv.tp-v-disabled .tp-coltxtv_mm{opacity:.5}.tp-coltxtv_w{flex:1}.tp-dfwv{position:absolute;top:8px;right:8px;width:256px}.tp-fldv{position:relative}.tp-fldv.tp-fldv-not .tp-fldv_b{display:none}.tp-fldv_t{padding-left:4px}.tp-fldv_b:disabled .tp-fldv_m{display:none}.tp-fldv_c{padding-left:4px}.tp-fldv_i{bottom:0;color:var(--cnt-bg);left:0;overflow:hidden;position:absolute;top:calc(var(--bld-us) + 4px);width:var(--bs-br)}.tp-fldv_i::before{background-color:currentColor;bottom:0;content:"";left:0;position:absolute;top:0;width:4px}.tp-fldv_b:hover+.tp-fldv_i{color:var(--cnt-bg-h)}.tp-fldv_b:focus+.tp-fldv_i{color:var(--cnt-bg-f)}.tp-fldv_b:active+.tp-fldv_i{color:var(--cnt-bg-a)}.tp-fldv.tp-v-disabled>.tp-fldv_i{opacity:.5}.tp-grlv{position:relative}.tp-grlv_g{display:block;height:calc(var(--bld-us)*3)}.tp-grlv_g polyline{fill:none;stroke:var(--mo-fg);stroke-linejoin:round}.tp-grlv_t{margin-top:-4px;transition:left .05s,top .05s;visibility:hidden}.tp-grlv_t.tp-grlv_t-a{visibility:visible}.tp-grlv_t.tp-grlv_t-in{transition:none}.tp-grlv.tp-v-disabled .tp-grlv_g{opacity:.5}.tp-grlv .tp-ttv{background-color:var(--mo-fg)}.tp-grlv .tp-ttv::before{border-top-color:var(--mo-fg)}.tp-lblv{align-items:center;display:flex;line-height:1.3;padding-left:var(--cnt-h-p);padding-right:var(--cnt-h-p)}.tp-lblv.tp-lblv-nol{display:block}.tp-lblv_l{color:var(--lbl-fg);flex:1;-webkit-hyphens:auto;hyphens:auto;overflow:hidden;padding-left:4px;padding-right:16px}.tp-lblv.tp-v-disabled .tp-lblv_l{opacity:.5}.tp-lblv.tp-lblv-nol .tp-lblv_l{display:none}.tp-lblv_v{align-self:flex-start;flex-grow:0;flex-shrink:0;width:160px}.tp-lblv.tp-lblv-nol .tp-lblv_v{width:100%}.tp-lstv_s{padding:0 20px 0 4px;width:100%}.tp-lstv_m{color:var(--btn-fg)}.tp-sglv_i{padding:0 4px}.tp-sglv.tp-v-disabled .tp-sglv_i{opacity:.5}.tp-mllv_i{display:block;height:calc(var(--bld-us)*3);line-height:var(--bld-us);padding:0 4px;resize:none;white-space:pre}.tp-mllv.tp-v-disabled .tp-mllv_i{opacity:.5}.tp-p2dv{position:relative}.tp-p2dv_h{display:flex}.tp-p2dv_b{height:var(--bld-us);margin-right:4px;position:relative;width:var(--bld-us)}.tp-p2dv_b svg{display:block;height:16px;left:50%;margin-left:-8px;margin-top:-8px;position:absolute;top:50%;width:16px}.tp-p2dv_b svg path{stroke:currentColor;stroke-width:2}.tp-p2dv_b svg circle{fill:currentColor}.tp-p2dv_t{flex:1}.tp-p2dv_p{height:0;margin-top:0;opacity:0;overflow:hidden;transition:height .2s ease-in-out,opacity .2s linear,margin .2s ease-in-out}.tp-p2dv.tp-p2dv-expanded .tp-p2dv_p{margin-top:var(--bld-s);opacity:1}.tp-p2dv .tp-popv{left:calc(-1*var(--cnt-h-p));right:calc(-1*var(--cnt-h-p));top:var(--bld-us)}.tp-p2dpv{padding-left:calc(var(--bld-us) + 4px)}.tp-p2dpv_p{cursor:crosshair;height:0;overflow:hidden;padding-bottom:100%;position:relative}.tp-p2dpv.tp-v-disabled .tp-p2dpv_p{opacity:.5}.tp-p2dpv_g{display:block;height:100%;left:0;pointer-events:none;position:absolute;top:0;width:100%}.tp-p2dpv_ax{opacity:.1;stroke:var(--in-fg);stroke-dasharray:1}.tp-p2dpv_l{opacity:.5;stroke:var(--in-fg);stroke-dasharray:1}.tp-p2dpv_m{border:var(--in-fg) solid 1px;border-radius:50%;box-sizing:border-box;height:4px;margin-left:-2px;margin-top:-2px;position:absolute;width:4px}.tp-p2dpv_p:focus .tp-p2dpv_m{background-color:var(--in-fg);border-width:0}.tp-popv{background-color:var(--bs-bg);border-radius:6px;box-shadow:0 2px 4px var(--bs-sh);display:none;max-width:168px;padding:var(--cnt-v-p) var(--cnt-h-p);position:absolute;visibility:hidden;z-index:1000}.tp-popv.tp-popv-v{display:block;visibility:visible}.tp-sprv_r{background-color:var(--grv-fg);border-width:0;display:block;height:2px;margin:0;width:100%}.tp-sprv.tp-v-disabled .tp-sprv_r{opacity:.5}.tp-sldv.tp-v-disabled{opacity:.5}.tp-sldv_t{box-sizing:border-box;cursor:pointer;height:var(--bld-us);margin:0 6px;outline:none;position:relative}.tp-sldv_t::before{background-color:var(--in-bg);border-radius:1px;bottom:0;content:"";display:block;height:2px;left:0;margin:auto;position:absolute;right:0;top:0}.tp-sldv_k{height:100%;left:0;position:absolute;top:0}.tp-sldv_k::before{background-color:var(--in-fg);border-radius:1px;bottom:0;content:"";display:block;height:2px;left:0;margin-bottom:auto;margin-top:auto;position:absolute;right:0;top:0}.tp-sldv_k::after{background-color:var(--btn-bg);border-radius:var(--elm-br);bottom:0;content:"";display:block;height:12px;margin-bottom:auto;margin-top:auto;position:absolute;right:-6px;top:0;width:12px}.tp-sldv_t:hover .tp-sldv_k::after{background-color:var(--btn-bg-h)}.tp-sldv_t:focus .tp-sldv_k::after{background-color:var(--btn-bg-f)}.tp-sldv_t:active .tp-sldv_k::after{background-color:var(--btn-bg-a)}.tp-sldtxtv{display:flex}.tp-sldtxtv_s{flex:2}.tp-sldtxtv_t{flex:1;margin-left:4px}.tp-tabv{position:relative}.tp-tabv_t{align-items:flex-end;color:var(--cnt-bg);display:flex;overflow:hidden;position:relative}.tp-tabv_t:hover{color:var(--cnt-bg-h)}.tp-tabv_t:has(*:focus){color:var(--cnt-bg-f)}.tp-tabv_t:has(*:active){color:var(--cnt-bg-a)}.tp-tabv_t::before{background-color:currentColor;bottom:0;content:"";height:2px;left:0;pointer-events:none;position:absolute;right:0}.tp-tabv.tp-v-disabled .tp-tabv_t::before{opacity:.5}.tp-tabv.tp-tabv-nop .tp-tabv_t{height:calc(var(--bld-us) + 4px);position:relative}.tp-tabv.tp-tabv-nop .tp-tabv_t::before{background-color:var(--cnt-bg);bottom:0;content:"";height:2px;left:0;position:absolute;right:0}.tp-tabv_c{padding-bottom:var(--cnt-v-p);padding-left:4px;padding-top:var(--cnt-v-p)}.tp-tabv_i{bottom:0;color:var(--cnt-bg);left:0;overflow:hidden;position:absolute;top:calc(var(--bld-us) + 4px);width:var(--bs-br)}.tp-tabv_i::before{background-color:currentColor;bottom:0;content:"";left:0;position:absolute;top:0;width:4px}.tp-tabv_t:hover+.tp-tabv_i{color:var(--cnt-bg-h)}.tp-tabv_t:has(*:focus)+.tp-tabv_i{color:var(--cnt-bg-f)}.tp-tabv_t:has(*:active)+.tp-tabv_i{color:var(--cnt-bg-a)}.tp-tabv.tp-v-disabled>.tp-tabv_i{opacity:.5}.tp-tbiv{flex:1;min-width:0;position:relative}.tp-tbiv+.tp-tbiv{margin-left:2px}.tp-tbiv+.tp-tbiv.tp-v-disabled::before{opacity:.5}.tp-tbiv_b{display:block;padding-left:calc(var(--cnt-h-p) + 4px);padding-right:calc(var(--cnt-h-p) + 4px);position:relative;width:100%}.tp-tbiv_b:disabled{opacity:.5}.tp-tbiv_b::before{background-color:var(--cnt-bg);bottom:2px;content:"";left:0;pointer-events:none;position:absolute;right:0;top:0}.tp-tbiv_b:hover::before{background-color:var(--cnt-bg-h)}.tp-tbiv_b:focus::before{background-color:var(--cnt-bg-f)}.tp-tbiv_b:active::before{background-color:var(--cnt-bg-a)}.tp-tbiv_t{color:var(--cnt-fg);height:calc(var(--bld-us) + 4px);line-height:calc(var(--bld-us) + 4px);opacity:.5;overflow:hidden;text-overflow:ellipsis}.tp-tbiv.tp-tbiv-sel .tp-tbiv_t{opacity:1}.tp-txtv{position:relative}.tp-txtv_i{padding:0 4px}.tp-txtv.tp-txtv-fst .tp-txtv_i{border-bottom-right-radius:0;border-top-right-radius:0}.tp-txtv.tp-txtv-mid .tp-txtv_i{border-radius:0}.tp-txtv.tp-txtv-lst .tp-txtv_i{border-bottom-left-radius:0;border-top-left-radius:0}.tp-txtv.tp-txtv-num .tp-txtv_i{text-align:right}.tp-txtv.tp-txtv-drg .tp-txtv_i{opacity:.3}.tp-txtv_k{cursor:pointer;height:100%;left:-3px;position:absolute;top:0;width:12px}.tp-txtv_k::before{background-color:var(--in-fg);border-radius:1px;bottom:0;content:"";height:calc(var(--bld-us) - 4px);left:50%;margin-bottom:auto;margin-left:-1px;margin-top:auto;opacity:.1;position:absolute;top:0;transition:border-radius .1s,height .1s,transform .1s,width .1s;width:2px}.tp-txtv_k:hover::before,.tp-txtv.tp-txtv-drg .tp-txtv_k::before{opacity:1}.tp-txtv.tp-txtv-drg .tp-txtv_k::before{border-radius:50%;height:4px;transform:translateX(-1px);width:4px}.tp-txtv_g{bottom:0;display:block;height:8px;left:50%;margin:auto;overflow:visible;pointer-events:none;position:absolute;top:0;visibility:hidden;width:100%}.tp-txtv.tp-txtv-drg .tp-txtv_g{visibility:visible}.tp-txtv_gb{fill:none;stroke:var(--in-fg);stroke-dasharray:1}.tp-txtv_gh{fill:none;stroke:var(--in-fg)}.tp-txtv .tp-ttv{margin-left:6px;visibility:hidden}.tp-txtv.tp-txtv-drg .tp-ttv{visibility:visible}.tp-ttv{background-color:var(--in-fg);border-radius:var(--elm-br);color:var(--bs-bg);padding:2px 4px;pointer-events:none;position:absolute;transform:translate(-50%, -100%)}.tp-ttv::before{border-color:var(--in-fg) rgba(0,0,0,0) rgba(0,0,0,0) rgba(0,0,0,0);border-style:solid;border-width:2px;box-sizing:border-box;content:"";font-size:.9em;height:4px;left:50%;margin-left:-2px;position:absolute;top:100%;width:4px}.tp-rotv{background-color:var(--bs-bg);border-radius:var(--bs-br);box-shadow:0 2px 4px var(--bs-sh);font-family:var(--font-family);font-size:11px;font-weight:500;line-height:1;text-align:left}.tp-rotv_b{border-bottom-left-radius:var(--bs-br);border-bottom-right-radius:var(--bs-br);border-top-left-radius:var(--bs-br);border-top-right-radius:var(--bs-br);padding-left:calc(4px + var(--bld-us) + var(--cnt-h-p));text-align:center}.tp-rotv.tp-rotv-expanded .tp-rotv_b{border-bottom-left-radius:0;border-bottom-right-radius:0}.tp-rotv.tp-rotv-not .tp-rotv_b{display:none}.tp-rotv_b:disabled .tp-rotv_m{display:none}.tp-rotv_c>.tp-fldv.tp-v-lst>.tp-fldv_c{border-bottom-left-radius:var(--bs-br);border-bottom-right-radius:var(--bs-br)}.tp-rotv_c>.tp-fldv.tp-v-lst>.tp-fldv_i{border-bottom-left-radius:var(--bs-br)}.tp-rotv_c>.tp-fldv.tp-v-lst:not(.tp-fldv-expanded)>.tp-fldv_b{border-bottom-left-radius:var(--bs-br);border-bottom-right-radius:var(--bs-br)}.tp-rotv_c .tp-fldv.tp-v-vlst:not(.tp-fldv-expanded)>.tp-fldv_b{border-bottom-right-radius:var(--bs-br)}.tp-rotv.tp-rotv-not .tp-rotv_c>.tp-fldv.tp-v-fst{margin-top:calc(-1*var(--cnt-v-p))}.tp-rotv.tp-rotv-not .tp-rotv_c>.tp-fldv.tp-v-fst>.tp-fldv_b{border-top-left-radius:var(--bs-br);border-top-right-radius:var(--bs-br)}.tp-rotv_c>.tp-tabv.tp-v-lst>.tp-tabv_c{border-bottom-left-radius:var(--bs-br);border-bottom-right-radius:var(--bs-br)}.tp-rotv_c>.tp-tabv.tp-v-lst>.tp-tabv_i{border-bottom-left-radius:var(--bs-br)}.tp-rotv.tp-rotv-not .tp-rotv_c>.tp-tabv.tp-v-fst{margin-top:calc(-1*var(--cnt-v-p))}.tp-rotv.tp-rotv-not .tp-rotv_c>.tp-tabv.tp-v-fst>.tp-tabv_t{border-top-left-radius:var(--bs-br);border-top-right-radius:var(--bs-br)}.tp-rotv.tp-v-disabled,.tp-rotv .tp-v-disabled{pointer-events:none}.tp-rotv.tp-v-hidden,.tp-rotv .tp-v-hidden{display:none}');
                    this.pool_.getAll().forEach(function(plugin) {
                        _this.embedPluginStyle_(plugin);
                    });
                    this.registerPlugin({
                        plugins: [
                            SliderBladePlugin,
                            ListBladePlugin,
                            TabBladePlugin,
                            TextBladePlugin
                        ]
                    });
                }
            }
        ]);
        return Pane;
    }(RootApi);
    var VERSION = new Semver('3.1.10');
    exports1.BladeApi = BladeApi;
    exports1.ButtonApi = ButtonApi;
    exports1.FolderApi = FolderApi;
    exports1.InputBindingApi = InputBindingApi;
    exports1.ListApi = ListApi;
    exports1.MonitorBindingApi = MonitorBindingApi;
    exports1.Pane = Pane;
    exports1.SeparatorApi = SeparatorApi;
    exports1.SliderApi = SliderApi;
    exports1.TabApi = TabApi;
    exports1.TabPageApi = TabPageApi;
    exports1.TextApi = TextApi;
    exports1.TpChangeEvent = TpChangeEvent;
    exports1.VERSION = VERSION;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});















/**
 * Main content for the worker that handles the loading and execution of
 * modules within it.
 */ 
var $9bddb17358f9b914$exports = {};
// shim for using process in browser
var $9bddb17358f9b914$var$process = $9bddb17358f9b914$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $9bddb17358f9b914$var$cachedSetTimeout;
var $9bddb17358f9b914$var$cachedClearTimeout;
function $9bddb17358f9b914$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $9bddb17358f9b914$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $9bddb17358f9b914$var$cachedSetTimeout = setTimeout;
        else $9bddb17358f9b914$var$cachedSetTimeout = $9bddb17358f9b914$var$defaultSetTimout;
    } catch (e) {
        $9bddb17358f9b914$var$cachedSetTimeout = $9bddb17358f9b914$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $9bddb17358f9b914$var$cachedClearTimeout = clearTimeout;
        else $9bddb17358f9b914$var$cachedClearTimeout = $9bddb17358f9b914$var$defaultClearTimeout;
    } catch (e) {
        $9bddb17358f9b914$var$cachedClearTimeout = $9bddb17358f9b914$var$defaultClearTimeout;
    }
})();
function $9bddb17358f9b914$var$runTimeout(fun) {
    if ($9bddb17358f9b914$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($9bddb17358f9b914$var$cachedSetTimeout === $9bddb17358f9b914$var$defaultSetTimout || !$9bddb17358f9b914$var$cachedSetTimeout) && setTimeout) {
        $9bddb17358f9b914$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $9bddb17358f9b914$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $9bddb17358f9b914$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $9bddb17358f9b914$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $9bddb17358f9b914$var$runClearTimeout(marker) {
    if ($9bddb17358f9b914$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($9bddb17358f9b914$var$cachedClearTimeout === $9bddb17358f9b914$var$defaultClearTimeout || !$9bddb17358f9b914$var$cachedClearTimeout) && clearTimeout) {
        $9bddb17358f9b914$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $9bddb17358f9b914$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $9bddb17358f9b914$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $9bddb17358f9b914$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $9bddb17358f9b914$var$queue = [];
var $9bddb17358f9b914$var$draining = false;
var $9bddb17358f9b914$var$currentQueue;
var $9bddb17358f9b914$var$queueIndex = -1;
function $9bddb17358f9b914$var$cleanUpNextTick() {
    if (!$9bddb17358f9b914$var$draining || !$9bddb17358f9b914$var$currentQueue) return;
    $9bddb17358f9b914$var$draining = false;
    if ($9bddb17358f9b914$var$currentQueue.length) $9bddb17358f9b914$var$queue = $9bddb17358f9b914$var$currentQueue.concat($9bddb17358f9b914$var$queue);
    else $9bddb17358f9b914$var$queueIndex = -1;
    if ($9bddb17358f9b914$var$queue.length) $9bddb17358f9b914$var$drainQueue();
}
function $9bddb17358f9b914$var$drainQueue() {
    if ($9bddb17358f9b914$var$draining) return;
    var timeout = $9bddb17358f9b914$var$runTimeout($9bddb17358f9b914$var$cleanUpNextTick);
    $9bddb17358f9b914$var$draining = true;
    var len = $9bddb17358f9b914$var$queue.length;
    while(len){
        $9bddb17358f9b914$var$currentQueue = $9bddb17358f9b914$var$queue;
        $9bddb17358f9b914$var$queue = [];
        while(++$9bddb17358f9b914$var$queueIndex < len)if ($9bddb17358f9b914$var$currentQueue) $9bddb17358f9b914$var$currentQueue[$9bddb17358f9b914$var$queueIndex].run();
        $9bddb17358f9b914$var$queueIndex = -1;
        len = $9bddb17358f9b914$var$queue.length;
    }
    $9bddb17358f9b914$var$currentQueue = null;
    $9bddb17358f9b914$var$draining = false;
    $9bddb17358f9b914$var$runClearTimeout(timeout);
}
$9bddb17358f9b914$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $9bddb17358f9b914$var$queue.push(new $9bddb17358f9b914$var$Item(fun, args));
    if ($9bddb17358f9b914$var$queue.length === 1 && !$9bddb17358f9b914$var$draining) $9bddb17358f9b914$var$runTimeout($9bddb17358f9b914$var$drainQueue);
};
// v8 likes predictible objects
function $9bddb17358f9b914$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$9bddb17358f9b914$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$9bddb17358f9b914$var$process.title = 'browser';
$9bddb17358f9b914$var$process.browser = true;
$9bddb17358f9b914$var$process.env = {};
$9bddb17358f9b914$var$process.argv = [];
$9bddb17358f9b914$var$process.version = ''; // empty string to avoid regexp issues
$9bddb17358f9b914$var$process.versions = {};
function $9bddb17358f9b914$var$noop() {}
$9bddb17358f9b914$var$process.on = $9bddb17358f9b914$var$noop;
$9bddb17358f9b914$var$process.addListener = $9bddb17358f9b914$var$noop;
$9bddb17358f9b914$var$process.once = $9bddb17358f9b914$var$noop;
$9bddb17358f9b914$var$process.off = $9bddb17358f9b914$var$noop;
$9bddb17358f9b914$var$process.removeListener = $9bddb17358f9b914$var$noop;
$9bddb17358f9b914$var$process.removeAllListeners = $9bddb17358f9b914$var$noop;
$9bddb17358f9b914$var$process.emit = $9bddb17358f9b914$var$noop;
$9bddb17358f9b914$var$process.prependListener = $9bddb17358f9b914$var$noop;
$9bddb17358f9b914$var$process.prependOnceListener = $9bddb17358f9b914$var$noop;
$9bddb17358f9b914$var$process.listeners = function(name) {
    return [];
};
$9bddb17358f9b914$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$9bddb17358f9b914$var$process.cwd = function() {
    return '/';
};
$9bddb17358f9b914$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$9bddb17358f9b914$var$process.umask = function() {
    return 0;
};


function $7d2465470e3fafe3$var$workerBootstrap() {
    var modules = Object.create(null);
    // Handle messages for registering a module
    function registerModule(ref, callback) {
        var id = ref.id;
        var name = ref.name;
        var dependencies = ref.dependencies;
        if (dependencies === void 0) dependencies = [];
        var init = ref.init;
        if (init === void 0) init = function init() {};
        var getTransferables = ref.getTransferables;
        if (getTransferables === void 0) getTransferables = null;
        // Only register once
        if (modules[id]) return;
        try {
            // If any dependencies are modules, ensure they're registered and grab their value
            dependencies = dependencies.map(function(dep) {
                if (dep && dep.isWorkerModule) {
                    registerModule(dep, function(depResult) {
                        if (depResult instanceof Error) throw depResult;
                    });
                    dep = modules[dep.id].value;
                }
                return dep;
            });
            // Rehydrate functions
            init = rehydrate("<" + name + ">.init", init);
            if (getTransferables) getTransferables = rehydrate("<" + name + ">.getTransferables", getTransferables);
            // Initialize the module and store its value
            var value = null;
            if (typeof init === 'function') value = init.apply(void 0, dependencies);
            else console.error('worker module init function failed to rehydrate');
            modules[id] = {
                id: id,
                value: value,
                getTransferables: getTransferables
            };
            callback(value);
        } catch (err) {
            if (!(err && err.noLog)) console.error(err);
            callback(err);
        }
    }
    // Handle messages for calling a registered module's result function
    function callModule(ref, callback) {
        var ref$1;
        var id = ref.id;
        var args = ref.args;
        if (!modules[id] || typeof modules[id].value !== 'function') callback(new Error("Worker module " + id + ": not found or its 'init' did not return a function"));
        try {
            var result = (ref$1 = modules[id]).value.apply(ref$1, args);
            if (result && typeof result.then === 'function') result.then(handleResult, function(rej) {
                return callback(rej instanceof Error ? rej : new Error('' + rej));
            });
            else handleResult(result);
        } catch (err) {
            callback(err);
        }
        function handleResult(result) {
            try {
                var tx = modules[id].getTransferables && modules[id].getTransferables(result);
                if (!tx || !Array.isArray(tx) || !tx.length) tx = undefined; //postMessage is very picky about not passing null or empty transferables
                callback(result, tx);
            } catch (err) {
                console.error(err);
                callback(err);
            }
        }
    }
    function rehydrate(name, str) {
        var result = void 0;
        self.troikaDefine = function(r) {
            return result = r;
        };
        var url = URL.createObjectURL(new Blob([
            "/** " + name.replace(/\*/g, '') + " **/\n\ntroikaDefine(\n" + str + "\n)"
        ], {
            type: 'application/javascript'
        }));
        try {
            importScripts(url);
        } catch (err) {
            console.error(err);
        }
        URL.revokeObjectURL(url);
        delete self.troikaDefine;
        return result;
    }
    // Handler for all messages within the worker
    self.addEventListener('message', function(e) {
        var ref = e.data;
        var messageId = ref.messageId;
        var action = ref.action;
        var data = ref.data;
        try {
            // Module registration
            if (action === 'registerModule') registerModule(data, function(result) {
                if (result instanceof Error) postMessage({
                    messageId: messageId,
                    success: false,
                    error: result.message
                });
                else postMessage({
                    messageId: messageId,
                    success: true,
                    result: {
                        isCallable: typeof result === 'function'
                    }
                });
            });
            // Invocation
            if (action === 'callModule') callModule(data, function(result, transferables) {
                if (result instanceof Error) postMessage({
                    messageId: messageId,
                    success: false,
                    error: result.message
                });
                else postMessage({
                    messageId: messageId,
                    success: true,
                    result: result
                }, transferables || undefined);
            });
        } catch (err) {
            postMessage({
                messageId: messageId,
                success: false,
                error: err.stack
            });
        }
    });
}
/**
 * Fallback for `defineWorkerModule` that behaves identically but runs in the main
 * thread, for when the execution environment doesn't support web workers or they
 * are disallowed due to e.g. CSP security restrictions.
 */ function $7d2465470e3fafe3$var$defineMainThreadModule(options) {
    var moduleFunc = function moduleFunc1() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return moduleFunc._getInitResult().then(function(initResult) {
            if (typeof initResult === 'function') return initResult.apply(void 0, args);
            else throw new Error('Worker module function was called but `init` did not return a callable function');
        });
    };
    moduleFunc._getInitResult = function() {
        // We can ignore getTransferables in main thread. TODO workerId?
        var dependencies = options.dependencies;
        var init = options.init;
        // Resolve dependencies
        dependencies = Array.isArray(dependencies) ? dependencies.map(function(dep) {
            return dep && dep._getInitResult ? dep._getInitResult() : dep;
        }) : [];
        // Invoke init with the resolved dependencies
        var initPromise = Promise.all(dependencies).then(function(deps) {
            return init.apply(null, deps);
        });
        // Cache the resolved promise for subsequent calls
        moduleFunc._getInitResult = function() {
            return initPromise;
        };
        return initPromise;
    };
    return moduleFunc;
}
var $7d2465470e3fafe3$var$supportsWorkers = function supportsWorkers1() {
    var supported = false;
    // Only attempt worker initialization in browsers; elsewhere it would just be
    // noise e.g. loading into a Node environment for SSR.
    if (typeof window !== 'undefined' && typeof window.document !== 'undefined') try {
        // TODO additional checks for things like importScripts within the worker?
        //  Would need to be an async check.
        var worker = new Worker(URL.createObjectURL(new Blob([
            ''
        ], {
            type: 'application/javascript'
        })));
        worker.terminate();
        supported = true;
    } catch (err) {
        typeof $9bddb17358f9b914$exports === "undefined" ? "undefined" : (0, $86d22bcb52172ef7$export$71511d61b312f219)($9bddb17358f9b914$exports);
        console.log("Troika createWorkerModule: web workers not allowed; falling back to main thread execution. Cause: [" + err.message + "]");
    }
    // Cached result
    $7d2465470e3fafe3$var$supportsWorkers = function supportsWorkers() {
        return supported;
    };
    return supported;
};
var $7d2465470e3fafe3$var$_workerModuleId = 0;
var $7d2465470e3fafe3$var$_messageId = 0;
var $7d2465470e3fafe3$var$_allowInitAsString = false;
var $7d2465470e3fafe3$var$workers = Object.create(null);
var $7d2465470e3fafe3$var$registeredModules = Object.create(null); //workerId -> Set<unregisterFn>
var $7d2465470e3fafe3$var$openRequests = Object.create(null);
/**
 * Define a module of code that will be executed with a web worker. This provides a simple
 * interface for moving chunks of logic off the main thread, and managing their dependencies
 * among one another.
 *
 * @param {object} options
 * @param {function} options.init
 * @param {array} [options.dependencies]
 * @param {function} [options.getTransferables]
 * @param {string} [options.name]
 * @param {string} [options.workerId]
 * @return {function(...[*]): {then}}
 */ function $7d2465470e3fafe3$export$e2063b0a5e3f6023(options) {
    if ((!options || typeof options.init !== 'function') && !$7d2465470e3fafe3$var$_allowInitAsString) throw new Error('requires `options.init` function');
    var dependencies = options.dependencies;
    var init = options.init;
    var getTransferables = options.getTransferables;
    var workerId = options.workerId;
    if (!$7d2465470e3fafe3$var$supportsWorkers()) return $7d2465470e3fafe3$var$defineMainThreadModule(options);
    if (workerId == null) workerId = '#default';
    var id = "workerModule" + ++$7d2465470e3fafe3$var$_workerModuleId;
    var name = options.name || id;
    var registrationPromise = null;
    dependencies = dependencies && dependencies.map(function(dep) {
        // Wrap raw functions as worker modules with no dependencies
        if (typeof dep === 'function' && !dep.workerModuleData) {
            $7d2465470e3fafe3$var$_allowInitAsString = true;
            dep = $7d2465470e3fafe3$export$e2063b0a5e3f6023({
                workerId: workerId,
                name: "<" + name + "> function dependency: " + dep.name,
                init: "function(){return (\n" + $7d2465470e3fafe3$export$d62b0b738687b4b2(dep) + "\n)}"
            });
            $7d2465470e3fafe3$var$_allowInitAsString = false;
        }
        // Grab postable data for worker modules
        if (dep && dep.workerModuleData) dep = dep.workerModuleData;
        return dep;
    });
    function moduleFunc() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        // Register this module if needed
        if (!registrationPromise) {
            registrationPromise = $7d2465470e3fafe3$var$callWorker(workerId, 'registerModule', moduleFunc.workerModuleData);
            var unregister = function unregister1() {
                registrationPromise = null;
                $7d2465470e3fafe3$var$registeredModules[workerId].delete(unregister);
            };
            ($7d2465470e3fafe3$var$registeredModules[workerId] || ($7d2465470e3fafe3$var$registeredModules[workerId] = new Set())).add(unregister);
        }
        // Invoke the module, returning a promise
        return registrationPromise.then(function(ref) {
            var isCallable = ref.isCallable;
            if (isCallable) return $7d2465470e3fafe3$var$callWorker(workerId, 'callModule', {
                id: id,
                args: args
            });
            else throw new Error('Worker module function was called but `init` did not return a callable function');
        });
    }
    moduleFunc.workerModuleData = {
        isWorkerModule: true,
        id: id,
        name: name,
        dependencies: dependencies,
        init: $7d2465470e3fafe3$export$d62b0b738687b4b2(init),
        getTransferables: getTransferables && $7d2465470e3fafe3$export$d62b0b738687b4b2(getTransferables)
    };
    return moduleFunc;
}
/**
 * Terminate an active Worker by a workerId that was passed to defineWorkerModule.
 * This only terminates the Worker itself; the worker module will remain available
 * and if you call it again its Worker will be respawned.
 * @param {string} workerId
 */ function $7d2465470e3fafe3$export$a61a973ac243a75e(workerId) {
    // Unregister all modules that were registered in that worker
    if ($7d2465470e3fafe3$var$registeredModules[workerId]) $7d2465470e3fafe3$var$registeredModules[workerId].forEach(function(unregister) {
        unregister();
    });
    // Terminate the Worker object
    if ($7d2465470e3fafe3$var$workers[workerId]) {
        $7d2465470e3fafe3$var$workers[workerId].terminate();
        delete $7d2465470e3fafe3$var$workers[workerId];
    }
}
/**
 * Stringifies a function into a form that can be deserialized in the worker
 * @param fn
 */ function $7d2465470e3fafe3$export$d62b0b738687b4b2(fn) {
    var str = fn.toString();
    // If it was defined in object method/property format, it needs to be modified
    if (!/^function/.test(str) && /^\w+\s*\(/.test(str)) str = 'function ' + str;
    return str;
}
function $7d2465470e3fafe3$var$getWorker(workerId) {
    var worker = $7d2465470e3fafe3$var$workers[workerId];
    if (!worker) {
        // Bootstrap the worker's content
        var bootstrap = $7d2465470e3fafe3$export$d62b0b738687b4b2($7d2465470e3fafe3$var$workerBootstrap);
        // Create the worker from the bootstrap function content
        worker = $7d2465470e3fafe3$var$workers[workerId] = new Worker(URL.createObjectURL(new Blob([
            "/** Worker Module Bootstrap: " + workerId.replace(/\*/g, '') + " **/\n\n;(" + bootstrap + ")()"
        ], {
            type: 'application/javascript'
        })));
        // Single handler for response messages from the worker
        worker.onmessage = function(e) {
            var response = e.data;
            var msgId = response.messageId;
            var callback = $7d2465470e3fafe3$var$openRequests[msgId];
            if (!callback) throw new Error('WorkerModule response with empty or unknown messageId');
            delete $7d2465470e3fafe3$var$openRequests[msgId];
            callback(response);
        };
    }
    return worker;
}
// Issue a call to the worker with a callback to handle the response
function $7d2465470e3fafe3$var$callWorker(workerId, action, data) {
    return new Promise(function(resolve, reject) {
        var messageId = ++$7d2465470e3fafe3$var$_messageId;
        $7d2465470e3fafe3$var$openRequests[messageId] = function(response) {
            if (response.success) resolve(response.result);
            else reject(new Error("Error in worker " + action + " call: " + response.error));
        };
        $7d2465470e3fafe3$var$getWorker(workerId).postMessage({
            messageId: messageId,
            action: action,
            data: data
        });
    });
}


function $cdfb19fee16f58da$export$2e2bcd8739ae039() {
    var exports = function(exports) {
        /**
   * Find the point on a quadratic bezier curve at t where t is in the range [0, 1]
   */ function pointOnQuadraticBezier(x0, y0, x1, y1, x2, y2, t, pointOut) {
            var t2 = 1 - t;
            pointOut.x = t2 * t2 * x0 + 2 * t2 * t * x1 + t * t * x2;
            pointOut.y = t2 * t2 * y0 + 2 * t2 * t * y1 + t * t * y2;
        }
        /**
   * Find the point on a cubic bezier curve at t where t is in the range [0, 1]
   */ function pointOnCubicBezier(x0, y0, x1, y1, x2, y2, x3, y3, t, pointOut) {
            var t2 = 1 - t;
            pointOut.x = t2 * t2 * t2 * x0 + 3 * t2 * t2 * t * x1 + 3 * t2 * t * t * x2 + t * t * t * x3;
            pointOut.y = t2 * t2 * t2 * y0 + 3 * t2 * t2 * t * y1 + 3 * t2 * t * t * y2 + t * t * t * y3;
        }
        /**
   * Parse a path string into its constituent line/curve commands, invoking a callback for each.
   * @param {string} pathString - An SVG-like path string to parse; should only contain commands: M/L/Q/C/Z
   * @param {function(
   *   command: 'L'|'Q'|'C',
   *   startX: number,
   *   startY: number,
   *   endX: number,
   *   endY: number,
   *   ctrl1X?: number,
   *   ctrl1Y?: number,
   *   ctrl2X?: number,
   *   ctrl2Y?: number
   * )} commandCallback - A callback function that will be called once for each parsed path command, passing the
   *                      command identifier (only L/Q/C commands) and its numeric arguments.
   */ function forEachPathCommand(pathString, commandCallback) {
            var segmentRE = /([MLQCZ])([^MLQCZ]*)/g;
            var match, firstX, firstY, prevX, prevY;
            while(match = segmentRE.exec(pathString)){
                var args = match[2].replace(/^\s*|\s*$/g, '').split(/[,\s]+/).map(function(v) {
                    return parseFloat(v);
                });
                switch(match[1]){
                    case 'M':
                        prevX = firstX = args[0];
                        prevY = firstY = args[1];
                        break;
                    case 'L':
                        if (args[0] !== prevX || args[1] !== prevY) commandCallback('L', prevX, prevY, prevX = args[0], prevY = args[1]);
                        break;
                    case 'Q':
                        commandCallback('Q', prevX, prevY, prevX = args[2], prevY = args[3], args[0], args[1]);
                        break;
                    case 'C':
                        commandCallback('C', prevX, prevY, prevX = args[4], prevY = args[5], args[0], args[1], args[2], args[3]);
                        break;
                    case 'Z':
                        if (prevX !== firstX || prevY !== firstY) commandCallback('L', prevX, prevY, firstX, firstY);
                        break;
                }
            }
        }
        /**
   * Convert a path string to a series of straight line segments
   * @param {string} pathString - An SVG-like path string to parse; should only contain commands: M/L/Q/C/Z
   * @param {function(x1:number, y1:number, x2:number, y2:number)} segmentCallback - A callback
   *        function that will be called once for every line segment
   * @param {number} [curvePoints] - How many straight line segments to use when approximating a
   *        bezier curve in the path. Defaults to 16.
   */ function pathToLineSegments(pathString, segmentCallback, curvePoints) {
            if (curvePoints === void 0) curvePoints = 16;
            var tempPoint = {
                x: 0,
                y: 0
            };
            forEachPathCommand(pathString, function(command, startX, startY, endX, endY, ctrl1X, ctrl1Y, ctrl2X, ctrl2Y) {
                switch(command){
                    case 'L':
                        segmentCallback(startX, startY, endX, endY);
                        break;
                    case 'Q':
                        var prevCurveX = startX;
                        var prevCurveY = startY;
                        for(var i = 1; i < curvePoints; i++){
                            pointOnQuadraticBezier(startX, startY, ctrl1X, ctrl1Y, endX, endY, i / (curvePoints - 1), tempPoint);
                            segmentCallback(prevCurveX, prevCurveY, tempPoint.x, tempPoint.y);
                            prevCurveX = tempPoint.x;
                            prevCurveY = tempPoint.y;
                        }
                        break;
                    case 'C':
                        var prevCurveX$1 = startX;
                        var prevCurveY$1 = startY;
                        for(var i$1 = 1; i$1 < curvePoints; i$1++){
                            pointOnCubicBezier(startX, startY, ctrl1X, ctrl1Y, ctrl2X, ctrl2Y, endX, endY, i$1 / (curvePoints - 1), tempPoint);
                            segmentCallback(prevCurveX$1, prevCurveY$1, tempPoint.x, tempPoint.y);
                            prevCurveX$1 = tempPoint.x;
                            prevCurveY$1 = tempPoint.y;
                        }
                        break;
                }
            });
        }
        var viewportQuadVertex = "precision highp float;attribute vec2 aUV;varying vec2 vUV;void main(){vUV=aUV;gl_Position=vec4(mix(vec2(-1.0),vec2(1.0),aUV),0.0,1.0);}";
        var copyTexFragment = "precision highp float;uniform sampler2D tex;varying vec2 vUV;void main(){gl_FragColor=texture2D(tex,vUV);}";
        var cache = new WeakMap();
        var glContextParams = {
            premultipliedAlpha: false,
            preserveDrawingBuffer: true,
            antialias: false,
            depth: false
        };
        /**
   * This is a little helper library for WebGL. It assists with state management for a GL context.
   * It's pretty tightly wrapped to the needs of this package, not very general-purpose.
   *
   * @param { WebGLRenderingContext | HTMLCanvasElement | OffscreenCanvas } glOrCanvas - the GL context to wrap
   * @param { ({gl, getExtension, withProgram, withTexture, withTextureFramebuffer, handleContextLoss}) => void } callback
   */ function withWebGLContext(glOrCanvas, callback) {
            var gl = glOrCanvas.getContext ? glOrCanvas.getContext('webgl', glContextParams) : glOrCanvas;
            var wrapper = cache.get(gl);
            if (!wrapper) {
                var isWebGL2 = typeof WebGL2RenderingContext !== 'undefined' && gl instanceof WebGL2RenderingContext;
                var extensions = {};
                var programs = {};
                var textures = {};
                var textureUnit = -1;
                var framebufferStack = [];
                gl.canvas.addEventListener('webglcontextlost', function(e) {
                    handleContextLoss();
                    e.preventDefault();
                }, false);
                function getExtension(name) {
                    var ext = extensions[name];
                    if (!ext) {
                        ext = extensions[name] = gl.getExtension(name);
                        if (!ext) throw new Error(name + " not supported");
                    }
                    return ext;
                }
                function compileShader(src, type) {
                    var shader = gl.createShader(type);
                    gl.shaderSource(shader, src);
                    gl.compileShader(shader);
                    // const status = gl.getShaderParameter(shader, gl.COMPILE_STATUS)
                    // if (!status && !gl.isContextLost()) {
                    //   throw new Error(gl.getShaderInfoLog(shader).trim())
                    // }
                    return shader;
                }
                function withProgram(name, vert, frag, func) {
                    if (!programs[name]) {
                        var attributes = {};
                        var uniforms = {};
                        var program = gl.createProgram();
                        gl.attachShader(program, compileShader(vert, gl.VERTEX_SHADER));
                        gl.attachShader(program, compileShader(frag, gl.FRAGMENT_SHADER));
                        gl.linkProgram(program);
                        programs[name] = {
                            program: program,
                            transaction: function transaction(func) {
                                gl.useProgram(program);
                                func({
                                    setUniform: function setUniform(type, name) {
                                        var values = [], len = arguments.length - 2;
                                        while(len-- > 0)values[len] = arguments[len + 2];
                                        var uniformLoc = uniforms[name] || (uniforms[name] = gl.getUniformLocation(program, name));
                                        gl["uniform" + type].apply(gl, [
                                            uniformLoc
                                        ].concat(values));
                                    },
                                    setAttribute: function setAttribute(name, size, usage, instancingDivisor, data) {
                                        var attr = attributes[name];
                                        if (!attr) attr = attributes[name] = {
                                            buf: gl.createBuffer(),
                                            loc: gl.getAttribLocation(program, name),
                                            data: null
                                        };
                                        gl.bindBuffer(gl.ARRAY_BUFFER, attr.buf);
                                        gl.vertexAttribPointer(attr.loc, size, gl.FLOAT, false, 0, 0);
                                        gl.enableVertexAttribArray(attr.loc);
                                        if (isWebGL2) gl.vertexAttribDivisor(attr.loc, instancingDivisor);
                                        else getExtension('ANGLE_instanced_arrays').vertexAttribDivisorANGLE(attr.loc, instancingDivisor);
                                        if (data !== attr.data) {
                                            gl.bufferData(gl.ARRAY_BUFFER, data, usage);
                                            attr.data = data;
                                        }
                                    }
                                });
                            }
                        };
                    }
                    programs[name].transaction(func);
                }
                function withTexture(name, func) {
                    textureUnit++;
                    try {
                        gl.activeTexture(gl.TEXTURE0 + textureUnit);
                        var texture = textures[name];
                        if (!texture) {
                            texture = textures[name] = gl.createTexture();
                            gl.bindTexture(gl.TEXTURE_2D, texture);
                            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
                            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
                        }
                        gl.bindTexture(gl.TEXTURE_2D, texture);
                        func(texture, textureUnit);
                    } finally{
                        textureUnit--;
                    }
                }
                function withTextureFramebuffer(texture, textureUnit, func) {
                    var framebuffer = gl.createFramebuffer();
                    framebufferStack.push(framebuffer);
                    gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
                    gl.activeTexture(gl.TEXTURE0 + textureUnit);
                    gl.bindTexture(gl.TEXTURE_2D, texture);
                    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);
                    try {
                        func(framebuffer);
                    } finally{
                        gl.deleteFramebuffer(framebuffer);
                        gl.bindFramebuffer(gl.FRAMEBUFFER, framebufferStack[--framebufferStack.length - 1] || null);
                    }
                }
                function handleContextLoss() {
                    extensions = {};
                    programs = {};
                    textures = {};
                    textureUnit = -1;
                    framebufferStack.length = 0;
                }
                cache.set(gl, wrapper = {
                    gl: gl,
                    isWebGL2: isWebGL2,
                    getExtension: getExtension,
                    withProgram: withProgram,
                    withTexture: withTexture,
                    withTextureFramebuffer: withTextureFramebuffer,
                    handleContextLoss: handleContextLoss
                });
            }
            callback(wrapper);
        }
        function renderImageData(glOrCanvas, imageData, x, y, width, height, channels, framebuffer) {
            if (channels === void 0) channels = 15;
            if (framebuffer === void 0) framebuffer = null;
            withWebGLContext(glOrCanvas, function(ref) {
                var gl = ref.gl;
                var withProgram = ref.withProgram;
                var withTexture = ref.withTexture;
                withTexture('copy', function(tex, texUnit) {
                    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, width, height, 0, gl.RGBA, gl.UNSIGNED_BYTE, imageData);
                    withProgram('copy', viewportQuadVertex, copyTexFragment, function(ref) {
                        var setUniform = ref.setUniform;
                        var setAttribute = ref.setAttribute;
                        setAttribute('aUV', 2, gl.STATIC_DRAW, 0, new Float32Array([
                            0,
                            0,
                            2,
                            0,
                            0,
                            2
                        ]));
                        setUniform('1i', 'image', texUnit);
                        gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer || null);
                        gl.disable(gl.BLEND);
                        gl.colorMask(channels & 8, channels & 4, channels & 2, channels & 1);
                        gl.viewport(x, y, width, height);
                        gl.scissor(x, y, width, height);
                        gl.drawArrays(gl.TRIANGLES, 0, 3);
                    });
                });
            });
        }
        /**
   * Resizing a canvas clears its contents; this utility copies the previous contents over.
   * @param canvas
   * @param newWidth
   * @param newHeight
   */ function resizeWebGLCanvasWithoutClearing(canvas, newWidth, newHeight) {
            var width = canvas.width;
            var height = canvas.height;
            withWebGLContext(canvas, function(ref) {
                var gl = ref.gl;
                var data = new Uint8Array(width * height * 4);
                gl.readPixels(0, 0, width, height, gl.RGBA, gl.UNSIGNED_BYTE, data);
                canvas.width = newWidth;
                canvas.height = newHeight;
                renderImageData(gl, data, 0, 0, width, height);
            });
        }
        var webglUtils = /*#__PURE__*/ Object.freeze({
            __proto__: null,
            withWebGLContext: withWebGLContext,
            renderImageData: renderImageData,
            resizeWebGLCanvasWithoutClearing: resizeWebGLCanvasWithoutClearing
        });
        function generate$2(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent) {
            if (sdfExponent === void 0) sdfExponent = 1;
            var textureData = new Uint8Array(sdfWidth * sdfHeight);
            var viewBoxWidth = viewBox[2] - viewBox[0];
            var viewBoxHeight = viewBox[3] - viewBox[1];
            // Decompose all paths into straight line segments and add them to an index
            var segments = [];
            pathToLineSegments(path, function(x1, y1, x2, y2) {
                segments.push({
                    x1: x1,
                    y1: y1,
                    x2: x2,
                    y2: y2,
                    minX: Math.min(x1, x2),
                    minY: Math.min(y1, y2),
                    maxX: Math.max(x1, x2),
                    maxY: Math.max(y1, y2)
                });
            });
            // Sort segments by maxX, this will let us short-circuit some loops below
            segments.sort(function(a, b) {
                return a.maxX - b.maxX;
            });
            // For each target SDF texel, find the distance from its center to its nearest line segment,
            // map that distance to an alpha value, and write that alpha to the texel
            for(var sdfX = 0; sdfX < sdfWidth; sdfX++)for(var sdfY = 0; sdfY < sdfHeight; sdfY++){
                var signedDist = findNearestSignedDistance(viewBox[0] + viewBoxWidth * (sdfX + 0.5) / sdfWidth, viewBox[1] + viewBoxHeight * (sdfY + 0.5) / sdfHeight);
                // Use an exponential scale to ensure the texels very near the glyph path have adequate
                // precision, while allowing the distance field to cover the entire texture, given that
                // there are only 8 bits available. Formula visualized: https://www.desmos.com/calculator/uiaq5aqiam
                var alpha = Math.pow(1 - Math.abs(signedDist) / maxDistance, sdfExponent) / 2;
                if (signedDist < 0) alpha = 1 - alpha;
                alpha = Math.max(0, Math.min(255, Math.round(alpha * 255))); //clamp
                textureData[sdfY * sdfWidth + sdfX] = alpha;
            }
            return textureData;
            /**
     * For a given x/y, search the index for the closest line segment and return
     * its signed distance. Negative = inside, positive = outside, zero = on edge
     * @param x
     * @param y
     * @returns {number}
     */ function findNearestSignedDistance(x, y) {
                var closestDistSq = Infinity;
                var closestDist = Infinity;
                for(var i = segments.length; i--;){
                    var seg = segments[i];
                    if (seg.maxX + closestDist <= x) break;
                     //sorting by maxX means no more can be closer, so we can short-circuit
                    if (x + closestDist > seg.minX && y - closestDist < seg.maxY && y + closestDist > seg.minY) {
                        var distSq = absSquareDistanceToLineSegment(x, y, seg.x1, seg.y1, seg.x2, seg.y2);
                        if (distSq < closestDistSq) {
                            closestDistSq = distSq;
                            closestDist = Math.sqrt(closestDistSq);
                        }
                    }
                }
                // Flip to negative distance if inside the poly
                if (isPointInPoly(x, y)) closestDist = -closestDist;
                return closestDist;
            }
            /**
     * Determine whether the given point lies inside or outside the glyph. Uses a simple
     * winding-number ray casting algorithm using a ray pointing east from the point.
     */ function isPointInPoly(x, y) {
                var winding = 0;
                for(var i = segments.length; i--;){
                    var seg = segments[i];
                    if (seg.maxX <= x) break;
                     //sorting by maxX means no more can cross, so we can short-circuit
                    var intersects = seg.y1 > y !== seg.y2 > y && x < (seg.x2 - seg.x1) * (y - seg.y1) / (seg.y2 - seg.y1) + seg.x1;
                    if (intersects) winding += seg.y1 < seg.y2 ? 1 : -1;
                }
                return winding !== 0;
            }
        }
        function generateIntoCanvas$2(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent, canvas, x, y, channel) {
            if (sdfExponent === void 0) sdfExponent = 1;
            if (x === void 0) x = 0;
            if (y === void 0) y = 0;
            if (channel === void 0) channel = 0;
            generateIntoFramebuffer$1(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent, canvas, null, x, y, channel);
        }
        function generateIntoFramebuffer$1(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent, glOrCanvas, framebuffer, x, y, channel) {
            if (sdfExponent === void 0) sdfExponent = 1;
            if (x === void 0) x = 0;
            if (y === void 0) y = 0;
            if (channel === void 0) channel = 0;
            var data = generate$2(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent);
            // Expand single-channel data to rbga
            var rgbaData = new Uint8Array(data.length * 4);
            for(var i = 0; i < data.length; i++)rgbaData[i * 4 + channel] = data[i];
            renderImageData(glOrCanvas, rgbaData, x, y, sdfWidth, sdfHeight, 1 << 3 - channel, framebuffer);
        }
        /**
   * Find the absolute distance from a point to a line segment at closest approach
   */ function absSquareDistanceToLineSegment(x, y, lineX0, lineY0, lineX1, lineY1) {
            var ldx = lineX1 - lineX0;
            var ldy = lineY1 - lineY0;
            var lengthSq = ldx * ldx + ldy * ldy;
            var t = lengthSq ? Math.max(0, Math.min(1, ((x - lineX0) * ldx + (y - lineY0) * ldy) / lengthSq)) : 0;
            var dx = x - (lineX0 + t * ldx);
            var dy = y - (lineY0 + t * ldy);
            return dx * dx + dy * dy;
        }
        var javascript = /*#__PURE__*/ Object.freeze({
            __proto__: null,
            generate: generate$2,
            generateIntoCanvas: generateIntoCanvas$2,
            generateIntoFramebuffer: generateIntoFramebuffer$1
        });
        var mainVertex = "precision highp float;uniform vec4 uGlyphBounds;attribute vec2 aUV;attribute vec4 aLineSegment;varying vec4 vLineSegment;varying vec2 vGlyphXY;void main(){vLineSegment=aLineSegment;vGlyphXY=mix(uGlyphBounds.xy,uGlyphBounds.zw,aUV);gl_Position=vec4(mix(vec2(-1.0),vec2(1.0),aUV),0.0,1.0);}";
        var mainFragment = "precision highp float;uniform vec4 uGlyphBounds;uniform float uMaxDistance;uniform float uExponent;varying vec4 vLineSegment;varying vec2 vGlyphXY;float absDistToSegment(vec2 point,vec2 lineA,vec2 lineB){vec2 lineDir=lineB-lineA;float lenSq=dot(lineDir,lineDir);float t=lenSq==0.0 ? 0.0 : clamp(dot(point-lineA,lineDir)/lenSq,0.0,1.0);vec2 linePt=lineA+t*lineDir;return distance(point,linePt);}void main(){vec4 seg=vLineSegment;vec2 p=vGlyphXY;float dist=absDistToSegment(p,seg.xy,seg.zw);float val=pow(1.0-clamp(dist/uMaxDistance,0.0,1.0),uExponent)*0.5;bool crossing=(seg.y>p.y!=seg.w>p.y)&&(p.x<(seg.z-seg.x)*(p.y-seg.y)/(seg.w-seg.y)+seg.x);bool crossingUp=crossing&&vLineSegment.y<vLineSegment.w;gl_FragColor=vec4(crossingUp ? 1.0/255.0 : 0.0,crossing&&!crossingUp ? 1.0/255.0 : 0.0,0.0,val);}";
        var postFragment = "precision highp float;uniform sampler2D tex;varying vec2 vUV;void main(){vec4 color=texture2D(tex,vUV);bool inside=color.r!=color.g;float val=inside ? 1.0-color.a : color.a;gl_FragColor=vec4(val);}";
        // Single triangle covering viewport
        var viewportUVs = new Float32Array([
            0,
            0,
            2,
            0,
            0,
            2
        ]);
        var implicitContext = null;
        var isTestingSupport = false;
        var NULL_OBJECT = {};
        var supportByCanvas = new WeakMap(); // canvas -> bool
        function validateSupport(glOrCanvas) {
            if (!isTestingSupport && !isSupported(glOrCanvas)) throw new Error('WebGL generation not supported');
        }
        function generate$1(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent, glOrCanvas) {
            if (sdfExponent === void 0) sdfExponent = 1;
            if (glOrCanvas === void 0) glOrCanvas = null;
            if (!glOrCanvas) {
                glOrCanvas = implicitContext;
                if (!glOrCanvas) {
                    var canvas = typeof OffscreenCanvas === 'function' ? new OffscreenCanvas(1, 1) : typeof document !== 'undefined' ? document.createElement('canvas') : null;
                    if (!canvas) throw new Error('OffscreenCanvas or DOM canvas not supported');
                    glOrCanvas = implicitContext = canvas.getContext('webgl', {
                        depth: false
                    });
                }
            }
            validateSupport(glOrCanvas);
            var rgbaData = new Uint8Array(sdfWidth * sdfHeight * 4); //not Uint8ClampedArray, cuz Safari
            // Render into a background texture framebuffer
            withWebGLContext(glOrCanvas, function(ref) {
                var gl = ref.gl;
                var withTexture = ref.withTexture;
                var withTextureFramebuffer = ref.withTextureFramebuffer;
                withTexture('readable', function(texture, textureUnit) {
                    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, sdfWidth, sdfHeight, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
                    withTextureFramebuffer(texture, textureUnit, function(framebuffer) {
                        generateIntoFramebuffer(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent, gl, framebuffer, 0, 0, 0 // red channel
                        );
                        gl.readPixels(0, 0, sdfWidth, sdfHeight, gl.RGBA, gl.UNSIGNED_BYTE, rgbaData);
                    });
                });
            });
            // Throw away all but the red channel
            var data = new Uint8Array(sdfWidth * sdfHeight);
            for(var i = 0, j = 0; i < rgbaData.length; i += 4)data[j++] = rgbaData[i];
            return data;
        }
        function generateIntoCanvas$1(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent, canvas, x, y, channel) {
            if (sdfExponent === void 0) sdfExponent = 1;
            if (x === void 0) x = 0;
            if (y === void 0) y = 0;
            if (channel === void 0) channel = 0;
            generateIntoFramebuffer(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent, canvas, null, x, y, channel);
        }
        function generateIntoFramebuffer(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent, glOrCanvas, framebuffer, x, y, channel) {
            if (sdfExponent === void 0) sdfExponent = 1;
            if (x === void 0) x = 0;
            if (y === void 0) y = 0;
            if (channel === void 0) channel = 0;
            // Verify support
            validateSupport(glOrCanvas);
            // Compute path segments
            var lineSegmentCoords = [];
            pathToLineSegments(path, function(x1, y1, x2, y2) {
                lineSegmentCoords.push(x1, y1, x2, y2);
            });
            lineSegmentCoords = new Float32Array(lineSegmentCoords);
            withWebGLContext(glOrCanvas, function(ref) {
                var gl = ref.gl;
                var isWebGL2 = ref.isWebGL2;
                var getExtension = ref.getExtension;
                var withProgram = ref.withProgram;
                var withTexture = ref.withTexture;
                var withTextureFramebuffer = ref.withTextureFramebuffer;
                var handleContextLoss = ref.handleContextLoss;
                withTexture('rawDistances', function(intermediateTexture, intermediateTextureUnit) {
                    if (sdfWidth !== intermediateTexture._lastWidth || sdfHeight !== intermediateTexture._lastHeight) gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, intermediateTexture._lastWidth = sdfWidth, intermediateTexture._lastHeight = sdfHeight, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
                    // Unsigned distance pass
                    withProgram('main', mainVertex, mainFragment, function(ref) {
                        var setAttribute = ref.setAttribute;
                        var setUniform = ref.setUniform;
                        // Init extensions
                        var instancingExtension = !isWebGL2 && getExtension('ANGLE_instanced_arrays');
                        var blendMinMaxExtension = !isWebGL2 && getExtension('EXT_blend_minmax');
                        // Init/update attributes
                        setAttribute('aUV', 2, gl.STATIC_DRAW, 0, viewportUVs);
                        setAttribute('aLineSegment', 4, gl.DYNAMIC_DRAW, 1, lineSegmentCoords);
                        // Init/update uniforms
                        setUniform.apply(void 0, [
                            '4f',
                            'uGlyphBounds'
                        ].concat(viewBox));
                        setUniform('1f', 'uMaxDistance', maxDistance);
                        setUniform('1f', 'uExponent', sdfExponent);
                        // Render initial unsigned distance / winding number info to a texture
                        withTextureFramebuffer(intermediateTexture, intermediateTextureUnit, function(framebuffer) {
                            gl.enable(gl.BLEND);
                            gl.colorMask(true, true, true, true);
                            gl.viewport(0, 0, sdfWidth, sdfHeight);
                            gl.scissor(0, 0, sdfWidth, sdfHeight);
                            gl.blendFunc(gl.ONE, gl.ONE);
                            // Red+Green channels are incremented (FUNC_ADD) for segment-ray crossings to give a "winding number".
                            // Alpha holds the closest (MAX) unsigned distance.
                            gl.blendEquationSeparate(gl.FUNC_ADD, isWebGL2 ? gl.MAX : blendMinMaxExtension.MAX_EXT);
                            gl.clear(gl.COLOR_BUFFER_BIT);
                            if (isWebGL2) gl.drawArraysInstanced(gl.TRIANGLES, 0, 3, lineSegmentCoords.length / 4);
                            else instancingExtension.drawArraysInstancedANGLE(gl.TRIANGLES, 0, 3, lineSegmentCoords.length / 4);
                        // Debug
                        // const debug = new Uint8Array(sdfWidth * sdfHeight * 4)
                        // gl.readPixels(0, 0, sdfWidth, sdfHeight, gl.RGBA, gl.UNSIGNED_BYTE, debug)
                        // console.log('intermediate texture data: ', debug)
                        });
                    });
                    // Use the data stored in the texture to apply inside/outside and write to the output framebuffer rect+channel.
                    withProgram('post', viewportQuadVertex, postFragment, function(program) {
                        program.setAttribute('aUV', 2, gl.STATIC_DRAW, 0, viewportUVs);
                        program.setUniform('1i', 'tex', intermediateTextureUnit);
                        gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
                        gl.disable(gl.BLEND);
                        gl.colorMask(channel === 0, channel === 1, channel === 2, channel === 3);
                        gl.viewport(x, y, sdfWidth, sdfHeight);
                        gl.scissor(x, y, sdfWidth, sdfHeight);
                        gl.drawArrays(gl.TRIANGLES, 0, 3);
                    });
                });
                // Handle context loss occurring during any of the above calls
                if (gl.isContextLost()) {
                    handleContextLoss();
                    throw new Error('webgl context lost');
                }
            });
        }
        function isSupported(glOrCanvas) {
            var key = !glOrCanvas || glOrCanvas === implicitContext ? NULL_OBJECT : glOrCanvas.canvas || glOrCanvas;
            var supported = supportByCanvas.get(key);
            if (supported === undefined) {
                isTestingSupport = true;
                var failReason = null;
                try {
                    // Since we can't detect all failure modes up front, let's just do a trial run of a
                    // simple path and compare what we get back to the correct expected result. This will
                    // also serve to prime the shader compilation.
                    var expectedResult = [
                        97,
                        106,
                        97,
                        61,
                        99,
                        137,
                        118,
                        80,
                        80,
                        118,
                        137,
                        99,
                        61,
                        97,
                        106,
                        97
                    ];
                    var testResult = generate$1(4, 4, 'M8,8L16,8L24,24L16,24Z', [
                        0,
                        0,
                        32,
                        32
                    ], 24, 1, glOrCanvas);
                    supported = testResult && expectedResult.length === testResult.length && testResult.every(function(val, i) {
                        return val === expectedResult[i];
                    });
                    if (!supported) {
                        failReason = 'bad trial run results';
                        console.info(expectedResult, testResult);
                    }
                } catch (err) {
                    // TODO if it threw due to webgl context loss, should we maybe leave isSupported as null and try again later?
                    supported = false;
                    failReason = err.message;
                }
                if (failReason) console.warn('WebGL SDF generation not supported:', failReason);
                isTestingSupport = false;
                supportByCanvas.set(key, supported);
            }
            return supported;
        }
        var webgl = /*#__PURE__*/ Object.freeze({
            __proto__: null,
            generate: generate$1,
            generateIntoCanvas: generateIntoCanvas$1,
            generateIntoFramebuffer: generateIntoFramebuffer,
            isSupported: isSupported
        });
        /**
   * Generate an SDF texture image for a 2D path.
   *
   * @param {number} sdfWidth - width of the SDF output image in pixels.
   * @param {number} sdfHeight - height of the SDF output image in pixels.
   * @param {string} path - an SVG-like path string describing the glyph; should only contain commands: M/L/Q/C/Z.
   * @param {number[]} viewBox - [minX, minY, maxX, maxY] in font units aligning with the texture's edges.
   * @param {number} maxDistance - the maximum distance from the glyph path in font units that will be encoded; defaults
   *        to half the maximum viewBox dimension.
   * @param {number} [sdfExponent] - specifies an exponent for encoding the SDF's distance values; higher exponents
   *        will give greater precision nearer the glyph's path.
   * @return {Uint8Array}
   */ function generate(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent) {
            if (maxDistance === void 0) maxDistance = Math.max(viewBox[2] - viewBox[0], viewBox[3] - viewBox[1]) / 2;
            if (sdfExponent === void 0) sdfExponent = 1;
            try {
                return generate$1.apply(webgl, arguments);
            } catch (e) {
                console.info('WebGL SDF generation failed, falling back to JS', e);
                return generate$2.apply(javascript, arguments);
            }
        }
        /**
   * Generate an SDF texture image for a 2D path, inserting the result into a WebGL `canvas` at a given x/y position
   * and color channel. This is generally much faster than calling `generate` because it does not require reading pixels
   * back from the GPU->CPU -- the `canvas` can be used directly as a WebGL texture image, so it all stays on the GPU.
   *
   * @param {number} sdfWidth - width of the SDF output image in pixels.
   * @param {number} sdfHeight - height of the SDF output image in pixels.
   * @param {string} path - an SVG-like path string describing the glyph; should only contain commands: M/L/Q/C/Z.
   * @param {number[]} viewBox - [minX, minY, maxX, maxY] in font units aligning with the texture's edges.
   * @param {number} maxDistance - the maximum distance from the glyph path in font units that will be encoded; defaults
   *        to half the maximum viewBox dimension.
   * @param {number} [sdfExponent] - specifies an exponent for encoding the SDF's distance values; higher exponents
   *        will give greater precision nearer the glyph's path.
   * @param {HTMLCanvasElement|OffscreenCanvas} canvas - a WebGL-enabled canvas into which the SDF will be rendered.
   *        Only the relevant rect/channel will be modified, the rest will be preserved. To avoid unpredictable results
   *        due to shared GL context state, this canvas should be dedicated to use by this library alone.
   * @param {number} x - the x position at which to render the SDF.
   * @param {number} y - the y position at which to render the SDF.
   * @param {number} channel - the color channel index (0-4) into which the SDF will be rendered.
   * @return {Uint8Array}
   */ function generateIntoCanvas(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent, canvas, x, y, channel) {
            if (maxDistance === void 0) maxDistance = Math.max(viewBox[2] - viewBox[0], viewBox[3] - viewBox[1]) / 2;
            if (sdfExponent === void 0) sdfExponent = 1;
            if (x === void 0) x = 0;
            if (y === void 0) y = 0;
            if (channel === void 0) channel = 0;
            try {
                return generateIntoCanvas$1.apply(webgl, arguments);
            } catch (e) {
                console.info('WebGL SDF generation failed, falling back to JS', e);
                return generateIntoCanvas$2.apply(javascript, arguments);
            }
        }
        exports.forEachPathCommand = forEachPathCommand;
        exports.generate = generate;
        exports.generateIntoCanvas = generateIntoCanvas;
        exports.javascript = javascript;
        exports.pathToLineSegments = pathToLineSegments;
        exports.webgl = webgl;
        exports.webglUtils = webglUtils;
        Object.defineProperty(exports, '__esModule', {
            value: true
        });
        return exports;
    }({});
    return exports;
}


function $031b8ddc392a3293$var$bidiFactory() {
    var bidi = function(exports) {
        // Bidi character types data, auto generated
        var DATA = {
            "R": "13k,1a,2,3,3,2+1j,ch+16,a+1,5+2,2+n,5,a,4,6+16,4+3,h+1b,4mo,179q,2+9,2+11,2i9+7y,2+68,4,3+4,5+13,4+3,2+4k,3+29,8+cf,1t+7z,w+17,3+3m,1t+3z,16o1+5r,8+30,8+mc,29+1r,29+4v,75+73",
            "EN": "1c+9,3d+1,6,187+9,513,4+5,7+9,sf+j,175h+9,qw+q,161f+1d,4xt+a,25i+9",
            "ES": "17,2,6dp+1,f+1,av,16vr,mx+1,4o,2",
            "ET": "z+2,3h+3,b+1,ym,3e+1,2o,p4+1,8,6u,7c,g6,1wc,1n9+4,30+1b,2n,6d,qhx+1,h0m,a+1,49+2,63+1,4+1,6bb+3,12jj",
            "AN": "16o+5,2j+9,2+1,35,ed,1ff2+9,87+u",
            "CS": "18,2+1,b,2u,12k,55v,l,17v0,2,3,53,2+1,b",
            "B": "a,3,f+2,2v,690",
            "S": "9,2,k",
            "WS": "c,k,4f4,1vk+a,u,1j,335",
            "ON": "x+1,4+4,h+5,r+5,r+3,z,5+3,2+1,2+1,5,2+2,3+4,o,w,ci+1,8+d,3+d,6+8,2+g,39+1,9,6+1,2,33,b8,3+1,3c+1,7+1,5r,b,7h+3,sa+5,2,3i+6,jg+3,ur+9,2v,ij+1,9g+9,7+a,8m,4+1,49+x,14u,2+2,c+2,e+2,e+2,e+1,i+n,e+e,2+p,u+2,e+2,36+1,2+3,2+1,b,2+2,6+5,2,2,2,h+1,5+4,6+3,3+f,16+2,5+3l,3+81,1y+p,2+40,q+a,m+13,2r+ch,2+9e,75+hf,3+v,2+2w,6e+5,f+6,75+2a,1a+p,2+2g,d+5x,r+b,6+3,4+o,g,6+1,6+2,2k+1,4,2j,5h+z,1m+1,1e+f,t+2,1f+e,d+3,4o+3,2s+1,w,535+1r,h3l+1i,93+2,2s,b+1,3l+x,2v,4g+3,21+3,kz+1,g5v+1,5a,j+9,n+v,2,3,2+8,2+1,3+2,2,3,46+1,4+4,h+5,r+5,r+a,3h+2,4+6,b+4,78,1r+24,4+c,4,1hb,ey+6,103+j,16j+c,1ux+7,5+g,fsh,jdq+1t,4,57+2e,p1,1m,1m,1m,1m,4kt+1,7j+17,5+2r,d+e,3+e,2+e,2+10,m+4,w,1n+5,1q,4z+5,4b+rb,9+c,4+c,4+37,d+2g,8+b,l+b,5+1j,9+9,7+13,9+t,3+1,27+3c,2+29,2+3q,d+d,3+4,4+2,6+6,a+o,8+6,a+2,e+6,16+42,2+1i",
            "BN": "0+8,6+d,2s+5,2+p,e,4m9,1kt+2,2b+5,5+5,17q9+v,7k,6p+8,6+1,119d+3,440+7,96s+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+75,6p+2rz,1ben+1,1ekf+1,1ekf+1",
            "NSM": "lc+33,7o+6,7c+18,2,2+1,2+1,2,21+a,1d+k,h,2u+6,3+5,3+1,2+3,10,v+q,2k+a,1n+8,a,p+3,2+8,2+2,2+4,18+2,3c+e,2+v,1k,2,5+7,5,4+6,b+1,u,1n,5+3,9,l+1,r,3+1,1m,5+1,5+1,3+2,4,v+1,4,c+1,1m,5+4,2+1,5,l+1,n+5,2,1n,3,2+3,9,8+1,c+1,v,1q,d,1f,4,1m+2,6+2,2+3,8+1,c+1,u,1n,g+1,l+1,t+1,1m+1,5+3,9,l+1,u,21,8+2,2,2j,3+6,d+7,2r,3+8,c+5,23+1,s,2,2,1k+d,2+4,2+1,6+a,2+z,a,2v+3,2+5,2+1,3+1,q+1,5+2,h+3,e,3+1,7,g,jk+2,qb+2,u+2,u+1,v+1,1t+1,2+6,9,3+a,a,1a+2,3c+1,z,3b+2,5+1,a,7+2,64+1,3,1n,2+6,2,2,3+7,7+9,3,1d+g,1s+3,1d,2+4,2,6,15+8,d+1,x+3,3+1,2+2,1l,2+1,4,2+2,1n+7,3+1,49+2,2+c,2+6,5,7,4+1,5j+1l,2+4,k1+w,2db+2,3y,2p+v,ff+3,30+1,n9x+3,2+9,x+1,29+1,7l,4,5,q+1,6,48+1,r+h,e,13+7,q+a,1b+2,1d,3+3,3+1,14,1w+5,3+1,3+1,d,9,1c,1g,2+2,3+1,6+1,2,17+1,9,6n,3,5,fn5,ki+f,h+f,r2,6b,46+4,1af+2,2+1,6+3,15+2,5,4m+1,fy+3,as+1,4a+a,4x,1j+e,1l+2,1e+3,3+1,1y+2,11+4,2+7,1r,d+1,1h+8,b+3,3,2o+2,3,2+1,7,4h,4+7,m+1,1m+1,4,12+6,4+4,5g+7,3+2,2,o,2d+5,2,5+1,2+1,6n+3,7+1,2+1,s+1,2e+7,3,2+1,2z,2,3+5,2,2u+2,3+3,2+4,78+8,2+1,75+1,2,5,41+3,3+1,5,x+5,3+1,15+5,3+3,9,a+5,3+2,1b+c,2+1,bb+6,2+5,2d+l,3+6,2+1,2+1,3f+5,4,2+1,2+6,2,21+1,4,2,9o+1,f0c+4,1o+6,t5,1s+3,2a,f5l+1,43t+2,i+7,3+6,v+3,45+2,1j0+1i,5+1d,9,f,n+4,2+e,11t+6,2+g,3+6,2+1,2+4,7a+6,c6+3,15t+6,32+6,gzhy+6n",
            "AL": "16w,3,2,e+1b,z+2,2+2s,g+1,8+1,b+m,2+t,s+2i,c+e,4h+f,1d+1e,1bwe+dp,3+3z,x+c,2+1,35+3y,2rm+z,5+7,b+5,dt+l,c+u,17nl+27,1t+27,4x+6n,3+d",
            "LRO": "6ct",
            "RLO": "6cu",
            "LRE": "6cq",
            "RLE": "6cr",
            "PDF": "6cs",
            "LRI": "6ee",
            "RLI": "6ef",
            "FSI": "6eg",
            "PDI": "6eh"
        };
        var TYPES = {};
        var TYPES_TO_NAMES = {};
        TYPES.L = 1; //L is the default
        TYPES_TO_NAMES[1] = 'L';
        Object.keys(DATA).forEach(function(type, i) {
            TYPES[type] = 1 << i + 1;
            TYPES_TO_NAMES[TYPES[type]] = type;
        });
        Object.freeze(TYPES);
        var ISOLATE_INIT_TYPES = TYPES.LRI | TYPES.RLI | TYPES.FSI;
        var STRONG_TYPES = TYPES.L | TYPES.R | TYPES.AL;
        var NEUTRAL_ISOLATE_TYPES = TYPES.B | TYPES.S | TYPES.WS | TYPES.ON | TYPES.FSI | TYPES.LRI | TYPES.RLI | TYPES.PDI;
        var BN_LIKE_TYPES = TYPES.BN | TYPES.RLE | TYPES.LRE | TYPES.RLO | TYPES.LRO | TYPES.PDF;
        var TRAILING_TYPES = TYPES.S | TYPES.WS | TYPES.B | ISOLATE_INIT_TYPES | TYPES.PDI | BN_LIKE_TYPES;
        var map = null;
        function parseData() {
            if (!map) {
                //const start = performance.now()
                map = new Map();
                var loop = function loop(type) {
                    if (DATA.hasOwnProperty(type)) {
                        var lastCode = 0;
                        DATA[type].split(',').forEach(function(range) {
                            var ref = range.split('+');
                            var skip = ref[0];
                            var step = ref[1];
                            skip = parseInt(skip, 36);
                            step = step ? parseInt(step, 36) : 0;
                            map.set(lastCode += skip, TYPES[type]);
                            for(var i = 0; i < step; i++)map.set(++lastCode, TYPES[type]);
                        });
                    }
                };
                for(var type in DATA)loop(type);
            //console.log(`char types parsed in ${performance.now() - start}ms`)
            }
        }
        /**
   * @param {string} char
   * @return {number}
   */ function getBidiCharType(char) {
            parseData();
            return map.get(char.codePointAt(0)) || TYPES.L;
        }
        function getBidiCharTypeName(char) {
            return TYPES_TO_NAMES[getBidiCharType(char)];
        }
        // Bidi bracket pairs data, auto generated
        var data$1 = {
            "pairs": "14>1,1e>2,u>2,2wt>1,1>1,1ge>1,1wp>1,1j>1,f>1,hm>1,1>1,u>1,u6>1,1>1,+5,28>1,w>1,1>1,+3,b8>1,1>1,+3,1>3,-1>-1,3>1,1>1,+2,1s>1,1>1,x>1,th>1,1>1,+2,db>1,1>1,+3,3>1,1>1,+2,14qm>1,1>1,+1,4q>1,1e>2,u>2,2>1,+1",
            "canonical": "6f1>-6dx,6dy>-6dx,6ec>-6ed,6ee>-6ed,6ww>2jj,-2ji>2jj,14r4>-1e7l,1e7m>-1e7l,1e7m>-1e5c,1e5d>-1e5b,1e5c>-14qx,14qy>-14qx,14vn>-1ecg,1ech>-1ecg,1edu>-1ecg,1eci>-1ecg,1eda>-1ecg,1eci>-1ecg,1eci>-168q,168r>-168q,168s>-14ye,14yf>-14ye"
        };
        /**
   * Parses an string that holds encoded codepoint mappings, e.g. for bracket pairs or
   * mirroring characters, as encoded by scripts/generateBidiData.js. Returns an object
   * holding the `map`, and optionally a `reverseMap` if `includeReverse:true`.
   * @param {string} encodedString
   * @param {boolean} includeReverse - true if you want reverseMap in the output
   * @return {{map: Map<number, number>, reverseMap?: Map<number, number>}}
   */ function parseCharacterMap(encodedString, includeReverse) {
            var radix = 36;
            var lastCode = 0;
            var map = new Map();
            var reverseMap = includeReverse && new Map();
            var prevPair;
            encodedString.split(',').forEach(function visit(entry) {
                if (entry.indexOf('+') !== -1) for(var i = +entry; i--;)visit(prevPair);
                else {
                    prevPair = entry;
                    var ref = entry.split('>');
                    var a = ref[0];
                    var b = ref[1];
                    a = String.fromCodePoint(lastCode += parseInt(a, radix));
                    b = String.fromCodePoint(lastCode += parseInt(b, radix));
                    map.set(a, b);
                    includeReverse && reverseMap.set(b, a);
                }
            });
            return {
                map: map,
                reverseMap: reverseMap
            };
        }
        var openToClose, closeToOpen, canonical;
        function parse$1() {
            if (!openToClose) {
                //const start = performance.now()
                var ref = parseCharacterMap(data$1.pairs, true);
                var map = ref.map;
                var reverseMap = ref.reverseMap;
                openToClose = map;
                closeToOpen = reverseMap;
                canonical = parseCharacterMap(data$1.canonical, false).map;
            //console.log(`brackets parsed in ${performance.now() - start}ms`)
            }
        }
        function openingToClosingBracket(char) {
            parse$1();
            return openToClose.get(char) || null;
        }
        function closingToOpeningBracket(char) {
            parse$1();
            return closeToOpen.get(char) || null;
        }
        function getCanonicalBracket(char) {
            parse$1();
            return canonical.get(char) || null;
        }
        // Local type aliases
        var TYPE_L = TYPES.L;
        var TYPE_R = TYPES.R;
        var TYPE_EN = TYPES.EN;
        var TYPE_ES = TYPES.ES;
        var TYPE_ET = TYPES.ET;
        var TYPE_AN = TYPES.AN;
        var TYPE_CS = TYPES.CS;
        var TYPE_B = TYPES.B;
        var TYPE_S = TYPES.S;
        var TYPE_ON = TYPES.ON;
        var TYPE_BN = TYPES.BN;
        var TYPE_NSM = TYPES.NSM;
        var TYPE_AL = TYPES.AL;
        var TYPE_LRO = TYPES.LRO;
        var TYPE_RLO = TYPES.RLO;
        var TYPE_LRE = TYPES.LRE;
        var TYPE_RLE = TYPES.RLE;
        var TYPE_PDF = TYPES.PDF;
        var TYPE_LRI = TYPES.LRI;
        var TYPE_RLI = TYPES.RLI;
        var TYPE_FSI = TYPES.FSI;
        var TYPE_PDI = TYPES.PDI;
        /**
   * @typedef {object} GetEmbeddingLevelsResult
   * @property {{start, end, level}[]} paragraphs
   * @property {Uint8Array} levels
   */ /**
   * This function applies the Bidirectional Algorithm to a string, returning the resolved embedding levels
   * in a single Uint8Array plus a list of objects holding each paragraph's start and end indices and resolved
   * base embedding level.
   *
   * @param {string} string - The input string
   * @param {"ltr"|"rtl"|"auto"} [baseDirection] - Use "ltr" or "rtl" to force a base paragraph direction,
   *        otherwise a direction will be chosen automatically from each paragraph's contents.
   * @return {GetEmbeddingLevelsResult}
   */ function getEmbeddingLevels(string, baseDirection) {
            var MAX_DEPTH = 125;
            // Start by mapping all characters to their unicode type, as a bitmask integer
            var charTypes = new Uint32Array(string.length);
            for(var i = 0; i < string.length; i++)charTypes[i] = getBidiCharType(string[i]);
            var charTypeCounts = new Map(); //will be cleared at start of each paragraph
            function changeCharType(i, type) {
                var oldType = charTypes[i];
                charTypes[i] = type;
                charTypeCounts.set(oldType, charTypeCounts.get(oldType) - 1);
                if (oldType & NEUTRAL_ISOLATE_TYPES) charTypeCounts.set(NEUTRAL_ISOLATE_TYPES, charTypeCounts.get(NEUTRAL_ISOLATE_TYPES) - 1);
                charTypeCounts.set(type, (charTypeCounts.get(type) || 0) + 1);
                if (type & NEUTRAL_ISOLATE_TYPES) charTypeCounts.set(NEUTRAL_ISOLATE_TYPES, (charTypeCounts.get(NEUTRAL_ISOLATE_TYPES) || 0) + 1);
            }
            var embedLevels = new Uint8Array(string.length);
            var isolationPairs = new Map(); //init->pdi and pdi->init
            // === 3.3.1 The Paragraph Level ===
            // 3.3.1 P1: Split the text into paragraphs
            var paragraphs = []; // [{start, end, level}, ...]
            var paragraph = null;
            for(var i$1 = 0; i$1 < string.length; i$1++){
                if (!paragraph) paragraphs.push(paragraph = {
                    start: i$1,
                    end: string.length - 1,
                    // 3.3.1 P2-P3: Determine the paragraph level
                    level: baseDirection === 'rtl' ? 1 : baseDirection === 'ltr' ? 0 : determineAutoEmbedLevel(i$1, false)
                });
                if (charTypes[i$1] & TYPE_B) {
                    paragraph.end = i$1;
                    paragraph = null;
                }
            }
            var FORMATTING_TYPES = TYPE_RLE | TYPE_LRE | TYPE_RLO | TYPE_LRO | ISOLATE_INIT_TYPES | TYPE_PDI | TYPE_PDF | TYPE_B;
            var nextEven = function nextEven(n) {
                return n + (n & 1 ? 1 : 2);
            };
            var nextOdd = function nextOdd(n) {
                return n + (n & 1 ? 2 : 1);
            };
            // Everything from here on will operate per paragraph.
            for(var paraIdx = 0; paraIdx < paragraphs.length; paraIdx++){
                paragraph = paragraphs[paraIdx];
                var statusStack = [
                    {
                        _level: paragraph.level,
                        _override: 0,
                        _isolate: 0 //bool
                    }
                ];
                var stackTop = void 0;
                var overflowIsolateCount = 0;
                var overflowEmbeddingCount = 0;
                var validIsolateCount = 0;
                charTypeCounts.clear();
                // === 3.3.2 Explicit Levels and Directions ===
                for(var i$2 = paragraph.start; i$2 <= paragraph.end; i$2++){
                    var charType = charTypes[i$2];
                    stackTop = statusStack[statusStack.length - 1];
                    // Set initial counts
                    charTypeCounts.set(charType, (charTypeCounts.get(charType) || 0) + 1);
                    if (charType & NEUTRAL_ISOLATE_TYPES) charTypeCounts.set(NEUTRAL_ISOLATE_TYPES, (charTypeCounts.get(NEUTRAL_ISOLATE_TYPES) || 0) + 1);
                    // Explicit Embeddings: 3.3.2 X2 - X3
                    if (charType & FORMATTING_TYPES) {
                        if (charType & (TYPE_RLE | TYPE_LRE)) {
                            embedLevels[i$2] = stackTop._level; // 5.2
                            var level = (charType === TYPE_RLE ? nextOdd : nextEven)(stackTop._level);
                            if (level <= MAX_DEPTH && !overflowIsolateCount && !overflowEmbeddingCount) statusStack.push({
                                _level: level,
                                _override: 0,
                                _isolate: 0
                            });
                            else if (!overflowIsolateCount) overflowEmbeddingCount++;
                        } else if (charType & (TYPE_RLO | TYPE_LRO)) {
                            embedLevels[i$2] = stackTop._level; // 5.2
                            var level$1 = (charType === TYPE_RLO ? nextOdd : nextEven)(stackTop._level);
                            if (level$1 <= MAX_DEPTH && !overflowIsolateCount && !overflowEmbeddingCount) statusStack.push({
                                _level: level$1,
                                _override: charType & TYPE_RLO ? TYPE_R : TYPE_L,
                                _isolate: 0
                            });
                            else if (!overflowIsolateCount) overflowEmbeddingCount++;
                        } else if (charType & ISOLATE_INIT_TYPES) {
                            // X5c - FSI becomes either RLI or LRI
                            if (charType & TYPE_FSI) charType = determineAutoEmbedLevel(i$2 + 1, true) === 1 ? TYPE_RLI : TYPE_LRI;
                            embedLevels[i$2] = stackTop._level;
                            if (stackTop._override) changeCharType(i$2, stackTop._override);
                            var level$2 = (charType === TYPE_RLI ? nextOdd : nextEven)(stackTop._level);
                            if (level$2 <= MAX_DEPTH && overflowIsolateCount === 0 && overflowEmbeddingCount === 0) {
                                validIsolateCount++;
                                statusStack.push({
                                    _level: level$2,
                                    _override: 0,
                                    _isolate: 1,
                                    _isolInitIndex: i$2
                                });
                            } else overflowIsolateCount++;
                        } else if (charType & TYPE_PDI) {
                            if (overflowIsolateCount > 0) overflowIsolateCount--;
                            else if (validIsolateCount > 0) {
                                overflowEmbeddingCount = 0;
                                while(!statusStack[statusStack.length - 1]._isolate)statusStack.pop();
                                // Add to isolation pairs bidirectional mapping:
                                var isolInitIndex = statusStack[statusStack.length - 1]._isolInitIndex;
                                if (isolInitIndex != null) {
                                    isolationPairs.set(isolInitIndex, i$2);
                                    isolationPairs.set(i$2, isolInitIndex);
                                }
                                statusStack.pop();
                                validIsolateCount--;
                            }
                            stackTop = statusStack[statusStack.length - 1];
                            embedLevels[i$2] = stackTop._level;
                            if (stackTop._override) changeCharType(i$2, stackTop._override);
                        } else if (charType & TYPE_PDF) {
                            if (overflowIsolateCount === 0) {
                                if (overflowEmbeddingCount > 0) overflowEmbeddingCount--;
                                else if (!stackTop._isolate && statusStack.length > 1) {
                                    statusStack.pop();
                                    stackTop = statusStack[statusStack.length - 1];
                                }
                            }
                            embedLevels[i$2] = stackTop._level; // 5.2
                        } else if (charType & TYPE_B) embedLevels[i$2] = paragraph.level;
                    } else {
                        embedLevels[i$2] = stackTop._level;
                        // NOTE: This exclusion of BN seems to go against what section 5.2 says, but is required for test passage
                        if (stackTop._override && charType !== TYPE_BN) changeCharType(i$2, stackTop._override);
                    }
                }
                // === 3.3.3 Preparations for Implicit Processing ===
                // Remove all RLE, LRE, RLO, LRO, PDF, and BN characters: 3.3.3 X9
                // Note: Due to section 5.2, we won't remove them, but we'll use the BN_LIKE_TYPES bitset to
                // easily ignore them all from here on out.
                // 3.3.3 X10
                // Compute the set of isolating run sequences as specified by BD13
                var levelRuns = [];
                var currentRun = null;
                for(var i$3 = paragraph.start; i$3 <= paragraph.end; i$3++){
                    var charType$1 = charTypes[i$3];
                    if (!(charType$1 & BN_LIKE_TYPES)) {
                        var lvl = embedLevels[i$3];
                        var isIsolInit = charType$1 & ISOLATE_INIT_TYPES;
                        var isPDI = charType$1 === TYPE_PDI;
                        if (currentRun && lvl === currentRun._level) {
                            currentRun._end = i$3;
                            currentRun._endsWithIsolInit = isIsolInit;
                        } else levelRuns.push(currentRun = {
                            _start: i$3,
                            _end: i$3,
                            _level: lvl,
                            _startsWithPDI: isPDI,
                            _endsWithIsolInit: isIsolInit
                        });
                    }
                }
                var isolatingRunSeqs = []; // [{seqIndices: [], sosType: L|R, eosType: L|R}]
                for(var runIdx = 0; runIdx < levelRuns.length; runIdx++){
                    var run = levelRuns[runIdx];
                    if (!run._startsWithPDI || run._startsWithPDI && !isolationPairs.has(run._start)) {
                        var seqRuns = [
                            currentRun = run
                        ];
                        for(var pdiIndex = void 0; currentRun && currentRun._endsWithIsolInit && (pdiIndex = isolationPairs.get(currentRun._end)) != null;){
                            for(var i$4 = runIdx + 1; i$4 < levelRuns.length; i$4++)if (levelRuns[i$4]._start === pdiIndex) {
                                seqRuns.push(currentRun = levelRuns[i$4]);
                                break;
                            }
                        }
                        // build flat list of indices across all runs:
                        var seqIndices = [];
                        for(var i$5 = 0; i$5 < seqRuns.length; i$5++){
                            var run$1 = seqRuns[i$5];
                            for(var j = run$1._start; j <= run$1._end; j++)seqIndices.push(j);
                        }
                        // determine the sos/eos types:
                        var firstLevel = embedLevels[seqIndices[0]];
                        var prevLevel = paragraph.level;
                        for(var i$6 = seqIndices[0] - 1; i$6 >= 0; i$6--)if (!(charTypes[i$6] & BN_LIKE_TYPES)) {
                            prevLevel = embedLevels[i$6];
                            break;
                        }
                        var lastIndex = seqIndices[seqIndices.length - 1];
                        var lastLevel = embedLevels[lastIndex];
                        var nextLevel = paragraph.level;
                        if (!(charTypes[lastIndex] & ISOLATE_INIT_TYPES)) {
                            for(var i$7 = lastIndex + 1; i$7 <= paragraph.end; i$7++)if (!(charTypes[i$7] & BN_LIKE_TYPES)) {
                                nextLevel = embedLevels[i$7];
                                break;
                            }
                        }
                        isolatingRunSeqs.push({
                            _seqIndices: seqIndices,
                            _sosType: Math.max(prevLevel, firstLevel) % 2 ? TYPE_R : TYPE_L,
                            _eosType: Math.max(nextLevel, lastLevel) % 2 ? TYPE_R : TYPE_L
                        });
                    }
                }
                // The next steps are done per isolating run sequence
                for(var seqIdx = 0; seqIdx < isolatingRunSeqs.length; seqIdx++){
                    var ref = isolatingRunSeqs[seqIdx];
                    var seqIndices$1 = ref._seqIndices;
                    var sosType = ref._sosType;
                    var eosType = ref._eosType;
                    /**
         * All the level runs in an isolating run sequence have the same embedding level.
         * 
         * DO NOT change any `embedLevels[i]` within the current scope.
         */ var embedDirection = embedLevels[seqIndices$1[0]] & 1 ? TYPE_R : TYPE_L;
                    // === 3.3.4 Resolving Weak Types ===
                    // W1 + 5.2. Search backward from each NSM to the first character in the isolating run sequence whose
                    // bidirectional type is not BN, and set the NSM to ON if it is an isolate initiator or PDI, and to its
                    // type otherwise. If the NSM is the first non-BN character, change the NSM to the type of sos.
                    if (charTypeCounts.get(TYPE_NSM)) for(var si = 0; si < seqIndices$1.length; si++){
                        var i$8 = seqIndices$1[si];
                        if (charTypes[i$8] & TYPE_NSM) {
                            var prevType = sosType;
                            for(var sj = si - 1; sj >= 0; sj--)if (!(charTypes[seqIndices$1[sj]] & BN_LIKE_TYPES)) {
                                prevType = charTypes[seqIndices$1[sj]];
                                break;
                            }
                            changeCharType(i$8, prevType & (ISOLATE_INIT_TYPES | TYPE_PDI) ? TYPE_ON : prevType);
                        }
                    }
                    // W2. Search backward from each instance of a European number until the first strong type (R, L, AL, or sos)
                    // is found. If an AL is found, change the type of the European number to Arabic number.
                    if (charTypeCounts.get(TYPE_EN)) for(var si$1 = 0; si$1 < seqIndices$1.length; si$1++){
                        var i$9 = seqIndices$1[si$1];
                        if (charTypes[i$9] & TYPE_EN) for(var sj$1 = si$1 - 1; sj$1 >= -1; sj$1--){
                            var prevCharType = sj$1 === -1 ? sosType : charTypes[seqIndices$1[sj$1]];
                            if (prevCharType & STRONG_TYPES) {
                                if (prevCharType === TYPE_AL) changeCharType(i$9, TYPE_AN);
                                break;
                            }
                        }
                    }
                    // W3. Change all ALs to R
                    if (charTypeCounts.get(TYPE_AL)) for(var si$2 = 0; si$2 < seqIndices$1.length; si$2++){
                        var i$10 = seqIndices$1[si$2];
                        if (charTypes[i$10] & TYPE_AL) changeCharType(i$10, TYPE_R);
                    }
                    // W4. A single European separator between two European numbers changes to a European number. A single common
                    // separator between two numbers of the same type changes to that type.
                    if (charTypeCounts.get(TYPE_ES) || charTypeCounts.get(TYPE_CS)) for(var si$3 = 1; si$3 < seqIndices$1.length - 1; si$3++){
                        var i$11 = seqIndices$1[si$3];
                        if (charTypes[i$11] & (TYPE_ES | TYPE_CS)) {
                            var prevType$1 = 0, nextType = 0;
                            for(var sj$2 = si$3 - 1; sj$2 >= 0; sj$2--){
                                prevType$1 = charTypes[seqIndices$1[sj$2]];
                                if (!(prevType$1 & BN_LIKE_TYPES)) break;
                            }
                            for(var sj$3 = si$3 + 1; sj$3 < seqIndices$1.length; sj$3++){
                                nextType = charTypes[seqIndices$1[sj$3]];
                                if (!(nextType & BN_LIKE_TYPES)) break;
                            }
                            if (prevType$1 === nextType && (charTypes[i$11] === TYPE_ES ? prevType$1 === TYPE_EN : prevType$1 & (TYPE_EN | TYPE_AN))) changeCharType(i$11, prevType$1);
                        }
                    }
                    // W5. A sequence of European terminators adjacent to European numbers changes to all European numbers.
                    if (charTypeCounts.get(TYPE_EN)) for(var si$4 = 0; si$4 < seqIndices$1.length; si$4++){
                        var i$12 = seqIndices$1[si$4];
                        if (charTypes[i$12] & TYPE_EN) {
                            for(var sj$4 = si$4 - 1; sj$4 >= 0 && charTypes[seqIndices$1[sj$4]] & (TYPE_ET | BN_LIKE_TYPES); sj$4--)changeCharType(seqIndices$1[sj$4], TYPE_EN);
                            for(si$4++; si$4 < seqIndices$1.length && charTypes[seqIndices$1[si$4]] & (TYPE_ET | BN_LIKE_TYPES | TYPE_EN); si$4++)if (charTypes[seqIndices$1[si$4]] !== TYPE_EN) changeCharType(seqIndices$1[si$4], TYPE_EN);
                        }
                    }
                    // W6. Otherwise, separators and terminators change to Other Neutral.
                    if (charTypeCounts.get(TYPE_ET) || charTypeCounts.get(TYPE_ES) || charTypeCounts.get(TYPE_CS)) for(var si$5 = 0; si$5 < seqIndices$1.length; si$5++){
                        var i$13 = seqIndices$1[si$5];
                        if (charTypes[i$13] & (TYPE_ET | TYPE_ES | TYPE_CS)) {
                            changeCharType(i$13, TYPE_ON);
                            // 5.2 transform adjacent BNs too:
                            for(var sj$5 = si$5 - 1; sj$5 >= 0 && charTypes[seqIndices$1[sj$5]] & BN_LIKE_TYPES; sj$5--)changeCharType(seqIndices$1[sj$5], TYPE_ON);
                            for(var sj$6 = si$5 + 1; sj$6 < seqIndices$1.length && charTypes[seqIndices$1[sj$6]] & BN_LIKE_TYPES; sj$6++)changeCharType(seqIndices$1[sj$6], TYPE_ON);
                        }
                    }
                    // W7. Search backward from each instance of a European number until the first strong type (R, L, or sos)
                    // is found. If an L is found, then change the type of the European number to L.
                    // NOTE: implemented in single forward pass for efficiency
                    if (charTypeCounts.get(TYPE_EN)) for(var si$6 = 0, prevStrongType = sosType; si$6 < seqIndices$1.length; si$6++){
                        var i$14 = seqIndices$1[si$6];
                        var type = charTypes[i$14];
                        if (type & TYPE_EN) {
                            if (prevStrongType === TYPE_L) changeCharType(i$14, TYPE_L);
                        } else if (type & STRONG_TYPES) prevStrongType = type;
                    }
                    // === 3.3.5 Resolving Neutral and Isolate Formatting Types ===
                    if (charTypeCounts.get(NEUTRAL_ISOLATE_TYPES)) {
                        // N0. Process bracket pairs in an isolating run sequence sequentially in the logical order of the text
                        // positions of the opening paired brackets using the logic given below. Within this scope, bidirectional
                        // types EN and AN are treated as R.
                        var R_TYPES_FOR_N_STEPS = TYPE_R | TYPE_EN | TYPE_AN;
                        var STRONG_TYPES_FOR_N_STEPS = R_TYPES_FOR_N_STEPS | TYPE_L;
                        // * Identify the bracket pairs in the current isolating run sequence according to BD16.
                        var bracketPairs = [];
                        var openerStack = [];
                        for(var si$7 = 0; si$7 < seqIndices$1.length; si$7++)// NOTE: for any potential bracket character we also test that it still carries a NI
                        // type, as that may have been changed earlier. This doesn't seem to be explicitly
                        // called out in the spec, but is required for passage of certain tests.
                        if (charTypes[seqIndices$1[si$7]] & NEUTRAL_ISOLATE_TYPES) {
                            var char = string[seqIndices$1[si$7]];
                            var oppositeBracket = void 0;
                            // Opening bracket
                            if (openingToClosingBracket(char) !== null) {
                                if (openerStack.length < 63) openerStack.push({
                                    char: char,
                                    seqIndex: si$7
                                });
                                else break;
                            } else if ((oppositeBracket = closingToOpeningBracket(char)) !== null) for(var stackIdx = openerStack.length - 1; stackIdx >= 0; stackIdx--){
                                var stackChar = openerStack[stackIdx].char;
                                if (stackChar === oppositeBracket || stackChar === closingToOpeningBracket(getCanonicalBracket(char)) || openingToClosingBracket(getCanonicalBracket(stackChar)) === char) {
                                    bracketPairs.push([
                                        openerStack[stackIdx].seqIndex,
                                        si$7
                                    ]);
                                    openerStack.length = stackIdx; //pop the matching bracket and all following
                                    break;
                                }
                            }
                        }
                        bracketPairs.sort(function(a, b) {
                            return a[0] - b[0];
                        });
                        // * For each bracket-pair element in the list of pairs of text positions
                        for(var pairIdx = 0; pairIdx < bracketPairs.length; pairIdx++){
                            var ref$1 = bracketPairs[pairIdx];
                            var openSeqIdx = ref$1[0];
                            var closeSeqIdx = ref$1[1];
                            // a. Inspect the bidirectional types of the characters enclosed within the bracket pair.
                            // b. If any strong type (either L or R) matching the embedding direction is found, set the type for both
                            // brackets in the pair to match the embedding direction.
                            var foundStrongType = false;
                            var useStrongType = 0;
                            for(var si$8 = openSeqIdx + 1; si$8 < closeSeqIdx; si$8++){
                                var i$15 = seqIndices$1[si$8];
                                if (charTypes[i$15] & STRONG_TYPES_FOR_N_STEPS) {
                                    foundStrongType = true;
                                    var lr = charTypes[i$15] & R_TYPES_FOR_N_STEPS ? TYPE_R : TYPE_L;
                                    if (lr === embedDirection) {
                                        useStrongType = lr;
                                        break;
                                    }
                                }
                            }
                            // c. Otherwise, if there is a strong type it must be opposite the embedding direction. Therefore, test
                            // for an established context with a preceding strong type by checking backwards before the opening paired
                            // bracket until the first strong type (L, R, or sos) is found.
                            //    1. If the preceding strong type is also opposite the embedding direction, context is established, so
                            //    set the type for both brackets in the pair to that direction.
                            //    2. Otherwise set the type for both brackets in the pair to the embedding direction.
                            if (foundStrongType && !useStrongType) {
                                useStrongType = sosType;
                                for(var si$9 = openSeqIdx - 1; si$9 >= 0; si$9--){
                                    var i$16 = seqIndices$1[si$9];
                                    if (charTypes[i$16] & STRONG_TYPES_FOR_N_STEPS) {
                                        var lr$1 = charTypes[i$16] & R_TYPES_FOR_N_STEPS ? TYPE_R : TYPE_L;
                                        if (lr$1 !== embedDirection) useStrongType = lr$1;
                                        else useStrongType = embedDirection;
                                        break;
                                    }
                                }
                            }
                            if (useStrongType) {
                                charTypes[seqIndices$1[openSeqIdx]] = charTypes[seqIndices$1[closeSeqIdx]] = useStrongType;
                                // * Any number of characters that had original bidirectional character type NSM prior to the application
                                // of W1 that immediately follow a paired bracket which changed to L or R under N0 should change to match
                                // the type of their preceding bracket.
                                if (useStrongType !== embedDirection) {
                                    for(var si$10 = openSeqIdx + 1; si$10 < seqIndices$1.length; si$10++)if (!(charTypes[seqIndices$1[si$10]] & BN_LIKE_TYPES)) {
                                        if (getBidiCharType(string[seqIndices$1[si$10]]) & TYPE_NSM) charTypes[seqIndices$1[si$10]] = useStrongType;
                                        break;
                                    }
                                }
                                if (useStrongType !== embedDirection) {
                                    for(var si$11 = closeSeqIdx + 1; si$11 < seqIndices$1.length; si$11++)if (!(charTypes[seqIndices$1[si$11]] & BN_LIKE_TYPES)) {
                                        if (getBidiCharType(string[seqIndices$1[si$11]]) & TYPE_NSM) charTypes[seqIndices$1[si$11]] = useStrongType;
                                        break;
                                    }
                                }
                            }
                        }
                        // N1. A sequence of NIs takes the direction of the surrounding strong text if the text on both sides has the
                        // same direction.
                        // N2. Any remaining NIs take the embedding direction.
                        for(var si$12 = 0; si$12 < seqIndices$1.length; si$12++)if (charTypes[seqIndices$1[si$12]] & NEUTRAL_ISOLATE_TYPES) {
                            var niRunStart = si$12, niRunEnd = si$12;
                            var prevType$2 = sosType; //si === 0 ? sosType : (charTypes[seqIndices[si - 1]] & R_TYPES_FOR_N_STEPS) ? TYPE_R : TYPE_L
                            for(var si2 = si$12 - 1; si2 >= 0; si2--)if (charTypes[seqIndices$1[si2]] & BN_LIKE_TYPES) niRunStart = si2; //5.2 treat BNs adjacent to NIs as NIs
                            else {
                                prevType$2 = charTypes[seqIndices$1[si2]] & R_TYPES_FOR_N_STEPS ? TYPE_R : TYPE_L;
                                break;
                            }
                            var nextType$1 = eosType;
                            for(var si2$1 = si$12 + 1; si2$1 < seqIndices$1.length; si2$1++)if (charTypes[seqIndices$1[si2$1]] & (NEUTRAL_ISOLATE_TYPES | BN_LIKE_TYPES)) niRunEnd = si2$1;
                            else {
                                nextType$1 = charTypes[seqIndices$1[si2$1]] & R_TYPES_FOR_N_STEPS ? TYPE_R : TYPE_L;
                                break;
                            }
                            for(var sj$7 = niRunStart; sj$7 <= niRunEnd; sj$7++)charTypes[seqIndices$1[sj$7]] = prevType$2 === nextType$1 ? prevType$2 : embedDirection;
                            si$12 = niRunEnd;
                        }
                    }
                }
                // === 3.3.6 Resolving Implicit Levels ===
                for(var i$17 = paragraph.start; i$17 <= paragraph.end; i$17++){
                    var level$3 = embedLevels[i$17];
                    var type$1 = charTypes[i$17];
                    // I2. For all characters with an odd (right-to-left) embedding level, those of type L, EN or AN go up one level.
                    if (level$3 & 1) {
                        if (type$1 & (TYPE_L | TYPE_EN | TYPE_AN)) embedLevels[i$17]++;
                    } else {
                        if (type$1 & TYPE_R) embedLevels[i$17]++;
                        else if (type$1 & (TYPE_AN | TYPE_EN)) embedLevels[i$17] += 2;
                    }
                    // 5.2: Resolve any LRE, RLE, LRO, RLO, PDF, or BN to the level of the preceding character if there is one,
                    // and otherwise to the base level.
                    if (type$1 & BN_LIKE_TYPES) embedLevels[i$17] = i$17 === 0 ? paragraph.level : embedLevels[i$17 - 1];
                    // 3.4 L1.1-4: Reset the embedding level of segment/paragraph separators, and any sequence of whitespace or
                    // isolate formatting characters preceding them or the end of the paragraph, to the paragraph level.
                    // NOTE: this will also need to be applied to each individual line ending after line wrapping occurs.
                    if (i$17 === paragraph.end || getBidiCharType(string[i$17]) & (TYPE_S | TYPE_B)) for(var j$1 = i$17; j$1 >= 0 && getBidiCharType(string[j$1]) & TRAILING_TYPES; j$1--)embedLevels[j$1] = paragraph.level;
                }
            }
            // DONE! The resolved levels can then be used, after line wrapping, to flip runs of characters
            // according to section 3.4 Reordering Resolved Levels
            return {
                levels: embedLevels,
                paragraphs: paragraphs
            };
            function determineAutoEmbedLevel(start, isFSI) {
                // 3.3.1 P2 - P3
                for(var i = start; i < string.length; i++){
                    var charType = charTypes[i];
                    if (charType & (TYPE_R | TYPE_AL)) return 1;
                    if (charType & (TYPE_B | TYPE_L) || isFSI && charType === TYPE_PDI) return 0;
                    if (charType & ISOLATE_INIT_TYPES) {
                        var pdi = indexOfMatchingPDI(i);
                        i = pdi === -1 ? string.length : pdi;
                    }
                }
                return 0;
            }
            function indexOfMatchingPDI(isolateStart) {
                // 3.1.2 BD9
                var isolationLevel = 1;
                for(var i = isolateStart + 1; i < string.length; i++){
                    var charType = charTypes[i];
                    if (charType & TYPE_B) break;
                    if (charType & TYPE_PDI) {
                        if (--isolationLevel === 0) return i;
                    } else if (charType & ISOLATE_INIT_TYPES) isolationLevel++;
                }
                return -1;
            }
        }
        // Bidi mirrored chars data, auto generated
        var data = "14>1,j>2,t>2,u>2,1a>g,2v3>1,1>1,1ge>1,1wd>1,b>1,1j>1,f>1,ai>3,-2>3,+1,8>1k0,-1jq>1y7,-1y6>1hf,-1he>1h6,-1h5>1ha,-1h8>1qi,-1pu>1,6>3u,-3s>7,6>1,1>1,f>1,1>1,+2,3>1,1>1,+13,4>1,1>1,6>1eo,-1ee>1,3>1mg,-1me>1mk,-1mj>1mi,-1mg>1mi,-1md>1,1>1,+2,1>10k,-103>1,1>1,4>1,5>1,1>1,+10,3>1,1>8,-7>8,+1,-6>7,+1,a>1,1>1,u>1,u6>1,1>1,+5,26>1,1>1,2>1,2>2,8>1,7>1,4>1,1>1,+5,b8>1,1>1,+3,1>3,-2>1,2>1,1>1,+2,c>1,3>1,1>1,+2,h>1,3>1,a>1,1>1,2>1,3>1,1>1,d>1,f>1,3>1,1a>1,1>1,6>1,7>1,13>1,k>1,1>1,+19,4>1,1>1,+2,2>1,1>1,+18,m>1,a>1,1>1,lk>1,1>1,4>1,2>1,f>1,3>1,1>1,+3,db>1,1>1,+3,3>1,1>1,+2,14qm>1,1>1,+1,6>1,4j>1,j>2,t>2,u>2,2>1,+1";
        var mirrorMap;
        function parse() {
            if (!mirrorMap) {
                //const start = performance.now()
                var ref = parseCharacterMap(data, true);
                var map = ref.map;
                var reverseMap = ref.reverseMap;
                // Combine both maps into one
                reverseMap.forEach(function(value, key) {
                    map.set(key, value);
                });
                mirrorMap = map;
            //console.log(`mirrored chars parsed in ${performance.now() - start}ms`)
            }
        }
        function getMirroredCharacter(char) {
            parse();
            return mirrorMap.get(char) || null;
        }
        /**
   * Given a string and its resolved embedding levels, build a map of indices to replacement chars
   * for any characters in right-to-left segments that have defined mirrored characters.
   * @param string
   * @param embeddingLevels
   * @param [start]
   * @param [end]
   * @return {Map<number, string>}
   */ function getMirroredCharactersMap(string, embeddingLevels, start, end) {
            var strLen = string.length;
            start = Math.max(0, start == null ? 0 : +start);
            end = Math.min(strLen - 1, end == null ? strLen - 1 : +end);
            var map = new Map();
            for(var i = start; i <= end; i++)if (embeddingLevels[i] & 1) {
                var mirror = getMirroredCharacter(string[i]);
                if (mirror !== null) map.set(i, mirror);
            }
            return map;
        }
        /**
   * Given a start and end denoting a single line within a string, and a set of precalculated
   * bidi embedding levels, produce a list of segments whose ordering should be flipped, in sequence.
   * @param {string} string - the full input string
   * @param {GetEmbeddingLevelsResult} embeddingLevelsResult - the result object from getEmbeddingLevels
   * @param {number} [start] - first character in a subset of the full string
   * @param {number} [end] - last character in a subset of the full string
   * @return {number[][]} - the list of start/end segments that should be flipped, in order.
   */ function getReorderSegments(string, embeddingLevelsResult, start, end) {
            var strLen = string.length;
            start = Math.max(0, start == null ? 0 : +start);
            end = Math.min(strLen - 1, end == null ? strLen - 1 : +end);
            var segments = [];
            embeddingLevelsResult.paragraphs.forEach(function(paragraph) {
                var lineStart = Math.max(start, paragraph.start);
                var lineEnd = Math.min(end, paragraph.end);
                if (lineStart < lineEnd) {
                    // Local slice for mutation
                    var lineLevels = embeddingLevelsResult.levels.slice(lineStart, lineEnd + 1);
                    // 3.4 L1.4: Reset any sequence of whitespace characters and/or isolate formatting characters at the
                    // end of the line to the paragraph level.
                    for(var i = lineEnd; i >= lineStart && getBidiCharType(string[i]) & TRAILING_TYPES; i--)lineLevels[i] = paragraph.level;
                    // L2. From the highest level found in the text to the lowest odd level on each line, including intermediate levels
                    // not actually present in the text, reverse any contiguous sequence of characters that are at that level or higher.
                    var maxLevel = paragraph.level;
                    var minOddLevel = Infinity;
                    for(var i$1 = 0; i$1 < lineLevels.length; i$1++){
                        var level = lineLevels[i$1];
                        if (level > maxLevel) maxLevel = level;
                        if (level < minOddLevel) minOddLevel = level | 1;
                    }
                    for(var lvl = maxLevel; lvl >= minOddLevel; lvl--){
                        for(var i$2 = 0; i$2 < lineLevels.length; i$2++)if (lineLevels[i$2] >= lvl) {
                            var segStart = i$2;
                            while(i$2 + 1 < lineLevels.length && lineLevels[i$2 + 1] >= lvl)i$2++;
                            if (i$2 > segStart) segments.push([
                                segStart + lineStart,
                                i$2 + lineStart
                            ]);
                        }
                    }
                }
            });
            return segments;
        }
        /**
   * @param {string} string
   * @param {GetEmbeddingLevelsResult} embedLevelsResult
   * @param {number} [start]
   * @param {number} [end]
   * @return {string} the new string with bidi segments reordered
   */ function getReorderedString(string, embedLevelsResult, start, end) {
            var indices = getReorderedIndices(string, embedLevelsResult, start, end);
            var chars = [].concat(string);
            indices.forEach(function(charIndex, i) {
                chars[i] = (embedLevelsResult.levels[charIndex] & 1 ? getMirroredCharacter(string[charIndex]) : null) || string[charIndex];
            });
            return chars.join('');
        }
        /**
   * @param {string} string
   * @param {GetEmbeddingLevelsResult} embedLevelsResult
   * @param {number} [start]
   * @param {number} [end]
   * @return {number[]} an array with character indices in their new bidi order
   */ function getReorderedIndices(string, embedLevelsResult, start, end) {
            var segments = getReorderSegments(string, embedLevelsResult, start, end);
            // Fill an array with indices
            var indices = [];
            for(var i = 0; i < string.length; i++)indices[i] = i;
            // Reverse each segment in order
            segments.forEach(function(ref) {
                var _$start = ref[0];
                var _$end = ref[1];
                var slice = indices.slice(_$start, _$end + 1);
                for(var i = slice.length; i--;)indices[_$end - i] = slice[i];
            });
            return indices;
        }
        exports.closingToOpeningBracket = closingToOpeningBracket;
        exports.getBidiCharType = getBidiCharType;
        exports.getBidiCharTypeName = getBidiCharTypeName;
        exports.getCanonicalBracket = getCanonicalBracket;
        exports.getEmbeddingLevels = getEmbeddingLevels;
        exports.getMirroredCharacter = getMirroredCharacter;
        exports.getMirroredCharactersMap = getMirroredCharactersMap;
        exports.getReorderSegments = getReorderSegments;
        exports.getReorderedIndices = getReorderedIndices;
        exports.getReorderedString = getReorderedString;
        exports.openingToClosingBracket = openingToClosingBracket;
        Object.defineProperty(exports, '__esModule', {
            value: true
        });
        return exports;
    }({});
    return bidi;
}
var $031b8ddc392a3293$export$2e2bcd8739ae039 = $031b8ddc392a3293$var$bidiFactory;







/**
 * Regular expression for matching the `void main() {` opener line in GLSL.
 * @type {RegExp}
 */ var $00dca729031a266b$export$f402b5c74ecf5e1e = /\bvoid\s+main\s*\(\s*\)\s*{/g;
/**
 * Recursively expands all `#include <xyz>` statements within string of shader code.
 * Copied from three's WebGLProgram#parseIncludes for external use.
 *
 * @param {string} source - The GLSL source code to evaluate
 * @return {string} The GLSL code with all includes expanded
 */ function $00dca729031a266b$export$bec7143e67d6a2ef(source) {
    var pattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
    function replace(match, include) {
        var chunk = (0, $079becb54c0579a9$export$955f9f2e84c43c8b)[include];
        return chunk ? $00dca729031a266b$export$bec7143e67d6a2ef(chunk) : match;
    }
    return source.replace(pattern, replace);
}
/*
 * This is a direct copy of MathUtils.generateUUID from Three.js, to preserve compatibility with three
 * versions before 0.113.0 as it was changed from Math to MathUtils in that version.
 * https://github.com/mrdoob/three.js/blob/dd8b5aa3b270c17096b90945cd2d6d1b13aaec53/src/math/MathUtils.js#L16
 */ var $00dca729031a266b$var$_lut = [];
for(var $00dca729031a266b$var$i = 0; $00dca729031a266b$var$i < 256; $00dca729031a266b$var$i++)$00dca729031a266b$var$_lut[$00dca729031a266b$var$i] = ($00dca729031a266b$var$i < 16 ? '0' : '') + $00dca729031a266b$var$i.toString(16);
function $00dca729031a266b$var$generateUUID() {
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
    var d0 = Math.random() * 0xffffffff | 0;
    var d1 = Math.random() * 0xffffffff | 0;
    var d2 = Math.random() * 0xffffffff | 0;
    var d3 = Math.random() * 0xffffffff | 0;
    var uuid = $00dca729031a266b$var$_lut[d0 & 0xff] + $00dca729031a266b$var$_lut[d0 >> 8 & 0xff] + $00dca729031a266b$var$_lut[d0 >> 16 & 0xff] + $00dca729031a266b$var$_lut[d0 >> 24 & 0xff] + '-' + $00dca729031a266b$var$_lut[d1 & 0xff] + $00dca729031a266b$var$_lut[d1 >> 8 & 0xff] + '-' + $00dca729031a266b$var$_lut[d1 >> 16 & 0x0f | 0x40] + $00dca729031a266b$var$_lut[d1 >> 24 & 0xff] + '-' + $00dca729031a266b$var$_lut[d2 & 0x3f | 0x80] + $00dca729031a266b$var$_lut[d2 >> 8 & 0xff] + '-' + $00dca729031a266b$var$_lut[d2 >> 16 & 0xff] + $00dca729031a266b$var$_lut[d2 >> 24 & 0xff] + $00dca729031a266b$var$_lut[d3 & 0xff] + $00dca729031a266b$var$_lut[d3 >> 8 & 0xff] + $00dca729031a266b$var$_lut[d3 >> 16 & 0xff] + $00dca729031a266b$var$_lut[d3 >> 24 & 0xff];
    // .toUpperCase() here flattens concatenated strings to save heap memory space.
    return uuid.toUpperCase();
}
// Local assign polyfill to avoid importing troika-core
var $00dca729031a266b$var$assign = Object.assign || function() {
    var target = arguments[0];
    for(var i = 1, len = arguments.length; i < len; i++){
        var source = arguments[i];
        if (source) {
            for(var prop in source)if (Object.prototype.hasOwnProperty.call(source, prop)) target[prop] = source[prop];
        }
    }
    return target;
};
var $00dca729031a266b$var$epoch = Date.now();
var $00dca729031a266b$var$CONSTRUCTOR_CACHE = new WeakMap();
var $00dca729031a266b$var$SHADER_UPGRADE_CACHE = new Map();
// Material ids must be integers, but we can't access the increment from Three's `Material` module,
// so let's choose a sufficiently large starting value that should theoretically never collide.
var $00dca729031a266b$var$materialInstanceId = 1e10;
/**
 * A utility for creating a custom shader material derived from another material's
 * shaders. This allows you to inject custom shader logic and transforms into the
 * builtin ThreeJS materials without having to recreate them from scratch.
 *
 * @param {THREE.Material} baseMaterial - the original material to derive from
 *
 * @param {Object} options - How the base material should be modified.
 * @param {Object} options.defines - Custom `defines` for the material
 * @param {Object} options.extensions - Custom `extensions` for the material, e.g. `{derivatives: true}`
 * @param {Object} options.uniforms - Custom `uniforms` for use in the modified shader. These can
 *        be accessed and manipulated via the resulting material's `uniforms` property, just like
 *        in a ShaderMaterial. You do not need to repeat the base material's own uniforms here.
 * @param {String} options.timeUniform - If specified, a uniform of this name will be injected into
 *        both shaders, and it will automatically be updated on each render frame with a number of
 *        elapsed milliseconds. The "zero" epoch time is not significant so don't rely on this as a
 *        true calendar time.
 * @param {String} options.vertexDefs - Custom GLSL code to inject into the vertex shader's top-level
 *        definitions, above the `void main()` function.
 * @param {String} options.vertexMainIntro - Custom GLSL code to inject at the top of the vertex
 *        shader's `void main` function.
 * @param {String} options.vertexMainOutro - Custom GLSL code to inject at the end of the vertex
 *        shader's `void main` function.
 * @param {String} options.vertexTransform - Custom GLSL code to manipulate the `position`, `normal`,
 *        and/or `uv` vertex attributes. This code will be wrapped within a standalone function with
 *        those attributes exposed by their normal names as read/write values.
 * @param {String} options.fragmentDefs - Custom GLSL code to inject into the fragment shader's top-level
 *        definitions, above the `void main()` function.
 * @param {String} options.fragmentMainIntro - Custom GLSL code to inject at the top of the fragment
 *        shader's `void main` function.
 * @param {String} options.fragmentMainOutro - Custom GLSL code to inject at the end of the fragment
 *        shader's `void main` function. You can manipulate `gl_FragColor` here but keep in mind it goes
 *        after any of ThreeJS's color postprocessing shader chunks (tonemapping, fog, etc.), so if you
 *        want those to apply to your changes use `fragmentColorTransform` instead.
 * @param {String} options.fragmentColorTransform - Custom GLSL code to manipulate the `gl_FragColor`
 *        output value. Will be injected near the end of the `void main` function, but before any
 *        of ThreeJS's color postprocessing shader chunks (tonemapping, fog, etc.), and before the
 *        `fragmentMainOutro`.
 * @param {function<{vertexShader,fragmentShader}>:{vertexShader,fragmentShader}} options.customRewriter - A function
 *        for performing custom rewrites of the full shader code. Useful if you need to do something
 *        special that's not covered by the other builtin options. This function will be executed before
 *        any other transforms are applied.
 * @param {boolean} options.chained - Set to `true` to prototype-chain the derived material to the base
 *        material, rather than the default behavior of copying it. This allows the derived material to
 *        automatically pick up changes made to the base material and its properties. This can be useful
 *        where the derived material is hidden from the user as an implementation detail, allowing them
 *        to work with the original material like normal. But it can result in unexpected behavior if not
 *        handled carefully.
 *
 * @return {THREE.Material}
 *
 * The returned material will also have two new methods, `getDepthMaterial()` and `getDistanceMaterial()`,
 * which can be called to get a variant of the derived material for use in shadow casting. If the
 * target mesh is expected to cast shadows, then you can assign these to the mesh's `customDepthMaterial`
 * (for directional and spot lights) and/or `customDistanceMaterial` (for point lights) properties to
 * allow the cast shadow to honor your derived shader's vertex transforms and discarded fragments. These
 * will also set a custom `#define IS_DEPTH_MATERIAL` or `#define IS_DISTANCE_MATERIAL` that you can look
 * for in your derived shaders with `#ifdef` to customize their behavior for the depth or distance
 * scenarios, e.g. skipping antialiasing or expensive shader logic.
 */ function $00dca729031a266b$export$9251ec91c7de57b5(baseMaterial, options) {
    // Generate a key that is unique to the content of these `options`. We'll use this
    // throughout for caching and for generating the upgraded shader code. This increases
    // the likelihood that the resulting shaders will line up across multiple calls so
    // their GL programs can be shared and cached.
    var optionsKey = $00dca729031a266b$var$getKeyForOptions(options);
    // First check to see if we've already derived from this baseMaterial using this
    // unique set of options, and if so reuse the constructor to avoid some allocations.
    var ctorsByDerivation = $00dca729031a266b$var$CONSTRUCTOR_CACHE.get(baseMaterial);
    if (!ctorsByDerivation) $00dca729031a266b$var$CONSTRUCTOR_CACHE.set(baseMaterial, ctorsByDerivation = Object.create(null));
    if (ctorsByDerivation[optionsKey]) return new ctorsByDerivation[optionsKey]();
    var privateBeforeCompileProp = "_onBeforeCompile".concat(optionsKey);
    // Private onBeforeCompile handler that injects the modified shaders and uniforms when
    // the renderer switches to this material's program
    var onBeforeCompile = function onBeforeCompile(shaderInfo, renderer) {
        baseMaterial.onBeforeCompile.call(this, shaderInfo, renderer);
        // Upgrade the shaders, caching the result by incoming source code
        var cacheKey = this.customProgramCacheKey() + '|' + shaderInfo.vertexShader + '|' + shaderInfo.fragmentShader;
        var upgradedShaders = $00dca729031a266b$var$SHADER_UPGRADE_CACHE[cacheKey];
        if (!upgradedShaders) {
            var upgraded = $00dca729031a266b$var$upgradeShaders(this, shaderInfo, options, optionsKey);
            upgradedShaders = $00dca729031a266b$var$SHADER_UPGRADE_CACHE[cacheKey] = upgraded;
        }
        // Inject upgraded shaders and uniforms into the program
        shaderInfo.vertexShader = upgradedShaders.vertexShader;
        shaderInfo.fragmentShader = upgradedShaders.fragmentShader;
        $00dca729031a266b$var$assign(shaderInfo.uniforms, this.uniforms);
        // Inject auto-updating time uniform if requested
        if (options.timeUniform) shaderInfo.uniforms[options.timeUniform] = {
            get value () {
                return Date.now() - $00dca729031a266b$var$epoch;
            }
        };
        // Users can still add their own handlers on top of ours
        if (this[privateBeforeCompileProp]) this[privateBeforeCompileProp](shaderInfo);
    };
    var DerivedMaterial = function DerivedMaterial() {
        return derive(options.chained ? baseMaterial : baseMaterial.clone());
    };
    var derive = function derive(base) {
        // Prototype chain to the base material
        var derived = Object.create(base, descriptor);
        // Store the baseMaterial for reference; this is always the original even when cloning
        Object.defineProperty(derived, 'baseMaterial', {
            value: baseMaterial
        });
        // Needs its own ids
        Object.defineProperty(derived, 'id', {
            value: $00dca729031a266b$var$materialInstanceId++
        });
        derived.uuid = $00dca729031a266b$var$generateUUID();
        // Merge uniforms, defines, and extensions
        derived.uniforms = $00dca729031a266b$var$assign({}, base.uniforms, options.uniforms);
        derived.defines = $00dca729031a266b$var$assign({}, base.defines, options.defines);
        derived.defines["TROIKA_DERIVED_MATERIAL_".concat(optionsKey)] = ''; //force a program change from the base material
        derived.extensions = $00dca729031a266b$var$assign({}, base.extensions, options.extensions);
        // Don't inherit EventDispatcher listeners
        derived._listeners = undefined;
        return derived;
    };
    var descriptor = {
        constructor: {
            value: DerivedMaterial
        },
        isDerivedMaterial: {
            value: true
        },
        customProgramCacheKey: {
            writable: true,
            configurable: true,
            value: function value() {
                return baseMaterial.customProgramCacheKey() + '|' + optionsKey;
            }
        },
        onBeforeCompile: {
            get: function() {
                return onBeforeCompile;
            },
            set: function(fn) {
                this[privateBeforeCompileProp] = fn;
            }
        },
        copy: {
            writable: true,
            configurable: true,
            value: function value(source) {
                baseMaterial.copy.call(this, source);
                if (!baseMaterial.isShaderMaterial && !baseMaterial.isDerivedMaterial) {
                    $00dca729031a266b$var$assign(this.extensions, source.extensions);
                    $00dca729031a266b$var$assign(this.defines, source.defines);
                    $00dca729031a266b$var$assign(this.uniforms, (0, $1a55656020b89c3a$export$d8ecdf8615bfea69).clone(source.uniforms));
                }
                return this;
            }
        },
        clone: {
            writable: true,
            configurable: true,
            value: function value() {
                var newBase = new baseMaterial.constructor();
                return derive(newBase).copy(this);
            }
        },
        /**
     * Utility to get a MeshDepthMaterial that will honor this derived material's vertex
     * transformations and discarded fragments.
     */ getDepthMaterial: {
            writable: true,
            configurable: true,
            value: function value() {
                var depthMaterial = this._depthMaterial;
                if (!depthMaterial) {
                    depthMaterial = this._depthMaterial = $00dca729031a266b$export$9251ec91c7de57b5(baseMaterial.isDerivedMaterial ? baseMaterial.getDepthMaterial() : new (0, $1a55656020b89c3a$export$2698c22ec13825db)({
                        depthPacking: (0, $1a55656020b89c3a$export$8f910f4c4f73df11)
                    }), options);
                    depthMaterial.defines.IS_DEPTH_MATERIAL = '';
                    depthMaterial.uniforms = this.uniforms; //automatically recieve same uniform values
                }
                return depthMaterial;
            }
        },
        /**
     * Utility to get a MeshDistanceMaterial that will honor this derived material's vertex
     * transformations and discarded fragments.
     */ getDistanceMaterial: {
            writable: true,
            configurable: true,
            value: function value() {
                var distanceMaterial = this._distanceMaterial;
                if (!distanceMaterial) {
                    distanceMaterial = this._distanceMaterial = $00dca729031a266b$export$9251ec91c7de57b5(baseMaterial.isDerivedMaterial ? baseMaterial.getDistanceMaterial() : new (0, $1a55656020b89c3a$export$33e187ed002f2a19)(), options);
                    distanceMaterial.defines.IS_DISTANCE_MATERIAL = '';
                    distanceMaterial.uniforms = this.uniforms; //automatically recieve same uniform values
                }
                return distanceMaterial;
            }
        },
        dispose: {
            writable: true,
            configurable: true,
            value: function() {
                var _this = this, _depthMaterial = _this._depthMaterial, _distanceMaterial = _this._distanceMaterial;
                if (_depthMaterial) _depthMaterial.dispose();
                if (_distanceMaterial) _distanceMaterial.dispose();
                baseMaterial.dispose.call(this);
            }
        }
    };
    ctorsByDerivation[optionsKey] = DerivedMaterial;
    return new DerivedMaterial();
}
function $00dca729031a266b$var$upgradeShaders(material, param, options, key) {
    var vertexShader = param.vertexShader, fragmentShader = param.fragmentShader;
    var vertexDefs = options.vertexDefs, vertexMainIntro = options.vertexMainIntro, vertexMainOutro = options.vertexMainOutro, vertexTransform = options.vertexTransform, fragmentDefs = options.fragmentDefs, fragmentMainIntro = options.fragmentMainIntro, fragmentMainOutro = options.fragmentMainOutro, fragmentColorTransform = options.fragmentColorTransform, customRewriter = options.customRewriter, timeUniform = options.timeUniform;
    vertexDefs = vertexDefs || '';
    vertexMainIntro = vertexMainIntro || '';
    vertexMainOutro = vertexMainOutro || '';
    fragmentDefs = fragmentDefs || '';
    fragmentMainIntro = fragmentMainIntro || '';
    fragmentMainOutro = fragmentMainOutro || '';
    // Expand includes if needed
    if (vertexTransform || customRewriter) vertexShader = $00dca729031a266b$export$bec7143e67d6a2ef(vertexShader);
    if (fragmentColorTransform || customRewriter) {
        // We need to be able to find postprocessing chunks after include expansion in order to
        // put them after the fragmentColorTransform, so mark them with comments first. Even if
        // this particular derivation doesn't have a fragmentColorTransform, other derivations may,
        // so we still mark them.
        fragmentShader = fragmentShader.replace(/^[ \t]*#include <((?:tonemapping|encodings|fog|premultiplied_alpha|dithering)_fragment)>/gm, '\n//!BEGIN_POST_CHUNK $1\n$&\n//!END_POST_CHUNK\n');
        fragmentShader = $00dca729031a266b$export$bec7143e67d6a2ef(fragmentShader);
    }
    // Apply custom rewriter function
    if (customRewriter) {
        var res = customRewriter({
            vertexShader: vertexShader,
            fragmentShader: fragmentShader
        });
        vertexShader = res.vertexShader;
        fragmentShader = res.fragmentShader;
    }
    // The fragmentColorTransform needs to go before any postprocessing chunks, so extract
    // those and re-insert them into the outro in the correct place:
    if (fragmentColorTransform) {
        var postChunks = [];
        fragmentShader = fragmentShader.replace(/^\/\/!BEGIN_POST_CHUNK[^]+?^\/\/!END_POST_CHUNK/gm, function(match) {
            postChunks.push(match);
            return '';
        });
        fragmentMainOutro = "".concat(fragmentColorTransform, "\n").concat(postChunks.join('\n'), "\n").concat(fragmentMainOutro);
    }
    // Inject auto-updating time uniform if requested
    if (timeUniform) {
        var code = "\nuniform float ".concat(timeUniform, ";\n");
        vertexDefs = code + vertexDefs;
        fragmentDefs = code + fragmentDefs;
    }
    // Inject a function for the vertexTransform and rename all usages of position/normal/uv
    if (vertexTransform) {
        // Hoist these defs to the very top so they work in other function defs
        vertexShader = "vec3 troika_position_".concat(key, ";\nvec3 troika_normal_").concat(key, ";\nvec2 troika_uv_").concat(key, ";\n").concat(vertexShader, "\n");
        vertexDefs = "".concat(vertexDefs, "\nvoid troikaVertexTransform").concat(key, "(inout vec3 position, inout vec3 normal, inout vec2 uv) {\n  ").concat(vertexTransform, "\n}\n");
        vertexMainIntro = "\ntroika_position_".concat(key, " = vec3(position);\ntroika_normal_").concat(key, " = vec3(normal);\ntroika_uv_").concat(key, " = vec2(uv);\ntroikaVertexTransform").concat(key, "(troika_position_").concat(key, ", troika_normal_").concat(key, ", troika_uv_").concat(key, ");\n").concat(vertexMainIntro, "\n");
        vertexShader = vertexShader.replace(/\b(position|normal|uv)\b/g, function(match, match1, index, fullStr) {
            return /\battribute\s+vec[23]\s+$/.test(fullStr.substr(0, index)) ? match1 : "troika_".concat(match1, "_").concat(key);
        });
        // Three r152 introduced the MAP_UV token, replace it too if it's pointing to the main 'uv'
        // Perhaps the other textures too going forward?
        if (!(material.map && material.map.channel > 0)) vertexShader = vertexShader.replace(/\bMAP_UV\b/g, "troika_uv_".concat(key));
    }
    // Inject defs and intro/outro snippets
    vertexShader = $00dca729031a266b$var$injectIntoShaderCode(vertexShader, key, vertexDefs, vertexMainIntro, vertexMainOutro);
    fragmentShader = $00dca729031a266b$var$injectIntoShaderCode(fragmentShader, key, fragmentDefs, fragmentMainIntro, fragmentMainOutro);
    return {
        vertexShader: vertexShader,
        fragmentShader: fragmentShader
    };
}
function $00dca729031a266b$var$injectIntoShaderCode(shaderCode, id, defs, intro, outro) {
    if (intro || outro || defs) {
        shaderCode = shaderCode.replace($00dca729031a266b$export$f402b5c74ecf5e1e, "\n".concat(defs, "\nvoid troikaOrigMain").concat(id, "() {"));
        shaderCode += "\nvoid main() {\n  ".concat(intro, "\n  troikaOrigMain").concat(id, "();\n  ").concat(outro, "\n}");
    }
    return shaderCode;
}
function $00dca729031a266b$var$optionsJsonReplacer(key, value) {
    return key === 'uniforms' ? undefined : typeof value === 'function' ? value.toString() : value;
}
var $00dca729031a266b$var$_idCtr = 0;
var $00dca729031a266b$var$optionsHashesToIds = new Map();
function $00dca729031a266b$var$getKeyForOptions(options) {
    var optionsHash = JSON.stringify(options, $00dca729031a266b$var$optionsJsonReplacer);
    var id = $00dca729031a266b$var$optionsHashesToIds.get(optionsHash);
    if (id == null) $00dca729031a266b$var$optionsHashesToIds.set(optionsHash, id = ++$00dca729031a266b$var$_idCtr);
    return id;
}
// Copied from threejs WebGLPrograms.js so we can resolve builtin materials to their shaders
// TODO how can we keep this from getting stale?
var $00dca729031a266b$var$MATERIAL_TYPES_TO_SHADERS = {
    MeshDepthMaterial: 'depth',
    MeshDistanceMaterial: 'distanceRGBA',
    MeshNormalMaterial: 'normal',
    MeshBasicMaterial: 'basic',
    MeshLambertMaterial: 'lambert',
    MeshPhongMaterial: 'phong',
    MeshToonMaterial: 'toon',
    MeshStandardMaterial: 'physical',
    MeshPhysicalMaterial: 'physical',
    MeshMatcapMaterial: 'matcap',
    LineBasicMaterial: 'basic',
    LineDashedMaterial: 'dashed',
    PointsMaterial: 'points',
    ShadowMaterial: 'shadow',
    SpriteMaterial: 'sprite'
};
/**
 * Given a Three.js `Material` instance, find the shaders/uniforms that will be
 * used to render that material.
 *
 * @param material - the Material instance
 * @return {object} - the material's shader info: `{uniforms:{}, fragmentShader:'', vertexShader:''}`
 */ function $00dca729031a266b$export$45b4115c5d90bd21(material) {
    var builtinType = $00dca729031a266b$var$MATERIAL_TYPES_TO_SHADERS[material.type];
    return builtinType ? (0, $079becb54c0579a9$export$bee4a7d47f8f5014)[builtinType] : material //TODO fallback for unknown type?
    ;
}
/**
 * Find all uniforms and their types within a shader code string.
 *
 * @param {string} shader - The shader code to parse
 * @return {object} mapping of uniform names to their glsl type
 */ function $00dca729031a266b$export$c7d2dd72fdbc2421(shader) {
    var uniformRE = /\buniform\s+(int|float|vec[234]|mat[34])\s+([A-Za-z_][\w]*)/g;
    var uniforms = Object.create(null);
    var match;
    while((match = uniformRE.exec(shader)) !== null)uniforms[match[2]] = match[1];
    return uniforms;
}
/**
 * Helper for smoothing out the `m.getInverse(x)` --> `m.copy(x).invert()` conversion
 * that happened in ThreeJS r123.
 * @param {Matrix4} srcMatrix
 * @param {Matrix4} [tgtMatrix]
 */ function $00dca729031a266b$export$3425937be2407bfa(srcMatrix) {
    var tgtMatrix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new (0, $1a55656020b89c3a$export$2ae72fc923e5eb5)();
    if (typeof tgtMatrix.invert === 'function') tgtMatrix.copy(srcMatrix).invert();
    else tgtMatrix.getInverse(srcMatrix);
    return tgtMatrix;
}
/*
Input geometry is a cylinder with r=1, height in y dimension from 0 to 1,
divided into a reasonable number of height segments.
*/ var $00dca729031a266b$var$vertexDefs = "\nuniform vec3 pointA;\nuniform vec3 controlA;\nuniform vec3 controlB;\nuniform vec3 pointB;\nuniform float radius;\nvarying float bezierT;\n\nvec3 cubicBezier(vec3 p1, vec3 c1, vec3 c2, vec3 p2, float t) {\n  float t2 = 1.0 - t;\n  float b0 = t2 * t2 * t2;\n  float b1 = 3.0 * t * t2 * t2;\n  float b2 = 3.0 * t * t * t2;\n  float b3 = t * t * t;\n  return b0 * p1 + b1 * c1 + b2 * c2 + b3 * p2;\n}\n\nvec3 cubicBezierDerivative(vec3 p1, vec3 c1, vec3 c2, vec3 p2, float t) {\n  float t2 = 1.0 - t;\n  return -3.0 * p1 * t2 * t2 +\n    c1 * (3.0 * t2 * t2 - 6.0 * t2 * t) +\n    c2 * (6.0 * t2 * t - 3.0 * t * t) +\n    3.0 * p2 * t * t;\n}\n";
var $00dca729031a266b$var$vertexTransform = '\nfloat t = position.y;\nbezierT = t;\nvec3 bezierCenterPos = cubicBezier(pointA, controlA, controlB, pointB, t);\nvec3 bezierDir = normalize(cubicBezierDerivative(pointA, controlA, controlB, pointB, t));\n\n// Make "sideways" always perpendicular to the camera ray; this ensures that any twists\n// in the cylinder occur where you won\'t see them: \nvec3 viewDirection = normalMatrix * vec3(0.0, 0.0, 1.0);\nif (bezierDir == viewDirection) {\n  bezierDir = normalize(cubicBezierDerivative(pointA, controlA, controlB, pointB, t == 1.0 ? t - 0.0001 : t + 0.0001));\n}\nvec3 sideways = normalize(cross(bezierDir, viewDirection));\nvec3 upish = normalize(cross(sideways, bezierDir));\n\n// Build a matrix for transforming this disc in the cylinder:\nmat4 discTx;\ndiscTx[0].xyz = sideways * radius;\ndiscTx[1].xyz = bezierDir * radius;\ndiscTx[2].xyz = upish * radius;\ndiscTx[3].xyz = bezierCenterPos;\ndiscTx[3][3] = 1.0;\n\n// Apply transform, ignoring original y\nposition = (discTx * vec4(position.x, 0.0, position.z, 1.0)).xyz;\nnormal = normalize(mat3(discTx) * normal);\n';
var $00dca729031a266b$var$fragmentDefs = "\nuniform vec3 dashing;\nvarying float bezierT;\n";
var $00dca729031a266b$var$fragmentMainIntro = "\nif (dashing.x + dashing.y > 0.0) {\n  float dashFrac = mod(bezierT - dashing.z, dashing.x + dashing.y);\n  if (dashFrac > dashing.x) {\n    discard;\n  }\n}\n";
// Debugging: separate color for each of the 6 sides:
// const fragmentColorTransform = `
// float sideNum = floor(vUV.x * 6.0);
// vec3 mixColor = sideNum < 1.0 ? vec3(1.0, 0.0, 0.0) :
//   sideNum < 2.0 ? vec3(0.0, 1.0, 1.0) :
//   sideNum < 3.0 ? vec3(1.0, 1.0, 0.0) :
//   sideNum < 4.0 ? vec3(0.0, 0.0, 1.0) :
//   sideNum < 5.0 ? vec3(0.0, 1.0, 0.0) :
//   vec3(1.0, 0.0, 1.0);
// gl_FragColor.xyz = mix(gl_FragColor.xyz, mixColor, 0.5);
// `
function $00dca729031a266b$var$createBezierMeshMaterial(baseMaterial) {
    return $00dca729031a266b$export$9251ec91c7de57b5(baseMaterial, {
        chained: true,
        uniforms: {
            pointA: {
                value: new (0, $1a55656020b89c3a$export$64b5c384219d3699)()
            },
            controlA: {
                value: new (0, $1a55656020b89c3a$export$64b5c384219d3699)()
            },
            controlB: {
                value: new (0, $1a55656020b89c3a$export$64b5c384219d3699)()
            },
            pointB: {
                value: new (0, $1a55656020b89c3a$export$64b5c384219d3699)()
            },
            radius: {
                value: 0.01
            },
            dashing: {
                value: new (0, $1a55656020b89c3a$export$64b5c384219d3699)()
            } //on, off, offset
        },
        vertexDefs: $00dca729031a266b$var$vertexDefs,
        vertexTransform: $00dca729031a266b$var$vertexTransform,
        fragmentDefs: $00dca729031a266b$var$fragmentDefs,
        fragmentMainIntro: $00dca729031a266b$var$fragmentMainIntro
    });
}
var $00dca729031a266b$var$geometry = null;
var $00dca729031a266b$var$defaultBaseMaterial = /*#__PURE__*/ new (0, $1a55656020b89c3a$export$f2980790215acccd)({
    color: 0xffffff,
    side: (0, $1a55656020b89c3a$export$3b296b6f144d5b03)
});
/**
 * A ThreeJS `Mesh` that bends a tube shape along a 3D cubic bezier path. The bending is done
 * by deforming a straight cylindrical geometry in the vertex shader based on a set of four
 * control point uniforms. It patches the necessary GLSL into the mesh's assigned `material`
 * automatically.
 *
 * The cubiz bezier path is determined by its four `Vector3` properties:
 * - `pointA`
 * - `controlA`
 * - `controlB`
 * - `pointB`
 *
 * The tube's radius is controlled by its `radius` property, which defaults to `0.01`.
 *
 * You can also give the tube a dashed appearance with two properties:
 *
 * - `dashArray` - an array of two numbers, defining the length of "on" and "off" parts of
 *   the dash. Each is a 0-1 ratio of the entire path's length. (Actually this is the `t` length
 *   used as input to the cubic bezier function, not its visible length.)
 * - `dashOffset` - offset of where the dash starts. You can animate this to make the dashes move.
 *
 * Note that the dashes will appear like a hollow tube, not solid. This will be more apparent on
 * thicker tubes.
 *
 * TODO: proper geometry bounding sphere and raycasting
 * TODO: allow control of the geometry's segment counts
 */ var $00dca729031a266b$export$5f27619f2db8836e = /*#__PURE__*/ function(Mesh) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(BezierMesh, Mesh);
    function BezierMesh() {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, BezierMesh);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, BezierMesh, [
            BezierMesh.getGeometry(),
            $00dca729031a266b$var$defaultBaseMaterial
        ]);
        _this.pointA = new (0, $1a55656020b89c3a$export$64b5c384219d3699)();
        _this.controlA = new (0, $1a55656020b89c3a$export$64b5c384219d3699)();
        _this.controlB = new (0, $1a55656020b89c3a$export$64b5c384219d3699)();
        _this.pointB = new (0, $1a55656020b89c3a$export$64b5c384219d3699)();
        _this.radius = 0.01;
        _this.dashArray = new (0, $1a55656020b89c3a$export$c977b3e384af9ae1)();
        _this.dashOffset = 0;
        // TODO - disabling frustum culling until I figure out how to customize the
        //  geometry's bounding sphere that gets used
        _this.frustumCulled = false;
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(BezierMesh, [
        {
            key: "material",
            get: // Handler for automatically wrapping the base material with our upgrades. We do the wrapping
            // lazily on _read_ rather than write to avoid unnecessary wrapping on transient values.
            function get() {
                var derivedMaterial = this._derivedMaterial;
                var baseMaterial = this._baseMaterial || this._defaultMaterial || (this._defaultMaterial = $00dca729031a266b$var$defaultBaseMaterial.clone());
                if (!derivedMaterial || derivedMaterial.baseMaterial !== baseMaterial) {
                    derivedMaterial = this._derivedMaterial = $00dca729031a266b$var$createBezierMeshMaterial(baseMaterial);
                    // dispose the derived material when its base material is disposed:
                    baseMaterial.addEventListener('dispose', function onDispose() {
                        baseMaterial.removeEventListener('dispose', onDispose);
                        derivedMaterial.dispose();
                    });
                }
                return derivedMaterial;
            },
            set: function set(baseMaterial) {
                this._baseMaterial = baseMaterial;
            }
        },
        {
            key: "customDepthMaterial",
            get: // Create and update material for shadows upon request:
            function get() {
                return this.material.getDepthMaterial();
            }
        },
        {
            key: "customDistanceMaterial",
            get: function get() {
                return this.material.getDistanceMaterial();
            }
        },
        {
            key: "onBeforeRender",
            value: function onBeforeRender() {
                var uniforms = this.material.uniforms;
                var _this = this, pointA = _this.pointA, controlA = _this.controlA, controlB = _this.controlB, pointB = _this.pointB, radius = _this.radius, dashArray = _this.dashArray, dashOffset = _this.dashOffset;
                uniforms.pointA.value.copy(pointA);
                uniforms.controlA.value.copy(controlA);
                uniforms.controlB.value.copy(controlB);
                uniforms.pointB.value.copy(pointB);
                uniforms.radius.value = radius;
                uniforms.dashing.value.set(dashArray.x, dashArray.y, dashOffset || 0);
            }
        },
        {
            key: "raycast",
            value: function raycast() {
            // TODO - just fail for now
            }
        }
    ], [
        {
            key: "getGeometry",
            value: function getGeometry() {
                return $00dca729031a266b$var$geometry || ($00dca729031a266b$var$geometry = new (0, $1a55656020b89c3a$export$68f745719dbe5198)(1, 1, 1, 6, 64).translate(0, 0.5, 0));
            }
        }
    ]);
    return BezierMesh;
}((0, $1a55656020b89c3a$export$e176487c05830cc5));


/**
 * Factory function that creates a self-contained environment for processing text typesetting requests.
 *
 * It is important that this function has no closure dependencies, so that it can be easily injected
 * into the source for a Worker without requiring a build step or complex dependency loading. All its
 * dependencies must be passed in at initialization.
 *
 * @param {function} fontParser - a function that accepts an ArrayBuffer of the font data and returns
 * a standardized structure giving access to the font and its glyphs:
 *   {
 *     unitsPerEm: number,
 *     ascender: number,
 *     descender: number,
 *     capHeight: number,
 *     xHeight: number,
 *     lineGap: number,
 *     forEachGlyph(string, fontSize, letterSpacing, callback) {
 *       //invokes callback for each glyph to render, passing it an object:
 *       callback({
 *         index: number,
 *         advanceWidth: number,
 *         xMin: number,
 *         yMin: number,
 *         xMax: number,
 *         yMax: number,
 *         path: string,
 *         pathCommandCount: number
 *       })
 *     }
 *   }
 * @param {object} bidi - the bidi.js implementation object
 * @param {Object} config
 * @return {Object}
 */ function $6591e3ca76d1668d$var$createTypesetter(fontParser, bidi, config) {
    var defaultFontURL = config.defaultFontURL;
    /**
   * Holds parsed font objects by url
   */ var fonts = Object.create(null);
    var INF = Infinity;
    // Set of Unicode Default_Ignorable_Code_Point characters, these will not produce visible glyphs
    // eslint-disable-next-line no-misleading-character-class
    var DEFAULT_IGNORABLE_CHARS = /[\u00AD\u034F\u061C\u115F-\u1160\u17B4-\u17B5\u180B-\u180E\u200B-\u200F\u202A-\u202E\u2060-\u206F\u3164\uFE00-\uFE0F\uFEFF\uFFA0\uFFF0-\uFFF8]/;
    // This regex (instead of /\s/) allows us to select all whitespace EXCEPT for non-breaking white spaces
    var lineBreakingWhiteSpace = "[^\\S\\u00A0]";
    // Incomplete set of characters that allow line breaking after them
    // In the future we may consider a full Unicode line breaking algorithm impl: https://www.unicode.org/reports/tr14
    var BREAK_AFTER_CHARS = new RegExp("".concat(lineBreakingWhiteSpace, "|[\\-\\u007C\\u00AD\\u2010\\u2012-\\u2014\\u2027\\u2056\\u2E17\\u2E40]"));
    /**
   * Load a given font url
   */ function doLoadFont(url, callback) {
        function tryLoad() {
            var onError = function(err) {
                console.error("Failure loading font ".concat(url).concat(url === defaultFontURL ? '' : '; trying fallback'), err);
                if (url !== defaultFontURL) {
                    url = defaultFontURL;
                    tryLoad();
                }
            };
            try {
                var request = new XMLHttpRequest();
                request.open('get', url, true);
                request.responseType = 'arraybuffer';
                request.onload = function() {
                    if (request.status >= 400) onError(new Error(request.statusText));
                    else if (request.status > 0) try {
                        var fontObj = fontParser(request.response);
                        callback(fontObj);
                    } catch (e) {
                        onError(e);
                    }
                };
                request.onerror = onError;
                request.send();
            } catch (err) {
                onError(err);
            }
        }
        tryLoad();
    }
    /**
   * Load a given font url if needed, invoking a callback when it's loaded. If already
   * loaded, the callback will be called synchronously.
   */ function loadFont(fontUrl, callback) {
        if (!fontUrl) fontUrl = defaultFontURL;
        var font = fonts[fontUrl];
        if (font) {
            // if currently loading font, add to callbacks, otherwise execute immediately
            if (font.pending) font.pending.push(callback);
            else callback(font);
        } else {
            fonts[fontUrl] = {
                pending: [
                    callback
                ]
            };
            doLoadFont(fontUrl, function(fontObj) {
                var callbacks = fonts[fontUrl].pending;
                fonts[fontUrl] = fontObj;
                callbacks.forEach(function(cb) {
                    return cb(fontObj);
                });
            });
        }
    }
    /**
   * Main entry point.
   * Process a text string with given font and formatting parameters, and return all info
   * necessary to render all its glyphs.
   */ function typeset(param, callback) {
        var _param_text = param.text, text = _param_text === void 0 ? '' : _param_text, _param_font = param.font, font = _param_font === void 0 ? defaultFontURL : _param_font, _param_sdfGlyphSize = param.sdfGlyphSize, sdfGlyphSize = _param_sdfGlyphSize === void 0 ? 64 : _param_sdfGlyphSize, _param_fontSize = param.fontSize, fontSize = _param_fontSize === void 0 ? 1 : _param_fontSize, _param_letterSpacing = param.letterSpacing, letterSpacing = _param_letterSpacing === void 0 ? 0 : _param_letterSpacing, _param_lineHeight = param.lineHeight, lineHeight = _param_lineHeight === void 0 ? 'normal' : _param_lineHeight, _param_maxWidth = param.maxWidth, maxWidth = _param_maxWidth === void 0 ? INF : _param_maxWidth, direction = param.direction, _param_textAlign = param.textAlign, textAlign = _param_textAlign === void 0 ? 'left' : _param_textAlign, _param_textIndent = param.textIndent, textIndent = _param_textIndent === void 0 ? 0 : _param_textIndent, _param_whiteSpace = param.whiteSpace, whiteSpace = _param_whiteSpace === void 0 ? 'normal' : _param_whiteSpace, _param_overflowWrap = param.overflowWrap, overflowWrap = _param_overflowWrap === void 0 ? 'normal' : _param_overflowWrap, _param_anchorX = param.anchorX, anchorX = _param_anchorX === void 0 ? 0 : _param_anchorX, _param_anchorY = param.anchorY, anchorY = _param_anchorY === void 0 ? 0 : _param_anchorY, _param_includeCaretPositions = param.includeCaretPositions, includeCaretPositions = _param_includeCaretPositions === void 0 ? false : _param_includeCaretPositions, _param_chunkedBoundsSize = param.chunkedBoundsSize, chunkedBoundsSize = _param_chunkedBoundsSize === void 0 ? 8192 : _param_chunkedBoundsSize, _param_colorRanges = param.colorRanges, colorRanges = _param_colorRanges === void 0 ? null : _param_colorRanges, metricsOnly = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        var mainStart = now();
        var timings = {
            fontLoad: 0,
            typesetting: 0
        };
        // Ensure newlines are normalized
        if (text.indexOf('\r') > -1) {
            console.info('Typesetter: got text with \\r chars; normalizing to \\n');
            text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
        }
        // Ensure we've got numbers not strings
        fontSize = +fontSize;
        letterSpacing = +letterSpacing;
        maxWidth = +maxWidth;
        lineHeight = lineHeight || 'normal';
        textIndent = +textIndent;
        loadFont(font, function(fontObj) {
            var hasMaxWidth = isFinite(maxWidth);
            var glyphIds = null;
            var glyphPositions = null;
            var glyphData = null;
            var glyphColors = null;
            var caretPositions = null;
            var visibleBounds = null;
            var chunkedBounds = null;
            var maxLineWidth = 0;
            var renderableGlyphCount = 0;
            var canWrap = whiteSpace !== 'nowrap';
            var ascender = fontObj.ascender, descender = fontObj.descender, unitsPerEm = fontObj.unitsPerEm, lineGap = fontObj.lineGap, capHeight = fontObj.capHeight, xHeight = fontObj.xHeight;
            timings.fontLoad = now() - mainStart;
            var typesetStart = now();
            // Find conversion between native font units and fontSize units; this will already be done
            // for the gx/gy values below but everything else we'll need to convert
            var fontSizeMult = fontSize / unitsPerEm;
            // Determine appropriate value for 'normal' line height based on the font's actual metrics
            // TODO this does not guarantee individual glyphs won't exceed the line height, e.g. Roboto; should we use yMin/Max instead?
            if (lineHeight === 'normal') lineHeight = (ascender - descender + lineGap) / unitsPerEm;
            // Determine line height and leading adjustments
            lineHeight = lineHeight * fontSize;
            var halfLeading = (lineHeight - (ascender - descender) * fontSizeMult) / 2;
            var topBaseline = -(ascender * fontSizeMult + halfLeading);
            var caretHeight = Math.min(lineHeight, (ascender - descender) * fontSizeMult);
            var caretBottomOffset = (ascender + descender) / 2 * fontSizeMult - caretHeight / 2;
            // Distribute glyphs into lines based on wrapping
            var lineXOffset = textIndent;
            var currentLine = new TextLine();
            var lines = [
                currentLine
            ];
            fontObj.forEachGlyph(text, fontSize, letterSpacing, function(glyphObj, glyphX, charIndex) {
                var char = text.charAt(charIndex);
                var glyphWidth = glyphObj.advanceWidth * fontSizeMult;
                var curLineCount = currentLine.count;
                var nextLine;
                // Calc isWhitespace and isEmpty once per glyphObj
                if (!('isEmpty' in glyphObj)) {
                    glyphObj.isWhitespace = !!char && new RegExp(lineBreakingWhiteSpace).test(char);
                    glyphObj.canBreakAfter = !!char && BREAK_AFTER_CHARS.test(char);
                    glyphObj.isEmpty = glyphObj.xMin === glyphObj.xMax || glyphObj.yMin === glyphObj.yMax || DEFAULT_IGNORABLE_CHARS.test(char);
                }
                if (!glyphObj.isWhitespace && !glyphObj.isEmpty) renderableGlyphCount++;
                // If a non-whitespace character overflows the max width, we need to soft-wrap
                if (canWrap && hasMaxWidth && !glyphObj.isWhitespace && glyphX + glyphWidth + lineXOffset > maxWidth && curLineCount) {
                    // If it's the first char after a whitespace, start a new line
                    if (currentLine.glyphAt(curLineCount - 1).glyphObj.canBreakAfter) {
                        nextLine = new TextLine();
                        lineXOffset = -glyphX;
                    } else // Back up looking for a whitespace character to wrap at
                    for(var i = curLineCount; i--;){
                        // If we got the start of the line there's no soft break point; make hard break if overflowWrap='break-word'
                        if (i === 0 && overflowWrap === 'break-word') {
                            nextLine = new TextLine();
                            lineXOffset = -glyphX;
                            break;
                        } else if (currentLine.glyphAt(i).glyphObj.canBreakAfter) {
                            nextLine = currentLine.splitAt(i + 1);
                            var adjustX = nextLine.glyphAt(0).x;
                            lineXOffset -= adjustX;
                            for(var j = nextLine.count; j--;)nextLine.glyphAt(j).x -= adjustX;
                            break;
                        }
                    }
                    if (nextLine) {
                        currentLine.isSoftWrapped = true;
                        currentLine = nextLine;
                        lines.push(currentLine);
                        maxLineWidth = maxWidth; //after soft wrapping use maxWidth as calculated width
                    }
                }
                var fly = currentLine.glyphAt(currentLine.count);
                fly.glyphObj = glyphObj;
                fly.x = glyphX + lineXOffset;
                fly.width = glyphWidth;
                fly.charIndex = charIndex;
                // Handle hard line breaks
                if (char === '\n') {
                    currentLine = new TextLine();
                    lines.push(currentLine);
                    lineXOffset = -(glyphX + glyphWidth + letterSpacing * fontSize) + textIndent;
                }
            });
            // Calculate width of each line (excluding trailing whitespace) and maximum block width
            lines.forEach(function(line) {
                for(var i = line.count; i--;){
                    var _line_glyphAt = line.glyphAt(i), glyphObj = _line_glyphAt.glyphObj, x = _line_glyphAt.x, width = _line_glyphAt.width;
                    if (!glyphObj.isWhitespace) {
                        line.width = x + width;
                        if (line.width > maxLineWidth) maxLineWidth = line.width;
                        return;
                    }
                }
            });
            // Find overall position adjustments for anchoring
            var anchorXOffset = 0;
            var anchorYOffset = 0;
            if (anchorX) {
                if (typeof anchorX === 'number') anchorXOffset = -anchorX;
                else if (typeof anchorX === 'string') anchorXOffset = -maxLineWidth * (anchorX === 'left' ? 0 : anchorX === 'center' ? 0.5 : anchorX === 'right' ? 1 : parsePercent(anchorX));
            }
            if (anchorY) {
                if (typeof anchorY === 'number') anchorYOffset = -anchorY;
                else if (typeof anchorY === 'string') {
                    var height = lines.length * lineHeight;
                    anchorYOffset = anchorY === 'top' ? 0 : anchorY === 'top-baseline' ? -topBaseline : anchorY === 'top-cap' ? -topBaseline - capHeight * fontSizeMult : anchorY === 'top-ex' ? -topBaseline - xHeight * fontSizeMult : anchorY === 'middle' ? height / 2 : anchorY === 'bottom' ? height : anchorY === 'bottom-baseline' ? height - halfLeading + descender * fontSizeMult : parsePercent(anchorY) * height;
                }
            }
            if (!metricsOnly) {
                // Resolve bidi levels
                var bidiLevelsResult = bidi.getEmbeddingLevels(text, direction);
                // Process each line, applying alignment offsets, adding each glyph to the atlas, and
                // collecting all renderable glyphs into a single collection.
                glyphIds = new Uint16Array(renderableGlyphCount);
                glyphPositions = new Float32Array(renderableGlyphCount * 2);
                glyphData = {};
                visibleBounds = [
                    INF,
                    INF,
                    -INF,
                    -INF
                ];
                chunkedBounds = [];
                var lineYOffset = topBaseline;
                if (includeCaretPositions) caretPositions = new Float32Array(text.length * 3);
                if (colorRanges) glyphColors = new Uint8Array(renderableGlyphCount * 3);
                var renderableGlyphIndex = 0;
                var prevCharIndex = -1;
                var colorCharIndex = -1;
                var chunk;
                var currentColor;
                lines.forEach(function(line, lineIndex) {
                    var lineGlyphCount = line.count, lineWidth = line.width;
                    // Ignore empty lines
                    if (lineGlyphCount > 0) {
                        // Count trailing whitespaces, we want to ignore these for certain things
                        var trailingWhitespaceCount = 0;
                        for(var i = lineGlyphCount; i-- && line.glyphAt(i).glyphObj.isWhitespace;)trailingWhitespaceCount++;
                        // Apply horizontal alignment adjustments
                        var lineXOffset = 0;
                        var justifyAdjust = 0;
                        if (textAlign === 'center') lineXOffset = (maxLineWidth - lineWidth) / 2;
                        else if (textAlign === 'right') lineXOffset = maxLineWidth - lineWidth;
                        else if (textAlign === 'justify' && line.isSoftWrapped) {
                            // count non-trailing whitespace characters, and we'll adjust the offsets per character in the next loop
                            var whitespaceCount = 0;
                            for(var i1 = lineGlyphCount - trailingWhitespaceCount; i1--;)if (line.glyphAt(i1).glyphObj.isWhitespace) whitespaceCount++;
                            justifyAdjust = (maxLineWidth - lineWidth) / whitespaceCount;
                        }
                        if (justifyAdjust || lineXOffset) {
                            var justifyOffset = 0;
                            for(var i2 = 0; i2 < lineGlyphCount; i2++){
                                var glyphInfo = line.glyphAt(i2);
                                var glyphObj = glyphInfo.glyphObj;
                                glyphInfo.x += lineXOffset + justifyOffset;
                                // Expand non-trailing whitespaces for justify alignment
                                if (justifyAdjust !== 0 && glyphObj.isWhitespace && i2 < lineGlyphCount - trailingWhitespaceCount) {
                                    justifyOffset += justifyAdjust;
                                    glyphInfo.width += justifyAdjust;
                                }
                            }
                        }
                        // Perform bidi range flipping
                        var flips = bidi.getReorderSegments(text, bidiLevelsResult, line.glyphAt(0).charIndex, line.glyphAt(line.count - 1).charIndex);
                        for(var fi = 0; fi < flips.length; fi++){
                            var _flips_fi = (0, $cccf0333cb9f9910$export$71511d61b312f219)(flips[fi], 2), start = _flips_fi[0], end = _flips_fi[1];
                            // Map start/end string indices to indices in the line
                            var left = Infinity, right = -Infinity;
                            for(var i3 = 0; i3 < lineGlyphCount; i3++)if (line.glyphAt(i3).charIndex >= start) {
                                var startInLine = i3, endInLine = i3;
                                for(; endInLine < lineGlyphCount; endInLine++){
                                    var info = line.glyphAt(endInLine);
                                    if (info.charIndex > end) break;
                                    if (endInLine < lineGlyphCount - trailingWhitespaceCount) {
                                        left = Math.min(left, info.x);
                                        right = Math.max(right, info.x + info.width);
                                    }
                                }
                                for(var j = startInLine; j < endInLine; j++){
                                    var glyphInfo1 = line.glyphAt(j);
                                    glyphInfo1.x = right - (glyphInfo1.x + glyphInfo1.width - left);
                                }
                                break;
                            }
                        }
                        // Assemble final data arrays
                        var glyphObj1;
                        var setGlyphObj = function(g) {
                            return glyphObj1 = g;
                        };
                        for(var i4 = 0; i4 < lineGlyphCount; i4++){
                            var glyphInfo2 = line.glyphAt(i4);
                            glyphObj1 = glyphInfo2.glyphObj;
                            var glyphId = glyphObj1.index;
                            // Replace mirrored characters in rtl
                            var rtl = bidiLevelsResult.levels[glyphInfo2.charIndex] & 1; //odd level means rtl
                            if (rtl) {
                                var mirrored = bidi.getMirroredCharacter(text[glyphInfo2.charIndex]);
                                if (mirrored) fontObj.forEachGlyph(mirrored, 0, 0, setGlyphObj);
                            }
                            // Add caret positions
                            if (includeCaretPositions) {
                                var charIndex = glyphInfo2.charIndex;
                                var caretLeft = glyphInfo2.x + anchorXOffset;
                                var caretRight = glyphInfo2.x + glyphInfo2.width + anchorXOffset;
                                caretPositions[charIndex * 3] = rtl ? caretRight : caretLeft; //start edge x
                                caretPositions[charIndex * 3 + 1] = rtl ? caretLeft : caretRight; //end edge x
                                caretPositions[charIndex * 3 + 2] = lineYOffset + caretBottomOffset + anchorYOffset; //common bottom y
                                // If we skipped any chars from the previous glyph (due to ligature subs), fill in caret
                                // positions for those missing char indices; currently this uses a best-guess by dividing
                                // the ligature's width evenly. In the future we may try to use the font's LigatureCaretList
                                // table to get better interior caret positions.
                                var ligCount = charIndex - prevCharIndex;
                                if (ligCount > 1) fillLigatureCaretPositions(caretPositions, prevCharIndex, ligCount);
                                prevCharIndex = charIndex;
                            }
                            // Track current color range
                            if (colorRanges) {
                                var charIndex1 = glyphInfo2.charIndex;
                                while(charIndex1 > colorCharIndex){
                                    colorCharIndex++;
                                    if (colorRanges.hasOwnProperty(colorCharIndex)) currentColor = colorRanges[colorCharIndex];
                                }
                            }
                            // Get atlas data for renderable glyphs
                            if (!glyphObj1.isWhitespace && !glyphObj1.isEmpty) {
                                var idx = renderableGlyphIndex++;
                                // Add this glyph's path data
                                if (!glyphData[glyphId]) glyphData[glyphId] = {
                                    path: glyphObj1.path,
                                    pathBounds: [
                                        glyphObj1.xMin,
                                        glyphObj1.yMin,
                                        glyphObj1.xMax,
                                        glyphObj1.yMax
                                    ]
                                };
                                // Determine final glyph position and add to glyphPositions array
                                var glyphX = glyphInfo2.x + anchorXOffset;
                                var glyphY = lineYOffset + anchorYOffset;
                                glyphPositions[idx * 2] = glyphX;
                                glyphPositions[idx * 2 + 1] = glyphY;
                                // Track total visible bounds
                                var visX0 = glyphX + glyphObj1.xMin * fontSizeMult;
                                var visY0 = glyphY + glyphObj1.yMin * fontSizeMult;
                                var visX1 = glyphX + glyphObj1.xMax * fontSizeMult;
                                var visY1 = glyphY + glyphObj1.yMax * fontSizeMult;
                                if (visX0 < visibleBounds[0]) visibleBounds[0] = visX0;
                                if (visY0 < visibleBounds[1]) visibleBounds[1] = visY0;
                                if (visX1 > visibleBounds[2]) visibleBounds[2] = visX1;
                                if (visY1 > visibleBounds[3]) visibleBounds[3] = visY1;
                                // Track bounding rects for each chunk of N glyphs
                                if (idx % chunkedBoundsSize === 0) {
                                    chunk = {
                                        start: idx,
                                        end: idx,
                                        rect: [
                                            INF,
                                            INF,
                                            -INF,
                                            -INF
                                        ]
                                    };
                                    chunkedBounds.push(chunk);
                                }
                                chunk.end++;
                                var chunkRect = chunk.rect;
                                if (visX0 < chunkRect[0]) chunkRect[0] = visX0;
                                if (visY0 < chunkRect[1]) chunkRect[1] = visY0;
                                if (visX1 > chunkRect[2]) chunkRect[2] = visX1;
                                if (visY1 > chunkRect[3]) chunkRect[3] = visY1;
                                // Add to glyph ids array
                                glyphIds[idx] = glyphId;
                                // Add colors
                                if (colorRanges) {
                                    var start1 = idx * 3;
                                    glyphColors[start1] = currentColor >> 16 & 255;
                                    glyphColors[start1 + 1] = currentColor >> 8 & 255;
                                    glyphColors[start1 + 2] = currentColor & 255;
                                }
                            }
                        }
                    }
                    // Increment y offset for next line
                    lineYOffset -= lineHeight;
                });
                // Fill in remaining caret positions in case the final character was a ligature
                if (caretPositions) {
                    var ligCount = text.length - prevCharIndex;
                    if (ligCount > 1) fillLigatureCaretPositions(caretPositions, prevCharIndex, ligCount);
                }
            }
            // Timing stats
            timings.typesetting = now() - typesetStart;
            callback({
                glyphIds: glyphIds,
                glyphPositions: glyphPositions,
                glyphData: glyphData,
                caretPositions: caretPositions,
                caretHeight: caretHeight,
                glyphColors: glyphColors,
                chunkedBounds: chunkedBounds,
                fontSize: fontSize,
                unitsPerEm: unitsPerEm,
                ascender: ascender * fontSizeMult,
                descender: descender * fontSizeMult,
                capHeight: capHeight * fontSizeMult,
                xHeight: xHeight * fontSizeMult,
                lineHeight: lineHeight,
                topBaseline: topBaseline,
                blockBounds: [
                    anchorXOffset,
                    anchorYOffset - lines.length * lineHeight,
                    anchorXOffset + maxLineWidth,
                    anchorYOffset
                ],
                visibleBounds: visibleBounds,
                timings: timings
            });
        });
    }
    /**
   * For a given text string and font parameters, determine the resulting block dimensions
   * after wrapping for the given maxWidth.
   * @param args
   * @param callback
   */ function measure(args, callback) {
        typeset(args, function(result) {
            var _result_blockBounds = (0, $cccf0333cb9f9910$export$71511d61b312f219)(result.blockBounds, 4), x0 = _result_blockBounds[0], y0 = _result_blockBounds[1], x1 = _result_blockBounds[2], y1 = _result_blockBounds[3];
            callback({
                width: x1 - x0,
                height: y1 - y0
            });
        }, {
            metricsOnly: true
        });
    }
    function parsePercent(str) {
        var match = str.match(/^([\d.]+)%$/);
        var pct = match ? parseFloat(match[1]) : NaN;
        return isNaN(pct) ? 0 : pct / 100;
    }
    function fillLigatureCaretPositions(caretPositions, ligStartIndex, ligCount) {
        var ligStartX = caretPositions[ligStartIndex * 3];
        var ligEndX = caretPositions[ligStartIndex * 3 + 1];
        var ligY = caretPositions[ligStartIndex * 3 + 2];
        var guessedAdvanceX = (ligEndX - ligStartX) / ligCount;
        for(var i = 0; i < ligCount; i++){
            var startIndex = (ligStartIndex + i) * 3;
            caretPositions[startIndex] = ligStartX + guessedAdvanceX * i;
            caretPositions[startIndex + 1] = ligStartX + guessedAdvanceX * (i + 1);
            caretPositions[startIndex + 2] = ligY;
        }
    }
    function now() {
        return (self.performance || Date).now();
    }
    // Array-backed structure for a single line's glyphs data
    function TextLine() {
        this.data = [];
    }
    var textLineProps = [
        'glyphObj',
        'x',
        'width',
        'charIndex'
    ];
    TextLine.prototype = {
        width: 0,
        isSoftWrapped: false,
        get count () {
            return Math.ceil(this.data.length / textLineProps.length);
        },
        glyphAt: function(i) {
            var fly = TextLine.flyweight;
            fly.data = this.data;
            fly.index = i;
            return fly;
        },
        splitAt: function(i) {
            var newLine = new TextLine();
            newLine.data = this.data.splice(i * textLineProps.length);
            return newLine;
        }
    };
    TextLine.flyweight = textLineProps.reduce(function(obj, prop, i, all) {
        Object.defineProperty(obj, prop, {
            get: function() {
                return this.data[this.index * textLineProps.length + i];
            },
            set: function(val) {
                this.data[this.index * textLineProps.length + i] = val;
            }
        });
        return obj;
    }, {
        data: null,
        index: 0
    });
    return {
        typeset: typeset,
        measure: measure,
        loadFont: loadFont
    };
}
var $6591e3ca76d1668d$var$now = function() {
    return (self.performance || Date).now();
};
var $6591e3ca76d1668d$var$mainThreadGenerator = /*#__PURE__*/ (0, $cdfb19fee16f58da$export$2e2bcd8739ae039)();
var $6591e3ca76d1668d$var$warned;
/**
 * Generate an SDF texture image for a single glyph path, placing the result into a webgl canvas at a
 * given location and channel. Utilizes the webgl-sdf-generator external package for GPU-accelerated SDF
 * generation when supported.
 */ function $6591e3ca76d1668d$var$generateSDF(width, height, path, viewBox, distance, exponent, canvas, x, y, channel) {
    var useWebGL = arguments.length > 10 && arguments[10] !== void 0 ? arguments[10] : true;
    // Allow opt-out
    if (!useWebGL) return $6591e3ca76d1668d$var$generateSDF_JS_Worker(width, height, path, viewBox, distance, exponent, canvas, x, y, channel);
    // Attempt GPU-accelerated generation first
    return $6591e3ca76d1668d$var$generateSDF_GL(width, height, path, viewBox, distance, exponent, canvas, x, y, channel).then(null, function(err) {
        // WebGL failed either due to a hard error or unexpected results; fall back to JS in workers
        if (!$6591e3ca76d1668d$var$warned) {
            console.warn("WebGL SDF generation failed, falling back to JS", err);
            $6591e3ca76d1668d$var$warned = true;
        }
        return $6591e3ca76d1668d$var$generateSDF_JS_Worker(width, height, path, viewBox, distance, exponent, canvas, x, y, channel);
    });
}
var $6591e3ca76d1668d$var$queue = [];
var $6591e3ca76d1668d$var$chunkTimeBudget = 5; // ms
var $6591e3ca76d1668d$var$timer = 0;
function $6591e3ca76d1668d$var$nextChunk() {
    var start = $6591e3ca76d1668d$var$now();
    while($6591e3ca76d1668d$var$queue.length && $6591e3ca76d1668d$var$now() - start < $6591e3ca76d1668d$var$chunkTimeBudget)$6591e3ca76d1668d$var$queue.shift()();
    $6591e3ca76d1668d$var$timer = $6591e3ca76d1668d$var$queue.length ? setTimeout($6591e3ca76d1668d$var$nextChunk, 0) : 0;
}
/**
 * WebGL-based implementation executed on the main thread. Requests are executed in time-bounded
 * macrotask chunks to allow render frames to execute in between.
 */ var $6591e3ca76d1668d$var$generateSDF_GL = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return new Promise(function(resolve, reject) {
        $6591e3ca76d1668d$var$queue.push(function() {
            var start = $6591e3ca76d1668d$var$now();
            try {
                var _mainThreadGenerator_webgl;
                (_mainThreadGenerator_webgl = $6591e3ca76d1668d$var$mainThreadGenerator.webgl).generateIntoCanvas.apply(_mainThreadGenerator_webgl, (0, $4fcd3d80e9e33ca7$export$71511d61b312f219)(args));
                resolve({
                    timing: $6591e3ca76d1668d$var$now() - start
                });
            } catch (err) {
                reject(err);
            }
        });
        if (!$6591e3ca76d1668d$var$timer) $6591e3ca76d1668d$var$timer = setTimeout($6591e3ca76d1668d$var$nextChunk, 0);
    });
};
var $6591e3ca76d1668d$var$threadCount = 4; // how many workers to spawn
var $6591e3ca76d1668d$var$idleTimeout = 2000; // workers will be terminated after being idle this many milliseconds
var $6591e3ca76d1668d$var$threads = {};
var $6591e3ca76d1668d$var$callNum = 0;
/**
 * Fallback JS-based implementation, fanned out to a number of worker threads for parallelism
 */ function $6591e3ca76d1668d$var$generateSDF_JS_Worker(width, height, path, viewBox, distance, exponent, canvas, x, y, channel) {
    var workerId = 'TroikaTextSDFGenerator_JS_' + $6591e3ca76d1668d$var$callNum++ % $6591e3ca76d1668d$var$threadCount;
    var thread = $6591e3ca76d1668d$var$threads[workerId];
    if (!thread) thread = $6591e3ca76d1668d$var$threads[workerId] = {
        workerModule: (0, $7d2465470e3fafe3$export$e2063b0a5e3f6023)({
            name: workerId,
            workerId: workerId,
            dependencies: [
                (0, $cdfb19fee16f58da$export$2e2bcd8739ae039),
                $6591e3ca76d1668d$var$now
            ],
            init: function(_createSDFGenerator, now) {
                var generate = _createSDFGenerator().javascript.generate;
                return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    var start = now();
                    var textureData = generate.apply(void 0, (0, $4fcd3d80e9e33ca7$export$71511d61b312f219)(args));
                    return {
                        textureData: textureData,
                        timing: now() - start
                    };
                };
            },
            getTransferables: function(result) {
                return [
                    result.textureData.buffer
                ];
            }
        }),
        requests: 0,
        idleTimer: null
    };
    thread.requests++;
    clearTimeout(thread.idleTimer);
    return thread.workerModule(width, height, path, viewBox, distance, exponent).then(function(param) {
        var textureData = param.textureData, timing = param.timing;
        // copy result data into the canvas
        var start = $6591e3ca76d1668d$var$now();
        // expand single-channel data into rgba
        var imageData = new Uint8Array(textureData.length * 4);
        for(var i = 0; i < textureData.length; i++)imageData[i * 4 + channel] = textureData[i];
        $6591e3ca76d1668d$var$mainThreadGenerator.webglUtils.renderImageData(canvas, imageData, x, y, width, height, 1 << 3 - channel);
        timing += $6591e3ca76d1668d$var$now() - start;
        // clean up workers after a while
        if (--thread.requests === 0) thread.idleTimer = setTimeout(function() {
            (0, $7d2465470e3fafe3$export$a61a973ac243a75e)(workerId);
        }, $6591e3ca76d1668d$var$idleTimeout);
        return {
            timing: timing
        };
    });
}
function $6591e3ca76d1668d$var$warmUpSDFCanvas(canvas) {
    if (!canvas._warm) {
        $6591e3ca76d1668d$var$mainThreadGenerator.webgl.isSupported(canvas);
        canvas._warm = true;
    }
}
var $6591e3ca76d1668d$var$resizeWebGLCanvasWithoutClearing = $6591e3ca76d1668d$var$mainThreadGenerator.webglUtils.resizeWebGLCanvasWithoutClearing;
/*!
Custom build of Typr.ts (https://github.com/fredli74/Typr.ts) for use in Troika text rendering.
Original MIT license applies: https://github.com/fredli74/Typr.ts/blob/master/LICENSE
*/ function $6591e3ca76d1668d$var$typrFactory() {
    return "undefined" == typeof window && (self.window = self), function(r) {
        var e = {
            parse: function parse(r) {
                var t = e._bin, a = new Uint8Array(r);
                if ("ttcf" == t.readASCII(a, 0, 4)) {
                    var n = 4;
                    t.readUshort(a, n), n += 2, t.readUshort(a, n), n += 2;
                    var o = t.readUint(a, n);
                    n += 4;
                    for(var s = [], i = 0; i < o; i++){
                        var h = t.readUint(a, n);
                        n += 4, s.push(e._readFont(a, h));
                    }
                    return s;
                }
                return [
                    e._readFont(a, 0)
                ];
            },
            _readFont: function _readFont(r, t) {
                var a = e._bin, n = t;
                a.readFixed(r, t), t += 4;
                var o = a.readUshort(r, t);
                t += 2, a.readUshort(r, t), t += 2, a.readUshort(r, t), t += 2, a.readUshort(r, t), t += 2;
                for(var s = [
                    "cmap",
                    "head",
                    "hhea",
                    "maxp",
                    "hmtx",
                    "name",
                    "OS/2",
                    "post",
                    "loca",
                    "glyf",
                    "kern",
                    "CFF ",
                    "GPOS",
                    "GSUB",
                    "SVG "
                ], i = {
                    _data: r,
                    _offset: n
                }, h = {}, f = 0; f < o; f++){
                    var d = a.readASCII(r, t, 4);
                    t += 4, a.readUint(r, t), t += 4;
                    var u = a.readUint(r, t);
                    t += 4;
                    var l = a.readUint(r, t);
                    t += 4, h[d] = {
                        offset: u,
                        length: l
                    };
                }
                for(f = 0; f < s.length; f++){
                    var v = s[f];
                    h[v] && (i[v.trim()] = e[v.trim()].parse(r, h[v].offset, h[v].length, i));
                }
                return i;
            },
            _tabOffset: function _tabOffset(r, t, a) {
                for(var n = e._bin, o = n.readUshort(r, a + 4), s = a + 12, i = 0; i < o; i++){
                    var h = n.readASCII(r, s, 4);
                    s += 4, n.readUint(r, s), s += 4;
                    var f = n.readUint(r, s);
                    if (s += 4, n.readUint(r, s), s += 4, h == t) return f;
                }
                return 0;
            }
        };
        e._bin = {
            readFixed: function readFixed(r, e) {
                return (r[e] << 8 | r[e + 1]) + (r[e + 2] << 8 | r[e + 3]) / 65540;
            },
            readF2dot14: function readF2dot14(r, t) {
                return e._bin.readShort(r, t) / 16384;
            },
            readInt: function readInt(r, t) {
                return e._bin._view(r).getInt32(t);
            },
            readInt8: function readInt8(r, t) {
                return e._bin._view(r).getInt8(t);
            },
            readShort: function readShort(r, t) {
                return e._bin._view(r).getInt16(t);
            },
            readUshort: function readUshort(r, t) {
                return e._bin._view(r).getUint16(t);
            },
            readUshorts: function readUshorts(r, t, a) {
                for(var n = [], o = 0; o < a; o++)n.push(e._bin.readUshort(r, t + 2 * o));
                return n;
            },
            readUint: function readUint(r, t) {
                return e._bin._view(r).getUint32(t);
            },
            readUint64: function readUint64(r, t) {
                return 4294967296 * e._bin.readUint(r, t) + e._bin.readUint(r, t + 4);
            },
            readASCII: function readASCII(r, e, t) {
                for(var a = "", n = 0; n < t; n++)a += String.fromCharCode(r[e + n]);
                return a;
            },
            readUnicode: function readUnicode(r, e, t) {
                for(var a = "", n = 0; n < t; n++){
                    var o = r[e++] << 8 | r[e++];
                    a += String.fromCharCode(o);
                }
                return a;
            },
            _tdec: "undefined" != typeof window && window.TextDecoder ? new window.TextDecoder : null,
            readUTF8: function readUTF8(r, t, a) {
                var n = e._bin._tdec;
                return n && 0 == t && a == r.length ? n.decode(r) : e._bin.readASCII(r, t, a);
            },
            readBytes: function readBytes(r, e, t) {
                for(var a = [], n = 0; n < t; n++)a.push(r[e + n]);
                return a;
            },
            readASCIIArray: function readASCIIArray(r, e, t) {
                for(var a = [], n = 0; n < t; n++)a.push(String.fromCharCode(r[e + n]));
                return a;
            },
            _view: function _view(r) {
                return r._dataView || (r._dataView = r.buffer ? new DataView(r.buffer, r.byteOffset, r.byteLength) : new DataView(new Uint8Array(r).buffer));
            }
        }, e._lctf = {}, e._lctf.parse = function(r, t, a, n, o) {
            var s = e._bin, i = {}, h = t;
            s.readFixed(r, t), t += 4;
            var f = s.readUshort(r, t);
            t += 2;
            var d = s.readUshort(r, t);
            t += 2;
            var u = s.readUshort(r, t);
            return t += 2, i.scriptList = e._lctf.readScriptList(r, h + f), i.featureList = e._lctf.readFeatureList(r, h + d), i.lookupList = e._lctf.readLookupList(r, h + u, o), i;
        }, e._lctf.readLookupList = function(r, t, a) {
            var n = e._bin, o = t, s = [], i = n.readUshort(r, t);
            t += 2;
            for(var h = 0; h < i; h++){
                var f = n.readUshort(r, t);
                t += 2;
                var d = e._lctf.readLookupTable(r, o + f, a);
                s.push(d);
            }
            return s;
        }, e._lctf.readLookupTable = function(r, t, a) {
            var n = e._bin, o = t, s = {
                tabs: []
            };
            s.ltype = n.readUshort(r, t), t += 2, s.flag = n.readUshort(r, t), t += 2;
            var i = n.readUshort(r, t);
            t += 2;
            for(var h = s.ltype, f = 0; f < i; f++){
                var d = n.readUshort(r, t);
                t += 2;
                var u = a(r, h, o + d, s);
                s.tabs.push(u);
            }
            return s;
        }, e._lctf.numOfOnes = function(r) {
            for(var e = 0, t = 0; t < 32; t++)0 != (r >>> t & 1) && e++;
            return e;
        }, e._lctf.readClassDef = function(r, t) {
            var a = e._bin, n = [], o = a.readUshort(r, t);
            if (t += 2, 1 == o) {
                var s = a.readUshort(r, t);
                t += 2;
                var i = a.readUshort(r, t);
                t += 2;
                for(var h = 0; h < i; h++)n.push(s + h), n.push(s + h), n.push(a.readUshort(r, t)), t += 2;
            }
            if (2 == o) {
                var f = a.readUshort(r, t);
                t += 2;
                for(h = 0; h < f; h++)n.push(a.readUshort(r, t)), t += 2, n.push(a.readUshort(r, t)), t += 2, n.push(a.readUshort(r, t)), t += 2;
            }
            return n;
        }, e._lctf.getInterval = function(r, e) {
            for(var t = 0; t < r.length; t += 3){
                var a = r[t], n = r[t + 1];
                if (r[t + 2], a <= e && e <= n) return t;
            }
            return -1;
        }, e._lctf.readCoverage = function(r, t) {
            var a = e._bin, n = {};
            n.fmt = a.readUshort(r, t), t += 2;
            var o = a.readUshort(r, t);
            return t += 2, 1 == n.fmt && (n.tab = a.readUshorts(r, t, o)), 2 == n.fmt && (n.tab = a.readUshorts(r, t, 3 * o)), n;
        }, e._lctf.coverageIndex = function(r, t) {
            var a = r.tab;
            if (1 == r.fmt) return a.indexOf(t);
            if (2 == r.fmt) {
                var n = e._lctf.getInterval(a, t);
                if (-1 != n) return a[n + 2] + (t - a[n]);
            }
            return -1;
        }, e._lctf.readFeatureList = function(r, t) {
            var a = e._bin, n = t, o = [], s = a.readUshort(r, t);
            t += 2;
            for(var i = 0; i < s; i++){
                var h = a.readASCII(r, t, 4);
                t += 4;
                var f = a.readUshort(r, t);
                t += 2;
                var d = e._lctf.readFeatureTable(r, n + f);
                d.tag = h.trim(), o.push(d);
            }
            return o;
        }, e._lctf.readFeatureTable = function(r, t) {
            var a = e._bin, n = t, o = {}, s = a.readUshort(r, t);
            t += 2, s > 0 && (o.featureParams = n + s);
            var i = a.readUshort(r, t);
            t += 2, o.tab = [];
            for(var h = 0; h < i; h++)o.tab.push(a.readUshort(r, t + 2 * h));
            return o;
        }, e._lctf.readScriptList = function(r, t) {
            var a = e._bin, n = t, o = {}, s = a.readUshort(r, t);
            t += 2;
            for(var i = 0; i < s; i++){
                var h = a.readASCII(r, t, 4);
                t += 4;
                var f = a.readUshort(r, t);
                t += 2, o[h.trim()] = e._lctf.readScriptTable(r, n + f);
            }
            return o;
        }, e._lctf.readScriptTable = function(r, t) {
            var a = e._bin, n = t, o = {}, s = a.readUshort(r, t);
            t += 2, o.default = e._lctf.readLangSysTable(r, n + s);
            var i = a.readUshort(r, t);
            t += 2;
            for(var h = 0; h < i; h++){
                var f = a.readASCII(r, t, 4);
                t += 4;
                var d = a.readUshort(r, t);
                t += 2, o[f.trim()] = e._lctf.readLangSysTable(r, n + d);
            }
            return o;
        }, e._lctf.readLangSysTable = function(r, t) {
            var a = e._bin, n = {};
            a.readUshort(r, t), t += 2, n.reqFeature = a.readUshort(r, t), t += 2;
            var o = a.readUshort(r, t);
            return t += 2, n.features = a.readUshorts(r, t, o), n;
        }, e.CFF = {}, e.CFF.parse = function(r, t, a) {
            var n = e._bin;
            (r = new Uint8Array(r.buffer, t, a))[t = 0], r[++t], r[++t], r[++t], t++;
            var o = [];
            t = e.CFF.readIndex(r, t, o);
            for(var s = [], i = 0; i < o.length - 1; i++)s.push(n.readASCII(r, t + o[i], o[i + 1] - o[i]));
            t += o[o.length - 1];
            var h = [];
            t = e.CFF.readIndex(r, t, h);
            var f = [];
            for(i = 0; i < h.length - 1; i++)f.push(e.CFF.readDict(r, t + h[i], t + h[i + 1]));
            t += h[h.length - 1];
            var d = f[0], u = [];
            t = e.CFF.readIndex(r, t, u);
            var l = [];
            for(i = 0; i < u.length - 1; i++)l.push(n.readASCII(r, t + u[i], u[i + 1] - u[i]));
            if (t += u[u.length - 1], e.CFF.readSubrs(r, t, d), d.CharStrings) {
                t = d.CharStrings;
                u = [];
                t = e.CFF.readIndex(r, t, u);
                var v = [];
                for(i = 0; i < u.length - 1; i++)v.push(n.readBytes(r, t + u[i], u[i + 1] - u[i]));
                d.CharStrings = v;
            }
            if (d.ROS) {
                t = d.FDArray;
                var c = [];
                t = e.CFF.readIndex(r, t, c), d.FDArray = [];
                for(i = 0; i < c.length - 1; i++){
                    var p = e.CFF.readDict(r, t + c[i], t + c[i + 1]);
                    e.CFF._readFDict(r, p, l), d.FDArray.push(p);
                }
                t += c[c.length - 1], t = d.FDSelect, d.FDSelect = [];
                var U = r[t];
                if (t++, 3 != U) throw U;
                var g = n.readUshort(r, t);
                t += 2;
                for(i = 0; i < g + 1; i++)d.FDSelect.push(n.readUshort(r, t), r[t + 2]), t += 3;
            }
            return d.Encoding && (d.Encoding = e.CFF.readEncoding(r, d.Encoding, d.CharStrings.length)), d.charset && (d.charset = e.CFF.readCharset(r, d.charset, d.CharStrings.length)), e.CFF._readFDict(r, d, l), d;
        }, e.CFF._readFDict = function(r, t, a) {
            var n;
            for(var o in t.Private && (n = t.Private[1], t.Private = e.CFF.readDict(r, n, n + t.Private[0]), t.Private.Subrs && e.CFF.readSubrs(r, n + t.Private.Subrs, t.Private)), t)-1 != [
                "FamilyName",
                "FontName",
                "FullName",
                "Notice",
                "version",
                "Copyright"
            ].indexOf(o) && (t[o] = a[t[o] - 426 + 35]);
        }, e.CFF.readSubrs = function(r, t, a) {
            var n = e._bin, o = [];
            t = e.CFF.readIndex(r, t, o);
            var s, i = o.length;
            s = i < 1240 ? 107 : i < 33900 ? 1131 : 32768, a.Bias = s, a.Subrs = [];
            for(var h = 0; h < o.length - 1; h++)a.Subrs.push(n.readBytes(r, t + o[h], o[h + 1] - o[h]));
        }, e.CFF.tableSE = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22,
            23,
            24,
            25,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            38,
            39,
            40,
            41,
            42,
            43,
            44,
            45,
            46,
            47,
            48,
            49,
            50,
            51,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            59,
            60,
            61,
            62,
            63,
            64,
            65,
            66,
            67,
            68,
            69,
            70,
            71,
            72,
            73,
            74,
            75,
            76,
            77,
            78,
            79,
            80,
            81,
            82,
            83,
            84,
            85,
            86,
            87,
            88,
            89,
            90,
            91,
            92,
            93,
            94,
            95,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            96,
            97,
            98,
            99,
            100,
            101,
            102,
            103,
            104,
            105,
            106,
            107,
            108,
            109,
            110,
            0,
            111,
            112,
            113,
            114,
            0,
            115,
            116,
            117,
            118,
            119,
            120,
            121,
            122,
            0,
            123,
            0,
            124,
            125,
            126,
            127,
            128,
            129,
            130,
            131,
            0,
            132,
            133,
            0,
            134,
            135,
            136,
            137,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            138,
            0,
            139,
            0,
            0,
            0,
            0,
            140,
            141,
            142,
            143,
            0,
            0,
            0,
            0,
            0,
            144,
            0,
            0,
            0,
            145,
            0,
            0,
            146,
            147,
            148,
            149,
            0,
            0,
            0,
            0
        ], e.CFF.glyphByUnicode = function(r, e) {
            for(var t = 0; t < r.charset.length; t++)if (r.charset[t] == e) return t;
            return -1;
        }, e.CFF.glyphBySE = function(r, t) {
            return t < 0 || t > 255 ? -1 : e.CFF.glyphByUnicode(r, e.CFF.tableSE[t]);
        }, e.CFF.readEncoding = function(r, t, a) {
            e._bin;
            var n = [
                ".notdef"
            ], o = r[t];
            if (t++, 0 != o) throw "error: unknown encoding format: " + o;
            var s = r[t];
            t++;
            for(var i = 0; i < s; i++)n.push(r[t + i]);
            return n;
        }, e.CFF.readCharset = function(r, t, a) {
            var n = e._bin, o = [
                ".notdef"
            ], s = r[t];
            if (t++, 0 == s) for(var i = 0; i < a; i++){
                var h = n.readUshort(r, t);
                t += 2, o.push(h);
            }
            else {
                if (1 != s && 2 != s) throw "error: format: " + s;
                for(; o.length < a;){
                    h = n.readUshort(r, t);
                    t += 2;
                    var f = 0;
                    1 == s ? (f = r[t], t++) : (f = n.readUshort(r, t), t += 2);
                    for(i = 0; i <= f; i++)o.push(h), h++;
                }
            }
            return o;
        }, e.CFF.readIndex = function(r, t, a) {
            var n = e._bin, o = n.readUshort(r, t) + 1, s = r[t += 2];
            if (t++, 1 == s) for(var i = 0; i < o; i++)a.push(r[t + i]);
            else if (2 == s) for(i = 0; i < o; i++)a.push(n.readUshort(r, t + 2 * i));
            else if (3 == s) for(i = 0; i < o; i++)a.push(16777215 & n.readUint(r, t + 3 * i - 1));
            else if (1 != o) throw "unsupported offset size: " + s + ", count: " + o;
            return (t += o * s) - 1;
        }, e.CFF.getCharString = function(r, t, a) {
            var n = e._bin, o = r[t], s = r[t + 1];
            r[t + 2], r[t + 3], r[t + 4];
            var i = 1, h = null, f = null;
            o <= 20 && (h = o, i = 1), 12 == o && (h = 100 * o + s, i = 2), 21 <= o && o <= 27 && (h = o, i = 1), 28 == o && (f = n.readShort(r, t + 1), i = 3), 29 <= o && o <= 31 && (h = o, i = 1), 32 <= o && o <= 246 && (f = o - 139, i = 1), 247 <= o && o <= 250 && (f = 256 * (o - 247) + s + 108, i = 2), 251 <= o && o <= 254 && (f = 256 * -(o - 251) - s - 108, i = 2), 255 == o && (f = n.readInt(r, t + 1) / 65535, i = 5), a.val = null != f ? f : "o" + h, a.size = i;
        }, e.CFF.readCharString = function(r, t, a) {
            for(var n = t + a, o = e._bin, s = []; t < n;){
                var i = r[t], h = r[t + 1];
                r[t + 2], r[t + 3], r[t + 4];
                var f = 1, d = null, u = null;
                i <= 20 && (d = i, f = 1), 12 == i && (d = 100 * i + h, f = 2), 19 != i && 20 != i || (d = i, f = 2), 21 <= i && i <= 27 && (d = i, f = 1), 28 == i && (u = o.readShort(r, t + 1), f = 3), 29 <= i && i <= 31 && (d = i, f = 1), 32 <= i && i <= 246 && (u = i - 139, f = 1), 247 <= i && i <= 250 && (u = 256 * (i - 247) + h + 108, f = 2), 251 <= i && i <= 254 && (u = 256 * -(i - 251) - h - 108, f = 2), 255 == i && (u = o.readInt(r, t + 1) / 65535, f = 5), s.push(null != u ? u : "o" + d), t += f;
            }
            return s;
        }, e.CFF.readDict = function(r, t, a) {
            for(var n = e._bin, o = {}, s = []; t < a;){
                var i = r[t], h = r[t + 1];
                r[t + 2], r[t + 3], r[t + 4];
                var f = 1, d = null, u = null;
                if (28 == i && (u = n.readShort(r, t + 1), f = 3), 29 == i && (u = n.readInt(r, t + 1), f = 5), 32 <= i && i <= 246 && (u = i - 139, f = 1), 247 <= i && i <= 250 && (u = 256 * (i - 247) + h + 108, f = 2), 251 <= i && i <= 254 && (u = 256 * -(i - 251) - h - 108, f = 2), 255 == i) throw u = n.readInt(r, t + 1) / 65535, f = 5, "unknown number";
                if (30 == i) {
                    var l = [];
                    for(f = 1;;){
                        var v = r[t + f];
                        f++;
                        var c = v >> 4, p = 15 & v;
                        if (15 != c && l.push(c), 15 != p && l.push(p), 15 == p) break;
                    }
                    for(var U = "", g = [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        ".",
                        "e",
                        "e-",
                        "reserved",
                        "-",
                        "endOfNumber"
                    ], S = 0; S < l.length; S++)U += g[l[S]];
                    u = parseFloat(U);
                }
                if (i <= 21) {
                    if (d = [
                        "version",
                        "Notice",
                        "FullName",
                        "FamilyName",
                        "Weight",
                        "FontBBox",
                        "BlueValues",
                        "OtherBlues",
                        "FamilyBlues",
                        "FamilyOtherBlues",
                        "StdHW",
                        "StdVW",
                        "escape",
                        "UniqueID",
                        "XUID",
                        "charset",
                        "Encoding",
                        "CharStrings",
                        "Private",
                        "Subrs",
                        "defaultWidthX",
                        "nominalWidthX"
                    ][i], f = 1, 12 == i) d = [
                        "Copyright",
                        "isFixedPitch",
                        "ItalicAngle",
                        "UnderlinePosition",
                        "UnderlineThickness",
                        "PaintType",
                        "CharstringType",
                        "FontMatrix",
                        "StrokeWidth",
                        "BlueScale",
                        "BlueShift",
                        "BlueFuzz",
                        "StemSnapH",
                        "StemSnapV",
                        "ForceBold",
                        0,
                        0,
                        "LanguageGroup",
                        "ExpansionFactor",
                        "initialRandomSeed",
                        "SyntheticBase",
                        "PostScript",
                        "BaseFontName",
                        "BaseFontBlend",
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        "ROS",
                        "CIDFontVersion",
                        "CIDFontRevision",
                        "CIDFontType",
                        "CIDCount",
                        "UIDBase",
                        "FDArray",
                        "FDSelect",
                        "FontName"
                    ][h], f = 2;
                }
                null != d ? (o[d] = 1 == s.length ? s[0] : s, s = []) : s.push(u), t += f;
            }
            return o;
        }, e.cmap = {}, e.cmap.parse = function(r, t, a) {
            r = new Uint8Array(r.buffer, t, a), t = 0;
            var n = e._bin, o = {};
            n.readUshort(r, t), t += 2;
            var s = n.readUshort(r, t);
            t += 2;
            var i = [];
            o.tables = [];
            for(var h = 0; h < s; h++){
                var f = n.readUshort(r, t);
                t += 2;
                var d = n.readUshort(r, t);
                t += 2;
                var u = n.readUint(r, t);
                t += 4;
                var l = "p" + f + "e" + d, v = i.indexOf(u);
                if (-1 == v) {
                    var c;
                    v = o.tables.length, i.push(u);
                    var p = n.readUshort(r, u);
                    0 == p ? c = e.cmap.parse0(r, u) : 4 == p ? c = e.cmap.parse4(r, u) : 6 == p ? c = e.cmap.parse6(r, u) : 12 == p ? c = e.cmap.parse12(r, u) : console.debug("unknown format: " + p, f, d, u), o.tables.push(c);
                }
                if (null != o[l]) throw "multiple tables for one platform+encoding";
                o[l] = v;
            }
            return o;
        }, e.cmap.parse0 = function(r, t) {
            var a = e._bin, n = {};
            n.format = a.readUshort(r, t), t += 2;
            var o = a.readUshort(r, t);
            t += 2, a.readUshort(r, t), t += 2, n.map = [];
            for(var s = 0; s < o - 6; s++)n.map.push(r[t + s]);
            return n;
        }, e.cmap.parse4 = function(r, t) {
            var a = e._bin, n = t, o = {};
            o.format = a.readUshort(r, t), t += 2;
            var s = a.readUshort(r, t);
            t += 2, a.readUshort(r, t), t += 2;
            var i = a.readUshort(r, t);
            t += 2;
            var h = i / 2;
            o.searchRange = a.readUshort(r, t), t += 2, o.entrySelector = a.readUshort(r, t), t += 2, o.rangeShift = a.readUshort(r, t), t += 2, o.endCount = a.readUshorts(r, t, h), t += 2 * h, t += 2, o.startCount = a.readUshorts(r, t, h), t += 2 * h, o.idDelta = [];
            for(var f = 0; f < h; f++)o.idDelta.push(a.readShort(r, t)), t += 2;
            for(o.idRangeOffset = a.readUshorts(r, t, h), t += 2 * h, o.glyphIdArray = []; t < n + s;)o.glyphIdArray.push(a.readUshort(r, t)), t += 2;
            return o;
        }, e.cmap.parse6 = function(r, t) {
            var a = e._bin, n = {};
            n.format = a.readUshort(r, t), t += 2, a.readUshort(r, t), t += 2, a.readUshort(r, t), t += 2, n.firstCode = a.readUshort(r, t), t += 2;
            var o = a.readUshort(r, t);
            t += 2, n.glyphIdArray = [];
            for(var s = 0; s < o; s++)n.glyphIdArray.push(a.readUshort(r, t)), t += 2;
            return n;
        }, e.cmap.parse12 = function(r, t) {
            var a = e._bin, n = {};
            n.format = a.readUshort(r, t), t += 2, t += 2, a.readUint(r, t), t += 4, a.readUint(r, t), t += 4;
            var o = a.readUint(r, t);
            t += 4, n.groups = [];
            for(var s = 0; s < o; s++){
                var i = t + 12 * s, h = a.readUint(r, i + 0), f = a.readUint(r, i + 4), d = a.readUint(r, i + 8);
                n.groups.push([
                    h,
                    f,
                    d
                ]);
            }
            return n;
        }, e.glyf = {}, e.glyf.parse = function(r, e, t, a) {
            for(var n = [], o = 0; o < a.maxp.numGlyphs; o++)n.push(null);
            return n;
        }, e.glyf._parseGlyf = function(r, t) {
            var a = e._bin, n = r._data, o = e._tabOffset(n, "glyf", r._offset) + r.loca[t];
            if (r.loca[t] == r.loca[t + 1]) return null;
            var s = {};
            if (s.noc = a.readShort(n, o), o += 2, s.xMin = a.readShort(n, o), o += 2, s.yMin = a.readShort(n, o), o += 2, s.xMax = a.readShort(n, o), o += 2, s.yMax = a.readShort(n, o), o += 2, s.xMin >= s.xMax || s.yMin >= s.yMax) return null;
            if (s.noc > 0) {
                s.endPts = [];
                for(var i = 0; i < s.noc; i++)s.endPts.push(a.readUshort(n, o)), o += 2;
                var h = a.readUshort(n, o);
                if (o += 2, n.length - o < h) return null;
                s.instructions = a.readBytes(n, o, h), o += h;
                var f = s.endPts[s.noc - 1] + 1;
                s.flags = [];
                for(i = 0; i < f; i++){
                    var d = n[o];
                    if (o++, s.flags.push(d), 0 != (8 & d)) {
                        var u = n[o];
                        o++;
                        for(var l = 0; l < u; l++)s.flags.push(d), i++;
                    }
                }
                s.xs = [];
                for(i = 0; i < f; i++){
                    var v = 0 != (2 & s.flags[i]), c = 0 != (16 & s.flags[i]);
                    v ? (s.xs.push(c ? n[o] : -n[o]), o++) : c ? s.xs.push(0) : (s.xs.push(a.readShort(n, o)), o += 2);
                }
                s.ys = [];
                for(i = 0; i < f; i++){
                    v = 0 != (4 & s.flags[i]), c = 0 != (32 & s.flags[i]);
                    v ? (s.ys.push(c ? n[o] : -n[o]), o++) : c ? s.ys.push(0) : (s.ys.push(a.readShort(n, o)), o += 2);
                }
                var p = 0, U = 0;
                for(i = 0; i < f; i++)p += s.xs[i], U += s.ys[i], s.xs[i] = p, s.ys[i] = U;
            } else {
                var g;
                s.parts = [];
                do {
                    g = a.readUshort(n, o), o += 2;
                    var S = {
                        m: {
                            a: 1,
                            b: 0,
                            c: 0,
                            d: 1,
                            tx: 0,
                            ty: 0
                        },
                        p1: -1,
                        p2: -1
                    };
                    if (s.parts.push(S), S.glyphIndex = a.readUshort(n, o), o += 2, 1 & g) {
                        var m = a.readShort(n, o);
                        o += 2;
                        var b = a.readShort(n, o);
                        o += 2;
                    } else {
                        m = a.readInt8(n, o);
                        o++;
                        b = a.readInt8(n, o);
                        o++;
                    }
                    2 & g ? (S.m.tx = m, S.m.ty = b) : (S.p1 = m, S.p2 = b), 8 & g ? (S.m.a = S.m.d = a.readF2dot14(n, o), o += 2) : 64 & g ? (S.m.a = a.readF2dot14(n, o), o += 2, S.m.d = a.readF2dot14(n, o), o += 2) : 128 & g && (S.m.a = a.readF2dot14(n, o), o += 2, S.m.b = a.readF2dot14(n, o), o += 2, S.m.c = a.readF2dot14(n, o), o += 2, S.m.d = a.readF2dot14(n, o), o += 2);
                }while (32 & g);
                if (256 & g) {
                    var y = a.readUshort(n, o);
                    o += 2, s.instr = [];
                    for(i = 0; i < y; i++)s.instr.push(n[o]), o++;
                }
            }
            return s;
        }, e.GPOS = {}, e.GPOS.parse = function(r, t, a, n) {
            return e._lctf.parse(r, t, a, n, e.GPOS.subt);
        }, e.GPOS.subt = function(r, t, a, n) {
            var o = e._bin, s = a, i = {};
            if (i.fmt = o.readUshort(r, a), a += 2, 1 == t || 2 == t || 3 == t || 7 == t || 8 == t && i.fmt <= 2) {
                var h = o.readUshort(r, a);
                a += 2, i.coverage = e._lctf.readCoverage(r, h + s);
            }
            if (1 == t && 1 == i.fmt) {
                var f = o.readUshort(r, a);
                a += 2;
                var d = e._lctf.numOfOnes(f);
                0 != f && (i.pos = e.GPOS.readValueRecord(r, a, f));
            } else if (2 == t && i.fmt >= 1 && i.fmt <= 2) {
                f = o.readUshort(r, a);
                a += 2;
                var u = o.readUshort(r, a);
                a += 2;
                d = e._lctf.numOfOnes(f);
                var l = e._lctf.numOfOnes(u);
                if (1 == i.fmt) {
                    i.pairsets = [];
                    var v = o.readUshort(r, a);
                    a += 2;
                    for(var c = 0; c < v; c++){
                        var p = s + o.readUshort(r, a);
                        a += 2;
                        var U = o.readUshort(r, p);
                        p += 2;
                        for(var g = [], S = 0; S < U; S++){
                            var m = o.readUshort(r, p);
                            p += 2, 0 != f && (x = e.GPOS.readValueRecord(r, p, f), p += 2 * d), 0 != u && (P = e.GPOS.readValueRecord(r, p, u), p += 2 * l), g.push({
                                gid2: m,
                                val1: x,
                                val2: P
                            });
                        }
                        i.pairsets.push(g);
                    }
                }
                if (2 == i.fmt) {
                    var b = o.readUshort(r, a);
                    a += 2;
                    var y = o.readUshort(r, a);
                    a += 2;
                    var F = o.readUshort(r, a);
                    a += 2;
                    var _ = o.readUshort(r, a);
                    a += 2, i.classDef1 = e._lctf.readClassDef(r, s + b), i.classDef2 = e._lctf.readClassDef(r, s + y), i.matrix = [];
                    for(c = 0; c < F; c++){
                        var C = [];
                        for(S = 0; S < _; S++){
                            var x = null, P = null;
                            0 != f && (x = e.GPOS.readValueRecord(r, a, f), a += 2 * d), 0 != u && (P = e.GPOS.readValueRecord(r, a, u), a += 2 * l), C.push({
                                val1: x,
                                val2: P
                            });
                        }
                        i.matrix.push(C);
                    }
                }
            } else {
                if (9 == t && 1 == i.fmt) {
                    var I = o.readUshort(r, a);
                    a += 2;
                    var w = o.readUint(r, a);
                    if (a += 4, 9 == n.ltype) n.ltype = I;
                    else if (n.ltype != I) throw "invalid extension substitution";
                    return e.GPOS.subt(r, n.ltype, s + w);
                }
                console.debug("unsupported GPOS table LookupType", t, "format", i.fmt);
            }
            return i;
        }, e.GPOS.readValueRecord = function(r, t, a) {
            var n = e._bin, o = [];
            return o.push(1 & a ? n.readShort(r, t) : 0), t += 1 & a ? 2 : 0, o.push(2 & a ? n.readShort(r, t) : 0), t += 2 & a ? 2 : 0, o.push(4 & a ? n.readShort(r, t) : 0), t += 4 & a ? 2 : 0, o.push(8 & a ? n.readShort(r, t) : 0), t += 8 & a ? 2 : 0, o;
        }, e.GSUB = {}, e.GSUB.parse = function(r, t, a, n) {
            return e._lctf.parse(r, t, a, n, e.GSUB.subt);
        }, e.GSUB.subt = function(r, t, a, n) {
            var o = e._bin, s = a, i = {};
            if (i.fmt = o.readUshort(r, a), a += 2, 1 != t && 4 != t && 5 != t && 6 != t) return null;
            if (1 == t || 4 == t || 5 == t && i.fmt <= 2 || 6 == t && i.fmt <= 2) {
                var h = o.readUshort(r, a);
                a += 2, i.coverage = e._lctf.readCoverage(r, s + h);
            }
            if (1 == t && i.fmt >= 1 && i.fmt <= 2) {
                if (1 == i.fmt) i.delta = o.readShort(r, a), a += 2;
                else if (2 == i.fmt) {
                    var f = o.readUshort(r, a);
                    a += 2, i.newg = o.readUshorts(r, a, f), a += 2 * i.newg.length;
                }
            } else if (4 == t) {
                i.vals = [];
                f = o.readUshort(r, a);
                a += 2;
                for(var d = 0; d < f; d++){
                    var u = o.readUshort(r, a);
                    a += 2, i.vals.push(e.GSUB.readLigatureSet(r, s + u));
                }
            } else if (5 == t && 2 == i.fmt) {
                if (2 == i.fmt) {
                    var l = o.readUshort(r, a);
                    a += 2, i.cDef = e._lctf.readClassDef(r, s + l), i.scset = [];
                    var v = o.readUshort(r, a);
                    a += 2;
                    for(d = 0; d < v; d++){
                        var c = o.readUshort(r, a);
                        a += 2, i.scset.push(0 == c ? null : e.GSUB.readSubClassSet(r, s + c));
                    }
                }
            } else if (6 == t && 3 == i.fmt) {
                if (3 == i.fmt) {
                    for(d = 0; d < 3; d++){
                        f = o.readUshort(r, a);
                        a += 2;
                        for(var p = [], U = 0; U < f; U++)p.push(e._lctf.readCoverage(r, s + o.readUshort(r, a + 2 * U)));
                        a += 2 * f, 0 == d && (i.backCvg = p), 1 == d && (i.inptCvg = p), 2 == d && (i.ahedCvg = p);
                    }
                    f = o.readUshort(r, a);
                    a += 2, i.lookupRec = e.GSUB.readSubstLookupRecords(r, a, f);
                }
            } else {
                if (7 == t && 1 == i.fmt) {
                    var g = o.readUshort(r, a);
                    a += 2;
                    var S = o.readUint(r, a);
                    if (a += 4, 9 == n.ltype) n.ltype = g;
                    else if (n.ltype != g) throw "invalid extension substitution";
                    return e.GSUB.subt(r, n.ltype, s + S);
                }
                console.debug("unsupported GSUB table LookupType", t, "format", i.fmt);
            }
            return i;
        }, e.GSUB.readSubClassSet = function(r, t) {
            var a = e._bin.readUshort, n = t, o = [], s = a(r, t);
            t += 2;
            for(var i = 0; i < s; i++){
                var h = a(r, t);
                t += 2, o.push(e.GSUB.readSubClassRule(r, n + h));
            }
            return o;
        }, e.GSUB.readSubClassRule = function(r, t) {
            var a = e._bin.readUshort, n = {}, o = a(r, t), s = a(r, t += 2);
            t += 2, n.input = [];
            for(var i = 0; i < o - 1; i++)n.input.push(a(r, t)), t += 2;
            return n.substLookupRecords = e.GSUB.readSubstLookupRecords(r, t, s), n;
        }, e.GSUB.readSubstLookupRecords = function(r, t, a) {
            for(var n = e._bin.readUshort, o = [], s = 0; s < a; s++)o.push(n(r, t), n(r, t + 2)), t += 4;
            return o;
        }, e.GSUB.readChainSubClassSet = function(r, t) {
            var a = e._bin, n = t, o = [], s = a.readUshort(r, t);
            t += 2;
            for(var i = 0; i < s; i++){
                var h = a.readUshort(r, t);
                t += 2, o.push(e.GSUB.readChainSubClassRule(r, n + h));
            }
            return o;
        }, e.GSUB.readChainSubClassRule = function(r, t) {
            for(var a = e._bin, n = {}, o = [
                "backtrack",
                "input",
                "lookahead"
            ], s = 0; s < o.length; s++){
                var i = a.readUshort(r, t);
                t += 2, 1 == s && i--, n[o[s]] = a.readUshorts(r, t, i), t += 2 * n[o[s]].length;
            }
            i = a.readUshort(r, t);
            return t += 2, n.subst = a.readUshorts(r, t, 2 * i), t += 2 * n.subst.length, n;
        }, e.GSUB.readLigatureSet = function(r, t) {
            var a = e._bin, n = t, o = [], s = a.readUshort(r, t);
            t += 2;
            for(var i = 0; i < s; i++){
                var h = a.readUshort(r, t);
                t += 2, o.push(e.GSUB.readLigature(r, n + h));
            }
            return o;
        }, e.GSUB.readLigature = function(r, t) {
            var a = e._bin, n = {
                chain: []
            };
            n.nglyph = a.readUshort(r, t), t += 2;
            var o = a.readUshort(r, t);
            t += 2;
            for(var s = 0; s < o - 1; s++)n.chain.push(a.readUshort(r, t)), t += 2;
            return n;
        }, e.head = {}, e.head.parse = function(r, t, a) {
            var n = e._bin, o = {};
            return n.readFixed(r, t), t += 4, o.fontRevision = n.readFixed(r, t), t += 4, n.readUint(r, t), t += 4, n.readUint(r, t), t += 4, o.flags = n.readUshort(r, t), t += 2, o.unitsPerEm = n.readUshort(r, t), t += 2, o.created = n.readUint64(r, t), t += 8, o.modified = n.readUint64(r, t), t += 8, o.xMin = n.readShort(r, t), t += 2, o.yMin = n.readShort(r, t), t += 2, o.xMax = n.readShort(r, t), t += 2, o.yMax = n.readShort(r, t), t += 2, o.macStyle = n.readUshort(r, t), t += 2, o.lowestRecPPEM = n.readUshort(r, t), t += 2, o.fontDirectionHint = n.readShort(r, t), t += 2, o.indexToLocFormat = n.readShort(r, t), t += 2, o.glyphDataFormat = n.readShort(r, t), t += 2, o;
        }, e.hhea = {}, e.hhea.parse = function(r, t, a) {
            var n = e._bin, o = {};
            return n.readFixed(r, t), t += 4, o.ascender = n.readShort(r, t), t += 2, o.descender = n.readShort(r, t), t += 2, o.lineGap = n.readShort(r, t), t += 2, o.advanceWidthMax = n.readUshort(r, t), t += 2, o.minLeftSideBearing = n.readShort(r, t), t += 2, o.minRightSideBearing = n.readShort(r, t), t += 2, o.xMaxExtent = n.readShort(r, t), t += 2, o.caretSlopeRise = n.readShort(r, t), t += 2, o.caretSlopeRun = n.readShort(r, t), t += 2, o.caretOffset = n.readShort(r, t), t += 2, t += 8, o.metricDataFormat = n.readShort(r, t), t += 2, o.numberOfHMetrics = n.readUshort(r, t), t += 2, o;
        }, e.hmtx = {}, e.hmtx.parse = function(r, t, a, n) {
            for(var o = e._bin, s = {
                aWidth: [],
                lsBearing: []
            }, i = 0, h = 0, f = 0; f < n.maxp.numGlyphs; f++)f < n.hhea.numberOfHMetrics && (i = o.readUshort(r, t), t += 2, h = o.readShort(r, t), t += 2), s.aWidth.push(i), s.lsBearing.push(h);
            return s;
        }, e.kern = {}, e.kern.parse = function(r, t, a, n) {
            var o = e._bin, s = o.readUshort(r, t);
            if (t += 2, 1 == s) return e.kern.parseV1(r, t - 2, a, n);
            var i = o.readUshort(r, t);
            t += 2;
            for(var h = {
                glyph1: [],
                rval: []
            }, f = 0; f < i; f++){
                t += 2;
                a = o.readUshort(r, t);
                t += 2;
                var d = o.readUshort(r, t);
                t += 2;
                var u = d >>> 8;
                if (0 != (u &= 15)) throw "unknown kern table format: " + u;
                t = e.kern.readFormat0(r, t, h);
            }
            return h;
        }, e.kern.parseV1 = function(r, t, a, n) {
            var o = e._bin;
            o.readFixed(r, t), t += 4;
            var s = o.readUint(r, t);
            t += 4;
            for(var i = {
                glyph1: [],
                rval: []
            }, h = 0; h < s; h++){
                o.readUint(r, t), t += 4;
                var f = o.readUshort(r, t);
                t += 2, o.readUshort(r, t), t += 2;
                var d = f >>> 8;
                if (0 != (d &= 15)) throw "unknown kern table format: " + d;
                t = e.kern.readFormat0(r, t, i);
            }
            return i;
        }, e.kern.readFormat0 = function(r, t, a) {
            var n = e._bin, o = -1, s = n.readUshort(r, t);
            t += 2, n.readUshort(r, t), t += 2, n.readUshort(r, t), t += 2, n.readUshort(r, t), t += 2;
            for(var i = 0; i < s; i++){
                var h = n.readUshort(r, t);
                t += 2;
                var f = n.readUshort(r, t);
                t += 2;
                var d = n.readShort(r, t);
                t += 2, h != o && (a.glyph1.push(h), a.rval.push({
                    glyph2: [],
                    vals: []
                }));
                var u = a.rval[a.rval.length - 1];
                u.glyph2.push(f), u.vals.push(d), o = h;
            }
            return t;
        }, e.loca = {}, e.loca.parse = function(r, t, a, n) {
            var o = e._bin, s = [], i = n.head.indexToLocFormat, h = n.maxp.numGlyphs + 1;
            if (0 == i) for(var f = 0; f < h; f++)s.push(o.readUshort(r, t + (f << 1)) << 1);
            if (1 == i) for(f = 0; f < h; f++)s.push(o.readUint(r, t + (f << 2)));
            return s;
        }, e.maxp = {}, e.maxp.parse = function(r, t, a) {
            var n = e._bin, o = {}, s = n.readUint(r, t);
            return t += 4, o.numGlyphs = n.readUshort(r, t), t += 2, 65536 == s && (o.maxPoints = n.readUshort(r, t), t += 2, o.maxContours = n.readUshort(r, t), t += 2, o.maxCompositePoints = n.readUshort(r, t), t += 2, o.maxCompositeContours = n.readUshort(r, t), t += 2, o.maxZones = n.readUshort(r, t), t += 2, o.maxTwilightPoints = n.readUshort(r, t), t += 2, o.maxStorage = n.readUshort(r, t), t += 2, o.maxFunctionDefs = n.readUshort(r, t), t += 2, o.maxInstructionDefs = n.readUshort(r, t), t += 2, o.maxStackElements = n.readUshort(r, t), t += 2, o.maxSizeOfInstructions = n.readUshort(r, t), t += 2, o.maxComponentElements = n.readUshort(r, t), t += 2, o.maxComponentDepth = n.readUshort(r, t), t += 2), o;
        }, e.name = {}, e.name.parse = function(r, t, a) {
            var n = e._bin, o = {};
            n.readUshort(r, t), t += 2;
            var s = n.readUshort(r, t);
            t += 2, n.readUshort(r, t);
            for(var i, h = [
                "copyright",
                "fontFamily",
                "fontSubfamily",
                "ID",
                "fullName",
                "version",
                "postScriptName",
                "trademark",
                "manufacturer",
                "designer",
                "description",
                "urlVendor",
                "urlDesigner",
                "licence",
                "licenceURL",
                "---",
                "typoFamilyName",
                "typoSubfamilyName",
                "compatibleFull",
                "sampleText",
                "postScriptCID",
                "wwsFamilyName",
                "wwsSubfamilyName",
                "lightPalette",
                "darkPalette"
            ], f = t += 2, d = 0; d < s; d++){
                var u = n.readUshort(r, t);
                t += 2;
                var l = n.readUshort(r, t);
                t += 2;
                var v = n.readUshort(r, t);
                t += 2;
                var c = n.readUshort(r, t);
                t += 2;
                var p = n.readUshort(r, t);
                t += 2;
                var U = n.readUshort(r, t);
                t += 2;
                var g, S = h[c], m = f + 12 * s + U;
                if (0 == u) g = n.readUnicode(r, m, p / 2);
                else if (3 == u && 0 == l) g = n.readUnicode(r, m, p / 2);
                else if (0 == l) g = n.readASCII(r, m, p);
                else if (1 == l) g = n.readUnicode(r, m, p / 2);
                else if (3 == l) g = n.readUnicode(r, m, p / 2);
                else {
                    if (1 != u) throw "unknown encoding " + l + ", platformID: " + u;
                    g = n.readASCII(r, m, p), console.debug("reading unknown MAC encoding " + l + " as ASCII");
                }
                var b = "p" + u + "," + v.toString(16);
                null == o[b] && (o[b] = {}), o[b][void 0 !== S ? S : c] = g, o[b]._lang = v;
            }
            for(var y in o)if (null != o[y].postScriptName && 1033 == o[y]._lang) return o[y];
            for(var y in o)if (null != o[y].postScriptName && 0 == o[y]._lang) return o[y];
            for(var y in o)if (null != o[y].postScriptName && 3084 == o[y]._lang) return o[y];
            for(var y in o)if (null != o[y].postScriptName) return o[y];
            for(var y in o){
                i = y;
                break;
            }
            return console.debug("returning name table with languageID " + o[i]._lang), o[i];
        }, e["OS/2"] = {}, e["OS/2"].parse = function(r, t, a) {
            var n = e._bin.readUshort(r, t);
            t += 2;
            var o = {};
            if (0 == n) e["OS/2"].version0(r, t, o);
            else if (1 == n) e["OS/2"].version1(r, t, o);
            else if (2 == n || 3 == n || 4 == n) e["OS/2"].version2(r, t, o);
            else {
                if (5 != n) throw "unknown OS/2 table version: " + n;
                e["OS/2"].version5(r, t, o);
            }
            return o;
        }, e["OS/2"].version0 = function(r, t, a) {
            var n = e._bin;
            return a.xAvgCharWidth = n.readShort(r, t), t += 2, a.usWeightClass = n.readUshort(r, t), t += 2, a.usWidthClass = n.readUshort(r, t), t += 2, a.fsType = n.readUshort(r, t), t += 2, a.ySubscriptXSize = n.readShort(r, t), t += 2, a.ySubscriptYSize = n.readShort(r, t), t += 2, a.ySubscriptXOffset = n.readShort(r, t), t += 2, a.ySubscriptYOffset = n.readShort(r, t), t += 2, a.ySuperscriptXSize = n.readShort(r, t), t += 2, a.ySuperscriptYSize = n.readShort(r, t), t += 2, a.ySuperscriptXOffset = n.readShort(r, t), t += 2, a.ySuperscriptYOffset = n.readShort(r, t), t += 2, a.yStrikeoutSize = n.readShort(r, t), t += 2, a.yStrikeoutPosition = n.readShort(r, t), t += 2, a.sFamilyClass = n.readShort(r, t), t += 2, a.panose = n.readBytes(r, t, 10), t += 10, a.ulUnicodeRange1 = n.readUint(r, t), t += 4, a.ulUnicodeRange2 = n.readUint(r, t), t += 4, a.ulUnicodeRange3 = n.readUint(r, t), t += 4, a.ulUnicodeRange4 = n.readUint(r, t), t += 4, a.achVendID = [
                n.readInt8(r, t),
                n.readInt8(r, t + 1),
                n.readInt8(r, t + 2),
                n.readInt8(r, t + 3)
            ], t += 4, a.fsSelection = n.readUshort(r, t), t += 2, a.usFirstCharIndex = n.readUshort(r, t), t += 2, a.usLastCharIndex = n.readUshort(r, t), t += 2, a.sTypoAscender = n.readShort(r, t), t += 2, a.sTypoDescender = n.readShort(r, t), t += 2, a.sTypoLineGap = n.readShort(r, t), t += 2, a.usWinAscent = n.readUshort(r, t), t += 2, a.usWinDescent = n.readUshort(r, t), t += 2;
        }, e["OS/2"].version1 = function(r, t, a) {
            var n = e._bin;
            return t = e["OS/2"].version0(r, t, a), a.ulCodePageRange1 = n.readUint(r, t), t += 4, a.ulCodePageRange2 = n.readUint(r, t), t += 4;
        }, e["OS/2"].version2 = function(r, t, a) {
            var n = e._bin;
            return t = e["OS/2"].version1(r, t, a), a.sxHeight = n.readShort(r, t), t += 2, a.sCapHeight = n.readShort(r, t), t += 2, a.usDefault = n.readUshort(r, t), t += 2, a.usBreak = n.readUshort(r, t), t += 2, a.usMaxContext = n.readUshort(r, t), t += 2;
        }, e["OS/2"].version5 = function(r, t, a) {
            var n = e._bin;
            return t = e["OS/2"].version2(r, t, a), a.usLowerOpticalPointSize = n.readUshort(r, t), t += 2, a.usUpperOpticalPointSize = n.readUshort(r, t), t += 2;
        }, e.post = {}, e.post.parse = function(r, t, a) {
            var n = e._bin, o = {};
            return o.version = n.readFixed(r, t), t += 4, o.italicAngle = n.readFixed(r, t), t += 4, o.underlinePosition = n.readShort(r, t), t += 2, o.underlineThickness = n.readShort(r, t), t += 2, o;
        }, null == e && (e = {}), null == e.U && (e.U = {}), e.U.codeToGlyph = function(r, e) {
            var t = r.cmap, a = -1;
            if (null != t.p0e4 ? a = t.p0e4 : null != t.p3e1 ? a = t.p3e1 : null != t.p1e0 ? a = t.p1e0 : null != t.p0e3 && (a = t.p0e3), -1 == a) throw "no familiar platform and encoding!";
            var n = t.tables[a];
            if (0 == n.format) return e >= n.map.length ? 0 : n.map[e];
            if (4 == n.format) {
                for(var o = -1, s = 0; s < n.endCount.length; s++)if (e <= n.endCount[s]) {
                    o = s;
                    break;
                }
                if (-1 == o) return 0;
                if (n.startCount[o] > e) return 0;
                return 65535 & (0 != n.idRangeOffset[o] ? n.glyphIdArray[e - n.startCount[o] + (n.idRangeOffset[o] >> 1) - (n.idRangeOffset.length - o)] : e + n.idDelta[o]);
            }
            if (12 == n.format) {
                if (e > n.groups[n.groups.length - 1][1]) return 0;
                for(s = 0; s < n.groups.length; s++){
                    var i = n.groups[s];
                    if (i[0] <= e && e <= i[1]) return i[2] + (e - i[0]);
                }
                return 0;
            }
            throw "unknown cmap table format " + n.format;
        }, e.U.glyphToPath = function(r, t) {
            var a = {
                cmds: [],
                crds: []
            };
            if (r.SVG && r.SVG.entries[t]) {
                var n = r.SVG.entries[t];
                return null == n ? a : ("string" == typeof n && (n = e.SVG.toPath(n), r.SVG.entries[t] = n), n);
            }
            if (r.CFF) {
                var o = {
                    x: 0,
                    y: 0,
                    stack: [],
                    nStems: 0,
                    haveWidth: !1,
                    width: r.CFF.Private ? r.CFF.Private.defaultWidthX : 0,
                    open: !1
                }, s = r.CFF, i = r.CFF.Private;
                if (s.ROS) {
                    for(var h = 0; s.FDSelect[h + 2] <= t;)h += 2;
                    i = s.FDArray[s.FDSelect[h + 1]].Private;
                }
                e.U._drawCFF(r.CFF.CharStrings[t], o, s, i, a);
            } else r.glyf && e.U._drawGlyf(t, r, a);
            return a;
        }, e.U._drawGlyf = function(r, t, a) {
            var n = t.glyf[r];
            null == n && (n = t.glyf[r] = e.glyf._parseGlyf(t, r)), null != n && (n.noc > -1 ? e.U._simpleGlyph(n, a) : e.U._compoGlyph(n, t, a));
        }, e.U._simpleGlyph = function(r, t) {
            for(var a = 0; a < r.noc; a++){
                for(var n = 0 == a ? 0 : r.endPts[a - 1] + 1, o = r.endPts[a], s = n; s <= o; s++){
                    var i = s == n ? o : s - 1, h = s == o ? n : s + 1, f = 1 & r.flags[s], d = 1 & r.flags[i], u = 1 & r.flags[h], l = r.xs[s], v = r.ys[s];
                    if (s == n) {
                        if (f) {
                            if (!d) {
                                e.U.P.moveTo(t, l, v);
                                continue;
                            }
                            e.U.P.moveTo(t, r.xs[i], r.ys[i]);
                        } else d ? e.U.P.moveTo(t, r.xs[i], r.ys[i]) : e.U.P.moveTo(t, (r.xs[i] + l) / 2, (r.ys[i] + v) / 2);
                    }
                    f ? d && e.U.P.lineTo(t, l, v) : u ? e.U.P.qcurveTo(t, l, v, r.xs[h], r.ys[h]) : e.U.P.qcurveTo(t, l, v, (l + r.xs[h]) / 2, (v + r.ys[h]) / 2);
                }
                e.U.P.closePath(t);
            }
        }, e.U._compoGlyph = function(r, t, a) {
            for(var n = 0; n < r.parts.length; n++){
                var o = {
                    cmds: [],
                    crds: []
                }, s = r.parts[n];
                e.U._drawGlyf(s.glyphIndex, t, o);
                for(var i = s.m, h = 0; h < o.crds.length; h += 2){
                    var f = o.crds[h], d = o.crds[h + 1];
                    a.crds.push(f * i.a + d * i.b + i.tx), a.crds.push(f * i.c + d * i.d + i.ty);
                }
                for(h = 0; h < o.cmds.length; h++)a.cmds.push(o.cmds[h]);
            }
        }, e.U._getGlyphClass = function(r, t) {
            var a = e._lctf.getInterval(t, r);
            return -1 == a ? 0 : t[a + 2];
        }, e.U.getPairAdjustment = function(r, t, a) {
            var n = !1;
            if (r.GPOS) for(var o = r.GPOS, s = o.lookupList, i = o.featureList, h = [], f = 0; f < i.length; f++){
                var d = i[f];
                if ("kern" == d.tag) {
                    n = !0;
                    for(var u = 0; u < d.tab.length; u++)if (!h[d.tab[u]]) {
                        h[d.tab[u]] = !0;
                        for(var l = s[d.tab[u]], v = 0; v < l.tabs.length; v++)if (null != l.tabs[v]) {
                            var c, p = l.tabs[v];
                            if (!p.coverage || -1 != (c = e._lctf.coverageIndex(p.coverage, t))) {
                                if (1 == l.ltype) ;
                                else if (2 == l.ltype) {
                                    var U = null;
                                    if (1 == p.fmt) {
                                        var g = p.pairsets[c];
                                        for(f = 0; f < g.length; f++)g[f].gid2 == a && (U = g[f]);
                                    } else if (2 == p.fmt) {
                                        var S = e.U._getGlyphClass(t, p.classDef1), m = e.U._getGlyphClass(a, p.classDef2);
                                        U = p.matrix[S][m];
                                    }
                                    if (U) {
                                        var b = 0;
                                        return U.val1 && U.val1[2] && (b += U.val1[2]), U.val2 && U.val2[0] && (b += U.val2[0]), b;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            if (r.kern && !n) {
                var y = r.kern.glyph1.indexOf(t);
                if (-1 != y) {
                    var F = r.kern.rval[y].glyph2.indexOf(a);
                    if (-1 != F) return r.kern.rval[y].vals[F];
                }
            }
            return 0;
        }, e.U._applySubs = function(r, t, a, n) {
            for(var o = r.length - t - 1, s = 0; s < a.tabs.length; s++)if (null != a.tabs[s]) {
                var i, h = a.tabs[s];
                if (!h.coverage || -1 != (i = e._lctf.coverageIndex(h.coverage, r[t]))) {
                    if (1 == a.ltype) r[t], 1 == h.fmt ? r[t] = r[t] + h.delta : r[t] = h.newg[i];
                    else if (4 == a.ltype) for(var f = h.vals[i], d = 0; d < f.length; d++){
                        var u = f[d], l = u.chain.length;
                        if (!(l > o)) {
                            for(var v = !0, c = 0, p = 0; p < l; p++){
                                for(; -1 == r[t + c + (1 + p)];)c++;
                                u.chain[p] != r[t + c + (1 + p)] && (v = !1);
                            }
                            if (v) {
                                r[t] = u.nglyph;
                                for(p = 0; p < l + c; p++)r[t + p + 1] = -1;
                                break;
                            }
                        }
                    }
                    else if (5 == a.ltype && 2 == h.fmt) for(var U = e._lctf.getInterval(h.cDef, r[t]), g = h.cDef[U + 2], S = h.scset[g], m = 0; m < S.length; m++){
                        var b = S[m], y = b.input;
                        if (!(y.length > o)) {
                            for(v = !0, p = 0; p < y.length; p++){
                                var F = e._lctf.getInterval(h.cDef, r[t + 1 + p]);
                                if (-1 == U && h.cDef[F + 2] != y[p]) {
                                    v = !1;
                                    break;
                                }
                            }
                            if (v) {
                                var _ = b.substLookupRecords;
                                for(d = 0; d < _.length; d += 2)_[d], _[d + 1];
                            }
                        }
                    }
                    else if (6 == a.ltype && 3 == h.fmt) {
                        if (!e.U._glsCovered(r, h.backCvg, t - h.backCvg.length)) continue;
                        if (!e.U._glsCovered(r, h.inptCvg, t)) continue;
                        if (!e.U._glsCovered(r, h.ahedCvg, t + h.inptCvg.length)) continue;
                        var C = h.lookupRec;
                        for(m = 0; m < C.length; m += 2){
                            U = C[m];
                            var x = n[C[m + 1]];
                            e.U._applySubs(r, t + U, x, n);
                        }
                    }
                }
            }
        }, e.U._glsCovered = function(r, t, a) {
            for(var n = 0; n < t.length; n++){
                if (-1 == e._lctf.coverageIndex(t[n], r[a + n])) return !1;
            }
            return !0;
        }, e.U.glyphsToPath = function(r, t, a) {
            for(var n = {
                cmds: [],
                crds: []
            }, o = 0, s = 0; s < t.length; s++){
                var i = t[s];
                if (-1 != i) {
                    for(var h = s < t.length - 1 && -1 != t[s + 1] ? t[s + 1] : 0, f = e.U.glyphToPath(r, i), d = 0; d < f.crds.length; d += 2)n.crds.push(f.crds[d] + o), n.crds.push(f.crds[d + 1]);
                    a && n.cmds.push(a);
                    for(d = 0; d < f.cmds.length; d++)n.cmds.push(f.cmds[d]);
                    a && n.cmds.push("X"), o += r.hmtx.aWidth[i], s < t.length - 1 && (o += e.U.getPairAdjustment(r, i, h));
                }
            }
            return n;
        }, e.U.P = {}, e.U.P.moveTo = function(r, e, t) {
            r.cmds.push("M"), r.crds.push(e, t);
        }, e.U.P.lineTo = function(r, e, t) {
            r.cmds.push("L"), r.crds.push(e, t);
        }, e.U.P.curveTo = function(r, e, t, a, n, o, s) {
            r.cmds.push("C"), r.crds.push(e, t, a, n, o, s);
        }, e.U.P.qcurveTo = function(r, e, t, a, n) {
            r.cmds.push("Q"), r.crds.push(e, t, a, n);
        }, e.U.P.closePath = function(r) {
            r.cmds.push("Z");
        }, e.U._drawCFF = function(r, t, a, n, o) {
            for(var s = t.stack, i = t.nStems, h = t.haveWidth, f = t.width, d = t.open, u = 0, l = t.x, v = t.y, c = 0, p = 0, U = 0, g = 0, S = 0, m = 0, b = 0, y = 0, F = 0, _ = 0, C = {
                val: 0,
                size: 0
            }; u < r.length;){
                e.CFF.getCharString(r, u, C);
                var x = C.val;
                if (u += C.size, "o1" == x || "o18" == x) s.length % 2 != 0 && !h && (f = s.shift() + n.nominalWidthX), i += s.length >> 1, s.length = 0, h = !0;
                else if ("o3" == x || "o23" == x) s.length % 2 != 0 && !h && (f = s.shift() + n.nominalWidthX), i += s.length >> 1, s.length = 0, h = !0;
                else if ("o4" == x) s.length > 1 && !h && (f = s.shift() + n.nominalWidthX, h = !0), d && e.U.P.closePath(o), v += s.pop(), e.U.P.moveTo(o, l, v), d = !0;
                else if ("o5" == x) for(; s.length > 0;)l += s.shift(), v += s.shift(), e.U.P.lineTo(o, l, v);
                else if ("o6" == x || "o7" == x) for(var P = s.length, I = "o6" == x, w = 0; w < P; w++){
                    var O = s.shift();
                    I ? l += O : v += O, I = !I, e.U.P.lineTo(o, l, v);
                }
                else if ("o8" == x || "o24" == x) {
                    P = s.length;
                    for(var T = 0; T + 6 <= P;)c = l + s.shift(), p = v + s.shift(), U = c + s.shift(), g = p + s.shift(), l = U + s.shift(), v = g + s.shift(), e.U.P.curveTo(o, c, p, U, g, l, v), T += 6;
                    "o24" == x && (l += s.shift(), v += s.shift(), e.U.P.lineTo(o, l, v));
                } else {
                    if ("o11" == x) break;
                    if ("o1234" == x || "o1235" == x || "o1236" == x || "o1237" == x) "o1234" == x && (p = v, U = (c = l + s.shift()) + s.shift(), _ = g = p + s.shift(), m = g, y = v, l = (b = (S = (F = U + s.shift()) + s.shift()) + s.shift()) + s.shift(), e.U.P.curveTo(o, c, p, U, g, F, _), e.U.P.curveTo(o, S, m, b, y, l, v)), "o1235" == x && (c = l + s.shift(), p = v + s.shift(), U = c + s.shift(), g = p + s.shift(), F = U + s.shift(), _ = g + s.shift(), S = F + s.shift(), m = _ + s.shift(), b = S + s.shift(), y = m + s.shift(), l = b + s.shift(), v = y + s.shift(), s.shift(), e.U.P.curveTo(o, c, p, U, g, F, _), e.U.P.curveTo(o, S, m, b, y, l, v)), "o1236" == x && (c = l + s.shift(), p = v + s.shift(), U = c + s.shift(), _ = g = p + s.shift(), m = g, b = (S = (F = U + s.shift()) + s.shift()) + s.shift(), y = m + s.shift(), l = b + s.shift(), e.U.P.curveTo(o, c, p, U, g, F, _), e.U.P.curveTo(o, S, m, b, y, l, v)), "o1237" == x && (c = l + s.shift(), p = v + s.shift(), U = c + s.shift(), g = p + s.shift(), F = U + s.shift(), _ = g + s.shift(), S = F + s.shift(), m = _ + s.shift(), b = S + s.shift(), y = m + s.shift(), Math.abs(b - l) > Math.abs(y - v) ? l = b + s.shift() : v = y + s.shift(), e.U.P.curveTo(o, c, p, U, g, F, _), e.U.P.curveTo(o, S, m, b, y, l, v));
                    else if ("o14" == x) {
                        if (s.length > 0 && !h && (f = s.shift() + a.nominalWidthX, h = !0), 4 == s.length) {
                            var k = s.shift(), G = s.shift(), D = s.shift(), B = s.shift(), L = e.CFF.glyphBySE(a, D), R = e.CFF.glyphBySE(a, B);
                            e.U._drawCFF(a.CharStrings[L], t, a, n, o), t.x = k, t.y = G, e.U._drawCFF(a.CharStrings[R], t, a, n, o);
                        }
                        d && (e.U.P.closePath(o), d = !1);
                    } else if ("o19" == x || "o20" == x) s.length % 2 != 0 && !h && (f = s.shift() + n.nominalWidthX), i += s.length >> 1, s.length = 0, h = !0, u += i + 7 >> 3;
                    else if ("o21" == x) s.length > 2 && !h && (f = s.shift() + n.nominalWidthX, h = !0), v += s.pop(), l += s.pop(), d && e.U.P.closePath(o), e.U.P.moveTo(o, l, v), d = !0;
                    else if ("o22" == x) s.length > 1 && !h && (f = s.shift() + n.nominalWidthX, h = !0), l += s.pop(), d && e.U.P.closePath(o), e.U.P.moveTo(o, l, v), d = !0;
                    else if ("o25" == x) {
                        for(; s.length > 6;)l += s.shift(), v += s.shift(), e.U.P.lineTo(o, l, v);
                        c = l + s.shift(), p = v + s.shift(), U = c + s.shift(), g = p + s.shift(), l = U + s.shift(), v = g + s.shift(), e.U.P.curveTo(o, c, p, U, g, l, v);
                    } else if ("o26" == x) for(s.length % 2 && (l += s.shift()); s.length > 0;)c = l, p = v + s.shift(), l = U = c + s.shift(), v = (g = p + s.shift()) + s.shift(), e.U.P.curveTo(o, c, p, U, g, l, v);
                    else if ("o27" == x) for(s.length % 2 && (v += s.shift()); s.length > 0;)p = v, U = (c = l + s.shift()) + s.shift(), g = p + s.shift(), l = U + s.shift(), v = g, e.U.P.curveTo(o, c, p, U, g, l, v);
                    else if ("o10" == x || "o29" == x) {
                        var A = "o10" == x ? n : a;
                        if (0 == s.length) console.debug("error: empty stack");
                        else {
                            var W = s.pop(), M = A.Subrs[W + A.Bias];
                            t.x = l, t.y = v, t.nStems = i, t.haveWidth = h, t.width = f, t.open = d, e.U._drawCFF(M, t, a, n, o), l = t.x, v = t.y, i = t.nStems, h = t.haveWidth, f = t.width, d = t.open;
                        }
                    } else if ("o30" == x || "o31" == x) {
                        var V = s.length, N = (T = 0, "o31" == x);
                        for(T += V - (P = -3 & V); T < P;)N ? (p = v, U = (c = l + s.shift()) + s.shift(), v = (g = p + s.shift()) + s.shift(), P - T == 5 ? (l = U + s.shift(), T++) : l = U, N = !1) : (c = l, p = v + s.shift(), U = c + s.shift(), g = p + s.shift(), l = U + s.shift(), P - T == 5 ? (v = g + s.shift(), T++) : v = g, N = !0), e.U.P.curveTo(o, c, p, U, g, l, v), T += 4;
                    } else {
                        if ("o" == (x + "").charAt(0)) throw console.debug("Unknown operation: " + x, r), x;
                        s.push(x);
                    }
                }
            }
            t.x = l, t.y = v, t.nStems = i, t.haveWidth = h, t.width = f, t.open = d;
        };
        var t = e, a = {
            Typr: t
        };
        return r.Typr = t, r.default = a, Object.defineProperty(r, "__esModule", {
            value: !0
        }), r;
    }({}).Typr;
}
/*!
Custom bundle of woff2otf (https://github.com/arty-name/woff2otf) with fflate
(https://github.com/101arrowz/fflate) for use in Troika text rendering. 
Original licenses apply: 
- fflate: https://github.com/101arrowz/fflate/blob/master/LICENSE (MIT)
- woff2otf.js: https://github.com/arty-name/woff2otf/blob/master/woff2otf.js (Apache2)
*/ function $6591e3ca76d1668d$var$woff2otfFactory() {
    return function(r) {
        var e = Uint8Array, n = Uint16Array, t = Uint32Array, a = new e([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            1,
            1,
            1,
            2,
            2,
            2,
            2,
            3,
            3,
            3,
            3,
            4,
            4,
            4,
            4,
            5,
            5,
            5,
            5,
            0,
            0,
            0,
            0
        ]), i = new e([
            0,
            0,
            0,
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            4,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            8,
            8,
            9,
            9,
            10,
            10,
            11,
            11,
            12,
            12,
            13,
            13,
            0,
            0
        ]), o = new e([
            16,
            17,
            18,
            0,
            8,
            7,
            9,
            6,
            10,
            5,
            11,
            4,
            12,
            3,
            13,
            2,
            14,
            1,
            15
        ]), f = function f(r, e) {
            for(var a = new n(31), i = 0; i < 31; ++i)a[i] = e += 1 << r[i - 1];
            var o = new t(a[30]);
            for(i = 1; i < 30; ++i)for(var f = a[i]; f < a[i + 1]; ++f)o[f] = f - a[i] << 5 | i;
            return [
                a,
                o
            ];
        }, u = f(a, 2), v = u[0], s = u[1];
        v[28] = 258, s[258] = 28;
        for(var l = f(i, 0)[0], c = new n(32768), g = 0; g < 32768; ++g){
            var h = (43690 & g) >>> 1 | (21845 & g) << 1;
            h = (61680 & (h = (52428 & h) >>> 2 | (13107 & h) << 2)) >>> 4 | (3855 & h) << 4, c[g] = ((65280 & h) >>> 8 | (255 & h) << 8) >>> 1;
        }
        var w = function w(r, e, t) {
            for(var a = r.length, i = 0, o = new n(e); i < a; ++i)++o[r[i] - 1];
            var f, u = new n(e);
            for(i = 0; i < e; ++i)u[i] = u[i - 1] + o[i - 1] << 1;
            if (t) {
                f = new n(1 << e);
                var v = 15 - e;
                for(i = 0; i < a; ++i)if (r[i]) for(var s = i << 4 | r[i], l = e - r[i], g = u[r[i] - 1]++ << l, h = g | (1 << l) - 1; g <= h; ++g)f[c[g] >>> v] = s;
            } else for(f = new n(a), i = 0; i < a; ++i)r[i] && (f[i] = c[u[r[i] - 1]++] >>> 15 - r[i]);
            return f;
        }, d = new e(288);
        for(g = 0; g < 144; ++g)d[g] = 8;
        for(g = 144; g < 256; ++g)d[g] = 9;
        for(g = 256; g < 280; ++g)d[g] = 7;
        for(g = 280; g < 288; ++g)d[g] = 8;
        var m = new e(32);
        for(g = 0; g < 32; ++g)m[g] = 5;
        var b = w(d, 9, 1), p = w(m, 5, 1), y = function y(r) {
            for(var e = r[0], n = 1; n < r.length; ++n)r[n] > e && (e = r[n]);
            return e;
        }, L = function L(r, e, n) {
            var t = e / 8 | 0;
            return (r[t] | r[t + 1] << 8) >> (7 & e) & n;
        }, U = function U(r, e) {
            var n = e / 8 | 0;
            return (r[n] | r[n + 1] << 8 | r[n + 2] << 16) >> (7 & e);
        }, k = [
            "unexpected EOF",
            "invalid block type",
            "invalid length/literal",
            "invalid distance",
            "stream finished",
            "no stream handler",
            ,
            "no callback",
            "invalid UTF-8 data",
            "extra field too long",
            "date not in range 1980-2099",
            "filename too long",
            "stream finishing",
            "invalid zip data"
        ], T = function T1(r, e, n) {
            var t = new Error(e || k[r]);
            if (t.code = r, Error.captureStackTrace && Error.captureStackTrace(t, T), !n) throw t;
            return t;
        }, O = function O(r, f, u) {
            var s = r.length;
            if (!s || u && !u.l && s < 5) return f || new e(0);
            var c = !f || u, g = !u || u.i;
            u || (u = {}), f || (f = new e(3 * s));
            var h, d = function d(r) {
                var n = f.length;
                if (r > n) {
                    var t = new e(Math.max(2 * n, r));
                    t.set(f), f = t;
                }
            }, m = u.f || 0, k = u.p || 0, O = u.b || 0, A = u.l, x = u.d, E = u.m, D = u.n, M = 8 * s;
            do {
                if (!A) {
                    u.f = m = L(r, k, 1);
                    var S = L(r, k + 1, 3);
                    if (k += 3, !S) {
                        var V = r[(I = ((h = k) / 8 | 0) + (7 & h && 1) + 4) - 4] | r[I - 3] << 8, _ = I + V;
                        if (_ > s) {
                            g && T(0);
                            break;
                        }
                        c && d(O + V), f.set(r.subarray(I, _), O), u.b = O += V, u.p = k = 8 * _;
                        continue;
                    }
                    if (1 == S) A = b, x = p, E = 9, D = 5;
                    else if (2 == S) {
                        var j = L(r, k, 31) + 257, z = L(r, k + 10, 15) + 4, C = j + L(r, k + 5, 31) + 1;
                        k += 14;
                        for(var F = new e(C), P = new e(19), q = 0; q < z; ++q)P[o[q]] = L(r, k + 3 * q, 7);
                        k += 3 * z;
                        var B = y(P), G = (1 << B) - 1, H = w(P, B, 1);
                        for(q = 0; q < C;){
                            var I, J = H[L(r, k, G)];
                            if (k += 15 & J, (I = J >>> 4) < 16) F[q++] = I;
                            else {
                                var K = 0, N = 0;
                                for(16 == I ? (N = 3 + L(r, k, 3), k += 2, K = F[q - 1]) : 17 == I ? (N = 3 + L(r, k, 7), k += 3) : 18 == I && (N = 11 + L(r, k, 127), k += 7); N--;)F[q++] = K;
                            }
                        }
                        var Q = F.subarray(0, j), R = F.subarray(j);
                        E = y(Q), D = y(R), A = w(Q, E, 1), x = w(R, D, 1);
                    } else T(1);
                    if (k > M) {
                        g && T(0);
                        break;
                    }
                }
                c && d(O + 131072);
                for(var W = (1 << E) - 1, X = (1 << D) - 1, Y = k;; Y = k){
                    var Z = (K = A[U(r, k) & W]) >>> 4;
                    if ((k += 15 & K) > M) {
                        g && T(0);
                        break;
                    }
                    if (K || T(2), Z < 256) f[O++] = Z;
                    else {
                        if (256 == Z) {
                            Y = k, A = null;
                            break;
                        }
                        var $ = Z - 254;
                        if (Z > 264) {
                            var rr = a[q = Z - 257];
                            $ = L(r, k, (1 << rr) - 1) + v[q], k += rr;
                        }
                        var er = x[U(r, k) & X], nr = er >>> 4;
                        er || T(3), k += 15 & er;
                        R = l[nr];
                        if (nr > 3) {
                            rr = i[nr];
                            R += U(r, k) & (1 << rr) - 1, k += rr;
                        }
                        if (k > M) {
                            g && T(0);
                            break;
                        }
                        c && d(O + 131072);
                        for(var tr = O + $; O < tr; O += 4)f[O] = f[O - R], f[O + 1] = f[O + 1 - R], f[O + 2] = f[O + 2 - R], f[O + 3] = f[O + 3 - R];
                        O = tr;
                    }
                }
                u.l = A, u.p = Y, u.b = O, A && (m = 1, u.m = E, u.d = x, u.n = D);
            }while (!m);
            return O == f.length ? f : function(r, a, i) {
                (null == a || a < 0) && (a = 0), (null == i || i > r.length) && (i = r.length);
                var o = new (r instanceof n ? n : r instanceof t ? t : e)(i - a);
                return o.set(r.subarray(a, i)), o;
            }(f, 0, O);
        }, A = new e(0);
        var x = "undefined" != typeof TextDecoder && new TextDecoder;
        try {
            x.decode(A, {
                stream: !0
            });
        } catch (r) {}
        return r.convert_streams = function(r) {
            var e = new DataView(r), n = 0;
            function t() {
                var _$r = e.getUint16(n);
                return n += 2, _$r;
            }
            function a() {
                var _$r = e.getUint32(n);
                return n += 4, _$r;
            }
            function i(r) {
                m.setUint16(b, r), b += 2;
            }
            function o(r) {
                m.setUint32(b, r), b += 4;
            }
            for(var f = {
                signature: a(),
                flavor: a(),
                length: a(),
                numTables: t(),
                reserved: t(),
                totalSfntSize: a(),
                majorVersion: t(),
                minorVersion: t(),
                metaOffset: a(),
                metaLength: a(),
                metaOrigLength: a(),
                privOffset: a(),
                privLength: a()
            }, u = 0; Math.pow(2, u) <= f.numTables;)u++;
            u--;
            for(var v = 16 * Math.pow(2, u), s = 16 * f.numTables - v, l = 12, c = [], g = 0; g < f.numTables; g++)c.push({
                tag: a(),
                offset: a(),
                compLength: a(),
                origLength: a(),
                origChecksum: a()
            }), l += 16;
            var h, w = new Uint8Array(12 + 16 * c.length + c.reduce(function(r, e) {
                return r + e.origLength + 4;
            }, 0)), d = w.buffer, m = new DataView(d), b = 0;
            return o(f.flavor), i(f.numTables), i(v), i(u), i(s), c.forEach(function(r) {
                o(r.tag), o(r.origChecksum), o(l), o(r.origLength), r.outOffset = l, (l += r.origLength) % 4 != 0 && (l += 4 - l % 4);
            }), c.forEach(function(e) {
                var n, _$t = r.slice(e.offset, e.offset + e.compLength);
                if (e.compLength != e.origLength) {
                    var _$a = new Uint8Array(e.origLength);
                    n = new Uint8Array(_$t, 2), O(n, _$a);
                } else _$a = new Uint8Array(_$t);
                w.set(_$a, e.outOffset);
                var _$i = 0;
                (l = e.outOffset + e.origLength) % 4 != 0 && (_$i = 4 - l % 4), w.set(new Uint8Array(_$i).buffer, e.outOffset + e.origLength), h = l + _$i;
            }), d.slice(0, h);
        }, Object.defineProperty(r, "__esModule", {
            value: !0
        }), r;
    }({}).convert_streams;
}
/**
 * A factory wrapper parsing a font file using Typr.
 * Also adds support for WOFF files (not WOFF2).
 */ function $6591e3ca76d1668d$var$parserFactory(Typr, woff2otf) {
    var cmdArgLengths = {
        M: 2,
        L: 2,
        Q: 4,
        C: 6,
        Z: 0
    };
    // {joinType: "skip+step,..."}
    var joiningTypeRawData = {
        "C": "18g,ca,368,1kz",
        "D": "17k,6,2,2+4,5+c,2+6,2+1,10+1,9+f,j+11,2+1,a,2,2+1,15+2,3,j+2,6+3,2+8,2,2,2+1,w+a,4+e,3+3,2,3+2,3+5,23+w,2f+4,3,2+9,2,b,2+3,3,1k+9,6+1,3+1,2+2,2+d,30g,p+y,1,1+1g,f+x,2,sd2+1d,jf3+4,f+3,2+4,2+2,b+3,42,2,4+2,2+1,2,3,t+1,9f+w,2,el+2,2+g,d+2,2l,2+1,5,3+1,2+1,2,3,6,16wm+1v",
        "R": "17m+3,2,2,6+3,m,15+2,2+2,h+h,13,3+8,2,2,3+1,2,p+1,x,5+4,5,a,2,2,3,u,c+2,g+1,5,2+1,4+1,5j,6+1,2,b,2+2,f,2+1,1s+2,2,3+1,7,1ez0,2,2+1,4+4,b,4,3,b,42,2+2,4,3,2+1,2,o+3,ae,ep,x,2o+2,3+1,3,5+1,6",
        "L": "x9u,jff,a,fd,jv",
        "T": "4t,gj+33,7o+4,1+1,7c+18,2,2+1,2+1,2,21+a,2,1b+k,h,2u+6,3+5,3+1,2+3,y,2,v+q,2k+a,1n+8,a,p+3,2+8,2+2,2+4,18+2,3c+e,2+v,1k,2,5+7,5,4+6,b+1,u,1n,5+3,9,l+1,r,3+1,1m,5+1,5+1,3+2,4,v+1,4,c+1,1m,5+4,2+1,5,l+1,n+5,2,1n,3,2+3,9,8+1,c+1,v,1q,d,1f,4,1m+2,6+2,2+3,8+1,c+1,u,1n,3,7,6+1,l+1,t+1,1m+1,5+3,9,l+1,u,21,8+2,2,2j,3+6,d+7,2r,3+8,c+5,23+1,s,2,2,1k+d,2+4,2+1,6+a,2+z,a,2v+3,2+5,2+1,3+1,q+1,5+2,h+3,e,3+1,7,g,jk+2,qb+2,u+2,u+1,v+1,1t+1,2+6,9,3+a,a,1a+2,3c+1,z,3b+2,5+1,a,7+2,64+1,3,1n,2+6,2,2,3+7,7+9,3,1d+d,1,1+1,1s+3,1d,2+4,2,6,15+8,d+1,x+3,3+1,2+2,1l,2+1,4,2+2,1n+7,3+1,49+2,2+c,2+6,5,7,4+1,5j+1l,2+4,ek,3+1,r+4,1e+4,6+5,2p+c,1+3,1,1+2,1+b,2db+2,3y,2p+v,ff+3,30+1,n9x,1+2,2+9,x+1,29+1,7l,4,5,q+1,6,48+1,r+h,e,13+7,q+a,1b+2,1d,3+3,3+1,14,1w+5,3+1,3+1,d,9,1c,1g,2+2,3+1,6+1,2,17+1,9,6n,3,5,fn5,ki+f,h+f,5s,6y+2,ea,6b,46+4,1af+2,2+1,6+3,15+2,5,4m+1,fy+3,as+1,4a+a,4x,1j+e,1l+2,1e+3,3+1,1y+2,11+4,2+7,1r,d+1,1h+8,b+3,3,2o+2,3,2+1,7,4h,4+7,m+1,1m+1,4,12+6,4+4,5g+7,3+2,2,o,2d+5,2,5+1,2+1,6n+3,7+1,2+1,s+1,2e+7,3,2+1,2z,2,3+5,2,2u+2,3+3,2+4,78+8,2+1,75+1,2,5,41+3,3+1,5,x+9,15+5,3+3,9,a+5,3+2,1b+c,2+1,bb+6,2+5,2,2b+l,3+6,2+1,2+1,3f+5,4,2+1,2+6,2,21+1,4,2,9o+1,470+8,at4+4,1o+6,t5,1s+3,2a,f5l+1,2+3,43o+2,a+7,1+7,3+6,v+3,45+2,1j0+1i,5+1d,9,f,n+4,2+e,11t+6,2+g,3+6,2+1,2+4,7a+6,c6+3,15t+6,32+6,1,gzau,v+2n,3l+6n"
    };
    var JT_LEFT = 1, JT_RIGHT = 2, JT_DUAL = 4, JT_TRANSPARENT = 8, JT_JOIN_CAUSING = 16, JT_NON_JOINING = 32; //indicates that a character does not join with the preceding or with the subsequent character.,
    var joiningTypeMap;
    function getCharJoiningType(ch) {
        if (!joiningTypeMap) {
            var _loop = function(type) {
                var lastCode = 0;
                joiningTypeRawData[type].split(',').forEach(function(range) {
                    var _range_split = (0, $cccf0333cb9f9910$export$71511d61b312f219)(range.split('+'), 2), skip = _range_split[0], step = _range_split[1];
                    skip = parseInt(skip, 36);
                    step = step ? parseInt(step, 36) : 0;
                    joiningTypeMap.set(lastCode += skip, m[type]);
                    for(var i = step; i--;)joiningTypeMap.set(++lastCode, m[type]);
                });
            };
            var m = {
                R: JT_RIGHT,
                L: JT_LEFT,
                D: JT_DUAL,
                C: JT_JOIN_CAUSING,
                U: JT_NON_JOINING,
                T: JT_TRANSPARENT
            };
            joiningTypeMap = new Map();
            for(var type in joiningTypeRawData)_loop(type);
        }
        return joiningTypeMap.get(ch) || JT_NON_JOINING;
    }
    var ISOL = 1, INIT = 2, FINA = 3, MEDI = 4;
    var formsToFeatures = [
        null,
        'isol',
        'init',
        'fina',
        'medi'
    ];
    function detectJoiningForms(str) {
        // This implements the algorithm described here:
        // https://github.com/n8willis/opentype-shaping-documents/blob/master/opentype-shaping-arabic-general.md
        var joiningForms = new Uint8Array(str.length);
        var prevJoiningType = JT_NON_JOINING;
        var prevForm = ISOL;
        var prevIndex = -1;
        for(var i = 0; i < str.length; i++){
            var code = str.codePointAt(i);
            var joiningType = getCharJoiningType(code) | 0;
            var form = ISOL;
            if (joiningType & JT_TRANSPARENT) continue;
            if (prevJoiningType & (JT_LEFT | JT_DUAL | JT_JOIN_CAUSING)) {
                if (joiningType & (JT_RIGHT | JT_DUAL | JT_JOIN_CAUSING)) {
                    form = FINA;
                    // isol->init, fina->medi
                    if (prevForm === ISOL || prevForm === FINA) joiningForms[prevIndex]++;
                } else if (joiningType & (JT_LEFT | JT_NON_JOINING)) // medi->fina, init->isol
                {
                    if (prevForm === INIT || prevForm === MEDI) joiningForms[prevIndex]--;
                }
            } else if (prevJoiningType & (JT_RIGHT | JT_NON_JOINING)) // medi->fina, init->isol
            {
                if (prevForm === INIT || prevForm === MEDI) joiningForms[prevIndex]--;
            }
            prevForm = joiningForms[i] = form;
            prevJoiningType = joiningType;
            prevIndex = i;
            if (code > 0xffff) i++;
        }
        // console.log(str.split('').map(ch => ch.codePointAt(0).toString(16)))
        // console.log(str.split('').map(ch => getCharJoiningType(ch.codePointAt(0))))
        // console.log(Array.from(joiningForms).map(f => formsToFeatures[f] || 'none'))
        return joiningForms;
    }
    function stringToGlyphs(font, str) {
        var glyphIds = [];
        for(var i = 0; i < str.length; i++){
            var cc = str.codePointAt(i);
            if (cc > 0xffff) i++;
            glyphIds.push(Typr.U.codeToGlyph(font, cc));
        }
        var gsub = font['GSUB'];
        if (gsub) {
            var lookupList = gsub.lookupList, featureList = gsub.featureList;
            var joiningForms;
            var supportedFeatures = /^(rlig|liga|mset|isol|init|fina|medi|half|pres|blws)$/;
            var usedLookups = [];
            featureList.forEach(function(feature) {
                if (supportedFeatures.test(feature.tag)) for(var ti = 0; ti < feature.tab.length; ti++){
                    if (usedLookups[feature.tab[ti]]) continue;
                    usedLookups[feature.tab[ti]] = true;
                    var tab = lookupList[feature.tab[ti]];
                    var isJoiningFeature = /^(isol|init|fina|medi)$/.test(feature.tag);
                    if (isJoiningFeature && !joiningForms) joiningForms = detectJoiningForms(str);
                    for(var ci = 0; ci < glyphIds.length; ci++)if (!joiningForms || !isJoiningFeature || formsToFeatures[joiningForms[ci]] === feature.tag) Typr.U._applySubs(glyphIds, ci, tab, lookupList);
                }
            });
        }
        return glyphIds;
    }
    function firstNum() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        for(var i = 0; i < args.length; i++){
            if (typeof args[i] === 'number') return args[i];
        }
    }
    function wrapFontObj(typrFont) {
        var glyphMap = Object.create(null);
        var os2 = typrFont['OS/2'];
        var hhea = typrFont.hhea;
        var unitsPerEm = typrFont.head.unitsPerEm;
        var ascender = firstNum(os2 && os2.sTypoAscender, hhea && hhea.ascender, unitsPerEm);
        var fontObj = {
            unitsPerEm: unitsPerEm,
            ascender: ascender,
            descender: firstNum(os2 && os2.sTypoDescender, hhea && hhea.descender, 0),
            capHeight: firstNum(os2 && os2.sCapHeight, ascender),
            xHeight: firstNum(os2 && os2.sxHeight, ascender),
            lineGap: firstNum(os2 && os2.sTypoLineGap, hhea && hhea.lineGap),
            forEachGlyph: function(text, fontSize, letterSpacing, callback) {
                var glyphX = 0;
                var fontScale = 1 / fontObj.unitsPerEm * fontSize;
                var glyphIndices = stringToGlyphs(typrFont, text);
                var charIndex = 0;
                var prevGlyphIndex = -1;
                glyphIndices.forEach(function(glyphIndex, i) {
                    // Typr returns a glyph index per string codepoint, with -1s in place of those that
                    // were omitted due to ligature substitution. So we can track original index in the
                    // string via simple increment, and skip everything else when seeing a -1.
                    if (glyphIndex !== -1) {
                        var glyphObj = glyphMap[glyphIndex];
                        if (!glyphObj) {
                            var _Typr_U_glyphToPath = Typr.U.glyphToPath(typrFont, glyphIndex), cmds = _Typr_U_glyphToPath.cmds, crds = _Typr_U_glyphToPath.crds;
                            // Build path string
                            var path = '';
                            var crdsIdx = 0;
                            for(var i1 = 0, len = cmds.length; i1 < len; i1++){
                                var numArgs = cmdArgLengths[cmds[i1]];
                                path += cmds[i1];
                                for(var j = 1; j <= numArgs; j++)path += (j > 1 ? ',' : '') + crds[crdsIdx++];
                            }
                            // Find extents - Glyf gives this in metadata but not CFF, and Typr doesn't
                            // normalize the two, so it's simplest just to iterate ourselves.
                            var xMin, yMin, xMax, yMax;
                            if (crds.length) {
                                xMin = yMin = Infinity;
                                xMax = yMax = -Infinity;
                                for(var i2 = 0, len1 = crds.length; i2 < len1; i2 += 2){
                                    var x = crds[i2];
                                    var y = crds[i2 + 1];
                                    if (x < xMin) xMin = x;
                                    if (y < yMin) yMin = y;
                                    if (x > xMax) xMax = x;
                                    if (y > yMax) yMax = y;
                                }
                            } else xMin = xMax = yMin = yMax = 0;
                            glyphObj = glyphMap[glyphIndex] = {
                                index: glyphIndex,
                                advanceWidth: typrFont.hmtx.aWidth[glyphIndex],
                                xMin: xMin,
                                yMin: yMin,
                                xMax: xMax,
                                yMax: yMax,
                                path: path,
                                pathCommandCount: cmds.length
                            };
                        }
                        // Kerning
                        if (prevGlyphIndex !== -1) glyphX += Typr.U.getPairAdjustment(typrFont, prevGlyphIndex, glyphIndex) * fontScale;
                        callback.call(null, glyphObj, glyphX, charIndex);
                        if (glyphObj.advanceWidth) glyphX += glyphObj.advanceWidth * fontScale;
                        if (letterSpacing) glyphX += letterSpacing * fontSize;
                        prevGlyphIndex = glyphIndex;
                    }
                    charIndex += text.codePointAt(charIndex) > 0xffff ? 2 : 1;
                });
                return glyphX;
            }
        };
        return fontObj;
    }
    return function parse(buffer) {
        // Look to see if we have a WOFF file and convert it if so:
        var peek = new Uint8Array(buffer, 0, 4);
        var tag = Typr._bin.readASCII(peek, 0, 4);
        if (tag === 'wOFF') buffer = woff2otf(buffer);
        else if (tag === 'wOF2') throw new Error('woff2 fonts not supported');
        return wrapFontObj(Typr.parse(buffer)[0]);
    };
}
var $6591e3ca76d1668d$var$workerModule = /*#__PURE__*/ (0, $7d2465470e3fafe3$export$e2063b0a5e3f6023)({
    name: 'Typr Font Parser',
    dependencies: [
        $6591e3ca76d1668d$var$typrFactory,
        $6591e3ca76d1668d$var$woff2otfFactory,
        $6591e3ca76d1668d$var$parserFactory
    ],
    init: function(typrFactory, woff2otfFactory, parserFactory) {
        var Typr = typrFactory();
        var woff2otf = woff2otfFactory();
        return parserFactory(Typr, woff2otf);
    }
});
var $6591e3ca76d1668d$var$CONFIG = {
    defaultFontURL: 'https://fonts.gstatic.com/s/roboto/v18/KFOmCnqEu92Fr1Mu4mxM.woff',
    sdfGlyphSize: 64,
    sdfMargin: 1 / 16,
    sdfExponent: 9,
    textureWidth: 2048
};
var $6591e3ca76d1668d$var$tempColor = /*#__PURE__*/ new (0, $1a55656020b89c3a$export$892596cec99bc70e)();
var $6591e3ca76d1668d$var$hasRequested = false;
function $6591e3ca76d1668d$var$now$1() {
    return (self.performance || Date).now();
}
/**
 * Customizes the text builder configuration. This must be called prior to the first font processing
 * request, and applies to all fonts.
 *
 * @param {String} config.defaultFontURL - The URL of the default font to use for text processing
 *                 requests, in case none is specified or the specifiede font fails to load or parse.
 *                 Defaults to "Roboto Regular" from Google Fonts.
 * @param {Number} config.sdfGlyphSize - The default size of each glyph's SDF (signed distance field)
 *                 texture used for rendering. Must be a power-of-two number, and applies to all fonts,
 *                 but note that this can also be overridden per call to `getTextRenderInfo()`.
 *                 Larger sizes can improve the quality of glyph rendering by increasing the sharpness
 *                 of corners and preventing loss of very thin lines, at the expense of memory. Defaults
 *                 to 64 which is generally a good balance of size and quality.
 * @param {Number} config.sdfExponent - The exponent used when encoding the SDF values. A higher exponent
 *                 shifts the encoded 8-bit values to achieve higher precision/accuracy at texels nearer
 *                 the glyph's path, with lower precision further away. Defaults to 9.
 * @param {Number} config.sdfMargin - How much space to reserve in the SDF as margin outside the glyph's
 *                 path, as a percentage of the SDF width. A larger margin increases the quality of
 *                 extruded glyph outlines, but decreases the precision available for the glyph itself.
 *                 Defaults to 1/16th of the glyph size.
 * @param {Number} config.textureWidth - The width of the SDF texture; must be a power of 2. Defaults to
 *                 2048 which is a safe maximum texture dimension according to the stats at
 *                 https://webglstats.com/webgl/parameter/MAX_TEXTURE_SIZE and should allow for a
 *                 reasonably large number of glyphs (default glyph size of 64^2 and safe texture size of
 *                 2048^2, times 4 channels, allows for 4096 glyphs.) This can be increased if you need to
 *                 increase the glyph size and/or have an extraordinary number of glyphs.
 */ function $6591e3ca76d1668d$export$57e337d56090a178(config) {
    if ($6591e3ca76d1668d$var$hasRequested) console.warn('configureTextBuilder called after first font request; will be ignored.');
    else $6591e3ca76d1668d$var$assign($6591e3ca76d1668d$var$CONFIG, config);
}
/**
 * Repository for all font SDF atlas textures and their glyph mappings. There is a separate atlas for
 * each sdfGlyphSize. Each atlas has a single Texture that holds all glyphs for all fonts.
 *
 *   {
 *     [sdfGlyphSize]: {
 *       glyphCount: number,
 *       sdfGlyphSize: number,
 *       sdfTexture: Texture,
 *       sdfCanvas: HTMLCanvasElement,
 *       contextLost: boolean,
 *       glyphsByFont: Map<fontURL, Map<glyphID, {path, atlasIndex, sdfViewBox}>>
 *     }
 *   }
 */ var $6591e3ca76d1668d$var$atlases = Object.create(null);
/**
 * @typedef {object} TroikaTextRenderInfo - Format of the result from `getTextRenderInfo`.
 * @property {object} parameters - The normalized input arguments to the render call.
 * @property {Texture} sdfTexture - The SDF atlas texture.
 * @property {number} sdfGlyphSize - The size of each glyph's SDF; see `configureTextBuilder`.
 * @property {number} sdfExponent - The exponent used in encoding the SDF's values; see `configureTextBuilder`.
 * @property {Float32Array} glyphBounds - List of [minX, minY, maxX, maxY] quad bounds for each glyph.
 * @property {Float32Array} glyphAtlasIndices - List holding each glyph's index in the SDF atlas.
 * @property {Uint8Array} [glyphColors] - List holding each glyph's [r, g, b] color, if `colorRanges` was supplied.
 * @property {Float32Array} [caretPositions] - A list of caret positions for all characters in the string; each is
 *           three elements: the starting X, the ending X, and the bottom Y for the caret.
 * @property {number} [caretHeight] - An appropriate height for all selection carets.
 * @property {number} ascender - The font's ascender metric.
 * @property {number} descender - The font's descender metric.
 * @property {number} capHeight - The font's cap height metric, based on the height of Latin capital letters.
 * @property {number} xHeight - The font's x height metric, based on the height of Latin lowercase letters.
 * @property {number} lineHeight - The final computed lineHeight measurement.
 * @property {number} topBaseline - The y position of the top line's baseline.
 * @property {Array<number>} blockBounds - The total [minX, minY, maxX, maxY] rect of the whole text block;
 *           this can include extra vertical space beyond the visible glyphs due to lineHeight, and is
 *           equivalent to the dimensions of a block-level text element in CSS.
 * @property {Array<number>} visibleBounds - The total [minX, minY, maxX, maxY] rect of the whole text block;
 *           unlike `blockBounds` this is tightly wrapped to the visible glyph paths.
 * @property {Array<object>} chunkedBounds - List of bounding rects for each consecutive set of N glyphs,
 *           in the format `{start:N, end:N, rect:[minX, minY, maxX, maxY]}`.
 * @property {object} timings - Timing info for various parts of the rendering logic including SDF
 *           generation, typesetting, etc.
 * @frozen
 */ /**
 * @callback getTextRenderInfo~callback
 * @param {TroikaTextRenderInfo} textRenderInfo
 */ /**
 * Main entry point for requesting the data needed to render a text string with given font parameters.
 * This is an asynchronous call, performing most of the logic in a web worker thread.
 * @param {object} args
 * @param {getTextRenderInfo~callback} callback
 */ function $6591e3ca76d1668d$var$getTextRenderInfo(args, callback) {
    $6591e3ca76d1668d$var$hasRequested = true;
    args = $6591e3ca76d1668d$var$assign({}, args);
    var totalStart = $6591e3ca76d1668d$var$now$1();
    // Apply default font here to avoid a 'null' atlas, and convert relative
    // URLs to absolute so they can be resolved in the worker
    args.font = $6591e3ca76d1668d$var$toAbsoluteURL(args.font || $6591e3ca76d1668d$var$CONFIG.defaultFontURL);
    // Normalize text to a string
    args.text = '' + args.text;
    args.sdfGlyphSize = args.sdfGlyphSize || $6591e3ca76d1668d$var$CONFIG.sdfGlyphSize;
    // Normalize colors
    if (args.colorRanges != null) {
        var colors = {};
        for(var key in args.colorRanges)if (args.colorRanges.hasOwnProperty(key)) {
            var val = args.colorRanges[key];
            if (typeof val !== 'number') val = $6591e3ca76d1668d$var$tempColor.set(val).getHex();
            colors[key] = val;
        }
        args.colorRanges = colors;
    }
    Object.freeze(args);
    // Init the atlas if needed
    var textureWidth = $6591e3ca76d1668d$var$CONFIG.textureWidth, sdfExponent = $6591e3ca76d1668d$var$CONFIG.sdfExponent;
    var sdfGlyphSize = args.sdfGlyphSize;
    var glyphsPerRow = textureWidth / sdfGlyphSize * 4;
    var atlas = $6591e3ca76d1668d$var$atlases[sdfGlyphSize];
    if (!atlas) {
        var canvas = document.createElement('canvas');
        canvas.width = textureWidth;
        canvas.height = sdfGlyphSize * 256 / glyphsPerRow; // start tall enough to fit 256 glyphs
        atlas = $6591e3ca76d1668d$var$atlases[sdfGlyphSize] = {
            glyphCount: 0,
            sdfGlyphSize: sdfGlyphSize,
            sdfCanvas: canvas,
            sdfTexture: new (0, $1a55656020b89c3a$export$5431306cf43de24a)(canvas, undefined, undefined, undefined, (0, $1a55656020b89c3a$export$8a72f490b25c56c8), (0, $1a55656020b89c3a$export$8a72f490b25c56c8)),
            contextLost: false,
            glyphsByFont: new Map()
        };
        atlas.sdfTexture.generateMipmaps = false;
        $6591e3ca76d1668d$var$initContextLossHandling(atlas);
    }
    var sdfTexture = atlas.sdfTexture, sdfCanvas = atlas.sdfCanvas;
    var fontGlyphs = atlas.glyphsByFont.get(args.font);
    if (!fontGlyphs) atlas.glyphsByFont.set(args.font, fontGlyphs = new Map());
    // Issue request to the typesetting engine in the worker
    $6591e3ca76d1668d$var$typesetInWorker(args).then(function(result) {
        var glyphIds = result.glyphIds, glyphPositions = result.glyphPositions, fontSize = result.fontSize, unitsPerEm = result.unitsPerEm, timings = result.timings;
        var neededSDFs = [];
        var glyphBounds = new Float32Array(glyphIds.length * 4);
        var fontSizeMult = fontSize / unitsPerEm;
        var boundsIdx = 0;
        var positionsIdx = 0;
        var quadsStart = $6591e3ca76d1668d$var$now$1();
        glyphIds.forEach(function(glyphId, i) {
            var glyphInfo = fontGlyphs.get(glyphId);
            // If this is a glyphId not seen before, add it to the atlas
            if (!glyphInfo) {
                var _result_glyphData_glyphId = result.glyphData[glyphId], path = _result_glyphData_glyphId.path, pathBounds = _result_glyphData_glyphId.pathBounds;
                // Margin around path edges in SDF, based on a percentage of the glyph's max dimension.
                // Note we add an extra 0.5 px over the configured value because the outer 0.5 doesn't contain
                // useful interpolated values and will be ignored anyway.
                var fontUnitsMargin = Math.max(pathBounds[2] - pathBounds[0], pathBounds[3] - pathBounds[1]) / sdfGlyphSize * ($6591e3ca76d1668d$var$CONFIG.sdfMargin * sdfGlyphSize + 0.5);
                var atlasIndex = atlas.glyphCount++;
                var sdfViewBox = [
                    pathBounds[0] - fontUnitsMargin,
                    pathBounds[1] - fontUnitsMargin,
                    pathBounds[2] + fontUnitsMargin,
                    pathBounds[3] + fontUnitsMargin
                ];
                fontGlyphs.set(glyphId, glyphInfo = {
                    path: path,
                    atlasIndex: atlasIndex,
                    sdfViewBox: sdfViewBox
                });
                // Collect those that need SDF generation
                neededSDFs.push(glyphInfo);
            }
            // Calculate bounds for renderable quads
            // TODO can we get this back off the main thread?
            var sdfViewBox1 = glyphInfo.sdfViewBox;
            var posX = glyphPositions[positionsIdx++];
            var posY = glyphPositions[positionsIdx++];
            glyphBounds[boundsIdx++] = posX + sdfViewBox1[0] * fontSizeMult;
            glyphBounds[boundsIdx++] = posY + sdfViewBox1[1] * fontSizeMult;
            glyphBounds[boundsIdx++] = posX + sdfViewBox1[2] * fontSizeMult;
            glyphBounds[boundsIdx++] = posY + sdfViewBox1[3] * fontSizeMult;
            // Convert glyphId to SDF index for the shader
            glyphIds[i] = glyphInfo.atlasIndex;
        });
        timings.quads = (timings.quads || 0) + ($6591e3ca76d1668d$var$now$1() - quadsStart);
        var sdfStart = $6591e3ca76d1668d$var$now$1();
        timings.sdf = {};
        // Grow the texture height by power of 2 if needed
        var currentHeight = sdfCanvas.height;
        var neededRows = Math.ceil(atlas.glyphCount / glyphsPerRow);
        var neededHeight = Math.pow(2, Math.ceil(Math.log2(neededRows * sdfGlyphSize)));
        if (neededHeight > currentHeight) {
            // Since resizing the canvas clears its render buffer, it needs special handling to copy the old contents over
            console.info("Increasing SDF texture size ".concat(currentHeight, "->").concat(neededHeight));
            $6591e3ca76d1668d$var$resizeWebGLCanvasWithoutClearing(sdfCanvas, textureWidth, neededHeight);
            // As of Three r136 textures cannot be resized once they're allocated on the GPU, we must dispose to reallocate it
            sdfTexture.dispose();
        }
        Promise.all(neededSDFs.map(function(glyphInfo) {
            return $6591e3ca76d1668d$var$generateGlyphSDF(glyphInfo, atlas, args.gpuAccelerateSDF).then(function(param) {
                var timing = param.timing;
                timings.sdf[glyphInfo.atlasIndex] = timing;
            });
        })).then(function() {
            if (neededSDFs.length && !atlas.contextLost) {
                $6591e3ca76d1668d$var$safariPre15Workaround(atlas);
                sdfTexture.needsUpdate = true;
            }
            timings.sdfTotal = $6591e3ca76d1668d$var$now$1() - sdfStart;
            timings.total = $6591e3ca76d1668d$var$now$1() - totalStart;
            // console.log(`SDF - ${timings.sdfTotal}, Total - ${timings.total - timings.fontLoad}`)
            // Invoke callback with the text layout arrays and updated texture
            callback(Object.freeze({
                parameters: args,
                sdfTexture: sdfTexture,
                sdfGlyphSize: sdfGlyphSize,
                sdfExponent: sdfExponent,
                glyphBounds: glyphBounds,
                glyphAtlasIndices: glyphIds,
                glyphColors: result.glyphColors,
                caretPositions: result.caretPositions,
                caretHeight: result.caretHeight,
                chunkedBounds: result.chunkedBounds,
                ascender: result.ascender,
                descender: result.descender,
                lineHeight: result.lineHeight,
                capHeight: result.capHeight,
                xHeight: result.xHeight,
                topBaseline: result.topBaseline,
                blockBounds: result.blockBounds,
                visibleBounds: result.visibleBounds,
                timings: result.timings
            }));
        });
    });
    // While the typesetting request is being handled, go ahead and make sure the atlas canvas context is
    // "warmed up"; the first request will be the longest due to shader program compilation so this gets
    // a head start on that process before SDFs actually start getting processed.
    Promise.resolve().then(function() {
        if (!atlas.contextLost) $6591e3ca76d1668d$var$warmUpSDFCanvas(sdfCanvas);
    });
}
function $6591e3ca76d1668d$var$generateGlyphSDF(param, param1, useGPU) {
    var path = param.path, atlasIndex = param.atlasIndex, sdfViewBox = param.sdfViewBox, sdfGlyphSize = param1.sdfGlyphSize, sdfCanvas = param1.sdfCanvas, contextLost = param1.contextLost;
    if (contextLost) // If the context is lost there's nothing we can do, just quit silently and let it
    // get regenerated when the context is restored
    return Promise.resolve({
        timing: -1
    });
    var textureWidth = $6591e3ca76d1668d$var$CONFIG.textureWidth, sdfExponent = $6591e3ca76d1668d$var$CONFIG.sdfExponent;
    var maxDist = Math.max(sdfViewBox[2] - sdfViewBox[0], sdfViewBox[3] - sdfViewBox[1]);
    var squareIndex = Math.floor(atlasIndex / 4);
    var x = squareIndex % (textureWidth / sdfGlyphSize) * sdfGlyphSize;
    var y = Math.floor(squareIndex / (textureWidth / sdfGlyphSize)) * sdfGlyphSize;
    var channel = atlasIndex % 4;
    return $6591e3ca76d1668d$var$generateSDF(sdfGlyphSize, sdfGlyphSize, path, sdfViewBox, maxDist, sdfExponent, sdfCanvas, x, y, channel, useGPU);
}
function $6591e3ca76d1668d$var$initContextLossHandling(atlas) {
    var canvas = atlas.sdfCanvas;
    /*
  // Begin context loss simulation
  if (!window.WebGLDebugUtils) {
    let script = document.getElementById('WebGLDebugUtilsScript')
    if (!script) {
      script = document.createElement('script')
      script.id = 'WebGLDebugUtils'
      document.head.appendChild(script)
      script.src = 'https://cdn.jsdelivr.net/gh/KhronosGroup/WebGLDeveloperTools@b42e702/src/debug/webgl-debug.js'
    }
    script.addEventListener('load', () => {
      initContextLossHandling(atlas)
    })
    return
  }
  window.WebGLDebugUtils.makeLostContextSimulatingCanvas(canvas)
  canvas.loseContextInNCalls(500)
  canvas.addEventListener('webglcontextrestored', (event) => {
    canvas.loseContextInNCalls(5000)
  })
  // End context loss simulation
  */ canvas.addEventListener('webglcontextlost', function(event) {
        console.log('Context Lost', event);
        event.preventDefault();
        atlas.contextLost = true;
    });
    canvas.addEventListener('webglcontextrestored', function(event) {
        console.log('Context Restored', event);
        atlas.contextLost = false;
        // Regenerate all glyphs into the restored canvas:
        var promises = [];
        atlas.glyphsByFont.forEach(function(glyphMap) {
            glyphMap.forEach(function(glyph) {
                promises.push($6591e3ca76d1668d$var$generateGlyphSDF(glyph, atlas, true));
            });
        });
        Promise.all(promises).then(function() {
            $6591e3ca76d1668d$var$safariPre15Workaround(atlas);
            atlas.sdfTexture.needsUpdate = true;
        });
    });
}
/**
 * Preload a given font and optionally pre-generate glyph SDFs for one or more character sequences.
 * This can be useful to avoid long pauses when first showing text in a scene, by preloading the
 * needed fonts and glyphs up front along with other assets.
 *
 * @param {object} options
 * @param {string} options.font - URL of the font file to preload. If not given, the default font will
 *        be loaded.
 * @param {string|string[]} options.characters - One or more character sequences for which to pre-
 *        generate glyph SDFs. Note that this will honor ligature substitution, so you may need
 *        to specify ligature sequences in addition to their individual characters to get all
 *        possible glyphs, e.g. `["t", "h", "th"]` to get the "t" and "h" glyphs plus the "th" ligature.
 * @param {number} options.sdfGlyphSize - The size at which to prerender the SDF textures for the
 *        specified `characters`.
 * @param {function} callback - A function that will be called when the preloading is complete.
 */ function $6591e3ca76d1668d$export$8a6ffa2d67c47c6c(param, callback) {
    var font = param.font, characters = param.characters, sdfGlyphSize = param.sdfGlyphSize;
    var text = Array.isArray(characters) ? characters.join('\n') : '' + characters;
    $6591e3ca76d1668d$var$getTextRenderInfo({
        font: font,
        sdfGlyphSize: sdfGlyphSize,
        text: text
    }, callback);
}
// Local assign impl so we don't have to import troika-core
function $6591e3ca76d1668d$var$assign(toObj, fromObj) {
    for(var key in fromObj)if (fromObj.hasOwnProperty(key)) toObj[key] = fromObj[key];
    return toObj;
}
// Utility for making URLs absolute
var $6591e3ca76d1668d$var$linkEl;
function $6591e3ca76d1668d$var$toAbsoluteURL(path) {
    if (!$6591e3ca76d1668d$var$linkEl) $6591e3ca76d1668d$var$linkEl = typeof document === 'undefined' ? {} : document.createElement('a');
    $6591e3ca76d1668d$var$linkEl.href = path;
    return $6591e3ca76d1668d$var$linkEl.href;
}
/**
 * Safari < v15 seems unable to use the SDF webgl canvas as a texture. This applies a workaround
 * where it reads the pixels out of that canvas and uploads them as a data texture instead, at
 * a slight performance cost.
 */ function $6591e3ca76d1668d$var$safariPre15Workaround(atlas) {
    // Use createImageBitmap support as a proxy for Safari<15, all other mainstream browsers
    // have supported it for a long while so any false positives should be minimal.
    if (typeof createImageBitmap !== 'function') {
        console.info('Safari<15: applying SDF canvas workaround');
        var sdfCanvas = atlas.sdfCanvas, sdfTexture = atlas.sdfTexture;
        var width = sdfCanvas.width, height = sdfCanvas.height;
        var gl = atlas.sdfCanvas.getContext('webgl');
        var pixels = sdfTexture.image.data;
        if (!pixels || pixels.length !== width * height * 4) {
            pixels = new Uint8Array(width * height * 4);
            sdfTexture.image = {
                width: width,
                height: height,
                data: pixels
            };
            sdfTexture.flipY = false;
            sdfTexture.isDataTexture = true;
        }
        gl.readPixels(0, 0, width, height, gl.RGBA, gl.UNSIGNED_BYTE, pixels);
    }
}
var $6591e3ca76d1668d$export$adeaafcde0994a07 = /*#__PURE__*/ (0, $7d2465470e3fafe3$export$e2063b0a5e3f6023)({
    name: 'Typesetter',
    dependencies: [
        $6591e3ca76d1668d$var$CONFIG,
        $6591e3ca76d1668d$var$workerModule,
        $6591e3ca76d1668d$var$createTypesetter,
        (0, $031b8ddc392a3293$export$2e2bcd8739ae039)
    ],
    init: function(config, fontParser, createTypesetter, bidiFactory) {
        var defaultFontURL = config.defaultFontURL;
        return createTypesetter(fontParser, bidiFactory(), {
            defaultFontURL: defaultFontURL
        });
    }
});
var $6591e3ca76d1668d$var$typesetInWorker = /*#__PURE__*/ (0, $7d2465470e3fafe3$export$e2063b0a5e3f6023)({
    name: 'Typesetter',
    dependencies: [
        $6591e3ca76d1668d$export$adeaafcde0994a07
    ],
    init: function(typesetter) {
        return function(args) {
            return new Promise(function(resolve) {
                typesetter.typeset(args, resolve);
            });
        };
    },
    getTransferables: function(result) {
        // Mark array buffers as transferable to avoid cloning during postMessage
        var transferables = [
            result.glyphPositions.buffer,
            result.glyphIds.buffer
        ];
        if (result.caretPositions) transferables.push(result.caretPositions.buffer);
        if (result.glyphColors) transferables.push(result.glyphColors.buffer);
        return transferables;
    }
});
function $6591e3ca76d1668d$export$f81271cf861a33c1() {
    Object.keys($6591e3ca76d1668d$var$atlases).forEach(function(size) {
        var canvas = $6591e3ca76d1668d$var$atlases[size].sdfCanvas;
        var width = canvas.width, height = canvas.height;
        console.log("%c.", "\n      background: url(".concat(canvas.toDataURL(), ");\n      background-size: ").concat(width, "px ").concat(height, "px;\n      color: transparent;\n      font-size: 0;\n      line-height: ").concat(height, "px;\n      padding-left: ").concat(width, "px;\n    "));
    });
}
var $6591e3ca76d1668d$var$templateGeometries = {};
function $6591e3ca76d1668d$var$getTemplateGeometry(detail) {
    var geom = $6591e3ca76d1668d$var$templateGeometries[detail];
    if (!geom) {
        // Geometry is two planes back-to-back, which will always be rendered FrontSide only but
        // appear as DoubleSide by default. FrontSide/BackSide are emulated using drawRange.
        // We do it this way to avoid the performance hit of two draw calls for DoubleSide materials
        // introduced by Three.js in r130 - see https://github.com/mrdoob/three.js/pull/21967
        var front = new (0, $1a55656020b89c3a$export$967d831af31f69ce)(1, 1, detail, detail);
        var back = front.clone();
        var frontAttrs = front.attributes;
        var backAttrs = back.attributes;
        var combined = new (0, $1a55656020b89c3a$export$b7be63a67df8959)();
        var vertCount = frontAttrs.uv.count;
        for(var i = 0; i < vertCount; i++){
            backAttrs.position.array[i * 3] *= -1; // flip position x
            backAttrs.normal.array[i * 3 + 2] *= -1; // flip normal z
        }
        [
            'position',
            'normal',
            'uv'
        ].forEach(function(name) {
            combined.setAttribute(name, new (0, $1a55656020b89c3a$export$cbe7a62641830ebd)((0, $4fcd3d80e9e33ca7$export$71511d61b312f219)(frontAttrs[name].array).concat((0, $4fcd3d80e9e33ca7$export$71511d61b312f219)(backAttrs[name].array)), frontAttrs[name].itemSize));
        });
        combined.setIndex((0, $4fcd3d80e9e33ca7$export$71511d61b312f219)(front.index.array).concat((0, $4fcd3d80e9e33ca7$export$71511d61b312f219)(back.index.array.map(function(n) {
            return n + vertCount;
        }))));
        combined.translate(0.5, 0.5, 0);
        geom = $6591e3ca76d1668d$var$templateGeometries[detail] = combined;
    }
    return geom;
}
var $6591e3ca76d1668d$var$glyphBoundsAttrName = 'aTroikaGlyphBounds';
var $6591e3ca76d1668d$var$glyphIndexAttrName = 'aTroikaGlyphIndex';
var $6591e3ca76d1668d$var$glyphColorAttrName = 'aTroikaGlyphColor';
/**
@class GlyphsGeometry

A specialized Geometry for rendering a set of text glyphs. Uses InstancedBufferGeometry to
render the glyphs using GPU instancing of a single quad, rather than constructing a whole
geometry with vertices, for much smaller attribute arraybuffers according to this math:

  Where N = number of glyphs...

  Instanced:
  - position: 4 * 3
  - index: 2 * 3
  - normal: 4 * 3
  - uv: 4 * 2
  - glyph x/y bounds: N * 4
  - glyph indices: N * 1
  = 5N + 38

  Non-instanced:
  - position: N * 4 * 3
  - index: N * 2 * 3
  - normal: N * 4 * 3
  - uv: N * 4 * 2
  - glyph indices: N * 1
  = 39N

A downside of this is the rare-but-possible lack of the instanced arrays extension,
which we could potentially work around with a fallback non-instanced implementation.

*/ var $6591e3ca76d1668d$export$16fe3b8f85ab6e35 = /*#__PURE__*/ function(InstancedBufferGeometry) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(GlyphsGeometry, InstancedBufferGeometry);
    function GlyphsGeometry() {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, GlyphsGeometry);
        var _this;
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, GlyphsGeometry);
        _this.detail = 1;
        _this.curveRadius = 0;
        // Define groups for rendering text outline as a separate pass; these will only
        // be used when the `material` getter returns an array, i.e. outlineWidth > 0.
        _this.groups = [
            {
                start: 0,
                count: Infinity,
                materialIndex: 0
            },
            {
                start: 0,
                count: Infinity,
                materialIndex: 1
            }
        ];
        // Preallocate empty bounding objects
        _this.boundingSphere = new (0, $1a55656020b89c3a$export$805e8b72413ccaba)();
        _this.boundingBox = new (0, $1a55656020b89c3a$export$6f7d5a9418ab2aa3)();
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(GlyphsGeometry, [
        {
            key: "computeBoundingSphere",
            value: function computeBoundingSphere() {
            // No-op; we'll sync the boundingSphere proactively when needed.
            }
        },
        {
            key: "computeBoundingBox",
            value: function computeBoundingBox() {
            // No-op; we'll sync the boundingBox proactively when needed.
            }
        },
        {
            // Since our base geometry contains triangles for both front and back sides, we can emulate
            // the "side" by restricting the draw range.
            key: "setSide",
            value: function setSide(side) {
                var verts = this.getIndex().count;
                this.setDrawRange(side === (0, $1a55656020b89c3a$export$d9f0486e75b5ace) ? verts / 2 : 0, side === (0, $1a55656020b89c3a$export$3b296b6f144d5b03) ? verts : verts / 2);
            }
        },
        {
            key: "detail",
            get: function get() {
                return this._detail;
            },
            set: function set(detail) {
                var _this = this;
                if (detail !== this._detail) {
                    this._detail = detail;
                    if (typeof detail !== 'number' || detail < 1) detail = 1;
                    var tpl = $6591e3ca76d1668d$var$getTemplateGeometry(detail);
                    [
                        'position',
                        'normal',
                        'uv'
                    ].forEach(function(attr) {
                        _this.attributes[attr] = tpl.attributes[attr].clone();
                    });
                    this.setIndex(tpl.getIndex().clone());
                }
            }
        },
        {
            key: "curveRadius",
            get: function get() {
                return this._curveRadius;
            },
            set: function set(r) {
                if (r !== this._curveRadius) {
                    this._curveRadius = r;
                    this._updateBounds();
                }
            }
        },
        {
            /**
   * Update the geometry for a new set of glyphs.
   * @param {Float32Array} glyphBounds - An array holding the planar bounds for all glyphs
   *        to be rendered, 4 entries for each glyph: x1,x2,y1,y1
   * @param {Float32Array} glyphAtlasIndices - An array holding the index of each glyph within
   *        the SDF atlas texture.
   * @param {Array} blockBounds - An array holding the [minX, minY, maxX, maxY] across all glyphs
   * @param {Array} [chunkedBounds] - An array of objects describing bounds for each chunk of N
   *        consecutive glyphs: `{start:N, end:N, rect:[minX, minY, maxX, maxY]}`. This can be
   *        used with `applyClipRect` to choose an optimized `instanceCount`.
   * @param {Uint8Array} [glyphColors] - An array holding r,g,b values for each glyph.
   */ key: "updateGlyphs",
            value: function updateGlyphs(glyphBounds, glyphAtlasIndices, blockBounds, chunkedBounds, glyphColors) {
                // Update the instance attributes
                $6591e3ca76d1668d$var$updateBufferAttr(this, $6591e3ca76d1668d$var$glyphBoundsAttrName, glyphBounds, 4);
                $6591e3ca76d1668d$var$updateBufferAttr(this, $6591e3ca76d1668d$var$glyphIndexAttrName, glyphAtlasIndices, 1);
                $6591e3ca76d1668d$var$updateBufferAttr(this, $6591e3ca76d1668d$var$glyphColorAttrName, glyphColors, 3);
                this._blockBounds = blockBounds;
                this._chunkedBounds = chunkedBounds;
                this.instanceCount = glyphAtlasIndices.length;
                this._updateBounds();
            }
        },
        {
            key: "_updateBounds",
            value: function _updateBounds() {
                var bounds = this._blockBounds;
                if (bounds) {
                    var _this = this, curveRadius = _this.curveRadius, bbox = _this.boundingBox;
                    if (curveRadius) {
                        var PI = Math.PI, floor = Math.floor, min = Math.min, max = Math.max, sin = Math.sin, cos = Math.cos;
                        var halfPi = PI / 2;
                        var twoPi = PI * 2;
                        var absR = Math.abs(curveRadius);
                        var leftAngle = bounds[0] / absR;
                        var rightAngle = bounds[2] / absR;
                        var minX = floor((leftAngle + halfPi) / twoPi) !== floor((rightAngle + halfPi) / twoPi) ? -absR : min(sin(leftAngle) * absR, sin(rightAngle) * absR);
                        var maxX = floor((leftAngle - halfPi) / twoPi) !== floor((rightAngle - halfPi) / twoPi) ? absR : max(sin(leftAngle) * absR, sin(rightAngle) * absR);
                        var maxZ = floor((leftAngle + PI) / twoPi) !== floor((rightAngle + PI) / twoPi) ? absR * 2 : max(absR - cos(leftAngle) * absR, absR - cos(rightAngle) * absR);
                        bbox.min.set(minX, bounds[1], curveRadius < 0 ? -maxZ : 0);
                        bbox.max.set(maxX, bounds[3], curveRadius < 0 ? 0 : maxZ);
                    } else {
                        bbox.min.set(bounds[0], bounds[1], 0);
                        bbox.max.set(bounds[2], bounds[3], 0);
                    }
                    bbox.getBoundingSphere(this.boundingSphere);
                }
            }
        },
        {
            /**
   * Given a clipping rect, and the chunkedBounds from the last updateGlyphs call, choose the lowest
   * `instanceCount` that will show all glyphs within the clipped view. This is an optimization
   * for long blocks of text that are clipped, to skip vertex shader evaluation for glyphs that would
   * be clipped anyway.
   *
   * Note that since `drawElementsInstanced[ANGLE]` only accepts an instance count and not a starting
   * offset, this optimization becomes less effective as the clipRect moves closer to the end of the
   * text block. We could fix that by switching from instancing to a full geometry with a drawRange,
   * but at the expense of much larger attribute buffers (see classdoc above.)
   *
   * @param {Vector4} clipRect
   */ key: "applyClipRect",
            value: function applyClipRect(clipRect) {
                var count = this.getAttribute($6591e3ca76d1668d$var$glyphIndexAttrName).count;
                var chunks = this._chunkedBounds;
                if (chunks) for(var i = chunks.length; i--;){
                    count = chunks[i].end;
                    var rect = chunks[i].rect;
                    // note: both rects are l-b-r-t
                    if (rect[1] < clipRect.w && rect[3] > clipRect.y && rect[0] < clipRect.z && rect[2] > clipRect.x) break;
                }
                this.instanceCount = count;
            }
        }
    ]);
    return GlyphsGeometry;
}((0, $1a55656020b89c3a$export$231f009cbe414146));
function $6591e3ca76d1668d$var$updateBufferAttr(geom, attrName, newArray, itemSize) {
    var attr = geom.getAttribute(attrName);
    if (newArray) {
        // If length isn't changing, just update the attribute's array data
        if (attr && attr.array.length === newArray.length) {
            attr.array.set(newArray);
            attr.needsUpdate = true;
        } else {
            geom.setAttribute(attrName, new (0, $1a55656020b89c3a$export$32ea87a8b54d744a)(newArray, itemSize));
            // If the new attribute has a different size, we also have to (as of r117) manually clear the
            // internal cached max instance count. See https://github.com/mrdoob/three.js/issues/19706
            // It's unclear if this is a threejs bug or a truly unsupported scenario; discussion in
            // that ticket is ambiguous as to whether replacing a BufferAttribute with one of a
            // different size is supported, but https://github.com/mrdoob/three.js/pull/17418 strongly
            // implies it should be supported. It's possible we need to
            delete geom._maxInstanceCount; //for r117+, could be fragile
            geom.dispose(); //for r118+, more robust feeling, but more heavy-handed than I'd like
        }
    } else if (attr) geom.deleteAttribute(attrName);
}
// language=GLSL
var $6591e3ca76d1668d$var$VERTEX_DEFS = "\nuniform vec2 uTroikaSDFTextureSize;\nuniform float uTroikaSDFGlyphSize;\nuniform vec4 uTroikaTotalBounds;\nuniform vec4 uTroikaClipRect;\nuniform mat3 uTroikaOrient;\nuniform bool uTroikaUseGlyphColors;\nuniform float uTroikaDistanceOffset;\nuniform float uTroikaBlurRadius;\nuniform vec2 uTroikaPositionOffset;\nuniform float uTroikaCurveRadius;\nattribute vec4 aTroikaGlyphBounds;\nattribute float aTroikaGlyphIndex;\nattribute vec3 aTroikaGlyphColor;\nvarying vec2 vTroikaGlyphUV;\nvarying vec4 vTroikaTextureUVBounds;\nvarying float vTroikaTextureChannel;\nvarying vec3 vTroikaGlyphColor;\nvarying vec2 vTroikaGlyphDimensions;\n";
// language=GLSL prefix="void main() {" suffix="}"
var $6591e3ca76d1668d$var$VERTEX_TRANSFORM = "\nvec4 bounds = aTroikaGlyphBounds;\nbounds.xz += uTroikaPositionOffset.x;\nbounds.yw -= uTroikaPositionOffset.y;\n\nvec4 outlineBounds = vec4(\n  bounds.xy - uTroikaDistanceOffset - uTroikaBlurRadius,\n  bounds.zw + uTroikaDistanceOffset + uTroikaBlurRadius\n);\nvec4 clippedBounds = vec4(\n  clamp(outlineBounds.xy, uTroikaClipRect.xy, uTroikaClipRect.zw),\n  clamp(outlineBounds.zw, uTroikaClipRect.xy, uTroikaClipRect.zw)\n);\n\nvec2 clippedXY = (mix(clippedBounds.xy, clippedBounds.zw, position.xy) - bounds.xy) / (bounds.zw - bounds.xy);\n\nposition.xy = mix(bounds.xy, bounds.zw, clippedXY);\n\nuv = (position.xy - uTroikaTotalBounds.xy) / (uTroikaTotalBounds.zw - uTroikaTotalBounds.xy);\n\nfloat rad = uTroikaCurveRadius;\nif (rad != 0.0) {\n  float angle = position.x / rad;\n  position.xz = vec2(sin(angle) * rad, rad - cos(angle) * rad);\n  normal.xz = vec2(sin(angle), cos(angle));\n}\n  \nposition = uTroikaOrient * position;\nnormal = uTroikaOrient * normal;\n\nvTroikaGlyphUV = clippedXY.xy;\nvTroikaGlyphDimensions = vec2(bounds[2] - bounds[0], bounds[3] - bounds[1]);\n\n\nfloat txCols = uTroikaSDFTextureSize.x / uTroikaSDFGlyphSize;\nvec2 txUvPerSquare = uTroikaSDFGlyphSize / uTroikaSDFTextureSize;\nvec2 txStartUV = txUvPerSquare * vec2(\n  mod(floor(aTroikaGlyphIndex / 4.0), txCols),\n  floor(floor(aTroikaGlyphIndex / 4.0) / txCols)\n);\nvTroikaTextureUVBounds = vec4(txStartUV, vec2(txStartUV) + txUvPerSquare);\nvTroikaTextureChannel = mod(aTroikaGlyphIndex, 4.0);\n";
// language=GLSL
var $6591e3ca76d1668d$var$FRAGMENT_DEFS = "\nuniform sampler2D uTroikaSDFTexture;\nuniform vec2 uTroikaSDFTextureSize;\nuniform float uTroikaSDFGlyphSize;\nuniform float uTroikaSDFExponent;\nuniform float uTroikaDistanceOffset;\nuniform float uTroikaFillOpacity;\nuniform float uTroikaOutlineOpacity;\nuniform float uTroikaBlurRadius;\nuniform vec3 uTroikaStrokeColor;\nuniform float uTroikaStrokeWidth;\nuniform float uTroikaStrokeOpacity;\nuniform bool uTroikaSDFDebug;\nvarying vec2 vTroikaGlyphUV;\nvarying vec4 vTroikaTextureUVBounds;\nvarying float vTroikaTextureChannel;\nvarying vec2 vTroikaGlyphDimensions;\n\nfloat troikaSdfValueToSignedDistance(float alpha) {\n  // Inverse of exponential encoding in webgl-sdf-generator\n  \n  float maxDimension = max(vTroikaGlyphDimensions.x, vTroikaGlyphDimensions.y);\n  float absDist = (1.0 - pow(2.0 * (alpha > 0.5 ? 1.0 - alpha : alpha), 1.0 / uTroikaSDFExponent)) * maxDimension;\n  float signedDist = absDist * (alpha > 0.5 ? -1.0 : 1.0);\n  return signedDist;\n}\n\nfloat troikaGlyphUvToSdfValue(vec2 glyphUV) {\n  vec2 textureUV = mix(vTroikaTextureUVBounds.xy, vTroikaTextureUVBounds.zw, glyphUV);\n  vec4 rgba = texture2D(uTroikaSDFTexture, textureUV);\n  float ch = floor(vTroikaTextureChannel + 0.5); //NOTE: can't use round() in WebGL1\n  return ch == 0.0 ? rgba.r : ch == 1.0 ? rgba.g : ch == 2.0 ? rgba.b : rgba.a;\n}\n\nfloat troikaGlyphUvToDistance(vec2 uv) {\n  return troikaSdfValueToSignedDistance(troikaGlyphUvToSdfValue(uv));\n}\n\nfloat troikaGetAADist() {\n  \n  #if defined(GL_OES_standard_derivatives) || __VERSION__ >= 300\n  return length(fwidth(vTroikaGlyphUV * vTroikaGlyphDimensions)) * 0.5;\n  #else\n  return vTroikaGlyphDimensions.x / 64.0;\n  #endif\n}\n\nfloat troikaGetFragDistValue() {\n  vec2 clampedGlyphUV = clamp(vTroikaGlyphUV, 0.5 / uTroikaSDFGlyphSize, 1.0 - 0.5 / uTroikaSDFGlyphSize);\n  float distance = troikaGlyphUvToDistance(clampedGlyphUV);\n \n  // Extrapolate distance when outside bounds:\n  distance += clampedGlyphUV == vTroikaGlyphUV ? 0.0 : \n    length((vTroikaGlyphUV - clampedGlyphUV) * vTroikaGlyphDimensions);\n\n  \n\n  return distance;\n}\n\nfloat troikaGetEdgeAlpha(float distance, float distanceOffset, float aaDist) {\n  #if defined(IS_DEPTH_MATERIAL) || defined(IS_DISTANCE_MATERIAL)\n  float alpha = step(-distanceOffset, -distance);\n  #else\n\n  float alpha = smoothstep(\n    distanceOffset + aaDist,\n    distanceOffset - aaDist,\n    distance\n  );\n  #endif\n\n  return alpha;\n}\n";
// language=GLSL prefix="void main() {" suffix="}"
var $6591e3ca76d1668d$var$FRAGMENT_TRANSFORM = "\nfloat aaDist = troikaGetAADist();\nfloat fragDistance = troikaGetFragDistValue();\nfloat edgeAlpha = uTroikaSDFDebug ?\n  troikaGlyphUvToSdfValue(vTroikaGlyphUV) :\n  troikaGetEdgeAlpha(fragDistance, uTroikaDistanceOffset, max(aaDist, uTroikaBlurRadius));\n\n#if !defined(IS_DEPTH_MATERIAL) && !defined(IS_DISTANCE_MATERIAL)\nvec4 fillRGBA = gl_FragColor;\nfillRGBA.a *= uTroikaFillOpacity;\nvec4 strokeRGBA = uTroikaStrokeWidth == 0.0 ? fillRGBA : vec4(uTroikaStrokeColor, uTroikaStrokeOpacity);\nif (fillRGBA.a == 0.0) fillRGBA.rgb = strokeRGBA.rgb;\ngl_FragColor = mix(fillRGBA, strokeRGBA, smoothstep(\n  -uTroikaStrokeWidth - aaDist,\n  -uTroikaStrokeWidth + aaDist,\n  fragDistance\n));\ngl_FragColor.a *= edgeAlpha;\n#endif\n\nif (edgeAlpha == 0.0) {\n  discard;\n}\n";
/**
 * Create a material for rendering text, derived from a baseMaterial
 */ function $6591e3ca76d1668d$export$ec8c2d2c0fe50886(baseMaterial) {
    var textMaterial = (0, $00dca729031a266b$export$9251ec91c7de57b5)(baseMaterial, {
        chained: true,
        extensions: {
            derivatives: true
        },
        uniforms: {
            uTroikaSDFTexture: {
                value: null
            },
            uTroikaSDFTextureSize: {
                value: new (0, $1a55656020b89c3a$export$c977b3e384af9ae1)()
            },
            uTroikaSDFGlyphSize: {
                value: 0
            },
            uTroikaSDFExponent: {
                value: 0
            },
            uTroikaTotalBounds: {
                value: new (0, $1a55656020b89c3a$export$fa7daccca11cdbe3)(0, 0, 0, 0)
            },
            uTroikaClipRect: {
                value: new (0, $1a55656020b89c3a$export$fa7daccca11cdbe3)(0, 0, 0, 0)
            },
            uTroikaDistanceOffset: {
                value: 0
            },
            uTroikaOutlineOpacity: {
                value: 0
            },
            uTroikaFillOpacity: {
                value: 1
            },
            uTroikaPositionOffset: {
                value: new (0, $1a55656020b89c3a$export$c977b3e384af9ae1)()
            },
            uTroikaCurveRadius: {
                value: 0
            },
            uTroikaBlurRadius: {
                value: 0
            },
            uTroikaStrokeWidth: {
                value: 0
            },
            uTroikaStrokeColor: {
                value: new (0, $1a55656020b89c3a$export$892596cec99bc70e)()
            },
            uTroikaStrokeOpacity: {
                value: 1
            },
            uTroikaOrient: {
                value: new (0, $1a55656020b89c3a$export$8ff26dafa08918)()
            },
            uTroikaUseGlyphColors: {
                value: true
            },
            uTroikaSDFDebug: {
                value: false
            }
        },
        vertexDefs: $6591e3ca76d1668d$var$VERTEX_DEFS,
        vertexTransform: $6591e3ca76d1668d$var$VERTEX_TRANSFORM,
        fragmentDefs: $6591e3ca76d1668d$var$FRAGMENT_DEFS,
        fragmentColorTransform: $6591e3ca76d1668d$var$FRAGMENT_TRANSFORM,
        customRewriter: function(param) {
            var vertexShader = param.vertexShader, fragmentShader = param.fragmentShader;
            var uDiffuseRE = /\buniform\s+vec3\s+diffuse\b/;
            if (uDiffuseRE.test(fragmentShader)) {
                // Replace all instances of `diffuse` with our varying
                fragmentShader = fragmentShader.replace(uDiffuseRE, 'varying vec3 vTroikaGlyphColor').replace(/\bdiffuse\b/g, 'vTroikaGlyphColor');
                // Make sure the vertex shader declares the uniform so we can grab it as a fallback
                if (!uDiffuseRE.test(vertexShader)) vertexShader = vertexShader.replace((0, $00dca729031a266b$export$f402b5c74ecf5e1e), 'uniform vec3 diffuse;\n$&\nvTroikaGlyphColor = uTroikaUseGlyphColors ? aTroikaGlyphColor / 255.0 : diffuse;\n');
            }
            return {
                vertexShader: vertexShader,
                fragmentShader: fragmentShader
            };
        }
    });
    // Force transparency - TODO is this reasonable?
    textMaterial.transparent = true;
    Object.defineProperties(textMaterial, {
        isTroikaTextMaterial: {
            value: true
        },
        // WebGLShadowMap reverses the side of the shadow material by default, which fails
        // for planes, so here we force the `shadowSide` to always match the main side.
        shadowSide: {
            get: function() {
                return this.side;
            },
            set: function() {
            //no-op
            }
        }
    });
    return textMaterial;
}
var $6591e3ca76d1668d$var$defaultMaterial = /*#__PURE__*/ new (0, $1a55656020b89c3a$export$55cbcc9b622fe1f5)({
    color: 0xffffff,
    side: (0, $1a55656020b89c3a$export$3b296b6f144d5b03),
    transparent: true
});
var $6591e3ca76d1668d$var$defaultStrokeColor = 0x808080;
var $6591e3ca76d1668d$var$tempMat4 = /*#__PURE__*/ new (0, $1a55656020b89c3a$export$2ae72fc923e5eb5)();
var $6591e3ca76d1668d$var$tempVec3a = /*#__PURE__*/ new (0, $1a55656020b89c3a$export$64b5c384219d3699)();
var $6591e3ca76d1668d$var$tempVec3b = /*#__PURE__*/ new (0, $1a55656020b89c3a$export$64b5c384219d3699)();
var $6591e3ca76d1668d$var$tempArray = [];
var $6591e3ca76d1668d$var$origin = /*#__PURE__*/ new (0, $1a55656020b89c3a$export$64b5c384219d3699)();
var $6591e3ca76d1668d$var$defaultOrient = '+x+y';
function $6591e3ca76d1668d$var$first(o) {
    return Array.isArray(o) ? o[0] : o;
}
var $6591e3ca76d1668d$var$getFlatRaycastMesh = function() {
    var mesh = new (0, $1a55656020b89c3a$export$e176487c05830cc5)(new (0, $1a55656020b89c3a$export$967d831af31f69ce)(1, 1), $6591e3ca76d1668d$var$defaultMaterial);
    $6591e3ca76d1668d$var$getFlatRaycastMesh = function() {
        return mesh;
    };
    return mesh;
};
var $6591e3ca76d1668d$var$getCurvedRaycastMesh = function() {
    var mesh = new (0, $1a55656020b89c3a$export$e176487c05830cc5)(new (0, $1a55656020b89c3a$export$967d831af31f69ce)(1, 1, 32, 1), $6591e3ca76d1668d$var$defaultMaterial);
    $6591e3ca76d1668d$var$getCurvedRaycastMesh = function() {
        return mesh;
    };
    return mesh;
};
var $6591e3ca76d1668d$var$syncStartEvent = {
    type: 'syncstart'
};
var $6591e3ca76d1668d$var$syncCompleteEvent = {
    type: 'synccomplete'
};
var $6591e3ca76d1668d$var$SYNCABLE_PROPS = [
    'font',
    'fontSize',
    'letterSpacing',
    'lineHeight',
    'maxWidth',
    'overflowWrap',
    'text',
    'direction',
    'textAlign',
    'textIndent',
    'whiteSpace',
    'anchorX',
    'anchorY',
    'colorRanges',
    'sdfGlyphSize'
];
var $6591e3ca76d1668d$var$COPYABLE_PROPS = $6591e3ca76d1668d$var$SYNCABLE_PROPS.concat('material', 'color', 'depthOffset', 'clipRect', 'curveRadius', 'orientation', 'glyphGeometryDetail');
/**
 * @class Text
 *
 * A ThreeJS Mesh that renders a string of text on a plane in 3D space using signed distance
 * fields (SDF).
 */ var $6591e3ca76d1668d$export$5f1af8db9871e1d6 = /*#__PURE__*/ function(Mesh) {
    "use strict";
    (0, $bd4a3c8f482b35a0$export$71511d61b312f219)(Text, Mesh);
    function Text() {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Text);
        var _this;
        var geometry = new $6591e3ca76d1668d$export$16fe3b8f85ab6e35();
        _this = (0, $c2e4ebfd0f0e7a33$export$71511d61b312f219)(this, Text, [
            geometry,
            null
        ]);
        // === Text layout properties: === //
        /**
     * @member {string} text
     * The string of text to be rendered.
     */ _this.text = '';
        /**
     * @member {number|string} anchorX
     * Defines the horizontal position in the text block that should line up with the local origin.
     * Can be specified as a numeric x position in local units, a string percentage of the total
     * text block width e.g. `'25%'`, or one of the following keyword strings: 'left', 'center',
     * or 'right'.
     */ _this.anchorX = 0;
        /**
     * @member {number|string} anchorX
     * Defines the vertical position in the text block that should line up with the local origin.
     * Can be specified as a numeric y position in local units (note: down is negative y), a string
     * percentage of the total text block height e.g. `'25%'`, or one of the following keyword strings:
     * 'top', 'top-baseline', 'top-cap', 'top-ex', 'middle', 'bottom-baseline', or 'bottom'.
     */ _this.anchorY = 0;
        /**
     * @member {number} curveRadius
     * Defines a cylindrical radius along which the text's plane will be curved. Positive numbers put
     * the cylinder's centerline (oriented vertically) that distance in front of the text, for a concave
     * curvature, while negative numbers put it behind the text for a convex curvature. The centerline
     * will be aligned with the text's local origin; you can use `anchorX` to offset it.
     *
     * Since each glyph is by default rendered with a simple quad, each glyph remains a flat plane
     * internally. You can use `glyphGeometryDetail` to add more vertices for curvature inside glyphs.
     */ _this.curveRadius = 0;
        /**
     * @member {string} direction
     * Sets the base direction for the text. The default value of "auto" will choose a direction based
     * on the text's content according to the bidi spec. A value of "ltr" or "rtl" will force the direction.
     */ _this.direction = 'auto';
        /**
     * @member {string} font
     * URL of a custom font to be used. Font files can be in .ttf, .otf, or .woff (not .woff2) formats.
     * Defaults to the Roboto font loaded from Google Fonts.
     */ _this.font = null; //will use default from TextBuilder
        /**
     * @member {number} fontSize
     * The size at which to render the font in local units; corresponds to the em-box height
     * of the chosen `font`.
     */ _this.fontSize = 0.1;
        /**
     * @member {number} letterSpacing
     * Sets a uniform adjustment to spacing between letters after kerning is applied. Positive
     * numbers increase spacing and negative numbers decrease it.
     */ _this.letterSpacing = 0;
        /**
     * @member {number|string} lineHeight
     * Sets the height of each line of text, as a multiple of the `fontSize`. Defaults to 'normal'
     * which chooses a reasonable height based on the chosen font's ascender/descender metrics.
     */ _this.lineHeight = 'normal';
        /**
     * @member {number} maxWidth
     * The maximum width of the text block, above which text may start wrapping according to the
     * `whiteSpace` and `overflowWrap` properties.
     */ _this.maxWidth = Infinity;
        /**
     * @member {string} overflowWrap
     * Defines how text wraps if the `whiteSpace` property is `normal`. Can be either `'normal'`
     * to break at whitespace characters, or `'break-word'` to allow breaking within words.
     * Defaults to `'normal'`.
     */ _this.overflowWrap = 'normal';
        /**
     * @member {string} textAlign
     * The horizontal alignment of each line of text within the overall text bounding box.
     */ _this.textAlign = 'left';
        /**
     * @member {number} textIndent
     * Indentation for the first character of a line; see CSS `text-indent`.
     */ _this.textIndent = 0;
        /**
     * @member {string} whiteSpace
     * Defines whether text should wrap when a line reaches the `maxWidth`. Can
     * be either `'normal'` (the default), to allow wrapping according to the `overflowWrap` property,
     * or `'nowrap'` to prevent wrapping. Note that `'normal'` here honors newline characters to
     * manually break lines, making it behave more like `'pre-wrap'` does in CSS.
     */ _this.whiteSpace = 'normal';
        // === Presentation properties: === //
        /**
     * @member {THREE.Material} material
     * Defines a _base_ material to be used when rendering the text. This material will be
     * automatically replaced with a material derived from it, that adds shader code to
     * decrease the alpha for each fragment (pixel) outside the text glyphs, with antialiasing.
     * By default it will derive from a simple white MeshBasicMaterial, but you can use any
     * of the other mesh materials to gain other features like lighting, texture maps, etc.
     *
     * Also see the `color` shortcut property.
     */ _this.material = null;
        /**
     * @member {string|number|THREE.Color} color
     * This is a shortcut for setting the `color` of the text's material. You can use this
     * if you don't want to specify a whole custom `material`. Also, if you do use a custom
     * `material`, this color will only be used for this particuar Text instance, even if
     * that same material instance is shared across multiple Text objects.
     */ _this.color = null;
        /**
     * @member {object|null} colorRanges
     * WARNING: This API is experimental and may change.
     * This allows more fine-grained control of colors for individual or ranges of characters,
     * taking precedence over the material's `color`. Its format is an Object whose keys each
     * define a starting character index for a range, and whose values are the color for each
     * range. The color value can be a numeric hex color value, a `THREE.Color` object, or
     * any of the strings accepted by `THREE.Color`.
     */ _this.colorRanges = null;
        /**
     * @member {number|string} outlineWidth
     * WARNING: This API is experimental and may change.
     * The width of an outline/halo to be drawn around each text glyph using the `outlineColor` and `outlineOpacity`.
     * Can be specified as either an absolute number in local units, or as a percentage string e.g.
     * `"12%"` which is treated as a percentage of the `fontSize`. Defaults to `0`, which means
     * no outline will be drawn unless an `outlineOffsetX/Y` or `outlineBlur` is set.
     */ _this.outlineWidth = 0;
        /**
     * @member {string|number|THREE.Color} outlineColor
     * WARNING: This API is experimental and may change.
     * The color of the text outline, if `outlineWidth`/`outlineBlur`/`outlineOffsetX/Y` are set.
     * Defaults to black.
     */ _this.outlineColor = 0x000000;
        /**
     * @member {number} outlineOpacity
     * WARNING: This API is experimental and may change.
     * The opacity of the outline, if `outlineWidth`/`outlineBlur`/`outlineOffsetX/Y` are set.
     * Defaults to `1`.
     */ _this.outlineOpacity = 1;
        /**
     * @member {number|string} outlineBlur
     * WARNING: This API is experimental and may change.
     * A blur radius applied to the outer edge of the text's outline. If the `outlineWidth` is
     * zero, the blur will be applied at the glyph edge, like CSS's `text-shadow` blur radius.
     * Can be specified as either an absolute number in local units, or as a percentage string e.g.
     * `"12%"` which is treated as a percentage of the `fontSize`. Defaults to `0`.
     */ _this.outlineBlur = 0;
        /**
     * @member {number|string} outlineOffsetX
     * WARNING: This API is experimental and may change.
     * A horizontal offset for the text outline.
     * Can be specified as either an absolute number in local units, or as a percentage string e.g. `"12%"`
     * which is treated as a percentage of the `fontSize`. Defaults to `0`.
     */ _this.outlineOffsetX = 0;
        /**
     * @member {number|string} outlineOffsetY
     * WARNING: This API is experimental and may change.
     * A vertical offset for the text outline.
     * Can be specified as either an absolute number in local units, or as a percentage string e.g. `"12%"`
     * which is treated as a percentage of the `fontSize`. Defaults to `0`.
     */ _this.outlineOffsetY = 0;
        /**
     * @member {number|string} strokeWidth
     * WARNING: This API is experimental and may change.
     * The width of an inner stroke drawn inside each text glyph using the `strokeColor` and `strokeOpacity`.
     * Can be specified as either an absolute number in local units, or as a percentage string e.g. `"12%"`
     * which is treated as a percentage of the `fontSize`. Defaults to `0`.
     */ _this.strokeWidth = 0;
        /**
     * @member {string|number|THREE.Color} strokeColor
     * WARNING: This API is experimental and may change.
     * The color of the text stroke, if `strokeWidth` is greater than zero. Defaults to gray.
     */ _this.strokeColor = $6591e3ca76d1668d$var$defaultStrokeColor;
        /**
     * @member {number} strokeOpacity
     * WARNING: This API is experimental and may change.
     * The opacity of the stroke, if `strokeWidth` is greater than zero. Defaults to `1`.
     */ _this.strokeOpacity = 1;
        /**
     * @member {number} fillOpacity
     * WARNING: This API is experimental and may change.
     * The opacity of the glyph's fill from 0 to 1. This behaves like the material's `opacity` but allows
     * giving the fill a different opacity than the `strokeOpacity`. A fillOpacity of `0` makes the
     * interior of the glyph invisible, leaving just the `strokeWidth`. Defaults to `1`.
     */ _this.fillOpacity = 1;
        /**
     * @member {number} depthOffset
     * This is a shortcut for setting the material's `polygonOffset` and related properties,
     * which can be useful in preventing z-fighting when this text is laid on top of another
     * plane in the scene. Positive numbers are further from the camera, negatives closer.
     */ _this.depthOffset = 0;
        /**
     * @member {Array<number>} clipRect
     * If specified, defines a `[minX, minY, maxX, maxY]` of a rectangle outside of which all
     * pixels will be discarded. This can be used for example to clip overflowing text when
     * `whiteSpace='nowrap'`.
     */ _this.clipRect = null;
        /**
     * @member {string} orientation
     * Defines the axis plane on which the text should be laid out when the mesh has no extra
     * rotation transform. It is specified as a string with two axes: the horizontal axis with
     * positive pointing right, and the vertical axis with positive pointing up. By default this
     * is '+x+y', meaning the text sits on the xy plane with the text's top toward positive y
     * and facing positive z. A value of '+x-z' would place it on the xz plane with the text's
     * top toward negative z and facing positive y.
     */ _this.orientation = $6591e3ca76d1668d$var$defaultOrient;
        /**
     * @member {number} glyphGeometryDetail
     * Controls number of vertical/horizontal segments that make up each glyph's rectangular
     * plane. Defaults to 1. This can be increased to provide more geometrical detail for custom
     * vertex shader effects, for example.
     */ _this.glyphGeometryDetail = 1;
        /**
     * @member {number|null} sdfGlyphSize
     * The size of each glyph's SDF (signed distance field) used for rendering. This must be a
     * power-of-two number. Defaults to 64 which is generally a good balance of size and quality
     * for most fonts. Larger sizes can improve the quality of glyph rendering by increasing
     * the sharpness of corners and preventing loss of very thin lines, at the expense of
     * increased memory footprint and longer SDF generation time.
     */ _this.sdfGlyphSize = null;
        /**
     * @member {boolean} gpuAccelerateSDF
     * When `true`, the SDF generation process will be GPU-accelerated with WebGL when possible,
     * making it much faster especially for complex glyphs, and falling back to a JavaScript version
     * executed in web workers when support isn't available. It should automatically detect support,
     * but it's still somewhat experimental, so you can set it to `false` to force it to use the JS
     * version if you encounter issues with it.
     */ _this.gpuAccelerateSDF = true;
        _this.debugSDF = false;
        return _this;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Text, [
        {
            /**
   * Updates the text rendering according to the current text-related configuration properties.
   * This is an async process, so you can pass in a callback function to be executed when it
   * finishes.
   * @param {function} [callback]
   */ key: "sync",
            value: function sync(callback) {
                var _this = this;
                if (this._needsSync) {
                    this._needsSync = false;
                    // If there's another sync still in progress, queue
                    if (this._isSyncing) (this._queuedSyncs || (this._queuedSyncs = [])).push(callback);
                    else {
                        this._isSyncing = true;
                        this.dispatchEvent($6591e3ca76d1668d$var$syncStartEvent);
                        $6591e3ca76d1668d$var$getTextRenderInfo({
                            text: this.text,
                            font: this.font,
                            fontSize: this.fontSize || 0.1,
                            letterSpacing: this.letterSpacing || 0,
                            lineHeight: this.lineHeight || 'normal',
                            maxWidth: this.maxWidth,
                            direction: this.direction || 'auto',
                            textAlign: this.textAlign,
                            textIndent: this.textIndent,
                            whiteSpace: this.whiteSpace,
                            overflowWrap: this.overflowWrap,
                            anchorX: this.anchorX,
                            anchorY: this.anchorY,
                            colorRanges: this.colorRanges,
                            includeCaretPositions: true,
                            sdfGlyphSize: this.sdfGlyphSize,
                            gpuAccelerateSDF: this.gpuAccelerateSDF
                        }, function(textRenderInfo) {
                            _this._isSyncing = false;
                            // Save result for later use in onBeforeRender
                            _this._textRenderInfo = textRenderInfo;
                            // Update the geometry attributes
                            _this.geometry.updateGlyphs(textRenderInfo.glyphBounds, textRenderInfo.glyphAtlasIndices, textRenderInfo.blockBounds, textRenderInfo.chunkedBounds, textRenderInfo.glyphColors);
                            // If we had extra sync requests queued up, kick it off
                            var queued = _this._queuedSyncs;
                            if (queued) {
                                _this._queuedSyncs = null;
                                _this._needsSync = true;
                                _this.sync(function() {
                                    queued.forEach(function(fn) {
                                        return fn && fn();
                                    });
                                });
                            }
                            _this.dispatchEvent($6591e3ca76d1668d$var$syncCompleteEvent);
                            if (callback) callback();
                        });
                    }
                }
            }
        },
        {
            /**
   * Initiate a sync if needed - note it won't complete until next frame at the
   * earliest so if possible it's a good idea to call sync() manually as soon as
   * all the properties have been set.
   * @override
   */ key: "onBeforeRender",
            value: function onBeforeRender(renderer, scene, camera, geometry, material, group) {
                this.sync();
                // This may not always be a text material, e.g. if there's a scene.overrideMaterial present
                if (material.isTroikaTextMaterial) this._prepareForRender(material);
                // We need to force the material to FrontSide to avoid the double-draw-call performance hit
                // introduced in Three.js r130: https://github.com/mrdoob/three.js/pull/21967 - The sidedness
                // is instead applied via drawRange in the GlyphsGeometry.
                material._hadOwnSide = material.hasOwnProperty('side');
                this.geometry.setSide(material._actualSide = material.side);
                material.side = (0, $1a55656020b89c3a$export$2ede184fc2998901);
            }
        },
        {
            key: "onAfterRender",
            value: function onAfterRender(renderer, scene, camera, geometry, material, group) {
                // Restore original material side
                if (material._hadOwnSide) material.side = material._actualSide;
                else delete material.side; // back to inheriting from base material
            }
        },
        {
            /**
   * Shortcut to dispose the geometry specific to this instance.
   * Note: we don't also dispose the derived material here because if anything else is
   * sharing the same base material it will result in a pause next frame as the program
   * is recompiled. Instead users can dispose the base material manually, like normal,
   * and we'll also dispose the derived material at that time.
   */ key: "dispose",
            value: function dispose() {
                this.geometry.dispose();
            }
        },
        {
            key: "textRenderInfo",
            get: /**
   * @property {TroikaTextRenderInfo|null} textRenderInfo
   * @readonly
   * The current processed rendering data for this TextMesh, returned by the TextBuilder after
   * a `sync()` call. This will be `null` initially, and may be stale for a short period until
   * the asynchrous `sync()` process completes.
   */ function get() {
                return this._textRenderInfo || null;
            }
        },
        {
            key: "material",
            get: // Handler for automatically wrapping the base material with our upgrades. We do the wrapping
            // lazily on _read_ rather than write to avoid unnecessary wrapping on transient values.
            function get() {
                var derivedMaterial = this._derivedMaterial;
                var baseMaterial = this._baseMaterial || this._defaultMaterial || (this._defaultMaterial = $6591e3ca76d1668d$var$defaultMaterial.clone());
                if (!derivedMaterial || derivedMaterial.baseMaterial !== baseMaterial) {
                    derivedMaterial = this._derivedMaterial = $6591e3ca76d1668d$export$ec8c2d2c0fe50886(baseMaterial);
                    // dispose the derived material when its base material is disposed:
                    baseMaterial.addEventListener('dispose', function onDispose() {
                        baseMaterial.removeEventListener('dispose', onDispose);
                        derivedMaterial.dispose();
                    });
                }
                // If text outline is configured, render it as a preliminary draw using Three's multi-material
                // feature (see GlyphsGeometry which sets up `groups` for this purpose) Doing it with multi
                // materials ensures the layers are always rendered consecutively in a consistent order.
                // Each layer will trigger onBeforeRender with the appropriate material.
                if (this.outlineWidth || this.outlineBlur || this.outlineOffsetX || this.outlineOffsetY) {
                    var outlineMaterial = derivedMaterial._outlineMtl;
                    if (!outlineMaterial) {
                        outlineMaterial = derivedMaterial._outlineMtl = Object.create(derivedMaterial, {
                            id: {
                                value: derivedMaterial.id + 0.1
                            }
                        });
                        outlineMaterial.isTextOutlineMaterial = true;
                        outlineMaterial.depthWrite = false;
                        outlineMaterial.map = null; //???
                        derivedMaterial.addEventListener('dispose', function onDispose() {
                            derivedMaterial.removeEventListener('dispose', onDispose);
                            outlineMaterial.dispose();
                        });
                    }
                    return [
                        outlineMaterial,
                        derivedMaterial
                    ];
                } else return derivedMaterial;
            },
            set: function set(baseMaterial) {
                if (baseMaterial && baseMaterial.isTroikaTextMaterial) {
                    this._derivedMaterial = baseMaterial;
                    this._baseMaterial = baseMaterial.baseMaterial;
                } else this._baseMaterial = baseMaterial;
            }
        },
        {
            key: "glyphGeometryDetail",
            get: function get() {
                return this.geometry.detail;
            },
            set: function set(detail) {
                this.geometry.detail = detail;
            }
        },
        {
            key: "curveRadius",
            get: function get() {
                return this.geometry.curveRadius;
            },
            set: function set(r) {
                this.geometry.curveRadius = r;
            }
        },
        {
            key: "customDepthMaterial",
            get: // Create and update material for shadows upon request:
            function get() {
                return $6591e3ca76d1668d$var$first(this.material).getDepthMaterial();
            }
        },
        {
            key: "customDistanceMaterial",
            get: function get() {
                return $6591e3ca76d1668d$var$first(this.material).getDistanceMaterial();
            }
        },
        {
            key: "_prepareForRender",
            value: function _prepareForRender(material) {
                var isOutline = material.isTextOutlineMaterial;
                var uniforms = material.uniforms;
                var textInfo = this.textRenderInfo;
                if (textInfo) {
                    var sdfTexture = textInfo.sdfTexture, blockBounds = textInfo.blockBounds;
                    uniforms.uTroikaSDFTexture.value = sdfTexture;
                    uniforms.uTroikaSDFTextureSize.value.set(sdfTexture.image.width, sdfTexture.image.height);
                    uniforms.uTroikaSDFGlyphSize.value = textInfo.sdfGlyphSize;
                    uniforms.uTroikaSDFExponent.value = textInfo.sdfExponent;
                    uniforms.uTroikaTotalBounds.value.fromArray(blockBounds);
                    uniforms.uTroikaUseGlyphColors.value = !isOutline && !!textInfo.glyphColors;
                    var distanceOffset = 0;
                    var blurRadius = 0;
                    var strokeWidth = 0;
                    var fillOpacity;
                    var strokeOpacity;
                    var strokeColor;
                    var offsetX = 0;
                    var offsetY = 0;
                    if (isOutline) {
                        var _this = this, outlineWidth = _this.outlineWidth, outlineOffsetX = _this.outlineOffsetX, outlineOffsetY = _this.outlineOffsetY, outlineBlur = _this.outlineBlur, outlineOpacity = _this.outlineOpacity;
                        distanceOffset = this._parsePercent(outlineWidth) || 0;
                        blurRadius = Math.max(0, this._parsePercent(outlineBlur) || 0);
                        fillOpacity = outlineOpacity;
                        offsetX = this._parsePercent(outlineOffsetX) || 0;
                        offsetY = this._parsePercent(outlineOffsetY) || 0;
                    } else {
                        strokeWidth = Math.max(0, this._parsePercent(this.strokeWidth) || 0);
                        if (strokeWidth) {
                            strokeColor = this.strokeColor;
                            uniforms.uTroikaStrokeColor.value.set(strokeColor == null ? $6591e3ca76d1668d$var$defaultStrokeColor : strokeColor);
                            strokeOpacity = this.strokeOpacity;
                            if (strokeOpacity == null) strokeOpacity = 1;
                        }
                        fillOpacity = this.fillOpacity;
                    }
                    uniforms.uTroikaDistanceOffset.value = distanceOffset;
                    uniforms.uTroikaPositionOffset.value.set(offsetX, offsetY);
                    uniforms.uTroikaBlurRadius.value = blurRadius;
                    uniforms.uTroikaStrokeWidth.value = strokeWidth;
                    uniforms.uTroikaStrokeOpacity.value = strokeOpacity;
                    uniforms.uTroikaFillOpacity.value = fillOpacity == null ? 1 : fillOpacity;
                    uniforms.uTroikaCurveRadius.value = this.curveRadius || 0;
                    var clipRect = this.clipRect;
                    if (clipRect && Array.isArray(clipRect) && clipRect.length === 4) uniforms.uTroikaClipRect.value.fromArray(clipRect);
                    else {
                        // no clipping - choose a finite rect that shouldn't ever be reached by overflowing glyphs or outlines
                        var pad = (this.fontSize || 0.1) * 100;
                        uniforms.uTroikaClipRect.value.set(blockBounds[0] - pad, blockBounds[1] - pad, blockBounds[2] + pad, blockBounds[3] + pad);
                    }
                    this.geometry.applyClipRect(uniforms.uTroikaClipRect.value);
                }
                uniforms.uTroikaSDFDebug.value = !!this.debugSDF;
                material.polygonOffset = !!this.depthOffset;
                material.polygonOffsetFactor = material.polygonOffsetUnits = this.depthOffset || 0;
                // Shortcut for setting material color via `color` prop on the mesh; this is
                // applied only to the derived material to avoid mutating a shared base material.
                var color = isOutline ? this.outlineColor || 0 : this.color;
                if (color == null) delete material.color; //inherit from base
                else {
                    var colorObj = material.hasOwnProperty('color') ? material.color : material.color = new (0, $1a55656020b89c3a$export$892596cec99bc70e)();
                    if (color !== colorObj._input || (typeof color === "undefined" ? "undefined" : (0, $86d22bcb52172ef7$export$71511d61b312f219)(color)) === 'object') colorObj.set(colorObj._input = color);
                }
                // base orientation
                var orient = this.orientation || $6591e3ca76d1668d$var$defaultOrient;
                if (orient !== material._orientation) {
                    var rotMat = uniforms.uTroikaOrient.value;
                    orient = orient.replace(/[^-+xyz]/g, '');
                    var match = orient !== $6591e3ca76d1668d$var$defaultOrient && orient.match(/^([-+])([xyz])([-+])([xyz])$/);
                    if (match) {
                        var _match = (0, $cccf0333cb9f9910$export$71511d61b312f219)(match, 5), hSign = _match[1], hAxis = _match[2], vSign = _match[3], vAxis = _match[4];
                        $6591e3ca76d1668d$var$tempVec3a.set(0, 0, 0)[hAxis] = hSign === '-' ? 1 : -1;
                        $6591e3ca76d1668d$var$tempVec3b.set(0, 0, 0)[vAxis] = vSign === '-' ? -1 : 1;
                        $6591e3ca76d1668d$var$tempMat4.lookAt($6591e3ca76d1668d$var$origin, $6591e3ca76d1668d$var$tempVec3a.cross($6591e3ca76d1668d$var$tempVec3b), $6591e3ca76d1668d$var$tempVec3b);
                        rotMat.setFromMatrix4($6591e3ca76d1668d$var$tempMat4);
                    } else rotMat.identity();
                    material._orientation = orient;
                }
            }
        },
        {
            key: "_parsePercent",
            value: function _parsePercent(value) {
                if (typeof value === 'string') {
                    var match = value.match(/^(-?[\d.]+)%$/);
                    var pct = match ? parseFloat(match[1]) : NaN;
                    value = (isNaN(pct) ? 0 : pct / 100) * this.fontSize;
                }
                return value;
            }
        },
        {
            /**
   * Translate a point in local space to an x/y in the text plane.
   */ key: "localPositionToTextCoords",
            value: function localPositionToTextCoords(position) {
                var target = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new (0, $1a55656020b89c3a$export$c977b3e384af9ae1)();
                target.copy(position); //simple non-curved case is 1:1
                var r = this.curveRadius;
                if (r) target.x = Math.atan2(position.x, Math.abs(r) - Math.abs(position.z)) * Math.abs(r);
                return target;
            }
        },
        {
            /**
   * Translate a point in world space to an x/y in the text plane.
   */ key: "worldPositionToTextCoords",
            value: function worldPositionToTextCoords(position) {
                var target = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new (0, $1a55656020b89c3a$export$c977b3e384af9ae1)();
                $6591e3ca76d1668d$var$tempVec3a.copy(position);
                return this.localPositionToTextCoords(this.worldToLocal($6591e3ca76d1668d$var$tempVec3a), target);
            }
        },
        {
            /**
   * @override Custom raycasting to test against the whole text block's max rectangular bounds
   * TODO is there any reason to make this more granular, like within individual line or glyph rects?
   */ key: "raycast",
            value: function raycast(raycaster, intersects) {
                var _this = this, textRenderInfo = _this.textRenderInfo, curveRadius = _this.curveRadius;
                if (textRenderInfo) {
                    var bounds = textRenderInfo.blockBounds;
                    var raycastMesh = curveRadius ? $6591e3ca76d1668d$var$getCurvedRaycastMesh() : $6591e3ca76d1668d$var$getFlatRaycastMesh();
                    var geom = raycastMesh.geometry;
                    var _geom_attributes = geom.attributes, position = _geom_attributes.position, uv = _geom_attributes.uv;
                    for(var i = 0; i < uv.count; i++){
                        var x = bounds[0] + uv.getX(i) * (bounds[2] - bounds[0]);
                        var y = bounds[1] + uv.getY(i) * (bounds[3] - bounds[1]);
                        var z = 0;
                        if (curveRadius) {
                            z = curveRadius - Math.cos(x / curveRadius) * curveRadius;
                            x = Math.sin(x / curveRadius) * curveRadius;
                        }
                        position.setXYZ(i, x, y, z);
                    }
                    geom.boundingSphere = this.geometry.boundingSphere;
                    geom.boundingBox = this.geometry.boundingBox;
                    raycastMesh.matrixWorld = this.matrixWorld;
                    raycastMesh.material.side = this.material.side;
                    $6591e3ca76d1668d$var$tempArray.length = 0;
                    raycastMesh.raycast(raycaster, $6591e3ca76d1668d$var$tempArray);
                    for(var i1 = 0; i1 < $6591e3ca76d1668d$var$tempArray.length; i1++){
                        $6591e3ca76d1668d$var$tempArray[i1].object = this;
                        intersects.push($6591e3ca76d1668d$var$tempArray[i1]);
                    }
                }
            }
        },
        {
            key: "copy",
            value: function copy(source) {
                var _this = this;
                // Prevent copying the geometry reference so we don't end up sharing attributes between instances
                var geom = this.geometry;
                (0, $d78318602248389b$export$71511d61b312f219)((0, $c142f060853b922a$export$71511d61b312f219)(Text.prototype), "copy", this).call(this, source);
                this.geometry = geom;
                $6591e3ca76d1668d$var$COPYABLE_PROPS.forEach(function(prop) {
                    _this[prop] = source[prop];
                });
                return this;
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new this.constructor().copy(this);
            }
        }
    ]);
    return Text;
}((0, $1a55656020b89c3a$export$e176487c05830cc5));
// Create setters for properties that affect text layout:
$6591e3ca76d1668d$var$SYNCABLE_PROPS.forEach(function(prop) {
    var privateKey = '_private_' + prop;
    Object.defineProperty($6591e3ca76d1668d$export$5f1af8db9871e1d6.prototype, prop, {
        get: function() {
            return this[privateKey];
        },
        set: function(value) {
            if (value !== this[privateKey]) {
                this[privateKey] = value;
                this._needsSync = true;
            }
        }
    });
});
//=== Utility functions for dealing with carets and selection ranges ===//
/**
 * @typedef {object} TextCaret
 * @property {number} x - x position of the caret
 * @property {number} y - y position of the caret's bottom
 * @property {number} height - height of the caret
 * @property {number} charIndex - the index in the original input string of this caret's target
 *   character; the caret will be for the position _before_ that character.
 */ /**
 * Given a local x/y coordinate in the text block plane, find the nearest caret position.
 * @param {TroikaTextRenderInfo} textRenderInfo - a result object from TextBuilder#getTextRenderInfo
 * @param {number} x
 * @param {number} y
 * @return {TextCaret | null}
 */ function $6591e3ca76d1668d$export$c92621821fde77a5(textRenderInfo, x, y) {
    var closestCaret = null;
    var caretHeight = textRenderInfo.caretHeight;
    var caretsByRow = $6591e3ca76d1668d$var$groupCaretsByRow(textRenderInfo);
    // Find nearest row by y first
    var closestRowY = Infinity;
    caretsByRow.forEach(function(carets, rowY) {
        if (Math.abs(y - (rowY + caretHeight / 2)) < Math.abs(y - (closestRowY + caretHeight / 2))) closestRowY = rowY;
    });
    // Then find closest caret by x within that row
    caretsByRow.get(closestRowY).forEach(function(caret) {
        if (!closestCaret || Math.abs(x - caret.x) < Math.abs(x - closestCaret.x)) closestCaret = caret;
    });
    return closestCaret;
}
var $6591e3ca76d1668d$var$_rectsCache = new WeakMap();
/**
 * Given start and end character indexes, return a list of rectangles covering all the
 * characters within that selection.
 * @param {TroikaTextRenderInfo} textRenderInfo
 * @param {number} start - index of the first char in the selection
 * @param {number} end - index of the first char after the selection
 * @return {Array<{left, top, right, bottom}> | null}
 */ function $6591e3ca76d1668d$export$2b95125f38323093(textRenderInfo, start, end) {
    var rects;
    if (textRenderInfo) {
        // Check cache - textRenderInfo is frozen so it's safe to cache based on it
        var prevResult = $6591e3ca76d1668d$var$_rectsCache.get(textRenderInfo);
        if (prevResult && prevResult.start === start && prevResult.end === end) return prevResult.rects;
        var caretPositions = textRenderInfo.caretPositions, caretHeight = textRenderInfo.caretHeight;
        // Normalize
        if (end < start) {
            var s = start;
            start = end;
            end = s;
        }
        start = Math.max(start, 0);
        end = Math.min(end, caretPositions.length + 1);
        // Build list of rects, expanding the current rect for all characters in a run and starting
        // a new rect whenever reaching a new line or a new bidi direction
        rects = [];
        var currentRect = null;
        for(var i = start; i < end; i++){
            var x1 = caretPositions[i * 3];
            var x2 = caretPositions[i * 3 + 1];
            var left = Math.min(x1, x2);
            var right = Math.max(x1, x2);
            var bottom = caretPositions[i * 3 + 2];
            if (!currentRect || bottom !== currentRect.bottom || left > currentRect.right || right < currentRect.left) {
                currentRect = {
                    left: Infinity,
                    right: -Infinity,
                    bottom: bottom,
                    top: bottom + caretHeight
                };
                rects.push(currentRect);
            }
            currentRect.left = Math.min(left, currentRect.left);
            currentRect.right = Math.max(right, currentRect.right);
        }
        // Merge any overlapping rects, e.g. those formed by adjacent bidi runs
        rects.sort(function(a, b) {
            return b.bottom - a.bottom || a.left - b.left;
        });
        for(var i1 = rects.length - 1; i1-- > 0;){
            var rectA = rects[i1];
            var rectB = rects[i1 + 1];
            if (rectA.bottom === rectB.bottom && rectA.left <= rectB.right && rectA.right >= rectB.left) {
                rectB.left = Math.min(rectB.left, rectA.left);
                rectB.right = Math.max(rectB.right, rectA.right);
                rects.splice(i1, 1);
            }
        }
        $6591e3ca76d1668d$var$_rectsCache.set(textRenderInfo, {
            start: start,
            end: end,
            rects: rects
        });
    }
    return rects;
}
var $6591e3ca76d1668d$var$_caretsByRowCache = new WeakMap();
function $6591e3ca76d1668d$var$groupCaretsByRow(textRenderInfo) {
    // textRenderInfo is frozen so it's safe to cache based on it
    var caretsByRow = $6591e3ca76d1668d$var$_caretsByRowCache.get(textRenderInfo);
    if (!caretsByRow) {
        var caretPositions = textRenderInfo.caretPositions, caretHeight = textRenderInfo.caretHeight;
        caretsByRow = new Map();
        for(var i = 0; i < caretPositions.length; i += 3){
            var rowY = caretPositions[i + 2];
            var rowCarets = caretsByRow.get(rowY);
            if (!rowCarets) caretsByRow.set(rowY, rowCarets = []);
            rowCarets.push({
                x: caretPositions[i],
                y: rowY,
                height: caretHeight,
                charIndex: i / 3
            });
            // Add one more caret after the final char
            if (i + 3 >= caretPositions.length) rowCarets.push({
                x: caretPositions[i + 1],
                y: rowY,
                height: caretHeight,
                charIndex: i / 3 + 1
            });
        }
    }
    $6591e3ca76d1668d$var$_caretsByRowCache.set(textRenderInfo, caretsByRow);
    return caretsByRow;
}



var $6409c1839f1ee086$export$3e9821499b1eab90 = /*#__PURE__*/ function() {
    "use strict";
    function ThreePerfUI(props) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, ThreePerfUI);
        var _a;
        this._charts = /* @__PURE__ */ new Map();
        this._width = 400;
        this._height = 110;
        this._backgroundOpacity = 0.7;
        this._perf = props.perf;
        this._backgroundOpacity = (_a = props.backgroundOpacity) != null ? _a : this._backgroundOpacity;
        this.wrapper = document.createElement("div");
        this.wrapper.id = "three-perf-ui";
        this.wrapper.style.position = "fixed";
        this.wrapper.style.bottom = "0";
        this.wrapper.style.left = "0";
        this.wrapper.style.width = this._width + "px";
        this.wrapper.style.height = this._height + "px";
        props.domElement.appendChild(this.wrapper);
        this.canvas = document.createElement("canvas");
        this.canvas.width = this._width;
        this.canvas.height = this._height;
        this.canvas.style.position = "absolute";
        this.wrapper.appendChild(this.canvas);
        this.initCanvas();
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(ThreePerfUI, [
        {
            key: "setScale",
            value: function setScale(value) {
                this.wrapper.style.width = value * this.width + "px";
                this.wrapper.style.height = value * this.height + "px";
                this._renderer.setSize(this._width * value, this._height * value, true);
            }
        },
        {
            key: "initCanvas",
            value: function initCanvas() {
                this._renderer = new (0, $079becb54c0579a9$export$f6cc00ef28d7cf97)({
                    canvas: this.canvas,
                    antialias: true,
                    alpha: true
                });
                this._renderer.setClearColor(0, this._backgroundOpacity);
                this._renderer.setPixelRatio(window.devicePixelRatio);
                this._scene = new (0, $1a55656020b89c3a$export$38af1803e3442a7f)();
                this._camera = new (0, $1a55656020b89c3a$export$9ebf355ee4ed261b)(0, this._width, 0, -this._height, 0.1, 100);
                this._camera.position.set(0, 0, 10);
                this._camera.lookAt(0, 0, 0);
                this._camera.updateProjectionMatrix();
                this._scene.add(this._camera);
                this._scene.userData.useStats = false;
                var gpuValue = new (0, $6591e3ca76d1668d$export$5f1af8db9871e1d6)();
                gpuValue.anchorX = "right";
                gpuValue.position.set(45, -8, 0);
                gpuValue.text = "0.000";
                gpuValue.fontSize = 15;
                gpuValue.color = "rgb(253, 151, 31)";
                gpuValue.sync();
                this._scene.add(gpuValue);
                var gpuMs = new (0, $6591e3ca76d1668d$export$5f1af8db9871e1d6)();
                gpuMs.anchorX = "right";
                gpuMs.position.set(65, -7, 0);
                gpuMs.text = "ms";
                gpuMs.fontSize = 9;
                gpuMs.color = "rgb(255, 255, 255)";
                gpuMs.sync();
                this._scene.add(gpuMs);
                var gpuLabel = new (0, $6591e3ca76d1668d$export$5f1af8db9871e1d6)();
                gpuLabel.anchorX = "right";
                gpuLabel.position.set(65, -22, 0);
                gpuLabel.text = "GPU";
                gpuLabel.fontSize = 9;
                gpuLabel.color = "rgb(253, 151, 31)";
                gpuLabel.sync();
                this._scene.add(gpuLabel);
                var cpuValue = new (0, $6591e3ca76d1668d$export$5f1af8db9871e1d6)();
                cpuValue.anchorX = "right";
                cpuValue.position.set(115, -8, 0);
                cpuValue.text = "0.000";
                cpuValue.fontSize = 15;
                cpuValue.color = "rgb(66, 226, 46)";
                cpuValue.sync();
                this._scene.add(cpuValue);
                var cpuMs = new (0, $6591e3ca76d1668d$export$5f1af8db9871e1d6)();
                cpuMs.anchorX = "right";
                cpuMs.position.set(135, -7, 0);
                cpuMs.text = "ms";
                cpuMs.fontSize = 9;
                cpuMs.color = "rgb(255, 255, 255)";
                cpuMs.sync();
                this._scene.add(cpuMs);
                var cpuLabel = new (0, $6591e3ca76d1668d$export$5f1af8db9871e1d6)();
                cpuLabel.anchorX = "right";
                cpuLabel.position.set(135, -22, 0);
                cpuLabel.text = "CPU";
                cpuLabel.fontSize = 9;
                cpuLabel.color = "rgb(66, 226, 46)";
                cpuLabel.sync();
                this._scene.add(cpuLabel);
                var fpsValue = new (0, $6591e3ca76d1668d$export$5f1af8db9871e1d6)();
                fpsValue.anchorX = "center";
                fpsValue.position.set(165, -8, 0);
                fpsValue.text = "0";
                fpsValue.fontSize = 15;
                fpsValue.color = "rgb(238, 38, 110)";
                fpsValue.sync();
                this._scene.add(fpsValue);
                var fpsLabel = new (0, $6591e3ca76d1668d$export$5f1af8db9871e1d6)();
                fpsLabel.anchorX = "center";
                fpsLabel.position.set(175, -22, 0);
                fpsLabel.text = "FPS";
                fpsLabel.fontSize = 9;
                fpsLabel.color = "rgb(238, 38, 110)";
                fpsLabel.sync();
                this._scene.add(fpsLabel);
                var callsValue = new (0, $6591e3ca76d1668d$export$5f1af8db9871e1d6)();
                callsValue.anchorX = "right";
                callsValue.position.set(235, -8, 0);
                callsValue.text = "0";
                callsValue.fontSize = 15;
                callsValue.color = "#ffffff";
                callsValue.sync();
                this._scene.add(callsValue);
                var callsLabel = new (0, $6591e3ca76d1668d$export$5f1af8db9871e1d6)();
                callsLabel.anchorX = "right";
                callsLabel.position.set(235, -22, 0);
                callsLabel.text = "calls";
                callsLabel.fontSize = 9;
                callsLabel.color = "rgb(101, 197, 188)";
                callsLabel.sync();
                this._scene.add(callsLabel);
                var trianglesValue = new (0, $6591e3ca76d1668d$export$5f1af8db9871e1d6)();
                trianglesValue.anchorX = "right";
                trianglesValue.position.set(315, -8, 0);
                trianglesValue.text = "0";
                trianglesValue.fontSize = 15;
                trianglesValue.color = "#ffffff";
                trianglesValue.sync();
                this._scene.add(trianglesValue);
                var trianglesLabel = new (0, $6591e3ca76d1668d$export$5f1af8db9871e1d6)();
                trianglesLabel.anchorX = "right";
                trianglesLabel.position.set(315, -22, 0);
                trianglesLabel.text = "triangles";
                trianglesLabel.fontSize = 9;
                trianglesLabel.color = "rgb(101, 197, 188)";
                trianglesLabel.sync();
                this._scene.add(trianglesLabel);
                var renderpassesValue = new (0, $6591e3ca76d1668d$export$5f1af8db9871e1d6)();
                renderpassesValue.anchorX = "right";
                renderpassesValue.position.set(365, -8, 0);
                renderpassesValue.text = "0";
                renderpassesValue.fontSize = 15;
                renderpassesValue.color = "#ffffff";
                renderpassesValue.sync();
                this._scene.add(renderpassesValue);
                var renderpassesLabel = new (0, $6591e3ca76d1668d$export$5f1af8db9871e1d6)();
                renderpassesLabel.anchorX = "right";
                renderpassesLabel.position.set(365, -22, 0);
                renderpassesLabel.text = "passes";
                renderpassesLabel.fontSize = 9;
                renderpassesLabel.color = "rgb(101, 197, 188)";
                renderpassesLabel.sync();
                this._scene.add(renderpassesLabel);
                this._basicInfoElements = {
                    gpuValue: gpuValue,
                    cpuValue: cpuValue,
                    fpsValue: fpsValue,
                    callsValue: callsValue,
                    trianglesValue: trianglesValue,
                    renderpassesValue: renderpassesValue
                };
                var geometriesValue = new (0, $6591e3ca76d1668d$export$5f1af8db9871e1d6)();
                geometriesValue.anchorX = "right";
                geometriesValue.position.set(65, -39, 0);
                geometriesValue.text = "0";
                geometriesValue.fontSize = 15;
                geometriesValue.color = "#ffffff";
                geometriesValue.sync();
                this._scene.add(geometriesValue);
                var geometriesLabel = new (0, $6591e3ca76d1668d$export$5f1af8db9871e1d6)();
                geometriesLabel.anchorX = "right";
                geometriesLabel.position.set(65, -53, 0);
                geometriesLabel.text = "geometries";
                geometriesLabel.fontSize = 9;
                geometriesLabel.color = "rgb(101, 197, 188)";
                geometriesLabel.sync();
                this._scene.add(geometriesLabel);
                var texturesValue = new (0, $6591e3ca76d1668d$export$5f1af8db9871e1d6)();
                texturesValue.anchorX = "right";
                texturesValue.position.set(135, -39, 0);
                texturesValue.text = "0";
                texturesValue.fontSize = 15;
                texturesValue.color = "#ffffff";
                texturesValue.sync();
                this._scene.add(texturesValue);
                var texturesLabel = new (0, $6591e3ca76d1668d$export$5f1af8db9871e1d6)();
                texturesLabel.anchorX = "right";
                texturesLabel.position.set(135, -53, 0);
                texturesLabel.text = "textures";
                texturesLabel.fontSize = 9;
                texturesLabel.color = "rgb(101, 197, 188)";
                texturesLabel.sync();
                this._scene.add(texturesLabel);
                var shadersValue = new (0, $6591e3ca76d1668d$export$5f1af8db9871e1d6)();
                shadersValue.anchorX = "right";
                shadersValue.position.set(205, -39, 0);
                shadersValue.text = "0";
                shadersValue.fontSize = 15;
                shadersValue.color = "#ffffff";
                shadersValue.sync();
                this._scene.add(shadersValue);
                var shadersLabel = new (0, $6591e3ca76d1668d$export$5f1af8db9871e1d6)();
                shadersLabel.anchorX = "right";
                shadersLabel.position.set(205, -53, 0);
                shadersLabel.text = "shaders";
                shadersLabel.fontSize = 9;
                shadersLabel.color = "rgb(101, 197, 188)";
                shadersLabel.sync();
                this._scene.add(shadersLabel);
                var linesValue = new (0, $6591e3ca76d1668d$export$5f1af8db9871e1d6)();
                linesValue.anchorX = "right";
                linesValue.position.set(275, -39, 0);
                linesValue.text = "0";
                linesValue.fontSize = 15;
                linesValue.color = "#ffffff";
                linesValue.sync();
                this._scene.add(linesValue);
                var linesLabel = new (0, $6591e3ca76d1668d$export$5f1af8db9871e1d6)();
                linesLabel.anchorX = "right";
                linesLabel.position.set(275, -53, 0);
                linesLabel.text = "lines";
                linesLabel.fontSize = 9;
                linesLabel.color = "rgb(101, 197, 188)";
                linesLabel.sync();
                this._scene.add(linesLabel);
                var pointsValue = new (0, $6591e3ca76d1668d$export$5f1af8db9871e1d6)();
                pointsValue.anchorX = "right";
                pointsValue.position.set(345, -39, 0);
                pointsValue.text = "0";
                pointsValue.fontSize = 15;
                pointsValue.color = "#ffffff";
                pointsValue.sync();
                this._scene.add(pointsValue);
                var pointsLabel = new (0, $6591e3ca76d1668d$export$5f1af8db9871e1d6)();
                pointsLabel.anchorX = "right";
                pointsLabel.position.set(345, -53, 0);
                pointsLabel.text = "points";
                pointsLabel.fontSize = 9;
                pointsLabel.color = "rgb(101, 197, 188)";
                pointsLabel.sync();
                this._scene.add(pointsLabel);
                this._memInfoElements = {
                    geometriesValue: geometriesValue,
                    geometriesLabel: geometriesLabel,
                    texturesValue: texturesValue,
                    texturesLabel: texturesLabel,
                    shadersValue: shadersValue,
                    shadersLabel: shadersLabel,
                    linesValue: linesValue,
                    linesLabel: linesLabel,
                    pointsValue: pointsValue,
                    pointsLabel: pointsLabel
                };
                var gpuChartGeometry = new (0, $1a55656020b89c3a$export$b7be63a67df8959)();
                var positions = new Float32Array(180);
                for(var i = 0; i < 60; i++){
                    positions[3 * i + 0] = this._width / 59 * i;
                    positions[3 * i + 1] = -110;
                    positions[3 * i + 2] = 0;
                }
                var positionAttribute = new (0, $1a55656020b89c3a$export$8dea267bd6bde117)(positions, 3);
                positionAttribute.usage = (0, $1a55656020b89c3a$export$8505d14ac8546ca);
                gpuChartGeometry.setAttribute("position", positionAttribute);
                var gpuChart = new (0, $1a55656020b89c3a$export$17d680238e50603e)(gpuChartGeometry, new (0, $1a55656020b89c3a$export$fbaaa33907730a0c)({
                    color: "rgb(253, 151, 31)"
                }));
                this._scene.add(gpuChart);
                this._charts.set("gpu", gpuChart);
                var cpuChartGeometry = new (0, $1a55656020b89c3a$export$b7be63a67df8959)();
                positions = new Float32Array(180);
                for(var i1 = 0; i1 < 60; i1++){
                    positions[3 * i1 + 0] = this._width / 59 * i1;
                    positions[3 * i1 + 1] = -110;
                    positions[3 * i1 + 2] = 0;
                }
                positionAttribute = new (0, $1a55656020b89c3a$export$8dea267bd6bde117)(positions, 3);
                positionAttribute.usage = (0, $1a55656020b89c3a$export$8505d14ac8546ca);
                cpuChartGeometry.setAttribute("position", positionAttribute);
                var cpuChart = new (0, $1a55656020b89c3a$export$17d680238e50603e)(cpuChartGeometry, new (0, $1a55656020b89c3a$export$fbaaa33907730a0c)({
                    color: "rgb(66, 226, 46)"
                }));
                this._scene.add(cpuChart);
                this._charts.set("cpu", cpuChart);
                var fpsChartGeometry = new (0, $1a55656020b89c3a$export$b7be63a67df8959)();
                positions = new Float32Array(180);
                for(var i2 = 0; i2 < 60; i2++){
                    positions[3 * i2 + 0] = this._width / 59 * i2;
                    positions[3 * i2 + 1] = -110;
                    positions[3 * i2 + 2] = 0;
                }
                positionAttribute = new (0, $1a55656020b89c3a$export$8dea267bd6bde117)(positions, 3);
                positionAttribute.usage = (0, $1a55656020b89c3a$export$8505d14ac8546ca);
                fpsChartGeometry.setAttribute("position", positionAttribute);
                var fpsChart = new (0, $1a55656020b89c3a$export$17d680238e50603e)(fpsChartGeometry, new (0, $1a55656020b89c3a$export$fbaaa33907730a0c)({
                    color: "rgb(238, 38, 110)"
                }));
                this._scene.add(fpsChart);
                this._charts.set("fps", fpsChart);
            }
        },
        {
            key: "update",
            value: function update() {
                var _a, _b;
                if (this._perf.chart && this._perf.showGraph) for(var chartName in this._perf.chart.data){
                    var chartData = this._perf.chart.data[chartName];
                    if (!this._charts.get(chartName) || !chartData) continue;
                    var geometry = this._charts.get(chartName).geometry;
                    var positionAttr = geometry.attributes.position;
                    var maxValue = 0;
                    for(var i = 0; i < chartData.length; i++)if (chartData[i] > maxValue) maxValue = chartData[i];
                    maxValue = Math.max(maxValue, 20);
                    for(var i1 = 0; i1 < chartData.length; i1++){
                        var id = (this._perf.chart.circularId + i1 + 1) % 60;
                        positionAttr.setY(i1, (chartData[id] / maxValue * 90 - 110) * this.height / 110);
                    }
                    positionAttr.needsUpdate = true;
                }
                this._basicInfoElements.gpuValue.text = this._perf.log.gpu.toFixed(3);
                this._basicInfoElements.cpuValue.text = this._perf.log.cpu.toFixed(3);
                this._basicInfoElements.fpsValue.text = this._perf.log.fps.toFixed(0);
                this._basicInfoElements.callsValue.text = this._perf.threeRenderer.info.render.calls.toString();
                this._basicInfoElements.trianglesValue.text = this._perf.threeRenderer.info.render.triangles.toString();
                this._basicInfoElements.renderpassesValue.text = this._perf.renderPassesNumber.toString();
                this._memInfoElements.geometriesValue.text = this._perf.threeRenderer.info.memory.geometries.toString();
                this._memInfoElements.texturesValue.text = this._perf.threeRenderer.info.memory.textures.toString();
                this._memInfoElements.shadersValue.text = (_b = (_a = this._perf.threeRenderer.info.programs) == null ? void 0 : _a.length.toString()) != null ? _b : "";
                this._memInfoElements.linesValue.text = this._perf.threeRenderer.info.render.lines.toString();
                this._memInfoElements.pointsValue.text = this._perf.threeRenderer.info.render.points.toString();
                this.render();
            }
        },
        {
            key: "render",
            value: function render() {
                this._renderer.render(this._scene, this._camera);
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this.wrapper.remove();
            }
        },
        {
            //
            key: "toggleVisibility",
            value: function toggleVisibility(value) {
                this.wrapper.style.display = value ? "block" : "none";
            }
        },
        {
            key: "toggleCharts",
            value: function toggleCharts(value) {
                this._charts.forEach(function(chart) {
                    chart.visible = value;
                });
                if (this._perf.showGraph) this.height = this._perf.memory ? 110 : 70;
                else this.height = this._perf.memory ? 70 : 40;
                this.wrapper.style.height = this._perf.scale * this.height + "px";
            }
        },
        {
            key: "toggleMemoryInfo",
            value: function toggleMemoryInfo(value) {
                for(var key in this._memInfoElements)this._memInfoElements[key].visible = value;
                this.width = 380;
                if (this._perf.showGraph) this.height = this._perf.memory ? 110 : 70;
                else this.height = this._perf.memory ? 70 : 40;
                this.wrapper.style.width = this._perf.scale * this.width + "px";
                this.wrapper.style.height = this._perf.scale * this.height + "px";
            }
        },
        {
            key: "setBackgroundOpacity",
            value: function setBackgroundOpacity(value) {
                this._backgroundOpacity = value;
                this._renderer.setClearColor(0, this._backgroundOpacity);
                this.render();
            }
        },
        {
            key: "width",
            get: //
            function get() {
                return this._width;
            },
            set: function set(value) {
                this._width = value;
                this._camera.right = value;
                this._camera.updateProjectionMatrix();
                this._renderer.setSize(this._perf.scale * this._width, this._perf.scale * this._height);
                this.render();
            }
        },
        {
            key: "height",
            get: function get() {
                return this._height;
            },
            set: function set(value) {
                this._height = value;
                this._camera.bottom = -value;
                this._camera.updateProjectionMatrix();
                this._renderer.setSize(this._perf.scale * this._width, this._perf.scale * this._height);
                this.render();
            }
        }
    ]);
    return ThreePerfUI;
}();





var $10a02f05c7d322c3$export$10c224b6cf324828 = {
    value: 0,
    fpsLimit: 60,
    isOverLimit: 0
};
var $10a02f05c7d322c3$var$average = function(arr) {
    return (arr == null ? void 0 : arr.reduce(function(a, b) {
        return a + b;
    }, 0)) / arr.length;
};
var $10a02f05c7d322c3$export$63702a27d0893ffe = /*#__PURE__*/ function() {
    "use strict";
    function GLPerf(settings) {
        var _this = this;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, GLPerf);
        this.names = [
            ""
        ];
        this.finished = [];
        this.paused = false;
        this.overClock = false;
        this.queryHasResult = false;
        this.queryCreated = false;
        this.isWebGL2 = true;
        this.memAccums = [];
        this.gpuAccums = [];
        this.activeAccums = [];
        this.logsAccums = {
            mem: [],
            gpu: [],
            cpu: [],
            fps: [],
            fpsFixed: []
        };
        this.fpsChart = [];
        this.gpuChart = [];
        this.cpuChart = [];
        this.memChart = [];
        this.paramLogger = function() {};
        this.glFinish = function() {};
        this.chartLogger = function() {};
        this.chartLen = 60;
        this.logsPerSecond = 10;
        this.maxMemory = 1500;
        this.chartHz = 10;
        this.startCpuProfiling = false;
        this.lastCalculateFixed = 0;
        this.chartFrame = 0;
        this.gpuTimeProcess = 0;
        this.chartTime = 0;
        this.activeQueries = 0;
        this.circularId = 0;
        this.detected = 0;
        this.frameId = 0;
        this.rafId = 0;
        this.idleCbId = 0;
        this.checkQueryId = 0;
        this.uuid = void 0;
        this.currentCpu = 0;
        this.currentMem = 0;
        this.paramFrame = 0;
        this.paramTime = 0;
        this.now = function() {};
        this.t0 = 0;
        this.nextFps = function(d) {
            var goal = 1e3 / 60;
            var elapsed = goal - d.timeRemaining();
            var fps = goal * $10a02f05c7d322c3$export$10c224b6cf324828.fpsLimit / 10 / elapsed;
            if (fps < 0) return;
            $10a02f05c7d322c3$export$10c224b6cf324828.value = fps;
            if ($10a02f05c7d322c3$export$10c224b6cf324828.isOverLimit < 25) $10a02f05c7d322c3$export$10c224b6cf324828.isOverLimit++;
            else _this.perf.overclockingFps = true;
        };
        this.nextFrame = function(now) {
            _this.frameId++;
            var t = now || _this.now();
            var duration = t - _this.paramTime;
            var gpu = 0;
            if (_this.frameId <= 1) {
                _this.paramFrame = _this.frameId;
                _this.paramTime = t;
            } else if (t >= _this.paramTime) {
                _this.maxMemory = window.performance.memory ? window.performance.memory.jsHeapSizeLimit / 1048576 : 0;
                var frameCount = _this.frameId - _this.paramFrame;
                var fpsFixed = frameCount * 1e3 / duration;
                var fps = _this.perf.overclockingFps ? $10a02f05c7d322c3$export$10c224b6cf324828.value : fpsFixed;
                gpu = _this.isWebGL2 ? _this.gpuAccums[0] : _this.gpuAccums[0] / duration;
                if (_this.isWebGL2) _this.gpuAccums[0] = 0;
                else Promise.all(_this.finished).then(function() {
                    _this.gpuAccums[0] = 0;
                    _this.finished = [];
                });
                _this.currentMem = Math.round(window.performance && window.performance.memory ? window.performance.memory.usedJSHeapSize / 1048576 : 0);
                if (window.performance && _this.startCpuProfiling) {
                    window.performance.mark("cpu-finished");
                    var cpuMeasure = performance.measure("cpu-duration", "cpu-started", "cpu-finished");
                    _this.currentCpu = cpuMeasure.duration;
                    _this.logsAccums.cpu.push(_this.currentCpu);
                    _this.startCpuProfiling = false;
                }
                _this.logsAccums.mem.push(_this.currentMem);
                _this.logsAccums.fpsFixed.push(fpsFixed);
                _this.logsAccums.fps.push(fps);
                _this.logsAccums.gpu.push(gpu);
                if (_this.overClock && typeof window.requestIdleCallback !== "undefined") {
                    if ($10a02f05c7d322c3$export$10c224b6cf324828.isOverLimit > 0 && fps > fpsFixed) $10a02f05c7d322c3$export$10c224b6cf324828.isOverLimit--;
                    else if (_this.perf.overclockingFps) _this.perf.overclockingFps = false;
                }
                if (t >= _this.paramTime + 1e3 / _this.logsPerSecond) {
                    _this.paramLogger({
                        cpu: $10a02f05c7d322c3$var$average(_this.logsAccums.cpu),
                        gpu: $10a02f05c7d322c3$var$average(_this.logsAccums.gpu),
                        mem: $10a02f05c7d322c3$var$average(_this.logsAccums.mem),
                        fps: $10a02f05c7d322c3$var$average(_this.logsAccums.fps),
                        duration: Math.round(duration),
                        maxMemory: _this.maxMemory,
                        frameCount: frameCount
                    });
                    _this.logsAccums.mem = [];
                    _this.logsAccums.fps = [];
                    _this.logsAccums.gpu = [];
                    _this.logsAccums.cpu = [];
                    _this.paramFrame = _this.frameId;
                    _this.paramTime = t;
                }
                if (_this.overClock) {
                    if (t - _this.lastCalculateFixed >= 2000) {
                        _this.lastCalculateFixed = now;
                        $10a02f05c7d322c3$export$10c224b6cf324828.fpsLimit = Math.round($10a02f05c7d322c3$var$average(_this.logsAccums.fpsFixed) / 10) * 100;
                        _this.perf.fpsLimit = $10a02f05c7d322c3$export$10c224b6cf324828.fpsLimit / 10;
                        _this.logsAccums.fpsFixed = [];
                        _this.paramFrame = _this.frameId;
                        _this.paramTime = t;
                    }
                }
            }
            if (!_this.detected || !_this.chartFrame) {
                _this.chartFrame = _this.frameId;
                _this.chartTime = t;
                _this.circularId = 0;
            } else {
                var timespan = t - _this.chartTime;
                var hz = _this.chartHz * timespan / 1e3;
                while(--hz > 0 && _this.detected){
                    var frameCount1 = _this.frameId - _this.chartFrame;
                    var fpsFixed1 = frameCount1 / timespan * 1e3;
                    var fps1 = _this.perf.overclockingFps ? $10a02f05c7d322c3$export$10c224b6cf324828.value : fpsFixed1;
                    _this.fpsChart[_this.circularId % _this.chartLen] = fps1;
                    var memS = 1e3 / _this.currentMem;
                    var cpuS = _this.currentCpu;
                    var gpuS = (_this.isWebGL2 ? _this.gpuAccums[1] * 2 : Math.round(_this.gpuAccums[1] / duration * 100)) + 4;
                    if (gpuS > 0) _this.gpuChart[_this.circularId % _this.chartLen] = gpuS;
                    if (cpuS > 0) _this.cpuChart[_this.circularId % _this.chartLen] = cpuS;
                    if (memS > 0) _this.memChart[_this.circularId % _this.chartLen] = memS;
                    for(var i = 0; i < _this.names.length; i++)_this.chartLogger({
                        i: i,
                        data: {
                            fps: _this.fpsChart,
                            gpu: _this.gpuChart,
                            cpu: _this.cpuChart,
                            mem: _this.memChart
                        },
                        circularId: _this.circularId
                    });
                    _this.circularId++;
                    _this.chartFrame = _this.frameId;
                    _this.chartTime = t;
                }
            }
        };
        this.perf = settings.perf;
        this.trackGPU = settings.trackGPU;
        this.overClock = settings.overClock;
        this.logsPerSecond = settings.logsPerSecond;
        this.gl = settings.gl;
        this.paramLogger = settings.paramLogger;
        this.chartLogger = settings.chartLogger;
        window.GLPerf = window.GLPerf || {};
        this.fpsChart = new Array(this.chartLen).fill(0);
        this.gpuChart = new Array(this.chartLen).fill(0);
        this.cpuChart = new Array(this.chartLen).fill(0);
        this.memChart = new Array(this.chartLen).fill(0);
        this.now = function() {
            return window.performance && window.performance.now ? window.performance.now() : Date.now();
        };
        this.initGpu();
        this.is120hz();
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(GLPerf, [
        {
            key: "initGpu",
            value: function initGpu() {
                this.uuid = (0, $1a55656020b89c3a$export$6a7ef315a0d1ef07).generateUUID();
                if (this.gl) {
                    this.isWebGL2 = true;
                    if (!this.extension) this.extension = this.gl.getExtension("EXT_disjoint_timer_query_webgl2");
                    if (this.extension === null) this.isWebGL2 = false;
                }
            }
        },
        {
            /**
   * 120hz device detection
   */ key: "is120hz",
            value: function is120hz() {
                var _this = this;
                var n = 0;
                var loop = function(t) {
                    if (++n < 20) _this.rafId = window.requestAnimationFrame(loop);
                    else {
                        _this.detected = Math.ceil(1e3 * n / (t - _this.t0) / 70);
                        window.cancelAnimationFrame(_this.rafId);
                    }
                    if (!_this.t0) _this.t0 = t;
                };
                this.rafId = window.requestAnimationFrame(loop);
            }
        },
        {
            /**
   * Explicit UI add
   * @param { string | undefined } name
   */ key: "addUI",
            value: function addUI(name) {
                if (this.names.indexOf(name) === -1) {
                    this.names.push(name);
                    this.gpuAccums.push(0);
                    this.activeAccums.push(false);
                }
            }
        },
        {
            key: "startGpu",
            value: function startGpu() {
                var _this = this;
                var gl = this.gl;
                var ext = this.extension;
                if (!gl || !ext) return;
                if (this.isWebGL2) {
                    var available = false;
                    var disjoint;
                    var ns;
                    if (this.query) {
                        this.queryHasResult = false;
                        var query = this.query;
                        available = gl.getQueryParameter(query, gl.QUERY_RESULT_AVAILABLE);
                        disjoint = gl.getParameter(ext.GPU_DISJOINT_EXT);
                        if (available && !disjoint) {
                            ns = gl.getQueryParameter(this.query, gl.QUERY_RESULT);
                            var ms = ns * 1e-6;
                            if (available || disjoint) {
                                gl.deleteQuery(this.query);
                                query = null;
                            }
                            if (available && ms > 0) {
                                if (!disjoint) this.activeAccums.forEach(function(_active, i) {
                                    _this.gpuAccums[i] = ms;
                                });
                            }
                        }
                    }
                    if (available || !this.query) {
                        this.queryCreated = true;
                        this.query = gl.createQuery();
                        gl.beginQuery(ext.TIME_ELAPSED_EXT, this.query);
                    }
                }
            }
        },
        {
            key: "endGpu",
            value: function endGpu() {
                var ext = this.extension;
                var gl = this.gl;
                if (this.isWebGL2 && this.queryCreated && gl.getQuery(ext.TIME_ELAPSED_EXT, gl.CURRENT_QUERY)) gl.endQuery(ext.TIME_ELAPSED_EXT);
            }
        },
        {
            /**
   * Begin named measurement
   * @param { string | undefined } name
   */ key: "begin",
            value: function begin(name) {
                this.startGpu();
                this.updateAccums(name);
            }
        },
        {
            /**
   * End named measure
   * @param { string | undefined } name
   */ key: "end",
            value: function end(name) {
                this.endGpu();
                this.updateAccums(name);
            }
        },
        {
            key: "updateAccums",
            value: function updateAccums(name) {
                var nameId = this.names.indexOf(name);
                if (nameId === -1) {
                    nameId = this.names.length;
                    this.addUI(name);
                }
                var t = this.now();
                this.activeAccums[nameId] = !this.activeAccums[nameId];
                this.t0 = t;
            }
        }
    ]);
    return GLPerf;
}();


var $a66862e92e8d5269$var$updateMatrixWorldTemp = (0, $1a55656020b89c3a$export$e4dd07dff30cc924).prototype.updateMatrixWorld;
var $a66862e92e8d5269$var$updateWorldMatrixTemp = (0, $1a55656020b89c3a$export$e4dd07dff30cc924).prototype.updateWorldMatrix;
var $a66862e92e8d5269$var$updateMatrixTemp = (0, $1a55656020b89c3a$export$e4dd07dff30cc924).prototype.updateMatrix;
var $a66862e92e8d5269$var$maxGl = [
    "calls",
    "triangles",
    "points",
    "lines"
];
var $a66862e92e8d5269$var$maxLog = [
    "gpu",
    "cpu",
    "mem",
    "fps"
];
var $a66862e92e8d5269$export$5275fd2211a376d9 = /*#__PURE__*/ function() {
    "use strict";
    function ThreePerf(props) {
        var _this = this;
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, ThreePerf);
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
        this.gui = new (0, $38038850429cf425$exports.Pane)();
        this.accumulated = {
            totalFrames: 0,
            log: {
                i: 0,
                maxMemory: 0,
                gpu: 0,
                mem: 0,
                cpu: 0,
                fps: 0,
                duration: 0,
                frameCount: 0
            },
            gl: {
                calls: 0,
                triangles: 0,
                points: 0,
                lines: 0,
                counts: 0
            },
            max: {
                log: {
                    i: 0,
                    maxMemory: 0,
                    gpu: 0,
                    mem: 0,
                    cpu: 0,
                    fps: 0,
                    duration: 0,
                    frameCount: 0
                },
                gl: {
                    calls: 0,
                    triangles: 0,
                    points: 0,
                    lines: 0,
                    counts: 0
                }
            }
        };
        this.renderPassesNumber = 0;
        this._keypressed = "";
        this._guiVisible = true;
        this.actionToCallUI = "dev";
        this.keypressHandler = function(event) {
            if (!_this.actionToCallUI) return;
            _this._keypressed += event.key;
            var keys = _this._keypressed.split("");
            while(keys.length > _this.actionToCallUI.length)keys.shift();
            if (keys.join("") === _this.actionToCallUI) {
                _this._keypressed = "";
                _this.guiVisible = !_this.guiVisible;
            }
        };
        this.afterRender = function() {
            if (!_this._enabled) return;
            if (!_this.perfEngine.paused) {
                _this.perfEngine.nextFrame(window.performance.now());
                if (_this.perfEngine.overClock && typeof window.requestIdleCallback !== "undefined") _this.perfEngine.idleCbId = requestIdleCallback(_this.perfEngine.nextFps);
            }
            if (_this.perfEngine) _this.perfEngine.end("profiler");
            if (window.performance) {
                window.performance.mark("cpu-started");
                _this.perfEngine.startCpuProfiling = true;
            }
            _this.deepAnalyze;
        };
        this.deepAnalyze = (_a = props.deepAnalyze) != null ? _a : false;
        this.threeRenderer = props.renderer;
        this.ui = new (0, $6409c1839f1ee086$export$3e9821499b1eab90)({
            perf: this,
            domElement: props.domElement,
            backgroundOpacity: props.backgroundOpacity
        });
        this._visible = (_b = props.visible) != null ? _b : true;
        this._enabled = (_c = props.enabled) != null ? _c : true;
        this.scale = (_d = props.scale) != null ? _d : 1;
        this.anchorX = (_e = props.anchorX) != null ? _e : "left";
        this.anchorY = (_f = props.anchorY) != null ? _f : "top";
        this.showGraph = (_g = props.showGraph) != null ? _g : true;
        this.memory = (_h = props.memory) != null ? _h : true;
        this.actionToCallUI = (_i = props.actionToCallUI) != null ? _i : "";
        this.guiVisible = (_j = props.guiVisible) != null ? _j : false;
        this.gui.element.parentElement.style.width = "300px";
        window.addEventListener("keypress", this.keypressHandler);
        var overClock = (_k = props.overClock) != null ? _k : true;
        this.perfEngine = new (0, $10a02f05c7d322c3$export$63702a27d0893ffe)({
            perf: this,
            trackGPU: true,
            overClock: overClock,
            chartLen: 120,
            // chart ? chart.length : 120,
            chartHz: 60,
            // chart ? chart.hz : 60,
            logsPerSecond: (_l = props.logsPerSecond) != null ? _l : 10,
            gl: props.renderer.getContext(),
            chartLogger: function(chart) {
                _this.chart = chart;
            },
            paramLogger: function(logger) {
                if (!_this._enabled) return;
                var log = {
                    maxMemory: logger.maxMemory,
                    gpu: logger.gpu,
                    cpu: logger.cpu,
                    mem: logger.mem,
                    fps: logger.fps,
                    totalTime: logger.duration,
                    frameCount: logger.frameCount
                };
                _this.log = log;
                var accumulated = _this.accumulated;
                var glRender = _this.threeRenderer.info.render;
                accumulated.totalFrames++;
                accumulated.gl.calls += glRender.calls;
                accumulated.gl.triangles += glRender.triangles;
                accumulated.gl.points += glRender.points;
                accumulated.gl.lines += glRender.lines;
                accumulated.log.gpu += logger.gpu;
                accumulated.log.cpu += logger.cpu;
                accumulated.log.mem += logger.mem;
                accumulated.log.fps += logger.fps;
                for(var i = 0; i < $a66862e92e8d5269$var$maxGl.length; i++){
                    var key = $a66862e92e8d5269$var$maxGl[i];
                    var value = glRender[key];
                    if (value > accumulated.max.gl[key]) accumulated.max.gl[key] = value;
                }
                for(var i1 = 0; i1 < $a66862e92e8d5269$var$maxLog.length; i1++){
                    var key1 = $a66862e92e8d5269$var$maxLog[i1];
                    var value1 = logger[key1];
                    if (value1 > accumulated.max.log[key1]) accumulated.max.log[key1] = value1;
                }
                _this.accumulated = accumulated;
                _this.ui.update();
            }
        });
        var ctx = props.renderer.getContext();
        var glRenderer = null;
        var glVendor = null;
        var rendererInfo = ctx.getExtension("WEBGL_debug_renderer_info");
        var glVersion = ctx.getParameter(ctx.VERSION);
        if (rendererInfo != null) {
            glRenderer = ctx.getParameter(rendererInfo.UNMASKED_RENDERER_WEBGL);
            glVendor = ctx.getParameter(rendererInfo.UNMASKED_VENDOR_WEBGL);
        }
        if (!glVendor) glVendor = "Unknown vendor";
        if (!glRenderer) glRenderer = ctx.getParameter(ctx.RENDERER);
        this.startTime = performance.now();
        this.infos = {
            version: glVersion,
            renderer: glRenderer,
            vendor: glVendor
        };
        this.rendererRender = this.threeRenderer.render;
        this.threeRenderer.info.autoReset = false;
        this.threeRenderer.render = function(scene, camera) {
            _this.renderPassesNumber++;
            _this.rendererRender.call(_this.threeRenderer, scene, camera);
        };
        this.guiFolder = this.gui.addFolder({
            title: "Settings"
        });
        var perfFolder = this.guiFolder.addFolder({
            title: "ThreePerf"
        });
        perfFolder.addInput(this, "visible", {
            label: "Visible"
        });
        perfFolder.addInput(this, "enabled", {
            label: "Enabled"
        });
        perfFolder.addInput(this, "anchorX", {
            label: "xAnchor",
            options: {
                left: "left",
                right: "right"
            }
        });
        perfFolder.addInput(this, "anchorY", {
            label: "yAnchor",
            options: {
                top: "top",
                bottom: "bottom"
            }
        });
        perfFolder.addInput(this, "backgroundOpacity", {
            label: "Background opacity",
            min: 0,
            max: 1,
            step: 0.1
        });
        perfFolder.addInput(this, "memory", {
            label: "Memory"
        });
        perfFolder.addInput(this, "showGraph", {
            label: "Charts"
        });
        perfFolder.addInput(this, "scale", {
            label: "Scale",
            min: 0.1,
            max: 2,
            step: 0.1
        });
        perfFolder.addInput(this, "logsPerSecond", {
            label: "LogsPerSecond",
            min: 1,
            max: 60,
            step: 1
        });
        console.log("ThreePerf inited.");
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(ThreePerf, [
        {
            key: "begin",
            value: function begin() {
                this.perfEngine.begin("profiler");
            }
        },
        {
            key: "end",
            value: function end() {
                this.afterRender();
                this.renderPassesNumber = 0;
                this.threeRenderer.info.reset();
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                var _a;
                this.ui.dispose();
                (_a = this.gui.element.parentElement) == null || _a.remove();
                window.removeEventListener("keypress", this.keypressHandler);
            }
        },
        {
            key: "enabled",
            get: //
            function get() {
                return this._enabled;
            },
            set: function set(value) {
                this._enabled = value;
            }
        },
        {
            key: "visible",
            get: function get() {
                return this._visible;
            },
            set: function set(value) {
                this._visible = value;
                this.ui.toggleVisibility(value);
            }
        },
        {
            key: "guiVisible",
            get: function get() {
                return this._guiVisible;
            },
            set: function set(value) {
                this._guiVisible = value;
                this.gui.element.parentElement.style["display"] = value ? "block" : "none";
            }
        },
        {
            key: "anchorX",
            get: function get() {
                return this._anchorX;
            },
            set: function set(value) {
                this._anchorX = value;
                if (this._anchorX === "left") {
                    this.ui.wrapper.style.left = "0";
                    this.ui.wrapper.style.right = "";
                } else {
                    this.ui.wrapper.style.left = "";
                    this.ui.wrapper.style.right = "0";
                }
            }
        },
        {
            key: "anchorY",
            get: function get() {
                return this._anchorY;
            },
            set: function set(value) {
                this._anchorY = value;
                if (this._anchorY === "top") {
                    this.ui.wrapper.style.top = "0";
                    this.ui.wrapper.style.bottom = "";
                } else {
                    this.ui.wrapper.style.top = "";
                    this.ui.wrapper.style.bottom = "0";
                }
            }
        },
        {
            key: "showGraph",
            get: function get() {
                return this._showGraph;
            },
            set: function set(value) {
                this._showGraph = value;
                this.ui.toggleCharts(value);
            }
        },
        {
            key: "memory",
            get: function get() {
                return this._memory;
            },
            set: function set(value) {
                this._memory = value;
                this.ui.toggleMemoryInfo(value);
            }
        },
        {
            key: "scale",
            get: function get() {
                return this._scale;
            },
            set: function set(value) {
                this._scale = value;
                this.ui.setScale(value);
            }
        },
        {
            key: "logsPerSecond",
            get: function get() {
                return this.perfEngine.logsPerSecond;
            },
            set: function set(value) {
                this.perfEngine.logsPerSecond = value;
            }
        },
        {
            key: "backgroundOpacity",
            get: function get() {
                return this.ui._backgroundOpacity;
            },
            set: function set(value) {
                this.ui.setBackgroundOpacity(value);
            }
        }
    ]);
    return ThreePerf;
}();








/**
 * CustomMaterial
 *
 * Custom Three.ShaderMaterial.
 */ var $e700a1d2afbfcbf0$export$55538ea799e2f967 = new (0, $1a55656020b89c3a$export$83c7d75d550a8b0d)({
    depthWrite: false,
    transparent: true,
    side: (0, $1a55656020b89c3a$export$3b296b6f144d5b03),
    uniforms: {
        time: {
            value: 1.0
        },
        opacity: {
            value: 0.0
        },
        displacementScale: {
            value: 1.0
        },
        combinedTexture: {
            value: new (0, $1a55656020b89c3a$export$5431306cf43de24a)()
        },
        isVertical: {
            value: 0
        }
    },
    vertexShader: "\nuniform float displacementScale;\nuniform sampler2D combinedTexture;    \nuniform int isVertical;    \nvarying vec2 vUv;\n\nvoid main() {\n    vUv = uv;\n    \n    float displacement;\n\n    if( isVertical == 1 ) {\n        displacement = texture2D(combinedTexture, vec2( vUv.x / 2.0, vUv.y) ).x;\n    } else {\n        displacement = texture2D(combinedTexture, vec2( vUv.x, vUv.y / 2.0) ).x;\n\n    }\n\n    vec3 displacedPosition = vec3(position.x, position.y, position.z + displacement * displacementScale);\n\n    gl_Position = projectionMatrix * modelViewMatrix * vec4(displacedPosition, 1.0);\n}\n    ",
    fragmentShader: "\nuniform float opacity;\nuniform float time;\nuniform sampler2D combinedTexture;\nuniform int isVertical;    \nvarying vec2 vUv;\n    \nvoid main() {\n    vec4 textureColor = vec4(0.0,0.0,0.0,0.0);\n\n    if( isVertical == 1 ) {\n        textureColor = texture2D(combinedTexture, vec2( vUv.x / 2.0, vUv.y));  \n    } else {\n        textureColor = texture2D(combinedTexture, vec2( vUv.x,  0.5 + vUv.y / 2.0));  \n    }\n    \n    gl_FragColor = vec4(textureColor.rgb, opacity );\n}\n    "
});









function $94b9dd2824161a80$export$ff8602cd201ea63c(url) {
    return $94b9dd2824161a80$var$_resolveRedirectedUrl.apply(this, arguments);
}
function $94b9dd2824161a80$var$_resolveRedirectedUrl() {
    $94b9dd2824161a80$var$_resolveRedirectedUrl = (0, $5941428b630ec017$export$71511d61b312f219)(function(url) {
        var response;
        return (0, $353b713f9392bb93$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!url) return [
                        2,
                        null
                    ];
                    return [
                        4,
                        fetch(url, {
                            method: 'HEAD'
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.url
                    ];
            }
        });
    });
    return $94b9dd2824161a80$var$_resolveRedirectedUrl.apply(this, arguments);
}


/**
 * VideoElement
 *
 * Creates a <video> and handles loading and playback
 */ var $8c7d3e4ae31d1162$export$bb0df175ffb3c87a = /*#__PURE__*/ function() {
    "use strict";
    function VideoElement(url) {
        var videoAttributes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, VideoElement);
        console.log('new VideoElement()', url);
        if (!url) return;
        this.url = url;
        this.videoAttributes = videoAttributes;
        this.videoElement = null;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(VideoElement, [
        {
            key: "build",
            value: function build() {
                var _this = this;
                return (0, $5941428b630ec017$export$71511d61b312f219)(function() {
                    return (0, $353b713f9392bb93$export$67ebef60e6f28a6)(this, function(_state) {
                        return [
                            2,
                            new Promise(/*#__PURE__*/ function() {
                                var _ref = (0, $5941428b630ec017$export$71511d61b312f219)(function(resolve) {
                                    return (0, $353b713f9392bb93$export$67ebef60e6f28a6)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    (0, $94b9dd2824161a80$export$ff8602cd201ea63c)(_this.url)
                                                ];
                                            case 1:
                                                _this.url = _state.sent();
                                                _this.videoElement = Object.assign(document.createElement('video'), (0, $84de056ed7b7040b$export$71511d61b312f219)({
                                                    crossOrigin: 'anonymous',
                                                    loop: true,
                                                    muted: true,
                                                    playsInline: true
                                                }, _this.videoAttributes));
                                                _this.videoElement.addEventListener('canplay', function() {
                                                    _this.videoElement.play().then(function() {
                                                        resolve();
                                                    }).catch(function(error) {
                                                        console.error(error);
                                                        resolve();
                                                    });
                                                });
                                                _this.videoElement.src = _this.url;
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(resolve) {
                                    return _ref.apply(this, arguments);
                                };
                            }())
                        ];
                    });
                })();
            }
        },
        {
            key: "unbuild",
            value: function unbuild() {
                if (!this.videoElement) return;
                this.videoElement.src = null;
                this.videoElement.load();
                this.videoElement.remove();
                this.videoElement = null;
            }
        },
        {
            key: "getVideoElement",
            value: function getVideoElement() {
                var _this;
                return (_this = this) === null || _this === void 0 ? void 0 : _this.videoElement;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.unbuild();
            }
        }
    ]);
    return VideoElement;
}();



function $36fb9d48193fad25$export$dae797ad3d9971fb(object) {
    if (!object || !(object === null || object === void 0 ? void 0 : object.traverse) || typeof object.traverse !== 'function') return;
    object.traverse(function(node) {
        if (node instanceof (0, $1a55656020b89c3a$export$e176487c05830cc5)) {
            if (node === null || node === void 0 ? void 0 : node.geometry) {
                console.log('found geometry to dispose', node === null || node === void 0 ? void 0 : node.geometry);
                node.geometry.dispose();
            }
            if (node === null || node === void 0 ? void 0 : node.material) {
                console.log('found material to dispose', node.material);
                $36fb9d48193fad25$var$maps.forEach(function(map) {
                    var _node_material;
                    if ((_node_material = node.material) === null || _node_material === void 0 ? void 0 : _node_material[map]) {
                        console.log('found map to dispose', map, node.material.map);
                        node.material[map].dispose();
                    }
                });
                node.material.dispose();
            }
        }
    });
}
var $36fb9d48193fad25$var$maps = [
    'alphaMap',
    'map',
    'aoMap',
    'bumpMap',
    'clearcoatMap',
    'clearCoarNormalMap',
    'clearcoatRoughnessMap',
    'displacementMap',
    'emissiveMap',
    'envMap',
    'iridescenceMap',
    'iridescenceThicknessMap',
    'lightMap',
    'metalnessMap',
    'normalMap',
    'roughnessMap',
    'sheenColorMap',
    'sheenRoughnessMap',
    'specularCOlorMap',
    'specularIntensityMap',
    'thicknessMap',
    'transmissionMap'
];



var $20bd4c57573bfebb$var$PLANE_DIVISIONS = 128;
var $20bd4c57573bfebb$var$SCALE = {
    portrait: 9,
    square: 9,
    landscape: 12
};
var $20bd4c57573bfebb$var$TRANSITION = {
    x: 0,
    y: 0,
    z: 0,
    scale: {
        x: 3,
        y: 3,
        z: 3
    },
    opacity: 0
};
var $20bd4c57573bfebb$var$LERP_FACTOR = {
    inputRotation: 0.005,
    transition: {
        position: 0.06,
        scale: 0.06,
        opacity: 0.06
    }
};
/**
 * Item
 *
 * Items rendered in Visual.
 */ var $20bd4c57573bfebb$export$6d08773d2e66f8f2 = /*#__PURE__*/ function() {
    "use strict";
    function Item(data) {
        var onLoaded = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {};
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Item);
        console.log('new Item', data);
        if (!data) return;
        this.data = data;
        this.onLoaded = onLoaded;
        this.pointerPosition = {
            x: 0,
            y: 0
        };
        this.video = null;
        this.texture = null;
        this.previewTexture = null;
        this.object = null;
        this.screen = null;
        this.seed = Math.random();
        this.is = {
            active: false,
            // loading: false,
            loadingTexture: false,
            loadingPreviewTexture: false
        };
        // this.transition = {
        //     y: TRANSITION.y,
        //     opacity: 0,
        // };
        this.groups = {};
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Item, [
        {
            key: "build",
            value: function build() {
                var _this_data;
                console.log('Item.build()', this.data.id);
                var _ref = (_this_data = this.data) === null || _this_data === void 0 ? void 0 : _this_data.video, videoWidth = _ref.width, videoHeight = _ref.height;
                // Object
                this.groups.object = new (0, $1a55656020b89c3a$export$eb2fcfdbd7ba97d4)();
                this.groups.object.visible = false;
                // - Transition
                this.groups.transition = new (0, $1a55656020b89c3a$export$eb2fcfdbd7ba97d4)();
                this.groups.transition.position.set($20bd4c57573bfebb$var$TRANSITION.x, $20bd4c57573bfebb$var$TRANSITION.y, $20bd4c57573bfebb$var$TRANSITION.z);
                // -- InputRotation
                this.groups.inputRotation = new (0, $1a55656020b89c3a$export$eb2fcfdbd7ba97d4)();
                // --- AutoRotation
                this.groups.autoRotation = new (0, $1a55656020b89c3a$export$eb2fcfdbd7ba97d4)();
                // ---- Scale
                console.log('SCALE', videoHeight / videoWidth);
                var scale = Math.abs(1 - videoHeight / videoWidth) < 0.1 ? $20bd4c57573bfebb$var$SCALE.square : videoHeight > videoWidth ? $20bd4c57573bfebb$var$SCALE.portrait : $20bd4c57573bfebb$var$SCALE.landscape;
                this.groups.scale = new (0, $1a55656020b89c3a$export$eb2fcfdbd7ba97d4)();
                this.groups.scale.scale.set(scale, scale, scale);
                console.info('scale', this.groups.scale.x);
                // ----- Screen
                // const screenMaterial = new MeshBasicMaterial({ color: 0xff0000, side: DoubleSide });
                var screenMaterial = (0, $e700a1d2afbfcbf0$export$55538ea799e2f967).clone();
                console.log('isVertical', videoHeight > videoWidth);
                screenMaterial.uniforms.isVertical.value = videoHeight > videoWidth;
                screenMaterial.uniforms.displacementScale.value = -0.5;
                this.screen = new (0, $1a55656020b89c3a$export$e176487c05830cc5)(new (0, $1a55656020b89c3a$export$967d831af31f69ce)(1, 1 / (videoWidth / videoHeight), $20bd4c57573bfebb$var$PLANE_DIVISIONS, $20bd4c57573bfebb$var$PLANE_DIVISIONS), screenMaterial);
                this.groups.object.add(this.groups.transition);
                this.groups.transition.add(this.groups.inputRotation);
                this.groups.inputRotation.add(this.groups.autoRotation);
                this.groups.autoRotation.add(this.groups.scale);
                this.groups.scale.add(this.screen);
            }
        },
        {
            key: "unbuild",
            value: function unbuild() {
                console.log('Item.unbuild()', this.data.id);
                if (!this.groups.object) return;
                // Scene graph
                this.groups.object.removeFromParent();
                // Children
                (0, $36fb9d48193fad25$export$dae797ad3d9971fb)(this.groups.object);
                // Video
                this.unload();
                // Cleanup
                this.groups.object = null;
                this.groups.transition = null;
                this.groups.inputRotation = null;
                this.groups.autoRotation = null;
                this.groups.scale = null;
                this.screen = null;
            }
        },
        {
            key: "load",
            value: /**
     * TODO: Handle edge case / race condition:
     * load() und then unload() quickly.
     * 

     *
     */ function load() {
                var _this = this;
                return (0, $5941428b630ec017$export$71511d61b312f219)(function() {
                    var _this_data, _ref, videoUrl, previewImageUrl;
                    return (0, $353b713f9392bb93$export$67ebef60e6f28a6)(this, function(_state) {
                        console.log('Item.load()', _this.data.id, _this.is.loading, _this.texture);
                        if (_this.texture) return [
                            2
                        ]; // already loaded, simple as that...
                        // if (this.is.loading) return; // never a bad idea to have a flag
                        _ref = (_this_data = _this.data) === null || _this_data === void 0 ? void 0 : _this_data.video, videoUrl = _ref.combined, previewImageUrl = _ref.thumbnail;
                        // Preview image
                        if (previewImageUrl) _this.initPreviewTexture(previewImageUrl).then(function() {
                            var texture = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).texture;
                            // do not override already loaded video
                            // + correctly dispose temporary texture
                            if (_this.texture) {
                                if (texture) texture.dispose();
                                return;
                            }
                            if (_this.previewTexture) {
                                if (texture) texture.dispose();
                                return;
                            }
                            _this.previewTexture = texture;
                            // Apply texture
                            _this.applyTexture(_this.previewTexture);
                        });
                        // Video texture
                        if (videoUrl) _this.initTexture(videoUrl).then(function() {
                            var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, video = _ref.video, texture = _ref.texture;
                            // do not override already loaded video or texture
                            // + correctly dispose temporary video or texture
                            if (_this.video) {
                                if (video) video.destroy();
                            } else _this.video = video;
                            if (_this.texture) {
                                if (texture) texture.dispose();
                            } else _this.texture = texture;
                            // Apply texture
                            _this.applyTexture(_this.texture);
                        });
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "unload",
            value: function unload() {
                console.log('Item.unload()', this.data.id);
                if (this.texture) this.texture.dispose();
                if (this.previewTexture) this.previewTexture.dispose();
                if (this.video) this.video.destroy();
                this.texture = null;
                this.previewTexture = null;
                this.video = null;
            }
        },
        {
            // transitionIn() {
            //     console.log('Item.transitionIn()', this.data.id);
            //     // this.groups.object.visible = true;
            //     this.transition.y = 0;
            //     this.transition.opacity = 1;
            // }
            // transitionOut() {
            //     console.log('Item.transitionOut()', this.data.id);
            //     // this.groups.object.visible = false;
            //     this.transition.y = TRANSITION.y;
            //     this.transition.opacity = 0;
            // }
            key: "show",
            value: function show() {
                console.log('Item.show()', this.data.id);
                this.is.active = true;
            }
        },
        {
            key: "hide",
            value: function hide() {
                this.is.active = false;
            }
        },
        {
            key: "activate",
            value: function activate() {
                console.log('Item.activate()', this.data.id);
                if (!this.groups.object) return;
                this.groups.object.visible = true;
            }
        },
        {
            key: "deactivate",
            value: function deactivate() {
                console.log('Item.deactivate()', this.data.id);
                if (!this.groups.object) return;
                this.groups.object.visible = false;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.unbuild();
            }
        },
        {
            key: "initTexture",
            value: /**
     * Build, loads video texture
     *
     * @param {*} videoUrl
     * @returns
     */ function initTexture(videoUrl) {
                var _this = this;
                return (0, $5941428b630ec017$export$71511d61b312f219)(function() {
                    var video, texture;
                    return (0, $353b713f9392bb93$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!videoUrl) return [
                                    2
                                ];
                                if (_this.video) return [
                                    2
                                ]; // do not create multiple videos
                                if (_this.texture) return [
                                    2
                                ]; // do not create multiple textures
                                if (_this.is.loadingTexture) return [
                                    2
                                ];
                                console.log('initTexture()', _this.data.id, _this.texture);
                                _this.is.loadingTexture = true;
                                // Create and load <video> element
                                video = new (0, $8c7d3e4ae31d1162$export$bb0df175ffb3c87a)(videoUrl);
                                return [
                                    4,
                                    video.build()
                                ];
                            case 1:
                                _state.sent();
                                // Create video texture
                                texture = new (0, $1a55656020b89c3a$export$6e09d1edf8d5a25c)(video.getVideoElement());
                                texture.colorSpace = (0, $1a55656020b89c3a$export$561f394b24edfcaa);
                                texture.minFilter = (0, $1a55656020b89c3a$export$8a72f490b25c56c8);
                                texture.magFilter = (0, $1a55656020b89c3a$export$8a72f490b25c56c8);
                                _this.is.loadingTexture = false;
                                return [
                                    2,
                                    {
                                        video: video,
                                        texture: texture
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "initPreviewTexture",
            value: function initPreviewTexture(previewImageUrl) {
                var _this = this;
                return (0, $5941428b630ec017$export$71511d61b312f219)(function() {
                    var loader, texture;
                    return (0, $353b713f9392bb93$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                console.log('initPreviewTexture()', _this.data.id);
                                if (!previewImageUrl) return [
                                    2
                                ];
                                if (_this.previewTexture) return [
                                    2
                                ]; // do not create multiple textures
                                if (_this.is.loadingPreviewTexture) return [
                                    2
                                ];
                                _this.is.loadingPreviewTexture = true;
                                loader = new (0, $1a55656020b89c3a$export$fd1bfc71f64c538c)();
                                return [
                                    4,
                                    loader.loadAsync(previewImageUrl)
                                ];
                            case 1:
                                texture = _state.sent();
                                _this.is.loadingPreviewTexture = false;
                                return [
                                    2,
                                    {
                                        texture: texture
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "applyTexture",
            value: function applyTexture(texture) {
                if (!texture) return;
                if (!this.screen) return;
                this.screen.material.uniforms.combinedTexture.value.dispose(); // this is important when overwriting unfiform texture
                this.screen.material.uniforms.combinedTexture.value = texture;
                this.screen.material.needsUpdate = true;
                this.is.loaded = true;
                this.onLoaded();
            }
        },
        {
            key: "onFrame",
            value: function onFrame(time, delta) {
                // Auto Rotation
                if (this.groups.autoRotation) {
                    this.groups.autoRotation.rotation.x = Math.sin(time) * 0.2;
                    this.groups.autoRotation.rotation.y = Math.sin(time + this.seed * 10 + 12) * 0.2;
                    this.groups.autoRotation.rotation.z = Math.sin(time + this.seed * 10 + 3) * 0.2;
                }
                // Input Rotation
                if (this.groups.inputRotation) {
                    this.groups.inputRotation.rotation.y = (0, $4aa967d09edd827c$export$3a89f8d6f6bf6c9f)(this.groups.inputRotation.rotation.y, this.pointerPosition.x * 0.6, $20bd4c57573bfebb$var$LERP_FACTOR.inputRotation / delta);
                    this.groups.inputRotation.rotation.x = (0, $4aa967d09edd827c$export$3a89f8d6f6bf6c9f)(this.groups.inputRotation.rotation.x, this.pointerPosition.y * -0.6, $20bd4c57573bfebb$var$LERP_FACTOR.inputRotation / delta);
                }
                // Transition
                if (this.groups.transition) {
                    // - Position
                    this.groups.transition.position.x = (0, $4aa967d09edd827c$export$3a89f8d6f6bf6c9f)(this.groups.transition.position.x, this.is.active && (this.is.loaded || true) ? 0 : $20bd4c57573bfebb$var$TRANSITION.x, $20bd4c57573bfebb$var$LERP_FACTOR.transition.scale / delta);
                    this.groups.transition.position.y = (0, $4aa967d09edd827c$export$3a89f8d6f6bf6c9f)(this.groups.transition.position.y, this.is.active && (this.is.loaded || true) ? 0 : $20bd4c57573bfebb$var$TRANSITION.y, $20bd4c57573bfebb$var$LERP_FACTOR.transition.scale / delta);
                    this.groups.transition.position.z = (0, $4aa967d09edd827c$export$3a89f8d6f6bf6c9f)(this.groups.transition.position.z, this.is.active && (this.is.loaded || true) ? 0 : $20bd4c57573bfebb$var$TRANSITION.z, $20bd4c57573bfebb$var$LERP_FACTOR.transition.scale / delta);
                    // - scale
                    this.groups.transition.scale.set((0, $4aa967d09edd827c$export$3a89f8d6f6bf6c9f)(this.groups.transition.scale.x, this.is.active && (this.is.loaded || true) ? 1 : $20bd4c57573bfebb$var$TRANSITION.scale.x, $20bd4c57573bfebb$var$LERP_FACTOR.transition.scale / delta), (0, $4aa967d09edd827c$export$3a89f8d6f6bf6c9f)(this.groups.transition.scale.y, this.is.active && (this.is.loaded || true) ? 1 : $20bd4c57573bfebb$var$TRANSITION.scale.y, $20bd4c57573bfebb$var$LERP_FACTOR.transition.scale / delta), (0, $4aa967d09edd827c$export$3a89f8d6f6bf6c9f)(this.groups.transition.scale.z, this.is.active && (this.is.loaded || true) ? 1 : $20bd4c57573bfebb$var$TRANSITION.scale.z, $20bd4c57573bfebb$var$LERP_FACTOR.transition.scale / delta));
                }
                // - Opacity
                if (this.screen.material) {
                    var _this_screen_material_uniforms, _this_screen_material;
                    if ((_this_screen_material = this.screen.material) === null || _this_screen_material === void 0 ? void 0 : (_this_screen_material_uniforms = _this_screen_material.uniforms) === null || _this_screen_material_uniforms === void 0 ? void 0 : _this_screen_material_uniforms.opacity) this.screen.material.uniforms.opacity.value = (0, $4aa967d09edd827c$export$3a89f8d6f6bf6c9f)(this.screen.material.uniforms.opacity.value, this.is.active && (this.is.loaded || true) ? 1 : $20bd4c57573bfebb$var$TRANSITION.opacity, $20bd4c57573bfebb$var$LERP_FACTOR.transition.opacity / delta);
                    else this.screen.material.opacity = (0, $4aa967d09edd827c$export$3a89f8d6f6bf6c9f)(this.screen.material.opacity, this.is.active && (this.is.loaded || true) ? 1 : $20bd4c57573bfebb$var$TRANSITION.opacity, $20bd4c57573bfebb$var$LERP_FACTOR.transition.opacity / delta);
                }
            }
        },
        {
            key: "getObject",
            value: function getObject() {
                var _this_groups, _this;
                return (_this = this) === null || _this === void 0 ? void 0 : (_this_groups = _this.groups) === null || _this_groups === void 0 ? void 0 : _this_groups.object;
            }
        },
        {
            key: "getTexture",
            value: function getTexture() {
                var _this;
                return (_this = this) === null || _this === void 0 ? void 0 : _this.texture;
            }
        },
        {
            key: "setPointerPosition",
            value: function setPointerPosition(pointerPosition) {
                if (!pointerPosition) return;
                this.pointerPosition.x = pointerPosition.x;
                this.pointerPosition.y = pointerPosition.y;
            }
        }
    ]);
    return Item;
}();


var $b426a0588130524f$var$MAX_DPR = 2;
var $b426a0588130524f$var$USE_COMPOSER = false;
var $b426a0588130524f$var$AFTERIMAGE_STRENGTH = 0.98; // based on 60fps
/**
 * Visual
 *
 * Creates a WebGL context and renders Items to it.
 */ var $b426a0588130524f$export$af9c170e35e0c8f7 = /*#__PURE__*/ function() {
    "use strict";
    function Visual(data, currentIndex) {
        var _this = this;
        var onLoaded = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {};
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Visual);
        console.log('new Visual', data, currentIndex);
        if (!data) return;
        this.data = data;
        this.currentIndex = currentIndex;
        this.onLoaded = onLoaded;
        this.items = [];
        this.pointerPosition = {
            x: 0,
            y: 0
        };
        this.is = {
            debug: window.location.href.includes('?debug')
        };
        this.build();
        this.resize();
        this.currentIndex.on(function() {
            _this.onCurrentIndexChange();
        });
        this.onCurrentIndexChange();
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Visual, [
        {
            key: "build",
            value: function build() {
                var _this = this;
                return (0, $5941428b630ec017$export$71511d61b312f219)(function() {
                    return (0, $353b713f9392bb93$export$67ebef60e6f28a6)(this, function(_state) {
                        // Clock
                        _this.clock = new (0, $1a55656020b89c3a$export$9735c82c4bae3302)();
                        // Renderer
                        _this.renderer = new (0, $079becb54c0579a9$export$f6cc00ef28d7cf97)({
                            antialias: true,
                            alpha: true,
                            precision: 'highp'
                        });
                        _this.renderer.outputColorSpace = (0, $1a55656020b89c3a$export$561f394b24edfcaa);
                        // this.renderer.toneMapping = ACESFilmicToneMapping;
                        _this.renderer.domElement.setAttribute('data-STHVisual-role', 'canvas');
                        // Scene
                        _this.scene = new (0, $1a55656020b89c3a$export$38af1803e3442a7f)();
                        // Camera
                        _this.camera = new (0, $1a55656020b89c3a$export$74e4ae24825f68d7)(50, 16 / 9, 0.1, 1000);
                        _this.camera.position.z = 10;
                        // Items
                        if (_this.data.items) _this.data.items.forEach(/*#__PURE__*/ function() {
                            var _ref = (0, $5941428b630ec017$export$71511d61b312f219)(function(itemData) {
                                var item;
                                return (0, $353b713f9392bb93$export$67ebef60e6f28a6)(this, function(_state) {
                                    item = new (0, $20bd4c57573bfebb$export$6d08773d2e66f8f2)(itemData, _this.onLoaded);
                                    item.build();
                                    _this.scene.add(item.getObject());
                                    _this.items.push(item);
                                    return [
                                        2
                                    ];
                                });
                            });
                            return function(itemData) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        // Postprocessing
                        if ($b426a0588130524f$var$USE_COMPOSER) {
                            _this.composer = {};
                            _this.composer.composer = new (0, $e047865f13e317c0$export$7fe01e6ab8aa748c)(_this.renderer);
                            // Renderpass
                            _this.composer.renderPass = new (0, $824eec6761c11732$export$f63ea822f020b5b0)(_this.scene, _this.camera);
                            _this.composer.composer.addPass(_this.composer.renderPass);
                            // AfterImage
                            _this.composer.afterimagePass = new (0, $68d1b828c7be5c52$export$1794c02a58210166)();
                            _this.composer.composer.addPass(_this.composer.afterimagePass);
                            // OutputPass
                            _this.composer.outputPass = new (0, $36861e50dc478ff2$export$4035ba3abeff0682)();
                        // this.composer.composer.addPass(this.composer.outputPass);
                        }
                        // Stats
                        if (_this.is.debug) _this.monitor = new (0, $a66862e92e8d5269$export$5275fd2211a376d9)({
                            anchorX: 'left',
                            anchorY: 'top',
                            domElement: document.body,
                            renderer: _this.renderer,
                            scale: 0.6
                        });
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "unbuild",
            value: function unbuild() {
                var _this, _this_composer, _this1, _this_composer1, _this2, _this_composer2, _this3, _this_composer3, _this4;
                // Items
                if (this.items) {
                    this.items.forEach(function(item) {
                        return item.destroy();
                    });
                    this.items = [];
                }
                // Renderer
                if (this.renderer) this.renderer.dispose();
                // Stats
                if ((_this = this) === null || _this === void 0 ? void 0 : _this.monitor) this.monitor.dispose();
                // Composer
                if ((_this1 = this) === null || _this1 === void 0 ? void 0 : (_this_composer = _this1.composer) === null || _this_composer === void 0 ? void 0 : _this_composer.composer) this.composer.composer.dispose();
                if ((_this2 = this) === null || _this2 === void 0 ? void 0 : (_this_composer1 = _this2.composer) === null || _this_composer1 === void 0 ? void 0 : _this_composer1.afterimagePass) this.composer.afterimagePass.dispose();
                if ((_this3 = this) === null || _this3 === void 0 ? void 0 : (_this_composer2 = _this3.composer) === null || _this_composer2 === void 0 ? void 0 : _this_composer2.renderPass) this.composer.renderPass.dispose();
                if ((_this4 = this) === null || _this4 === void 0 ? void 0 : (_this_composer3 = _this4.composer) === null || _this_composer3 === void 0 ? void 0 : _this_composer3.outputPass) this.composer.outputPass.dispose();
            }
        },
        {
            key: "resize",
            value: function resize(dimensions) {
                var _this_composer, _this;
                if (!dimensions) return;
                if (!this.renderer) return;
                console.log('Visual.resize()', dimensions);
                var renderWidth = (0, $4aa967d09edd827c$export$7d15b64cf5a3a4c4)(window.devicePixelRatio, 1, $b426a0588130524f$var$MAX_DPR) * dimensions.width;
                var renderHeight = (0, $4aa967d09edd827c$export$7d15b64cf5a3a4c4)(window.devicePixelRatio, 1, $b426a0588130524f$var$MAX_DPR) * dimensions.height;
                // WebGLRenderer
                this.renderer.setSize(renderWidth, renderHeight, false);
                // Composer
                if ((_this = this) === null || _this === void 0 ? void 0 : (_this_composer = _this.composer) === null || _this_composer === void 0 ? void 0 : _this_composer.composer) this.composer.composer.setSize(renderWidth, renderWidth);
                // Camera
                this.camera.aspect = dimensions.width / dimensions.height;
                this.camera.updateProjectionMatrix();
            }
        },
        {
            key: "start",
            value: function start() {
                if (!this.renderer) return;
                this.render = this.render.bind(this);
                this.renderer.setAnimationLoop(this.render);
                this.clock.start();
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (!this.renderer) return;
                this.renderer.setAnimationLoop(null);
                this.clock.stop();
            }
        },
        {
            key: "render",
            value: function render(state) {
                var _this = this;
                var _this1, _this_composer, _this2, _this3;
                var delta = this.clock.getDelta();
                var deltaNormalized = 1 / 60 / delta;
                if (this.items) this.items.forEach(function(item) {
                    item.setPointerPosition(_this.pointerPosition);
                    item.onFrame(_this.clock.getElapsedTime(), deltaNormalized);
                });
                if ((_this1 = this) === null || _this1 === void 0 ? void 0 : _this1.monitor) this.monitor.begin();
                if ($b426a0588130524f$var$USE_COMPOSER && ((_this2 = this) === null || _this2 === void 0 ? void 0 : (_this_composer = _this2.composer) === null || _this_composer === void 0 ? void 0 : _this_composer.composer)) {
                    this.composer.afterimagePass.uniforms.damp.value = $b426a0588130524f$var$AFTERIMAGE_STRENGTH;
                    this.composer.composer.render(deltaNormalized);
                } else this.renderer.render(this.scene, this.camera);
                if ((_this3 = this) === null || _this3 === void 0 ? void 0 : _this3.monitor) this.monitor.end();
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.stop();
                this.unbuild();
            }
        },
        {
            key: "setPointerPosition",
            value: function setPointerPosition(pointerPosition) {
                if (!pointerPosition) return;
                this.pointerPosition.x = pointerPosition.x;
                this.pointerPosition.y = pointerPosition.y;
            }
        },
        {
            key: "getRendererElement",
            value: function getRendererElement() {
                if (!this.renderer) return;
                return this.renderer.domElement;
            }
        },
        {
            key: "onCurrentIndexChange",
            value: function onCurrentIndexChange() {
                var _this_items;
                console.log('Visual.onCurrentIndexChange()', this.currentIndex.get());
                if (!((_this_items = this.items) === null || _this_items === void 0 ? void 0 : _this_items.length)) return;
                var _this = this;
                this.items.forEach(/*#__PURE__*/ function() {
                    var _ref = (0, $5941428b630ec017$export$71511d61b312f219)(function(item, i) {
                        return (0, $353b713f9392bb93$export$67ebef60e6f28a6)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!(Math.abs(_this.currentIndex.get() - i) <= 1 || Math.abs(_this.currentIndex.get() + _this.items.length - i) <= 1)) return [
                                        3,
                                        2
                                    ];
                                    // close items
                                    if (_this.currentIndex.get() === i) // current item
                                    item.show();
                                    else // close not bit current
                                    item.hide();
                                    return [
                                        4,
                                        item.load()
                                    ];
                                case 1:
                                    _state.sent();
                                    // this.renderer.initTexture(item.getTexture());
                                    item.activate();
                                    return [
                                        3,
                                        3
                                    ];
                                case 2:
                                    // not so close items
                                    item.hide();
                                    item.unload();
                                    item.deactivate();
                                    _state.label = 3;
                                case 3:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(item, i) {
                        return _ref.apply(this, arguments);
                    };
                }());
            }
        }
    ]);
    return Visual;
}();


/**
 * 
    //////
  ///     ´
    ///
      /////
  ,     ///
   //////

S

Lean subscription-based state management.

 * 
 */ 

var $1cc4f4085220679a$export$25ce5a424b770e84 = /*#__PURE__*/ function() {
    "use strict";
    function S(initialState) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, S);
        // {
        //   'x': 1,
        //   'y': 'Hi!'
        // }
        this._state = {};
        // [
        //   {
        //      key: 'x'.
        //      callback: () => {},
        //      context: null
        //   }
        // ]
        this._subscriptions = [];
        // {
        //   x: {timeout},
        //   x: {timeout}
        // }
        this._onChangeDelays = {};
        if (initialState !== undefined) this._state = initialState;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(S, [
        {
            key: "set",
            value: function set(key, value) {
                var immediate = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, triggerWhenEqual = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
                if (!key || typeof key !== 'string') throw new Error('No key provided.');
                if (!triggerWhenEqual && value === this._state[key]) return;
                this._state[key] = value;
                if (immediate) this._onChange(key);
                else this._debounceOnChange(key);
            }
        },
        {
            key: "get",
            value: function get(key) {
                if (!key || typeof key !== 'string') throw new Error('No key provided.');
                return this._state[key];
            }
        },
        {
            key: "toggle",
            value: function toggle(key) {
                var immediate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, triggerWhenEqual = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                this.set(key, !Boolean(this.get(key)), immediate, triggerWhenEqual);
            }
        },
        {
            key: "on",
            value: function on(keys, callback, context) {
                var _this = this;
                if (!keys || typeof keys !== 'string') throw new Error('No keys provided.');
                if (!callback || typeof callback !== 'function') throw new Error('No callback provided.');
                keys.split(' ').forEach(function(key) {
                    _this._subscriptions.push({
                        key: key,
                        callback: callback,
                        context: context
                    });
                });
            }
        },
        {
            key: "off",
            value: function off(key, callbackOrContext) {
                if (!key) {
                    if (!callbackOrContext) // .off()
                    this._subscriptions = [];
                    else // .off( null, callbackOrContext )
                    if (typeof callbackOrContext === 'string') // callbackOrContext is context
                    this._subscriptions = this._subscriptions.filter(function(subscription) {
                        return callbackOrContext !== subscription.context;
                    });
                    else // callbackOrContext is callback
                    this._subscriptions = this._subscriptions.filter(function(subscription) {
                        return callbackOrContext !== subscription.callback;
                    });
                } else {
                    if (!callbackOrContext) // .off( key )
                    this._subscriptions = this._subscriptions.filter(function(subscription) {
                        return key !== subscription.key;
                    });
                    else // .off( key, callbackOrContext )
                    if (typeof callbackOrContext === 'string') // callbackOrContext is context
                    this._subscriptions = this._subscriptions.filter(function(subscription) {
                        return key !== subscription.key || callbackOrContext !== subscription.context;
                    });
                    else // callbackOrContext is callback
                    this._subscriptions = this._subscriptions.filter(function(subscription) {
                        return key !== subscription.key || callbackOrContext !== subscription.callback;
                    });
                }
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this._state = {};
                this._subscriptions = [];
                this._onChangeDelays = {};
            }
        },
        {
            key: "_debounceOnChange",
            value: function _debounceOnChange(key) {
                var _this = this;
                if (!key || typeof key !== 'string') return;
                if (this._onChangeDelays[key]) clearTimeout(this._onChangeDelays[key]);
                this._onChangeDelays[key] = setTimeout(function() {
                    _this._onChange(key);
                }, 1);
            }
        },
        {
            key: "_onChange",
            value: function _onChange(key) {
                if (this._subscriptions.length < 1) return;
                this._subscriptions.forEach(function(_subscription) {
                    if (key === _subscription.key) _subscription.callback.call();
                });
            }
        }
    ]);
    return S;
}();
var $1cc4f4085220679a$export$2408f22a0fab9ae5 = /*#__PURE__*/ function() {
    "use strict";
    function s(initialValue) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, s);
        // 1
        this._value = undefined;
        // [
        //   () => {},
        //   () => {}
        // ]
        this._subscriptions = [];
        this._onChangeDelay = null;
        if (initialValue !== undefined) this._value = initialValue;
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(s, [
        {
            key: "set",
            value: function set(value) {
                var _this = this;
                var immediate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, triggerWhenEqual = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                if (!triggerWhenEqual && value === this._value) return;
                this._value = value;
                // debounce onChange();
                if (this._onChangeDelay) clearTimeout(this._onChangeDelay);
                if (immediate) this._onChange();
                else this._onChangeDelay = setTimeout(function() {
                    _this._onChange();
                }, 1);
            }
        },
        {
            key: "get",
            value: function get() {
                return this._value;
            }
        },
        {
            key: "toggle",
            value: function toggle() {
                var immediate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, triggerWhenEqual = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                this.set(!Boolean(this.get()), immediate, triggerWhenEqual);
            }
        },
        {
            key: "on",
            value: function on(callback, context) {
                if (!callback || typeof callback !== 'function') throw new Error('No callback provided.');
                this._subscriptions.push({
                    callback: callback,
                    context: context
                });
            }
        },
        {
            key: "off",
            value: function off(callbackOrContext) {
                if (!callbackOrContext) // .off()
                this._subscriptions = [];
                else // .off( callbackOrContext )
                if (typeof callbackOrContext === 'string') // callbackOrContext is context
                this._subscriptions = this._subscriptions.filter(function(subscription) {
                    return callbackOrContext !== subscription.context;
                });
                else // callbackOrContext is callback
                this._subscriptions = this._subscriptions.filter(function(subscription) {
                    return callbackOrContext !== subscription.callback;
                });
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this._value = undefined;
                this._subscriptions = [];
                if (this._onChangeDelay) clearTimeout(this._onChangeDelay);
            }
        },
        {
            key: "_onChange",
            value: function _onChange() {
                if (this._subscriptions.length < 1) return;
                this._subscriptions.forEach(function(_subscription) {
                    _subscription.callback.call();
                });
            }
        }
    ]);
    return s;
}();



var $158d7b5a8778ce58$var$API_ACTIONS = [
    'prev',
    'next',
    'go'
];
/**
 * Instance
 *
 * Each instance controls a Visual and
 * handles resize and visibility
 */ var $158d7b5a8778ce58$export$38456927afaf190a = /*#__PURE__*/ function() {
    "use strict";
    function Instance(wrapperElement) {
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, Instance);
        console.log('new Instance', wrapperElement);
        if (!wrapperElement) return false;
        if (wrapperElement.getAttribute('data-STHVisual-isInitiated') == 'true') return false;
        this.wrapperElement = wrapperElement;
        this.data = this.wrapperElement.getAttribute('data-STHVisual-data') ? JSON.parse(this.wrapperElement.getAttribute('data-STHVisual-data')) : null;
        if (!this.data) return false;
        this.dimensions = {
            width: 1,
            height: 1
        };
        this.resizeObserver = null;
        this.intersectionObserver = null;
        this.visual = null;
        this.currentIndex = new (0, $1cc4f4085220679a$export$2408f22a0fab9ae5)(0);
        this.is = {
            initiated: false,
            loaded: false
        };
        this.build();
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(Instance, [
        {
            key: "build",
            value: function build() {
                var _this = this;
                var _this_visual, _this_visual1;
                console.log('Instance.build()');
                // Visual
                this.visual = new (0, $b426a0588130524f$export$af9c170e35e0c8f7)(this.data, this.currentIndex, function() {
                    _this.onLoaded();
                });
                if ((_this_visual = this.visual) === null || _this_visual === void 0 ? void 0 : _this_visual.monitor) this.wrapperElement.appendChild((_this_visual1 = this.visual) === null || _this_visual1 === void 0 ? void 0 : _this_visual1.monitor.ui.wrapper);
                // DOM
                this.wrapperElement.appendChild(this.visual.getRendererElement());
                // ResizeObserver
                this.observeResize();
                // IntersectionObserver
                this.observeIntersection();
                // Events
                this.bindEvents();
                // Callback
                this.onInitiated();
            }
        },
        {
            key: "unbuild",
            value: function unbuild() {
                // Visual
                if (this.visual) this.visual.destroy();
                // DOM
                var canvasElement = this.wrapperElement.querySelector('[data-STHVisual-role~="canvas"]');
                if (canvasElement) canvasElement.remove();
                // ResizeObserver
                this.unobserveResize();
                // IntersectionObserver
                this.unobserveIntersection();
                // Events
                this.unbindEvents();
                // DOM Attributes
                this.wrapperElement.removeAttribute('data-STHVisual-isInitiated');
                this.wrapperElement.removeAttribute('data-STHVisual-isLoaded');
            }
        },
        {
            key: "bindEvents",
            value: function bindEvents() {
                this.onMouseMove = this.onMouseMove.bind(this);
                this.onMouseLeave = this.onMouseLeave.bind(this);
                this.onApi = this.onApi.bind(this);
                this.wrapperElement.addEventListener('mousemove', this.onMouseMove);
                this.wrapperElement.addEventListener('mouseleave', this.onMouseLeave);
                this.wrapperElement.addEventListener('STHVisual/api', this.onApi);
            }
        },
        {
            key: "unbindEvents",
            value: function unbindEvents() {
                this.wrapperElement.removeEventListener('mousemove', this.onMouseMove);
                this.wrapperElement.removeEventListener('mouseleave', this.onMouseLeave);
                this.wrapperElement.removeEventListener('STHVisual/api', this.onApi);
            }
        },
        {
            key: "observeResize",
            value: function observeResize() {
                var _this = this;
                this.resizeObserver = new (0, $84826c5bdf349b6b$export$9caf76241ca21a11)(function() {
                    _this.resize();
                }).observe(this.wrapperElement);
            }
        },
        {
            key: "unobserveResize",
            value: function unobserveResize() {
                if (!this.resizeObserver) return;
                this.resizeObserver.disconnect();
                this.resizeObserver = null;
            }
        },
        {
            key: "observeIntersection",
            value: function observeIntersection() {
                var _this = this;
                this.intersectionObserver = new IntersectionObserver(function(entries) {
                    if (!entries[0]) return;
                    if (entries[0].isIntersecting) _this.onEnter();
                    else _this.onLeave();
                }, {
                    threshold: 0.0
                });
                this.intersectionObserver.observe(this.wrapperElement);
            }
        },
        {
            key: "unobserveIntersection",
            value: function unobserveIntersection() {
                if (!this.intersectionObserver) return;
                this.intersectionObserver.disconnect();
                this.intersectionObserver = null;
            }
        },
        {
            key: "resize",
            value: function resize() {
                this.dimensions = {
                    width: this.wrapperElement.offsetWidth,
                    height: this.wrapperElement.offsetHeight
                };
                if (this.visual) this.visual.resize(this.dimensions);
            }
        },
        {
            key: "go",
            value: function go() {
                var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                if (!this.data.items.length) return;
                this.currentIndex.set((0, $4aa967d09edd827c$export$4997ffc0176396a6)(index, this.data.items.length));
            }
        },
        {
            key: "dispatchEvent",
            value: function dispatchEvent(eventName, data) {
                var bubbles = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                if (!eventName) return;
                if (!this.wrapperElement) return;
                var event = new CustomEvent("STHVisual/".concat(eventName), {
                    detail: data,
                    bubbles: bubbles
                });
                this.wrapperElement.dispatchEvent(event);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.unbuild();
            }
        },
        {
            key: "onEnter",
            value: function onEnter() {
                if (this.visual) this.visual.start();
            }
        },
        {
            key: "onLeave",
            value: function onLeave() {
                if (this.visual) this.visual.stop();
            }
        },
        {
            key: "onMouseMove",
            value: function onMouseMove(event) {
                if (this.visual) this.visual.setPointerPosition({
                    x: (-0.5 + event.offsetX / this.dimensions.width) * 2,
                    y: (-0.5 + event.offsetY / this.dimensions.height) * 2
                });
            }
        },
        {
            key: "onMouseLeave",
            value: function onMouseLeave(event) {
                if (this.visual) this.visual.setPointerPosition({
                    x: 0,
                    y: 0
                });
            }
        },
        {
            key: "onInitiated",
            value: function onInitiated() {
                console.log('Instance.onInitiated()');
                if (this.is.initiated) return;
                if (!this.wrapperElement) return;
                this.is.initiated = true;
                this.wrapperElement.setAttribute('data-STHVisual-isInitiated', 'true');
                this.dispatchEvent('initiated');
            }
        },
        {
            key: "onLoaded",
            value: function onLoaded() {
                console.log('Instance.onLoaded()');
                if (this.is.loaded) return;
                if (!this.wrapperElement) return;
                this.is.loaded = true;
                this.wrapperElement.setAttribute('data-STHVisual-isLoaded', 'true');
                this.dispatchEvent('loaded');
            }
        },
        {
            key: "onApi",
            value: function onApi(event) {
                var _ref = event === null || event === void 0 ? void 0 : event.detail, action = _ref.action, index = _ref.index;
                if (!action || !$158d7b5a8778ce58$var$API_ACTIONS.includes(action)) return;
                console.log('Instance.onApi()', action, index);
                switch(action){
                    case 'prev':
                        this.go(this.currentIndex.get() - 1);
                        break;
                    case 'next':
                        this.go(this.currentIndex.get() + 1);
                        break;
                    case 'go':
                        this.go(index);
                    case 'destroy':
                        this.destroy;
                }
            }
        }
    ]);
    return Instance;
}();


var $58d9627164ab41cd$var$API_ACTIONS = [
    'init',
    'destroy'
];
/**
 * STHVisual
 *
 */ var $58d9627164ab41cd$var$STHVisual = /*#__PURE__*/ function() {
    "use strict";
    function STHVisual() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, $9a1684911372ec89$export$71511d61b312f219)(this, STHVisual);
        var defaults = {
            selectorInstance: '[data-STHVisual-role~="instance"]'
        };
        this.options = (0, $84de056ed7b7040b$export$71511d61b312f219)({}, defaults, options);
        this.instances = [];
        if (window.matchMedia('(prefers-reduced-motion)').matches) return;
        this.init();
        this.bindEvents();
    }
    (0, $4c70eeab04b218c5$export$71511d61b312f219)(STHVisual, [
        {
            key: "init",
            value: function init() {
                var _this = this;
                if (this.instances.length) this.destroy();
                var instanceElements = document.querySelectorAll(this.options.selectorInstance);
                if (!(instanceElements === null || instanceElements === void 0 ? void 0 : instanceElements.length)) return;
                instanceElements.forEach(function(instanceElement) {
                    var instance = new (0, $158d7b5a8778ce58$export$38456927afaf190a)(instanceElement);
                    if (instance) _this.instances.push(instance);
                });
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                if (this.instances) this.instances.forEach(function(instance) {
                    return instance.destroy();
                });
                this.instances = [];
            }
        },
        {
            key: "bindEvents",
            value: function bindEvents() {
                this.onApi = this.onApi.bind(this);
                document.addEventListener('STHVisual/api', this.onApi);
            }
        },
        {
            // don't unbind global events...
            key: "unbindEvents",
            value: function unbindEvents() {
                document.removeEventListener('STHVisual/api', this.onApi);
            }
        },
        {
            key: "onApi",
            value: function onApi(event) {
                var _ref = event === null || event === void 0 ? void 0 : event.detail, action = _ref.action, index = _ref.index;
                if (!action || !$58d9627164ab41cd$var$API_ACTIONS.includes(action)) return;
                console.log('STHVisual.onApi()', action, index);
                switch(action){
                    case 'init':
                        this.init();
                        break;
                    case 'destroy':
                        this.destroy();
                        break;
                }
            }
        }
    ]);
    return STHVisual;
}();
window.STHVisual = new $58d9627164ab41cd$var$STHVisual({});

})();
//# sourceMappingURL=sth-visual.legacy.min.js.map
